webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(3);
	var app_module_1 = __webpack_require__(23);
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var platform_browser_1 = __webpack_require__(21);
	var core_1 = __webpack_require__(3);
	var core_module_1 = __webpack_require__(24);
	var app_component_1 = __webpack_require__(51);
	var gestao_module_1 = __webpack_require__(56);
	var app_routing_module_1 = __webpack_require__(1046);
	var visitantes_module_1 = __webpack_require__(1057);
	var home_component_1 = __webpack_require__(168);
	var error_page_component_1 = __webpack_require__(1050);
	var projeto_module_1 = __webpack_require__(1058);
	var not_tenant_page_component_1 = __webpack_require__(1054);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            declarations: [
	                app_component_1.AppComponent,
	                home_component_1.HomeComponent,
	                error_page_component_1.ErrorPageComponent,
	                not_tenant_page_component_1.NotTenantPageComponent
	            ],
	            imports: [
	                platform_browser_1.BrowserModule,
	                core_module_1.CoreModule,
	                projeto_module_1.ProjetoModule,
	                gestao_module_1.GestaoModule,
	                visitantes_module_1.VisitantesModule,
	                app_routing_module_1.AppRoutingModule
	            ],
	            providers: [],
	            bootstrap: [app_component_1.AppComponent]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(25);
	var rest_service_1 = __webpack_require__(26);
	var rest_operators_service_1 = __webpack_require__(27);
	var data_service_1 = __webpack_require__(50);
	var CoreModule = (function () {
	    function CoreModule() {
	    }
	    CoreModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                http_1.HttpModule
	            ],
	            providers: [
	                data_service_1.DataService,
	                rest_service_1.RestService,
	                rest_operators_service_1.RestOperatorsService
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CoreModule);
	    return CoreModule;
	}());
	exports.CoreModule = CoreModule;


/***/ },
/* 25 */,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(25);
	var rest_operators_service_1 = __webpack_require__(27);
	var RestService = (function () {
	    function RestService(_http, _restOperationsService) {
	        this._http = _http;
	        this._restOperationsService = _restOperationsService;
	    }
	    RestService.prototype.onPost = function (route, object, done) {
	        var arg = '/inserir';
	        var apiRoute = this._restOperationsService.getApiRoute(route, arg);
	        var options = this._restOperationsService.getHeaderJson();
	        object.ativo = true;
	        object = JSON.stringify(object);
	        var response = this._http
	            .post(apiRoute, object, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        return this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onPostCustom = function (route, object, done) {
	        var apiRoute = this._restOperationsService.getApiRoute(route, '');
	        var options = this._restOperationsService.getHeaderJson();
	        object = JSON.stringify(object);
	        var response = this._http
	            .post(apiRoute, object, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        return this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onPut = function (route, object, done) {
	        var arg = '/editar/id/' + object.id;
	        var apiRoute = this._restOperationsService.getApiRoute(route, arg);
	        var options = this._restOperationsService.getHeaderJson();
	        object = JSON.stringify(object);
	        var response = this._http
	            .put(apiRoute, object, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onPatch = function (route, object, done) {
	        var apiRoute = this._restOperationsService.getApiRoute(route, '');
	        var options = this._restOperationsService.getHeaderJson();
	        object = JSON.stringify(object);
	        var response = this._http
	            .patch(apiRoute, object, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onDelete = function (route, objectId, done) {
	        var arg = '/editar/id/' + objectId;
	        var apiRoute = this._restOperationsService.getApiRoute(route, arg);
	        var options = this._restOperationsService.getHeaderJson();
	        var object = { ativo: false };
	        object = JSON.stringify(object);
	        var response = this._http
	            .put(apiRoute, object, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onGet = function (route, done) {
	        var apiRoute = this._restOperationsService.getApiRoute(route, '');
	        var options = this._restOperationsService.getHeaderJson();
	        var response = this._http
	            .get(apiRoute, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onGetSemSchema = function (route, done) {
	        var server_url = this._restOperationsService.server_url;
	        var options = this._restOperationsService.getHeaderJson();
	        var response = this._http
	            .get(server_url + '/' + route, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onGetSemToken = function (route, done) {
	        var schema = this._restOperationsService.getTenant();
	        var server_url = this._restOperationsService.server_url;
	        var options = this._restOperationsService.getHeaderJson();
	        var response = this._http
	            .get(server_url + '/' + route + '/' + schema, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onGetPost = function (route, object, done) {
	        var arg = '/listar';
	        var apiRoute = this._restOperationsService.getApiRoute(route, arg);
	        var options = this._restOperationsService.getHeaderJson();
	        object = JSON.stringify(object);
	        var response = this._http
	            .post(apiRoute, object, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onGetPostId = function (route, objectId, object, done) {
	        var arg = '/id/' + objectId;
	        var apiRoute = this._restOperationsService.getApiRoute(route, arg);
	        var options = this._restOperationsService.getHeaderJson();
	        object = JSON.stringify(object);
	        var response = this._http
	            .post(apiRoute, object, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.onGetPostCustom = function (route, object, done) {
	        var apiRoute = this._restOperationsService.getApiRoute(route, '');
	        var options = this._restOperationsService.getHeaderJson();
	        object = JSON.stringify(object);
	        var response = this._http
	            .post(apiRoute, object, options)
	            .map(this._restOperationsService.extractData)
	            .catch(this._restOperationsService.handleError);
	        this._restOperationsService.call(response, done);
	    };
	    RestService.prototype.getAutocompleteAjax = function (route, arg, method) {
	        var apiRoute = this._restOperationsService.getApiRoute(route, arg);
	        if (!method) {
	            method = 'POST';
	        }
	        var Ajax = {
	            url: apiRoute,
	            headers: { 'Content-Type': 'application/json' },
	            dataType: 'json',
	            method: method,
	            delay: 250,
	            cache: true
	        };
	        return Ajax;
	    };
	    RestService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object, (typeof (_b = typeof rest_operators_service_1.RestOperatorsService !== 'undefined' && rest_operators_service_1.RestOperatorsService) === 'function' && _b) || Object])
	    ], RestService);
	    return RestService;
	    var _a, _b;
	}());
	exports.RestService = RestService;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(25);
	var Observable_1 = __webpack_require__(5);
	__webpack_require__(28);
	__webpack_require__(35);
	__webpack_require__(42);
	__webpack_require__(44);
	__webpack_require__(46);
	__webpack_require__(48);
	var data_service_1 = __webpack_require__(50);
	var RestOperatorsService = (function () {
	    function RestOperatorsService(_dataService) {
	        this._dataService = _dataService;
	        this.handleError = (function (error) {
	            var body = error.json() || '';
	            var err = body.error || JSON.stringify(body);
	            var errMsg = this.extractError(err);
	            this.errorMessage = JSON.stringify({ error: errMsg });
	            return Observable_1.Observable.throw(errMsg);
	        }.bind(this));
	        this.error = (function (error, done) {
	            error = JSON.parse(this.errorMessage);
	            done(error);
	        }.bind(this));
	        this.server_url = this._dataService.getServer();
	        this.tenants = this._dataService.getTenants();
	    }
	    RestOperatorsService.prototype.extractData = function (res) {
	        var body = res.json();
	        return body;
	    };
	    RestOperatorsService.prototype.call = function (response, done) {
	        var _this = this;
	        response.subscribe(function (result) { return done(result); }, function (error) { return _this.error(error, done); });
	    };
	    RestOperatorsService.prototype.getHeaderJson = function () {
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        var options = new http_1.RequestOptions({ headers: headers });
	        return options;
	    };
	    RestOperatorsService.prototype.getHeaderObject = function () {
	        var headers = {
	            'Content-Type': 'application/x-www-form-urlencoded'
	        };
	        return headers;
	    };
	    RestOperatorsService.prototype.getToken = function () {
	        var token = this._dataService.getToken();
	        var tokenAccess = 'access_token=' + token;
	        return tokenAccess;
	    };
	    RestOperatorsService.prototype.getTenant = function () {
	        var parentRouter = document.location.href, tenants = this.tenants, x, lenX, projectIndex, tenantName = '', schema = 'schema/';
	        for (x = 0, lenX = tenants.length; x < lenX; x++) {
	            projectIndex = parentRouter.indexOf(tenants[x]);
	            if (projectIndex !== -1) {
	                tenantName = tenants[x];
	                break;
	            }
	        }
	        schema = schema.concat(tenantName);
	        return schema;
	    };
	    RestOperatorsService.prototype.getApiRoute = function (route, arg) {
	        var server_url = this.server_url;
	        var access_token = this.getToken();
	        var schema = this.getTenant();
	        if (arg) {
	            route = route.concat(arg);
	        }
	        var apiRoute = server_url + '/' + route + "/" + schema + '?' + access_token;
	        return apiRoute;
	    };
	    RestOperatorsService.prototype.extractError = function (err) {
	        var errMsg = err.status + " - " + (err.message || '');
	        if (err.name === 'hidrometroJaCadastradoNoDia') {
	            errMsg = err;
	        }
	        return errMsg;
	    };
	    RestOperatorsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof data_service_1.DataService !== 'undefined' && data_service_1.DataService) === 'function' && _a) || Object])
	    ], RestOperatorsService);
	    return RestOperatorsService;
	    var _a;
	}());
	exports.RestOperatorsService = RestOperatorsService;


/***/ },
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	//token-visitante = 'eyJhbGciOiJIUzI1NiJ9.MTgx.YlwDOqAiNUqzozngn-VTvhoYJ-9xNJpTQ48AOSZKknc';
	//token-adm = 'eyJhbGciOiJIUzI1NiJ9.MTgw.0dhL7CSKEEdznJW9AbFAFsBW3kwKBlnWBAXjUkq65is';
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var DataService = (function () {
	    function DataService() {
	        console.log(("production"));
	        if (true) {
	            this.setServer('https://frotas-api.geosiap.net/api');
	            this.setTenants(["grupoembras", "demo", "teste"]);
	            this.setS3('http://geosiap.s3.amazonaws.com/');
	            this.setCookieName('production_token');
	            this.setContasDomain('https://contas.geosiap.net');
	        }
	        else if (process.env.ENV === 'staging') {
	            this.setServer('https://frotas-api-beta.geosiap.net/api');
	            this.setTenants(["t1", "t2", "t3", "pinda", "teste"]);
	            this.setS3('http://geosiap-beta.s3.amazonaws.com/');
	            this.setCookieName('production_token');
	            this.setContasDomain('https://contas.geosiap.net');
	        }
	        else {
	            this.setServer('https://frotas-api-beta.geosiap.net/api'); // this.setServer('http://localhost:3000/api');
	            this.setTenants(["t1", "t2", "t3", "pinda", "teste"]);
	            this.setS3('http://geosiap-beta.s3.amazonaws.com/');
	            this.setCookieName('staging_token');
	            this.setContasDomain('https://contas.geosiap.net');
	        }
	        this.setGoogleMapApi("AIzaSyARKrWpAYaGGnxKdgF_Zf35ObKQJw2gbyY");
	        this.setCoordinates({ lat: -18.7049724, lng: -44.8395315 });
	        // const url: string = window.location.href;
	        // if (url.indexOf('visitante') === -1) {
	        //     this.setToken('eyJhbGciOiJIUzI1NiJ9.MTgw.0dhL7CSKEEdznJW9AbFAFsBW3kwKBlnWBAXjUkq65is');
	        // } else {
	        //     this.setToken('eyJhbGciOiJIUzI1NiJ9.MTgx.YlwDOqAiNUqzozngn-VTvhoYJ-9xNJpTQ48AOSZKknc');
	        // }
	    }
	    DataService.prototype.setToken = function (item) {
	        this.TOKEN = item;
	    };
	    DataService.prototype.getToken = function () {
	        return this.TOKEN;
	    };
	    DataService.prototype.setTenants = function (item) {
	        this.TENANTS = item;
	    };
	    DataService.prototype.getTenants = function () {
	        return this.TENANTS;
	    };
	    DataService.prototype.setServer = function (item) {
	        this.SERVER_URL = item;
	    };
	    DataService.prototype.getServer = function () {
	        return this.SERVER_URL;
	    };
	    DataService.prototype.setGoogleMapApi = function (item) {
	        this.GOOGLE_MAP_API = item;
	    };
	    DataService.prototype.getGoogleMapApi = function () {
	        return this.LATLNG;
	    };
	    DataService.prototype.setCoordinates = function (item) {
	        this.LATLNG = item;
	    };
	    DataService.prototype.getCoordinates = function () {
	        return this.GOOGLE_MAP_API;
	    };
	    DataService.prototype.setS3 = function (item) {
	        this.S3URL = item;
	    };
	    DataService.prototype.getS3 = function () {
	        return this.S3URL;
	    };
	    DataService.prototype.setCookieName = function (item) {
	        this.COOKIE_NAME = item;
	    };
	    DataService.prototype.getCookieName = function () {
	        return this.COOKIE_NAME;
	    };
	    DataService.prototype.setContasDomain = function (item) {
	        this.CONTAS_DOMAIN = item;
	    };
	    DataService.prototype.getContasDomain = function () {
	        return this.CONTAS_DOMAIN;
	    };
	    DataService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], DataService);
	    return DataService;
	}());
	exports.DataService = DataService;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var projeto_service_1 = __webpack_require__(52);
	var AppComponent = (function () {
	    function AppComponent(_projetoService) {
	        this._projetoService = _projetoService;
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        this._projetoService.getAllProjects();
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'app-root',
	            template: __webpack_require__(55)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof projeto_service_1.ProjetoService !== 'undefined' && projeto_service_1.ProjetoService) === 'function' && _a) || Object])
	    ], AppComponent);
	    return AppComponent;
	    var _a;
	}());
	exports.AppComponent = AppComponent;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(53);
	var projeto_api_service_1 = __webpack_require__(54);
	var ProjetoService = (function () {
	    function ProjetoService(_projetoApiService) {
	        this._projetoApiService = _projetoApiService;
	    }
	    //session
	    ProjetoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.projetoStorage + '-new', object);
	    };
	    ProjetoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.projetoStorage + "-new");
	        return JSON.parse(item);
	    };
	    ProjetoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.projetoStorage + "-new");
	    };
	    ProjetoService.prototype.getAllProjects = function () {
	        var onDone = (function (response) {
	            var x, lenX, domain = window.location.pathname;
	            for (x = 0, lenX = response.length; x < lenX; x++) {
	                if (domain.search(response[x]) !== -1) {
	                    this.getProject(response[x]);
	                    break;
	                }
	            }
	        }.bind(this));
	        this._projetoApiService.onGetAll(onDone);
	    };
	    ProjetoService.prototype.getProject = function (tenantName) {
	        var onDone = (function (response) {
	            this.setSessionStorage(response);
	        }.bind(this));
	        this._projetoApiService.onGetByTenantName(tenantName, onDone);
	    };
	    ProjetoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof projeto_api_service_1.ProjetoApiService !== 'undefined' && projeto_api_service_1.ProjetoApiService) === 'function' && _a) || Object])
	    ], ProjetoService);
	    return ProjetoService;
	    var _a;
	}());
	exports.ProjetoService = ProjetoService;


/***/ },
/* 53 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'projetos';
	exports.projetoRoute = 'projeto';
	exports.projetoStorage = 'projeto';


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(53);
	var rest_service_1 = __webpack_require__(26);
	var ProjetoApiService = (function () {
	    function ProjetoApiService(_restService) {
	        this._restService = _restService;
	    }
	    ProjetoApiService.prototype.onGetAll = function (done) {
	        this._restService.onGetSemSchema(data_service_1.apiName + "/listar-todos", done);
	    };
	    ProjetoApiService.prototype.onGetByTenantName = function (tenant, done) {
	        this._restService.onGetSemSchema(data_service_1.apiName + '/schema/' + tenant, done);
	    };
	    ProjetoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ProjetoApiService);
	    return ProjetoApiService;
	    var _a;
	}());
	exports.ProjetoApiService = ProjetoApiService;


/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = "<router-outlet></router-outlet>";

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var gestao_component_1 = __webpack_require__(143);
	var gestao_routing_module_1 = __webpack_require__(167);
	var recursos_humanos_module_1 = __webpack_require__(876);
	var estruturas_module_1 = __webpack_require__(893);
	var bens_module_1 = __webpack_require__(915);
	var viagens_module_1 = __webpack_require__(935);
	var frotas_module_1 = __webpack_require__(968);
	var abastecimentos_module_1 = __webpack_require__(970);
	var manutencoes_module_1 = __webpack_require__(986);
	var almoxarifado_module_1 = __webpack_require__(1018);
	var contas_module_1 = __webpack_require__(1022);
	var despachos_module_1 = __webpack_require__(1030);
	var rastreamentos_module_1 = __webpack_require__(1039);
	var GestaoModule = (function () {
	    function GestaoModule() {
	    }
	    GestaoModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                recursos_humanos_module_1.RecursosHumanosModule,
	                estruturas_module_1.EstruturasModule,
	                bens_module_1.BensModule,
	                viagens_module_1.ViagensModule,
	                frotas_module_1.FrotasModule,
	                abastecimentos_module_1.AbastecimentosModule,
	                manutencoes_module_1.ManutencoesModule,
	                almoxarifado_module_1.AlmoxarifadoModule,
	                contas_module_1.ContasModule,
	                despachos_module_1.DespachosModule,
	                rastreamentos_module_1.RastreamentosModule,
	                gestao_routing_module_1.GestaoRoutingModule
	            ],
	            declarations: [
	                gestao_component_1.GestaoComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], GestaoModule);
	    return GestaoModule;
	}());
	exports.GestaoModule = GestaoModule;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var forms_1 = __webpack_require__(58);
	var auth_service_1 = __webpack_require__(61);
	var auth_guard_service_1 = __webpack_require__(89);
	var phone_mask_directive_1 = __webpack_require__(90);
	var email_validation_1 = __webpack_require__(91);
	var phone_validation_1 = __webpack_require__(92);
	var util_service_1 = __webpack_require__(88);
	var filter_pipe_1 = __webpack_require__(93);
	var filter_active_pipe_1 = __webpack_require__(95);
	var sort_pipe_1 = __webpack_require__(96);
	var filter_service_1 = __webpack_require__(94);
	var sort_service_1 = __webpack_require__(97);
	var phone_mask_pipe_1 = __webpack_require__(98);
	var capitalize_pipe_1 = __webpack_require__(99);
	var autocomplete_component_1 = __webpack_require__(100);
	var autocomplete_service_1 = __webpack_require__(101);
	var datepicker_directive_1 = __webpack_require__(103);
	var cep_mask_directive_1 = __webpack_require__(104);
	var number_integer_mask_directive_1 = __webpack_require__(105);
	var cnpj_validation_1 = __webpack_require__(106);
	var cnpj_mask_directive_1 = __webpack_require__(107);
	var cnpj_mask_pipe_1 = __webpack_require__(108);
	var license_plate_mask_pipe_1 = __webpack_require__(109);
	var license_plate_mask_directive_1 = __webpack_require__(110);
	var group_by_service_1 = __webpack_require__(111);
	var currency_mask_pipe_1 = __webpack_require__(112);
	var filter_number_pipe_1 = __webpack_require__(113);
	var currency_mask_directive_1 = __webpack_require__(114);
	var cpf_mask_directive_1 = __webpack_require__(115);
	var cpf_validation_1 = __webpack_require__(116);
	var cpf_mask_pipe_1 = __webpack_require__(117);
	var autocomplete_insert_component_1 = __webpack_require__(118);
	var autocomplete_insert_service_1 = __webpack_require__(119);
	var spinner_component_1 = __webpack_require__(122);
	var codigo_pipe_1 = __webpack_require__(125);
	var codigo_mask_directive_1 = __webpack_require__(126);
	var gtin_13_mask_directive_1 = __webpack_require__(127);
	var gtin_13_pipe_1 = __webpack_require__(128);
	var odometro_horimetro_mask_directive_1 = __webpack_require__(129);
	var odometro_horimetro_mask_pipe_1 = __webpack_require__(130);
	var number_validation_1 = __webpack_require__(132);
	var liter_mask_pipe_1 = __webpack_require__(137);
	var number_max_min_value_validation_1 = __webpack_require__(138);
	var timepicker_directive_1 = __webpack_require__(139);
	var odometro_horimetro_validation_1 = __webpack_require__(140);
	var att_service_1 = __webpack_require__(141);
	var export_csv_service_1 = __webpack_require__(142);
	var SharedModule = (function () {
	    function SharedModule() {
	    }
	    SharedModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule
	            ],
	            providers: [
	                forms_1.FormBuilder,
	                auth_service_1.AuthService,
	                auth_guard_service_1.AuthGuardService,
	                util_service_1.UtilService,
	                filter_service_1.FilterService,
	                sort_service_1.SortService,
	                group_by_service_1.GroupByService,
	                autocomplete_service_1.AutoCompleteService,
	                autocomplete_insert_service_1.AutoCompleteInsertService,
	                att_service_1.AttService,
	                export_csv_service_1.ExportCsvService,
	                email_validation_1.EmailValidator,
	                phone_validation_1.PhoneValidator,
	                cnpj_validation_1.CnpjValidator,
	                cpf_validation_1.CpfValidator,
	                number_validation_1.NumberValidator,
	                number_max_min_value_validation_1.NumberMaxMinValueValidator,
	                odometro_horimetro_validation_1.OdometroHorimetroValidator
	            ],
	            declarations: [
	                autocomplete_component_1.AutoCompleteComponent,
	                autocomplete_insert_component_1.AutoCompleteInsertComponent,
	                spinner_component_1.SpinnerComponent,
	                phone_mask_directive_1.PhoneMaskDirective,
	                datepicker_directive_1.DatepickerDirective,
	                timepicker_directive_1.TimepickerDirective,
	                cep_mask_directive_1.CepMaskDirective,
	                number_integer_mask_directive_1.NumberIntegerDirective,
	                cnpj_mask_directive_1.CnpjMaskDirective,
	                license_plate_mask_directive_1.LicensePlateMaskDirective,
	                currency_mask_directive_1.CurrencyMaskDirective,
	                cpf_mask_directive_1.CpfMaskDirective,
	                codigo_mask_directive_1.CodigoMaskMaskDirective,
	                gtin_13_mask_directive_1.Gtin13MaskDirective,
	                odometro_horimetro_mask_directive_1.OdometroHorimetroMaskDirective,
	                filter_pipe_1.FilterPipe,
	                filter_active_pipe_1.FilterActivePipe,
	                filter_number_pipe_1.FilterNumberPipe,
	                sort_pipe_1.SortPipe,
	                phone_mask_pipe_1.PhoneMaskPipe,
	                capitalize_pipe_1.CapitalizePipe,
	                cnpj_mask_pipe_1.CnpjMaskPipe,
	                license_plate_mask_pipe_1.LicensePlateMaskPipe,
	                currency_mask_pipe_1.CurrencyMaskPipe,
	                cpf_mask_pipe_1.CpfMaskPipe,
	                codigo_pipe_1.CodigoMaskPipe,
	                gtin_13_pipe_1.Gtin13Pipe,
	                odometro_horimetro_mask_pipe_1.OdometroHorimetroMaskPipe,
	                liter_mask_pipe_1.LiterMaskPipe
	            ],
	            exports: [
	                common_1.CommonModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule,
	                autocomplete_component_1.AutoCompleteComponent,
	                autocomplete_insert_component_1.AutoCompleteInsertComponent,
	                spinner_component_1.SpinnerComponent,
	                phone_mask_directive_1.PhoneMaskDirective,
	                datepicker_directive_1.DatepickerDirective,
	                timepicker_directive_1.TimepickerDirective,
	                cep_mask_directive_1.CepMaskDirective,
	                number_integer_mask_directive_1.NumberIntegerDirective,
	                cnpj_mask_directive_1.CnpjMaskDirective,
	                license_plate_mask_directive_1.LicensePlateMaskDirective,
	                currency_mask_directive_1.CurrencyMaskDirective,
	                cpf_mask_directive_1.CpfMaskDirective,
	                codigo_mask_directive_1.CodigoMaskMaskDirective,
	                gtin_13_mask_directive_1.Gtin13MaskDirective,
	                odometro_horimetro_mask_directive_1.OdometroHorimetroMaskDirective,
	                filter_pipe_1.FilterPipe,
	                filter_active_pipe_1.FilterActivePipe,
	                filter_number_pipe_1.FilterNumberPipe,
	                sort_pipe_1.SortPipe,
	                phone_mask_pipe_1.PhoneMaskPipe,
	                capitalize_pipe_1.CapitalizePipe,
	                cnpj_mask_pipe_1.CnpjMaskPipe,
	                license_plate_mask_pipe_1.LicensePlateMaskPipe,
	                currency_mask_pipe_1.CurrencyMaskPipe,
	                cpf_mask_pipe_1.CpfMaskPipe,
	                codigo_pipe_1.CodigoMaskPipe,
	                gtin_13_pipe_1.Gtin13Pipe,
	                odometro_horimetro_mask_pipe_1.OdometroHorimetroMaskPipe,
	                liter_mask_pipe_1.LiterMaskPipe
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SharedModule);
	    return SharedModule;
	}());
	exports.SharedModule = SharedModule;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v2.3.0
	 * (c) 2010-2016 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(3), __webpack_require__(49), __webpack_require__(4), __webpack_require__(5), __webpack_require__(59)) :
	    typeof define === 'function' && define.amd ? define(['exports', '@angular/core', 'rxjs/operator/toPromise', 'rxjs/Subject', 'rxjs/Observable', 'rxjs/observable/fromPromise'], factory) :
	    (factory((global.ng = global.ng || {}, global.ng.forms = global.ng.forms || {}),global.ng.core,global.Rx.Observable.prototype,global.Rx,global.Rx,global.Rx.Observable));
	}(this, function (exports,_angular_core,rxjs_operator_toPromise,rxjs_Subject,rxjs_Observable,rxjs_observable_fromPromise) { 'use strict';
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    /**
	     *  Base class for control directives.
	      * *
	      * Only used internally in the forms module.
	      * *
	     * @abstract
	     */
	    var AbstractControlDirective = (function () {
	        function AbstractControlDirective() {
	        }
	        Object.defineProperty(AbstractControlDirective.prototype, "control", {
	            /**
	             * @return {?}
	             */
	            get: function () { throw new Error('unimplemented'); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "value", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.value : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "valid", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.valid : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.invalid : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "pending", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.pending : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "errors", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.errors : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.pristine : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.dirty : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "touched", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.touched : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.untouched : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.disabled : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.enabled : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.statusChanges : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.control ? this.control.valueChanges : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "path", {
	            /**
	             * @return {?}
	             */
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?=} value
	         * @return {?}
	         */
	        AbstractControlDirective.prototype.reset = function (value) {
	            if (value === void 0) { value = undefined; }
	            if (this.control)
	                this.control.reset(value);
	        };
	        /**
	         * @param {?} errorCode
	         * @param {?=} path
	         * @return {?}
	         */
	        AbstractControlDirective.prototype.hasError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            return this.control ? this.control.hasError(errorCode, path) : false;
	        };
	        /**
	         * @param {?} errorCode
	         * @param {?=} path
	         * @return {?}
	         */
	        AbstractControlDirective.prototype.getError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            return this.control ? this.control.getError(errorCode, path) : null;
	        };
	        return AbstractControlDirective;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$1 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     *  A directive that contains multiple {@link NgControl}s.
	      * *
	      * Only used by the forms module.
	      * *
	     */
	    var ControlContainer = (function (_super) {
	        __extends$1(ControlContainer, _super);
	        function ControlContainer() {
	            _super.apply(this, arguments);
	        }
	        Object.defineProperty(ControlContainer.prototype, "formDirective", {
	            /**
	             *  Get the form to which this container belongs.
	             * @return {?}
	             */
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(ControlContainer.prototype, "path", {
	            /**
	             *  Get the path to this container.
	             * @return {?}
	             */
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        return ControlContainer;
	    }(AbstractControlDirective));
	
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function isPresent(obj) {
	        return obj != null;
	    }
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function isBlank(obj) {
	        return obj == null;
	    }
	    /**
	     * @param {?} a
	     * @param {?} b
	     * @return {?}
	     */
	    function looseIdentical(a, b) {
	        return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
	    }
	    /**
	     * @param {?} o
	     * @return {?}
	     */
	    function isJsObject(o) {
	        return o !== null && (typeof o === 'function' || typeof o === 'object');
	    }
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function isPrimitive(obj) {
	        return !isJsObject(obj);
	    }
	
	    /**
	     *  Wraps Javascript Objects
	     */
	    var StringMapWrapper = (function () {
	        function StringMapWrapper() {
	        }
	        /**
	         * @param {?} m1
	         * @param {?} m2
	         * @return {?}
	         */
	        StringMapWrapper.merge = function (m1, m2) {
	            var /** @type {?} */ m = {};
	            for (var _i = 0, _a = Object.keys(m1); _i < _a.length; _i++) {
	                var k = _a[_i];
	                m[k] = m1[k];
	            }
	            for (var _b = 0, _c = Object.keys(m2); _b < _c.length; _b++) {
	                var k = _c[_b];
	                m[k] = m2[k];
	            }
	            return m;
	        };
	        /**
	         * @param {?} m1
	         * @param {?} m2
	         * @return {?}
	         */
	        StringMapWrapper.equals = function (m1, m2) {
	            var /** @type {?} */ k1 = Object.keys(m1);
	            var /** @type {?} */ k2 = Object.keys(m2);
	            if (k1.length != k2.length) {
	                return false;
	            }
	            for (var /** @type {?} */ i = 0; i < k1.length; i++) {
	                var /** @type {?} */ key = k1[i];
	                if (m1[key] !== m2[key]) {
	                    return false;
	                }
	            }
	            return true;
	        };
	        return StringMapWrapper;
	    }());
	    var ListWrapper = (function () {
	        function ListWrapper() {
	        }
	        /**
	         * @param {?} arr
	         * @param {?} condition
	         * @return {?}
	         */
	        ListWrapper.findLast = function (arr, condition) {
	            for (var /** @type {?} */ i = arr.length - 1; i >= 0; i--) {
	                if (condition(arr[i])) {
	                    return arr[i];
	                }
	            }
	            return null;
	        };
	        /**
	         * @param {?} list
	         * @param {?} items
	         * @return {?}
	         */
	        ListWrapper.removeAll = function (list, items) {
	            for (var /** @type {?} */ i = 0; i < items.length; ++i) {
	                var /** @type {?} */ index = list.indexOf(items[i]);
	                if (index > -1) {
	                    list.splice(index, 1);
	                }
	            }
	        };
	        /**
	         * @param {?} list
	         * @param {?} el
	         * @return {?}
	         */
	        ListWrapper.remove = function (list, el) {
	            var /** @type {?} */ index = list.indexOf(el);
	            if (index > -1) {
	                list.splice(index, 1);
	                return true;
	            }
	            return false;
	        };
	        /**
	         * @param {?} a
	         * @param {?} b
	         * @return {?}
	         */
	        ListWrapper.equals = function (a, b) {
	            if (a.length != b.length)
	                return false;
	            for (var /** @type {?} */ i = 0; i < a.length; ++i) {
	                if (a[i] !== b[i])
	                    return false;
	            }
	            return true;
	        };
	        /**
	         * @param {?} list
	         * @return {?}
	         */
	        ListWrapper.flatten = function (list) {
	            return list.reduce(function (flat, item) {
	                var /** @type {?} */ flatItem = Array.isArray(item) ? ListWrapper.flatten(item) : item;
	                return ((flat)).concat(flatItem);
	            }, []);
	        };
	        return ListWrapper;
	    }());
	
	    var /** @type {?} */ isPromise = _angular_core.__core_private__.isPromise;
	
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    function isEmptyInputValue(value) {
	        return value == null || typeof value === 'string' && value.length === 0;
	    }
	    /**
	     * Providers for validators to be used for {@link FormControl}s in a form.
	     *
	     * Provide this using `multi: true` to add validators.
	     *
	     * ### Example
	     *
	     * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
	     * @stable
	     */
	    var /** @type {?} */ NG_VALIDATORS = new _angular_core.OpaqueToken('NgValidators');
	    /**
	     * Providers for asynchronous validators to be used for {@link FormControl}s
	     * in a form.
	     *
	     * Provide this using `multi: true` to add validators.
	     *
	     * See {@link NG_VALIDATORS} for more details.
	     *
	     * @stable
	     */
	    var /** @type {?} */ NG_ASYNC_VALIDATORS = new _angular_core.OpaqueToken('NgAsyncValidators');
	    /**
	     *  Provides a set of validators used by form controls.
	      * *
	      * A validator is a function that processes a {@link FormControl} or collection of
	      * controls and returns a map of errors. A null map means that validation has passed.
	      * *
	      * ### Example
	      * *
	      * ```typescript
	      * var loginControl = new FormControl("", Validators.required)
	      * ```
	      * *
	     */
	    var Validators = (function () {
	        function Validators() {
	        }
	        /**
	         *  Validator that requires controls to have a non-empty value.
	         * @param {?} control
	         * @return {?}
	         */
	        Validators.required = function (control) {
	            return isEmptyInputValue(control.value) ? { 'required': true } : null;
	        };
	        /**
	         *  Validator that requires controls to have a value of a minimum length.
	         * @param {?} minLength
	         * @return {?}
	         */
	        Validators.minLength = function (minLength) {
	            return function (control) {
	                if (isEmptyInputValue(control.value)) {
	                    return null; // don't validate empty values to allow optional controls
	                }
	                var /** @type {?} */ length = typeof control.value === 'string' ? control.value.length : 0;
	                return length < minLength ?
	                    { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
	                    null;
	            };
	        };
	        /**
	         *  Validator that requires controls to have a value of a maximum length.
	         * @param {?} maxLength
	         * @return {?}
	         */
	        Validators.maxLength = function (maxLength) {
	            return function (control) {
	                var /** @type {?} */ length = typeof control.value === 'string' ? control.value.length : 0;
	                return length > maxLength ?
	                    { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
	                    null;
	            };
	        };
	        /**
	         *  Validator that requires a control to match a regex to its value.
	         * @param {?} pattern
	         * @return {?}
	         */
	        Validators.pattern = function (pattern) {
	            if (!pattern)
	                return Validators.nullValidator;
	            var /** @type {?} */ regex;
	            var /** @type {?} */ regexStr;
	            if (typeof pattern === 'string') {
	                regexStr = "^" + pattern + "$";
	                regex = new RegExp(regexStr);
	            }
	            else {
	                regexStr = pattern.toString();
	                regex = pattern;
	            }
	            return function (control) {
	                if (isEmptyInputValue(control.value)) {
	                    return null; // don't validate empty values to allow optional controls
	                }
	                var /** @type {?} */ value = control.value;
	                return regex.test(value) ? null :
	                    { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
	            };
	        };
	        /**
	         *  No-op validator.
	         * @param {?} c
	         * @return {?}
	         */
	        Validators.nullValidator = function (c) { return null; };
	        /**
	         *  Compose multiple validators into a single function that returns the union
	          * of the individual error maps.
	         * @param {?} validators
	         * @return {?}
	         */
	        Validators.compose = function (validators) {
	            if (!validators)
	                return null;
	            var /** @type {?} */ presentValidators = validators.filter(isPresent);
	            if (presentValidators.length == 0)
	                return null;
	            return function (control) {
	                return _mergeErrors(_executeValidators(control, presentValidators));
	            };
	        };
	        /**
	         * @param {?} validators
	         * @return {?}
	         */
	        Validators.composeAsync = function (validators) {
	            if (!validators)
	                return null;
	            var /** @type {?} */ presentValidators = validators.filter(isPresent);
	            if (presentValidators.length == 0)
	                return null;
	            return function (control) {
	                var /** @type {?} */ promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
	                return Promise.all(promises).then(_mergeErrors);
	            };
	        };
	        return Validators;
	    }());
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function _convertToPromise(obj) {
	        return isPromise(obj) ? obj : rxjs_operator_toPromise.toPromise.call(obj);
	    }
	    /**
	     * @param {?} control
	     * @param {?} validators
	     * @return {?}
	     */
	    function _executeValidators(control, validators) {
	        return validators.map(function (v) { return v(control); });
	    }
	    /**
	     * @param {?} control
	     * @param {?} validators
	     * @return {?}
	     */
	    function _executeAsyncValidators(control, validators) {
	        return validators.map(function (v) { return v(control); });
	    }
	    /**
	     * @param {?} arrayOfErrors
	     * @return {?}
	     */
	    function _mergeErrors(arrayOfErrors) {
	        var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
	            return isPresent(errors) ? StringMapWrapper.merge(res, errors) : res;
	        }, {});
	        return Object.keys(res).length === 0 ? null : res;
	    }
	
	    /**
	     * Used to provide a {@link ControlValueAccessor} for form controls.
	     *
	     * See {@link DefaultValueAccessor} for how to implement one.
	     * @stable
	     */
	    var /** @type {?} */ NG_VALUE_ACCESSOR = new _angular_core.OpaqueToken('NgValueAccessor');
	
	    var /** @type {?} */ CHECKBOX_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return CheckboxControlValueAccessor; }),
	        multi: true,
	    };
	    /**
	     *  The accessor for writing a value and listening to changes on a checkbox input element.
	      * *
	      * ### Example
	      * ```
	      * <input type="checkbox" name="rememberLogin" ngModel>
	      * ```
	      * *
	      * @stable
	     */
	    var CheckboxControlValueAccessor = (function () {
	        /**
	         * @param {?} _renderer
	         * @param {?} _elementRef
	         */
	        function CheckboxControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        CheckboxControlValueAccessor.prototype.writeValue = function (value) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        CheckboxControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
	                        host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
	                        providers: [CHECKBOX_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        CheckboxControlValueAccessor.ctorParameters = function () { return [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ]; };
	        return CheckboxControlValueAccessor;
	    }());
	
	    var /** @type {?} */ DEFAULT_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return DefaultValueAccessor; }),
	        multi: true
	    };
	    /**
	     *  The default accessor for writing a value and listening to changes that is used by the
	      * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	      * *
	      * ### Example
	      * ```
	      * <input type="text" name="searchQuery" ngModel>
	      * ```
	      * *
	      * @stable
	     */
	    var DefaultValueAccessor = (function () {
	        /**
	         * @param {?} _renderer
	         * @param {?} _elementRef
	         */
	        function DefaultValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        DefaultValueAccessor.prototype.writeValue = function (value) {
	            var /** @type {?} */ normalizedValue = value == null ? '' : value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        DefaultValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
	                        // TODO: vsavkin replace the above selector with the one below it once
	                        // https://github.com/angular/angular/issues/3011 is implemented
	                        // selector: '[ngControl],[ngModel],[ngFormControl]',
	                        host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                        providers: [DEFAULT_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        DefaultValueAccessor.ctorParameters = function () { return [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ]; };
	        return DefaultValueAccessor;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    /**
	     * @param {?} validator
	     * @return {?}
	     */
	    function normalizeValidator(validator) {
	        if (((validator)).validate) {
	            return function (c) { return ((validator)).validate(c); };
	        }
	        else {
	            return (validator);
	        }
	    }
	    /**
	     * @param {?} validator
	     * @return {?}
	     */
	    function normalizeAsyncValidator(validator) {
	        if (((validator)).validate) {
	            return function (c) { return ((validator)).validate(c); };
	        }
	        else {
	            return (validator);
	        }
	    }
	
	    var /** @type {?} */ NUMBER_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return NumberValueAccessor; }),
	        multi: true
	    };
	    /**
	     *  The accessor for writing a number value and listening to changes that is used by the
	      * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	      * *
	      * ### Example
	      * ```
	      * <input type="number" [(ngModel)]="age">
	      * ```
	     */
	    var NumberValueAccessor = (function () {
	        /**
	         * @param {?} _renderer
	         * @param {?} _elementRef
	         */
	        function NumberValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        NumberValueAccessor.prototype.writeValue = function (value) {
	            // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
	            var /** @type {?} */ normalizedValue = value == null ? '' : value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        NumberValueAccessor.prototype.registerOnChange = function (fn) {
	            this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        NumberValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
	                        host: {
	                            '(change)': 'onChange($event.target.value)',
	                            '(input)': 'onChange($event.target.value)',
	                            '(blur)': 'onTouched()'
	                        },
	                        providers: [NUMBER_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        NumberValueAccessor.ctorParameters = function () { return [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ]; };
	        return NumberValueAccessor;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$2 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * @return {?}
	     */
	    function unimplemented() {
	        throw new Error('unimplemented');
	    }
	    /**
	     *  A base class that all control directive extend.
	      * It binds a {@link FormControl} object to a DOM element.
	      * *
	      * Used internally by Angular forms.
	      * *
	     * @abstract
	     */
	    var NgControl = (function (_super) {
	        __extends$2(NgControl, _super);
	        function NgControl() {
	            _super.apply(this, arguments);
	            /** @internal */
	            this._parent = null;
	            this.name = null;
	            this.valueAccessor = null;
	            /** @internal */
	            this._rawValidators = [];
	            /** @internal */
	            this._rawAsyncValidators = [];
	        }
	        Object.defineProperty(NgControl.prototype, "validator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return (unimplemented()); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgControl.prototype, "asyncValidator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return (unimplemented()); },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @abstract
	         * @param {?} newValue
	         * @return {?}
	         */
	        NgControl.prototype.viewToModelUpdate = function (newValue) { };
	        return NgControl;
	    }(AbstractControlDirective));
	
	    var /** @type {?} */ RADIO_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return RadioControlValueAccessor; }),
	        multi: true
	    };
	    /**
	     *  Internal class used by Angular to uncheck radio buttons with the matching name.
	     */
	    var RadioControlRegistry = (function () {
	        function RadioControlRegistry() {
	            this._accessors = [];
	        }
	        /**
	         * @param {?} control
	         * @param {?} accessor
	         * @return {?}
	         */
	        RadioControlRegistry.prototype.add = function (control, accessor) {
	            this._accessors.push([control, accessor]);
	        };
	        /**
	         * @param {?} accessor
	         * @return {?}
	         */
	        RadioControlRegistry.prototype.remove = function (accessor) {
	            for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
	                if (this._accessors[i][1] === accessor) {
	                    this._accessors.splice(i, 1);
	                    return;
	                }
	            }
	        };
	        /**
	         * @param {?} accessor
	         * @return {?}
	         */
	        RadioControlRegistry.prototype.select = function (accessor) {
	            var _this = this;
	            this._accessors.forEach(function (c) {
	                if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
	                    c[1].fireUncheck(accessor.value);
	                }
	            });
	        };
	        /**
	         * @param {?} controlPair
	         * @param {?} accessor
	         * @return {?}
	         */
	        RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
	            if (!controlPair[0].control)
	                return false;
	            return controlPair[0]._parent === accessor._control._parent &&
	                controlPair[1].name === accessor.name;
	        };
	        RadioControlRegistry.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        RadioControlRegistry.ctorParameters = function () { return []; };
	        return RadioControlRegistry;
	    }());
	    /**
	     *  *
	      * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
	      * to keep the view synced with the {@link FormControl} model.
	      * *
	      * *
	      * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
	      * value accessor will be active on any radio control that has a form directive. You do
	      * **not** need to add a special selector to activate it.
	      * *
	      * ### How to use radio buttons with form directives
	      * *
	      * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
	      * in the same group have the same `name` attribute.  Radio buttons with different `name`
	      * attributes do not affect each other.
	      * *
	      * {@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
	      * *
	      * When using radio buttons in a reactive form, radio buttons in the same group should have the
	      * same `formControlName`. You can also add a `name` attribute, but it's optional.
	      * *
	      * {@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	      * @stable
	     */
	    var RadioControlValueAccessor = (function () {
	        /**
	         * @param {?} _renderer
	         * @param {?} _elementRef
	         * @param {?} _registry
	         * @param {?} _injector
	         */
	        function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this._registry = _registry;
	            this._injector = _injector;
	            this.onChange = function () { };
	            this.onTouched = function () { };
	        }
	        /**
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype.ngOnInit = function () {
	            this._control = this._injector.get(NgControl);
	            this._checkName();
	            this._registry.add(this._control, this);
	        };
	        /**
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype.writeValue = function (value) {
	            this._state = value === this.value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this._fn = fn;
	            this.onChange = function () {
	                fn(_this.value);
	                _this._registry.select(_this);
	            };
	        };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        /**
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype._checkName = function () {
	            if (this.name && this.formControlName && this.name !== this.formControlName) {
	                this._throwNameError();
	            }
	            if (!this.name && this.formControlName)
	                this.name = this.formControlName;
	        };
	        /**
	         * @return {?}
	         */
	        RadioControlValueAccessor.prototype._throwNameError = function () {
	            throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
	        };
	        RadioControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
	                        host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
	                        providers: [RADIO_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        RadioControlValueAccessor.ctorParameters = function () { return [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	            { type: RadioControlRegistry, },
	            { type: _angular_core.Injector, },
	        ]; };
	        RadioControlValueAccessor.propDecorators = {
	            'name': [{ type: _angular_core.Input },],
	            'formControlName': [{ type: _angular_core.Input },],
	            'value': [{ type: _angular_core.Input },],
	        };
	        return RadioControlValueAccessor;
	    }());
	
	    var /** @type {?} */ RANGE_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return RangeValueAccessor; }),
	        multi: true
	    };
	    /**
	     *  The accessor for writing a range value and listening to changes that is used by the
	      * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	      * *
	      * ### Example
	      * ```
	      * <input type="range" [(ngModel)]="age" >
	      * ```
	     */
	    var RangeValueAccessor = (function () {
	        /**
	         * @param {?} _renderer
	         * @param {?} _elementRef
	         */
	        function RangeValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        RangeValueAccessor.prototype.writeValue = function (value) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        RangeValueAccessor.prototype.registerOnChange = function (fn) {
	            this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        RangeValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
	                        host: {
	                            '(change)': 'onChange($event.target.value)',
	                            '(input)': 'onChange($event.target.value)',
	                            '(blur)': 'onTouched()'
	                        },
	                        providers: [RANGE_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        RangeValueAccessor.ctorParameters = function () { return [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ]; };
	        return RangeValueAccessor;
	    }());
	
	    var /** @type {?} */ SELECT_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return SelectControlValueAccessor; }),
	        multi: true
	    };
	    /**
	     * @param {?} id
	     * @param {?} value
	     * @return {?}
	     */
	    function _buildValueString(id, value) {
	        if (id == null)
	            return "" + value;
	        if (!isPrimitive(value))
	            value = 'Object';
	        return (id + ": " + value).slice(0, 50);
	    }
	    /**
	     * @param {?} valueString
	     * @return {?}
	     */
	    function _extractId(valueString) {
	        return valueString.split(':')[0];
	    }
	    /**
	     *  *
	      * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
	      * to keep the view synced with the {@link FormControl} model.
	      * *
	      * *
	      * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
	      * value accessor will be active on any select control that has a form directive. You do
	      * **not** need to add a special selector to activate it.
	      * *
	      * ### How to use select controls with form directives
	      * *
	      * To use a select in a template-driven form, simply add an `ngModel` and a `name`
	      * attribute to the main `<select>` tag.
	      * *
	      * If your option values are simple strings, you can bind to the normal `value` property
	      * on the option.  If your option values happen to be objects (and you'd like to save the
	      * selection in your form as an object), use `ngValue` instead:
	      * *
	      * {@example forms/ts/selectControl/select_control_example.ts region='Component'}
	      * *
	      * In reactive forms, you'll also want to add your form directive (`formControlName` or
	      * `formControl`) on the main `<select>` tag. Like in the former example, you have the
	      * choice of binding to the  `value` or `ngValue` property on the select's options.
	      * *
	      * {@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
	      * *
	      * Note: We listen to the 'change' event because 'input' events aren't fired
	      * for selects in Firefox and IE:
	      * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
	      * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	     */
	    var SelectControlValueAccessor = (function () {
	        /**
	         * @param {?} _renderer
	         * @param {?} _elementRef
	         */
	        function SelectControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            /** @internal */
	            this._optionMap = new Map();
	            /** @internal */
	            this._idCounter = 0;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        SelectControlValueAccessor.prototype.writeValue = function (value) {
	            this.value = value;
	            var /** @type {?} */ valueString = _buildValueString(this._getOptionId(value), value);
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this.onChange = function (valueString) {
	                _this.value = valueString;
	                fn(_this._getOptionValue(valueString));
	            };
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        /**
	         * @return {?}
	         */
	        SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        SelectControlValueAccessor.prototype._getOptionId = function (value) {
	            for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
	                var id = _a[_i];
	                if (looseIdentical(this._optionMap.get(id), value))
	                    return id;
	            }
	            return null;
	        };
	        /**
	         * @param {?} valueString
	         * @return {?}
	         */
	        SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
	            var /** @type {?} */ id = _extractId(valueString);
	            return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
	        };
	        SelectControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
	                        host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                        providers: [SELECT_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        SelectControlValueAccessor.ctorParameters = function () { return [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ]; };
	        return SelectControlValueAccessor;
	    }());
	    /**
	     *  *
	      * *
	      * See docs for {@link SelectControlValueAccessor} for usage examples.
	      * *
	     */
	    var NgSelectOption = (function () {
	        /**
	         * @param {?} _element
	         * @param {?} _renderer
	         * @param {?} _select
	         */
	        function NgSelectOption(_element, _renderer, _select) {
	            this._element = _element;
	            this._renderer = _renderer;
	            this._select = _select;
	            if (this._select)
	                this.id = this._select._registerOption();
	        }
	        Object.defineProperty(NgSelectOption.prototype, "ngValue", {
	            /**
	             * @param {?} value
	             * @return {?}
	             */
	            set: function (value) {
	                if (this._select == null)
	                    return;
	                this._select._optionMap.set(this.id, value);
	                this._setElementValue(_buildValueString(this.id, value));
	                this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgSelectOption.prototype, "value", {
	            /**
	             * @param {?} value
	             * @return {?}
	             */
	            set: function (value) {
	                this._setElementValue(value);
	                if (this._select)
	                    this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        NgSelectOption.prototype._setElementValue = function (value) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	        };
	        /**
	         * @return {?}
	         */
	        NgSelectOption.prototype.ngOnDestroy = function () {
	            if (this._select) {
	                this._select._optionMap.delete(this.id);
	                this._select.writeValue(this._select.value);
	            }
	        };
	        NgSelectOption.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: 'option' },] },
	        ];
	        /** @nocollapse */
	        NgSelectOption.ctorParameters = function () { return [
	            { type: _angular_core.ElementRef, },
	            { type: _angular_core.Renderer, },
	            { type: SelectControlValueAccessor, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        ]; };
	        NgSelectOption.propDecorators = {
	            'ngValue': [{ type: _angular_core.Input, args: ['ngValue',] },],
	            'value': [{ type: _angular_core.Input, args: ['value',] },],
	        };
	        return NgSelectOption;
	    }());
	
	    var /** @type {?} */ SELECT_MULTIPLE_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return SelectMultipleControlValueAccessor; }),
	        multi: true
	    };
	    /**
	     * @param {?} id
	     * @param {?} value
	     * @return {?}
	     */
	    function _buildValueString$1(id, value) {
	        if (id == null)
	            return "" + value;
	        if (typeof value === 'string')
	            value = "'" + value + "'";
	        if (!isPrimitive(value))
	            value = 'Object';
	        return (id + ": " + value).slice(0, 50);
	    }
	    /**
	     * @param {?} valueString
	     * @return {?}
	     */
	    function _extractId$1(valueString) {
	        return valueString.split(':')[0];
	    }
	    /**
	     *  The accessor for writing a value and listening to changes on a select element.
	      * *
	     */
	    var SelectMultipleControlValueAccessor = (function () {
	        /**
	         * @param {?} _renderer
	         * @param {?} _elementRef
	         */
	        function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            /** @internal */
	            this._optionMap = new Map();
	            /** @internal */
	            this._idCounter = 0;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
	            var _this = this;
	            this.value = value;
	            if (value == null)
	                return;
	            var /** @type {?} */ values = (value);
	            // convert values to ids
	            var /** @type {?} */ ids = values.map(function (v) { return _this._getOptionId(v); });
	            this._optionMap.forEach(function (opt, o) { opt._setSelected(ids.indexOf(o.toString()) > -1); });
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this.onChange = function (_) {
	                var /** @type {?} */ selected = [];
	                if (_.hasOwnProperty('selectedOptions')) {
	                    var /** @type {?} */ options = _.selectedOptions;
	                    for (var /** @type {?} */ i = 0; i < options.length; i++) {
	                        var /** @type {?} */ opt = options.item(i);
	                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
	                        selected.push(val);
	                    }
	                }
	                else {
	                    var /** @type {?} */ options = (_.options);
	                    for (var /** @type {?} */ i = 0; i < options.length; i++) {
	                        var /** @type {?} */ opt = options.item(i);
	                        if (opt.selected) {
	                            var /** @type {?} */ val = _this._getOptionValue(opt.value);
	                            selected.push(val);
	                        }
	                    }
	                }
	                fn(selected);
	            };
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
	            var /** @type {?} */ id = (this._idCounter++).toString();
	            this._optionMap.set(id, value);
	            return id;
	        };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
	            for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
	                var id = _a[_i];
	                if (looseIdentical(this._optionMap.get(id)._value, value))
	                    return id;
	            }
	            return null;
	        };
	        /**
	         * @param {?} valueString
	         * @return {?}
	         */
	        SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
	            var /** @type {?} */ id = _extractId$1(valueString);
	            return this._optionMap.has(id) ? this._optionMap.get(id)._value : valueString;
	        };
	        SelectMultipleControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
	                        host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
	                        providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        SelectMultipleControlValueAccessor.ctorParameters = function () { return [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ]; };
	        return SelectMultipleControlValueAccessor;
	    }());
	    /**
	     *  Marks `<option>` as dynamic, so Angular can be notified when options change.
	      * *
	      * ### Example
	      * *
	      * ```
	      * <select multiple name="city" ngModel>
	      * <option *ngFor="let c of cities" [value]="c"></option>
	      * </select>
	      * ```
	     */
	    var NgSelectMultipleOption = (function () {
	        /**
	         * @param {?} _element
	         * @param {?} _renderer
	         * @param {?} _select
	         */
	        function NgSelectMultipleOption(_element, _renderer, _select) {
	            this._element = _element;
	            this._renderer = _renderer;
	            this._select = _select;
	            if (this._select) {
	                this.id = this._select._registerOption(this);
	            }
	        }
	        Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
	            /**
	             * @param {?} value
	             * @return {?}
	             */
	            set: function (value) {
	                if (this._select == null)
	                    return;
	                this._value = value;
	                this._setElementValue(_buildValueString$1(this.id, value));
	                this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
	            /**
	             * @param {?} value
	             * @return {?}
	             */
	            set: function (value) {
	                if (this._select) {
	                    this._value = value;
	                    this._setElementValue(_buildValueString$1(this.id, value));
	                    this._select.writeValue(this._select.value);
	                }
	                else {
	                    this._setElementValue(value);
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        NgSelectMultipleOption.prototype._setElementValue = function (value) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	        };
	        /**
	         * @param {?} selected
	         * @return {?}
	         */
	        NgSelectMultipleOption.prototype._setSelected = function (selected) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
	        };
	        /**
	         * @return {?}
	         */
	        NgSelectMultipleOption.prototype.ngOnDestroy = function () {
	            if (this._select) {
	                this._select._optionMap.delete(this.id);
	                this._select.writeValue(this._select.value);
	            }
	        };
	        NgSelectMultipleOption.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: 'option' },] },
	        ];
	        /** @nocollapse */
	        NgSelectMultipleOption.ctorParameters = function () { return [
	            { type: _angular_core.ElementRef, },
	            { type: _angular_core.Renderer, },
	            { type: SelectMultipleControlValueAccessor, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        ]; };
	        NgSelectMultipleOption.propDecorators = {
	            'ngValue': [{ type: _angular_core.Input, args: ['ngValue',] },],
	            'value': [{ type: _angular_core.Input, args: ['value',] },],
	        };
	        return NgSelectMultipleOption;
	    }());
	
	    /**
	     * @param {?} name
	     * @param {?} parent
	     * @return {?}
	     */
	    function controlPath(name, parent) {
	        return parent.path.concat([name]);
	    }
	    /**
	     * @param {?} control
	     * @param {?} dir
	     * @return {?}
	     */
	    function setUpControl(control, dir) {
	        if (!control)
	            _throwError(dir, 'Cannot find control with');
	        if (!dir.valueAccessor)
	            _throwError(dir, 'No value accessor for form control with');
	        control.validator = Validators.compose([control.validator, dir.validator]);
	        control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	        dir.valueAccessor.writeValue(control.value);
	        // view -> model
	        dir.valueAccessor.registerOnChange(function (newValue) {
	            dir.viewToModelUpdate(newValue);
	            control.markAsDirty();
	            control.setValue(newValue, { emitModelToViewChange: false });
	        });
	        // touched
	        dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
	        control.registerOnChange(function (newValue, emitModelEvent) {
	            // control -> view
	            dir.valueAccessor.writeValue(newValue);
	            // control -> ngModel
	            if (emitModelEvent)
	                dir.viewToModelUpdate(newValue);
	        });
	        if (dir.valueAccessor.setDisabledState) {
	            control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
	        }
	        // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
	        dir._rawValidators.forEach(function (validator) {
	            if (((validator)).registerOnValidatorChange)
	                ((validator)).registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
	        });
	        dir._rawAsyncValidators.forEach(function (validator) {
	            if (((validator)).registerOnValidatorChange)
	                ((validator)).registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
	        });
	    }
	    /**
	     * @param {?} control
	     * @param {?} dir
	     * @return {?}
	     */
	    function cleanUpControl(control, dir) {
	        dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
	        dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
	        dir._rawValidators.forEach(function (validator) {
	            if (validator.registerOnValidatorChange) {
	                validator.registerOnValidatorChange(null);
	            }
	        });
	        dir._rawAsyncValidators.forEach(function (validator) {
	            if (validator.registerOnValidatorChange) {
	                validator.registerOnValidatorChange(null);
	            }
	        });
	        if (control)
	            control._clearChangeFns();
	    }
	    /**
	     * @param {?} control
	     * @param {?} dir
	     * @return {?}
	     */
	    function setUpFormContainer(control, dir) {
	        if (isBlank(control))
	            _throwError(dir, 'Cannot find control with');
	        control.validator = Validators.compose([control.validator, dir.validator]);
	        control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	    }
	    /**
	     * @param {?} dir
	     * @return {?}
	     */
	    function _noControlError(dir) {
	        return _throwError(dir, 'There is no FormControl instance attached to form control element with');
	    }
	    /**
	     * @param {?} dir
	     * @param {?} message
	     * @return {?}
	     */
	    function _throwError(dir, message) {
	        var /** @type {?} */ messageEnd;
	        if (dir.path.length > 1) {
	            messageEnd = "path: '" + dir.path.join(' -> ') + "'";
	        }
	        else if (dir.path[0]) {
	            messageEnd = "name: '" + dir.path + "'";
	        }
	        else {
	            messageEnd = 'unspecified name attribute';
	        }
	        throw new Error(message + " " + messageEnd);
	    }
	    /**
	     * @param {?} validators
	     * @return {?}
	     */
	    function composeValidators(validators) {
	        return isPresent(validators) ? Validators.compose(validators.map(normalizeValidator)) : null;
	    }
	    /**
	     * @param {?} validators
	     * @return {?}
	     */
	    function composeAsyncValidators(validators) {
	        return isPresent(validators) ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
	            null;
	    }
	    /**
	     * @param {?} changes
	     * @param {?} viewModel
	     * @return {?}
	     */
	    function isPropertyUpdated(changes, viewModel) {
	        if (!changes.hasOwnProperty('model'))
	            return false;
	        var /** @type {?} */ change = changes['model'];
	        if (change.isFirstChange())
	            return true;
	        return !looseIdentical(viewModel, change.currentValue);
	    }
	    var /** @type {?} */ BUILTIN_ACCESSORS = [
	        CheckboxControlValueAccessor,
	        RangeValueAccessor,
	        NumberValueAccessor,
	        SelectControlValueAccessor,
	        SelectMultipleControlValueAccessor,
	        RadioControlValueAccessor,
	    ];
	    /**
	     * @param {?} valueAccessor
	     * @return {?}
	     */
	    function isBuiltInAccessor(valueAccessor) {
	        return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
	    }
	    /**
	     * @param {?} dir
	     * @param {?} valueAccessors
	     * @return {?}
	     */
	    function selectValueAccessor(dir, valueAccessors) {
	        if (!valueAccessors)
	            return null;
	        var /** @type {?} */ defaultAccessor;
	        var /** @type {?} */ builtinAccessor;
	        var /** @type {?} */ customAccessor;
	        valueAccessors.forEach(function (v) {
	            if (v.constructor === DefaultValueAccessor) {
	                defaultAccessor = v;
	            }
	            else if (isBuiltInAccessor(v)) {
	                if (builtinAccessor)
	                    _throwError(dir, 'More than one built-in value accessor matches form control with');
	                builtinAccessor = v;
	            }
	            else {
	                if (customAccessor)
	                    _throwError(dir, 'More than one custom value accessor matches form control with');
	                customAccessor = v;
	            }
	        });
	        if (customAccessor)
	            return customAccessor;
	        if (builtinAccessor)
	            return builtinAccessor;
	        if (defaultAccessor)
	            return defaultAccessor;
	        _throwError(dir, 'No valid value accessor for form control with');
	        return null;
	    }
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     *  This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
	      * *
	     */
	    var AbstractFormGroupDirective = (function (_super) {
	        __extends(AbstractFormGroupDirective, _super);
	        function AbstractFormGroupDirective() {
	            _super.apply(this, arguments);
	        }
	        /**
	         * @return {?}
	         */
	        AbstractFormGroupDirective.prototype.ngOnInit = function () {
	            this._checkParentType();
	            this.formDirective.addFormGroup(this);
	        };
	        /**
	         * @return {?}
	         */
	        AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeFormGroup(this);
	            }
	        };
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
	            /**
	             *  Get the {@link FormGroup} backing this binding.
	             * @return {?}
	             */
	            get: function () { return this.formDirective.getFormGroup(this); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
	            /**
	             *  Get the path to this control group.
	             * @return {?}
	             */
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
	            /**
	             *  Get the {@link Form} to which this group belongs.
	             * @return {?}
	             */
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return composeValidators(this._validators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return composeAsyncValidators(this._asyncValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @return {?}
	         */
	        AbstractFormGroupDirective.prototype._checkParentType = function () { };
	        return AbstractFormGroupDirective;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$3 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var AbstractControlStatus = (function () {
	        /**
	         * @param {?} cd
	         */
	        function AbstractControlStatus(cd) {
	            this._cd = cd;
	        }
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._cd.control ? this._cd.control.untouched : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._cd.control ? this._cd.control.touched : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._cd.control ? this._cd.control.pristine : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._cd.control ? this._cd.control.dirty : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._cd.control ? this._cd.control.valid : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._cd.control ? this._cd.control.invalid : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._cd.control ? this._cd.control.pending : false; },
	            enumerable: true,
	            configurable: true
	        });
	        return AbstractControlStatus;
	    }());
	    var /** @type {?} */ ngControlStatusHost = {
	        '[class.ng-untouched]': 'ngClassUntouched',
	        '[class.ng-touched]': 'ngClassTouched',
	        '[class.ng-pristine]': 'ngClassPristine',
	        '[class.ng-dirty]': 'ngClassDirty',
	        '[class.ng-valid]': 'ngClassValid',
	        '[class.ng-invalid]': 'ngClassInvalid',
	        '[class.ng-pending]': 'ngClassPending',
	    };
	    /**
	     *  Directive automatically applied to Angular form controls that sets CSS classes
	      * based on control status (valid/invalid/dirty/etc).
	      * *
	     */
	    var NgControlStatus = (function (_super) {
	        __extends$3(NgControlStatus, _super);
	        /**
	         * @param {?} cd
	         */
	        function NgControlStatus(cd) {
	            _super.call(this, cd);
	        }
	        NgControlStatus.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
	        ];
	        /** @nocollapse */
	        NgControlStatus.ctorParameters = function () { return [
	            { type: NgControl, decorators: [{ type: _angular_core.Self },] },
	        ]; };
	        return NgControlStatus;
	    }(AbstractControlStatus));
	    /**
	     *  Directive automatically applied to Angular form groups that sets CSS classes
	      * based on control status (valid/invalid/dirty/etc).
	      * *
	     */
	    var NgControlStatusGroup = (function (_super) {
	        __extends$3(NgControlStatusGroup, _super);
	        /**
	         * @param {?} cd
	         */
	        function NgControlStatusGroup(cd) {
	            _super.call(this, cd);
	        }
	        NgControlStatusGroup.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
	                        host: ngControlStatusHost
	                    },] },
	        ];
	        /** @nocollapse */
	        NgControlStatusGroup.ctorParameters = function () { return [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Self },] },
	        ]; };
	        return NgControlStatusGroup;
	    }(AbstractControlStatus));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$5 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     *  Use by directives and components to emit custom Events.
	      * *
	      * ### Examples
	      * *
	      * In the following example, `Zippy` alternatively emits `open` and `close` events when its
	      * title gets clicked:
	      * *
	      * ```
	      * selector: 'zippy',
	      * template: `
	      * <div class="zippy">
	      * <div (click)="toggle()">Toggle</div>
	      * <div [hidden]="!visible">
	      * <ng-content></ng-content>
	      * </div>
	      * </div>`})
	      * export class Zippy {
	      * visible: boolean = true;
	      * @Output() open: EventEmitter<any> = new EventEmitter();
	      * @Output() close: EventEmitter<any> = new EventEmitter();
	      * *
	      * toggle() {
	      * this.visible = !this.visible;
	      * if (this.visible) {
	      * this.open.emit(null);
	      * } else {
	      * this.close.emit(null);
	      * }
	      * }
	      * }
	      * ```
	      * *
	      * The events payload can be accessed by the parameter `$event` on the components output event
	      * handler:
	      * *
	      * ```
	      * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
	      * ```
	      * *
	      * Uses Rx.Observable but provides an adapter to make it work as specified here:
	      * https://github.com/jhusain/observable-spec
	      * *
	      * Once a reference implementation of the spec is available, switch to it.
	     */
	    var EventEmitter = (function (_super) {
	        __extends$5(EventEmitter, _super);
	        /**
	         *  Creates an instance of [EventEmitter], which depending on [isAsync],
	          * delivers events synchronously or asynchronously.
	         * @param {?=} isAsync
	         */
	        function EventEmitter(isAsync) {
	            if (isAsync === void 0) { isAsync = false; }
	            _super.call(this);
	            this.__isAsync = isAsync;
	        }
	        /**
	         * @param {?=} value
	         * @return {?}
	         */
	        EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
	        /**
	         * @param {?=} generatorOrNext
	         * @param {?=} error
	         * @param {?=} complete
	         * @return {?}
	         */
	        EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
	            var /** @type {?} */ schedulerFn;
	            var /** @type {?} */ errorFn = function (err) { return null; };
	            var /** @type {?} */ completeFn = function () { return null; };
	            if (generatorOrNext && typeof generatorOrNext === 'object') {
	                schedulerFn = this.__isAsync ? function (value) {
	                    setTimeout(function () { return generatorOrNext.next(value); });
	                } : function (value) { generatorOrNext.next(value); };
	                if (generatorOrNext.error) {
	                    errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
	                        function (err) { generatorOrNext.error(err); };
	                }
	                if (generatorOrNext.complete) {
	                    completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
	                        function () { generatorOrNext.complete(); };
	                }
	            }
	            else {
	                schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
	                    function (value) { generatorOrNext(value); };
	                if (error) {
	                    errorFn =
	                        this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
	                }
	                if (complete) {
	                    completeFn =
	                        this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
	                }
	            }
	            return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
	        };
	        return EventEmitter;
	    }(rxjs_Subject.Subject));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$6 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
	     */
	    var /** @type {?} */ VALID = 'VALID';
	    /**
	     * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
	     */
	    var /** @type {?} */ INVALID = 'INVALID';
	    /**
	     * Indicates that a FormControl is pending, i.e. that async validation is occurring and
	     * errors are not yet available for the input value.
	     */
	    var /** @type {?} */ PENDING = 'PENDING';
	    /**
	     * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
	     * calculations of validity or value.
	     */
	    var /** @type {?} */ DISABLED = 'DISABLED';
	    /**
	     * @param {?} control
	     * @param {?} path
	     * @param {?} delimiter
	     * @return {?}
	     */
	    function _find(control, path, delimiter) {
	        if (path == null)
	            return null;
	        if (!(path instanceof Array)) {
	            path = ((path)).split(delimiter);
	        }
	        if (path instanceof Array && (path.length === 0))
	            return null;
	        return ((path)).reduce(function (v, name) {
	            if (v instanceof FormGroup) {
	                return v.controls[name] || null;
	            }
	            if (v instanceof FormArray) {
	                return v.at(/** @type {?} */ (name)) || null;
	            }
	            return null;
	        }, control);
	    }
	    /**
	     * @param {?} r
	     * @return {?}
	     */
	    function toObservable(r) {
	        return isPromise(r) ? rxjs_observable_fromPromise.fromPromise(r) : r;
	    }
	    /**
	     * @param {?} validator
	     * @return {?}
	     */
	    function coerceToValidator(validator) {
	        return Array.isArray(validator) ? composeValidators(validator) : validator;
	    }
	    /**
	     * @param {?} asyncValidator
	     * @return {?}
	     */
	    function coerceToAsyncValidator(asyncValidator) {
	        return Array.isArray(asyncValidator) ? composeAsyncValidators(asyncValidator) : asyncValidator;
	    }
	    /**
	     *  {@link FormArray}.
	      * *
	      * It provides some of the shared behavior that all controls and groups of controls have, like
	      * running validators, calculating status, and resetting state. It also defines the properties
	      * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
	      * instantiated directly.
	      * *
	     * @abstract
	     */
	    var AbstractControl = (function () {
	        /**
	         * @param {?} validator
	         * @param {?} asyncValidator
	         */
	        function AbstractControl(validator, asyncValidator) {
	            this.validator = validator;
	            this.asyncValidator = asyncValidator;
	            /** @internal */
	            this._onCollectionChange = function () { };
	            this._pristine = true;
	            this._touched = false;
	            /** @internal */
	            this._onDisabledChange = [];
	        }
	        Object.defineProperty(AbstractControl.prototype, "value", {
	            /**
	             *  The value of the control.
	             * @return {?}
	             */
	            get: function () { return this._value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "parent", {
	            /**
	             *  The parent control.
	             * @return {?}
	             */
	            get: function () { return this._parent; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "status", {
	            /**
	             *  The validation status of the control. There are four possible
	              * validation statuses:
	              * *
	              * * **VALID**:  control has passed all validation checks
	              * * **INVALID**: control has failed at least one validation check
	              * * **PENDING**: control is in the midst of conducting a validation check
	              * * **DISABLED**: control is exempt from validation checks
	              * *
	              * These statuses are mutually exclusive, so a control cannot be
	              * both valid AND invalid or invalid AND disabled.
	             * @return {?}
	             */
	            get: function () { return this._status; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "valid", {
	            /**
	             *  A control is `valid` when its `status === VALID`.
	              * *
	              * In order to have this status, the control must have passed all its
	              * validation checks.
	             * @return {?}
	             */
	            get: function () { return this._status === VALID; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "invalid", {
	            /**
	             *  A control is `invalid` when its `status === INVALID`.
	              * *
	              * In order to have this status, the control must have failed
	              * at least one of its validation checks.
	             * @return {?}
	             */
	            get: function () { return this._status === INVALID; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "pending", {
	            /**
	             *  A control is `pending` when its `status === PENDING`.
	              * *
	              * In order to have this status, the control must be in the
	              * middle of conducting a validation check.
	             * @return {?}
	             */
	            get: function () { return this._status == PENDING; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "disabled", {
	            /**
	             *  A control is `disabled` when its `status === DISABLED`.
	              * *
	              * Disabled controls are exempt from validation checks and
	              * are not included in the aggregate value of their ancestor
	              * controls.
	             * @return {?}
	             */
	            get: function () { return this._status === DISABLED; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "enabled", {
	            /**
	             *  A control is `enabled` as long as its `status !== DISABLED`.
	              * *
	              * In other words, it has a status of `VALID`, `INVALID`, or
	              * `PENDING`.
	             * @return {?}
	             */
	            get: function () { return this._status !== DISABLED; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "errors", {
	            /**
	             *  Returns any errors generated by failing validation. If there
	              * are no errors, it will return null.
	             * @return {?}
	             */
	            get: function () { return this._errors; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "pristine", {
	            /**
	             *  A control is `pristine` if the user has not yet changed
	              * the value in the UI.
	              * *
	              * Note that programmatic changes to a control's value will
	              * *not* mark it dirty.
	             * @return {?}
	             */
	            get: function () { return this._pristine; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "dirty", {
	            /**
	             *  A control is `dirty` if the user has changed the value
	              * in the UI.
	              * *
	              * Note that programmatic changes to a control's value will
	              * *not* mark it dirty.
	             * @return {?}
	             */
	            get: function () { return !this.pristine; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "touched", {
	            /**
	             *  A control is marked `touched` once the user has triggered
	              * a `blur` event on it.
	             * @return {?}
	             */
	            get: function () { return this._touched; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "untouched", {
	            /**
	             *  A control is `untouched` if the user has not yet triggered
	              * a `blur` event on it.
	             * @return {?}
	             */
	            get: function () { return !this._touched; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "valueChanges", {
	            /**
	             *  Emits an event every time the value of the control changes, in
	              * the UI or programmatically.
	             * @return {?}
	             */
	            get: function () { return this._valueChanges; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "statusChanges", {
	            /**
	             *  Emits an event every time the validation status of the control
	              * is re-calculated.
	             * @return {?}
	             */
	            get: function () { return this._statusChanges; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         *  Sets the synchronous validators that are active on this control.  Calling
	          * this will overwrite any existing sync validators.
	         * @param {?} newValidator
	         * @return {?}
	         */
	        AbstractControl.prototype.setValidators = function (newValidator) {
	            this.validator = coerceToValidator(newValidator);
	        };
	        /**
	         *  Sets the async validators that are active on this control. Calling this
	          * will overwrite any existing async validators.
	         * @param {?} newValidator
	         * @return {?}
	         */
	        AbstractControl.prototype.setAsyncValidators = function (newValidator) {
	            this.asyncValidator = coerceToAsyncValidator(newValidator);
	        };
	        /**
	         *  Empties out the sync validator list.
	         * @return {?}
	         */
	        AbstractControl.prototype.clearValidators = function () { this.validator = null; };
	        /**
	         *  Empties out the async validator list.
	         * @return {?}
	         */
	        AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
	        /**
	         *  Marks the control as `touched`.
	          * *
	          * This will also mark all direct ancestors as `touched` to maintain
	          * the model.
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype.markAsTouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._touched = true;
	            if (this._parent && !onlySelf) {
	                this._parent.markAsTouched({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         *  Marks the control as `untouched`.
	          * *
	          * If the control has any children, it will also mark all children as `untouched`
	          * to maintain the model, and re-calculate the `touched` status of all parent
	          * controls.
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype.markAsUntouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._touched = false;
	            this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
	            if (this._parent && !onlySelf) {
	                this._parent._updateTouched({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         *  Marks the control as `dirty`.
	          * *
	          * This will also mark all direct ancestors as `dirty` to maintain
	          * the model.
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype.markAsDirty = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._pristine = false;
	            if (this._parent && !onlySelf) {
	                this._parent.markAsDirty({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         *  Marks the control as `pristine`.
	          * *
	          * If the control has any children, it will also mark all children as `pristine`
	          * to maintain the model, and re-calculate the `pristine` status of all parent
	          * controls.
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype.markAsPristine = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._pristine = true;
	            this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
	            if (this._parent && !onlySelf) {
	                this._parent._updatePristine({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         *  Marks the control as `pending`.
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype.markAsPending = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._status = PENDING;
	            if (this._parent && !onlySelf) {
	                this._parent.markAsPending({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         *  Disables the control. This means the control will be exempt from validation checks and
	          * excluded from the aggregate value of any parent. Its status is `DISABLED`.
	          * *
	          * If the control has children, all children will be disabled to maintain the model.
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype.disable = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._status = DISABLED;
	            this._errors = null;
	            this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
	            this._updateValue();
	            if (emitEvent !== false) {
	                this._valueChanges.emit(this._value);
	                this._statusChanges.emit(this._status);
	            }
	            this._updateAncestors(onlySelf);
	            this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
	        };
	        /**
	         *  Enables the control. This means the control will be included in validation checks and
	          * the aggregate value of its parent. Its status is re-calculated based on its value and
	          * its validators.
	          * *
	          * If the control has children, all children will be enabled.
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype.enable = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._status = VALID;
	            this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
	            this._updateAncestors(onlySelf);
	            this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
	        };
	        /**
	         * @param {?} onlySelf
	         * @return {?}
	         */
	        AbstractControl.prototype._updateAncestors = function (onlySelf) {
	            if (this._parent && !onlySelf) {
	                this._parent.updateValueAndValidity();
	                this._parent._updatePristine();
	                this._parent._updateTouched();
	            }
	        };
	        /**
	         * @param {?} parent
	         * @return {?}
	         */
	        AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
	        /**
	         *  Sets the value of the control. Abstract method (implemented in sub-classes).
	         * @abstract
	         * @param {?} value
	         * @param {?=} options
	         * @return {?}
	         */
	        AbstractControl.prototype.setValue = function (value, options) { };
	        /**
	         *  Patches the value of the control. Abstract method (implemented in sub-classes).
	         * @abstract
	         * @param {?} value
	         * @param {?=} options
	         * @return {?}
	         */
	        AbstractControl.prototype.patchValue = function (value, options) { };
	        /**
	         *  Resets the control. Abstract method (implemented in sub-classes).
	         * @abstract
	         * @param {?=} value
	         * @param {?=} options
	         * @return {?}
	         */
	        AbstractControl.prototype.reset = function (value, options) { };
	        /**
	         *  Re-calculates the value and validation status of the control.
	          * *
	          * By default, it will also update the value and validity of its ancestors.
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype.updateValueAndValidity = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._setInitialStatus();
	            this._updateValue();
	            if (this.enabled) {
	                this._errors = this._runValidator();
	                this._status = this._calculateStatus();
	                if (this._status === VALID || this._status === PENDING) {
	                    this._runAsyncValidator(emitEvent);
	                }
	            }
	            if (emitEvent !== false) {
	                this._valueChanges.emit(this._value);
	                this._statusChanges.emit(this._status);
	            }
	            if (this._parent && !onlySelf) {
	                this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	            }
	        };
	        /**
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype._updateTreeValidity = function (_a) {
	            var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
	            this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
	        };
	        /**
	         * @return {?}
	         */
	        AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
	        /**
	         * @return {?}
	         */
	        AbstractControl.prototype._runValidator = function () {
	            return this.validator ? this.validator(this) : null;
	        };
	        /**
	         * @param {?} emitEvent
	         * @return {?}
	         */
	        AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
	            var _this = this;
	            if (this.asyncValidator) {
	                this._status = PENDING;
	                this._cancelExistingSubscription();
	                var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
	                this._asyncValidationSubscription =
	                    obs.subscribe({ next: function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); } });
	            }
	        };
	        /**
	         * @return {?}
	         */
	        AbstractControl.prototype._cancelExistingSubscription = function () {
	            if (this._asyncValidationSubscription) {
	                this._asyncValidationSubscription.unsubscribe();
	            }
	        };
	        /**
	         *  Sets errors on a form control.
	          * *
	          * This is used when validations are run manually by the user, rather than automatically.
	          * *
	          * Calling `setErrors` will also update the validity of the parent control.
	          * *
	          * ### Example
	          * *
	          * ```
	          * const login = new FormControl("someLogin");
	          * login.setErrors({
	          * "notUnique": true
	          * });
	          * *
	          * expect(login.valid).toEqual(false);
	          * expect(login.errors).toEqual({"notUnique": true});
	          * *
	          * login.setValue("someOtherLogin");
	          * *
	          * expect(login.valid).toEqual(true);
	          * ```
	         * @param {?} errors
	         * @param {?=} __1
	         * @return {?}
	         */
	        AbstractControl.prototype.setErrors = function (errors, _a) {
	            var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
	            this._errors = errors;
	            this._updateControlsErrors(emitEvent !== false);
	        };
	        /**
	         *  Retrieves a child control given the control's name or path.
	          * *
	          * Paths can be passed in as an array or a string delimited by a dot.
	          * *
	          * To get a control nested within a `person` sub-group:
	          * *
	          * * `this.form.get('person.name');`
	          * *
	          * -OR-
	          * *
	          * * `this.form.get(['person', 'name']);`
	         * @param {?} path
	         * @return {?}
	         */
	        AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
	        /**
	         *  Returns true if the control with the given path has the error specified. Otherwise
	          * returns null or undefined.
	          * *
	          * If no path is given, it checks for the error on the present control.
	         * @param {?} errorCode
	         * @param {?=} path
	         * @return {?}
	         */
	        AbstractControl.prototype.getError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            var /** @type {?} */ control = path ? this.get(path) : this;
	            return control && control._errors ? control._errors[errorCode] : null;
	        };
	        /**
	         *  Returns true if the control with the given path has the error specified. Otherwise
	          * returns false.
	          * *
	          * If no path is given, it checks for the error on the present control.
	         * @param {?} errorCode
	         * @param {?=} path
	         * @return {?}
	         */
	        AbstractControl.prototype.hasError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            return !!this.getError(errorCode, path);
	        };
	        Object.defineProperty(AbstractControl.prototype, "root", {
	            /**
	             *  Retrieves the top-level ancestor of this control.
	             * @return {?}
	             */
	            get: function () {
	                var /** @type {?} */ x = this;
	                while (x._parent) {
	                    x = x._parent;
	                }
	                return x;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} emitEvent
	         * @return {?}
	         */
	        AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
	            this._status = this._calculateStatus();
	            if (emitEvent) {
	                this._statusChanges.emit(this._status);
	            }
	            if (this._parent) {
	                this._parent._updateControlsErrors(emitEvent);
	            }
	        };
	        /**
	         * @return {?}
	         */
	        AbstractControl.prototype._initObservables = function () {
	            this._valueChanges = new EventEmitter();
	            this._statusChanges = new EventEmitter();
	        };
	        /**
	         * @return {?}
	         */
	        AbstractControl.prototype._calculateStatus = function () {
	            if (this._allControlsDisabled())
	                return DISABLED;
	            if (this._errors)
	                return INVALID;
	            if (this._anyControlsHaveStatus(PENDING))
	                return PENDING;
	            if (this._anyControlsHaveStatus(INVALID))
	                return INVALID;
	            return VALID;
	        };
	        /**
	         * @abstract
	         * @return {?}
	         */
	        AbstractControl.prototype._updateValue = function () { };
	        /**
	         * @abstract
	         * @param {?} cb
	         * @return {?}
	         */
	        AbstractControl.prototype._forEachChild = function (cb) { };
	        /**
	         * @abstract
	         * @param {?} condition
	         * @return {?}
	         */
	        AbstractControl.prototype._anyControls = function (condition) { };
	        /**
	         * @abstract
	         * @return {?}
	         */
	        AbstractControl.prototype._allControlsDisabled = function () { };
	        /**
	         * @param {?} status
	         * @return {?}
	         */
	        AbstractControl.prototype._anyControlsHaveStatus = function (status) {
	            return this._anyControls(function (control) { return control.status === status; });
	        };
	        /**
	         * @return {?}
	         */
	        AbstractControl.prototype._anyControlsDirty = function () {
	            return this._anyControls(function (control) { return control.dirty; });
	        };
	        /**
	         * @return {?}
	         */
	        AbstractControl.prototype._anyControlsTouched = function () {
	            return this._anyControls(function (control) { return control.touched; });
	        };
	        /**
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype._updatePristine = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._pristine = !this._anyControlsDirty();
	            if (this._parent && !onlySelf) {
	                this._parent._updatePristine({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * @param {?=} __0
	         * @return {?}
	         */
	        AbstractControl.prototype._updateTouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._touched = this._anyControlsTouched();
	            if (this._parent && !onlySelf) {
	                this._parent._updateTouched({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * @param {?} formState
	         * @return {?}
	         */
	        AbstractControl.prototype._isBoxedValue = function (formState) {
	            return typeof formState === 'object' && formState !== null &&
	                Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
	        return AbstractControl;
	    }());
	    /**
	     *  *
	      * It is one of the three fundamental building blocks of Angular forms, along with
	      * {@link FormGroup} and {@link FormArray}.
	      * *
	      * *
	      * When instantiating a {@link FormControl}, you can pass in an initial value as the
	      * first argument. Example:
	      * *
	      * ```ts
	      * const ctrl = new FormControl('some value');
	      * console.log(ctrl.value);     // 'some value'
	      * *```
	      * *
	      * You can also initialize the control with a form state object on instantiation,
	      * which includes both the value and whether or not the control is disabled.
	      * You can't use the value key without the disabled key; both are required
	      * to use this way of initialization.
	      * *
	      * ```ts
	      * const ctrl = new FormControl({value: 'n/a', disabled: true});
	      * console.log(ctrl.value);     // 'n/a'
	      * console.log(ctrl.status);   // 'DISABLED'
	      * ```
	      * *
	      * To include a sync validator (or an array of sync validators) with the control,
	      * pass it in as the second argument. Async validators are also supported, but
	      * have to be passed in separately as the third arg.
	      * *
	      * ```ts
	      * const ctrl = new FormControl('', Validators.required);
	      * console.log(ctrl.value);     // ''
	      * console.log(ctrl.status);   // 'INVALID'
	      * ```
	      * *
	      * See its superclass, {@link AbstractControl}, for more properties and methods.
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	     */
	    var FormControl = (function (_super) {
	        __extends$6(FormControl, _super);
	        /**
	         * @param {?=} formState
	         * @param {?=} validator
	         * @param {?=} asyncValidator
	         */
	        function FormControl(formState, validator, asyncValidator) {
	            if (formState === void 0) { formState = null; }
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
	            /** @internal */
	            this._onChange = [];
	            this._applyFormState(formState);
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	            this._initObservables();
	        }
	        /**
	         *  Set the value of the form control to `value`.
	          * *
	          * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	          * and not its parent component. This defaults to false.
	          * *
	          * If `emitEvent` is `true`, this
	          * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
	          * to true (as it falls through to `updateValueAndValidity`).
	          * *
	          * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	          * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	          * specified.
	          * *
	          * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
	          * model.  This is the default behavior if `emitViewToModelChange` is not specified.
	         * @param {?} value
	         * @param {?=} __1
	         * @return {?}
	         */
	        FormControl.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
	            this._value = value;
	            if (this._onChange.length && emitModelToViewChange !== false) {
	                this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange !== false); });
	            }
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         *  Patches the value of a control.
	          * *
	          * This function is functionally the same as {@link FormControl.setValue} at this level.
	          * It exists for symmetry with {@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
	          * where it does behave differently.
	         * @param {?} value
	         * @param {?=} options
	         * @return {?}
	         */
	        FormControl.prototype.patchValue = function (value, options) {
	            if (options === void 0) { options = {}; }
	            this.setValue(value, options);
	        };
	        /**
	         *  Resets the form control. This means by default:
	          * *
	          * * it is marked as `pristine`
	          * * it is marked as `untouched`
	          * * value is set to null
	          * *
	          * You can also reset to a specific form state by passing through a standalone
	          * value or a form state object that contains both a value and a disabled state
	          * (these are the only two properties that cannot be calculated).
	          * *
	          * Ex:
	          * *
	          * ```ts
	          * this.control.reset('Nancy');
	          * *
	          * console.log(this.control.value);  // 'Nancy'
	          * ```
	          * *
	          * OR
	          * *
	          * ```
	          * this.control.reset({value: 'Nancy', disabled: true});
	          * *
	          * console.log(this.control.value);  // 'Nancy'
	          * console.log(this.control.status);  // 'DISABLED'
	          * ```
	         * @param {?=} formState
	         * @param {?=} __1
	         * @return {?}
	         */
	        FormControl.prototype.reset = function (formState, _a) {
	            if (formState === void 0) { formState = null; }
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._applyFormState(formState);
	            this.markAsPristine({ onlySelf: onlySelf });
	            this.markAsUntouched({ onlySelf: onlySelf });
	            this.setValue(this._value, { onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         * @return {?}
	         */
	        FormControl.prototype._updateValue = function () { };
	        /**
	         * @param {?} condition
	         * @return {?}
	         */
	        FormControl.prototype._anyControls = function (condition) { return false; };
	        /**
	         * @return {?}
	         */
	        FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
	        /**
	         *  Register a listener for change events.
	         * @param {?} fn
	         * @return {?}
	         */
	        FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
	        /**
	         * @return {?}
	         */
	        FormControl.prototype._clearChangeFns = function () {
	            this._onChange = [];
	            this._onDisabledChange = [];
	            this._onCollectionChange = function () { };
	        };
	        /**
	         *  Register a listener for disabled events.
	         * @param {?} fn
	         * @return {?}
	         */
	        FormControl.prototype.registerOnDisabledChange = function (fn) {
	            this._onDisabledChange.push(fn);
	        };
	        /**
	         * @param {?} cb
	         * @return {?}
	         */
	        FormControl.prototype._forEachChild = function (cb) { };
	        /**
	         * @param {?} formState
	         * @return {?}
	         */
	        FormControl.prototype._applyFormState = function (formState) {
	            if (this._isBoxedValue(formState)) {
	                this._value = formState.value;
	                formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
	                    this.enable({ onlySelf: true, emitEvent: false });
	            }
	            else {
	                this._value = formState;
	            }
	        };
	        return FormControl;
	    }(AbstractControl));
	    /**
	     *  instances.
	      * *
	      * A `FormGroup` aggregates the values of each child {@link FormControl} into one object,
	      * with each control name as the key.  It calculates its status by reducing the statuses
	      * of its children. For example, if one of the controls in a group is invalid, the entire
	      * group becomes invalid.
	      * *
	      * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
	      * along with {@link FormControl} and {@link FormArray}.
	      * *
	      * *
	      * When instantiating a {@link FormGroup}, pass in a collection of child controls as the first
	      * argument. The key for each child will be the name under which it is registered.
	      * *
	      * ### Example
	      * *
	      * ```
	      * const form = new FormGroup({
	      * first: new FormControl('Nancy', Validators.minLength(2)),
	      * last: new FormControl('Drew'),
	      * });
	      * *
	      * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
	      * console.log(form.status);  // 'VALID'
	      * ```
	      * *
	      * You can also include group-level validators as the second arg, or group-level async
	      * validators as the third arg. These come in handy when you want to perform validation
	      * that considers the value of more than one child control.
	      * *
	      * ### Example
	      * *
	      * ```
	      * const form = new FormGroup({
	      * password: new FormControl('', Validators.minLength(2)),
	      * passwordConfirm: new FormControl('', Validators.minLength(2)),
	      * }, passwordMatchValidator);
	      * *
	      * *
	      * function passwordMatchValidator(g: FormGroup) {
	      * return g.get('password').value === g.get('passwordConfirm').value
	      * ? null : {'mismatch': true};
	      * }
	      * ```
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	     */
	    var FormGroup = (function (_super) {
	        __extends$6(FormGroup, _super);
	        /**
	         * @param {?} controls
	         * @param {?=} validator
	         * @param {?=} asyncValidator
	         */
	        function FormGroup(controls, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, validator, asyncValidator);
	            this.controls = controls;
	            this._initObservables();
	            this._setUpControls();
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        /**
	         *  Registers a control with the group's list of controls.
	          * *
	          * This method does not update value or validity of the control, so for
	          * most cases you'll want to use {@link FormGroup.addControl} instead.
	         * @param {?} name
	         * @param {?} control
	         * @return {?}
	         */
	        FormGroup.prototype.registerControl = function (name, control) {
	            if (this.controls[name])
	                return this.controls[name];
	            this.controls[name] = control;
	            control.setParent(this);
	            control._registerOnCollectionChange(this._onCollectionChange);
	            return control;
	        };
	        /**
	         *  Add a control to this group.
	         * @param {?} name
	         * @param {?} control
	         * @return {?}
	         */
	        FormGroup.prototype.addControl = function (name, control) {
	            this.registerControl(name, control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         *  Remove a control from this group.
	         * @param {?} name
	         * @return {?}
	         */
	        FormGroup.prototype.removeControl = function (name) {
	            if (this.controls[name])
	                this.controls[name]._registerOnCollectionChange(function () { });
	            delete (this.controls[name]);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         *  Replace an existing control.
	         * @param {?} name
	         * @param {?} control
	         * @return {?}
	         */
	        FormGroup.prototype.setControl = function (name, control) {
	            if (this.controls[name])
	                this.controls[name]._registerOnCollectionChange(function () { });
	            delete (this.controls[name]);
	            if (control)
	                this.registerControl(name, control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         *  Check whether there is an enabled control with the given name in the group.
	          * *
	          * It will return false for disabled controls. If you'd like to check for
	          * existence in the group only, use {@link AbstractControl.get} instead.
	         * @param {?} controlName
	         * @return {?}
	         */
	        FormGroup.prototype.contains = function (controlName) {
	            return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
	        };
	        /**
	         *  Sets the value of the {@link FormGroup}. It accepts an object that matches
	          * the structure of the group, with control names as keys.
	          * *
	          * This method performs strict checks, so it will throw an error if you try
	          * to set the value of a control that doesn't exist or if you exclude the
	          * value of a control.
	          * *
	          * ### Example
	          * *
	          * ```
	          * const form = new FormGroup({
	          * first: new FormControl(),
	          * last: new FormControl()
	          * });
	          * console.log(form.value);   // {first: null, last: null}
	          * *
	          * form.setValue({first: 'Nancy', last: 'Drew'});
	          * console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
	          * *
	          * ```
	         * @param {?} value
	         * @param {?=} __1
	         * @return {?}
	         */
	        FormGroup.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._checkAllValuesPresent(value);
	            Object.keys(value).forEach(function (name) {
	                _this._throwIfControlMissing(name);
	                _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: emitEvent });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         *  Patches the value of the {@link FormGroup}. It accepts an object with control
	          * names as keys, and will do its best to match the values to the correct controls
	          * in the group.
	          * *
	          * It accepts both super-sets and sub-sets of the group without throwing an error.
	          * *
	          * ### Example
	          * *
	          * ```
	          * const form = new FormGroup({
	          * first: new FormControl(),
	          * last: new FormControl()
	          * });
	          * console.log(form.value);   // {first: null, last: null}
	          * *
	          * form.patchValue({first: 'Nancy'});
	          * console.log(form.value);   // {first: 'Nancy', last: null}
	          * *
	          * ```
	         * @param {?} value
	         * @param {?=} __1
	         * @return {?}
	         */
	        FormGroup.prototype.patchValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            Object.keys(value).forEach(function (name) {
	                if (_this.controls[name]) {
	                    _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: emitEvent });
	                }
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         *  Resets the {@link FormGroup}. This means by default:
	          * *
	          * * The group and all descendants are marked `pristine`
	          * * The group and all descendants are marked `untouched`
	          * * The value of all descendants will be null or null maps
	          * *
	          * You can also reset to a specific form state by passing in a map of states
	          * that matches the structure of your form, with control names as keys. The state
	          * can be a standalone value or a form state object with both a value and a disabled
	          * status.
	          * *
	          * ### Example
	          * *
	          * ```ts
	          * this.form.reset({first: 'name', last: 'last name'});
	          * *
	          * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	          * ```
	          * *
	          * - OR -
	          * *
	          * ```
	          * this.form.reset({
	          * first: {value: 'name', disabled: true},
	          * last: 'last'
	          * });
	          * *
	          * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	          * console.log(this.form.get('first').status);  // 'DISABLED'
	          * ```
	         * @param {?=} value
	         * @param {?=} __1
	         * @return {?}
	         */
	        FormGroup.prototype.reset = function (value, _a) {
	            if (value === void 0) { value = {}; }
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._forEachChild(function (control, name) {
	                control.reset(value[name], { onlySelf: true, emitEvent: emitEvent });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	            this._updatePristine({ onlySelf: onlySelf });
	            this._updateTouched({ onlySelf: onlySelf });
	        };
	        /**
	         *  The aggregate value of the {@link FormGroup}, including any disabled controls.
	          * *
	          * If you'd like to include all values regardless of disabled status, use this method.
	          * Otherwise, the `value` property is the best way to get the value of the group.
	         * @return {?}
	         */
	        FormGroup.prototype.getRawValue = function () {
	            return this._reduceChildren({}, function (acc, control, name) {
	                acc[name] = control.value;
	                return acc;
	            });
	        };
	        /**
	         * @param {?} name
	         * @return {?}
	         */
	        FormGroup.prototype._throwIfControlMissing = function (name) {
	            if (!Object.keys(this.controls).length) {
	                throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
	            }
	            if (!this.controls[name]) {
	                throw new Error("Cannot find form control with name: " + name + ".");
	            }
	        };
	        /**
	         * @param {?} cb
	         * @return {?}
	         */
	        FormGroup.prototype._forEachChild = function (cb) {
	            var _this = this;
	            Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
	        };
	        /**
	         * @return {?}
	         */
	        FormGroup.prototype._setUpControls = function () {
	            var _this = this;
	            this._forEachChild(function (control) {
	                control.setParent(_this);
	                control._registerOnCollectionChange(_this._onCollectionChange);
	            });
	        };
	        /**
	         * @return {?}
	         */
	        FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
	        /**
	         * @param {?} condition
	         * @return {?}
	         */
	        FormGroup.prototype._anyControls = function (condition) {
	            var _this = this;
	            var /** @type {?} */ res = false;
	            this._forEachChild(function (control, name) {
	                res = res || (_this.contains(name) && condition(control));
	            });
	            return res;
	        };
	        /**
	         * @return {?}
	         */
	        FormGroup.prototype._reduceValue = function () {
	            var _this = this;
	            return this._reduceChildren({}, function (acc, control, name) {
	                if (control.enabled || _this.disabled) {
	                    acc[name] = control.value;
	                }
	                return acc;
	            });
	        };
	        /**
	         * @param {?} initValue
	         * @param {?} fn
	         * @return {?}
	         */
	        FormGroup.prototype._reduceChildren = function (initValue, fn) {
	            var /** @type {?} */ res = initValue;
	            this._forEachChild(function (control, name) { res = fn(res, control, name); });
	            return res;
	        };
	        /**
	         * @return {?}
	         */
	        FormGroup.prototype._allControlsDisabled = function () {
	            for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
	                var controlName = _a[_i];
	                if (this.controls[controlName].enabled) {
	                    return false;
	                }
	            }
	            return Object.keys(this.controls).length > 0 || this.disabled;
	        };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        FormGroup.prototype._checkAllValuesPresent = function (value) {
	            this._forEachChild(function (control, name) {
	                if (value[name] === undefined) {
	                    throw new Error("Must supply a value for form control with name: '" + name + "'.");
	                }
	            });
	        };
	        return FormGroup;
	    }(AbstractControl));
	    /**
	     *  instances.
	      * *
	      * A `FormArray` aggregates the values of each child {@link FormControl} into an array.
	      * It calculates its status by reducing the statuses of its children. For example, if one of
	      * the controls in a `FormArray` is invalid, the entire array becomes invalid.
	      * *
	      * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
	      * along with {@link FormControl} and {@link FormGroup}.
	      * *
	      * *
	      * When instantiating a {@link FormArray}, pass in an array of child controls as the first
	      * argument.
	      * *
	      * ### Example
	      * *
	      * ```
	      * const arr = new FormArray([
	      * new FormControl('Nancy', Validators.minLength(2)),
	      * new FormControl('Drew'),
	      * ]);
	      * *
	      * console.log(arr.value);   // ['Nancy', 'Drew']
	      * console.log(arr.status);  // 'VALID'
	      * ```
	      * *
	      * You can also include array-level validators as the second arg, or array-level async
	      * validators as the third arg. These come in handy when you want to perform validation
	      * that considers the value of more than one child control.
	      * *
	      * ### Adding or removing controls
	      * *
	      * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
	      * in `FormArray` itself. These methods ensure the controls are properly tracked in the
	      * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
	      * the `FormArray` directly, as that will result in strange and unexpected behavior such
	      * as broken change detection.
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	     */
	    var FormArray = (function (_super) {
	        __extends$6(FormArray, _super);
	        /**
	         * @param {?} controls
	         * @param {?=} validator
	         * @param {?=} asyncValidator
	         */
	        function FormArray(controls, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, validator, asyncValidator);
	            this.controls = controls;
	            this._initObservables();
	            this._setUpControls();
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        /**
	         *  Get the {@link AbstractControl} at the given `index` in the array.
	         * @param {?} index
	         * @return {?}
	         */
	        FormArray.prototype.at = function (index) { return this.controls[index]; };
	        /**
	         *  Insert a new {@link AbstractControl} at the end of the array.
	         * @param {?} control
	         * @return {?}
	         */
	        FormArray.prototype.push = function (control) {
	            this.controls.push(control);
	            this._registerControl(control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         *  Insert a new {@link AbstractControl} at the given `index` in the array.
	         * @param {?} index
	         * @param {?} control
	         * @return {?}
	         */
	        FormArray.prototype.insert = function (index, control) {
	            this.controls.splice(index, 0, control);
	            this._registerControl(control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         *  Remove the control at the given `index` in the array.
	         * @param {?} index
	         * @return {?}
	         */
	        FormArray.prototype.removeAt = function (index) {
	            if (this.controls[index])
	                this.controls[index]._registerOnCollectionChange(function () { });
	            this.controls.splice(index, 1);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         *  Replace an existing control.
	         * @param {?} index
	         * @param {?} control
	         * @return {?}
	         */
	        FormArray.prototype.setControl = function (index, control) {
	            if (this.controls[index])
	                this.controls[index]._registerOnCollectionChange(function () { });
	            this.controls.splice(index, 1);
	            if (control) {
	                this.controls.splice(index, 0, control);
	                this._registerControl(control);
	            }
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        Object.defineProperty(FormArray.prototype, "length", {
	            /**
	             *  Length of the control array.
	             * @return {?}
	             */
	            get: function () { return this.controls.length; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         *  Sets the value of the {@link FormArray}. It accepts an array that matches
	          * the structure of the control.
	          * *
	          * This method performs strict checks, so it will throw an error if you try
	          * to set the value of a control that doesn't exist or if you exclude the
	          * value of a control.
	          * *
	          * ### Example
	          * *
	          * ```
	          * const arr = new FormArray([
	          * new FormControl(),
	          * new FormControl()
	          * ]);
	          * console.log(arr.value);   // [null, null]
	          * *
	          * arr.setValue(['Nancy', 'Drew']);
	          * console.log(arr.value);   // ['Nancy', 'Drew']
	          * ```
	         * @param {?} value
	         * @param {?=} __1
	         * @return {?}
	         */
	        FormArray.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._checkAllValuesPresent(value);
	            value.forEach(function (newValue, index) {
	                _this._throwIfControlMissing(index);
	                _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: emitEvent });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         *  Patches the value of the {@link FormArray}. It accepts an array that matches the
	          * structure of the control, and will do its best to match the values to the correct
	          * controls in the group.
	          * *
	          * It accepts both super-sets and sub-sets of the array without throwing an error.
	          * *
	          * ### Example
	          * *
	          * ```
	          * const arr = new FormArray([
	          * new FormControl(),
	          * new FormControl()
	          * ]);
	          * console.log(arr.value);   // [null, null]
	          * *
	          * arr.patchValue(['Nancy']);
	          * console.log(arr.value);   // ['Nancy', null]
	          * ```
	         * @param {?} value
	         * @param {?=} __1
	         * @return {?}
	         */
	        FormArray.prototype.patchValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            value.forEach(function (newValue, index) {
	                if (_this.at(index)) {
	                    _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: emitEvent });
	                }
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         *  Resets the {@link FormArray}. This means by default:
	          * *
	          * * The array and all descendants are marked `pristine`
	          * * The array and all descendants are marked `untouched`
	          * * The value of all descendants will be null or null maps
	          * *
	          * You can also reset to a specific form state by passing in an array of states
	          * that matches the structure of the control. The state can be a standalone value
	          * or a form state object with both a value and a disabled status.
	          * *
	          * ### Example
	          * *
	          * ```ts
	          * this.arr.reset(['name', 'last name']);
	          * *
	          * console.log(this.arr.value);  // ['name', 'last name']
	          * ```
	          * *
	          * - OR -
	          * *
	          * ```
	          * this.arr.reset([
	          * {value: 'name', disabled: true},
	          * 'last'
	          * ]);
	          * *
	          * console.log(this.arr.value);  // ['name', 'last name']
	          * console.log(this.arr.get(0).status);  // 'DISABLED'
	          * ```
	         * @param {?=} value
	         * @param {?=} __1
	         * @return {?}
	         */
	        FormArray.prototype.reset = function (value, _a) {
	            if (value === void 0) { value = []; }
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._forEachChild(function (control, index) {
	                control.reset(value[index], { onlySelf: true, emitEvent: emitEvent });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	            this._updatePristine({ onlySelf: onlySelf });
	            this._updateTouched({ onlySelf: onlySelf });
	        };
	        /**
	         *  The aggregate value of the array, including any disabled controls.
	          * *
	          * If you'd like to include all values regardless of disabled status, use this method.
	          * Otherwise, the `value` property is the best way to get the value of the array.
	         * @return {?}
	         */
	        FormArray.prototype.getRawValue = function () { return this.controls.map(function (control) { return control.value; }); };
	        /**
	         * @param {?} index
	         * @return {?}
	         */
	        FormArray.prototype._throwIfControlMissing = function (index) {
	            if (!this.controls.length) {
	                throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
	            }
	            if (!this.at(index)) {
	                throw new Error("Cannot find form control at index " + index);
	            }
	        };
	        /**
	         * @param {?} cb
	         * @return {?}
	         */
	        FormArray.prototype._forEachChild = function (cb) {
	            this.controls.forEach(function (control, index) { cb(control, index); });
	        };
	        /**
	         * @return {?}
	         */
	        FormArray.prototype._updateValue = function () {
	            var _this = this;
	            this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
	                .map(function (control) { return control.value; });
	        };
	        /**
	         * @param {?} condition
	         * @return {?}
	         */
	        FormArray.prototype._anyControls = function (condition) {
	            return this.controls.some(function (control) { return control.enabled && condition(control); });
	        };
	        /**
	         * @return {?}
	         */
	        FormArray.prototype._setUpControls = function () {
	            var _this = this;
	            this._forEachChild(function (control) { return _this._registerControl(control); });
	        };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        FormArray.prototype._checkAllValuesPresent = function (value) {
	            this._forEachChild(function (control, i) {
	                if (value[i] === undefined) {
	                    throw new Error("Must supply a value for form control at index: " + i + ".");
	                }
	            });
	        };
	        /**
	         * @return {?}
	         */
	        FormArray.prototype._allControlsDisabled = function () {
	            for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
	                var control = _a[_i];
	                if (control.enabled)
	                    return false;
	            }
	            return this.controls.length > 0 || this.disabled;
	        };
	        /**
	         * @param {?} control
	         * @return {?}
	         */
	        FormArray.prototype._registerControl = function (control) {
	            control.setParent(this);
	            control._registerOnCollectionChange(this._onCollectionChange);
	        };
	        return FormArray;
	    }(AbstractControl));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$4 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var /** @type {?} */ formDirectiveProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return NgForm; })
	    };
	    var /** @type {?} */ resolvedPromise = Promise.resolve(null);
	    /**
	     *  to track aggregate form value and validation status.
	      * *
	      * *
	      * As soon as you import the `FormsModule`, this directive becomes active by default on
	      * all `<form>` tags.  You don't need to add a special selector.
	      * *
	      * You can export the directive into a local template variable using `ngForm` as the key
	      * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
	      * {@link FormGroup} instance are duplicated on the directive itself, so a reference to it
	      * will give you access to the aggregate value and validity status of the form, as well as
	      * user interaction properties like `dirty` and `touched`.
	      * *
	      * To register child controls with the form, you'll want to use {@link NgModel} with a
	      * `name` attribute.  You can also use {@link NgModelGroup} if you'd like to create
	      * sub-groups within the form.
	      * *
	      * You can listen to the directive's `ngSubmit` event to be notified when the user has
	      * triggered a form submission. The `ngSubmit` event will be emitted with the original form
	      * submission event.
	      * *
	      * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	      * * **NgModule**: `FormsModule`
	      * *
	      * @stable
	     */
	    var NgForm = (function (_super) {
	        __extends$4(NgForm, _super);
	        /**
	         * @param {?} validators
	         * @param {?} asyncValidators
	         */
	        function NgForm(validators, asyncValidators) {
	            _super.call(this);
	            this._submitted = false;
	            this.ngSubmit = new EventEmitter();
	            this.form =
	                new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
	        }
	        Object.defineProperty(NgForm.prototype, "submitted", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._submitted; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "formDirective", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "control", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "path", {
	            /**
	             * @return {?}
	             */
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "controls", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.form.controls; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        NgForm.prototype.addControl = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var /** @type {?} */ container = _this._findContainer(dir.path);
	                dir._control = (container.registerControl(dir.name, dir.control));
	                setUpControl(dir.control, dir);
	                dir.control.updateValueAndValidity({ emitEvent: false });
	            });
	        };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        NgForm.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        NgForm.prototype.removeControl = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var /** @type {?} */ container = _this._findContainer(dir.path);
	                if (container) {
	                    container.removeControl(dir.name);
	                }
	            });
	        };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        NgForm.prototype.addFormGroup = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var /** @type {?} */ container = _this._findContainer(dir.path);
	                var /** @type {?} */ group = new FormGroup({});
	                setUpFormContainer(group, dir);
	                container.registerControl(dir.name, group);
	                group.updateValueAndValidity({ emitEvent: false });
	            });
	        };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        NgForm.prototype.removeFormGroup = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var /** @type {?} */ container = _this._findContainer(dir.path);
	                if (container) {
	                    container.removeControl(dir.name);
	                }
	            });
	        };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        NgForm.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
	        /**
	         * @param {?} dir
	         * @param {?} value
	         * @return {?}
	         */
	        NgForm.prototype.updateModel = function (dir, value) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var /** @type {?} */ ctrl = (_this.form.get(dir.path));
	                ctrl.setValue(value);
	            });
	        };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
	        /**
	         * @param {?} $event
	         * @return {?}
	         */
	        NgForm.prototype.onSubmit = function ($event) {
	            this._submitted = true;
	            this.ngSubmit.emit($event);
	            return false;
	        };
	        /**
	         * @return {?}
	         */
	        NgForm.prototype.onReset = function () { this.resetForm(); };
	        /**
	         * @param {?=} value
	         * @return {?}
	         */
	        NgForm.prototype.resetForm = function (value) {
	            if (value === void 0) { value = undefined; }
	            this.form.reset(value);
	            this._submitted = false;
	        };
	        /**
	         * @param {?} path
	         * @return {?}
	         */
	        NgForm.prototype._findContainer = function (path) {
	            path.pop();
	            return path.length ? (this.form.get(path)) : this.form;
	        };
	        NgForm.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
	                        providers: [formDirectiveProvider],
	                        host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
	                        outputs: ['ngSubmit'],
	                        exportAs: 'ngForm'
	                    },] },
	        ];
	        /** @nocollapse */
	        NgForm.ctorParameters = function () { return [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ]; };
	        return NgForm;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var /** @type {?} */ Examples = {
	        formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
	        formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
	        formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; let i=index\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
	        ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
	        ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
	    };
	
	    var TemplateDrivenErrors = (function () {
	        function TemplateDrivenErrors() {
	        }
	        /**
	         * @return {?}
	         */
	        TemplateDrivenErrors.modelParentException = function () {
	            throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + Examples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + Examples.ngModelWithFormGroup);
	        };
	        /**
	         * @return {?}
	         */
	        TemplateDrivenErrors.formGroupNameException = function () {
	            throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + Examples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + Examples.ngModelGroup);
	        };
	        /**
	         * @return {?}
	         */
	        TemplateDrivenErrors.missingNameException = function () {
	            throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
	        };
	        /**
	         * @return {?}
	         */
	        TemplateDrivenErrors.modelGroupParentException = function () {
	            throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + Examples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + Examples.ngModelGroup);
	        };
	        return TemplateDrivenErrors;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$8 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var /** @type {?} */ modelGroupProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return NgModelGroup; })
	    };
	    /**
	     *  *
	      * *
	      * This directive can only be used as a child of {@link NgForm} (or in other words,
	      * within `<form>` tags).
	      * *
	      * Use this directive if you'd like to create a sub-group within a form. This can
	      * come in handy if you want to validate a sub-group of your form separately from
	      * the rest of your form, or if some values in your domain model make more sense to
	      * consume together in a nested object.
	      * *
	      * Pass in the name you'd like this sub-group to have and it will become the key
	      * for the sub-group in the form's full value. You can also export the directive into
	      * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
	      * *
	      * {@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	      * * **NgModule**: `FormsModule`
	      * *
	     */
	    var NgModelGroup = (function (_super) {
	        __extends$8(NgModelGroup, _super);
	        /**
	         * @param {?} parent
	         * @param {?} validators
	         * @param {?} asyncValidators
	         */
	        function NgModelGroup(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        /**
	         * @return {?}
	         */
	        NgModelGroup.prototype._checkParentType = function () {
	            if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
	                TemplateDrivenErrors.modelGroupParentException();
	            }
	        };
	        NgModelGroup.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
	        ];
	        /** @nocollapse */
	        NgModelGroup.ctorParameters = function () { return [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ]; };
	        NgModelGroup.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['ngModelGroup',] },],
	        };
	        return NgModelGroup;
	    }(AbstractFormGroupDirective));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$7 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var /** @type {?} */ formControlBinding = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return NgModel; })
	    };
	    /**
	     * `ngModel` forces an additional change detection run when its inputs change:
	     * E.g.:
	     * ```
	     * <div>{{myModel.valid}}</div>
	     * <input [(ngModel)]="myValue" #myModel="ngModel">
	     * ```
	     * I.e. `ngModel` can export itself on the element and then be used in the template.
	     * Normally, this would result in expressions before the `input` that use the exported directive
	     * to have and old value as they have been
	     * dirty checked before. As this is a very common case for `ngModel`, we added this second change
	     * detection run.
	     *
	     * Notes:
	     * - this is just one extra run no matter how many `ngModel` have been changed.
	     * - this is a general problem when using `exportAs` for directives!
	     */
	    var /** @type {?} */ resolvedPromise$1 = Promise.resolve(null);
	    /**
	     *  to a form control element.
	      * *
	      * The {@link FormControl} instance will track the value, user interaction, and
	      * validation status of the control and keep the view synced with the model. If used
	      * within a parent form, the directive will also register itself with the form as a child
	      * control.
	      * *
	      * *
	      * This directive can be used by itself or as part of a larger form. All you need is the
	      * `ngModel` selector to activate it.
	      * *
	      * It accepts a domain model as an optional {@link @Input}. If you have a one-way binding
	      * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
	      * class will set the value in the view. If you have a two-way binding with `[()]` syntax
	      * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
	      * the domain model in your class as well.
	      * *
	      * If you wish to inspect the properties of the associated {@link FormControl} (like
	      * validity state), you can also export the directive into a local template variable using
	      * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
	      * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
	      * will fall through to the control anyway, so you can access them directly. You can see a
	      * full list of properties directly available in {@link AbstractControlDirective}.
	      * *
	      * The following is an example of a simple standalone control using `ngModel`:
	      * *
	      * {@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
	      * *
	      * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
	      * so that the control can be registered with the parent form under that name.
	      * *
	      * It's worth noting that in the context of a parent form, you often can skip one-way or
	      * two-way binding because the parent form will sync the value for you. You can access
	      * its properties by exporting it into a local template variable using `ngForm` (ex:
	      * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
	      * *
	      * If you do need to populate initial values into your form, using a one-way binding for
	      * `ngModel` tends to be sufficient as long as you use the exported form's value rather
	      * than the domain model's value on submit.
	      * *
	      * Take a look at an example of using `ngModel` within a form:
	      * *
	      * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
	      * *
	      * To see `ngModel` examples with different form control types, see:
	      * *
	      * * Radio buttons: {@link RadioControlValueAccessor}
	      * * Selects: {@link SelectControlValueAccessor}
	      * *
	      * **npm package**: `@angular/forms`
	      * *
	      * **NgModule**: `FormsModule`
	      * *
	      * @stable
	     */
	    var NgModel = (function (_super) {
	        __extends$7(NgModel, _super);
	        /**
	         * @param {?} parent
	         * @param {?} validators
	         * @param {?} asyncValidators
	         * @param {?} valueAccessors
	         */
	        function NgModel(parent, validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            /** @internal */
	            this._control = new FormControl();
	            /** @internal */
	            this._registered = false;
	            this.update = new EventEmitter();
	            this._parent = parent;
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        NgModel.prototype.ngOnChanges = function (changes) {
	            this._checkForErrors();
	            if (!this._registered)
	                this._setUpControl();
	            if ('isDisabled' in changes) {
	                this._updateDisabled(changes);
	            }
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this._updateValue(this.model);
	                this.viewModel = this.model;
	            }
	        };
	        /**
	         * @return {?}
	         */
	        NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
	        Object.defineProperty(NgModel.prototype, "control", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._control; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "path", {
	            /**
	             * @return {?}
	             */
	            get: function () {
	                return this._parent ? controlPath(this.name, this._parent) : [this.name];
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "formDirective", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "validator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "asyncValidator", {
	            /**
	             * @return {?}
	             */
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        NgModel.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        /**
	         * @return {?}
	         */
	        NgModel.prototype._setUpControl = function () {
	            this._isStandalone() ? this._setUpStandalone() :
	                this.formDirective.addControl(this);
	            this._registered = true;
	        };
	        /**
	         * @return {?}
	         */
	        NgModel.prototype._isStandalone = function () {
	            return !this._parent || (this.options && this.options.standalone);
	        };
	        /**
	         * @return {?}
	         */
	        NgModel.prototype._setUpStandalone = function () {
	            setUpControl(this._control, this);
	            this._control.updateValueAndValidity({ emitEvent: false });
	        };
	        /**
	         * @return {?}
	         */
	        NgModel.prototype._checkForErrors = function () {
	            if (!this._isStandalone()) {
	                this._checkParentType();
	            }
	            this._checkName();
	        };
	        /**
	         * @return {?}
	         */
	        NgModel.prototype._checkParentType = function () {
	            if (!(this._parent instanceof NgModelGroup) &&
	                this._parent instanceof AbstractFormGroupDirective) {
	                TemplateDrivenErrors.formGroupNameException();
	            }
	            else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
	                TemplateDrivenErrors.modelParentException();
	            }
	        };
	        /**
	         * @return {?}
	         */
	        NgModel.prototype._checkName = function () {
	            if (this.options && this.options.name)
	                this.name = this.options.name;
	            if (!this._isStandalone() && !this.name) {
	                TemplateDrivenErrors.missingNameException();
	            }
	        };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        NgModel.prototype._updateValue = function (value) {
	            var _this = this;
	            resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
	        };
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        NgModel.prototype._updateDisabled = function (changes) {
	            var _this = this;
	            var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
	            var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
	            resolvedPromise$1.then(function () {
	                if (isDisabled && !_this.control.disabled) {
	                    _this.control.disable();
	                }
	                else if (!isDisabled && _this.control.disabled) {
	                    _this.control.enable();
	                }
	            });
	        };
	        NgModel.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[ngModel]:not([formControlName]):not([formControl])',
	                        providers: [formControlBinding],
	                        exportAs: 'ngModel'
	                    },] },
	        ];
	        /** @nocollapse */
	        NgModel.ctorParameters = function () { return [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ]; };
	        NgModel.propDecorators = {
	            'name': [{ type: _angular_core.Input },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'options': [{ type: _angular_core.Input, args: ['ngModelOptions',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	        };
	        return NgModel;
	    }(NgControl));
	
	    var ReactiveErrors = (function () {
	        function ReactiveErrors() {
	        }
	        /**
	         * @return {?}
	         */
	        ReactiveErrors.controlParentException = function () {
	            throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + Examples.formControlName);
	        };
	        /**
	         * @return {?}
	         */
	        ReactiveErrors.ngModelGroupException = function () {
	            throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + Examples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + Examples.ngModelGroup);
	        };
	        /**
	         * @return {?}
	         */
	        ReactiveErrors.missingFormException = function () {
	            throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + Examples.formControlName);
	        };
	        /**
	         * @return {?}
	         */
	        ReactiveErrors.groupParentException = function () {
	            throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + Examples.formGroupName);
	        };
	        /**
	         * @return {?}
	         */
	        ReactiveErrors.arrayParentException = function () {
	            throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + Examples.formArrayName);
	        };
	        /**
	         * @return {?}
	         */
	        ReactiveErrors.disabledAttrWarning = function () {
	            console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
	        };
	        return ReactiveErrors;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$9 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var /** @type {?} */ formControlBinding$1 = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return FormControlDirective; })
	    };
	    /**
	     *  *
	      * In other words, this directive ensures that any values written to the {@link FormControl}
	      * instance programmatically will be written to the DOM element (model -> view). Conversely,
	      * any values written to the DOM element through user input will be reflected in the
	      * {@link FormControl} instance (view -> model).
	      * *
	      * *
	      * Use this directive if you'd like to create and manage a {@link FormControl} instance directly.
	      * Simply create a {@link FormControl}, save it to your component class, and pass it into the
	      * {@link FormControlDirective}.
	      * *
	      * This directive is designed to be used as a standalone control.  Unlike {@link FormControlName},
	      * it does not require that your {@link FormControl} instance be part of any parent
	      * {@link FormGroup}, and it won't be registered to any {@link FormGroupDirective} that
	      * exists above it.
	      * *
	      * **Get the value**: the `value` property is always synced and available on the
	      * {@link FormControl} instance. See a full list of available properties in
	      * {@link AbstractControl}.
	      * *
	      * **Set the value**: You can pass in an initial value when instantiating the {@link FormControl},
	      * or you can set it programmatically later using {@link AbstractControl.setValue} or
	      * {@link AbstractControl.patchValue}.
	      * *
	      * **Listen to value**: If you want to listen to changes in the value of the control, you can
	      * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	      * {@link AbstractControl.statusChanges} to be notified when the validation status is
	      * re-calculated.
	      * *
	      * ### Example
	      * *
	      * {@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	      * * **NgModule**: `ReactiveFormsModule`
	      * *
	      * @stable
	     */
	    var FormControlDirective = (function (_super) {
	        __extends$9(FormControlDirective, _super);
	        /**
	         * @param {?} validators
	         * @param {?} asyncValidators
	         * @param {?} valueAccessors
	         */
	        function FormControlDirective(validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            this.update = new EventEmitter();
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
	            /**
	             * @param {?} isDisabled
	             * @return {?}
	             */
	            set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        FormControlDirective.prototype.ngOnChanges = function (changes) {
	            if (this._isControlChanged(changes)) {
	                setUpControl(this.form, this);
	                if (this.control.disabled && this.valueAccessor.setDisabledState) {
	                    this.valueAccessor.setDisabledState(true);
	                }
	                this.form.updateValueAndValidity({ emitEvent: false });
	            }
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this.form.setValue(this.model);
	                this.viewModel = this.model;
	            }
	        };
	        Object.defineProperty(FormControlDirective.prototype, "path", {
	            /**
	             * @return {?}
	             */
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "validator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
	            /**
	             * @return {?}
	             */
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "control", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        FormControlDirective.prototype._isControlChanged = function (changes) {
	            return changes.hasOwnProperty('form');
	        };
	        FormControlDirective.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
	        ];
	        /** @nocollapse */
	        FormControlDirective.ctorParameters = function () { return [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ]; };
	        FormControlDirective.propDecorators = {
	            'form': [{ type: _angular_core.Input, args: ['formControl',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	        };
	        return FormControlDirective;
	    }(NgControl));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$11 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var /** @type {?} */ formDirectiveProvider$1 = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormGroupDirective; })
	    };
	    /**
	     *  *
	      * *
	      * This directive accepts an existing {@link FormGroup} instance. It will then use this
	      * {@link FormGroup} instance to match any child {@link FormControl}, {@link FormGroup},
	      * and {@link FormArray} instances to child {@link FormControlName}, {@link FormGroupName},
	      * and {@link FormArrayName} directives.
	      * *
	      * **Set value**: You can set the form's initial value when instantiating the
	      * {@link FormGroup}, or you can set it programmatically later using the {@link FormGroup}'s
	      * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue} methods.
	      * *
	      * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
	      * to the {@link FormGroup}'s {@link AbstractControl.valueChanges} event.  You can also listen to
	      * its {@link AbstractControl.statusChanges} event to be notified when the validation status is
	      * re-calculated.
	      * *
	      * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
	      * triggered a form submission. The `ngSubmit` event will be emitted with the original form
	      * submission event.
	      * *
	      * ### Example
	      * *
	      * In this example, we create form controls for first name and last name.
	      * *
	      * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
	      * *
	      * **npm package**: `@angular/forms`
	      * *
	      * **NgModule**: {@link ReactiveFormsModule}
	      * *
	      * @stable
	     */
	    var FormGroupDirective = (function (_super) {
	        __extends$11(FormGroupDirective, _super);
	        /**
	         * @param {?} _validators
	         * @param {?} _asyncValidators
	         */
	        function FormGroupDirective(_validators, _asyncValidators) {
	            _super.call(this);
	            this._validators = _validators;
	            this._asyncValidators = _asyncValidators;
	            this._submitted = false;
	            this.directives = [];
	            this.form = null;
	            this.ngSubmit = new EventEmitter();
	        }
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        FormGroupDirective.prototype.ngOnChanges = function (changes) {
	            this._checkFormPresent();
	            if (changes.hasOwnProperty('form')) {
	                this._updateValidators();
	                this._updateDomValue();
	                this._updateRegistrations();
	            }
	        };
	        Object.defineProperty(FormGroupDirective.prototype, "submitted", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._submitted; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "control", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "path", {
	            /**
	             * @return {?}
	             */
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.addControl = function (dir) {
	            var /** @type {?} */ ctrl = this.form.get(dir.path);
	            setUpControl(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	            this.directives.push(dir);
	            return ctrl;
	        };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.removeControl = function (dir) { ListWrapper.remove(this.directives, dir); };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.addFormGroup = function (dir) {
	            var /** @type {?} */ ctrl = this.form.get(dir.path);
	            setUpFormContainer(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	        };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.removeFormGroup = function (dir) { };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.addFormArray = function (dir) {
	            var /** @type {?} */ ctrl = this.form.get(dir.path);
	            setUpFormContainer(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	        };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.removeFormArray = function (dir) { };
	        /**
	         * @param {?} dir
	         * @return {?}
	         */
	        FormGroupDirective.prototype.getFormArray = function (dir) { return (this.form.get(dir.path)); };
	        /**
	         * @param {?} dir
	         * @param {?} value
	         * @return {?}
	         */
	        FormGroupDirective.prototype.updateModel = function (dir, value) {
	            var /** @type {?} */ ctrl = (this.form.get(dir.path));
	            ctrl.setValue(value);
	        };
	        /**
	         * @param {?} $event
	         * @return {?}
	         */
	        FormGroupDirective.prototype.onSubmit = function ($event) {
	            this._submitted = true;
	            this.ngSubmit.emit($event);
	            return false;
	        };
	        /**
	         * @return {?}
	         */
	        FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
	        /**
	         * @param {?=} value
	         * @return {?}
	         */
	        FormGroupDirective.prototype.resetForm = function (value) {
	            if (value === void 0) { value = undefined; }
	            this.form.reset(value);
	            this._submitted = false;
	        };
	        /**
	         * @return {?}
	         */
	        FormGroupDirective.prototype._updateDomValue = function () {
	            var _this = this;
	            this.directives.forEach(function (dir) {
	                var /** @type {?} */ newCtrl = _this.form.get(dir.path);
	                if (dir._control !== newCtrl) {
	                    cleanUpControl(dir._control, dir);
	                    if (newCtrl)
	                        setUpControl(newCtrl, dir);
	                    dir._control = newCtrl;
	                }
	            });
	            this.form._updateTreeValidity({ emitEvent: false });
	        };
	        /**
	         * @return {?}
	         */
	        FormGroupDirective.prototype._updateRegistrations = function () {
	            var _this = this;
	            this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
	            if (this._oldForm)
	                this._oldForm._registerOnCollectionChange(function () { });
	            this._oldForm = this.form;
	        };
	        /**
	         * @return {?}
	         */
	        FormGroupDirective.prototype._updateValidators = function () {
	            var /** @type {?} */ sync = composeValidators(this._validators);
	            this.form.validator = Validators.compose([this.form.validator, sync]);
	            var /** @type {?} */ async = composeAsyncValidators(this._asyncValidators);
	            this.form.asyncValidator = Validators.composeAsync([this.form.asyncValidator, async]);
	        };
	        /**
	         * @return {?}
	         */
	        FormGroupDirective.prototype._checkFormPresent = function () {
	            if (!this.form) {
	                ReactiveErrors.missingFormException();
	            }
	        };
	        FormGroupDirective.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[formGroup]',
	                        providers: [formDirectiveProvider$1],
	                        host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
	                        exportAs: 'ngForm'
	                    },] },
	        ];
	        /** @nocollapse */
	        FormGroupDirective.ctorParameters = function () { return [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ]; };
	        FormGroupDirective.propDecorators = {
	            'form': [{ type: _angular_core.Input, args: ['formGroup',] },],
	            'ngSubmit': [{ type: _angular_core.Output },],
	        };
	        return FormGroupDirective;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$12 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var /** @type {?} */ formGroupNameProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormGroupName; })
	    };
	    /**
	     *  *
	      * *
	      * This directive can only be used with a parent {@link FormGroupDirective} (selector:
	      * `[formGroup]`).
	      * *
	      * It accepts the string name of the nested {@link FormGroup} you want to link, and
	      * will look for a {@link FormGroup} registered with that name in the parent
	      * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
	      * *
	      * Nested form groups can come in handy when you want to validate a sub-group of a
	      * form separately from the rest or when you'd like to group the values of certain
	      * controls into their own nested object.
	      * *
	      * **Access the group**: You can access the associated {@link FormGroup} using the
	      * {@link AbstractControl.get} method. Ex: `this.form.get('name')`.
	      * *
	      * You can also access individual controls within the group using dot syntax.
	      * Ex: `this.form.get('name.first')`
	      * *
	      * **Get the value**: the `value` property is always synced and available on the
	      * {@link FormGroup}. See a full list of available properties in {@link AbstractControl}.
	      * *
	      * **Set the value**: You can set an initial value for each child control when instantiating
	      * the {@link FormGroup}, or you can set it programmatically later using
	      * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
	      * *
	      * **Listen to value**: If you want to listen to changes in the value of the group, you can
	      * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	      * {@link AbstractControl.statusChanges} to be notified when the validation status is
	      * re-calculated.
	      * *
	      * ### Example
	      * *
	      * {@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	      * * **NgModule**: `ReactiveFormsModule`
	      * *
	     */
	    var FormGroupName = (function (_super) {
	        __extends$12(FormGroupName, _super);
	        /**
	         * @param {?} parent
	         * @param {?} validators
	         * @param {?} asyncValidators
	         */
	        function FormGroupName(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        /**
	         * @return {?}
	         */
	        FormGroupName.prototype._checkParentType = function () {
	            if (_hasInvalidParent(this._parent)) {
	                ReactiveErrors.groupParentException();
	            }
	        };
	        FormGroupName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
	        ];
	        /** @nocollapse */
	        FormGroupName.ctorParameters = function () { return [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ]; };
	        FormGroupName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formGroupName',] },],
	        };
	        return FormGroupName;
	    }(AbstractFormGroupDirective));
	    var /** @type {?} */ formArrayNameProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormArrayName; })
	    };
	    /**
	     *  *
	      * *
	      * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
	      * `[formGroup]`).
	      * *
	      * It accepts the string name of the nested {@link FormArray} you want to link, and
	      * will look for a {@link FormArray} registered with that name in the parent
	      * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
	      * *
	      * Nested form arrays can come in handy when you have a group of form controls but
	      * you're not sure how many there will be. Form arrays allow you to create new
	      * form controls dynamically.
	      * *
	      * **Access the array**: You can access the associated {@link FormArray} using the
	      * {@link AbstractControl.get} method on the parent {@link FormGroup}.
	      * Ex: `this.form.get('cities')`.
	      * *
	      * **Get the value**: the `value` property is always synced and available on the
	      * {@link FormArray}. See a full list of available properties in {@link AbstractControl}.
	      * *
	      * **Set the value**: You can set an initial value for each child control when instantiating
	      * the {@link FormArray}, or you can set the value programmatically later using the
	      * {@link FormArray}'s {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}
	      * methods.
	      * *
	      * **Listen to value**: If you want to listen to changes in the value of the array, you can
	      * subscribe to the {@link FormArray}'s {@link AbstractControl.valueChanges} event.  You can also
	      * listen to its {@link AbstractControl.statusChanges} event to be notified when the validation
	      * status is re-calculated.
	      * *
	      * **Add new controls**: You can add new controls to the {@link FormArray} dynamically by
	      * calling its {@link FormArray.push} method.
	      * Ex: `this.form.get('cities').push(new FormControl());`
	      * *
	      * ### Example
	      * *
	      * {@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	      * * **NgModule**: `ReactiveFormsModule`
	      * *
	     */
	    var FormArrayName = (function (_super) {
	        __extends$12(FormArrayName, _super);
	        /**
	         * @param {?} parent
	         * @param {?} validators
	         * @param {?} asyncValidators
	         */
	        function FormArrayName(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        /**
	         * @return {?}
	         */
	        FormArrayName.prototype.ngOnInit = function () {
	            this._checkParentType();
	            this.formDirective.addFormArray(this);
	        };
	        /**
	         * @return {?}
	         */
	        FormArrayName.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeFormArray(this);
	            }
	        };
	        Object.defineProperty(FormArrayName.prototype, "control", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this.formDirective.getFormArray(this); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "formDirective", {
	            /**
	             * @return {?}
	             */
	            get: function () {
	                return this._parent ? (this._parent.formDirective) : null;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "path", {
	            /**
	             * @return {?}
	             */
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "validator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return composeValidators(this._validators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return composeAsyncValidators(this._asyncValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @return {?}
	         */
	        FormArrayName.prototype._checkParentType = function () {
	            if (_hasInvalidParent(this._parent)) {
	                ReactiveErrors.arrayParentException();
	            }
	        };
	        FormArrayName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
	        ];
	        /** @nocollapse */
	        FormArrayName.ctorParameters = function () { return [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ]; };
	        FormArrayName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formArrayName',] },],
	        };
	        return FormArrayName;
	    }(ControlContainer));
	    /**
	     * @param {?} parent
	     * @return {?}
	     */
	    function _hasInvalidParent(parent) {
	        return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
	            !(parent instanceof FormArrayName);
	    }
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$10 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var /** @type {?} */ controlNameBinding = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return FormControlName; })
	    };
	    /**
	     *  element by name.
	      * *
	      * In other words, this directive ensures that any values written to the {@link FormControl}
	      * instance programmatically will be written to the DOM element (model -> view). Conversely,
	      * any values written to the DOM element through user input will be reflected in the
	      * {@link FormControl} instance (view -> model).
	      * *
	      * *
	      * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
	      * `[formGroup]`).
	      * *
	      * It accepts the string name of the {@link FormControl} instance you want to
	      * link, and will look for a {@link FormControl} registered with that name in the
	      * closest {@link FormGroup} or {@link FormArray} above it.
	      * *
	      * **Access the control**: You can access the {@link FormControl} associated with
	      * this directive by using the {@link AbstractControl.get} method.
	      * Ex: `this.form.get('first');`
	      * *
	      * **Get value**: the `value` property is always synced and available on the {@link FormControl}.
	      * See a full list of available properties in {@link AbstractControl}.
	      * *
	      * **Set value**: You can set an initial value for the control when instantiating the
	      * {@link FormControl}, or you can set it programmatically later using
	      * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
	      * *
	      * **Listen to value**: If you want to listen to changes in the value of the control, you can
	      * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	      * {@link AbstractControl.statusChanges} to be notified when the validation status is
	      * re-calculated.
	      * *
	      * ### Example
	      * *
	      * In this example, we create form controls for first name and last name.
	      * *
	      * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
	      * *
	      * To see `formControlName` examples with different form control types, see:
	      * *
	      * * Radio buttons: {@link RadioControlValueAccessor}
	      * * Selects: {@link SelectControlValueAccessor}
	      * *
	      * **npm package**: `@angular/forms`
	      * *
	      * **NgModule**: {@link ReactiveFormsModule}
	      * *
	      * @stable
	     */
	    var FormControlName = (function (_super) {
	        __extends$10(FormControlName, _super);
	        /**
	         * @param {?} parent
	         * @param {?} validators
	         * @param {?} asyncValidators
	         * @param {?} valueAccessors
	         */
	        function FormControlName(parent, validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            this._added = false;
	            this.update = new EventEmitter();
	            this._parent = parent;
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        Object.defineProperty(FormControlName.prototype, "isDisabled", {
	            /**
	             * @param {?} isDisabled
	             * @return {?}
	             */
	            set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        FormControlName.prototype.ngOnChanges = function (changes) {
	            if (!this._added)
	                this._setUpControl();
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this.viewModel = this.model;
	                this.formDirective.updateModel(this, this.model);
	            }
	        };
	        /**
	         * @return {?}
	         */
	        FormControlName.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeControl(this);
	            }
	        };
	        /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        FormControlName.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        Object.defineProperty(FormControlName.prototype, "path", {
	            /**
	             * @return {?}
	             */
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "formDirective", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "validator", {
	            /**
	             * @return {?}
	             */
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "asyncValidator", {
	            /**
	             * @return {?}
	             */
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "control", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._control; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @return {?}
	         */
	        FormControlName.prototype._checkParentType = function () {
	            if (!(this._parent instanceof FormGroupName) &&
	                this._parent instanceof AbstractFormGroupDirective) {
	                ReactiveErrors.ngModelGroupException();
	            }
	            else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
	                !(this._parent instanceof FormArrayName)) {
	                ReactiveErrors.controlParentException();
	            }
	        };
	        /**
	         * @return {?}
	         */
	        FormControlName.prototype._setUpControl = function () {
	            this._checkParentType();
	            this._control = this.formDirective.addControl(this);
	            if (this.control.disabled && this.valueAccessor.setDisabledState) {
	                this.valueAccessor.setDisabledState(true);
	            }
	            this._added = true;
	        };
	        FormControlName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
	        ];
	        /** @nocollapse */
	        FormControlName.ctorParameters = function () { return [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ]; };
	        FormControlName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formControlName',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	        };
	        return FormControlName;
	    }(NgControl));
	
	    var /** @type {?} */ REQUIRED_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return RequiredValidator; }),
	        multi: true
	    };
	    /**
	     *  A Directive that adds the `required` validator to any controls marked with the
	      * `required` attribute, via the {@link NG_VALIDATORS} binding.
	      * *
	      * ### Example
	      * *
	      * ```
	      * <input name="fullName" ngModel required>
	      * ```
	      * *
	     */
	    var RequiredValidator = (function () {
	        function RequiredValidator() {
	        }
	        Object.defineProperty(RequiredValidator.prototype, "required", {
	            /**
	             * @return {?}
	             */
	            get: function () { return this._required; },
	            /**
	             * @param {?} value
	             * @return {?}
	             */
	            set: function (value) {
	                this._required = value != null && value !== false && "" + value !== 'false';
	                if (this._onChange)
	                    this._onChange();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} c
	         * @return {?}
	         */
	        RequiredValidator.prototype.validate = function (c) {
	            return this.required ? Validators.required(c) : null;
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        RequiredValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[required][formControlName],[required][formControl],[required][ngModel]',
	                        providers: [REQUIRED_VALIDATOR],
	                        host: { '[attr.required]': 'required ? "" : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        RequiredValidator.ctorParameters = function () { return []; };
	        RequiredValidator.propDecorators = {
	            'required': [{ type: _angular_core.Input },],
	        };
	        return RequiredValidator;
	    }());
	    /**
	     * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
	     *
	     * ## Example:
	     *
	     * {@example common/forms/ts/validators/validators.ts region='min'}
	     */
	    var /** @type {?} */ MIN_LENGTH_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return MinLengthValidator; }),
	        multi: true
	    };
	    /**
	     *  A directive which installs the {@link MinLengthValidator} for any `formControlName`,
	      * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
	      * *
	     */
	    var MinLengthValidator = (function () {
	        function MinLengthValidator() {
	        }
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        MinLengthValidator.prototype.ngOnChanges = function (changes) {
	            if ('minlength' in changes) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        /**
	         * @param {?} c
	         * @return {?}
	         */
	        MinLengthValidator.prototype.validate = function (c) {
	            return this.minlength == null ? null : this._validator(c);
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        /**
	         * @return {?}
	         */
	        MinLengthValidator.prototype._createValidator = function () {
	            this._validator = Validators.minLength(parseInt(this.minlength, 10));
	        };
	        MinLengthValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
	                        providers: [MIN_LENGTH_VALIDATOR],
	                        host: { '[attr.minlength]': 'minlength ? minlength : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        MinLengthValidator.ctorParameters = function () { return []; };
	        MinLengthValidator.propDecorators = {
	            'minlength': [{ type: _angular_core.Input },],
	        };
	        return MinLengthValidator;
	    }());
	    /**
	     * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
	     *
	     * ## Example:
	     *
	     * {@example common/forms/ts/validators/validators.ts region='max'}
	     */
	    var /** @type {?} */ MAX_LENGTH_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return MaxLengthValidator; }),
	        multi: true
	    };
	    /**
	     *  A directive which installs the {@link MaxLengthValidator} for any `formControlName,
	      * `formControl`,
	      * or control with `ngModel` that also has a `maxlength` attribute.
	      * *
	     */
	    var MaxLengthValidator = (function () {
	        function MaxLengthValidator() {
	        }
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        MaxLengthValidator.prototype.ngOnChanges = function (changes) {
	            if ('maxlength' in changes) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        /**
	         * @param {?} c
	         * @return {?}
	         */
	        MaxLengthValidator.prototype.validate = function (c) {
	            return this.maxlength != null ? this._validator(c) : null;
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        /**
	         * @return {?}
	         */
	        MaxLengthValidator.prototype._createValidator = function () {
	            this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
	        };
	        MaxLengthValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
	                        providers: [MAX_LENGTH_VALIDATOR],
	                        host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        MaxLengthValidator.ctorParameters = function () { return []; };
	        MaxLengthValidator.propDecorators = {
	            'maxlength': [{ type: _angular_core.Input },],
	        };
	        return MaxLengthValidator;
	    }());
	    var /** @type {?} */ PATTERN_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return PatternValidator; }),
	        multi: true
	    };
	    /**
	     *  A Directive that adds the `pattern` validator to any controls marked with the
	      * `pattern` attribute, via the {@link NG_VALIDATORS} binding. Uses attribute value
	      * as the regex to validate Control value against.  Follows pattern attribute
	      * semantics; i.e. regex must match entire Control value.
	      * *
	      * ### Example
	      * *
	      * ```
	      * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
	      * ```
	     */
	    var PatternValidator = (function () {
	        function PatternValidator() {
	        }
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        PatternValidator.prototype.ngOnChanges = function (changes) {
	            if ('pattern' in changes) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        /**
	         * @param {?} c
	         * @return {?}
	         */
	        PatternValidator.prototype.validate = function (c) { return this._validator(c); };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        /**
	         * @return {?}
	         */
	        PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
	        PatternValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
	                        providers: [PATTERN_VALIDATOR],
	                        host: { '[attr.pattern]': 'pattern ? pattern : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        PatternValidator.ctorParameters = function () { return []; };
	        PatternValidator.propDecorators = {
	            'pattern': [{ type: _angular_core.Input },],
	        };
	        return PatternValidator;
	    }());
	
	    /**
	     *  *
	      * It is essentially syntactic sugar that shortens the `new FormGroup()`,
	      * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
	      * forms.
	      * *
	      * *
	      * To use, inject `FormBuilder` into your component class. You can then call its methods
	      * directly.
	      * *
	      * {@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
	      * *
	      * * **npm package**: `@angular/forms`
	      * *
	      * * **NgModule**: {@link ReactiveFormsModule}
	      * *
	     */
	    var FormBuilder = (function () {
	        function FormBuilder() {
	        }
	        /**
	         *  Construct a new {@link FormGroup} with the given map of configuration.
	          * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
	          * *
	          * See the {@link FormGroup} constructor for more details.
	         * @param {?} controlsConfig
	         * @param {?=} extra
	         * @return {?}
	         */
	        FormBuilder.prototype.group = function (controlsConfig, extra) {
	            if (extra === void 0) { extra = null; }
	            var /** @type {?} */ controls = this._reduceControls(controlsConfig);
	            var /** @type {?} */ validator = isPresent(extra) ? extra['validator'] : null;
	            var /** @type {?} */ asyncValidator = isPresent(extra) ? extra['asyncValidator'] : null;
	            return new FormGroup(controls, validator, asyncValidator);
	        };
	        /**
	         *  Construct a new {@link FormControl} with the given `formState`,`validator`, and
	          * `asyncValidator`.
	          * *
	          * `formState` can either be a standalone value for the form control or an object
	          * that contains both a value and a disabled status.
	          * *
	         * @param {?} formState
	         * @param {?=} validator
	         * @param {?=} asyncValidator
	         * @return {?}
	         */
	        FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            return new FormControl(formState, validator, asyncValidator);
	        };
	        /**
	         *  Construct a {@link FormArray} from the given `controlsConfig` array of
	          * configuration, with the given optional `validator` and `asyncValidator`.
	         * @param {?} controlsConfig
	         * @param {?=} validator
	         * @param {?=} asyncValidator
	         * @return {?}
	         */
	        FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
	            var _this = this;
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
	            return new FormArray(controls, validator, asyncValidator);
	        };
	        /**
	         * @param {?} controlsConfig
	         * @return {?}
	         */
	        FormBuilder.prototype._reduceControls = function (controlsConfig) {
	            var _this = this;
	            var /** @type {?} */ controls = {};
	            Object.keys(controlsConfig).forEach(function (controlName) {
	                controls[controlName] = _this._createControl(controlsConfig[controlName]);
	            });
	            return controls;
	        };
	        /**
	         * @param {?} controlConfig
	         * @return {?}
	         */
	        FormBuilder.prototype._createControl = function (controlConfig) {
	            if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
	                controlConfig instanceof FormArray) {
	                return controlConfig;
	            }
	            else if (Array.isArray(controlConfig)) {
	                var /** @type {?} */ value = controlConfig[0];
	                var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
	                var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
	                return this.control(value, validator, asyncValidator);
	            }
	            else {
	                return this.control(controlConfig);
	            }
	        };
	        FormBuilder.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        FormBuilder.ctorParameters = function () { return []; };
	        return FormBuilder;
	    }());
	
	    /**
	     * @stable
	     */
	    var /** @type {?} */ VERSION = new _angular_core.Version('2.3.0');
	
	    var /** @type {?} */ SHARED_FORM_DIRECTIVES = [
	        NgSelectOption, NgSelectMultipleOption, DefaultValueAccessor, NumberValueAccessor,
	        RangeValueAccessor, CheckboxControlValueAccessor, SelectControlValueAccessor,
	        SelectMultipleControlValueAccessor, RadioControlValueAccessor, NgControlStatus,
	        NgControlStatusGroup, RequiredValidator, MinLengthValidator, MaxLengthValidator, PatternValidator
	    ];
	    var /** @type {?} */ TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
	    var /** @type {?} */ REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
	    /**
	     *  Internal module used for sharing directives between FormsModule and ReactiveFormsModule
	     */
	    var InternalFormsSharedModule = (function () {
	        function InternalFormsSharedModule() {
	        }
	        InternalFormsSharedModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        declarations: SHARED_FORM_DIRECTIVES,
	                        exports: SHARED_FORM_DIRECTIVES,
	                    },] },
	        ];
	        /** @nocollapse */
	        InternalFormsSharedModule.ctorParameters = function () { return []; };
	        return InternalFormsSharedModule;
	    }());
	
	    /**
	     *  The ng module for forms.
	     */
	    var FormsModule = (function () {
	        function FormsModule() {
	        }
	        FormsModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        declarations: TEMPLATE_DRIVEN_DIRECTIVES,
	                        providers: [RadioControlRegistry],
	                        exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
	                    },] },
	        ];
	        /** @nocollapse */
	        FormsModule.ctorParameters = function () { return []; };
	        return FormsModule;
	    }());
	    /**
	     *  The ng module for reactive forms.
	     */
	    var ReactiveFormsModule = (function () {
	        function ReactiveFormsModule() {
	        }
	        ReactiveFormsModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        declarations: [REACTIVE_DRIVEN_DIRECTIVES],
	                        providers: [FormBuilder, RadioControlRegistry],
	                        exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
	                    },] },
	        ];
	        /** @nocollapse */
	        ReactiveFormsModule.ctorParameters = function () { return []; };
	        return ReactiveFormsModule;
	    }());
	
	    exports.AbstractControlDirective = AbstractControlDirective;
	    exports.AbstractFormGroupDirective = AbstractFormGroupDirective;
	    exports.CheckboxControlValueAccessor = CheckboxControlValueAccessor;
	    exports.ControlContainer = ControlContainer;
	    exports.NG_VALUE_ACCESSOR = NG_VALUE_ACCESSOR;
	    exports.DefaultValueAccessor = DefaultValueAccessor;
	    exports.NgControl = NgControl;
	    exports.NgControlStatus = NgControlStatus;
	    exports.NgControlStatusGroup = NgControlStatusGroup;
	    exports.NgForm = NgForm;
	    exports.NgModel = NgModel;
	    exports.NgModelGroup = NgModelGroup;
	    exports.RadioControlValueAccessor = RadioControlValueAccessor;
	    exports.FormControlDirective = FormControlDirective;
	    exports.FormControlName = FormControlName;
	    exports.FormGroupDirective = FormGroupDirective;
	    exports.FormArrayName = FormArrayName;
	    exports.FormGroupName = FormGroupName;
	    exports.NgSelectOption = NgSelectOption;
	    exports.SelectControlValueAccessor = SelectControlValueAccessor;
	    exports.SelectMultipleControlValueAccessor = SelectMultipleControlValueAccessor;
	    exports.MaxLengthValidator = MaxLengthValidator;
	    exports.MinLengthValidator = MinLengthValidator;
	    exports.PatternValidator = PatternValidator;
	    exports.RequiredValidator = RequiredValidator;
	    exports.FormBuilder = FormBuilder;
	    exports.AbstractControl = AbstractControl;
	    exports.FormArray = FormArray;
	    exports.FormControl = FormControl;
	    exports.FormGroup = FormGroup;
	    exports.NG_ASYNC_VALIDATORS = NG_ASYNC_VALIDATORS;
	    exports.NG_VALIDATORS = NG_VALIDATORS;
	    exports.Validators = Validators;
	    exports.VERSION = VERSION;
	    exports.FormsModule = FormsModule;
	    exports.ReactiveFormsModule = ReactiveFormsModule;
	
	}));

/***/ },
/* 59 */,
/* 60 */,
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(50);
	var usuario_service_1 = __webpack_require__(85);
	var AuthService = (function () {
	    function AuthService(_usuarioService, _dataService, _router) {
	        this._usuarioService = _usuarioService;
	        this._dataService = _dataService;
	        this._router = _router;
	        this.isLoggedIn = false;
	        this.tenants = this._dataService.getTenants();
	        this.contasDomain = this._dataService.getContasDomain();
	    }
	    AuthService.prototype.navigateTo = function (pathTo, param) {
	        var tenantName = this.getTenantUrl();
	        var url = this._router.url;
	        if (url.indexOf("visitante") === -1) {
	            pathTo = tenantName.concat("/" + pathTo);
	        }
	        else {
	            pathTo = tenantName.concat("/visitante/" + pathTo);
	        }
	        if (param) {
	            if (param.length) {
	                var params = param;
	                params.unshift(pathTo);
	                this._router.navigate(params);
	            }
	            else {
	                this._router.navigate([pathTo, param]);
	            }
	        }
	        else {
	            this._router.navigate([pathTo]);
	        }
	    };
	    AuthService.prototype.logout = function () {
	        this.isLoggedIn = false;
	        localStorage.clear();
	        sessionStorage.clear();
	        var exp = this._dataService.getCookieName();
	        document.cookie = exp + '=123; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=.geosiap.net';
	        window.location.assign(this.contasDomain + "/logout");
	    };
	    AuthService.prototype.checkCookie = function () {
	        // if (process.env.ENV !== 'production' && process.env.ENV !== 'staging') {
	        //    document.cookie = "staging_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpZCI6NjYsImVtYWlsIjoiZnJvdGFzQGV4bGEuY29tLmJyIiwidXNlcm5hbWUiOiJmcm90YXMiLCJub21lIjoiVXN1w6FyaW8gVGVzdGUgRnJvdGFzIiwiZm90b191cmwiOm51bGx9.fihDuWnIEHut1_i1E1SWyhTGMEWS-2eV51MjQeA8QMCa74sEYNcEukiO3y-AfXx4oJFvNIlfHYdE5gvg_xF3capge-7qDP-7i4QtR0m1la1-xF8uN9IOLfz5Deb3RnZcv8Px7pw-hOk2AKMTFkWx2To73V3fq6YROqsuKnGtCP9xH3Jj9w62YjeTJPm8oEomKBS85OBfmNmRQCJpC6rQpuGacBbtrcarvAc8irOQya3fg76uRO6OFEXMFYOCU4E1Ehgc39B5GiHSlaRBLGbYuzw4ZboH7ZXs61RC9Kk7d741RFkWngmM0QCHilzIkkGlYI2SjldtJaMtORLdLlNGNA";
	        // }
	        var cookie = this.getCookieToken();
	        if (!cookie) {
	            this.isLoggedIn = false;
	            localStorage.clear();
	            sessionStorage.clear();
	            this.redirectToAccountPage();
	        }
	        else {
	            var storageToken = this._usuarioService.getStorageToken();
	            if (!storageToken) {
	                var l = this.redirectUrl.split("/");
	                if (l.length) {
	                    this.redirectUrl = "/" + l[1];
	                }
	                this._usuarioService.getCredential(cookie);
	            }
	            else {
	                this._dataService.setToken(storageToken);
	            }
	            this.isLoggedIn = true;
	            this.navigateTo(this.redirectUrl);
	        }
	    };
	    AuthService.prototype.redirectToAccountPage = function () {
	        var r = this.contasDomain + "/login?return_to=" + window.location.href;
	        window.localStorage.setItem('redirect', 'true');
	        window.location.assign(r);
	    };
	    AuthService.prototype.getTenantUrl = function () {
	        var url = this._router.url, tenants = this.tenants, findTenantName, findProjectIndex, x, lenX;
	        for (x = 0, lenX = tenants.length; x < lenX; x++) {
	            findProjectIndex = url.indexOf("/" + tenants[x] + "/");
	            if (findProjectIndex !== -1) {
	                findTenantName = tenants[x];
	                return findTenantName;
	            }
	        }
	        return '';
	    };
	    AuthService.prototype.getCookieToken = function () {
	        var cookie = document.cookie;
	        var cookie2 = null;
	        if (cookie) {
	            // cookie = cookie.split("=");
	            // cookie2 = cookie[1];
	            cookie = cookie.split(";");
	            var x = void 0, lenX = void 0;
	            var cookieName = this._dataService.getCookieName();
	            for (x = 0, lenX = cookie.length; x < lenX; x++) {
	                if (cookie[x].search(cookieName) !== -1) {
	                    cookie2 = cookie[x].split("=");
	                    cookie2 = cookie2[1];
	                    break;
	                }
	            }
	        }
	        return cookie2;
	    };
	    AuthService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof usuario_service_1.UsuarioService !== 'undefined' && usuario_service_1.UsuarioService) === 'function' && _a) || Object, (typeof (_b = typeof data_service_1.DataService !== 'undefined' && data_service_1.DataService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object])
	    ], AuthService);
	    return AuthService;
	    var _a, _b, _c;
	}());
	exports.AuthService = AuthService;


/***/ },
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 21/02/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(50);
	var usuario_api_service_1 = __webpack_require__(86);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(87);
	var UsuarioService = (function () {
	    function UsuarioService(_router, _dataService, _usuarioApiService, _utilService) {
	        this._router = _router;
	        this._dataService = _dataService;
	        this._usuarioApiService = _usuarioApiService;
	        this._utilService = _utilService;
	    }
	    UsuarioService.prototype.setSessionStorageLogged = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_2.usuariosStorage + '-logged', object);
	    };
	    UsuarioService.prototype.getSessionStorageLogged = function () {
	        var item = sessionStorage.getItem(data_service_2.usuariosStorage + "-logged");
	        return JSON.parse(item);
	    };
	    UsuarioService.prototype.setStorageToken = function (item) {
	        localStorage.setItem(data_service_2.usuariosStorage + '-token', item);
	    };
	    UsuarioService.prototype.getStorageToken = function () {
	        var item = localStorage.getItem(data_service_2.usuariosStorage + "-token");
	        return item;
	    };
	    UsuarioService.prototype.checkIsVisitor = function () {
	        var url = this._router.url;
	        if (url.indexOf('visitante') === -1) {
	            return false;
	        }
	        var token = this._dataService.getToken();
	        var tokenSplit = token.split(/\./);
	        var userId = atob(tokenSplit[1]);
	        return Number(userId);
	    };
	    UsuarioService.prototype.getCredential = function (cookie) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this._dataService.setToken(Response.token);
	                this.setStorageToken(Response.token);
	                this.setSessionStorageLogged(Response);
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._usuarioApiService.onGetTokenByCookie(cookie, onDone);
	    };
	    UsuarioService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof data_service_1.DataService !== 'undefined' && data_service_1.DataService) === 'function' && _b) || Object, (typeof (_c = typeof usuario_api_service_1.UsuarioApiService !== 'undefined' && usuario_api_service_1.UsuarioApiService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], UsuarioService);
	    return UsuarioService;
	    var _a, _b, _c, _d;
	}());
	exports.UsuarioService = UsuarioService;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(87);
	var UsuarioApiService = (function () {
	    function UsuarioApiService(_restService) {
	        this._restService = _restService;
	    }
	    UsuarioApiService.prototype.onGetTokenByCookie = function (cookie, done) {
	        this._restService.onGetSemToken(data_service_1.apiName + '/credenciais/token/' + cookie, done);
	    };
	    UsuarioApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], UsuarioApiService);
	    return UsuarioApiService;
	    var _a;
	}());
	exports.UsuarioApiService = UsuarioApiService;


/***/ },
/* 87 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'usuarios';
	exports.usuariosRoute = 'usuarios';
	exports.usuariosStorage = 'usuarios';
	exports.usuariosModuleName = { plural: 'Usuários', single: 'Usuário' };
	exports.usuariosQuery = {
	    "where": {
	        "ativo": true,
	        "email": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "email"
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var UtilService = (function () {
	    function UtilService() {
	    }
	    UtilService.prototype.removeSpecialCharacter = function (item) {
	        return item.replace(/[^0-9|^a-z]/gi, '');
	    };
	    UtilService.prototype.cloneObject = function (object) {
	        return JSON.parse(JSON.stringify(object));
	    };
	    UtilService.prototype.swalMessageDelete = function (done, closeOnConfirm) {
	        if (!closeOnConfirm) {
	            closeOnConfirm = false;
	        }
	        swal({
	            title: "Você deseja realmente desativar este item?",
	            text: "O item será desativado.",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Desativar",
	            cancelButtonText: "Cancelar",
	            closeOnConfirm: closeOnConfirm
	        }, function () {
	            return done();
	        });
	    };
	    UtilService.prototype.swalMessageDeleteSuccess = function () {
	        swal("Desativado!", 'Desativado com sucesso.', "success");
	    };
	    UtilService.prototype.swalMessageDeleteError = function () {
	        swal("Erro!", 'Não foi possível desativar o item.', "error");
	    };
	    UtilService.prototype.swalMessagePostError = function () {
	        swal("Erro!", 'Não foi salvar os dados.', "error");
	    };
	    UtilService.prototype.swalMessageAddSuccess = function () {
	        swal("Cadastrado!", "O item foi cadastrado com sucesso.", "success");
	    };
	    UtilService.prototype.swalMessageEditSuccess = function () {
	        swal("Editado!", "O item foi editado com sucesso.", "success");
	    };
	    UtilService.prototype.swalMessageWarningCustom = function (message) {
	        swal("Aviso!", message, "warning");
	    };
	    UtilService.prototype.setSelectOnFormControl = function (form, item, object, arg) {
	        var tt = form.controls[item];
	        if (arg) {
	            tt.patchValue(object[arg]);
	        }
	        else {
	            if (typeof object === 'string') {
	                tt.patchValue(object);
	            }
	            else {
	                tt.patchValue(object.id);
	            }
	        }
	    };
	    UtilService.prototype.convertDateToString = function (date) {
	        date = new Date(date);
	        var day = date.getUTCDate();
	        var month = date.getUTCMonth() + 1;
	        var year = date.getUTCFullYear();
	        var monthS = month.toString();
	        var dayS = day.toString();
	        if (month < 10) {
	            monthS = "0" + monthS;
	        }
	        if (day < 10) {
	            dayS = "0" + dayS;
	        }
	        var newDate = dayS + "/" + monthS + "/" + year;
	        return newDate;
	    };
	    UtilService.prototype.convertStringToDate = function (date) {
	        var newDate = false;
	        var dateArray = date.split("/");
	        if (dateArray.length === 3) {
	            var day = Number(dateArray[0]);
	            var month = Number(dateArray[1]) - 1;
	            var year = Number(dateArray[2]);
	            var time = new Date();
	            if (month < 12 && day < 32) {
	                newDate = new Date(year, month, day);
	                newDate.setHours(time.getHours());
	                newDate.setMinutes(time.getMinutes());
	                return newDate;
	            }
	            else {
	                return false;
	            }
	        }
	        else {
	            return false;
	        }
	    };
	    UtilService.prototype.convertStringToDateTime = function (date, time) {
	        var newDateTime = this.convertStringToDate(date);
	        var timeArray = time.split(":");
	        if (timeArray.length === 2) {
	            var hours = Number(timeArray[0]);
	            var minutes = Number(timeArray[1]);
	            if (hours <= 24 && minutes <= 59) {
	                newDateTime.setHours(hours);
	                newDateTime.setMinutes(minutes);
	                return newDateTime;
	            }
	            else {
	                return false;
	            }
	        }
	        else {
	            return false;
	        }
	    };
	    UtilService.prototype.convertTimeToString = function (date) {
	        date = new Date(date);
	        var hour = date.getHours();
	        var minute = date.getMinutes();
	        if (hour < 10) {
	            hour = "0" + hour;
	        }
	        if (minute < 10) {
	            minute = "0" + minute;
	        }
	        var newDate = hour + ":" + minute;
	        return newDate;
	    };
	    UtilService.prototype.disabledFutureDates = function (inputId) {
	        var datePicker = $('#' + inputId);
	        datePicker.datepicker({ maxDate: "+0D" });
	    };
	    UtilService.prototype.getCurrency = function (currency) {
	        currency = currency.toString();
	        currency = currency.replace(/\./g, '');
	        currency = currency.replace(",", ".");
	        currency = parseFloat(currency);
	        return currency;
	    };
	    UtilService.prototype.currencyFormat = function (newVal, start) {
	        var formatted = '', x, lenX;
	        if (!newVal) {
	            newVal = 0;
	        }
	        else {
	            newVal = newVal.toString();
	            if (start) {
	                var point = newVal.indexOf(".");
	                if (point === -1) {
	                    newVal = newVal + '00';
	                }
	                else {
	                    var afterPoint = newVal.slice(point + 1, newVal.length);
	                    if (afterPoint.length < 2) {
	                        newVal = newVal + '0';
	                    }
	                }
	                newVal = newVal.replace(".", "");
	            }
	            else {
	                findCharacter('.');
	                findCharacter(',');
	                newVal = newVal.replace(/\D/g, '').replace(/\./g, '').replace(/,/g, '').replace(/^0+/, '');
	            }
	            if (newVal.length == 2)
	                newVal = '0' + newVal;
	            if (newVal.length == 1)
	                newVal = '00' + newVal;
	            for (x = 0, lenX = newVal.length; x < lenX; x++) {
	                var sep = '';
	                if (x == 2)
	                    sep = ',';
	                if (x > 3 && (x + 1) % 3 == 0)
	                    sep = '.';
	                formatted = newVal.substring(newVal.length - 1 - x, newVal.length - x) + sep + formatted;
	            }
	            newVal = formatted;
	        }
	        return newVal;
	        function findCharacter(char) {
	            var pos = newVal.lastIndexOf(char);
	            if (pos !== -1) {
	                var part2 = newVal.slice((pos + 1), newVal.length);
	                if (part2.length == 1)
	                    newVal = newVal + '0';
	            }
	        }
	    };
	    UtilService.prototype.checkNumber = function (value) {
	        var valueNumber = Number(value);
	        if (isNaN(valueNumber)) {
	            return '';
	        }
	        return value;
	    };
	    UtilService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], UtilService);
	    return UtilService;
	}());
	exports.UtilService = UtilService;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var AuthGuardService = (function () {
	    function AuthGuardService(_authService) {
	        this._authService = _authService;
	    }
	    AuthGuardService.prototype.canActivate = function (route, state) {
	        var url = state.url;
	        return this.checkLogin(url);
	    };
	    AuthGuardService.prototype.canActivateChild = function (route, state) {
	        return this.canActivate(route, state);
	    };
	    AuthGuardService.prototype.checkLogin = function (url) {
	        if (this._authService.isLoggedIn) {
	            return true;
	        }
	        // Store the attempted URL for redirecting
	        this._authService.redirectUrl = url;
	        // Navigate to the login page with extras
	        this._authService.checkCookie();
	        return false;
	    };
	    AuthGuardService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], AuthGuardService);
	    return AuthGuardService;
	    var _a;
	}());
	exports.AuthGuardService = AuthGuardService;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var PhoneMaskDirective = (function () {
	    function PhoneMaskDirective(model) {
	        this.model = model;
	    }
	    PhoneMaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    PhoneMaskDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    PhoneMaskDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    PhoneMaskDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model.replace(/\D/g, '');
	            if (backspace) {
	                if (newVal.length === 1) {
	                    newVal = newVal.substring(0, newVal.length - 1);
	                }
	            }
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else if (newVal.length === 1) {
	                newVal = newVal.replace(/(\d{1})/, "($1");
	            }
	            else if (newVal.length === 2) {
	                newVal = newVal.replace(/(\d{2})/, "($1)");
	            }
	            else if (newVal.length <= 6) {
	                newVal = newVal.replace(/(\d{2})(\d{0,4})/, "($1) $2");
	            }
	            else if (newVal.length <= 10) {
	                newVal = newVal.replace(/(\d{2})(\d{0,4})(\d{0,4})/, "($1) $2-$3");
	            }
	            else if (newVal.length <= 11) {
	                newVal = newVal.replace(/(\d{2})(\d{0,5})(\d{0,4})/, "($1) $2-$3");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], PhoneMaskDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], PhoneMaskDirective.prototype, "onKeyDownBackspace", null);
	    PhoneMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[appPhoneMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], PhoneMaskDirective);
	    return PhoneMaskDirective;
	    var _a;
	}());
	exports.PhoneMaskDirective = PhoneMaskDirective;


/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	var EmailValidator = (function () {
	    function EmailValidator() {
	    }
	    EmailValidator.emailFormat = function (item) {
	        var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
	        if (item.value && !EMAIL_REGEXP.test(item.value)) {
	            return { "incorrectMailFormat": true };
	        }
	        return null;
	    };
	    return EmailValidator;
	}());
	exports.EmailValidator = EmailValidator;


/***/ },
/* 92 */
/***/ function(module, exports) {

	"use strict";
	var PhoneValidator = (function () {
	    function PhoneValidator() {
	    }
	    PhoneValidator.phoneFormat = function (item) {
	        var PHONE_REGEXP;
	        if (item.value) {
	            var tt = item.value.replace(/[^0-9]/gi, '');
	            if (tt.length === 10) {
	                PHONE_REGEXP = /([0-9]{10})/;
	            }
	            else {
	                PHONE_REGEXP = /([0-9]{11})/;
	            }
	            if (item.value && !PHONE_REGEXP.test(tt)) {
	                return { "incorrectPhoneFormat": true };
	            }
	        }
	        return null;
	    };
	    return PhoneValidator;
	}());
	exports.PhoneValidator = PhoneValidator;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var filter_service_1 = __webpack_require__(94);
	var FilterPipe = (function () {
	    function FilterPipe(_filterService) {
	        this._filterService = _filterService;
	    }
	    FilterPipe.prototype.transform = function (value, args, attr) {
	        var arrayFiltered = this._filterService.filterArray(value, args, attr);
	        return arrayFiltered;
	    };
	    FilterPipe = __decorate([
	        core_1.Pipe({
	            name: 'filter'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof filter_service_1.FilterService !== 'undefined' && filter_service_1.FilterService) === 'function' && _a) || Object])
	    ], FilterPipe);
	    return FilterPipe;
	    var _a;
	}());
	exports.FilterPipe = FilterPipe;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var FilterService = (function () {
	    function FilterService() {
	    }
	    FilterService.prototype.filterArray = function (list, args, attr) {
	        var filter;
	        var item2;
	        var tt;
	        var attrSplit;
	        var filter2 = list.filter(function (item) {
	            for (var key in attr) {
	                attrSplit = attr[key].split(".");
	                item2 = item;
	                for (var keyY in attrSplit) {
	                    tt = item2[attrSplit[keyY]];
	                    if (tt) {
	                        item2 = tt;
	                    }
	                    else {
	                        break;
	                    }
	                }
	                if (typeof args === 'string') {
	                    filter = (args || '').toLowerCase();
	                    filter = removeAccents(filter);
	                    item2 = item2.toString();
	                    item2 = item2.toLowerCase();
	                    item2 = removeAccents(item2);
	                    if (item2.indexOf(filter) != -1) {
	                        return item;
	                    }
	                }
	                else {
	                    filter = args;
	                    if (item2 === filter) {
	                        return item;
	                    }
	                }
	            }
	        });
	        function removeAccents(value) {
	            return value
	                .replace(/á/g, 'a')
	                .replace(/â/g, 'a')
	                .replace(/à/g, 'a')
	                .replace(/ã/g, 'a')
	                .replace(/é/g, 'e')
	                .replace(/è/g, 'e')
	                .replace(/ê/g, 'e')
	                .replace(/í/g, 'i')
	                .replace(/ì/g, 'i')
	                .replace(/î/g, 'i')
	                .replace(/ó/g, 'o')
	                .replace(/ò/g, 'o')
	                .replace(/ô/g, 'o')
	                .replace(/õ/g, 'o')
	                .replace(/ú/g, 'u')
	                .replace(/ù/g, 'u')
	                .replace(/û/g, 'u')
	                .replace(/ç/g, 'c');
	        }
	        return filter ? filter2 : list;
	    };
	    FilterService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], FilterService);
	    return FilterService;
	}());
	exports.FilterService = FilterService;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var FilterActivePipe = (function () {
	    function FilterActivePipe() {
	    }
	    FilterActivePipe.prototype.transform = function (value, args) {
	        return value.filter(function (item) {
	            if (args) {
	                return true;
	            }
	            else {
	                if (item.ativo) {
	                    return true;
	                }
	            }
	        });
	    };
	    FilterActivePipe = __decorate([
	        core_1.Pipe({
	            name: 'filterActive',
	            pure: false
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FilterActivePipe);
	    return FilterActivePipe;
	}());
	exports.FilterActivePipe = FilterActivePipe;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var sort_service_1 = __webpack_require__(97);
	var SortPipe = (function () {
	    function SortPipe(_sortService) {
	        this._sortService = _sortService;
	    }
	    SortPipe.prototype.transform = function (value, args, desc) {
	        var returned = this._sortService.sortArray(value, args, desc);
	        return returned;
	    };
	    SortPipe = __decorate([
	        core_1.Pipe({
	            name: 'sort'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sort_service_1.SortService !== 'undefined' && sort_service_1.SortService) === 'function' && _a) || Object])
	    ], SortPipe);
	    return SortPipe;
	    var _a;
	}());
	exports.SortPipe = SortPipe;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SortService = (function () {
	    function SortService() {
	    }
	    SortService.prototype.sortArray = function (list, args, desc) {
	        var _this = this;
	        if (!list || !list.sort) {
	            return list;
	        }
	        var a2;
	        var b2;
	        var tt;
	        var attrSplit;
	        return list.sort(function (a, b) {
	            for (var key in args) {
	                attrSplit = args[key].split(".");
	                a2 = a;
	                b2 = b;
	                for (var keyY in attrSplit) {
	                    tt = a2[attrSplit[keyY]];
	                    if (tt) {
	                        a2 = tt;
	                    }
	                    tt = b2[attrSplit[keyY]];
	                    if (tt) {
	                        b2 = tt;
	                    }
	                }
	            }
	            if (typeof a2 === 'string') {
	                var itemA = a2.toLowerCase();
	                var itemB = b2.toLowerCase();
	                itemA = _this.removeAccents(itemA);
	                itemB = _this.removeAccents(itemB);
	                if (desc) {
	                    //decrescente
	                    if (itemA > itemB) {
	                        return -1;
	                    }
	                    if (itemA < itemB) {
	                        return 1;
	                    }
	                }
	                else {
	                    if (itemA < itemB) {
	                        return -1;
	                    }
	                    if (itemA > itemB) {
	                        return 1;
	                    }
	                }
	            }
	            return 0;
	        });
	    };
	    SortService.prototype.removeAccents = function (value) {
	        return value
	            .replace(/á/g, 'a')
	            .replace(/â/g, 'a')
	            .replace(/à/g, 'a')
	            .replace(/ã/g, 'a')
	            .replace(/é/g, 'e')
	            .replace(/è/g, 'e')
	            .replace(/ê/g, 'e')
	            .replace(/í/g, 'i')
	            .replace(/ì/g, 'i')
	            .replace(/î/g, 'i')
	            .replace(/ó/g, 'o')
	            .replace(/ò/g, 'o')
	            .replace(/ô/g, 'o')
	            .replace(/õ/g, 'o')
	            .replace(/ú/g, 'u')
	            .replace(/ù/g, 'u')
	            .replace(/û/g, 'u')
	            .replace(/ç/g, 'c');
	    };
	    SortService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], SortService);
	    return SortService;
	}());
	exports.SortService = SortService;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PhoneMaskPipe = (function () {
	    function PhoneMaskPipe() {
	    }
	    PhoneMaskPipe.prototype.transform = function (value, args) {
	        if (value) {
	            value = value.replace(/\D/g, '');
	            if (value.length >= 10) {
	                var phone = [];
	                phone.push(value.slice(0, 2));
	                if (value.length === 10) {
	                    phone.push(value.slice(2, 6));
	                    phone.push(value.slice(6, 10));
	                }
	                else {
	                    phone.push(value.slice(2, 7));
	                    phone.push(value.slice(7, 11));
	                }
	                value = '(' + phone[0] + ') ' + phone[1] + '-' + phone[2];
	            }
	            return value;
	        }
	    };
	    PhoneMaskPipe = __decorate([
	        core_1.Pipe({
	            name: 'phoneMask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PhoneMaskPipe);
	    return PhoneMaskPipe;
	}());
	exports.PhoneMaskPipe = PhoneMaskPipe;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CapitalizePipe = (function () {
	    function CapitalizePipe() {
	    }
	    CapitalizePipe.prototype.transform = function (value, args) {
	        if (value) {
	            return value.charAt(0).toUpperCase() + value.slice(1);
	        }
	        return value;
	    };
	    CapitalizePipe = __decorate([
	        core_1.Pipe({
	            name: 'capitalize'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CapitalizePipe);
	    return CapitalizePipe;
	}());
	exports.CapitalizePipe = CapitalizePipe;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var autocomplete_service_1 = __webpack_require__(101);
	var AutoCompleteComponent = (function () {
	    function AutoCompleteComponent(_restService, _autocompleteService) {
	        this._restService = _restService;
	        this._autocompleteService = _autocompleteService;
	        this.isRequired = true;
	        this.isDisabled = false;
	        this.isCreateNew = true;
	        this.submitted = false;
	        this.delay = false;
	        this.clear = false;
	        this.placeholder = '— Selecione —';
	        this.apiCustom = '/listar';
	        this.method = 'POST';
	        this.setObejct = new core_1.EventEmitter();
	        this.clearObject = new core_1.EventEmitter();
	        this.processIn = (function (params) {
	            if (!params.term) {
	                params.term = '';
	            }
	            var newQuery = JSON.stringify(this.query);
	            newQuery = newQuery.replace(/REPLACEHERE/g, params.term);
	            newQuery = JSON.parse(newQuery);
	            var ObjectIn = newQuery;
	            return ObjectIn;
	        }.bind(this));
	        this.processOut = (function (ResponseResultFind) {
	            var processOutResults = this.processOutResults;
	            var hasTemplate = this.templateResult;
	            var ObjectOut;
	            if (!hasTemplate) {
	                ObjectOut = processOutResults(ResponseResultFind, this.terms);
	            }
	            else {
	                ObjectOut = ResponseResultFind;
	            }
	            return ObjectOut;
	        }.bind(this));
	        this.processData = (function (params) {
	            var ObjectSend = this.processIn(params);
	            var filter = JSON.stringify(ObjectSend);
	            return filter;
	        }.bind(this));
	        this.processResults = (function (ResultFind, Params) {
	            var ResponseResultFind = ResultFind;
	            Params.page = Params.page || 1;
	            var Items = [];
	            var indiceResult;
	            var lengthResult;
	            for (indiceResult = 0, lengthResult = ResponseResultFind.length; indiceResult < lengthResult; indiceResult++) {
	                var Item = this.processOut(ResponseResultFind[indiceResult]);
	                Items.push(Item);
	            }
	            var text = "";
	            if (Params.term) {
	                text = Params.term;
	            }
	            if (this.isCreateNew) {
	                Items.push({ id: -1, text: text });
	            }
	            else {
	                if (Items.length === 0) {
	                    Items.push({ id: -1, text: 'Nenhum item encontrado' });
	                }
	                else {
	                    Items.push({ id: -1, text: '' });
	                }
	            }
	            return {
	                results: Items,
	                pagination: {
	                    more: (Params.page * 30) < lengthResult
	                }
	            };
	        }.bind(this));
	        this.onchangeSelect = (function ($event) {
	            if ($event.params) {
	                var thisValue = $event.params.data;
	                if (thisValue.id) {
	                    if (thisValue.id === -1) {
	                        this.model = { novo: true, text: thisValue.text };
	                    }
	                    else {
	                        if (this.templateResult) {
	                            //se tiver um template result
	                            this.model = thisValue;
	                        }
	                        else {
	                            //se for text/id
	                            this.model = { id: thisValue.id, text: thisValue.text };
	                        }
	                    }
	                }
	                else {
	                    this.model = null;
	                }
	                this.setObejct.next(this.model);
	            }
	        }.bind(this));
	        this.onOpenSelect = (function ($event) {
	            setTimeout(function () {
	                var element = document.getElementById("select2-newElement");
	                if (!element) {
	                    var div = document.createElement("DIV");
	                    div.id = "select2-newElement";
	                    $(".select2-results").append(div);
	                }
	            });
	        }.bind(this));
	        this.templateList = (function (state) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (!this.isCreateNew) {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                }
	                else {
	                    text = state.text;
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    AutoCompleteComponent.prototype.ngOnInit = function () {
	        if (this.fieldToShow) {
	            this.terms = this.fieldToShow.split(",");
	        }
	        var select2;
	        if (this.delay) {
	            setTimeout(function () {
	                select2 = $("#" + this.selectId + " select");
	                this.createSelect2(select2);
	            }.bind(this));
	        }
	        else {
	            select2 = $("#" + this.selectId + " select");
	            this.createSelect2(select2);
	        }
	    };
	    AutoCompleteComponent.prototype.ngDoCheck = function () {
	    };
	    AutoCompleteComponent.prototype.createSelect2 = function (select2) {
	        this.autocomplete(select2);
	        select2.on('select2:select', function (evt) {
	            this.onchangeSelect(evt);
	        }.bind(this));
	        select2.on('select2:open', function (evt) {
	            this.onOpenSelect(evt);
	        }.bind(this));
	        select2.on('select2:unselect', function (evt) {
	            this.clearObject.next({});
	            select2.select2("close");
	        }.bind(this));
	    };
	    AutoCompleteComponent.prototype.autocomplete = function (inputElement) {
	        var route, Ajax;
	        route = this._service.onGetApiUrl();
	        Ajax = this._restService.getAutocompleteAjax(route, this.apiCustom, this.method);
	        Ajax.data = this.processData;
	        Ajax.processResults = this.processResults;
	        var OptionsSelect2 = {
	            ajax: Ajax
	        };
	        this.createOption2(OptionsSelect2, inputElement);
	    };
	    AutoCompleteComponent.prototype.processOutResults = function (ResultObject, fieldShow) {
	        var ObjectOut = {
	            id: ResultObject.id
	        };
	        var text = "";
	        var term1;
	        var term2;
	        var termSplit;
	        for (var key in fieldShow) {
	            termSplit = fieldShow[key].split(".");
	            term1 = ResultObject;
	            for (var keyY in termSplit) {
	                term2 = term1[termSplit[keyY]];
	                if (term2) {
	                    term1 = term2;
	                }
	            }
	            if (text && (key < fieldShow.length)) {
	                text = text.concat(" / ");
	            }
	            text = text.concat(term1);
	        }
	        ObjectOut.text = text;
	        return ObjectOut;
	    };
	    AutoCompleteComponent.prototype.createOption2 = function (OptionsSelect2, inputElement) {
	        if (this.templateResult) {
	            OptionsSelect2.templateResult = this.templateResult;
	            OptionsSelect2.templateSelection = this.templateResult;
	        }
	        else {
	            OptionsSelect2.templateResult = this.templateList;
	            OptionsSelect2.templateSelection = this.templateList;
	        }
	        if (this.placeholder) {
	            OptionsSelect2.placeholder = this.placeholder;
	        }
	        if (this.clear) {
	            OptionsSelect2.allowClear = true;
	        }
	        inputElement.select2(OptionsSelect2);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteComponent.prototype, "isRequired", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteComponent.prototype, "isDisabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteComponent.prototype, "isCreateNew", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteComponent.prototype, "submitted", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteComponent.prototype, "delay", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteComponent.prototype, "clear", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteComponent.prototype, "selectId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteComponent.prototype, "fieldToShow", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteComponent.prototype, "placeholder", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteComponent.prototype, "apiCustom", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteComponent.prototype, "method", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AutoCompleteComponent.prototype, "model", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AutoCompleteComponent.prototype, "_service", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AutoCompleteComponent.prototype, "query", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AutoCompleteComponent.prototype, "templateResult", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AutoCompleteComponent.prototype, "templateSelection", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], AutoCompleteComponent.prototype, "setObejct", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_b = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _b) || Object)
	    ], AutoCompleteComponent.prototype, "clearObject", void 0);
	    AutoCompleteComponent = __decorate([
	        core_1.Component({
	            selector: 'autocomplete-component',
	            template: __webpack_require__(102)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _c) || Object, (typeof (_d = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _d) || Object])
	    ], AutoCompleteComponent);
	    return AutoCompleteComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AutoCompleteComponent = AutoCompleteComponent;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AutoCompleteService = (function () {
	    function AutoCompleteService() {
	    }
	    AutoCompleteService.prototype.createOptionOnSelect2 = function (selectId, optionToSet) {
	        var option = document.createElement("OPTION");
	        option.setAttribute("value", optionToSet.id);
	        var text = document.createTextNode(optionToSet.text);
	        option.appendChild(text);
	        var element = document.getElementById(selectId);
	        if (element) {
	            element.appendChild(option);
	        }
	        $("#" + selectId + " select").append(option);
	    };
	    AutoCompleteService.prototype.setValueOnSelect2 = function (value, selectedId) {
	        var select = $("#" + selectedId + " select");
	        select.val(value).trigger("change");
	    };
	    AutoCompleteService.prototype.setNewTagInList = function (state) {
	        var text;
	        if (state.text === "") {
	            text = "Criar novo";
	        }
	        else {
	            text = "<b>\"" + state.text + "\"</b> (criar novo)";
	        }
	        return $('<span class="last_item_select2"> ' + text + '</span>');
	    };
	    AutoCompleteService.prototype.setNoCreateNew = function (text) {
	        return $('<span class="last_item_select2 not_link">' + text + '</span>');
	    };
	    AutoCompleteService.prototype.getTextSelect2 = function (obj, att) {
	        var text = '';
	        if (obj) {
	            text = obj.text;
	            if (obj[att]) {
	                text = obj[att];
	            }
	        }
	        return text;
	    };
	    //storage
	    AutoCompleteService.prototype.setSessionStorage = function (item, module) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem('autocomplete-new-' + module, object);
	    };
	    AutoCompleteService.prototype.getSessionStorage = function (module) {
	        var item = sessionStorage.getItem("autocomplete-new-" + module);
	        return JSON.parse(item);
	    };
	    AutoCompleteService.prototype.clearSessionStorage = function (module) {
	        sessionStorage.removeItem("autocomplete-new-" + module);
	    };
	    AutoCompleteService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], AutoCompleteService);
	    return AutoCompleteService;
	}());
	exports.AutoCompleteService = AutoCompleteService;


/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = "<div [ngClass]=\"{'geo-input--error': (!model.id && isRequired && submitted)}\" style=\"margin-top: 0;\">\n    <label>{{label}} <abbr *ngIf=\"isRequired\">*</abbr></label>\n    <div>\n        <span class=\"error-alert\" *ngIf=\"(!model.id && isRequired && submitted)\">Este campo é obrigatório.</span>\n        <select class=\"select2\" [disabled]=\"isDisabled\" [(ngModel)]=\"model\" ></select>\n    </div>\n</div>\n";

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var DatepickerDirective = (function () {
	    function DatepickerDirective(model, el) {
	        this.model = model;
	        this.el = el;
	    }
	    DatepickerDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    DatepickerDirective.prototype.modelValue = function () {
	        var scope = this.model;
	        var elementId = this.el.nativeElement.id;
	        $("#" + elementId).datepicker({
	            onSelect: function (dateText) {
	                scope.valueAccessor.onChange(dateText);
	            }
	        });
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], DatepickerDirective.prototype, "ngModelChange", null);
	    DatepickerDirective = __decorate([
	        core_1.Directive({
	            selector: '[appDatepicker]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object, (typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object])
	    ], DatepickerDirective);
	    return DatepickerDirective;
	    var _a, _b;
	}());
	exports.DatepickerDirective = DatepickerDirective;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var CepMaskDirective = (function () {
	    function CepMaskDirective(model) {
	        this.model = model;
	    }
	    CepMaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    CepMaskDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    CepMaskDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    CepMaskDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model.replace(/\D/g, '');
	            if (backspace) {
	                if (newVal.length === 2) {
	                    newVal = newVal.substring(0, newVal.length - 1);
	                }
	            }
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else {
	                newVal = newVal.replace(/(\d{5})(\d{0})/, "$1-$2");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CepMaskDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CepMaskDirective.prototype, "onKeyDownBackspace", null);
	    CepMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[appCepMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], CepMaskDirective);
	    return CepMaskDirective;
	    var _a;
	}());
	exports.CepMaskDirective = CepMaskDirective;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var NumberIntegerDirective = (function () {
	    function NumberIntegerDirective(model) {
	        this.model = model;
	    }
	    NumberIntegerDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    NumberIntegerDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    NumberIntegerDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    NumberIntegerDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model.replace(/\D/g, '');
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else {
	                newVal = newVal.replace('/[^0-9]/', '');
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], NumberIntegerDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], NumberIntegerDirective.prototype, "onKeyDownBackspace", null);
	    NumberIntegerDirective = __decorate([
	        core_1.Directive({
	            selector: '[appNumberInteger]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], NumberIntegerDirective);
	    return NumberIntegerDirective;
	    var _a;
	}());
	exports.NumberIntegerDirective = NumberIntegerDirective;


/***/ },
/* 106 */
/***/ function(module, exports) {

	"use strict";
	var CnpjValidator = (function () {
	    function CnpjValidator() {
	    }
	    CnpjValidator.cnpjFormat = function (item) {
	        var CNPJ_REGEXP;
	        if (item.value) {
	            var tt = item.value.replace(/[^0-9]/gi, '');
	            CNPJ_REGEXP = /([0-9]{14})/;
	            if (item.value && !CNPJ_REGEXP.test(tt)) {
	                return { "incorrectCnpjFormat": true };
	            }
	        }
	        return null;
	    };
	    return CnpjValidator;
	}());
	exports.CnpjValidator = CnpjValidator;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var CnpjMaskDirective = (function () {
	    function CnpjMaskDirective(model) {
	        this.model = model;
	    }
	    CnpjMaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    CnpjMaskDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    CnpjMaskDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    CnpjMaskDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model.replace(/\D/g, '');
	            if (backspace) {
	                if (newVal.length === 2) {
	                    newVal = newVal.substring(0, newVal.length - 1);
	                }
	            }
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else if (newVal.length === 2) {
	                newVal = newVal.replace(/(\d{2})/, "$1.");
	            }
	            else if (newVal.length <= 5) {
	                newVal = newVal.replace(/(\d{2})(\d{0,3})/, "$1.$2");
	            }
	            else if (newVal.length <= 8) {
	                newVal = newVal.replace(/(\d{2})(\d{0,3})(\d{0,3})/, "$1.$2.$3");
	            }
	            else if (newVal.length <= 12) {
	                newVal = newVal.replace(/(\d{2})(\d{0,3})(\d{0,3})(\d{0,4})/, "$1.$2.$3/$4");
	            }
	            else if (newVal.length <= 14) {
	                newVal = newVal.replace(/(\d{2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, "$1.$2.$3/$4-$5");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CnpjMaskDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CnpjMaskDirective.prototype, "onKeyDownBackspace", null);
	    CnpjMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[appCnpjMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], CnpjMaskDirective);
	    return CnpjMaskDirective;
	    var _a;
	}());
	exports.CnpjMaskDirective = CnpjMaskDirective;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CnpjMaskPipe = (function () {
	    function CnpjMaskPipe() {
	    }
	    CnpjMaskPipe.prototype.transform = function (value, args) {
	        if (value) {
	            value = value.replace(/\D/g, '');
	            if (value.length === 14) {
	                value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
	            }
	            return value;
	        }
	    };
	    CnpjMaskPipe = __decorate([
	        core_1.Pipe({
	            name: 'cnpjMask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CnpjMaskPipe);
	    return CnpjMaskPipe;
	}());
	exports.CnpjMaskPipe = CnpjMaskPipe;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LicensePlateMaskPipe = (function () {
	    function LicensePlateMaskPipe() {
	    }
	    LicensePlateMaskPipe.prototype.transform = function (value, args) {
	        if (value) {
	            if (value.length === 7) {
	                var x1 = value.slice(0, 3);
	                var x2 = value.slice(3, value.length);
	                value = x1 + "-" + x2;
	            }
	            return value;
	        }
	    };
	    LicensePlateMaskPipe = __decorate([
	        core_1.Pipe({
	            name: 'licensePlateMask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LicensePlateMaskPipe);
	    return LicensePlateMaskPipe;
	}());
	exports.LicensePlateMaskPipe = LicensePlateMaskPipe;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var LicensePlateMaskDirective = (function () {
	    function LicensePlateMaskDirective(model) {
	        this.model = model;
	    }
	    LicensePlateMaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    LicensePlateMaskDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    LicensePlateMaskDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    LicensePlateMaskDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model;
	            if (backspace) {
	                if (newVal.length === 2) {
	                    newVal = newVal.substring(0, newVal.length - 1);
	                }
	            }
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else if (newVal.length <= 3) {
	                newVal = this.testWord(newVal);
	                newVal = newVal.toUpperCase();
	            }
	            else if (newVal.length <= 8) {
	                newVal.replace('-', '');
	                var x1 = newVal.slice(0, 3);
	                var x2 = newVal.slice(3, newVal.length);
	                x1 = this.testWord(x1);
	                x2 = this.testNumber(x2);
	                newVal = x1.concat(x2);
	                newVal = newVal.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    LicensePlateMaskDirective.prototype.testWord = function (word) {
	        word = word.replace(/[^a-zA-Z]+/, '');
	        word = word.replace(/(\w{0,3})/, "$1");
	        return word;
	    };
	    LicensePlateMaskDirective.prototype.testNumber = function (numb) {
	        numb = numb.replace(/\D/g, '');
	        numb = numb.replace(/(\d{0,4})/, "$1");
	        return numb;
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], LicensePlateMaskDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], LicensePlateMaskDirective.prototype, "onKeyDownBackspace", null);
	    LicensePlateMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[appLicensePlateMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], LicensePlateMaskDirective);
	    return LicensePlateMaskDirective;
	    var _a;
	}());
	exports.LicensePlateMaskDirective = LicensePlateMaskDirective;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var GroupByService = (function () {
	    function GroupByService() {
	    }
	    GroupByService.prototype.groupBy = function (collection, term, returnRepeated) {
	        var _this = this;
	        var newValue = [];
	        if (returnRepeated) {
	            /*para retornar o group com key value e uma lista com os repetidos*/
	            var _loop_1 = function(i) {
	                var termObject = term.split(".");
	                var val = this_1.deepFind(collection[i], termObject[0]);
	                var keyVal = this_1.deepFind(collection[i], term);
	                var index = newValue.findIndex(function (myObj) { return myObj.key == keyVal; });
	                if (index >= 0) {
	                    newValue[index].items.push(collection[i]);
	                }
	                else {
	                    newValue.push({ key: keyVal, value: val, items: [collection[i]] });
	                }
	            };
	            var this_1 = this;
	            for (var i = 0; i < collection.length; i++) {
	                _loop_1(i);
	            }
	        }
	        else {
	            var _loop_2 = function(i) {
	                var keyVal = this_2.deepFind(collection[i], term);
	                var index = newValue.findIndex(function (myObj) { return _this.deepFind(myObj, term) == keyVal; });
	                if (index === -1) {
	                    newValue.push(collection[i]);
	                }
	            };
	            var this_2 = this;
	            for (var i = 0; i < collection.length; i++) {
	                _loop_2(i);
	            }
	        }
	        return newValue;
	    };
	    GroupByService.prototype.deepFind = function (obj, path) {
	        var paths = path.toString().split(/[\.\[\]]/);
	        var current = obj;
	        for (var i = 0; i < paths.length; ++i) {
	            if (paths[i] !== "") {
	                if (current[paths[i]] == undefined) {
	                    return undefined;
	                }
	                else {
	                    current = current[paths[i]];
	                }
	            }
	        }
	        return current;
	    };
	    GroupByService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], GroupByService);
	    return GroupByService;
	}());
	exports.GroupByService = GroupByService;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CurrencyMaskPipe = (function () {
	    function CurrencyMaskPipe() {
	    }
	    CurrencyMaskPipe.prototype.transform = function (value, args) {
	        if (value) {
	            var formatted = '', x, lenX, newVal = value;
	            if (!newVal) {
	                newVal = 0;
	            }
	            if (typeof newVal == 'number') {
	                newVal = newVal.toFixed(2);
	            }
	            newVal = newVal.toString();
	            var point = newVal.indexOf(".");
	            if (point === -1) {
	                newVal = newVal + '00';
	            }
	            else {
	                var afterPoint = newVal.slice(point + 1, newVal.length);
	                if (afterPoint.length < 2) {
	                    newVal = newVal + '0';
	                }
	            }
	            newVal = newVal.replace(".", "");
	            if (newVal.length == 2)
	                newVal = '0' + newVal;
	            if (newVal.length == 1)
	                newVal = '00' + newVal;
	            for (x = 0, lenX = newVal.length; x < lenX; x++) {
	                var sep = '';
	                if (x == 2)
	                    sep = ',';
	                if (x > 3 && (x + 1) % 3 == 0)
	                    sep = '.';
	                formatted = newVal.substring(newVal.length - 1 - x, newVal.length - x) + sep + formatted;
	            }
	            newVal = formatted;
	            return "R$ " + newVal;
	        }
	    };
	    CurrencyMaskPipe = __decorate([
	        core_1.Pipe({
	            name: 'currencyMask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CurrencyMaskPipe);
	    return CurrencyMaskPipe;
	}());
	exports.CurrencyMaskPipe = CurrencyMaskPipe;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var FilterNumberPipe = (function () {
	    function FilterNumberPipe() {
	    }
	    FilterNumberPipe.prototype.transform = function (list, args, attr) {
	        if (!list)
	            return false;
	        var attrSplit;
	        var item2;
	        var tt;
	        var filter;
	        filter = list.filter(function (item) {
	            if (!args) {
	                return item;
	            }
	            for (var key in attr) {
	                attrSplit = attr[key].split(".");
	                item2 = item;
	                for (var keyY in attrSplit) {
	                    tt = item2[attrSplit[keyY]];
	                    if (tt) {
	                        item2 = tt;
	                    }
	                }
	                if (item2 == args) {
	                    return item;
	                }
	            }
	        });
	        return filter ? filter : list;
	    };
	    FilterNumberPipe = __decorate([
	        core_1.Pipe({
	            name: 'filterNumber',
	            pure: false
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FilterNumberPipe);
	    return FilterNumberPipe;
	}());
	exports.FilterNumberPipe = FilterNumberPipe;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var CurrencyMaskDirective = (function () {
	    function CurrencyMaskDirective(model) {
	        this.model = model;
	    }
	    CurrencyMaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    CurrencyMaskDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    CurrencyMaskDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    CurrencyMaskDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var start = this.isStart;
	            var newVal = model; //.replace(/\D/g, '');
	            // if (backspace) {
	            //   if(newVal.length){
	            //     newVal = newVal.substring(0, newVal.length - 1);
	            //   }
	            // }
	            var formatted = '', x, lenX;
	            if (!newVal) {
	                newVal = 0;
	            }
	            else {
	                newVal = newVal.toString();
	                if (start) {
	                    var point = newVal.indexOf(".");
	                    if (point === -1) {
	                        newVal = newVal + '00';
	                    }
	                    else {
	                        var afterPoint = newVal.slice(point + 1, newVal.length);
	                        if (afterPoint.length < 2) {
	                            newVal = newVal + '0';
	                        }
	                    }
	                    newVal = newVal.replace(".", "");
	                }
	                else {
	                    newVal = newVal.replace(/\D/g, '').replace(/\./g, '').replace(/,/g, '').replace(/^0+/, '');
	                }
	                if (newVal.length == 2)
	                    newVal = '0' + newVal;
	                if (newVal.length == 1)
	                    newVal = '00' + newVal;
	                for (x = 0, lenX = newVal.length; x < lenX; x++) {
	                    var sep = '';
	                    if (x == 2)
	                        sep = ',';
	                    if (x > 3 && (x + 1) % 3 == 0)
	                        sep = '.';
	                    formatted = newVal.substring(newVal.length - 1 - x, newVal.length - x) + sep + formatted;
	                }
	                newVal = formatted;
	                if (!newVal) {
	                    newVal = 0;
	                }
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.Input('appCurrencyMask'), 
	        __metadata('design:type', Boolean)
	    ], CurrencyMaskDirective.prototype, "isStart", void 0);
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CurrencyMaskDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CurrencyMaskDirective.prototype, "onKeyDownBackspace", null);
	    CurrencyMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[appCurrencyMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], CurrencyMaskDirective);
	    return CurrencyMaskDirective;
	    var _a;
	}());
	exports.CurrencyMaskDirective = CurrencyMaskDirective;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var CpfMaskDirective = (function () {
	    function CpfMaskDirective(model) {
	        this.model = model;
	    }
	    CpfMaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    CpfMaskDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    CpfMaskDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    CpfMaskDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model.replace(/\D/g, '');
	            if (backspace) {
	                if (newVal.length === 3) {
	                    newVal = newVal.substring(0, newVal.length - 1);
	                }
	            }
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else if (newVal.length === 3) {
	                newVal = newVal.replace(/(\d{3})/, "$1.");
	            }
	            else if (newVal.length <= 6) {
	                newVal = newVal.replace(/(\d{3})(\d{0,3})/, "$1.$2");
	            }
	            else if (newVal.length <= 9) {
	                newVal = newVal.replace(/(\d{3})(\d{0,3})(\d{0,3})/, "$1.$2.$3");
	            }
	            else if (newVal.length <= 11) {
	                newVal = newVal.replace(/(\d{3})(\d{0,3})(\d{0,3})(\d{0,2})/, "$1.$2.$3-$4");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CpfMaskDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CpfMaskDirective.prototype, "onKeyDownBackspace", null);
	    CpfMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[appCpfMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], CpfMaskDirective);
	    return CpfMaskDirective;
	    var _a;
	}());
	exports.CpfMaskDirective = CpfMaskDirective;


/***/ },
/* 116 */
/***/ function(module, exports) {

	"use strict";
	var CpfValidator = (function () {
	    function CpfValidator() {
	    }
	    CpfValidator.cpfFormat = function (item) {
	        var CPF_REGEXP;
	        if (item.value) {
	            var tt = item.value.replace(/[^0-9]/gi, '');
	            CPF_REGEXP = /([0-9]{11})/;
	            if (item.value && !CPF_REGEXP.test(tt)) {
	                return { "incorrectCpfFormat": true };
	            }
	        }
	        return null;
	    };
	    return CpfValidator;
	}());
	exports.CpfValidator = CpfValidator;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CpfMaskPipe = (function () {
	    function CpfMaskPipe() {
	    }
	    CpfMaskPipe.prototype.transform = function (value, args) {
	        if (value) {
	            value = value.replace(/\D/g, '');
	            if (value.length === 11) {
	                value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
	            }
	            return value;
	        }
	    };
	    CpfMaskPipe = __decorate([
	        core_1.Pipe({
	            name: 'cpfMask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CpfMaskPipe);
	    return CpfMaskPipe;
	}());
	exports.CpfMaskPipe = CpfMaskPipe;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var autocomplete_insert_service_1 = __webpack_require__(119);
	var AutoCompleteInsertComponent = (function () {
	    function AutoCompleteInsertComponent(_restService, _autocompleteService) {
	        this._restService = _restService;
	        this._autocompleteService = _autocompleteService;
	        this.isRequired = true;
	        this.isDisabled = false;
	        this.submitted = false;
	        this.clear = false;
	        this.apiCustom = '/listar';
	        this.placeholder = '— Selecione —';
	        this.loading = false;
	        this.setObejct = new core_1.EventEmitter();
	        this.clearObject = new core_1.EventEmitter();
	        this.processIn = (function (params) {
	            var ObjectIn;
	            if (!params.term) {
	                params.term = '';
	            }
	            var newQuery = JSON.stringify(this.query);
	            newQuery = newQuery.replace(/REPLACEHERE/g, params.term);
	            newQuery = JSON.parse(newQuery);
	            ObjectIn = newQuery;
	            return ObjectIn;
	        }.bind(this));
	        this.processOut = (function (ResponseResultFind) {
	            var processOutResults = this.processOutResults;
	            var ObjectOut;
	            ObjectOut = processOutResults(ResponseResultFind, this.fieldToShow);
	            return ObjectOut;
	        }.bind(this));
	        this.processData = (function (params) {
	            var ObjectSend = this.processIn(params);
	            var filter = JSON.stringify(ObjectSend);
	            return filter;
	        }.bind(this));
	        this.processResults = (function (ResultFind, Params) {
	            var ResponseResultFind = ResultFind;
	            Params.page = Params.page || 1;
	            var Items = [];
	            var indiceResult;
	            var lengthResult;
	            for (indiceResult = 0, lengthResult = ResponseResultFind.length; indiceResult < lengthResult; indiceResult++) {
	                var Item = this.processOut(ResponseResultFind[indiceResult]);
	                Items.push(Item);
	            }
	            var text = "";
	            if (Params.term) {
	                text = Params.term;
	            }
	            //add a linha de para criar novo
	            Items.push({ id: -1, text: text });
	            return {
	                results: Items,
	                pagination: {
	                    more: (Params.page * 30) < lengthResult
	                }
	            };
	        }.bind(this));
	        this.onchangeSelect = (function ($event) {
	            if ($event.params) {
	                var thisValue = $event.params.data;
	                if (thisValue.id) {
	                    if (thisValue.id === -1) {
	                        this.model = { novo: true, text: thisValue.text };
	                    }
	                    else {
	                        //se for text/id
	                        this.model = { id: thisValue.id, text: thisValue.text };
	                    }
	                }
	                else {
	                    this.model = null;
	                }
	                this.setObejct.next(this.model);
	            }
	        }.bind(this));
	        this.onOpenSelect = (function ($event) {
	            setTimeout(function () {
	                var element = document.getElementById("select2-insertElement");
	                if (!element) {
	                    var div = document.createElement("DIV");
	                    div.id = "select2-insertElement";
	                    $(".select2-results").append(div);
	                }
	            });
	        }.bind(this));
	        this.templateList = (function (state) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    stateReturn = this._autocompleteService.setNewTagInList(state);
	                }
	                else {
	                    text = state.text;
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    AutoCompleteInsertComponent.prototype.ngOnInit = function () {
	        var select2;
	        select2 = $("#" + this.selectId + " select");
	        this.createSelect2(select2);
	    };
	    AutoCompleteInsertComponent.prototype.createSelect2 = function (select2) {
	        this.autocomplete(select2);
	        select2.on('select2:select', function (evt) {
	            this.onchangeSelect(evt);
	        }.bind(this));
	        select2.on('select2:open', function (evt) {
	            this.onOpenSelect(evt);
	        }.bind(this));
	        select2.on('select2:unselect', function (evt) {
	            this.clearObject.next({});
	            select2.select2("close");
	        }.bind(this));
	    };
	    AutoCompleteInsertComponent.prototype.autocomplete = function (inputElement) {
	        var route, Ajax;
	        route = this._service.onGetApiUrl();
	        Ajax = this._restService.getAutocompleteAjax(route, this.apiCustom);
	        Ajax.data = this.processData;
	        Ajax.processResults = this.processResults;
	        var OptionsSelect2 = {
	            ajax: Ajax
	        };
	        this.createOption2(OptionsSelect2, inputElement);
	    };
	    AutoCompleteInsertComponent.prototype.processOutResults = function (ResultObject, fieldShow) {
	        var ObjectOut = {
	            id: ResultObject.id
	        };
	        ObjectOut.text = ResultObject[fieldShow];
	        return ObjectOut;
	    };
	    AutoCompleteInsertComponent.prototype.createOption2 = function (OptionsSelect2, inputElement) {
	        OptionsSelect2.templateResult = this.templateList;
	        OptionsSelect2.templateSelection = this.templateList;
	        if (this.placeholder) {
	            OptionsSelect2.placeholder = this.placeholder;
	        }
	        if (this.clear) {
	            OptionsSelect2.allowClear = true;
	        }
	        inputElement.select2(OptionsSelect2);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteInsertComponent.prototype, "isRequired", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteInsertComponent.prototype, "isDisabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteInsertComponent.prototype, "submitted", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteInsertComponent.prototype, "clear", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteInsertComponent.prototype, "selectId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteInsertComponent.prototype, "apiCustom", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteInsertComponent.prototype, "placeholder", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteInsertComponent.prototype, "fieldToShow", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], AutoCompleteInsertComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AutoCompleteInsertComponent.prototype, "model", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AutoCompleteInsertComponent.prototype, "query", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], AutoCompleteInsertComponent.prototype, "_service", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AutoCompleteInsertComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], AutoCompleteInsertComponent.prototype, "setObejct", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_b = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _b) || Object)
	    ], AutoCompleteInsertComponent.prototype, "clearObject", void 0);
	    AutoCompleteInsertComponent = __decorate([
	        core_1.Component({
	            selector: 'autocomplete-insert-component',
	            template: __webpack_require__(120),
	            styles: [__webpack_require__(121)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _c) || Object, (typeof (_d = typeof autocomplete_insert_service_1.AutoCompleteInsertService !== 'undefined' && autocomplete_insert_service_1.AutoCompleteInsertService) === 'function' && _d) || Object])
	    ], AutoCompleteInsertComponent);
	    return AutoCompleteInsertComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AutoCompleteInsertComponent = AutoCompleteInsertComponent;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AutoCompleteInsertService = (function () {
	    function AutoCompleteInsertService() {
	    }
	    AutoCompleteInsertService.prototype.createOptionOnSelect2 = function (selectId, optionToSet) {
	        var option = document.createElement("OPTION");
	        option.setAttribute("value", optionToSet.id);
	        var text = document.createTextNode(optionToSet.text);
	        option.appendChild(text);
	        var element = document.getElementById(selectId);
	        if (element) {
	            element.appendChild(option);
	        }
	        $("#" + selectId + " select").append(option);
	    };
	    AutoCompleteInsertService.prototype.setValueOnSelect2 = function (value, selectedId) {
	        var select = $("#" + selectedId + " select");
	        select.val(value).trigger("change");
	    };
	    AutoCompleteInsertService.prototype.setNewTagInList = function (state) {
	        var text;
	        if (state.text === "") {
	            text = "Digite o valor para adicionar à lista";
	        }
	        else {
	            text = "Inserir <b>\"" + state.text + "\"</b>";
	        }
	        return $('<span class="last_item_select2"> ' + text + '</span>');
	    };
	    AutoCompleteInsertService.prototype.getTextSelect2 = function (obj, att) {
	        var text = obj.text;
	        if (obj[att]) {
	            text = obj[att];
	        }
	        return text;
	    };
	    //storage
	    AutoCompleteInsertService.prototype.setSessionStorage = function (item, module) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem('autocomplete-insert-' + module, object);
	    };
	    AutoCompleteInsertService.prototype.getSessionStorage = function (module) {
	        var item = sessionStorage.getItem("autocomplete-insert-" + module);
	        return JSON.parse(item);
	    };
	    AutoCompleteInsertService.prototype.clearSessionStorage = function (module) {
	        sessionStorage.removeItem("autocomplete-insert-" + module);
	    };
	    AutoCompleteInsertService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], AutoCompleteInsertService);
	    return AutoCompleteInsertService;
	}());
	exports.AutoCompleteInsertService = AutoCompleteInsertService;


/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = "<div [ngClass]=\"{'geo-input--error': (!model.id && isRequired && submitted)}\" style=\"margin-top: 0;\">\n    <label>{{label}} <abbr *ngIf=\"isRequired\">*</abbr></label>\n    <div class=\"containerSelect\">\n        <span class=\"error-alert\" *ngIf=\"(!model.id && isRequired && submitted)\">Este campo é obrigatório.</span>\n        <select class=\"select2\" [(ngModel)]=\"model\" ></select>\n        <spinner-component *ngIf=\"loading\"></spinner-component>\n    </div>\n</div>\n";

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = ".containerSelect {\n  position: relative;\n}\n\nspinner-component {\n  position: absolute;\n  top: -5px;\n  right: 12px;\n}\n"

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SpinnerComponent = (function () {
	    function SpinnerComponent() {
	        this.showDisplay = false;
	    }
	    SpinnerComponent.prototype.ngOnInit = function () { };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], SpinnerComponent.prototype, "showDisplay", void 0);
	    SpinnerComponent = __decorate([
	        core_1.Component({
	            selector: 'spinner-component',
	            template: __webpack_require__(123),
	            styles: [__webpack_require__(124)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SpinnerComponent);
	    return SpinnerComponent;
	}());
	exports.SpinnerComponent = SpinnerComponent;


/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports = "<div class=\"spinner\">\n  <div class=\"rect1\"></div>\n  <div class=\"rect2\"></div>\n  <div class=\"rect3\"></div>\n  <div class=\"rect4\"></div>\n  <div class=\"rect5\"></div>\n</div>\n\n<div class=\"display\" *ngIf=\"showDisplay\">Carregando...</div>\n";

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports = ".spinner {\n  /*margin: 100px auto;*/\n  width: 50px;\n  height: 25px;\n  text-align: center;\n  font-size: 10px;\n  float: left;\n}\n\n.spinner > div {\n  background-color: #4C87FF;;\n  height: 100%;\n  width: 1px;\n  display: inline-block;\n\n  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;\n  animation: sk-stretchdelay 1.2s infinite ease-in-out;\n}\n\n.spinner .rect2 {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.spinner .rect3 {\n  -webkit-animation-delay: -1.0s;\n  animation-delay: -1.0s;\n}\n\n.spinner .rect4 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.spinner .rect5 {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.display {\n  float: left;\n  color: rgba(116, 116, 116, 0.8);\n}\n\n@-webkit-keyframes sk-stretchdelay {\n  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }\n  20% { -webkit-transform: scaleY(1.0) }\n}\n\n@keyframes sk-stretchdelay {\n  0%, 40%, 100% {\n    transform: scaleY(0.4);\n    -webkit-transform: scaleY(0.4);\n  }  20% {\n       transform: scaleY(1.0);\n       -webkit-transform: scaleY(1.0);\n     }\n}\n"

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 29/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var CodigoMaskPipe = (function () {
	    function CodigoMaskPipe() {
	    }
	    CodigoMaskPipe.prototype.transform = function (value, args) {
	        if (value) {
	            if (typeof value !== 'string') {
	                value = value.toString();
	            }
	            var valueLength = value.length, x, lenX;
	            for (x = valueLength, lenX = args; x < lenX; x++) {
	                value = "0" + value;
	            }
	            return value;
	        }
	    };
	    CodigoMaskPipe = __decorate([
	        core_1.Pipe({
	            name: 'codigoMask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CodigoMaskPipe);
	    return CodigoMaskPipe;
	}());
	exports.CodigoMaskPipe = CodigoMaskPipe;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 29/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var CodigoMaskMaskDirective = (function () {
	    function CodigoMaskMaskDirective(model) {
	        this.model = model;
	        this._defaultValue = 10;
	    }
	    CodigoMaskMaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    CodigoMaskMaskDirective.prototype.modelValue = function () {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel);
	            }
	        }
	    };
	    CodigoMaskMaskDirective.prototype.inputChange = function (model) {
	        if (model) {
	            var newVal = model, valueLength = model.length;
	            setTimeout(function () {
	                if (!this.codigoLimit) {
	                    this.codigoLimit = this._defaultValue;
	                }
	                if (valueLength == 0) {
	                    newVal = '';
	                }
	                else {
	                    var x, lenX;
	                    for (x = valueLength, lenX = this.codigoLimit; x < lenX; x++) {
	                        newVal = "0" + newVal;
	                    }
	                }
	                this.model.valueAccessor.writeValue(newVal);
	            }.bind(this));
	        }
	    };
	    __decorate([
	        core_1.Input('codigoMask'), 
	        __metadata('design:type', Number)
	    ], CodigoMaskMaskDirective.prototype, "codigoLimit", void 0);
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], CodigoMaskMaskDirective.prototype, "ngModelChange", null);
	    CodigoMaskMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[codigoMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], CodigoMaskMaskDirective);
	    return CodigoMaskMaskDirective;
	    var _a;
	}());
	exports.CodigoMaskMaskDirective = CodigoMaskMaskDirective;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 11/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var Gtin13MaskDirective = (function () {
	    function Gtin13MaskDirective(model) {
	        this.model = model;
	    }
	    Gtin13MaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    Gtin13MaskDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    Gtin13MaskDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    Gtin13MaskDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model.replace(/\D/g, '');
	            if (backspace) {
	                if ((newVal.length === 1) || (newVal.length === 7)) {
	                    newVal = newVal.substring(0, newVal.length - 1);
	                }
	            }
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else if (newVal.length === 1) {
	                newVal = newVal.replace(/(\d{1})/, "$1 ");
	            }
	            else if (newVal.length <= 6) {
	                newVal = newVal.replace(/(\d{1})(\d{0,5})/, "$1 $2");
	            }
	            else if (newVal.length <= 13) {
	                newVal = newVal.replace(/(\d{1})(\d{0,6})(\d{0,6})/, "$1 $2 $3");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], Gtin13MaskDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], Gtin13MaskDirective.prototype, "onKeyDownBackspace", null);
	    Gtin13MaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[gtin13]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], Gtin13MaskDirective);
	    return Gtin13MaskDirective;
	    var _a;
	}());
	exports.Gtin13MaskDirective = Gtin13MaskDirective;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 29/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var Gtin13Pipe = (function () {
	    function Gtin13Pipe() {
	    }
	    Gtin13Pipe.prototype.transform = function (value, args) {
	        if (value) {
	            if (typeof value !== 'string') {
	                value = value.toString();
	            }
	            value = value.replace(/\D/g, '');
	            if (value.length === 13) {
	                value = value.replace(/(\d{1})(\d{6})(\d{6})/, "$1 $2 $3");
	            }
	            return value;
	        }
	    };
	    Gtin13Pipe = __decorate([
	        core_1.Pipe({
	            name: 'Gtin13Mask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], Gtin13Pipe);
	    return Gtin13Pipe;
	}());
	exports.Gtin13Pipe = Gtin13Pipe;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var OdometroHorimetroMaskDirective = (function () {
	    function OdometroHorimetroMaskDirective(model) {
	        this.model = model;
	    }
	    OdometroHorimetroMaskDirective.prototype.ngModelChange = function ($event) {
	        this.inputChange($event);
	    };
	    OdometroHorimetroMaskDirective.prototype.inputChange = function (value) {
	        if (value) {
	            var newVal = value.toString();
	            newVal = newVal.replace(/\D/g, '');
	            newVal = Number(newVal).toString();
	            if (newVal.length === 0 || !newVal || newVal === '0') {
	                newVal = '';
	            }
	            else {
	                if (newVal.length < 2) {
	                    newVal = '0'.concat(newVal);
	                }
	                newVal = newVal.replace(/(\d{0,})(\d{1})/, "$1.$2");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], OdometroHorimetroMaskDirective.prototype, "ngModelChange", null);
	    OdometroHorimetroMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[appOdometroHorimetroMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], OdometroHorimetroMaskDirective);
	    return OdometroHorimetroMaskDirective;
	    var _a;
	}());
	exports.OdometroHorimetroMaskDirective = OdometroHorimetroMaskDirective;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var odometro_horimetro_service_1 = __webpack_require__(131);
	var OdometroHorimetroMaskPipe = (function () {
	    function OdometroHorimetroMaskPipe(_odometroHorimetroService) {
	        this._odometroHorimetroService = _odometroHorimetroService;
	    }
	    OdometroHorimetroMaskPipe.prototype.transform = function (value, args) {
	        if (value) {
	            value = this._odometroHorimetroService.setMask(value);
	            return value;
	        }
	    };
	    OdometroHorimetroMaskPipe = __decorate([
	        core_1.Pipe({
	            name: 'odometroHorimetroMask'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof odometro_horimetro_service_1.OdometroHorimetroService !== 'undefined' && odometro_horimetro_service_1.OdometroHorimetroService) === 'function' && _a) || Object])
	    ], OdometroHorimetroMaskPipe);
	    return OdometroHorimetroMaskPipe;
	    var _a;
	}());
	exports.OdometroHorimetroMaskPipe = OdometroHorimetroMaskPipe;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var OdometroHorimetroService = (function () {
	    function OdometroHorimetroService() {
	    }
	    OdometroHorimetroService.prototype.setMask = function (value) {
	        if (value) {
	            value = value.toString();
	            value = value.replace(/\D/g, '');
	            value = value.replace(/(\d{0,})(\d{1})/, "$1.$2");
	        }
	        else {
	            value = '';
	        }
	        return value;
	    };
	    OdometroHorimetroService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], OdometroHorimetroService);
	    return OdometroHorimetroService;
	}());
	exports.OdometroHorimetroService = OdometroHorimetroService;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var util_1 = __webpack_require__(133);
	var NumberValidator = (function () {
	    function NumberValidator() {
	    }
	    NumberValidator.numberFormat = function (item) {
	        if (util_1.isNull(item.value)) {
	            return { "incorrectNumberFormat": true };
	        }
	        return null;
	    };
	    return NumberValidator;
	}());
	exports.NumberValidator = NumberValidator;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(135);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(136);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(134)))

/***/ },
/* 134 */,
/* 135 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 136 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LiterMaskPipe = (function () {
	    function LiterMaskPipe() {
	    }
	    LiterMaskPipe.prototype.transform = function (value, args) {
	        if (value) {
	            value = value.toString();
	            value = value.replace('.', ",");
	            var isNegative = (value < 0) ? true : false;
	            if (isNegative) {
	                value = value * (-1);
	                value = value.toString();
	            }
	            var commonIndex = value.lastIndexOf(","), beforeCommon = value, afterCommon = '';
	            if (commonIndex !== -1) {
	                beforeCommon = value.substr(0, commonIndex);
	                afterCommon = value.substr(commonIndex, value.length);
	            }
	            var beforeCommonSplit = beforeCommon.split('').reverse();
	            var x = 0, lenX = beforeCommonSplit.length, countPoint = 3;
	            for (x, lenX; x < lenX; x++) {
	                if (x === countPoint) {
	                    beforeCommonSplit[x] = beforeCommonSplit[x].concat(".");
	                    countPoint += 3;
	                }
	            }
	            var newNumber = beforeCommonSplit.reverse().toString();
	            newNumber = newNumber.replace(/,/g, '');
	            if (afterCommon.length > 3) {
	                afterCommon = afterCommon.substr(0, 4);
	            }
	            newNumber = newNumber.concat(afterCommon);
	            if (isNegative) {
	                newNumber = "-".concat(newNumber);
	            }
	            return newNumber;
	        }
	        else {
	            return 0;
	        }
	    };
	    LiterMaskPipe = __decorate([
	        core_1.Pipe({
	            name: 'literMask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LiterMaskPipe);
	    return LiterMaskPipe;
	}());
	exports.LiterMaskPipe = LiterMaskPipe;


/***/ },
/* 138 */
/***/ function(module, exports) {

	"use strict";
	var NumberMaxMinValueValidator = (function () {
	    function NumberMaxMinValueValidator() {
	    }
	    NumberMaxMinValueValidator.numberMaxMin = function (min, max) {
	        return function (control) {
	            var item = control.value;
	            if ((item > max) || (item < min))
	                return { 'incorrectMaxMinNumber': 'Informe um número entre ' + min + ' e ' + max };
	            else
	                return null;
	        };
	    };
	    return NumberMaxMinValueValidator;
	}());
	exports.NumberMaxMinValueValidator = NumberMaxMinValueValidator;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var TimepickerDirective = (function () {
	    function TimepickerDirective(model) {
	        this.model = model;
	    }
	    TimepickerDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    TimepickerDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    TimepickerDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    TimepickerDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model.replace(/\D/g, '');
	            if (backspace) {
	                if (newVal.length === 1) {
	                    newVal = newVal.substring(0, newVal.length - 1);
	                }
	            }
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else if (newVal.length === 1) {
	                if (newVal > 2) {
	                    newVal = '';
	                }
	                else {
	                    newVal = newVal.replace(/(\d{1})/, "$1");
	                }
	            }
	            else if (newVal.length === 2) {
	                if (newVal > 23) {
	                    newVal = newVal.charAt(0);
	                }
	                else {
	                    newVal = newVal.replace(/(\d{1})(\d{1})/, "$1$2");
	                }
	            }
	            else if (newVal.length === 3) {
	                var newVal2 = newVal.charAt(2);
	                if (newVal2 > 5) {
	                    newVal = newVal.slice(0, 2);
	                    newVal = newVal.replace(/(\d{1})(\d{1})/, "$1$2");
	                }
	                else {
	                    newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})/, "$1$2:$3");
	                }
	            }
	            else if (newVal.length === 4) {
	                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})/, "$1$2:$3$4");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], TimepickerDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], TimepickerDirective.prototype, "onKeyDownBackspace", null);
	    TimepickerDirective = __decorate([
	        core_1.Directive({
	            selector: '[appTimepicker]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], TimepickerDirective);
	    return TimepickerDirective;
	    var _a;
	}());
	exports.TimepickerDirective = TimepickerDirective;


/***/ },
/* 140 */
/***/ function(module, exports) {

	"use strict";
	var OdometroHorimetroValidator = (function () {
	    function OdometroHorimetroValidator() {
	    }
	    OdometroHorimetroValidator.odometroHorimetroFormat = function (item) {
	        var Odometro_REGEXP;
	        if (item.value) {
	            var tt = item.value.replace(/[^0-9]/gi, '');
	            Odometro_REGEXP = /([0-9]{6})/;
	            if (item.value && !Odometro_REGEXP.test(tt)) {
	                return { "incorrectOdometroHorimetroFormat": true };
	            }
	        }
	        return null;
	    };
	    return OdometroHorimetroValidator;
	}());
	exports.OdometroHorimetroValidator = OdometroHorimetroValidator;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_operators_service_1 = __webpack_require__(27);
	var util_service_1 = __webpack_require__(88);
	var projeto_service_1 = __webpack_require__(52);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(50);
	var AttService = (function () {
	    function AttService(_restOperatorsService, _restService, _utilService, _projectService, _dataService) {
	        this._restOperatorsService = _restOperatorsService;
	        this._restService = _restService;
	        this._utilService = _utilService;
	        this._projectService = _projectService;
	        this._dataService = _dataService;
	    }
	    AttService.prototype.isValidAttachment = function (files, onlyImage, onlyFile) {
	        //files === e.target.files[0];
	        if (files.length === 0) {
	            return false;
	        }
	        var x, lenX, file, isValid;
	        for (x = 0, lenX = files.files.length; x < lenX; x++) {
	            file = files.files[x];
	            if (onlyImage) {
	                isValid = this.validImageFormat(file.type);
	            }
	            else if (onlyFile) {
	                isValid = this.validFileFormat(file.type);
	            }
	            else {
	                isValid = this.validAttachmentFormat(file.type);
	            }
	            if (!isValid) {
	                break;
	            }
	        }
	        if (isValid) {
	            return true;
	        }
	        else {
	            this._utilService.swalMessageWarningCustom("Arquivo com formato inválido!");
	            return false;
	        }
	    };
	    AttService.prototype.loadFile = function (file, responseSuccess) {
	        var oFReader = new FileReader();
	        oFReader.onload = function (oFREvent) {
	            if (this.validImageFormat(file.type)) {
	                var img = new Image();
	                img.onload = function () {
	                    var canvas = this.cropImage(img);
	                    this.fileBase64 = canvas.toDataURL();
	                    this.uploadFile(file, responseSuccess);
	                    //this.sendToS3(file, responseSuccess);
	                }.bind(this);
	                img.src = oFREvent.target.result;
	            }
	            else {
	                this.fileBase64 = oFREvent.target.result;
	                this.sendToS3(file, responseSuccess);
	            }
	        }.bind(this);
	        oFReader.readAsDataURL(file);
	    };
	    AttService.prototype.validImageFormat = function (attType) {
	        var isValid = true;
	        var TypeFileFromFormat = [
	            'image/png',
	            'image/jpg',
	            'image/jpeg' //jpeg
	        ];
	        var format = TypeFileFromFormat.indexOf(attType);
	        if (format === -1) {
	            isValid = false;
	        }
	        return isValid;
	    };
	    AttService.prototype.validFileFormat = function (attType) {
	        var isValid = true;
	        var TypeFileFromFormat = [
	            'application/pdf' //pdf
	        ];
	        var format = TypeFileFromFormat.indexOf(attType);
	        if (format === -1) {
	            isValid = false;
	        }
	        return isValid;
	    };
	    AttService.prototype.validAttachmentFormat = function (attType) {
	        var isValid = true;
	        isValid = this.validImageFormat(attType);
	        if (!isValid) {
	            isValid = this.validFileFormat(attType);
	        }
	        return isValid;
	    };
	    //recorta a imagem
	    AttService.prototype.cropImage = function (img) {
	        var canvas = document.createElement("canvas");
	        var ctx = canvas.getContext("2d");
	        var MAX_WIDTH = 600;
	        var MAX_HEIGHT = 600;
	        var width = img.width;
	        var height = img.height;
	        if (width > height) {
	            if (width > MAX_WIDTH) {
	                height *= MAX_WIDTH / width;
	                width = MAX_WIDTH;
	            }
	        }
	        else {
	            if (height > MAX_HEIGHT) {
	                width *= MAX_HEIGHT / height;
	                height = MAX_HEIGHT;
	            }
	        }
	        canvas.width = width;
	        canvas.height = height;
	        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
	        return canvas;
	    };
	    //obtem a extensao do arquivo
	    AttService.prototype.getAttachmentFormat = function (attachiment) {
	        var attachimentType, object = {
	            type: "",
	            format: ""
	        };
	        attachimentType = attachiment.name.split(".");
	        attachimentType = attachimentType[attachimentType.length - 1];
	        if (attachimentType) {
	            attachimentType = attachimentType.toLowerCase();
	        }
	        if (attachimentType === 'png') {
	            object.type = 'image/png';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'jpg') {
	            object.type = 'image/jpg';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'jpeg') {
	            object.type = 'image/jpeg';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'pdf') {
	            object.type = 'application/pdf';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'ppt') {
	            object.type = 'application/vnd.ms-powerpoint';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'pptx') {
	            object.type = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'doc') {
	            object.type = 'application/msword';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'docx') {
	            object.type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'xls') {
	            object.type = 'application/vnd.ms-excel';
	            object.format = attachimentType;
	        }
	        else if (attachimentType === 'xlsx') {
	            object.type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	            object.format = attachimentType;
	        }
	        return object;
	    };
	    //coverte a imagem de base64 para blob
	    AttService.prototype.convertBase64ToBlob = function (base64, typeFile) {
	        var ImageBase64 = atob(base64.split(',')[1]);
	        var ArrayFileImage = [];
	        var indiceArrayFileImage = 0;
	        var arrayFileImagemLength = ImageBase64.length;
	        for (; indiceArrayFileImage < arrayFileImagemLength; indiceArrayFileImage++) {
	            ArrayFileImage.push(ImageBase64.charCodeAt(indiceArrayFileImage));
	        }
	        var ImageBlob = new Blob([new Uint8Array(ArrayFileImage)], { type: typeFile });
	        return ImageBlob;
	    };
	    AttService.prototype.sendToS3 = function (file, callback) {
	        var fileExtension = this.getAttachmentFormat(file);
	        var imageBase64 = this.fileBase64;
	        var blobb = this.convertBase64ToBlob(imageBase64, file.type);
	        this.getSignedRequest(file, blobb, fileExtension, callback);
	    };
	    //envia para o s3
	    AttService.prototype.getSignedRequest = function (file, blob, fileExtension, callback) {
	        var route = 'anexo/sign';
	        var apiRoute = this._restOperatorsService.getApiRoute(route, '');
	        var xhr = new XMLHttpRequest();
	        xhr.open("POST", apiRoute);
	        xhr.setRequestHeader('Content-Type', 'application/json');
	        var _utilService = this._utilService;
	        xhr.onreadystatechange = function () {
	            if (xhr.readyState === 4) {
	                var Response = JSON.parse(xhr.responseText);
	                if (xhr.status === 200) {
	                    upload_file(blob, Response, callback);
	                }
	                else {
	                    _utilService.swalMessageWarningCustom(Response.message);
	                }
	            }
	            else {
	            }
	        };
	        var date = new Date();
	        var timestamp = date.getTime();
	        var project = this._projectService.getSessionStorage();
	        var tenant = '';
	        if (project && project.id) {
	            tenant = project.nomeTenant;
	        }
	        var folder = tenant + "/" + timestamp + '.' + fileExtension.format;
	        xhr.send(JSON.stringify({ name: folder, type: file.type }));
	        function upload_file(blob, Ass, callback) {
	            var signed_request = Ass.signature;
	            var xhr = new XMLHttpRequest();
	            xhr.open("PUT", signed_request);
	            xhr.setRequestHeader('x-amz-acl', 'public-read');
	            xhr.onload = function () {
	                if (xhr.status === 200) {
	                    Ass.location = folder;
	                    Ass.fileExtension = fileExtension.format;
	                    callback(Ass);
	                }
	            };
	            xhr.onerror = function (x) {
	                console.log(x);
	                alert("Could not upload file.");
	            };
	            xhr.send(blob);
	        }
	    };
	    //salva o upload no banco
	    AttService.prototype.uploadFile = function (file, callback) {
	        var fileExtension = this.getAttachmentFormat(file);
	        var date = new Date();
	        var timestamp = date.getTime();
	        var project = this._projectService.getSessionStorage();
	        var tenant = '';
	        if (project && project.id) {
	            tenant = project.nomeTenant;
	        }
	        var folder = tenant + "/" + timestamp + '.' + fileExtension.format;
	        var c = this.fileBase64.split(',');
	        c = c[1];
	        var object = {
	            destino: folder,
	            tipo: file.type,
	            base64: c
	        };
	        var s3 = this._dataService.getS3();
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.url = s3 + folder;
	                Response.fileExtension = fileExtension.type;
	                callback(Response);
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._restService.onPostCustom('anexo/upload', object, onDone);
	    };
	    AttService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_operators_service_1.RestOperatorsService !== 'undefined' && rest_operators_service_1.RestOperatorsService) === 'function' && _a) || Object, (typeof (_b = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof projeto_service_1.ProjetoService !== 'undefined' && projeto_service_1.ProjetoService) === 'function' && _d) || Object, (typeof (_e = typeof data_service_1.DataService !== 'undefined' && data_service_1.DataService) === 'function' && _e) || Object])
	    ], AttService);
	    return AttService;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AttService = AttService;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ExportCsvService = (function () {
	    function ExportCsvService() {
	    }
	    ExportCsvService.prototype.JsonToCsvConvertor = function (JSONData, documentName, showLabel) {
	        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
	        var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
	        var CSV = '', row = "", index, x, lenX;
	        //This condition will generate the Label/Header
	        if (showLabel) {
	            //This loop will extract the label from 1st index of on array
	            for (index in arrData[0]) {
	                //Now convert each value to string and comma-seprated
	                row += index + ',';
	            }
	            row = row.slice(0, -1);
	            //append Label row with line break
	            CSV += row + '\r\n';
	        }
	        //1st loop is to extract each row
	        for (x = 0, lenX = arrData.length; x < lenX; x++) {
	            row = "";
	            //2nd loop will extract each column and convert it in string comma-seprated
	            for (index in arrData[x]) {
	                row += '"' + arrData[x][index] + '",';
	            }
	            row.slice(0, row.length - 1);
	            //add a line break after each row
	            CSV += row + '\r\n';
	        }
	        if (CSV == '') {
	            // alert("Invalid data");
	            return;
	        }
	        // Generate a file name
	        // this will remove the blank-spaces from the title and replace it with an underscore
	        var fileName = documentName.replace(/ /g, "_");
	        //Initialize file format you want csv or xls
	        var uri = 'data:text/csv;charset=utf-8,' + encodeURI(CSV);
	        // Now the little tricky part.
	        // you can use either>> window.open(uri);
	        // but this will not work in some browsers
	        // or you will not get the correct file extension
	        //this trick will generate a temp <a /> tag
	        var link = document.createElement("a");
	        link.href = uri;
	        //set the visibility hidden so it will not effect on your web-layout
	        link.style = "visibility:hidden";
	        link.download = fileName + ".csv";
	        //this part will append the anchor tag and remove it after automatic click
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	    };
	    ExportCsvService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], ExportCsvService);
	    return ExportCsvService;
	}());
	exports.ExportCsvService = ExportCsvService;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(144);
	var data_service_2 = __webpack_require__(145);
	var data_service_3 = __webpack_require__(146);
	var data_service_4 = __webpack_require__(147);
	var data_service_5 = __webpack_require__(148);
	var data_service_6 = __webpack_require__(149);
	var data_service_7 = __webpack_require__(150);
	var data_service_8 = __webpack_require__(151);
	var data_service_9 = __webpack_require__(152);
	var data_service_10 = __webpack_require__(153);
	var data_service_11 = __webpack_require__(154);
	var data_service_12 = __webpack_require__(155);
	var data_service_13 = __webpack_require__(156);
	var data_service_14 = __webpack_require__(157);
	var data_service_15 = __webpack_require__(158);
	var data_service_16 = __webpack_require__(159);
	var data_service_17 = __webpack_require__(160);
	var data_service_18 = __webpack_require__(161);
	var usuario_service_1 = __webpack_require__(85);
	var GestaoComponent = (function () {
	    function GestaoComponent(_authService, _usuarioService) {
	        this._authService = _authService;
	        this._usuarioService = _usuarioService;
	        this.user = {};
	        this.rhRoute = data_service_2.recursosHumanosRoute;
	        this.pessoasRoute = data_service_1.pessoasRoute;
	        this.rhModule = data_service_2.recursosHumanosModuleName;
	        this.pessoasModule = data_service_1.pessoasModuleName;
	        this.motoristasModule = data_service_3.motoristasModuleName;
	        this.motoristasRoute = data_service_3.motoristasRoute;
	        this.estruturasRoute = data_service_4.estruturasRoute;
	        this.localidadesRoute = data_service_5.localidadesRoute;
	        this.localidadesModule = data_service_5.localidadesModuleName;
	        this.orgaosRoute = data_service_6.orgaosRoute;
	        this.orgaosModule = data_service_6.orgaosModuleName;
	        this.divisoesRoute = data_service_7.divisoesRoute;
	        this.divisoesModule = data_service_7.divisoesModuleName;
	        this.orgaoTiposRoute = data_service_12.orgaoTiposRoute;
	        this.orgaoTiposModule = data_service_12.orgaoTiposModuleName;
	        this.bensRoute = data_service_8.bensRoute;
	        this.marcasRoute = data_service_9.marcasRoute;
	        this.marcasModule = data_service_9.marcasModuleName;
	        this.categoriasRoute = data_service_10.categoriasRoute;
	        this.categoriasModule = data_service_10.categoriasModuleName;
	        this.frotasRoute = data_service_11.frotasRoute;
	        this.veiculosRoute = data_service_11.veiculosRoute;
	        this.veiculosModule = data_service_11.veiculosModuleName;
	        this.aeronavesRoute = data_service_11.aeronavesRoute;
	        this.aeronavesModule = data_service_11.aeronavesModuleName;
	        this.embarcacoesRoute = data_service_11.embarcacoesRoute;
	        this.embarcacoesModule = data_service_11.embarcacoesModuleName;
	        this.equipamentosRoute = data_service_11.equipamentosRoute;
	        this.equipamentosModule = data_service_11.equipamentosModuleName;
	        this.maquinarioRoute = data_service_11.maquinarioRoute;
	        this.maquinarioModule = data_service_11.maquinarioModuleName;
	        this.outrosRoute = data_service_11.outrosRoute;
	        this.outrosModule = data_service_11.outrosModuleName;
	        this.contasRoute = data_service_15.contasRoute;
	        this.contasContabeisMedidaRoute = data_service_16.contasContabeisRouter;
	        this.contasContabeisModule = data_service_16.contasContabeisModuleName;
	        this.almoxarifadoRoute = data_service_13.almoxarifadoRoute;
	        this.medidasRoute = data_service_14.medidasRouter;
	        this.medidasModule = data_service_14.medidasModuleName;
	        this.gruposMateriaisRoute = data_service_17.gruposMateriaisRouter;
	        this.gruposMateriaisModule = data_service_17.gruposMateriaisModuleName;
	        this.materialRoute = data_service_18.materialRouter;
	        this.materiaisModule = data_service_18.materialTitle;
	        this.materiaisRoute = data_service_18.materiaisRouter;
	    }
	    GestaoComponent.prototype.ngOnInit = function () {
	    };
	    GestaoComponent.prototype.ngAfterViewInit = function () {
	        var user = this._usuarioService.getSessionStorageLogged();
	        if (user) {
	            this.user = user;
	        }
	    };
	    GestaoComponent.prototype.clickLogout = function () {
	        this._authService.logout();
	    };
	    GestaoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(162),
	            styles: [__webpack_require__(166)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof usuario_service_1.UsuarioService !== 'undefined' && usuario_service_1.UsuarioService) === 'function' && _b) || Object])
	    ], GestaoComponent);
	    return GestaoComponent;
	    var _a, _b;
	}());
	exports.GestaoComponent = GestaoComponent;


/***/ },
/* 144 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'pessoas';
	exports.pessoasRoute = 'pessoas';
	exports.pessoasStorage = 'pessoas';
	exports.pessoasModuleName = { plural: 'Pessoas', single: 'Pessoa' };
	exports.pessoaImageApiName = 'imagens-pessoas';
	exports.pessoasQuery = {
	    "where": {
	        "ativo": true,
	        "nome": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "nome"
	};


/***/ },
/* 145 */
/***/ function(module, exports) {

	"use strict";
	exports.recursosHumanosRoute = 'rh';
	exports.recursosHumanosModuleName = { plural: 'Pessoas', single: 'Pessoa' };


/***/ },
/* 146 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'motoristas';
	exports.motoristasRoute = 'motoristas';
	exports.motoristasStorage = 'motoristas';
	exports.motoristasModuleName = { plural: 'Motoristas', single: 'Motorista' };
	exports.motoristasQuery = {
	    "where": {
	        "ativo": true,
	        "funcionario": {
	            "pessoa": {
	                "nome": { "regexp": "/REPLACEHERE/i" }
	            }
	        }
	    },
	    "include": [
	        { "funcionario": "pessoa" }
	    ]
	};


/***/ },
/* 147 */
/***/ function(module, exports) {

	"use strict";
	exports.estruturasRoute = 'estruturas';
	exports.estruturasModuleName = { plural: 'Estruturas', single: 'Estrutura' };


/***/ },
/* 148 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'localidades';
	exports.localidadesRoute = 'localidades';
	exports.localidadesStorage = 'localidades';
	exports.localidadesModuleName = { plural: 'Localidades', single: 'Localidade' };
	exports.localidadesQuery = {
	    "where": {
	        "ativo": true,
	        "localidade": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "localidade"
	};


/***/ },
/* 149 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'orgaos';
	exports.orgaosRoute = 'orgaos';
	exports.orgaosStorage = 'orgaos';
	exports.orgaosModuleName = { plural: 'Órgãos', single: 'Órgão' };
	exports.orgaosQuery = {
	    "where": {
	        "ativo": true,
	        "razaoSocial": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "razaoSocial"
	};


/***/ },
/* 150 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'divisoes';
	exports.divisoesRoute = 'divisoes';
	exports.divisoesStorage = 'divisoes';
	exports.divisoesModuleName = { plural: 'Divisões', single: 'Divisão' };
	exports.divisoesQuery = {
	    "where": {
	        "ativo": true,
	        "divisao": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "divisao"
	};


/***/ },
/* 151 */
/***/ function(module, exports) {

	"use strict";
	exports.bensRoute = 'bens';
	exports.bensModuleName = { plural: 'Bens', single: 'Bem' };


/***/ },
/* 152 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'marcas';
	exports.marcasRoute = 'marcas';
	exports.marcasStorage = 'marcas';
	exports.marcasModuleName = { plural: 'Marcas', single: 'Marca' };
	exports.marcasQuery = {
	    "where": {
	        "ativo": true,
	        "marca": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "marca"
	};


/***/ },
/* 153 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'categorias';
	exports.categoriasRoute = 'categorias';
	exports.categoriasStorage = 'categorias';
	exports.categoriasModuleName = { plural: 'Categorias', single: 'Categoria' };


/***/ },
/* 154 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'bens';
	exports.frotasStorage = 'frotas';
	exports.frotasRoute = 'frotas';
	exports.aeronavesRoute = 'aeronaves';
	exports.embarcacoesRoute = 'embarcacoes';
	exports.equipamentosRoute = 'equipamenos';
	exports.maquinarioRoute = 'maquinario';
	exports.outrosRoute = 'outros';
	exports.veiculosRoute = 'veiculos';
	exports.aeronavesModuleName = { plural: 'Aeronaves', single: 'Aeronave' };
	exports.embarcacoesModuleName = { plural: 'Embarcações', single: 'Embarcação' };
	exports.equipamentosModuleName = { plural: 'Equipamentos', single: 'Equipamento' };
	exports.maquinarioModuleName = { plural: 'Maquinários', single: 'Maquinário' };
	exports.outrosModuleName = { plural: 'Outros', single: 'Outro' };
	exports.veiculosModuleName = { plural: 'Veículos', single: 'Veículo' };
	exports.frotaImagemApiName = 'imagens-bens';
	exports.frotasQueryComCombustivel = {
	    "where": {
	        "ativo": true,
	        "or": [
	            { "codigo": { "regexp": "/REPLACEHERE/i" } },
	            { "placa": { "regexp": "/REPLACEHERE/i" } },
	            { "identificacao": { "regexp": "/REPLACEHERE/i" } }
	        ]
	    },
	    "order": "identificacao",
	    "include": ["modelo", "orgao", "area", "divisao", "setor", "localidade", "cor", "situacao", "odometroHorimetro"]
	};
	exports.frotasQuery = {
	    "where": {
	        "and": [
	            { "ativo": true },
	            {
	                "or": [
	                    { "codigo": { "regexp": "/REPLACEHERE/i" } },
	                    { "placa": { "regexp": "/REPLACEHERE/i" } },
	                    { "identificacao": { "regexp": "/REPLACEHERE/i" } }
	                ]
	            }
	        ]
	    },
	    "order": "identificacao",
	    "include": ["modelo", "orgao", "area", "divisao", "setor", "localidade", "cor", "situacao", "odometroHorimetro"]
	};
	exports.frotasQueryComGPS = {
	    where: {
	        gpsImei: { neq: null },
	        gpsModeloId: { neq: null }
	    }
	};


/***/ },
/* 155 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-orgaos';
	exports.orgaoTiposRoute = 'tipo-orgao';
	exports.orgaoTiposStorage = 'orgaotipos';
	exports.orgaoTiposModuleName = { plural: 'Tipos de órgãos', single: 'Tipo de órgão' };
	exports.orgaoTiposQuery = {
	    "where": {
	        "and": [
	            { "ativo": true },
	            {
	                "or": [
	                    { "descricao": { "regexp": "/REPLACEHERE/i" } },
	                    { "codigoTCE": { "regexp": "/REPLACEHERE/i" } }
	                ]
	            }
	        ]
	    },
	    "include": ["estado"],
	    "order": "codigoTCE"
	};


/***/ },
/* 156 */
/***/ function(module, exports) {

	"use strict";
	exports.almoxarifadoRoute = 'almoxarifado';
	exports.almoxarifadoModuleName = { plural: 'Almoxarifados', single: 'Almoxarifado' };


/***/ },
/* 157 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'medidas';
	exports.medidasRouter = 'medidas';
	exports.medidasStorage = 'medidas';
	exports.medidasModuleName = { plural: 'Medidas', single: 'Medida' };
	exports.medidasQuery = {
	    "where": {
	        "ativo": true,
	        "medida": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "medida"
	};


/***/ },
/* 158 */
/***/ function(module, exports) {

	"use strict";
	exports.contasRoute = 'contas';
	exports.contasModuleName = { plural: 'Contas', single: 'Conta' };


/***/ },
/* 159 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'contas-contabeis';
	exports.contasContabeisRouter = 'contas-contabeis';
	exports.contasContabeisStorage = 'contascontabeis';
	exports.contasContabeisModuleName = { plural: 'Contas contábeis', single: 'Conta contábil' };
	exports.modelosContaContabil = [
	    { Key: 1, Value: 'Sintético' },
	    { Key: 2, Value: 'Analítico' }
	];
	exports.contaContabilCodigoMask = 15; //9 digitos + 6 pontos
	exports.contasContabeisQuery = {
	    "where": {
	        "ativo": true,
	        "descricao": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "descricao"
	}; //include:["contaContabil"]


/***/ },
/* 160 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'grupos-materiais';
	exports.gruposMateriaisRouter = 'grupos-materiais';
	exports.gruposMateriaisStorage = 'gruposmateriais';
	exports.gruposMateriaisModuleName = { plural: 'Grupos de materiais', single: 'Grupo' };
	exports.subgruposMateriaisRouter = 'subgrupos';
	exports.subgruposMateriaisModuleName = { plural: 'Subgrupos', single: 'Subgrupo' };
	exports.grupoMaterialCodigoMask = 3;
	exports.gruposQuery = {
	    "where": {
	        "ativo": true,
	        "descricao": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "descricao",
	    "include": ["contaContabil"]
	};


/***/ },
/* 161 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	exports.materiaisRouter = 'materiais';
	exports.materialRouter = 'lista';
	exports.materialApi = 'Materiais';
	exports.materialStorageName = 'material';
	exports.materialTitle = { plural: 'Materiais', single: 'Material' };
	exports.materialEspecificacaoRouter = 'especificacoes';
	exports.materialEspecificacaoApi = 'materiais-especificadores';
	exports.materialEspecificacaoStorageName = 'materialespecificacao';
	exports.materialEspecificacaoTitle = { plural: 'Especificações', single: 'Especificação' };
	exports.materialCodigoBarraRouter = 'codigo-barra';
	exports.materialCodigoBarraApi = 'materiais-codigos-barra';
	exports.materialCodigoBarraStorageName = 'materialcodigobarra';
	exports.materialCodigoBarraTitle = { plural: 'Códigos de barra', single: 'Código de barra' };
	exports.tiposMateriais = [
	    { Key: 1, Value: 'Consumo' },
	    { Key: 2, Value: 'Permanente' }
	];
	exports.materialGrupoCodigoMask = 3;
	exports.materialCodigoMask = 6;
	exports.materiaisQuery = {
	    "where": {
	        "ativo": true,
	        "descricao": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "descricao",
	    "include": ["medida"]
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"geo-framework\">\n    <div class=\"geo-nav__header--mobile\">\n    <span class=\"geo-mobile__toggle\">\n        <img alt=\"Abrir menu\" src=\"" + __webpack_require__(163) + "\" />\n    </span>\n    </div>\n    <div class=\"geo-nav__overlay\"></div>\n\n    <nav class=\"geo-nav\">\n        <div class=\"geo-nav__header\">\n            <a [routerLink]=\"['./']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">\n                <span data-logo=\"expand\"><svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-assets'/></svg></span>\n                <img alt=\"Logo GeoSiap\" data-logo=\"reduced\" src=\"" + __webpack_require__(164) + "\" />\n            </a>\n        </div>\n        <div class=\"geo-nav__menu\">\n            <a class=\"geo-menu__button\" [routerLink]=\"['./']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">\n                <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-home' /></svg>\n                <span>Home</span>\n            </a>\n\n            <a class=\"geo-menu__button\" [routerLink]=\"['./' + contasRoute + '/' + contasContabeisMedidaRoute]\" routerLinkActive=\"active\">\n                <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-contas'/></svg>\n                <span>{{contasContabeisModule.plural}}</span>\n            </a>\n\n            <span class='geo-menu__button' data-submenu>\n        <span class=\"geo-arrow\"></span>\n        <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-equipamento'/></svg>\n        <span>Equipamentos</span>\n        <div class=\"geo-submenu\">\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + bensRoute + '/' + frotasRoute + '/' + equipamentosRoute]\" routerLinkActive=\"active\">{{equipamentosModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + bensRoute + '/' + frotasRoute + '/' + outrosRoute]\" routerLinkActive=\"active\">{{outrosModule.plural}}</a>\n        </div>\n      </span>\n\n            <span class='geo-menu__button' data-submenu>\n        <span class=\"geo-arrow\"></span>\n        <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-frota'/></svg>\n        <span>Frotas</span>\n        <div class=\"geo-submenu\">\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + bensRoute + '/' + frotasRoute + '/' + aeronavesRoute]\" routerLinkActive=\"active\">{{aeronavesModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + bensRoute + '/' + frotasRoute + '/' + embarcacoesRoute]\" routerLinkActive=\"active\">{{embarcacoesModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + bensRoute + '/' + frotasRoute + '/' + maquinarioRoute]\" routerLinkActive=\"active\">{{maquinarioModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + bensRoute + '/' + frotasRoute + '/' + veiculosRoute]\" routerLinkActive=\"active\">{{veiculosModule.plural}}</a>\n        </div>\n      </span>\n\n            <app-abastecimento-menu class=\"geo-menu__button\" data-submenu></app-abastecimento-menu>\n\n            <app-viagem-menu class=\"geo-menu__button\" data-submenu></app-viagem-menu>\n\n\n            <app-rastreamento-menu class=\"geo-menu__button\" data-submenu></app-rastreamento-menu>\n\n            <app-manutencao-menu class=\"geo-menu__button\" data-submenu></app-manutencao-menu>\n\n            <span class='geo-menu__button' data-submenu>\n        <span class=\"geo-arrow\"></span>\n        <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-almoxarifado'/></svg>\n        <span>Materiais</span>\n        <div class=\"geo-submenu\">\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + almoxarifadoRoute + '/' + materiaisRoute + '/' + materialRoute]\" routerLinkActive=\"active\">{{materiaisModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + almoxarifadoRoute + '/' + gruposMateriaisRoute]\" routerLinkActive=\"active\">{{gruposMateriaisModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + almoxarifadoRoute + '/' + medidasRoute]\" routerLinkActive=\"active\">{{medidasModule.plural}}</a>\n        </div>\n      </span>\n\n            <span class='geo-menu__button' data-submenu>\n        <span class=\"geo-arrow\"></span>\n        <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-pessoa'/></svg>\n        <span>Pessoas</span>\n        <div class=\"geo-submenu\">\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + rhRoute + '/' + pessoasRoute]\" routerLinkActive=\"active\">{{pessoasModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + rhRoute + '/' + motoristasRoute]\" routerLinkActive=\"active\">{{motoristasModule.plural}}</a>\n        </div>\n      </span>\n\n            <app-despacho-seguros-menu class=\"geo-menu__button\" data-submenu></app-despacho-seguros-menu>\n\n            <app-despacho-obrigacoes-menu class=\"geo-menu__button\" data-submenu></app-despacho-obrigacoes-menu>\n\n            <span class='geo-menu__button' data-submenu>\n        <span class=\"geo-arrow\"></span>\n        <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-configuracao'/></svg>\n        <span>Configurações</span>\n        <div class=\"geo-submenu\">\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + bensRoute + '/' + categoriasRoute]\" routerLinkActive=\"active\">{{categoriasModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + estruturasRoute + '/' + divisoesRoute]\" routerLinkActive=\"active\">{{divisoesModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + estruturasRoute + '/' + localidadesRoute]\" routerLinkActive=\"active\">{{localidadesModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + bensRoute + '/' + marcasRoute]\" routerLinkActive=\"active\">{{marcasModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + estruturasRoute + '/' + orgaosRoute]\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">{{orgaosModule.plural}}</a>\n            <a class=\"geo-submenu__item\" [routerLink]=\"['./' + estruturasRoute + '/' + orgaosRoute + '/' + orgaoTiposRoute]\" routerLinkActive=\"active\" >{{orgaoTiposModule.plural}}</a>\n        </div>\n      </span>\n        </div>\n\n        <div class=\"geo-nav__footer\"></div>\n    </nav>\n\n    <main class=\"geo-framework__content\">\n        <header class=\"geo-header\">\n      <span class=\"geo-header__title\">\n        <a [routerLink]=\"['./']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">Embras - Empresa Brasileira de Sistemas</a>\n      </span>\n\n            <div class=\"geo-header__info\">\n                <a class=\"geo-menu__button\" id=\"menu-user\" data-menu>\n                    <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-usuario_info'/></svg>\n                </a>\n            </div>\n        </header>\n\n        <div class=\"geo-content\">\n            <router-outlet></router-outlet>\n        </div>\n    </main>\n</div>\n\n<div class=\"geo-menu geo-menu--bottom-left\" data-geo-for=\"menu-user\">\n    <div class=\"geo-menu--full\">\n        <div class=\"menu-full__header\">\n            <img src=\"" + __webpack_require__(165) + "\" class=\"profile-picture\">\n            <div class=\"menu-full__infos\">\n                <p><strong>Nome do usuário</strong></p>\n                <p>{{user.email}}</p>\n            </div>\n        </div>\n        <div class=\"menu-full__actions\">\n            <a [routerLink]=\"['./rh/usuarios/trocar']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">Alterar perfil</a>\n            <a class=\"cursor-pointer\" (click)=\"clickLogout()\">Sair</a>\n        </div>\n    </div>\n</div>\n";

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/menu.b38ef06de09ee07f92eed460e0ee3fb8.svg";

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_geosiap-reduced.ab67a6fc5889df8f2c5d9d956a6f3290.png";

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/profile-picture.245864a7153c80dffb2feddd34f9d365.jpg";

/***/ },
/* 166 */
/***/ function(module, exports) {

	module.exports = ""

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var router_1 = __webpack_require__(62);
	var core_1 = __webpack_require__(3);
	var home_component_1 = __webpack_require__(168);
	var auth_guard_service_1 = __webpack_require__(89);
	var data_service_1 = __webpack_require__(145);
	var recursos_humanos_component_1 = __webpack_require__(170);
	var pessoas_component_1 = __webpack_require__(172);
	var data_service_2 = __webpack_require__(144);
	var pessoas_routing_module_1 = __webpack_require__(174);
	var data_service_3 = __webpack_require__(146);
	var motoristas_routing_module_1 = __webpack_require__(207);
	var motoristas_component_1 = __webpack_require__(221);
	var data_service_4 = __webpack_require__(147);
	var estruturas_component_1 = __webpack_require__(223);
	var data_service_5 = __webpack_require__(148);
	var localidades_routing_module_1 = __webpack_require__(225);
	var localidades_component_1 = __webpack_require__(246);
	var data_service_6 = __webpack_require__(149);
	var orgaos_routing_module_1 = __webpack_require__(248);
	var orgaos_component_1 = __webpack_require__(270);
	var data_service_7 = __webpack_require__(190);
	var areas_routing_module_1 = __webpack_require__(272);
	var areas_component_1 = __webpack_require__(281);
	var data_service_8 = __webpack_require__(150);
	var divisoes_routing_module_1 = __webpack_require__(283);
	var divisoes_component_1 = __webpack_require__(292);
	var data_service_9 = __webpack_require__(196);
	var setores_routing_module_1 = __webpack_require__(294);
	var setores_component_1 = __webpack_require__(300);
	var data_service_10 = __webpack_require__(151);
	var bens_component_1 = __webpack_require__(302);
	var data_service_11 = __webpack_require__(152);
	var marcas_component_1 = __webpack_require__(304);
	var marcas_routing_module_1 = __webpack_require__(306);
	var data_service_12 = __webpack_require__(153);
	var categorias_component_1 = __webpack_require__(320);
	var categorias_routing_module_1 = __webpack_require__(322);
	var data_service_13 = __webpack_require__(332);
	var bem_tipos_component_1 = __webpack_require__(333);
	var bem_tipos_routing_module_1 = __webpack_require__(335);
	var data_service_14 = __webpack_require__(312);
	var modelos_component_1 = __webpack_require__(346);
	var modelos_routing_module_1 = __webpack_require__(348);
	var data_service_15 = __webpack_require__(154);
	var frotas_component_1 = __webpack_require__(364);
	var frotas_routing_module_1 = __webpack_require__(366);
	var data_service_16 = __webpack_require__(457);
	var viagens_component_1 = __webpack_require__(462);
	var data_service_17 = __webpack_require__(398);
	var data_service_18 = __webpack_require__(234);
	var manutencoes_component_1 = __webpack_require__(464);
	var data_service_19 = __webpack_require__(156);
	var almoxarifado_component_1 = __webpack_require__(466);
	var data_service_20 = __webpack_require__(157);
	var medidas_component_1 = __webpack_require__(468);
	var medidas_routing_1 = __webpack_require__(470);
	var data_service_21 = __webpack_require__(158);
	var contas_component_1 = __webpack_require__(480);
	var data_service_22 = __webpack_require__(159);
	var conta_contabil_component_1 = __webpack_require__(482);
	var conta_contabil_routing_1 = __webpack_require__(484);
	var data_service_23 = __webpack_require__(160);
	var grupos_materiais_component_1 = __webpack_require__(498);
	var grupos_materiais_routing_1 = __webpack_require__(500);
	var materiais_component_1 = __webpack_require__(507);
	var data_service_24 = __webpack_require__(161);
	var materiais_routing_1 = __webpack_require__(509);
	var data_service_25 = __webpack_require__(537);
	var despachos_component_1 = __webpack_require__(538);
	var abastecimentos_component_1 = __webpack_require__(540);
	var abastecimentos_routing_module_1 = __webpack_require__(542);
	var viagens_routing_module_1 = __webpack_require__(624);
	var usuarios_routing_module_1 = __webpack_require__(689);
	var data_service_26 = __webpack_require__(87);
	var usuarios_component_1 = __webpack_require__(693);
	var manutencoes_routing_module_1 = __webpack_require__(695);
	var despachos_routing_module_1 = __webpack_require__(740);
	var data_service_27 = __webpack_require__(813);
	var rastreamentos_component_1 = __webpack_require__(814);
	var rastreamentos_routing_module_1 = __webpack_require__(816);
	var GestaoRoutingModule = (function () {
	    function GestaoRoutingModule() {
	    }
	    GestaoRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], GestaoRoutingModule);
	    return GestaoRoutingModule;
	}());
	exports.GestaoRoutingModule = GestaoRoutingModule;
	exports.gestaoRoutes = [
	    {
	        path: '',
	        component: home_component_1.HomeComponent
	    }, {
	        path: data_service_1.recursosHumanosRoute,
	        component: recursos_humanos_component_1.RecursosHumanosComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: [
	            {
	                path: '',
	                redirectTo: '/' + data_service_2.pessoasRoute,
	                pathMatch: 'full'
	            }, {
	                path: data_service_2.pessoasRoute,
	                component: pessoas_component_1.PessoasComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: pessoas_routing_module_1.pessoasRoutes
	            }, {
	                path: data_service_3.motoristasRoute,
	                component: motoristas_component_1.MotoristasComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: motoristas_routing_module_1.motoristasRoutes
	            }, {
	                path: data_service_26.usuariosRoute,
	                component: usuarios_component_1.UsuariosComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: usuarios_routing_module_1.usuariosRoutes
	            }
	        ]
	    }, {
	        path: data_service_4.estruturasRoute,
	        component: estruturas_component_1.EstruturasComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: [
	            {
	                path: '',
	                redirectTo: '/' + data_service_5.localidadesRoute,
	                pathMatch: 'full'
	            }, {
	                path: data_service_5.localidadesRoute,
	                component: localidades_component_1.LocalidadesComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: localidades_routing_module_1.localidadesRoutes
	            }, {
	                path: data_service_6.orgaosRoute,
	                component: orgaos_component_1.OrgaosComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: orgaos_routing_module_1.orgaosRoutes
	            }, {
	                path: data_service_7.areasRoute,
	                component: areas_component_1.AreasComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: areas_routing_module_1.areasRoutes
	            }, {
	                path: data_service_8.divisoesRoute,
	                component: divisoes_component_1.DivisoesComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: divisoes_routing_module_1.divisoesRoutes
	            }, {
	                path: data_service_9.setoresRoute,
	                component: setores_component_1.SetoresComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: setores_routing_module_1.setoresRoutes
	            }
	        ]
	    }, {
	        path: data_service_10.bensRoute,
	        component: bens_component_1.BensComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: [
	            {
	                path: '',
	                redirectTo: '/' + data_service_11.marcasRoute,
	                pathMatch: 'full'
	            }, {
	                path: data_service_11.marcasRoute,
	                component: marcas_component_1.MarcasComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: marcas_routing_module_1.marcasRoutes
	            }, {
	                path: data_service_12.categoriasRoute,
	                component: categorias_component_1.CategoriasComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: categorias_routing_module_1.categoriasRoutes
	            }, {
	                path: data_service_13.bemTiposRoute,
	                component: bem_tipos_component_1.BemTiposComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: bem_tipos_routing_module_1.bemTiposRoutes
	            }, {
	                path: data_service_14.modelosRoute,
	                component: modelos_component_1.ModelosComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: modelos_routing_module_1.modelosRoutes
	            }, {
	                path: data_service_15.frotasRoute,
	                component: frotas_component_1.FrotasComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: frotas_routing_module_1.frotasRoutes
	            },
	        ]
	    }, {
	        path: data_service_16.viagensRoute,
	        component: viagens_component_1.ViagensComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: viagens_routing_module_1.viagensRoutes
	    }, {
	        path: data_service_17.abastecimentosRoute,
	        component: abastecimentos_component_1.AbastecimentosComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: abastecimentos_routing_module_1.abastecimentosRoutes
	    }, {
	        path: data_service_18.manutencoesRoute,
	        component: manutencoes_component_1.ManutencoesComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: manutencoes_routing_module_1.manutencoesRoutes
	    }, {
	        path: data_service_19.almoxarifadoRoute,
	        component: almoxarifado_component_1.AlmoxarifadoComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: [
	            {
	                path: '',
	                redirectTo: '/' + data_service_20.medidasRouter,
	                pathMatch: 'full'
	            }, {
	                path: data_service_20.medidasRouter,
	                component: medidas_component_1.MedidasComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: medidas_routing_1.medidasRoutes
	            }, {
	                path: data_service_23.gruposMateriaisRouter,
	                component: grupos_materiais_component_1.GruposMateriaisComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: grupos_materiais_routing_1.gruposMateriaisRoutes
	            }, {
	                path: data_service_24.materiaisRouter,
	                component: materiais_component_1.MateriaisComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: materiais_routing_1.materiaisRoutes
	            }
	        ]
	    }, {
	        path: data_service_21.contasRoute,
	        component: contas_component_1.ContasComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: [
	            {
	                path: '',
	                redirectTo: '/' + data_service_22.contasContabeisRouter,
	                pathMatch: 'full'
	            }, {
	                path: data_service_22.contasContabeisRouter,
	                component: conta_contabil_component_1.ContaContabilComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: conta_contabil_routing_1.contaContabilRoutes
	            }
	        ]
	    }, {
	        path: data_service_25.despachosRoute,
	        component: despachos_component_1.DespachosComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: despachos_routing_module_1.despachosRoutes
	    }, {
	        path: data_service_27.rastreamentosRoute,
	        component: rastreamentos_component_1.RastreamentosComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: rastreamentos_routing_module_1.rastreamentosRoutes
	    }
	];


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var HomeComponent = (function () {
	    function HomeComponent() {
	    }
	    HomeComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(169)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], HomeComponent);
	    return HomeComponent;
	}());
	exports.HomeComponent = HomeComponent;


/***/ },
/* 169 */
/***/ function(module, exports) {

	module.exports = "<h1>Home</h1>\n";

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var RecursosHumanosComponent = (function () {
	    function RecursosHumanosComponent() {
	    }
	    RecursosHumanosComponent.prototype.ngOnInit = function () {
	    };
	    RecursosHumanosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(171)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], RecursosHumanosComponent);
	    return RecursosHumanosComponent;
	}());
	exports.RecursosHumanosComponent = RecursosHumanosComponent;


/***/ },
/* 171 */
/***/ function(module, exports) {

	module.exports = "<router-outlet></router-outlet>\n";

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PessoasComponent = (function () {
	    function PessoasComponent() {
	    }
	    PessoasComponent.prototype.ngOnInit = function () {
	    };
	    PessoasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(173)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PessoasComponent);
	    return PessoasComponent;
	}());
	exports.PessoasComponent = PessoasComponent;


/***/ },
/* 173 */
171,
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var pessoa_list_component_1 = __webpack_require__(175);
	var pessoa_form_component_1 = __webpack_require__(181);
	var data_service_1 = __webpack_require__(178);
	var PessoasRoutingModule = (function () {
	    function PessoasRoutingModule() {
	    }
	    PessoasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PessoasRoutingModule);
	    return PessoasRoutingModule;
	}());
	exports.PessoasRoutingModule = PessoasRoutingModule;
	exports.pessoasRoutes = [
	    {
	        path: '',
	        component: pessoa_list_component_1.PessoaListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: pessoa_form_component_1.PessoaFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: pessoa_form_component_1.PessoaFormComponent
	    }
	];


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(144);
	var pessoa_api_service_1 = __webpack_require__(176);
	var pessoa_navigation_service_1 = __webpack_require__(177);
	var util_service_1 = __webpack_require__(88);
	var PessoaListComponent = (function () {
	    function PessoaListComponent(_pessoasApiService, _pessoaNavigationService, _utilService) {
	        this._pessoasApiService = _pessoasApiService;
	        this._pessoaNavigationService = _pessoaNavigationService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.pessoasModuleName = data_service_1.pessoasModuleName;
	    }
	    PessoaListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    PessoaListComponent.prototype.clickNew = function () {
	        this._pessoaNavigationService.goToNew();
	    };
	    PessoaListComponent.prototype.clickEdit = function (item) {
	        this._pessoaNavigationService.goToEdit(item.id);
	    };
	    PessoaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    PessoaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._pessoasApiService.onGetAll(onDone);
	    };
	    PessoaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._pessoasApiService.onDelete(item.id, onDone);
	    };
	    PessoaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(179),
	            styles: [__webpack_require__(180)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof pessoa_api_service_1.PessoaApiService !== 'undefined' && pessoa_api_service_1.PessoaApiService) === 'function' && _a) || Object, (typeof (_b = typeof pessoa_navigation_service_1.PessoaNavigationService !== 'undefined' && pessoa_navigation_service_1.PessoaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object])
	    ], PessoaListComponent);
	    return PessoaListComponent;
	    var _a, _b, _c;
	}());
	exports.PessoaListComponent = PessoaListComponent;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(144);
	var PessoaApiService = (function () {
	    function PessoaApiService(_restService) {
	        this._restService = _restService;
	    }
	    PessoaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    PessoaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    PessoaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    PessoaApiService.prototype.onGetAll = function (done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', {}, done); //busca pessoas populado com funcionarios
	    };
	    PessoaApiService.prototype.onGetAllActive = function (done) {
	        var filter = { "where": { "ativo": true }, "order": "nome" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    PessoaApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    PessoaApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //pessoa imagem
	    PessoaApiService.prototype.onPostImage = function (object, done) {
	        this._restService.onPost(data_service_1.pessoaImageApiName, object, done);
	    };
	    PessoaApiService.prototype.onPutImage = function (object, done) {
	        this._restService.onPut(data_service_1.pessoaImageApiName, object, done);
	    };
	    PessoaApiService.prototype.onDeleteImage = function (objectId, done) {
	        this._restService.onDelete(data_service_1.pessoaImageApiName, objectId, done);
	    };
	    PessoaApiService.prototype.onGetByPessoa = function (pessoaId, done) {
	        var filter = { where: { pessoaId: pessoaId, ativo: true } };
	        this._restService.onGetPost(data_service_1.pessoaImageApiName, filter, done);
	    };
	    PessoaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], PessoaApiService);
	    return PessoaApiService;
	    var _a;
	}());
	exports.PessoaApiService = PessoaApiService;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(144);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(145);
	var PessoaNavigationService = (function () {
	    function PessoaNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.pessoasRoute;
	        this.fatherRouter = data_service_3.recursosHumanosRoute;
	    }
	    PessoaNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    PessoaNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    PessoaNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    PessoaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], PessoaNavigationService);
	    return PessoaNavigationService;
	    var _a;
	}());
	exports.PessoaNavigationService = PessoaNavigationService;


/***/ },
/* 178 */
/***/ function(module, exports) {

	/**
	 * Created by Daniela on 19/10/2016.
	 */
	"use strict";
	exports.newRoute = 'novo';
	exports.newRouteFemale = 'nova';
	exports.editRoute = 'editar';
	exports.detailRoute = 'detalhe';
	exports.configuracaoRoute = 'configuracoes';
	exports.configuracaoModuleName = { plural: 'Configurações', single: 'Configuração' };


/***/ },
/* 179 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{pessoasModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{pessoasModuleName.single | lowercase}} cadastrada</p>\n\n  <table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n      <th>Nome</th>\n      <th class=\"small\">Funcionário</th>\n      <th class=\"small\"></th>\n    </tr>\n    </thead>\n    <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['nome'] | filterActive:showDisabled | sort:['nome'])\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n      <td><span class=\"geo-arrow\"></span> {{item.nome}}</td>\n      <td class=\"small\">\n        <span *ngIf=\"item.Funcionario && item.Funcionario.ativo\">Sim</span><span *ngIf=\"!item.Funcionario || !item.Funcionario.ativo\">Não</span>\n      </td>\n      <td class=\"geo-table--action\">\n        <a (click)=\"clickEdit(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n        </a>\n        <a (click)=\"clickDelete(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n        </a>\n      </td>\n    </tr>\n    <tr class=\"description\">\n      <td colspan=\"100%\">\n        <div class=\"geo-content__row\">\n          <div class=\"geo-columns--6c\">\n            <p><strong>Email: </strong> {{item.email}} <i *ngIf=\"!item.email\">não cadastrado</i></p>\n            <p><strong>Telefone: </strong> {{item.telefone | phoneMask}} <i *ngIf=\"!item.telefone\">não cadastrado</i></p>\n          </div>\n          <div class=\"geo-columns--6c\">\n            <p><strong>CPF: </strong> {{item.cpf | cpfMask}} <i *ngIf=\"!item.cpf\">não cadastrado</i></p>\n            <p><strong>RG: </strong> {{item.rg}} <i *ngIf=\"!item.rg\">não cadastrado</i></p>\n            <p><strong>Órgão expedidor: </strong> {{item.rgOrgaoExpedidor}} <i *ngIf=\"!item.rgOrgaoExpedidor\">não cadastrado</i></p>\n          </div>\n        </div>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n";

/***/ },
/* 180 */
166,
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(145);
	var data_service_2 = __webpack_require__(144);
	var pessoa_model_1 = __webpack_require__(182);
	var data_service_3 = __webpack_require__(178);
	var pessoa_navigation_service_1 = __webpack_require__(177);
	var pessoa_api_service_1 = __webpack_require__(176);
	var funcionario_model_1 = __webpack_require__(183);
	var funcionario_api_service_1 = __webpack_require__(184);
	var phone_validation_1 = __webpack_require__(92);
	var email_validation_1 = __webpack_require__(91);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var pessoa_service_1 = __webpack_require__(186);
	var cpf_validation_1 = __webpack_require__(116);
	var att_service_1 = __webpack_require__(141);
	var PessoaFormComponent = (function () {
	    function PessoaFormComponent(_route, _pessoaNavigationService, _pessoaApiService, _funcionarioApiService, _utilService, _autocompleteService, _pessoaService, _attService, _fb) {
	        this._route = _route;
	        this._pessoaNavigationService = _pessoaNavigationService;
	        this._pessoaApiService = _pessoaApiService;
	        this._funcionarioApiService = _funcionarioApiService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._pessoaService = _pessoaService;
	        this._attService = _attService;
	        this._fb = _fb;
	        this.recursosHumanosModule = data_service_1.recursosHumanosModuleName;
	        this.pessoasModule = data_service_2.pessoasModuleName;
	        this.formObject = new pessoa_model_1.Pessoa();
	        this.funcionarioObject = new funcionario_model_1.Funcionario();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.isFuncionario = false;
	        this.imageUrl = '';
	        this.nome = new forms_1.FormControl('', forms_1.Validators.required);
	        this.ativo = new forms_1.FormControl('');
	        this.email = new forms_1.FormControl('', forms_1.Validators.compose([email_validation_1.EmailValidator.emailFormat]));
	        this.rg = new forms_1.FormControl('');
	        this.rgOrgaoExpedidor = new forms_1.FormControl('');
	        this.telefone = new forms_1.FormControl('', forms_1.Validators.compose([phone_validation_1.PhoneValidator.phoneFormat]));
	        this.funcionario = new forms_1.FormControl('');
	        this.cpf = new forms_1.FormControl('', forms_1.Validators.compose([cpf_validation_1.CpfValidator.cpfFormat]));
	        this.returnToOtherForm = false;
	        this.imageToSave = {};
	        this.onDoneFuncionario = (function (Response) {
	            var funcionarioObject = Response;
	            funcionarioObject.pessoa = this.responsePessoa;
	            this.responsePessoa = funcionarioObject;
	            this.btnSaveDisabled = false;
	            this.toLeaveHere();
	        }.bind(this));
	        this.responseSuccessS3File = (function (response) {
	            var description = this.formObject.nome;
	            var newAtt = {
	                descricao: description,
	                url: response.url,
	                formato: response.fileExtension,
	                data: new Date(),
	                ativo: true,
	                pessoaId: this.formObject.id
	            };
	            if (this.imageToSave.id) {
	                newAtt.id = this.imageToSave.id;
	            }
	            this.imageUrl = response.url;
	            this.imageToSave = newAtt;
	            if (this.formObject.id) {
	                this.onSaveFile();
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            email: this.email,
	            nome: this.nome,
	            rg: this.rg,
	            rgOrgaoExpedidor: this.rgOrgaoExpedidor,
	            telefone: this.telefone,
	            funcionario: this.funcionario,
	            cpf: this.cpf
	        });
	    }
	    PessoaFormComponent.prototype.ngOnInit = function () {
	        this.setImagePattern();
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.actionTitle = data_service_3.editRoute;
	            this.getObject(id);
	            this.getImage(id);
	        }
	        else {
	            this.actionTitle = data_service_3.newRouteFemale;
	            this.isNewAutoComplete();
	        }
	    };
	    PessoaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    PessoaFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    PessoaFormComponent.prototype.clickRemoverImagem = function () {
	        var onDelete = (function () {
	            this.onDeleteFile();
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    PessoaFormComponent.prototype.changeFile = function (e) {
	        var target = e.target;
	        var isValid = this._attService.isValidAttachment(target, true, false);
	        if (isValid) {
	            this._attService.loadFile(target.files[0], this.responseSuccessS3File);
	        }
	    };
	    PessoaFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this.formObject;
	            if (object.telefone) {
	                object.telefone = this._utilService.removeSpecialCharacter(object.telefone);
	            }
	            if (object.cpf) {
	                object.cpf = this._utilService.removeSpecialCharacter(object.cpf);
	            }
	            if (object.id) {
	                this.onEditPessoa(object);
	            }
	            else {
	                this.onAddPessoa(object);
	            }
	        }
	    };
	    PessoaFormComponent.prototype.onAddPessoa = function (object) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.responsePessoa = Response;
	                if (this.imageToSave.ativo) {
	                    this.imageToSave.descricao = Response.nome;
	                    this.imageToSave.pessoaId = Response.id;
	                    this.onSaveFile();
	                }
	                if (this.isFuncionario) {
	                    this.onAddFuncionario(Response.id);
	                }
	                else {
	                    this.toLeaveHere();
	                }
	                this._utilService.swalMessageAddSuccess();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._pessoaApiService.onPost(object, onDone);
	    };
	    PessoaFormComponent.prototype.onEditPessoa = function (object) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.funcionarioObject && this.funcionarioObject.id) {
	                    var object_1 = this.funcionarioObject;
	                    object_1.ativo = this.isFuncionario;
	                    this.onEditFuncionario(object_1);
	                }
	                else if (this.isFuncionario) {
	                    //se a pessoa nao era um funcionario e foi editado adicionado o funcionario
	                    this.onAddFuncionario(this.formObject.id);
	                }
	                else {
	                    this.goToList();
	                }
	                this._utilService.swalMessageEditSuccess();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._pessoaApiService.onPut(object, onDone);
	    };
	    PessoaFormComponent.prototype.onAddFuncionario = function (pessoaId) {
	        var object = new funcionario_model_1.Funcionario();
	        object.pessoaId = pessoaId;
	        this._funcionarioApiService.onPost(object, this.onDoneFuncionario);
	    };
	    PessoaFormComponent.prototype.onEditFuncionario = function (object) {
	        this._funcionarioApiService.onPut(object, this.onDoneFuncionario);
	    };
	    PessoaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.getFuncionario(Response.id);
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma pessoa encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._pessoaApiService.onGetById(id, onDone);
	    };
	    PessoaFormComponent.prototype.getImage = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (Response.length) {
	                    this.imageUrl = Response[0].url;
	                    this.imageToSave = Response[0];
	                }
	            }
	        }.bind(this));
	        this._pessoaApiService.onGetByPessoa(id, onDone);
	    };
	    PessoaFormComponent.prototype.getFuncionario = function (personId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.funcionarioObject = Response[0];
	                if (this.funcionarioObject) {
	                    if (this.funcionarioObject.ativo) {
	                        this.isFuncionario = true;
	                    }
	                }
	            }
	        }.bind(this));
	        this._funcionarioApiService.onGetByPerson(personId, onDone);
	    };
	    PessoaFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_2.pessoasStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.nome = newAutoComplete.nome;
	            this.isFuncionario = newAutoComplete.isFuncionario;
	        }
	    };
	    PessoaFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._pessoaService.returnToOtherForm(this.otherForm, this.responsePessoa);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    PessoaFormComponent.prototype.goToList = function () {
	        this._pessoaNavigationService.goToList();
	    };
	    PessoaFormComponent.prototype.onSaveFile = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageAddSuccess();
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        if (this.imageToSave.id) {
	            this._pessoaApiService.onPutImage(this.imageToSave, onDone);
	        }
	        else {
	            this._pessoaApiService.onPostImage(this.imageToSave, onDone);
	        }
	    };
	    PessoaFormComponent.prototype.onDeleteFile = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.setImagePattern();
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        if (this.imageToSave.id) {
	            this._pessoaApiService.onDeleteImage(this.imageToSave.id, onDone);
	        }
	        else {
	            this.imageToSave = {};
	            this.setImagePattern();
	            this._utilService.swalMessageDeleteSuccess();
	            ;
	        }
	    };
	    PessoaFormComponent.prototype.setImagePattern = function () {
	        this.imageUrl = '';
	    };
	    PessoaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(205),
	            styles: [__webpack_require__(206)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof pessoa_navigation_service_1.PessoaNavigationService !== 'undefined' && pessoa_navigation_service_1.PessoaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof pessoa_api_service_1.PessoaApiService !== 'undefined' && pessoa_api_service_1.PessoaApiService) === 'function' && _c) || Object, (typeof (_d = typeof funcionario_api_service_1.FuncionarioApiService !== 'undefined' && funcionario_api_service_1.FuncionarioApiService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof pessoa_service_1.PessoaService !== 'undefined' && pessoa_service_1.PessoaService) === 'function' && _g) || Object, (typeof (_h = typeof att_service_1.AttService !== 'undefined' && att_service_1.AttService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], PessoaFormComponent);
	    return PessoaFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.PessoaFormComponent = PessoaFormComponent;


/***/ },
/* 182 */
/***/ function(module, exports) {

	"use strict";
	var Pessoa = (function () {
	    function Pessoa() {
	    }
	    return Pessoa;
	}());
	exports.Pessoa = Pessoa;
	var PessoaImagem = (function () {
	    function PessoaImagem() {
	    }
	    return PessoaImagem;
	}());
	exports.PessoaImagem = PessoaImagem;


/***/ },
/* 183 */
/***/ function(module, exports) {

	"use strict";
	var Funcionario = (function () {
	    function Funcionario() {
	    }
	    return Funcionario;
	}());
	exports.Funcionario = Funcionario;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(185);
	var FuncionarioApiService = (function () {
	    function FuncionarioApiService(_restService) {
	        this._restService = _restService;
	    }
	    FuncionarioApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    FuncionarioApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    FuncionarioApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    FuncionarioApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "nome" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    FuncionarioApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGet(data_service_1.apiName + '/' + objectId + '?', done);
	    };
	    FuncionarioApiService.prototype.onGetByPerson = function (personId, done) {
	        var filter = { "where": { "pessoaId": personId } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    FuncionarioApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    FuncionarioApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], FuncionarioApiService);
	    return FuncionarioApiService;
	    var _a;
	}());
	exports.FuncionarioApiService = FuncionarioApiService;


/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'funcionarios';
	exports.funcionariosQueryComPessoa = { "Pessoa": { "nome": { "regexp": "/REPLACEHERE/i" }, "ativo": true }, "ativo": true };


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(144);
	var data_service_2 = __webpack_require__(146);
	var motorista_navigation_service_1 = __webpack_require__(187);
	var motorista_service_1 = __webpack_require__(188);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_3 = __webpack_require__(149);
	var orgao_service_1 = __webpack_require__(189);
	var orgao_navigation_service_1 = __webpack_require__(204);
	var PessoaService = (function () {
	    function PessoaService(_motoristaNavigationService, _motoristaService, _orgaoNavigationService, _orgaoService, _autocompleteService) {
	        this._motoristaNavigationService = _motoristaNavigationService;
	        this._motoristaService = _motoristaService;
	        this._orgaoNavigationService = _orgaoNavigationService;
	        this._orgaoService = _orgaoService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    PessoaService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.pessoasStorage + '-new', object);
	    };
	    PessoaService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.pessoasStorage + "-new");
	        return JSON.parse(item);
	    };
	    PessoaService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_2.motoristasStorage) {
	                otherFormObject = this._motoristaService.getSessionStorage();
	                otherFormObject.funcionario = Response;
	                this._motoristaService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.orgaosStorage) {
	                otherFormObject = this._orgaoService.getSessionStorage();
	                otherFormObject.responsavel = Response;
	                this._orgaoService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.pessoasStorage);
	        if (otherForm === data_service_2.motoristasStorage) {
	            otherFormObject = this._motoristaService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._motoristaNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._motoristaNavigationService.goToNew();
	            }
	        }
	        else if (otherForm === data_service_3.orgaosStorage) {
	            otherFormObject = this._orgaoService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._orgaoNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._orgaoNavigationService.goToNew();
	            }
	        }
	    };
	    PessoaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof motorista_navigation_service_1.MotoristaNavigationService !== 'undefined' && motorista_navigation_service_1.MotoristaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof motorista_service_1.MotoristaService !== 'undefined' && motorista_service_1.MotoristaService) === 'function' && _b) || Object, (typeof (_c = typeof orgao_navigation_service_1.OrgaoNavigationService !== 'undefined' && orgao_navigation_service_1.OrgaoNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof orgao_service_1.OrgaoService !== 'undefined' && orgao_service_1.OrgaoService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object])
	    ], PessoaService);
	    return PessoaService;
	    var _a, _b, _c, _d, _e;
	}());
	exports.PessoaService = PessoaService;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(146);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(145);
	var MotoristaNavigationService = (function () {
	    function MotoristaNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.motoristasRoute;
	        this.fatherRouter = data_service_3.recursosHumanosRoute;
	    }
	    MotoristaNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    MotoristaNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    MotoristaNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    MotoristaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], MotoristaNavigationService);
	    return MotoristaNavigationService;
	    var _a;
	}());
	exports.MotoristaNavigationService = MotoristaNavigationService;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(146);
	var autocomplete_service_1 = __webpack_require__(101);
	var MotoristaService = (function () {
	    function MotoristaService(_autocompleteService) {
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var name;
	                        if (state.funcionario) {
	                            if (state.funcionario.pessoa) {
	                                name = state.funcionario.pessoa.nome;
	                            }
	                        }
	                        text = name;
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    MotoristaService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.motoristasStorage + '-new', object);
	    };
	    MotoristaService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.motoristasStorage + "-new");
	        return JSON.parse(item);
	    };
	    MotoristaService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.motoristasStorage + "-new");
	    };
	    MotoristaService.prototype.returnToOtherForm = function (otherForm, Response) {
	    };
	    MotoristaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object])
	    ], MotoristaService);
	    return MotoristaService;
	    var _a;
	}());
	exports.MotoristaService = MotoristaService;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(149);
	var data_service_2 = __webpack_require__(190);
	var area_navigation_service_1 = __webpack_require__(191);
	var area_service_1 = __webpack_require__(192);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_3 = __webpack_require__(154);
	var frota_service_1 = __webpack_require__(203);
	var frota_navigation_service_1 = __webpack_require__(198);
	var OrgaoService = (function () {
	    function OrgaoService(_areaNavigationService, _areaService, _frotaNavigationService, _frotaService, _autocompleteService) {
	        this._areaNavigationService = _areaNavigationService;
	        this._areaService = _areaService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaService = _frotaService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    OrgaoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.orgaosStorage + '-new', object);
	    };
	    OrgaoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.orgaosStorage + "-new");
	        return JSON.parse(item);
	    };
	    OrgaoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.orgaosStorage + "-new");
	    };
	    OrgaoService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.areasStorage) {
	                otherFormObject = this._areaService.getSessionStorage();
	                otherFormObject.orgao = Response;
	                this._areaService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.frotasStorage) {
	                otherFormObject = this._frotaService.getSessionStorage();
	                otherFormObject.orgao = Response;
	                this._frotaService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.orgaosStorage);
	        if (otherForm === data_service_2.areasStorage) {
	            otherFormObject = this._areaService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._areaNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._areaNavigationService.goToNew();
	            }
	        }
	        else if (otherForm === data_service_3.frotasStorage) {
	            otherFormObject = this._frotaService.getSessionStorage();
	            var frotasRoute = otherFormObject.thisRoute;
	            if (otherFormObject.id) {
	                this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
	            }
	            else {
	                this._frotaNavigationService.goToNew(frotasRoute);
	            }
	        }
	    };
	    OrgaoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof area_navigation_service_1.AreaNavigationService !== 'undefined' && area_navigation_service_1.AreaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof area_service_1.AreaService !== 'undefined' && area_service_1.AreaService) === 'function' && _b) || Object, (typeof (_c = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object])
	    ], OrgaoService);
	    return OrgaoService;
	    var _a, _b, _c, _d, _e;
	}());
	exports.OrgaoService = OrgaoService;


/***/ },
/* 190 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'areas';
	exports.areasRoute = 'areas';
	exports.areasStorage = 'areas';
	exports.areasModuleName = { plural: 'Áreas', single: 'Área' };
	exports.areasQuery = {
	    "where": {
	        "ativo": true,
	        "nome": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "nome"
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(190);
	var data_service_2 = __webpack_require__(147);
	var auth_service_1 = __webpack_require__(61);
	var data_service_3 = __webpack_require__(178);
	var data_service_4 = __webpack_require__(149);
	var AreaNavigationService = (function () {
	    function AreaNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.areasRoute;
	        this.orgaosRouter = data_service_4.orgaosRoute;
	        this.fatherRouter = data_service_2.estruturasRoute;
	    }
	    AreaNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.orgaosRouter;
	        this._authService.navigateTo(router);
	    };
	    AreaNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    AreaNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    AreaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], AreaNavigationService);
	    return AreaNavigationService;
	    var _a;
	}());
	exports.AreaNavigationService = AreaNavigationService;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(190);
	var divisao_navigation_service_1 = __webpack_require__(193);
	var divisao_service_1 = __webpack_require__(194);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(150);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_service_1 = __webpack_require__(203);
	var data_service_3 = __webpack_require__(154);
	var AreaService = (function () {
	    function AreaService(_divisaoService, _divisaoNavigationService, _frotaNavigationService, _frotaService, _autocompleteService) {
	        this._divisaoService = _divisaoService;
	        this._divisaoNavigationService = _divisaoNavigationService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaService = _frotaService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    AreaService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.areasStorage + '-new', object);
	    };
	    AreaService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.areasStorage + "-new");
	        return JSON.parse(item);
	    };
	    AreaService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.areasStorage + "-new");
	    };
	    AreaService.prototype.setSessionStorageFatherModule = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.areasStorage + '-father', object);
	    };
	    AreaService.prototype.getSessionStorageFatherModule = function () {
	        var item = sessionStorage.getItem(data_service_1.areasStorage + "-father");
	        return JSON.parse(item);
	    };
	    AreaService.prototype.clearSessionStorageFatherModule = function () {
	        sessionStorage.removeItem(data_service_1.areasStorage + "-father");
	    };
	    AreaService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.divisoesStorage) {
	                otherFormObject = this._divisaoService.getSessionStorage();
	                otherFormObject.area = Response;
	                this._divisaoService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.frotasStorage) {
	                otherFormObject = this._frotaService.getSessionStorage();
	                otherFormObject.area = Response;
	                this._frotaService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.areasStorage);
	        if (otherForm === data_service_2.divisoesStorage) {
	            otherFormObject = this._divisaoService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._divisaoNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._divisaoNavigationService.goToNew();
	            }
	        }
	        else if (otherForm === data_service_3.frotasStorage) {
	            otherFormObject = this._frotaService.getSessionStorage();
	            var frotasRoute = otherFormObject.thisRoute;
	            if (otherFormObject.id) {
	                this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
	            }
	            else {
	                this._frotaNavigationService.goToNew(frotasRoute);
	            }
	        }
	    };
	    AreaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof divisao_service_1.DivisoesService !== 'undefined' && divisao_service_1.DivisoesService) === 'function' && _a) || Object, (typeof (_b = typeof divisao_navigation_service_1.DivisaoNavigationService !== 'undefined' && divisao_navigation_service_1.DivisaoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object])
	    ], AreaService);
	    return AreaService;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AreaService = AreaService;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	//
	var data_service_1 = __webpack_require__(147);
	var data_service_2 = __webpack_require__(150);
	var auth_service_1 = __webpack_require__(61);
	var data_service_3 = __webpack_require__(178);
	var DivisaoNavigationService = (function () {
	    function DivisaoNavigationService(_authService) {
	        this._authService = _authService;
	        this.fatherRouter = data_service_1.estruturasRoute;
	        this.moduleRouter = data_service_2.divisoesRoute;
	    }
	    DivisaoNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    DivisaoNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    DivisaoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    DivisaoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], DivisaoNavigationService);
	    return DivisaoNavigationService;
	    var _a;
	}());
	exports.DivisaoNavigationService = DivisaoNavigationService;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(150);
	var setor_navigation_service_1 = __webpack_require__(195);
	var setor_service_1 = __webpack_require__(197);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(196);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_service_1 = __webpack_require__(203);
	var data_service_3 = __webpack_require__(154);
	var DivisoesService = (function () {
	    function DivisoesService(_setorNavigationService, _setorService, _frotaNavigationService, _frotaService, _autocompleteService) {
	        this._setorNavigationService = _setorNavigationService;
	        this._setorService = _setorService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaService = _frotaService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    DivisoesService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.divisoesStorage + '-new', object);
	    };
	    DivisoesService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.divisoesStorage + "-new");
	        return JSON.parse(item);
	    };
	    DivisoesService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.divisoesStorage + "-new");
	    };
	    DivisoesService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.setoresStorage) {
	                otherFormObject = this._setorService.getSessionStorage();
	                otherFormObject.divisao = Response;
	                this._setorService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.frotasStorage) {
	                otherFormObject = this._frotaService.getSessionStorage();
	                otherFormObject.divisao = Response;
	                this._frotaService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.divisoesStorage);
	        if (otherForm === data_service_2.setoresStorage) {
	            otherFormObject = this._setorService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._setorNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._setorNavigationService.goToNew();
	            }
	        }
	        else if (otherForm === data_service_3.frotasStorage) {
	            otherFormObject = this._frotaService.getSessionStorage();
	            var frotasRoute = otherFormObject.thisRoute;
	            if (otherFormObject.id) {
	                this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
	            }
	            else {
	                this._frotaNavigationService.goToNew(frotasRoute);
	            }
	        }
	    };
	    DivisoesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof setor_navigation_service_1.SetorNavigationService !== 'undefined' && setor_navigation_service_1.SetorNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof setor_service_1.SetorService !== 'undefined' && setor_service_1.SetorService) === 'function' && _b) || Object, (typeof (_c = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object])
	    ], DivisoesService);
	    return DivisoesService;
	    var _a, _b, _c, _d, _e;
	}());
	exports.DivisoesService = DivisoesService;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(196);
	var data_service_2 = __webpack_require__(147);
	var auth_service_1 = __webpack_require__(61);
	var data_service_3 = __webpack_require__(178);
	var data_service_4 = __webpack_require__(150);
	var SetorNavigationService = (function () {
	    function SetorNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.setoresRoute;
	        this.divisoesRouter = data_service_4.divisoesRoute;
	        this.fatherRouter = data_service_2.estruturasRoute;
	    }
	    SetorNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.divisoesRouter;
	        this._authService.navigateTo(router);
	    };
	    SetorNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    SetorNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    SetorNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], SetorNavigationService);
	    return SetorNavigationService;
	    var _a;
	}());
	exports.SetorNavigationService = SetorNavigationService;


/***/ },
/* 196 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'setores';
	exports.setoresRoute = 'setores';
	exports.setoresStorage = 'setores';
	exports.setoresModuleName = { plural: 'Setores', single: 'Setor' };
	exports.setoresQuery = {
	    "where": {
	        "ativo": true,
	        "setor": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "setor"
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(196);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(154);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_service_1 = __webpack_require__(203);
	var SetorService = (function () {
	    function SetorService(_frotaNavigationService, _frotaService, _autocompleteService) {
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaService = _frotaService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    SetorService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.setoresStorage + '-new', object);
	    };
	    SetorService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.setoresStorage + "-new");
	        return JSON.parse(item);
	    };
	    SetorService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.setoresStorage + "-new");
	    };
	    SetorService.prototype.setSessionStorageFatherModule = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.setoresStorage + '-father', object);
	    };
	    SetorService.prototype.getSessionStorageFatherModule = function () {
	        var item = sessionStorage.getItem(data_service_1.setoresStorage + "-father");
	        return JSON.parse(item);
	    };
	    SetorService.prototype.clearSessionStorageFatherModule = function () {
	        sessionStorage.removeItem(data_service_1.setoresStorage + "-father");
	    };
	    SetorService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.frotasStorage) {
	                otherFormObject = this._frotaService.getSessionStorage();
	                otherFormObject.setor = Response;
	                this._frotaService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.setoresStorage);
	        if (otherForm === data_service_2.frotasStorage) {
	            otherFormObject = this._frotaService.getSessionStorage();
	            var frotasRoute = otherFormObject.thisRoute;
	            if (otherFormObject.id) {
	                this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
	            }
	            else {
	                this._frotaNavigationService.goToNew(frotasRoute);
	            }
	        }
	    };
	    SetorService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object])
	    ], SetorService);
	    return SetorService;
	    var _a, _b, _c;
	}());
	exports.SetorService = SetorService;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(151);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(154);
	var data_service_4 = __webpack_require__(199);
	var data_service_5 = __webpack_require__(200);
	var data_service_6 = __webpack_require__(201);
	var data_service_7 = __webpack_require__(202);
	var FrotaNavigationService = (function () {
	    function FrotaNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    FrotaNavigationService.prototype.goToList = function (moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    FrotaNavigationService.prototype.goToNew = function (moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    FrotaNavigationService.prototype.goToEdit = function (objectId, moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    FrotaNavigationService.prototype.goToDetail = function (objectId, moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_2.detailRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    FrotaNavigationService.prototype.goToFrotaImagem = function (objectId, moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/fotos';
	        this._authService.navigateTo(router, objectId);
	    };
	    FrotaNavigationService.prototype.goToFrotaOdometroHorimetro = function (objectId, moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/odometro-horimetro';
	        this._authService.navigateTo(router, objectId);
	    };
	    FrotaNavigationService.prototype.goToFrotaAbastecimento = function (moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_4.abastecimentoBensRoute;
	        this._authService.navigateTo(router);
	    };
	    FrotaNavigationService.prototype.goToFrotaManutencao = function (moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_5.ordensServicoRoute;
	        this._authService.navigateTo(router);
	    };
	    FrotaNavigationService.prototype.goToFrotaDeslocamento = function (moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_7.deslocamentosRoute + '/historico';
	        this._authService.navigateTo(router);
	    };
	    FrotaNavigationService.prototype.goToFrotaAbastecimentoNew = function (moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_4.abastecimentoBensRoute + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    FrotaNavigationService.prototype.goToFrotaManutencaoNew = function (moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_5.ordensServicoRoute + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    FrotaNavigationService.prototype.goToFrotaAbastecimentoEdit = function (moduleRouter, abastecimentoId) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_4.abastecimentoBensRoute + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, abastecimentoId);
	    };
	    FrotaNavigationService.prototype.goToFrotaManutencaoEdit = function (moduleRouter, manutencaoId) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_5.ordensServicoRoute + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, manutencaoId);
	    };
	    FrotaNavigationService.prototype.goToFrotaManutencaoDetail = function (moduleRouter, manutencaoId) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_5.ordensServicoRoute + '/' + data_service_2.detailRoute;
	        this._authService.navigateTo(router, manutencaoId);
	    };
	    FrotaNavigationService.prototype.goToFrotaPlanoManutencao = function (moduleRouter) {
	        var router = data_service_1.bensRoute + '/' + data_service_3.frotasRoute + '/' + moduleRouter + '/' + data_service_6.planosRoute;
	        this._authService.navigateTo(router);
	    };
	    FrotaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], FrotaNavigationService);
	    return FrotaNavigationService;
	    var _a;
	}());
	exports.FrotaNavigationService = FrotaNavigationService;


/***/ },
/* 199 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'abastecimentos-bens';
	exports.abastecimentoBensRoute = 'abastecimento-bens';
	exports.abastecimentoBensStorage = 'abastecimento-bens';
	exports.abastecimentoBensModuleName = { plural: 'Abastecimentos', single: 'Abastecimento' };
	exports.months = [
	    { Key: 0, Value: 'Janeiro' },
	    { Key: 1, Value: 'Fevereiro' },
	    { Key: 2, Value: 'Março' },
	    { Key: 3, Value: 'Abril' },
	    { Key: 4, Value: 'Maio' },
	    { Key: 5, Value: 'Junho' },
	    { Key: 6, Value: 'Julho' },
	    { Key: 7, Value: 'Agosto' },
	    { Key: 8, Value: 'Setembro' },
	    { Key: 9, Value: 'Outubro' },
	    { Key: 10, Value: 'Novembro' },
	    { Key: 11, Value: 'Dezembro' }
	];
	exports.TiposAbastecimentoBens = [
	    { Key: 1, Value: "Interno" },
	    { Key: 2, Value: "Externo" },
	    { Key: 3, Value: "Convênio" }
	];


/***/ },
/* 200 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'ordens-servicos';
	exports.ordensServicoRoute = 'ordens-servico';
	exports.ordensServicoItemsServicoRoute = 'servico';
	exports.ordensServicoItemsMaterialRoute = 'material';
	exports.ordensServicoStorage = 'ordens-servico';
	exports.ordensServicoItemsStorage = 'ordens-servico-itens';
	exports.ordensServicoModuleName = { plural: 'Manutenções', single: 'Manutenção' };
	exports.OrdemServicoStatus = [
	    { Key: 1, Value: "Ativo" },
	    { Key: 2, Value: "Concluído" },
	    { Key: 3, Value: "Cancelado" }
	];
	exports.TipoOrdemServico = [
	    { Key: 2, Value: "Preventiva" },
	    { Key: 1, Value: "Corretiva" }
	];
	exports.TipoMaterialServico = [
	    { Key: 2, Value: "Material" },
	    { Key: 1, Value: "Serviço" }
	];
	// export const ordemServicoQueryMateriaisServicos: any = {"where":{"ativo":true,"descricao":{"regexp":"/REPLACEHERE/i"}}};


/***/ },
/* 201 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'planos-manutencoes';
	exports.planosRoute = 'planos';
	exports.planosStorage = 'planos';
	exports.planosModuleName = { plural: 'Planos de manutenção', single: 'Plano de manutenção' };
	exports.referenciaTempo = [
	    { Key: 1, Value: 'Dia(s)' },
	    { Key: 7, Value: 'Semana(s)' },
	    { Key: 30, Value: 'Mes(es)' },
	    { Key: 365, Value: 'Ano(s)' }
	];
	exports.planoQuery = {
	    "where": {
	        "and": [
	            { "ativo": true },
	            { "titulo": { "regexp": "/REPLACEHERE/i" } }
	        ]
	    },
	    "include": ["marca", "categoria"],
	    "order": "titulo"
	};


/***/ },
/* 202 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'deslocamentos';
	exports.deslocamentosRoute = 'deslocamentos';
	exports.deslocamentosStorage = 'deslocamentos';
	exports.deslocamentosModuleName = { plural: 'Solicitações', single: 'Solicitação' };
	exports.apiNameCustosDeslocamento = 'custos-deslocamentos';
	exports.tiposDeslocamentos = [
	    { "Key": 1, "Value": "Saída" },
	    { "Key": 2, "Value": "Viagem" }
	];
	exports.statusDeslocamentos = [
	    { "Key": 3, "Value": "Aprovado" },
	    { "Key": 1, "Value": "Solicitado" },
	    { "Key": 2, "Value": "Cancelado" },
	    { "Key": 4, "Value": "Concluído" }
	];


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(154);
	var autocomplete_service_1 = __webpack_require__(101);
	var FrotasService = (function () {
	    function FrotasService(_router, _autocompleteService) {
	        this._router = _router;
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var placa = '';
	                        if (state.placa) {
	                            placa = state.placa.toUpperCase();
	                            placa = placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
	                            placa = placa + " / ";
	                        }
	                        text = placa.concat(state.identificacao);
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    FrotasService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.frotasStorage + '-new', object);
	    };
	    FrotasService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.frotasStorage + "-new");
	        return JSON.parse(item);
	    };
	    FrotasService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.frotasStorage + "-new");
	    };
	    FrotasService.prototype.setBackStorage = function (frotaObject) {
	        var object = JSON.stringify(frotaObject);
	        sessionStorage.setItem(data_service_1.frotasStorage + '-back', object);
	    };
	    FrotasService.prototype.getBackStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.frotasStorage + "-back");
	        return JSON.parse(item);
	    };
	    FrotasService.prototype.clearBackStorage = function () {
	        sessionStorage.removeItem(data_service_1.frotasStorage + "-back");
	    };
	    FrotasService.prototype.getModuleName = function () {
	        var url = this._router.url;
	        var module = {};
	        if (url.indexOf(data_service_1.aeronavesRoute) !== -1) {
	            module = data_service_1.aeronavesModuleName;
	        }
	        else if (url.indexOf(data_service_1.embarcacoesRoute) !== -1) {
	            module = data_service_1.embarcacoesModuleName;
	        }
	        else if (url.indexOf(data_service_1.equipamentosRoute) !== -1) {
	            module = data_service_1.equipamentosModuleName;
	        }
	        else if (url.indexOf(data_service_1.maquinarioRoute) !== -1) {
	            module = data_service_1.maquinarioModuleName;
	        }
	        else if (url.indexOf(data_service_1.outrosRoute) !== -1) {
	            module = data_service_1.outrosModuleName;
	        }
	        else if (url.indexOf(data_service_1.veiculosRoute) !== -1) {
	            module = data_service_1.veiculosModuleName;
	        }
	        return module;
	    };
	    FrotasService.prototype.getRouteName = function () {
	        var url = this._router.url;
	        var routeName;
	        if (url.indexOf(data_service_1.aeronavesRoute) !== -1) {
	            routeName = data_service_1.aeronavesRoute;
	        }
	        else if (url.indexOf(data_service_1.embarcacoesRoute) !== -1) {
	            routeName = data_service_1.embarcacoesRoute;
	        }
	        else if (url.indexOf(data_service_1.equipamentosRoute) !== -1) {
	            routeName = data_service_1.equipamentosRoute;
	        }
	        else if (url.indexOf(data_service_1.maquinarioRoute) !== -1) {
	            routeName = data_service_1.maquinarioRoute;
	        }
	        else if (url.indexOf(data_service_1.outrosRoute) !== -1) {
	            routeName = data_service_1.outrosRoute;
	        }
	        else if (url.indexOf(data_service_1.veiculosRoute) !== -1) {
	            routeName = data_service_1.veiculosRoute;
	        }
	        return routeName;
	    };
	    FrotasService.prototype.getModuleId = function () {
	        var url = this._router.url;
	        var moduleId;
	        if (url.indexOf(data_service_1.aeronavesRoute) !== -1) {
	            moduleId = 1;
	        }
	        else if (url.indexOf(data_service_1.embarcacoesRoute) !== -1) {
	            moduleId = 2;
	        }
	        else if (url.indexOf(data_service_1.equipamentosRoute) !== -1) {
	            moduleId = 5;
	        }
	        else if (url.indexOf(data_service_1.maquinarioRoute) !== -1) {
	            moduleId = 4;
	        }
	        else if (url.indexOf(data_service_1.outrosRoute) !== -1) {
	            moduleId = 99;
	        }
	        else if (url.indexOf(data_service_1.veiculosRoute) !== -1) {
	            moduleId = 3;
	        }
	        return moduleId;
	    };
	    FrotasService.prototype.getTipoVeiculo = function () {
	        return 3;
	    };
	    FrotasService.prototype.testBackHistory = function (autoCompleteId) {
	        var history = this.getBackStorage();
	        var settings = {
	            frotaDetailHistory: history,
	            frotasModule: this.getModuleName(),
	            frotaRoute: this.getRouteName()
	        };
	        if (settings.frotaRoute) {
	            if (autoCompleteId) {
	                this.setAutocompleteOption(autoCompleteId, history);
	            }
	            settings.showFrotaLink = true;
	        }
	        else {
	            this.clearBackStorage();
	            settings.showFrotaLink = false;
	        }
	        return settings;
	    };
	    FrotasService.prototype.setAutocompleteOption = function (autoCompleteId, frotaObject) {
	        var placa = '';
	        if (frotaObject.placa) {
	            placa = frotaObject.placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
	            placa = placa + ' / ';
	        }
	        var selectObject = { text: placa.concat(frotaObject.identificacao), id: frotaObject.id };
	        this._autocompleteService.createOptionOnSelect2(autoCompleteId, selectObject);
	        this._autocompleteService.setValueOnSelect2(selectObject.id, autoCompleteId);
	    };
	    FrotasService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _b) || Object])
	    ], FrotasService);
	    return FrotasService;
	    var _a, _b;
	}());
	exports.FrotasService = FrotasService;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(149);
	var data_service_2 = __webpack_require__(147);
	var auth_service_1 = __webpack_require__(61);
	var data_service_3 = __webpack_require__(178);
	var OrgaoNavigationService = (function () {
	    function OrgaoNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    OrgaoNavigationService.prototype.goToList = function () {
	        var router = data_service_2.estruturasRoute + '/' + data_service_1.orgaosRoute;
	        this._authService.navigateTo(router);
	    };
	    OrgaoNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.estruturasRoute + '/' + data_service_1.orgaosRoute + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    OrgaoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.estruturasRoute + '/' + data_service_1.orgaosRoute + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    OrgaoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], OrgaoNavigationService);
	    return OrgaoNavigationService;
	    var _a;
	}());
	exports.OrgaoNavigationService = OrgaoNavigationService;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{pessoasModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{pessoasModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{pessoasModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--3c geo-columns--center\">\n            <div class=\"geo-send-file\" data-picture=\"\">\n                <label for=\"file\">\n                    <img [src]=\"imageUrl\" class=\"profile-picture--big\" *ngIf=\"imageUrl\">\n                    <img src=\"" + __webpack_require__(165) + "\" class=\"profile-picture--big\" *ngIf=\"!imageUrl\">\n                    <span>Selecione uma foto</span>\n                </label>\n                <input id=\"file\" type=\"file\" (change)=\"changeFile($event)\">\n            </div>\n            <br />\n            <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickRemoverImagem()\">Remover foto</button>\n        </div>\n        <div class=\"geo-columns--9c\">\n            <div class=\"geo-content__row\">\n                <div class=\"geo-input--9c\" [ngClass]=\"{'geo-input--error': !nome.valid && submitted}\">\n                    <label for=\"nome\">Nome <abbr>*</abbr></label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!nome.valid && submitted\">Este campo é obrigatório.</span>\n                        <input type=\"text\" id=\"nome\" [(ngModel)]=\"formObject.nome\" formControlName=\"nome\" autofocus>\n                    </div>\n                </div>\n\n                <div class=\"geo-toggle toggleFuncionario\">\n                    <input type=\"checkbox\" id=\"funcionario\" value=\"\" [(ngModel)]=\"isFuncionario\" formControlName=\"funcionario\">\n                    <label for=\"funcionario\">É funcionário</label>\n                </div>\n\n                <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !telefone.valid && submitted}\">\n                    <label for=\"telefone\">Telefone</label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!telefone.valid && submitted\">Número de telefone inválido.</span>\n                        <input type=\"text\" id=\"telefone\" [(ngModel)]=\"formObject.telefone\" formControlName=\"telefone\" appPhoneMask maxlength=\"15\">\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !email.valid && submitted}\">\n                    <label for=\"email\">Email</label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!email.valid && submitted\">Email inválido.</span>\n                        <input type=\"text\" id=\"email\" [(ngModel)]=\"formObject.email\" formControlName=\"email\">\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !cpf.valid && submitted}\">\n                    <label for=\"rg\">CPF</label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!cpf.valid && submitted\">CPF inválido.</span>\n                        <input type=\"text\" id=\"cpf\" [(ngModel)]=\"formObject.cpf\" formControlName=\"cpf\" appCpfMask maxlength=\"14\">\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c\" >\n                    <label for=\"rg\">RG</label>\n                    <div>\n                        <input type=\"text\" id=\"rg\" [(ngModel)]=\"formObject.rg\" formControlName=\"rg\">\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c\" >\n                    <label for=\"rgOrgaoExpedidor\">Órgão expedidor</label>\n                    <div>\n                        <input type=\"text\" id=\"rgOrgaoExpedidor\" [(ngModel)]=\"formObject.rgOrgaoExpedidor\" formControlName=\"rgOrgaoExpedidor\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 206 */
/***/ function(module, exports) {

	module.exports = "@media only screen and (min-width: 821px) {\n  .toggleFuncionario {\n    margin-top: 36px;\n  }\n}\n"

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var motorista_list_component_1 = __webpack_require__(208);
	var motorista_form_component_1 = __webpack_require__(212);
	var data_service_1 = __webpack_require__(178);
	var MotoristasRoutingModule = (function () {
	    function MotoristasRoutingModule() {
	    }
	    MotoristasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MotoristasRoutingModule);
	    return MotoristasRoutingModule;
	}());
	exports.MotoristasRoutingModule = MotoristasRoutingModule;
	exports.motoristasRoutes = [
	    {
	        path: '',
	        component: motorista_list_component_1.MotoristaListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: motorista_form_component_1.MotoristaFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: motorista_form_component_1.MotoristaFormComponent
	    }
	];


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(146);
	var motorista_api_service_1 = __webpack_require__(209);
	var motorista_navigation_service_1 = __webpack_require__(187);
	var util_service_1 = __webpack_require__(88);
	var motorista_service_1 = __webpack_require__(188);
	var MotoristaListComponent = (function () {
	    function MotoristaListComponent(_motoristasApiService, _motoristaNavigationService, _motoristaService, _utilService) {
	        this._motoristasApiService = _motoristasApiService;
	        this._motoristaNavigationService = _motoristaNavigationService;
	        this._motoristaService = _motoristaService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.motoristasModuleName = data_service_1.motoristasModuleName;
	    }
	    MotoristaListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    MotoristaListComponent.prototype.clickNew = function () {
	        this._motoristaService.clearSessionStorage();
	        this._motoristaNavigationService.goToNew();
	    };
	    MotoristaListComponent.prototype.clickEdit = function (item) {
	        this._motoristaService.clearSessionStorage();
	        this._motoristaNavigationService.goToEdit(item.id);
	    };
	    MotoristaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    MotoristaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._motoristasApiService.onGetAll(onDone);
	    };
	    MotoristaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._motoristasApiService.onDelete(item.id, onDone);
	    };
	    MotoristaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(210),
	            styles: [__webpack_require__(211)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof motorista_api_service_1.MotoristaApiService !== 'undefined' && motorista_api_service_1.MotoristaApiService) === 'function' && _a) || Object, (typeof (_b = typeof motorista_navigation_service_1.MotoristaNavigationService !== 'undefined' && motorista_navigation_service_1.MotoristaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof motorista_service_1.MotoristaService !== 'undefined' && motorista_service_1.MotoristaService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], MotoristaListComponent);
	    return MotoristaListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MotoristaListComponent = MotoristaListComponent;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(146);
	var MotoristaApiService = (function () {
	    function MotoristaApiService(_restService) {
	        this._restService = _restService;
	    }
	    MotoristaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    MotoristaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    MotoristaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    MotoristaApiService.prototype.onGetAll = function (done) {
	        var filter = { "include": [{ "funcionario": ["pessoa"] }, "categoriaCnh"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    MotoristaApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": [{ "funcionario": ["pessoa"] }, "categoriaCnh"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    MotoristaApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    MotoristaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], MotoristaApiService);
	    return MotoristaApiService;
	    var _a;
	}());
	exports.MotoristaApiService = MotoristaApiService;


/***/ },
/* 210 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <h1>{{motoristasModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{motoristasModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Motorista</th>\n            <th>CNH</th>\n            <th>Validade da habilitação</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['funcionario.pessoa.nome', 'cnh', 'validadeHabilitacao'] | filterActive:showDisabled | sort:['funcionario.pessoa.nome'])\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>\n                <span *ngIf=\"item.funcionario\">\n          <span *ngIf=\"item.funcionario.pessoa\">{{item.funcionario.pessoa.nome}}</span>\n        </span>\n            </td>\n            <td>\n                {{item.cnh}}\n            </td>\n            <td>\n                {{item.validadeHabilitacao | date: 'dd/MM/yyyy'}}\n            </td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div class=\"geo-content__row\">\n                    <div class=\"geo-columns--6c\">\n                        <p><strong>Categoria CNH: </strong>\n                            <span *ngIf=\"item.categoriaCnh\">{{item.categoriaCnh.categoria}}</span>\n                            <i *ngIf=\"!item.categoriaCnh\">não cadastrado</i>\n                        </p>\n                        <p><strong>1ª habilitação: </strong> <span>{{item.primeiraHabilitacao | date: 'dd/MM/yyyy'}}</span> <i *ngIf=\"!item.primeiraHabilitacao\">não cadastrado</i></p>\n                        <p><strong>Matrícula: </strong> <span>{{item.matricula}}</span> <i *ngIf=\"!item.matricula\">não cadastrado</i></p>\n                        <p><strong>Data da admissão: </strong> <span>{{item.dataAdmissao | date: 'dd/MM/yyyy'}}</span> <i *ngIf=\"!item.dataAdmissao\">não cadastrado</i></p>\n                        <p><strong>Data da demissão: </strong> <span>{{item.dataDemissao | date: 'dd/MM/yyyy'}}</span> <i *ngIf=\"!item.dataDemissao\">não cadastrado</i></p>\n                    </div>\n                    <div class=\"geo-columns--6c\">\n                        <p><strong>Vínculo empregatício: </strong> <span *ngIf=\"item.vinculoEmpregaticio\">Sim</span><span *ngIf=\"!item.vinculoEmpregaticio\">Não</span></p>\n                        <p><strong>Uso obrigatório de lentes: </strong> <span *ngIf=\"item.lentesObrigatorias\">Sim</span><span *ngIf=\"!item.lentesObrigatorias\">Não</span></p>\n                        <p><strong>Observação: </strong> {{item.observacoes}} <i *ngIf=\"!item.observacoes\">não cadastrado</i></p>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 211 */
166,
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(145);
	var data_service_2 = __webpack_require__(146);
	var motorista_model_1 = __webpack_require__(213);
	var motorista_navigation_service_1 = __webpack_require__(187);
	var motorista_api_service_1 = __webpack_require__(209);
	var funcionario_api_service_1 = __webpack_require__(184);
	var util_service_1 = __webpack_require__(88);
	var data_service_3 = __webpack_require__(178);
	var funcionario_model_1 = __webpack_require__(183);
	var funcionario_service_1 = __webpack_require__(214);
	var cnh_validation_1 = __webpack_require__(215);
	var autocomplete_service_1 = __webpack_require__(101);
	var motorista_service_1 = __webpack_require__(188);
	var data_service_4 = __webpack_require__(144);
	var pessoa_navigation_service_1 = __webpack_require__(177);
	var data_service_5 = __webpack_require__(185);
	var categoria_cnh_api_service_1 = __webpack_require__(216);
	var categoria_cnh_model_1 = __webpack_require__(218);
	var att_service_1 = __webpack_require__(141);
	var pessoa_api_service_1 = __webpack_require__(176);
	var MotoristaFormComponent = (function () {
	    function MotoristaFormComponent(_route, _motoristaNavigationService, _motoristaApiService, _motoristaService, _funcionarioApiService, _funcionarioService, _pessoaNavigationService, _pessoaApiService, _utilService, _autocompleteService, _categoriaCnhApiService, _attService, _fb) {
	        this._route = _route;
	        this._motoristaNavigationService = _motoristaNavigationService;
	        this._motoristaApiService = _motoristaApiService;
	        this._motoristaService = _motoristaService;
	        this._funcionarioApiService = _funcionarioApiService;
	        this._funcionarioService = _funcionarioService;
	        this._pessoaNavigationService = _pessoaNavigationService;
	        this._pessoaApiService = _pessoaApiService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._categoriaCnhApiService = _categoriaCnhApiService;
	        this._attService = _attService;
	        this._fb = _fb;
	        this.recursosHumanosModule = data_service_1.recursosHumanosModuleName;
	        this.motoristasModule = data_service_2.motoristasModuleName;
	        this.formObject = new motorista_model_1.Motorista();
	        this.funcionarioObject = new funcionario_model_1.Funcionario();
	        this.categoriaCnhObject = new categoria_cnh_model_1.CategoriaCnh();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.imageUrl = '';
	        this.funcionarioSelectId = 'funcionario';
	        this.funcionarioQuery = data_service_5.funcionariosQueryComPessoa;
	        this.categoriasCnhList = [];
	        this.cnh = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, cnh_validation_1.CnhValidator.cnhFormat]));
	        this.ativo = new forms_1.FormControl('');
	        this.dataDemissao = new forms_1.FormControl('');
	        this.dataAdmissao = new forms_1.FormControl('');
	        this.lentesObrigatorias = new forms_1.FormControl('');
	        this.observacoes = new forms_1.FormControl('');
	        this.primeiraHabilitacao = new forms_1.FormControl('');
	        this.validadeHabilitacao = new forms_1.FormControl('');
	        this.vinculoEmpregaticio = new forms_1.FormControl('');
	        this.categoriaCnh = new forms_1.FormControl('');
	        this.matricula = new forms_1.FormControl('');
	        this.funcionario = new forms_1.FormControl('', forms_1.Validators.required);
	        this.returnToOtherForm = false;
	        this.imageToSave = {};
	        this.funcionarioTemplateResult = (function (state) {
	            var template = this._funcionarioService.templateResult(state, true);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                    if (this.imageToSave.ativo) {
	                        var des = '';
	                        if (this.funcionarioObject.pessoa) {
	                            des = this.funcionarioObject.pessoa.nome;
	                        }
	                        this.imageToSave.descricao = des;
	                        this.imageToSave.pessoaId = this.funcionarioObject.pessoaId;
	                        this.onSaveFile();
	                    }
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.responseSuccessS3File = (function (response) {
	            var description = '', pessoaId = null;
	            if (this.funcionarioObject.pessoa) {
	                description = this.funcionarioObject.pessoa.nome;
	                pessoaId = this.funcionarioObject.pessoaId;
	            }
	            var newAtt = {
	                descricao: description,
	                url: response.url,
	                formato: response.fileExtension,
	                data: new Date(),
	                ativo: true,
	                pessoaId: pessoaId
	            };
	            if (this.imageToSave.id) {
	                newAtt.id = this.imageToSave.id;
	            }
	            this.imageUrl = response.url;
	            this.imageToSave = newAtt;
	            if (this.formObject.id) {
	                this.onSaveFile();
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            dataDemissao: this.dataDemissao,
	            dataAdmissao: this.dataAdmissao,
	            matricula: this.matricula,
	            cnh: this.cnh,
	            lentesObrigatorias: this.lentesObrigatorias,
	            observacoes: this.observacoes,
	            primeiraHabilitacao: this.primeiraHabilitacao,
	            validadeHabilitacao: this.validadeHabilitacao,
	            vinculoEmpregaticio: this.vinculoEmpregaticio,
	            categoriaCnh: this.categoriaCnh,
	            funcionario: this.funcionario
	        });
	    }
	    MotoristaFormComponent.prototype.ngOnInit = function () {
	        this.setImagePattern();
	        this.getCategoriasCnh();
	        this.isNewAutoComplete();
	    };
	    MotoristaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    MotoristaFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    MotoristaFormComponent.prototype.changeFile = function (e) {
	        var target = e.target;
	        var isValid = this._attService.isValidAttachment(target, true, false);
	        if (isValid) {
	            this._attService.loadFile(target.files[0], this.responseSuccessS3File);
	        }
	    };
	    MotoristaFormComponent.prototype.clickRemoverImagem = function () {
	        var onDelete = (function () {
	            this.onDeleteFile();
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    MotoristaFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            var validade_date;
	            if (this.funcionarioObject.id) {
	                object.funcionarioId = this.funcionarioObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            validade_date = document.getElementById('validade_habilitacao');
	            if (validade_date.value) {
	                object.validadeHabilitacao = this._utilService.convertStringToDate(validade_date.value);
	            }
	            else {
	                object.validadeHabilitacao = null;
	            }
	            validade_date = document.getElementById('primeira_habilitacao');
	            if (validade_date.value) {
	                object.primeiraHabilitacao = this._utilService.convertStringToDate(validade_date.value);
	            }
	            else {
	                object.primeiraHabilitacao = null;
	            }
	            validade_date = document.getElementById('demissao');
	            if (validade_date.value) {
	                object.dataDemissao = this._utilService.convertStringToDate(validade_date.value);
	            }
	            else {
	                object.dataDemissao = null;
	            }
	            validade_date = document.getElementById('admissao');
	            if (validade_date.value) {
	                object.dataAdmissao = this._utilService.convertStringToDate(validade_date.value);
	            }
	            else {
	                object.dataAdmissao = null;
	            }
	            if (this.categoriaCnhObject.id) {
	                object.categoriaCnhId = this.categoriaCnhObject.id;
	            }
	            else {
	                object.categoriaCnhId = null;
	            }
	            if (object.id) {
	                this.onEditMotorista(object);
	            }
	            else {
	                this.onAddMotorista(object);
	            }
	        }
	    };
	    MotoristaFormComponent.prototype.getFuncionariosObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.formObject;
	            thisFormObject.funcionario = this.funcionarioObject;
	            this._motoristaService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                nome: object.text,
	                isFuncionario: true,
	                form: data_service_2.motoristasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.pessoasStorage);
	            this._pessoaNavigationService.goToNew();
	        }
	        else {
	            this.funcionarioObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'funcionario', object);
	        }
	    };
	    MotoristaFormComponent.prototype.keyupCnh = function () {
	        this.formObject.cnh = this.formObject.cnh.replace(/\D/g, '');
	    };
	    MotoristaFormComponent.prototype.onAddMotorista = function (object) {
	        this._motoristaApiService.onPost(object, this.onDone);
	    };
	    MotoristaFormComponent.prototype.onEditMotorista = function (object) {
	        this._motoristaApiService.onPut(object, this.onDone);
	    };
	    MotoristaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum motorista encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._motoristaApiService.onGetById(id, onDone);
	    };
	    MotoristaFormComponent.prototype.getImage = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (Response.length) {
	                    this.imageUrl = Response[0].url;
	                    this.imageToSave = Response[0];
	                }
	            }
	        }.bind(this));
	        this._pessoaApiService.onGetByPessoa(id, onDone);
	    };
	    MotoristaFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.validadeHabilitacao) {
	            if (this.formObject.validadeHabilitacao.indexOf("/") === -1) {
	                this.formObject.validadeHabilitacao = this._utilService.convertDateToString(this.formObject.validadeHabilitacao);
	            }
	        }
	        if (this.formObject.primeiraHabilitacao) {
	            if (this.formObject.primeiraHabilitacao.indexOf("/") === -1) {
	                this.formObject.primeiraHabilitacao = this._utilService.convertDateToString(this.formObject.primeiraHabilitacao);
	            }
	        }
	        if (this.formObject.dataDemissao) {
	            if (this.formObject.dataDemissao.indexOf("/") === -1) {
	                this.formObject.dataDemissao = this._utilService.convertDateToString(this.formObject.dataDemissao);
	            }
	        }
	        if (this.formObject.dataAdmissao) {
	            if (this.formObject.dataAdmissao.indexOf("/") === -1) {
	                this.formObject.dataAdmissao = this._utilService.convertDateToString(this.formObject.dataAdmissao);
	            }
	        }
	        if (this.formObject.funcionario) {
	            this.funcionarioObject = this._utilService.cloneObject(this.formObject.funcionario);
	            delete this.formObject['funcionario'];
	            if (this.funcionarioObject.pessoa) {
	                this.getImage(this.funcionarioObject.pessoaId);
	                var selectObject = { text: this.funcionarioObject.pessoa.nome, id: this.funcionarioObject.id };
	                this._autocompleteService.createOptionOnSelect2(this.funcionarioSelectId, selectObject);
	                this._autocompleteService.setValueOnSelect2(selectObject.id, this.funcionarioSelectId);
	                this._utilService.setSelectOnFormControl(this.form, 'funcionario', this.funcionarioObject);
	            }
	        }
	        if (this.formObject.categoriaCnh) {
	            this.categoriaCnhObject = this._utilService.cloneObject(this.formObject.categoriaCnh);
	            delete this.formObject['categoriaCnh'];
	            this.setCategoriaCnh();
	        }
	    };
	    MotoristaFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._motoristaService.returnToOtherForm(this.otherForm, this.responseMotorista);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    MotoristaFormComponent.prototype.goToList = function () {
	        this._motoristaNavigationService.goToList();
	    };
	    MotoristaFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._motoristaService.getSessionStorage();
	        this._motoristaService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    MotoristaFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_3.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_3.newRoute;
	        }
	    };
	    MotoristaFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    MotoristaFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    MotoristaFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    MotoristaFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    MotoristaFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_2.motoristasStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.funcionarioObject = { pessoa: newAutoComplete.nome };
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    MotoristaFormComponent.prototype.getCategoriasCnh = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.categoriasCnhList = Response;
	                this.categoriasCnhList.unshift({ id: null, categoria: '— Selecione —' });
	                this.setCategoriaCnh();
	            }
	        }.bind(this));
	        this._categoriaCnhApiService.onGetAll(onDone);
	    };
	    MotoristaFormComponent.prototype.setCategoriaCnh = function () {
	        var x, lenX, t = this.categoriaCnhObject.id;
	        if (!t) {
	            t = this.categoriasCnhList[0].id;
	        }
	        for (x = 0, lenX = this.categoriasCnhList.length; x < lenX; x++) {
	            if (this.categoriasCnhList[x].id === t) {
	                this.categoriaCnhObject = this.categoriasCnhList[x];
	                break;
	            }
	        }
	    };
	    MotoristaFormComponent.prototype.onSaveFile = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageAddSuccess();
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        if (this.imageToSave.id) {
	            this._pessoaApiService.onPutImage(this.imageToSave, onDone);
	        }
	        else {
	            this._pessoaApiService.onPostImage(this.imageToSave, onDone);
	        }
	    };
	    MotoristaFormComponent.prototype.onDeleteFile = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.setImagePattern();
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        if (this.imageToSave.id) {
	            this._pessoaApiService.onDeleteImage(this.imageToSave.id, onDone);
	        }
	        else {
	            this.imageToSave = {};
	            this.setImagePattern();
	            this._utilService.swalMessageDeleteSuccess();
	        }
	    };
	    MotoristaFormComponent.prototype.setImagePattern = function () {
	        this.imageUrl = '';
	    };
	    MotoristaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(219),
	            styles: [__webpack_require__(220)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof motorista_navigation_service_1.MotoristaNavigationService !== 'undefined' && motorista_navigation_service_1.MotoristaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof motorista_api_service_1.MotoristaApiService !== 'undefined' && motorista_api_service_1.MotoristaApiService) === 'function' && _c) || Object, (typeof (_d = typeof motorista_service_1.MotoristaService !== 'undefined' && motorista_service_1.MotoristaService) === 'function' && _d) || Object, (typeof (_e = typeof funcionario_api_service_1.FuncionarioApiService !== 'undefined' && funcionario_api_service_1.FuncionarioApiService) === 'function' && _e) || Object, (typeof (_f = typeof funcionario_service_1.FuncionarioService !== 'undefined' && funcionario_service_1.FuncionarioService) === 'function' && _f) || Object, (typeof (_g = typeof pessoa_navigation_service_1.PessoaNavigationService !== 'undefined' && pessoa_navigation_service_1.PessoaNavigationService) === 'function' && _g) || Object, (typeof (_h = typeof pessoa_api_service_1.PessoaApiService !== 'undefined' && pessoa_api_service_1.PessoaApiService) === 'function' && _h) || Object, (typeof (_j = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _j) || Object, (typeof (_k = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _k) || Object, (typeof (_l = typeof categoria_cnh_api_service_1.CategoriaCnhApiService !== 'undefined' && categoria_cnh_api_service_1.CategoriaCnhApiService) === 'function' && _l) || Object, (typeof (_m = typeof att_service_1.AttService !== 'undefined' && att_service_1.AttService) === 'function' && _m) || Object, (typeof (_o = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _o) || Object])
	    ], MotoristaFormComponent);
	    return MotoristaFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
	}());
	exports.MotoristaFormComponent = MotoristaFormComponent;


/***/ },
/* 213 */
/***/ function(module, exports) {

	"use strict";
	var Motorista = (function () {
	    function Motorista() {
	    }
	    return Motorista;
	}());
	exports.Motorista = Motorista;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var autocomplete_service_1 = __webpack_require__(101);
	var FuncionarioService = (function () {
	    function FuncionarioService(_autocompleteService) {
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var name;
	                        if (state.pessoa) {
	                            name = state.pessoa.nome;
	                        }
	                        text = name;
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    FuncionarioService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object])
	    ], FuncionarioService);
	    return FuncionarioService;
	    var _a;
	}());
	exports.FuncionarioService = FuncionarioService;


/***/ },
/* 215 */
/***/ function(module, exports) {

	"use strict";
	var CnhValidator = (function () {
	    function CnhValidator() {
	    }
	    CnhValidator.cnhFormat = function (item) {
	        var CNH_REGEXP;
	        if (item.value) {
	            var tt = item.value.replace(/[^0-9]/gi, '');
	            CNH_REGEXP = /([0-9]{11})/;
	            if (item.value && !CNH_REGEXP.test(tt)) {
	                return { "incorrectCnhFormat": true };
	            }
	        }
	        return null;
	    };
	    return CnhValidator;
	}());
	exports.CnhValidator = CnhValidator;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/12/2016.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(217);
	var rest_service_1 = __webpack_require__(26);
	var CategoriaCnhApiService = (function () {
	    function CategoriaCnhApiService(_restService) {
	        this._restService = _restService;
	    }
	    CategoriaCnhApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    CategoriaCnhApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    CategoriaCnhApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    CategoriaCnhApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "categoria", "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    CategoriaCnhApiService.prototype.onGetAllVeiculo = function (done) {
	        var filter = { "order": "categoria", "where": { "ativo": true, "veiculo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    CategoriaCnhApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    CategoriaCnhApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    CategoriaCnhApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], CategoriaCnhApiService);
	    return CategoriaCnhApiService;
	    var _a;
	}());
	exports.CategoriaCnhApiService = CategoriaCnhApiService;


/***/ },
/* 217 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'categorias-cnh';
	exports.categoriasCnhQuery = {
	    "where": {
	        "ativo": true,
	        "categoria": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "categoria"
	};


/***/ },
/* 218 */
/***/ function(module, exports) {

	"use strict";
	var CategoriaCnh = (function () {
	    function CategoriaCnh() {
	    }
	    return CategoriaCnh;
	}());
	exports.CategoriaCnh = CategoriaCnh;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{motoristasModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{motoristasModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{motoristasModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--3c geo-columns--center\">\n            <div class=\"geo-send-file\" data-picture=\"\">\n                <label for=\"file\">\n                    <img [src]=\"imageUrl\" class=\"profile-picture--big\" *ngIf=\"imageUrl\">\n                    <img src=\"" + __webpack_require__(165) + "\" class=\"profile-picture--big\" *ngIf=\"!imageUrl\">\n                    <span>Selecione uma foto</span>\n                </label>\n                <input id=\"file\" type=\"file\" (change)=\"changeFile($event)\">\n            </div>\n            <br />\n            <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickRemoverImagem()\">Remover foto</button>\n        </div>\n        <div class=\"geo-columns--9c\">\n            <div class=\"geo-content__row\">\n                <autocomplete-component class=\"geo-input--3c\" id=\"funcionario\"\n                                        (setObejct)=\"getFuncionariosObject($event)\"\n                                        [submitted]=\"submitted\"\n                                        [isRequired]=\"true\"\n                                        [selectId]=\"funcionarioSelectId\"\n                                        [model]=\"funcionarioObject\"\n                                        [_service]=\"_funcionarioApiService\"\n                                        [templateResult]=\"funcionarioTemplateResult\"\n                                        [apiCustom]=\"'/populado'\"\n                                        [query]=\"funcionarioQuery\"\n                                        [label]=\"'Funcionário'\"></autocomplete-component>\n\n\n                <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!cnh.valid && submitted) || (cnh.errors && cnh.errors.incorrectCnhFormat)}\">\n                    <label for=\"cnh\">Número da CNH <abbr>*</abbr></label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!cnh.valid && submitted\">Este campo é obrigatório.</span>\n                        <span class=\"error-alert\" *ngIf=\"submitted && cnh.errors && cnh.errors.incorrectCnhFormat\">Formato incorreto.</span>\n                        <input type=\"text\" id=\"cnh\" [(ngModel)]=\"formObject.cnh\" formControlName=\"cnh\" (keyup)=\"keyupCnh()\" maxlength=\"11\">\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c\">\n                    <label for=\"categoriacnh\">Categoria CNH</label>\n                    <div>\n                        <select id=\"categoriacnh\" [(ngModel)]=\"categoriaCnhObject\" formControlName=\"categoriaCnh\" class=\"option_{{categoriaCnhObject.id}}\">\n                            <option *ngFor=\"let item of categoriasCnhList\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.categoria}}</option>\n                        </select>\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c geo-input--datepicker\">\n                    <label for=\"validade_habilitacao\">Validade da habilitação</label>\n                    <div>\n                        <input type=\"text\" class=\"input-datepicker\" id=\"validade_habilitacao\" [(ngModel)]=\"formObject.validadeHabilitacao\" formControlName=\"validadeHabilitacao\" appDatepicker autocomplete=\"off\" />\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c geo-input--datepicker\">\n                    <label for=\"primeira_habilitacao\">Data da 1ª habilitação</label>\n                    <div>\n                        <input type=\"text\" id=\"primeira_habilitacao\" [(ngModel)]=\"formObject.primeiraHabilitacao\" formControlName=\"primeiraHabilitacao\" appDatepicker autocomplete=\"off\" />\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c\">\n                    <label for=\"matricula\">Matrícula </label>\n                    <div>\n                        <input type=\"text\" id=\"matricula\" [(ngModel)]=\"formObject.matricula\" formControlName=\"matricula\" >\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c geo-input--datepicker\">\n                    <label for=\"admissao\">Data da admissão</label>\n                    <div>\n                        <input type=\"text\" class=\"input-datepicker\" id=\"admissao\" [(ngModel)]=\"formObject.dataAdmissao\" formControlName=\"dataAdmissao\" appDatepicker autocomplete=\"off\" />\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c geo-input--datepicker\">\n                    <label for=\"demissao\">Data da demissão</label>\n                    <div>\n                        <input type=\"text\" class=\"input-datepicker\" id=\"demissao\" [(ngModel)]=\"formObject.dataDemissao\" formControlName=\"dataDemissao\" appDatepicker autocomplete=\"off\" />\n                    </div>\n                </div>\n\n                <div class=\"geo-columns--12c\">\n                    <div class=\"geo-input--12c\">\n                        <label>Informações adicionais </label>\n                    </div>\n                    <div class=\"geo-toggle\">\n                        <input type=\"checkbox\" id=\"lentes\" value=\"\" [(ngModel)]=\"formObject.lentesObrigatorias\" formControlName=\"lentesObrigatorias\">\n                        <label for=\"lentes\">Uso obrigatório de lentes</label>\n                    </div>\n                    <div class=\"geo-toggle\">\n                        <input type=\"checkbox\" id=\"vinculoEmpregaticio\" value=\"\" [(ngModel)]=\"formObject.vinculoEmpregaticio\" formControlName=\"vinculoEmpregaticio\">\n                        <label for=\"vinculoEmpregaticio\"> Possui vínculo empregatício</label>\n                    </div>\n                </div>\n\n                <div class=\"geo-input--12c\">\n                    <label for=\"observacao\">Observação</label>\n                    <div>\n                        <textarea id=\"observacao\" [(ngModel)]=\"formObject.observacoes\" formControlName=\"observacoes\"></textarea>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 220 */
166,
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var MotoristasComponent = (function () {
	    function MotoristasComponent() {
	    }
	    MotoristasComponent.prototype.ngOnInit = function () {
	    };
	    MotoristasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(222)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MotoristasComponent);
	    return MotoristasComponent;
	}());
	exports.MotoristasComponent = MotoristasComponent;


/***/ },
/* 222 */
171,
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var EstruturasComponent = (function () {
	    function EstruturasComponent() {
	    }
	    EstruturasComponent.prototype.ngOnInit = function () {
	    };
	    EstruturasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(224)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], EstruturasComponent);
	    return EstruturasComponent;
	}());
	exports.EstruturasComponent = EstruturasComponent;


/***/ },
/* 224 */
171,
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var localidade_list_component_1 = __webpack_require__(226);
	var localidade_form_component_1 = __webpack_require__(238);
	var data_service_1 = __webpack_require__(178);
	var LocalidadesRoutingModule = (function () {
	    function LocalidadesRoutingModule() {
	    }
	    LocalidadesRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocalidadesRoutingModule);
	    return LocalidadesRoutingModule;
	}());
	exports.LocalidadesRoutingModule = LocalidadesRoutingModule;
	exports.localidadesRoutes = [
	    {
	        path: '',
	        component: localidade_list_component_1.LocalidadeListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: localidade_form_component_1.LocalidadeFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: localidade_form_component_1.LocalidadeFormComponent
	    }
	];


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(148);
	var localidade_api_service_1 = __webpack_require__(227);
	var localidade_navigation_service_1 = __webpack_require__(228);
	var util_service_1 = __webpack_require__(88);
	var endereco_service_1 = __webpack_require__(229);
	var localidade_service_1 = __webpack_require__(232);
	var LocalidadeListComponent = (function () {
	    function LocalidadeListComponent(_localidadesApiService, _localidadeNavigationService, _localidadeService, _utilService, _enderecoService) {
	        this._localidadesApiService = _localidadesApiService;
	        this._localidadeNavigationService = _localidadeNavigationService;
	        this._localidadeService = _localidadeService;
	        this._utilService = _utilService;
	        this._enderecoService = _enderecoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.localidadesModuleName = data_service_1.localidadesModuleName;
	    }
	    LocalidadeListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    LocalidadeListComponent.prototype.clickNew = function () {
	        this._localidadeService.clearSessionStorage();
	        this._localidadeNavigationService.goToNew();
	    };
	    LocalidadeListComponent.prototype.clickEdit = function (item) {
	        this._localidadeService.clearSessionStorage();
	        this._localidadeNavigationService.goToEdit(item.id);
	    };
	    LocalidadeListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    LocalidadeListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].endereco) {
	                        Response[x].address = this._enderecoService.getAddress(Response[x].endereco);
	                    }
	                }
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._localidadesApiService.onGetAll(onDone);
	    };
	    LocalidadeListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._localidadesApiService.onDelete(item.id, onDone);
	    };
	    LocalidadeListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(236),
	            styles: [__webpack_require__(237)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof localidade_api_service_1.LocalidadeApiService !== 'undefined' && localidade_api_service_1.LocalidadeApiService) === 'function' && _a) || Object, (typeof (_b = typeof localidade_navigation_service_1.LocalidadeNavigationService !== 'undefined' && localidade_navigation_service_1.LocalidadeNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof localidade_service_1.LocalidadeService !== 'undefined' && localidade_service_1.LocalidadeService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _e) || Object])
	    ], LocalidadeListComponent);
	    return LocalidadeListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.LocalidadeListComponent = LocalidadeListComponent;


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(148);
	var LocalidadeApiService = (function () {
	    function LocalidadeApiService(_restService) {
	        this._restService = _restService;
	    }
	    LocalidadeApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    LocalidadeApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    LocalidadeApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    LocalidadeApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "localidade", "include": ["tipoLocalidade", { "endereco": [{ "cidade": "estado" }, "tipoLogradouro"] }] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    LocalidadeApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["tipoLocalidade", { "endereco": [{ "cidade": "estado" }, "tipoLogradouro"] }] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    LocalidadeApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    LocalidadeApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], LocalidadeApiService);
	    return LocalidadeApiService;
	    var _a;
	}());
	exports.LocalidadeApiService = LocalidadeApiService;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(148);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(147);
	var LocalidadeNavigationService = (function () {
	    function LocalidadeNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.localidadesRoute;
	        this.fatherRouter = data_service_3.estruturasRoute;
	    }
	    LocalidadeNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    LocalidadeNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    LocalidadeNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    LocalidadeNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], LocalidadeNavigationService);
	    return LocalidadeNavigationService;
	    var _a;
	}());
	exports.LocalidadeNavigationService = LocalidadeNavigationService;


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var endereco_api_service_1 = __webpack_require__(230);
	var util_service_1 = __webpack_require__(88);
	var EnderecoService = (function () {
	    function EnderecoService(_enderecoApiService, _utilService) {
	        this._enderecoApiService = _enderecoApiService;
	        this._utilService = _utilService;
	    }
	    EnderecoService.prototype.onSubmit = function (object, onDone) {
	        var cloneObject = this._utilService.cloneObject(object);
	        if (cloneObject.cep) {
	            cloneObject.cep = this._utilService.removeSpecialCharacter(cloneObject.cep);
	        }
	        if (cloneObject.cidade) {
	            cloneObject.cidadeId = cloneObject.cidade.id;
	        }
	        if (cloneObject.tipoLogradouro) {
	            cloneObject.tipoLogradouroId = cloneObject.tipoLogradouro.id;
	        }
	        delete cloneObject["cidade"];
	        delete cloneObject["estado"];
	        delete cloneObject["tipoLogradouro"];
	        var onDone2 = (function (response) {
	            if (response) {
	                cloneObject.coordenadaLatitude = response.lat;
	                cloneObject.coordenadaLongitude = response.lng;
	            }
	            if (cloneObject.id) {
	                this._enderecoApiService.onPut(cloneObject, onDone);
	            }
	            else {
	                this._enderecoApiService.onPost(cloneObject, onDone);
	            }
	        }.bind(this));
	        var y = this.getGeocodingAddress(object);
	        this.getGeocoding(y, onDone2);
	    };
	    EnderecoService.prototype.getAddress = function (object) {
	        var address, street = "", typeStreet = "", number = "", city = "", neighborhood = "", complement = "", state = "", cep = "";
	        if (object.tipoLogradouro) {
	            typeStreet = object.tipoLogradouro.tipo;
	        }
	        if (object.logradouro) {
	            street = " " + object.logradouro;
	        }
	        if (object.cidade) {
	            city = " - " + object.cidade.nome;
	            if (object.cidade.estado) {
	                state = " / " + object.cidade.estado.nome;
	            }
	        }
	        if (object.bairro) {
	            neighborhood = " - Bairro " + object.bairro;
	        }
	        if (object.cep) {
	            if (object.cep.length > 4) {
	                cep = " - CEP: " + object.cep.slice(0, 5) + "-" + object.cep.slice(5, object.cep.length);
	            }
	            else {
	                cep = " - CEP: " + object.cep;
	            }
	        }
	        if (object.complemento) {
	            complement = " " + object.complemento;
	        }
	        if (object.numero) {
	            number = ", " + object.numero;
	        }
	        else {
	            number = ", s/n";
	        }
	        if (street && number) {
	            address = typeStreet + "" + street + "" + number + " " + complement + "" + neighborhood + "" + city + "" + state + "" + cep;
	        }
	        return address;
	    };
	    EnderecoService.prototype.getGeocodingAddress = function (object) {
	        var address, street = "", typeStreet = "", number = "", city = "", state = "", cep = "";
	        if (object.logradouro) {
	            street = object.logradouro;
	            if (object.tipoLogradouro) {
	                typeStreet = object.tipoLogradouro.tipo;
	            }
	        }
	        if (object.cidade) {
	            city = object.cidade.nome;
	        }
	        if (object.cidade.estado) {
	            state = object.cidade.estado.nome;
	        }
	        if (object.cep) {
	            cep = object.cep;
	        }
	        if (object.numero) {
	            number = object.numero;
	        }
	        address = cep + " " + street + " " + typeStreet + " " + city + " " + number + " " + state;
	        return address;
	    };
	    EnderecoService.prototype.getGeocoding = function (address, callback) {
	        var geocoder = new google.maps.Geocoder();
	        geocoder.geocode({ 'address': address }, function (results, status) {
	            if (status == google.maps.GeocoderStatus.OK) {
	                var lat = results[0].geometry.location.lat(), lng = results[0].geometry.location.lng();
	                var c = { lat: lat, lng: lng };
	                this.initMap(lat, lng);
	                callback(c);
	            }
	            else {
	                this._utilService.swalMessageWarningCustom("Nenhuma coordenada encontrada para este endereço!");
	                callback();
	            }
	        }.bind(this));
	    };
	    EnderecoService.prototype.initMap = function (lat, lng) {
	        var map;
	        var latlng = new google.maps.LatLng(lat, lng);
	        var mapOptions = {
	            zoom: 16,
	            center: latlng
	        };
	        map = new google.maps.Map(document.getElementById("map"), mapOptions);
	        map.setCenter(latlng);
	        var marker = new google.maps.Marker({
	            position: latlng
	        });
	        marker.setMap(map);
	    };
	    EnderecoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof endereco_api_service_1.EnderecoApiService !== 'undefined' && endereco_api_service_1.EnderecoApiService) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object])
	    ], EnderecoService);
	    return EnderecoService;
	    var _a, _b;
	}());
	exports.EnderecoService = EnderecoService;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(231);
	var EnderecoApiService = (function () {
	    function EnderecoApiService(_restService) {
	        this._restService = _restService;
	    }
	    EnderecoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    EnderecoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    EnderecoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    EnderecoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "logradouro" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    EnderecoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    EnderecoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], EnderecoApiService);
	    return EnderecoApiService;
	    var _a;
	}());
	exports.EnderecoApiService = EnderecoApiService;


/***/ },
/* 231 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'enderecos';
	exports.TipoLogradouros = [
	    "Aeroporto",
	    "Alameda",
	    "Apartamento",
	    "Avenida",
	    "Beco",
	    "Bloco",
	    "Caminho",
	    "Escadinha",
	    "Estação",
	    "Estrada",
	    "Fazenda",
	    "Fortaleza",
	    "Galeria",
	    "Ladeira",
	    "Largo",
	    "Parque",
	    "Praça",
	    "Praia",
	    "Quadra",
	    "Quilômetro",
	    "Quinta",
	    "Rodovia",
	    "Rua",
	    "Super quadra",
	    "Travessa",
	    "Viaduto",
	    "Vila"
	];


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(148);
	var data_service_2 = __webpack_require__(154);
	var autocomplete_service_1 = __webpack_require__(101);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_service_1 = __webpack_require__(203);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var ordem_servico_service_1 = __webpack_require__(235);
	var data_service_3 = __webpack_require__(200);
	var LocalidadeService = (function () {
	    function LocalidadeService(_frotaNavigationService, _frotaService, _ordemServicoNavigationService, _ordemServicoService, _autocompleteService) {
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaService = _frotaService;
	        this._ordemServicoNavigationService = _ordemServicoNavigationService;
	        this._ordemServicoService = _ordemServicoService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    LocalidadeService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.localidadesStorage + '-new', object);
	    };
	    LocalidadeService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.localidadesStorage + "-new");
	        return JSON.parse(item);
	    };
	    LocalidadeService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.localidadesStorage + "-new");
	    };
	    LocalidadeService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.frotasStorage) {
	                otherFormObject = this._frotaService.getSessionStorage();
	                otherFormObject.localidade = Response;
	                this._frotaService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.ordensServicoStorage) {
	                otherFormObject = this._ordemServicoService.getSessionStorage();
	                otherFormObject.localidade = Response;
	                this._ordemServicoService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.localidadesStorage);
	        if (otherForm === data_service_2.frotasStorage) {
	            otherFormObject = this._frotaService.getSessionStorage();
	            var frotasRoute = otherFormObject.thisRoute;
	            if (otherFormObject.id) {
	                this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
	            }
	            else {
	                this._frotaNavigationService.goToNew(frotasRoute);
	            }
	        }
	        else if (otherForm === data_service_3.ordensServicoStorage) {
	            otherFormObject = this._ordemServicoService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._ordemServicoNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._ordemServicoNavigationService.goToNew();
	            }
	        }
	    };
	    LocalidadeService.prototype.getTipoEstacionamento = function () {
	        var tipo = 2; //na api de localidades o id do tipo estacionamento eh 2    
	        return tipo;
	    };
	    LocalidadeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object])
	    ], LocalidadeService);
	    return LocalidadeService;
	    var _a, _b, _c, _d, _e;
	}());
	exports.LocalidadeService = LocalidadeService;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(234);
	var data_service_3 = __webpack_require__(200);
	var OrdemServicoNavigationService = (function () {
	    function OrdemServicoNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    OrdemServicoNavigationService.prototype.goToList = function () {
	        var router = data_service_2.manutencoesRoute + '/' + data_service_3.ordensServicoRoute;
	        this._authService.navigateTo(router);
	    };
	    OrdemServicoNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.manutencoesRoute + '/' + data_service_3.ordensServicoRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    OrdemServicoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.manutencoesRoute + '/' + data_service_3.ordensServicoRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    OrdemServicoNavigationService.prototype.goToDetail = function (objectId) {
	        var router = data_service_2.manutencoesRoute + '/' + data_service_3.ordensServicoRoute + '/' + data_service_1.detailRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    //itens: materiais e servicos
	    OrdemServicoNavigationService.prototype.goToNewServico = function (osId, tipo) {
	        var router = data_service_2.manutencoesRoute + '/' + data_service_3.ordensServicoRoute + '/' + data_service_3.ordensServicoItemsServicoRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router, [osId, tipo]);
	    };
	    OrdemServicoNavigationService.prototype.goToEditServico = function (osId, tipo, objectId) {
	        var router = data_service_2.manutencoesRoute + '/' + data_service_3.ordensServicoRoute + '/' + data_service_3.ordensServicoItemsServicoRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, [osId, tipo, objectId]);
	    };
	    OrdemServicoNavigationService.prototype.goToNewMaterial = function (osId, tipo) {
	        var router = data_service_2.manutencoesRoute + '/' + data_service_3.ordensServicoRoute + '/' + data_service_3.ordensServicoItemsMaterialRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router, [osId, tipo]);
	    };
	    OrdemServicoNavigationService.prototype.goToEditMaterial = function (osId, tipo, objectId) {
	        var router = data_service_2.manutencoesRoute + '/' + data_service_3.ordensServicoRoute + '/' + data_service_3.ordensServicoItemsMaterialRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, [osId, tipo, objectId]);
	    };
	    OrdemServicoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], OrdemServicoNavigationService);
	    return OrdemServicoNavigationService;
	    var _a;
	}());
	exports.OrdemServicoNavigationService = OrdemServicoNavigationService;


/***/ },
/* 234 */
/***/ function(module, exports) {

	"use strict";
	exports.manutencoesRoute = 'manutencao';
	exports.manutencoesModuleName = { plural: 'Manutenções', single: 'Manutenção' };


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(200);
	var autocomplete_service_1 = __webpack_require__(101);
	var OrdemServicoService = (function () {
	    function OrdemServicoService(_autocompleteService) {
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var tipo = '';
	                        if (state.Tipo) {
	                            tipo = state.Tipo.Value;
	                            tipo = " / (" + tipo + ")";
	                        }
	                        if (state.descricao) {
	                            text = state.descricao.concat(tipo);
	                        }
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    OrdemServicoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.ordensServicoStorage + '-new', object);
	    };
	    OrdemServicoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.ordensServicoStorage + "-new");
	        return JSON.parse(item);
	    };
	    OrdemServicoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.ordensServicoStorage + "-new");
	    };
	    OrdemServicoService.prototype.setItemsSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.ordensServicoItemsStorage + '-new', object);
	    };
	    OrdemServicoService.prototype.getItemsSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.ordensServicoItemsStorage + "-new");
	        return JSON.parse(item);
	    };
	    OrdemServicoService.prototype.clearItemsSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.ordensServicoItemsStorage + "-new");
	    };
	    OrdemServicoService.prototype.getTipoOrdemServico = function (tipo) {
	        var tipos = data_service_1.TipoOrdemServico, x, lenX;
	        for (x = 0, lenX = tipos.length; x < lenX; x++) {
	            if (tipos[x].Key === tipo) {
	                tipo = tipos[x];
	                break;
	            }
	        }
	        return tipo;
	    };
	    OrdemServicoService.prototype.getStatusOrdemServico = function (status) {
	        var statusList = data_service_1.OrdemServicoStatus, x, lenX;
	        for (x = 0, lenX = statusList.length; x < lenX; x++) {
	            if (statusList[x].Key === status) {
	                status = statusList[x];
	                break;
	            }
	        }
	        return status;
	    };
	    OrdemServicoService.prototype.getStatusAtivo = function () {
	        var statusList = data_service_1.OrdemServicoStatus;
	        return statusList[0];
	    };
	    OrdemServicoService.prototype.getStatusCancelado = function () {
	        var statusList = data_service_1.OrdemServicoStatus;
	        return statusList[2];
	    };
	    OrdemServicoService.prototype.getStatusConcluido = function () {
	        var statusList = data_service_1.OrdemServicoStatus;
	        return statusList[1];
	    };
	    OrdemServicoService.prototype.getItemTipoServico = function () {
	        var list = data_service_1.TipoMaterialServico;
	        return list[1];
	    };
	    OrdemServicoService.prototype.getItemTipoMaterial = function () {
	        var list = data_service_1.TipoMaterialServico;
	        return list[0];
	    };
	    OrdemServicoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object])
	    ], OrdemServicoService);
	    return OrdemServicoService;
	    var _a;
	}());
	exports.OrdemServicoService = OrdemServicoService;


/***/ },
/* 236 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{localidadesModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{localidadesModuleName.single | lowercase}} cadastrada</p>\n\n  <table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n      <th>Localidade</th>\n      <th>Unidade orçamentária</th>\n      <th>Tipo</th>\n      <th class=\"small\"></th>\n    </tr>\n    </thead>\n    <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['localidade', 'codigoUnidadeOrcamentaria', 'tipoLocalidade.tipo'] | filterActive:showDisabled)\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n      <td><span class=\"geo-arrow\"></span>{{item.localidade}}</td>\n      <td >{{item.codigoUnidadeOrcamentaria}}</td>\n      <td><span *ngIf=\"item.tipoLocalidade\">{{item.tipoLocalidade.tipo}}</span></td>\n      <td class=\"geo-table--action\">\n        <a (click)=\"clickEdit(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n        </a>\n        <a (click)=\"clickDelete(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n        </a>\n      </td>\n    </tr>\n    <tr class=\"description\">\n      <td colspan=\"100%\">\n        <div>\n          <p><strong>Endereço:</strong> {{item.address}} <i *ngIf=\"!item.address\">não cadastrado</i></p>\n        </div>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n";

/***/ },
/* 237 */
166,
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(148);
	var localidade_model_1 = __webpack_require__(239);
	var endereco_model_1 = __webpack_require__(240);
	var data_service_2 = __webpack_require__(178);
	var localidade_navigation_service_1 = __webpack_require__(228);
	var localidade_api_service_1 = __webpack_require__(227);
	var localidade_service_1 = __webpack_require__(232);
	var endereco_api_service_1 = __webpack_require__(230);
	var util_service_1 = __webpack_require__(88);
	var endereco_service_1 = __webpack_require__(229);
	var autocomplete_service_1 = __webpack_require__(101);
	var localidade_tipos_model_1 = __webpack_require__(241);
	var localidade_tipos_api_service_1 = __webpack_require__(242);
	var LocalidadeFormComponent = (function () {
	    function LocalidadeFormComponent(_route, _localidadeNavigationService, _localidadeApiService, _localidadeService, _enderecoApiService, _enderecoService, _localidadeTiposApiService, _utilService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._localidadeNavigationService = _localidadeNavigationService;
	        this._localidadeApiService = _localidadeApiService;
	        this._localidadeService = _localidadeService;
	        this._enderecoApiService = _enderecoApiService;
	        this._enderecoService = _enderecoService;
	        this._localidadeTiposApiService = _localidadeTiposApiService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.localidadesModule = data_service_1.localidadesModuleName;
	        this.formObject = new localidade_model_1.Localidade();
	        this.tipoLocalidadeObject = new localidade_tipos_model_1.TipoLocalidade();
	        this.formObjectToSave = new localidade_model_1.Localidade();
	        this.enderecoObject = new endereco_model_1.Endereco();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showAddress = false;
	        this.tiposLocalidadesList = [];
	        this.ativo = new forms_1.FormControl('');
	        this.localidade = new forms_1.FormControl('', forms_1.Validators.required);
	        this.codigoUnidadeOrcamentaria = new forms_1.FormControl('');
	        this.tipoLocalidade = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDoneEndereco = (function (Response) {
	            if (!Response.error) {
	                var addressId = Response.id;
	                this.formObjectToSave.enderecoId = addressId;
	                if (this.formObject.id) {
	                    this.onEditLocalidade();
	                }
	                else {
	                    this.onAddLocalidade();
	                }
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseLocalidade = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            localidade: this.localidade,
	            codigoUnidadeOrcamentaria: this.codigoUnidadeOrcamentaria,
	            tipoLocalidade: this.tipoLocalidade
	        });
	    }
	    LocalidadeFormComponent.prototype.ngOnInit = function () {
	        this.getTiposLocalidade();
	        this.isNewAutoComplete();
	    };
	    LocalidadeFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    LocalidadeFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    LocalidadeFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.tipoLocalidadeObject.id) {
	                object.tipoLocalidadeId = this.tipoLocalidadeObject.id;
	            }
	            else {
	                object.tipoLocalidadeId = null;
	            }
	            this.formObjectToSave = object;
	            this._enderecoService.onSubmit(this.enderecoObject, this.onDoneEndereco);
	        }
	    };
	    LocalidadeFormComponent.prototype.onAddLocalidade = function () {
	        this._localidadeApiService.onPost(this.formObjectToSave, this.onDone);
	    };
	    LocalidadeFormComponent.prototype.onEditLocalidade = function () {
	        this._localidadeApiService.onPut(this.formObjectToSave, this.onDone);
	    };
	    LocalidadeFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma localidade encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._localidadeApiService.onGetById(id, onDone);
	    };
	    LocalidadeFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._localidadeService.getSessionStorage();
	        this._localidadeService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    LocalidadeFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.tipoLocalidade) {
	            this.tipoLocalidadeObject = this.formObject.tipoLocalidade;
	            delete this.formObject['tipoLocalidade'];
	            if (this.tiposLocalidadesList.length) {
	                this.setTipoLocalidade();
	            }
	        }
	        if (this.formObject.endereco) {
	            this.enderecoObject = this.formObject.endereco;
	            delete this.formObject['endereco'];
	        }
	        this.showAddress = true;
	    };
	    LocalidadeFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._localidadeService.returnToOtherForm(this.otherForm, this.responseLocalidade);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    LocalidadeFormComponent.prototype.goToList = function () {
	        this._localidadeNavigationService.goToList();
	    };
	    LocalidadeFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.localidadesStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.localidade = newAutoComplete.localidade;
	            this.setActionTitle(this.formObject.id);
	            this.showAddress = true;
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    LocalidadeFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    LocalidadeFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    LocalidadeFormComponent.prototype.setNewNormal = function () {
	        this.showAddress = true;
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    LocalidadeFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    LocalidadeFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    LocalidadeFormComponent.prototype.getTiposLocalidade = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.tiposLocalidadesList = Response;
	                this.tiposLocalidadesList.unshift({ id: null, tipo: '— Selecione —' });
	                this.setTipoLocalidade();
	            }
	        }.bind(this));
	        this._localidadeTiposApiService.onGetAll(onDone);
	    };
	    LocalidadeFormComponent.prototype.setTipoLocalidade = function () {
	        var x, lenX, t = this.tipoLocalidadeObject.id;
	        if (!t) {
	            t = this.tiposLocalidadesList[0].id;
	        }
	        for (x = 0, lenX = this.tiposLocalidadesList.length; x < lenX; x++) {
	            if (this.tiposLocalidadesList[x].id === t) {
	                this.tipoLocalidadeObject = this.tiposLocalidadesList[x];
	                break;
	            }
	        }
	    };
	    LocalidadeFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(244),
	            styles: [__webpack_require__(245)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof localidade_navigation_service_1.LocalidadeNavigationService !== 'undefined' && localidade_navigation_service_1.LocalidadeNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof localidade_api_service_1.LocalidadeApiService !== 'undefined' && localidade_api_service_1.LocalidadeApiService) === 'function' && _c) || Object, (typeof (_d = typeof localidade_service_1.LocalidadeService !== 'undefined' && localidade_service_1.LocalidadeService) === 'function' && _d) || Object, (typeof (_e = typeof endereco_api_service_1.EnderecoApiService !== 'undefined' && endereco_api_service_1.EnderecoApiService) === 'function' && _e) || Object, (typeof (_f = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _f) || Object, (typeof (_g = typeof localidade_tipos_api_service_1.LocalidadeTiposApiService !== 'undefined' && localidade_tipos_api_service_1.LocalidadeTiposApiService) === 'function' && _g) || Object, (typeof (_h = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _h) || Object, (typeof (_j = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _j) || Object, (typeof (_k = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _k) || Object])
	    ], LocalidadeFormComponent);
	    return LocalidadeFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	}());
	exports.LocalidadeFormComponent = LocalidadeFormComponent;


/***/ },
/* 239 */
/***/ function(module, exports) {

	"use strict";
	var Localidade = (function () {
	    function Localidade() {
	    }
	    return Localidade;
	}());
	exports.Localidade = Localidade;


/***/ },
/* 240 */
/***/ function(module, exports) {

	"use strict";
	var Endereco = (function () {
	    function Endereco() {
	    }
	    return Endereco;
	}());
	exports.Endereco = Endereco;


/***/ },
/* 241 */
/***/ function(module, exports) {

	"use strict";
	var TipoLocalidade = (function () {
	    function TipoLocalidade() {
	    }
	    return TipoLocalidade;
	}());
	exports.TipoLocalidade = TipoLocalidade;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(243);
	var LocalidadeTiposApiService = (function () {
	    function LocalidadeTiposApiService(_restService) {
	        this._restService = _restService;
	    }
	    LocalidadeTiposApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    LocalidadeTiposApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    LocalidadeTiposApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    LocalidadeTiposApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "tipo", "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    LocalidadeTiposApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    LocalidadeTiposApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], LocalidadeTiposApiService);
	    return LocalidadeTiposApiService;
	    var _a;
	}());
	exports.LocalidadeTiposApiService = LocalidadeTiposApiService;


/***/ },
/* 243 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-localidades';


/***/ },
/* 244 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <ul class=\"geo-breadcrumb\">\n    <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{localidadesModule.plural}}</a></li>\n    <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{localidadesModule.single | lowercase}}</a></li>\n  </ul>\n  <h1>{{actionTitle | capitalize}} {{localidadesModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n  <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n    <div class=\"geo-columns--12c\">\n      <label class=\"geo-switch\">\n        <span class=\"geo-switch--label\">Ativo</span>\n        <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n        <div class=\"geo-switch--checkbox\">\n          <span class=\"geo-switch--status\"></span>\n        </div>\n      </label>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <h2>Identificação</h2>\n    <div class=\"geo-columns--12c\">\n      <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !localidade.valid && submitted}\">\n        <label for=\"localidade\">Localidade <abbr>*</abbr></label>\n        <div>\n          <span class=\"error-alert\" *ngIf=\"!localidade.valid && submitted\">Este campo é obrigatório.</span>\n          <input type=\"text\" id=\"localidade\" placeholder=\"\" [(ngModel)]=\"formObject.localidade\" formControlName=\"localidade\">\n        </div>\n      </div>\n\n      <div class=\"geo-input--3c\">\n        <label for=\"codigoUnidadeOrcamentaria\">Unidade orçamentária</label>\n        <div>\n          <input type=\"text\" id=\"codigoUnidadeOrcamentaria\" placeholder=\"\" [(ngModel)]=\"formObject.codigoUnidadeOrcamentaria\" formControlName=\"codigoUnidadeOrcamentaria\" appNumberInteger>\n        </div>\n      </div>\n\n      <div class=\"geo-input--3c\">\n        <label for=\"tipo_localidade\">Tipo de localidade</label>\n        <div>\n          <select id=\"tipo_localidade\" [(ngModel)]=\"tipoLocalidadeObject\" formControlName=\"tipoLocalidade\" class=\"option_{{tipoLocalidadeObject.id}}\">\n            <option *ngFor=\"let item of tiposLocalidadesList\" [ngValue]=\"item\"  class=\"option_{{item.id}}\">{{item.tipo}}</option>\n          </select>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <app-endereco-form [formObject]=\"enderecoObject\" *ngIf=\"showAddress\"></app-endereco-form>\n\n  <div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n  </div>\n</form>\n";

/***/ },
/* 245 */
166,
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LocalidadesComponent = (function () {
	    function LocalidadesComponent() {
	    }
	    LocalidadesComponent.prototype.ngOnInit = function () {
	    };
	    LocalidadesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(247)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocalidadesComponent);
	    return LocalidadesComponent;
	}());
	exports.LocalidadesComponent = LocalidadesComponent;


/***/ },
/* 247 */
171,
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var orgao_list_component_1 = __webpack_require__(249);
	var orgao_form_component_1 = __webpack_require__(253);
	var data_service_1 = __webpack_require__(178);
	var orgao_tipo_list_component_1 = __webpack_require__(261);
	var orgao_tipo_form_component_1 = __webpack_require__(264);
	var data_service_2 = __webpack_require__(155);
	var OrgaosRoutingModule = (function () {
	    function OrgaosRoutingModule() {
	    }
	    OrgaosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OrgaosRoutingModule);
	    return OrgaosRoutingModule;
	}());
	exports.OrgaosRoutingModule = OrgaosRoutingModule;
	exports.orgaosRoutes = [
	    {
	        path: '',
	        component: orgao_list_component_1.OrgaoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: orgao_form_component_1.OrgaoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: orgao_form_component_1.OrgaoFormComponent
	    }, {
	        path: data_service_2.orgaoTiposRoute,
	        component: orgao_tipo_list_component_1.OrgaoTipoListComponent
	    }, {
	        path: data_service_2.orgaoTiposRoute + '/' + data_service_1.editRoute + '/:id',
	        component: orgao_tipo_form_component_1.OrgaoTipoFormComponent
	    }, {
	        path: data_service_2.orgaoTiposRoute + '/' + data_service_1.newRoute,
	        component: orgao_tipo_form_component_1.OrgaoTipoFormComponent
	    }
	];


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(149);
	var orgao_api_service_1 = __webpack_require__(250);
	var util_service_1 = __webpack_require__(88);
	var orgao_navigation_service_1 = __webpack_require__(204);
	var endereco_service_1 = __webpack_require__(229);
	var orgao_service_1 = __webpack_require__(189);
	var OrgaoListComponent = (function () {
	    function OrgaoListComponent(_orgaosApiService, _orgaoNavigationService, _orgaoService, _utilService, _enderecoService) {
	        this._orgaosApiService = _orgaosApiService;
	        this._orgaoNavigationService = _orgaoNavigationService;
	        this._orgaoService = _orgaoService;
	        this._utilService = _utilService;
	        this._enderecoService = _enderecoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.orgaosModuleName = data_service_1.orgaosModuleName;
	    }
	    OrgaoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    OrgaoListComponent.prototype.clickNew = function () {
	        this._orgaoService.clearSessionStorage();
	        this._orgaoNavigationService.goToNew();
	    };
	    OrgaoListComponent.prototype.clickEdit = function (item) {
	        this._orgaoService.clearSessionStorage();
	        this._orgaoNavigationService.goToEdit(item.id);
	    };
	    OrgaoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    OrgaoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].endereco) {
	                        Response[x].address = this._enderecoService.getAddress(Response[x].endereco);
	                    }
	                }
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._orgaosApiService.onGetAll(onDone);
	    };
	    OrgaoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._orgaosApiService.onDelete(item.id, onDone);
	    };
	    OrgaoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(251),
	            styles: [__webpack_require__(252)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof orgao_api_service_1.OrgaoApiService !== 'undefined' && orgao_api_service_1.OrgaoApiService) === 'function' && _a) || Object, (typeof (_b = typeof orgao_navigation_service_1.OrgaoNavigationService !== 'undefined' && orgao_navigation_service_1.OrgaoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof orgao_service_1.OrgaoService !== 'undefined' && orgao_service_1.OrgaoService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _e) || Object])
	    ], OrgaoListComponent);
	    return OrgaoListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.OrgaoListComponent = OrgaoListComponent;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(149);
	var OrgaoApiService = (function () {
	    function OrgaoApiService(_restService) {
	        this._restService = _restService;
	    }
	    OrgaoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    OrgaoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    OrgaoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    OrgaoApiService.prototype.onGetAll = function (done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', {}, done); //busca orgaos populado com areas
	    };
	    OrgaoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": [{ "responsavel": ["pessoa"] }, { "endereco": [{ "cidade": "estado" }, "tipoLogradouro"] }, "tipoOrgao"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    OrgaoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    OrgaoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], OrgaoApiService);
	    return OrgaoApiService;
	    var _a;
	}());
	exports.OrgaoApiService = OrgaoApiService;


/***/ },
/* 251 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{orgaosModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{orgaosModuleName.single | lowercase}} cadastrado</p>\n\n  <table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n      <th>Órgão</th>\n      <th>CNPJ</th>\n      <th>Tipo</th>\n      <th class=\"small\"></th>\n    </tr>\n    </thead>\n    <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['razaoSocial', 'cnpj', 'tipoOrgao.tipo'] | filterActive:showDisabled | sort:['razaoSocial'])\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n      <td><span class=\"geo-arrow\"></span>{{item.razaoSocial}}</td>\n      <td >{{item.cnpj | cnpjMask}}</td>\n      <td ><span *ngIf=\"item.tipoOrgao\">{{item.tipoOrgao.codigoTCE}} - {{item.tipoOrgao.descricao}}</span></td>\n      <td class=\"geo-table--action\">\n        <a (click)=\"clickEdit(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n        </a>\n        <a (click)=\"clickDelete(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n        </a>\n      </td>\n    </tr>\n    <tr class=\"description\">\n      <td colspan=\"100%\">\n        <div class=\"geo-content__row\">\n          <div class=\"geo-columns--6c\">\n            <p><strong>Alias: </strong> {{item.alias}} <i *ngIf=\"!item.alias\">não cadastrado</i></p>\n            <p><strong>Responsável: </strong> <span *ngIf=\"item.responsavel && item.responsavel.pessoa\">{{item.responsavel.pessoa.nome}}</span> <i *ngIf=\"!item.responsavel\">não cadastrado</i></p>\n          </div>\n          <div class=\"geo-columns--6c\">\n            <p><strong>Telefone: </strong> {{item.telefone | phoneMask}} <i *ngIf=\"!item.telefone\">não cadastrado</i></p>\n            <p><strong>Email: </strong> {{item.email}} <i *ngIf=\"!item.email\">não cadastrado</i></p>\n            <p><strong>Endereço: </strong> {{item.address}} <i *ngIf=\"!item.address\">não cadastrado</i></p>\n          </div>\n        </div>\n\n        <app-area-list [list]=\"item.Areas\" [orgaoObject]=\"item\" [showDisabled]=\"showDisabled\"></app-area-list>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n";

/***/ },
/* 252 */
166,
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(147);
	var data_service_2 = __webpack_require__(149);
	var orgao_model_1 = __webpack_require__(254);
	var funcionario_model_1 = __webpack_require__(183);
	var orgao_navigation_service_1 = __webpack_require__(204);
	var orgao_api_service_1 = __webpack_require__(250);
	var orgao_service_1 = __webpack_require__(189);
	var funcionario_api_service_1 = __webpack_require__(184);
	var funcionario_service_1 = __webpack_require__(214);
	var pessoa_navigation_service_1 = __webpack_require__(177);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_3 = __webpack_require__(178);
	var data_service_4 = __webpack_require__(144);
	var cnpj_validation_1 = __webpack_require__(106);
	var endereco_model_1 = __webpack_require__(240);
	var email_validation_1 = __webpack_require__(91);
	var phone_validation_1 = __webpack_require__(92);
	var endereco_service_1 = __webpack_require__(229);
	var data_service_5 = __webpack_require__(185);
	var orgao_tipo_model_1 = __webpack_require__(255);
	var orgao_tipo_api_service_1 = __webpack_require__(256);
	var orgao_tipo_navigation_service_1 = __webpack_require__(257);
	var orgao_service_2 = __webpack_require__(258);
	var data_service_6 = __webpack_require__(155);
	var OrgaoFormComponent = (function () {
	    function OrgaoFormComponent(_route, _orgaoNavigationService, _orgaoApiService, _orgaoService, _orgaoTipoApiService, _orgaoTipoNavigationService, _orgaoTipoService, _funcionarioApiService, _funcionarioService, _pessoaNavigationService, _utilService, _autocompleteService, _enderecoService, _fb) {
	        this._route = _route;
	        this._orgaoNavigationService = _orgaoNavigationService;
	        this._orgaoApiService = _orgaoApiService;
	        this._orgaoService = _orgaoService;
	        this._orgaoTipoApiService = _orgaoTipoApiService;
	        this._orgaoTipoNavigationService = _orgaoTipoNavigationService;
	        this._orgaoTipoService = _orgaoTipoService;
	        this._funcionarioApiService = _funcionarioApiService;
	        this._funcionarioService = _funcionarioService;
	        this._pessoaNavigationService = _pessoaNavigationService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._enderecoService = _enderecoService;
	        this._fb = _fb;
	        this.estruturasModule = data_service_1.estruturasModuleName;
	        this.orgaosModule = data_service_2.orgaosModuleName;
	        this.formObject = new orgao_model_1.Orgao();
	        this.formObjectToSave = new orgao_model_1.Orgao();
	        this.funcionarioObject = new funcionario_model_1.Funcionario();
	        this.tipoOrgaoObject = new orgao_tipo_model_1.TipoOrgao();
	        this.enderecoObject = new endereco_model_1.Endereco();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showAddress = false;
	        this.funcionarioSelectId = 'funcionario';
	        this.funcionarioQuery = data_service_5.funcionariosQueryComPessoa;
	        this.tipoOrgaoSelectId = 'tipoOrgao';
	        this.orgaoTipoQuery = data_service_6.orgaoTiposQuery;
	        this.cnpj = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, cnpj_validation_1.CnpjValidator.cnpjFormat]));
	        this.email = new forms_1.FormControl('', forms_1.Validators.compose([email_validation_1.EmailValidator.emailFormat]));
	        this.razaoSocial = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipoOrgao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.telefone = new forms_1.FormControl('', forms_1.Validators.compose([phone_validation_1.PhoneValidator.phoneFormat]));
	        this.ativo = new forms_1.FormControl('');
	        this.funcionario = new forms_1.FormControl('');
	        this.alias = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.funcionarioTemplateResult = (function (state) {
	            var template = this._funcionarioService.templateResult(state, true);
	            return template;
	        }.bind(this));
	        this.tipoOrgaoTemplateResult = (function (state) {
	            var template = this._orgaoTipoService.templateResult(state, true);
	            return template;
	        }.bind(this));
	        this.onDoneEndereco = (function (Response) {
	            if (!Response.error) {
	                var addressId = Response.id;
	                this.formObjectToSave.enderecoId = addressId;
	                if (this.formObject.id) {
	                    this.onEditOrgao();
	                }
	                else {
	                    this.onAddOrgao();
	                }
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseOrgao = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            email: this.email,
	            cnpj: this.cnpj,
	            razaoSocial: this.razaoSocial,
	            tipoOrgao: this.tipoOrgao,
	            telefone: this.telefone,
	            funcionario: this.funcionario,
	            alias: this.alias
	        });
	    }
	    OrgaoFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    OrgaoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    OrgaoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    OrgaoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.funcionarioObject.id) {
	                object.responsavelId = this.funcionarioObject.id;
	            }
	            if (this.tipoOrgaoObject.id) {
	                object.tipoOrgaoId = this.tipoOrgaoObject.id;
	            }
	            if (object.telefone) {
	                object.telefone = this._utilService.removeSpecialCharacter(object.telefone);
	            }
	            if (object.cnpj) {
	                object.cnpj = this._utilService.removeSpecialCharacter(object.cnpj);
	            }
	            this.formObjectToSave = object;
	            this._enderecoService.onSubmit(this.enderecoObject, this.onDoneEndereco);
	        }
	    };
	    OrgaoFormComponent.prototype.getFuncionariosObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._orgaoService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                nome: object.text,
	                isFuncionario: true,
	                form: data_service_2.orgaosStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.pessoasStorage);
	            this._pessoaNavigationService.goToNew();
	        }
	        else {
	            this.funcionarioObject = object;
	            if (object.id) {
	                this._utilService.setSelectOnFormControl(this.form, 'funcionario', object);
	            }
	            else {
	                this._utilService.setSelectOnFormControl(this.form, 'funcionario', { id: -1 });
	            }
	        }
	    };
	    OrgaoFormComponent.prototype.getTipoOrgaoObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._orgaoService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                descricao: object.text,
	                form: data_service_2.orgaosStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_6.orgaoTiposStorage);
	            this._orgaoTipoNavigationService.goToNew();
	        }
	        else {
	            this.tipoOrgaoObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'tipoOrgao', object);
	        }
	    };
	    OrgaoFormComponent.prototype.onAddOrgao = function () {
	        this._orgaoApiService.onPost(this.formObjectToSave, this.onDone);
	    };
	    OrgaoFormComponent.prototype.onEditOrgao = function () {
	        this._orgaoApiService.onPut(this.formObjectToSave, this.onDone);
	    };
	    OrgaoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum órgão encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._orgaoApiService.onGetById(id, onDone);
	    };
	    OrgaoFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.responsavel = this.funcionarioObject;
	        object.tipoOrgao = this.tipoOrgaoObject;
	        object.endereco = this.enderecoObject;
	        return object;
	    };
	    OrgaoFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._orgaoService.getSessionStorage();
	        this._orgaoService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    OrgaoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_3.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_3.newRoute;
	        }
	    };
	    OrgaoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    OrgaoFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	        this.showAddress = true;
	    };
	    OrgaoFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    OrgaoFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    OrgaoFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_2.orgaosStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.razaoSocial = newAutoComplete.razaoSocial;
	            this.setActionTitle(this.formObject.id);
	            this.showAddress = true;
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    OrgaoFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.tipoOrgao) {
	            this.tipoOrgaoObject = this._utilService.cloneObject(this.formObject.tipoOrgao);
	            delete this.formObject['tipoOrgao'];
	            var text = this._autocompleteService.getTextSelect2(this.tipoOrgaoObject, 'descricao');
	            text = this._orgaoTipoService.templateText(this.tipoOrgaoObject);
	            var selectObject = { text: text, id: this.tipoOrgaoObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.tipoOrgaoSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.tipoOrgaoSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'tipoOrgao', this.tipoOrgaoObject);
	        }
	        if (this.formObject.responsavel) {
	            this.funcionarioObject = this._utilService.cloneObject(this.formObject.responsavel);
	            delete this.formObject['responsavel'];
	            if (this.funcionarioObject.pessoa) {
	                var selectObject = { text: this.funcionarioObject.pessoa.nome, id: this.funcionarioObject.id };
	                this._autocompleteService.createOptionOnSelect2(this.funcionarioSelectId, selectObject);
	                this._autocompleteService.setValueOnSelect2(selectObject.id, this.funcionarioSelectId);
	                this._utilService.setSelectOnFormControl(this.form, 'funcionario', this.funcionarioObject);
	            }
	        }
	        if (this.formObject.endereco) {
	            this.enderecoObject = this.formObject.endereco;
	            delete this.formObject['endereco'];
	        }
	        this.showAddress = true;
	    };
	    OrgaoFormComponent.prototype.goToList = function () {
	        this._orgaoNavigationService.goToList();
	    };
	    OrgaoFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._orgaoService.returnToOtherForm(this.otherForm, this.responseOrgao);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    OrgaoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(259),
	            styles: [__webpack_require__(260)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof orgao_navigation_service_1.OrgaoNavigationService !== 'undefined' && orgao_navigation_service_1.OrgaoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof orgao_api_service_1.OrgaoApiService !== 'undefined' && orgao_api_service_1.OrgaoApiService) === 'function' && _c) || Object, (typeof (_d = typeof orgao_service_1.OrgaoService !== 'undefined' && orgao_service_1.OrgaoService) === 'function' && _d) || Object, (typeof (_e = typeof orgao_tipo_api_service_1.OrgaoTipoApiService !== 'undefined' && orgao_tipo_api_service_1.OrgaoTipoApiService) === 'function' && _e) || Object, (typeof (_f = typeof orgao_tipo_navigation_service_1.OrgaoTipoNavigationService !== 'undefined' && orgao_tipo_navigation_service_1.OrgaoTipoNavigationService) === 'function' && _f) || Object, (typeof (_g = typeof orgao_service_2.OrgaoTipoService !== 'undefined' && orgao_service_2.OrgaoTipoService) === 'function' && _g) || Object, (typeof (_h = typeof funcionario_api_service_1.FuncionarioApiService !== 'undefined' && funcionario_api_service_1.FuncionarioApiService) === 'function' && _h) || Object, (typeof (_j = typeof funcionario_service_1.FuncionarioService !== 'undefined' && funcionario_service_1.FuncionarioService) === 'function' && _j) || Object, (typeof (_k = typeof pessoa_navigation_service_1.PessoaNavigationService !== 'undefined' && pessoa_navigation_service_1.PessoaNavigationService) === 'function' && _k) || Object, (typeof (_l = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _l) || Object, (typeof (_m = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _m) || Object, (typeof (_o = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _o) || Object, (typeof (_p = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _p) || Object])
	    ], OrgaoFormComponent);
	    return OrgaoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
	}());
	exports.OrgaoFormComponent = OrgaoFormComponent;


/***/ },
/* 254 */
/***/ function(module, exports) {

	"use strict";
	var Orgao = (function () {
	    function Orgao() {
	    }
	    return Orgao;
	}());
	exports.Orgao = Orgao;


/***/ },
/* 255 */
/***/ function(module, exports) {

	"use strict";
	var TipoOrgao = (function () {
	    function TipoOrgao() {
	    }
	    return TipoOrgao;
	}());
	exports.TipoOrgao = TipoOrgao;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(155);
	var OrgaoTipoApiService = (function () {
	    function OrgaoTipoApiService(_restService) {
	        this._restService = _restService;
	    }
	    OrgaoTipoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    OrgaoTipoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    OrgaoTipoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    OrgaoTipoApiService.prototype.onGetAll = function (done) {
	        var filter = { "include": ["estado"], "order": ["codigoTCE"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    OrgaoTipoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["estado"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    OrgaoTipoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    OrgaoTipoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], OrgaoTipoApiService);
	    return OrgaoTipoApiService;
	    var _a;
	}());
	exports.OrgaoTipoApiService = OrgaoTipoApiService;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(147);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(149);
	var data_service_4 = __webpack_require__(155);
	var OrgaoTipoNavigationService = (function () {
	    function OrgaoTipoNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    OrgaoTipoNavigationService.prototype.goToList = function () {
	        var router = data_service_1.estruturasRoute + '/' + data_service_3.orgaosRoute + '/' + data_service_4.orgaoTiposRoute;
	        this._authService.navigateTo(router);
	    };
	    OrgaoTipoNavigationService.prototype.goToNew = function () {
	        var router = data_service_1.estruturasRoute + '/' + data_service_3.orgaosRoute + '/' + data_service_4.orgaoTiposRoute + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    OrgaoTipoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_1.estruturasRoute + '/' + data_service_3.orgaosRoute + '/' + data_service_4.orgaoTiposRoute + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    OrgaoTipoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], OrgaoTipoNavigationService);
	    return OrgaoTipoNavigationService;
	    var _a;
	}());
	exports.OrgaoTipoNavigationService = OrgaoTipoNavigationService;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var orgao_navigation_service_1 = __webpack_require__(204);
	var orgao_service_1 = __webpack_require__(189);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_1 = __webpack_require__(155);
	var data_service_2 = __webpack_require__(149);
	var OrgaoTipoService = (function () {
	    function OrgaoTipoService(_orgaoNavigationService, _orgaoService, _autocompleteService) {
	        this._orgaoNavigationService = _orgaoNavigationService;
	        this._orgaoService = _orgaoService;
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        text = this.templateText(state);
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    OrgaoTipoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.orgaoTiposStorage + '-new', object);
	    };
	    OrgaoTipoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.orgaoTiposStorage + "-new");
	        return JSON.parse(item);
	    };
	    OrgaoTipoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.orgaoTiposStorage + "-new");
	    };
	    OrgaoTipoService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.orgaosStorage) {
	                otherFormObject = this._orgaoService.getSessionStorage();
	                otherFormObject.tipoOrgao = Response;
	                this._orgaoService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.orgaoTiposStorage);
	        if (otherForm === data_service_2.orgaosStorage) {
	            otherFormObject = this._orgaoService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._orgaoNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._orgaoNavigationService.goToNew();
	            }
	        }
	    };
	    OrgaoTipoService.prototype.templateText = function (item) {
	        var id = '', text = '', estado = '';
	        if (item.codigoTCE) {
	            id = item.codigoTCE;
	            text = id + " - ";
	        }
	        if (item.estado) {
	            estado = " (" + item.estado.nome + ")";
	        }
	        text = text.concat(item.descricao).concat(estado);
	        return text;
	    };
	    OrgaoTipoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof orgao_navigation_service_1.OrgaoNavigationService !== 'undefined' && orgao_navigation_service_1.OrgaoNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof orgao_service_1.OrgaoService !== 'undefined' && orgao_service_1.OrgaoService) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object])
	    ], OrgaoTipoService);
	    return OrgaoTipoService;
	    var _a, _b, _c;
	}());
	exports.OrgaoTipoService = OrgaoTipoService;


/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{orgaosModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{orgaosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{orgaosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Identificação da entidade</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !razaoSocial.valid && submitted}\">\n                <label for=\"razaoSocial\">Razão social <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!razaoSocial.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"razaoSocial\" placeholder=\"\" [(ngModel)]=\"formObject.razaoSocial\" formControlName=\"razaoSocial\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" >\n                <label for=\"alias\">Alias</label>\n                <div>\n                    <input type=\"text\" id=\"alias\" placeholder=\"\" [(ngModel)]=\"formObject.alias\" formControlName=\"alias\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!cnpj.valid && submitted) || (cnpj.errors && cnpj.errors.incorrectCnpjFormat)}\">\n                <label for=\"cnpj\">CNPJ <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!cnpj.valid && submitted\">Este campo é obrigatório.</span>\n                    <span class=\"error-alert\" *ngIf=\"submitted && cnpj.errors && cnpj.errors.incorrectCnpjFormat\">Formato incorreto.</span>\n                    <input type=\"text\" id=\"cnpj\" placeholder=\"\" [(ngModel)]=\"formObject.cnpj\" formControlName=\"cnpj\" appCnpjMask maxlength=\"18\">\n                </div>\n            </div>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"tipoOrgao\"\n                                    (setObejct)=\"getTipoOrgaoObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"tipoOrgaoSelectId\"\n                                    [model]=\"tipoOrgaoObject\"\n                                    [_service]=\"_orgaoTipoApiService\"\n                                    [query]=\"orgaoTipoQuery\"\n                                    [templateResult]=\"tipoOrgaoTemplateResult\"\n                                    [label]=\"'Tipo de órgão'\"></autocomplete-component>\n\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"funcionario\"\n                                    (setObejct)=\"getFuncionariosObject($event)\"\n                                    (clearObject)=\"getFuncionariosObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"false\"\n                                    [selectId]=\"funcionarioSelectId\"\n                                    [model]=\"funcionarioObject\"\n                                    [_service]=\"_funcionarioApiService\"\n                                    [templateResult]=\"funcionarioTemplateResult\"\n                                    [apiCustom]=\"'/populado'\"\n                                    [query]=\"funcionarioQuery\"\n                                    [clear]=\"true\"\n                                    [label]=\"'Responsável'\"></autocomplete-component>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Contatos</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !telefone.valid && submitted}\">\n                <label for=\"telefone\">Telefone</label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!telefone.valid && submitted\">Número de telefone inválido.</span>\n                    <input type=\"text\" id=\"telefone\" [(ngModel)]=\"formObject.telefone\" maxlength=\"15\" appPhoneMask formControlName=\"telefone\" >\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !email.valid && submitted}\">\n                <label for=\"email\">Email</label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!email.valid && submitted\">Email inválido.</span>\n                    <input type=\"text\" id=\"email\" [(ngModel)]=\"formObject.email\" formControlName=\"email\">\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <app-endereco-form [formObject]=\"enderecoObject\" *ngIf=\"showAddress\"></app-endereco-form>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 260 */
166,
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var util_service_1 = __webpack_require__(88);
	var orgao_tipo_api_service_1 = __webpack_require__(256);
	var orgao_tipo_navigation_service_1 = __webpack_require__(257);
	var orgao_service_1 = __webpack_require__(189);
	var data_service_1 = __webpack_require__(155);
	var OrgaoTipoListComponent = (function () {
	    function OrgaoTipoListComponent(_orgaoTipoApiService, _orgaoTipoNavigationService, _orgaoService, _utilService) {
	        this._orgaoTipoApiService = _orgaoTipoApiService;
	        this._orgaoTipoNavigationService = _orgaoTipoNavigationService;
	        this._orgaoService = _orgaoService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.orgaoTiposModuleName = data_service_1.orgaoTiposModuleName;
	    }
	    OrgaoTipoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    OrgaoTipoListComponent.prototype.clickNew = function () {
	        this._orgaoService.clearSessionStorage();
	        this._orgaoTipoNavigationService.goToNew();
	    };
	    OrgaoTipoListComponent.prototype.clickEdit = function (item) {
	        this._orgaoService.clearSessionStorage();
	        this._orgaoTipoNavigationService.goToEdit(item.id);
	    };
	    OrgaoTipoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    OrgaoTipoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._orgaoTipoApiService.onGetAll(onDone);
	    };
	    OrgaoTipoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._orgaoTipoApiService.onDelete(item.id, onDone);
	    };
	    OrgaoTipoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(262),
	            styles: [__webpack_require__(263)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof orgao_tipo_api_service_1.OrgaoTipoApiService !== 'undefined' && orgao_tipo_api_service_1.OrgaoTipoApiService) === 'function' && _a) || Object, (typeof (_b = typeof orgao_tipo_navigation_service_1.OrgaoTipoNavigationService !== 'undefined' && orgao_tipo_navigation_service_1.OrgaoTipoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof orgao_service_1.OrgaoService !== 'undefined' && orgao_service_1.OrgaoService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], OrgaoTipoListComponent);
	    return OrgaoTipoListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.OrgaoTipoListComponent = OrgaoTipoListComponent;


/***/ },
/* 262 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{orgaoTiposModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{orgaoTiposModuleName.single | lowercase}} cadastrado</p>\n\n  <table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n      <th>Descrição</th>\n      <th>Código TCE</th>\n      <th>Estado</th>\n      <th class=\"small\"></th>\n    </tr>\n    </thead>\n    <tbody *ngFor=\"let item of(list | filter:listFilter.value:['codigoTCE', 'descricao', 'estado.nome'] | filterActive:showDisabled)\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n      <td>{{item.descricao}}</td>\n      <td>{{item.codigoTCE}}</td>\n      <td><span *ngIf=\"item.estado\">{{item.estado.nome}}</span></td>\n      <td class=\"geo-table--action\">\n        <a (click)=\"clickEdit(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n        </a>\n        <a (click)=\"clickDelete(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n        </a>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n";

/***/ },
/* 263 */
166,
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var estado_api_service_1 = __webpack_require__(265);
	var estado_model_1 = __webpack_require__(267);
	var data_service_1 = __webpack_require__(178);
	var orgao_tipo_api_service_1 = __webpack_require__(256);
	var orgao_tipo_navigation_service_1 = __webpack_require__(257);
	var autocomplete_service_1 = __webpack_require__(101);
	var orgao_tipo_model_1 = __webpack_require__(255);
	var orgao_service_1 = __webpack_require__(258);
	var data_service_2 = __webpack_require__(155);
	var OrgaoTipoFormComponent = (function () {
	    function OrgaoTipoFormComponent(_route, _utilService, _orgaoTipoApiService, _orgaoTipoNavigationService, _orgaoTipoService, _estadoApiService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._orgaoTipoApiService = _orgaoTipoApiService;
	        this._orgaoTipoNavigationService = _orgaoTipoNavigationService;
	        this._orgaoTipoService = _orgaoTipoService;
	        this._estadoApiService = _estadoApiService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.orgaoTiposModule = data_service_2.orgaoTiposModuleName;
	        this.formObject = new orgao_tipo_model_1.TipoOrgao();
	        this.estadoObject = new estado_model_1.Estado();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.estadosList = [];
	        this.ativo = new forms_1.FormControl('');
	        this.codigoTCE = new forms_1.FormControl('');
	        this.descricao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.estado = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseTipoOrgao = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            descricao: this.descricao,
	            codigoTCE: this.codigoTCE,
	            estado: this.estado
	        });
	    }
	    OrgaoTipoFormComponent.prototype.ngOnInit = function () {
	        this.getEstados();
	        this.isNewAutoComplete();
	    };
	    OrgaoTipoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    OrgaoTipoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    OrgaoTipoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.estadoObject.id) {
	                object.estadoId = this.estadoObject.id;
	            }
	            else {
	                object.estadoId = null;
	            }
	            if (this.formObject.id) {
	                this.onEditSetor(object);
	            }
	            else {
	                this.onAddSetor(object);
	            }
	        }
	    };
	    OrgaoTipoFormComponent.prototype.onAddSetor = function (object) {
	        this._orgaoTipoApiService.onPost(object, this.onDone);
	    };
	    OrgaoTipoFormComponent.prototype.onEditSetor = function (object) {
	        this._orgaoTipoApiService.onPut(object, this.onDone);
	    };
	    OrgaoTipoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum tipo de órgão encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._orgaoTipoApiService.onGetById(id, onDone);
	    };
	    OrgaoTipoFormComponent.prototype.getEstados = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.estadosList = Response;
	                this.estadosList.unshift({ id: null, nome: '— Selecione —' });
	                this.setEstado(null);
	            }
	        }.bind(this));
	        this._estadoApiService.onGetAll(onDone);
	    };
	    OrgaoTipoFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.estadoId) {
	            delete this.formObject['estado'];
	            this.setEstado(this.formObject.estadoId);
	        }
	    };
	    OrgaoTipoFormComponent.prototype.setEstado = function (estadoId) {
	        var x, lenX;
	        if (!estadoId) {
	            estadoId = this.estadosList[0].id;
	        }
	        for (x = 0, lenX = this.estadosList.length; x < lenX; x++) {
	            if (this.estadosList[x].id === estadoId) {
	                this.estadoObject = this.estadosList[x];
	                break;
	            }
	        }
	    };
	    OrgaoTipoFormComponent.prototype.goToList = function () {
	        this._orgaoTipoNavigationService.goToList();
	    };
	    OrgaoTipoFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._orgaoTipoService.getSessionStorage();
	        this._orgaoTipoService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            if (id) {
	                this.setEditSession();
	            }
	            else {
	                this.setNewSession();
	            }
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    OrgaoTipoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_1.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_1.newRoute;
	        }
	    };
	    OrgaoTipoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    OrgaoTipoFormComponent.prototype.setNewNormal = function () {
	        this.setModelToForm();
	    };
	    OrgaoTipoFormComponent.prototype.setEditSession = function () {
	        setTimeout(function () {
	            this.setModelToForm();
	        }.bind(this));
	    };
	    OrgaoTipoFormComponent.prototype.setNewSession = function () {
	        this.setModelToForm();
	    };
	    OrgaoTipoFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_2.orgaoTiposStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.descricao = newAutoComplete.descricao;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    OrgaoTipoFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._orgaoTipoService.returnToOtherForm(this.otherForm, this.responseTipoOrgao);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    OrgaoTipoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(268),
	            styles: [__webpack_require__(269)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof orgao_tipo_api_service_1.OrgaoTipoApiService !== 'undefined' && orgao_tipo_api_service_1.OrgaoTipoApiService) === 'function' && _c) || Object, (typeof (_d = typeof orgao_tipo_navigation_service_1.OrgaoTipoNavigationService !== 'undefined' && orgao_tipo_navigation_service_1.OrgaoTipoNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof orgao_service_1.OrgaoTipoService !== 'undefined' && orgao_service_1.OrgaoTipoService) === 'function' && _e) || Object, (typeof (_f = typeof estado_api_service_1.EstadoApiService !== 'undefined' && estado_api_service_1.EstadoApiService) === 'function' && _f) || Object, (typeof (_g = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object])
	    ], OrgaoTipoFormComponent);
	    return OrgaoTipoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.OrgaoTipoFormComponent = OrgaoTipoFormComponent;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(266);
	var rest_service_1 = __webpack_require__(26);
	var EstadoApiService = (function () {
	    function EstadoApiService(_restService) {
	        this._restService = _restService;
	    }
	    EstadoApiService.prototype.onGetAll = function (done) {
	        var filter = { "where": { "ativo": true }, "order": "nome" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    EstadoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], EstadoApiService);
	    return EstadoApiService;
	    var _a;
	}());
	exports.EstadoApiService = EstadoApiService;


/***/ },
/* 266 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'estados';


/***/ },
/* 267 */
/***/ function(module, exports) {

	"use strict";
	var Estado = (function () {
	    function Estado() {
	    }
	    return Estado;
	}());
	exports.Estado = Estado;


/***/ },
/* 268 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <ul class=\"geo-breadcrumb\">\n    <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{orgaoTiposModule.plural}}</a></li>\n    <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{orgaoTiposModule.single | lowercase}}</a></li>\n  </ul>\n  <h1>{{actionTitle | capitalize}} {{orgaoTiposModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n  <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n    <div class=\"geo-columns--12c\">\n      <label class=\"geo-switch\">\n        <span class=\"geo-switch--label\">Ativo</span>\n        <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n        <div class=\"geo-switch--checkbox\">\n          <span class=\"geo-switch--status\"></span>\n        </div>\n      </label>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !descricao.valid && submitted}\">\n      <label for=\"descricao\">Descrição <abbr>*</abbr></label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!descricao.valid && submitted\">Este campo é obrigatório.</span>\n        <input type=\"text\" id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\">\n      </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n      <label for=\"codigoTce\">Código TCE </label>\n      <div>\n        <input type=\"text\" id=\"codigoTce\" [(ngModel)]=\"formObject.codigoTCE\" formControlName=\"codigoTCE\" appNumberInteger>\n      </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n      <label for=\"estado\">Estado</label>\n      <div>\n        <select id=\"estado\" [(ngModel)]=\"estadoObject\" formControlName=\"estado\" class=\"option_{{estadoObject.id}}\">\n          <option *ngFor=\"let item of estadosList\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.nome}}</option>\n        </select>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n  </div>\n</form>\n";

/***/ },
/* 269 */
166,
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var OrgaosComponent = (function () {
	    function OrgaosComponent() {
	    }
	    OrgaosComponent.prototype.ngOnInit = function () {
	    };
	    OrgaosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(271)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OrgaosComponent);
	    return OrgaosComponent;
	}());
	exports.OrgaosComponent = OrgaosComponent;


/***/ },
/* 271 */
171,
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var area_form_component_1 = __webpack_require__(273);
	var data_service_1 = __webpack_require__(178);
	var AreasRoutingModule = (function () {
	    function AreasRoutingModule() {
	    }
	    AreasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AreasRoutingModule);
	    return AreasRoutingModule;
	}());
	exports.AreasRoutingModule = AreasRoutingModule;
	exports.areasRoutes = [
	    {
	        path: data_service_1.editRoute + '/:id',
	        component: area_form_component_1.AreaFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: area_form_component_1.AreaFormComponent
	    }
	];


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var orgao_model_1 = __webpack_require__(254);
	var data_service_1 = __webpack_require__(190);
	var data_service_2 = __webpack_require__(147);
	var phone_validation_1 = __webpack_require__(92);
	var util_service_1 = __webpack_require__(88);
	var data_service_3 = __webpack_require__(178);
	var area_model_1 = __webpack_require__(274);
	var area_api_service_1 = __webpack_require__(275);
	var area_service_1 = __webpack_require__(192);
	var area_navigation_service_1 = __webpack_require__(191);
	var data_service_4 = __webpack_require__(149);
	var orgao_navigation_service_1 = __webpack_require__(204);
	var orgao_api_service_1 = __webpack_require__(250);
	var autocomplete_service_1 = __webpack_require__(101);
	var email_validation_1 = __webpack_require__(91);
	var contato_service_1 = __webpack_require__(276);
	var area_contato_api_service_1 = __webpack_require__(277);
	var AreaFormComponent = (function () {
	    function AreaFormComponent(_route, _utilService, _areaApiService, _areaService, _areaNavigationService, _orgaosNavigationService, _orgaoApiService, _autocompleteService, _contatoTipoService, _areaContatoApiService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._areaApiService = _areaApiService;
	        this._areaService = _areaService;
	        this._areaNavigationService = _areaNavigationService;
	        this._orgaosNavigationService = _orgaosNavigationService;
	        this._orgaoApiService = _orgaoApiService;
	        this._autocompleteService = _autocompleteService;
	        this._contatoTipoService = _contatoTipoService;
	        this._areaContatoApiService = _areaContatoApiService;
	        this._fb = _fb;
	        this.estruturasModule = data_service_2.estruturasModuleName;
	        this.areasModule = data_service_1.areasModuleName;
	        this.formObject = new area_model_1.Area();
	        this.orgaoObject = new orgao_model_1.Orgao();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showSelectOrgao = false;
	        this.orgaoSelectId = 'orgaoSelect';
	        this.orgaoQuery = data_service_4.orgaosQuery;
	        this.contatosList = [];
	        this.ativo = new forms_1.FormControl('');
	        this.nome = new forms_1.FormControl('', forms_1.Validators.required);
	        this.codigoUnidadeOrcamentaria = new forms_1.FormControl('');
	        this.nomeResponsavel = new forms_1.FormControl('');
	        this.telefoneResponsavel = new forms_1.FormControl('', forms_1.Validators.compose([phone_validation_1.PhoneValidator.phoneFormat]));
	        this.emailResponsavel = new forms_1.FormControl('', forms_1.Validators.compose([email_validation_1.EmailValidator.emailFormat]));
	        this.orgao = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responsArea = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            nome: this.nome,
	            codigoUnidadeOrcamentaria: this.codigoUnidadeOrcamentaria,
	            nomeResponsavel: this.nomeResponsavel,
	            telefoneResponsavel: this.telefoneResponsavel,
	            emailResponsavel: this.emailResponsavel,
	            orgao: this.orgao
	        });
	    }
	    AreaFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    AreaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    AreaFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    AreaFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.orgaoObject.id) {
	                object.orgaoId = this.orgaoObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (object.telefoneResponsavel) {
	                object.telefoneResponsavel = this._utilService.removeSpecialCharacter(object.telefoneResponsavel);
	            }
	            if (this.contatosList.length) {
	                var contatos = [], cloneContatos = this._utilService.cloneObject(this.contatosList), x, lenX;
	                for (x = 0, lenX = cloneContatos.length; x < lenX; x++) {
	                    if (cloneContatos[x].contato && cloneContatos[x].tipo) {
	                        cloneContatos[x].tipoContatoId = cloneContatos[x].tipo.id;
	                        delete cloneContatos[x]['tipo'];
	                        contatos.push(cloneContatos[x]);
	                    }
	                }
	                object.Contatos = contatos;
	            }
	            if (this.formObject.id) {
	                this.onEditArea(object);
	            }
	            else {
	                this.onAddArea(object);
	            }
	        }
	    };
	    AreaFormComponent.prototype.getOrgaosObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.formObject;
	            thisFormObject.orgao = this.orgaoObject;
	            thisFormObject.Contatos = this.contatosList;
	            this._areaService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                razaoSocial: object.text,
	                form: data_service_1.areasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.orgaosStorage);
	            this._orgaosNavigationService.goToNew();
	        }
	        else {
	            this.orgaoObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'orgao', object);
	        }
	    };
	    AreaFormComponent.prototype.onAddArea = function (object) {
	        this._areaApiService.onPost(object, this.onDone);
	    };
	    AreaFormComponent.prototype.onEditArea = function (object) {
	        this._areaApiService.onPut(object, this.onDone);
	    };
	    AreaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma área encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._areaApiService.onGetById(id, onDone);
	    };
	    AreaFormComponent.prototype.getContatosAreas = function (areaId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.contatosList = Response;
	            }
	        }.bind(this));
	        this._areaContatoApiService.onGetByArea(areaId, onDone);
	    };
	    AreaFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.orgao) {
	            this.orgaoObject = this.formObject.orgao;
	            delete this.formObject['orgao'];
	            var selectObject = { text: this.orgaoObject.razaoSocial, id: this.orgaoObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.orgaoSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.orgaoSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'orgao', this.orgaoObject);
	        }
	        if (this.formObject.Contatos) {
	            this.contatosList = this.formObject.Contatos;
	            delete this.formObject['Contatos'];
	        }
	    };
	    AreaFormComponent.prototype.goToList = function () {
	        this._areaService.clearSessionStorage();
	        this._areaNavigationService.goToList();
	    };
	    AreaFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._areaService.getSessionStorage();
	        this._areaService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            if (id) {
	                this.setEditSession();
	            }
	            else {
	                this.setNewSession();
	            }
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    AreaFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_3.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_3.newRouteFemale;
	        }
	    };
	    AreaFormComponent.prototype.setEditNormal = function (id) {
	        this.showSelectOrgao = true;
	        this.getContatosAreas(id);
	        this.getObject(id);
	    };
	    AreaFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	        this.orgaoObject = this._areaService.getSessionStorageFatherModule();
	        this.setModelToForm();
	    };
	    AreaFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	        this.showSelectOrgao = true;
	        setTimeout(function () {
	            this.setModelToForm();
	        }.bind(this));
	    };
	    AreaFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	        this.setModelToForm();
	    };
	    AreaFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.areasStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.nome = newAutoComplete.nome;
	            this.showSelectOrgao = true;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    AreaFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._areaService.returnToOtherForm(this.otherForm, this.responsArea);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    AreaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(279),
	            styles: [__webpack_require__(280)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _c) || Object, (typeof (_d = typeof area_service_1.AreaService !== 'undefined' && area_service_1.AreaService) === 'function' && _d) || Object, (typeof (_e = typeof area_navigation_service_1.AreaNavigationService !== 'undefined' && area_navigation_service_1.AreaNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof orgao_navigation_service_1.OrgaoNavigationService !== 'undefined' && orgao_navigation_service_1.OrgaoNavigationService) === 'function' && _f) || Object, (typeof (_g = typeof orgao_api_service_1.OrgaoApiService !== 'undefined' && orgao_api_service_1.OrgaoApiService) === 'function' && _g) || Object, (typeof (_h = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _h) || Object, (typeof (_j = typeof contato_service_1.ContatoTipoService !== 'undefined' && contato_service_1.ContatoTipoService) === 'function' && _j) || Object, (typeof (_k = typeof area_contato_api_service_1.AreaContatoApiService !== 'undefined' && area_contato_api_service_1.AreaContatoApiService) === 'function' && _k) || Object, (typeof (_l = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _l) || Object])
	    ], AreaFormComponent);
	    return AreaFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.AreaFormComponent = AreaFormComponent;


/***/ },
/* 274 */
/***/ function(module, exports) {

	"use strict";
	var Area = (function () {
	    function Area() {
	    }
	    return Area;
	}());
	exports.Area = Area;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(190);
	var rest_service_1 = __webpack_require__(26);
	var AreaApiService = (function () {
	    function AreaApiService(_restService) {
	        this._restService = _restService;
	    }
	    AreaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    AreaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    AreaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    AreaApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "nome", "include": "orgao" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    AreaApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": "orgao" };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    AreaApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    AreaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], AreaApiService);
	    return AreaApiService;
	    var _a;
	}());
	exports.AreaApiService = AreaApiService;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ContatoTipoService = (function () {
	    function ContatoTipoService() {
	    }
	    ContatoTipoService.prototype.getTipoTelefoneCelular = function (itemId) {
	        var test = false;
	        if (itemId === 1 || itemId === 2) {
	            test = true;
	        }
	        return test;
	    };
	    ContatoTipoService.prototype.getTipoEmail = function (itemId) {
	        var test = false;
	        if (itemId === 3) {
	            test = true;
	        }
	        return test;
	    };
	    ContatoTipoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], ContatoTipoService);
	    return ContatoTipoService;
	}());
	exports.ContatoTipoService = ContatoTipoService;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(278);
	var AreaContatoApiService = (function () {
	    function AreaContatoApiService(_restService) {
	        this._restService = _restService;
	    }
	    AreaContatoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    AreaContatoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    AreaContatoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    AreaContatoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "contato" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    AreaContatoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGet(data_service_1.apiName + '/' + objectId + '?', done);
	    };
	    AreaContatoApiService.prototype.onGetByArea = function (areaId, done) {
	        var filter = { "order": "contato", "where": { "areaId": areaId } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    AreaContatoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    AreaContatoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], AreaContatoApiService);
	    return AreaContatoApiService;
	    var _a;
	}());
	exports.AreaContatoApiService = AreaContatoApiService;


/***/ },
/* 278 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'contatos-areas';


/***/ },
/* 279 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <ul class=\"geo-breadcrumb\">\n    <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{areasModule.plural}}</a></li>\n    <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{areasModule.single | lowercase}}</a></li>\n  </ul>\n  <h1>{{actionTitle | capitalize}} {{areasModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n  <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n    <div class=\"geo-columns--12c\">\n      <label class=\"geo-switch\">\n        <span class=\"geo-switch--label\">Ativo</span>\n        <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n        <div class=\"geo-switch--checkbox\">\n          <span class=\"geo-switch--status\"></span>\n        </div>\n      </label>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <h2>Identificação da área</h2>\n    <div class=\"geo-columns--12c\">\n      <div class=\"geo-input--3c\" *ngIf=\"!showSelectOrgao\">\n        <label for=\"orgao\">Órgão <abbr>*</abbr></label>\n        <div>\n          <input type=\"text\" disabled id=\"orgao\" [(ngModel)]=\"orgaoObject.razaoSocial\" formControlName=\"orgao\">\n        </div>\n      </div>\n\n      <autocomplete-component class=\"geo-input--3c\" id=\"orgaoSelect\" *ngIf=\"showSelectOrgao\"\n                              (setObejct)=\"getOrgaosObject($event)\"\n                              [submitted]=\"submitted\"\n                              [isRequired]=\"true\"\n                              [selectId]=\"orgaoSelectId\"\n                              [model]=\"orgaoObject\"\n                              [_service]=\"_orgaoApiService\"\n                              [fieldToShow]=\"'razaoSocial'\"\n                              [query]=\"orgaoQuery\"\n                              [label]=\"'Órgão'\"></autocomplete-component>\n\n      <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !nome.valid && submitted}\">\n        <label for=\"nome\">Área <abbr>*</abbr></label>\n        <div>\n          <span class=\"error-alert\" *ngIf=\"!nome.valid && submitted\">Este campo é obrigatório.</span>\n          <input type=\"text\" id=\"nome\" [(ngModel)]=\"formObject.nome\" formControlName=\"nome\" autofocus>\n        </div>\n      </div>\n\n      <div class=\"geo-input--3c\">\n        <label for=\"codigoUnidadeOrcamentaria\">Unidade orçamentária</label>\n        <div>\n          <input type=\"text\" id=\"codigoUnidadeOrcamentaria\" placeholder=\"\" [(ngModel)]=\"formObject.codigoUnidadeOrcamentaria\" formControlName=\"codigoUnidadeOrcamentaria\" appNumberInteger>\n        </div>\n      </div>\n\n      <div class=\"geo-input--3c\" >\n        <label for=\"nomeResponsavel\">Responsável</label>\n        <div>\n          <input type=\"text\" id=\"nomeResponsavel\" [(ngModel)]=\"formObject.nomeResponsavel\" formControlName=\"nomeResponsavel\">\n        </div>\n      </div>\n\n      <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !telefoneResponsavel.valid && submitted}\">\n        <label for=\"telefoneResponsavel\">Telefone do responsável</label>\n        <div>\n          <span class=\"error-alert\" *ngIf=\"!telefoneResponsavel.valid && submitted\">Número de telefone inválido.</span>\n          <input type=\"text\" id=\"telefoneResponsavel\" [(ngModel)]=\"formObject.telefoneResponsavel\" formControlName=\"telefoneResponsavel\" appPhoneMask maxlength=\"15\">\n        </div>\n      </div>\n\n      <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !emailResponsavel.valid && submitted}\">\n        <label for=\"emailResponsavel\">Email do responsável</label>\n        <div>\n          <span class=\"error-alert\" *ngIf=\"!emailResponsavel.valid && submitted\">Email inválido.</span>\n          <input type=\"text\" id=\"emailResponsavel\" [(ngModel)]=\"formObject.emailResponsavel\" formControlName=\"emailResponsavel\">\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <app-contato-form [list]=\"contatosList\"></app-contato-form>\n\n  <div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n  </div>\n</form>\n";

/***/ },
/* 280 */
166,
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AreasComponent = (function () {
	    function AreasComponent() {
	    }
	    AreasComponent.prototype.ngOnInit = function () {
	    };
	    AreasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(282)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AreasComponent);
	    return AreasComponent;
	}());
	exports.AreasComponent = AreasComponent;


/***/ },
/* 282 */
171,
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var divisao_list_component_1 = __webpack_require__(284);
	var divisao_form_component_1 = __webpack_require__(288);
	var data_service_1 = __webpack_require__(178);
	var DivisoesRoutingModule = (function () {
	    function DivisoesRoutingModule() {
	    }
	    DivisoesRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DivisoesRoutingModule);
	    return DivisoesRoutingModule;
	}());
	exports.DivisoesRoutingModule = DivisoesRoutingModule;
	exports.divisoesRoutes = [
	    {
	        path: '',
	        component: divisao_list_component_1.DivisaoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: divisao_form_component_1.DivisaoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: divisao_form_component_1.DivisaoFormComponent
	    }
	];


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(150);
	var divisao_api_service_1 = __webpack_require__(285);
	var divisao_navigation_service_1 = __webpack_require__(193);
	var divisao_service_1 = __webpack_require__(194);
	var util_service_1 = __webpack_require__(88);
	var DivisaoListComponent = (function () {
	    function DivisaoListComponent(_divisoesApiService, _divisoesService, _divisaoNavigationService, _utilService) {
	        this._divisoesApiService = _divisoesApiService;
	        this._divisoesService = _divisoesService;
	        this._divisaoNavigationService = _divisaoNavigationService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.divisoesModuleName = data_service_1.divisoesModuleName;
	    }
	    DivisaoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    DivisaoListComponent.prototype.clickNew = function () {
	        this._divisoesService.clearSessionStorage();
	        this._divisaoNavigationService.goToNew();
	    };
	    DivisaoListComponent.prototype.clickEdit = function (item) {
	        this._divisoesService.clearSessionStorage();
	        this._divisaoNavigationService.goToEdit(item.id);
	    };
	    DivisaoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    DivisaoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._divisoesApiService.onGetAll(onDone);
	    };
	    DivisaoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._divisoesApiService.onDelete(item.id, onDone);
	    };
	    DivisaoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(286),
	            styles: [__webpack_require__(287)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof divisao_api_service_1.DivisaoApiService !== 'undefined' && divisao_api_service_1.DivisaoApiService) === 'function' && _a) || Object, (typeof (_b = typeof divisao_service_1.DivisoesService !== 'undefined' && divisao_service_1.DivisoesService) === 'function' && _b) || Object, (typeof (_c = typeof divisao_navigation_service_1.DivisaoNavigationService !== 'undefined' && divisao_navigation_service_1.DivisaoNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], DivisaoListComponent);
	    return DivisaoListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.DivisaoListComponent = DivisaoListComponent;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(150);
	var DivisaoApiService = (function () {
	    function DivisaoApiService(_restService) {
	        this._restService = _restService;
	    }
	    DivisaoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    DivisaoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    DivisaoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    DivisaoApiService.prototype.onGetAll = function (done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', {}, done); //busca divisoes populado com setores
	    };
	    DivisaoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["area"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    DivisaoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    DivisaoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], DivisaoApiService);
	    return DivisaoApiService;
	    var _a;
	}());
	exports.DivisaoApiService = DivisaoApiService;


/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{divisoesModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{divisoesModuleName.single | lowercase}} cadastrada</p>\n\n  <table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n      <th>Divisão</th>\n      <th>Área</th>\n      <th class=\"small\"></th>\n    </tr>\n    </thead>\n    <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['divisao', 'area.nome'] | filterActive:showDisabled | sort:['divisao'])\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n      <td><span class=\"geo-arrow\"></span>{{item.divisao}}</td>\n      <td ><span *ngIf=\"item.area\">{{item.area.nome}}</span></td>\n      <td class=\"geo-table--action\">\n        <a (click)=\"clickEdit(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n        </a>\n        <a (click)=\"clickDelete(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n        </a>\n      </td>\n    </tr>\n    <tr class=\"description\">\n      <td colspan=\"100%\">\n\n        <app-setor-list [list]=\"item.Setores\" [divisaoObject]=\"item\" [showDisabled]=\"showDisabled\"></app-setor-list>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n";

/***/ },
/* 287 */
166,
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(147);
	var data_service_2 = __webpack_require__(150);
	var divisao_model_1 = __webpack_require__(289);
	var divisao_navigation_service_1 = __webpack_require__(193);
	var divisao_api_service_1 = __webpack_require__(285);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_3 = __webpack_require__(178);
	var area_api_service_1 = __webpack_require__(275);
	var area_model_1 = __webpack_require__(274);
	var divisao_service_1 = __webpack_require__(194);
	var data_service_4 = __webpack_require__(190);
	var area_navigation_service_1 = __webpack_require__(191);
	var DivisaoFormComponent = (function () {
	    function DivisaoFormComponent(_route, _divisaoNavigationService, _divisaoApiService, _divisoesService, _areaApiService, _areaNavigationService, _utilService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._divisaoNavigationService = _divisaoNavigationService;
	        this._divisaoApiService = _divisaoApiService;
	        this._divisoesService = _divisoesService;
	        this._areaApiService = _areaApiService;
	        this._areaNavigationService = _areaNavigationService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.estruturasModule = data_service_1.estruturasModuleName;
	        this.divisoesModule = data_service_2.divisoesModuleName;
	        this.formObject = new divisao_model_1.Divisao();
	        this.areaObject = new area_model_1.Area();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.areaSelectId = 'area';
	        this.areasQuery = data_service_4.areasQuery;
	        this.divisao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.area = new forms_1.FormControl('');
	        this.ativo = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseDivisao = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            divisao: this.divisao,
	            area: this.area
	        });
	    }
	    DivisaoFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    DivisaoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    DivisaoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    DivisaoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.areaObject.id) {
	                object.areaId = this.areaObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.formObject.id) {
	                this.onEditDivisao(object);
	            }
	            else {
	                this.onAddDivisao(object);
	            }
	        }
	    };
	    DivisaoFormComponent.prototype.getAreasObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.formObject;
	            thisFormObject.area = this.areaObject;
	            this._divisoesService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                nome: object.text,
	                form: data_service_2.divisoesStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.areasStorage);
	            this._areaNavigationService.goToNew();
	        }
	        else {
	            this.areaObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'area', object);
	        }
	    };
	    DivisaoFormComponent.prototype.onAddDivisao = function (object) {
	        this._divisaoApiService.onPost(object, this.onDone);
	    };
	    DivisaoFormComponent.prototype.onEditDivisao = function (object) {
	        this._divisaoApiService.onPut(object, this.onDone);
	    };
	    DivisaoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma divisão encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._divisaoApiService.onGetById(id, onDone);
	    };
	    DivisaoFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._divisoesService.getSessionStorage();
	        this._divisoesService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    DivisaoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_3.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_3.newRouteFemale;
	        }
	    };
	    DivisaoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    DivisaoFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    DivisaoFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    DivisaoFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    DivisaoFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_2.divisoesStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.divisao = newAutoComplete.divisao;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    DivisaoFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.area) {
	            this.areaObject = this._utilService.cloneObject(this.formObject.area);
	            delete this.formObject['area'];
	            var selectObject = { text: this.areaObject.nome, id: this.areaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.areaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.areaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'area', this.areaObject);
	        }
	    };
	    DivisaoFormComponent.prototype.goToList = function () {
	        this._divisaoNavigationService.goToList();
	    };
	    DivisaoFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._divisoesService.returnToOtherForm(this.otherForm, this.responseDivisao);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    DivisaoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(290),
	            styles: [__webpack_require__(291)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof divisao_navigation_service_1.DivisaoNavigationService !== 'undefined' && divisao_navigation_service_1.DivisaoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof divisao_api_service_1.DivisaoApiService !== 'undefined' && divisao_api_service_1.DivisaoApiService) === 'function' && _c) || Object, (typeof (_d = typeof divisao_service_1.DivisoesService !== 'undefined' && divisao_service_1.DivisoesService) === 'function' && _d) || Object, (typeof (_e = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _e) || Object, (typeof (_f = typeof area_navigation_service_1.AreaNavigationService !== 'undefined' && area_navigation_service_1.AreaNavigationService) === 'function' && _f) || Object, (typeof (_g = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _g) || Object, (typeof (_h = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], DivisaoFormComponent);
	    return DivisaoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.DivisaoFormComponent = DivisaoFormComponent;


/***/ },
/* 289 */
/***/ function(module, exports) {

	"use strict";
	var Divisao = (function () {
	    function Divisao() {
	    }
	    return Divisao;
	}());
	exports.Divisao = Divisao;


/***/ },
/* 290 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <ul class=\"geo-breadcrumb\">\n    <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{divisoesModule.plural}}</a></li>\n    <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{divisoesModule.single | lowercase}}</a></li>\n  </ul>\n  <h1>{{actionTitle | capitalize}} {{divisoesModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n  <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n    <div class=\"geo-columns--12c\">\n      <label class=\"geo-switch\">\n        <span class=\"geo-switch--label\">Ativo</span>\n        <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n        <div class=\"geo-switch--checkbox\">\n          <span class=\"geo-switch--status\"></span>\n        </div>\n      </label>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <autocomplete-component class=\"geo-input--3c\" id=\"area\"\n                            (setObejct)=\"getAreasObject($event)\"\n                            [submitted]=\"submitted\"\n                            [isRequired]=\"true\"\n                            [selectId]=\"areaSelectId\"\n                            [model]=\"areaObject\"\n                            [_service]=\"_areaApiService\"\n                            [fieldToShow]=\"'nome'\"\n                            [query]=\"areasQuery\"\n                            [label]=\"'Área'\"></autocomplete-component>\n\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !divisao.valid && submitted}\">\n      <label for=\"divisao\">Divisão <abbr>*</abbr></label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!divisao.valid && submitted\">Este campo é obrigatório.</span>\n        <input type=\"text\" id=\"divisao\" placeholder=\"\" [(ngModel)]=\"formObject.divisao\" formControlName=\"divisao\">\n      </div>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n  </div>\n</form>\n";

/***/ },
/* 291 */
166,
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var DivisoesComponent = (function () {
	    function DivisoesComponent() {
	    }
	    DivisoesComponent.prototype.ngOnInit = function () {
	    };
	    DivisoesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(293)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DivisoesComponent);
	    return DivisoesComponent;
	}());
	exports.DivisoesComponent = DivisoesComponent;


/***/ },
/* 293 */
171,
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var setor_form_component_1 = __webpack_require__(295);
	var data_service_1 = __webpack_require__(178);
	var SetoresRoutingModule = (function () {
	    function SetoresRoutingModule() {
	    }
	    SetoresRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SetoresRoutingModule);
	    return SetoresRoutingModule;
	}());
	exports.SetoresRoutingModule = SetoresRoutingModule;
	exports.setoresRoutes = [
	    {
	        path: data_service_1.editRoute + '/:id',
	        component: setor_form_component_1.SetorFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: setor_form_component_1.SetorFormComponent
	    }
	];


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(196);
	var data_service_2 = __webpack_require__(147);
	var data_service_3 = __webpack_require__(178);
	var setor_model_1 = __webpack_require__(296);
	var setor_api_service_1 = __webpack_require__(297);
	var setor_service_1 = __webpack_require__(197);
	var autocomplete_service_1 = __webpack_require__(101);
	var divisao_model_1 = __webpack_require__(289);
	var divisao_navigation_service_1 = __webpack_require__(193);
	var setor_navigation_service_1 = __webpack_require__(195);
	var divisao_api_service_1 = __webpack_require__(285);
	var data_service_4 = __webpack_require__(150);
	var SetorFormComponent = (function () {
	    function SetorFormComponent(_route, _utilService, _setoreservice, _setorApiService, _setorNavigationService, _divisaoNavigationService, _divisaoApiService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._setoreservice = _setoreservice;
	        this._setorApiService = _setorApiService;
	        this._setorNavigationService = _setorNavigationService;
	        this._divisaoNavigationService = _divisaoNavigationService;
	        this._divisaoApiService = _divisaoApiService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.estruturasModule = data_service_2.estruturasModuleName;
	        this.setoresModule = data_service_1.setoresModuleName;
	        this.formObject = new setor_model_1.Setor();
	        this.divisaoObject = new divisao_model_1.Divisao();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showSelectDivisao = false;
	        this.divisaoSelectId = 'divisaoSelect';
	        this.divisaoQuery = data_service_4.divisoesQuery;
	        this.ativo = new forms_1.FormControl('');
	        this.setor = new forms_1.FormControl('', forms_1.Validators.required);
	        this.divisao = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responsSetor = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            setor: this.setor,
	            divisao: this.divisao
	        });
	    }
	    SetorFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    SetorFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    SetorFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    SetorFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.divisaoObject.id) {
	                object.divisaoId = this.divisaoObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.formObject.id) {
	                this.onEditSetor(object);
	            }
	            else {
	                this.onAddSetor(object);
	            }
	        }
	    };
	    SetorFormComponent.prototype.getDivisoesObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.formObject;
	            thisFormObject.divisao = this.divisaoObject;
	            this._setoreservice.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                divisao: object.text,
	                form: data_service_1.setoresStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.divisoesStorage);
	            this._divisaoNavigationService.goToNew();
	        }
	        else {
	            this.divisaoObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'divisao', object);
	        }
	    };
	    SetorFormComponent.prototype.onAddSetor = function (object) {
	        this._setorApiService.onPost(object, this.onDone);
	    };
	    SetorFormComponent.prototype.onEditSetor = function (object) {
	        this._setorApiService.onPut(object, this.onDone);
	    };
	    SetorFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum setor encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._setorApiService.onGetById(id, onDone);
	    };
	    SetorFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.divisao) {
	            this.divisaoObject = this.formObject.divisao;
	            delete this.formObject['divisao'];
	            var selectObject = { text: this.divisaoObject.divisao, id: this.divisaoObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.divisaoSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.divisaoSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'divisao', this.divisaoObject);
	        }
	    };
	    SetorFormComponent.prototype.goToList = function () {
	        this._setoreservice.clearSessionStorage();
	        this._setorNavigationService.goToList();
	    };
	    SetorFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._setoreservice.getSessionStorage();
	        this._setoreservice.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            if (id) {
	                this.setEditSession();
	            }
	            else {
	                this.setNewSession();
	            }
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    SetorFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_3.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_3.newRoute;
	        }
	    };
	    SetorFormComponent.prototype.setEditNormal = function (id) {
	        this.showSelectDivisao = true;
	        this.getObject(id);
	    };
	    SetorFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	        this.divisaoObject = this._setoreservice.getSessionStorageFatherModule();
	        this.setModelToForm();
	    };
	    SetorFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	        this.showSelectDivisao = true;
	        setTimeout(function () {
	            this.setModelToForm();
	        }.bind(this));
	    };
	    SetorFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	        this.setModelToForm();
	    };
	    SetorFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.setoresStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.setor = newAutoComplete.setor;
	            this.showSelectDivisao = true;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    SetorFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._setoreservice.returnToOtherForm(this.otherForm, this.responsSetor);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    SetorFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(298),
	            styles: [__webpack_require__(299)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof setor_service_1.SetorService !== 'undefined' && setor_service_1.SetorService) === 'function' && _c) || Object, (typeof (_d = typeof setor_api_service_1.SetorApiService !== 'undefined' && setor_api_service_1.SetorApiService) === 'function' && _d) || Object, (typeof (_e = typeof setor_navigation_service_1.SetorNavigationService !== 'undefined' && setor_navigation_service_1.SetorNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof divisao_navigation_service_1.DivisaoNavigationService !== 'undefined' && divisao_navigation_service_1.DivisaoNavigationService) === 'function' && _f) || Object, (typeof (_g = typeof divisao_api_service_1.DivisaoApiService !== 'undefined' && divisao_api_service_1.DivisaoApiService) === 'function' && _g) || Object, (typeof (_h = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], SetorFormComponent);
	    return SetorFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.SetorFormComponent = SetorFormComponent;


/***/ },
/* 296 */
/***/ function(module, exports) {

	"use strict";
	var Setor = (function () {
	    function Setor() {
	    }
	    return Setor;
	}());
	exports.Setor = Setor;


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(196);
	var rest_service_1 = __webpack_require__(26);
	var SetorApiService = (function () {
	    function SetorApiService(_restService) {
	        this._restService = _restService;
	    }
	    SetorApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    SetorApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    SetorApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    SetorApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "setor", "include": "divisao" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    SetorApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["divisao"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    SetorApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    SetorApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], SetorApiService);
	    return SetorApiService;
	    var _a;
	}());
	exports.SetorApiService = SetorApiService;


/***/ },
/* 298 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <ul class=\"geo-breadcrumb\">\n    <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{setoresModule.plural}}</a></li>\n    <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{setoresModule.single | lowercase}}</a></li>\n  </ul>\n  <h1>{{actionTitle | capitalize}} {{setoresModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n  <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n    <div class=\"geo-columns--12c\">\n      <label class=\"geo-switch\">\n        <span class=\"geo-switch--label\">Ativo</span>\n        <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n        <div class=\"geo-switch--checkbox\">\n          <span class=\"geo-switch--status\"></span>\n        </div>\n      </label>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <div class=\"geo-input--3c\" *ngIf=\"!showSelectDivisao\">\n      <label for=\"divisao\">Divisão <abbr>*</abbr></label>\n      <div>\n        <input type=\"text\" disabled id=\"divisao\" [(ngModel)]=\"divisaoObject.divisao\" formControlName=\"divisao\">\n      </div>\n    </div>\n\n    <autocomplete-component class=\"geo-input--3c\" id=\"divisaoSelect\" *ngIf=\"showSelectDivisao\"\n                            (setObejct)=\"getDivisoesObject($event)\"\n                            [submitted]=\"submitted\"\n                            [isRequired]=\"true\"\n                            [selectId]=\"divisaoSelectId\"\n                            [model]=\"divisaoObject\"\n                            [_service]=\"_divisaoApiService\"\n                            [fieldToShow]=\"'divisao'\"\n                            [query]=\"divisaoQuery\"\n                            [label]=\"'Divisão'\"></autocomplete-component>\n\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !setor.valid && submitted}\">\n      <label for=\"setor\">Setor <abbr>*</abbr></label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!setor.valid && submitted\">Este campo é obrigatório.</span>\n        <input type=\"text\" id=\"setor\" [(ngModel)]=\"formObject.setor\" formControlName=\"setor\" autofocus>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n  </div>\n</form>\n";

/***/ },
/* 299 */
166,
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SetoresComponent = (function () {
	    function SetoresComponent() {
	    }
	    SetoresComponent.prototype.ngOnInit = function () {
	    };
	    SetoresComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(301)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SetoresComponent);
	    return SetoresComponent;
	}());
	exports.SetoresComponent = SetoresComponent;


/***/ },
/* 301 */
171,
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var BensComponent = (function () {
	    function BensComponent() {
	    }
	    BensComponent.prototype.ngOnInit = function () {
	    };
	    BensComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(303)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BensComponent);
	    return BensComponent;
	}());
	exports.BensComponent = BensComponent;


/***/ },
/* 303 */
171,
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var MarcasComponent = (function () {
	    function MarcasComponent() {
	    }
	    MarcasComponent.prototype.ngOnInit = function () {
	    };
	    MarcasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(305)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MarcasComponent);
	    return MarcasComponent;
	}());
	exports.MarcasComponent = MarcasComponent;


/***/ },
/* 305 */
171,
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var marca_list_component_1 = __webpack_require__(307);
	var marca_form_component_1 = __webpack_require__(316);
	var data_service_1 = __webpack_require__(178);
	var MarcasRoutingModule = (function () {
	    function MarcasRoutingModule() {
	    }
	    MarcasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MarcasRoutingModule);
	    return MarcasRoutingModule;
	}());
	exports.MarcasRoutingModule = MarcasRoutingModule;
	exports.marcasRoutes = [
	    {
	        path: '',
	        component: marca_list_component_1.MarcaListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: marca_form_component_1.MarcaFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: marca_form_component_1.MarcaFormComponent
	    }
	];


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(152);
	var marca_api_service_1 = __webpack_require__(308);
	var marca_navigation_service_1 = __webpack_require__(309);
	var marca_service_1 = __webpack_require__(310);
	var util_service_1 = __webpack_require__(88);
	var MarcaListComponent = (function () {
	    function MarcaListComponent(_marcasApiService, _marcasService, _marcaNavigationService, _utilService) {
	        this._marcasApiService = _marcasApiService;
	        this._marcasService = _marcasService;
	        this._marcaNavigationService = _marcaNavigationService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.marcasModuleName = data_service_1.marcasModuleName;
	    }
	    MarcaListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    MarcaListComponent.prototype.clickNew = function () {
	        this._marcasService.clearSessionStorage();
	        this._marcaNavigationService.goToNew();
	    };
	    MarcaListComponent.prototype.clickEdit = function (item) {
	        this._marcasService.clearSessionStorage();
	        this._marcaNavigationService.goToEdit(item.id);
	    };
	    MarcaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    MarcaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._marcasApiService.onGetAll(onDone);
	    };
	    MarcaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._marcasApiService.onDelete(item.id, onDone);
	    };
	    MarcaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(314),
	            styles: [__webpack_require__(315)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof marca_api_service_1.MarcaApiService !== 'undefined' && marca_api_service_1.MarcaApiService) === 'function' && _a) || Object, (typeof (_b = typeof marca_service_1.MarcasService !== 'undefined' && marca_service_1.MarcasService) === 'function' && _b) || Object, (typeof (_c = typeof marca_navigation_service_1.MarcaNavigationService !== 'undefined' && marca_navigation_service_1.MarcaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], MarcaListComponent);
	    return MarcaListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MarcaListComponent = MarcaListComponent;


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(152);
	var MarcaApiService = (function () {
	    function MarcaApiService(_restService) {
	        this._restService = _restService;
	    }
	    MarcaApiService.prototype.onPost = function (object, done) {
	        return this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    MarcaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    MarcaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    MarcaApiService.prototype.onGetAll = function (done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', {}, done); //busca marcas populado com modelos
	    };
	    MarcaApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    MarcaApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    MarcaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], MarcaApiService);
	    return MarcaApiService;
	    var _a;
	}());
	exports.MarcaApiService = MarcaApiService;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(151);
	var data_service_2 = __webpack_require__(152);
	var auth_service_1 = __webpack_require__(61);
	var data_service_3 = __webpack_require__(178);
	var MarcaNavigationService = (function () {
	    function MarcaNavigationService(_authService) {
	        this._authService = _authService;
	        this.fatherRouter = data_service_1.bensRoute;
	        this.moduleRouter = data_service_2.marcasRoute;
	    }
	    MarcaNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    MarcaNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    MarcaNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    MarcaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], MarcaNavigationService);
	    return MarcaNavigationService;
	    var _a;
	}());
	exports.MarcaNavigationService = MarcaNavigationService;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(152);
	var autocomplete_service_1 = __webpack_require__(101);
	var modelo_navigation_service_1 = __webpack_require__(311);
	var modelo_service_1 = __webpack_require__(313);
	var data_service_2 = __webpack_require__(312);
	var data_service_3 = __webpack_require__(154);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_service_1 = __webpack_require__(203);
	var MarcasService = (function () {
	    function MarcasService(_modeloNavigationService, _modeloService, _frotaNavigationService, _frotaService, _autocompleteService) {
	        this._modeloNavigationService = _modeloNavigationService;
	        this._modeloService = _modeloService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaService = _frotaService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    MarcasService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.marcasStorage + '-new', object);
	    };
	    MarcasService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.marcasStorage + "-new");
	        return JSON.parse(item);
	    };
	    MarcasService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.marcasStorage + "-new");
	    };
	    MarcasService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_2.modelosStorage) {
	                otherFormObject = this._modeloService.getSessionStorage();
	                otherFormObject.marca = Response;
	                this._modeloService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.frotasStorage) {
	                otherFormObject = this._frotaService.getSessionStorage();
	                otherFormObject.modelo = { marca: Response };
	                this._frotaService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.marcasStorage);
	        if (otherForm === data_service_2.modelosStorage) {
	            otherFormObject = this._modeloService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._modeloNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._modeloNavigationService.goToNew();
	            }
	        }
	        else if (otherForm === data_service_3.frotasStorage) {
	            otherFormObject = this._frotaService.getSessionStorage();
	            var frotasRoute = otherFormObject.thisRoute;
	            if (otherFormObject.id) {
	                this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
	            }
	            else {
	                this._frotaNavigationService.goToNew(frotasRoute);
	            }
	        }
	    };
	    MarcasService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof modelo_navigation_service_1.ModeloNavigationService !== 'undefined' && modelo_navigation_service_1.ModeloNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof modelo_service_1.ModeloService !== 'undefined' && modelo_service_1.ModeloService) === 'function' && _b) || Object, (typeof (_c = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object])
	    ], MarcasService);
	    return MarcasService;
	    var _a, _b, _c, _d, _e;
	}());
	exports.MarcasService = MarcasService;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(312);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(152);
	var data_service_4 = __webpack_require__(151);
	var ModeloNavigationService = (function () {
	    function ModeloNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.modelosRoute;
	        this.marcasRouter = data_service_3.marcasRoute;
	        this.fatherRouter = data_service_4.bensRoute;
	    }
	    ModeloNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.marcasRouter;
	        this._authService.navigateTo(router);
	    };
	    ModeloNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    ModeloNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    ModeloNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ModeloNavigationService);
	    return ModeloNavigationService;
	    var _a;
	}());
	exports.ModeloNavigationService = ModeloNavigationService;


/***/ },
/* 312 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'modelos';
	exports.modelosRoute = 'modelos';
	exports.modelosStorage = 'modelos';
	exports.modelosModuleName = { plural: 'Modelos', single: 'Modelo' };
	exports.modelosQueryComCategoria = { "Modelo": { "modelo": { "regexp": "/REPLACEHERE/i" }, "ativo": true }, "Categoria": { "id": "REPLACECATEGORIAID" } };
	exports.modelosQueryComCategoriaMarca = { "Modelo": { "modelo": { "regexp": "/REPLACEHERE/i" }, "ativo": true, "marcaId": "REPLACEMARCAID" }, "Categoria": { "id": "REPLACECATEGORIAID" } };


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(312);
	var autocomplete_service_1 = __webpack_require__(101);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_service_1 = __webpack_require__(203);
	var data_service_2 = __webpack_require__(154);
	var ModeloService = (function () {
	    function ModeloService(_frotaNavigationService, _frotaService, _autocompleteService) {
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaService = _frotaService;
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var tipo;
	                        if (state.tipoBem) {
	                            tipo = state.tipoBem.tipo;
	                        }
	                        text = state.modelo + ' / ' + tipo;
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    ModeloService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.modelosStorage + '-new', object);
	    };
	    ModeloService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.modelosStorage + "-new");
	        return JSON.parse(item);
	    };
	    ModeloService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.modelosStorage + "-new");
	    };
	    ModeloService.prototype.setSessionStorageFatherModule = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.modelosStorage + '-father', object);
	    };
	    ModeloService.prototype.getSessionStorageFatherModule = function () {
	        var item = sessionStorage.getItem(data_service_1.modelosStorage + "-father");
	        return JSON.parse(item);
	    };
	    ModeloService.prototype.clearSessionStorageFatherModule = function () {
	        sessionStorage.removeItem(data_service_1.modelosStorage + "-father");
	    };
	    ModeloService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.frotasStorage) {
	                otherFormObject = this._frotaService.getSessionStorage();
	                otherFormObject.modelo = Response;
	                this._frotaService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.modelosStorage);
	        if (otherForm === data_service_2.frotasStorage) {
	            otherFormObject = this._frotaService.getSessionStorage();
	            var frotasRoute = otherFormObject.thisRoute;
	            if (otherFormObject.id) {
	                this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
	            }
	            else {
	                this._frotaNavigationService.goToNew(frotasRoute);
	            }
	        }
	    };
	    ModeloService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object])
	    ], ModeloService);
	    return ModeloService;
	    var _a, _b, _c;
	}());
	exports.ModeloService = ModeloService;


/***/ },
/* 314 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{marcasModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{marcasModuleName.single | lowercase}} cadastrada</p>\n\n  <table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n      <th>Marca</th>\n      <th class=\"small\"></th>\n    </tr>\n    </thead>\n    <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['marca'] | filterActive:showDisabled | sort:['marca'])\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n      <td><span class=\"geo-arrow\"></span>{{item.marca}}</td>\n      <td class=\"geo-table--action\">\n        <a (click)=\"clickEdit(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n        </a>\n        <a (click)=\"clickDelete(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n        </a>\n      </td>\n    </tr>\n    <tr class=\"description\">\n      <td colspan=\"100%\">\n\n        <app-modelo-list [list]=\"item.Modelos\" [marcaObject]=\"item\" [showDisabled]=\"showDisabled\"></app-modelo-list>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n";

/***/ },
/* 315 */
166,
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(152);
	var marca_model_1 = __webpack_require__(317);
	var marca_navigation_service_1 = __webpack_require__(309);
	var marca_api_service_1 = __webpack_require__(308);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(178);
	var marca_service_1 = __webpack_require__(310);
	var MarcaFormComponent = (function () {
	    function MarcaFormComponent(_route, _marcaNavigationService, _marcaApiService, _marcasService, _utilService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._marcaNavigationService = _marcaNavigationService;
	        this._marcaApiService = _marcaApiService;
	        this._marcasService = _marcasService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.marcasModule = data_service_1.marcasModuleName;
	        this.formObject = new marca_model_1.Marca();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.marca = new forms_1.FormControl('', forms_1.Validators.required);
	        this.ativo = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseMarca = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            marca: this.marca
	        });
	    }
	    MarcaFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    MarcaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    MarcaFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    MarcaFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEditMarca(object);
	            }
	            else {
	                this.onAddMarca(object);
	            }
	        }
	    };
	    MarcaFormComponent.prototype.onAddMarca = function (object) {
	        this._marcaApiService.onPost(object, this.onDone);
	    };
	    MarcaFormComponent.prototype.onEditMarca = function (object) {
	        this._marcaApiService.onPut(object, this.onDone);
	    };
	    MarcaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma marca encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._marcaApiService.onGetById(id, onDone);
	    };
	    MarcaFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._marcasService.getSessionStorage();
	        this._marcasService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    MarcaFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    MarcaFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    MarcaFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    MarcaFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    MarcaFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    MarcaFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.marcasStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.marca = newAutoComplete.marca;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    MarcaFormComponent.prototype.setModelToForm = function () {
	    };
	    MarcaFormComponent.prototype.goToList = function () {
	        this._marcaNavigationService.goToList();
	    };
	    MarcaFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._marcasService.returnToOtherForm(this.otherForm, this.responseMarca);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    MarcaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(318),
	            styles: [__webpack_require__(319)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof marca_navigation_service_1.MarcaNavigationService !== 'undefined' && marca_navigation_service_1.MarcaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof marca_api_service_1.MarcaApiService !== 'undefined' && marca_api_service_1.MarcaApiService) === 'function' && _c) || Object, (typeof (_d = typeof marca_service_1.MarcasService !== 'undefined' && marca_service_1.MarcasService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _g) || Object])
	    ], MarcaFormComponent);
	    return MarcaFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.MarcaFormComponent = MarcaFormComponent;


/***/ },
/* 317 */
/***/ function(module, exports) {

	"use strict";
	var Marca = (function () {
	    function Marca() {
	    }
	    return Marca;
	}());
	exports.Marca = Marca;


/***/ },
/* 318 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <ul class=\"geo-breadcrumb\">\n    <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{marcasModule.plural}}</a></li>\n    <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{marcasModule.single | lowercase}}</a></li>\n  </ul>\n  <h1>{{actionTitle | capitalize}} {{marcasModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n  <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n    <div class=\"geo-columns--12c\">\n      <label class=\"geo-switch\">\n        <span class=\"geo-switch--label\">Ativo</span>\n        <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n        <div class=\"geo-switch--checkbox\">\n          <span class=\"geo-switch--status\"></span>\n        </div>\n      </label>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !marca.valid && submitted}\">\n      <label for=\"marca\">Marca <abbr>*</abbr></label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!marca.valid && submitted\">Este campo é obrigatório.</span>\n        <input type=\"text\" id=\"marca\" placeholder=\"\" [(ngModel)]=\"formObject.marca\" formControlName=\"marca\">\n      </div>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n  </div>\n</form>\n";

/***/ },
/* 319 */
166,
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CategoriasComponent = (function () {
	    function CategoriasComponent() {
	    }
	    CategoriasComponent.prototype.ngOnInit = function () {
	    };
	    CategoriasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(321)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CategoriasComponent);
	    return CategoriasComponent;
	}());
	exports.CategoriasComponent = CategoriasComponent;


/***/ },
/* 321 */
171,
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var categoria_list_component_1 = __webpack_require__(323);
	var data_service_1 = __webpack_require__(178);
	var categoria_form_component_1 = __webpack_require__(328);
	var CategoriasRoutingModule = (function () {
	    function CategoriasRoutingModule() {
	    }
	    CategoriasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CategoriasRoutingModule);
	    return CategoriasRoutingModule;
	}());
	exports.CategoriasRoutingModule = CategoriasRoutingModule;
	exports.categoriasRoutes = [
	    {
	        path: '',
	        component: categoria_list_component_1.CategoriaListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: categoria_form_component_1.CategoriaFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: categoria_form_component_1.CategoriaFormComponent
	    }
	];


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(153);
	var categoria_api_service_1 = __webpack_require__(324);
	var categoria_navigation_service_1 = __webpack_require__(325);
	var util_service_1 = __webpack_require__(88);
	var CategoriaListComponent = (function () {
	    function CategoriaListComponent(_categoriaApiService, _categoriaNavigationService, _utilService) {
	        this._categoriaApiService = _categoriaApiService;
	        this._categoriaNavigationService = _categoriaNavigationService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.categoriasModuleName = data_service_1.categoriasModuleName;
	    }
	    CategoriaListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    CategoriaListComponent.prototype.clickNew = function () {
	        this._categoriaNavigationService.goToNew();
	    };
	    CategoriaListComponent.prototype.clickEdit = function (item) {
	        this._categoriaNavigationService.goToEdit(item.id);
	    };
	    CategoriaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        if (item.id === 1 || item.id === 2 || item.id === 3 || item.id === 4 || item.id === 5 || item.id === 6) {
	            swal("Aviso!", "Não é possível excluir esta categoria", "warning");
	        }
	        else {
	            this._utilService.swalMessageDelete(onDelete);
	        }
	    };
	    CategoriaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._categoriaApiService.onGetAll(onDone);
	    };
	    CategoriaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._categoriaApiService.onDelete(item.id, onDone);
	    };
	    CategoriaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(326),
	            styles: [__webpack_require__(327)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof categoria_api_service_1.CategoriaApiService !== 'undefined' && categoria_api_service_1.CategoriaApiService) === 'function' && _a) || Object, (typeof (_b = typeof categoria_navigation_service_1.CategoriaNavigationService !== 'undefined' && categoria_navigation_service_1.CategoriaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object])
	    ], CategoriaListComponent);
	    return CategoriaListComponent;
	    var _a, _b, _c;
	}());
	exports.CategoriaListComponent = CategoriaListComponent;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(153);
	var rest_service_1 = __webpack_require__(26);
	var CategoriaApiService = (function () {
	    function CategoriaApiService(_restService) {
	        this._restService = _restService;
	    }
	    CategoriaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    CategoriaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    CategoriaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    CategoriaApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "categoria", "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    CategoriaApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    CategoriaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], CategoriaApiService);
	    return CategoriaApiService;
	    var _a;
	}());
	exports.CategoriaApiService = CategoriaApiService;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(151);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(153);
	var data_service_3 = __webpack_require__(178);
	var CategoriaNavigationService = (function () {
	    function CategoriaNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    CategoriaNavigationService.prototype.goToList = function () {
	        var router = data_service_1.bensRoute + '/' + data_service_2.categoriasRoute;
	        this._authService.navigateTo(router);
	    };
	    CategoriaNavigationService.prototype.goToNew = function () {
	        var router = data_service_1.bensRoute + '/' + data_service_2.categoriasRoute + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    CategoriaNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_1.bensRoute + '/' + data_service_2.categoriasRoute + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    CategoriaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], CategoriaNavigationService);
	    return CategoriaNavigationService;
	    var _a;
	}());
	exports.CategoriaNavigationService = CategoriaNavigationService;


/***/ },
/* 326 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{categoriasModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{categoriasModuleName.single | lowercase}} cadastrada</p>\n\n  <table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n      <th>Categoria</th>\n      <th>Código TCE</th>\n      <th class=\"small\"></th>\n    </tr>\n    </thead>\n    <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['categoria', 'codigoTce'] | filterActive:showDisabled | sort:['categoria'])\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n      <td><span class=\"geo-arrow\"></span>{{item.categoria}}</td>\n      <td>{{item.codigoTce}}</td>\n      <td class=\"geo-table--action\">\n        <a (click)=\"clickEdit(item)\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n        </a>\n        <a (click)=\"clickDelete(item)\" *ngIf=\"item.id !== 1 && item.id !== 2 && item.id !== 3 && item.id !== 4 && item.id !== 5 && item.id !== 6\">\n          <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n        </a>\n      </td>\n    </tr>\n    <tr class=\"description\">\n      <td colspan=\"100%\">\n        <app-bem-tipos-list [categoriaObject]=\"item\" [showDisabled]=\"showDisabled\"></app-bem-tipos-list>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n";

/***/ },
/* 327 */
166,
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 24/11/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(153);
	var categoria_model_1 = __webpack_require__(329);
	var categoria_navigation_service_1 = __webpack_require__(325);
	var categoria_api_service_1 = __webpack_require__(324);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var CategoriaFormComponent = (function () {
	    function CategoriaFormComponent(_route, _categoriaNavigationService, _categoriaApiService, _utilService, _fb) {
	        this._route = _route;
	        this._categoriaNavigationService = _categoriaNavigationService;
	        this._categoriaApiService = _categoriaApiService;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this.moduleName = data_service_1.categoriasModuleName;
	        this.formObject = new categoria_model_1.Categoria();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.categoria = new forms_1.FormControl('', forms_1.Validators.required);
	        this.codigoTce = new forms_1.FormControl('');
	        this.ativo = new forms_1.FormControl('');
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            categoria: this.categoria,
	            codigoTce: this.codigoTce
	        });
	    }
	    CategoriaFormComponent.prototype.ngOnInit = function () {
	        this.testSession();
	    };
	    CategoriaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    CategoriaFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    CategoriaFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEditCategoria(object);
	            }
	            else {
	                this.onAddCategoria(object);
	            }
	        }
	    };
	    CategoriaFormComponent.prototype.onAddCategoria = function (object) {
	        this._categoriaApiService.onPost(object, this.onDone);
	    };
	    CategoriaFormComponent.prototype.onEditCategoria = function (object) {
	        this._categoriaApiService.onPut(object, this.onDone);
	    };
	    CategoriaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma categoria encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._categoriaApiService.onGetById(id, onDone);
	    };
	    CategoriaFormComponent.prototype.testSession = function () {
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.setEditNormal(id);
	        }
	        else {
	            this.setNewNormal();
	        }
	        this.setActionTitle(id);
	    };
	    CategoriaFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    CategoriaFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    CategoriaFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    CategoriaFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    CategoriaFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    CategoriaFormComponent.prototype.setModelToForm = function () {
	    };
	    CategoriaFormComponent.prototype.goToList = function () {
	        this._categoriaNavigationService.goToList();
	    };
	    CategoriaFormComponent.prototype.toLeaveHere = function () {
	        this.goToList();
	    };
	    CategoriaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(330),
	            styles: [__webpack_require__(331)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof categoria_navigation_service_1.CategoriaNavigationService !== 'undefined' && categoria_navigation_service_1.CategoriaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof categoria_api_service_1.CategoriaApiService !== 'undefined' && categoria_api_service_1.CategoriaApiService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _e) || Object])
	    ], CategoriaFormComponent);
	    return CategoriaFormComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.CategoriaFormComponent = CategoriaFormComponent;


/***/ },
/* 329 */
/***/ function(module, exports) {

	"use strict";
	var Categoria = (function () {
	    function Categoria() {
	    }
	    return Categoria;
	}());
	exports.Categoria = Categoria;


/***/ },
/* 330 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <ul class=\"geo-breadcrumb\">\n    <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{moduleName.plural}}</a></li>\n    <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{moduleName.single | lowercase}}</a></li>\n  </ul>\n  <h1>{{actionTitle | capitalize}} {{moduleName.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n  <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n    <div class=\"geo-columns--12c\">\n      <label class=\"geo-switch\">\n        <span class=\"geo-switch--label\">Ativo</span>\n        <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n        <div class=\"geo-switch--checkbox\">\n          <span class=\"geo-switch--status\"></span>\n        </div>\n      </label>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !categoria.valid && submitted}\">\n      <label for=\"categoria\">Categoria <abbr>*</abbr></label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!categoria.valid && submitted\">Este campo é obrigatório.</span>\n        <input type=\"text\" id=\"categoria\" placeholder=\"\" [(ngModel)]=\"formObject.categoria\" formControlName=\"categoria\">\n      </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n      <label for=\"codigo_tce\">Código TCE</label>\n      <div>\n        <input type=\"text\" id=\"codigo_tce\" placeholder=\"\" [(ngModel)]=\"formObject.codigoTce\" formControlName=\"codigoTce\" appNumberInteger>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n  </div>\n</form>\n";

/***/ },
/* 331 */
166,
/* 332 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-bens';
	exports.bemTiposRoute = 'tipos';
	exports.bemTiposStorage = 'bemTipos';
	exports.bemTiposModuleName = { plural: 'Tipos de Bens', single: 'Tipo de Bem' };
	exports.bemTiposQueryCategoria = {
	    "where": {
	        "ativo": true,
	        "tipo": { "regexp": "/REPLACEHERE/i" },
	        "categoriaId": null
	    },
	    "order": "tipo"
	};


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var BemTiposComponent = (function () {
	    function BemTiposComponent() {
	    }
	    BemTiposComponent.prototype.ngOnInit = function () {
	    };
	    BemTiposComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(334)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BemTiposComponent);
	    return BemTiposComponent;
	}());
	exports.BemTiposComponent = BemTiposComponent;


/***/ },
/* 334 */
171,
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var bem_tipos_list_component_1 = __webpack_require__(336);
	var bem_tipos_form_component_1 = __webpack_require__(343);
	var BemTiposRoutingModule = (function () {
	    function BemTiposRoutingModule() {
	    }
	    BemTiposRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BemTiposRoutingModule);
	    return BemTiposRoutingModule;
	}());
	exports.BemTiposRoutingModule = BemTiposRoutingModule;
	exports.bemTiposRoutes = [
	    {
	        path: '',
	        component: bem_tipos_list_component_1.BemTiposListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: bem_tipos_form_component_1.BemTiposFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: bem_tipos_form_component_1.BemTiposFormComponent
	    }
	];


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(332);
	var bem_tipos_model_1 = __webpack_require__(337);
	var bem_tipos_navigation_service_1 = __webpack_require__(338);
	var bem_tipos_api_service_1 = __webpack_require__(339);
	var util_service_1 = __webpack_require__(88);
	var bem_tipos_service_1 = __webpack_require__(340);
	var BemTiposListComponent = (function () {
	    function BemTiposListComponent(_bemTipoNavigationService, _bemTiposApiService, _bemTiposService, _utilService) {
	        this._bemTipoNavigationService = _bemTipoNavigationService;
	        this._bemTiposApiService = _bemTiposApiService;
	        this._bemTiposService = _bemTiposService;
	        this._utilService = _utilService;
	        this.categoriaObject = new bem_tipos_model_1.BemTipo();
	        this.showDisabled = true;
	        this.bemTiposModule = data_service_1.bemTiposModuleName;
	        this.list = [];
	    }
	    BemTiposListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    BemTiposListComponent.prototype.clickNew = function () {
	        this._bemTiposService.setSessionStorageFatherModule(this.categoriaObject);
	        this._bemTipoNavigationService.goToNew();
	    };
	    BemTiposListComponent.prototype.clickEdit = function (item) {
	        this._bemTiposService.clearSessionStorage();
	        this._bemTipoNavigationService.goToEdit(item.id);
	    };
	    BemTiposListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    BemTiposListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._bemTiposApiService.onGetByCategoria(this.categoriaObject.id, onDone);
	    };
	    BemTiposListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._bemTiposApiService.onDelete(item.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof bem_tipos_model_1.BemTipo !== 'undefined' && bem_tipos_model_1.BemTipo) === 'function' && _a) || Object)
	    ], BemTiposListComponent.prototype, "categoriaObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], BemTiposListComponent.prototype, "showDisabled", void 0);
	    BemTiposListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-bem-tipos-list',
	            template: __webpack_require__(341),
	            styles: [__webpack_require__(342)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof bem_tipos_navigation_service_1.BemTiposNavigationService !== 'undefined' && bem_tipos_navigation_service_1.BemTiposNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof bem_tipos_api_service_1.BemTiposApiService !== 'undefined' && bem_tipos_api_service_1.BemTiposApiService) === 'function' && _c) || Object, (typeof (_d = typeof bem_tipos_service_1.BemTiposService !== 'undefined' && bem_tipos_service_1.BemTiposService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], BemTiposListComponent);
	    return BemTiposListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.BemTiposListComponent = BemTiposListComponent;


/***/ },
/* 337 */
/***/ function(module, exports) {

	"use strict";
	var BemTipo = (function () {
	    function BemTipo() {
	    }
	    return BemTipo;
	}());
	exports.BemTipo = BemTipo;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(151);
	var data_service_2 = __webpack_require__(332);
	var auth_service_1 = __webpack_require__(61);
	var data_service_3 = __webpack_require__(178);
	var data_service_4 = __webpack_require__(153);
	var BemTiposNavigationService = (function () {
	    function BemTiposNavigationService(_authService) {
	        this._authService = _authService;
	        this.fatherRouter = data_service_1.bensRoute;
	        this.categoriaRouter = data_service_4.categoriasRoute;
	        this.moduleRouter = data_service_2.bemTiposRoute;
	    }
	    BemTiposNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.categoriaRouter;
	        this._authService.navigateTo(router);
	    };
	    BemTiposNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    BemTiposNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    BemTiposNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], BemTiposNavigationService);
	    return BemTiposNavigationService;
	    var _a;
	}());
	exports.BemTiposNavigationService = BemTiposNavigationService;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(332);
	var BemTiposApiService = (function () {
	    function BemTiposApiService(_restService) {
	        this._restService = _restService;
	    }
	    BemTiposApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    BemTiposApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    BemTiposApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    BemTiposApiService.prototype.onGetAll = function (done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', {}, done); //busca bemTipos populado com subtipos
	    };
	    BemTiposApiService.prototype.onGetById = function (objectId, done) {
	        var object = { "id": objectId }; //"body=%7B%22id%22%3A"+objectId+"%7D";
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', object, done); //busca o tipo de bem por id, com os subtipos populado
	    };
	    BemTiposApiService.prototype.onGetByCategoria = function (categoriaId, done) {
	        var object = { "categoriaId": categoriaId }; //"body=%7B%22categoriaId%22%3A"+categoriaId+"%7D";
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', object, done); //busca os tipos de bens por categoria, populado com subtipos
	    };
	    BemTiposApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    BemTiposApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], BemTiposApiService);
	    return BemTiposApiService;
	    var _a;
	}());
	exports.BemTiposApiService = BemTiposApiService;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(332);
	var autocomplete_service_1 = __webpack_require__(101);
	var modelo_navigation_service_1 = __webpack_require__(311);
	var modelo_service_1 = __webpack_require__(313);
	var data_service_2 = __webpack_require__(312);
	var BemTiposService = (function () {
	    function BemTiposService(_modeloNavigationService, _modeloService, _autocompleteService) {
	        this._modeloNavigationService = _modeloNavigationService;
	        this._modeloService = _modeloService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    BemTiposService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.bemTiposStorage + '-new', object);
	    };
	    BemTiposService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.bemTiposStorage + "-new");
	        return JSON.parse(item);
	    };
	    BemTiposService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.bemTiposStorage + "-new");
	    };
	    BemTiposService.prototype.setSessionStorageFatherModule = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.bemTiposStorage + '-father', object);
	    };
	    BemTiposService.prototype.getSessionStorageFatherModule = function () {
	        var item = sessionStorage.getItem(data_service_1.bemTiposStorage + "-father");
	        return JSON.parse(item);
	    };
	    BemTiposService.prototype.clearSessionStorageFatherModule = function () {
	        sessionStorage.removeItem(data_service_1.bemTiposStorage + "-father");
	    };
	    BemTiposService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.modelosStorage) {
	                otherFormObject = this._modeloService.getSessionStorage();
	                otherFormObject.tipoBem = Response;
	                this._modeloService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.bemTiposStorage);
	        if (otherForm === data_service_2.modelosStorage) {
	            otherFormObject = this._modeloService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._modeloNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._modeloNavigationService.goToNew();
	            }
	        }
	    };
	    BemTiposService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof modelo_navigation_service_1.ModeloNavigationService !== 'undefined' && modelo_navigation_service_1.ModeloNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof modelo_service_1.ModeloService !== 'undefined' && modelo_service_1.ModeloService) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object])
	    ], BemTiposService);
	    return BemTiposService;
	    var _a, _b, _c;
	}());
	exports.BemTiposService = BemTiposService;


/***/ },
/* 341 */
/***/ function(module, exports) {

	module.exports = "<a class=\"geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickNew(item)\">Novo tipo</a>\n\n<table>\n  <thead>\n  <tr>\n    <th>Tipo</th>\n    <th>Código TCE</th>\n    <th class=\"small\"></th>\n  </tr>\n  </thead>\n  <tbody *ngIf=\"!list || list.length === 0\">\n  <tr>\n    <td colspan=\"5\">Nenhum {{bemTiposModule.single | lowercase}} cadastrado</td>\n  </tr>\n  </tbody>\n  <tbody data-collapse *ngFor=\"let item of(list | filterActive:showDisabled | sort:['tipo'])\">\n  <tr [ngClass]=\"{inative: !item.ativo}\">\n    <td><span class=\"geo-arrow\"></span>{{item.tipo}}</td>\n    <td>{{item.codigoTce}}</td>\n    <td class=\"geo-table--action\">\n      <a (click)=\"clickEdit(item)\">\n        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n      </a>\n      <a (click)=\"clickDelete(item)\">\n        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n      </a>\n    </td>\n  </tr>\n  <tr class=\"description\">\n    <td colspan=\"100%\">\n      <app-bem-subtipos-list [list]=\"item.SubTipos\" [showDisabled]=\"showDisabled\"></app-bem-subtipos-list>\n    </td>\n  </tr>\n  </tbody>\n</table>\n";

/***/ },
/* 342 */
166,
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(332);
	var bem_tipos_model_1 = __webpack_require__(337);
	var categoria_model_1 = __webpack_require__(329);
	var util_service_1 = __webpack_require__(88);
	var bem_tipos_api_service_1 = __webpack_require__(339);
	var bem_tipos_service_1 = __webpack_require__(340);
	var data_service_2 = __webpack_require__(178);
	var autocomplete_service_1 = __webpack_require__(101);
	var bem_tipos_navigation_service_1 = __webpack_require__(338);
	var categoria_api_service_1 = __webpack_require__(324);
	var BemTiposFormComponent = (function () {
	    function BemTiposFormComponent(_route, _bemTiposApiService, _bemTiposService, _bemTiposNavigationService, _utilService, _categoriaApiService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._bemTiposApiService = _bemTiposApiService;
	        this._bemTiposService = _bemTiposService;
	        this._bemTiposNavigationService = _bemTiposNavigationService;
	        this._utilService = _utilService;
	        this._categoriaApiService = _categoriaApiService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.bemTiposModule = data_service_1.bemTiposModuleName;
	        this.formObject = new bem_tipos_model_1.BemTipo();
	        this.categoriaObject = new categoria_model_1.Categoria();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showSelectCategoria = false;
	        this.categoriasList = [];
	        this.subtiposList = [];
	        this.categoria = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.codigoTce = new forms_1.FormControl('');
	        this.ativo = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseBemTipos = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            categoria: this.categoria,
	            tipo: this.tipo,
	            codigoTce: this.codigoTce
	        });
	    }
	    BemTiposFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    BemTiposFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    BemTiposFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    BemTiposFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.categoriaObject.id) {
	                object.categoriaId = this.categoriaObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.subtiposList.length) {
	                var subTipos = [], x, lenX;
	                for (x = 0, lenX = this.subtiposList.length; x < lenX; x++) {
	                    if (this.subtiposList[x].subTipo) {
	                        this.subtiposList[x].codigoTce = object.codigoTce;
	                        subTipos.push(this.subtiposList[x]);
	                    }
	                }
	                object.SubTipos = subTipos;
	            }
	            if (this.formObject.id) {
	                this.onEditBemTipos(object);
	            }
	            else {
	                this.onAddBemTipos(object);
	            }
	        }
	    };
	    BemTiposFormComponent.prototype.onAddBemTipos = function (object) {
	        this._bemTiposApiService.onPost(object, this.onDone);
	    };
	    BemTiposFormComponent.prototype.onEditBemTipos = function (object) {
	        this._bemTiposApiService.onPut(object, this.onDone);
	    };
	    BemTiposFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response[0];
	                this.subtiposList = Response[0].SubTipos;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum tipo de bem encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._bemTiposApiService.onGetById(id, onDone);
	    };
	    BemTiposFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._bemTiposService.getSessionStorage();
	        this._bemTiposService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            if (id) {
	                this.setEditSession();
	            }
	            else {
	                this.setNewSession();
	            }
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    BemTiposFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    BemTiposFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	        this.getCategorias();
	        this.showSelectCategoria = true;
	    };
	    BemTiposFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	        this.categoriaObject = this._bemTiposService.getSessionStorageFatherModule();
	        this.setModelToForm();
	        this.setCodigoTce();
	    };
	    BemTiposFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	        this.getCategorias();
	        this.setModelToForm();
	        this.showSelectCategoria = true;
	    };
	    BemTiposFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	        this.getCategorias();
	        this.setModelToForm();
	    };
	    BemTiposFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.bemTiposStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.tipo = newAutoComplete.tipo;
	            this.categoriaObject.id = newAutoComplete.categoriaId;
	            this.showSelectCategoria = true;
	            this.getCategorias();
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    BemTiposFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.categoria) {
	            this.categoriaObject = this.formObject.categoria;
	            delete this.formObject['categoria'];
	            if (this.categoriasList.length) {
	                this.setCategoria();
	            }
	        }
	    };
	    BemTiposFormComponent.prototype.goToList = function () {
	        this._bemTiposNavigationService.goToList();
	    };
	    BemTiposFormComponent.prototype.getCategorias = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.categoriasList = Response;
	                this.setCategoria();
	            }
	        }.bind(this));
	        this._categoriaApiService.onGetAll(onDone);
	    };
	    BemTiposFormComponent.prototype.setCategoria = function () {
	        var x, lenX;
	        // if (this.returnToOtherForm) {
	        //   this.categoriaObject = this.categoriasList[0];
	        // }
	        for (x = 0, lenX = this.categoriasList.length; x < lenX; x++) {
	            if (this.categoriasList[x].id === this.categoriaObject.id) {
	                this.categoriaObject = this.categoriasList[x];
	                break;
	            }
	        }
	        this.setCodigoTce();
	    };
	    BemTiposFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._bemTiposService.returnToOtherForm(this.otherForm, this.responseBemTipos);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    BemTiposFormComponent.prototype.setCodigoTce = function () {
	        if (!this.formObject.id && !this.formObject.codigoTce) {
	            this.formObject.codigoTce = this.categoriaObject.codigoTce;
	        }
	    };
	    BemTiposFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-bem-tipos-form',
	            template: __webpack_require__(344),
	            styles: [__webpack_require__(345)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof bem_tipos_api_service_1.BemTiposApiService !== 'undefined' && bem_tipos_api_service_1.BemTiposApiService) === 'function' && _b) || Object, (typeof (_c = typeof bem_tipos_service_1.BemTiposService !== 'undefined' && bem_tipos_service_1.BemTiposService) === 'function' && _c) || Object, (typeof (_d = typeof bem_tipos_navigation_service_1.BemTiposNavigationService !== 'undefined' && bem_tipos_navigation_service_1.BemTiposNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof categoria_api_service_1.CategoriaApiService !== 'undefined' && categoria_api_service_1.CategoriaApiService) === 'function' && _f) || Object, (typeof (_g = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object])
	    ], BemTiposFormComponent);
	    return BemTiposFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.BemTiposFormComponent = BemTiposFormComponent;


/***/ },
/* 344 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{bemTiposModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{bemTiposModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{bemTiposModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados da categoria</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" *ngIf=\"!showSelectCategoria\">\n                <label for=\"categoria2\">Categoria <abbr>*</abbr></label>\n                <div>\n                    <input type=\"text\" disabled id=\"categoria2\" [(ngModel)]=\"categoriaObject.categoria\" formControlName=\"categoria\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !categoria.valid && submitted}\" *ngIf=\"showSelectCategoria\">\n                <label for=\"categoria\">Categoria <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!categoria.valid && submitted\">Este campo é obrigatório.</span>\n                    <select id=\"categoria\" [(ngModel)]=\"categoriaObject\" formControlName=\"categoria\">\n                        <option *ngFor=\"let item of categoriasList\" [ngValue]=\"item\">{{item.categoria}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipo.valid && submitted}\">\n                <label for=\"tipo\">Tipo <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!tipo.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"tipo\" placeholder=\"\" [(ngModel)]=\"formObject.tipo\" formControlName=\"tipo\" autofocus>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"codigo_tce\">Código TCE</label>\n                <div>\n                    <input type=\"text\" id=\"codigo_tce\" placeholder=\"\" [(ngModel)]=\"formObject.codigoTce\" formControlName=\"codigoTce\" appNumberInteger>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <app-bem-subtipos-form [list]=\"subtiposList\"></app-bem-subtipos-form>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 345 */
166,
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ModelosComponent = (function () {
	    function ModelosComponent() {
	    }
	    ModelosComponent.prototype.ngOnInit = function () {
	    };
	    ModelosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(347)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ModelosComponent);
	    return ModelosComponent;
	}());
	exports.ModelosComponent = ModelosComponent;


/***/ },
/* 347 */
171,
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var modelo_form_component_1 = __webpack_require__(349);
	var data_service_1 = __webpack_require__(178);
	var ModelosRoutingModule = (function () {
	    function ModelosRoutingModule() {
	    }
	    ModelosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ModelosRoutingModule);
	    return ModelosRoutingModule;
	}());
	exports.ModelosRoutingModule = ModelosRoutingModule;
	exports.modelosRoutes = [
	    {
	        path: data_service_1.editRoute + '/:id',
	        component: modelo_form_component_1.ModeloFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: modelo_form_component_1.ModeloFormComponent
	    }
	];


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/12/2016.
	 */
	/**
	 * Created by Daniela on 19/12/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(312);
	var data_service_2 = __webpack_require__(178);
	var modelo_model_1 = __webpack_require__(350);
	var modelo_api_service_1 = __webpack_require__(351);
	var modelo_service_1 = __webpack_require__(313);
	var autocomplete_service_1 = __webpack_require__(101);
	var modelo_navigation_service_1 = __webpack_require__(311);
	var marca_model_1 = __webpack_require__(317);
	var categoria_model_1 = __webpack_require__(329);
	var bem_tipos_model_1 = __webpack_require__(337);
	var bem_subtipo_model_1 = __webpack_require__(352);
	var deslocamento_tipos_model_1 = __webpack_require__(353);
	var marca_navigation_service_1 = __webpack_require__(309);
	var marca_api_service_1 = __webpack_require__(308);
	var data_service_3 = __webpack_require__(152);
	var data_service_4 = __webpack_require__(332);
	var bem_tipos_navigation_service_1 = __webpack_require__(338);
	var categoria_api_service_1 = __webpack_require__(324);
	var deslocamento_tipos_api_service_1 = __webpack_require__(354);
	var bem_subtipo_api_service_1 = __webpack_require__(356);
	var bem_tipos_api_service_1 = __webpack_require__(339);
	var deslocamento_tipos_service_1 = __webpack_require__(358);
	var categoria_cnh_model_1 = __webpack_require__(218);
	var categoria_cnh_api_service_1 = __webpack_require__(216);
	var forma_controle_api_service_1 = __webpack_require__(359);
	var forma_controle_model_1 = __webpack_require__(361);
	var ModeloFormComponent = (function () {
	    function ModeloFormComponent(_route, _utilService, _modelosService, _modeloApiService, _modeloNavigationService, _marcaNavigationService, _marcaApiService, _bemTipoApiService, _bemTipoNavigationService, _categoriaApiService, _categoriaCnhApiService, _deslocamentoTipoApiService, _deslocamentoTipoService, _bemSubtipoApiService, _autocompleteService, _formaControleApiService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._modelosService = _modelosService;
	        this._modeloApiService = _modeloApiService;
	        this._modeloNavigationService = _modeloNavigationService;
	        this._marcaNavigationService = _marcaNavigationService;
	        this._marcaApiService = _marcaApiService;
	        this._bemTipoApiService = _bemTipoApiService;
	        this._bemTipoNavigationService = _bemTipoNavigationService;
	        this._categoriaApiService = _categoriaApiService;
	        this._categoriaCnhApiService = _categoriaCnhApiService;
	        this._deslocamentoTipoApiService = _deslocamentoTipoApiService;
	        this._deslocamentoTipoService = _deslocamentoTipoService;
	        this._bemSubtipoApiService = _bemSubtipoApiService;
	        this._autocompleteService = _autocompleteService;
	        this._formaControleApiService = _formaControleApiService;
	        this._fb = _fb;
	        this.modelosModule = data_service_1.modelosModuleName;
	        this.formObject = new modelo_model_1.Modelo();
	        this.marcaObject = new marca_model_1.Marca();
	        this.categoriaObject = new categoria_model_1.Categoria();
	        this.bemTipoObject = new bem_tipos_model_1.BemTipo();
	        this.bemSubtipoObject = new bem_subtipo_model_1.BemSubtipo();
	        this.deslocamentoTipoObject = new deslocamento_tipos_model_1.TipoDeslocamento();
	        this.categoriaCnhObject = new categoria_cnh_model_1.CategoriaCnh();
	        this.formaControleObject = new forma_controle_model_1.FormaControle();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showSelectMarca = false;
	        this.marcaSelectId = 'marcaSelect';
	        this.marcaQuery = data_service_3.marcasQuery;
	        this.bemTipoSelectId = 'bemTipo';
	        this.bemTipoQuery = data_service_4.bemTiposQueryCategoria;
	        this.categoriasList = [];
	        this.bemSubtiposList = [];
	        this.deslocamentoTiposList = [];
	        this.formasControleList = [];
	        this.categoriasCnhList = [];
	        this.ativo = new forms_1.FormControl('');
	        this.modelo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.marca = new forms_1.FormControl('', forms_1.Validators.required);
	        this.categoria = new forms_1.FormControl('', forms_1.Validators.required);
	        this.bemTipo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.bemSubtipo = new forms_1.FormControl();
	        this.deslocamentoTipo = new forms_1.FormControl('');
	        this.consumoEsperadoMaximo = new forms_1.FormControl('');
	        this.consumoEsperadoMinimo = new forms_1.FormControl('');
	        this.formaControle = new forms_1.FormControl('');
	        this.motorizado = new forms_1.FormControl('');
	        this.numeroEixos = new forms_1.FormControl('');
	        this.categoriaCnh = new forms_1.FormControl('');
	        this.potencia = new forms_1.FormControl('');
	        this.cilindradas = new forms_1.FormControl('');
	        this.consumoMedio = new forms_1.FormControl('');
	        this.capacidadeTanque = new forms_1.FormControl('');
	        this.tipoEixo = new forms_1.FormControl('');
	        this.numeroPassageiros = new forms_1.FormControl('');
	        this.capacidadeCarga = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                Response.marca = this.marcaObject;
	                this.responsModelo = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            modelo: this.modelo,
	            marca: this.marca,
	            categoria: this.categoria,
	            bemTipo: this.bemTipo,
	            bemSubtipo: this.bemSubtipo,
	            deslocamentoTipo: this.deslocamentoTipo,
	            consumoEsperadoMaximo: this.consumoEsperadoMaximo,
	            consumoEsperadoMinimo: this.consumoEsperadoMinimo,
	            formaControle: this.formaControle,
	            motorizado: this.motorizado,
	            numeroEixos: this.numeroEixos,
	            categoriaCnh: this.categoriaCnh,
	            potencia: this.potencia,
	            cilindradas: this.cilindradas,
	            consumoMedio: this.consumoMedio,
	            capacidadeTanque: this.capacidadeTanque,
	            tipoEixo: this.tipoEixo,
	            numeroPassageiros: this.numeroPassageiros,
	            capacidadeCarga: this.capacidadeCarga,
	        });
	    }
	    ModeloFormComponent.prototype.ngOnInit = function () {
	        this.getCategorias();
	        this.getFormasControle();
	        this.getTipoDeslocamentos();
	        this.getCategoriasCnh();
	        this.isNewAutoComplete();
	    };
	    ModeloFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    ModeloFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    ModeloFormComponent.prototype.changeCategoria = function () {
	        this.bemTipoQuery.where.categoriaId = this.categoriaObject.id;
	    };
	    ModeloFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.marcaObject.id) {
	                object.marcaId = this.marcaObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.bemTipoObject.id) {
	                object.tipoBemId = this.bemTipoObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.bemSubtipoObject.id) {
	                object.subTipoBemId = this.bemSubtipoObject.id;
	            }
	            else {
	                object.subTipoBemId = null;
	            }
	            if (this.deslocamentoTipoObject.id) {
	                object.tipoDeslocamentoId = this.deslocamentoTipoObject.id;
	            }
	            else {
	                object.tipoDeslocamentoId = null;
	            }
	            if (this.formaControleObject.id) {
	                object.formaControleId = this.formaControleObject.id;
	            }
	            else {
	                object.formaControleId = null;
	            }
	            if (this.categoriaCnhObject.id) {
	                object.categoriaExigidaId = this.categoriaCnhObject.id;
	            }
	            else {
	                object.categoriaExigidaId = null;
	            }
	            if (object.numeroEixos) {
	                object.numeroEixos = this._utilService.checkNumber(object.numeroEixos);
	            }
	            if (object.potencia) {
	                object.potencia = this._utilService.checkNumber(object.potencia);
	            }
	            if (object.cilindradas) {
	                object.cilindradas = this._utilService.checkNumber(object.cilindradas);
	            }
	            if (object.numeroPassageiros) {
	                object.numeroPassageiros = this._utilService.checkNumber(object.numeroPassageiros);
	            }
	            if (this.formObject.id) {
	                this.onEditModelo(object);
	            }
	            else {
	                this.onAddModelo(object);
	            }
	        }
	    };
	    ModeloFormComponent.prototype.getMarcasObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._modelosService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                marca: object.text,
	                form: data_service_1.modelosStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_3.marcasStorage);
	            this._marcaNavigationService.goToNew();
	        }
	        else {
	            this.marcaObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'marca', object);
	        }
	    };
	    ModeloFormComponent.prototype.getBemTiposObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._modelosService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                tipo: object.text,
	                categoriaId: this.categoriaObject.id,
	                form: data_service_1.modelosStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.bemTiposStorage);
	            this._bemTipoNavigationService.goToNew();
	        }
	        else {
	            this.bemTipoObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'bemTipo', object);
	            this.getSubtiposBens();
	        }
	    };
	    ModeloFormComponent.prototype.onAddModelo = function (object) {
	        this._modeloApiService.onPost(object, this.onDone);
	    };
	    ModeloFormComponent.prototype.onEditModelo = function (object) {
	        this._modeloApiService.onPut(object, this.onDone);
	    };
	    ModeloFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum modelo encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._modeloApiService.onGetById(id, onDone);
	    };
	    ModeloFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.marca = this.marcaObject;
	        object.tipoBem = this.bemTipoObject;
	        object.subTipoBem = this.bemSubtipoObject;
	        object.tipoDeslocamento = this.deslocamentoTipoObject;
	        object.formaControle = this.formaControleObject;
	        object.categoriaExigida = this.categoriaCnhObject;
	        return object;
	    };
	    ModeloFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.marca) {
	            this.marcaObject = this.formObject.marca;
	            delete this.formObject['marca'];
	            if (this.showSelectMarca) {
	                var text = this._autocompleteService.getTextSelect2(this.marcaObject, 'marca');
	                var selectObject = { text: text, id: this.marcaObject.id };
	                this._autocompleteService.createOptionOnSelect2(this.marcaSelectId, selectObject);
	                this._autocompleteService.setValueOnSelect2(selectObject.id, this.marcaSelectId);
	                this._utilService.setSelectOnFormControl(this.form, 'marca', this.marcaObject);
	            }
	        }
	        if (this.formObject.tipoBem) {
	            this.bemTipoObject = this.formObject.tipoBem;
	            delete this.formObject['tipoBem'];
	            var text = this._autocompleteService.getTextSelect2(this.bemTipoObject, 'tipo');
	            var selectObject = { text: text, id: this.bemTipoObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.bemTipoSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.bemTipoSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'bemTipo', this.bemTipoObject);
	            if (this.bemTipoObject.categoriaId) {
	                if (this.categoriasList.length) {
	                    this.setCategoria();
	                }
	            }
	            this.getSubtiposBens();
	        }
	        if (this.formObject.subTipoBem) {
	            this.bemSubtipoObject = this.formObject.subTipoBem;
	            delete this.formObject['subTipoBem'];
	        }
	        if (this.formObject.tipoDeslocamento) {
	            this.deslocamentoTipoObject = this.formObject.tipoDeslocamento;
	            delete this.formObject['tipoDeslocamento'];
	            if (this.deslocamentoTiposList.length) {
	                this.setTipoDeslocamento();
	            }
	        }
	        if (this.formObject.formaControle) {
	            this.formaControleObject = this.formObject.formaControle;
	            delete this.formObject['formaControle'];
	            if (this.formasControleList.length) {
	                this.setFormaControle();
	            }
	        }
	        if (this.formObject.categoriaExigida) {
	            this.categoriaCnhObject = this.formObject.categoriaExigida;
	            delete this.formObject['categoriaExigida'];
	            this.setCategoriaCnh();
	        }
	    };
	    ModeloFormComponent.prototype.getFormasControle = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formasControleList = Response;
	                this.formasControleList.unshift({ id: null, formaControle: '— Selecione —' });
	                this.setFormaControle();
	            }
	        }.bind(this));
	        this._formaControleApiService.onGetAll(onDone);
	    };
	    ModeloFormComponent.prototype.getCategorias = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.categoriasList = Response;
	                this.setCategoria();
	            }
	        }.bind(this));
	        this._categoriaApiService.onGetAll(onDone);
	    };
	    ModeloFormComponent.prototype.getCategoriasCnh = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.categoriasCnhList = Response;
	                this.categoriasCnhList.unshift({ id: null, categoria: '— Selecione —' });
	                this.setCategoriaCnh();
	            }
	        }.bind(this));
	        this._categoriaCnhApiService.onGetAllVeiculo(onDone);
	    };
	    ModeloFormComponent.prototype.setCategoria = function () {
	        var x, lenX;
	        this.categoriaObject = this.categoriasList[0];
	        for (x = 0, lenX = this.categoriasList.length; x < lenX; x++) {
	            if (this.categoriasList[x].id === this.bemTipoObject.categoriaId) {
	                this.categoriaObject = this.categoriasList[x];
	                break;
	            }
	        }
	    };
	    ModeloFormComponent.prototype.setCategoriaCnh = function () {
	        var x, lenX, t = this.categoriaCnhObject.id;
	        if (!t) {
	            t = this.categoriasCnhList[0].id;
	        }
	        for (x = 0, lenX = this.categoriasCnhList.length; x < lenX; x++) {
	            if (this.categoriasCnhList[x].id === t) {
	                this.categoriaCnhObject = this.categoriasCnhList[x];
	                break;
	            }
	        }
	    };
	    ModeloFormComponent.prototype.setFormaControle = function () {
	        var x, lenX, t = this.formaControleObject.id;
	        if (!t) {
	            t = this.formasControleList[0].id;
	        }
	        for (x = 0, lenX = this.formasControleList.length; x < lenX; x++) {
	            if (this.formasControleList[x].id === t) {
	                this.formaControleObject = this.formasControleList[x];
	                break;
	            }
	        }
	    };
	    ModeloFormComponent.prototype.getTipoDeslocamentos = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].text = this._deslocamentoTipoService.templateResult(Response[x]);
	                }
	                this.deslocamentoTiposList = Response;
	                this.deslocamentoTiposList.unshift({ id: null, text: '— Selecione —' });
	                this.setTipoDeslocamento();
	            }
	        }.bind(this));
	        this._deslocamentoTipoApiService.onGetAll(onDone);
	    };
	    ModeloFormComponent.prototype.setTipoDeslocamento = function () {
	        var x, lenX, t = this.deslocamentoTipoObject.id;
	        if (!t) {
	            t = this.deslocamentoTiposList[0].id;
	        }
	        for (x = 0, lenX = this.deslocamentoTiposList.length; x < lenX; x++) {
	            if (this.deslocamentoTiposList[x].id === t) {
	                this.deslocamentoTipoObject = this.deslocamentoTiposList[x];
	                break;
	            }
	        }
	    };
	    ModeloFormComponent.prototype.getSubtiposBens = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.bemSubtiposList = list;
	                this.bemSubtiposList.unshift({ id: null, subTipo: '— Selecione —' });
	                this.setSubtipoBem();
	            }
	        }.bind(this));
	        this._bemSubtipoApiService.onGetByTipo(this.bemTipoObject.id, onDone);
	    };
	    ModeloFormComponent.prototype.setSubtipoBem = function () {
	        var x, lenX, t = this.bemSubtipoObject.id;
	        if (!t) {
	            t = this.bemSubtiposList[0].id;
	        }
	        for (x = 0, lenX = this.bemSubtiposList.length; x < lenX; x++) {
	            if (this.bemSubtiposList[x].id === t) {
	                this.bemSubtipoObject = this.bemSubtiposList[x];
	                break;
	            }
	        }
	        var select = document.getElementById("bemSubtipo");
	        select.disabled = (this.bemSubtiposList.length) ? false : true;
	    };
	    ModeloFormComponent.prototype.goToList = function () {
	        this._modelosService.clearSessionStorage();
	        this._modeloNavigationService.goToList();
	    };
	    ModeloFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._modelosService.getSessionStorage();
	        this._modelosService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            if (id) {
	                this.setEditSession();
	            }
	            else {
	                this.setNewSession();
	            }
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    ModeloFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    ModeloFormComponent.prototype.setEditNormal = function (id) {
	        this.showSelectMarca = true;
	        this.getObject(id);
	    };
	    ModeloFormComponent.prototype.setNewNormal = function () {
	        this.marcaObject = this._modelosService.getSessionStorageFatherModule();
	        this._utilService.setSelectOnFormControl(this.form, 'marca', this.marcaObject);
	        this.setModelToForm();
	    };
	    ModeloFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	        this.showSelectMarca = true;
	        setTimeout(function () {
	            this.setModelToForm();
	        }.bind(this));
	    };
	    ModeloFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	        this.setModelToForm();
	    };
	    ModeloFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.modelosStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.modelo = newAutoComplete.modelo;
	            this.formObject.marca = newAutoComplete.marca;
	            this.bemTipoObject.categoriaId = newAutoComplete.categoriaId;
	            this.showSelectMarca = true;
	            this.setActionTitle(this.formObject.id);
	            setTimeout(function () {
	                this.setModelToForm();
	            }.bind(this));
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    ModeloFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._modelosService.returnToOtherForm(this.otherForm, this.responsModelo);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    ModeloFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(362),
	            styles: [__webpack_require__(363)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof modelo_service_1.ModeloService !== 'undefined' && modelo_service_1.ModeloService) === 'function' && _c) || Object, (typeof (_d = typeof modelo_api_service_1.ModeloApiService !== 'undefined' && modelo_api_service_1.ModeloApiService) === 'function' && _d) || Object, (typeof (_e = typeof modelo_navigation_service_1.ModeloNavigationService !== 'undefined' && modelo_navigation_service_1.ModeloNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof marca_navigation_service_1.MarcaNavigationService !== 'undefined' && marca_navigation_service_1.MarcaNavigationService) === 'function' && _f) || Object, (typeof (_g = typeof marca_api_service_1.MarcaApiService !== 'undefined' && marca_api_service_1.MarcaApiService) === 'function' && _g) || Object, (typeof (_h = typeof bem_tipos_api_service_1.BemTiposApiService !== 'undefined' && bem_tipos_api_service_1.BemTiposApiService) === 'function' && _h) || Object, (typeof (_j = typeof bem_tipos_navigation_service_1.BemTiposNavigationService !== 'undefined' && bem_tipos_navigation_service_1.BemTiposNavigationService) === 'function' && _j) || Object, (typeof (_k = typeof categoria_api_service_1.CategoriaApiService !== 'undefined' && categoria_api_service_1.CategoriaApiService) === 'function' && _k) || Object, (typeof (_l = typeof categoria_cnh_api_service_1.CategoriaCnhApiService !== 'undefined' && categoria_cnh_api_service_1.CategoriaCnhApiService) === 'function' && _l) || Object, (typeof (_m = typeof deslocamento_tipos_api_service_1.DeslocamentoTiposApiService !== 'undefined' && deslocamento_tipos_api_service_1.DeslocamentoTiposApiService) === 'function' && _m) || Object, (typeof (_o = typeof deslocamento_tipos_service_1.DeslocamentoTiposService !== 'undefined' && deslocamento_tipos_service_1.DeslocamentoTiposService) === 'function' && _o) || Object, (typeof (_p = typeof bem_subtipo_api_service_1.BemSubtipoApiService !== 'undefined' && bem_subtipo_api_service_1.BemSubtipoApiService) === 'function' && _p) || Object, (typeof (_q = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _q) || Object, (typeof (_r = typeof forma_controle_api_service_1.FormaControleApiService !== 'undefined' && forma_controle_api_service_1.FormaControleApiService) === 'function' && _r) || Object, (typeof (_s = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _s) || Object])
	    ], ModeloFormComponent);
	    return ModeloFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
	}());
	exports.ModeloFormComponent = ModeloFormComponent;


/***/ },
/* 350 */
/***/ function(module, exports) {

	"use strict";
	var Modelo = (function () {
	    function Modelo() {
	    }
	    return Modelo;
	}());
	exports.Modelo = Modelo;


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(312);
	var rest_service_1 = __webpack_require__(26);
	var ModeloApiService = (function () {
	    function ModeloApiService(_restService) {
	        this._restService = _restService;
	    }
	    ModeloApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    ModeloApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    ModeloApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    ModeloApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "modelo" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ModeloApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["marca", "tipoBem", "subTipoBem", "tipoDeslocamento", "categoriaExigida", "formaControle"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    ModeloApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    ModeloApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ModeloApiService);
	    return ModeloApiService;
	    var _a;
	}());
	exports.ModeloApiService = ModeloApiService;


/***/ },
/* 352 */
/***/ function(module, exports) {

	"use strict";
	var BemSubtipo = (function () {
	    function BemSubtipo() {
	    }
	    return BemSubtipo;
	}());
	exports.BemSubtipo = BemSubtipo;


/***/ },
/* 353 */
/***/ function(module, exports) {

	"use strict";
	var TipoDeslocamento = (function () {
	    function TipoDeslocamento() {
	    }
	    return TipoDeslocamento;
	}());
	exports.TipoDeslocamento = TipoDeslocamento;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(355);
	var rest_service_1 = __webpack_require__(26);
	var DeslocamentoTiposApiService = (function () {
	    function DeslocamentoTiposApiService(_restService) {
	        this._restService = _restService;
	    }
	    DeslocamentoTiposApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    DeslocamentoTiposApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    DeslocamentoTiposApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    DeslocamentoTiposApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "nome" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    DeslocamentoTiposApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    DeslocamentoTiposApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], DeslocamentoTiposApiService);
	    return DeslocamentoTiposApiService;
	    var _a;
	}());
	exports.DeslocamentoTiposApiService = DeslocamentoTiposApiService;


/***/ },
/* 355 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-deslocamentos';


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(357);
	var BemSubtipoApiService = (function () {
	    function BemSubtipoApiService(_restService) {
	        this._restService = _restService;
	    }
	    BemSubtipoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    BemSubtipoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    BemSubtipoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    BemSubtipoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "subTipo" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    BemSubtipoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": "tipoBem" };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    BemSubtipoApiService.prototype.onGetByTipo = function (tipoId, done) {
	        var filter = { "where": { "tipoBemId": tipoId }, "order": "subTipo" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    BemSubtipoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], BemSubtipoApiService);
	    return BemSubtipoApiService;
	    var _a;
	}());
	exports.BemSubtipoApiService = BemSubtipoApiService;


/***/ },
/* 357 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'sub-tipos-bens';
	exports.bemSubtiposModuleName = { plural: 'Subtipos de Bens', single: 'Subtipo de Bem' };


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var DeslocamentoTiposService = (function () {
	    function DeslocamentoTiposService() {
	    }
	    DeslocamentoTiposService.prototype.templateResult = function (item) {
	        var text = item.nome.concat(" (" + item.sigla + ")");
	        return text;
	    };
	    DeslocamentoTiposService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], DeslocamentoTiposService);
	    return DeslocamentoTiposService;
	}());
	exports.DeslocamentoTiposService = DeslocamentoTiposService;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(360);
	var rest_service_1 = __webpack_require__(26);
	var FormaControleApiService = (function () {
	    function FormaControleApiService(_restService) {
	        this._restService = _restService;
	    }
	    FormaControleApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    FormaControleApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    FormaControleApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    FormaControleApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "formaControle", "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    FormaControleApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    FormaControleApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], FormaControleApiService);
	    return FormaControleApiService;
	    var _a;
	}());
	exports.FormaControleApiService = FormaControleApiService;


/***/ },
/* 360 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'formas-controles';


/***/ },
/* 361 */
/***/ function(module, exports) {

	"use strict";
	var FormaControle = (function () {
	    function FormaControle() {
	    }
	    return FormaControle;
	}());
	exports.FormaControle = FormaControle;


/***/ },
/* 362 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{modelosModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{modelosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{modelosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Identificação</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" *ngIf=\"!showSelectMarca\">\n                <label for=\"marca\">Marca</label>\n                <div>\n                    <input type=\"text\" disabled id=\"marca\" formControlName=\"marca\" [(ngModel)]=\"marcaObject.marca\">\n                </div>\n            </div>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"marcaSelect\" *ngIf=\"showSelectMarca\"\n                                    (setObejct)=\"getMarcasObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"marcaSelectId\"\n                                    [model]=\"marcaObject\"\n                                    [_service]=\"_marcaApiService\"\n                                    [fieldToShow]=\"'marca'\"\n                                    [query]=\"marcaQuery\"\n                                    [label]=\"'Marca'\"></autocomplete-component>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !modelo.valid && submitted}\">\n                <label for=\"modelo\">Modelo <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!modelo.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"modelo\" [(ngModel)]=\"formObject.modelo\" formControlName=\"modelo\" autofocus>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Categorização</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !categoria.valid && submitted}\">\n                <label for=\"categoria\">Categoria <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!categoria.valid && submitted\">Este campo é obrigatório.</span>\n                    <select id=\"categoria\" [(ngModel)]=\"categoriaObject\" formControlName=\"categoria\" (ngModelChange)=\"changeCategoria()\">\n                        <option *ngFor=\"let item of categoriasList\" [ngValue]=\"item\">{{item.categoria}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"bemTipo\"\n                                    (setObejct)=\"getBemTiposObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"bemTipoSelectId\"\n                                    [model]=\"bemTipoObject\"\n                                    [_service]=\"_bemTipoApiService\"\n                                    [fieldToShow]=\"'tipo'\"\n                                    [query]=\"bemTipoQuery\"\n                                    [label]=\"'Tipo'\"></autocomplete-component>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"bemSubtipo\">Subtipo</label>\n                <div>\n                    <select id=\"bemSubtipo\" [(ngModel)]=\"bemSubtipoObject\" formControlName=\"bemSubtipo\" disabled class=\"option_{{bemSubtipoObject.id}}\">\n                        <option *ngFor=\"let item of bemSubtiposList\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.subTipo}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"categoriacnh\">Categoria CNH</label>\n                <div>\n                    <select id=\"categoriacnh\" [(ngModel)]=\"categoriaCnhObject\" formControlName=\"categoriaCnh\" class=\"option_{{categoriaCnhObject.id}}\">\n                        <option *ngFor=\"let item of categoriasCnhList\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.categoria}}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Motorização</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-toggle\">\n                <input type=\"checkbox\" id=\"motorizado\" value=\"\" [(ngModel)]=\"formObject.motorizado\" formControlName=\"motorizado\">\n                <label for=\"motorizado\">Motorizado</label>\n            </div>\n\n            <br />\n\n            <div class=\"geo-input--3c\">\n                <label for=\"potencia\">Potência</label>\n                <div>\n                    <input type=\"text\" id=\"potencia\" autocomplete=\"off\" [(ngModel)]=\"formObject.potencia\" formControlName=\"potencia\" appNumberInteger>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"cilindradas\">Cilindrada</label>\n                <div>\n                    <input type=\"text\" id=\"cilindradas\" autocomplete=\"off\" [(ngModel)]=\"formObject.cilindradas\" formControlName=\"cilindradas\" appNumberInteger>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Formas de controle</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\">\n                <label for=\"formacontrole\">Forma de controle</label>\n                <div>\n                    <select id=\"formacontrole\" [(ngModel)]=\"formaControleObject\" formControlName=\"formaControle\" class=\"option_{{formaControleObject.id}}\">\n                        <option *ngFor=\"let item of formasControleList\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.formaControle}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"tipoDeslocamento\">Medida de deslocamento</label>\n                <div>\n                    <select id=\"tipoDeslocamento\" [(ngModel)]=\"deslocamentoTipoObject\" formControlName=\"deslocamentoTipo\" class=\"option_{{deslocamentoTipoObject.id}}\">\n                        <option *ngFor=\"let item of deslocamentoTiposList\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.text}}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Consumo</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\">\n                <label for=\"consumoMedio\">Médio </label>\n                <div>\n                    <input type=\"number\" step=\"any\"  id=\"consumoMedio\" autocomplete=\"off\" [(ngModel)]=\"formObject.consumoMedio\" formControlName=\"consumoMedio\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"consumoesperadominimo\">Mínimo</label>\n                <div>\n                    <input type=\"number\" step=\"any\"  id=\"consumoesperadominimo\" autocomplete=\"off\" [(ngModel)]=\"formObject.consumoEsperadoMinimo\" formControlName=\"consumoEsperadoMinimo\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"consumoesperadomaximo\">Máximo</label>\n                <div>\n                    <input type=\"number\" step=\"any\"  id=\"consumoesperadomaximo\" autocomplete=\"off\" [(ngModel)]=\"formObject.consumoEsperadoMaximo\" formControlName=\"consumoEsperadoMaximo\">\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Características</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\">\n                <label for=\"tanque\">Tanque </label>\n                <div>\n                    <input type=\"number\" step=\"any\"  id=\"tanque\" autocomplete=\"off\" [(ngModel)]=\"formObject.capacidadeTanque\" formControlName=\"capacidadeTanque\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"eixos\">Número de eixos</label>\n                <div>\n                    <input type=\"text\" id=\"eixos\" autocomplete=\"off\" [(ngModel)]=\"formObject.numeroEixos\" formControlName=\"numeroEixos\" appNumberInteger>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"tipoeixo\">Tipo de eixo</label>\n                <div>\n                    <input type=\"text\" id=\"tipoeixo\" [(ngModel)]=\"formObject.tipoEixo\" formControlName=\"tipoEixo\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"passageiros\">Quantidade / nº de passageiros</label>\n                <div>\n                    <input type=\"text\" id=\"passageiros\" autocomplete=\"off\" [(ngModel)]=\"formObject.numeroPassageiros\" formControlName=\"numeroPassageiros\" appNumberInteger>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"capacidadeCarga\">Capacidade de carga</label>\n                <div>\n                    <input type=\"number\" step=\"any\" id=\"capacidadeCarga\" autocomplete=\"off\" [(ngModel)]=\"formObject.capacidadeCarga\" formControlName=\"capacidadeCarga\">\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 363 */
166,
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var FrotasComponent = (function () {
	    function FrotasComponent() {
	    }
	    FrotasComponent.prototype.ngOnInit = function () {
	    };
	    FrotasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(365)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FrotasComponent);
	    return FrotasComponent;
	}());
	exports.FrotasComponent = FrotasComponent;


/***/ },
/* 365 */
171,
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var frota_list_component_1 = __webpack_require__(367);
	var frota_form_component_1 = __webpack_require__(372);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(154);
	var frota_detail_component_1 = __webpack_require__(391);
	var data_service_3 = __webpack_require__(199);
	var abastecimento_bem_list_component_1 = __webpack_require__(394);
	var abastecimento_bem_form_component_1 = __webpack_require__(411);
	var data_service_4 = __webpack_require__(200);
	var ordem_servico_list_component_1 = __webpack_require__(420);
	var ordem_servico_form_component_1 = __webpack_require__(426);
	var ordem_servico_detail_component_1 = __webpack_require__(436);
	var data_service_5 = __webpack_require__(201);
	var servico_bem_list_component_1 = __webpack_require__(439);
	var frota_imagem_component_1 = __webpack_require__(446);
	var frota_odometro_horimetro_component_1 = __webpack_require__(449);
	var data_service_6 = __webpack_require__(202);
	var deslocamento_history_component_1 = __webpack_require__(454);
	var FrotasRoutingModule = (function () {
	    function FrotasRoutingModule() {
	    }
	    FrotasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FrotasRoutingModule);
	    return FrotasRoutingModule;
	}());
	exports.FrotasRoutingModule = FrotasRoutingModule;
	exports.frotasRoutes = [
	    {
	        path: data_service_2.veiculosRoute,
	        component: frota_list_component_1.FrotaListComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_1.editRoute + '/:id',
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_1.newRoute,
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: frota_detail_component_1.FrotaDetailComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/fotos/:id',
	        component: frota_imagem_component_1.FrotaImagemComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/odometro-horimetro/:id',
	        component: frota_odometro_horimetro_component_1.FrotaOdometroHorimetroComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_3.abastecimentoBensRoute,
	        component: abastecimento_bem_list_component_1.AbastecimentoBemListComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.newRoute,
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.editRoute + '/:id',
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_4.ordensServicoRoute,
	        component: ordem_servico_list_component_1.OrdemServicoListComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.newRoute,
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.editRoute + '/:id',
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: ordem_servico_detail_component_1.OrdemServicoDetailComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_5.planosRoute,
	        component: servico_bem_list_component_1.ServicoBemListComponent
	    }, {
	        path: data_service_2.veiculosRoute + '/' + data_service_6.deslocamentosRoute + '/historico',
	        component: deslocamento_history_component_1.DeslocamentoHistoryComponent
	    },
	    {
	        path: data_service_2.aeronavesRoute,
	        component: frota_list_component_1.FrotaListComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_1.editRoute + '/:id',
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_1.newRoute,
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: frota_detail_component_1.FrotaDetailComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/fotos/:id',
	        component: frota_imagem_component_1.FrotaImagemComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/odometro-horimetro/:id',
	        component: frota_odometro_horimetro_component_1.FrotaOdometroHorimetroComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_3.abastecimentoBensRoute,
	        component: abastecimento_bem_list_component_1.AbastecimentoBemListComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.newRoute,
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.editRoute + '/:id',
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_4.ordensServicoRoute,
	        component: ordem_servico_list_component_1.OrdemServicoListComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.newRoute,
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.editRoute + '/:id',
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: ordem_servico_detail_component_1.OrdemServicoDetailComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_5.planosRoute,
	        component: servico_bem_list_component_1.ServicoBemListComponent
	    }, {
	        path: data_service_2.aeronavesRoute + '/' + data_service_6.deslocamentosRoute + '/historico',
	        component: deslocamento_history_component_1.DeslocamentoHistoryComponent
	    },
	    {
	        path: data_service_2.embarcacoesRoute,
	        component: frota_list_component_1.FrotaListComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_1.editRoute + '/:id',
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_1.newRoute,
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: frota_detail_component_1.FrotaDetailComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/fotos/:id',
	        component: frota_imagem_component_1.FrotaImagemComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/odometro-horimetro/:id',
	        component: frota_odometro_horimetro_component_1.FrotaOdometroHorimetroComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_3.abastecimentoBensRoute,
	        component: abastecimento_bem_list_component_1.AbastecimentoBemListComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.newRoute,
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.editRoute + '/:id',
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_4.ordensServicoRoute,
	        component: ordem_servico_list_component_1.OrdemServicoListComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.newRoute,
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.editRoute + '/:id',
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: ordem_servico_detail_component_1.OrdemServicoDetailComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_5.planosRoute,
	        component: servico_bem_list_component_1.ServicoBemListComponent
	    }, {
	        path: data_service_2.embarcacoesRoute + '/' + data_service_6.deslocamentosRoute + '/historico',
	        component: deslocamento_history_component_1.DeslocamentoHistoryComponent
	    },
	    {
	        path: data_service_2.equipamentosRoute,
	        component: frota_list_component_1.FrotaListComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_1.editRoute + '/:id',
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_1.newRoute,
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: frota_detail_component_1.FrotaDetailComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/fotos/:id',
	        component: frota_imagem_component_1.FrotaImagemComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/odometro-horimetro/:id',
	        component: frota_odometro_horimetro_component_1.FrotaOdometroHorimetroComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_3.abastecimentoBensRoute,
	        component: abastecimento_bem_list_component_1.AbastecimentoBemListComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.newRoute,
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.editRoute + '/:id',
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_4.ordensServicoRoute,
	        component: ordem_servico_list_component_1.OrdemServicoListComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.newRoute,
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.editRoute + '/:id',
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: ordem_servico_detail_component_1.OrdemServicoDetailComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_5.planosRoute,
	        component: servico_bem_list_component_1.ServicoBemListComponent
	    }, {
	        path: data_service_2.equipamentosRoute + '/' + data_service_6.deslocamentosRoute + '/historico',
	        component: deslocamento_history_component_1.DeslocamentoHistoryComponent
	    },
	    {
	        path: data_service_2.maquinarioRoute,
	        component: frota_list_component_1.FrotaListComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_1.editRoute + '/:id',
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_1.newRoute,
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: frota_detail_component_1.FrotaDetailComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/fotos/:id',
	        component: frota_imagem_component_1.FrotaImagemComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/odometro-horimetro/:id',
	        component: frota_odometro_horimetro_component_1.FrotaOdometroHorimetroComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_3.abastecimentoBensRoute,
	        component: abastecimento_bem_list_component_1.AbastecimentoBemListComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.newRoute,
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.editRoute + '/:id',
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_4.ordensServicoRoute,
	        component: ordem_servico_list_component_1.OrdemServicoListComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.newRoute,
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.editRoute + '/:id',
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: ordem_servico_detail_component_1.OrdemServicoDetailComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_5.planosRoute,
	        component: servico_bem_list_component_1.ServicoBemListComponent
	    }, {
	        path: data_service_2.maquinarioRoute + '/' + data_service_6.deslocamentosRoute + '/historico',
	        component: deslocamento_history_component_1.DeslocamentoHistoryComponent
	    },
	    {
	        path: data_service_2.outrosRoute,
	        component: frota_list_component_1.FrotaListComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_1.editRoute + '/:id',
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_1.newRoute,
	        component: frota_form_component_1.FrotaFormComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: frota_detail_component_1.FrotaDetailComponent
	    }, {
	        path: data_service_2.outrosRoute + '/fotos/:id',
	        component: frota_imagem_component_1.FrotaImagemComponent
	    }, {
	        path: data_service_2.outrosRoute + '/odometro-horimetro/:id',
	        component: frota_odometro_horimetro_component_1.FrotaOdometroHorimetroComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_3.abastecimentoBensRoute,
	        component: abastecimento_bem_list_component_1.AbastecimentoBemListComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.newRoute,
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.editRoute + '/:id',
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_4.ordensServicoRoute,
	        component: ordem_servico_list_component_1.OrdemServicoListComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.newRoute,
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.editRoute + '/:id',
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_4.ordensServicoRoute + '/' + data_service_1.detailRoute + '/:id',
	        component: ordem_servico_detail_component_1.OrdemServicoDetailComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_5.planosRoute,
	        component: servico_bem_list_component_1.ServicoBemListComponent
	    }, {
	        path: data_service_2.outrosRoute + '/' + data_service_6.deslocamentosRoute + '/historico',
	        component: deslocamento_history_component_1.DeslocamentoHistoryComponent
	    }
	];


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_service_1 = __webpack_require__(203);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(154);
	var data_service_2 = __webpack_require__(199);
	var forma_controle_service_1 = __webpack_require__(369);
	var FrotaListComponent = (function () {
	    function FrotaListComponent(_frotasApiService, _frotasService, _frotaNavigationService, _utilService, _formaControleService) {
	        this._frotasApiService = _frotasApiService;
	        this._frotasService = _frotasService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._utilService = _utilService;
	        this._formaControleService = _formaControleService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.frotasModuleName = {};
	        this.thisRoute = '';
	        this.aeronavesRoute = data_service_1.aeronavesRoute;
	        this.embarcacoesRoute = data_service_1.embarcacoesRoute;
	        this.equipamentosRoute = data_service_1.equipamentosRoute;
	        this.maquinarioRoute = data_service_1.maquinarioRoute;
	        this.outrosRoute = data_service_1.outrosRoute;
	        this.veiculosRoute = data_service_1.veiculosRoute;
	        this.monthsList = data_service_2.months;
	    }
	    FrotaListComponent.prototype.ngOnInit = function () {
	        this.frotasModuleName = this._frotasService.getModuleName();
	        this.thisRoute = this._frotasService.getRouteName();
	        this.moduleId = this._frotasService.getModuleId();
	        this.horimetro = this._formaControleService.getFormaControleHorimetro();
	        this.odometro = this._formaControleService.getFormaControleOdometro();
	        this.getAll();
	    };
	    FrotaListComponent.prototype.clickNew = function () {
	        this._frotasService.clearSessionStorage();
	        this._frotaNavigationService.goToNew(this.thisRoute);
	    };
	    FrotaListComponent.prototype.clickEdit = function (item) {
	        this._frotasService.clearSessionStorage();
	        this._frotaNavigationService.goToEdit(item.id, this.thisRoute);
	    };
	    FrotaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    FrotaListComponent.prototype.clickDetail = function (item) {
	        this._frotasService.setSessionStorage(item);
	        this._frotaNavigationService.goToDetail(item.id, this.thisRoute);
	    };
	    FrotaListComponent.prototype.keyupItem = function (event, item) {
	        if (event.keyCode === 13) {
	            this.clickDetail(item);
	        }
	    };
	    FrotaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX, y, lenY;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    for (y = 0, lenY = this.monthsList.length; y < lenY; y++) {
	                        if (Response[x].mesIPVA === this.monthsList[y].Key) {
	                            Response[x].mesIPVA = this.monthsList[y];
	                        }
	                        if (Response[x].mesLicenciamento === this.monthsList[y].Key) {
	                            Response[x].mesLicenciamento = this.monthsList[y];
	                        }
	                        if (Response[x].mesSeguroObrigatorio === this.monthsList[y].Key) {
	                            Response[x].mesSeguroObrigatorio = this.monthsList[y];
	                        }
	                    }
	                }
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._frotasApiService.onGetByCategoria(this.moduleId, onDone);
	    };
	    FrotaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._frotasApiService.onDelete(item.id, onDone);
	    };
	    FrotaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(370),
	            styles: [__webpack_require__(371)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _a) || Object, (typeof (_b = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _b) || Object, (typeof (_c = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _e) || Object])
	    ], FrotaListComponent);
	    return FrotaListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.FrotaListComponent = FrotaListComponent;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(154);
	var FrotaApiService = (function () {
	    function FrotaApiService(_restService) {
	        this._restService = _restService;
	        this.includeFilter = [{ "modelo": ["tipoBem", "marca"] }, { "motoristaPrincipal": [{ "funcionario": "pessoa" }] }, "orgao", "area", "divisao", "setor", "localidade", "cor", "situacao", "formaControle", "odometroHorimetro", "gpsModelo", "categoriaExigida"];
	    }
	    FrotaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    FrotaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    FrotaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    FrotaApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "identificacao", "include": this.includeFilter };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    FrotaApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": this.includeFilter };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    FrotaApiService.prototype.onGetByCategoria = function (categoriaId, done) {
	        this._restService.onGet(data_service_1.apiName + '/categoria/' + categoriaId, done);
	    };
	    FrotaApiService.prototype.onGetByCategoriaQuery = function (categoriaId, filter, done) {
	        filter.order = "identificacao";
	        filter.include = this.includeFilter;
	        this._restService.onGetPostCustom(data_service_1.apiName + '/categoria/' + categoriaId, filter, done);
	    };
	    FrotaApiService.prototype.onGetAllRastreamento = function (categoriaId, filter, done) {
	        filter.order = "identificacao";
	        filter.include = this.includeFilter;
	        this._restService.onGetPostCustom(data_service_1.apiName + '/categoria/imagens/' + categoriaId, filter, done);
	    };
	    FrotaApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //bem imagem
	    FrotaApiService.prototype.onPostImagem = function (object, done) {
	        this._restService.onPost(data_service_1.frotaImagemApiName, object, done);
	    };
	    FrotaApiService.prototype.onPostImages = function (object, done) {
	        this._restService.onPostCustom(data_service_1.frotaImagemApiName + '/bulk', object, done);
	    };
	    FrotaApiService.prototype.onDeleteImagem = function (objectId, done) {
	        this._restService.onDelete(data_service_1.frotaImagemApiName, objectId, done);
	    };
	    FrotaApiService.prototype.onGetAllImagem = function (bemId, done) {
	        var filter = { "order": "data", "where": { "bemId": bemId, "ativo": true } };
	        this._restService.onGetPost(data_service_1.frotaImagemApiName, filter, done);
	    };
	    FrotaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], FrotaApiService);
	    return FrotaApiService;
	    var _a;
	}());
	exports.FrotaApiService = FrotaApiService;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var odometro_horimetro_service_1 = __webpack_require__(131);
	var FormaControleService = (function () {
	    function FormaControleService(_odometroHorimetroService) {
	        this._odometroHorimetroService = _odometroHorimetroService;
	    }
	    FormaControleService.prototype.getFormaControleOdometro = function () {
	        return 2;
	    };
	    FormaControleService.prototype.getFormaControleHorimetro = function () {
	        return 3;
	    };
	    FormaControleService.prototype.getFormaControleSem = function () {
	        return 1;
	    };
	    FormaControleService.prototype.submitOdometroHorimetro = function (value) {
	        if (value) {
	            value = value.replace(/\D/g, '');
	            return Number(value);
	        }
	        else {
	            return null;
	        }
	    };
	    FormaControleService.prototype.setOdometroHorimetroToForm = function (value) {
	        if (value) {
	            value = this._odometroHorimetroService.setMask(value);
	        }
	        else {
	            value = '';
	        }
	        return value;
	    };
	    FormaControleService.prototype.changeFormaControle = function (formaControleId) {
	        var tipoOdometro = this.getFormaControleOdometro();
	        if (formaControleId === tipoOdometro) {
	            return true;
	        }
	        return false;
	    };
	    FormaControleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof odometro_horimetro_service_1.OdometroHorimetroService !== 'undefined' && odometro_horimetro_service_1.OdometroHorimetroService) === 'function' && _a) || Object])
	    ], FormaControleService);
	    return FormaControleService;
	    var _a;
	}());
	exports.FormaControleService = FormaControleService;


/***/ },
/* 370 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <h1>{{frotasModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" tabindex=\"-1\"  placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum<span *ngIf=\"thisRoute === aeronavesRoute || thisRoute === embarcacoesRoute\">a</span>\n        {{frotasModuleName.single | lowercase}} cadastrad<span *ngIf=\"thisRoute === aeronavesRoute || thisRoute === embarcacoesRoute\">a</span><span *ngIf=\"thisRoute !== aeronavesRoute && thisRoute !== embarcacoesRoute\">o</span>\n    </p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th class=\"small\"></th>\n            <th>Identificação</th>\n            <th>Modelo</th>\n            <th *ngIf=\"thisRoute === veiculosRoute\">Placa</th>\n            <th *ngIf=\"thisRoute === equipamentosRoute\">Registro</th>\n            <th *ngIf=\"thisRoute !== veiculosRoute && thisRoute !== equipamentosRoute\">Cód. do patrimônio</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse\n               *ngFor=\"let item of(list | filter:listFilter.value:['identificacao', 'modelo.modelo', 'placa', 'codigoPatrimonio', 'codigo', 'modelo.marca.marca', 'modelo.tipo.tipo'] | filterActive:showDisabled | sort:['identificacao']); let i=index;\"\n               tabindex=\"{{(i + 1)}}\"\n               (keyup)=\"keyupItem($event, item)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\" >\n            <td><span class=\"geo-arrow\"></span></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.identificacao}}</a></td>\n            <td class=\"has-link cursor-pointer\">\n                <a (click)=\"clickDetail(item)\">\n                    <span *ngIf=\"item.modelo\">{{item.modelo.modelo}}\n                        <span *ngIf=\"item.modelo.marca\"> / {{item.modelo.marca.marca}}</span>\n                        <span *ngIf=\"item.modelo.tipo\"> / {{item.modelo.tipo.tipo}}</span>\n                    </span>\n                </a>\n            </td>\n            <td *ngIf=\"thisRoute === veiculosRoute\" class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.placa | licensePlateMask}}</a></td>\n            <td *ngIf=\"thisRoute === equipamentosRoute\" class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.codigo}}</a></td>\n            <td *ngIf=\"thisRoute !== veiculosRoute && thisRoute !== equipamentosRoute\" class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.codigoPatrimonio}}</a></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div class=\"geo-content__row\">\n                    <div class=\"geo-columns--6c\">\n                        <p *ngIf=\"thisRoute === veiculosRoute\"><strong>Placa: </strong> {{item.placa | licensePlateMask}}</p>\n                        <p *ngIf=\"thisRoute === veiculosRoute\"><strong>Cód. do patrimônio: </strong> {{item.codigoPatrimonio}}<i *ngIf=\"!item.codigoPatrimonio\">não cadastrado</i></p>\n                        <p *ngIf=\"thisRoute === veiculosRoute || thisRoute === maquinarioRoute\"><strong>{{frotasModuleName.single}} de terceiro: </strong>\n                            <span *ngIf=\"item.terceiro\">Sim</span>\n                            <span *ngIf=\"!item.terceiro\">Não</span>\n                        </p>\n                        <p *ngIf=\"thisRoute === equipamentosRoute\"><strong>Número de série: </strong> {{item.numeroSerie}}<i *ngIf=\"!item.numeroSerie\">não cadastrado</i></p>\n                        <p *ngIf=\"thisRoute === equipamentosRoute\"><strong>Registro: </strong> {{item.codigo}}<i *ngIf=\"!item.codigo\">não cadastrado</i></p>\n                        <p *ngIf=\"thisRoute === veiculosRoute || thisRoute === maquinarioRoute || thisRoute === equipamentosRoute\"><strong>Chassi: </strong> {{item.chassi}}<i *ngIf=\"!item.chassi\">não cadastrado</i></p>\n                        <p *ngIf=\"thisRoute === veiculosRoute\"><strong>Renavam: </strong> {{item.numeroRenavam}}<i *ngIf=\"!item.numeroRenavam\">não cadastrado</i></p>\n                        <p><strong>Situação: </strong> <span *ngIf=\"item.situacao\">{{item.situacao.situacao}}</span><i *ngIf=\"!item.situacao\">não cadastrado</i></p>\n                        <p><strong>Ano de fabricação: </strong> {{item.anoFabricacao}}<i *ngIf=\"!item.anoFabricacao\">não cadastrado</i></p>\n                        <p><strong>Ano do modelo: </strong> {{item.anoModelo}}<i *ngIf=\"!item.anoModelo\">não cadastrado</i></p>\n                        <p><strong>Cor: </strong> <span *ngIf=\"item.cor\">{{item.cor.cor}}</span><i *ngIf=\"!item.cor\">não cadastrado</i></p>\n\n                        <p>\n                            <app-odometro-horimetro-label-component [labelHorimetro]=\"'Horímetro: '\"\n                                                                    [labelOdometro]=\"'Odômetro: '\"\n                                                                    [odometroHorimetroObject]=\"item.odometroHorimetro\"\n                                                                    [bemObject]=\"item\"></app-odometro-horimetro-label-component>\n                        </p>\n\n                        <p *ngIf=\"thisRoute === veiculosRoute || thisRoute === maquinarioRoute\"><strong>Capac. de carga: </strong> {{item.capacidadeCarga}}<i *ngIf=\"!item.capacidadeCarga\">não cadastrado</i></p>\n                        <p *ngIf=\"thisRoute === veiculosRoute\"><strong>Quant. de passageiros: </strong> {{item.numeroPassageiros}}<i *ngIf=\"!item.numeroPassageiros\">não cadastrado</i></p>\n\n                        <p><strong>Combustíveis: </strong>\n                            <span *ngFor=\"let comb of item.Combustiveis; let cLast=last\">{{comb.combustivel}}<span *ngIf=\"!cLast\">, </span></span>\n                            <i *ngIf=\"!item.Combustiveis\">não cadastrado</i>\n                        </p>\n\n                        <p *ngIf=\"thisRoute === veiculosRoute || thisRoute === maquinarioRoute\"><strong>Categoria CNH: </strong>\n                            <span *ngIf=\"item.categoriaExigida\">&nbsp;{{item.categoriaExigida.categoria}} </span>\n                            <i *ngIf=\"!item.categoriaExigida\">não cadastrado</i>\n                        </p>\n                        <p *ngIf=\"thisRoute === veiculosRoute\"><strong>Motorista principal: </strong>\n                            <span *ngIf=\"item.motoristaPrincipal\">\n                                <span *ngIf=\"item.motoristaPrincipal.funcionario\">\n                                  <span *ngIf=\"item.motoristaPrincipal.funcionario.pessoa\">{{item.motoristaPrincipal.funcionario.pessoa.nome}} </span>\n                                </span>\n                            </span>\n                            <i *ngIf=\"!item.motoristaPrincipal\">não cadastrado</i>\n                        </p>\n                    </div>\n                    <div class=\"geo-columns--6c\">\n                        <p><strong>Data da compra: </strong> {{item.dataCompra | date:'dd/MM/yyyy'}} <i *ngIf=\"!item.dataCompra\">não cadastrado</i></p>\n                        <p><strong>Data da venda: </strong> {{item.dataVenda | date:'dd/MM/yyyy'}} <i *ngIf=\"!item.dataVenda\">não cadastrado</i></p>\n                        <p><strong>Término da garantia: </strong> {{item.dataTerminoGarantia | date:'dd/MM/yyyy'}} <i *ngIf=\"!item.dataTerminoGarantia\">não cadastrado</i></p>\n                        <p><strong>Órgão: </strong> <span *ngIf=\"item.orgao\">{{item.orgao.razaoSocial}}</span> <i *ngIf=\"!item.orgao\">não cadastrado</i></p>\n                        <p><strong>Área: </strong> <span *ngIf=\"item.area\">{{item.area.nome}}</span> <i *ngIf=\"!item.area\">não cadastrado</i></p>\n                        <p><strong>Divisão: </strong> <span *ngIf=\"item.divisao\">{{item.divisao.divisao}}</span> <i *ngIf=\"!item.divisao\">não cadastrado</i></p>\n                        <p><strong>Setor: </strong> <span *ngIf=\"item.setor\">{{item.setor.setor}}</span> <i *ngIf=\"!item.setor\">não cadastrado</i></p>\n                        <p><strong>Localidade: </strong> <span *ngIf=\"item.localidade\">{{item.localidade.localidade}}</span> <i *ngIf=\"!item.localidade\">não cadastrado</i></p>\n                        <p><strong>Descrição: </strong> {{item.descricao}}<i *ngIf=\"!item.descricao\">não cadastrado</i></p>\n                        <p><strong>IMEI: </strong> {{item.gpsImei}}<i *ngIf=\"!item.gpsImei\">não cadastrado</i></p>\n                        <p><strong>Modelo do GPS: </strong> <span *ngIf=\"item.gpsModelo\">{{item.gpsModelo.modelo}}</span><i *ngIf=\"!item.gpsModelo\">não cadastrado</i></p>\n                        <p><strong>Velocidade máxima: </strong> <span *ngIf=\"item.velocidadeMaximaPermitida\">{{item.velocidadeMaximaPermitida}}km</span><i *ngIf=\"!item.velocidadeMaximaPermitida\">não cadastrado</i></p>\n                        <p><strong>Telefone: </strong> {{item.gpsTelefone | phoneMask}}<i *ngIf=\"!item.gpsTelefone\">não cadastrado</i></p>\n                        <p *ngIf=\"thisRoute === veiculosRoute\"><strong>Mês de licenciamento: </strong> <span *ngIf=\"item.mesLicenciamento\">{{item.mesLicenciamento.Value}}</span> <i *ngIf=\"!item.mesLicenciamento\">não cadastrado</i></p>\n                        <p *ngIf=\"thisRoute === veiculosRoute\"><strong>Mês do seguro obrigatório: </strong> <span *ngIf=\"item.mesSeguroObrigatorio\">{{item.mesSeguroObrigatorio.Value}}</span> <i *ngIf=\"!item.mesSeguroObrigatorio\">não cadastrado</i></p>\n                        <p *ngIf=\"thisRoute === veiculosRoute\"><strong>Vencimento do IPVA: </strong> <span *ngIf=\"item.mesIPVA\">{{item.mesIPVA.Value}}</span> <i *ngIf=\"!item.mesIPVA\">não cadastrado</i></p>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports = "tbody:focus {\n    outline: none;\n}\ntbody:focus td.has-link a,\ntbody:focus td.has-link a span {\n    color: #4C87FF;\n}\n"

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(154);
	var frota_model_1 = __webpack_require__(373);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_api_service_1 = __webpack_require__(368);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(178);
	var frota_service_1 = __webpack_require__(203);
	var cor_api_service_1 = __webpack_require__(374);
	var combustivel_api_service_1 = __webpack_require__(376);
	var cor_model_1 = __webpack_require__(378);
	var localidade_model_1 = __webpack_require__(239);
	var divisao_model_1 = __webpack_require__(289);
	var area_model_1 = __webpack_require__(274);
	var orgao_model_1 = __webpack_require__(254);
	var modelo_model_1 = __webpack_require__(350);
	var setor_model_1 = __webpack_require__(296);
	var orgao_api_service_1 = __webpack_require__(250);
	var area_api_service_1 = __webpack_require__(275);
	var divisao_api_service_1 = __webpack_require__(285);
	var setor_api_service_1 = __webpack_require__(297);
	var localidade_api_service_1 = __webpack_require__(227);
	var modelo_api_service_1 = __webpack_require__(351);
	var data_service_3 = __webpack_require__(149);
	var orgao_navigation_service_1 = __webpack_require__(204);
	var area_navigation_service_1 = __webpack_require__(191);
	var divisao_navigation_service_1 = __webpack_require__(193);
	var setor_navigation_service_1 = __webpack_require__(195);
	var localidade_navigation_service_1 = __webpack_require__(228);
	var modelo_navigation_service_1 = __webpack_require__(311);
	var data_service_4 = __webpack_require__(190);
	var data_service_5 = __webpack_require__(150);
	var data_service_6 = __webpack_require__(196);
	var data_service_7 = __webpack_require__(148);
	var data_service_8 = __webpack_require__(312);
	var bem_combustivel_api_service_1 = __webpack_require__(379);
	var modelo_service_1 = __webpack_require__(313);
	var marca_model_1 = __webpack_require__(317);
	var marca_api_service_1 = __webpack_require__(308);
	var marca_navigation_service_1 = __webpack_require__(309);
	var data_service_9 = __webpack_require__(152);
	var localidade_service_1 = __webpack_require__(232);
	var situacao_model_1 = __webpack_require__(381);
	var situacao_api_service_1 = __webpack_require__(382);
	var motorista_model_1 = __webpack_require__(213);
	var motorista_api_service_1 = __webpack_require__(209);
	var motorista_service_1 = __webpack_require__(188);
	var data_service_10 = __webpack_require__(199);
	var data_service_11 = __webpack_require__(375);
	var data_service_12 = __webpack_require__(146);
	var categoria_cnh_model_1 = __webpack_require__(218);
	var categoria_cnh_api_service_1 = __webpack_require__(216);
	var forma_controle_api_service_1 = __webpack_require__(359);
	var forma_controle_model_1 = __webpack_require__(361);
	var forma_controle_service_1 = __webpack_require__(369);
	var licenciamento_api_service_1 = __webpack_require__(384);
	var projeto_service_1 = __webpack_require__(52);
	var modelo_gps_service_1 = __webpack_require__(386);
	var modelo_gps_api_service_1 = __webpack_require__(388);
	var data_service_13 = __webpack_require__(387);
	var FrotaFormComponent = (function () {
	    function FrotaFormComponent(_route, _router, _frotaNavigationService, _frotaApiService, _frotasService, _utilService, _autocompleteService, _corApiService, _combustivelApiService, _bemCombustivelApiService, _orgaoApiService, _orgaosNavigationService, _areaApiService, _areaNavigationService, _divisaoApiService, _divisaoNavigationService, _setorApiService, _setorNavigationService, _localidadeApiService, _localidadeNavigationService, _localidadeService, _modeloApiService, _modeloNavigationService, _modeloService, _marcaApiService, _marcaNavigationService, _situacaoApiService, _motoristaApiService, _motoristaService, _categoriaCnhApiService, _formaControleApiService, _modeloGpsService, _modeloGpsApiService, _licenciamentoApiService, _projetoService, _formaControleService, _fb) {
	        this._route = _route;
	        this._router = _router;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaApiService = _frotaApiService;
	        this._frotasService = _frotasService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._corApiService = _corApiService;
	        this._combustivelApiService = _combustivelApiService;
	        this._bemCombustivelApiService = _bemCombustivelApiService;
	        this._orgaoApiService = _orgaoApiService;
	        this._orgaosNavigationService = _orgaosNavigationService;
	        this._areaApiService = _areaApiService;
	        this._areaNavigationService = _areaNavigationService;
	        this._divisaoApiService = _divisaoApiService;
	        this._divisaoNavigationService = _divisaoNavigationService;
	        this._setorApiService = _setorApiService;
	        this._setorNavigationService = _setorNavigationService;
	        this._localidadeApiService = _localidadeApiService;
	        this._localidadeNavigationService = _localidadeNavigationService;
	        this._localidadeService = _localidadeService;
	        this._modeloApiService = _modeloApiService;
	        this._modeloNavigationService = _modeloNavigationService;
	        this._modeloService = _modeloService;
	        this._marcaApiService = _marcaApiService;
	        this._marcaNavigationService = _marcaNavigationService;
	        this._situacaoApiService = _situacaoApiService;
	        this._motoristaApiService = _motoristaApiService;
	        this._motoristaService = _motoristaService;
	        this._categoriaCnhApiService = _categoriaCnhApiService;
	        this._formaControleApiService = _formaControleApiService;
	        this._modeloGpsService = _modeloGpsService;
	        this._modeloGpsApiService = _modeloGpsApiService;
	        this._licenciamentoApiService = _licenciamentoApiService;
	        this._projetoService = _projetoService;
	        this._formaControleService = _formaControleService;
	        this._fb = _fb;
	        this.frotasModule = {};
	        this.formObject = new frota_model_1.Frota();
	        this.corObject = new cor_model_1.Cor();
	        this.modeloObject = new modelo_model_1.Modelo();
	        this.marcaObject = new marca_model_1.Marca();
	        this.orgaoObject = new orgao_model_1.Orgao();
	        this.areaObject = new area_model_1.Area();
	        this.divisaoObject = new divisao_model_1.Divisao();
	        this.setorObject = new setor_model_1.Setor();
	        this.localidadeObject = new localidade_model_1.Localidade();
	        this.situacaoObject = new situacao_model_1.Situacao();
	        this.motoristaObject = new motorista_model_1.Motorista();
	        this.categoriaCnhObject = new categoria_cnh_model_1.CategoriaCnh();
	        this.formaControleObject = new forma_controle_model_1.FormaControle();
	        this.modeloGpsObject = {};
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showDetailLink = false;
	        this.situacoesList = [];
	        this.combustiveisList = [];
	        this.combustiveisCheckedList = [];
	        this.modeloSelectId = 'modelo';
	        this.modeloDisabled = true;
	        this.marcaSelectId = 'marca';
	        this.marcaQuery = data_service_9.marcasQuery;
	        this.modeloQuery = this._utilService.cloneObject(data_service_8.modelosQueryComCategoriaMarca);
	        this.orgaoSelectId = 'orgao';
	        this.orgaoQuery = data_service_3.orgaosQuery;
	        this.areaSelectId = 'area';
	        this.areaQuery = this._utilService.cloneObject(data_service_4.areasQuery);
	        this.divisaoSelectId = 'divisao';
	        this.divisaoQuery = this._utilService.cloneObject(data_service_5.divisoesQuery);
	        this.setorSelectId = 'setor';
	        this.setorQuery = this._utilService.cloneObject(data_service_6.setoresQuery);
	        this.localidadeQuery = this._utilService.cloneObject(data_service_7.localidadesQuery);
	        this.localidadeSelectId = 'localidade';
	        this.corSelectId = "cor";
	        this.corQuery = this._utilService.cloneObject(data_service_11.coresQuery);
	        this.corLoading = false;
	        this.motoristaSelectId = 'motorista';
	        this.motoristaQuery = this._utilService.cloneObject(data_service_12.motoristasQuery);
	        this.monthsList = [];
	        this.formasControleList = [];
	        this.categoriasCnhList = [];
	        this.showTipoOdometro = true;
	        this.modeloGpsSelectId = 'modeloGps';
	        this.loadingMesLicenciamento = false;
	        this.ativo = new forms_1.FormControl('');
	        this.capacidadeCarga = new forms_1.FormControl('');
	        this.categoriaCnh = new forms_1.FormControl('');
	        this.dataCompra = new forms_1.FormControl('');
	        this.dataTerminoGarantia = new forms_1.FormControl('');
	        this.dataVenda = new forms_1.FormControl('');
	        this.descricao = new forms_1.FormControl('');
	        this.identificacao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.anoModelo = new forms_1.FormControl('');
	        this.chassi = new forms_1.FormControl('');
	        this.codigo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.codigoPatrimonio = new forms_1.FormControl('', forms_1.Validators.required);
	        this.numeroPassageiros = new forms_1.FormControl('');
	        this.numeroRenavam = new forms_1.FormControl('');
	        this.placa = new forms_1.FormControl('');
	        this.terceiro = new forms_1.FormControl('');
	        this.modelo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.orgao = new forms_1.FormControl('');
	        this.area = new forms_1.FormControl('');
	        this.divisao = new forms_1.FormControl('');
	        this.setor = new forms_1.FormControl('');
	        this.localidade = new forms_1.FormControl('');
	        this.cor = new forms_1.FormControl('');
	        this.anoFabricacao = new forms_1.FormControl('');
	        this.numeroSerie = new forms_1.FormControl('');
	        this.marca = new forms_1.FormControl('', forms_1.Validators.required);
	        this.situacao = new forms_1.FormControl('');
	        this.motorista = new forms_1.FormControl('');
	        this.mesLicenciamento = new forms_1.FormControl('');
	        this.mesSeguroObrigatorio = new forms_1.FormControl('');
	        this.mesIPVA = new forms_1.FormControl('');
	        this.formaControle = new forms_1.FormControl('');
	        this.gpsImei = new forms_1.FormControl('');
	        this.gpsTelefone = new forms_1.FormControl('');
	        this.modeloGps = new forms_1.FormControl('');
	        this.velocidadeMaximaPermitida = new forms_1.FormControl('');
	        this.thisRoute = '';
	        this.aeronavesRoute = data_service_1.aeronavesRoute;
	        this.embarcacoesRoute = data_service_1.embarcacoesRoute;
	        this.equipamentosRoute = data_service_1.equipamentosRoute;
	        this.maquinarioRoute = data_service_1.maquinarioRoute;
	        this.outrosRoute = data_service_1.outrosRoute;
	        this.veiculosRoute = data_service_1.veiculosRoute;
	        this.returnToOtherForm = false;
	        this.modeloTemplateResult = (function (state) {
	            var template = this._modeloService.templateResult(state, true);
	            return template;
	        }.bind(this));
	        this.motoristaTemplateResult = (function (state) {
	            var template = this._motoristaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.modeloGpsTemplateResult = (function (state) {
	            var template = this._modeloGpsService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseFrota = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            capacidadeCarga: this.capacidadeCarga,
	            categoriaCnh: this.categoriaCnh,
	            dataCompra: this.dataCompra,
	            dataTerminoGarantia: this.dataTerminoGarantia,
	            dataVenda: this.dataVenda,
	            descricao: this.descricao,
	            identificacao: this.identificacao,
	            anoModelo: this.anoModelo,
	            chassi: this.chassi,
	            codigo: this.codigo,
	            codigoPatrimonio: this.codigoPatrimonio,
	            numeroPassageiros: this.numeroPassageiros,
	            numeroRenavam: this.numeroRenavam,
	            placa: this.placa,
	            terceiro: this.terceiro,
	            modelo: this.modelo,
	            orgao: this.orgao,
	            area: this.area,
	            divisao: this.divisao,
	            setor: this.setor,
	            localidade: this.localidade,
	            cor: this.cor,
	            anoFabricacao: this.anoFabricacao,
	            marca: this.marca,
	            numeroSerie: this.numeroSerie,
	            situacao: this.situacao,
	            motorista: this.motorista,
	            mesLicenciamento: this.mesLicenciamento,
	            mesSeguroObrigatorio: this.mesSeguroObrigatorio,
	            mesIPVA: this.mesIPVA,
	            formaControle: this.formaControle,
	            gpsImei: this.gpsImei,
	            gpsTelefone: this.gpsTelefone,
	            modeloGps: this.modeloGps,
	            velocidadeMaximaPermitida: this.velocidadeMaximaPermitida
	        });
	    }
	    FrotaFormComponent.prototype.ngOnInit = function () {
	        this.getSituacoes();
	        this.getCombustiveis();
	        this.getCategoriasCnh();
	        this.getFormasControle();
	        this.project = this._projetoService.getSessionStorage();
	        this.monthsList = this._utilService.cloneObject(data_service_10.months);
	        this.monthsList.unshift({ Key: null, Value: '— Selecione —' });
	        var history = this._frotasService.getBackStorage();
	        if ((history)) {
	            this.showDetailLink = true;
	        }
	        this.frotasModule = this._frotasService.getModuleName();
	        this.thisRoute = this._frotasService.getRouteName();
	        this.moduleId = this._frotasService.getModuleId();
	        this.modeloGpsQuery = this._utilService.cloneObject(data_service_13.modeloGpsQuery);
	        this.setCategoriaOnModelo();
	        this.testSession();
	    };
	    FrotaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    FrotaFormComponent.prototype.clickGoToDetail = function () {
	        this._frotaNavigationService.goToDetail(this.formObject.id, this.thisRoute);
	    };
	    FrotaFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    FrotaFormComponent.prototype.clickCheckCombustiveis = function (item) {
	        var x, lenX, add = true;
	        for (x = 0, lenX = this.combustiveisCheckedList.length; x < lenX; x++) {
	            if (this.combustiveisCheckedList[x] === item.id) {
	                this.combustiveisCheckedList.splice(x, 1);
	                add = false;
	                break;
	            }
	        }
	        if (add) {
	            this.combustiveisCheckedList.push(item.id);
	        }
	    };
	    FrotaFormComponent.prototype.clickThird = function () {
	        if (this.formObject.terceiro) {
	            this.onShowPatrimonio();
	        }
	        else {
	            this.onHidePatrimonio();
	        }
	    };
	    FrotaFormComponent.prototype.clickCheckSituacao = function (item) {
	        this.situacaoObject = item;
	    };
	    FrotaFormComponent.prototype.changeFormaControle = function () {
	        var formaControleId;
	        if (this.formaControleObject && this.formaControleObject.id) {
	            formaControleId = this.formaControleObject.id;
	            this.showTipoOdometro = this._formaControleService.changeFormaControle(formaControleId);
	        }
	        // if (this.formaControleObject && this.formaControleObject.id) {
	        //     formaControleId = this.formaControleObject.id;
	        //
	        //     let tipoOdometro: any = this._formaControleService.changeFormaControle(formaControleId);
	        //
	        //     if (tipoOdometro === null) {
	        //         this.formObject.odometroHorimetroValue = null;
	        //     }
	        //
	        //     if (tipoOdometro) {
	        //         this.showTipoOdometro = true;
	        //     } else {
	        //         this.showTipoOdometro = false;
	        //     }
	        // }
	    };
	    FrotaFormComponent.prototype.blurPlaca = function () {
	        if (this.formObject.placa) {
	            var p = this.formObject.placa;
	            p = p.replace(/\D/g, '');
	            var last = p.length;
	            if (last === 4) {
	                var lastPlacaNumber = p.charAt(last - 1);
	                if (this.project) {
	                    this.getMesLicenciamento(lastPlacaNumber);
	                }
	            }
	        }
	    };
	    FrotaFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (this.formObject.terceiro) {
	            this._utilService.setSelectOnFormControl(this.form, 'codigoPatrimonio', { id: -1 });
	        }
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject), date;
	            if (this.modeloObject.id) {
	                object.modeloId = this.modeloObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.orgaoObject.id) {
	                object.orgaoId = this.orgaoObject.id;
	            }
	            else {
	                object.orgaoId = null;
	            }
	            if (this.areaObject.id) {
	                object.areaId = this.areaObject.id;
	            }
	            else {
	                object.areaId = null;
	            }
	            if (this.divisaoObject.id) {
	                object.divisaoId = this.divisaoObject.id;
	            }
	            else {
	                object.divisaoId = null;
	            }
	            if (this.setorObject.id) {
	                object.setorId = this.setorObject.id;
	            }
	            else {
	                object.setorId = null;
	            }
	            if (this.localidadeObject.id) {
	                object.localidadeId = this.localidadeObject.id;
	            }
	            else {
	                object.localidadeId = null;
	            }
	            if (this.motoristaObject.id) {
	                object.motoristaPrincipalId = this.motoristaObject.id;
	            }
	            else {
	                object.motoristaPrincipalId = null;
	            }
	            if (this.corObject.id) {
	                object.corId = this.corObject.id;
	            }
	            if (this.situacaoObject.id) {
	                object.situacaoId = this.situacaoObject.id;
	            }
	            if (this.modeloGpsObject.id) {
	                object.gpsModeloId = this.modeloGpsObject.id;
	            }
	            else {
	                object.gpsModeloId = null;
	            }
	            if (this.formaControleObject.id) {
	                object.formaControleId = this.formaControleObject.id;
	                object.odometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.odometroHorimetroValue);
	                delete object['odometroHorimetroValue'];
	                if (!object.dataOdometroHorimetro) {
	                    object.dataOdometroHorimetro = new Date();
	                }
	            }
	            if (this.combustiveisCheckedList.length) {
	                object.Combustiveis = this.combustiveisCheckedList;
	            }
	            else {
	                object.Combustiveis = [];
	            }
	            if (object.mesIPVA) {
	                object.mesIPVA = object.mesIPVA.Key;
	            }
	            else {
	                object.mesIPVA = null;
	            }
	            if (object.mesLicenciamento) {
	                object.mesLicenciamento = object.mesLicenciamento.Key;
	            }
	            else {
	                object.mesLicenciamento = null;
	            }
	            if (object.mesSeguroObrigatorio) {
	                object.mesSeguroObrigatorio = object.mesSeguroObrigatorio.Key;
	            }
	            else {
	                object.mesSeguroObrigatorio = null;
	            }
	            if (object.placa) {
	                object.placa = this._utilService.removeSpecialCharacter(object.placa);
	            }
	            if (object.terceiro) {
	                object.codigoPatrimonio = '';
	            }
	            date = document.getElementById('data_compra');
	            if (date.value) {
	                object.dataCompra = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.dataCompra = null;
	            }
	            date = document.getElementById('termino_garantia');
	            if (date.value) {
	                object.dataTerminoGarantia = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.dataTerminoGarantia = null;
	            }
	            date = document.getElementById('data_venda');
	            if (date.value) {
	                object.dataVenda = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.dataVenda = null;
	            }
	            if (this.categoriaCnhObject.id) {
	                object.categoriaExigidaId = this.categoriaCnhObject.id;
	            }
	            else {
	                object.categoriaExigidaId = null;
	            }
	            if (this.formObject.id) {
	                this.onEditFrota(object);
	            }
	            else {
	                this.onAddFrota(object);
	            }
	        }
	    };
	    FrotaFormComponent.prototype.getOrgaosObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._frotasService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                razaoSocial: object.text,
	                form: data_service_1.frotasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_3.orgaosStorage);
	            this._orgaosNavigationService.goToNew();
	        }
	        else {
	            this.orgaoObject = object;
	            if (object.id) {
	                this.areaQuery.where.orgaoId = object.id;
	                this._utilService.setSelectOnFormControl(this.form, 'orgao', object);
	            }
	            else {
	                this._utilService.setSelectOnFormControl(this.form, 'orgao', { id: -1 });
	            }
	        }
	    };
	    FrotaFormComponent.prototype.getAreasObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._frotasService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                nome: object.text,
	                form: data_service_1.frotasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.areasStorage);
	            this._areaNavigationService.goToNew();
	        }
	        else {
	            this.areaObject = object;
	            if (object.id) {
	                this.divisaoQuery.where.areaId = object.id;
	                this._utilService.setSelectOnFormControl(this.form, 'area', object);
	            }
	            else {
	                this._utilService.setSelectOnFormControl(this.form, 'area', { id: -1 });
	            }
	        }
	    };
	    FrotaFormComponent.prototype.getDivisoesObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._frotasService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                divisao: object.text,
	                form: data_service_1.frotasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_5.divisoesStorage);
	            this._divisaoNavigationService.goToNew();
	        }
	        else {
	            this.divisaoObject = object;
	            if (object.id) {
	                this.setorQuery.where.divisaoId = object.id;
	                this._utilService.setSelectOnFormControl(this.form, 'divisao', object);
	            }
	            else {
	                this._utilService.setSelectOnFormControl(this.form, 'divisao', { id: -1 });
	            }
	        }
	    };
	    FrotaFormComponent.prototype.getSetoresObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._frotasService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                setor: object.text,
	                form: data_service_1.frotasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_6.setoresStorage);
	            this._setorNavigationService.goToNew();
	        }
	        else {
	            this.setorObject = object;
	            if (object.id) {
	                this._utilService.setSelectOnFormControl(this.form, 'setor', object);
	            }
	            else {
	                this._utilService.setSelectOnFormControl(this.form, 'setor', { id: -1 });
	            }
	        }
	    };
	    FrotaFormComponent.prototype.getLocalidadesObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._frotasService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                localidade: object.text,
	                form: data_service_1.frotasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_7.localidadesStorage);
	            this._localidadeNavigationService.goToNew();
	        }
	        else {
	            this.localidadeObject = object;
	            if (object.id) {
	                this._utilService.setSelectOnFormControl(this.form, 'localidade', object);
	            }
	            else {
	                this._utilService.setSelectOnFormControl(this.form, 'localidade', { id: -1 });
	            }
	        }
	    };
	    FrotaFormComponent.prototype.getModelosObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._frotasService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                modelo: object.text,
	                categoriaId: this.moduleId,
	                marca: this.marcaObject,
	                form: data_service_1.frotasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_8.modelosStorage);
	            this._modeloNavigationService.goToNew();
	        }
	        else {
	            this.modeloObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'modelo', object);
	        }
	    };
	    FrotaFormComponent.prototype.getMarcasObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._frotasService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                marca: object.text,
	                form: data_service_1.frotasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_9.marcasStorage);
	            this._marcaNavigationService.goToNew();
	        }
	        else {
	            this.marcaObject = object;
	            this.setMarcaOnModelo();
	            this._utilService.setSelectOnFormControl(this.form, 'marca', object);
	        }
	    };
	    FrotaFormComponent.prototype.getCorObject = function (object) {
	        var onDone = function (Response) {
	            if (!Response.error) {
	                onSet(Response);
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this);
	        var onSet = function (obj) {
	            this.corObject = obj;
	            this.setCorAutoComplete();
	            this.corLoading = false;
	        }.bind(this);
	        if (object.novo) {
	            this.corLoading = true;
	            var newObj = new cor_model_1.Cor();
	            newObj.cor = object.text;
	            this._corApiService.onPost(newObj, onDone);
	        }
	        else {
	            onSet(object);
	        }
	    };
	    FrotaFormComponent.prototype.getMotoristaObject = function (object) {
	        this.motoristaObject = object;
	        if (object.id) {
	            this._utilService.setSelectOnFormControl(this.form, 'motorista', object);
	        }
	        else {
	            this._utilService.setSelectOnFormControl(this.form, 'motorista', { id: -1 });
	        }
	    };
	    FrotaFormComponent.prototype.getModeloGpsObject = function (object) {
	        this.modeloGpsObject = object;
	        if (object.id) {
	            this._utilService.setSelectOnFormControl(this.form, 'modeloGps', object);
	        }
	        else {
	            this._utilService.setSelectOnFormControl(this.form, 'modeloGps', { id: -1 });
	        }
	    };
	    FrotaFormComponent.prototype.onAddFrota = function (object) {
	        this._frotaApiService.onPost(object, this.onDone);
	    };
	    FrotaFormComponent.prototype.onEditFrota = function (object) {
	        this._frotaApiService.onPut(object, this.onDone);
	    };
	    FrotaFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.modelo = this.modeloObject;
	        object.modelo.marca = this.marcaObject;
	        object.cor = this.corObject;
	        object.combustiveis = this.combustiveisCheckedList;
	        object.orgao = this.orgaoObject;
	        object.area = this.areaObject;
	        object.divisao = this.divisaoObject;
	        object.setor = this.setorObject;
	        object.localidade = this.localidadeObject;
	        object.situacao = this.situacaoObject;
	        object.motoristaPrincipal = this.motoristaObject;
	        object.categoriaExigida = this.categoriaCnhObject;
	        object.formaControle = this.formaControleObject;
	        object.gpsModelo = this.modeloGpsObject;
	        object.thisRoute = this.thisRoute;
	        return object;
	    };
	    FrotaFormComponent.prototype.onShowPatrimonio = function () {
	        document.getElementById('from-group_codigoPatrimonio').className = 'geo-input--3c geo-input--error';
	        var element = document.getElementById('codigoPatrimonio');
	        element.disabled = false;
	        if (document.getElementById('asterisk_codigoPatrimonio')) {
	            document.getElementById('asterisk_codigoPatrimonio').style.visibility = 'visible';
	        }
	    };
	    FrotaFormComponent.prototype.onHidePatrimonio = function () {
	        document.getElementById('from-group_codigoPatrimonio').className = 'geo-input--3c';
	        var element = document.getElementById('codigoPatrimonio');
	        element.disabled = true;
	        this.formObject.codigoPatrimonio = null;
	        if (document.getElementById('asterisk_codigoPatrimonio')) {
	            document.getElementById('asterisk_codigoPatrimonio').style.visibility = 'hidden';
	        }
	    };
	    FrotaFormComponent.prototype.getCombustiveis = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        this.combustiveisList.push(Response[x]);
	                    }
	                }
	            }
	        }.bind(this));
	        this._combustivelApiService.onGetAll(onDone);
	    };
	    FrotaFormComponent.prototype.getSituacoes = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.situacoesList = Response;
	                this.setSituacao();
	            }
	        }.bind(this));
	        this._situacaoApiService.onGetAll(onDone);
	    };
	    FrotaFormComponent.prototype.getMesLicenciamento = function (finalPlaca) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, t = void 0;
	                if (Response.length) {
	                    t = Response[0];
	                    for (x = 0, lenX = this.monthsList.length; x < lenX; x++) {
	                        if (this.monthsList[x].Key === t.mes) {
	                            this.formObject.mesLicenciamento = this.monthsList[x];
	                            break;
	                        }
	                    }
	                }
	                this.loadingMesLicenciamento = false;
	            }
	        }.bind(this));
	        this.loadingMesLicenciamento = true;
	        var query = { where: {
	                estadoId: this.project.estadoId,
	                finalPlaca: Number(finalPlaca)
	            } };
	        this._licenciamentoApiService.onGetFilter(query, onDone);
	    };
	    FrotaFormComponent.prototype.getCombustiveisByBem = function (bemId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX, element;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    this.combustiveisCheckedList.push(Response[x].combustivelId);
	                    element = document.getElementById("check_combustivel_" + Response[x].combustivelId);
	                    if (element) {
	                        element.checked = true;
	                    }
	                }
	            }
	        }.bind(this));
	        this._bemCombustivelApiService.onGetByBem(bemId, onDone);
	    };
	    FrotaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.identificationText = Response.identificacao;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum ' + this.frotasModule.single + ' encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._frotaApiService.onGetById(id, onDone);
	    };
	    FrotaFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._frotasService.getSessionStorage();
	        this._frotasService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    FrotaFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            if (this.thisRoute === data_service_1.aeronavesRoute || this.thisRoute === data_service_1.embarcacoesRoute) {
	                this.actionTitle = data_service_2.newRouteFemale;
	            }
	            else {
	                this.actionTitle = data_service_2.newRoute;
	            }
	        }
	        if (this.thisRoute === data_service_1.aeronavesRoute || this.thisRoute === data_service_1.embarcacoesRoute) {
	            this.articleTitle = "da";
	        }
	        else {
	            this.articleTitle = "do";
	        }
	    };
	    FrotaFormComponent.prototype.setEditNormal = function (id) {
	        this.formObject.mesIPVA = this.monthsList[0];
	        this.formObject.mesLicenciamento = this.monthsList[0];
	        this.formObject.mesSeguroObrigatorio = this.monthsList[0];
	        this.getObject(id);
	        this.getCombustiveisByBem(id);
	    };
	    FrotaFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	        this.formObject.mesIPVA = this.monthsList[0];
	        this.formObject.mesLicenciamento = this.monthsList[0];
	        this.formObject.mesSeguroObrigatorio = this.monthsList[0];
	        this.setFormaControle();
	    };
	    FrotaFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    FrotaFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    FrotaFormComponent.prototype.setModelToForm = function () {
	        var x, lenX, tipo;
	        if (this.formObject.terceiro) {
	            this.onHidePatrimonio();
	        }
	        if (this.formObject.dataCompra) {
	            if (this.formObject.dataCompra.indexOf("/") === -1) {
	                this.formObject.dataCompra = this._utilService.convertDateToString(this.formObject.dataCompra);
	            }
	        }
	        if (this.formObject.dataTerminoGarantia) {
	            if (this.formObject.dataTerminoGarantia.indexOf("/") === -1) {
	                this.formObject.dataTerminoGarantia = this._utilService.convertDateToString(this.formObject.dataTerminoGarantia);
	            }
	        }
	        if (this.formObject.dataVenda) {
	            if (this.formObject.dataVenda.indexOf("/") === -1) {
	                this.formObject.dataVenda = this._utilService.convertDateToString(this.formObject.dataVenda);
	            }
	        }
	        if (this.formObject.cor) {
	            this.corObject = this._utilService.cloneObject(this.formObject.cor);
	            delete this.formObject['cor'];
	            this.setCorAutoComplete();
	        }
	        if (this.formObject.situacao) {
	            this.situacaoObject = this._utilService.cloneObject(this.formObject.situacao);
	            delete this.formObject['situacao'];
	            this.setSituacao();
	        }
	        if (this.formObject.modelo) {
	            this.modeloObject = this._utilService.cloneObject(this.formObject.modelo);
	            delete this.formObject['modelo'];
	            this.modeloDisabled = false;
	            tipo = '';
	            if (this.modeloObject.tipoBem) {
	                tipo = this.modeloObject.tipoBem.tipo + ' / ';
	            }
	            var text = this._autocompleteService.getTextSelect2(this.modeloObject, 'modelo');
	            var selectObject = { text: tipo.concat(text), id: this.modeloObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.modeloSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.modeloSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'modelo', this.modeloObject);
	            if (this.modeloObject.marca) {
	                this.marcaObject = this._utilService.cloneObject(this.modeloObject.marca);
	                delete this.modeloObject['marca'];
	                var text_1 = this._autocompleteService.getTextSelect2(this.marcaObject, 'marca');
	                var selectObject = { text: text_1, id: this.marcaObject.id };
	                this._autocompleteService.createOptionOnSelect2(this.marcaSelectId, selectObject);
	                this._autocompleteService.setValueOnSelect2(selectObject.id, this.marcaSelectId);
	                this._utilService.setSelectOnFormControl(this.form, 'marca', this.marcaObject);
	                this.setMarcaOnModelo();
	            }
	        }
	        if (this.formObject.orgao) {
	            this.orgaoObject = this._utilService.cloneObject(this.formObject.orgao);
	            delete this.formObject['orgao'];
	            var text = this._autocompleteService.getTextSelect2(this.orgaoObject, 'razaoSocial');
	            var selectObject = { text: text, id: this.orgaoObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.orgaoSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.orgaoSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'orgao', this.orgaoObject);
	        }
	        if (this.formObject.area) {
	            this.areaObject = this._utilService.cloneObject(this.formObject.area);
	            delete this.formObject['area'];
	            var text = this._autocompleteService.getTextSelect2(this.areaObject, 'nome');
	            var selectObject = { text: text, id: this.areaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.areaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.areaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'area', this.areaObject);
	        }
	        if (this.formObject.divisao) {
	            this.divisaoObject = this._utilService.cloneObject(this.formObject.divisao);
	            delete this.formObject['divisao'];
	            var text = this._autocompleteService.getTextSelect2(this.divisaoObject, 'divisao');
	            var selectObject = { text: text, id: this.divisaoObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.divisaoSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.divisaoSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'divisao', this.divisaoObject);
	        }
	        if (this.formObject.setor) {
	            this.setorObject = this._utilService.cloneObject(this.formObject.setor);
	            delete this.formObject['setor'];
	            var text = this._autocompleteService.getTextSelect2(this.setorObject, 'setor');
	            var selectObject = { text: text, id: this.setorObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.setorSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.setorSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'setor', this.setorObject);
	        }
	        if (this.formObject.localidade) {
	            this.localidadeObject = this._utilService.cloneObject(this.formObject.localidade);
	            delete this.formObject['localidade'];
	            var text = this._autocompleteService.getTextSelect2(this.localidadeObject, 'localidade');
	            var selectObject = { text: text, id: this.localidadeObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.localidadeSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.localidadeSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'localidade', this.localidadeObject);
	        }
	        if (this.formObject.motoristaPrincipal) {
	            this.motoristaObject = this._utilService.cloneObject(this.formObject.motoristaPrincipal);
	            delete this.formObject['motoristaPrincipal'];
	            if (this.motoristaObject.funcionario && this.motoristaObject.funcionario.pessoa) {
	                var funcionario = this.motoristaObject.funcionario;
	                var selectObject = { text: funcionario.pessoa.nome, id: this.motoristaObject.id };
	                this._autocompleteService.createOptionOnSelect2(this.motoristaSelectId, selectObject);
	                this._autocompleteService.setValueOnSelect2(selectObject.id, this.motoristaSelectId);
	                this._utilService.setSelectOnFormControl(this.form, 'motorista', this.motoristaObject);
	            }
	        }
	        if (this.formObject.gpsModelo) {
	            this.modeloGpsObject = this._utilService.cloneObject(this.formObject.gpsModelo);
	            delete this.formObject['gpsModelo'];
	            var selectObject = { text: this.modeloGpsObject.modelo, id: this.modeloGpsObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.modeloGpsSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.modeloGpsSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'modeloGps', this.modeloGpsObject);
	        }
	        if (this.thisRoute === this.veiculosRoute) {
	            for (x = 0, lenX = this.monthsList.length; x < lenX; x++) {
	                if (this.formObject.mesIPVA && (this.formObject.mesIPVA === this.monthsList[x].Key || this.formObject.mesIPVA.Key === this.monthsList[x].Key)) {
	                    this.formObject.mesIPVA = this.monthsList[x];
	                }
	                if (this.formObject.mesLicenciamento && (this.formObject.mesLicenciamento === this.monthsList[x].Key || this.formObject.mesLicenciamento.Key === this.monthsList[x].Key)) {
	                    this.formObject.mesLicenciamento = this.monthsList[x];
	                }
	                if (this.formObject.mesSeguroObrigatorio && (this.formObject.mesSeguroObrigatorio === this.monthsList[x].Key || this.formObject.mesSeguroObrigatorio.Key === this.monthsList[x].Key)) {
	                    this.formObject.mesSeguroObrigatorio = this.monthsList[x];
	                }
	            }
	            if (!this.formObject.mesIPVA) {
	                this.formObject.mesIPVA = this.monthsList[0];
	            }
	            if (!this.formObject.mesLicenciamento) {
	                this.formObject.mesLicenciamento = this.monthsList[0];
	            }
	            if (!this.formObject.mesSeguroObrigatorio) {
	                this.formObject.mesSeguroObrigatorio = this.monthsList[0];
	            }
	        }
	        if (this.formObject.formaControle) {
	            this.formaControleObject = this._utilService.cloneObject(this.formObject.formaControle);
	            delete this.formObject['formaControle'];
	            this.setFormaControle();
	            if (this.formObject.odometroHorimetro) {
	                this.formObject.odometroHorimetroValue = this._formaControleService.setOdometroHorimetroToForm(this.formObject.odometroHorimetro.odometroHorimetro);
	                delete this.formObject['odometroHorimetro'];
	            }
	        }
	        if (this.formObject.anoFabricacao) {
	            this.formObject.anoFabricacao = this.formObject.anoFabricacao.toString();
	        }
	        if (this.formObject.anoModelo) {
	            this.formObject.anoModelo = this.formObject.anoModelo.toString();
	        }
	        if (this.formObject.categoriaExigida) {
	            this.categoriaCnhObject = this._utilService.cloneObject(this.formObject.categoriaExigida);
	            delete this.formObject['categoriaExigida'];
	            this.setCategoriaCnh();
	        }
	    };
	    FrotaFormComponent.prototype.goToList = function () {
	        this._frotasService.clearBackStorage();
	        this._frotaNavigationService.goToList(this.thisRoute);
	    };
	    FrotaFormComponent.prototype.toLeaveHere = function () {
	        this.goToList();
	    };
	    FrotaFormComponent.prototype.setMarcaOnModelo = function () {
	        this.setCategoriaOnModelo();
	        var modeloQuery = JSON.stringify(this.modeloQuery);
	        var marcaId = this.marcaObject.id;
	        modeloQuery = modeloQuery.replace("REPLACEMARCAID", marcaId);
	        this.modeloQuery = JSON.parse(modeloQuery);
	        this.modeloDisabled = false;
	    };
	    FrotaFormComponent.prototype.setCategoriaOnModelo = function () {
	        var modeloQuery = JSON.stringify(data_service_8.modelosQueryComCategoriaMarca);
	        var categoriaId = this.moduleId.toString();
	        modeloQuery = modeloQuery.replace("REPLACECATEGORIAID", categoriaId);
	        this.modeloQuery = JSON.parse(modeloQuery);
	    };
	    FrotaFormComponent.prototype.setCorAutoComplete = function () {
	        var text = this._autocompleteService.getTextSelect2(this.corObject, 'cor');
	        var selectObject = { text: text, id: this.corObject.id };
	        this._autocompleteService.createOptionOnSelect2(this.corSelectId, selectObject);
	        this._autocompleteService.setValueOnSelect2(selectObject.id, this.corSelectId);
	        this._utilService.setSelectOnFormControl(this.form, 'cor', this.corObject);
	    };
	    FrotaFormComponent.prototype.setSituacao = function () {
	        if (this.situacaoObject.id) {
	            var element = document.getElementById("radioSituacao_" + this.situacaoObject.id);
	            if (element) {
	                element.checked = true;
	            }
	        }
	    };
	    FrotaFormComponent.prototype.getCategoriasCnh = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.categoriasCnhList = Response;
	                this.categoriasCnhList.unshift({ id: null, categoria: '— Selecione —' });
	                this.setCategoriaCnh();
	            }
	        }.bind(this));
	        this._categoriaCnhApiService.onGetAllVeiculo(onDone);
	    };
	    FrotaFormComponent.prototype.setCategoriaCnh = function () {
	        var x, lenX, cnh = this.categoriaCnhObject.id;
	        if (this.categoriasCnhList.length && !this.categoriaCnhObject.id) {
	            cnh = this.categoriasCnhList[0].id;
	        }
	        for (x = 0, lenX = this.categoriasCnhList.length; x < lenX; x++) {
	            if (this.categoriasCnhList[x].id === cnh) {
	                this.categoriaCnhObject = this.categoriasCnhList[x];
	                break;
	            }
	        }
	    };
	    FrotaFormComponent.prototype.getFormasControle = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formasControleList = Response;
	                this.setFormaControle();
	            }
	        }.bind(this));
	        this._formaControleApiService.onGetAll(onDone);
	    };
	    FrotaFormComponent.prototype.setFormaControle = function () {
	        var x, lenX, sem = this._formaControleService.getFormaControleSem(), fc = this.formaControleObject.id;
	        if (!this.formaControleObject.id) {
	            fc = sem;
	        }
	        for (x = 0, lenX = this.formasControleList.length; x < lenX; x++) {
	            if (this.formasControleList[x].id === fc) {
	                this.formaControleObject = this.formasControleList[x];
	                break;
	            }
	        }
	    };
	    FrotaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(389),
	            styles: [__webpack_require__(390)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _d) || Object, (typeof (_e = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object, (typeof (_g = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _g) || Object, (typeof (_h = typeof cor_api_service_1.CorApiService !== 'undefined' && cor_api_service_1.CorApiService) === 'function' && _h) || Object, (typeof (_j = typeof combustivel_api_service_1.CombustivelApiService !== 'undefined' && combustivel_api_service_1.CombustivelApiService) === 'function' && _j) || Object, (typeof (_k = typeof bem_combustivel_api_service_1.BemCombustivelApiService !== 'undefined' && bem_combustivel_api_service_1.BemCombustivelApiService) === 'function' && _k) || Object, (typeof (_l = typeof orgao_api_service_1.OrgaoApiService !== 'undefined' && orgao_api_service_1.OrgaoApiService) === 'function' && _l) || Object, (typeof (_m = typeof orgao_navigation_service_1.OrgaoNavigationService !== 'undefined' && orgao_navigation_service_1.OrgaoNavigationService) === 'function' && _m) || Object, (typeof (_o = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _o) || Object, (typeof (_p = typeof area_navigation_service_1.AreaNavigationService !== 'undefined' && area_navigation_service_1.AreaNavigationService) === 'function' && _p) || Object, (typeof (_q = typeof divisao_api_service_1.DivisaoApiService !== 'undefined' && divisao_api_service_1.DivisaoApiService) === 'function' && _q) || Object, (typeof (_r = typeof divisao_navigation_service_1.DivisaoNavigationService !== 'undefined' && divisao_navigation_service_1.DivisaoNavigationService) === 'function' && _r) || Object, (typeof (_s = typeof setor_api_service_1.SetorApiService !== 'undefined' && setor_api_service_1.SetorApiService) === 'function' && _s) || Object, (typeof (_t = typeof setor_navigation_service_1.SetorNavigationService !== 'undefined' && setor_navigation_service_1.SetorNavigationService) === 'function' && _t) || Object, (typeof (_u = typeof localidade_api_service_1.LocalidadeApiService !== 'undefined' && localidade_api_service_1.LocalidadeApiService) === 'function' && _u) || Object, (typeof (_v = typeof localidade_navigation_service_1.LocalidadeNavigationService !== 'undefined' && localidade_navigation_service_1.LocalidadeNavigationService) === 'function' && _v) || Object, (typeof (_w = typeof localidade_service_1.LocalidadeService !== 'undefined' && localidade_service_1.LocalidadeService) === 'function' && _w) || Object, (typeof (_x = typeof modelo_api_service_1.ModeloApiService !== 'undefined' && modelo_api_service_1.ModeloApiService) === 'function' && _x) || Object, (typeof (_y = typeof modelo_navigation_service_1.ModeloNavigationService !== 'undefined' && modelo_navigation_service_1.ModeloNavigationService) === 'function' && _y) || Object, (typeof (_z = typeof modelo_service_1.ModeloService !== 'undefined' && modelo_service_1.ModeloService) === 'function' && _z) || Object, (typeof (_0 = typeof marca_api_service_1.MarcaApiService !== 'undefined' && marca_api_service_1.MarcaApiService) === 'function' && _0) || Object, (typeof (_1 = typeof marca_navigation_service_1.MarcaNavigationService !== 'undefined' && marca_navigation_service_1.MarcaNavigationService) === 'function' && _1) || Object, (typeof (_2 = typeof situacao_api_service_1.SituacaoApiService !== 'undefined' && situacao_api_service_1.SituacaoApiService) === 'function' && _2) || Object, (typeof (_3 = typeof motorista_api_service_1.MotoristaApiService !== 'undefined' && motorista_api_service_1.MotoristaApiService) === 'function' && _3) || Object, (typeof (_4 = typeof motorista_service_1.MotoristaService !== 'undefined' && motorista_service_1.MotoristaService) === 'function' && _4) || Object, (typeof (_5 = typeof categoria_cnh_api_service_1.CategoriaCnhApiService !== 'undefined' && categoria_cnh_api_service_1.CategoriaCnhApiService) === 'function' && _5) || Object, (typeof (_6 = typeof forma_controle_api_service_1.FormaControleApiService !== 'undefined' && forma_controle_api_service_1.FormaControleApiService) === 'function' && _6) || Object, (typeof (_7 = typeof modelo_gps_service_1.ModeloGpsService !== 'undefined' && modelo_gps_service_1.ModeloGpsService) === 'function' && _7) || Object, (typeof (_8 = typeof modelo_gps_api_service_1.ModeloGpsApiService !== 'undefined' && modelo_gps_api_service_1.ModeloGpsApiService) === 'function' && _8) || Object, (typeof (_9 = typeof licenciamento_api_service_1.LicenciamentoApiService !== 'undefined' && licenciamento_api_service_1.LicenciamentoApiService) === 'function' && _9) || Object, (typeof (_10 = typeof projeto_service_1.ProjetoService !== 'undefined' && projeto_service_1.ProjetoService) === 'function' && _10) || Object, (typeof (_11 = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _11) || Object, (typeof (_12 = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _12) || Object])
	    ], FrotaFormComponent);
	    return FrotaFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12;
	}());
	exports.FrotaFormComponent = FrotaFormComponent;


/***/ },
/* 373 */
/***/ function(module, exports) {

	"use strict";
	var Frota = (function () {
	    function Frota() {
	    }
	    return Frota;
	}());
	exports.Frota = Frota;
	var FrotaImagem = (function () {
	    function FrotaImagem() {
	    }
	    return FrotaImagem;
	}());
	exports.FrotaImagem = FrotaImagem;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(375);
	var rest_service_1 = __webpack_require__(26);
	var CorApiService = (function () {
	    function CorApiService(_restService) {
	        this._restService = _restService;
	    }
	    CorApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    CorApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    CorApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    CorApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "cor", "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    CorApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    CorApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    CorApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], CorApiService);
	    return CorApiService;
	    var _a;
	}());
	exports.CorApiService = CorApiService;


/***/ },
/* 375 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'cores';
	exports.coresQuery = {
	    "where": {
	        "ativo": true,
	        "cor": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "cor"
	};


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(377);
	var rest_service_1 = __webpack_require__(26);
	var CombustivelApiService = (function () {
	    function CombustivelApiService(_restService) {
	        this._restService = _restService;
	    }
	    CombustivelApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    CombustivelApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    CombustivelApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    CombustivelApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "combustivel" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    CombustivelApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    CombustivelApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    CombustivelApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], CombustivelApiService);
	    return CombustivelApiService;
	    var _a;
	}());
	exports.CombustivelApiService = CombustivelApiService;


/***/ },
/* 377 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'combustiveis';
	exports.combustiveisRoute = 'combustiveis';
	exports.combustiveisStorage = 'combustiveis';
	exports.combustiveisModuleName = { plural: 'Combustíveis', single: 'Combustível' };
	exports.combustiveisQuery = {
	    "where": {
	        "ativo": true,
	        "combustivel": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "combustivel"
	};


/***/ },
/* 378 */
/***/ function(module, exports) {

	"use strict";
	var Cor = (function () {
	    function Cor() {
	    }
	    return Cor;
	}());
	exports.Cor = Cor;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(380);
	var rest_service_1 = __webpack_require__(26);
	var BemCombustivelApiService = (function () {
	    function BemCombustivelApiService(_restService) {
	        this._restService = _restService;
	    }
	    BemCombustivelApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    BemCombustivelApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    BemCombustivelApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    BemCombustivelApiService.prototype.onGetByBem = function (bemId, done) {
	        var filter = { "where": { "bemId": bemId, "ativo": true }, "include": ["combustivel"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    BemCombustivelApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGet(data_service_1.apiName + '/' + objectId + '?', done);
	    };
	    BemCombustivelApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], BemCombustivelApiService);
	    return BemCombustivelApiService;
	    var _a;
	}());
	exports.BemCombustivelApiService = BemCombustivelApiService;


/***/ },
/* 380 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'combustiveis-bens';


/***/ },
/* 381 */
/***/ function(module, exports) {

	"use strict";
	var Situacao = (function () {
	    function Situacao() {
	    }
	    return Situacao;
	}());
	exports.Situacao = Situacao;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(383);
	var rest_service_1 = __webpack_require__(26);
	var SituacaoApiService = (function () {
	    function SituacaoApiService(_restService) {
	        this._restService = _restService;
	    }
	    SituacaoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    SituacaoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    SituacaoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    SituacaoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "situacao", "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    SituacaoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    SituacaoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], SituacaoApiService);
	    return SituacaoApiService;
	    var _a;
	}());
	exports.SituacaoApiService = SituacaoApiService;


/***/ },
/* 383 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'situacoes';


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(385);
	var LicenciamentoApiService = (function () {
	    function LicenciamentoApiService(_restService) {
	        this._restService = _restService;
	        this.include = ['estado'];
	    }
	    LicenciamentoApiService.prototype.onPost = function (object, done) {
	        return this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    LicenciamentoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    LicenciamentoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    LicenciamentoApiService.prototype.onGetAll = function (done) {
	        var filter = { include: this.include };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    LicenciamentoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { include: this.include };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    LicenciamentoApiService.prototype.onGetFilter = function (query, done) {
	        query.include = this.include;
	        this._restService.onGetPost(data_service_1.apiName, query, done);
	    };
	    LicenciamentoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    LicenciamentoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], LicenciamentoApiService);
	    return LicenciamentoApiService;
	    var _a;
	}());
	exports.LicenciamentoApiService = LicenciamentoApiService;


/***/ },
/* 385 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'meses-licenciamentos';
	exports.licenciamentosRoute = 'mes-licenciamentos';
	exports.licenciamentosStorage = 'mes-licenciamentos';
	exports.licenciamentosModuleName = { plural: 'Meses de licenciamento', single: 'Mês de licenciamento' };


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(387);
	var autocomplete_service_1 = __webpack_require__(101);
	var ModeloGpsService = (function () {
	    function ModeloGpsService(_autocompleteService) {
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        text = state.modelo;
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    ModeloGpsService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.modeloGpsStorage + '-new', object);
	    };
	    ModeloGpsService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.modeloGpsStorage + "-new");
	        return JSON.parse(item);
	    };
	    ModeloGpsService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.modeloGpsStorage + "-new");
	    };
	    ModeloGpsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object])
	    ], ModeloGpsService);
	    return ModeloGpsService;
	    var _a;
	}());
	exports.ModeloGpsService = ModeloGpsService;


/***/ },
/* 387 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'gps-modelos';
	exports.modeloGpsRoute = 'modelos-gps';
	exports.modeloGpsStorage = 'modelos-gps';
	exports.modeloGpsModuleName = { plural: 'Modelos de GPS', single: 'Modelo de GPS' };
	exports.modeloGpsQuery = {
	    "where": {
	        "ativo": true,
	        "modelo": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "modelo"
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(387);
	var rest_service_1 = __webpack_require__(26);
	var ModeloGpsApiService = (function () {
	    function ModeloGpsApiService(_restService) {
	        this._restService = _restService;
	    }
	    ModeloGpsApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    ModeloGpsApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    ModeloGpsApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    ModeloGpsApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "modelo" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ModeloGpsApiService.prototype.onGetById = function (objectId, done) {
	        var filter = {};
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    ModeloGpsApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    ModeloGpsApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ModeloGpsApiService);
	    return ModeloGpsApiService;
	    var _a;
	}());
	exports.ModeloGpsApiService = ModeloGpsApiService;


/***/ },
/* 389 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n        <li class=\"item\" *ngIf=\"showDetailLink\"><a (click)=\"clickGoToDetail()\" class=\"cursor-pointer\">{{formObject.identificacao}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{frotasModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{frotasModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c\" *ngIf=\"formObject.id\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n\n        <div class=\"geo-toggle terceiro\">\n            <input type=\"checkbox\" id=\"terceiro\" value=\"\" [(ngModel)]=\"formObject.terceiro\" (click)=\"clickThird()\" formControlName=\"terceiro\">\n            <label for=\"terceiro\">{{frotasModule.single}} de terceiro</label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Identificação {{articleTitle}} {{frotasModule.single | lowercase}}</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !identificacao.valid && submitted}\">\n                <label for=\"identificacao\">Identificação <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!identificacao.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"identificacao\" [(ngModel)]=\"formObject.identificacao\" formControlName=\"identificacao\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"thisRoute === veiculosRoute\">\n                <label for=\"placa\">Placa</label>\n                <div>\n                    <input type=\"text\" class=\"form-control text-uppercase\" id=\"placa\" [(ngModel)]=\"formObject.placa\" maxlength=\"8\" (blur)=\"blurPlaca()\" appLicensePlateMask formControlName=\"placa\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !codigo.valid && submitted}\">\n                <label for=\"registroCodigo\">Registro <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!codigo.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"registroCodigo\" [(ngModel)]=\"formObject.codigo\" formControlName=\"codigo\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"thisRoute === equipamentosRoute\">\n                <label for=\"numeroSerie\">Número de série</label>\n                <div>\n                    <input type=\"text\"  id=\"numeroSerie\" [(ngModel)]=\"formObject.numeroSerie\" formControlName=\"numeroSerie\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" id=\"from-group_codigoPatrimonio\" [ngClass]=\"{'geo-input--error': !codigoPatrimonio.valid && submitted}\" >\n                <label for=\"codigoPatrimonio\">Cód. do patrimônio <abbr id=\"asterisk_codigoPatrimonio\">*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!codigoPatrimonio.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\"  id=\"codigoPatrimonio\" [(ngModel)]=\"formObject.codigoPatrimonio\" formControlName=\"codigoPatrimonio\">\n                </div>\n            </div>\n\n            <autocomplete-insert-component class=\"geo-input--3c\" id=\"cor\"\n                                           (setObejct)=\"getCorObject($event)\"\n                                           (clearObject)=\"getCorObject($event)\"\n                                           [submitted]=\"submitted\"\n                                           [isRequired]=\"false\"\n                                           [selectId]=\"corSelectId\"\n                                           [model]=\"corObject\"\n                                           [_service]=\"_corApiService\"\n                                           [fieldToShow]=\"'cor'\"\n                                           [loading]=\"corLoading\"\n                                           [query]=\"corQuery\"\n                                           [clear]=\"true\"\n                                           [label]=\"'Cor'\"></autocomplete-insert-component>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"marca\"\n                                    (setObejct)=\"getMarcasObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"marcaSelectId\"\n                                    [model]=\"marcaObject\"\n                                    [_service]=\"_marcaApiService\"\n                                    [fieldToShow]=\"'marca'\"\n                                    [query]=\"marcaQuery\"\n                                    [label]=\"'Marca'\"></autocomplete-component>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"modelo\"\n                                    (setObejct)=\"getModelosObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [isDisabled]=\"modeloDisabled\"\n                                    [selectId]=\"modeloSelectId\"\n                                    [model]=\"modeloObject\"\n                                    [_service]=\"_modeloApiService\"\n                                    [apiCustom]=\"'/busca-avancada'\"\n                                    [query]=\"modeloQuery\"\n                                    [templateResult]=\"modeloTemplateResult\"\n                                    [label]=\"'Modelo'\"></autocomplete-component>\n\n\n            <div class=\"geo-input--3c\">\n                <label for=\"ano_fabricacao\">Ano de fabricação</label>\n                <div>\n                    <input type=\"text\" class=\"form-control year\" id=\"ano_fabricacao\" minlength=\"4\" maxlength=\"4\" [(ngModel)]=\"formObject.anoFabricacao\" appNumberInteger formControlName=\"anoFabricacao\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"ano_modelo\">Ano do modelo</label>\n                <div>\n                    <input type=\"text\" class=\"form-control year\" id=\"ano_modelo\" minlength=\"4\" maxlength=\"4\" [(ngModel)]=\"formObject.anoModelo\" appNumberInteger formControlName=\"anoModelo\">\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Lotação</h2>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"orgao\"\n                                (setObejct)=\"getOrgaosObject($event)\"\n                                (clearObject)=\"getOrgaosObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"orgaoSelectId\"\n                                [model]=\"orgaoObject\"\n                                [_service]=\"_orgaoApiService\"\n                                [fieldToShow]=\"'razaoSocial'\"\n                                [query]=\"orgaoQuery\"\n                                [clear]=\"true\"\n                                [label]=\"'Órgão'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"area\"\n                                (setObejct)=\"getAreasObject($event)\"\n                                (clearObject)=\"getAreasObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"areaSelectId\"\n                                [model]=\"areaObject\"\n                                [_service]=\"_areaApiService\"\n                                [fieldToShow]=\"'nome'\"\n                                [query]=\"areaQuery\"\n                                [clear]=\"true\"\n                                [label]=\"'Área'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"divisao\"\n                                (setObejct)=\"getDivisoesObject($event)\"\n                                (clearObject)=\"getDivisoesObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"divisaoSelectId\"\n                                [model]=\"divisaoObject\"\n                                [_service]=\"_divisaoApiService\"\n                                [fieldToShow]=\"'divisao'\"\n                                [query]=\"divisaoQuery\"\n                                [clear]=\"true\"\n                                [label]=\"'Divisão'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"setor\"\n                                (setObejct)=\"getSetoresObject($event)\"\n                                (clearObject)=\"getSetoresObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"setorSelectId\"\n                                [model]=\"setorObject\"\n                                [_service]=\"_setorApiService\"\n                                [fieldToShow]=\"'setor'\"\n                                [query]=\"setorQuery\"\n                                [clear]=\"true\"\n                                [label]=\"'Setor'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"localidade\"\n                                (setObejct)=\"getLocalidadesObject($event)\"\n                                (clearObject)=\"getLocalidadesObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"localidadeSelectId\"\n                                [model]=\"localidadeObject\"\n                                [_service]=\"_localidadeApiService\"\n                                [fieldToShow]=\"'localidade'\"\n                                [query]=\"localidadeQuery\"\n                                [clear]=\"true\"\n                                [label]=\"'Localidade'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"motorista\" *ngIf=\"thisRoute === veiculosRoute\"\n                                (setObejct)=\"getMotoristaObject($event)\"\n                                (clearObject)=\"getMotoristaObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"motoristaSelectId\"\n                                [model]=\"motoristaObject\"\n                                [_service]=\"_motoristaApiService\"\n                                [query]=\"motoristaQuery\"\n                                [templateResult]=\"motoristaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [clear]=\"true\"\n                                [label]=\"'Motorista principal'\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados {{articleTitle}} {{frotasModule.single | lowercase}}</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-columns--12c\">\n                <div class=\"geo-input--12c mb8\">\n                    <label>Situação</label>\n                </div>\n                <div class=\"geo-toggle\" *ngFor=\"let item of situacoesList\">\n                    <input id=\"radioSituacao_{{item.id}}\" type=\"radio\" name=\"radioSituacao\" (click)=\"clickCheckSituacao(item)\">\n                    <label attr.for=\"radioSituacao_{{item.id}}\">{{item.situacao}}</label>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"thisRoute === veiculosRoute\">\n                <label for=\"renavam\">Renavam</label>\n                <div>\n                    <input type=\"text\" class=\"form-control renavam\" id=\"renavam\" maxlength=\"11\" [(ngModel)]=\"formObject.numeroRenavam\" formControlName=\"numeroRenavam\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"thisRoute === veiculosRoute || thisRoute === maquinarioRoute || thisRoute === equipamentosRoute\">\n                <label for=\"chassi\">Chassi</label>\n                <div>\n                    <input type=\"text\"  id=\"chassi\" [(ngModel)]=\"formObject.chassi\" formControlName=\"chassi\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c geo-input--datepicker\">\n                <label for=\"data_compra\">Data da compra</label>\n                <div>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"data_compra\" [(ngModel)]=\"formObject.dataCompra\" formControlName=\"dataCompra\" appDatepicker />\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c geo-input--datepicker\">\n                <label for=\"termino_garantia\">Término da garantia</label>\n                <div>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"termino_garantia\" [(ngModel)]=\"formObject.dataTerminoGarantia\" formControlName=\"dataTerminoGarantia\" appDatepicker />\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c  geo-input--datepicker\">\n                <label for=\"data_venda\">Data da venda</label>\n                <div>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"data_venda\" [(ngModel)]=\"formObject.dataVenda\" formControlName=\"dataVenda\" appDatepicker />\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"thisRoute === veiculosRoute || thisRoute === maquinarioRoute\">\n                <label for=\"categoriacnh\">Categoria CNH</label>\n                <div>\n                    <select id=\"categoriacnh\" [(ngModel)]=\"categoriaCnhObject\" formControlName=\"categoriaCnh\"  class=\"option_{{categoriaCnhObject.id}}\">\n                        <option *ngFor=\"let item of categoriasCnhList\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.categoria}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--12c\">\n                <div class=\"geo-input--3c\">\n                    <label for=\"formacontrole\">Forma de controle</label>\n                    <div>\n                        <select id=\"formacontrole\" [(ngModel)]=\"formaControleObject\" formControlName=\"formaControle\" (ngModelChange)=\"changeFormaControle()\">\n                            <option *ngFor=\"let item of formasControleList\" [ngValue]=\"item\">{{item.formaControle}}</option>\n                        </select>\n                    </div>\n                </div>\n\n                <app-odometro-horimetro-form-component [labelOdometro]=\"''\"\n                                                       [labelHorimetro]=\"''\"\n                                                       [showOdometro]=\"showTipoOdometro\"\n                                                       [required]=\"false\"\n                                                       [submitted]=\"submitted\"\n                                                       [model]=\"formObject.odometroHorimetroValue\"\n                                                       (returnModel)=\"formObject.odometroHorimetroValue = $event\"\n                                                       [bemId]=\"formObject.id\"></app-odometro-horimetro-form-component>\n\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"thisRoute === veiculosRoute || thisRoute === maquinarioRoute\">\n                <label for=\"carga\">Capac. de carga</label>\n                <div>\n                    <input type=\"text\"  id=\"carga\" [(ngModel)]=\"formObject.capacidadeCarga\" formControlName=\"capacidadeCarga\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"thisRoute === veiculosRoute\">\n                <label for=\"passageiros\">Quant. de passageiros</label>\n                <div>\n                    <input type=\"text\" id=\"passageiros\" [(ngModel)]=\"formObject.numeroPassageiros\" appNumberInteger formControlName=\"numeroPassageiros\">\n                </div>\n            </div>\n\n            <div class=\"geo-columns--12c mb16\" *ngIf=\"(thisRoute === veiculosRoute || thisRoute === maquinarioRoute)\">\n                <div class=\"geo-input--12c mb8\">\n                    <label>Combustíveis</label>\n                    <p class=\"input-hint\" *ngIf=\"!combustiveisList.length\">Nenhum combustível cadastrado.</p>\n                </div>\n                <div class=\"geo-toggle\" *ngFor=\"let item of combustiveisList\" >\n                    <input type=\"checkbox\" id=\"check_combustivel_{{item.id}}\" (click)=\"clickCheckCombustiveis(item)\" >\n                    <label attr.for=\"check_combustivel_{{item.id}}\">{{item.combustivel}}</label>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--12c\">\n                <div class=\"geo-input--12c\">\n                    <label for=\"descricao\">Descrição</label>\n                    <div>\n                        <textarea id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\"></textarea>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados do GPS</h2>\n        <autocomplete-component class=\"geo-input--3c\" id=\"modeloGps\"\n                                (setObejct)=\"getModeloGpsObject($event)\"\n                                (clearObject)=\"getModeloGpsObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"modeloGpsSelectId\"\n                                [model]=\"modeloGpsObject\"\n                                [_service]=\"_modeloGpsApiService\"\n                                [query]=\"modeloGpsQuery\"\n                                [templateResult]=\"modeloGpsTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [clear]=\"true\"\n                                [label]=\"'Modelo'\"></autocomplete-component>\n\n        <div class=\"geo-input--3c\">\n            <label for=\"gpsImei\">IMEI</label>\n            <div>\n                <input type=\"text\"  id=\"gpsImei\" [(ngModel)]=\"formObject.gpsImei\" formControlName=\"gpsImei\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !gpsTelefone.valid && submitted}\">\n            <label for=\"gpsTelefone\">Telefone</label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!gpsTelefone.valid && submitted\">Número de telefone inválido.</span>\n                <input type=\"text\" id=\"gpsTelefone\" [(ngModel)]=\"formObject.gpsTelefone\" maxlength=\"15\" appPhoneMask formControlName=\"gpsTelefone\" >\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !velocidadeMaximaPermitida.valid && submitted}\">\n            <label for=\"velocidadeMaximaPermitida\">Velocidade máxima (km)</label>\n            <div>\n                <input type=\"text\" id=\"velocidadeMaximaPermitida\" [(ngModel)]=\"formObject.velocidadeMaximaPermitida\" maxlength=\"3\" appNumberInteger formControlName=\"velocidadeMaximaPermitida\" >\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\" *ngIf=\"thisRoute === veiculosRoute\">\n        <h2>Dados para despacho</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\">\n                <label for=\"mesLicenciamento\">Mês de licenciamento</label>\n                <div class=\"containerSpinner\">\n                    <spinner-component *ngIf=\"loadingMesLicenciamento\"></spinner-component>\n                    <select id=\"mesLicenciamento\" [(ngModel)]=\"formObject.mesLicenciamento\" formControlName=\"mesLicenciamento\" class=\"option_{{formObject.mesLicenciamento.Key}}\">\n                        <option *ngFor=\"let item of monthsList\" [ngValue]=\"item\">{{item.Value}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"mesSeguroObrigatorio\">Mês do seguro obrigatório</label>\n                <div>\n                    <select id=\"mesSeguroObrigatorio\" [(ngModel)]=\"formObject.mesSeguroObrigatorio\" formControlName=\"mesSeguroObrigatorio\" class=\"option_{{formObject.mesSeguroObrigatorio.Key}}\">\n                        <option *ngFor=\"let item of monthsList\" [ngValue]=\"item\">{{item.Value}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"mesIPVA\">Vencimento do IPVA</label>\n                <div>\n                    <select id=\"mesIPVA\" [(ngModel)]=\"formObject.mesIPVA\" formControlName=\"mesIPVA\" class=\"option_{{formObject.mesIPVA.Key}}\">\n                        <option *ngFor=\"let item of monthsList\" [ngValue]=\"item\">{{item.Value}}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 390 */
/***/ function(module, exports) {

	module.exports = ".mb16 {\n    margin-bottom: 16px;\n}\n.mb8 {\n    margin-bottom: 8px;\n}\n.text-uppercase {\n    text-transform: uppercase;\n}\n.terceiro {\n    position: relative;\n    top: 16px;\n}\n.input-hint {\n    font-size: 12px;\n}\n\n.containerSpinner {\n    position: relative;\n}\nspinner-component {\n    position: absolute;\n    top: -5px;\n    right: 12px;\n}\n"

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var frota_service_1 = __webpack_require__(203);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_api_service_1 = __webpack_require__(368);
	var data_service_1 = __webpack_require__(154);
	var FrotaDetailComponent = (function () {
	    function FrotaDetailComponent(_frotaService, _frotaNavigationService, _frotaApiService, _route) {
	        this._frotaService = _frotaService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaApiService = _frotaApiService;
	        this._route = _route;
	        this.frotasModule = {};
	        this.thisRoute = '';
	        this.detail = {};
	        this.loading = true;
	        this.aeronavesRoute = data_service_1.aeronavesRoute;
	        this.embarcacoesRoute = data_service_1.embarcacoesRoute;
	        this.equipamentosRoute = data_service_1.equipamentosRoute;
	        this.maquinarioRoute = data_service_1.maquinarioRoute;
	        this.outrosRoute = data_service_1.outrosRoute;
	        this.veiculosRoute = data_service_1.veiculosRoute;
	    }
	    FrotaDetailComponent.prototype.ngOnInit = function () {
	        this.frotasModule = this._frotaService.getModuleName();
	        this.thisRoute = this._frotaService.getRouteName();
	        this.moduleId = this._frotaService.getModuleId();
	        var id = +this._route.snapshot.params['id'];
	        this.getObject(id);
	    };
	    FrotaDetailComponent.prototype.clickGoToList = function () {
	        this._frotaNavigationService.goToList(this.thisRoute);
	    };
	    FrotaDetailComponent.prototype.clickGoToForm = function () {
	        this._frotaService.setBackStorage(this.detail);
	        this._frotaNavigationService.goToEdit(this.detail.id, this.thisRoute);
	    };
	    FrotaDetailComponent.prototype.clickGoToAbastecimentos = function () {
	        this._frotaService.setBackStorage(this.detail);
	        this._frotaNavigationService.goToFrotaAbastecimento(this.thisRoute);
	    };
	    FrotaDetailComponent.prototype.clickGoToDeslocamentos = function () {
	        this._frotaService.setBackStorage(this.detail);
	        this._frotaNavigationService.goToFrotaDeslocamento(this.thisRoute);
	    };
	    FrotaDetailComponent.prototype.clickGoToManutencao = function () {
	        this._frotaService.setBackStorage(this.detail);
	        this._frotaNavigationService.goToFrotaManutencao(this.thisRoute);
	    };
	    FrotaDetailComponent.prototype.clickGoToPlanoManutencao = function () {
	        this._frotaService.setBackStorage(this.detail);
	        this._frotaNavigationService.goToFrotaPlanoManutencao(this.thisRoute);
	    };
	    FrotaDetailComponent.prototype.clickGoToPhotos = function () {
	        this._frotaService.setBackStorage(this.detail);
	        this._frotaNavigationService.goToFrotaImagem(this.detail.id, this.thisRoute);
	    };
	    FrotaDetailComponent.prototype.clickGoToOdometroHorimetro = function () {
	        this._frotaService.setBackStorage(this.detail);
	        this._frotaNavigationService.goToFrotaOdometroHorimetro(this.detail.id, this.thisRoute);
	    };
	    FrotaDetailComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var storage = this._frotaService.getSessionStorage();
	                if (storage) {
	                    Response.Combustiveis = storage.Combustiveis;
	                }
	                this.detail = Response;
	                this.loading = false;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum ' + this.frotasModule.single + ' encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._frotaApiService.onGetById(id, onDone);
	    };
	    FrotaDetailComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(392),
	            styles: [__webpack_require__(393)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _a) || Object, (typeof (_b = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object])
	    ], FrotaDetailComponent);
	    return FrotaDetailComponent;
	    var _a, _b, _c, _d;
	}());
	exports.FrotaDetailComponent = FrotaDetailComponent;


/***/ },
/* 392 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{detail.identificacao}}</a></li>\n        </ul>\n        <h1>{{detail.identificacao}}</h1>\n        <div *ngIf=\"!loading\">\n            <p>\n                <strong>Modelo: </strong>\n                <span *ngIf=\"detail.modelo\">{{detail.modelo.modelo}}\n                <span *ngIf=\"detail.modelo.marca\"> / {{detail.modelo.marca.marca}}</span>\n                <span *ngIf=\"detail.modelo.tipo\"> / {{detail.modelo.tipo.tipo}}</span>\n            </span>\n                <i *ngIf=\"!detail.modelo\">não cadastrado</i>\n            </p>\n            <p *ngIf=\"thisRoute === veiculosRoute\">\n                <strong>Placa: </strong>\n                <span *ngIf=\"detail.placa\">{{detail.placa | licensePlateMask}}</span>\n                <i *ngIf=\"!detail.placa\">não cadastrado</i>\n            </p>\n            <p *ngIf=\"thisRoute === equipamentosRoute\">\n                <strong>Registro: </strong>\n                <span *ngIf=\"detail.codigo\">{{detail.codigo}}</span>\n                <i *ngIf=\"!detail.codigo\">não cadastrado</i>\n            </p>\n            <p *ngIf=\"thisRoute !== veiculosRoute && thisRoute !== equipamentosRoute\">\n                <strong>Cód. do patrimônio: </strong>\n                <span *ngIf=\"detail.codigoPatrimonio\">{{detail.codigoPatrimonio}}</span>\n                <i *ngIf=\"!detail.codigoPatrimonio\">não cadastrado</i>\n            </p>\n        </div>\n    </div>\n</div>\n\n<div class=\"geo-content__row\" *ngIf=\"loading\">\n    <spinner-component [showDisplay]=\"true\" ></spinner-component>\n</div>\n\n<div class=\"geo-content__row\" *ngIf=\"detail.id\">\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickGoToForm()\">\n        <div class=\"geo-card__title\">\n            <a>Cadastro</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Dados cadastrados\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickGoToPhotos()\">\n        <div class=\"geo-card__title\">\n            <a>Fotos</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Fotos\n            <span *ngIf=\"thisRoute === aeronavesRoute || thisRoute === embarcacoesRoute\">da</span>\n            <span *ngIf=\"thisRoute !== aeronavesRoute && thisRoute !== embarcacoesRoute\">do</span>\n            {{frotasModule.single | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickGoToAbastecimentos()\">\n        <div class=\"geo-card__title\">\n            <a>Abastecimentos</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Registro de abastecimentos realizados\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" *ngIf=\"thisRoute === veiculosRoute\" (click)=\"clickGoToDeslocamentos()\">\n        <div class=\"geo-card__title\">\n            <a>Deslocamentos</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Informações sobre deslocamentos e viagens\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickGoToManutencao()\">\n        <div class=\"geo-card__title\">\n            <a>Manutenções</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Histórico de manutenções e afins\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickGoToPlanoManutencao()\">\n        <div class=\"geo-card__title\">\n            <a>Plano de manutenção base</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Serviços necessários para a manutenção\n            <span *ngIf=\"thisRoute === aeronavesRoute || thisRoute === embarcacoesRoute\">da</span>\n            <span *ngIf=\"thisRoute !== aeronavesRoute && thisRoute !== embarcacoesRoute\">do</span>\n            {{frotasModule.single | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickGoToOdometroHorimetro()\">\n        <div class=\"geo-card__title\">\n            <a>Odômetros/horímetros</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Histórico de odômetros/horímetros\n        </div>\n    </div>\n</div>";

/***/ },
/* 393 */
/***/ function(module, exports) {

	module.exports = ".geo-card__content span {\n    color: inherit;\n}"

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var abastecimento_bem_api_service_1 = __webpack_require__(395);
	var abastecimento_bem_service_1 = __webpack_require__(396);
	var abastecimento_bem_navigation_service_1 = __webpack_require__(397);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(199);
	var autocomplete_service_1 = __webpack_require__(101);
	var local_service_1 = __webpack_require__(399);
	var combustivel_api_service_1 = __webpack_require__(376);
	var area_api_service_1 = __webpack_require__(275);
	var motorista_api_service_1 = __webpack_require__(209);
	var local_api_service_1 = __webpack_require__(407);
	var frota_service_1 = __webpack_require__(203);
	var frota_api_service_1 = __webpack_require__(368);
	var data_service_2 = __webpack_require__(154);
	var bomba_api_service_1 = __webpack_require__(408);
	var frota_navigation_service_1 = __webpack_require__(198);
	var router_1 = __webpack_require__(62);
	var forma_controle_service_1 = __webpack_require__(369);
	var AbastecimentoBemListComponent = (function () {
	    function AbastecimentoBemListComponent(_abastecimentoBemApiService, _abastecimentoBemService, _abastecimentoBemNavigationService, _autocompleteService, _localApiService, _localService, _bombaApiService, _combustivelApiService, _areaApiService, _motoristaApiService, _frotaService, _frotaApiService, _utilService, _frotasService, _frotaNavigationService, _formaControleService, _router) {
	        this._abastecimentoBemApiService = _abastecimentoBemApiService;
	        this._abastecimentoBemService = _abastecimentoBemService;
	        this._abastecimentoBemNavigationService = _abastecimentoBemNavigationService;
	        this._autocompleteService = _autocompleteService;
	        this._localApiService = _localApiService;
	        this._localService = _localService;
	        this._bombaApiService = _bombaApiService;
	        this._combustivelApiService = _combustivelApiService;
	        this._areaApiService = _areaApiService;
	        this._motoristaApiService = _motoristaApiService;
	        this._frotaService = _frotaService;
	        this._frotaApiService = _frotaApiService;
	        this._utilService = _utilService;
	        this._frotasService = _frotasService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._formaControleService = _formaControleService;
	        this._router = _router;
	        this.list = [];
	        this.loading = false;
	        this.showDisabled = false;
	        this.showAdvancedSearch = false;
	        this.researched = false;
	        this.abastecimentoBensModuleName = data_service_1.abastecimentoBensModuleName;
	        this.search = {};
	        this.showFrotaLink = false;
	        this.frotaDetailHistory = {};
	        this.frotasModule = {};
	        this.locaisList = [];
	        this.bombasList = [];
	        this.combustiveisList = [];
	        this.areasList = [];
	        this.motoristasList = [];
	        this.frotaSelectId = 'frota';
	        this.frotaQuery = data_service_2.frotasQuery;
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDoneSearch = (function (Response) {
	            if (!Response.error) {
	                this.list = [];
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].local) {
	                        if (Response[x].local.tipo) {
	                            Response[x].local.tipo = this._localService.getTipoLocal(Response[x].local.tipo);
	                        }
	                    }
	                    Response[x].formatDate = this._utilService.convertDateToString(Response[x].data);
	                    list.push(Response[x]);
	                }
	                this.list = list;
	                this.researched = true;
	            }
	            this.loading = false;
	        }.bind(this));
	    }
	    AbastecimentoBemListComponent.prototype.ngOnInit = function () {
	        var tipo = this._abastecimentoBemService.getTipoExterno();
	        this.tipoAbastecimentoExterno = tipo.Key;
	        tipo = this._abastecimentoBemService.getTipoInterno();
	        this.tipoAbastecimentoInterno = tipo.Key;
	        tipo = this._abastecimentoBemService.getTipoConvenio();
	        this.tipoAbastecimentoConvenio = tipo.Key;
	        this.getLocais();
	        this.getBombas();
	        this.getCombustiveis();
	        this.getAreas();
	        this.getMotoristas();
	        this.search.local = null;
	        this.search.combustivel = null;
	        this.search.motorista = null;
	        this.search.area = null;
	        this.search.bem = 0;
	        this.search.bomba = null;
	        var datePicker = $('.input-datepicker');
	        var t = this;
	        datePicker.datepicker({
	            onSelect: function (e) {
	                t.changeSearch();
	            }
	        });
	        this.testFrotaBackHistory();
	    };
	    AbastecimentoBemListComponent.prototype.clickNew = function () {
	        this._abastecimentoBemService.clearSessionStorage();
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaAbastecimentoNew(this.frotaRoute);
	        }
	        else {
	            this._abastecimentoBemNavigationService.goToNew();
	        }
	    };
	    AbastecimentoBemListComponent.prototype.clickEdit = function (item) {
	        this._abastecimentoBemService.clearSessionStorage();
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaAbastecimentoEdit(this.frotaRoute, item.id);
	        }
	        else {
	            this._abastecimentoBemNavigationService.goToEdit(item.id);
	        }
	    };
	    AbastecimentoBemListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    AbastecimentoBemListComponent.prototype.clickGoToFrotaDetail = function () {
	        this._frotasService.clearBackStorage();
	        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
	    };
	    AbastecimentoBemListComponent.prototype.clickGoToFrotaList = function () {
	        this._frotasService.clearBackStorage();
	        this._frotaNavigationService.goToList(this.frotaRoute);
	    };
	    AbastecimentoBemListComponent.prototype.clickToggleAdvancedSearch = function () {
	        $("#buscaAvancada").toggle("slow");
	        this.showAdvancedSearch = !this.showAdvancedSearch;
	    };
	    AbastecimentoBemListComponent.prototype.changeSearch = function () {
	        this.list = [];
	        this.querySearch();
	    };
	    AbastecimentoBemListComponent.prototype.clickClearSearch = function () {
	        this.search.local = null;
	        this.search.combustivel = null;
	        this.search.motorista = null;
	        this.search.area = null;
	        this.search.bem = 0;
	        this.search.bomba = null;
	        this.search.data_inicial = null;
	        this.search.data_final = null;
	        var date;
	        date = document.getElementById('data_inicial');
	        date.value = null;
	        date = document.getElementById('data_final');
	        date.value = null;
	        this._autocompleteService.setValueOnSelect2(null, "frota");
	    };
	    AbastecimentoBemListComponent.prototype.getFrotasObject = function (object) {
	        if (object.id) {
	            this.search.bem = object.id;
	        }
	        else {
	            this.search.bem = 0;
	        }
	        this.changeSearch();
	    };
	    AbastecimentoBemListComponent.prototype.querySearch = function () {
	        var dateStart;
	        var dateEnd;
	        var Query = [];
	        if (this.search.local) {
	            Query.push({
	                localId: this.search.local
	            });
	        }
	        if (this.search.bomba) {
	            Query.push({
	                bombaId: this.search.bomba
	            });
	        }
	        if (this.search.combustivel) {
	            Query.push({
	                combustivelId: this.search.combustivel
	            });
	        }
	        if (this.search.area) {
	            Query.push({
	                areaId: this.search.area
	            });
	        }
	        if (this.search.motorista) {
	            Query.push({
	                motoristaId: this.search.motorista
	            });
	        }
	        if (this.search.bem) {
	            Query.push({
	                bemId: this.search.bem
	            });
	        }
	        dateStart = document.getElementById('data_inicial');
	        if (dateStart.value) {
	            dateStart = this._utilService.convertStringToDate(dateStart.value);
	        }
	        dateEnd = document.getElementById('data_final');
	        if (dateEnd.value) {
	            dateEnd = this._utilService.convertStringToDate(dateEnd.value);
	        }
	        if (dateStart instanceof Date) {
	            Query.push({ data: { 'gte': dateStart } });
	        }
	        if (dateEnd instanceof Date) {
	            Query.push({ data: { 'lte': dateEnd } });
	        }
	        if (Query.length) {
	            this.loading = true;
	            Query = { and: Query };
	            this._abastecimentoBemApiService.onGetQuery(Query, this.onDoneSearch);
	        }
	        //envio: - dataInicial - dataFinal - bemId - localId - combustivelId - areaId - tanqueId - motoristaId - bombaId - orgaoId - tipoLancamento
	        //ex. {"tanqueId": 1, "and":[{"data":{"gte":"2017-01-23T13:09:44.377Z"}}, {"data": {"lte":"2018-01-23T13:09:44.377Z"}}, {"bemId": 3}]}
	    };
	    AbastecimentoBemListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._abastecimentoBemApiService.onDelete(item.id, onDone);
	    };
	    AbastecimentoBemListComponent.prototype.getLocais = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        Response[x].tipo = this._localService.getTipoLocal(Response[x].tipo);
	                        list.push(Response[x]);
	                    }
	                }
	                this.locaisList = list;
	            }
	        }.bind(this));
	        this._localApiService.onGetAll(onDone);
	    };
	    AbastecimentoBemListComponent.prototype.getBombas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.bombasList = list;
	            }
	        }.bind(this));
	        this._bombaApiService.onGetAll(onDone);
	    };
	    AbastecimentoBemListComponent.prototype.getCombustiveis = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.combustiveisList = list;
	            }
	        }.bind(this));
	        this._combustivelApiService.onGetAll(onDone);
	    };
	    AbastecimentoBemListComponent.prototype.getAreas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.areasList = list;
	            }
	        }.bind(this));
	        this._areaApiService.onGetAll(onDone);
	    };
	    AbastecimentoBemListComponent.prototype.getMotoristas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.motoristasList = list;
	            }
	        }.bind(this));
	        this._motoristaApiService.onGetAll(onDone);
	    };
	    AbastecimentoBemListComponent.prototype.testFrotaBackHistory = function () {
	        var settings = this._frotaService.testBackHistory('frota');
	        this.frotaDetailHistory = settings.frotaDetailHistory;
	        this.frotasModule = settings.frotasModule;
	        this.frotaRoute = settings.frotaRoute;
	        this.showFrotaLink = settings.showFrotaLink;
	        if (this.showFrotaLink) {
	            this.search.bem = this.frotaDetailHistory.id;
	            this.changeSearch();
	        }
	    };
	    AbastecimentoBemListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(409),
	            styles: [__webpack_require__(410)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof abastecimento_bem_api_service_1.AbastecimentoBemApiService !== 'undefined' && abastecimento_bem_api_service_1.AbastecimentoBemApiService) === 'function' && _a) || Object, (typeof (_b = typeof abastecimento_bem_service_1.AbastecimentoBemService !== 'undefined' && abastecimento_bem_service_1.AbastecimentoBemService) === 'function' && _b) || Object, (typeof (_c = typeof abastecimento_bem_navigation_service_1.AbastecimentoBemNavigationService !== 'undefined' && abastecimento_bem_navigation_service_1.AbastecimentoBemNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _d) || Object, (typeof (_e = typeof local_api_service_1.LocalApiService !== 'undefined' && local_api_service_1.LocalApiService) === 'function' && _e) || Object, (typeof (_f = typeof local_service_1.LocalService !== 'undefined' && local_service_1.LocalService) === 'function' && _f) || Object, (typeof (_g = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _g) || Object, (typeof (_h = typeof combustivel_api_service_1.CombustivelApiService !== 'undefined' && combustivel_api_service_1.CombustivelApiService) === 'function' && _h) || Object, (typeof (_j = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _j) || Object, (typeof (_k = typeof motorista_api_service_1.MotoristaApiService !== 'undefined' && motorista_api_service_1.MotoristaApiService) === 'function' && _k) || Object, (typeof (_l = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _l) || Object, (typeof (_m = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _m) || Object, (typeof (_o = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _o) || Object, (typeof (_p = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _p) || Object, (typeof (_q = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _q) || Object, (typeof (_r = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _r) || Object, (typeof (_s = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _s) || Object])
	    ], AbastecimentoBemListComponent);
	    return AbastecimentoBemListComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
	}());
	exports.AbastecimentoBemListComponent = AbastecimentoBemListComponent;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(199);
	var rest_service_1 = __webpack_require__(26);
	var AbastecimentoBemApiService = (function () {
	    function AbastecimentoBemApiService(_restService) {
	        this._restService = _restService;
	    }
	    AbastecimentoBemApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    AbastecimentoBemApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    AbastecimentoBemApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    AbastecimentoBemApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "data", "include": ["combustivel", "area", "bem", "local", "odometroHorimetro", { "bomba": [{ "tanque": "combustivel" }] }, { "motorista": [{ "funcionario": "pessoa" }] }] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    AbastecimentoBemApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["combustivel", "area", "bem", "local", "odometroHorimetro", { "bomba": [{ "tanque": "combustivel" }] }, { "motorista": [{ "funcionario": "pessoa" }] }] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    AbastecimentoBemApiService.prototype.onGetQuery = function (query, done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', query, done); //busca abastecimentos
	    };
	    AbastecimentoBemApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    AbastecimentoBemApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], AbastecimentoBemApiService);
	    return AbastecimentoBemApiService;
	    var _a;
	}());
	exports.AbastecimentoBemApiService = AbastecimentoBemApiService;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(199);
	var util_service_1 = __webpack_require__(88);
	var AbastecimentoBemService = (function () {
	    function AbastecimentoBemService(_utilService) {
	        this._utilService = _utilService;
	    }
	    //session
	    AbastecimentoBemService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.abastecimentoBensStorage + '-new', object);
	    };
	    AbastecimentoBemService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.abastecimentoBensStorage + "-new");
	        return JSON.parse(item);
	    };
	    AbastecimentoBemService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.abastecimentoBensStorage + "-new");
	    };
	    AbastecimentoBemService.prototype.getTipoExterno = function () {
	        return this.getTipoAbastecimento(2);
	    };
	    AbastecimentoBemService.prototype.getTipoInterno = function () {
	        return this.getTipoAbastecimento(1);
	    };
	    AbastecimentoBemService.prototype.getTipoConvenio = function () {
	        return this.getTipoAbastecimento(3);
	    };
	    AbastecimentoBemService.prototype.getTipoAbastecimento = function (tipoKey) {
	        var tipos = this._utilService.cloneObject(data_service_1.TiposAbastecimentoBens), x, lenX, tipo;
	        for (x = 0, lenX = tipos.length; x < lenX; x++) {
	            if (tipos[x].Key === tipoKey) {
	                tipo = tipos[x];
	                break;
	            }
	        }
	        return tipo;
	    };
	    AbastecimentoBemService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _a) || Object])
	    ], AbastecimentoBemService);
	    return AbastecimentoBemService;
	    var _a;
	}());
	exports.AbastecimentoBemService = AbastecimentoBemService;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(398);
	var data_service_3 = __webpack_require__(199);
	var AbastecimentoBemNavigationService = (function () {
	    function AbastecimentoBemNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    AbastecimentoBemNavigationService.prototype.goToList = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.abastecimentoBensRoute;
	        this._authService.navigateTo(router);
	    };
	    AbastecimentoBemNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    AbastecimentoBemNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.abastecimentoBensRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    AbastecimentoBemNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], AbastecimentoBemNavigationService);
	    return AbastecimentoBemNavigationService;
	    var _a;
	}());
	exports.AbastecimentoBemNavigationService = AbastecimentoBemNavigationService;


/***/ },
/* 398 */
/***/ function(module, exports) {

	"use strict";
	exports.abastecimentosRoute = 'abastecimentos';
	exports.abastecimentosModuleName = { plural: 'Abastecimentos', single: 'Abastecimento' };


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(400);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(401);
	var bomba_service_1 = __webpack_require__(402);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var data_service_3 = __webpack_require__(404);
	var tanque_service_1 = __webpack_require__(405);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var util_service_1 = __webpack_require__(88);
	var LocalService = (function () {
	    function LocalService(_bombaService, _bombaNavigationService, _autocompleteService, _tanqueService, _tanqueNavigationService, _utilService) {
	        this._bombaService = _bombaService;
	        this._bombaNavigationService = _bombaNavigationService;
	        this._autocompleteService = _autocompleteService;
	        this._tanqueService = _tanqueService;
	        this._tanqueNavigationService = _tanqueNavigationService;
	        this._utilService = _utilService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text = '';
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        if (state.nome) {
	                            text = state.nome;
	                        }
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    LocalService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.locaisStorage + '-new', object);
	    };
	    LocalService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.locaisStorage + "-new");
	        return JSON.parse(item);
	    };
	    LocalService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.locaisStorage + "-new");
	    };
	    LocalService.prototype.setSessionStorageFatherModule = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.locaisStorage + '-father', object);
	    };
	    LocalService.prototype.getSessionStorageFatherModule = function () {
	        var item = sessionStorage.getItem(data_service_1.locaisStorage + "-father");
	        return JSON.parse(item);
	    };
	    LocalService.prototype.clearSessionStorageFatherModule = function () {
	        sessionStorage.removeItem(data_service_1.locaisStorage + "-father");
	    };
	    LocalService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_2.bombasStorage) {
	                otherFormObject = this._bombaService.getSessionStorage();
	                otherFormObject.local = Response;
	                this._bombaService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.tanquesStorage) {
	                otherFormObject = this._tanqueService.getSessionStorage();
	                otherFormObject.local = Response;
	                this._tanqueService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.locaisStorage);
	        if (otherForm === data_service_2.bombasStorage) {
	            otherFormObject = this._bombaService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._bombaNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._bombaNavigationService.goToNew();
	            }
	        }
	        else if (otherForm === data_service_3.tanquesStorage) {
	            otherFormObject = this._tanqueService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._tanqueNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._tanqueNavigationService.goToNew();
	            }
	        }
	    };
	    LocalService.prototype.getTipoLocal = function (tipo) {
	        var tipos = data_service_1.TiposLocais, x, lenX;
	        for (x = 0, lenX = tipos.length; x < lenX; x++) {
	            if (tipos[x].Key === tipo) {
	                tipo = tipos[x];
	                break;
	            }
	        }
	        return tipo;
	    };
	    LocalService.prototype.getTipoInterno = function () {
	        var tipos = this._utilService.cloneObject(data_service_1.TiposLocais), x, lenX, tipo;
	        for (x = 0, lenX = tipos.length; x < lenX; x++) {
	            if (tipos[x].Key === 1) {
	                tipo = tipos[x];
	                break;
	            }
	        }
	        return tipo;
	    };
	    LocalService.prototype.getTipoConvenio = function () {
	        var tipos = this._utilService.cloneObject(data_service_1.TiposLocais), x, lenX, tipo;
	        for (x = 0, lenX = tipos.length; x < lenX; x++) {
	            if (tipos[x].Key === 2) {
	                tipo = tipos[x];
	                break;
	            }
	        }
	        return tipo;
	    };
	    LocalService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof bomba_service_1.BombaService !== 'undefined' && bomba_service_1.BombaService) === 'function' && _a) || Object, (typeof (_b = typeof bomba_navigation_service_1.BombaNavigationService !== 'undefined' && bomba_navigation_service_1.BombaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object, (typeof (_d = typeof tanque_service_1.TanqueService !== 'undefined' && tanque_service_1.TanqueService) === 'function' && _d) || Object, (typeof (_e = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object])
	    ], LocalService);
	    return LocalService;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.LocalService = LocalService;


/***/ },
/* 400 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'locais-abastecimentos';
	exports.locaisRoute = 'locais';
	exports.locaisStorage = 'locais';
	exports.locaisModuleName = { plural: 'Locais', single: 'Local' };
	exports.locaisCombustiveisApiName = 'combustiveis-locais-abastecimentos';
	exports.TiposLocais = [
	    { Key: 2, Value: 'Convênio' },
	    { Key: 1, Value: 'Interno' }
	];
	exports.locaisQuery = {
	    "where": {
	        "ativo": true,
	        "nome": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "nome"
	};


/***/ },
/* 401 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'bombas';
	exports.bombasRoute = 'bombas';
	exports.bombasStorage = 'bombas';
	exports.bombasModuleName = { plural: 'Bombas', single: 'Bomba' };
	exports.bombaAuditoriaApiName = 'hidrometros';
	exports.bombasAuditoriaRoute = 'auditoria';
	exports.bombasAuditoriaModuleName = { plural: 'Auditorias', single: 'Auditoria' };


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(401);
	var BombaService = (function () {
	    function BombaService() {
	    }
	    //session
	    BombaService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.bombasStorage + '-new', object);
	    };
	    BombaService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.bombasStorage + "-new");
	        return JSON.parse(item);
	    };
	    BombaService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.bombasStorage + "-new");
	    };
	    BombaService.prototype.setSessionStorageFatherModule = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.bombasStorage + '-father', object);
	    };
	    BombaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], BombaService);
	    return BombaService;
	}());
	exports.BombaService = BombaService;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(401);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(398);
	var BombaNavigationService = (function () {
	    function BombaNavigationService(_authService) {
	        this._authService = _authService;
	        this.configuracaoRoute = data_service_2.configuracaoRoute;
	    }
	    BombaNavigationService.prototype.goToList = function () {
	        var router = data_service_3.abastecimentosRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.bombasRoute;
	        this._authService.navigateTo(router);
	    };
	    BombaNavigationService.prototype.goToNew = function () {
	        var router = data_service_3.abastecimentosRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.bombasRoute + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    BombaNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_3.abastecimentosRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.bombasRoute + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    BombaNavigationService.prototype.goToDetail = function (objectId) {
	        var router = data_service_3.abastecimentosRoute + '/' + data_service_1.bombasRoute + '/' + data_service_2.detailRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    //auditoria
	    BombaNavigationService.prototype.goToAuditoriaList = function () {
	        var router = data_service_3.abastecimentosRoute + '/' + data_service_1.bombasAuditoriaRoute;
	        this._authService.navigateTo(router);
	    };
	    BombaNavigationService.prototype.goToAuditoriaDetail = function (bombaId) {
	        var router = data_service_3.abastecimentosRoute + '/' + data_service_1.bombasAuditoriaRoute + '/' + data_service_2.detailRoute;
	        this._authService.navigateTo(router, bombaId);
	    };
	    BombaNavigationService.prototype.goToAuditar = function (bombaId) {
	        var router = data_service_3.abastecimentosRoute + '/' + data_service_1.bombasAuditoriaRoute + '/auditar';
	        this._authService.navigateTo(router, bombaId);
	    };
	    BombaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], BombaNavigationService);
	    return BombaNavigationService;
	    var _a;
	}());
	exports.BombaNavigationService = BombaNavigationService;


/***/ },
/* 404 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	exports.apiName = 'tanques';
	exports.tanquesRoute = 'tanques';
	exports.tanquesStorage = 'tanques';
	exports.tanquesModuleName = { plural: 'Tanques', single: 'Tanque' };
	exports.tanquesEstoqueRoute = 'estoque';
	exports.tanquesEstoqueModuleName = { plural: 'Estoques', single: 'Estoque' };
	exports.tanquesMovimentacaoApiName = 'movimentacoes-tanques';
	exports.tanquesMovimentacaoAreaApiName = 'areas-movimentacoes-tanques';
	exports.tanquesMovimentacaoRoute = 'movimentacao';
	exports.tanquesMovimentacaoModuleName = { plural: 'Movimentações', single: 'Movimentação' };
	exports.tanquesQuery = {
	    "where": {
	        "ativo": true,
	        "identificacao": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "identificacao",
	    "include": ["combustivel"]
	};
	exports.TiposMovimentacoesTanques = [
	    { Key: 1, Value: "Entrada" },
	    { Key: 2, Value: "Saída" },
	    { Key: 3, Value: "Estorno" },
	    { Key: 4, Value: "Ajuste" },
	    { Key: 5, Value: "Tranferência" }
	];


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(404);
	var autocomplete_service_1 = __webpack_require__(101);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var bomba_service_1 = __webpack_require__(402);
	var data_service_2 = __webpack_require__(401);
	var util_service_1 = __webpack_require__(88);
	var TanqueService = (function () {
	    function TanqueService(_autocompleteService, _bombaNavigationService, _bombaService, _utilService) {
	        this._autocompleteService = _autocompleteService;
	        this._bombaNavigationService = _bombaNavigationService;
	        this._bombaService = _bombaService;
	        this._utilService = _utilService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var combustivel = '';
	                        if (state.combustivel) {
	                            combustivel = state.combustivel.combustivel;
	                            combustivel = " (" + combustivel + ")";
	                            text = state.identificacao.concat(combustivel);
	                        }
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    TanqueService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.tanquesStorage + '-new', object);
	    };
	    TanqueService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.tanquesStorage + "-new");
	        return JSON.parse(item);
	    };
	    TanqueService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.tanquesStorage + "-new");
	    };
	    TanqueService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_2.bombasStorage) {
	                otherFormObject = this._bombaService.getSessionStorage();
	                otherFormObject.tanque = Response;
	                this._bombaService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.tanquesStorage);
	        if (otherForm === data_service_2.bombasStorage) {
	            otherFormObject = this._bombaService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._bombaNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._bombaNavigationService.goToNew();
	            }
	        }
	    };
	    TanqueService.prototype.getTipoMovimentacaoEntrada = function () {
	        return this.getTipoMovimentacao(1);
	    };
	    TanqueService.prototype.getTipoMovimentacaoSaida = function () {
	        return this.getTipoMovimentacao(2);
	    };
	    TanqueService.prototype.getTipoMovimentacaoEstorno = function () {
	        return this.getTipoMovimentacao(3);
	    };
	    TanqueService.prototype.getTipoMovimentacaoAjuste = function () {
	        return this.getTipoMovimentacao(4);
	    };
	    TanqueService.prototype.getTipoMovimentacaoTransferencia = function () {
	        return this.getTipoMovimentacao(5);
	    };
	    TanqueService.prototype.getTipoMovimentacao = function (tipoKey) {
	        var tipos = this._utilService.cloneObject(data_service_1.TiposMovimentacoesTanques), x, lenX, tipo;
	        for (x = 0, lenX = tipos.length; x < lenX; x++) {
	            if (tipos[x].Key === tipoKey) {
	                tipo = tipos[x];
	                break;
	            }
	        }
	        return tipo;
	    };
	    TanqueService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object, (typeof (_b = typeof bomba_navigation_service_1.BombaNavigationService !== 'undefined' && bomba_navigation_service_1.BombaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof bomba_service_1.BombaService !== 'undefined' && bomba_service_1.BombaService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], TanqueService);
	    return TanqueService;
	    var _a, _b, _c, _d;
	}());
	exports.TanqueService = TanqueService;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(398);
	var data_service_3 = __webpack_require__(404);
	var TanqueNavigationService = (function () {
	    function TanqueNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    TanqueNavigationService.prototype.goToList = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tanquesRoute;
	        this._authService.navigateTo(router);
	    };
	    TanqueNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tanquesRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    TanqueNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tanquesRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    TanqueNavigationService.prototype.goToEstoque = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tanquesRoute + '/' + data_service_3.tanquesEstoqueRoute;
	        this._authService.navigateTo(router);
	    };
	    TanqueNavigationService.prototype.goToMovimentacaoDetail = function (tanqueId) {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tanquesRoute + '/' + data_service_3.tanquesMovimentacaoRoute + '/' + data_service_1.detailRoute;
	        this._authService.navigateTo(router, tanqueId);
	    };
	    TanqueNavigationService.prototype.goToMovimentacaoEdit = function (objectId) {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tanquesRoute + '/' + data_service_3.tanquesMovimentacaoRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    TanqueNavigationService.prototype.goToMovimentacaoNew = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tanquesRoute + '/' + data_service_3.tanquesMovimentacaoRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    TanqueNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], TanqueNavigationService);
	    return TanqueNavigationService;
	    var _a;
	}());
	exports.TanqueNavigationService = TanqueNavigationService;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(400);
	var rest_service_1 = __webpack_require__(26);
	var LocalApiService = (function () {
	    function LocalApiService(_restService) {
	        this._restService = _restService;
	    }
	    //local
	    LocalApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    LocalApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    LocalApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    LocalApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "nome" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    LocalApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["endereco"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    LocalApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //local-combustivel
	    LocalApiService.prototype.onPostLocalCombustivel = function (object, done) {
	        this._restService.onPost(data_service_1.locaisCombustiveisApiName, object, done);
	    };
	    LocalApiService.prototype.onPutLocalCombustivel = function (object, done) {
	        this._restService.onPut(data_service_1.locaisCombustiveisApiName, object, done);
	    };
	    LocalApiService.prototype.onDeleteLocalCombustivel = function (objectId, done) {
	        this._restService.onDelete(data_service_1.locaisCombustiveisApiName, objectId, done);
	    };
	    LocalApiService.prototype.onGetAllLocalCombustivel = function (done) {
	        var filter = { "include": ["combustivel"] };
	        this._restService.onGetPost(data_service_1.locaisCombustiveisApiName, filter, done);
	    };
	    LocalApiService.prototype.onGetLocalCombustivelByLocal = function (localId, done) {
	        var filter = { "include": ["combustivel"], "where": { "localId": localId } };
	        this._restService.onGetPost(data_service_1.locaisCombustiveisApiName, filter, done);
	    };
	    LocalApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], LocalApiService);
	    return LocalApiService;
	    var _a;
	}());
	exports.LocalApiService = LocalApiService;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(401);
	var rest_service_1 = __webpack_require__(26);
	var BombaApiService = (function () {
	    function BombaApiService(_restService) {
	        this._restService = _restService;
	    }
	    BombaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    BombaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    BombaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    BombaApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "nome", "include": [{ "tanque": ["combustivel"] }] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    BombaApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": [{ "tanque": ["combustivel"] }] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    BombaApiService.prototype.onGetByTanque = function (tanqueId, done) {
	        var filter = { "include": [{ "tanque": ["combustivel"] }], "where": { "tanqueId": tanqueId } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    BombaApiService.prototype.onGetMovimentacao = function (objectId, ano, mes, done) {
	        this._restService.onGet(data_service_1.apiName + '/relatorio/bomba/' + objectId + '/mes/' + mes + '/ano/' + ano, done);
	    };
	    BombaApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //auditoria
	    BombaApiService.prototype.onGetHidrometroByBomba = function (bombaId, done) {
	        var filter = { "where": { "bombaId": bombaId }, "order": "data DESC" };
	        this._restService.onGetPost(data_service_1.bombaAuditoriaApiName, filter, done);
	    };
	    BombaApiService.prototype.onPostHidrometro = function (object, done) {
	        this._restService.onPost(data_service_1.bombaAuditoriaApiName, object, done);
	    };
	    BombaApiService.prototype.onPutHidrometro = function (object, done) {
	        this._restService.onPut(data_service_1.bombaAuditoriaApiName, object, done);
	    };
	    BombaApiService.prototype.onDeleteHidrometro = function (objectId, done) {
	        this._restService.onDelete(data_service_1.bombaAuditoriaApiName, objectId, done);
	    };
	    BombaApiService.prototype.onPostAuditar = function (object, done) {
	        this._restService.onGetPostCustom('auditoria/bomba', object, done);
	        // {"bombaId": 1,"dataInicio": "2017-01-20T09:10:00.000Z","dataFim": "2018-12-01T09:10:00.000Z"}
	    };
	    BombaApiService.prototype.onGetHidrometroVirtual = function (bombaId, done) {
	        this._restService.onGet(data_service_1.bombaAuditoriaApiName + '/virtual/bomba/' + bombaId, done);
	    };
	    BombaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], BombaApiService);
	    return BombaApiService;
	    var _a;
	}());
	exports.BombaApiService = BombaApiService;


/***/ },
/* 409 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\" *ngIf=\"showFrotaLink\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a (click)=\"clickGoToFrotaList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n            <li class=\"item\"><a (click)=\"clickGoToFrotaDetail()\" class=\"cursor-pointer\">{{frotaDetailHistory.identificacao}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{abastecimentoBensModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{abastecimentoBensModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c geo-input--datepicker\">\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"data_inicial\" placeholder=\"Data inicial\" [(ngModel)]=\"search.dataInicial\" appDatepicker autocomplete=\"off\" (ngModelChange)=\"changeSearch()\"/>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c geo-input--datepicker\">\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"data_final\" placeholder=\"Data final\" [(ngModel)]=\"search.dataFinal\" appDatepicker autocomplete=\"off\" (ngModelChange)=\"changeSearch()\"/>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"frota\"\n                                (setObejct)=\"getFrotasObject($event)\"\n                                (clearObject)=\"getFrotasObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"search.bem\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'Frota / equipamento'\"\n                                [query]=\"frotaQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select [(ngModel)]=\"search.bomba\" id=\"bomba\" (ngModelChange)=\"changeSearch()\" class=\"option_{{search.bomba}}\">\n                    <option value=\"null\" selected=\"selected\" class=\"option_\">&mdash; Bomba &mdash;</option>\n                    <option *ngFor=\"let item of bombasList\" id=\"bomba_{{item.id}}\" value=\"{{item.id}}\">{{item.nome}} <span *ngIf=\"item.tanque && item.tanque.combustivel\">({{item.tanque.combustivel.combustivel}})</span></option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c\" id=\"buscaAvancada\" *ngIf=\"showAdvancedSearch\">\n        <div class=\"geo-content__row searchContainer\">\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <select [(ngModel)]=\"search.local\" id=\"local\" (ngModelChange)=\"changeSearch()\" class=\"option_{{search.local}}\">\n                            <option value=\"null\" selected=\"selected\" class=\"option_\">&mdash; Local &mdash;</option>\n                            <option *ngFor=\"let item of locaisList\" id=\"local_{{item.id}}\" value=\"{{item.id}}\">{{item.nome}} ({{item.tipo.Value}})</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <select [(ngModel)]=\"search.combustivel\" id=\"combustivel\" (ngModelChange)=\"changeSearch()\" class=\"option_{{search.combustivel}}\">\n                            <option value=\"null\" selected=\"selected\" class=\"option_\">&mdash; Combustível &mdash;</option>\n                            <option *ngFor=\"let item of combustiveisList\" id=\"combustivel_{{item.id}}\" value=\"{{item.id}}\">{{item.combustivel}}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <select [(ngModel)]=\"search.area\" id=\"area\" (ngModelChange)=\"changeSearch()\" class=\"option_{{search.area}}\">\n                            <option value=\"null\" selected=\"selected\" class=\"option_\">&mdash; Área &mdash;</option>\n                            <option *ngFor=\"let item of areasList\" id=\"area_{{item.id}}\" value=\"{{item.id}}\">{{item.nome}}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <select [(ngModel)]=\"search.motorista\" id=\"motorista\" (ngModelChange)=\"changeSearch()\" class=\"option_{{search.motorista}}\">\n                            <option value=\"null\" selected=\"selected\" class=\"option_\">&mdash; Motorista &mdash;</option>\n                            <option *ngFor=\"let item of motoristasList\" id=\"motorista_{{item.id}}\" value=\"{{item.id}}\"><span *ngIf=\"item.funcionario\"><span *ngIf=\"item.funcionario.pessoa\">{{item.funcionario.pessoa.nome}}</span></span></option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c geo-columns--right\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickClearSearch()\" class=\"cursor-pointer clear-search\">Limpar busca</a>\n            <a (click)=\"clickToggleAdvancedSearch()\" *ngIf=\"!showAdvancedSearch\" class=\"cursor-pointer\">Busca avançada</a>\n            <a (click)=\"clickToggleAdvancedSearch()\" *ngIf=\"showAdvancedSearch\" class=\"cursor-pointer\">Esconder busca avançada</a>\n        </p>\n    </div>\n\n    <div class=\"geo-columns--12c\">\n        <p class=\"lead padding\" *ngIf=\"!researched\">Realize a busca para visualizar os abastecimentos</p>\n    </div>\n\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading && researched\">Nenhum {{abastecimentoBensModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Data</th>\n            <th>Combustível</th>\n            <th>Litros</th>\n            <th>Frota / equipamento</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filterActive:showDisabled | sort:['data']:true)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.data  | date: 'dd/MM/yyyy'}}</td>\n            <td><span *ngIf=\"item.combustivel\">{{item.combustivel.combustivel}}</span></td>\n            <td>{{item.quantidade | literMask}}</td>\n            <td><span *ngIf=\"item.bem\">{{item.bem.identificacao}}</span> <span *ngIf=\"item.bem.placa\"> / {{item.bem.placa | licensePlateMask}}</span><span *ngIf=\"!item.bem\"> &mdash; </span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div class=\"geo-content__row\">\n                    <div class=\"geo-columns--6c\">\n                        <p><strong>Abastecimento de ajuste: </strong> <span *ngIf=\"item.ajuste\">Sim</span> <span *ngIf=\"!item.ajuste\">Não</span> </p>\n\n                        <p>\n                            <strong>Local: </strong>\n                            <span *ngIf=\"item.tipoLancamento === tipoAbastecimentoExterno\">Externo</span>\n                            <span *ngIf=\"item.tipoLancamento !== tipoAbastecimentoExterno\">\n                                <span *ngIf=\"item.local\">{{item.local.nome}} ({{item.local.tipo.Value}})</span>\n                            </span>\n                        </p>\n                        <p *ngIf=\"item.tipoLancamento === tipoAbastecimentoInterno\">\n                           <strong>Bomba: </strong>\n                            <span *ngIf=\"item.bomba\">{{item.bomba.nome}}</span>\n                        </p>\n                        <p *ngIf=\"!item.ajuste\"><strong>Placa / registro: </strong> <span *ngIf=\"item.bem && item.bem.placa\">{{item.bem.placa | licensePlateMask}}</span> <span *ngIf=\"item.bem\"> / {{item.bem.codigo}}</span> </p>\n                        <p *ngIf=\"!item.ajuste\"><strong>Motorista: </strong> <span *ngIf=\"item.motorista && item.motorista.funcionario && item.motorista.funcionario.pessoa\">{{item.motorista.funcionario.pessoa.nome}}</span> <i *ngIf=\"!item.motorista\">não cadastrado</i></p>\n                        <p><strong>Quantidade: </strong> <span>{{item.quantidade | literMask}} litros</span> <i *ngIf=\"!item.quantidade\">não cadastrado</i></p>\n                        <p *ngIf=\"!item.ajuste\"><strong>Preço por litro: </strong> <span>{{item.precoPorLitro | currencyMask}}</span> <i *ngIf=\"!item.precoPorLitro\">não cadastrado</i></p>\n                        <p *ngIf=\"!item.ajuste\"><strong>Total: </strong>{{item.precoTotal | currencyMask}} <i *ngIf=\"!item.precoTotal\">não cadastrado</i></p>\n                    </div>\n                    <div class=\"geo-columns--6c\">\n                        <p *ngIf=\"!item.ajuste\">\n                            <app-odometro-horimetro-label-component [labelHorimetro]=\"'Horímetro: '\"\n                                                                    [labelOdometro]=\"'Odômetro: '\"\n                                                                    [odometroHorimetroObject]=\"item.odometroHorimetro\"\n                                                                    [bemObject]=\"item.bem\"></app-odometro-horimetro-label-component>\n                        </p>\n                        <p *ngIf=\"item.tipoLancamento !== tipoAbastecimentoInterno && !item.ajuste\"><strong>Nota fiscal: </strong> {{item.notaFiscal}} <i *ngIf=\"!item.notaFiscal \">não cadastrado</i></p>\n                        <p *ngIf=\"item.tipoLancamento !== tipoAbastecimentoInterno && !item.ajuste\"><strong>Documento: </strong> {{item.documento}} <i *ngIf=\"!item.documento\">não cadastrado</i></p>\n                        <p *ngIf=\"item.tipoLancamento === tipoAbastecimentoConvenio && !item.ajuste\"><strong>Empenho: </strong> {{item.empenho }} <i *ngIf=\"!item.empenho  \">não cadastrado</i></p>\n                        <p><strong>Área: </strong> <span *ngIf=\"item.area\">{{item.area.nome}}</span> <i *ngIf=\"!item.area\">não cadastrado</i></p>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 410 */
/***/ function(module, exports) {

	module.exports = ".advanced-search {\n  border-bottom: 1px solid #edf0f4;\n  margin: -0.5em 1.5em 1em 0;\n  padding-bottom: 1em;\n}\n\n.advanced-search .clear-search {\n  margin-right: 32px;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.btnSearch {\n  width: 100%;\n}\n\n.searchContainer {\n  padding: 0;\n}\n"

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(62);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(199);
	var data_service_2 = __webpack_require__(154);
	var frota_model_1 = __webpack_require__(373);
	var frota_service_1 = __webpack_require__(203);
	var frota_api_service_1 = __webpack_require__(368);
	var area_model_1 = __webpack_require__(274);
	var combustivel_model_1 = __webpack_require__(412);
	var abastecimento_bem_service_1 = __webpack_require__(396);
	var abastecimento_bem_api_service_1 = __webpack_require__(395);
	var data_service_3 = __webpack_require__(190);
	var combustivel_api_service_1 = __webpack_require__(376);
	var area_api_service_1 = __webpack_require__(275);
	var motorista_api_service_1 = __webpack_require__(209);
	var motorista_model_1 = __webpack_require__(213);
	var motorista_service_1 = __webpack_require__(188);
	var isNumeric_1 = __webpack_require__(413);
	var local_model_1 = __webpack_require__(414);
	var local_api_service_1 = __webpack_require__(407);
	var local_service_1 = __webpack_require__(399);
	var data_service_4 = __webpack_require__(178);
	var abastecimento_bem_navigation_service_1 = __webpack_require__(397);
	var abastecimento_bem_model_1 = __webpack_require__(415);
	var bem_combustivel_api_service_1 = __webpack_require__(379);
	var data_service_5 = __webpack_require__(146);
	var number_validation_1 = __webpack_require__(132);
	var tanque_api_service_1 = __webpack_require__(416);
	var bomba_api_service_1 = __webpack_require__(408);
	var bomba_model_1 = __webpack_require__(417);
	var autocomplete_service_1 = __webpack_require__(101);
	var forma_controle_service_1 = __webpack_require__(369);
	var frota_navigation_service_1 = __webpack_require__(198);
	var AbastecimentoBemFormComponent = (function () {
	    function AbastecimentoBemFormComponent(_route, _frotaService, _frotaApiService, _abastecimentoBemService, _abastecimentoBemApiService, _abastecimentoBemNavigationService, _areaApiService, _combustivelApiService, _bemCombustivelApiService, _motoristaApiService, _motoristaService, _localApiService, _localService, _tanqueApiService, _bombaApiService, _frotaNavigationService, _autocompleteService, _formaControleService, _utilService, _fb, _cdRef) {
	        this._route = _route;
	        this._frotaService = _frotaService;
	        this._frotaApiService = _frotaApiService;
	        this._abastecimentoBemService = _abastecimentoBemService;
	        this._abastecimentoBemApiService = _abastecimentoBemApiService;
	        this._abastecimentoBemNavigationService = _abastecimentoBemNavigationService;
	        this._areaApiService = _areaApiService;
	        this._combustivelApiService = _combustivelApiService;
	        this._bemCombustivelApiService = _bemCombustivelApiService;
	        this._motoristaApiService = _motoristaApiService;
	        this._motoristaService = _motoristaService;
	        this._localApiService = _localApiService;
	        this._localService = _localService;
	        this._tanqueApiService = _tanqueApiService;
	        this._bombaApiService = _bombaApiService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._autocompleteService = _autocompleteService;
	        this._formaControleService = _formaControleService;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this._cdRef = _cdRef;
	        this.abastecimentoBensModule = data_service_1.abastecimentoBensModuleName;
	        this.formObject = new abastecimento_bem_model_1.AbastecimentoBem();
	        this.frotaObject = new frota_model_1.Frota();
	        this.motoristaObject = new motorista_model_1.Motorista();
	        this.areaObject = new area_model_1.Area();
	        this.combustivelObject = new combustivel_model_1.Combustivel();
	        this.odometroHorimetroObject = {};
	        this.localObject = new local_model_1.Local();
	        this.bombaObject = new bomba_model_1.Bomba();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.loadingSpinnerCombustiveis = false;
	        this.loadingSpinnerLocais = false;
	        this.loadingSpinnerBombas = false;
	        this.showFrotaLink = false;
	        this.frotaDetailHistory = {};
	        this.frotasModule = {};
	        this.frotaQuery = {};
	        this.frotaSelectId = 'frotaSelect';
	        this.motoristaQuery = {};
	        this.motoristaSelectId = 'motoristaSelect';
	        this.areaQuery = {};
	        this.areaSelectId = 'areaSelect';
	        this.combustiveisList = [];
	        this.locaisList = [];
	        this.bombasList = [];
	        this.ativo = new forms_1.FormControl('');
	        this.data = new forms_1.FormControl('', forms_1.Validators.required);
	        this.quantidade = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, number_validation_1.NumberValidator.numberFormat]));
	        this.precoPorLitro = new forms_1.FormControl('', forms_1.Validators.required);
	        this.precoTotal = new forms_1.FormControl({ value: '', disabled: true }, forms_1.Validators.required);
	        this.tipoLancamento = new forms_1.FormControl('');
	        this.notaFiscal = new forms_1.FormControl('', forms_1.Validators.required);
	        this.documento = new forms_1.FormControl('');
	        this.empenho = new forms_1.FormControl('');
	        this.bemText = new forms_1.FormControl({ value: '', disabled: true });
	        this.combustivelText = new forms_1.FormControl({ value: '', disabled: true });
	        this.bem = new forms_1.FormControl('', forms_1.Validators.required);
	        this.bomba = new forms_1.FormControl('', forms_1.Validators.required);
	        this.combustivel = new forms_1.FormControl({ value: '', disabled: true }, forms_1.Validators.required);
	        this.area = new forms_1.FormControl('', forms_1.Validators.required);
	        this.motorista = new forms_1.FormControl('', forms_1.Validators.required);
	        this.local = new forms_1.FormControl('', forms_1.Validators.required);
	        this.ajuste = new forms_1.FormControl('');
	        this.combustiveisListClone = [];
	        this.locaisListClone = [];
	        this.bombasListClone = [];
	        this.tanquesList = [];
	        this.isEdition = false;
	        this.firstPrice = false;
	        this.precoCombustiveisLocalInterno = [];
	        this.showTipoOdometro = true;
	        this.frotaTemplateResult = (function (state) {
	            return this._frotaService.templateResult(state, false);
	        }.bind(this));
	        this.motoristaTemplateResult = (function (state) {
	            return this._motoristaService.templateResult(state, false);
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toGetOutOfHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            data: this.data,
	            quantidade: this.quantidade,
	            precoPorLitro: this.precoPorLitro,
	            precoTotal: this.precoTotal,
	            tipoLancamento: this.tipoLancamento,
	            notaFiscal: this.notaFiscal,
	            documento: this.documento,
	            empenho: this.empenho,
	            bemText: this.bemText,
	            combustivelText: this.combustivelText,
	            bem: this.bem,
	            bomba: this.bomba,
	            combustivel: this.combustivel,
	            area: this.area,
	            motorista: this.motorista,
	            local: this.local,
	            ajuste: this.ajuste
	        });
	    }
	    AbastecimentoBemFormComponent.prototype.ngOnInit = function () {
	        this.frotaQuery = this._utilService.cloneObject(data_service_2.frotasQueryComCombustivel);
	        this.motoristaQuery = this._utilService.cloneObject(data_service_5.motoristasQuery);
	        this.areaQuery = this._utilService.cloneObject(data_service_3.areasQuery);
	        var tipo = this._abastecimentoBemService.getTipoExterno();
	        this.tipoAbastecimentoExterno = tipo.Key;
	        tipo = this._abastecimentoBemService.getTipoInterno();
	        this.tipoAbastecimentoInterno = tipo.Key;
	        tipo = this._abastecimentoBemService.getTipoConvenio();
	        this.tipoAbastecimentoConvenio = tipo.Key;
	        this._utilService.disabledFutureDates('data');
	        this.getCombustiveis();
	        this.getLocais();
	        this.testNew();
	        this.testFrotaBackHistory();
	    };
	    AbastecimentoBemFormComponent.prototype.ngAfterViewChecked = function () {
	        this._cdRef.detectChanges();
	    };
	    AbastecimentoBemFormComponent.prototype.clickGoToList = function () {
	        this.toGetOutOfHere();
	    };
	    AbastecimentoBemFormComponent.prototype.clickCancel = function () {
	        this.toGetOutOfHere();
	    };
	    AbastecimentoBemFormComponent.prototype.clickGoToFrotaDetail = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
	    };
	    AbastecimentoBemFormComponent.prototype.clickGoToFrotaList = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToList(this.frotaRoute);
	    };
	    AbastecimentoBemFormComponent.prototype.keyupQuantidade = function () {
	        this.calculate();
	    };
	    AbastecimentoBemFormComponent.prototype.keyupCurrency = function () {
	        this.setPriceByLiter(this.formObject.precoPorLitro);
	    };
	    AbastecimentoBemFormComponent.prototype.changeLocal = function () {
	        if (this.localObject) {
	            if (this.localObject.tipo) {
	                this.setTipoLancamento();
	            }
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.changeBomba = function () {
	        if (this.bombaObject) {
	            if (this.bombaObject.tanque) {
	                if (this.firstPrice) {
	                    this.firstPrice = false;
	                }
	                else {
	                    this.precoCombustivelLocalInterno();
	                }
	                if (this.bombaObject.tanque.combustivel) {
	                    this.combustivelTextValue = this.bombaObject.tanque.combustivel.combustivel;
	                }
	            }
	        }
	        if (this.formObject.precoPorLitro) {
	            this.setPriceByLiter(this.formObject.precoPorLitro);
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.changeCombustivel = function () {
	        if (this.firstPrice) {
	            this.firstPrice = false;
	            this.setPriceByLiter(this.formObjectClone.precoPorLitro);
	            return false;
	        }
	        if (this.combustivelObject) {
	            if (this.combustivelObject.preco) {
	                this.setPriceByLiter(this.combustivelObject.preco);
	            }
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.changeAjuste = function () {
	        if (this.formObject.ajuste) {
	            this.showOnlyLocalInterno();
	        }
	        else {
	            this.locaisList = this._utilService.cloneObject(this.locaisListClone);
	            this.setFirstLocal();
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.getFrotaObject = function (object) {
	        this.frotaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'bem', object);
	        this.frotaCombustiveis = object.Combustiveis;
	        this.setCombustiveisBemText();
	        this.setTipoLancamento();
	        this.changeFormaControle();
	    };
	    AbastecimentoBemFormComponent.prototype.getMotoristaObject = function (object) {
	        this.motoristaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'motorista', object);
	    };
	    AbastecimentoBemFormComponent.prototype.getAreaObject = function (object) {
	        this.areaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'area', object);
	    };
	    AbastecimentoBemFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
	            this._utilService.setSelectOnFormControl(this.form, 'bomba', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', "x");
	        }
	        else if (this.formObject.tipoLancamento === this.tipoAbastecimentoConvenio) {
	            this._utilService.setSelectOnFormControl(this.form, 'bomba', { id: -1 });
	        }
	        else if (this.formObject.tipoLancamento === this.tipoAbastecimentoInterno) {
	            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', "x");
	        }
	        if (this.formObject.ajuste) {
	            this._utilService.setSelectOnFormControl(this.form, 'precoPorLitro', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'precoTotal', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'bem', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'motorista', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', "x");
	        }
	        var date = document.getElementById('data');
	        if (date.value) {
	            this._utilService.setSelectOnFormControl(this.form, 'data', date, 'value');
	        }
	        if (!this.formObject.odometroHorimetroValue) {
	            return false;
	        }
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.ajuste) {
	                delete object['precoTotal'];
	                delete object['odometroHorimetro'];
	                delete object['precoPorLitro'];
	            }
	            else {
	                if (this.frotaObject && this.frotaObject.id) {
	                    object.bemId = this.frotaObject.id;
	                    object.odometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.odometroHorimetroValue);
	                    delete object['odometroHorimetroValue'];
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                if (this.motoristaObject && this.motoristaObject.id) {
	                    object.motoristaId = this.motoristaObject.id;
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                if (object.quantidade == 0 || object.precoPorLitro == 0 || object.precoTotal == 0) {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                if (object.precoPorLitro) {
	                    object.precoPorLitro = this._utilService.getCurrency(object.precoPorLitro);
	                }
	                if (object.precoTotal) {
	                    object.precoTotal = this._utilService.getCurrency(object.precoTotal);
	                }
	            }
	            if (this.areaObject && this.areaObject.id) {
	                object.areaId = this.areaObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (object.quantidade == 0) {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (date.value) {
	                object.data = this._utilService.convertStringToDate(date.value);
	            }
	            if (this.formObject.tipoLancamento === this.tipoAbastecimentoInterno || this.formObject.ajuste) {
	                if (this.bombaObject && this.bombaObject.id) {
	                    object.bombaId = this.bombaObject.id;
	                    if (this.bombaObject.tanque) {
	                        object.combustivelId = this.bombaObject.tanque.combustivelId;
	                    }
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                if (this.localObject && this.localObject.id) {
	                    object.localId = this.localObject.id;
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                delete object['notaFiscal'];
	                delete object['documento'];
	                delete object['empenho'];
	            }
	            else if (this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
	                if (this.combustivelObject && this.combustivelObject.id) {
	                    object.combustivelId = this.combustivelObject.id;
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                delete object['localId'];
	                delete object['bombaId'];
	                delete object['empenho'];
	            }
	            else if (this.formObject.tipoLancamento === this.tipoAbastecimentoConvenio) {
	                if (this.localObject && this.localObject.id) {
	                    object.localId = this.localObject.id;
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                if (this.combustivelObject && this.combustivelObject.id) {
	                    object.combustivelId = this.combustivelObject.id;
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	            }
	            delete object['combustivel'];
	            delete object['local'];
	            delete object['bomba'];
	            if (this.formObject.id) {
	                this.onEdit(object);
	            }
	            else {
	                this.onAdd(object);
	            }
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.onAdd = function (object) {
	        this._abastecimentoBemApiService.onPost(object, this.onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.onEdit = function (object) {
	        this._abastecimentoBemApiService.onPut(object, this.onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.testNew = function () {
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.setEditNormal(id);
	        }
	        else {
	            this.setNewNormal();
	        }
	        this.setActionTitle(id);
	    };
	    AbastecimentoBemFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_4.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_4.newRoute;
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.bem) {
	            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
	            this.frotaObject.Combustiveis = this.frotaCombustiveis;
	            delete this.formObject['bem'];
	            var placa = '';
	            if (this.frotaObject.placa) {
	                placa = this.frotaObject.placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
	                placa = placa + ' / ';
	            }
	            var selectObject = { text: placa.concat(this.frotaObject.identificacao), id: this.frotaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'bem', this.frotaObject);
	            this.changeFormaControle();
	        }
	        if (this.formObject.area) {
	            this.areaObject = this.formObject.area;
	            delete this.formObject['area'];
	            var text = this._autocompleteService.getTextSelect2(this.areaObject, 'nome');
	            var selectObject = { text: text, id: this.areaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.areaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.areaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'area', this.areaObject);
	        }
	        if (this.formObject.motorista) {
	            this.motoristaObject = this._utilService.cloneObject(this.formObject.motorista);
	            delete this.formObject['motorista'];
	            if (this.motoristaObject.funcionario && this.motoristaObject.funcionario.pessoa) {
	                var funcionario = this.motoristaObject.funcionario;
	                var selectObject = { text: funcionario.pessoa.nome, id: this.motoristaObject.id };
	                this._autocompleteService.createOptionOnSelect2(this.motoristaSelectId, selectObject);
	                this._autocompleteService.setValueOnSelect2(selectObject.id, this.motoristaSelectId);
	                this._utilService.setSelectOnFormControl(this.form, 'motorista', this.motoristaObject);
	            }
	        }
	        if (this.formObject.data) {
	            this.formObject.data = this._utilService.convertDateToString(this.formObject.data);
	        }
	        if (this.formObject.odometroHorimetro) {
	            this.formObject.odometroHorimetroValue = this._formaControleService.setOdometroHorimetroToForm(this.formObject.odometroHorimetro.odometroHorimetro);
	            delete this.formObject['odometroHorimetro'];
	        }
	        if (this.formObject.local) {
	            var local = this._utilService.cloneObject(this.formObject.local);
	            delete this.formObject['local'];
	            local.tipo = this.setLocalTipo(local.tipo);
	            this.setFirstLocal(local);
	        }
	        if (this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
	            this.localObject = this.locaisList[0];
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.setEditNormal = function (id) {
	        this.isEdition = true;
	        this.getObject(id);
	    };
	    AbastecimentoBemFormComponent.prototype.setNewNormal = function () {
	        this.formObject.data = this._utilService.convertDateToString(new Date());
	    };
	    AbastecimentoBemFormComponent.prototype.calculate = function () {
	        var total = 0;
	        if (this.formObject.quantidade && this.formObject.precoPorLitro) {
	            var price = this._utilService.cloneObject(this.formObject.precoPorLitro);
	            if (price) {
	                if (isNumeric_1.isNumeric(price)) {
	                    price = price.toString();
	                }
	                else {
	                    price = price.replace(/\./g, "");
	                    price = price.replace(",", ".");
	                }
	            }
	            price = parseFloat(price);
	            if (!price)
	                price = 0;
	            total = this.formObject.quantidade * price;
	            total = total.toFixed(2);
	        }
	        this.formObject.precoTotal = this._utilService.currencyFormat(total, false);
	    };
	    AbastecimentoBemFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.formObjectClone = this._utilService.cloneObject(Response);
	                this.getCombustiveisBem(Response.bemId);
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum abastecimento encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._abastecimentoBemApiService.onGetById(id, onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.getCombustiveis = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.combustiveisListClone = list;
	                this.loadingSpinnerCombustiveis = false;
	            }
	        }.bind(this));
	        this.loadingSpinnerCombustiveis = true;
	        this._combustivelApiService.onGetAll(onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.getCombustiveisLocal = function (localId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length, item = void 0;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        item = Response[x].combustivel;
	                        item.preco = Response[x].preco;
	                        item.localId = Response[x].localId;
	                        list.push(item);
	                    }
	                }
	                this.combustiveisList = list;
	                this.testBemCombustiveis();
	                this.loadingSpinnerCombustiveis = false;
	            }
	        }.bind(this));
	        this.loadingSpinnerCombustiveis = true;
	        this._localApiService.onGetLocalCombustivelByLocal(localId, onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.getCombustiveisLocalInterno = function (localId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length, item = void 0;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        item = Response[x].combustivel;
	                        item.preco = Response[x].preco;
	                        item.localId = Response[x].localId;
	                        list.push(item);
	                    }
	                }
	                this.precoCombustiveisLocalInterno = list;
	            }
	        }.bind(this));
	        this._localApiService.onGetLocalCombustivelByLocal(localId, onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.getCombustiveisBem = function (bemId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x] = Response[x].combustivel;
	                }
	                this.frotaCombustiveis = Response;
	                this.setCombustiveisBemText();
	                this.firstPrice = true;
	                this.setModelToForm();
	            }
	        }.bind(this));
	        this._bemCombustivelApiService.onGetByBem(bemId, onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.getTanques = function (localId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.tanquesList = list;
	                if (this.bombasListClone.length) {
	                    this.setBombas();
	                }
	                else {
	                    this.getBombas();
	                }
	            }
	        }.bind(this));
	        this.loadingSpinnerBombas = true;
	        this._tanqueApiService.onGetByLocal(localId, onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.getBombas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.bombasListClone = list;
	                this.setBombas();
	            }
	        }.bind(this));
	        this._bombaApiService.onGetAll(onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.getLocais = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        Response[x].tipo = this.setLocalTipo(Response[x].tipo);
	                        list.push(Response[x]);
	                    }
	                }
	                list.unshift({
	                    id: 0,
	                    nome: "Abastecimento externo",
	                    tipo: { Key: this.tipoAbastecimentoExterno }
	                });
	                this.locaisList = list;
	                this.locaisListClone = this._utilService.cloneObject(list);
	                this.loadingSpinnerLocais = false;
	                this.setFirstLocal();
	            }
	        }.bind(this));
	        this.loadingSpinnerLocais = true;
	        this._localApiService.onGetAll(onDone);
	    };
	    AbastecimentoBemFormComponent.prototype.setLocalTipo = function (tipo) {
	        var newTipo;
	        var tipoLocalInterno = this._localService.getTipoInterno();
	        var tipoLocalConvenio = this._localService.getTipoConvenio();
	        if (tipo === tipoLocalInterno.Key) {
	            newTipo = tipoLocalInterno;
	            //coloca o numero do convenio conforme a lista de abastecimento bens
	            newTipo.Key = this.tipoAbastecimentoInterno;
	        }
	        else {
	            newTipo = tipoLocalConvenio;
	            //coloca o numero do interno conforme a lista de abastecimento bens
	            newTipo.Key = this.tipoAbastecimentoConvenio;
	        }
	        return newTipo;
	    };
	    AbastecimentoBemFormComponent.prototype.setBombas = function () {
	        var x, lenX, y, lenY, list = [];
	        for (x = 0, lenX = this.tanquesList.length; x < lenX; x++) {
	            for (y = 0, lenY = this.bombasListClone.length; y < lenY; y++) {
	                if (this.tanquesList[x].id === this.bombasListClone[y].tanqueId) {
	                    list.push(this.bombasListClone[y]);
	                }
	            }
	        }
	        this.bombasList = list;
	        if (this.formObject.ajuste) {
	            this.setFisrtBomba();
	        }
	        else {
	            this.testBemCombustiveis();
	        }
	        this.combustivelTextValue = '';
	        this.loadingSpinnerBombas = false;
	    };
	    AbastecimentoBemFormComponent.prototype.setTipoLancamento = function () {
	        this.formObject.tipoLancamento = this.localObject.tipo.Key;
	        if (this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
	            this.disabledCombustivel();
	            setTimeout(function () {
	                this.combustiveisList = this._utilService.cloneObject(this.combustiveisListClone);
	                this.testBemCombustiveis();
	            }.bind(this));
	        }
	        else if (this.formObject.tipoLancamento === this.tipoAbastecimentoConvenio) {
	            this.disabledCombustivel();
	            this.getCombustiveisLocal(this.localObject.id);
	        }
	        else if (this.formObject.tipoLancamento === this.tipoAbastecimentoInterno) {
	            this.disabledBomba();
	            this.getTanques(this.localObject.id);
	            this.getCombustiveisLocalInterno(this.localObject.id);
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.enabledCombustivel = function () {
	        if (this.combustiveisList.length) {
	            var element = this.form.controls['combustivel'];
	            element.enable();
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.disabledCombustivel = function () {
	        var element = this.form.controls['combustivel'];
	        element.disable();
	    };
	    AbastecimentoBemFormComponent.prototype.enabledBomba = function () {
	        if (this.bombasList.length) {
	            var element = this.form.controls['bomba'];
	            element.enable();
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.disabledBomba = function () {
	        var element = this.form.controls['bomba'];
	        element.disable();
	    };
	    AbastecimentoBemFormComponent.prototype.setPriceByLiter = function (newPrice) {
	        var price = this._utilService.currencyFormat(newPrice, false);
	        if (price) {
	            this.formObject.precoPorLitro = price;
	            this.calculate();
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.toGetOutOfHere = function () {
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaAbastecimento(this.frotaRoute);
	        }
	        else {
	            this._abastecimentoBemNavigationService.goToList();
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.testBemCombustiveis = function () {
	        if (this.frotaObject.Combustiveis) {
	            if (this.formObject.tipoLancamento === this.tipoAbastecimentoConvenio ||
	                this.formObject.tipoLancamento === this.tipoAbastecimentoExterno) {
	                if (this.combustiveisList.length) {
	                    this.combustiveisList = this.compareBemAndLocaisCombustiveis(this.combustiveisList, 'id');
	                }
	                else {
	                    this.combustiveisList = [];
	                }
	                this.setFirstCombustivel();
	            }
	            else if (this.formObject.tipoLancamento === this.tipoAbastecimentoInterno) {
	                if (this.bombasList.length) {
	                    this.bombasList = this.compareBemAndLocaisCombustiveis(this.bombasList, 'combustivelId');
	                }
	                else {
	                    this.bombasList = [];
	                }
	                this.setFisrtBomba();
	            }
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.compareBemAndLocaisCombustiveis = function (fuelList, value) {
	        var x, lenX, y, lenY, frotaFuel = this.frotaObject.Combustiveis, list = [];
	        for (x = 0, lenX = frotaFuel.length; x < lenX; x++) {
	            for (y = 0, lenY = fuelList.length; y < lenY; y++) {
	                if (frotaFuel[x].id === fuelList[y][value]) {
	                    list.push(fuelList[y]);
	                }
	            }
	        }
	        return list;
	    };
	    AbastecimentoBemFormComponent.prototype.setFirstCombustivel = function () {
	        if (this.isEdition) {
	            if (this.formObjectClone) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.combustiveisList.length; x < lenX; x++) {
	                    if (this.combustiveisList[x].id === this.formObjectClone.combustivelId) {
	                        this.combustivelObject = this.combustiveisList[x];
	                        break;
	                    }
	                }
	            }
	        }
	        else {
	            this.combustivelObject = this.combustiveisList[0];
	        }
	        if (this.combustiveisList.length) {
	            this.enabledCombustivel();
	        }
	        else {
	            this.disabledCombustivel();
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.setFisrtBomba = function () {
	        if (this.isEdition) {
	            if (this.formObjectClone) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.bombasList.length; x < lenX; x++) {
	                    if (this.bombasList[x].id === this.formObjectClone.bombaId) {
	                        this.bombaObject = this.bombasList[x];
	                        break;
	                    }
	                }
	            }
	        }
	        else {
	            this.bombaObject = this.bombasList[0];
	        }
	        if (this.bombasList.length) {
	            this.enabledBomba();
	        }
	        else {
	            this.disabledBomba();
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.setFirstLocal = function (object) {
	        if (this.isEdition) {
	            if (object) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.locaisList.length; x < lenX; x++) {
	                    if (this.locaisList[x].id === object.id) {
	                        this.localObject = this.locaisList[x];
	                        break;
	                    }
	                }
	            }
	        }
	        else {
	            this.localObject = this.locaisList[0];
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.setCombustiveisBemText = function () {
	        var vv = [];
	        if (this.frotaCombustiveis) {
	            this.frotaCombustiveis.forEach(function (item) {
	                vv.push(item.combustivel);
	            });
	        }
	        this.combustiveisBemText = vv.toString();
	    };
	    AbastecimentoBemFormComponent.prototype.showOnlyLocalInterno = function () {
	        var tipoInterno = this._localService.getTipoInterno(), x, lenX, list = [];
	        for (x = 0, lenX = this.locaisList.length; x < lenX; x++) {
	            if (this.locaisList[x].tipo.Key === tipoInterno.Key) {
	                list.push(this.locaisList[x]);
	            }
	        }
	        this.locaisList = list;
	        this.setFirstLocal();
	    };
	    AbastecimentoBemFormComponent.prototype.precoCombustivelLocalInterno = function () {
	        var x, lenX, found = false;
	        for (x = 0, lenX = this.precoCombustiveisLocalInterno.length; x < lenX; x++) {
	            if (this.precoCombustiveisLocalInterno[x].id === this.bombaObject.tanque.combustivelId) {
	                this.formObject.precoPorLitro = this.precoCombustiveisLocalInterno[x].preco;
	                found = true;
	                break;
	            }
	        }
	        if (!found) {
	            this.formObject.precoPorLitro = '';
	        }
	    };
	    AbastecimentoBemFormComponent.prototype.changeFormaControle = function () {
	        this.showTipoOdometro = this._formaControleService.changeFormaControle(this.frotaObject.formaControleId);
	    };
	    AbastecimentoBemFormComponent.prototype.testFrotaBackHistory = function () {
	        var settings = this._frotaService.testBackHistory();
	        this.frotaDetailHistory = settings.frotaDetailHistory;
	        this.frotasModule = settings.frotasModule;
	        this.frotaRoute = settings.frotaRoute;
	        this.showFrotaLink = settings.showFrotaLink;
	        // if (this.frotaRoute) {
	        //     // if (this.actionTitle === newRoute) {
	        //     //     let placa: string = '';
	        //     //     if (history.placa) {
	        //     //         placa = history.placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
	        //     //         placa = placa + ' / ';
	        //     //     }
	        //     //
	        //     //     let selectObject: any = {text: placa.concat(history.identificacao), id: history.id};
	        //     //
	        //     //     setTimeout(function() {
	        //     //         this._autocompleteService.createOptionOnSelect2('frotaSelect', selectObject);
	        //     //         this._autocompleteService.setValueOnSelect2(selectObject.id, 'frotaSelect');
	        //     //         this.getFrotaObject(history);
	        //     //     }.bind(this));
	        //     // }
	        //     this.showFrotaLink = true;
	        // } else {
	        //     this._frotaService.clearBackStorage();
	        // }
	    };
	    AbastecimentoBemFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(418),
	            styles: [__webpack_require__(419)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _b) || Object, (typeof (_c = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _c) || Object, (typeof (_d = typeof abastecimento_bem_service_1.AbastecimentoBemService !== 'undefined' && abastecimento_bem_service_1.AbastecimentoBemService) === 'function' && _d) || Object, (typeof (_e = typeof abastecimento_bem_api_service_1.AbastecimentoBemApiService !== 'undefined' && abastecimento_bem_api_service_1.AbastecimentoBemApiService) === 'function' && _e) || Object, (typeof (_f = typeof abastecimento_bem_navigation_service_1.AbastecimentoBemNavigationService !== 'undefined' && abastecimento_bem_navigation_service_1.AbastecimentoBemNavigationService) === 'function' && _f) || Object, (typeof (_g = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _g) || Object, (typeof (_h = typeof combustivel_api_service_1.CombustivelApiService !== 'undefined' && combustivel_api_service_1.CombustivelApiService) === 'function' && _h) || Object, (typeof (_j = typeof bem_combustivel_api_service_1.BemCombustivelApiService !== 'undefined' && bem_combustivel_api_service_1.BemCombustivelApiService) === 'function' && _j) || Object, (typeof (_k = typeof motorista_api_service_1.MotoristaApiService !== 'undefined' && motorista_api_service_1.MotoristaApiService) === 'function' && _k) || Object, (typeof (_l = typeof motorista_service_1.MotoristaService !== 'undefined' && motorista_service_1.MotoristaService) === 'function' && _l) || Object, (typeof (_m = typeof local_api_service_1.LocalApiService !== 'undefined' && local_api_service_1.LocalApiService) === 'function' && _m) || Object, (typeof (_o = typeof local_service_1.LocalService !== 'undefined' && local_service_1.LocalService) === 'function' && _o) || Object, (typeof (_p = typeof tanque_api_service_1.TanqueApiService !== 'undefined' && tanque_api_service_1.TanqueApiService) === 'function' && _p) || Object, (typeof (_q = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _q) || Object, (typeof (_r = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _r) || Object, (typeof (_s = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _s) || Object, (typeof (_t = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _t) || Object, (typeof (_u = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _u) || Object, (typeof (_v = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _v) || Object, (typeof (_w = typeof core_1.ChangeDetectorRef !== 'undefined' && core_1.ChangeDetectorRef) === 'function' && _w) || Object])
	    ], AbastecimentoBemFormComponent);
	    return AbastecimentoBemFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
	}());
	exports.AbastecimentoBemFormComponent = AbastecimentoBemFormComponent;
	/*
	 Abastecimento Externo
	 - nota fiscal
	 - documento
	
	 Abastecimento Convenio
	 - Local
	 - nota fiscal
	 - documento
	 - empenho
	
	 Abastecimento Interno
	 - Local
	 - Bomba
	
	 */ 


/***/ },
/* 412 */
/***/ function(module, exports) {

	"use strict";
	var Combustivel = (function () {
	    function Combustivel() {
	    }
	    return Combustivel;
	}());
	exports.Combustivel = Combustivel;


/***/ },
/* 413 */,
/* 414 */
/***/ function(module, exports) {

	"use strict";
	var Local = (function () {
	    function Local() {
	    }
	    return Local;
	}());
	exports.Local = Local;
	var LocalCombustivel = (function () {
	    function LocalCombustivel() {
	    }
	    return LocalCombustivel;
	}());
	exports.LocalCombustivel = LocalCombustivel;


/***/ },
/* 415 */
/***/ function(module, exports) {

	"use strict";
	var AbastecimentoBem = (function () {
	    function AbastecimentoBem() {
	    }
	    return AbastecimentoBem;
	}());
	exports.AbastecimentoBem = AbastecimentoBem;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(404);
	var rest_service_1 = __webpack_require__(26);
	var TanqueApiService = (function () {
	    function TanqueApiService(_restService) {
	        this._restService = _restService;
	    }
	    TanqueApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    TanqueApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    TanqueApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    TanqueApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "identificacao", "include": ["combustivel", "local"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    TanqueApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["local", "combustivel"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    TanqueApiService.prototype.onGetByLocal = function (localId, done) {
	        var filter = { "order": "identificacao", "include": ["local", "combustivel"], "where": { "localId": localId } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    TanqueApiService.prototype.onGetEstoqueByTanque = function (done) {
	        this._restService.onGet(data_service_1.apiName + '/relatorio/capacidade-atual', done);
	    };
	    TanqueApiService.prototype.onGetEstoqueByArea = function (done) {
	        this._restService.onGet('areas/relatorio/capacidade-atual-por-combustivel', done);
	    };
	    TanqueApiService.prototype.onGetEstoqueByOrgao = function (done) {
	        this._restService.onGet('orgaos/relatorio/capacidade-atual-por-combustivel', done);
	    };
	    TanqueApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //movimentacao
	    TanqueApiService.prototype.onPostMovimentacao = function (object, done) {
	        this._restService.onPost(data_service_1.tanquesMovimentacaoApiName, object, done);
	    };
	    TanqueApiService.prototype.onPutMovimentacao = function (object, done) {
	        this._restService.onPut(data_service_1.tanquesMovimentacaoApiName, object, done);
	    };
	    TanqueApiService.prototype.onGetByMovimentacaoFilter = function (filter, done) {
	        filter.include = ["bem", "combustivel", "bomba", "area", { "funcionario": "pessoa" }, "local", "tanque", "tanqueDestino", "tipoAjuste"];
	        this._restService.onGetPost(data_service_1.tanquesMovimentacaoApiName, filter, done);
	    };
	    TanqueApiService.prototype.onGetByMovimentacaoId = function (objectId, done) {
	        var filter = { "include": ["bem", "combustivel", "bomba", "area", { "funcionario": "pessoa" }, "local", "tanque", "tanqueDestino", "tipoAjuste"] };
	        this._restService.onGetPostId(data_service_1.tanquesMovimentacaoApiName, objectId, filter, done);
	    };
	    TanqueApiService.prototype.onDeleteMovimentacao = function (objectId, done) {
	        this._restService.onDelete(data_service_1.tanquesMovimentacaoApiName, objectId, done);
	    };
	    //movimentacao tanque/area
	    TanqueApiService.prototype.onPostMovimentacaoArea = function (object, done) {
	        this._restService.onPost(data_service_1.tanquesMovimentacaoAreaApiName, object, done);
	    };
	    TanqueApiService.prototype.onPutMovimentacaoArea = function (object, done) {
	        this._restService.onPut(data_service_1.tanquesMovimentacaoAreaApiName, object, done);
	    };
	    TanqueApiService.prototype.onGetByMovimentacaoAreaFilter = function (filter, done) {
	        filter.include = ["area"];
	        this._restService.onGetPost(data_service_1.tanquesMovimentacaoAreaApiName, filter, done);
	    };
	    TanqueApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], TanqueApiService);
	    return TanqueApiService;
	    var _a;
	}());
	exports.TanqueApiService = TanqueApiService;


/***/ },
/* 417 */
/***/ function(module, exports) {

	"use strict";
	var Bomba = (function () {
	    function Bomba() {
	    }
	    return Bomba;
	}());
	exports.Bomba = Bomba;
	var Hidrometro = (function () {
	    function Hidrometro() {
	    }
	    return Hidrometro;
	}());
	exports.Hidrometro = Hidrometro;


/***/ },
/* 418 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\" *ngIf=\"showFrotaLink\"><a (click)=\"clickGoToFrotaList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n        <li class=\"item\" *ngIf=\"showFrotaLink\"><a (click)=\"clickGoToFrotaDetail()\" class=\"cursor-pointer\">{{frotaDetailHistory.identificacao}}</a></li>\n\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{abastecimentoBensModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{abastecimentoBensModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{abastecimentoBensModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-toggle\">\n                <input type=\"checkbox\" id=\"ajuste\" value=\"\" [(ngModel)]=\"formObject.ajuste\" formControlName=\"ajuste\" (ngModelChange)=\"changeAjuste()\">\n                <label for=\"ajuste\">Abastecimento de ajuste</label>\n            </div>\n        </div>\n\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c geo-input--datepicker\"  [ngClass]=\"{'geo-input--error': !data.value && submitted}\">\n                <label for=\"data\">Data <abbr>*</abbr></label>\n                <div>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"data\" [(ngModel)]=\"formObject.data\" formControlName=\"data\" appDatepicker autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"frotaSelect\" *ngIf=\"!formObject.ajuste\"\n                                    (setObejct)=\"getFrotaObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"frotaSelectId\"\n                                    [model]=\"frotaObject\"\n                                    [_service]=\"_frotaApiService\"\n                                    [templateResult]=\"frotaTemplateResult\"\n                                    [isCreateNew]=\"false\"\n                                    [apiCustom]=\"'/populado'\"\n                                    [query]=\"frotaQuery\"\n                                    [label]=\"'Frota / equipamento'\"></autocomplete-component>\n\n            <div class=\"geo-input--6c\" *ngIf=\"!formObject.ajuste\">\n                <label for=\"descricao\">Identificação</label>\n                <div class=\"containerText\">\n                    <input type=\"text\" id=\"descricao\" [(ngModel)]=\"frotaObject.identificacao\" formControlName=\"bemText\">\n                    <span class=\"input-text\" *ngIf=\"combustiveisBemText\">Combustíveis: {{combustiveisBemText}}</span>\n                </div>\n            </div>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"motoristaSelect\" *ngIf=\"!formObject.ajuste\"\n                                    (setObejct)=\"getMotoristaObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"motoristaSelectId\"\n                                    [model]=\"motoristaObject\"\n                                    [_service]=\"_motoristaApiService\"\n                                    [query]=\"motoristaQuery\"\n                                    [templateResult]=\"motoristaTemplateResult\"\n                                    [isCreateNew]=\"false\"\n                                    [label]=\"'Motorista'\"></autocomplete-component>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"areaSelect\"\n                                    (setObejct)=\"getAreaObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"areaSelectId\"\n                                    [model]=\"areaObject\"\n                                    [_service]=\"_areaApiService\"\n                                    [fieldToShow]=\"'nome'\"\n                                    [query]=\"areaQuery\"\n                                    [isCreateNew]=\"false\"\n                                    [label]=\"'Área'\"></autocomplete-component>\n\n            <app-odometro-horimetro-form-component [labelOdometro]=\"'Odômetro'\"\n                                                   [labelHorimetro]=\"'Horímetro'\"\n                                                   [showOdometro]=\"showTipoOdometro\"\n                                                   [required]=\"true\"\n                                                   [submitted]=\"submitted\"\n                                                   [model]=\"formObject.odometroHorimetroValue\"\n                                                   (returnModel)=\"formObject.odometroHorimetroValue = $event\"\n                                                   [bemId]=\"frotaObject.id\"></app-odometro-horimetro-form-component>\n        </div>\n\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !local.valid && submitted}\">\n                <label for=\"local\">Local <abbr>*</abbr></label>\n                <div class=\"containerSpinner\">\n                    <span class=\"error-alert\" *ngIf=\"(!local.valid && submitted)\">Este campo é obrigatório.</span>\n                    <select id=\"local\" [(ngModel)]=\"localObject\" formControlName=\"local\" (ngModelChange)=\"changeLocal()\">\n                        <option *ngFor=\"let item of locaisList\" [ngValue]=\"item\">{{item.nome}} <span *ngIf=\"item.id !== 0\">({{item.tipo.Value}})</span></option>\n                    </select>\n                    <spinner-component *ngIf=\"loadingSpinnerLocais\"></spinner-component>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !bomba.valid && submitted}\" *ngIf=\"formObject.tipoLancamento === tipoAbastecimentoInterno\">\n                <label for=\"bomba\">Bomba <abbr>*</abbr></label>\n                <div class=\"containerSpinner\">\n                    <span class=\"error-alert\" *ngIf=\"(!bomba.valid && submitted)\">Este campo é obrigatório.</span>\n                    <select id=\"bomba\" [(ngModel)]=\"bombaObject\" formControlName=\"bomba\" (ngModelChange)=\"changeBomba()\">\n                        <option *ngFor=\"let item of bombasList\" [ngValue]=\"item\">{{item.nome}} <span *ngIf=\"item.tanque && item.tanque.combustivel\">({{item.tanque.combustivel.combustivel}})</span></option>\n                    </select>\n                    <spinner-component *ngIf=\"loadingSpinnerBombas\"></spinner-component>\n                    <span *ngIf=\"!bombasList.length\" class=\"input-hint\">Nenhum combustível compatível</span>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !combustivel.valid && submitted}\" *ngIf=\"formObject.tipoLancamento !== tipoAbastecimentoInterno\">\n                <label for=\"combustivel\">Combustível <abbr>*</abbr></label>\n                <div class=\"containerSpinner\">\n                    <span class=\"error-alert\" *ngIf=\"(!combustivel.valid && submitted)\">Este campo é obrigatório / Formato incorreto.</span>\n                    <select id=\"combustivel\" [(ngModel)]=\"combustivelObject\" formControlName=\"combustivel\" (ngModelChange)=\"changeCombustivel()\">\n                        <option *ngFor=\"let item of combustiveisList\" [ngValue]=\"item\">{{item.combustivel}}</option>\n                    </select>\n                    <spinner-component *ngIf=\"loadingSpinnerCombustiveis\"></spinner-component>\n                </div>\n                <span *ngIf=\"!combustiveisList.length\" class=\"input-hint\">Nenhum combustível compatível com a frota/equipamento selecionado</span>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"formObject.tipoLancamento === tipoAbastecimentoInterno\">\n                <label for=\"combustivelText\">Combustível </label>\n                <div>\n                    <input type=\"text\" id=\"combustivelText\" [(ngModel)]=\"combustivelTextValue\" formControlName=\"combustivelText\">\n                </div>\n            </div>\n        </div>\n\n        <div class=\"geo-columns--12c\" *ngIf=\"!formObject.ajuste\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !notaFiscal.valid && submitted}\" *ngIf=\"formObject.tipoLancamento === tipoAbastecimentoExterno || formObject.tipoLancamento === tipoAbastecimentoConvenio\">\n                <label for=\"notaFiscal\">Nota fiscal  <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"(!notaFiscal.valid && submitted)\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"notaFiscal\" [(ngModel)]=\"formObject.notaFiscal\" formControlName=\"notaFiscal\" appNumberInteger>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"formObject.tipoLancamento === tipoAbastecimentoExterno || formObject.tipoLancamento === tipoAbastecimentoConvenio\">\n                <label for=\"documento\">Documento</label>\n                <div>\n                    <input type=\"text\" id=\"documento\" [(ngModel)]=\"formObject.documento\" formControlName=\"documento\" appNumberInteger>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"formObject.tipoLancamento === tipoAbastecimentoConvenio\">\n                <label for=\"empenho\">Número do empenho</label>\n                <div>\n                    <input type=\"text\" id=\"empenho\" [(ngModel)]=\"formObject.empenho\" formControlName=\"empenho\" appNumberInteger>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!quantidade.valid && submitted) || (quantidade.errors && quantidade.errors.incorrectNumberFormat)}\">\n                <label for=\"quantidade\">Quantidade (litros) <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"(!quantidade.valid && submitted)\">Este campo é obrigatório / Formato incorreto.</span>\n                    <input type=\"number\" id=\"quantidade\" [(ngModel)]=\"formObject.quantidade\" (keyup)=\"keyupQuantidade()\" formControlName=\"quantidade\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !precoPorLitro.valid && submitted}\" *ngIf=\"!formObject.ajuste\">\n                <label for=\"precoPorLitro\">Preço por litro (R$) <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!precoPorLitro.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"precoPorLitro\" [(ngModel)]=\"formObject.precoPorLitro\" formControlName=\"precoPorLitro\" (keyup)=\"keyupCurrency()\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" *ngIf=\"!formObject.ajuste\">\n                <label for=\"total\">Total (R$) </label>\n                <div>\n                    <input type=\"text\" id=\"total\" [(ngModel)]=\"formObject.precoTotal\" formControlName=\"precoTotal\" >\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 419 */
/***/ function(module, exports) {

	module.exports = ".toggleExterno {\n    margin-bottom: 22px;\n}\n\n.input-hint {\n    font-size: 12px;\n    position: absolute;\n}\n\n.input-text {\n    position: absolute;\n    font-size: 12px;\n    right: 16px;\n    top: 10px;\n}\n\n.containerText {\n    position: relative;\n}\n\n.containerSpinner {\n    position: relative;\n}\n\nspinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}"

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(200);
	var ordem_servico_api_service_1 = __webpack_require__(421);
	var ordem_servico_service_1 = __webpack_require__(235);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var frota_service_1 = __webpack_require__(203);
	var frota_api_service_1 = __webpack_require__(368);
	var data_service_2 = __webpack_require__(154);
	var autocomplete_service_1 = __webpack_require__(101);
	var frota_navigation_service_1 = __webpack_require__(198);
	var manutencao_programada_service_1 = __webpack_require__(422);
	var OrdemServicoListComponent = (function () {
	    function OrdemServicoListComponent(_ordemServicosApiService, _ordemServicoService, _ordemServicoNavigationService, _frotaService, _frotaApiService, _autocompleteService, _frotaNavigationService, _manutencaoProgramadaService, _utilService) {
	        this._ordemServicosApiService = _ordemServicosApiService;
	        this._ordemServicoService = _ordemServicoService;
	        this._ordemServicoNavigationService = _ordemServicoNavigationService;
	        this._frotaService = _frotaService;
	        this._frotaApiService = _frotaApiService;
	        this._autocompleteService = _autocompleteService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._manutencaoProgramadaService = _manutencaoProgramadaService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.ordemServicosModuleName = data_service_1.ordensServicoModuleName;
	        this.query = {};
	        this.showFrotaLink = false;
	        this.frotaDetailHistory = {};
	        this.frotasModule = {};
	        this.statusList = [];
	        this.frotaSelectId = "frota";
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	    }
	    OrdemServicoListComponent.prototype.ngOnInit = function () {
	        this.statusList = this._utilService.cloneObject(data_service_1.OrdemServicoStatus);
	        this.statusList.unshift({ Key: null, Value: 'Todos' });
	        this.frotaQuery = this._utilService.cloneObject(data_service_2.frotasQuery);
	        this.testFrotaBackHistory();
	    };
	    OrdemServicoListComponent.prototype.clickNew = function () {
	        this._manutencaoProgramadaService.clearSessionStorage();
	        this._ordemServicoService.clearSessionStorage();
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaManutencaoNew(this.frotaRoute);
	        }
	        else {
	            this._ordemServicoNavigationService.goToNew();
	        }
	    };
	    OrdemServicoListComponent.prototype.clickDetail = function (item) {
	        this._ordemServicoService.clearSessionStorage();
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaManutencaoDetail(this.frotaRoute, item.id);
	        }
	        else {
	            this._ordemServicoNavigationService.goToDetail(item.id);
	        }
	    };
	    OrdemServicoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    OrdemServicoListComponent.prototype.changeSearch = function () {
	        this.list = [];
	        this.querySearch();
	    };
	    OrdemServicoListComponent.prototype.clickClearSearch = function () {
	        this.startQuery();
	        this._autocompleteService.setValueOnSelect2(null, "frota");
	        this.changeSearch();
	    };
	    OrdemServicoListComponent.prototype.clickGoToFrotaDetail = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
	    };
	    OrdemServicoListComponent.prototype.clickGoToFrotaList = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToList(this.frotaRoute);
	    };
	    OrdemServicoListComponent.prototype.getFrotasObject = function (object) {
	        this.query.bem = object;
	        this.changeSearch();
	    };
	    OrdemServicoListComponent.prototype.getQuery = function (query) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.forEach(function (item) {
	                    item.tipo = this._ordemServicoService.getTipoOrdemServico(item.tipo);
	                    item.status = this._ordemServicoService.getStatusOrdemServico(item.status);
	                }.bind(this));
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._ordemServicosApiService.onGetByQuery(query, onDone);
	    };
	    OrdemServicoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._ordemServicosApiService.onDelete(item.id, onDone);
	    };
	    OrdemServicoListComponent.prototype.querySearch = function () {
	        this.loading = true;
	        var query = this._utilService.cloneObject(this.query);
	        if (query.status) {
	            if (query.status.Key) {
	                query.status = query.status.Key;
	            }
	            else {
	                delete query['status'];
	            }
	        }
	        if (query.bem) {
	            query.bemId = query.bem.id;
	        }
	        delete query['bem'];
	        this.getQuery(query);
	    };
	    OrdemServicoListComponent.prototype.startQuery = function () {
	        this.query.status = this.statusList[1];
	        this.query.bem = 0;
	    };
	    OrdemServicoListComponent.prototype.testFrotaBackHistory = function () {
	        var settings = this._frotaService.testBackHistory('frota');
	        this.frotaDetailHistory = settings.frotaDetailHistory;
	        this.frotasModule = settings.frotasModule;
	        this.frotaRoute = settings.frotaRoute;
	        this.showFrotaLink = settings.showFrotaLink;
	        this.startQuery();
	        if (this.showFrotaLink) {
	            this.query.bem = this.frotaDetailHistory;
	            this.query.status = this.statusList[0];
	        }
	        this.changeSearch();
	    };
	    OrdemServicoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(424),
	            styles: [__webpack_require__(425)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ordem_servico_api_service_1.OrdemServicoApiService !== 'undefined' && ordem_servico_api_service_1.OrdemServicoApiService) === 'function' && _a) || Object, (typeof (_b = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _d) || Object, (typeof (_e = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _g) || Object, (typeof (_h = typeof manutencao_programada_service_1.ManutencaoProgramadaService !== 'undefined' && manutencao_programada_service_1.ManutencaoProgramadaService) === 'function' && _h) || Object, (typeof (_j = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _j) || Object])
	    ], OrdemServicoListComponent);
	    return OrdemServicoListComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.OrdemServicoListComponent = OrdemServicoListComponent;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(200);
	var OrdemServicoApiService = (function () {
	    function OrdemServicoApiService(_restService) {
	        this._restService = _restService;
	        this.includeFilter = ["bem", { "localidade": "endereco" }, "odometroHorimetro"];
	    }
	    OrdemServicoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    OrdemServicoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    OrdemServicoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    OrdemServicoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "dataEntrada", "include": this.includeFilter };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    OrdemServicoApiService.prototype.onGetByQuery = function (query, done) {
	        var filter = { "order": "dataEntrada", "include": this.includeFilter };
	        filter.where = query;
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    OrdemServicoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": this.includeFilter };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    OrdemServicoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    OrdemServicoApiService.prototype.onGetAllMateriaisServices = function (done) {
	        var object = { "ativo": true, "sort": "descricao" };
	        this._restService.onGetPostCustom(data_service_1.apiName + '/busca/itens', object, done);
	    };
	    OrdemServicoApiService.prototype.onGetByIdMateriaisServicos = function (ordemServicoId, done) {
	        var object = { "ativo": true, "ordemServicoId": ordemServicoId };
	        this._restService.onGetPostCustom(data_service_1.apiName + '/busca/itens/os', object, done);
	    };
	    OrdemServicoApiService.prototype.onGetByFilter = function (filter, done) {
	        filter.include = this.includeFilter;
	        filter.order = "dataEntrada";
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    OrdemServicoApiService.prototype.onPostCustomApiUrl = function () {
	        return data_service_1.apiName + '/busca/itens';
	    };
	    OrdemServicoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], OrdemServicoApiService);
	    return OrdemServicoApiService;
	    var _a;
	}());
	exports.OrdemServicoApiService = OrdemServicoApiService;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(423);
	var ManutencaoProgramadaService = (function () {
	    function ManutencaoProgramadaService() {
	    }
	    //session
	    ManutencaoProgramadaService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.manutencoesProgramadaStorage + '-new', object);
	    };
	    ManutencaoProgramadaService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.manutencoesProgramadaStorage + "-new");
	        return JSON.parse(item);
	    };
	    ManutencaoProgramadaService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.manutencoesProgramadaStorage + "-new");
	    };
	    ManutencaoProgramadaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], ManutencaoProgramadaService);
	    return ManutencaoProgramadaService;
	}());
	exports.ManutencaoProgramadaService = ManutencaoProgramadaService;


/***/ },
/* 423 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'manutencoes-programadas';
	exports.manutencoesProgramadaRoute = 'manutencoes-programadas';
	exports.manutencoesProgramadaStorage = 'manutencaoProgramada';
	exports.manutencoesProgramadaModuleName = { plural: 'Alarmes de Manutenção', single: 'Alarme de Manutenção' };
	exports.tiposVencimento = [
	    { Key: 3, Value: 'Vencidos' },
	    { Key: 2, Value: 'A vencer' },
	];
	//status api
	//1 verde
	//2 amarelo
	//3 vermelho
	exports.selectedList = [
	    { Key: 1, Value: 'Criar manutenção' },
	    { Key: 2, Value: 'Excluir' },
	];


/***/ },
/* 424 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\" *ngIf=\"showFrotaLink\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a (click)=\"clickGoToFrotaList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n            <li class=\"item\"><a (click)=\"clickGoToFrotaDetail()\" class=\"cursor-pointer\">{{frotaDetailHistory.identificacao}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{ordemServicosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{ordemServicosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select [(ngModel)]=\"query.status\" id=\"os_status\" (ngModelChange)=\"changeSearch()\">\n                    <option *ngFor=\"let item of statusList\" id=\"filter_{{item.Key}}\" [ngValue]=\"item\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"frota\"\n                                (setObejct)=\"getFrotasObject($event)\"\n                                (clearObject)=\"getFrotasObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"query.bem\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'Frota / equipamento'\"\n                                [query]=\"frotaQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--12c geo-columns--right\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickClearSearch()\" class=\"cursor-pointer clear-search\">Limpar busca</a>\n        </p>\n    </div>\n\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{ordemServicosModuleName.single | lowercase}} cadastrada</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Número</th>\n            <th>Tipo</th>\n            <th>Frota / equipamento</th>\n            <th>Data entrada</th>\n            <th>Status</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['numero', 'dataEntrada','bem.identificacao','bem.placa','status.Value','tipo.Value'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.numero}}</a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.tipo\">{{item.tipo.Value}}</span></a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.bem\">{{item.bem.identificacao}}</span>  <span *ngIf=\"item.bem.placa\"> / {{item.bem.placa | licensePlateMask}}</span> </a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span>{{item.dataEntrada | date: 'dd/MM/yyyy'}}</span></a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.status\">{{item.status.Value}}</span></a></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 425 */
/***/ function(module, exports) {

	module.exports = ".advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}"

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(200);
	var ordem_servico_model_1 = __webpack_require__(427);
	var frota_model_1 = __webpack_require__(373);
	var localidade_model_1 = __webpack_require__(239);
	var ordem_servico_api_service_1 = __webpack_require__(421);
	var ordem_servico_service_1 = __webpack_require__(235);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var data_service_3 = __webpack_require__(148);
	var autocomplete_service_1 = __webpack_require__(101);
	var localidade_navigation_service_1 = __webpack_require__(228);
	var localidade_api_service_1 = __webpack_require__(227);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var data_service_4 = __webpack_require__(154);
	var forma_controle_service_1 = __webpack_require__(369);
	var frota_navigation_service_1 = __webpack_require__(198);
	var manutencao_programada_service_1 = __webpack_require__(422);
	var manutencao_programada_navigation_service_1 = __webpack_require__(428);
	var data_service_5 = __webpack_require__(423);
	var servico_api_service_1 = __webpack_require__(430);
	var material_servico_api_service_1 = __webpack_require__(431);
	var material_ordem_servico_api_service_1 = __webpack_require__(432);
	var OrdemServicosFormComponent = (function () {
	    function OrdemServicosFormComponent(_route, _ordemServicosApiService, _ordemServicosService, _ordemServicosNavigationService, _utilService, _autocompleteService, _frotaApiService, _frotaService, _localidadeApiService, _localidadeNavigationService, _frotaNavigationService, _formaControleService, _manutencaoProgramadaService, _manutencaoProgramadaNavigationService, _servicoApiService, _materialServicoApiService, _materialOrdemServicoApiService, _ordemServicoService, _fb) {
	        this._route = _route;
	        this._ordemServicosApiService = _ordemServicosApiService;
	        this._ordemServicosService = _ordemServicosService;
	        this._ordemServicosNavigationService = _ordemServicosNavigationService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._localidadeApiService = _localidadeApiService;
	        this._localidadeNavigationService = _localidadeNavigationService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._formaControleService = _formaControleService;
	        this._manutencaoProgramadaService = _manutencaoProgramadaService;
	        this._manutencaoProgramadaNavigationService = _manutencaoProgramadaNavigationService;
	        this._servicoApiService = _servicoApiService;
	        this._materialServicoApiService = _materialServicoApiService;
	        this._materialOrdemServicoApiService = _materialOrdemServicoApiService;
	        this._ordemServicoService = _ordemServicoService;
	        this._fb = _fb;
	        this.ordemServicosModule = data_service_2.ordensServicoModuleName;
	        this.manutencaoProgramadaModule = data_service_5.manutencoesProgramadaModuleName;
	        this.formObject = new ordem_servico_model_1.OrdemServico();
	        this.frotaObject = new frota_model_1.Frota();
	        this.tipoObject = {};
	        this.localidadeObject = new localidade_model_1.Localidade();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showTipoOdometro = true;
	        this.tiposList = data_service_2.TipoOrdemServico;
	        this.statusList = data_service_2.OrdemServicoStatus;
	        this.localidadeSelectId = 'localidade';
	        this.localidadeQuery = data_service_3.localidadesQuery;
	        this.frotaSelectId = 'frota';
	        this.frotaQuery = data_service_4.frotasQuery;
	        this.showFrotaLink = false;
	        this.frotaDetailHistory = {};
	        this.frotasModule = {};
	        this.showManutencaoProgramadaLink = false;
	        this.ativo = new forms_1.FormControl('');
	        this.dataEmpenho = new forms_1.FormControl('');
	        this.dataEntrada = new forms_1.FormControl('', forms_1.Validators.required);
	        this.dataSaida = new forms_1.FormControl('');
	        this.tipo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.bem = new forms_1.FormControl('', forms_1.Validators.required);
	        this.localidade = new forms_1.FormControl('', forms_1.Validators.required);
	        this.numeroEmpenho = new forms_1.FormControl('');
	        this.problemaInformado = new forms_1.FormControl('', forms_1.Validators.required);
	        this.laudo = new forms_1.FormControl('');
	        this.observacoes = new forms_1.FormControl('');
	        this.bemText = new forms_1.FormControl({ value: '', disabled: true });
	        this.complete = false;
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    if (this.complete) {
	                        swal("Sucesso!", "A manutenção foi concluída com sucesso.", "success");
	                    }
	                    else {
	                        this._utilService.swalMessageEditSuccess();
	                    }
	                    this.goToDetail(Response.id);
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                    if (this.showManutencaoProgramadaLink) {
	                        this.saveServicos(Response.id);
	                    }
	                    else {
	                        this.goToDetail(Response.id);
	                    }
	                }
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            dataEmpenho: this.dataEmpenho,
	            dataEntrada: this.dataEntrada,
	            dataSaida: this.dataEntrada,
	            tipo: this.tipo,
	            bem: this.bem,
	            localidade: this.localidade,
	            numeroEmpenho: this.numeroEmpenho,
	            problemaInformado: this.problemaInformado,
	            laudo: this.laudo,
	            observacoes: this.observacoes,
	            bemText: this.bemText
	        });
	    }
	    OrdemServicosFormComponent.prototype.ngOnInit = function () {
	        var t = this._ordemServicosService.getStatusConcluido();
	        this.statusConcluido = t.Key;
	        this.testSession();
	        this.testFrotaBackHistory();
	    };
	    OrdemServicosFormComponent.prototype.clickGoToList = function () {
	        this._manutencaoProgramadaService.clearSessionStorage();
	        this.goToList();
	    };
	    OrdemServicosFormComponent.prototype.clickGoToDetail = function () {
	        this.goToDetail();
	    };
	    OrdemServicosFormComponent.prototype.clickCancel = function () {
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.goToDetail();
	        }
	        else {
	            this.goToList();
	        }
	    };
	    OrdemServicosFormComponent.prototype.clickComplete = function () {
	        this.complete = true;
	        swal({
	            title: "Você deseja realmente concluir esta manutenção?",
	            text: "Esta operação não poderá ser desfeita!",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Concluir",
	            cancelButtonText: "Fechar",
	            closeOnConfirm: false
	        }, function () {
	            if (this.formObject.dataSaida && this.formObject.laudo && this.formObject.odometroHorimetroValue) {
	                this.onSend(this.form);
	            }
	            else {
	                swal({
	                    title: "Dados incompletos para concluir a manutenção",
	                    text: "Para concluir a manutenção informe o laudo, a data de saída e o odômetro/horímetro!",
	                    type: "warning",
	                    showCancelButton: true,
	                    confirmButtonText: "Informar dados",
	                    cancelButtonText: "Fechar",
	                    closeOnConfirm: false
	                }, function () {
	                    swal.close();
	                }.bind(this));
	            }
	        }.bind(this));
	    };
	    OrdemServicosFormComponent.prototype.clickGoToFrotaDetail = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
	    };
	    OrdemServicosFormComponent.prototype.clickGoToFrotaList = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToList(this.frotaRoute);
	    };
	    OrdemServicosFormComponent.prototype.clickGoToManutProg = function () {
	        this._manutencaoProgramadaService.clearSessionStorage();
	        this._manutencaoProgramadaNavigationService.goToList();
	    };
	    OrdemServicosFormComponent.prototype.onSubmit = function (evt) {
	        this.complete = false;
	        this.onSend(evt);
	    };
	    OrdemServicosFormComponent.prototype.getLocalidadeObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._ordemServicosService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                localidade: object.text,
	                form: data_service_2.ordensServicoStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_3.localidadesStorage);
	            this._localidadeNavigationService.goToNew();
	        }
	        else {
	            this.localidadeObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'localidade', object);
	        }
	    };
	    OrdemServicosFormComponent.prototype.getFrotaObject = function (object) {
	        this.frotaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'bem', object);
	        this.changeFormaControle();
	    };
	    OrdemServicosFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.bem = this.frotaObject;
	        object.localidade = this.localidadeObject;
	        object.tipo = this.tipoObject.Key;
	        return object;
	    };
	    OrdemServicosFormComponent.prototype.onSend = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            //this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject), date;
	            if (this.frotaObject.id) {
	                object.bemId = this.frotaObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.localidadeObject.id) {
	                object.localidadeId = this.localidadeObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.tipoObject.Key) {
	                object.tipo = this.tipoObject.Key;
	            }
	            if (object.status) {
	                object.status = object.status;
	            }
	            object.odometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.odometroHorimetroValue);
	            delete object['odometroHorimetroValue'];
	            if (!object.odometroHorimetro) {
	                object.odometroHorimetroId = null;
	            }
	            date = document.getElementById('dataEntrada');
	            if (date.value) {
	                object.dataEntrada = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.dataEntrada = null;
	            }
	            date = document.getElementById('dataSaida');
	            if (date.value) {
	                object.dataSaida = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.dataSaida = null;
	            }
	            if (this.complete) {
	                var statusConcluido = this._ordemServicoService.getStatusConcluido();
	                object.status = statusConcluido.Key;
	            }
	            if (this.formObject.id) {
	                this.onEditOrdemServicos(object);
	            }
	            else {
	                object.status = this._ordemServicosService.getStatusAtivo();
	                object.status = object.status.Key;
	                this.onAddOrdemServicos(object);
	            }
	        }
	    };
	    OrdemServicosFormComponent.prototype.onAddOrdemServicos = function (object) {
	        this._ordemServicosApiService.onPost(object, this.onDone);
	    };
	    OrdemServicosFormComponent.prototype.onEditOrdemServicos = function (object) {
	        this._ordemServicosApiService.onPut(object, this.onDone);
	    };
	    OrdemServicosFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma manutenção encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._ordemServicosApiService.onGetById(id, onDone);
	    };
	    OrdemServicosFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._ordemServicosService.getSessionStorage();
	        this._ordemServicosService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    OrdemServicosFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_1.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_1.newRouteFemale;
	        }
	    };
	    OrdemServicosFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    OrdemServicosFormComponent.prototype.setNewNormal = function () {
	        this.tipoObject = this.tiposList[0];
	    };
	    OrdemServicosFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.dataEntrada) {
	            if (this.formObject.dataEntrada.indexOf("/") === -1) {
	                this.formObject.dataEntrada = this._utilService.convertDateToString(this.formObject.dataEntrada);
	            }
	        }
	        if (this.formObject.dataEmpenho) {
	            if (this.formObject.dataEmpenho.indexOf("/") === -1) {
	                this.formObject.dataEmpenho = this._utilService.convertDateToString(this.formObject.dataEmpenho);
	            }
	        }
	        if (this.formObject.localidade) {
	            this.localidadeObject = this._utilService.cloneObject(this.formObject.localidade);
	            delete this.formObject['localidade'];
	            var selectObject = { text: this.localidadeObject.localidade, id: this.localidadeObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.localidadeSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.localidadeSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'localidade', this.localidadeObject);
	        }
	        if (this.formObject.bem) {
	            var text = '';
	            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
	            delete this.formObject['bem'];
	            if (this.frotaObject.placa) {
	                text = this.frotaObject.placa + ' / ';
	            }
	            var selectObject = { text: text.concat(this.frotaObject.identificacao), id: this.frotaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'bem', this.frotaObject);
	            this.changeFormaControle();
	        }
	        if (this.formObject.odometroHorimetro) {
	            this.formObject.odometroHorimetroValue = this._formaControleService.setOdometroHorimetroToForm(this.formObject.odometroHorimetro.odometroHorimetro);
	            delete this.formObject['odometroHorimetro'];
	        }
	        this.tipoObject = this._ordemServicosService.getTipoOrdemServico(this.formObject.tipo);
	    };
	    OrdemServicosFormComponent.prototype.goToList = function () {
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaManutencao(this.frotaRoute);
	        }
	        else {
	            this._ordemServicosNavigationService.goToList();
	        }
	    };
	    OrdemServicosFormComponent.prototype.goToDetail = function (osId) {
	        var id = this.formObject.id;
	        if (osId) {
	            id = osId;
	        }
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaManutencaoDetail(this.frotaRoute, id);
	        }
	        else {
	            this._ordemServicosNavigationService.goToDetail(id);
	        }
	    };
	    OrdemServicosFormComponent.prototype.changeFormaControle = function () {
	        this.showTipoOdometro = this._formaControleService.changeFormaControle(this.frotaObject.formaControleId);
	    };
	    OrdemServicosFormComponent.prototype.testFrotaBackHistory = function () {
	        var settings = this._frotaService.testBackHistory(this.frotaSelectId);
	        this.frotaDetailHistory = settings.frotaDetailHistory;
	        this.frotasModule = settings.frotasModule;
	        this.frotaRoute = settings.frotaRoute;
	        this.showFrotaLink = settings.showFrotaLink;
	        if (this.showFrotaLink) {
	            this.getFrotaObject(this.frotaDetailHistory);
	        }
	        else {
	            this.testManutencaoProgramadaBackHistory();
	        }
	    };
	    OrdemServicosFormComponent.prototype.testManutencaoProgramadaBackHistory = function () {
	        var manut = this._manutencaoProgramadaService.getSessionStorage();
	        if (manut) {
	            this.showManutencaoProgramadaLink = true;
	            if (manut.length) {
	                this._frotaService.setAutocompleteOption(this.frotaSelectId, manut[0].bem);
	                this.getFrotaObject(manut[0].bem);
	            }
	        }
	    };
	    OrdemServicosFormComponent.prototype.saveServicos = function (osId) {
	        var servicos = this._manutencaoProgramadaService.getSessionStorage();
	        var list = [], servicosId = [];
	        servicos.forEach(function (item) {
	            if (item.servico) {
	                list.push({
	                    descricao: item.servico.descricao,
	                    quantidade: 1,
	                    valor: item.servico.valor,
	                    ordemServicoId: osId,
	                    servicoId: item.servico.id,
	                    data: new Date(),
	                    ativo: true
	                });
	                servicosId.push(item.servico.id);
	            }
	        }.bind(this));
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.saveMateriais(servicosId, osId);
	            }
	        }.bind(this));
	        if (list.length) {
	            var obj = { ordemServicoId: osId, bemId: this.frotaObject.id, Servicos: list };
	            this._servicoApiService.onPostServicosOrdemServico(obj, onDone);
	        }
	        else {
	            this.goToDetail(osId);
	        }
	    };
	    OrdemServicosFormComponent.prototype.saveMateriais = function (servicos, osId) {
	        var onDone = (function (Response) {
	            var list = [];
	            Response.forEach(function (item) {
	                if (item.material) {
	                    list.push({
	                        descricao: item.material.descricao,
	                        quantidade: item.quantidade,
	                        medidaId: item.material.medidaId,
	                        materialId: item.material.id,
	                        ordemServicoId: osId,
	                        ativo: true
	                    });
	                }
	            }.bind(this));
	            var obj = { ordemServicoId: osId, Materiais: list };
	            this._materialOrdemServicoApiService.onPostMateriaisOrdemServico(obj, onDone2);
	        }.bind(this));
	        var onDone2 = (function (Response) {
	            if (!Response.error) {
	                this.goToDetail(osId);
	            }
	        }.bind(this));
	        var query = { "where": { "servicoId": { "inq": servicos } } };
	        this._materialServicoApiService.onGetCustomFilter(query, onDone);
	    };
	    OrdemServicosFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(434),
	            styles: [__webpack_require__(435)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof ordem_servico_api_service_1.OrdemServicoApiService !== 'undefined' && ordem_servico_api_service_1.OrdemServicoApiService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _c) || Object, (typeof (_d = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _g) || Object, (typeof (_h = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _h) || Object, (typeof (_j = typeof localidade_api_service_1.LocalidadeApiService !== 'undefined' && localidade_api_service_1.LocalidadeApiService) === 'function' && _j) || Object, (typeof (_k = typeof localidade_navigation_service_1.LocalidadeNavigationService !== 'undefined' && localidade_navigation_service_1.LocalidadeNavigationService) === 'function' && _k) || Object, (typeof (_l = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _l) || Object, (typeof (_m = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _m) || Object, (typeof (_o = typeof manutencao_programada_service_1.ManutencaoProgramadaService !== 'undefined' && manutencao_programada_service_1.ManutencaoProgramadaService) === 'function' && _o) || Object, (typeof (_p = typeof manutencao_programada_navigation_service_1.ManutencaoProgramadaNavigationService !== 'undefined' && manutencao_programada_navigation_service_1.ManutencaoProgramadaNavigationService) === 'function' && _p) || Object, (typeof (_q = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _q) || Object, (typeof (_r = typeof material_servico_api_service_1.MaterialServicoApiService !== 'undefined' && material_servico_api_service_1.MaterialServicoApiService) === 'function' && _r) || Object, (typeof (_s = typeof material_ordem_servico_api_service_1.MaterialOrdemServicoApiService !== 'undefined' && material_ordem_servico_api_service_1.MaterialOrdemServicoApiService) === 'function' && _s) || Object, (typeof (_t = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _t) || Object, (typeof (_u = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _u) || Object])
	    ], OrdemServicosFormComponent);
	    return OrdemServicosFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
	}());
	exports.OrdemServicosFormComponent = OrdemServicosFormComponent;


/***/ },
/* 427 */
/***/ function(module, exports) {

	"use strict";
	var OrdemServico = (function () {
	    function OrdemServico() {
	    }
	    return OrdemServico;
	}());
	exports.OrdemServico = OrdemServico;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(234);
	var data_service_2 = __webpack_require__(423);
	var auth_service_1 = __webpack_require__(61);
	var data_service_3 = __webpack_require__(200);
	var data_service_4 = __webpack_require__(178);
	var data_service_5 = __webpack_require__(429);
	var ManutencaoProgramadaNavigationService = (function () {
	    function ManutencaoProgramadaNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    ManutencaoProgramadaNavigationService.prototype.goToList = function () {
	        var router = data_service_1.manutencoesRoute + '/' + data_service_2.manutencoesProgramadaRoute;
	        this._authService.navigateTo(router);
	    };
	    ManutencaoProgramadaNavigationService.prototype.goToNewOS = function () {
	        var router = data_service_1.manutencoesRoute + '/' + data_service_2.manutencoesProgramadaRoute + '/' + data_service_3.ordensServicoRoute + '/' + data_service_4.newRoute;
	        this._authService.navigateTo(router);
	    };
	    ManutencaoProgramadaNavigationService.prototype.goToServico = function (benServicoId) {
	        var router = data_service_1.manutencoesRoute + '/' + data_service_2.manutencoesProgramadaRoute + '/' + data_service_5.servicosRoute;
	        this._authService.navigateTo(router, benServicoId);
	    };
	    ManutencaoProgramadaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ManutencaoProgramadaNavigationService);
	    return ManutencaoProgramadaNavigationService;
	    var _a;
	}());
	exports.ManutencaoProgramadaNavigationService = ManutencaoProgramadaNavigationService;


/***/ },
/* 429 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'servicos';
	exports.servicosRoute = 'servicos';
	exports.servicosStorage = 'servicos';
	exports.servicosModuleName = { plural: 'Serviços', single: 'Serviço' };
	//servico planos
	exports.servicoPlanosApiName = 'servicos-planos-manutencoes';
	exports.servicoPlanosStorage = 'servicoPlanos';
	exports.servicoPlanosComponentName = { plural: 'Serviços', single: 'Serviço' };
	//servico ordem servico
	exports.servicoOrdensServicoApiName = 'servicos-ordens-servicos';
	//servico bens
	exports.servicoBensApiName = 'servicos-bens';
	exports.servicoBensStorage = 'servicoBens';
	exports.servicosQuery = {
	    "where": {
	        "ativo": true,
	        "descricao": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "descricao"
	};


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(429);
	var ServicoApiService = (function () {
	    function ServicoApiService(_restService) {
	        this._restService = _restService;
	    }
	    ServicoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    ServicoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    ServicoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    ServicoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "descricao" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ServicoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    ServicoApiService.prototype.onGetWithMateriais = function (done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', {}, done); //busca servicos populado com materiais
	    };
	    ServicoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //servicos planos
	    ServicoApiService.prototype.onPostServicoPlano = function (object, done) {
	        this._restService.onPost(data_service_1.servicoPlanosApiName, object, done);
	    };
	    ServicoApiService.prototype.onPutServicoPlano = function (object, done) {
	        this._restService.onPut(data_service_1.servicoPlanosApiName, object, done);
	    };
	    ServicoApiService.prototype.onDeleteServicoPlano = function (objectId, done) {
	        this._restService.onDelete(data_service_1.servicoPlanosApiName, objectId, done);
	    };
	    ServicoApiService.prototype.onGetAllServicoPlano = function (done) {
	        var filter = { "include": ["plano", "servico"] };
	        this._restService.onGetPost(data_service_1.servicoPlanosApiName, filter, done);
	    };
	    ServicoApiService.prototype.onGetByIdServicoPlano = function (objectId, done) {
	        var filter = { "include": ["plano", "servico"] };
	        this._restService.onGetPostId(data_service_1.servicoPlanosApiName, objectId, filter, done);
	    };
	    ServicoApiService.prototype.onGetByPlanoServicoPlano = function (planoId, done) {
	        var filter = { "where": { "planoId": planoId }, "include": ["servico"] };
	        this._restService.onGetPost(data_service_1.servicoPlanosApiName, filter, done);
	    };
	    //servicos bens
	    ServicoApiService.prototype.onPostServicoBem = function (object, done) {
	        this._restService.onPost(data_service_1.servicoBensApiName, object, done);
	    };
	    ServicoApiService.prototype.onPostServicosBem = function (object, done) {
	        this._restService.onPostCustom(data_service_1.servicoBensApiName + '/bulk', object, done);
	    };
	    ServicoApiService.prototype.onPutServicoBem = function (object, done) {
	        this._restService.onPut(data_service_1.servicoBensApiName, object, done);
	    };
	    ServicoApiService.prototype.onDeleteServicoBem = function (objectId, done) {
	        this._restService.onDelete(data_service_1.servicoBensApiName, objectId, done);
	    };
	    ServicoApiService.prototype.onGetByBemServicoBem = function (bemId, done) {
	        var filter = { "where": { "bemId": bemId }, "include": ["servico", { "plano": ["marca", "categoria"] }] };
	        this._restService.onGetPost(data_service_1.servicoBensApiName, filter, done);
	    };
	    ServicoApiService.prototype.onGetByIdServicoBem = function (objectId, done) {
	        var filter = { "include": ["servico", "bem"] };
	        this._restService.onGetPostId(data_service_1.servicoBensApiName, objectId, filter, done);
	    };
	    ServicoApiService.prototype.onDeleteServicosBem = function (list, done) {
	        this._restService.onPostCustom(data_service_1.servicoBensApiName + "/remover-lista", list, done);
	    };
	    //servicos ordens servico
	    ServicoApiService.prototype.onPostServicoOrdemServico = function (object, done) {
	        this._restService.onPost(data_service_1.servicoOrdensServicoApiName, object, done);
	    };
	    ServicoApiService.prototype.onPutServicoOrdemServico = function (object, done) {
	        this._restService.onPut(data_service_1.servicoOrdensServicoApiName, object, done);
	    };
	    ServicoApiService.prototype.onDeleteServicoOrdemServico = function (objectId, done) {
	        this._restService.onDelete(data_service_1.servicoOrdensServicoApiName, objectId, done);
	    };
	    ServicoApiService.prototype.onGetAllServicoOrdemServico = function (done) {
	        var filter = { "include": ["medida", "servico", "ordemServico"] };
	        this._restService.onGetPost(data_service_1.servicoOrdensServicoApiName, filter, done);
	    };
	    ServicoApiService.prototype.onGetByIdServicoOrdemServico = function (objectId, done) {
	        var filter = { "include": ["medida", "servico", "ordemServico"] };
	        this._restService.onGetPostId(data_service_1.servicoOrdensServicoApiName, objectId, filter, done);
	    };
	    ServicoApiService.prototype.onPostServicosOrdemServico = function (servicos, done) {
	        this._restService.onPostCustom(data_service_1.servicoOrdensServicoApiName + '/bulk', servicos, done);
	    };
	    ServicoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ServicoApiService);
	    return ServicoApiService;
	    var _a;
	}());
	exports.ServicoApiService = ServicoApiService;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var MaterialServicoApiService = (function () {
	    function MaterialServicoApiService(_restService) {
	        this._restService = _restService;
	        this.apiName = 'materiais-servicos';
	    }
	    MaterialServicoApiService.prototype.onGetByServico = function (servicoId, done) {
	        var filter = { "where": { "servicoId": servicoId }, "include": [{ "material": ["medida"] }] };
	        this._restService.onGetPost(this.apiName, filter, done);
	    };
	    MaterialServicoApiService.prototype.onGetCustomFilter = function (filter, done) {
	        filter.include = [{ "material": ["medida"] }];
	        this._restService.onGetPost(this.apiName, filter, done);
	    };
	    MaterialServicoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], MaterialServicoApiService);
	    return MaterialServicoApiService;
	    var _a;
	}());
	exports.MaterialServicoApiService = MaterialServicoApiService;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(433);
	var rest_service_1 = __webpack_require__(26);
	var MaterialOrdemServicoApiService = (function () {
	    function MaterialOrdemServicoApiService(_restService) {
	        this._restService = _restService;
	    }
	    //materiais ordens material
	    MaterialOrdemServicoApiService.prototype.onPostMaterialOrdemServico = function (object, done) {
	        this._restService.onPost(data_service_1.materialOrdensMaterialApiName, object, done);
	    };
	    MaterialOrdemServicoApiService.prototype.onPutMaterialOrdemServico = function (object, done) {
	        this._restService.onPut(data_service_1.materialOrdensMaterialApiName, object, done);
	    };
	    MaterialOrdemServicoApiService.prototype.onDeleteMaterialOrdemServico = function (objectId, done) {
	        this._restService.onDelete(data_service_1.materialOrdensMaterialApiName, objectId, done);
	    };
	    MaterialOrdemServicoApiService.prototype.onGetAllMaterialOrdemServico = function (done) {
	        var filter = { "include": ["medida", "material", "ordemServico"] };
	        this._restService.onGetPost(data_service_1.materialOrdensMaterialApiName, filter, done);
	    };
	    MaterialOrdemServicoApiService.prototype.onGetByIdMaterialOrdemServico = function (objectId, done) {
	        var filter = { "include": ["material"] };
	        this._restService.onGetPostId(data_service_1.materialOrdensMaterialApiName, objectId, filter, done);
	    };
	    MaterialOrdemServicoApiService.prototype.onPostMateriaisOrdemServico = function (materiais, done) {
	        this._restService.onPostCustom(data_service_1.materialOrdensMaterialApiName + '/bulk', materiais, done);
	    };
	    MaterialOrdemServicoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], MaterialOrdemServicoApiService);
	    return MaterialOrdemServicoApiService;
	    var _a;
	}());
	exports.MaterialOrdemServicoApiService = MaterialOrdemServicoApiService;


/***/ },
/* 433 */
/***/ function(module, exports) {

	"use strict";
	//material ordem servico
	exports.materialOrdensMaterialApiName = 'materiais-ordens-servicos';
	exports.materialOrdensMaterialRoute = 'os-materiais';
	exports.materialOrdensMateriaistorage = 'materialOrdensServico';
	exports.materialOrdensMaterialComponentName = { plural: 'Materiais', single: 'Material' };


/***/ },
/* 434 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\" *ngIf=\"showFrotaLink\"><a (click)=\"clickGoToFrotaList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n        <li class=\"item\" *ngIf=\"showFrotaLink\"><a (click)=\"clickGoToFrotaDetail()\" class=\"cursor-pointer\">{{frotaDetailHistory.identificacao}}</a></li>\n\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{ordemServicosModule.plural}}</a></li>\n        <li class=\"item\" *ngIf=\"showManutencaoProgramadaLink\"><a (click)=\"clickGoToManutProg()\" class=\"cursor-pointer\">{{manutencaoProgramadaModule.plural}}</a></li>\n        <li class=\"item\" *ngIf=\"formObject.id\"><a (click)=\"clickGoToDetail()\" class=\"cursor-pointer\" >{{formObject.numero}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{ordemServicosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{ordemServicosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipo.valid && submitted}\">\n                <label>Tipo <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!tipo.valid && submitted\">Este campo é obrigatório.</span>\n                    <select id=\"tipo\" [(ngModel)]=\"tipoObject\" formControlName=\"tipo\">\n                        <option *ngFor=\"let item of tiposList\" [ngValue]=\"item\">{{item.Value}}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"geo-columns--12c\">\n            <autocomplete-component class=\"geo-input--3c\" id=\"localidade\"\n                                    (setObejct)=\"getLocalidadeObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"localidadeSelectId\"\n                                    [model]=\"localidadeObject\"\n                                    [_service]=\"_localidadeApiService\"\n                                    [fieldToShow]=\"'localidade'\"\n                                    [query]=\"localidadeQuery\"\n                                    [label]=\"'Localidade'\"></autocomplete-component>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"frota\"\n                                    (setObejct)=\"getFrotaObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [isCreateNew]=\"false\"\n                                    [selectId]=\"frotaSelectId\"\n                                    [model]=\"frotaObject\"\n                                    [_service]=\"_frotaApiService\"\n                                    [templateResult]=\"frotaTemplateResult\"\n                                    [query]=\"frotaQuery\"\n                                    [label]=\"'Frota / equipamento'\"></autocomplete-component>\n\n            <div class=\"geo-input--6c\">\n                <label for=\"identificacao\">Identificação </label>\n                <div>\n                    <input type=\"text\" class=\"form-control\" id=\"identificacao\" placeholder=\"\" [(ngModel)]=\"frotaObject.identificacao\" formControlName=\"bemText\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label>Número do empenho </label>\n                <div>\n                    <input type=\"text\" id=\"numero_empenho\" [(ngModel)]=\"formObject.numeroEmpenho\" appNumberInteger  formControlName=\"numeroEmpenho\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c geo-input--datepicker\"  [ngClass]=\"{'geo-input--error': !dataEntrada.value && submitted}\">\n                <label for=\"dataEntrada\">Data da entrada <abbr>*</abbr></label>\n                <div>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"dataEntrada\" [(ngModel)]=\"formObject.dataEntrada\" formControlName=\"dataEntrada\" appDatepicker autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c geo-input--datepicker\">\n                <label>Data prevista de saída </label>\n                <div>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"dataSaida\" [(ngModel)]=\"formObject.dataSaida\" formControlName=\"dataSaida\" appDatepicker autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <app-odometro-horimetro-form-component [labelOdometro]=\"'Odômetro de saída'\"\n                                                   [labelHorimetro]=\"'Horímetro de saída'\"\n                                                   [showOdometro]=\"showTipoOdometro\"\n                                                   [required]=\"formObject.status === statusConcluido\"\n                                                   [submitted]=\"submitted\"\n                                                   [model]=\"formObject.odometroHorimetroValue\"\n                                                   (returnModel)=\"formObject.odometroHorimetroValue = $event\"\n                                                   [bemId]=\"frotaObject.id\"></app-odometro-horimetro-form-component>\n\n            <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !problemaInformado.valid && submitted}\">\n                <label for=\"problemaInformado\">Descrição do problema <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!problemaInformado.valid && submitted\">Este campo é obrigatório.</span>\n                    <textarea id=\"problemaInformado\" [(ngModel)]=\"formObject.problemaInformado\" formControlName=\"problemaInformado\"></textarea>\n                </div>\n            </div>\n\n            <div class=\"geo-input--12c\">\n                <label>Laudo </label>\n                <div>\n                    <textarea id=\"laudo\" [(ngModel)]=\"formObject.laudo\" formControlName=\"laudo\"></textarea>\n                </div>\n            </div>\n\n            <div class=\"geo-input--12c\">\n                <label>Observação </label>\n                <div>\n                    <textarea id=\"observacoes\" [(ngModel)]=\"formObject.observacoes\" formControlName=\"observacoes\"></textarea>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n        <button type=\"button\" class=\"geo-button--action geo-button\" (click)=\"clickComplete()\" *ngIf=\"formObject.id\">Concluir</button>\n    </div>\n</form>\n";

/***/ },
/* 435 */
166,
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(200);
	var ordem_servico_model_1 = __webpack_require__(427);
	var util_service_1 = __webpack_require__(88);
	var ordem_servico_api_service_1 = __webpack_require__(421);
	var ordem_servico_service_1 = __webpack_require__(235);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var frota_service_1 = __webpack_require__(203);
	var frota_navigation_service_1 = __webpack_require__(198);
	var OrdemServicoDetailComponent = (function () {
	    function OrdemServicoDetailComponent(_ordemServicoApiService, _ordemServicoNavigationService, _ordemServicoService, _route, _frotaService, _frotaNavigationService, _utilService) {
	        this._ordemServicoApiService = _ordemServicoApiService;
	        this._ordemServicoNavigationService = _ordemServicoNavigationService;
	        this._ordemServicoService = _ordemServicoService;
	        this._route = _route;
	        this._frotaService = _frotaService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._utilService = _utilService;
	        this.ordensServicoModule = data_service_1.ordensServicoModuleName;
	        this.detail = new ordem_servico_model_1.OrdemServico();
	        this.statusObject = {};
	        this.tipoObject = {};
	        this.tabSelected = 'detalhes';
	        this.total = 0;
	        this.materiaisList = [];
	        this.servicosList = [];
	        this.totalServicos = 0;
	        this.totalMateriais = 0;
	        this.showFrotaLink = false;
	        this.frotaDetailHistory = {};
	        this.frotasModule = {};
	    }
	    OrdemServicoDetailComponent.prototype.ngOnInit = function () {
	        this.getObject();
	        this.getMateriaisServicos();
	        this.testFrotaBackHistory();
	    };
	    OrdemServicoDetailComponent.prototype.clickEdit = function () {
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaManutencaoEdit(this.frotaRoute, this.detail.id);
	        }
	        else {
	            this._ordemServicoNavigationService.goToEdit(this.detail.id);
	        }
	    };
	    OrdemServicoDetailComponent.prototype.clickList = function () {
	        if (this.showFrotaLink) {
	            this._frotaNavigationService.goToFrotaManutencao(this.frotaRoute);
	        }
	        else {
	            this._ordemServicoNavigationService.goToList();
	        }
	    };
	    OrdemServicoDetailComponent.prototype.clickGoToFrotaDetail = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
	    };
	    OrdemServicoDetailComponent.prototype.clickGoToFrotaList = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToList(this.frotaRoute);
	    };
	    OrdemServicoDetailComponent.prototype.clickCancel = function () {
	        this.cancel();
	    };
	    OrdemServicoDetailComponent.prototype.clickComplete = function () {
	        this.complete();
	    };
	    OrdemServicoDetailComponent.prototype.setTab = function (tab) {
	        this.tabSelected = tab;
	    };
	    OrdemServicoDetailComponent.prototype.isTab = function (tab) {
	        return (tab === this.tabSelected);
	    };
	    OrdemServicoDetailComponent.prototype.getObject = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.detail = Response;
	                this.setToModel();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma manutenção encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        var id = +this._route.snapshot.params['id'];
	        this._ordemServicoApiService.onGetById(id, onDone);
	    };
	    OrdemServicoDetailComponent.prototype.cancel = function () {
	        var onDone = (function (Resposta) {
	            if (!Resposta.error) {
	                this.statusObject = this._ordemServicoService.getStatusCancelado();
	                swal("Sucesso!", "A manutenção foi cancelada com sucesso.", "success");
	            }
	            else {
	                swal("Erro!", "Não foi possível cancelar a manutenção.", "error");
	            }
	        }.bind(this));
	        swal({
	            title: "Você deseja realmente cancelar esta manutenção?",
	            text: "Os materias alocados para realizar esta manutenção serão devolvidos ao almoxarifado. Esta operação não poderá ser desfeita!",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Cancelar",
	            cancelButtonText: "Fechar",
	            closeOnConfirm: false
	        }, function () {
	            var statusCancelado = this._ordemServicoService.getStatusCancelado();
	            var obj = { id: this.detail.id, status: statusCancelado.Key };
	            this._ordemServicoApiService.onPut(obj, onDone);
	        }.bind(this));
	    };
	    OrdemServicoDetailComponent.prototype.complete = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.statusObject = this._ordemServicoService.getStatusConcluido();
	                swal("Sucesso!", "A manutenção foi concluída com sucesso.", "success");
	            }
	            else {
	                swal("Erro!", "Não foi possível concluir a manutenção.", "error");
	            }
	        }.bind(this));
	        swal({
	            title: "Você deseja realmente concluir esta manutenção?",
	            text: "Esta operação não poderá ser desfeita!",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Concluir",
	            cancelButtonText: "Fechar",
	            closeOnConfirm: false
	        }, function () {
	            if (this.detail.dataSaida && this.detail.laudo && this.detail.odometroHorimetroId) {
	                var statusConcluido = this._ordemServicoService.getStatusConcluido();
	                var obj = { id: this.detail.id, status: statusConcluido.Key };
	                this._ordemServicoApiService.onPut(obj, onDone);
	            }
	            else {
	                swal({
	                    title: "Dados incompletos para concluir a manutenção",
	                    text: "Para concluir a manutenção informe o laudo, a data de saída e o odômetro/horímetro!",
	                    type: "warning",
	                    showCancelButton: true,
	                    confirmButtonText: "Informar dados",
	                    cancelButtonText: "Fechar",
	                    closeOnConfirm: false
	                }, function () {
	                    swal.close();
	                    this.clickEdit();
	                }.bind(this));
	            }
	        }.bind(this));
	    };
	    OrdemServicoDetailComponent.prototype.setToModel = function () {
	        if (this.detail.status) {
	            this.statusObject = this._ordemServicoService.getStatusOrdemServico(this.detail.status);
	        }
	        if (this.detail.tipo) {
	            this.tipoObject = this._ordemServicoService.getTipoOrdemServico(this.detail.tipo);
	        }
	    };
	    OrdemServicoDetailComponent.prototype.getMateriaisServicos = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var total = 0, servicos = [], materiais = [], totalServicos = 0, totalMateriais = 0, tipoServico = this._ordemServicoService.getItemTipoServico();
	                tipoServico = tipoServico.Key;
	                Response.forEach(function (item) {
	                    item.valorUnitario = (item.valor / item.quantidade).toFixed(2);
	                    total += item.valor;
	                    if (item.Tipo.Key === tipoServico) {
	                        servicos.push(item);
	                        totalServicos += item.valor;
	                    }
	                    else {
	                        materiais.push(item);
	                        totalMateriais += item.valor;
	                    }
	                }.bind(this));
	                this.materiaisList = materiais;
	                this.servicosList = servicos;
	                this.totalServicos = totalServicos;
	                this.totalMateriais = totalMateriais;
	                this.total = total;
	            }
	        }.bind(this));
	        var id = +this._route.snapshot.params['id'];
	        this._ordemServicoApiService.onGetByIdMateriaisServicos(id, onDone);
	    };
	    OrdemServicoDetailComponent.prototype.testFrotaBackHistory = function () {
	        var settings = this._frotaService.testBackHistory();
	        this.frotaDetailHistory = settings.frotaDetailHistory;
	        this.frotasModule = settings.frotasModule;
	        this.frotaRoute = settings.frotaRoute;
	        this.showFrotaLink = settings.showFrotaLink;
	    };
	    OrdemServicoDetailComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(437),
	            styles: [__webpack_require__(438)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ordem_servico_api_service_1.OrdemServicoApiService !== 'undefined' && ordem_servico_api_service_1.OrdemServicoApiService) === 'function' && _a) || Object, (typeof (_b = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _e) || Object, (typeof (_f = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _f) || Object, (typeof (_g = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _g) || Object])
	    ], OrdemServicoDetailComponent);
	    return OrdemServicoDetailComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.OrdemServicoDetailComponent = OrdemServicoDetailComponent;


/***/ },
/* 437 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\" *ngIf=\"showFrotaLink\"><a (click)=\"clickGoToFrotaList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n            <li class=\"item\" *ngIf=\"showFrotaLink\"><a (click)=\"clickGoToFrotaDetail()\" class=\"cursor-pointer\">{{frotaDetailHistory.identificacao}}</a></li>\n\n            <li class=\"item\"><a (click)=\"clickList()\" class=\"cursor-pointer\">{{ordensServicoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{detail.numero}}</a></li>\n        </ul>\n        <h1>{{detail.numero}}</h1>\n        <p><strong>Status: </strong>{{statusObject.Value}}</p>\n        <p><strong>Data da entrada: </strong>{{detail.dataEntrada | date:'dd/MM/yyyy'}}</p>\n        <p><strong>Data prevista de saída: </strong> <span *ngIf=\"detail.dataSaida\">{{detail.dataSaida | date:'dd/MM/yyyy'}}</span> <i *ngIf=\"!detail.dataSaida\">não cadastrado</i></p>\n        <p><strong>Total: </strong> {{total | currencyMask}} <span *ngIf=\"!total\">R$ 0,00</span></p>\n    </div>\n    <div class=\"geo-columns--6c geo-columns--right\">\n        <div class=\"geo-columns--12c\" *ngIf=\"statusObject.Key === 1\">\n            <a (click)=\"clickComplete()\" class=\"geo-button--action geo-button__icon--add\">Concluir</a>\n        </div>\n        <div class=\"geo-columns--12c\" *ngIf=\"statusObject.Key === 1\">\n            <a (click)=\"clickCancel()\" class=\"geo-button\">Cancelar</a>\n        </div>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <nav class=\"geo-tabs\">\n        <ul class=\"items\">\n            <li class=\"item\">\n                <a (click)=\"setTab('detalhes')\" [ngClass]=\"{'active': isTab('detalhes')}\" class=\"item-link\">Detalhes</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('servicos')\" [ngClass]=\"{'active': isTab('servicos')}\" class=\"item-link\">Serviços</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('materiais')\" [ngClass]=\"{'active': isTab('materiais')}\" class=\"item-link\">Materiais</a>\n            </li>\n        </ul>\n    </nav>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('detalhes')\">\n        <a class=\"geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickEdit()\" *ngIf=\"statusObject.Key === 1\">Alterar</a>\n\n        <p><strong>Tipo: </strong> <span *ngIf=\"detail.tipo\">{{tipoObject.Value}}</span> <i *ngIf=\"!detail.tipo\">não cadastrado</i></p>\n        <p><strong>Localidade: </strong><span *ngIf=\"detail.localidade\">{{detail.localidade.localidade}}</span> <i *ngIf=\"!detail.localidade\">não cadastrado</i></p>\n        <p><strong>Registro / placa: </strong> <span *ngIf=\"detail.bem\">{{detail.bem.codigo}}</span> <span *ngIf=\"detail.bem && detail.bem.placa\"  class=\"text-uppercase\"> / {{detail.bem.placa | licensePlateMask}} </span><i *ngIf=\"!detail.bem\">não cadastrado</i></p>\n        <p><strong>Identificação: </strong><span *ngIf=\"detail.bem\">{{detail.bem.identificacao}}</span> <i *ngIf=\"!detail.bem\">não cadastrado</i></p>\n        <p><strong>Número do empenho: </strong> {{detail.numeroEmpenho}} <i *ngIf=\"!detail.numeroEmpenho\">não cadastrado</i></p>\n        <p>\n            <app-odometro-horimetro-label-component [labelHorimetro]=\"'Horímetro de saída: '\"\n                                                    [labelOdometro]=\"'Odômetro de saída: '\"\n                                                    [odometroHorimetroObject]=\"detail.odometroHorimetro\"\n                                                    [bemObject]=\"detail.bem\"></app-odometro-horimetro-label-component>\n        </p>\n        <p><strong>Descrição do problema: </strong>{{detail.problemaInformado}} <i *ngIf=\"!detail.problemaInformado\">não cadastrado</i></p>\n        <p><strong>Laudo: </strong>{{detail.laudo}} <i *ngIf=\"!detail.laudo\">não cadastrado</i></p>\n        <p><strong>Observação: </strong>{{detail.observacoes}} <i *ngIf=\"!detail.observacoes\">não cadastrado</i></p>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('servicos')\">\n        <app-ordem-servico-item-table [statusObject]=\"statusObject\"\n                                      [osObject]=\"detail\"\n                                      [total]=\"totalServicos\"\n                                      [totalOs]=\"total\"\n                                      [list]=\"servicosList\"\n                                      [tipo]=\"'servico'\"></app-ordem-servico-item-table>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('materiais')\">\n        <app-ordem-servico-item-table [statusObject]=\"statusObject\"\n                                      [osObject]=\"detail\"\n                                      [total]=\"totalMateriais\"\n                                      [totalOs]=\"total\"\n                                      [list]=\"materiaisList\"\n                                      [tipo]=\"'material'\"></app-ordem-servico-item-table>\n    </div>\n</div>\n";

/***/ },
/* 438 */
/***/ function(module, exports) {

	module.exports = ".button-search-icon {\n  text-align: left;\n}\n.button-search-icon button {\n  width: 20px;\n  height: 20px;\n  background-color: transparent;\n  border: none;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iXzAxXy1fY2FtcG9fZGVfYnVzY2FfbWVudV9jbG9zZSIgZGF0YS1uYW1lPSIwMSAtIGNhbXBvIGRlIGJ1c2NhIG1lbnUgY2xvc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE0IDE0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6Izc0NzQ3NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24tcGVzcXVpc2EtYmFyPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNTk5LjA2LDg2LjhoLTAuNjNsLTAuMjItLjIyYTUuMiw1LjIsMCwxLDAtLjU2LjU2bDAuMjEsMC4yMlY4OGw0LDQsMS4xOS0xLjE5Wm0tNC44LDBhMy42LDMuNiwwLDEsMSwzLjYtMy42QTMuNiwzLjYsMCwwLDEsMTU5NC4yNiw4Ni44WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1ODkuMDYgLTc4KSIvPjwvc3ZnPg==);\n  cursor: pointer;\n  padding: 6px;\n}\n.button-search-icon button:active,\n.button-search-icon button:focus {\n  outline: 0;\n}\n.table-svg {\n  position: relative;\n  top: 7px;\n}\n.table-svg.left{\n  fill: #7d4b0e;\n}\n.table-svg.down{\n  fill: #df1d1d;\n}\n.table-svg.up{\n  fill: #268d19;\n}\n.table-svg.shuffle{\n  fill: #f87316;\n}\n"

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var servico_api_service_1 = __webpack_require__(430);
	var servico_service_1 = __webpack_require__(440);
	var util_service_1 = __webpack_require__(88);
	var frota_service_1 = __webpack_require__(203);
	var frota_navigation_service_1 = __webpack_require__(198);
	var data_service_1 = __webpack_require__(201);
	var plano_api_service_1 = __webpack_require__(443);
	var plano_service_1 = __webpack_require__(442);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(429);
	var ServicoBemListComponent = (function () {
	    function ServicoBemListComponent(_servicoApiService, _servicoService, _utilService, _frotaService, _frotaNavigationService, _planoApiService, _planoService, _autocompleteService) {
	        this._servicoApiService = _servicoApiService;
	        this._servicoService = _servicoService;
	        this._utilService = _utilService;
	        this._frotaService = _frotaService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._planoApiService = _planoApiService;
	        this._planoService = _planoService;
	        this._autocompleteService = _autocompleteService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.moduleName = data_service_1.planosModuleName;
	        this.showFrotaLink = false;
	        this.frotaDetailHistory = {};
	        this.frotasModule = {};
	        this.showServicoForm = false;
	        this.planoSelectId = 'plano';
	        this.planoObject = {};
	        this.servicoObject = {};
	        this.count = 0;
	        this.planoTemplateResult = (function (state) {
	            var template = this._planoService.templateResult(state, false);
	            return template;
	        }.bind(this));
	    }
	    ServicoBemListComponent.prototype.ngOnInit = function () {
	        var session = this._servicoService.getServicoBemSessionStorage();
	        if (session) {
	            if (session.servico) {
	                this.servicoObject = session.servico;
	                this.showServicoForm = true;
	                this._servicoService.clearServicoBemSessionStorage();
	            }
	        }
	        this.testFrotaBackHistory();
	    };
	    ServicoBemListComponent.prototype.clickGoToFrotaDetail = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
	    };
	    ServicoBemListComponent.prototype.clickGoToFrotaList = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToList(this.frotaRoute);
	    };
	    ServicoBemListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete, true);
	    };
	    ServicoBemListComponent.prototype.clickSave = function () {
	        swal({
	            title: "Você deseja realmente salvar este plano?",
	            text: "Os serviços vinculados ao plano de manutenção anterior serão removidos!",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Salvar",
	            cancelButtonText: "Fechar",
	            closeOnConfirm: false
	        }, function () {
	            var list = [], x, lenX, obj;
	            for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                if (this.list[x].planoId === this.planoObject.id || !this.list[x].planoId) {
	                    obj = {
	                        alertaInicioOdometroHorimetro: this.list[x].alertaInicioOdometroHorimetro,
	                        alertaInicioTempo: this.list[x].alertaInicioTempo,
	                        periodicidadeOdometroHorimetro: this.list[x].periodicidadeOdometroHorimetro,
	                        periodicidadeTempo: this.list[x].periodicidadeTempo,
	                        referenciaTempo: this.list[x].referenciaTempo.Key,
	                        servicoId: this.list[x].servicoId,
	                        ativo: true
	                    };
	                    if (this.list[x].planoId) {
	                        obj.planoId = this.list[x].planoId;
	                    }
	                    list.push(obj);
	                }
	            }
	            this.saveServicos(list);
	        }.bind(this));
	    };
	    ServicoBemListComponent.prototype.clickToggleServico = function () {
	        this.showServicoForm = !this.showServicoForm;
	    };
	    ServicoBemListComponent.prototype.getPlanoObject = function (object) {
	        this.planoObject = object;
	        this.getAllServicosByPlano();
	    };
	    ServicoBemListComponent.prototype.onSubmitServicoBem = function (evt) {
	        evt.bemId = this.frotaDetailHistory.id;
	        var obj = this._utilService.cloneObject(evt);
	        obj.referenciaTempo = obj.referenciaTempo.Key;
	        obj.servicoId = obj.servico.id;
	        delete obj['servico'];
	        this.list.push(evt);
	        this.saveServico(obj);
	    };
	    ServicoBemListComponent.prototype.returnNewServicoObject = function (object) {
	        this._servicoService.setServicoBemSessionStorage({ moduleRouter: this.frotaRoute });
	        var toOtherFormObject = {
	            descricao: object.text,
	            form: data_service_2.servicoBensStorage
	        };
	        this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_2.servicosStorage);
	    };
	    ServicoBemListComponent.prototype.getAllServicosByBem = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, plano = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        Response[x].referenciaTempo = this._planoService.getReferenciaTempo(Response[x].referenciaTempo);
	                        if (Response[x].plano) {
	                            plano = Response[x].plano;
	                        }
	                        list.push(Response[x]);
	                    }
	                }
	                if (plano) {
	                    this.planoObject = plano;
	                    var text = this._autocompleteService.getTextSelect2(this.planoObject, 'titulo');
	                    var selectObject = { text: text, id: this.planoObject.id };
	                    this._autocompleteService.createOptionOnSelect2(this.planoSelectId, selectObject);
	                    this._autocompleteService.setValueOnSelect2(selectObject.id, this.planoSelectId);
	                }
	                this.list = list;
	                this.loading = false;
	            }
	        }.bind(this));
	        this._servicoApiService.onGetByBemServicoBem(this.frotaDetailHistory.id, onDone);
	    };
	    ServicoBemListComponent.prototype.getAllServicosByPlano = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.forEach(function (item) {
	                    item.referenciaTempo = this._planoService.getReferenciaTempo(item.referenciaTempo);
	                }.bind(this));
	                var x = void 0, lenX = void 0, list = Response || [];
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].planoId && this.list[x].planoId !== this.planoObject.id) {
	                        this.list[x].paraRemover = true;
	                    }
	                    list.push(this.list[x]);
	                }
	                this.list = list;
	            }
	        }.bind(this));
	        this._servicoApiService.onGetByPlanoServicoPlano(this.planoObject.id, onDone);
	    };
	    ServicoBemListComponent.prototype.saveServicos = function (items) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this._utilService.swalMessageAddSuccess();
	            }
	        }.bind(this));
	        var obj = {
	            bemId: this.frotaDetailHistory.id,
	            Servicos: items
	        };
	        this._servicoApiService.onPostServicosBem(obj, onDone);
	    };
	    ServicoBemListComponent.prototype.saveServico = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this._utilService.swalMessageAddSuccess();
	            }
	        }.bind(this));
	        this._servicoApiService.onPostServicoBem(item, onDone);
	    };
	    ServicoBemListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list.splice(item[1], 1);
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        if (item.length) {
	            if (item[0].bemId) {
	                this._servicoApiService.onDeleteServicoBem(item[0].id, onDone);
	            }
	            else {
	                this.list.splice(item[1], 1);
	            }
	        }
	    };
	    ServicoBemListComponent.prototype.testFrotaBackHistory = function () {
	        var settings = this._frotaService.testBackHistory('frota');
	        this.frotaDetailHistory = settings.frotaDetailHistory;
	        this.frotasModule = settings.frotasModule;
	        this.frotaRoute = settings.frotaRoute;
	        this.showFrotaLink = settings.showFrotaLink;
	        this.planoQuery = this._utilService.cloneObject(data_service_1.planoQuery);
	        if (this.frotaDetailHistory) {
	            if (this.frotaDetailHistory.modelo && this.frotaDetailHistory.modelo.marcaId) {
	                this.planoQuery.where.and.push({ "or": [{ "marcaId": this.frotaDetailHistory.modelo.marcaId }, { "marcaId": null }] });
	                if (this.frotaDetailHistory.modelo.tipoBem) {
	                    this.planoQuery.where.and.push({ "or": [{ "categoriaId": this.frotaDetailHistory.modelo.tipoBem.categoriaId }, { "categoriaId": null }] });
	                }
	            }
	        }
	        this.getAllServicosByBem();
	    };
	    ServicoBemListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(444),
	            styles: [__webpack_require__(445)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _a) || Object, (typeof (_b = typeof servico_service_1.ServicoService !== 'undefined' && servico_service_1.ServicoService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _d) || Object, (typeof (_e = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof plano_api_service_1.PlanoApiService !== 'undefined' && plano_api_service_1.PlanoApiService) === 'function' && _f) || Object, (typeof (_g = typeof plano_service_1.PlanoService !== 'undefined' && plano_service_1.PlanoService) === 'function' && _g) || Object, (typeof (_h = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _h) || Object])
	    ], ServicoBemListComponent);
	    return ServicoBemListComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.ServicoBemListComponent = ServicoBemListComponent;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(429);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(201);
	var plano_navigation_service_1 = __webpack_require__(441);
	var plano_service_1 = __webpack_require__(442);
	var data_service_3 = __webpack_require__(200);
	var ordem_servico_service_1 = __webpack_require__(235);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var frota_navigation_service_1 = __webpack_require__(198);
	var ServicoService = (function () {
	    function ServicoService(_planoNavigationService, _planoService, _ordemServicoService, _ordemServicoNavigationService, _frotaNavigationService, _autocompleteService) {
	        this._planoNavigationService = _planoNavigationService;
	        this._planoService = _planoService;
	        this._ordemServicoService = _ordemServicoService;
	        this._ordemServicoNavigationService = _ordemServicoNavigationService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    ServicoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.servicosStorage + '-new', object);
	    };
	    ServicoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.servicosStorage + "-new");
	        return JSON.parse(item);
	    };
	    ServicoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.servicosStorage + "-new");
	    };
	    ServicoService.prototype.setServicoBemSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.servicoBensStorage + '-new', object);
	    };
	    ServicoService.prototype.getServicoBemSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.servicoBensStorage + "-new");
	        return JSON.parse(item);
	    };
	    ServicoService.prototype.clearServicoBemSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.servicoBensStorage + "-new");
	    };
	    ServicoService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_2.planosStorage) {
	                otherFormObject = this._planoService.getSessionStorage();
	                otherFormObject.servicoObject = Response;
	                this._planoService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.ordensServicoItemsStorage) {
	                otherFormObject = this._ordemServicoService.getItemsSessionStorage();
	                otherFormObject.servico = Response;
	                this._ordemServicoService.setItemsSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_1.servicoBensStorage) {
	                otherFormObject = this.getServicoBemSessionStorage();
	                otherFormObject.servico = Response;
	                this.setServicoBemSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.servicosStorage);
	        if (otherForm === data_service_2.planosStorage) {
	            otherFormObject = this._planoService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._planoNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._planoNavigationService.goToNew();
	            }
	        }
	        else if (otherForm === data_service_3.ordensServicoItemsStorage) {
	            otherFormObject = this._ordemServicoService.getItemsSessionStorage();
	            if (otherFormObject.id) {
	                this._ordemServicoNavigationService.goToEditServico(otherFormObject.osId, otherFormObject.tipo, otherFormObject.id);
	            }
	            else {
	                this._ordemServicoNavigationService.goToNewServico(otherFormObject.osId, otherFormObject.tipo);
	            }
	        }
	        else if (otherForm === data_service_1.servicoBensStorage) {
	            otherFormObject = this.getServicoBemSessionStorage();
	            this._frotaNavigationService.goToFrotaPlanoManutencao(otherFormObject.moduleRouter);
	        }
	    };
	    ServicoService.prototype.setServicosToModel = function (list) {
	        setTimeout(function () {
	            var x, lenX, id, text;
	            for (x = 0, lenX = list.length; x < lenX; x++) {
	                id = 'servico_' + x;
	                if (list[x].servico) {
	                    if (list[x].servico.descricao) {
	                        text = list[x].servico.descricao;
	                    }
	                    else {
	                        text = list[x].servico.text;
	                    }
	                    list[x].servico.text = text;
	                }
	                this._autocompleteService.createOptionOnSelect2(id, list[x].servico);
	                this._autocompleteService.setValueOnSelect2(list[x].servico.id, id);
	            }
	        }.bind(this));
	    };
	    ServicoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof plano_navigation_service_1.PlanoNavigationService !== 'undefined' && plano_navigation_service_1.PlanoNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof plano_service_1.PlanoService !== 'undefined' && plano_service_1.PlanoService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _c) || Object, (typeof (_d = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object])
	    ], ServicoService);
	    return ServicoService;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.ServicoService = ServicoService;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(201);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(234);
	var PlanoNavigationService = (function () {
	    function PlanoNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    PlanoNavigationService.prototype.goToList = function () {
	        var router = data_service_3.manutencoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.planosRoute;
	        this._authService.navigateTo(router);
	    };
	    PlanoNavigationService.prototype.goToNew = function () {
	        var router = data_service_3.manutencoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.planosRoute + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    PlanoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_3.manutencoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.planosRoute + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    PlanoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], PlanoNavigationService);
	    return PlanoNavigationService;
	    var _a;
	}());
	exports.PlanoNavigationService = PlanoNavigationService;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(201);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var PlanoService = (function () {
	    function PlanoService(_utilService, _autocompleteService) {
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        if (state.titulo) {
	                            text = state.titulo;
	                        }
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    PlanoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.planosStorage + '-new', object);
	    };
	    PlanoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.planosStorage + "-new");
	        return JSON.parse(item);
	    };
	    PlanoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.planosStorage + "-new");
	    };
	    //others
	    PlanoService.prototype.getReferenciaTempo = function (refId) {
	        var list = this._utilService.cloneObject(data_service_1.referenciaTempo), x, lenX, ref;
	        for (x = 0, lenX = list.length; x < lenX; x++) {
	            if (list[x].Key === refId) {
	                ref = list[x];
	                break;
	            }
	        }
	        return ref;
	    };
	    PlanoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _a) || Object, (typeof (_b = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _b) || Object])
	    ], PlanoService);
	    return PlanoService;
	    var _a, _b;
	}());
	exports.PlanoService = PlanoService;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(201);
	var PlanoApiService = (function () {
	    function PlanoApiService(_restService) {
	        this._restService = _restService;
	        this.includef = ["marca", "categoria"];
	    }
	    PlanoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    PlanoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    PlanoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    PlanoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "titulo", "include": this.includef };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    PlanoApiService.prototype.onGetAllPopulate = function (done) {
	        var filter = { "order": "titulo", "include": this.includef };
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', filter, done); //retornar planos populados com marcas
	    };
	    PlanoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": this.includef };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    PlanoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    PlanoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], PlanoApiService);
	    return PlanoApiService;
	    var _a;
	}());
	exports.PlanoApiService = PlanoApiService;


/***/ },
/* 444 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a (click)=\"clickGoToFrotaList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n            <li class=\"item\"><a (click)=\"clickGoToFrotaDetail()\" class=\"cursor-pointer\">{{frotaDetailHistory.identificacao}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{moduleName.single}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{moduleName.single}}</h1>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--12c mb0\">\n        <autocomplete-component class=\"geo-input--3c mb0\" id=\"plano\"\n                                (setObejct)=\"getPlanoObject($event)\"\n                                (clearObject)=\"getPlanoObject($event)\"\n                                [isRequired]=\"false\"\n                                [isCreateNew]=\"false\"\n                                [selectId]=\"planoSelectId\"\n                                [model]=\"planoObject\"\n                                [_service]=\"_planoApiService\"\n                                [templateResult]=\"planoTemplateResult\"\n                                [query]=\"planoQuery\"\n                                [clear]=\"true\"\n                                [label]=\"'Plano de manutenção'\"></autocomplete-component>\n\n        <div class=\"geo-input--3c mb0\">\n            <button type=\"button\" class=\"geo-button button-remove-margin-left\" (click)=\"clickSave()\">Salvar</button>\n        </div>\n\n        <div class=\"geo-input--12c\">\n            <p class=\"planoDescription\">{{planoObject.descricao}}\n                <span *ngIf=\"planoObject.categoria\">/ Categoria: {{planoObject.categoria.categoria}}</span>\n                <span *ngIf=\"planoObject.marca\">/ Marca: {{planoObject.marca.marca}}</span>\n            </p>\n        </div>\n\n        <div class=\"geo-input--12c mb0\">\n            <p class=\"advanced\">\n                <a (click)=\"clickToggleServico()\">Adicionar serviço</a>\n            </p>\n        </div>\n    </div>\n</div>\n\n<app-servico-plano-form *ngIf=\"showServicoForm\"\n                        [servicoObject]=\"servicoObject\"\n                        (serviceNewEvent)=\"returnNewServicoObject($event)\"\n                        (submitEvent)=\"onSubmitServicoBem($event)\"></app-servico-plano-form>\n\n<div class=\"geo-content__row\">\n\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <app-servico-plano-table [list]=\"list\"\n                             [showRemove]=\"true\"\n                             (removeEvent)=\"clickDelete($event)\"></app-servico-plano-table>\n</div>\n";

/***/ },
/* 445 */
/***/ function(module, exports) {

	module.exports = "app-servico-plano-table {\n    width: 100%;\n}\n.advanced {\n    border-bottom: 1px solid #edf0f4;\n}\n.advanced a {\n    cursor: pointer;\n    margin: 0;\n}\n\n.mb0 {\n    margin-bottom: 0;\n}\n\n.planoDescription {\n    margin: 0;\n}"

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var frota_service_1 = __webpack_require__(203);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_api_service_1 = __webpack_require__(368);
	var att_service_1 = __webpack_require__(141);
	var util_service_1 = __webpack_require__(88);
	var FrotaImagemComponent = (function () {
	    function FrotaImagemComponent(_frotaService, _frotaNavigationService, _frotaApiService, _attService, _utilService, _route) {
	        this._frotaService = _frotaService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaApiService = _frotaApiService;
	        this._attService = _attService;
	        this._utilService = _utilService;
	        this._route = _route;
	        this.frotasModule = {};
	        this.thisRoute = '';
	        this.detail = {};
	        this.images = [];
	        this.loading = true;
	        this.showView = false;
	        this.imagesToSave = [];
	        this.responseSuccessS3File = (function (response) {
	            this.saveFile(response);
	        }.bind(this));
	    }
	    FrotaImagemComponent.prototype.ngOnInit = function () {
	        this.frotasModule = this._frotaService.getModuleName();
	        this.thisRoute = this._frotaService.getRouteName();
	        this.moduleId = this._frotaService.getModuleId();
	        var id = +this._route.snapshot.params['id'];
	        this.getObject(id);
	        this.getImages(id);
	    };
	    FrotaImagemComponent.prototype.clickGoToList = function () {
	        this._frotaNavigationService.goToList(this.thisRoute);
	    };
	    FrotaImagemComponent.prototype.clickGoToDetail = function () {
	        this._frotaNavigationService.goToDetail(this.detail.id, this.thisRoute);
	    };
	    FrotaImagemComponent.prototype.changeFile = function (e) {
	        this.loading = true;
	        var target = e.target;
	        var isValid = this._attService.isValidAttachment(target, true, false);
	        if (isValid) {
	            var x = void 0, lenX = void 0;
	            this.files = target.files.length;
	            this.files2 = 0;
	            this.imagesToSave = [];
	            for (x = 0, lenX = target.files.length; x < lenX; x++) {
	                this.sendAttachment(target.files[x]);
	            }
	        }
	    };
	    FrotaImagemComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    FrotaImagemComponent.prototype.clickViewImage = function (item, index) {
	        // this.showView = true;
	    };
	    FrotaImagemComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var storage = this._frotaService.getSessionStorage();
	                if (storage) {
	                    Response.Combustiveis = storage.Combustiveis;
	                }
	                this.detail = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum ' + this.frotasModule.single + ' encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._frotaApiService.onGetById(id, onDone);
	    };
	    FrotaImagemComponent.prototype.getImages = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.images = Response;
	                this.loading = false;
	            }
	        }.bind(this));
	        this._frotaApiService.onGetAllImagem(id, onDone);
	    };
	    FrotaImagemComponent.prototype.sendAttachment = function (item) {
	        this._attService.loadFile(item, this.responseSuccessS3File);
	    };
	    FrotaImagemComponent.prototype.saveFile = function (response) {
	        var description = this.detail.identificacao;
	        if (this.detail.placa) {
	            var placa = this.detail.placa.toUpperCase();
	            placa = placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
	            description = description.concat(" - Placa: " + placa);
	        }
	        if (this.detail.codigo) {
	            description = description.concat(" - Registro: " + this.detail.codigo);
	        }
	        var newAtt = {
	            descricao: description,
	            url: response.url,
	            formato: response.fileExtension,
	            data: new Date(),
	            ativo: true,
	            bemId: this.detail.id
	        };
	        this.imagesToSave.push(newAtt);
	        this.files2 += 1;
	        if (this.files === this.files2) {
	            this.onSave();
	        }
	    };
	    FrotaImagemComponent.prototype.onSave = function () {
	        var onDone = (function (Response) {
	            this.getImages(this.detail.id);
	            this.loading = false;
	        }.bind(this));
	        var images = { Imagens: this.imagesToSave };
	        this._frotaApiService.onPostImages(images, onDone);
	    };
	    FrotaImagemComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.images.length; x < lenX; x++) {
	                    if (this.images[x].id === item.id) {
	                        this.images.splice(x, 1);
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._frotaApiService.onDeleteImagem(item.id, onDone);
	    };
	    FrotaImagemComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(447),
	            styles: [__webpack_require__(448)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _a) || Object, (typeof (_b = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _c) || Object, (typeof (_d = typeof att_service_1.AttService !== 'undefined' && att_service_1.AttService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object])
	    ], FrotaImagemComponent);
	    return FrotaImagemComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.FrotaImagemComponent = FrotaImagemComponent;


/***/ },
/* 447 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n            <li class=\"item\"><a (click)=\"clickGoToDetail()\" class=\"cursor-pointer\">{{detail.identificacao}}</a></li>\n            <li class=\"item\"><a class=\"active\">Fotos</a></li>\n        </ul>\n        <h1>Fotos</h1>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-send-file\" data-picture=\"\">\n            <label for=\"file\">\n                <div class=\"imageLayout\">\n                    <!--<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-image'/></svg>-->\n                    <!--<br />-->\n                    <span>Clique aqui para selecionar uma foto</span>\n                </div>\n            </label>\n            <input id=\"file\" type=\"file\" multiple (change)=\"changeFile($event)\">\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c borderT\">\n        <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n        <p class=\"lead padding\" *ngIf=\"!images.length && !loading\">Nenhuma foto cadastrada</p>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <div *ngFor=\"let item of (images);let i = index;\">\n        <div class=\"image-container\" [ngStyle]=\"{'background-image': 'url('+item.url+')'}\" (click)=\"clickViewImage(item)\">\n            <div class=\"options\">\n                <a (click)=\"clickDelete(item, i)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!--<div class=\"viewImages\" *ngIf=\"showView\">-->\n    <!--<div *ngFor=\"let item of (images)\">-->\n        <!--<img [src]=\"item.url\" title=\"{{item.descricao}}\" class=\"images\" id=\"image_{{item.id}}\">-->\n    <!--</div>-->\n    <!--<button>proximo</button>-->\n    <!--<button>anterior</button>-->\n<!--</div>-->";

/***/ },
/* 448 */
/***/ function(module, exports) {

	module.exports = ".pt8 {\n    padding-top: 8px;\n}\n\n.imageLayout {\n    width: 300px;\n    height: 36px;\n    /* background-color: #d9e5ea; */\n    border: 1px solid#b1abaf;\n    cursor: pointer;\n    box-shadow: 1px 1px 1px #d8d8d8;\n}\n\n.borderT {\n    border-top: 1px solid #edf0f4;\n}\n\n.borderB .geo-send-file {\n    width: 100%;\n}\n\n.image-container {\n    position: relative;\n    width: 250px;\n    height: 200px;\n    max-height: 200px;\n    border: 1px solid #e6e3e3;\n    margin: 8px;\n    margin-left: 0;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.image-container .options {\n    /* background-image: linear-gradient(to bottom,rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.8) 22px,rgba(0, 0, 0, 0)); */\n    height: 40px;\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n    background-color: rgb(248, 250, 251);\n    border-top: 0;\n}\n.image-container .options a {\n    position: relative;\n    top: 7px;\n    left: 10px;\n    cursor: pointer;\n}\n\n\n.viewImages {\n    background-color: #000;\n    z-index: 999;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n.viewImages img.images {\n    display: none;\n}"

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var frota_service_1 = __webpack_require__(203);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_api_service_1 = __webpack_require__(368);
	var odometro_horimetro_api_service_1 = __webpack_require__(450);
	var forma_controle_service_1 = __webpack_require__(369);
	var FrotaOdometroHorimetroComponent = (function () {
	    function FrotaOdometroHorimetroComponent(_frotaService, _frotaNavigationService, _frotaApiService, _odometroHorimetroApiService, _formaControleService, _route) {
	        this._frotaService = _frotaService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._frotaApiService = _frotaApiService;
	        this._odometroHorimetroApiService = _odometroHorimetroApiService;
	        this._formaControleService = _formaControleService;
	        this._route = _route;
	        this.frotasModule = {};
	        this.thisRoute = '';
	        this.detail = {};
	        this.list = [];
	        this.loading = true;
	        this.isOdometro = false;
	    }
	    FrotaOdometroHorimetroComponent.prototype.ngOnInit = function () {
	        this.frotasModule = this._frotaService.getModuleName();
	        this.thisRoute = this._frotaService.getRouteName();
	        this.moduleId = this._frotaService.getModuleId();
	        var id = +this._route.snapshot.params['id'];
	        this.getObject(id);
	        this.getAll(id);
	    };
	    FrotaOdometroHorimetroComponent.prototype.clickGoToList = function () {
	        this._frotaNavigationService.goToList(this.thisRoute);
	    };
	    FrotaOdometroHorimetroComponent.prototype.clickGoToDetail = function () {
	        this._frotaNavigationService.goToDetail(this.detail.id, this.thisRoute);
	    };
	    FrotaOdometroHorimetroComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var storage = this._frotaService.getSessionStorage();
	                if (storage) {
	                    Response.Combustiveis = storage.Combustiveis;
	                }
	                this.detail = Response;
	                var y = this._formaControleService.getFormaControleOdometro();
	                if (Response.formaControleId === y) {
	                    this.isOdometro = true;
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum ' + this.frotasModule.single + ' encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._frotaApiService.onGetById(id, onDone);
	    };
	    FrotaOdometroHorimetroComponent.prototype.getAll = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	                this.loading = false;
	            }
	        }.bind(this));
	        this._odometroHorimetroApiService.onGetByBem(id, onDone);
	    };
	    FrotaOdometroHorimetroComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(452),
	            styles: [__webpack_require__(453)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _a) || Object, (typeof (_b = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _c) || Object, (typeof (_d = typeof odometro_horimetro_api_service_1.OdometroHorimetroApiService !== 'undefined' && odometro_horimetro_api_service_1.OdometroHorimetroApiService) === 'function' && _d) || Object, (typeof (_e = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object])
	    ], FrotaOdometroHorimetroComponent);
	    return FrotaOdometroHorimetroComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.FrotaOdometroHorimetroComponent = FrotaOdometroHorimetroComponent;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(451);
	var OdometroHorimetroApiService = (function () {
	    function OdometroHorimetroApiService(_restService) {
	        this._restService = _restService;
	    }
	    OdometroHorimetroApiService.prototype.onGetByBem = function (bemId, done) {
	        var filter = { "where": { "bemId": bemId }, "order": ["data"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    OdometroHorimetroApiService.prototype.onGetLast = function (bemId, done) {
	        this._restService.onGet(data_service_1.apiName + '/bem/' + bemId, done);
	    };
	    OdometroHorimetroApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], OdometroHorimetroApiService);
	    return OdometroHorimetroApiService;
	    var _a;
	}());
	exports.OdometroHorimetroApiService = OdometroHorimetroApiService;


/***/ },
/* 451 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'odometros-horimetros';


/***/ },
/* 452 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n            <li class=\"item\"><a (click)=\"clickGoToDetail()\" class=\"cursor-pointer\">{{detail.identificacao}}</a></li>\n            <li class=\"item\"><a class=\"active\">Odômetros/horímetros</a></li>\n        </ul>\n        <h1>Odômetros/horímetros</h1>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum odômetro/horímetro informado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Data</th>\n            <th>Valor</th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filterActive:showDisabled | sort:['data']:true)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.data | date:'dd/MM/yyyy HH:mm'}}</td>\n            <td>\n                <span *ngIf=\"isOdometro\">{{item.odometroHorimetro | odometroHorimetroMask}}</span>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 453 */
/***/ function(module, exports) {

	module.exports = ".imageLayout {\n    width: 100%;\n    height: 80px;\n    background-color: #F8FAFB;\n    border: 4px dashed #DCD9DB;\n    /*padding: 0 8px;*/\n    line-height: 55px;\n}\n\n.imageLayout span {\n    /*line-height: 40px;*/\n    /*cursor: pointer;*/\n    /*padding: 0;*/\n    /*background-color: #FFF;*/\n    /*color: #BCC0C7;*/\n    /*border: 1px solid #BCC0C7;*/\n}\n\n.borderB {\n    /*border-bottom: 1px solid #edf0f4;*/\n}\n\n.borderB .geo-send-file {\n    width: 100%;\n}"

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(202);
	var deslocamento_api_service_1 = __webpack_require__(455);
	var util_service_1 = __webpack_require__(88);
	var deslocamento_service_1 = __webpack_require__(456);
	var funcionario_service_1 = __webpack_require__(214);
	var data_service_2 = __webpack_require__(185);
	var funcionario_api_service_1 = __webpack_require__(184);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_3 = __webpack_require__(457);
	var data_service_4 = __webpack_require__(458);
	var frota_service_1 = __webpack_require__(203);
	var frota_api_service_1 = __webpack_require__(368);
	var motorista_api_service_1 = __webpack_require__(209);
	var motorista_service_1 = __webpack_require__(188);
	var destino_api_service_1 = __webpack_require__(459);
	var data_service_5 = __webpack_require__(146);
	var data_service_6 = __webpack_require__(154);
	var frota_navigation_service_1 = __webpack_require__(198);
	var DeslocamentoHistoryComponent = (function () {
	    function DeslocamentoHistoryComponent(_deslocamentosApiService, _deslocamentoService, _utilService, _funcionarioService, _funcionarioApiService, _destinoApiService, _frotaService, _frotaApiService, _frotaNavigationService, _motoristaApiService, _motoristaService, _autocompleteService) {
	        this._deslocamentosApiService = _deslocamentosApiService;
	        this._deslocamentoService = _deslocamentoService;
	        this._utilService = _utilService;
	        this._funcionarioService = _funcionarioService;
	        this._funcionarioApiService = _funcionarioApiService;
	        this._destinoApiService = _destinoApiService;
	        this._frotaService = _frotaService;
	        this._frotaApiService = _frotaApiService;
	        this._frotaNavigationService = _frotaNavigationService;
	        this._motoristaApiService = _motoristaApiService;
	        this._motoristaService = _motoristaService;
	        this._autocompleteService = _autocompleteService;
	        this.list = [];
	        this.loading = false;
	        this.showDisabled = false;
	        this.deslocamentosModuleName = data_service_1.deslocamentosModuleName;
	        this.module = data_service_3.viagensModuleName;
	        this.researched = false;
	        this.showFrotaLink = false;
	        this.frotaDetailHistory = {};
	        this.frotasModule = {};
	        this.funcionarioSearch = {};
	        this.funcionarioSelectId = 'funcionario';
	        this.funcionarioQuery = {};
	        this.tipoSearch = {};
	        this.tiposList = [];
	        this.statusSearch = {};
	        this.statusList = [];
	        this.destinoSearch = {};
	        this.destinoSelectId = 'destino';
	        this.destinoQuery = {};
	        this.frotaSearch = {};
	        this.frotaSelectId = 'frota';
	        this.frotaQuery = {};
	        this.motoristaSearch = {};
	        this.motoristaSelectId = 'motorista';
	        this.motoristaQuery = {};
	        this.funcionarioTemplateResult = (function (state) {
	            var template = this._funcionarioService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.motoristaTemplateResult = (function (state) {
	            var template = this._motoristaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].tipo = this._deslocamentoService.getTipo(Response[x].tipo);
	                    Response[x].status = this._deslocamentoService.getStatus(Response[x].status);
	                }
	                this.list = Response;
	            }
	            this.loading = false;
	            this.researched = true;
	        }.bind(this));
	    }
	    DeslocamentoHistoryComponent.prototype.ngOnInit = function () {
	        this.funcionarioQuery = this._utilService.cloneObject(data_service_2.funcionariosQueryComPessoa);
	        this.destinoQuery = this._utilService.cloneObject(data_service_4.destinosQuery);
	        this.motoristaQuery = this._utilService.cloneObject(data_service_5.motoristasQuery);
	        this.frotaQuery = this._utilService.cloneObject(data_service_6.frotasQuery);
	        this.getTipos();
	        this.getStatus();
	        this.clickClearSearch();
	        var datePicker = $('.input-datepicker');
	        var t = this;
	        datePicker.datepicker({
	            onSelect: function (e) {
	                t.changeData();
	            }
	        });
	        this.testFrotaBackHistory();
	    };
	    DeslocamentoHistoryComponent.prototype.changeData = function () {
	        this.list = [];
	        this.queryMovimentacoes();
	    };
	    DeslocamentoHistoryComponent.prototype.changeTipo = function () {
	        this.queryMovimentacoes();
	    };
	    DeslocamentoHistoryComponent.prototype.changeStatus = function () {
	        this.queryMovimentacoes();
	    };
	    DeslocamentoHistoryComponent.prototype.keyupPassageiro = function (e) {
	        if (e.keyCode === 13) {
	            this.queryMovimentacoes();
	        }
	    };
	    DeslocamentoHistoryComponent.prototype.clickClearSearch = function () {
	        this.tipoSearch = this.tiposList[0];
	        this.statusSearch = this.statusList[0];
	        this.funcionarioSearch = {};
	        this.frotaSearch = {};
	        this.destinoSearch = {};
	        this.motoristaSearch = {};
	        this.numeroRequisicaoSearch = '';
	        this.passageiroNomeSearch = '';
	        this.passageiroCpfSearch = '';
	        var date = document.getElementById('data_inicial');
	        date.value = null;
	        date = document.getElementById('data_final');
	        date.value = null;
	        this._autocompleteService.setValueOnSelect2(null, "funcionario");
	        this._autocompleteService.setValueOnSelect2(null, "frota");
	        this._autocompleteService.setValueOnSelect2(null, "motorista");
	        this._autocompleteService.setValueOnSelect2(null, "destino");
	        this.list = [];
	    };
	    DeslocamentoHistoryComponent.prototype.clickGoToFrotaDetail = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
	    };
	    DeslocamentoHistoryComponent.prototype.clickGoToFrotaList = function () {
	        this._frotaService.clearBackStorage();
	        this._frotaNavigationService.goToList(this.frotaRoute);
	    };
	    DeslocamentoHistoryComponent.prototype.getDestinoObject = function (object) {
	        this.destinoSearch = object;
	        this.queryMovimentacoes();
	    };
	    DeslocamentoHistoryComponent.prototype.getFuncionarioObject = function (object) {
	        this.funcionarioSearch = object;
	        this.queryMovimentacoes();
	    };
	    DeslocamentoHistoryComponent.prototype.getFrotaObject = function (object) {
	        this.frotaSearch = object;
	        this.queryMovimentacoes();
	    };
	    DeslocamentoHistoryComponent.prototype.getMotoristaObject = function (object) {
	        this.motoristaSearch = object;
	        this.queryMovimentacoes();
	    };
	    DeslocamentoHistoryComponent.prototype.queryMovimentacoes = function () {
	        var query = {}, queryDateStart, queryDateEnd;
	        var dateStart = document.getElementById('data_inicial');
	        if (dateStart.value) {
	            var currDate = this._utilService.convertStringToDate(dateStart.value);
	            var nextCurrDate = new Date(currDate.getTime());
	            nextCurrDate.setDate(currDate.getDate() + 1);
	            queryDateStart = { dataHoraPrevistaSaida: { "gt": currDate } };
	        }
	        var dateEnd = document.getElementById('data_final');
	        if (dateEnd.value) {
	            var currDate = this._utilService.convertStringToDate(dateEnd.value);
	            var nextCurrDate = new Date(currDate.getTime());
	            nextCurrDate.setDate(currDate.getDate() + 1);
	            queryDateEnd = { dataHoraPrevistaSaida: { "lt": nextCurrDate } };
	        }
	        if (dateEnd.value && dateStart.value) {
	            query.and = [queryDateStart, queryDateEnd];
	        }
	        else if (dateEnd.value && !dateStart.value) {
	            query.and = [queryDateEnd];
	        }
	        else if (dateStart.value && !dateEnd.value) {
	            query.and = [queryDateStart];
	        }
	        if (this.tipoSearch.Key) {
	            query.tipo = this.tipoSearch.Key;
	        }
	        if (this.statusSearch.Key) {
	            if (this.statusSearch.Key === -1) {
	                var statusAprovado = this._deslocamentoService.getStatusAprovado();
	                var statusSolicitado = this._deslocamentoService.getStatusSolicitado();
	                var or = { or: [{ status: statusAprovado }, { status: statusSolicitado }] };
	                if (query.and) {
	                    query.and.push(or);
	                }
	                else {
	                    query.and = [or];
	                }
	            }
	            else {
	                query.status = this.statusSearch.Key;
	            }
	        }
	        if (this.funcionarioSearch.id) {
	            query.solicitanteId = this.funcionarioSearch.id;
	        }
	        if (this.destinoSearch.id) {
	            query.destinoId = this.destinoSearch.id;
	        }
	        if (this.motoristaSearch.id) {
	            query.motoristaDesignadoId = this.motoristaSearch.id;
	        }
	        if (this.frotaSearch.id) {
	            query.bemId = this.frotaSearch.id;
	        }
	        if (this.numeroRequisicaoSearch) {
	            query.numeroRequisicao = this.numeroRequisicaoSearch;
	        }
	        if (this.passageiroCpfSearch) {
	            var cpf = this.passageiroCpfSearch;
	            cpf = this._utilService.removeSpecialCharacter(cpf);
	            query.cpfPassageiro = cpf;
	        }
	        if (this.passageiroNomeSearch) {
	            query.nomePassageiro = this.passageiroNomeSearch;
	        }
	        this.getMovimentacoes(query);
	    };
	    DeslocamentoHistoryComponent.prototype.getMovimentacoes = function (query) {
	        this.loading = true;
	        this._deslocamentosApiService.onGetByPassageiro(query, this.onDone);
	    };
	    DeslocamentoHistoryComponent.prototype.getStatus = function () {
	        var list = this._utilService.cloneObject(data_service_1.statusDeslocamentos);
	        var statusAprovado = this._deslocamentoService.getStatusAprovado();
	        var statusSolicitado = this._deslocamentoService.getStatusSolicitado();
	        statusAprovado = this._deslocamentoService.getStatus(statusAprovado);
	        statusSolicitado = this._deslocamentoService.getStatus(statusSolicitado);
	        list.unshift({ Key: -1, Value: 'Ativos (' + statusAprovado.Value + ' e ' + statusSolicitado.Value + ')' });
	        list.unshift({ Key: null, Value: '— Status —' });
	        this.statusList = list;
	        this.statusSearch = this.statusList[0];
	    };
	    DeslocamentoHistoryComponent.prototype.getTipos = function () {
	        var list = this._utilService.cloneObject(data_service_1.tiposDeslocamentos);
	        list.unshift({ Key: null, Value: '— Tipo —' });
	        this.tiposList = list;
	        this.tipoSearch = this.tiposList[0];
	    };
	    DeslocamentoHistoryComponent.prototype.testFrotaBackHistory = function () {
	        var settings = this._frotaService.testBackHistory('frota');
	        this.frotaDetailHistory = settings.frotaDetailHistory;
	        this.frotasModule = settings.frotasModule;
	        this.frotaRoute = settings.frotaRoute;
	        this.showFrotaLink = settings.showFrotaLink;
	        if (this.showFrotaLink) {
	            this.getFrotaObject(this.frotaDetailHistory);
	        }
	    };
	    DeslocamentoHistoryComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(460),
	            styles: [__webpack_require__(461)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof deslocamento_api_service_1.DeslocamentoApiService !== 'undefined' && deslocamento_api_service_1.DeslocamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof deslocamento_service_1.DeslocamentoService !== 'undefined' && deslocamento_service_1.DeslocamentoService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof funcionario_service_1.FuncionarioService !== 'undefined' && funcionario_service_1.FuncionarioService) === 'function' && _d) || Object, (typeof (_e = typeof funcionario_api_service_1.FuncionarioApiService !== 'undefined' && funcionario_api_service_1.FuncionarioApiService) === 'function' && _e) || Object, (typeof (_f = typeof destino_api_service_1.DestinoApiService !== 'undefined' && destino_api_service_1.DestinoApiService) === 'function' && _f) || Object, (typeof (_g = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _g) || Object, (typeof (_h = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _h) || Object, (typeof (_j = typeof frota_navigation_service_1.FrotaNavigationService !== 'undefined' && frota_navigation_service_1.FrotaNavigationService) === 'function' && _j) || Object, (typeof (_k = typeof motorista_api_service_1.MotoristaApiService !== 'undefined' && motorista_api_service_1.MotoristaApiService) === 'function' && _k) || Object, (typeof (_l = typeof motorista_service_1.MotoristaService !== 'undefined' && motorista_service_1.MotoristaService) === 'function' && _l) || Object, (typeof (_m = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _m) || Object])
	    ], DeslocamentoHistoryComponent);
	    return DeslocamentoHistoryComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
	}());
	exports.DeslocamentoHistoryComponent = DeslocamentoHistoryComponent;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(202);
	var DeslocamentoApiService = (function () {
	    function DeslocamentoApiService(_restService) {
	        this._restService = _restService;
	        this.includeFilter = [{ "solicitante": "pessoa" }, "bem", "area", { "motoristaDesignado": { "funcionario": "pessoa" } }, "kmRetorno", "kmSaida", "destino", "tipoViagem"];
	    }
	    DeslocamentoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    DeslocamentoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    DeslocamentoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    DeslocamentoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "dataHoraPrevistaSaida", "include": this.includeFilter };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    DeslocamentoApiService.prototype.onGetByFilter = function (filter, done) {
	        filter.include = this.includeFilter;
	        filter.order = "dataHoraPrevistaSaida";
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    DeslocamentoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": this.includeFilter };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    DeslocamentoApiService.prototype.onGetByPassageiro = function (query, done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', query, done);
	    };
	    DeslocamentoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //custos
	    DeslocamentoApiService.prototype.onPostCustoDeslocamento = function (object, done) {
	        this._restService.onPost(data_service_1.apiNameCustosDeslocamento, object, done);
	    };
	    DeslocamentoApiService.prototype.onDeleteCustoDeslocamento = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiNameCustosDeslocamento, objectId, done);
	    };
	    DeslocamentoApiService.prototype.onGetCustoDeslocamento = function (filter, done) {
	        filter.include = ["deslocamento"];
	        this._restService.onGetPost(data_service_1.apiNameCustosDeslocamento, filter, done);
	    };
	    DeslocamentoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], DeslocamentoApiService);
	    return DeslocamentoApiService;
	    var _a;
	}());
	exports.DeslocamentoApiService = DeslocamentoApiService;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(202);
	var DeslocamentoService = (function () {
	    function DeslocamentoService(_router) {
	        this._router = _router;
	    }
	    //session
	    DeslocamentoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.deslocamentosStorage + '-new', object);
	    };
	    DeslocamentoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.deslocamentosStorage + "-new");
	        return JSON.parse(item);
	    };
	    DeslocamentoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.deslocamentosStorage + "-new");
	    };
	    DeslocamentoService.prototype.checkVisitor = function () {
	        var url = this._router.url;
	        if (url.indexOf("visitante") === -1) {
	            return true;
	        }
	        return false;
	    };
	    DeslocamentoService.prototype.getTipo = function (value) {
	        var tipo = data_service_1.tiposDeslocamentos;
	        var x, lenX;
	        for (x = 0, lenX = tipo.length; x < lenX; x++) {
	            if (value === tipo[x].Key) {
	                value = tipo[x];
	                break;
	            }
	        }
	        return value;
	    };
	    DeslocamentoService.prototype.getTipoSaida = function () {
	        return 1;
	    };
	    DeslocamentoService.prototype.getTipoViagem = function () {
	        return 2;
	    };
	    DeslocamentoService.prototype.getStatus = function (value) {
	        var status = data_service_1.statusDeslocamentos;
	        var x, lenX;
	        for (x = 0, lenX = status.length; x < lenX; x++) {
	            if (value === status[x].Key) {
	                value = status[x];
	                break;
	            }
	        }
	        return value;
	    };
	    DeslocamentoService.prototype.getStatusSolicitado = function () {
	        return 1;
	    };
	    DeslocamentoService.prototype.getStatusCancelado = function () {
	        return 2;
	    };
	    DeslocamentoService.prototype.getStatusAprovado = function () {
	        return 3;
	    };
	    DeslocamentoService.prototype.getStatusConcluido = function () {
	        return 4;
	    };
	    DeslocamentoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object])
	    ], DeslocamentoService);
	    return DeslocamentoService;
	    var _a;
	}());
	exports.DeslocamentoService = DeslocamentoService;


/***/ },
/* 457 */
/***/ function(module, exports) {

	"use strict";
	exports.viagensRoute = 'viagens';
	exports.viagensModuleName = { plural: 'Deslocamentos', single: 'Deslocamento' };


/***/ },
/* 458 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'destinos-deslocamentos';
	exports.destinosRoute = 'destinos';
	exports.destinosStorage = 'destinos';
	exports.destinosModuleName = { plural: 'Destinos', single: 'Destino' };
	exports.destinosQuery = {
	    "where": {
	        "ativo": true,
	        "destino": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "destino"
	};


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(458);
	var DestinoApiService = (function () {
	    function DestinoApiService(_restService) {
	        this._restService = _restService;
	    }
	    DestinoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    DestinoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    DestinoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    DestinoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "destino" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    DestinoApiService.prototype.onGetAllActive = function (done) {
	        var filter = { "where": { "ativo": true }, "order": "destino" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    DestinoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    DestinoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    DestinoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], DestinoApiService);
	    return DestinoApiService;
	    var _a;
	}());
	exports.DestinoApiService = DestinoApiService;


/***/ },
/* 460 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\" *ngIf=\"showFrotaLink\"><a (click)=\"clickGoToFrotaList()\" class=\"cursor-pointer\">{{frotasModule.plural}}</a></li>\n            <li class=\"item\" *ngIf=\"showFrotaLink\"><a (click)=\"clickGoToFrotaDetail()\" class=\"cursor-pointer\">{{frotaDetailHistory.identificacao}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">Histórico</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>Histórico</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--12c\">\n        <div class=\"geo-content__row second\">\n            <h2>Parâmetros</h2>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <input type=\"number\" id=\"numeroRequisicao\" placeholder=\"Número da requisição\" [(ngModel)]=\"numeroRequisicaoSearch\">\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <select id=\"tipo\" [(ngModel)]=\"tipoSearch\" (ngModelChange)=\"changeTipo()\" class=\"option_{{tipoSearch.Key}}\">\n                            <option *ngFor=\"let item of tiposList\" id=\"tipo_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <select id=\"status\" [(ngModel)]=\"statusSearch\" (ngModelChange)=\"changeStatus()\" class=\"option_{{statusSearch.Key}}\">\n                            <option *ngFor=\"let item of statusList\" id=\"status_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <autocomplete-component class=\"geo-input--12c\" id=\"funcionario\"\n                                        (setObejct)=\"getFuncionarioObject($event)\"\n                                        (clearObject)=\"getFuncionarioObject($event)\"\n                                        [isRequired]=\"false\"\n                                        [selectId]=\"funcionarioSelectId\"\n                                        [model]=\"funcionarioSearch\"\n                                        [_service]=\"_funcionarioApiService\"\n                                        [templateResult]=\"funcionarioTemplateResult\"\n                                        [isCreateNew]=\"false\"\n                                        [placeholder]=\"'— Solicitante —'\"\n                                        [apiCustom]=\"'/populado'\"\n                                        [query]=\"funcionarioQuery\"\n                                        [clear]=\"true\"\n                                        [label]=\"\"></autocomplete-component>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <autocomplete-component class=\"geo-input--12c\" id=\"destino\"\n                                        (setObejct)=\"getDestinoObject($event)\"\n                                        (clearObject)=\"getDestinoObject($event)\"\n                                        [isRequired]=\"false\"\n                                        [selectId]=\"destinoSelectId\"\n                                        [model]=\"destinoSearch\"\n                                        [_service]=\"_destinoApiService\"\n                                        [fieldToShow]=\"'destino'\"\n                                        [isCreateNew]=\"false\"\n                                        [placeholder]=\"'— Destino —'\"\n                                        [query]=\"destinoQuery\"\n                                        [clear]=\"true\"\n                                        [label]=\"\"></autocomplete-component>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c geo-input--datepicker\">\n                    <div>\n                        <input type=\"text\" class=\"input-datepicker\" id=\"data_inicial\" placeholder=\"Data inicial\" [(ngModel)]=\"dataInicialSearch\" appDatepicker autocomplete=\"off\" (ngModelChange)=\"changeData()\"/>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-input--12c geo-input--datepicker\">\n                    <div>\n                        <input type=\"text\" class=\"input-datepicker\" id=\"data_final\" placeholder=\"Data final\" [(ngModel)]=\"dataFinalSearch\" appDatepicker autocomplete=\"off\" (ngModelChange)=\"changeData()\"/>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--6c\">\n        <div class=\"geo-content__row second\">\n            <h2>Passageiro</h2>\n\n            <div class=\"geo-columns--6c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <input type=\"text\" id=\"passageiroNome\" placeholder=\"Nome do passageiro\" [(ngModel)]=\"passageiroNomeSearch\" (keyup)=\"keyupPassageiro($event)\">\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-columns--6c\">\n                <div class=\"geo-input--12c\">\n                    <div>\n                        <input type=\"text\" id=\"passageiroCpf\" placeholder=\"CPF do passageiro\" [(ngModel)]=\"passageiroCpfSearch\" appCpfMask maxlength=\"14\" (keyup)=\"keyupPassageiro($event)\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--6c\">\n        <div class=\"geo-content__row second\">\n            <h2>Veículo e motorista</h2>\n\n            <div class=\"geo-columns--6c\">\n                <autocomplete-component class=\"geo-input--12c\" id=\"frota\"\n                                        (setObejct)=\"getFrotaObject($event)\"\n                                        (clearObject)=\"getFrotaObject($event)\"\n                                        [submitted]=\"submitted\"\n                                        [isRequired]=\"false\"\n                                        [selectId]=\"frotaSelectId\"\n                                        [model]=\"frotaSearch\"\n                                        [_service]=\"_frotaApiService\"\n                                        [templateResult]=\"frotaTemplateResult\"\n                                        [isCreateNew]=\"false\"\n                                        [placeholder]=\"'— Veículo —'\"\n                                        [query]=\"frotaQuery\"\n                                        [clear]=\"true\"\n                                        [label]=\"\"></autocomplete-component>\n            </div>\n\n            <div class=\"geo-columns--6c\">\n                <autocomplete-component class=\"geo-input--12c\" id=\"motorista\"\n                                        (setObejct)=\"getMotoristaObject($event)\"\n                                        (clearObject)=\"getMotoristaObject($event)\"\n                                        [submitted]=\"submitted\"\n                                        [isRequired]=\"false\"\n                                        [selectId]=\"motoristaSelectId\"\n                                        [model]=\"motoristaSearch\"\n                                        [_service]=\"_motoristaApiService\"\n                                        [query]=\"motoristaQuery\"\n                                        [templateResult]=\"motoristaTemplateResult\"\n                                        [isCreateNew]=\"false\"\n                                        [placeholder]=\"'— Motorista —'\"\n                                        [clear]=\"true\"\n                                        [label]=\"\"></autocomplete-component>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c geo-columns--right\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickClearSearch()\" class=\"cursor-pointer clear-search\">Limpar busca</a>\n        </p>\n    </div>\n\n    <div class=\"geo-columns--12c\">\n        <p class=\"lead padding\" *ngIf=\"!researched\">Realize a busca para visualizar as solicitações</p>\n    </div>\n</div>\n\n<app-deslocamento-table [list]=\"list\"\n                        [loading]=\"loading\"\n                        [researched]=\"researched\"\n                        [showDisabled]=\"showDisabled\"></app-deslocamento-table>";

/***/ },
/* 461 */
/***/ function(module, exports) {

	module.exports = ".cursor-pointer {\n    cursor: pointer;\n}\n\n.advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}\n\n.geo-content__row.second {\n    padding: 0;\n}"

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ViagensComponent = (function () {
	    function ViagensComponent() {
	    }
	    ViagensComponent.prototype.ngOnInit = function () {
	    };
	    ViagensComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(463)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ViagensComponent);
	    return ViagensComponent;
	}());
	exports.ViagensComponent = ViagensComponent;


/***/ },
/* 463 */
55,
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ManutencoesComponent = (function () {
	    function ManutencoesComponent() {
	    }
	    ManutencoesComponent.prototype.ngOnInit = function () {
	    };
	    ManutencoesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(465)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ManutencoesComponent);
	    return ManutencoesComponent;
	}());
	exports.ManutencoesComponent = ManutencoesComponent;


/***/ },
/* 465 */
171,
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AlmoxarifadoComponent = (function () {
	    function AlmoxarifadoComponent() {
	    }
	    AlmoxarifadoComponent.prototype.ngOnInit = function () {
	    };
	    AlmoxarifadoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(467)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AlmoxarifadoComponent);
	    return AlmoxarifadoComponent;
	}());
	exports.AlmoxarifadoComponent = AlmoxarifadoComponent;


/***/ },
/* 467 */
171,
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var MedidasComponent = (function () {
	    function MedidasComponent() {
	    }
	    MedidasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(469)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MedidasComponent);
	    return MedidasComponent;
	}());
	exports.MedidasComponent = MedidasComponent;


/***/ },
/* 469 */
55,
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var router_1 = __webpack_require__(62);
	var core_1 = __webpack_require__(3);
	var medida_list_component_1 = __webpack_require__(471);
	var data_service_1 = __webpack_require__(178);
	var medida_form_component_1 = __webpack_require__(477);
	var MedidasRoutingModule = (function () {
	    function MedidasRoutingModule() {
	    }
	    MedidasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MedidasRoutingModule);
	    return MedidasRoutingModule;
	}());
	exports.MedidasRoutingModule = MedidasRoutingModule;
	exports.medidasRoutes = [
	    {
	        path: '',
	        component: medida_list_component_1.MedidaListComponent
	    },
	    {
	        path: data_service_1.newRoute,
	        component: medida_form_component_1.MedidaFormComponent
	    },
	    {
	        path: data_service_1.editRoute + '/:id',
	        component: medida_form_component_1.MedidaFormComponent
	    }
	];


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(157);
	var util_service_1 = __webpack_require__(88);
	var medida_api_service_1 = __webpack_require__(472);
	var medida_navigation_service_1 = __webpack_require__(473);
	var medida_service_1 = __webpack_require__(474);
	var MedidaListComponent = (function () {
	    function MedidaListComponent(_medidaApiService, _medidaService, _medidaNavigationService, _utilService) {
	        this._medidaApiService = _medidaApiService;
	        this._medidaService = _medidaService;
	        this._medidaNavigationService = _medidaNavigationService;
	        this._utilService = _utilService;
	        this.medidasModuleName = data_service_1.medidasModuleName;
	        this.list = [];
	        this.showDisabled = false;
	        this.loading = true;
	    }
	    MedidaListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    MedidaListComponent.prototype.clickNew = function () {
	        this._medidaService.clearSessionStorage();
	        this._medidaNavigationService.goToNew();
	    };
	    MedidaListComponent.prototype.clickEdit = function (item) {
	        this._medidaService.clearSessionStorage();
	        this._medidaNavigationService.goToEdit(item.id);
	    };
	    MedidaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    MedidaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._medidaApiService.onGetAll(onDone);
	    };
	    MedidaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._medidaApiService.onDelete(item.id, onDone);
	    };
	    MedidaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(476),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof medida_api_service_1.MedidaApiService !== 'undefined' && medida_api_service_1.MedidaApiService) === 'function' && _a) || Object, (typeof (_b = typeof medida_service_1.MedidaService !== 'undefined' && medida_service_1.MedidaService) === 'function' && _b) || Object, (typeof (_c = typeof medida_navigation_service_1.MedidaNavigationService !== 'undefined' && medida_navigation_service_1.MedidaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], MedidaListComponent);
	    return MedidaListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MedidaListComponent = MedidaListComponent;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(157);
	var rest_service_1 = __webpack_require__(26);
	var MedidaApiService = (function () {
	    function MedidaApiService(_restService) {
	        this._restService = _restService;
	    }
	    MedidaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    MedidaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    MedidaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    MedidaApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "medida" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    MedidaApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    MedidaApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    MedidaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], MedidaApiService);
	    return MedidaApiService;
	    var _a;
	}());
	exports.MedidaApiService = MedidaApiService;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(157);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(156);
	var MedidaNavigationService = (function () {
	    function MedidaNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    MedidaNavigationService.prototype.goToList = function () {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.medidasRouter;
	        this._authService.navigateTo(router);
	    };
	    MedidaNavigationService.prototype.goToNew = function () {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.medidasRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    MedidaNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.medidasRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    MedidaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], MedidaNavigationService);
	    return MedidaNavigationService;
	    var _a;
	}());
	exports.MedidaNavigationService = MedidaNavigationService;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(157);
	var material_service_1 = __webpack_require__(475);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(161);
	var MedidaService = (function () {
	    function MedidaService(_materialService, _autocompleteService) {
	        this._materialService = _materialService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    MedidaService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.medidasStorage + '-new', object);
	    };
	    MedidaService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.medidasStorage + "-new");
	        return JSON.parse(item);
	    };
	    MedidaService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.medidasStorage + "-new");
	    };
	    MedidaService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_2.materialStorageName) {
	                otherFormObject = this._materialService.getSessionStorage();
	                otherFormObject.medida = Response;
	                this._materialService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.medidasStorage);
	        if (otherForm === data_service_2.materialStorageName) {
	            otherFormObject = this._materialService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._materialService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._materialService.goToAdd();
	            }
	        }
	    };
	    MedidaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _a) || Object, (typeof (_b = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _b) || Object])
	    ], MedidaService);
	    return MedidaService;
	    var _a, _b;
	}());
	exports.MedidaService = MedidaService;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(161);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(156);
	var data_service_4 = __webpack_require__(200);
	var ordem_servico_service_1 = __webpack_require__(235);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var autocomplete_service_1 = __webpack_require__(101);
	var MaterialService = (function () {
	    function MaterialService(_restService, _authService, _ordemServicoService, _ordemServicoNavigationService, _autocompleteService) {
	        this._restService = _restService;
	        this._authService = _authService;
	        this._ordemServicoService = _ordemServicoService;
	        this._ordemServicoNavigationService = _ordemServicoNavigationService;
	        this._autocompleteService = _autocompleteService;
	        this.apiUrl = data_service_1.materialApi;
	        this.storageName = data_service_1.materialStorageName;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var name = state.descricao;
	                        text = name;
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    MaterialService.prototype.onPost = function (object, done) {
	        this._restService.onPost(this.apiUrl, object, done);
	    };
	    MaterialService.prototype.onPut = function (object, done) {
	        this._restService.onPut(this.apiUrl, object, done);
	    };
	    MaterialService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(this.apiUrl, objectId, done);
	    };
	    MaterialService.prototype.onGetAll = function (done) {
	        var filter = { "order": "descricao", "include": [{ "grupoMaterial": "grupo" }, "tipo"] };
	        this._restService.onGetPost(this.apiUrl, filter, done);
	    };
	    MaterialService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": [{ "grupoMaterial": ["grupo", "contaContabil"] }, "medida", "contaContabil", "tipo"] };
	        this._restService.onGetPostId(this.apiUrl, objectId, filter, done);
	    };
	    MaterialService.prototype.onGetApiUrl = function () {
	        return this.apiUrl;
	    };
	    //storage
	    MaterialService.prototype.setStorage = function (item) {
	        var object = JSON.stringify(item);
	        localStorage.setItem(this.storageName + '-selected', object);
	    };
	    MaterialService.prototype.getStorage = function () {
	        var item = localStorage.getItem(this.storageName + "-selected");
	        return JSON.parse(item);
	    };
	    //session
	    MaterialService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(this.storageName + '-new', object);
	    };
	    MaterialService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(this.storageName + "-new");
	        return JSON.parse(item);
	    };
	    MaterialService.prototype.clearStorage = function () {
	        sessionStorage.clear();
	        localStorage.clear();
	    };
	    //router
	    MaterialService.prototype.goToList = function () {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialRouter;
	        this._authService.navigateTo(router);
	    };
	    MaterialService.prototype.goToAdd = function () {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    MaterialService.prototype.goToEdit = function (objectId) {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    MaterialService.prototype.goToDetail = function (objectId) {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialRouter + '/' + data_service_2.detailRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    //others
	    MaterialService.prototype.getClassificacao = function (materialObject) {
	        var materialType = materialObject.tipo, materialGrupoCodigo = materialObject.grupo, materialSubgrupoCodigo = materialObject.subgrupo, materialCodigo = materialObject.id, classificacao = '', x, lenX, codigoLength;
	        if (materialType.id) {
	            materialType = materialType.id;
	        }
	        if (materialGrupoCodigo) {
	            materialGrupoCodigo = materialGrupoCodigo.codigo;
	            if (typeof materialGrupoCodigo !== 'string') {
	                materialGrupoCodigo = materialGrupoCodigo.toString();
	            }
	            codigoLength = materialGrupoCodigo.length;
	            for (x = codigoLength, lenX = data_service_1.materialGrupoCodigoMask; x < lenX; x++) {
	                materialGrupoCodigo = "0" + materialGrupoCodigo;
	            }
	        }
	        if (materialSubgrupoCodigo) {
	            materialSubgrupoCodigo = materialSubgrupoCodigo.codigoGrupo;
	            if (typeof materialSubgrupoCodigo !== 'string') {
	                materialSubgrupoCodigo = materialSubgrupoCodigo.toString();
	            }
	            codigoLength = materialSubgrupoCodigo.length;
	            for (x = codigoLength, lenX = data_service_1.materialGrupoCodigoMask; x < lenX; x++) {
	                materialSubgrupoCodigo = "0" + materialSubgrupoCodigo;
	            }
	        }
	        if (materialCodigo) {
	            if (typeof materialCodigo !== 'string') {
	                materialCodigo = materialCodigo.toString();
	            }
	            codigoLength = materialCodigo.length;
	            for (x = codigoLength, lenX = data_service_1.materialCodigoMask; x < lenX; x++) {
	                materialCodigo = "0" + materialCodigo;
	            }
	        }
	        classificacao = materialGrupoCodigo + '.' + materialSubgrupoCodigo + '.' + materialCodigo + "-" + materialType;
	        return classificacao;
	    };
	    //qndo retorna para continuar o cadastro, caso tenha ido para outro formulario
	    MaterialService.prototype.returnToForm = function () {
	        var session = this.getSessionStorage();
	        if (session && session.id) {
	            this.goToEdit(session.id);
	        }
	        else {
	            this.goToAdd();
	        }
	    };
	    MaterialService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_4.ordensServicoItemsStorage) {
	                otherFormObject = this._ordemServicoService.getItemsSessionStorage();
	                otherFormObject.material = Response;
	                otherFormObject.medidaId = Response.medidaId;
	                this._ordemServicoService.setItemsSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.materialStorageName);
	        if (otherForm === data_service_4.ordensServicoItemsStorage) {
	            otherFormObject = this._ordemServicoService.getItemsSessionStorage();
	            if (otherFormObject.id) {
	                this._ordemServicoNavigationService.goToEditServico(otherFormObject.osId, otherFormObject.tipo, otherFormObject.id);
	            }
	            else {
	                this._ordemServicoNavigationService.goToNewServico(otherFormObject.osId, otherFormObject.tipo);
	            }
	        }
	    };
	    MaterialService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _c) || Object, (typeof (_d = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object])
	    ], MaterialService);
	    return MaterialService;
	    var _a, _b, _c, _d, _e;
	}());
	exports.MaterialService = MaterialService;


/***/ },
/* 476 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{medidasModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{medidasModuleName.single | lowercase}} cadastrada</p>\n\n  <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Medida</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['medida'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.medida}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var medida_model_1 = __webpack_require__(478);
	var medida_service_1 = __webpack_require__(474);
	var data_service_1 = __webpack_require__(157);
	var medida_navigation_service_1 = __webpack_require__(473);
	var medida_api_service_1 = __webpack_require__(472);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(178);
	var MedidaFormComponent = (function () {
	    function MedidaFormComponent(_route, _medidaNavigationService, _medidaApiService, _medidaService, _utilService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._medidaNavigationService = _medidaNavigationService;
	        this._medidaApiService = _medidaApiService;
	        this._medidaService = _medidaService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.medidaModule = data_service_1.medidasModuleName;
	        this.formObject = new medida_model_1.Medida();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.medida = new forms_1.FormControl('', forms_1.Validators.required);
	        this.ativo = new forms_1.FormControl();
	        this.returnToOtherForm = false;
	        this.otherForm = "";
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseMedida = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            medida: this.medida
	        });
	    }
	    MedidaFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    MedidaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    MedidaFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    MedidaFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEditMedida(object);
	            }
	            else {
	                this.onAddMedida(object);
	            }
	        }
	    };
	    MedidaFormComponent.prototype.onAddMedida = function (object) {
	        this._medidaApiService.onPost(object, this.onDone);
	    };
	    MedidaFormComponent.prototype.onEditMedida = function (object) {
	        this._medidaApiService.onPut(object, this.onDone);
	    };
	    MedidaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma unidade de medida encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._medidaApiService.onGetById(id, onDone);
	    };
	    MedidaFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._medidaService.getSessionStorage();
	        this._medidaService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    MedidaFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    MedidaFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    MedidaFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    MedidaFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    MedidaFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    MedidaFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.medidasStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.medida = newAutoComplete.medida;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    MedidaFormComponent.prototype.setModelToForm = function () {
	    };
	    MedidaFormComponent.prototype.goToList = function () {
	        this._medidaNavigationService.goToList();
	    };
	    MedidaFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._medidaService.returnToOtherForm(this.otherForm, this.responseMedida);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    MedidaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(479),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof medida_navigation_service_1.MedidaNavigationService !== 'undefined' && medida_navigation_service_1.MedidaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof medida_api_service_1.MedidaApiService !== 'undefined' && medida_api_service_1.MedidaApiService) === 'function' && _c) || Object, (typeof (_d = typeof medida_service_1.MedidaService !== 'undefined' && medida_service_1.MedidaService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _g) || Object])
	    ], MedidaFormComponent);
	    return MedidaFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.MedidaFormComponent = MedidaFormComponent;


/***/ },
/* 478 */
/***/ function(module, exports) {

	"use strict";
	var Medida = (function () {
	    function Medida() {
	    }
	    return Medida;
	}());
	exports.Medida = Medida;


/***/ },
/* 479 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <ul class=\"geo-breadcrumb\">\n    <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{medidaModule.plural}}</a></li>\n    <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{medidaModule.single | lowercase}}</a></li>\n  </ul>\n  <h1>{{actionTitle | capitalize}} {{medidaModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n  <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n    <div class=\"geo-columns--12c\">\n      <label class=\"geo-switch\">\n        <span class=\"geo-switch--label\">Ativo</span>\n        <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n        <div class=\"geo-switch--checkbox\">\n          <span class=\"geo-switch--status\"></span>\n        </div>\n      </label>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !medida.valid && submitted}\">\n      <label for=\"medida\">Medida <abbr>*</abbr></label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!medida.valid && submitted\">Este campo é obrigatório.</span>\n        <input type=\"text\" id=\"medida\" [(ngModel)]=\"formObject.medida\" formControlName=\"medida\">\n      </div>\n    </div>\n  </div>\n\n  <div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSalveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n  </div>\n</form>\n";

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ContasComponent = (function () {
	    function ContasComponent() {
	    }
	    ContasComponent.prototype.ngOnInit = function () {
	    };
	    ContasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(481)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContasComponent);
	    return ContasComponent;
	}());
	exports.ContasComponent = ContasComponent;


/***/ },
/* 481 */
171,
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var ContaContabilComponent = (function () {
	    function ContaContabilComponent() {
	    }
	    ContaContabilComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(483)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContaContabilComponent);
	    return ContaContabilComponent;
	}());
	exports.ContaContabilComponent = ContaContabilComponent;


/***/ },
/* 483 */
55,
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var router_1 = __webpack_require__(62);
	var core_1 = __webpack_require__(3);
	var conta_contabil_list_component_1 = __webpack_require__(485);
	var conta_contabil_form_component_1 = __webpack_require__(492);
	var data_service_1 = __webpack_require__(178);
	var ContaContabilRoutingModule = (function () {
	    function ContaContabilRoutingModule() {
	    }
	    ContaContabilRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContaContabilRoutingModule);
	    return ContaContabilRoutingModule;
	}());
	exports.ContaContabilRoutingModule = ContaContabilRoutingModule;
	exports.contaContabilRoutes = [
	    {
	        path: '',
	        component: conta_contabil_list_component_1.ContaContabilListComponent
	    },
	    {
	        path: data_service_1.newRoute,
	        component: conta_contabil_form_component_1.ContaContabilFormComponent
	    },
	    {
	        path: data_service_1.editRoute + '/:id',
	        component: conta_contabil_form_component_1.ContaContabilFormComponent
	    }
	];


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(159);
	var conta_contabil_api_service_1 = __webpack_require__(486);
	var conta_contabil_navigation_service_1 = __webpack_require__(487);
	var filter_service_1 = __webpack_require__(94);
	var util_service_1 = __webpack_require__(88);
	var conta_contabil_service_1 = __webpack_require__(488);
	var ContaContabilListComponent = (function () {
	    function ContaContabilListComponent(_contaContabilApiService, _contaContabilNavigationService, _contaContabilService, _filterService, _utilService) {
	        this._contaContabilApiService = _contaContabilApiService;
	        this._contaContabilNavigationService = _contaContabilNavigationService;
	        this._contaContabilService = _contaContabilService;
	        this._filterService = _filterService;
	        this._utilService = _utilService;
	        this.contaContabilModuleName = data_service_1.contasContabeisModuleName;
	        this.list = [];
	        this.listClone = [];
	        this.showDisabled = false;
	        this.loading = true;
	        this.codigoMask = data_service_1.contaContabilCodigoMask;
	        this.count = 0;
	    }
	    ContaContabilListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    ContaContabilListComponent.prototype.clickNew = function () {
	        this._contaContabilService.clearSessionStorage();
	        this._contaContabilNavigationService.goToNew();
	    };
	    ContaContabilListComponent.prototype.clickEdit = function (item) {
	        this._contaContabilService.clearSessionStorage();
	        this._contaContabilNavigationService.goToEdit(item.id);
	    };
	    ContaContabilListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    ContaContabilListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.listClone = Response;
	                var list = filterChildren(Response);
	                list.forEach(function (ll) {
	                    ll.labels = getLabels(ll);
	                });
	                this.list = list;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._contaContabilApiService.onGetAll(onDone);
	        function removeChildren(subcontas, list) {
	            var x, lenX, descricoesParaFiltrar = [];
	            subcontas.forEach(function (vv) {
	                for (x = 0, lenX = list.length; x < lenX; x++) {
	                    if (list[x].id === vv.id) {
	                        descricoesParaFiltrar.push(vv.descricao);
	                        descricoesParaFiltrar.push(vv.codigo);
	                        list.splice(x, 1);
	                        break;
	                    }
	                }
	            });
	            list.push(descricoesParaFiltrar);
	            return list;
	        }
	        var filterChildren = (function (subcontas) {
	            var itemId, subcontas2, list2, lastPosition, labels = [];
	            subcontas.forEach(function (item) {
	                itemId = item.id.toString();
	                subcontas2 = this._filterService.filterArray(this.listClone, itemId, ['paiId']);
	                list2 = removeChildren(subcontas2, this.listClone);
	                lastPosition = list2.length - 1;
	                labels.push(list2[lastPosition]);
	                list2.splice(lastPosition, 1);
	                this.listClone = list2;
	                subcontas2 = filterChildren(subcontas2);
	                item.contas = subcontas2;
	                item.labels = labels;
	            }.bind(this));
	            return subcontas;
	        }.bind(this));
	        function getLabels(ll) {
	            var labels = [];
	            var labels2 = [];
	            ll.contas.forEach(function (nn1) {
	                labels.push(nn1.descricao);
	                labels.push(nn1.codigo);
	                nn1.contas.forEach(function (nn2) {
	                    labels.push(nn2.descricao);
	                    labels.push(nn2.codigo);
	                    nn2.contas.forEach(function (nn3) {
	                        labels.push(nn3.descricao);
	                        labels.push(nn3.codigo);
	                        nn3.contas.forEach(function (nn4) {
	                            labels.push(nn4.descricao);
	                            labels.push(nn4.codigo);
	                            nn4.contas.forEach(function (nn5) {
	                                labels.push(nn5.descricao);
	                                labels.push(nn5.codigo);
	                                nn5.contas.forEach(function (nn6) {
	                                    labels.push(nn6.descricao);
	                                    labels.push(nn6.codigo);
	                                    nn6.contas.forEach(function (nn7) {
	                                        labels.push(nn7.descricao);
	                                        labels.push(nn7.codigo);
	                                        nn7.contas.forEach(function (nn8) {
	                                            labels2.push(nn8.descricao);
	                                            labels2.push(nn8.codigo);
	                                            nn8.labels = labels;
	                                        });
	                                        nn7.labels = labels;
	                                    });
	                                    nn6.labels = labels;
	                                });
	                                nn5.labels = labels;
	                            });
	                            nn4.labels = labels;
	                        });
	                        nn3.labels = labels;
	                    });
	                    nn2.labels = labels;
	                });
	                nn1.labels = labels;
	            });
	            return labels;
	        }
	    };
	    ContaContabilListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._contaContabilApiService.onDelete(item.id, onDone);
	    };
	    ContaContabilListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(491)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof conta_contabil_api_service_1.ContaContabilApiService !== 'undefined' && conta_contabil_api_service_1.ContaContabilApiService) === 'function' && _a) || Object, (typeof (_b = typeof conta_contabil_navigation_service_1.ContaContabilNavigationService !== 'undefined' && conta_contabil_navigation_service_1.ContaContabilNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof conta_contabil_service_1.ContaContabilService !== 'undefined' && conta_contabil_service_1.ContaContabilService) === 'function' && _c) || Object, (typeof (_d = typeof filter_service_1.FilterService !== 'undefined' && filter_service_1.FilterService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], ContaContabilListComponent);
	    return ContaContabilListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ContaContabilListComponent = ContaContabilListComponent;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(159);
	var ContaContabilApiService = (function () {
	    function ContaContabilApiService(_restService) {
	        this._restService = _restService;
	    }
	    ContaContabilApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    ContaContabilApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    ContaContabilApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    ContaContabilApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "codigo", "include": ["pai", "tipo"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ContaContabilApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": "pai" };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    ContaContabilApiService.prototype.onGetFather = function (fatherId, done) {
	        this._restService.onGet(data_service_1.apiName + '/pai/' + fatherId, done);
	    };
	    ContaContabilApiService.prototype.onGetByCode = function (code, done) {
	        var filter = { "where": { "codigo": code } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ContaContabilApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    ContaContabilApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ContaContabilApiService);
	    return ContaContabilApiService;
	    var _a;
	}());
	exports.ContaContabilApiService = ContaContabilApiService;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(159);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(158);
	var ContaContabilNavigationService = (function () {
	    function ContaContabilNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    ContaContabilNavigationService.prototype.goToList = function () {
	        var router = data_service_3.contasRoute + '/' + data_service_1.contasContabeisRouter;
	        this._authService.navigateTo(router);
	    };
	    ContaContabilNavigationService.prototype.goToNew = function () {
	        var router = data_service_3.contasRoute + '/' + data_service_1.contasContabeisRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    ContaContabilNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_3.contasRoute + '/' + data_service_1.contasContabeisRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    ContaContabilNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ContaContabilNavigationService);
	    return ContaContabilNavigationService;
	    var _a;
	}());
	exports.ContaContabilNavigationService = ContaContabilNavigationService;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(159);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(160);
	var grupo_material_service_1 = __webpack_require__(489);
	var grupo_material_navigation_service_1 = __webpack_require__(490);
	var material_service_1 = __webpack_require__(475);
	var data_service_3 = __webpack_require__(161);
	var ContaContabilService = (function () {
	    function ContaContabilService(_grupoMaterialService, _grupoMaterialNavigationService, _materialService, _autocompleteService) {
	        this._grupoMaterialService = _grupoMaterialService;
	        this._grupoMaterialNavigationService = _grupoMaterialNavigationService;
	        this._materialService = _materialService;
	        this._autocompleteService = _autocompleteService;
	        //select2 para a caonta contabil
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var code = '';
	                        var description = '';
	                        if (state.codigo) {
	                            code = state.codigo.concat(" - ");
	                        }
	                        if (state.descricao) {
	                            description = state.descricao;
	                        }
	                        text = code.concat(description);
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    ContaContabilService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.contasContabeisStorage + '-new', object);
	    };
	    ContaContabilService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.contasContabeisStorage + "-new");
	        return JSON.parse(item);
	    };
	    ContaContabilService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.contasContabeisStorage + "-new");
	    };
	    ContaContabilService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_2.gruposMateriaisStorage) {
	                otherFormObject = this._grupoMaterialService.getSessionStorage();
	                otherFormObject.contaContabil = Response;
	                this._grupoMaterialService.setSessionStorage(otherFormObject);
	            }
	            else if (otherForm === data_service_3.materialStorageName) {
	                otherFormObject = this._materialService.getSessionStorage();
	                otherFormObject.contaContabil = Response;
	                this._materialService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.contasContabeisStorage);
	        if (otherForm === data_service_2.gruposMateriaisStorage) {
	            otherFormObject = this._grupoMaterialService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._grupoMaterialNavigationService.goToEditSubgrupo(otherFormObject.grupoId, otherFormObject.id);
	            }
	            else {
	                this._grupoMaterialNavigationService.goToAddSubgrupo(otherFormObject.grupoId);
	            }
	        }
	        else if (otherForm === data_service_3.materialStorageName) {
	            otherFormObject = this._materialService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._materialService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._materialService.goToAdd();
	            }
	        }
	    };
	    //others
	    //parametros: fatherCode=codigo da conta contabil pai / nextCode=codigo a ser adotado pela conta filho
	    //retorna o novo codigo da conta filho
	    ContaContabilService.prototype.getLastCodeNumber = function (fatherCode, nextCode) {
	        var codeSplit = fatherCode.split(".");
	        var first0 = codeSplit.indexOf("0");
	        var newCode = '';
	        if (first0 === -1) {
	            first0 = codeSplit.indexOf("00");
	            if (nextCode.length === 1) {
	                nextCode = "0".concat(nextCode);
	            }
	        }
	        codeSplit[first0] = nextCode;
	        newCode = codeSplit.toString();
	        newCode = newCode.replace(/,/g, ".");
	        return newCode;
	    };
	    ContaContabilService.prototype.getTipoEstoque = function () {
	        return 1;
	    };
	    ContaContabilService.prototype.getTipoConsumo = function () {
	        return 2;
	    };
	    ContaContabilService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof grupo_material_service_1.GrupoMaterialService !== 'undefined' && grupo_material_service_1.GrupoMaterialService) === 'function' && _a) || Object, (typeof (_b = typeof grupo_material_navigation_service_1.GrupoMaterialNavigationService !== 'undefined' && grupo_material_navigation_service_1.GrupoMaterialNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _c) || Object, (typeof (_d = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _d) || Object])
	    ], ContaContabilService);
	    return ContaContabilService;
	    var _a, _b, _c, _d;
	}());
	exports.ContaContabilService = ContaContabilService;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_1 = __webpack_require__(160);
	var material_service_1 = __webpack_require__(475);
	var data_service_2 = __webpack_require__(161);
	var GrupoMaterialService = (function () {
	    function GrupoMaterialService(_materialService, _autocompleteService) {
	        this._materialService = _materialService;
	        this._autocompleteService = _autocompleteService;
	        //select2 para a caonta contabil
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var code = '';
	                        var description = '';
	                        if (state.codigo) {
	                            code = state.codigo.toString();
	                            code = this.getLastCodeNumber(code);
	                            code = code.concat(" - ");
	                        }
	                        else if (state.codigoGrupo) {
	                            code = state.codigoGrupo.toString();
	                            code = this.getLastCodeNumber(code);
	                            code = code.concat(" - ");
	                        }
	                        if (state.descricao) {
	                            description = state.descricao;
	                        }
	                        text = code.concat(description);
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    GrupoMaterialService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.gruposMateriaisStorage + '-new', object);
	    };
	    GrupoMaterialService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.gruposMateriaisStorage + "-new");
	        return JSON.parse(item);
	    };
	    GrupoMaterialService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.gruposMateriaisStorage + "-new");
	    };
	    //others
	    GrupoMaterialService.prototype.getLastCodeNumber = function (nextCode) {
	        if (nextCode.length === 1) {
	            nextCode = "00".concat(nextCode);
	        }
	        else if (nextCode.length === 2) {
	            nextCode = "0".concat(nextCode);
	        }
	        return nextCode;
	    };
	    GrupoMaterialService.prototype.returnToOtherForm = function (otherForm, Response) {
	        var otherFormObject;
	        if (Response) {
	            if (otherForm === data_service_2.materialStorageName) {
	                otherFormObject = this._materialService.getSessionStorage();
	                if (Response.grupoId) {
	                    otherFormObject.subgrupo = Response;
	                }
	                else {
	                    otherFormObject.grupo = Response;
	                }
	                this._materialService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.gruposMateriaisStorage);
	        if (otherForm === data_service_2.materialStorageName) {
	            otherFormObject = this._materialService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._materialService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._materialService.goToAdd();
	            }
	        }
	    };
	    GrupoMaterialService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _a) || Object, (typeof (_b = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _b) || Object])
	    ], GrupoMaterialService);
	    return GrupoMaterialService;
	    var _a, _b;
	}());
	exports.GrupoMaterialService = GrupoMaterialService;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(160);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(156);
	var GrupoMaterialNavigationService = (function () {
	    function GrupoMaterialNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    GrupoMaterialNavigationService.prototype.goToList = function () {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.gruposMateriaisRouter;
	        this._authService.navigateTo(router);
	    };
	    GrupoMaterialNavigationService.prototype.goToNew = function () {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.gruposMateriaisRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    GrupoMaterialNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.gruposMateriaisRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    //subgrupos
	    GrupoMaterialNavigationService.prototype.goToAddSubgrupo = function (grupoId) {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.gruposMateriaisRouter + '/' + data_service_1.subgruposMateriaisRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router, grupoId);
	    };
	    GrupoMaterialNavigationService.prototype.goToEditSubgrupo = function (grupoId, objectId) {
	        var router = data_service_3.almoxarifadoRoute + '/' + data_service_1.gruposMateriaisRouter + '/' + data_service_1.subgruposMateriaisRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, [grupoId, objectId]);
	    };
	    GrupoMaterialNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], GrupoMaterialNavigationService);
	    return GrupoMaterialNavigationService;
	    var _a;
	}());
	exports.GrupoMaterialNavigationService = GrupoMaterialNavigationService;


/***/ },
/* 491 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{contaContabilModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{contaContabilModuleName.single | lowercase}} cadastrada</p>\n\n</div>\n\n<conta-contabil-table [list]=\"list\"\n                      [listFilter]=\"listFilter\"\n                      [showDisabled]=\"showDisabled\"\n                      [count]=\"count\"\n                      (editEvent)=\"clickEdit($event)\"\n                      (deleteEvent)=\"clickDelete($event)\"></conta-contabil-table>\n";

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(159);
	var conta_contabil_model_1 = __webpack_require__(493);
	var contaContabilCodigo_validator_1 = __webpack_require__(494);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var conta_contabil_service_1 = __webpack_require__(488);
	var conta_contabil_api_service_1 = __webpack_require__(486);
	var conta_contabil_navigation_service_1 = __webpack_require__(487);
	var data_service_2 = __webpack_require__(178);
	var conta_contabil_tipo_api_service_1 = __webpack_require__(495);
	var ContaContabilFormComponent = (function () {
	    function ContaContabilFormComponent(_route, _contaContabilService, _contaContabilApiService, _contaContabilNavigationService, _autocompleteService, _contaContabilTipoService, _utilService, _fb) {
	        this._route = _route;
	        this._contaContabilService = _contaContabilService;
	        this._contaContabilApiService = _contaContabilApiService;
	        this._contaContabilNavigationService = _contaContabilNavigationService;
	        this._autocompleteService = _autocompleteService;
	        this._contaContabilTipoService = _contaContabilTipoService;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this.contaContabilModule = data_service_1.contasContabeisModuleName;
	        this.formObject = new conta_contabil_model_1.ContaContabil();
	        this.contaContabilPaiObject = new conta_contabil_model_1.ContaContabil();
	        this.btnSalveDisabled = false;
	        this.submitted = false;
	        this.loading = false;
	        this.descricao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipo = new forms_1.FormControl();
	        this.descricaoAnalitica = new forms_1.FormControl();
	        this.codigo = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, contaContabilCodigo_validator_1.ContaContabilCodigoValidator.contaContabilCodigoFormat]));
	        this.pai = new forms_1.FormControl();
	        this.ativo = new forms_1.FormControl();
	        this.contaContabilSelectId = 'contacontabil_contaContabil';
	        this.codeExists = false;
	        this.disabledModel = false;
	        this.types = [];
	        this.models = data_service_1.modelosContaContabil;
	        this.codigoMask = data_service_1.contaContabilCodigoMask;
	        this.returnToOtherForm = false;
	        this.otherForm = "";
	        this.contaContabilTemplateResult = (function (state) {
	            var template = this._contaContabilService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseContaContabil = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            descricao: this.descricao,
	            tipo: this.tipo,
	            descricaoAnalitica: this.descricaoAnalitica,
	            codigo: this.codigo,
	            pai: this.pai
	        });
	    }
	    ContaContabilFormComponent.prototype.ngOnInit = function () {
	        this.getTiposContaContabil();
	        this.isNewAutoComplete();
	        this.contaContabilQuery = this._utilService.cloneObject(data_service_1.contasContabeisQuery);
	        this.contaContabilQuery.where.descricaoAnalitica = false;
	    };
	    ContaContabilFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    ContaContabilFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    ContaContabilFormComponent.prototype.clickCheckType = function (selectedItemKey) {
	        this.formObject.tipoId = selectedItemKey;
	        this.checkType();
	    };
	    ContaContabilFormComponent.prototype.clickCheckModel = function (selectedItemKey) {
	        this.formObject.descricaoAnalitica = (selectedItemKey === 2) ? true : false;
	        this.checkModel();
	    };
	    ContaContabilFormComponent.prototype.blurCode = function () {
	        if (this.formObject.codigo) {
	            this.checkIfExistsCode(this.formObject.codigo);
	        }
	    };
	    ContaContabilFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid && !this.codeExists) {
	            this.btnSalveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (!object.descricaoAnalitica) {
	                object.tipoId = null;
	                object.descricaoAnalitica = false;
	            }
	            if (this.contaContabilPaiObject.id) {
	                object.paiId = this.contaContabilPaiObject.id;
	            }
	            else {
	                object.paiId = null;
	            }
	            delete object['contas'];
	            if (object.id) {
	                this.onEditContaContabil(object);
	            }
	            else {
	                this.onSaveContaContabil(object);
	            }
	        }
	    };
	    ContaContabilFormComponent.prototype.onGetContaContabilObject = function (object) {
	        if (object.novo) {
	            this.contaContabilPaiObject = {};
	            this.formObject.codigo = '';
	            return false;
	        }
	        this.contaContabilPaiObject = object;
	        if (object.id) {
	            this._utilService.setSelectOnFormControl(this.form, 'pai', object);
	            this.onGetFather(object.id);
	        }
	        else {
	            this._utilService.setSelectOnFormControl(this.form, 'pai', { id: -1 });
	        }
	    };
	    ContaContabilFormComponent.prototype.checkType = function () {
	        if (this.formObject.tipoId) {
	            var selectedItemKey = this.formObject.tipoId;
	            setTimeout(function () {
	                var tt = document.getElementById("type_" + selectedItemKey);
	                if (tt) {
	                    tt.checked = true;
	                }
	            });
	        }
	    };
	    ContaContabilFormComponent.prototype.checkModel = function () {
	        var selectedItemKey;
	        if (this.formObject.descricaoAnalitica) {
	            selectedItemKey = this.models[1].Key; //analitica
	            if (!this.formObject.tipoId) {
	                this.formObject.tipoId = this.types[0].id;
	            }
	            this.checkType();
	        }
	        else {
	            selectedItemKey = this.models[0].Key; //sintetica
	        }
	        setTimeout(function () {
	            var tt = document.getElementById("model_" + selectedItemKey);
	            if (tt) {
	                tt.checked = true;
	            }
	        });
	    };
	    ContaContabilFormComponent.prototype.onSaveContaContabil = function (objeto) {
	        this._contaContabilApiService.onPost(objeto, this.onDone);
	    };
	    ContaContabilFormComponent.prototype.onEditContaContabil = function (objeto) {
	        this._contaContabilApiService.onPut(objeto, this.onDone);
	    };
	    ContaContabilFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma conta contábil encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._contaContabilApiService.onGetById(id, onDone);
	    };
	    ContaContabilFormComponent.prototype.onGetFather = function (fatherId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var fatherCode = this.contaContabilPaiObject.codigo, nextCode = Response.toString();
	                var newCode = this._contaContabilService.getLastCodeNumber(fatherCode, nextCode);
	                this.formObject.codigo = newCode;
	                this._utilService.setSelectOnFormControl(this.form, 'codigo', newCode);
	                this.checkIfAnalytic();
	            }
	            else {
	                console.log("Erro: " + Response.message);
	            }
	            this.loading = false;
	        }.bind(this));
	        this._contaContabilApiService.onGetFather(fatherId, onDone);
	    };
	    //check if exists the code typed by user
	    ContaContabilFormComponent.prototype.checkIfExistsCode = function (newCode) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (Response.length > 0) {
	                    this.codeExists = true;
	                }
	                else {
	                    this.codeExists = false;
	                }
	            }
	            else {
	                console.log("Erro: " + Response.message);
	            }
	            this.loading = false;
	        }.bind(this));
	        this._contaContabilApiService.onGetByCode(newCode, onDone);
	    };
	    //if de last digit of the code is no empty, de object is analytic
	    ContaContabilFormComponent.prototype.checkIfAnalytic = function () {
	        var newCode = this.formObject.codigo;
	        var codeSplit = newCode.split(".");
	        var lastIndex = codeSplit.length - 1;
	        var lastDigit = parseInt(codeSplit[lastIndex]);
	        if (lastDigit > 0) {
	            this.disabledModel = true;
	            this.formObject.descricaoAnalitica = true;
	        }
	        this.checkModel();
	    };
	    ContaContabilFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._contaContabilService.getSessionStorage();
	        this._contaContabilService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    ContaContabilFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    ContaContabilFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    ContaContabilFormComponent.prototype.setNewNormal = function () {
	        this.checkModel();
	    };
	    ContaContabilFormComponent.prototype.setEditSession = function () {
	    };
	    ContaContabilFormComponent.prototype.setNewSession = function () {
	    };
	    ContaContabilFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.contasContabeisStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.descricao = newAutoComplete.descricao;
	            this.formObject.tipoId = newAutoComplete.tipoId;
	            this.formObject.descricaoAnalitica = newAutoComplete.descricaoAnalitica;
	            this.setActionTitle(this.formObject.id);
	            this.setModelToForm();
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    ContaContabilFormComponent.prototype.setModelToForm = function () {
	        this.checkType();
	        this.checkModel();
	        if (this.formObject.pai) {
	            this.contaContabilPaiObject = this.formObject.pai;
	            delete this.formObject['pai'];
	            var text = this._autocompleteService.getTextSelect2(this.contaContabilPaiObject, 'descricao');
	            text = this.contaContabilPaiObject.codigo.concat(" - " + text);
	            var selectObject = { text: text, id: this.contaContabilPaiObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.contaContabilSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.contaContabilSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'pai', this.contaContabilPaiObject);
	        }
	    };
	    ContaContabilFormComponent.prototype.goToList = function () {
	        this._contaContabilNavigationService.goToList();
	    };
	    ContaContabilFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._contaContabilService.returnToOtherForm(this.otherForm, this.responseContaContabil);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    ContaContabilFormComponent.prototype.getTiposContaContabil = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.types = Response;
	                this.checkType();
	            }
	        }.bind(this));
	        this._contaContabilTipoService.onGetAll(onDone);
	    };
	    ContaContabilFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(497)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof conta_contabil_service_1.ContaContabilService !== 'undefined' && conta_contabil_service_1.ContaContabilService) === 'function' && _b) || Object, (typeof (_c = typeof conta_contabil_api_service_1.ContaContabilApiService !== 'undefined' && conta_contabil_api_service_1.ContaContabilApiService) === 'function' && _c) || Object, (typeof (_d = typeof conta_contabil_navigation_service_1.ContaContabilNavigationService !== 'undefined' && conta_contabil_navigation_service_1.ContaContabilNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object, (typeof (_f = typeof conta_contabil_tipo_api_service_1.ContaContabilTipoApiService !== 'undefined' && conta_contabil_tipo_api_service_1.ContaContabilTipoApiService) === 'function' && _f) || Object, (typeof (_g = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object])
	    ], ContaContabilFormComponent);
	    return ContaContabilFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.ContaContabilFormComponent = ContaContabilFormComponent;


/***/ },
/* 493 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 12/09/2016.
	 */
	var ContaContabil = (function () {
	    function ContaContabil() {
	    }
	    return ContaContabil;
	}());
	exports.ContaContabil = ContaContabil;


/***/ },
/* 494 */
/***/ function(module, exports) {

	"use strict";
	var ContaContabilCodigoValidator = (function () {
	    function ContaContabilCodigoValidator() {
	    }
	    ContaContabilCodigoValidator.contaContabilCodigoFormat = function (item) {
	        var code = item.value;
	        if (code) {
	            var CODIGO_REGEXP = /^\d{1}\.\d{1}\.\d{1}\.\d{1}\.\d{1}\.\d{2}\.\d{2}$/;
	            if (!CODIGO_REGEXP.test(code)) {
	                return { "incorrectCodigoFormat": true };
	            }
	            return null;
	        }
	    };
	    return ContaContabilCodigoValidator;
	}());
	exports.ContaContabilCodigoValidator = ContaContabilCodigoValidator;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(496);
	var ContaContabilTipoApiService = (function () {
	    function ContaContabilTipoApiService(_restService) {
	        this._restService = _restService;
	    }
	    ContaContabilTipoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    ContaContabilTipoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    ContaContabilTipoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    ContaContabilTipoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": ["descricao"], "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ContaContabilTipoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    ContaContabilTipoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    ContaContabilTipoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ContaContabilTipoApiService);
	    return ContaContabilTipoApiService;
	    var _a;
	}());
	exports.ContaContabilTipoApiService = ContaContabilTipoApiService;


/***/ },
/* 496 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-contas-contabeis';


/***/ },
/* 497 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{contaContabilModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{contaContabilModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{contaContabilModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !descricao.valid && submitted}\">\n            <label for=\"contacontabil_descricao\">Descrição <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!descricao.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"contacontabil_descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\" maxlength=\"255\">\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <autocomplete-component class=\"geo-input--3c\" id=\"contacontabil_contaContabil\"\n                                (setObejct)=\"onGetContaContabilObject($event)\"\n                                (clearObject)=\"onGetContaContabilObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"contaContabilSelectId\"\n                                [model]=\"contaContabilPaiObject\"\n                                [_service]=\"_contaContabilApiService\"\n                                [templateResult]=\"contaContabilTemplateResult\"\n                                [query]=\"contaContabilQuery\"\n                                [isCreateNew]=\"false\"\n                                [clear]=\"true\"\n                                [label]=\"'Relação (conta pai)'\"></autocomplete-component>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!codigo.valid && submitted) || (codigo.errors && codigo.errors.incorrectCodigoFormat) || codeExists}\">\n            <label for=\"contacontabil_codigo\">Código <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!codigo.valid && submitted && !codeExists && (codigo.errors && !codigo.errors.incorrectCodigoFormat)\">Este campo é obrigatório.</span>\n                <span class=\"error-alert\" *ngIf=\"codeExists\">Este código já existe.</span>\n                <!--<span class=\"error-alert\" *ngIf=\"codigo.errors && codigo.errors.incorrectCodigoFormat\">Formato incorreto.</span>-->\n                <input type=\"text\" id=\"contacontabil_codigo\" [(ngModel)]=\"formObject.codigo\" formControlName=\"codigo\" (blur)=\"blurCode()\" contaContabilCodigoMask maxlength=\"15\">\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Modelo de conta</h2>\n        <div *ngFor=\"let item of models\" class=\"geo-toggle\">\n            <input id=\"model_{{item.Key}}\" type=\"radio\" name=\"modelo\" value=\"{{item.Key}}\" (change)=\"clickCheckModel(item.Key)\" [disabled]=\"disabledModel\">\n            <label attr.for=\"model_{{item.Key}}\">{{item.Value}}</label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\" *ngIf=\"formObject.descricaoAnalitica\">\n        <h2>Tipo de conta</h2>\n        <div *ngFor=\"let item of types\" class=\"geo-toggle\">\n            <input id=\"type_{{item.id}}\" type=\"radio\" name=\"tipo\" value=\"{{item.id}}\" (change)=\"clickCheckType(item.id)\">\n            <label attr.for=\"type_{{item.id}}\">{{item.descricao}}</label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSalveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n\n\n";

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var GruposMateriaisComponent = (function () {
	    function GruposMateriaisComponent() {
	    }
	    GruposMateriaisComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(499)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], GruposMateriaisComponent);
	    return GruposMateriaisComponent;
	}());
	exports.GruposMateriaisComponent = GruposMateriaisComponent;


/***/ },
/* 499 */
55,
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var router_1 = __webpack_require__(62);
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(178);
	var grupo_material_list_component_1 = __webpack_require__(501);
	var grupo_material_form_component_1 = __webpack_require__(504);
	var data_service_2 = __webpack_require__(160);
	var GruposMateriaisRoutingModule = (function () {
	    function GruposMateriaisRoutingModule() {
	    }
	    GruposMateriaisRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], GruposMateriaisRoutingModule);
	    return GruposMateriaisRoutingModule;
	}());
	exports.GruposMateriaisRoutingModule = GruposMateriaisRoutingModule;
	exports.gruposMateriaisRoutes = [
	    {
	        path: '',
	        component: grupo_material_list_component_1.GrupoMaterialListComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: grupo_material_form_component_1.GrupoMaterialFormComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: grupo_material_form_component_1.GrupoMaterialFormComponent
	    }, {
	        path: data_service_2.subgruposMateriaisRouter + '/' + data_service_1.editRoute + '/:grupoId/:id',
	        component: grupo_material_form_component_1.GrupoMaterialFormComponent
	    }, {
	        path: data_service_2.subgruposMateriaisRouter + '/' + data_service_1.newRoute + '/:grupoId',
	        component: grupo_material_form_component_1.GrupoMaterialFormComponent
	    }
	];


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var grupo_material_service_1 = __webpack_require__(489);
	var util_service_1 = __webpack_require__(88);
	var filter_service_1 = __webpack_require__(94);
	var data_service_1 = __webpack_require__(160);
	var data_service_2 = __webpack_require__(159);
	var grupo_material_api_service_1 = __webpack_require__(502);
	var grupo_material_navigation_service_1 = __webpack_require__(490);
	var GrupoMaterialListComponent = (function () {
	    function GrupoMaterialListComponent(_grupoMaterialService, _grupoMaterialApiService, _grupoMaterialNavigationService, _utilService, _filterService) {
	        this._grupoMaterialService = _grupoMaterialService;
	        this._grupoMaterialApiService = _grupoMaterialApiService;
	        this._grupoMaterialNavigationService = _grupoMaterialNavigationService;
	        this._utilService = _utilService;
	        this._filterService = _filterService;
	        this.gruposMateriaisModuleName = data_service_1.gruposMateriaisModuleName;
	        this.subgrupoMaterialModuelName = data_service_1.subgruposMateriaisModuleName;
	        this.list = [];
	        this.showDisabled = false;
	        this.loading = true;
	        this.codigoMask = data_service_1.grupoMaterialCodigoMask;
	        this.contaContabilCodigoMask = data_service_2.contaContabilCodigoMask;
	    }
	    GrupoMaterialListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    GrupoMaterialListComponent.prototype.clickNew = function () {
	        this._grupoMaterialService.clearSessionStorage();
	        this._grupoMaterialNavigationService.goToNew();
	    };
	    GrupoMaterialListComponent.prototype.clickEdit = function (item) {
	        this._grupoMaterialService.clearSessionStorage();
	        this._grupoMaterialNavigationService.goToEdit(item.id);
	    };
	    GrupoMaterialListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    GrupoMaterialListComponent.prototype.clickAddSubgrupo = function (grupo) {
	        this._grupoMaterialService.clearSessionStorage();
	        this._grupoMaterialNavigationService.goToAddSubgrupo(grupo.id);
	    };
	    GrupoMaterialListComponent.prototype.clickEditSubgrupo = function (grupo, subgrupo) {
	        this._grupoMaterialService.clearSessionStorage();
	        this._grupoMaterialNavigationService.goToEditSubgrupo(grupo.id, subgrupo.id);
	    };
	    GrupoMaterialListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list_1 = Response;
	                var subgrupos = [], listClone = [], itemId;
	                Response.forEach(function (item) {
	                    if (!item.grupoId) {
	                        itemId = item.id.toString();
	                        subgrupos = this._filterService.filterArray(list_1, item.id, ['grupoId']);
	                        item.subgrupos = subgrupos;
	                        listClone.push(item);
	                    }
	                    subgrupos = [];
	                }.bind(this));
	                this.list = listClone;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._grupoMaterialApiService.onGetAll(onDone);
	    };
	    GrupoMaterialListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (item.grupoId) {
	                    this.disabledSubgrupo(item);
	                }
	                else {
	                    this.disabledGrupo(item);
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._grupoMaterialApiService.onDelete(item.id, onDone);
	    };
	    GrupoMaterialListComponent.prototype.disabledGrupo = function (item) {
	        var x, lenX;
	        for (x = 0, lenX = this.list.length; x < lenX; x++) {
	            if (this.list[x].id === item.id) {
	                this.list[x].ativo = false;
	                break;
	            }
	        }
	    };
	    GrupoMaterialListComponent.prototype.disabledSubgrupo = function (item) {
	        var x, lenX, grupoIndex;
	        for (x = 0, lenX = this.list.length; x < lenX; x++) {
	            if (this.list[x].id === item.grupoId) {
	                grupoIndex = x;
	                break;
	            }
	        }
	        for (x = 0, lenX = this.list[grupoIndex].subgrupos.length; x < lenX; x++) {
	            if (this.list[grupoIndex].subgrupos[x].id === item.id) {
	                this.list[grupoIndex].subgrupos[x].ativo = false;
	                break;
	            }
	        }
	    };
	    GrupoMaterialListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(503)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof grupo_material_service_1.GrupoMaterialService !== 'undefined' && grupo_material_service_1.GrupoMaterialService) === 'function' && _a) || Object, (typeof (_b = typeof grupo_material_api_service_1.GrupoMaterialApiService !== 'undefined' && grupo_material_api_service_1.GrupoMaterialApiService) === 'function' && _b) || Object, (typeof (_c = typeof grupo_material_navigation_service_1.GrupoMaterialNavigationService !== 'undefined' && grupo_material_navigation_service_1.GrupoMaterialNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof filter_service_1.FilterService !== 'undefined' && filter_service_1.FilterService) === 'function' && _e) || Object])
	    ], GrupoMaterialListComponent);
	    return GrupoMaterialListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.GrupoMaterialListComponent = GrupoMaterialListComponent;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(160);
	var rest_service_1 = __webpack_require__(26);
	var GrupoMaterialApiService = (function () {
	    function GrupoMaterialApiService(_restService) {
	        this._restService = _restService;
	    }
	    GrupoMaterialApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    GrupoMaterialApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    GrupoMaterialApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    GrupoMaterialApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": ["codigo", "codigoGrupo"], "include": "contaContabil" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    GrupoMaterialApiService.prototype.onGetFather = function (fatherId, done) {
	        this._restService.onGet(data_service_1.apiName + '/pai/' + fatherId, done);
	    };
	    GrupoMaterialApiService.prototype.onGetByCodeSubgrupo = function (code, fatherId, done) {
	        var filter = { "where": { "codigoGrupo": code, "grupoId": fatherId } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    GrupoMaterialApiService.prototype.onGetByCodeGrupo = function (code, done) {
	        var filter = { "where": { "codigo": code } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    GrupoMaterialApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": "contaContabil" };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    GrupoMaterialApiService.prototype.onGetGrupos = function (done) {
	        var filter = { "where": { "ativo": true, "grupoId": null } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    GrupoMaterialApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    GrupoMaterialApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], GrupoMaterialApiService);
	    return GrupoMaterialApiService;
	    var _a;
	}());
	exports.GrupoMaterialApiService = GrupoMaterialApiService;


/***/ },
/* 503 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n  <div class=\"geo-columns--3c\">\n    <h1>{{gruposMateriaisModuleName.plural}}</h1>\n\n    <label class=\"geo-switch\">\n      <span class=\"geo-switch--label\">Exibir inativos:</span>\n      <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n      <div class=\"geo-switch--checkbox\">\n        <span class=\"geo-switch--status\"></span>\n      </div>\n    </label>\n  </div>\n  <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n    <div class=\"geo-input--4c geo-input--search\">\n      <div>\n        <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n      </div>\n    </div>\n    <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n  </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{gruposMateriaisModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Código</th>\n            <th>Descrição</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['descricao', 'codigo'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.codigo | codigoMask: codigoMask}} <span *ngIf=\"!item.codigo\"> - </span></td>\n            <td>{{item.descricao}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <a class=\"geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickAddSubgrupo(item)\">Novo subgrupo</a>\n\n                <table>\n                    <thead>\n                    <tr>\n                        <th>Código</th>\n                        <th>Conta contábil de estoque</th>\n                        <th>Descrição</th>\n                        <th class=\"small\"></th>\n                    </tr>\n                    </thead>\n                    <tbody *ngIf=\"item.subgrupos.length === 0\">\n                    <tr>\n                        <td colspan=\"4\">Nenhum {{subgrupoMaterialModuelName.single | lowercase}} cadastrado</td>\n                    </tr>\n                    </tbody>\n                    <tbody *ngFor=\"let subgrupo of(item.subgrupos | filterActive:showDisabled)\">\n                    <tr [ngClass]=\"{inative: !subgrupo.ativo}\">\n                        <td>{{subgrupo.codigoGrupo | codigoMask: codigoMask}}</td>\n                        <td>\n                            <span *ngIf=\"subgrupo.contaContabil\">\n                                {{subgrupo.contaContabil.codigo}} - {{subgrupo.contaContabil.descricao}}\n                            </span>\n                        </td>\n                        <td>{{subgrupo.descricao}} </td>\n                        <td class=\"geo-table--action\">\n                            <a (click)=\"clickEditSubgrupo(item, subgrupo)\">\n                                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                            </a>\n                            <a (click)=\"clickDelete(subgrupo)\">\n                                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                            </a>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(160);
	var grupo_material_service_1 = __webpack_require__(489);
	var grupo_material_api_service_1 = __webpack_require__(502);
	var grupo_material_navigation_service_1 = __webpack_require__(490);
	var conta_contabil_api_service_1 = __webpack_require__(486);
	var conta_contabil_navigation_service_1 = __webpack_require__(487);
	var autocomplete_service_1 = __webpack_require__(101);
	var util_service_1 = __webpack_require__(88);
	var grupo_material_codigo_validator_1 = __webpack_require__(505);
	var data_service_2 = __webpack_require__(159);
	var conta_contabil_service_1 = __webpack_require__(488);
	var data_service_3 = __webpack_require__(178);
	var conta_contabil_model_1 = __webpack_require__(493);
	var GrupoMaterialFormComponent = (function () {
	    function GrupoMaterialFormComponent(_grupoMaterialService, _grupoMaterialApiService, _grupoMaterialNavigationService, _contaContabilApiService, _contaContabilNavigationService, _contaContabilService, _autocompleteService, _utilService, _router, _route, builder) {
	        this._grupoMaterialService = _grupoMaterialService;
	        this._grupoMaterialApiService = _grupoMaterialApiService;
	        this._grupoMaterialNavigationService = _grupoMaterialNavigationService;
	        this._contaContabilApiService = _contaContabilApiService;
	        this._contaContabilNavigationService = _contaContabilNavigationService;
	        this._contaContabilService = _contaContabilService;
	        this._autocompleteService = _autocompleteService;
	        this._utilService = _utilService;
	        this._router = _router;
	        this._route = _route;
	        this.builder = builder;
	        this.grupoMaterialModule = data_service_1.gruposMateriaisModuleName;
	        this.formObject = {};
	        this.grupoObject = {};
	        this.contaContabilObject = new conta_contabil_model_1.ContaContabil();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.btnSalveDisabled = false;
	        this.submitAttempt = false;
	        this.isMaterialSubgrupo = false;
	        this.codeExists = false;
	        this.codigoMask = data_service_1.grupoMaterialCodigoMask;
	        this.gruposList = [];
	        this.codigo = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, grupo_material_codigo_validator_1.GrupoMaterialCodigoValidator.grupoMaterialCodigoFormat]));
	        this.descricao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.contaContabil = new forms_1.FormControl();
	        this.grupo = new forms_1.FormControl();
	        this.ativo = new forms_1.FormControl();
	        this.contaContabilSelectId = 'grupoMaterial_contacontabil';
	        this.materialSubgrupRouter = data_service_1.subgruposMateriaisRouter;
	        this.hasSession = false;
	        this.returnToOtherForm = false;
	        this.otherForm = "";
	        this.contaContabilTemplateResult = (function (state) {
	            var template = this._contaContabilService.templateResult(state, true);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                var contaContabil = this.contaContabilObject;
	                Response.contaContabil = contaContabil;
	                this.responseGrupoMaterial = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.onDoneExists = (function (Response) {
	            if (!Response.error) {
	                if (Response.length > 0) {
	                    this.codeExists = true;
	                }
	                else {
	                    this.codeExists = false;
	                }
	            }
	            else {
	                console.log("Erro: " + Response.message);
	            }
	            this.loading = false;
	        }.bind(this));
	        this.form = builder.group({
	            ativo: this.ativo,
	            grupo: this.grupo,
	            codigo: this.codigo,
	            descricao: this.descricao,
	            contaContabil: this.contaContabil
	        });
	    }
	    GrupoMaterialFormComponent.prototype.ngOnInit = function () {
	        this.contaContabilQuery = this._utilService.cloneObject(data_service_2.contasContabeisQuery);
	        this.contaContabilTipo = this._contaContabilService.getTipoEstoque();
	        var parentRouter = this._router.url;
	        var parentLocation = parentRouter.indexOf(this.materialSubgrupRouter);
	        if (parentLocation !== -1) {
	            this.isMaterialSubgrupo = true;
	            this.contaContabilQuery.where.tipoId = this.contaContabilTipo;
	        }
	        this.isNewAutoComplete();
	    };
	    GrupoMaterialFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    GrupoMaterialFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    GrupoMaterialFormComponent.prototype.onSubmit = function (evt) {
	        this.submitAttempt = true;
	        if (this.grupoObject) {
	            if (this.grupoObject.id && !this.contaContabilObject.id) {
	                return false;
	            }
	        }
	        if (evt.valid && !this.codeExists) {
	            this.btnSalveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.grupoObject) {
	                if (this.grupoObject.id) {
	                    object.grupoId = this.grupoObject.id;
	                    object.codigoGrupo = object.codigo;
	                    object.codigo = null;
	                    if (this.contaContabilObject.id) {
	                        object.contaContabilId = this.contaContabilObject.id;
	                    }
	                    else {
	                        object.contaContabilId = null;
	                    }
	                }
	            }
	            if (object.id) {
	                this.onEditGrupoMaterial(object);
	            }
	            else {
	                this.onSaveGrupoMaterial(object);
	            }
	        }
	    };
	    GrupoMaterialFormComponent.prototype.blurCode = function () {
	        var code = this.formObject.codigo;
	        if (this.formObject.codigo != this.oldCodeEdit) {
	            if (this.isMaterialSubgrupo) {
	                this.checkIfExistsCodeSubgrupo(code, this.grupoObject.id);
	            }
	            else {
	                this.checkIfExistsCodeGrupo(code);
	            }
	        }
	    };
	    GrupoMaterialFormComponent.prototype.changeGrupo = function () {
	        if (this.grupoObject.id) {
	            if (this.grupoObject.id !== this.oldGrupoEdit) {
	                this.onGetFather(this.grupoObject.id);
	            }
	            else {
	                this.formObject.codigo = this.oldCodeEdit;
	            }
	        }
	    };
	    //conta contabil
	    GrupoMaterialFormComponent.prototype.onGetContaContabilObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._grupoMaterialService.setSessionStorage(thisFormObject);
	            var objectModel = {
	                descricao: object.text,
	                tipoId: this.contaContabilTipo,
	                descricaoAnalitica: true,
	                novo: true,
	                form: data_service_1.gruposMateriaisStorage
	            };
	            this._autocompleteService.setSessionStorage(objectModel, data_service_2.contasContabeisStorage);
	            this._contaContabilNavigationService.goToNew();
	        }
	        else {
	            this.contaContabilObject = object;
	            if (object.id) {
	                this._utilService.setSelectOnFormControl(this.form, 'contaContabil', object);
	            }
	            else {
	                this._utilService.setSelectOnFormControl(this.form, 'contaContabil', { id: -1 });
	            }
	        }
	    };
	    //grupos - relacao
	    GrupoMaterialFormComponent.prototype.onGetGrupos = function (grupoId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.gruposList = Response;
	                var x, lenX;
	                for (x = 0, lenX = this.gruposList.length; x < lenX; x++) {
	                    if (this.gruposList[x].id === grupoId) {
	                        this.grupoObject = this.gruposList[x];
	                        break;
	                    }
	                }
	            }
	        }.bind(this));
	        this._grupoMaterialApiService.onGetGrupos(onDone);
	    };
	    GrupoMaterialFormComponent.prototype.onSaveGrupoMaterial = function (objeto) {
	        this._grupoMaterialApiService.onPost(objeto, this.onDone);
	    };
	    GrupoMaterialFormComponent.prototype.onEditGrupoMaterial = function (objeto) {
	        this._grupoMaterialApiService.onPut(objeto, this.onDone);
	    };
	    GrupoMaterialFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.contaContabil = this.contaContabilObject;
	        object.grupo = this.grupoObject;
	        object.grupoId = this.grupoObject.id;
	        object.codigoGrupo = this.formObject.codigo;
	        return object;
	    };
	    GrupoMaterialFormComponent.prototype.onGetFather = function (fatherId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var nextCode;
	                if (this.isMaterialSubgrupo) {
	                    nextCode = Response.codigoGrupo.toString();
	                }
	                else {
	                    nextCode = Response.codigo.toString();
	                }
	                var newCode = this._grupoMaterialService.getLastCodeNumber(nextCode);
	                this.formObject.codigo = newCode;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._grupoMaterialApiService.onGetFather(fatherId, onDone);
	    };
	    GrupoMaterialFormComponent.prototype.checkIfExistsCodeSubgrupo = function (newCode, fatherId) {
	        //newCode = newCode.replace(/0/g, '');
	        this._grupoMaterialApiService.onGetByCodeSubgrupo(newCode, fatherId, this.onDoneExists);
	    };
	    GrupoMaterialFormComponent.prototype.checkIfExistsCodeGrupo = function (newCode) {
	        //newCode = newCode.replace(/0/g, '');
	        this._grupoMaterialApiService.onGetByCodeGrupo(newCode, this.onDoneExists);
	    };
	    GrupoMaterialFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum grupo de material encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._grupoMaterialApiService.onGetById(id, onDone);
	    };
	    GrupoMaterialFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._grupoMaterialService.getSessionStorage();
	        this._grupoMaterialService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    GrupoMaterialFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_3.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_3.newRoute;
	        }
	    };
	    GrupoMaterialFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    GrupoMaterialFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	        if (this.isMaterialSubgrupo) {
	            var id = +this._route.snapshot.params['grupoId'];
	            this.contaContabilObject = new conta_contabil_model_1.ContaContabil();
	            this.onGetFather(id);
	            this.onGetGrupos(id);
	        }
	        else {
	            this.onGetFather(0);
	        }
	    };
	    GrupoMaterialFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    GrupoMaterialFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    GrupoMaterialFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.gruposMateriaisStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.descricao = newAutoComplete.descricao;
	            this.grupoObject = newAutoComplete.grupo;
	            if (this.grupoObject) {
	                this.onGetFather(this.grupoObject.id);
	            }
	            else {
	                this.onGetFather(0);
	            }
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    GrupoMaterialFormComponent.prototype.setModelToForm = function () {
	        if (this.isMaterialSubgrupo) {
	            this.formObject.codigo = this.formObject.codigoGrupo;
	            // this.onGetFather(this.formObject.grupoId);
	            this.onGetGrupos(this.formObject.grupoId);
	        }
	        this.formObject.codigo = this._grupoMaterialService.getLastCodeNumber(this.formObject.codigo.toString());
	        this.oldCodeEdit = this.formObject.codigo;
	        this.oldGrupoEdit = this.formObject.grupoId;
	        if (this.formObject.contaContabil) {
	            this.contaContabilObject = this.formObject.contaContabil;
	            delete this.formObject['contaContabil'];
	            var text = this._autocompleteService.getTextSelect2(this.contaContabilObject, 'descricao');
	            if (this.contaContabilObject.codigo) {
	                text = this.contaContabilObject.codigo.concat(" - " + text);
	            }
	            var selectObject = { text: text, id: this.contaContabilObject.id };
	            if (this.contaContabilObject.id) {
	                setTimeout(function () {
	                    this._autocompleteService.createOptionOnSelect2(this.contaContabilSelectId, selectObject);
	                    this._autocompleteService.setValueOnSelect2(selectObject.id, this.contaContabilSelectId);
	                }.bind(this));
	                this._utilService.setSelectOnFormControl(this.form, 'contaContabil', this.contaContabilObject);
	            }
	        }
	    };
	    GrupoMaterialFormComponent.prototype.goToList = function () {
	        this._grupoMaterialNavigationService.goToList();
	    };
	    GrupoMaterialFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._grupoMaterialService.returnToOtherForm(this.otherForm, this.responseGrupoMaterial);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    GrupoMaterialFormComponent = __decorate([
	        core_1.Component({
	            selector: 'grupo-material-formulario',
	            template: __webpack_require__(506)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof grupo_material_service_1.GrupoMaterialService !== 'undefined' && grupo_material_service_1.GrupoMaterialService) === 'function' && _a) || Object, (typeof (_b = typeof grupo_material_api_service_1.GrupoMaterialApiService !== 'undefined' && grupo_material_api_service_1.GrupoMaterialApiService) === 'function' && _b) || Object, (typeof (_c = typeof grupo_material_navigation_service_1.GrupoMaterialNavigationService !== 'undefined' && grupo_material_navigation_service_1.GrupoMaterialNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof conta_contabil_api_service_1.ContaContabilApiService !== 'undefined' && conta_contabil_api_service_1.ContaContabilApiService) === 'function' && _d) || Object, (typeof (_e = typeof conta_contabil_navigation_service_1.ContaContabilNavigationService !== 'undefined' && conta_contabil_navigation_service_1.ContaContabilNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof conta_contabil_service_1.ContaContabilService !== 'undefined' && conta_contabil_service_1.ContaContabilService) === 'function' && _f) || Object, (typeof (_g = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _g) || Object, (typeof (_h = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _h) || Object, (typeof (_j = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _j) || Object, (typeof (_k = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _k) || Object, (typeof (_l = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _l) || Object])
	    ], GrupoMaterialFormComponent);
	    return GrupoMaterialFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.GrupoMaterialFormComponent = GrupoMaterialFormComponent;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var data_service_1 = __webpack_require__(160);
	var GrupoMaterialCodigoValidator = (function () {
	    function GrupoMaterialCodigoValidator() {
	    }
	    GrupoMaterialCodigoValidator.grupoMaterialCodigoFormat = function (item) {
	        var code = item.value, codeNumber;
	        if (code) {
	            code = code.toString();
	            code = code.replace(/\D/g, '');
	            codeNumber = parseInt(code);
	            if ((code.length !== data_service_1.grupoMaterialCodigoMask) || (codeNumber <= 0)) {
	                return { "incorrectCodigoFormat": true };
	            }
	            return null;
	        }
	    };
	    return GrupoMaterialCodigoValidator;
	}());
	exports.GrupoMaterialCodigoValidator = GrupoMaterialCodigoValidator;


/***/ },
/* 506 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{grupoMaterialModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{grupoMaterialModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{grupoMaterialModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" *ngIf=\"isMaterialSubgrupo\">\n            <label for=\"materialGrupo_relacao\">Relação (grupo pai) <abbr>*</abbr></label>\n            <div *ngIf=\"!formObject.id\">\n                <input type=\"text\" id=\"materialGrupo_relacao\" [(ngModel)]=\"grupoObject.descricao\" formControlName=\"grupo\" disabled>\n            </div>\n            <div *ngIf=\"formObject.id\">\n                <select id=\"materialGrupo_relacao\" [(ngModel)]=\"grupoObject\" formControlName=\"grupo\" (ngModelChange)=\"changeGrupo()\">\n                    <option *ngFor=\"let item of gruposList\" [ngValue]=\"item\">{{item.codigo |  codigoMask: codigoMask}} - {{item.descricao}}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!codigo.valid && submitAttempt) || (codigo.errors && codigo.errors.incorrectCodigoFormat) || codeExists}\">\n            <label for=\"materialGrupo_codigo\">Código <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!codigo.valid && submitAttempt && !codeExists && (codigo.errors && !codigo.errors.incorrectCodigoFormat)\">Este campo é obrigatório.</span>\n                <span class=\"error-alert\" *ngIf=\"codeExists\">Este código já existe.</span>\n                <!--<span class=\"error-alert\" *ngIf=\"codigo.errors && codigo.errors.incorrectCodigoFormat\">Formato incorreto.</span>-->\n                <input type=\"text\" id=\"materialGrupo_codigo\" [(ngModel)]=\"formObject.codigo\" formControlName=\"codigo\" (blur)=\"blurCode()\" materialGrupoCodigoMask maxlength=\"3\">\n            </div>\n        </div>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"grupoMaterial_contacontabil\" *ngIf=\"isMaterialSubgrupo\"\n                                (setObejct)=\"onGetContaContabilObject($event)\"\n                                (clearObject)=\"onGetContaContabilObject($event)\"\n                                [submitted]=\"submitAttempt\"\n                                [isRequired]=\"grupoObject.id\"\n                                [selectId]=\"contaContabilSelectId\"\n                                [model]=\"contaContabilObject\"\n                                [_service]=\"_contaContabilApiService\"\n                                [templateResult]=\"contaContabilTemplateResult\"\n                                [query]=\"contaContabilQuery\"\n                                [clear]=\"true\"\n                                [label]=\"'Conta contábil de estoque'\"></autocomplete-component>\n\n        <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !descricao.valid && submitAttempt}\">\n            <label for=\"materialGrupo_descricao\">Descrição <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!descricao.valid && submitAttempt\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"materialGrupo_descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\" maxlength=\"255\">\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSalveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n\n";

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var MateriaisComponent = (function () {
	    function MateriaisComponent() {
	    }
	    MateriaisComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(508)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MateriaisComponent);
	    return MateriaisComponent;
	}());
	exports.MateriaisComponent = MateriaisComponent;


/***/ },
/* 508 */
55,
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var router_1 = __webpack_require__(62);
	var core_1 = __webpack_require__(3);
	var material_list_component_1 = __webpack_require__(510);
	var material_detail_component_1 = __webpack_require__(512);
	var material_form_component_1 = __webpack_require__(515);
	var material_especificacao_component_1 = __webpack_require__(521);
	var material_especificacao_list_component_1 = __webpack_require__(523);
	var material_especificacao_register_component_1 = __webpack_require__(527);
	var material_codigo_barra_list_component_1 = __webpack_require__(530);
	var material_codigo_barra_register_component_1 = __webpack_require__(533);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(161);
	var material_component_1 = __webpack_require__(535);
	var MateriaisRoutingModule = (function () {
	    function MateriaisRoutingModule() {
	    }
	    MateriaisRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MateriaisRoutingModule);
	    return MateriaisRoutingModule;
	}());
	exports.MateriaisRoutingModule = MateriaisRoutingModule;
	exports.materiaisRoutes = [
	    {
	        path: data_service_2.materialRouter,
	        component: material_component_1.MaterialComponent,
	        children: [
	            {
	                path: '',
	                component: material_list_component_1.MaterialListComponent
	            },
	            {
	                path: data_service_1.detailRoute + '/:id',
	                component: material_detail_component_1.MaterialDetailComponent
	            },
	            {
	                path: data_service_1.newRoute,
	                component: material_form_component_1.MaterialFormComponent
	            },
	            {
	                path: data_service_1.editRoute + '/:id',
	                component: material_form_component_1.MaterialFormComponent
	            }
	        ]
	    }, {
	        path: data_service_2.materialEspecificacaoRouter,
	        component: material_especificacao_component_1.MaterialEspecificacaoComponent,
	        children: [
	            {
	                path: '',
	                component: material_especificacao_list_component_1.MaterialEspecificacaoListComponent
	            },
	            {
	                path: data_service_1.newRoute,
	                component: material_especificacao_register_component_1.MaterialEspecificacaoRegisterComponent
	            },
	            {
	                path: data_service_1.editRoute + '/:id',
	                component: material_especificacao_register_component_1.MaterialEspecificacaoRegisterComponent
	            }
	        ]
	    }, {
	        path: data_service_2.materialCodigoBarraRouter,
	        component: material_especificacao_component_1.MaterialEspecificacaoComponent,
	        children: [
	            {
	                path: '',
	                component: material_codigo_barra_list_component_1.MaterialCodigoBarraListComponent
	            },
	            {
	                path: data_service_1.newRoute,
	                component: material_codigo_barra_register_component_1.MaterialCodigoBarraRegisterComponent
	            },
	            {
	                path: data_service_1.editRoute + '/:id',
	                component: material_codigo_barra_register_component_1.MaterialCodigoBarraRegisterComponent
	            }
	        ]
	    }
	];


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(161);
	var material_service_1 = __webpack_require__(475);
	var util_service_1 = __webpack_require__(88);
	var MaterialListComponent = (function () {
	    function MaterialListComponent(_service, _utilService) {
	        this._service = _service;
	        this._utilService = _utilService;
	        this.materialTitle = data_service_1.materialTitle;
	        this.list = [];
	        this.showDisabled = false;
	        this.showLoad = true;
	        this.materialCodigoMask = data_service_1.materialCodigoMask;
	    }
	    MaterialListComponent.prototype.ngOnInit = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var items = Response;
	                items.forEach(function (item) {
	                    if (item.grupoMaterial) {
	                        item.subgrupo = this._utilService.cloneObject(item.grupoMaterial);
	                        item.grupo = item.subgrupo.grupo;
	                    }
	                    item.classificacao = this._service.getClassificacao(item);
	                }.bind(this));
	                this.list = items;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	            this.showLoad = false;
	        }.bind(this));
	        this._service.onGetAll(onDone);
	    };
	    MaterialListComponent.prototype.onclickGoToAdd = function () {
	        this._service.clearStorage();
	        this._service.goToAdd();
	    };
	    MaterialListComponent.prototype.onclickDelete = function (item) {
	        swal({
	            title: "Você deseja realmente excluir este item?",
	            text: "O item será desativado.",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Excluir",
	            cancelButtonText: "Cancelar",
	            closeOnConfirm: false
	        }, function () {
	            this.onDelete(item);
	        }.bind(this));
	    };
	    MaterialListComponent.prototype.onclickGoToEdit = function (item) {
	        this._service.clearStorage();
	        this._service.setStorage(item);
	        this._service.goToEdit(item.id);
	    };
	    MaterialListComponent.prototype.onclickGoToDetail = function (item) {
	        this._service.setStorage(item);
	        this._service.goToDetail(item.id);
	    };
	    MaterialListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                swal("Excluído!", this.deleteSuccess, "success");
	            }
	            else {
	                swal("Erro!", this.deleteError, "error");
	            }
	        }.bind(this));
	        this._service.onDelete(item.id, onDone);
	    };
	    MaterialListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(511)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object])
	    ], MaterialListComponent);
	    return MaterialListComponent;
	    var _a, _b;
	}());
	exports.MaterialListComponent = MaterialListComponent;


/***/ },
/* 511 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <h1>{{materialTitle.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"onclickGoToAdd()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"showLoad\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !showLoad\">Nenhum {{materialTitle.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Classificação</th>\n            <th>Descrição</th>\n            <th>Tipo</th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['codigo', 'descricao', 'tipo.tipo', 'grupo.grupo'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\" (click)=\"onclickGoToDetail(item)\">\n            <td class=\"has-link\"><a >{{item.classificacao}}</a></td>\n            <td class=\"has-link\"><a >{{item.descricao}}</a></td>\n            <td class=\"has-link\"><a ><span *ngIf=\"item.tipo\">{{item.tipo.tipo}}</span></a></td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 27/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(161);
	var material_model_1 = __webpack_require__(513);
	var data_service_2 = __webpack_require__(159);
	var material_service_1 = __webpack_require__(475);
	var util_service_1 = __webpack_require__(88);
	var MaterialDetailComponent = (function () {
	    function MaterialDetailComponent(_materialService, _utilService, _route) {
	        this._materialService = _materialService;
	        this._utilService = _utilService;
	        this._route = _route;
	        this.materialTitle = data_service_1.materialTitle;
	        this.detail = new material_model_1.Material();
	        this.showLoad = false;
	        this.classificacao = '';
	        this.tabSelected = 'detalhes';
	        this.materialMask = data_service_1.materialCodigoMask;
	        this.materialGrupoMask = data_service_1.materialGrupoCodigoMask;
	        this.contaContabilMask = data_service_2.contaContabilCodigoMask;
	    }
	    MaterialDetailComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (Response) {
	                    this.detail = Response;
	                    this.detail.subgrupo = this.detail.grupoMaterial;
	                    this.detail.grupo = this.detail.subgrupo.grupo;
	                    this.classificacao = this._materialService.getClassificacao(this.detail);
	                }
	                else {
	                    this._utilService.swalMessageWarningCustom(Response.error);
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	            this.showLoad = false;
	        }.bind(this));
	        this._route.params.forEach(function (params) {
	            var id = +params['id'];
	            _this._materialService.onGetById(id, onDone);
	        });
	    };
	    MaterialDetailComponent.prototype.setTab = function (tab) {
	        this.tabSelected = tab;
	    };
	    MaterialDetailComponent.prototype.isTab = function (tab) {
	        var isTab = (tab === this.tabSelected) ? true : false;
	        return isTab;
	    };
	    MaterialDetailComponent.prototype.onclickGoToList = function () {
	        this._materialService.goToList();
	    };
	    MaterialDetailComponent.prototype.onclickGoToEdit = function () {
	        this._materialService.clearStorage();
	        this._materialService.goToEdit(this.detail.id);
	    };
	    MaterialDetailComponent.prototype.onclickDelete = function () {
	        swal({
	            title: "Você deseja realmente excluir este item?",
	            text: "O item será desativado.",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Excluir",
	            cancelButtonText: "Cancelar",
	            closeOnConfirm: false
	        }, function () {
	            this.onDelete();
	        }.bind(this));
	    };
	    MaterialDetailComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this._utilService.swalMessageDeleteSuccess();
	                this.onclickGoToList();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._materialService.onDelete(this.detail.id, onDone);
	    };
	    MaterialDetailComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(514)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object])
	    ], MaterialDetailComponent);
	    return MaterialDetailComponent;
	    var _a, _b, _c;
	}());
	exports.MaterialDetailComponent = MaterialDetailComponent;


/***/ },
/* 513 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 12/09/2016.
	 */
	var Material = (function () {
	    function Material() {
	    }
	    return Material;
	}());
	exports.Material = Material;


/***/ },
/* 514 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a (click)=\"onclickGoToList()\" class=\"cursor-pointer\">{{materialTitle.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{detail.descricao}}</a></li>\n        </ul>\n        <h1>{{detail.descricao}}</h1>\n        <p><strong>Classificação: </strong>{{classificacao}}</p>\n        <p><strong>Tipo: </strong><span *ngIf=\"detail.tipo\">{{detail.tipo.tipo}}</span></p>\n    </div>\n    <div class=\"geo-columns--6c geo-columns--right\">\n        <div class=\"geo-columns--12c\">\n            <a (click)=\"onclickGoToEdit()\" class=\"geo-button--action geo-button__icon--add\">Editar</a>\n        </div>\n        <div class=\"geo-columns--12c\">\n            <a (click)=\"onclickDelete()\" class=\"geo-button geo-button--secundary\">Excluir</a>\n        </div>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <nav class=\"geo-tabs\">\n        <ul class=\"items\">\n            <li class=\"item\">\n                <a (click)=\"setTab('detalhes')\" [ngClass]=\"{'active': isTab('detalhes')}\" class=\"item-link\">Detalhes</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('codigosbarra')\" [ngClass]=\"{'active': isTab('codigosbarra')}\" class=\"item-link\">Códigos de barra</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('especificacoes')\" [ngClass]=\"{'active': isTab('especificacoes')}\" class=\"item-link\">Especificações</a>\n            </li>\n        </ul>\n    </nav>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('detalhes')\">\n        <p><strong>Código: </strong>{{detail.id | codigoMask: materialMask}}<i *ngIf=\"!detail.id\">não cadastrado</i></p>\n        <p><strong>Grupo: </strong><span *ngIf=\"detail.grupo\"> {{detail.grupo.codigo | codigoMask: materialGrupoMask}} - {{detail.grupo.descricao}}</span></p>\n        <p><strong>Subgrupo: </strong><span *ngIf=\"detail.subgrupo\">{{detail.subgrupo.codigo_grupo | codigoMask: materialGrupoMask}} - {{detail.subgrupo.descricao}}</span></p>\n        <p><strong>Descrição completa: </strong>{{detail.descricaoCompleta}}<i *ngIf=\"!detail.descricaoCompleta\">não cadastrado</i></p>\n        <p>\n            <strong>Conta contábil de consumo: </strong>\n            <span *ngIf=\"detail.contaContabil\">\n            {{detail.contaContabil.codigo | codigoMask: contaContabilMask}} - {{detail.contaContabil.descricao}}\n            </span>\n            <i *ngIf=\"!detail.contaContabil\">não cadastrado</i>\n        </p>\n        <p><strong>Medida: </strong> <span *ngIf=\"detail.medida\">{{detail.medida.medida}}</span> <i *ngIf=\"!detail.medida\">não cadastrado</i></p>\n        <!--<p><strong>Data do cadastro: </strong> <span *ngIf=\"detail.data_cadastro\">{{detail.data_cadastro | date:'dd/MM/yyyy'}}</span> <i *ngIf=\"!detail.data_cadastro\">não cadastrado</i></p>-->\n        <p><strong>Controla validade: </strong> <span *ngIf=\"detail.controlaValidade\">Sim</span> <span *ngIf=\"!detail.controlaValidade\">Não</span></p>\n        <p><strong>Exige marca: </strong> <span *ngIf=\"detail.exigeMarca\">Sim</span> <span *ngIf=\"!detail.exigeMarca\">Não</span></p>\n        <p><strong>Mantém estoque: </strong> <span *ngIf=\"detail.mantemEstoque\">Sim</span> <span *ngIf=\"!detail.mantemEstoque\">Não</span></p>\n        <p><strong>Inventariável: </strong> <span *ngIf=\"detail.inventariavel\">Sim</span> <span *ngIf=\"!detail.inventariavel\">Não</span></p>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('codigosbarra')\">\n        <material-codigo-barra-list [materialObject]=\"detail\"></material-codigo-barra-list>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('especificacoes')\">\n        <material-especificacao-list [materialObject]=\"detail\"></material-especificacao-list>\n    </div>\n</div>\n";

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(62);
	var isDate_1 = __webpack_require__(516);
	var data_service_1 = __webpack_require__(161);
	var material_service_1 = __webpack_require__(475);
	var autocomplete_service_1 = __webpack_require__(101);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var medida_model_1 = __webpack_require__(478);
	var conta_contabil_model_1 = __webpack_require__(493);
	var grupo_material_model_1 = __webpack_require__(517);
	var data_service_3 = __webpack_require__(160);
	var data_service_4 = __webpack_require__(159);
	var data_service_5 = __webpack_require__(157);
	var grupo_material_api_service_1 = __webpack_require__(502);
	var grupo_material_navigation_service_1 = __webpack_require__(490);
	var grupo_material_service_1 = __webpack_require__(489);
	var conta_contabil_api_service_1 = __webpack_require__(486);
	var conta_contabil_service_1 = __webpack_require__(488);
	var conta_contabil_navigation_service_1 = __webpack_require__(487);
	var medida_api_service_1 = __webpack_require__(472);
	var medida_navigation_service_1 = __webpack_require__(473);
	var medida_service_1 = __webpack_require__(474);
	var material_tipo_api_service_1 = __webpack_require__(518);
	var MaterialFormComponent = (function () {
	    function MaterialFormComponent(_materialService, _grupoMaterialApiService, _grupoMaterialNavigationService, _grupoMaterialService, _contaContabilApiService, _contaContabilService, _contaContabilNavigationService, _medidaApiService, _medidaNavigationService, _materialTipoApiService, _medidaService, _autocompleteService, _utilService, _route, builder) {
	        this._materialService = _materialService;
	        this._grupoMaterialApiService = _grupoMaterialApiService;
	        this._grupoMaterialNavigationService = _grupoMaterialNavigationService;
	        this._grupoMaterialService = _grupoMaterialService;
	        this._contaContabilApiService = _contaContabilApiService;
	        this._contaContabilService = _contaContabilService;
	        this._contaContabilNavigationService = _contaContabilNavigationService;
	        this._medidaApiService = _medidaApiService;
	        this._medidaNavigationService = _medidaNavigationService;
	        this._materialTipoApiService = _materialTipoApiService;
	        this._medidaService = _medidaService;
	        this._autocompleteService = _autocompleteService;
	        this._utilService = _utilService;
	        this._route = _route;
	        this.builder = builder;
	        this.materialTitle = data_service_1.materialTitle;
	        this.btnSalveDisabled = false;
	        this.types = [];
	        this.classificacaoCodigo = '';
	        this.materialCodigoMask = data_service_1.materialCodigoMask;
	        this.submitted = false;
	        this.medidaObject = new medida_model_1.Medida();
	        this.contaContabilObject = new conta_contabil_model_1.ContaContabil();
	        this.grupoObject = new grupo_material_model_1.GrupoMaterial();
	        this.subgrupoObject = new grupo_material_model_1.GrupoMaterial();
	        this.formObject = {};
	        this.grupoSelectId = 'material_grupo';
	        this.subgrupoSelectId = 'material_subgrupo';
	        this.contaContabilSelectId = 'material_contacontabil_consumo';
	        this.contaContabilConsumoText = '';
	        this.medidaSelectId = 'material_medida';
	        this.medidaQuery = data_service_5.medidasQuery;
	        this.hasSession = false;
	        this.materialModule = data_service_1.materialStorageName;
	        this.returnToOtherForm = false;
	        this.otherForm = "";
	        this.grupoTemplateResult = (function (state) {
	            var template = this._grupoMaterialService.templateResult(state, true);
	            return template;
	        }.bind(this));
	        this.contaContabilTemplateResult = (function (state) {
	            var template = this._contaContabilService.templateResult(state, true);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseMaterial = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.id = new forms_1.FormControl({ value: '', disabled: true });
	        this.descricao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipo = new forms_1.FormControl();
	        this.grupo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.subgrupo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.descricaoCompleta = new forms_1.FormControl('', forms_1.Validators.required);
	        this.contaContabil = new forms_1.FormControl('', forms_1.Validators.required);
	        this.contaContabilConsumo = new forms_1.FormControl({ value: '', disabled: true });
	        this.medida = new forms_1.FormControl('', forms_1.Validators.required);
	        this.dataCriacao = new forms_1.FormControl({ value: '', disabled: true }, forms_1.Validators.required);
	        this.ativo = new forms_1.FormControl();
	        this.controlaValidade = new forms_1.FormControl();
	        this.exigeMarca = new forms_1.FormControl();
	        this.mantemEstoque = new forms_1.FormControl();
	        this.inventariavel = new forms_1.FormControl();
	        this.classificacao = new forms_1.FormControl({ value: '', disabled: true });
	        this.formMaterial = builder.group({
	            ativo: this.ativo,
	            id: this.id,
	            descricao: this.descricao,
	            tipo: this.tipo,
	            grupo: this.grupo,
	            subgrupo: this.subgrupo,
	            descricaoCompleta: this.descricaoCompleta,
	            contaContabil: this.contaContabil,
	            contaContabilConsumo: this.contaContabilConsumo,
	            medida: this.medida,
	            dataCriacao: this.dataCriacao,
	            controlaValidade: this.controlaValidade,
	            exigeMarca: this.exigeMarca,
	            mantemEstoque: this.mantemEstoque,
	            inventariavel: this.inventariavel,
	            classificacao: this.classificacao
	        });
	    }
	    MaterialFormComponent.prototype.ngOnInit = function () {
	        this.getTiposMateriais();
	        this.contaContabilQuery = this._utilService.cloneObject(data_service_4.contasContabeisQuery);
	        this.grupoQuery = this._utilService.cloneObject(data_service_3.gruposQuery);
	        this.subgrupoQuery = this._utilService.cloneObject(data_service_3.gruposQuery);
	        this.contaContabilTipo = this._contaContabilService.getTipoConsumo();
	        this.contaContabilQuery.where.tipoId = this.contaContabilTipo;
	        this.grupoQuery.where.codigoGrupo = null;
	        this.isNewAutoComplete();
	        document.getElementById("material_descricao").focus();
	    };
	    MaterialFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        var date = null;
	        date = document.getElementById("material_data_cadastro");
	        if (date.value) {
	            this.setSelectOnFormControl('dataCriacao', date, 'value');
	        }
	        if (evt.valid) {
	            this.btnSalveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.grupoObject && this.subgrupoObject) {
	                object.grupoMaterialId = this.subgrupoObject.id;
	            }
	            if (this.contaContabilObject) {
	                object.contaContabilId = this.contaContabilObject.id;
	            }
	            if (this.medidaObject) {
	                object.medidaId = this.medidaObject.id;
	            }
	            if (!object.controlaValidade)
	                object.controlaValidade = false;
	            if (!object.exigeMarca)
	                object.exigeMarca = false;
	            if (!object.mantemEstoque)
	                object.mantemEstoque = false;
	            if (!object.inventariavel)
	                object.inventariavel = false;
	            object.dataCriacao = this._utilService.convertStringToDate(date.value);
	            delete object['contaContabil'];
	            delete object['medida'];
	            delete object['grupo'];
	            delete object['subgrupo'];
	            delete object['dataCriacao'];
	            delete object['dataUltimaAlteracao'];
	            delete object['usuarioCriacaoId'];
	            delete object['usuarioUltimaAlteracaoId'];
	            delete object['tipo'];
	            if (object.id) {
	                this.onEditMaterial(object);
	            }
	            else {
	                this.onSaveMaterial(object);
	            }
	        }
	    };
	    MaterialFormComponent.prototype.onCheckType = function (selectedItem) {
	        this.formObject.tipoId = selectedItem;
	        setTimeout(function () {
	            var tt = document.getElementById("type_" + selectedItem);
	            if (tt) {
	                tt.checked = true;
	            }
	        });
	    };
	    MaterialFormComponent.prototype.clickGoToList = function () {
	        this.toLeaveHere();
	    };
	    MaterialFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    //grupo
	    MaterialFormComponent.prototype.onGetGrupoObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._materialService.setSessionStorage(thisFormObject);
	            var objectModel = { descricao: object.text, novo: true, form: data_service_1.materialStorageName };
	            this._autocompleteService.setSessionStorage(objectModel, data_service_3.gruposMateriaisStorage);
	            this._grupoMaterialNavigationService.goToNew();
	        }
	        else {
	            this.grupoObject = object;
	            this.setSelectOnFormControl('grupo', object);
	            this.onSetGrupoSeleted();
	        }
	    };
	    MaterialFormComponent.prototype.onSetGrupoSeleted = function () {
	        if (this.subgrupoQuery) {
	            this.subgrupoQuery.where.grupoId = this.grupoObject.id;
	        }
	        else {
	            this.subgrupoQuery = { where: { grupoId: this.grupoObject.id } };
	        }
	    };
	    MaterialFormComponent.prototype.onGetSubgrupoObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._materialService.setSessionStorage(thisFormObject);
	            var descricao = (this.grupoObject.descricao) ? this.grupoObject.descricao : this.grupoObject.text;
	            var grupo = { id: this.grupoObject.id, descricao: descricao };
	            var objectModel = { grupo: grupo, descricao: object.text, novo: true, form: data_service_1.materialStorageName };
	            this._autocompleteService.setSessionStorage(objectModel, data_service_3.gruposMateriaisStorage);
	            this._grupoMaterialNavigationService.goToAddSubgrupo(grupo.id);
	        }
	        else {
	            this.subgrupoObject = object;
	            this.setSelectOnFormControl('subgrupo', object);
	            this.setContaContabilLabel(object.contaContabil);
	        }
	    };
	    //conta contabil
	    MaterialFormComponent.prototype.onGetContaContabilObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._materialService.setSessionStorage(thisFormObject);
	            var objectModel = {
	                descricao: object.text,
	                tipoId: this.contaContabilTipo,
	                descricaoAnalitica: true,
	                novo: true,
	                form: data_service_1.materialStorageName
	            };
	            this._autocompleteService.setSessionStorage(objectModel, data_service_4.contasContabeisStorage);
	            this._contaContabilNavigationService.goToNew();
	        }
	        else {
	            this.contaContabilObject = object;
	            this.setSelectOnFormControl('contaContabil', object);
	        }
	    };
	    //medida
	    MaterialFormComponent.prototype.onGetMedidaObject = function (object) {
	        if (object.novo) {
	            this._materialService.setSessionStorage(this.formObject);
	            var objectModel = { medida: object.text, novo: true, form: data_service_1.materialStorageName };
	            this._autocompleteService.setSessionStorage(objectModel, data_service_5.medidasStorage);
	            this._medidaNavigationService.goToNew();
	        }
	        else {
	            this.medidaObject = object;
	            this.setSelectOnFormControl('medida', object);
	        }
	    };
	    MaterialFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.contaContabil = this.contaContabilObject;
	        object.grupoMaterial = this.grupoObject;
	        object.subgrupo = this.subgrupoObject;
	        object.medida = this.medidaObject;
	        return object;
	    };
	    MaterialFormComponent.prototype.setContaContabilLabel = function (object) {
	        if (object) {
	            this.contaContabilConsumoText = object.codigo + " - " + object.descricao;
	        }
	    };
	    MaterialFormComponent.prototype.onSaveMaterial = function (objeto) {
	        this._materialService.onPost(objeto, this.onDone);
	    };
	    MaterialFormComponent.prototype.onEditMaterial = function (objeto) {
	        this._materialService.onPut(objeto, this.onDone);
	    };
	    MaterialFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.materialStorageName);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.descricao = newAutoComplete.descricao;
	            this.setActionTitle(this.formObject.id);
	            this.toFormatFormCommon();
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    MaterialFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._materialService.getSessionStorage();
	        if (session) {
	            this.hasSession = true;
	            this.formObject = session;
	            id = session.id;
	            this.toFormatFormCommon();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.getObject(id);
	            }
	            else {
	                this.toFormatFormAdd();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    MaterialFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    MaterialFormComponent.prototype.setSelectOnFormControl = function (item, object, arg) {
	        var tt = this.formMaterial.controls[item];
	        if (arg) {
	            tt.patchValue(object[arg]);
	        }
	        else {
	            tt.patchValue(object.id);
	        }
	    };
	    //se edicao
	    MaterialFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.toFormatFormEdit();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum material encontrado com este id.');
	            }
	        }.bind(this));
	        this._materialService.onGetById(id, onDone);
	    };
	    MaterialFormComponent.prototype.toFormatFormEdit = function () {
	        this.subgrupoObject = this._utilService.cloneObject(this.formObject.grupoMaterial);
	        this.grupoObject = this._utilService.cloneObject(this.subgrupoObject.grupo);
	        this.formObject.grupoMaterial = this.grupoObject;
	        this.formObject.subgrupo = this.subgrupoObject;
	        var object = this._utilService.cloneObject(this.formObject);
	        object.grupo = this.grupoObject;
	        object.subgrupo = this.subgrupoObject;
	        this.classificacaoCodigo = this._materialService.getClassificacao(object);
	        this.onCheckType(this.formObject.tipoId);
	        this.toFormatFormCommon();
	    };
	    MaterialFormComponent.prototype.toFormatFormAdd = function () {
	        this.toFormatFormCommon();
	    };
	    MaterialFormComponent.prototype.toFormatFormCommon = function () {
	        if (this.hasSession) {
	            var object;
	            object = this._grupoMaterialService.getSessionStorage();
	            if (object) {
	                if (object.grupoId) {
	                    this.subgrupoObject = object;
	                }
	                else {
	                    this.grupoObject = object;
	                }
	            }
	            object = this._contaContabilService.getSessionStorage();
	            if (object) {
	                this.contaContabilObject = object;
	            }
	            object = this._medidaService.getSessionStorage();
	            if (object) {
	                this.medidaObject = object;
	            }
	            this._autocompleteService.clearSessionStorage(data_service_4.contasContabeisStorage);
	            this._autocompleteService.clearSessionStorage(data_service_3.gruposMateriaisStorage);
	            this._autocompleteService.clearSessionStorage(data_service_5.medidasStorage);
	            this._contaContabilService.clearSessionStorage();
	            this._grupoMaterialService.clearSessionStorage();
	            this._medidaService.clearSessionStorage();
	        }
	        if (this.formObject.grupoMaterial) {
	            this.grupoObject = this.formObject.grupoMaterial;
	            delete this.formObject['grupoMaterial'];
	            if (this.grupoObject && this.grupoObject.descricao) {
	                this.grupoObject = { text: this.grupoObject.codigo + " - " + this.grupoObject.descricao, id: this.grupoObject.id };
	            }
	            setTimeout(function () {
	                this._autocompleteService.createOptionOnSelect2(this.grupoSelectId, this.grupoObject);
	                this._autocompleteService.setValueOnSelect2(this.grupoObject.id, this.grupoSelectId);
	            }.bind(this));
	            this.setSelectOnFormControl('grupo', this.grupoObject);
	            this.onSetGrupoSeleted();
	        }
	        if (this.formObject.subgrupo) {
	            this.subgrupoObject = this.formObject.subgrupo;
	            delete this.formObject['subgrupo'];
	            this.setContaContabilLabel(this.subgrupoObject.contaContabil);
	            if (this.subgrupoObject && this.subgrupoObject.descricao) {
	                this.subgrupoObject = { text: this.subgrupoObject.codigoGrupo + ' - ' + this.subgrupoObject.descricao, id: this.subgrupoObject.id };
	            }
	            setTimeout(function () {
	                this._autocompleteService.createOptionOnSelect2(this.subgrupoSelectId, this.subgrupoObject);
	                this._autocompleteService.setValueOnSelect2(this.subgrupoObject.id, this.subgrupoSelectId);
	            }.bind(this));
	            this.setSelectOnFormControl('subgrupo', this.subgrupoObject);
	        }
	        if (this.formObject.contaContabil) {
	            this.contaContabilObject = this.formObject.contaContabil;
	            delete this.formObject['contaContabil'];
	            if (this.contaContabilObject && this.contaContabilObject.descricao) {
	                this.contaContabilObject = { text: this.contaContabilObject.codigo + ' - ' + this.contaContabilObject.descricao, id: this.contaContabilObject.id };
	            }
	            setTimeout(function () {
	                this._autocompleteService.createOptionOnSelect2(this.contaContabilSelectId, this.contaContabilObject);
	                this._autocompleteService.setValueOnSelect2(this.contaContabilObject.id, this.contaContabilSelectId);
	            }.bind(this));
	            this.setSelectOnFormControl('contaContabil', this.contaContabilObject);
	        }
	        if (this.formObject.medida) {
	            this.medidaObject = this.formObject.medida;
	            delete this.formObject['medida'];
	            if (this.medidaObject && this.medidaObject.medida) {
	                this.medidaObject = { text: this.medidaObject.medida, id: this.medidaObject.id };
	            }
	            setTimeout(function () {
	                this._autocompleteService.createOptionOnSelect2(this.medidaSelectId, this.medidaObject);
	                this._autocompleteService.setValueOnSelect2(this.medidaObject.id, this.medidaSelectId);
	            }.bind(this));
	            this.setSelectOnFormControl('medida', this.medidaObject);
	        }
	        var date = (this.formObject.dataCriacao) ? this.formObject.dataCriacao : new Date();
	        date = new Date(date);
	        if (isDate_1.isDate(date)) {
	            this.formObject.dataCriacao = this._utilService.convertDateToString(date);
	        }
	    };
	    MaterialFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._materialService.returnToOtherForm(this.otherForm, this.responseMaterial);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    MaterialFormComponent.prototype.goToList = function () {
	        this._materialService.goToList();
	    };
	    MaterialFormComponent.prototype.getTiposMateriais = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.types = Response;
	                this.onCheckType(this.types[1].id);
	            }
	        }.bind(this));
	        this._materialTipoApiService.onGetAll(onDone);
	    };
	    MaterialFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(520)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _a) || Object, (typeof (_b = typeof grupo_material_api_service_1.GrupoMaterialApiService !== 'undefined' && grupo_material_api_service_1.GrupoMaterialApiService) === 'function' && _b) || Object, (typeof (_c = typeof grupo_material_navigation_service_1.GrupoMaterialNavigationService !== 'undefined' && grupo_material_navigation_service_1.GrupoMaterialNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof grupo_material_service_1.GrupoMaterialService !== 'undefined' && grupo_material_service_1.GrupoMaterialService) === 'function' && _d) || Object, (typeof (_e = typeof conta_contabil_api_service_1.ContaContabilApiService !== 'undefined' && conta_contabil_api_service_1.ContaContabilApiService) === 'function' && _e) || Object, (typeof (_f = typeof conta_contabil_service_1.ContaContabilService !== 'undefined' && conta_contabil_service_1.ContaContabilService) === 'function' && _f) || Object, (typeof (_g = typeof conta_contabil_navigation_service_1.ContaContabilNavigationService !== 'undefined' && conta_contabil_navigation_service_1.ContaContabilNavigationService) === 'function' && _g) || Object, (typeof (_h = typeof medida_api_service_1.MedidaApiService !== 'undefined' && medida_api_service_1.MedidaApiService) === 'function' && _h) || Object, (typeof (_j = typeof medida_navigation_service_1.MedidaNavigationService !== 'undefined' && medida_navigation_service_1.MedidaNavigationService) === 'function' && _j) || Object, (typeof (_k = typeof material_tipo_api_service_1.MaterialTipoApiService !== 'undefined' && material_tipo_api_service_1.MaterialTipoApiService) === 'function' && _k) || Object, (typeof (_l = typeof medida_service_1.MedidaService !== 'undefined' && medida_service_1.MedidaService) === 'function' && _l) || Object, (typeof (_m = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _m) || Object, (typeof (_o = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _o) || Object, (typeof (_p = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _p) || Object, (typeof (_q = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _q) || Object])
	    ], MaterialFormComponent);
	    return MaterialFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
	}());
	exports.MaterialFormComponent = MaterialFormComponent;


/***/ },
/* 516 */,
/* 517 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 12/09/2016.
	 */
	var GrupoMaterial = (function () {
	    function GrupoMaterial() {
	    }
	    return GrupoMaterial;
	}());
	exports.GrupoMaterial = GrupoMaterial;


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(519);
	var MaterialTipoApiService = (function () {
	    function MaterialTipoApiService(_restService) {
	        this._restService = _restService;
	    }
	    MaterialTipoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    MaterialTipoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    MaterialTipoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    MaterialTipoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": ["tipo"], "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    MaterialTipoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    MaterialTipoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    MaterialTipoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], MaterialTipoApiService);
	    return MaterialTipoApiService;
	    var _a;
	}());
	exports.MaterialTipoApiService = MaterialTipoApiService;


/***/ },
/* 519 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-materiais';


/***/ },
/* 520 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{materialTitle.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{materialTitle.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{materialTitle.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"formMaterial\" (ngSubmit)=\"onSubmit(formMaterial)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" *ngIf=\"formObject.id\">\n            <label for=\"material_classificacao\">Classificação</label>\n            <div>\n                <input type=\"text\" id=\"material_classificacao\" [(ngModel)]=\"classificacaoCodigo\" formControlName=\"classificacao\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" *ngIf=\"formObject.id\">\n            <label for=\"material_codigo\">Código</label>\n            <div>\n                <input type=\"text\" id=\"material_codigo\" [(ngModel)]=\"formObject.id\" formControlName=\"id\" [codigoMask]=\"materialCodigoMask\" maxlength=\"10\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\">\n            <label for=\"material_data_cadastro\">Data do cadastro</label>\n            <div>\n                <input type=\"text\" id=\"material_data_cadastro\" [(ngModel)]=\"formObject.dataCriacao\" formControlName=\"dataCriacao\" #data_cadastro />\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Tipo de material</h2>\n        <div *ngFor=\"let item of types\" class=\"geo-toggle\">\n            <input id=\"type_{{item.id}}\" type=\"radio\" name=\"tipo\" value=\"{{item.id}}\"  (change)=\"onCheckType(item.id)\">\n            <label attr.for=\"type_{{item.id}}\">{{item.tipo}}</label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <autocomplete-component class=\"geo-input--3c\" id=\"material_contacontabil_consumo\"\n                                (setObejct)=\"onGetContaContabilObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"contaContabilSelectId\"\n                                [model]=\"contaContabilObject\"\n                                [_service]=\"_contaContabilApiService\"\n                                [templateResult]=\"contaContabilTemplateResult\"\n                                [query]=\"contaContabilQuery\"\n                                [label]=\"'Conta contábil de consumo'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"material_grupo\"\n                                (setObejct)=\"onGetGrupoObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"grupoSelectId\"\n                                [model]=\"grupoObject\"\n                                [_service]=\"_grupoMaterialApiService\"\n                                [templateResult]=\"grupoTemplateResult\"\n                                [query]=\"grupoQuery\"\n                                [label]=\"'Grupo'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" *ngIf=\"grupoObject.id\" id=\"material_subgrupo\"\n                                (setObejct)=\"onGetSubgrupoObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"subgrupoSelectId\"\n                                [model]=\"subgrupoObject\"\n                                [_service]=\"_grupoMaterialApiService\"\n                                [templateResult]=\"grupoTemplateResult\"\n                                [query]=\"subgrupoQuery\"\n                                [label]=\"'Subgrupo'\"></autocomplete-component>\n\n        <div class=\"geo-input--3c\" *ngIf=\"subgrupoObject.id\">\n            <label for=\"material_contacontabil_estoque\">Conta contábil de estoque </label>\n            <div>\n                <input type=\"text\" id=\"material_contacontabil_estoque\" [(ngModel)]=\"contaContabilConsumoText\" formControlName=\"contaContabilConsumo\">\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--9c\" [ngClass]=\"{'geo-input--error': !descricao.valid && submitted}\">\n            <label for=\"material_descricao\">Descrição <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!descricao.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"material_descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\" maxlength=\"255\">\n            </div>\n        </div>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"material_medida\"\n                                (setObejct)=\"onGetMedidaObject($event)\"\n                                [submitted]=\"submitted\"\n                                [selectId]=\"medidaSelectId\"\n                                [model]=\"medidaObject\"\n                                [_service]=\"_medidaApiService\"\n                                [fieldToShow]=\"'medida'\"\n                                [query]=\"medidaQuery\"\n                                [label]=\"'Medida'\"></autocomplete-component>\n\n        <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !descricaoCompleta.valid && submitted}\">\n            <label for=\"material_descricao_completa\">Descrição completa <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!descricaoCompleta.valid && submitted\">Este campo é obrigatório.</span>\n                <textarea id=\"material_descricao_completa\" [(ngModel)]=\"formObject.descricaoCompleta\" formControlName=\"descricaoCompleta\"></textarea>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-toggle\">\n            <input type=\"checkbox\" id=\"material_material_validade\" value=\"\" [(ngModel)]=\"formObject.controlaValidade\" formControlName=\"controlaValidade\">\n            <label for=\"material_material_validade\">Controla validade</label>\n        </div>\n\n        <div class=\"geo-toggle\">\n            <input type=\"checkbox\" id=\"material_exige_marca\" value=\"\" [(ngModel)]=\"formObject.exigeMarca\" formControlName=\"exigeMarca\">\n            <label for=\"material_exige_marca\">Exige marca</label>\n        </div>\n\n        <div class=\"geo-toggle\">\n            <input type=\"checkbox\" id=\"material_mantem_estoque\" value=\"\" [(ngModel)]=\"formObject.mantemEstoque\" formControlName=\"mantemEstoque\">\n            <label for=\"material_mantem_estoque\">Mantém estoque</label>\n        </div>\n\n        <div class=\"geo-toggle\">\n            <input type=\"checkbox\" id=\"material_inventariavel\" value=\"\" [(ngModel)]=\"formObject.inventariavel\" formControlName=\"inventariavel\">\n            <label for=\"material_inventariavel\">Invetariável</label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" id=\"btnSaveMaterial\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSalveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 27/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var MaterialEspecificacaoComponent = (function () {
	    function MaterialEspecificacaoComponent() {
	    }
	    MaterialEspecificacaoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(522)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MaterialEspecificacaoComponent);
	    return MaterialEspecificacaoComponent;
	}());
	exports.MaterialEspecificacaoComponent = MaterialEspecificacaoComponent;


/***/ },
/* 522 */
55,
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var material_model_1 = __webpack_require__(513);
	var material_especificacao_service_1 = __webpack_require__(524);
	var util_service_1 = __webpack_require__(88);
	var material_codigo_barra_model_1 = __webpack_require__(525);
	var data_service_1 = __webpack_require__(161);
	var material_service_1 = __webpack_require__(475);
	var MaterialEspecificacaoListComponent = (function () {
	    function MaterialEspecificacaoListComponent(_service, _materialService, _utilService) {
	        this._service = _service;
	        this._materialService = _materialService;
	        this._utilService = _utilService;
	        this.materialObject = new material_model_1.Material();
	        this.materialEspecificacaoTitle = data_service_1.materialEspecificacaoTitle;
	        this.list = [];
	        this.showDisabled = false;
	        this.showLoad = true;
	    }
	    MaterialEspecificacaoListComponent.prototype.ngOnInit = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	            this.showLoad = false;
	        }.bind(this));
	        this._service.onGetbyMaterial(this.materialObject.id, onDone);
	    };
	    MaterialEspecificacaoListComponent.prototype.onclickGoToAdd = function () {
	        this._materialService.clearStorage();
	        var object = new material_codigo_barra_model_1.MaterialCodigoBarra();
	        object.material = this.materialObject;
	        this._service.setStorage(object);
	        this._service.goToAdd();
	    };
	    MaterialEspecificacaoListComponent.prototype.onclickGoToEdit = function (item) {
	        this._materialService.clearStorage();
	        item.material = this.materialObject;
	        this._service.setStorage(item);
	        this._service.goToEdit(item.id);
	    };
	    MaterialEspecificacaoListComponent.prototype.onclickDelete = function (item) {
	        swal({
	            title: "Você deseja realmente excluir este item?",
	            text: "O item será desativado.",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Excluir",
	            cancelButtonText: "Cancelar",
	            closeOnConfirm: false
	        }, function () {
	            this.onDelete(item);
	        }.bind(this));
	    };
	    MaterialEspecificacaoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._service.onDelete(item.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof material_model_1.Material !== 'undefined' && material_model_1.Material) === 'function' && _a) || Object)
	    ], MaterialEspecificacaoListComponent.prototype, "materialObject", void 0);
	    MaterialEspecificacaoListComponent = __decorate([
	        core_1.Component({
	            selector: 'material-especificacao-list',
	            template: __webpack_require__(526)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof material_especificacao_service_1.MaterialEspecificacaoService !== 'undefined' && material_especificacao_service_1.MaterialEspecificacaoService) === 'function' && _b) || Object, (typeof (_c = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], MaterialEspecificacaoListComponent);
	    return MaterialEspecificacaoListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MaterialEspecificacaoListComponent = MaterialEspecificacaoListComponent;


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(161);
	var data_service_2 = __webpack_require__(156);
	var data_service_3 = __webpack_require__(178);
	var MaterialEspecificacaoService = (function () {
	    function MaterialEspecificacaoService(_restService, _authService) {
	        this._restService = _restService;
	        this._authService = _authService;
	        this.apiUrl = data_service_1.materialEspecificacaoApi;
	        this.storageName = data_service_1.materialEspecificacaoStorageName;
	    }
	    MaterialEspecificacaoService.prototype.onPost = function (object, done) {
	        this._restService.onPost(this.apiUrl, object, done);
	    };
	    MaterialEspecificacaoService.prototype.onPut = function (object, done) {
	        this._restService.onPut(this.apiUrl, object, done);
	    };
	    MaterialEspecificacaoService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(this.apiUrl, objectId, done);
	    };
	    MaterialEspecificacaoService.prototype.onGetbyMaterial = function (materialId, done) {
	        var filter = { "order": "descricao", "where": { "materialId": materialId } };
	        this._restService.onGetPost(this.apiUrl, filter, done);
	    };
	    MaterialEspecificacaoService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": "material" };
	        this._restService.onGetPostId(this.apiUrl, objectId, filter, done);
	    };
	    //storage
	    MaterialEspecificacaoService.prototype.setStorage = function (item) {
	        var object = JSON.stringify(item);
	        localStorage.setItem(this.storageName + '-selected', object);
	    };
	    MaterialEspecificacaoService.prototype.getStorage = function () {
	        var item = localStorage.getItem(this.storageName + "-selected");
	        return JSON.parse(item);
	    };
	    //session
	    MaterialEspecificacaoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(this.storageName + '-new', object);
	    };
	    MaterialEspecificacaoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(this.storageName + "-new");
	        return JSON.parse(item);
	    };
	    //router
	    MaterialEspecificacaoService.prototype.goToList = function () {
	        var router = data_service_2.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialEspecificacaoRouter;
	        this._authService.navigateTo(router);
	    };
	    MaterialEspecificacaoService.prototype.goToAdd = function () {
	        var router = data_service_2.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialEspecificacaoRouter + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    MaterialEspecificacaoService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialEspecificacaoRouter + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    //others
	    //qndo retorna para continuar o cadastro, caso tenha ido para outro formulario
	    MaterialEspecificacaoService.prototype.returnToForm = function () {
	        var session = this.getSessionStorage();
	        if (session && session.id) {
	            this.goToEdit(session.id);
	        }
	        else {
	            this.goToAdd();
	        }
	    };
	    MaterialEspecificacaoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], MaterialEspecificacaoService);
	    return MaterialEspecificacaoService;
	    var _a, _b;
	}());
	exports.MaterialEspecificacaoService = MaterialEspecificacaoService;


/***/ },
/* 525 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 12/09/2016.
	 */
	var MaterialCodigoBarra = (function () {
	    function MaterialCodigoBarra() {
	    }
	    return MaterialCodigoBarra;
	}());
	exports.MaterialCodigoBarra = MaterialCodigoBarra;


/***/ },
/* 526 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n    <div class=\"geo-columns--9c\">\n        <a (click)=\"onclickGoToAdd()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n    <div class=\"geo-columns--3c geo-columns--right geo-columns--middle\">\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n  <spinner-component [showDisplay]=\"true\" *ngIf=\"showLoad\"></spinner-component>\n\n  <p class=\"lead padding\" *ngIf=\"!list.length && !showLoad\">Nenhuma {{materialEspecificacaoTitle.single | lowercase}} cadastrada</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Especificação</th>\n            <th>Título da especificação</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.descricao}}</td>\n            <td>{{item.especificacao}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"onclickGoToEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"onclickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var material_model_1 = __webpack_require__(513);
	var material_especificacao_model_1 = __webpack_require__(528);
	var material_especificacao_service_1 = __webpack_require__(524);
	var material_service_1 = __webpack_require__(475);
	var data_service_1 = __webpack_require__(161);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var MaterialEspecificacaoRegisterComponent = (function () {
	    function MaterialEspecificacaoRegisterComponent(_service, _materialService, _utilService, _route) {
	        this._service = _service;
	        this._materialService = _materialService;
	        this._utilService = _utilService;
	        this._route = _route;
	        this.materialEspecificacaoTitle = data_service_1.materialEspecificacaoTitle;
	        this.itemObject = new material_especificacao_model_1.MaterialEspecificacao();
	        this.materialObject = new material_model_1.Material();
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.actionTitle === data_service_2.editRoute) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.onclickGoToMaterialDetail();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	    }
	    MaterialEspecificacaoRegisterComponent.prototype.ngOnInit = function () {
	        var id = +this._route.snapshot.params['id'];
	        this.itemObject = this._service.getStorage();
	        this.materialObject = this.itemObject.material;
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	            this.itemObject.id = id;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    MaterialEspecificacaoRegisterComponent.prototype.onclickSend = function (arg) {
	        if (this.actionTitle === data_service_2.editRoute) {
	            this.onEdit(arg);
	        }
	        else {
	            this.onSave(arg);
	        }
	    };
	    MaterialEspecificacaoRegisterComponent.prototype.onclickGoToMaterialDetail = function () {
	        this._materialService.goToDetail(this.materialObject.id);
	    };
	    MaterialEspecificacaoRegisterComponent.prototype.onclickCancel = function () {
	        this.onclickGoToMaterialDetail();
	    };
	    MaterialEspecificacaoRegisterComponent.prototype.onSave = function (arg) {
	        this.onDone(arg);
	    };
	    MaterialEspecificacaoRegisterComponent.prototype.onEdit = function (arg) {
	        this.onDone(arg);
	    };
	    MaterialEspecificacaoRegisterComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(529)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof material_especificacao_service_1.MaterialEspecificacaoService !== 'undefined' && material_especificacao_service_1.MaterialEspecificacaoService) === 'function' && _a) || Object, (typeof (_b = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object])
	    ], MaterialEspecificacaoRegisterComponent);
	    return MaterialEspecificacaoRegisterComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MaterialEspecificacaoRegisterComponent = MaterialEspecificacaoRegisterComponent;


/***/ },
/* 528 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 12/09/2016.
	 */
	var MaterialEspecificacao = (function () {
	    function MaterialEspecificacao() {
	    }
	    return MaterialEspecificacao;
	}());
	exports.MaterialEspecificacao = MaterialEspecificacao;


/***/ },
/* 529 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"onclickGoToList()\" class=\"cursor-pointer\">{{materialEspecificacaoTitle.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{materialEspecificacaoTitle.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{materialEspecificacaoTitle.single | lowercase}}</h1>\n</div>\n<material-especificacao-formulario [formObject]=\"itemObject\" (submitEvent)=\"onclickSend($event)\" (cancelEvent)=\"onclickCancel($event)\"></material-especificacao-formulario>\n\n";

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var material_model_1 = __webpack_require__(513);
	var material_codigo_barra_model_1 = __webpack_require__(525);
	var material_codigo_barra_service_1 = __webpack_require__(531);
	var data_service_1 = __webpack_require__(161);
	var util_service_1 = __webpack_require__(88);
	var material_service_1 = __webpack_require__(475);
	var MaterialCodigoBarraListComponent = (function () {
	    function MaterialCodigoBarraListComponent(_service, _materialService, _utilService) {
	        this._service = _service;
	        this._materialService = _materialService;
	        this._utilService = _utilService;
	        this.materialObject = new material_model_1.Material();
	        this.materialCodigoBarraTitle = data_service_1.materialCodigoBarraTitle;
	        this.list = [];
	        this.showDisabled = false;
	        this.showLoad = true;
	    }
	    MaterialCodigoBarraListComponent.prototype.ngOnInit = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            else {
	                console.log("Erro: " + Response.message);
	            }
	            this.showLoad = false;
	        }.bind(this));
	        this._service.onGetbyMaterial(this.materialObject.id, onDone);
	    };
	    MaterialCodigoBarraListComponent.prototype.onclickGoToAdd = function () {
	        this._materialService.clearStorage();
	        var object = new material_codigo_barra_model_1.MaterialCodigoBarra();
	        object.material = this.materialObject;
	        this._service.setStorage(object);
	        this._service.goToAdd();
	    };
	    MaterialCodigoBarraListComponent.prototype.onclickDelete = function (item) {
	        swal({
	            title: "Você deseja realmente excluir este item?",
	            text: "O item será desativado.",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Excluir",
	            cancelButtonText: "Cancelar",
	            closeOnConfirm: false
	        }, function () {
	            this.onDelete(item);
	        }.bind(this));
	    };
	    MaterialCodigoBarraListComponent.prototype.onclickGoToEdit = function (item) {
	        this._materialService.clearStorage();
	        item.material = this.materialObject;
	        this._service.setStorage(item);
	        this._service.goToEdit(item.id);
	    };
	    MaterialCodigoBarraListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._service.onDelete(item.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof material_model_1.Material !== 'undefined' && material_model_1.Material) === 'function' && _a) || Object)
	    ], MaterialCodigoBarraListComponent.prototype, "materialObject", void 0);
	    MaterialCodigoBarraListComponent = __decorate([
	        core_1.Component({
	            selector: 'material-codigo-barra-list',
	            template: __webpack_require__(532),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof material_codigo_barra_service_1.MaterialCodigoBarraService !== 'undefined' && material_codigo_barra_service_1.MaterialCodigoBarraService) === 'function' && _b) || Object, (typeof (_c = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], MaterialCodigoBarraListComponent);
	    return MaterialCodigoBarraListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MaterialCodigoBarraListComponent = MaterialCodigoBarraListComponent;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(161);
	var rest_service_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(156);
	var data_service_3 = __webpack_require__(178);
	var MaterialCodigoBarraService = (function () {
	    function MaterialCodigoBarraService(_restService, _authService) {
	        this._restService = _restService;
	        this._authService = _authService;
	        this.apiUrl = data_service_1.materialCodigoBarraApi;
	        this.storageName = data_service_1.materialCodigoBarraStorageName;
	    }
	    MaterialCodigoBarraService.prototype.onPost = function (object, done) {
	        this._restService.onPost(this.apiUrl, object, done);
	    };
	    MaterialCodigoBarraService.prototype.onPut = function (object, done) {
	        this._restService.onPut(this.apiUrl, object, done);
	    };
	    MaterialCodigoBarraService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(this.apiUrl, objectId, done);
	    };
	    MaterialCodigoBarraService.prototype.onGetbyMaterial = function (materialId, done) {
	        var filter = { "order": "codigoBarra", "where": { "materialId": materialId } };
	        this._restService.onGetPost(this.apiUrl, filter, done);
	    };
	    MaterialCodigoBarraService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": "material" };
	        this._restService.onGetPostId(this.apiUrl, objectId, filter, done);
	    };
	    //storage
	    MaterialCodigoBarraService.prototype.setStorage = function (item) {
	        var object = JSON.stringify(item);
	        localStorage.setItem(this.storageName + '-selected', object);
	    };
	    MaterialCodigoBarraService.prototype.getStorage = function () {
	        var item = localStorage.getItem(this.storageName + "-selected");
	        return JSON.parse(item);
	    };
	    //session
	    MaterialCodigoBarraService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(this.storageName + '-new', object);
	    };
	    MaterialCodigoBarraService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(this.storageName + "-new");
	        return JSON.parse(item);
	    };
	    //router
	    MaterialCodigoBarraService.prototype.goToList = function () {
	        // var router: string =  this.moduleRouter + '/' + this.componentRouter;
	        // this._authService.navigateTo(router);
	    };
	    MaterialCodigoBarraService.prototype.goToAdd = function () {
	        var router = data_service_2.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialCodigoBarraRouter + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    MaterialCodigoBarraService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.almoxarifadoRoute + '/' + data_service_1.materiaisRouter + '/' + data_service_1.materialCodigoBarraRouter + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    //others
	    //qndo retorna para continuar o cadastro, caso tenha ido para outro formulario
	    MaterialCodigoBarraService.prototype.returnToForm = function () {
	        var session = this.getSessionStorage();
	        if (session && session.id) {
	            this.goToEdit(session.id);
	        }
	        else {
	            this.goToAdd();
	        }
	    };
	    MaterialCodigoBarraService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], MaterialCodigoBarraService);
	    return MaterialCodigoBarraService;
	    var _a, _b;
	}());
	exports.MaterialCodigoBarraService = MaterialCodigoBarraService;


/***/ },
/* 532 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n    <div class=\"geo-columns--9c\">\n        <a (click)=\"onclickGoToAdd()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n    <div class=\"geo-columns--3c geo-columns--right geo-columns--middle\">\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"showLoad\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !showLoad\">Nenhum {{materialCodigoBarraTitle.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Código de barra</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.codigoBarra | Gtin13Mask}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"onclickGoToEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"onclickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var material_codigo_barra_model_1 = __webpack_require__(525);
	var material_model_1 = __webpack_require__(513);
	var material_codigo_barra_service_1 = __webpack_require__(531);
	var material_service_1 = __webpack_require__(475);
	var data_service_1 = __webpack_require__(161);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var MaterialCodigoBarraRegisterComponent = (function () {
	    function MaterialCodigoBarraRegisterComponent(_service, _materialService, _utilService, _route) {
	        this._service = _service;
	        this._materialService = _materialService;
	        this._utilService = _utilService;
	        this._route = _route;
	        this.materialCodigoBarraTitle = data_service_1.materialCodigoBarraTitle;
	        this.itemObject = new material_codigo_barra_model_1.MaterialCodigoBarra();
	        this.materialObject = new material_model_1.Material();
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.actionTitle === data_service_2.editRoute) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.onclickGoToMaterialDetail();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	    }
	    MaterialCodigoBarraRegisterComponent.prototype.ngOnInit = function () {
	        var id = +this._route.snapshot.params['id'];
	        this.itemObject = this._service.getStorage();
	        this.materialObject = this.itemObject.material;
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	            this.itemObject.id = id;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    MaterialCodigoBarraRegisterComponent.prototype.onclickSend = function (arg) {
	        if (this.actionTitle === data_service_2.editRoute) {
	            this.onEdit(arg);
	        }
	        else {
	            this.onSave(arg);
	        }
	    };
	    MaterialCodigoBarraRegisterComponent.prototype.onclickGoToMaterialDetail = function () {
	        this._materialService.goToDetail(this.materialObject.id);
	    };
	    MaterialCodigoBarraRegisterComponent.prototype.onclickCancel = function () {
	        this.onclickGoToMaterialDetail();
	    };
	    MaterialCodigoBarraRegisterComponent.prototype.onSave = function (arg) {
	        this.onDone(arg);
	    };
	    MaterialCodigoBarraRegisterComponent.prototype.onEdit = function (arg) {
	        this.onDone(arg);
	    };
	    MaterialCodigoBarraRegisterComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(534)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof material_codigo_barra_service_1.MaterialCodigoBarraService !== 'undefined' && material_codigo_barra_service_1.MaterialCodigoBarraService) === 'function' && _a) || Object, (typeof (_b = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object])
	    ], MaterialCodigoBarraRegisterComponent);
	    return MaterialCodigoBarraRegisterComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MaterialCodigoBarraRegisterComponent = MaterialCodigoBarraRegisterComponent;


/***/ },
/* 534 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"onclickGoToList()\" class=\"cursor-pointer\">{{materialCodigoBarraTitle.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{materialCodigoBarraTitle.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{materialCodigoBarraTitle.single | lowercase}}</h1>\n</div>\n<material-codigo-barra-formulario [formObject]=\"itemObject\" (submitEvent)=\"onclickSend($event)\" (cancelEvent)=\"onclickCancel($event)\"></material-codigo-barra-formulario>\n\n";

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 27/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var MaterialComponent = (function () {
	    function MaterialComponent() {
	    }
	    MaterialComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(536)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MaterialComponent);
	    return MaterialComponent;
	}());
	exports.MaterialComponent = MaterialComponent;


/***/ },
/* 536 */
55,
/* 537 */
/***/ function(module, exports) {

	"use strict";
	exports.despachosRoute = 'despachos';


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var DespachosComponent = (function () {
	    function DespachosComponent() {
	    }
	    DespachosComponent.prototype.ngOnInit = function () {
	    };
	    DespachosComponent = __decorate([
	        core_1.Component({
	            selector: 'app-despachos',
	            template: __webpack_require__(539)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DespachosComponent);
	    return DespachosComponent;
	}());
	exports.DespachosComponent = DespachosComponent;


/***/ },
/* 539 */
55,
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AbastecimentosComponent = (function () {
	    function AbastecimentosComponent() {
	    }
	    AbastecimentosComponent.prototype.ngOnInit = function () {
	    };
	    AbastecimentosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(541)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AbastecimentosComponent);
	    return AbastecimentosComponent;
	}());
	exports.AbastecimentosComponent = AbastecimentosComponent;


/***/ },
/* 541 */
171,
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var auth_guard_service_1 = __webpack_require__(89);
	var locais_routing_module_1 = __webpack_require__(543);
	var bombas_component_1 = __webpack_require__(552);
	var bombas_routing_module_1 = __webpack_require__(554);
	var data_service_1 = __webpack_require__(199);
	var data_service_2 = __webpack_require__(377);
	var combustiveis_component_1 = __webpack_require__(571);
	var combustiveis_routing_module_1 = __webpack_require__(573);
	var locais_component_1 = __webpack_require__(582);
	var data_service_3 = __webpack_require__(401);
	var data_service_4 = __webpack_require__(400);
	var abastecimento_configuracao_component_1 = __webpack_require__(584);
	var data_service_5 = __webpack_require__(398);
	var data_service_6 = __webpack_require__(404);
	var tanques_component_1 = __webpack_require__(589);
	var tanques_routing_module_1 = __webpack_require__(591);
	var data_service_7 = __webpack_require__(585);
	var tipo_ajustes_component_1 = __webpack_require__(609);
	var tipo_ajustes_routing_module_1 = __webpack_require__(611);
	var abastecimento_bens_component_1 = __webpack_require__(619);
	var abastecimento_bens_routing_module_1 = __webpack_require__(621);
	var abastecimento_relatorio_component_1 = __webpack_require__(622);
	var data_service_8 = __webpack_require__(178);
	var AbastecimentosRoutingModule = (function () {
	    function AbastecimentosRoutingModule() {
	    }
	    AbastecimentosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AbastecimentosRoutingModule);
	    return AbastecimentosRoutingModule;
	}());
	exports.AbastecimentosRoutingModule = AbastecimentosRoutingModule;
	exports.abastecimentosRoutes = [
	    {
	        path: '',
	        redirectTo: './' + data_service_5.abastecimentosRoute + '/' + data_service_1.abastecimentoBensRoute,
	        pathMatch: 'full'
	    }, {
	        path: 'configuracoes',
	        component: abastecimento_configuracao_component_1.AbastecimentoConfiguracaoComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	    }, {
	        path: 'relatorios',
	        component: abastecimento_relatorio_component_1.AbastecimentoRelatorioComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	    }, {
	        path: data_service_4.locaisRoute,
	        component: locais_component_1.LocaisComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: locais_routing_module_1.locaisRoutes
	    }, {
	        path: data_service_8.configuracaoRoute + '/' + data_service_3.bombasRoute,
	        component: bombas_component_1.BombasComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: bombas_routing_module_1.bombasRoutes
	    }, {
	        path: data_service_3.bombasAuditoriaRoute,
	        component: bombas_component_1.BombasComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: bombas_routing_module_1.auditoriaRoutes
	    }, {
	        path: data_service_1.abastecimentoBensRoute,
	        component: abastecimento_bens_component_1.AbastecimentoBensComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: abastecimento_bens_routing_module_1.abastecimentoBensRoutes
	    }, {
	        path: data_service_2.combustiveisRoute,
	        component: combustiveis_component_1.CombustiveisComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: combustiveis_routing_module_1.combustiveisRoutes
	    }, {
	        path: data_service_6.tanquesRoute,
	        component: tanques_component_1.TanquesComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: tanques_routing_module_1.tanquesRoutes
	    }, {
	        path: data_service_7.tipoAjustesRoute,
	        component: tipo_ajustes_component_1.TipoAjustesComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: tipo_ajustes_routing_module_1.tipoAjustesRoutes
	    }
	];


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var local_list_component_1 = __webpack_require__(544);
	var data_service_1 = __webpack_require__(178);
	var local_form_component_1 = __webpack_require__(549);
	var LocaisRoutingModule = (function () {
	    function LocaisRoutingModule() {
	    }
	    LocaisRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocaisRoutingModule);
	    return LocaisRoutingModule;
	}());
	exports.LocaisRoutingModule = LocaisRoutingModule;
	exports.locaisRoutes = [
	    {
	        path: '',
	        component: local_list_component_1.LocalListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: local_form_component_1.LocalFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: local_form_component_1.LocalFormComponent
	    }
	];


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(400);
	var local_api_service_1 = __webpack_require__(407);
	var local_navigation_service_1 = __webpack_require__(545);
	var util_service_1 = __webpack_require__(88);
	var local_service_1 = __webpack_require__(399);
	var abastecimento_service_1 = __webpack_require__(546);
	var data_service_2 = __webpack_require__(398);
	var data_service_3 = __webpack_require__(178);
	var LocalListComponent = (function () {
	    function LocalListComponent(_locaisApiService, _localService, _localNavigationService, _utilService, _abastecimentoService) {
	        this._locaisApiService = _locaisApiService;
	        this._localService = _localService;
	        this._localNavigationService = _localNavigationService;
	        this._utilService = _utilService;
	        this._abastecimentoService = _abastecimentoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.locaisModuleName = data_service_1.locaisModuleName;
	        this.module = data_service_2.abastecimentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	        this.localCombustiveis = [];
	    }
	    LocalListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	        this.getAllLocalCombustivel();
	    };
	    LocalListComponent.prototype.clickNew = function () {
	        this._localService.clearSessionStorage();
	        this._localNavigationService.goToNew();
	    };
	    LocalListComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    LocalListComponent.prototype.clickEdit = function (item) {
	        this._localService.clearSessionStorage();
	        this._localNavigationService.goToEdit(item.id);
	    };
	    LocalListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    LocalListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].tipo = this._localService.getTipoLocal(Response[x].tipo);
	                    Response[x].combustiveis = [];
	                }
	                this.list = Response;
	                if (this.localCombustiveis.length) {
	                    this.setLocaisCombustiveis();
	                }
	            }
	            this.loading = false;
	        }.bind(this));
	        this._locaisApiService.onGetAll(onDone);
	    };
	    LocalListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._locaisApiService.onDelete(item.id, onDone);
	    };
	    LocalListComponent.prototype.getAllLocalCombustivel = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.localCombustiveis = Response;
	                if (this.list.length) {
	                    this.setLocaisCombustiveis();
	                }
	            }
	            this.loading = false;
	        }.bind(this));
	        this._locaisApiService.onGetAllLocalCombustivel(onDone);
	    };
	    LocalListComponent.prototype.setLocaisCombustiveis = function () {
	        var x, lenX, y, lenY;
	        for (x = 0, lenX = this.list.length; x < lenX; x++) {
	            for (y = 0, lenY = this.localCombustiveis.length; y < lenY; y++) {
	                if (this.list[x].id === this.localCombustiveis[y].localId) {
	                    this.list[x].combustiveis.push(this.localCombustiveis[y]);
	                }
	            }
	        }
	    };
	    LocalListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(547),
	            styles: [__webpack_require__(548)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof local_api_service_1.LocalApiService !== 'undefined' && local_api_service_1.LocalApiService) === 'function' && _a) || Object, (typeof (_b = typeof local_service_1.LocalService !== 'undefined' && local_service_1.LocalService) === 'function' && _b) || Object, (typeof (_c = typeof local_navigation_service_1.LocalNavigationService !== 'undefined' && local_navigation_service_1.LocalNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _e) || Object])
	    ], LocalListComponent);
	    return LocalListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.LocalListComponent = LocalListComponent;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(398);
	var data_service_3 = __webpack_require__(400);
	var LocalNavigationService = (function () {
	    function LocalNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    LocalNavigationService.prototype.goToList = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.locaisRoute;
	        this._authService.navigateTo(router);
	    };
	    LocalNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.locaisRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    LocalNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.locaisRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    LocalNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], LocalNavigationService);
	    return LocalNavigationService;
	    var _a;
	}());
	exports.LocalNavigationService = LocalNavigationService;


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(398);
	var auth_service_1 = __webpack_require__(61);
	var AbastecimentoService = (function () {
	    function AbastecimentoService(_authService) {
	        this._authService = _authService;
	    }
	    AbastecimentoService.prototype.goToSetting = function () {
	        var router = data_service_1.abastecimentosRoute + '/configuracoes';
	        this._authService.navigateTo(router);
	    };
	    AbastecimentoService.prototype.goToReports = function () {
	        var router = data_service_1.abastecimentosRoute + '/relatorios';
	        this._authService.navigateTo(router);
	    };
	    AbastecimentoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], AbastecimentoService);
	    return AbastecimentoService;
	    var _a;
	}());
	exports.AbastecimentoService = AbastecimentoService;


/***/ },
/* 547 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{locaisModuleName.plural}}</a></li>\n        </ul>\n        <h1>{{locaisModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{locaisModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Nome</th>\n            <th>Tipo</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['nome', 'tipo.Value'] | filterActive:showDisabled | sort:['nome'])\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.nome}}</td>\n            <td ><span *ngIf=\"item.tipo\">{{item.tipo.Value}}</span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <p><strong>Descrição: </strong> {{item.descricao}} <i *ngIf=\"!item.descricao\">não cadastrado</i></p>\n\n                <app-local-combustivel-list [list]=\"item.combustiveis\"\n                                            [showDisabled]=\"showDisabled\"></app-local-combustivel-list>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 548 */
166,
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(400);
	var local_model_1 = __webpack_require__(414);
	var data_service_2 = __webpack_require__(178);
	var local_navigation_service_1 = __webpack_require__(545);
	var local_api_service_1 = __webpack_require__(407);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var local_service_1 = __webpack_require__(399);
	var abastecimento_service_1 = __webpack_require__(546);
	var data_service_3 = __webpack_require__(398);
	var LocalFormComponent = (function () {
	    function LocalFormComponent(_route, _localNavigationService, _localApiService, _localService, _utilService, _autocompleteService, _abastecimentoService, _fb) {
	        this._route = _route;
	        this._localNavigationService = _localNavigationService;
	        this._localApiService = _localApiService;
	        this._localService = _localService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._abastecimentoService = _abastecimentoService;
	        this._fb = _fb;
	        this.locaisModule = data_service_1.locaisModuleName;
	        this.formObject = new local_model_1.Local();
	        this.tipoLocalObject = {};
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.module = data_service_3.abastecimentosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.tiposLocaisList = data_service_1.TiposLocais;
	        this.localCombustiveis = [];
	        this.ativo = new forms_1.FormControl('');
	        this.nome = new forms_1.FormControl('', forms_1.Validators.required);
	        this.descricao = new forms_1.FormControl('');
	        this.tipo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseLocal = Response;
	                var localId = void 0;
	                if (this.formObject.id) {
	                    localId = this.formObject.id;
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    localId = Response.id;
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.submitLocalCombustivel(localId);
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.onDoneLocalCombustivel = (function (Response) {
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            nome: this.nome,
	            descricao: this.descricao,
	            tipo: this.tipo
	        });
	    }
	    LocalFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    LocalFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    LocalFormComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    LocalFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    LocalFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.tipoLocalObject.Key) {
	                object.tipo = this.tipoLocalObject.Key;
	            }
	            if (this.formObject.id) {
	                this.onEditLocal(object);
	            }
	            else {
	                this.onAddLocal(object);
	            }
	        }
	    };
	    LocalFormComponent.prototype.onAddLocal = function (object) {
	        this._localApiService.onPost(object, this.onDone);
	    };
	    LocalFormComponent.prototype.onEditLocal = function (object) {
	        this._localApiService.onPut(object, this.onDone);
	    };
	    LocalFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum local encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._localApiService.onGetById(id, onDone);
	    };
	    LocalFormComponent.prototype.getLocalCombustiveis = function (localId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.localCombustiveis = Response;
	            }
	        }.bind(this));
	        this._localApiService.onGetLocalCombustivelByLocal(localId, onDone);
	    };
	    LocalFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._localService.getSessionStorage();
	        this._localService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    LocalFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.tipo) {
	            this.tipoLocalObject = this._localService.getTipoLocal(this.formObject.tipo);
	        }
	    };
	    LocalFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._localService.returnToOtherForm(this.otherForm, this.responseLocal);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    LocalFormComponent.prototype.goToList = function () {
	        this._localNavigationService.goToList();
	    };
	    LocalFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.locaisStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.nome = newAutoComplete.nome;
	            this.formObject.tipo = newAutoComplete.tipo;
	            this.setActionTitle(this.formObject.id);
	            this.setModelToForm();
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    LocalFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    LocalFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	        this.getLocalCombustiveis(id);
	    };
	    LocalFormComponent.prototype.setNewNormal = function () {
	        this.tipoLocalObject = this.tiposLocaisList[0];
	    };
	    LocalFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    LocalFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    //local combustivel
	    LocalFormComponent.prototype.submitLocalCombustivel = function (localId) {
	        var x = 0, lenX = this.localCombustiveis.length, object = {};
	        for (x, lenX; x < lenX; x++) {
	            object = this.localCombustiveis[x];
	            if (object.preco) {
	                object.localId = localId;
	                object.combustivelId = object.combustivel.id;
	                delete object['combustivel'];
	                if (object.preco) {
	                    object.preco = this._utilService.getCurrency(object.preco);
	                }
	                if (this.localCombustiveis[x].id) {
	                    this.onEditLocalCombustivel(object);
	                }
	                else {
	                    this.onAddLocalCombustivel(object);
	                }
	            }
	        }
	    };
	    LocalFormComponent.prototype.onAddLocalCombustivel = function (object) {
	        this._localApiService.onPostLocalCombustivel(object, this.onDoneLocalCombustivel);
	    };
	    LocalFormComponent.prototype.onEditLocalCombustivel = function (object) {
	        this._localApiService.onPutLocalCombustivel(object, this.onDoneLocalCombustivel);
	    };
	    LocalFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(550),
	            styles: [__webpack_require__(551)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof local_navigation_service_1.LocalNavigationService !== 'undefined' && local_navigation_service_1.LocalNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof local_api_service_1.LocalApiService !== 'undefined' && local_api_service_1.LocalApiService) === 'function' && _c) || Object, (typeof (_d = typeof local_service_1.LocalService !== 'undefined' && local_service_1.LocalService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object])
	    ], LocalFormComponent);
	    return LocalFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.LocalFormComponent = LocalFormComponent;


/***/ },
/* 550 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{locaisModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{locaisModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{locaisModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados do local</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !nome.valid && submitted}\">\n                <label for=\"nome\">Nome <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!nome.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"nome\" placeholder=\"\" [(ngModel)]=\"formObject.nome\" formControlName=\"nome\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipo.valid && submitted}\">\n                <label for=\"tipo\">Tipo <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!tipo.valid && submitted\">Este campo é obrigatório.</span>\n                    <select id=\"tipo\" [(ngModel)]=\"tipoLocalObject\" formControlName=\"tipo\">\n                        <option *ngFor=\"let item of tiposLocaisList\" [ngValue]=\"item\">{{item.Value}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--12c\">\n                <label for=\"descricao\">Descrição </label>\n                <div>\n                    <textarea id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\"></textarea>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <app-local-combustivel-form [list]=\"localCombustiveis\"></app-local-combustivel-form>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 551 */
/***/ function(module, exports) {

	module.exports = "textarea {\n  min-height: 80px;\n}\n"

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var BombasComponent = (function () {
	    function BombasComponent() {
	    }
	    BombasComponent.prototype.ngOnInit = function () {
	    };
	    BombasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(553)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BombasComponent);
	    return BombasComponent;
	}());
	exports.BombasComponent = BombasComponent;


/***/ },
/* 553 */
171,
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var bomba_form_component_1 = __webpack_require__(555);
	var data_service_1 = __webpack_require__(178);
	var bomba_list_component_1 = __webpack_require__(559);
	var bomba_auditoria_list_component_1 = __webpack_require__(562);
	var bomba_auditoria_detail_component_1 = __webpack_require__(565);
	var bomba_auditoria_component_1 = __webpack_require__(568);
	var BombasRoutingModule = (function () {
	    function BombasRoutingModule() {
	    }
	    BombasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BombasRoutingModule);
	    return BombasRoutingModule;
	}());
	exports.BombasRoutingModule = BombasRoutingModule;
	exports.bombasRoutes = [
	    {
	        path: '',
	        component: bomba_list_component_1.BombaListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: bomba_form_component_1.BombaFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: bomba_form_component_1.BombaFormComponent
	    }
	];
	exports.auditoriaRoutes = [
	    {
	        path: '',
	        component: bomba_auditoria_list_component_1.BombaAuditoriaListComponent
	    }, {
	        path: data_service_1.detailRoute + '/:id',
	        component: bomba_auditoria_detail_component_1.BombaAuditoriaDetailComponent
	    }, {
	        path: 'auditar/:id',
	        component: bomba_auditoria_component_1.BombaAuditoriaComponent
	    }
	];


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(401);
	var data_service_2 = __webpack_require__(178);
	var bomba_model_1 = __webpack_require__(417);
	var bomba_api_service_1 = __webpack_require__(408);
	var bomba_service_1 = __webpack_require__(402);
	var autocomplete_service_1 = __webpack_require__(101);
	var tanque_model_1 = __webpack_require__(556);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var tanque_api_service_1 = __webpack_require__(416);
	var data_service_3 = __webpack_require__(404);
	var tanque_service_1 = __webpack_require__(405);
	var data_service_4 = __webpack_require__(398);
	var abastecimento_service_1 = __webpack_require__(546);
	var BombaFormComponent = (function () {
	    function BombaFormComponent(_route, _utilService, _bombaService, _bombaApiService, _bombaNavigationService, _tanqueNavigationService, _tanqueApiService, _tanqueService, _autocompleteService, _abastecimentoService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._bombaService = _bombaService;
	        this._bombaApiService = _bombaApiService;
	        this._bombaNavigationService = _bombaNavigationService;
	        this._tanqueNavigationService = _tanqueNavigationService;
	        this._tanqueApiService = _tanqueApiService;
	        this._tanqueService = _tanqueService;
	        this._autocompleteService = _autocompleteService;
	        this._abastecimentoService = _abastecimentoService;
	        this._fb = _fb;
	        this.bombasModule = data_service_1.bombasModuleName;
	        this.formObject = new bomba_model_1.Bomba();
	        this.tanqueObject = new tanque_model_1.Tanque();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.module = data_service_4.abastecimentosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.tanqueSelectId = 'tanqueSelect';
	        this.tanqueQuery = {};
	        this.fuelName = '';
	        this.ativo = new forms_1.FormControl('');
	        this.nome = new forms_1.FormControl('', forms_1.Validators.required);
	        this.combustivel = new forms_1.FormControl({ value: '', disabled: true });
	        this.numeroPatrimonio = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tanque = new forms_1.FormControl('', forms_1.Validators.required);
	        this.hidrometroInicial = new forms_1.FormControl('', forms_1.Validators.required);
	        this.automatizado = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.tanqueTemplateResult = (function (state) {
	            return this._tanqueService.templateResult(state, true);
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            nome: this.nome,
	            tanque: this.tanque,
	            combustivel: this.combustivel,
	            numeroPatrimonio: this.numeroPatrimonio,
	            automatizado: this.automatizado,
	            hidrometroInicial: this.hidrometroInicial
	        });
	    }
	    BombaFormComponent.prototype.ngOnInit = function () {
	        this.tanqueQuery = this._utilService.cloneObject(data_service_3.tanquesQuery);
	        this.isNewAutoComplete();
	    };
	    BombaFormComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    BombaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    BombaFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    BombaFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.tanqueObject.id) {
	                object.tanqueId = this.tanqueObject.id;
	                object.combustivelId = this.tanqueObject.combustivelId;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.formObject.id) {
	                this.onEditBomba(object);
	            }
	            else {
	                this.onAddBomba(object);
	            }
	        }
	    };
	    BombaFormComponent.prototype.getTanqueObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.formObject;
	            thisFormObject.tanque = this.tanqueObject;
	            this._bombaService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                identificacao: object.text,
	                form: data_service_1.bombasStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_3.tanquesStorage);
	            this._tanqueNavigationService.goToNew();
	        }
	        else {
	            this.tanqueObject = object;
	            this.setFuelName(object.combustivel);
	            this._utilService.setSelectOnFormControl(this.form, 'tanque', object);
	        }
	    };
	    BombaFormComponent.prototype.onAddBomba = function (object) {
	        this._bombaApiService.onPost(object, this.onDone);
	    };
	    BombaFormComponent.prototype.onEditBomba = function (object) {
	        this._bombaApiService.onPut(object, this.onDone);
	    };
	    BombaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma bomba encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._bombaApiService.onGetById(id, onDone);
	    };
	    BombaFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.tanque) {
	            this.tanqueObject = this.formObject.tanque;
	            delete this.formObject['tanque'];
	            var text = this._autocompleteService.getTextSelect2(this.tanqueObject, 'identificacao');
	            var selectObject = { text: text, id: this.tanqueObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.tanqueSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.tanqueSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'tanque', this.tanqueObject);
	            if (this.tanqueObject.combustivel) {
	                this.setFuelName(this.tanqueObject.combustivel);
	            }
	        }
	    };
	    BombaFormComponent.prototype.goToList = function () {
	        this._bombaService.clearSessionStorage();
	        this._bombaNavigationService.goToList();
	    };
	    BombaFormComponent.prototype.testSession = function () {
	        var id, session = this._bombaService.getSessionStorage();
	        this._bombaService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            if (id) {
	                this.setEditSession();
	            }
	            else {
	                this.setNewSession();
	            }
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    BombaFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    BombaFormComponent.prototype.setEditNormal = function (id) {
	        var element = this.form.controls['hidrometroInicial'];
	        element.disable();
	        this.getObject(id);
	    };
	    BombaFormComponent.prototype.setNewNormal = function () {
	    };
	    BombaFormComponent.prototype.setEditSession = function () {
	        this.setModelToForm();
	    };
	    BombaFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	        this.setModelToForm();
	    };
	    BombaFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.bombasStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.bomba = newAutoComplete.bomba;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    BombaFormComponent.prototype.toLeaveHere = function () {
	        this.goToList();
	    };
	    BombaFormComponent.prototype.setFuelName = function (fuel) {
	        this.fuelName = this._autocompleteService.getTextSelect2(fuel, 'combustivel');
	    };
	    BombaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(557),
	            styles: [__webpack_require__(558)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof bomba_service_1.BombaService !== 'undefined' && bomba_service_1.BombaService) === 'function' && _c) || Object, (typeof (_d = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _d) || Object, (typeof (_e = typeof bomba_navigation_service_1.BombaNavigationService !== 'undefined' && bomba_navigation_service_1.BombaNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _f) || Object, (typeof (_g = typeof tanque_api_service_1.TanqueApiService !== 'undefined' && tanque_api_service_1.TanqueApiService) === 'function' && _g) || Object, (typeof (_h = typeof tanque_service_1.TanqueService !== 'undefined' && tanque_service_1.TanqueService) === 'function' && _h) || Object, (typeof (_j = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _j) || Object, (typeof (_k = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _k) || Object, (typeof (_l = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _l) || Object])
	    ], BombaFormComponent);
	    return BombaFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.BombaFormComponent = BombaFormComponent;


/***/ },
/* 556 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var Tanque = (function () {
	    function Tanque() {
	    }
	    return Tanque;
	}());
	exports.Tanque = Tanque;
	var MovimentacaoTanque = (function () {
	    function MovimentacaoTanque() {
	    }
	    return MovimentacaoTanque;
	}());
	exports.MovimentacaoTanque = MovimentacaoTanque;
	var MovimentacaoTanqueArea = (function () {
	    function MovimentacaoTanqueArea() {
	    }
	    return MovimentacaoTanqueArea;
	}());
	exports.MovimentacaoTanqueArea = MovimentacaoTanqueArea;


/***/ },
/* 557 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{bombasModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{bombasModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{bombasModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !nome.valid && submitted}\">\n                <label for=\"nome\">Identificação <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!nome.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"nome\" [(ngModel)]=\"formObject.nome\" formControlName=\"nome\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !numeroPatrimonio.valid && submitted}\">\n                <label for=\"numeroPatrimonio\">Nº do patrimônio <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!numeroPatrimonio.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"numeroPatrimonio\" [(ngModel)]=\"formObject.numeroPatrimonio\" formControlName=\"numeroPatrimonio\">\n                </div>\n            </div>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"tanqueSelect\"\n                                    (setObejct)=\"getTanqueObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"tanqueSelectId\"\n                                    [model]=\"tanqueObject\"\n                                    [_service]=\"_tanqueApiService\"\n                                    [templateResult]=\"tanqueTemplateResult\"\n                                    [query]=\"tanqueQuery\"\n                                    [label]=\"'Tanque'\"></autocomplete-component>\n\n            <div class=\"geo-input--3c\" >\n                <label for=\"combustivel\">Combustível</label>\n                <div>\n                    <input type=\"text\" id=\"combustivel\" [(ngModel)]=\"fuelName\" formControlName=\"combustivel\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!hidrometroInicial.valid && submitted && !formObject.id)}\">\n                <label for=\"hidrometroInicial\">Hidrômetro inicial <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!hidrometroInicial.valid && submitted  && !formObject.id\">Este campo é obrigatório.</span>\n                    <input type=\"number\" id=\"hidrometroInicial\" [(ngModel)]=\"formObject.hidrometroInicial\" formControlName=\"hidrometroInicial\">\n                </div>\n            </div>\n\n            <div class=\"geo-columns--3c\">\n                <div class=\"geo-toggle\">\n                    <input type=\"checkbox\" id=\"automatizado\" value=\"\" [(ngModel)]=\"formObject.automatizado\" formControlName=\"automatizado\">\n                    <label for=\"automatizado\">Automatizada</label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 558 */
166,
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var util_service_1 = __webpack_require__(88);
	var bomba_api_service_1 = __webpack_require__(408);
	var data_service_1 = __webpack_require__(401);
	var bomba_service_1 = __webpack_require__(402);
	var abastecimento_service_1 = __webpack_require__(546);
	var data_service_2 = __webpack_require__(398);
	var data_service_3 = __webpack_require__(178);
	var BombaListComponent = (function () {
	    function BombaListComponent(_bombaNavigationService, _bombasApiService, _bombasService, _utilService, _abastecimentoService) {
	        this._bombaNavigationService = _bombaNavigationService;
	        this._bombasApiService = _bombasApiService;
	        this._bombasService = _bombasService;
	        this._utilService = _utilService;
	        this._abastecimentoService = _abastecimentoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.bombaModule = data_service_1.bombasModuleName;
	        this.module = data_service_2.abastecimentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	    }
	    BombaListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    BombaListComponent.prototype.clickNew = function () {
	        this._bombasService.clearSessionStorage();
	        this._bombaNavigationService.goToNew();
	    };
	    BombaListComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    BombaListComponent.prototype.clickEdit = function (item) {
	        this._bombasService.clearSessionStorage();
	        this._bombaNavigationService.goToEdit(item.id);
	    };
	    BombaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    BombaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._bombasApiService.onGetAll(onDone);
	    };
	    BombaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._bombasApiService.onDelete(item.id, onDone);
	    };
	    BombaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(560),
	            styles: [__webpack_require__(561)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof bomba_navigation_service_1.BombaNavigationService !== 'undefined' && bomba_navigation_service_1.BombaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _b) || Object, (typeof (_c = typeof bomba_service_1.BombaService !== 'undefined' && bomba_service_1.BombaService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _e) || Object])
	    ], BombaListComponent);
	    return BombaListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.BombaListComponent = BombaListComponent;


/***/ },
/* 560 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{bombaModule.plural}}</a></li>\n        </ul>\n        <h1>{{bombaModule.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{bombaModule.single | lowercase}} cadastrada</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Identificação</th>\n            <th>Tanque</th>\n            <th>Combustível</th>\n            <th>Nº do patrimônio</th>\n            <th>Hidrômetro inicial</th>\n            <th>Automatizada</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['nome', 'tanque.combustivel.combustivel', 'tanque.identificacao', 'numeroPatrimonio'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.nome}}</td>\n            <td><span *ngIf=\"item.tanque\">{{item.tanque.identificacao}}</span></td>\n            <td><span *ngIf=\"item.tanque && item.tanque.combustivel\">{{item.tanque.combustivel.combustivel}}</span> </td>\n            <td>{{item.numeroPatrimonio}}</td>\n            <td><span *ngIf=\"item.hidrometroInicial\">{{item.hidrometroInicial}}</span></td>\n            <td><span *ngIf=\"item.automatizado\">Sim</span> <span *ngIf=\"!item.automatizado\">Não</span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 561 */
166,
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 30/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var bomba_api_service_1 = __webpack_require__(408);
	var data_service_1 = __webpack_require__(401);
	var data_service_2 = __webpack_require__(398);
	var BombaAuditoriaListComponent = (function () {
	    function BombaAuditoriaListComponent(_bombaNavigationService, _bombasApiService) {
	        this._bombaNavigationService = _bombaNavigationService;
	        this._bombasApiService = _bombasApiService;
	        this.list = [];
	        this.loading = true;
	        this.bombaModule = data_service_1.bombasModuleName;
	        this.bombasAuditoriaModule = data_service_1.bombasAuditoriaModuleName;
	        this.module = data_service_2.abastecimentosModuleName;
	    }
	    BombaAuditoriaListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    BombaAuditoriaListComponent.prototype.clickDetail = function (item) {
	        this._bombaNavigationService.goToAuditoriaDetail(item.id);
	    };
	    BombaAuditoriaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._bombasApiService.onGetAll(onDone);
	    };
	    BombaAuditoriaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(563),
	            styles: [__webpack_require__(564)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof bomba_navigation_service_1.BombaNavigationService !== 'undefined' && bomba_navigation_service_1.BombaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _b) || Object])
	    ], BombaAuditoriaListComponent);
	    return BombaAuditoriaListComponent;
	    var _a, _b;
	}());
	exports.BombaAuditoriaListComponent = BombaAuditoriaListComponent;


/***/ },
/* 563 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">{{bombasAuditoriaModule.single}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{bombasAuditoriaModule.single}}</h1>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{bombasModule.single | lowercase}} cadastrada</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Identificação</th>\n            <th>Nº do patrimônio</th>\n            <th>Combustível</th>\n            <th>Automatizada</th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['nome', 'tanque.combustivel.combustivel', 'tanque.identificacao', 'numeroPatrimonio'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.nome}}</a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.numeroPatrimonio}}</a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.tanque && item.tanque.combustivel\">{{item.tanque.combustivel.combustivel}}</span></a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.automatizado\">Sim</span> <span *ngIf=\"!item.automatizado\">Não</span></a></td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 564 */
166,
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 30/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var bomba_api_service_1 = __webpack_require__(408);
	var data_service_1 = __webpack_require__(401);
	var number_validation_1 = __webpack_require__(132);
	var bomba_model_1 = __webpack_require__(417);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(398);
	var BombaAuditoriaDetailComponent = (function () {
	    function BombaAuditoriaDetailComponent(_bombaNavigationService, _bombasApiService, _utilService, _route, _cdRef, _fb) {
	        this._bombaNavigationService = _bombaNavigationService;
	        this._bombasApiService = _bombasApiService;
	        this._utilService = _utilService;
	        this._route = _route;
	        this._cdRef = _cdRef;
	        this._fb = _fb;
	        this.detail = {};
	        this.list = [];
	        this.formObject = new bomba_model_1.Hidrometro();
	        this.loading = true;
	        this.showDisabled = false;
	        this.submitted = false;
	        this.bombasModuleName = data_service_1.bombasModuleName;
	        this.bombasAuditoriaModule = data_service_1.bombasAuditoriaModuleName;
	        this.module = data_service_2.abastecimentosModuleName;
	        this.hidrometro = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, number_validation_1.NumberValidator.numberFormat]));
	        this.data = new forms_1.FormControl('', forms_1.Validators.required);
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.initForm();
	            }
	            else {
	                if (Response.error.name === 'hidrometroJaCadastradoNoDia') {
	                    this.swalRepeatDate(Response.error);
	                }
	                else {
	                    this._utilService.swalMessageWarningCustom(Response.error);
	                }
	            }
	        }.bind(this));
	        this.swalRepeatDate = (function (err) {
	            var t = this;
	            var hidroAtual = err.Hidrometro.hidrometro;
	            swal({
	                title: 'Registro encontrado nesta data.',
	                text: 'Há um hidrômetro registrado com o valor de ' + hidroAtual + ' litros para esta data. Você deseja reescrever este valor?',
	                type: "warning",
	                showCancelButton: true,
	                confirmButtonText: "Sim, reescrever",
	                cancelButtonText: "Cancelar",
	                closeOnConfirm: false
	            }, function () {
	                return t.onEdit(err.Hidrometro);
	            });
	        }.bind(this));
	        this.fromT = _fb.group({
	            hidrometro: this.hidrometro,
	            data: this.data
	        });
	    }
	    BombaAuditoriaDetailComponent.prototype.ngOnInit = function () {
	        this.bombaId = +this._route.snapshot.params['id'];
	        this._utilService.disabledFutureDates('hidroData');
	        this.getBomba();
	        this.getHidrometroVirtual();
	        this.initForm();
	    };
	    BombaAuditoriaDetailComponent.prototype.ngAfterViewChecked = function () {
	        this._cdRef.detectChanges();
	    };
	    BombaAuditoriaDetailComponent.prototype.clickAuditoriaList = function () {
	        this._bombaNavigationService.goToAuditoriaList();
	    };
	    BombaAuditoriaDetailComponent.prototype.clickAuditar = function () {
	        this._bombaNavigationService.goToAuditar(this.bombaId);
	    };
	    BombaAuditoriaDetailComponent.prototype.keyupSave = function ($event) {
	        if ($event.keyCode === 13) {
	            this.clickSave();
	        }
	    };
	    BombaAuditoriaDetailComponent.prototype.clickSave = function () {
	        this.submitted = true;
	        if (!this.hidrometro.valid) {
	            return false;
	        }
	        var date = document.getElementById('hidroData');
	        if (!date.value) {
	            return false;
	        }
	        var object = this._utilService.cloneObject(this.formObject);
	        object.bombaId = this.bombaId;
	        object.data = this._utilService.convertStringToDate(date.value);
	        this.onAdd(object);
	    };
	    BombaAuditoriaDetailComponent.prototype.onAdd = function (object) {
	        this._bombasApiService.onPostHidrometro(object, this.onDone);
	    };
	    BombaAuditoriaDetailComponent.prototype.onEdit = function (object) {
	        object.hidrometro = this.formObject.hidrometro;
	        this._bombasApiService.onPutHidrometro(object, this.onDone);
	    };
	    BombaAuditoriaDetailComponent.prototype.getBomba = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.detail = Response;
	            }
	        }.bind(this));
	        this._bombasApiService.onGetById(this.bombaId, onDone);
	    };
	    BombaAuditoriaDetailComponent.prototype.getHidrometros = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].data = this._utilService.convertDateToString(Response[x].data);
	                }
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._bombasApiService.onGetHidrometroByBomba(this.bombaId, onDone);
	    };
	    BombaAuditoriaDetailComponent.prototype.getHidrometroVirtual = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.hidrometroVirtual = Response.hidrometroVirtual;
	            }
	        }.bind(this));
	        this._bombasApiService.onGetHidrometroVirtual(this.bombaId, onDone);
	    };
	    BombaAuditoriaDetailComponent.prototype.initForm = function () {
	        this.getHidrometros();
	        this.formObject = new bomba_model_1.Hidrometro();
	        this.formObject.data = this._utilService.convertDateToString(new Date());
	        this.submitted = false;
	    };
	    BombaAuditoriaDetailComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(566),
	            styles: [__webpack_require__(567)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof bomba_navigation_service_1.BombaNavigationService !== 'undefined' && bomba_navigation_service_1.BombaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof core_1.ChangeDetectorRef !== 'undefined' && core_1.ChangeDetectorRef) === 'function' && _e) || Object, (typeof (_f = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _f) || Object])
	    ], BombaAuditoriaDetailComponent);
	    return BombaAuditoriaDetailComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.BombaAuditoriaDetailComponent = BombaAuditoriaDetailComponent;


/***/ },
/* 566 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickAuditoriaList()\" class=\"cursor-pointer\">{{bombasAuditoriaModule.single}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{detail.nome}}</a></li>\n        </ul>\n        <h1>{{detail.nome}}</h1>\n        <p><strong>Nº do patrimônio: </strong><span *ngIf=\"detail.numeroPatrimonio\">{{detail.numeroPatrimonio}}</span> <i *ngIf=\"!detail.numeroPatrimonio\">não cadastrado</i></p>\n        <p><strong>Combustível: </strong><span *ngIf=\"detail.tanque && detail.tanque.combustivel\">{{detail.tanque.combustivel.combustivel}}</span> <i *ngIf=\"!detail.tanque\">não cadastrado</i></p>\n        <p><strong>Tanque: </strong><span *ngIf=\"detail.tanque\">{{detail.tanque.identificacao}}</span> <i *ngIf=\"!detail.tanque\">não cadastrado</i></p>\n        <p><strong>Automatizada: </strong><span *ngIf=\"detail.automatizado\">Sim</span> <span *ngIf=\"!detail.automatizado\">Não</span></p>\n        <p>\n            <strong>Hidrômetro inicial: </strong><span *ngIf=\"detail.hidrometroInicial\">{{detail.hidrometroInicial | literMask}} litroos </span> <i *ngIf=\"!detail.hidrometroInicial\">não cadastrado</i>\n             - <strong>Hidrômetro virtual: </strong><span *ngIf=\"hidrometroVirtual\">{{hidrometroVirtual | literMask}} litros </span> <i *ngIf=\"!hidrometroVirtual\">não informado</i>\n        </p>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <a (click)=\"clickAuditar()\" class=\"geo-button geo-button--action\">Auditar</a>\n    </div>\n\n    <div class=\"geo-columns--6c geo-columns--right\">\n        <!--<label class=\"geo-switch\">-->\n            <!--<span class=\"geo-switch&#45;&#45;label\">Exibir inativos:</span>-->\n            <!--<input type=\"checkbox\" [(ngModel)]=\"showDisabled\">-->\n            <!--<div class=\"geo-switch&#45;&#45;checkbox\">-->\n                <!--<span class=\"geo-switch&#45;&#45;status\"></span>-->\n            <!--</div>-->\n        <!--</label>-->\n    </div>\n\n    <table>\n        <thead>\n        <tr>\n            <th>Data</th>\n            <th>Hidrômetro</th>\n            <th></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr [formGroup]=\"fromT\">\n            <td>\n                <div class=\"geo-input--12c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': !data.value && submitted}\">\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!data.valid && data.hasError('required')\">Este campo é obrigatório.</span>\n                        <input type=\"text\" class=\"input-datepicker\" id=\"hidroData\" [(ngModel)]=\"formObject.data\" formControlName=\"data\" appDatepicker autocomplete=\"off\" />\n                    </div>\n                </div>\n            </td>\n            <td>\n                <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !hidrometro.valid && submitted}\">\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!hidrometro.valid && hidrometro.hasError('required')\">Este campo é obrigatório.</span>\n                        <span class=\"error-alert\" *ngIf=\"!hidrometro.valid && hidrometro.hasError('incorrectNumberFormat')\">Formato incorreto.</span>\n                        <input type=\"number\" placeholder=\"Hidrômetro\" [(ngModel)]=\"formObject.hidrometro\" formControlName=\"hidrometro\" (keyup)=\"keyupSave($event)\">\n                    </div>\n                </div>\n            </td>\n            <td>\n                <a (click)=\"clickSave()\" class=\"geo-button\">Salvar</a>\n            </td>\n        </tr>\n        </tbody>\n        <tbody *ngFor=\"let item of(list | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.data}}</td>\n            <td>{{item.hidrometro | literMask}} litros</td>\n            <td></td>\n        </tr>\n        </tbody>\n    </table>\n\n    <div class=\"geo-columns--3c\">\n        <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n    </div>\n</div>";

/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports = "td .geo-button {\n    margin-bottom: 0;\n}"

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 30/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var bomba_api_service_1 = __webpack_require__(408);
	var util_service_1 = __webpack_require__(88);
	var bomba_model_1 = __webpack_require__(417);
	var data_service_1 = __webpack_require__(401);
	var abastecimento_bem_navigation_service_1 = __webpack_require__(397);
	var data_service_2 = __webpack_require__(398);
	var BombaAuditoriaComponent = (function () {
	    function BombaAuditoriaComponent(_bombaNavigationService, _bombasApiService, _utilService, _abastecimentoNavigationService, _route, _cdRef, _fb) {
	        this._bombaNavigationService = _bombaNavigationService;
	        this._bombasApiService = _bombasApiService;
	        this._utilService = _utilService;
	        this._abastecimentoNavigationService = _abastecimentoNavigationService;
	        this._route = _route;
	        this._cdRef = _cdRef;
	        this._fb = _fb;
	        this.bombaObject = new bomba_model_1.Bomba();
	        this.audits = null;
	        this.formObject = {};
	        this.loading = false;
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.bombasAuditoriaModule = data_service_1.bombasAuditoriaModuleName;
	        this.module = data_service_2.abastecimentosModuleName;
	        this.dataFim = new forms_1.FormControl('', forms_1.Validators.required);
	        this.dataInicio = new forms_1.FormControl('', forms_1.Validators.required);
	        this.onDoneAudit = (function (Response) {
	            if (!Response.error) {
	                Response.inconformidade = Response.totalContabilizado - Response.totalEsperado;
	                this.audits = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	            this.loading = false;
	        }.bind(this));
	        this.formT = _fb.group({
	            dataFim: this.dataFim,
	            dataInicio: this.dataInicio
	        });
	    }
	    BombaAuditoriaComponent.prototype.ngOnInit = function () {
	        this.bombaId = +this._route.snapshot.params['id'];
	        this._utilService.disabledFutureDates('dataInicio');
	        this._utilService.disabledFutureDates('dataFim');
	        this.formObject.dataFim = this._utilService.convertDateToString(new Date());
	        this.getBomba();
	    };
	    BombaAuditoriaComponent.prototype.ngAfterViewChecked = function () {
	        this._cdRef.detectChanges();
	    };
	    BombaAuditoriaComponent.prototype.clickAuditoriaList = function () {
	        this._bombaNavigationService.goToAuditoriaList();
	    };
	    BombaAuditoriaComponent.prototype.clickGoToDetail = function () {
	        this._bombaNavigationService.goToAuditoriaDetail(this.bombaId);
	    };
	    BombaAuditoriaComponent.prototype.clickAjustar = function () {
	        this._abastecimentoNavigationService.goToNew();
	    };
	    BombaAuditoriaComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        var startDate = document.getElementById('dataInicio');
	        if (!startDate.value) {
	            return false;
	        }
	        this.formObject.dataInicio = startDate.value;
	        var endDate = document.getElementById('dataFim');
	        if (!endDate.value) {
	            return false;
	        }
	        this.formObject.dataFim = endDate.value;
	        var object = this._utilService.cloneObject(this.formObject);
	        object.bombaId = this.bombaId;
	        object.dataInicio = this._utilService.convertStringToDate(startDate.value);
	        object.dataFim = this._utilService.convertStringToDate(endDate.value);
	        this.loading = true;
	        this.audits = null;
	        this.onAudit(object);
	    };
	    BombaAuditoriaComponent.prototype.onAudit = function (object) {
	        this._bombasApiService.onPostAuditar(object, this.onDoneAudit);
	    };
	    BombaAuditoriaComponent.prototype.getBomba = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.bombaObject = Response;
	            }
	        }.bind(this));
	        this._bombasApiService.onGetById(this.bombaId, onDone);
	    };
	    BombaAuditoriaComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(569),
	            styles: [__webpack_require__(570)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof bomba_navigation_service_1.BombaNavigationService !== 'undefined' && bomba_navigation_service_1.BombaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof abastecimento_bem_navigation_service_1.AbastecimentoBemNavigationService !== 'undefined' && abastecimento_bem_navigation_service_1.AbastecimentoBemNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof core_1.ChangeDetectorRef !== 'undefined' && core_1.ChangeDetectorRef) === 'function' && _f) || Object, (typeof (_g = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _g) || Object])
	    ], BombaAuditoriaComponent);
	    return BombaAuditoriaComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.BombaAuditoriaComponent = BombaAuditoriaComponent;


/***/ },
/* 569 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickAuditoriaList()\" class=\"cursor-pointer\">{{bombasAuditoriaModule.single}}</a></li>\n            <li class=\"item\"><a (click)=\"clickGoToDetail()\" class=\"cursor-pointer\">{{bombaObject.nome}}</a></li>\n            <li class=\"item\"><a class=\"active\">Auditar</a></li>\n        </ul>\n        <h1>Auditar</h1>\n    </div>\n</div>\n\n<form [formGroup]=\"formT\" (ngSubmit)=\"onSubmit(formT)\" novalidate>\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': !dataInicio.value && submitted}\">\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!dataInicio.valid && dataInicio.hasError('required')\">Este campo é obrigatório.</span>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"dataInicio\" placeholder=\"Data inicial\" [(ngModel)]=\"formObject.dataInicio\" formControlName=\"dataInicio\" appDatepicker autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': !dataFim.value && submitted}\">\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!dataFim.valid && dataFim.hasError('required')\">Este campo é obrigatório.</span>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"dataFim\" placeholder=\"Data final\" [(ngModel)]=\"formObject.dataFim\" formControlName=\"dataFim\" appDatepicker autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <button type=\"submit\" class=\"geo-button\">Auditar</button>\n        </div>\n    </div>\n</form>\n\n<div class=\"geo-content__row borderTop\" *ngIf=\"!audits && !loading\">\n    <p class=\"lead padding\">Informe o período da auditoria</p>\n</div>\n\n<div class=\"geo-content__row\" *ngIf=\"loading\">\n    <spinner-component [showDisplay]=\"true\" ></spinner-component>\n</div>\n\n<div class=\"geo-content__row containerTotais\" *ngIf=\"audits\">\n    <div class=\"geo-columns--3c geo-card\">\n        <div class=\"geo-card__title\">\n            <a>Registrado na bomba</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            {{audits.totalEsperado | literMask}} litros\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c geo-card\">\n        <div class=\"geo-card__title\">\n            <a>Total de abastecimentos</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            {{audits.totalContabilizado | literMask}} litros\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c geo-card\">\n        <div class=\"geo-card__title\">\n            <a>Inconformidade</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content containerRelative\">\n            <span [ngClass]=\"{red: (audits.inconformidade !== 0)}\">{{audits.inconformidade | literMask}} litros</span>\n\n            <a class=\"geo-button geo-button--error\" (click)=\"clickAjustar()\" *ngIf=\"audits.totalContabilizado < audits.totalEsperado\">Ajustar</a>\n        </div>\n    </div>\n</div>\n";

/***/ },
/* 570 */
/***/ function(module, exports) {

	module.exports = ".red {\n    color: #fc0707;\n}\n\n.containerTotais {\n    padding: 0;\n}\n\n.containerRelative {\n    position: relative;\n}\n\n.containerRelative a {\n    position: absolute;\n    right: -13px;\n    top: -38px;\n}\n\n.containerAjuste {\n    margin: 1rem;\n}\n\n.borderTop {\n    border-top: 1px solid #edf0f4;\n}\n\n.containerAjuste p.lead {\n    padding-left: 12px;\n}"

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CombustiveisComponent = (function () {
	    function CombustiveisComponent() {
	    }
	    CombustiveisComponent.prototype.ngOnInit = function () {
	    };
	    CombustiveisComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(572)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CombustiveisComponent);
	    return CombustiveisComponent;
	}());
	exports.CombustiveisComponent = CombustiveisComponent;


/***/ },
/* 572 */
171,
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var combustivel_list_component_1 = __webpack_require__(574);
	var data_service_1 = __webpack_require__(178);
	var combustivel_form_component_1 = __webpack_require__(579);
	var CombustiveisRoutingModule = (function () {
	    function CombustiveisRoutingModule() {
	    }
	    CombustiveisRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CombustiveisRoutingModule);
	    return CombustiveisRoutingModule;
	}());
	exports.CombustiveisRoutingModule = CombustiveisRoutingModule;
	exports.combustiveisRoutes = [
	    {
	        path: '',
	        component: combustivel_list_component_1.CombustivelListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: combustivel_form_component_1.CombustivelFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: combustivel_form_component_1.CombustivelFormComponent
	    }
	];


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(377);
	var combustivel_api_service_1 = __webpack_require__(376);
	var util_service_1 = __webpack_require__(88);
	var combustivel_navigation_service_1 = __webpack_require__(575);
	var combustivel_service_1 = __webpack_require__(576);
	var data_service_2 = __webpack_require__(398);
	var abastecimento_service_1 = __webpack_require__(546);
	var data_service_3 = __webpack_require__(178);
	var CombustivelListComponent = (function () {
	    function CombustivelListComponent(_combustiveisApiService, _combustivelService, _combustivelNavigationService, _utilService, _abastecimentoService) {
	        this._combustiveisApiService = _combustiveisApiService;
	        this._combustivelService = _combustivelService;
	        this._combustivelNavigationService = _combustivelNavigationService;
	        this._utilService = _utilService;
	        this._abastecimentoService = _abastecimentoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.combustiveisModuleName = data_service_1.combustiveisModuleName;
	        this.abastecimentosRoute = data_service_2.abastecimentosRoute;
	        this.module = data_service_2.abastecimentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	    }
	    CombustivelListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    CombustivelListComponent.prototype.clickNew = function () {
	        this._combustivelService.clearSessionStorage();
	        this._combustivelNavigationService.goToNew();
	    };
	    CombustivelListComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    CombustivelListComponent.prototype.clickEdit = function (item) {
	        this._combustivelService.clearSessionStorage();
	        this._combustivelNavigationService.goToEdit(item.id);
	    };
	    CombustivelListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    CombustivelListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._combustiveisApiService.onGetAll(onDone);
	    };
	    CombustivelListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._combustiveisApiService.onDelete(item.id, onDone);
	    };
	    CombustivelListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(577),
	            styles: [__webpack_require__(578)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof combustivel_api_service_1.CombustivelApiService !== 'undefined' && combustivel_api_service_1.CombustivelApiService) === 'function' && _a) || Object, (typeof (_b = typeof combustivel_service_1.CombustivelService !== 'undefined' && combustivel_service_1.CombustivelService) === 'function' && _b) || Object, (typeof (_c = typeof combustivel_navigation_service_1.CombustivelNavigationService !== 'undefined' && combustivel_navigation_service_1.CombustivelNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _e) || Object])
	    ], CombustivelListComponent);
	    return CombustivelListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.CombustivelListComponent = CombustivelListComponent;


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(398);
	var data_service_3 = __webpack_require__(377);
	var CombustivelNavigationService = (function () {
	    function CombustivelNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    CombustivelNavigationService.prototype.goToList = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.combustiveisRoute;
	        this._authService.navigateTo(router);
	    };
	    CombustivelNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.combustiveisRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    CombustivelNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.combustiveisRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    CombustivelNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], CombustivelNavigationService);
	    return CombustivelNavigationService;
	    var _a;
	}());
	exports.CombustivelNavigationService = CombustivelNavigationService;


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(377);
	var data_service_2 = __webpack_require__(404);
	var tanque_service_1 = __webpack_require__(405);
	var autocomplete_service_1 = __webpack_require__(101);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var CombustivelService = (function () {
	    function CombustivelService(_autocompleteService, _tanqueService, _tanqueNavigationService) {
	        this._autocompleteService = _autocompleteService;
	        this._tanqueService = _tanqueService;
	        this._tanqueNavigationService = _tanqueNavigationService;
	    }
	    //session
	    CombustivelService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.combustiveisStorage + '-new', object);
	    };
	    CombustivelService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.combustiveisStorage + "-new");
	        return JSON.parse(item);
	    };
	    CombustivelService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.combustiveisStorage + "-new");
	    };
	    CombustivelService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.tanquesStorage) {
	                otherFormObject = this._tanqueService.getSessionStorage();
	                otherFormObject.combustivel = Response;
	                this._tanqueService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.combustiveisStorage);
	        if (otherForm === data_service_2.tanquesStorage) {
	            otherFormObject = this._tanqueService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._tanqueNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._tanqueNavigationService.goToNew();
	            }
	        }
	    };
	    CombustivelService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object, (typeof (_b = typeof tanque_service_1.TanqueService !== 'undefined' && tanque_service_1.TanqueService) === 'function' && _b) || Object, (typeof (_c = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _c) || Object])
	    ], CombustivelService);
	    return CombustivelService;
	    var _a, _b, _c;
	}());
	exports.CombustivelService = CombustivelService;


/***/ },
/* 577 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{combustiveisModuleName.plural}}</a></li>\n        </ul>\n        <h1>{{combustiveisModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{combustiveisModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Descrição</th>\n            <th>Código TCE</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['combustivel', 'codigoTCE'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.combustivel}}</td>\n            <td>{{item.codigoTCE}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 578 */
166,
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(377);
	var combustivel_model_1 = __webpack_require__(412);
	var data_service_2 = __webpack_require__(178);
	var combustivel_navigation_service_1 = __webpack_require__(575);
	var combustivel_api_service_1 = __webpack_require__(376);
	var util_service_1 = __webpack_require__(88);
	var combustivel_service_1 = __webpack_require__(576);
	var data_service_3 = __webpack_require__(398);
	var abastecimento_service_1 = __webpack_require__(546);
	var autocomplete_service_1 = __webpack_require__(101);
	var CombustivelFormComponent = (function () {
	    function CombustivelFormComponent(_route, _combustivelNavigationService, _combustivelApiService, _combustivelService, _utilService, _abastecimentoService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._combustivelNavigationService = _combustivelNavigationService;
	        this._combustivelApiService = _combustivelApiService;
	        this._combustivelService = _combustivelService;
	        this._utilService = _utilService;
	        this._abastecimentoService = _abastecimentoService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.abastecimentosRoute = data_service_3.abastecimentosRoute;
	        this.combustiveisModule = data_service_1.combustiveisModuleName;
	        this.formObject = new combustivel_model_1.Combustivel();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.module = data_service_3.abastecimentosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.ativo = new forms_1.FormControl('');
	        this.combustivel = new forms_1.FormControl('', forms_1.Validators.required);
	        this.codigoTCE = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseCombustivel = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            combustivel: this.combustivel,
	            codigoTCE: this.codigoTCE
	        });
	    }
	    CombustivelFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    CombustivelFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    CombustivelFormComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    CombustivelFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    CombustivelFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEditCombustivel(object);
	            }
	            else {
	                this.onAddCombustivel(object);
	            }
	        }
	    };
	    CombustivelFormComponent.prototype.onAddCombustivel = function (object) {
	        this._combustivelApiService.onPost(object, this.onDone);
	    };
	    CombustivelFormComponent.prototype.onEditCombustivel = function (object) {
	        this._combustivelApiService.onPut(object, this.onDone);
	    };
	    CombustivelFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum combustível encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._combustivelApiService.onGetById(id, onDone);
	    };
	    CombustivelFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.combustiveisStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.combustivel = newAutoComplete.combustivel;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    CombustivelFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._combustivelService.getSessionStorage();
	        this._combustivelService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    CombustivelFormComponent.prototype.setModelToForm = function () {
	    };
	    CombustivelFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._combustivelService.returnToOtherForm(this.otherForm, this.responseCombustivel);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    CombustivelFormComponent.prototype.goToList = function () {
	        this._combustivelNavigationService.goToList();
	    };
	    CombustivelFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    CombustivelFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    CombustivelFormComponent.prototype.setNewNormal = function () {
	    };
	    CombustivelFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    CombustivelFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    CombustivelFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(580),
	            styles: [__webpack_require__(581)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof combustivel_navigation_service_1.CombustivelNavigationService !== 'undefined' && combustivel_navigation_service_1.CombustivelNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof combustivel_api_service_1.CombustivelApiService !== 'undefined' && combustivel_api_service_1.CombustivelApiService) === 'function' && _c) || Object, (typeof (_d = typeof combustivel_service_1.CombustivelService !== 'undefined' && combustivel_service_1.CombustivelService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _f) || Object, (typeof (_g = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object])
	    ], CombustivelFormComponent);
	    return CombustivelFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.CombustivelFormComponent = CombustivelFormComponent;


/***/ },
/* 580 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{combustiveisModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{combustiveisModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{combustiveisModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !combustivel.valid && submitted}\">\n            <label for=\"combustivel\">Combustível <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!combustivel.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"combustivel\" placeholder=\"\" [(ngModel)]=\"formObject.combustivel\" formControlName=\"combustivel\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\">\n            <label for=\"codigoTCE\">Código TCE </label>\n            <div>\n                <input type=\"text\" id=\"codigoTCE\" placeholder=\"\" [(ngModel)]=\"formObject.codigoTCE\" formControlName=\"codigoTCE\">\n            </div>\n        </div>\n\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 581 */
551,
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LocaisComponent = (function () {
	    function LocaisComponent() {
	    }
	    LocaisComponent.prototype.ngOnInit = function () {
	    };
	    LocaisComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(583)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocaisComponent);
	    return LocaisComponent;
	}());
	exports.LocaisComponent = LocaisComponent;


/***/ },
/* 583 */
171,
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(398);
	var data_service_2 = __webpack_require__(401);
	var data_service_3 = __webpack_require__(400);
	var data_service_4 = __webpack_require__(377);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var combustivel_navigation_service_1 = __webpack_require__(575);
	var local_navigation_service_1 = __webpack_require__(545);
	var data_service_5 = __webpack_require__(404);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var data_service_6 = __webpack_require__(585);
	var tipo_ajuste_navigation_service_1 = __webpack_require__(586);
	var data_service_7 = __webpack_require__(178);
	var AbastecimentoConfiguracaoComponent = (function () {
	    function AbastecimentoConfiguracaoComponent(_bombaService, _combustivelService, _localService, _tanqueService, _tipoAjusteService) {
	        this._bombaService = _bombaService;
	        this._combustivelService = _combustivelService;
	        this._localService = _localService;
	        this._tanqueService = _tanqueService;
	        this._tipoAjusteService = _tipoAjusteService;
	        this.module = data_service_1.abastecimentosModuleName;
	        this.bombaModule = data_service_2.bombasModuleName;
	        this.tanqueModule = data_service_5.tanquesModuleName;
	        this.localModule = data_service_3.locaisModuleName;
	        this.combustivelModule = data_service_4.combustiveisModuleName;
	        this.tipoAjusteModule = data_service_6.tipoAjustesModuleName;
	        this.configuracaoModule = data_service_7.configuracaoModuleName;
	    }
	    AbastecimentoConfiguracaoComponent.prototype.ngOnInit = function () {
	    };
	    AbastecimentoConfiguracaoComponent.prototype.clickItem = function (module) {
	        if (module.plural === this.bombaModule.plural) {
	            this._bombaService.goToList();
	        }
	        else if (module.plural === this.tanqueModule.plural) {
	            this._tanqueService.goToList();
	        }
	        else if (module.plural === this.localModule.plural) {
	            this._localService.goToList();
	        }
	        else if (module.plural === this.combustivelModule.plural) {
	            this._combustivelService.goToList();
	        }
	        else if (module.plural === this.tipoAjusteModule.plural) {
	            this._tipoAjusteService.goToList();
	        }
	    };
	    AbastecimentoConfiguracaoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(587),
	            styles: [__webpack_require__(588)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof bomba_navigation_service_1.BombaNavigationService !== 'undefined' && bomba_navigation_service_1.BombaNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof combustivel_navigation_service_1.CombustivelNavigationService !== 'undefined' && combustivel_navigation_service_1.CombustivelNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof local_navigation_service_1.LocalNavigationService !== 'undefined' && local_navigation_service_1.LocalNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof tipo_ajuste_navigation_service_1.TipoAjusteNavigationService !== 'undefined' && tipo_ajuste_navigation_service_1.TipoAjusteNavigationService) === 'function' && _e) || Object])
	    ], AbastecimentoConfiguracaoComponent);
	    return AbastecimentoConfiguracaoComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AbastecimentoConfiguracaoComponent = AbastecimentoConfiguracaoComponent;


/***/ },
/* 585 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	exports.apiName = 'tipos-ajustes';
	exports.tipoAjustesRoute = 'tipo-ajustes';
	exports.tipoAjustesStorage = 'tipo-ajustes';
	exports.tipoAjustesModuleName = { plural: 'Tipos de ajustes', single: 'Tipo de ajuste' };
	exports.tipoAjustesQuery = {};


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(398);
	var data_service_3 = __webpack_require__(585);
	var TipoAjusteNavigationService = (function () {
	    function TipoAjusteNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    TipoAjusteNavigationService.prototype.goToList = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tipoAjustesRoute;
	        this._authService.navigateTo(router);
	    };
	    TipoAjusteNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tipoAjustesRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    TipoAjusteNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.abastecimentosRoute + '/' + data_service_3.tipoAjustesRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    TipoAjusteNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], TipoAjusteNavigationService);
	    return TipoAjusteNavigationService;
	    var _a;
	}());
	exports.TipoAjusteNavigationService = TipoAjusteNavigationService;


/***/ },
/* 587 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a class=\"active\">{{configuracaoModule.plural}}</a></li>\n    </ul>\n\n    <h1>Configurações de {{module.plural | lowercase}}</h1>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(bombaModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{bombaModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{bombaModule.plural | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(combustivelModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{combustivelModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{combustivelModule.plural | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(localModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{localModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{localModule.plural | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(tanqueModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{tanqueModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{tanqueModule.plural | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(tipoAjusteModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{tipoAjusteModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{tipoAjusteModule.plural | lowercase}}\n        </div>\n    </div>\n</div>";

/***/ },
/* 588 */
166,
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var TanquesComponent = (function () {
	    function TanquesComponent() {
	    }
	    TanquesComponent.prototype.ngOnInit = function () {
	    };
	    TanquesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(590)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TanquesComponent);
	    return TanquesComponent;
	}());
	exports.TanquesComponent = TanquesComponent;


/***/ },
/* 590 */
55,
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var tanque_list_component_1 = __webpack_require__(592);
	var tanque_form_component_1 = __webpack_require__(595);
	var tanque_estoque_list_component_1 = __webpack_require__(598);
	var data_service_2 = __webpack_require__(404);
	var tanque_movimentacao_detail_component_1 = __webpack_require__(601);
	var tanque_movimentacao_form_component_1 = __webpack_require__(604);
	var TanquesRoutingModule = (function () {
	    function TanquesRoutingModule() {
	    }
	    TanquesRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TanquesRoutingModule);
	    return TanquesRoutingModule;
	}());
	exports.TanquesRoutingModule = TanquesRoutingModule;
	exports.tanquesRoutes = [
	    {
	        path: '',
	        component: tanque_list_component_1.TanqueListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: tanque_form_component_1.TanqueFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: tanque_form_component_1.TanqueFormComponent
	    }, {
	        path: data_service_2.tanquesEstoqueRoute,
	        component: tanque_estoque_list_component_1.TanqueEstoqueListComponent
	    }, {
	        path: data_service_2.tanquesMovimentacaoRoute,
	        children: [
	            {
	                path: data_service_1.editRoute + '/:id',
	                component: tanque_movimentacao_form_component_1.TanqueMovimentacaoFormComponent
	            }, {
	                path: data_service_1.newRoute,
	                component: tanque_movimentacao_form_component_1.TanqueMovimentacaoFormComponent
	            }, {
	                path: data_service_1.detailRoute + '/:id',
	                component: tanque_movimentacao_detail_component_1.TanqueMovimentacaoDetailComponent,
	            }
	        ]
	    }
	];


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(404);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(398);
	var abastecimento_service_1 = __webpack_require__(546);
	var tanque_api_service_1 = __webpack_require__(416);
	var tanque_service_1 = __webpack_require__(405);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var data_service_3 = __webpack_require__(178);
	var TanqueListComponent = (function () {
	    function TanqueListComponent(_tanquesApiService, _tanqueService, _tanqueNavigationService, _utilService, _abastecimentoService) {
	        this._tanquesApiService = _tanquesApiService;
	        this._tanqueService = _tanqueService;
	        this._tanqueNavigationService = _tanqueNavigationService;
	        this._utilService = _utilService;
	        this._abastecimentoService = _abastecimentoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.tanquesModuleName = data_service_1.tanquesModuleName;
	        this.abastecimentosRoute = data_service_2.abastecimentosRoute;
	        this.module = data_service_2.abastecimentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	    }
	    TanqueListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    TanqueListComponent.prototype.clickNew = function () {
	        this._tanqueService.clearSessionStorage();
	        this._tanqueNavigationService.goToNew();
	    };
	    TanqueListComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    TanqueListComponent.prototype.clickEdit = function (item) {
	        this._tanqueService.clearSessionStorage();
	        this._tanqueNavigationService.goToEdit(item.id);
	    };
	    TanqueListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    TanqueListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._tanquesApiService.onGetAll(onDone);
	    };
	    TanqueListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._tanquesApiService.onDelete(item.id, onDone);
	    };
	    TanqueListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(593),
	            styles: [__webpack_require__(594)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof tanque_api_service_1.TanqueApiService !== 'undefined' && tanque_api_service_1.TanqueApiService) === 'function' && _a) || Object, (typeof (_b = typeof tanque_service_1.TanqueService !== 'undefined' && tanque_service_1.TanqueService) === 'function' && _b) || Object, (typeof (_c = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _e) || Object])
	    ], TanqueListComponent);
	    return TanqueListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.TanqueListComponent = TanqueListComponent;


/***/ },
/* 593 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{tanquesModuleName.plural}}</a></li>\n        </ul>\n\n        <h1>{{tanquesModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{tanquesModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Identificação</th>\n            <th>Combustível</th>\n            <th>Capacidade</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['identificacao', 'numeroPatrimonio', 'combustivel.combustivel', 'capacidade', 'local.nome'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.identificacao}}</td>\n            <td><span *ngIf=\"item.combustivel\">{{item.combustivel.combustivel}}</span></td>\n            <td>{{item.capacidade | literMask}} litros</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <p><strong>Nº do patrimônio: </strong>{{item.numeroPatrimonio}}<i *ngIf=\"!item.numeroPatrimonio\">não cadastrado</i></p>\n                <p><strong>Local: </strong><span *ngIf=\"item.local\">{{item.local.nome}}</span><i *ngIf=\"!item.local\">não cadastrado</i></p>\n                <p><strong>Alerta de atenção: </strong> <span *ngIf=\"item.statusAmarelo\">{{item.statusAmarelo}}%</span><i *ngIf=\"!item.statusAmarelo\">não cadastrado</i></p>\n                <p><strong>Alerta de emergência: </strong><span *ngIf=\"item.statusVermelho\">{{item.statusVermelho}}%</span><i *ngIf=\"!item.statusVermelho\">não cadastrado</i></p>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 594 */
166,
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(404);
	var tanque_model_1 = __webpack_require__(556);
	var data_service_2 = __webpack_require__(178);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var tanque_api_service_1 = __webpack_require__(416);
	var util_service_1 = __webpack_require__(88);
	var tanque_service_1 = __webpack_require__(405);
	var data_service_3 = __webpack_require__(398);
	var abastecimento_service_1 = __webpack_require__(546);
	var number_validation_1 = __webpack_require__(132);
	var combustivel_model_1 = __webpack_require__(412);
	var local_model_1 = __webpack_require__(414);
	var combustivel_api_service_1 = __webpack_require__(376);
	var local_api_service_1 = __webpack_require__(407);
	var autocomplete_service_1 = __webpack_require__(101);
	var combustivel_navigation_service_1 = __webpack_require__(575);
	var local_navigation_service_1 = __webpack_require__(545);
	var data_service_4 = __webpack_require__(377);
	var data_service_5 = __webpack_require__(400);
	var local_service_1 = __webpack_require__(399);
	var number_max_min_value_validation_1 = __webpack_require__(138);
	var TanqueFormComponent = (function () {
	    function TanqueFormComponent(_route, _tanqueNavigationService, _tanqueApiService, _tanqueService, _utilService, _abastecimentoService, _combustivelApiService, _localApiService, _autocompleteService, _combustivelNavigationService, _localNavigationService, _localService, _fb, _cdRef) {
	        this._route = _route;
	        this._tanqueNavigationService = _tanqueNavigationService;
	        this._tanqueApiService = _tanqueApiService;
	        this._tanqueService = _tanqueService;
	        this._utilService = _utilService;
	        this._abastecimentoService = _abastecimentoService;
	        this._combustivelApiService = _combustivelApiService;
	        this._localApiService = _localApiService;
	        this._autocompleteService = _autocompleteService;
	        this._combustivelNavigationService = _combustivelNavigationService;
	        this._localNavigationService = _localNavigationService;
	        this._localService = _localService;
	        this._fb = _fb;
	        this._cdRef = _cdRef;
	        this.abastecimentosRoute = data_service_3.abastecimentosRoute;
	        this.tanquesModule = data_service_1.tanquesModuleName;
	        this.formObject = new tanque_model_1.Tanque();
	        this.combustivelObject = new combustivel_model_1.Combustivel();
	        this.localObject = new local_model_1.Local();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.module = data_service_3.abastecimentosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.combustivelSelectId = 'combustivelSelect';
	        this.localSelectId = 'localSelect';
	        this.ativo = new forms_1.FormControl('');
	        this.identificacao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.numeroPatrimonio = new forms_1.FormControl('', forms_1.Validators.required);
	        this.capacidade = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, number_validation_1.NumberValidator.numberFormat]));
	        this.local = new forms_1.FormControl('', forms_1.Validators.required);
	        this.combustivel = new forms_1.FormControl('', forms_1.Validators.required);
	        this.statusAmarelo = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, number_max_min_value_validation_1.NumberMaxMinValueValidator.numberMaxMin(0, 100)]));
	        this.statusVermelho = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, number_max_min_value_validation_1.NumberMaxMinValueValidator.numberMaxMin(0, 100)]));
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                Response.combustivel = this.combustivelObject;
	                this.responseTanque = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            identificacao: this.identificacao,
	            numeroPatrimonio: this.numeroPatrimonio,
	            capacidade: this.capacidade,
	            local: this.local,
	            combustivel: this.combustivel,
	            statusVermelho: this.statusVermelho,
	            statusAmarelo: this.statusAmarelo
	        });
	    }
	    TanqueFormComponent.prototype.ngOnInit = function () {
	        this.combustivelQuery = this._utilService.cloneObject(data_service_4.combustiveisQuery);
	        this.localQuery = this._utilService.cloneObject(data_service_5.locaisQuery);
	        var tipoLocalInterno = this._localService.getTipoInterno();
	        this.tipoLocalInterno = tipoLocalInterno.Key;
	        this.localQuery.where.tipo = this.tipoLocalInterno;
	        this.isNewAutoComplete();
	    };
	    TanqueFormComponent.prototype.ngAfterViewChecked = function () {
	        this._cdRef.detectChanges();
	    };
	    TanqueFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    TanqueFormComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    TanqueFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    TanqueFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.combustivelObject.id) {
	                object.combustivelId = this.combustivelObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.localObject.id) {
	                object.localId = this.localObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.formObject.id) {
	                this.onEditTanque(object);
	            }
	            else {
	                this.onAddTanque(object);
	            }
	        }
	    };
	    TanqueFormComponent.prototype.getCombustivelObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.formObject;
	            thisFormObject.combustivel = this.combustivelObject;
	            thisFormObject.local = this.localObject;
	            this._tanqueService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                combustivel: object.text,
	                form: data_service_1.tanquesStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.combustiveisStorage);
	            this._combustivelNavigationService.goToNew();
	        }
	        else {
	            this.combustivelObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'combustivel', object);
	        }
	    };
	    TanqueFormComponent.prototype.getLocalObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.formObject;
	            thisFormObject.combustivel = this.combustivelObject;
	            thisFormObject.local = this.localObject;
	            this._tanqueService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                nome: object.text,
	                tipo: this.tipoLocalInterno,
	                form: data_service_1.tanquesStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_5.locaisStorage);
	            this._localNavigationService.goToNew();
	        }
	        else {
	            this.localObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'local', object);
	        }
	    };
	    TanqueFormComponent.prototype.onAddTanque = function (object) {
	        this._tanqueApiService.onPost(object, this.onDone);
	    };
	    TanqueFormComponent.prototype.onEditTanque = function (object) {
	        this._tanqueApiService.onPut(object, this.onDone);
	    };
	    TanqueFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum tanque encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._tanqueApiService.onGetById(id, onDone);
	    };
	    TanqueFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.tanquesStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.identificacao = newAutoComplete.identificacao;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    TanqueFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._tanqueService.getSessionStorage();
	        this._tanqueService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    TanqueFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.combustivel) {
	            this.combustivelObject = this.formObject.combustivel;
	            delete this.formObject['combustivel'];
	            var text = this._autocompleteService.getTextSelect2(this.combustivelObject, 'combustivel');
	            var selectObject = { text: text, id: this.combustivelObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.combustivelSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.combustivelSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'combustivel', this.combustivelObject);
	        }
	        if (this.formObject.local) {
	            this.localObject = this.formObject.local;
	            delete this.formObject['local'];
	            var text = this._autocompleteService.getTextSelect2(this.localObject, 'nome');
	            var selectObject = { text: text, id: this.localObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.localSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.localSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'local', this.localObject);
	        }
	    };
	    TanqueFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._tanqueService.returnToOtherForm(this.otherForm, this.responseTanque);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    TanqueFormComponent.prototype.goToList = function () {
	        this._tanqueNavigationService.goToList();
	    };
	    TanqueFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    TanqueFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    TanqueFormComponent.prototype.setNewNormal = function () {
	    };
	    TanqueFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    TanqueFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    TanqueFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(596),
	            styles: [__webpack_require__(597)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof tanque_api_service_1.TanqueApiService !== 'undefined' && tanque_api_service_1.TanqueApiService) === 'function' && _c) || Object, (typeof (_d = typeof tanque_service_1.TanqueService !== 'undefined' && tanque_service_1.TanqueService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _f) || Object, (typeof (_g = typeof combustivel_api_service_1.CombustivelApiService !== 'undefined' && combustivel_api_service_1.CombustivelApiService) === 'function' && _g) || Object, (typeof (_h = typeof local_api_service_1.LocalApiService !== 'undefined' && local_api_service_1.LocalApiService) === 'function' && _h) || Object, (typeof (_j = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _j) || Object, (typeof (_k = typeof combustivel_navigation_service_1.CombustivelNavigationService !== 'undefined' && combustivel_navigation_service_1.CombustivelNavigationService) === 'function' && _k) || Object, (typeof (_l = typeof local_navigation_service_1.LocalNavigationService !== 'undefined' && local_navigation_service_1.LocalNavigationService) === 'function' && _l) || Object, (typeof (_m = typeof local_service_1.LocalService !== 'undefined' && local_service_1.LocalService) === 'function' && _m) || Object, (typeof (_o = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _o) || Object, (typeof (_p = typeof core_1.ChangeDetectorRef !== 'undefined' && core_1.ChangeDetectorRef) === 'function' && _p) || Object])
	    ], TanqueFormComponent);
	    return TanqueFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
	}());
	exports.TanqueFormComponent = TanqueFormComponent;


/***/ },
/* 596 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{tanquesModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{tanquesModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{tanquesModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !identificacao.valid && submitted}\">\n            <label for=\"identificacao\">Identificação <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!identificacao.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"identificacao\" placeholder=\"\" [(ngModel)]=\"formObject.identificacao\" formControlName=\"identificacao\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !numeroPatrimonio.valid && submitted}\">\n            <label for=\"numeroPatrimonio\">Nº do patrimônio <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!numeroPatrimonio.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"numeroPatrimonio\" placeholder=\"\" [(ngModel)]=\"formObject.numeroPatrimonio\" formControlName=\"numeroPatrimonio\">\n            </div>\n        </div>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"combustivelSelect\"\n                                (setObejct)=\"getCombustivelObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"combustivelSelectId\"\n                                [model]=\"combustivelObject\"\n                                [_service]=\"_combustivelApiService\"\n                                [fieldToShow]=\"'combustivel'\"\n                                [query]=\"combustivelQuery\"\n                                [label]=\"'Combustível'\"></autocomplete-component>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!capacidade.valid && submitted) || (capacidade.errors && capacidade.errors.incorrectNumberFormat)}\">\n            <label for=\"capacidade\">Capacidade (litros) <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"(!capacidade.valid && submitted)\">Este campo é obrigatório / Formato incorreto.</span>\n                <input type=\"text\" id=\"capacidade\" [(ngModel)]=\"formObject.capacidade\" formControlName=\"capacidade\">\n            </div>\n        </div>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"localSelect\"\n                                (setObejct)=\"getLocalObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"localSelectId\"\n                                [model]=\"localObject\"\n                                [_service]=\"_localApiService\"\n                                [fieldToShow]=\"'nome'\"\n                                [query]=\"localQuery\"\n                                [label]=\"'Local'\"></autocomplete-component>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!statusAmarelo.valid && submitted)}\">\n            <label for=\"statusAmarelo\">Alarme de atenção (%) <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!statusVermelho.valid && statusVermelho.hasError('required')\">Este campo é obrigatório.</span>\n                <span class=\"error-alert\" *ngIf=\"!statusVermelho.valid && statusVermelho.hasError('incorrectMaxMinNumber')\"> {{statusVermelho.errors.incorrectMaxMinNumber}}</span>\n                <input type=\"text\" id=\"statusAmarelo\" [(ngModel)]=\"formObject.statusAmarelo\" formControlName=\"statusAmarelo\" appNumberInteger>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!statusVermelho.valid && submitted)}\">\n            <label for=\"statusVermelho\">Alarme de emergência (%) <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!statusVermelho.valid && statusVermelho.hasError('required')\">Este campo é obrigatório.</span>\n                <span class=\"error-alert\" *ngIf=\"!statusVermelho.valid && statusVermelho.hasError('incorrectMaxMinNumber')\"> {{statusVermelho.errors.incorrectMaxMinNumber}}</span>\n                <input type=\"text\" id=\"statusVermelho\" [(ngModel)]=\"formObject.statusVermelho\" formControlName=\"statusVermelho\" appNumberInteger>\n            </div>\n        </div>\n\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 597 */
166,
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(404);
	var tanque_api_service_1 = __webpack_require__(416);
	var tanque_service_1 = __webpack_require__(405);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var data_service_2 = __webpack_require__(398);
	var TanqueEstoqueListComponent = (function () {
	    function TanqueEstoqueListComponent(_tanquesApiService, _tanqueService, _tanqueNavigationService) {
	        this._tanquesApiService = _tanquesApiService;
	        this._tanqueService = _tanqueService;
	        this._tanqueNavigationService = _tanqueNavigationService;
	        this.list = [];
	        this.loading = true;
	        this.tanquesEstoqueModuleName = data_service_1.tanquesEstoqueModuleName;
	        this.tanquesModuleName = data_service_1.tanquesModuleName;
	        this.tabSelected = 'tanques';
	        this.module = data_service_2.abastecimentosModuleName;
	    }
	    TanqueEstoqueListComponent.prototype.ngOnInit = function () {
	        this.getByTanque();
	    };
	    TanqueEstoqueListComponent.prototype.clickNew = function () {
	        this._tanqueNavigationService.goToMovimentacaoNew();
	    };
	    TanqueEstoqueListComponent.prototype.clickDetail = function (item) {
	        this._tanqueNavigationService.goToMovimentacaoDetail(item.id);
	    };
	    TanqueEstoqueListComponent.prototype.setTab = function (tab) {
	        this.tabSelected = tab;
	        this.list = [];
	        this.loading = true;
	        if (tab === 'tanques') {
	            this.getByTanque();
	        }
	        else if (tab === 'areas') {
	            this.getByArea();
	        }
	        else if (tab === 'orgaos') {
	            this.getByOrgao();
	        }
	    };
	    TanqueEstoqueListComponent.prototype.isTab = function (tab) {
	        var isTab = (tab === this.tabSelected) ? true : false;
	        return isTab;
	    };
	    TanqueEstoqueListComponent.prototype.getByTanque = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.checkTanque(Response);
	            }
	            this.loading = false;
	        }.bind(this));
	        this._tanquesApiService.onGetEstoqueByTanque(onDone);
	    };
	    TanqueEstoqueListComponent.prototype.getByArea = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._tanquesApiService.onGetEstoqueByArea(onDone);
	    };
	    TanqueEstoqueListComponent.prototype.getByOrgao = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._tanquesApiService.onGetEstoqueByOrgao(onDone);
	    };
	    TanqueEstoqueListComponent.prototype.checkTanque = function (itens) {
	        var x, lenX, list = [], yellowState, redState;
	        for (x = 0, lenX = itens.length; x < lenX; x++) {
	            if (itens[x].ativo) {
	                if (itens[x].statusAmarelo) {
	                    yellowState = (itens[x].statusAmarelo / 100) * itens[x].capacidade;
	                }
	                else {
	                    yellowState = 0;
	                }
	                if (itens[x].statusVermelho) {
	                    redState = (itens[x].statusVermelho / 100) * itens[x].capacidade;
	                }
	                else {
	                    redState = 0;
	                }
	                if (itens[x].total <= redState) {
	                    itens[x].statusColor = 'red';
	                }
	                else if (itens[x].total <= yellowState) {
	                    itens[x].statusColor = 'yellow';
	                }
	                else {
	                    itens[x].statusColor = 'green';
	                }
	                list.push(itens[x]);
	            }
	        }
	        this.list = list;
	    };
	    TanqueEstoqueListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(599),
	            styles: [__webpack_require__(600)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof tanque_api_service_1.TanqueApiService !== 'undefined' && tanque_api_service_1.TanqueApiService) === 'function' && _a) || Object, (typeof (_b = typeof tanque_service_1.TanqueService !== 'undefined' && tanque_service_1.TanqueService) === 'function' && _b) || Object, (typeof (_c = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _c) || Object])
	    ], TanqueEstoqueListComponent);
	    return TanqueEstoqueListComponent;
	    var _a, _b, _c;
	}());
	exports.TanqueEstoqueListComponent = TanqueEstoqueListComponent;


/***/ },
/* 599 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">{{tanquesEstoqueModuleName.single}} de {{tanquesModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{tanquesEstoqueModuleName.single}} de {{tanquesModuleName.plural | lowercase}}</h1>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Nova movimentação</a>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <nav class=\"geo-tabs\">\n        <ul class=\"items\">\n            <li class=\"item\">\n                <a (click)=\"setTab('tanques')\" [ngClass]=\"{'active': isTab('tanques')}\" class=\"item-link\">Tanques</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('areas')\" [ngClass]=\"{'active': isTab('areas')}\" class=\"item-link\">Áreas</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('orgaos')\" [ngClass]=\"{'active': isTab('orgaos')}\" class=\"item-link\">Órgãos</a>\n            </li>\n        </ul>\n    </nav>\n\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{tanquesModuleName.single | lowercase}} cadastrado</p>\n\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('tanques')\">\n        <table *ngIf=\"list.length\">\n            <thead>\n            <tr>\n                <th>Identificação</th>\n                <th>Combustível</th>\n                <th>Quantidade atual</th>\n                <th>Status</th>\n            </tr>\n            </thead>\n            <tbody *ngFor=\"let item of(list | filter:listFilter.value:['identificacao', 'total', 'combustivel.combustivel'] | sort:['identificacao'])\">\n            <tr [ngClass]=\"{inative: !item.ativo}\">\n                <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.identificacao}}</a></td>\n                <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.combustivel\">{{item.combustivel.combustivel}}</span></a></td>\n                <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.total | literMask}} litros</a></td>\n                <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"> <div class=\"status\" [ngClass]=\"item.statusColor\"></div></a></td>\n            </tr>\n            </tbody>\n        </table>\n\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('areas')\">\n        <table *ngIf=\"list.length\">\n            <thead>\n            <tr>\n                <th>Área</th>\n            </tr>\n            </thead>\n            <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['nome'] | sort:['nome'])\">\n            <tr [ngClass]=\"{inative: !item.ativo}\">\n                <td><span class=\"geo-arrow\"></span>{{item.nome}}</td>\n            </tr>\n            <tr class=\"description\">\n                <td colspan=\"100%\">\n                    <p class=\"lead padding\" *ngIf=\"!item.Combustiveis.length && !loading\">Nenhum combustível</p>\n\n                    <table *ngIf=\"item.Combustiveis.length\">\n                        <thead>\n                        <tr>\n                            <th>Combustível</th>\n                            <th>Entrada</th>\n                            <th>Saída</th>\n                            <th>Total</th>\n                        </tr>\n                        </thead>\n                        <tbody *ngFor=\"let combustivel of(item.Combustiveis | filter:listFilter.value:['combustivel', 'total', 'entrada', 'saida'])\">\n                        <tr [ngClass]=\"{inative: !combustivel.ativo}\">\n                            <td>{{combustivel.combustivel}}</td>\n                            <td>{{combustivel.entrada | literMask}} litros</td>\n                            <td>{{combustivel.saida | literMask}} litros</td>\n                            <td>{{combustivel.total | literMask}} litros</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('orgaos')\">\n        <table *ngIf=\"list.length\">\n            <thead>\n            <tr>\n                <th>Órgão</th>\n                <th>CNPJ</th>\n                <th>Tipo</th>\n            </tr>\n            </thead>\n            <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['razaoSocial','cnpj','tipoOrgao.descricao','tipoOrgao.codigoTCE'] | sort:['razaoSocial'])\">\n            <tr [ngClass]=\"{inative: !item.ativo}\">\n                <td><span class=\"geo-arrow\"></span>{{item.razaoSocial}}</td>\n                <td>{{item.cnpj | cnpjMask}}</td>\n                <td><span *ngIf=\"item.tipoOrgao\"><span *ngIf=\"item.tipoOrgao.codigoTCE\">{{item.tipoOrgao.codigoTCE}} -</span> {{item.tipoOrgao.descricao}}</span></td>\n            </tr>\n            <tr class=\"description\">\n                <td colspan=\"100%\">\n                    <p class=\"lead padding\" *ngIf=\"!item.Combustiveis.length && !loading\">Nenhum combustível</p>\n\n                    <table *ngIf=\"item.Combustiveis.length\">\n                        <thead>\n                        <tr>\n                            <th>Combustível</th>\n                            <th>Entrada</th>\n                            <th>Saída</th>\n                            <th>Total</th>\n                        </tr>\n                        </thead>\n                        <tbody *ngFor=\"let combustivel of(item.Combustiveis | filter:listFilter.value:['combustivel', 'total', 'entrada', 'saida'])\">\n                        <tr [ngClass]=\"{inative: !combustivel.ativo}\">\n                            <td>{{combustivel.combustivel}}</td>\n                            <td>{{combustivel.entrada | literMask}} litros</td>\n                            <td>{{combustivel.saida | literMask}} litros</td>\n                            <td>{{combustivel.total | literMask}} litros</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n";

/***/ },
/* 600 */
/***/ function(module, exports) {

	module.exports = ".geo-content__row .geo-columns--4c {\n    width: 33.3%;\n}\n\n.tab {\n    background-color: #F8FAFB;\n    margin-top: 16px;\n    border: 1px solid rgba(0, 0, 0, 0.02);\n    padding: 0;\n}\n\n.tab-item {\n    text-align: center;\n}\n.tab-item p {\n    padding: 0 12px;\n    color: #BCC0C7;\n}\n.tab-item.active,\n.tab-item:hover {\n    border-bottom: 1px solid #4C87FF;\n    cursor: pointer;\n}\n.tab-item.active p,\n.tab-item:hover p {\n    color: #4C87FF;\n    font-size: 1em;\n    font-weight: 700;\n}\n\n.status {\n    width: 50%;\n    height: 15px;\n    border-radius: 2px;\n}\n.status.yellow {\n    background-color: #f0cc31;\n}\n.status.red {\n    background-color: #f83636;\n}\n.status.green {\n    background-color: #3ca63c;\n}\n\n\n@media screen and (max-width: 1200px) {\n    .geo-content__row .geo-columns--4c {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .geo-content__row .geo-columns--4c {\n        width: 100%;\n    }\n}"

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 27/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var data_service_1 = __webpack_require__(404);
	var tanque_api_service_1 = __webpack_require__(416);
	var util_service_1 = __webpack_require__(88);
	var tanque_service_1 = __webpack_require__(405);
	var area_api_service_1 = __webpack_require__(275);
	var bomba_api_service_1 = __webpack_require__(408);
	var filter_service_1 = __webpack_require__(94);
	var data_service_2 = __webpack_require__(398);
	var TanqueMovimentacaoDetailComponent = (function () {
	    function TanqueMovimentacaoDetailComponent(_tanqueNavigationService, _tanqueApiService, _utilService, _tanqueService, _areaApiService, _bombaApiService, _filterService, _route) {
	        this._tanqueNavigationService = _tanqueNavigationService;
	        this._tanqueApiService = _tanqueApiService;
	        this._utilService = _utilService;
	        this._tanqueService = _tanqueService;
	        this._areaApiService = _areaApiService;
	        this._bombaApiService = _bombaApiService;
	        this._filterService = _filterService;
	        this._route = _route;
	        this.detail = {};
	        this.list = [];
	        this.loading = true;
	        this.tanquesEstoqueModuleName = data_service_1.tanquesEstoqueModuleName;
	        this.tanquesModuleName = data_service_1.tanquesModuleName;
	        this.showDisabled = false;
	        this.areasList = [];
	        this.bombasList = [];
	        this.tipoLancamentosList = [];
	        this.periodosList = [];
	        this.periodoSearch = {};
	        this.bombaSearch = {};
	        this.areaSearch = {};
	        this.lancamentoSearch = {};
	        this.loadingBombas = true;
	        this.loadingAreas = true;
	        this.module = data_service_2.abastecimentosModuleName;
	        this.movimentacoesAreasList = [];
	        this.cloneList = [];
	    }
	    TanqueMovimentacaoDetailComponent.prototype.ngOnInit = function () {
	        var tipo = this._tanqueService.getTipoMovimentacaoEntrada();
	        this.tipoEntrada = tipo.Key;
	        tipo = this._tanqueService.getTipoMovimentacaoSaida();
	        this.tipoSaida = tipo.Key;
	        tipo = this._tanqueService.getTipoMovimentacaoEstorno();
	        this.tipoEstorno = tipo.Key;
	        tipo = this._tanqueService.getTipoMovimentacaoAjuste();
	        this.tipoAjuste = tipo.Key;
	        tipo = this._tanqueService.getTipoMovimentacaoTransferencia();
	        this.tipoTransferencia = tipo.Key;
	        this.tanqueId = +this._route.snapshot.params['id'];
	        this.getTanque();
	        this.getPeriodos();
	        this.getTiposLancamentos();
	        this.getAreas();
	        this.getBombas();
	    };
	    TanqueMovimentacaoDetailComponent.prototype.clickGoToEstoque = function () {
	        this._tanqueNavigationService.goToEstoque();
	    };
	    TanqueMovimentacaoDetailComponent.prototype.clickEdit = function (item) {
	        this._tanqueService.clearSessionStorage();
	        this._tanqueNavigationService.goToMovimentacaoEdit(item.id);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.changePeriodo = function () {
	        this.queryMovimentacoes();
	    };
	    TanqueMovimentacaoDetailComponent.prototype.changeLancamento = function () {
	        this.queryMovimentacoes();
	    };
	    TanqueMovimentacaoDetailComponent.prototype.changeArea = function () {
	        this.queryMovimentacoes();
	    };
	    TanqueMovimentacaoDetailComponent.prototype.changeBomba = function () {
	        this.queryMovimentacoes();
	    };
	    TanqueMovimentacaoDetailComponent.prototype.getTiposLancamentos = function () {
	        var list = this._utilService.cloneObject(data_service_1.TiposMovimentacoesTanques);
	        list.unshift({ Key: null, Value: '— Tipo de lançamento —' });
	        this.tipoLancamentosList = list;
	        this.lancamentoSearch = this.tipoLancamentosList[0];
	    };
	    TanqueMovimentacaoDetailComponent.prototype.getAreas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                list.unshift({ id: null, nome: '— Área —' });
	                this.areasList = list;
	                this.areaSearch = this.areasList[0];
	            }
	            this.loadingAreas = false;
	        }.bind(this));
	        this._areaApiService.onGetAll(onDone);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.getBombas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                list.unshift({ id: null, nome: '— Bomba —' });
	                this.bombasList = list;
	                this.bombaSearch = this.bombasList[0];
	            }
	            this.loadingBombas = false;
	        }.bind(this));
	        this._bombaApiService.onGetByTanque(this.tanqueId, onDone);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.getMovimentacoes = function (query) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.cloneList = this.formatMovimentacao(Response);
	                this.checkMovimentacoesAreas();
	            }
	            else {
	                this.loading = false;
	            }
	        }.bind(this));
	        this.list = [];
	        this.cloneList = [];
	        this.loading = true;
	        this._tanqueApiService.onGetByMovimentacaoFilter(query, onDone);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.getMovimentacoesAreas = function (query) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.movimentacoesAreasList = Response;
	                this.putAreasInMovimentacao();
	            }
	            this.loading = false;
	        }.bind(this));
	        this._tanqueApiService.onGetByMovimentacaoAreaFilter(query, onDone);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.getTanque = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.detail = Response;
	            }
	        }.bind(this));
	        this._tanqueApiService.onGetById(this.tanqueId, onDone);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.formatMovimentacao = function (list) {
	        var x, lenX, y, lenY, tiposMovimentacao = this._utilService.cloneObject(data_service_1.TiposMovimentacoesTanques);
	        for (x = 0, lenX = list.length; x < lenX; x++) {
	            for (y = 0, lenY = tiposMovimentacao.length; y < lenY; y++) {
	                if (list[x].tipoLancamento === tiposMovimentacao[y].Key) {
	                    list[x].tipoMovimentacao = tiposMovimentacao[y];
	                    break;
	                }
	            }
	        }
	        return list;
	    };
	    TanqueMovimentacaoDetailComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._tanqueApiService.onDeleteMovimentacao(item.id, onDone);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.getPeriodos = function () {
	        var list = [
	            { Key: 1, Value: 'Últimos 7 dias', days: 7 },
	            { Key: 2, Value: 'Últimos 30 dias', days: 30 },
	            { Key: 3, Value: 'Últimos 3 meses', days: 90 },
	        ];
	        this.periodosList = list;
	        this.periodoSearch = this.periodosList[0];
	        this.changePeriodo();
	    };
	    TanqueMovimentacaoDetailComponent.prototype.queryMovimentacoes = function () {
	        var query = { "order": "data DESC", "where": {} };
	        query.where = this.calcPeriodo(this.periodoSearch.days);
	        query.where.or = [{ tanqueId: this.tanqueId }, { tanqueDestinoId: this.tanqueId }];
	        if (this.bombaSearch.id) {
	            query.where.bombaId = this.bombaSearch.id;
	        }
	        if (this.lancamentoSearch.Key) {
	            query.where.tipoLancamento = this.lancamentoSearch.Key;
	        }
	        this.getMovimentacoes(query);
	    };
	    TanqueMovimentacaoDetailComponent.prototype.calcPeriodo = function (periodo) {
	        var currDate = new Date();
	        var currDay = currDate.getDate(), currMonth = currDate.getMonth(), currYear = currDate.getFullYear();
	        var currDate2 = new Date(currYear, currMonth, currDay);
	        var today = currDate.getDate();
	        var lastDate = new Date(currDate.getTime());
	        lastDate.setDate(today - periodo);
	        var lastDay = lastDate.getDate(), lastMonth = lastDate.getMonth(), lastYear = lastDate.getFullYear();
	        var lastDate2 = new Date(lastYear, lastMonth, lastDay);
	        //{"where":{"and":[{"data":{"gte":"2017-01-28T02:00:00.000Z"}},{"data":{"lte":"2017-01-30T02:00:00.000Z"}}]}}
	        return { "and": [{ "data": { "gte": lastDate2 } }, { "data": { "lte": currDate2 } }] };
	    };
	    TanqueMovimentacaoDetailComponent.prototype.checkMovimentacoesAreas = function () {
	        var x, lenX, list = [];
	        for (x = 0, lenX = this.cloneList.length; x < lenX; x++) {
	            list.push({ movimentacaoId: this.cloneList[x].id });
	        }
	        if (list.length) {
	            var query = { "where": { "or": list } };
	            this.getMovimentacoesAreas(query);
	        }
	        else {
	            this.movimentacoesAreasList = [];
	            this.putAreasInMovimentacao();
	        }
	    };
	    TanqueMovimentacaoDetailComponent.prototype.putAreasInMovimentacao = function () {
	        var areasMovimentacoes = this.movimentacoesAreasList;
	        if (this.areaSearch.id) {
	            //pega todas as areasmovimentacoes que sejam iguais a area q esta sendo filtrada
	            areasMovimentacoes = this._filterService.filterArray(this.movimentacoesAreasList, this.areaSearch.id, ["areaId"]);
	        }
	        ///coloca as areas nas movimentacoes
	        this.cloneList.forEach(function (item) {
	            item.areas = this._filterService.filterArray(areasMovimentacoes, item.id, ["movimentacaoId"]);
	        }.bind(this));
	        if (this.areaSearch.id) {
	            //remove todas as movimentacoes que nao tenham area
	            var x = void 0, lenX = void 0, list = this._utilService.cloneObject(this.cloneList), list2 = [];
	            for (x = 0, lenX = list.length; x < lenX; x++) {
	                if (list[x].areas.length || (list[x].areaId === this.areaSearch.id)) {
	                    list2.push(list[x]);
	                }
	            }
	            this.list = list2;
	        }
	        else {
	            this.list = this._utilService.cloneObject(this.cloneList);
	        }
	        this.loading = false;
	    };
	    TanqueMovimentacaoDetailComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(602),
	            styles: [__webpack_require__(603)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof tanque_api_service_1.TanqueApiService !== 'undefined' && tanque_api_service_1.TanqueApiService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof tanque_service_1.TanqueService !== 'undefined' && tanque_service_1.TanqueService) === 'function' && _d) || Object, (typeof (_e = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _e) || Object, (typeof (_f = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _f) || Object, (typeof (_g = typeof filter_service_1.FilterService !== 'undefined' && filter_service_1.FilterService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _h) || Object])
	    ], TanqueMovimentacaoDetailComponent);
	    return TanqueMovimentacaoDetailComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.TanqueMovimentacaoDetailComponent = TanqueMovimentacaoDetailComponent;


/***/ },
/* 602 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToEstoque()\" class=\"cursor-pointer\">{{tanquesEstoqueModuleName.single}} de {{tanquesModuleName.plural | lowercase}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{detail.identificacao}}</a></li>\n        </ul>\n        <h1>{{detail.identificacao}}</h1>\n        <p><strong>Combustível: </strong><span *ngIf=\"detail.combustivel\">{{detail.combustivel.combustivel}}</span> <i *ngIf=\"!detail.combustivel\">não cadastrado</i></p>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"periodo\" [(ngModel)]=\"periodoSearch\" (ngModelChange)=\"changePeriodo()\" class=\"option_{{periodoSearch.Key}}\">\n                    <option *ngFor=\"let item of periodosList\" id=\"periodo_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"tipoLancamento\" [(ngModel)]=\"lancamentoSearch\" (ngModelChange)=\"changeLancamento()\" class=\"option_{{lancamentoSearch.Key}}\">\n                    <option *ngFor=\"let item of tipoLancamentosList\" id=\"lancamento_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div class=\"containerSpinner\">\n                <select [(ngModel)]=\"areaSearch\" id=\"area\" (ngModelChange)=\"changeArea()\" class=\"option_{{areaSearch.id}}\">\n                    <option *ngFor=\"let item of areasList\" id=\"area_{{item.id}}\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.nome}}</option>\n                </select>\n                <spinner-component *ngIf=\"loadingAreas\"></spinner-component>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div class=\"containerSpinner\">\n                <select [(ngModel)]=\"bombaSearch\" id=\"bomba\" (ngModelChange)=\"changeBomba()\" class=\"option_{{bombaSearch.id}}\">\n                    <option *ngFor=\"let item of bombasList\" id=\"bomba_{{item.id}}\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.nome}}</option>\n                </select>\n                <spinner-component *ngIf=\"loadingBombas\"></spinner-component>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n\n    <div class=\"geo-columns--12c\">\n        <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n        <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma movimentação</p>\n    </div>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Tipo</th>\n            <th>Data</th>\n            <th>Quantidade</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>\n                <span class=\"geo-arrow\"></span>\n                <svg class='table-svg left' *ngIf=\"item.tipoLancamento === tipoSaida\"><use xlink:href='../../assets/images/icons/icons.svg#icon-arrow-left'/></svg>\n                <svg class='table-svg rotate-back' *ngIf=\"item.tipoLancamento === tipoEstorno\"><use xlink:href='../../assets/images/icons/icons.svg#icon-rotate-back'/></svg>\n                <svg class='table-svg up' *ngIf=\"item.tipoLancamento === tipoEntrada\"><use xlink:href='../../assets/images/icons/icons.svg#icon-arrow-up'/></svg>\n                <svg class='table-svg shuffle' *ngIf=\"item.tipoLancamento === tipoTransferencia\"><use xlink:href='../../assets/images/icons/icons.svg#icon-arrow-shuffle'/></svg>\n                <svg class='table-svg settings-gears' *ngIf=\"item.tipoLancamento === tipoAjuste\"><use xlink:href='../../assets/images/icons/icons.svg#icon-settings-gears'/></svg>\n                <span *ngIf=\"item.tipoMovimentacao\">{{item.tipoMovimentacao.Value}}</span>\n            </td>\n            <td>{{item.data | date:'dd/MM/yyyy'}}</td>\n            <td>{{item.quantidade  | literMask}} litros</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <p><strong>Combustível: </strong><span *ngIf=\"item.combustivel\">{{item.combustivel.combustivel}}</span><i *ngIf=\"!item.combustivel\">não cadastrado</i></p>\n                <p><strong>Responsável: </strong><span *ngIf=\"item.funcionario && item.funcionario.pessoa\">{{item.funcionario.pessoa.nome}}</span><i *ngIf=\"!item.funcionario || !item.funcionario.pessoa\">não cadastrado</i></p>\n                <p *ngIf=\"item.tipoLancamento === tipoTransferencia\">\n                    <span *ngIf=\"item.tanqueDestinoId !== tanqueId\"><strong>Tanque de destino: </strong><span *ngIf=\"item.tanqueDestino\">{{item.tanqueDestino.identificacao}}</span><i *ngIf=\"!item.tanqueDestino\">não cadastrado</i></span>\n                    <span *ngIf=\"item.tanqueDestinoId === tanqueId\"><strong>Tanque de origem: </strong><span *ngIf=\"item.tanque\">{{item.tanque.identificacao}}</span><i *ngIf=\"!item.tanque\">não cadastrado</i></span>\n                </p>\n                <p *ngFor=\"let area of item.areas\">\n                    <strong>Área: </strong><span *ngIf=\"area.area\">{{area.area.nome}}</span><i *ngIf=\"!area.area\">não cadastrado</i>\n                    <strong>&nbsp;&nbsp;&nbsp;&nbsp; quantidade: </strong><span *ngIf=\"area.quantidade\">{{area.quantidade | literMask}} litros</span> <i *ngIf=\"!area.quantidade\">não cadastrado</i>\n                </p>\n                <p *ngIf=\"item.tipoLancamento === tipoSaida\">\n                    <strong>Bomba: </strong><span *ngIf=\"item.bomba\">{{item.bomba.nome}}</span><i *ngIf=\"!item.bomba\">não cadastrado</i>\n                </p>\n                <p *ngIf=\"item.tipoLancamento === tipoAjuste\">\n                    <strong>Tipo de ajuste: </strong><span *ngIf=\"item.tipoAjuste\">{{item.tipoAjuste.tipo}}</span><i *ngIf=\"!item.tipoAjuste\">não cadastrado</i>\n                </p>\n                <p *ngIf=\"item.tipoLancamento === tipoEntrada\">\n                    <strong>AF: </strong> {{item.af}} <i *ngIf=\"!item.af\">não cadastrado</i>\n                </p>\n                <p *ngIf=\"item.tipoLancamento === tipoEntrada || item.tipoLancamento === tipoEstorno\">\n                    <strong>Nota fiscal: </strong> {{item.notaFiscal}} <i *ngIf=\"!item.notaFiscal\">não cadastrado</i>\n                </p>\n                <p *ngIf=\"item.tipoLancamento === tipoSaida || item.tipoLancamento === tipoEstorno\">\n                    <strong>Motivo: </strong> {{item.motivo}} <i *ngIf=\"!item.motivo\">não cadastrado</i>\n                </p>\n                <p><strong>Observação: </strong> {{item.observacao}} <i *ngIf=\"!item.observacao\">não cadastrado</i></p>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 603 */
/***/ function(module, exports) {

	module.exports = ".table-svg {\n    position: relative;\n    top: 7px;\n    margin-right: 8px;\n}\n.table-svg.left{\n    fill: #a55024;\n}\n.table-svg.down{\n    fill: #dfa71c;\n}\n.table-svg.up{\n    fill: #268d19;\n}\n.table-svg.shuffle{\n    fill: #f86015;\n}\n.table-svg.settings-gears {\n    fill: #f23147;\n}\n.table-svg.rotate-back {\n    fill: #55247d;\n}\n\ncontainerSpinner {\n    position: relative;\n}\n.containerSpinner spinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}"

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 27/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var data_service_1 = __webpack_require__(404);
	var data_service_2 = __webpack_require__(178);
	var tanque_model_1 = __webpack_require__(556);
	var funcionario_model_1 = __webpack_require__(183);
	var area_model_1 = __webpack_require__(274);
	var area_api_service_1 = __webpack_require__(275);
	var funcionario_api_service_1 = __webpack_require__(184);
	var tanque_api_service_1 = __webpack_require__(416);
	var data_service_3 = __webpack_require__(185);
	var data_service_4 = __webpack_require__(190);
	var util_service_1 = __webpack_require__(88);
	var tanque_service_1 = __webpack_require__(405);
	var funcionario_service_1 = __webpack_require__(214);
	var tipo_ajuste_api_service_1 = __webpack_require__(605);
	var tipo_ajuste_model_1 = __webpack_require__(606);
	var number_validation_1 = __webpack_require__(132);
	var bomba_model_1 = __webpack_require__(417);
	var bomba_api_service_1 = __webpack_require__(408);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_5 = __webpack_require__(398);
	var TanqueMovimentacaoFormComponent = (function () {
	    function TanqueMovimentacaoFormComponent(_utilService, _tanqueNavigationService, _tanqueApiService, _tanqueService, _areaApiService, _funcionarioApiService, _funcionarioService, _tipoAjusteApiService, _bombaApiService, _autocompleteService, _route, _fb, _cdRef) {
	        this._utilService = _utilService;
	        this._tanqueNavigationService = _tanqueNavigationService;
	        this._tanqueApiService = _tanqueApiService;
	        this._tanqueService = _tanqueService;
	        this._areaApiService = _areaApiService;
	        this._funcionarioApiService = _funcionarioApiService;
	        this._funcionarioService = _funcionarioService;
	        this._tipoAjusteApiService = _tipoAjusteApiService;
	        this._bombaApiService = _bombaApiService;
	        this._autocompleteService = _autocompleteService;
	        this._route = _route;
	        this._fb = _fb;
	        this._cdRef = _cdRef;
	        this.tanquesModuelName = data_service_1.tanquesModuleName;
	        this.tanquesEstoqueModuleName = data_service_1.tanquesEstoqueModuleName;
	        this.tanquesMovimentacaoModuleName = data_service_1.tanquesMovimentacaoModuleName;
	        this.formObject = new tanque_model_1.MovimentacaoTanque();
	        this.tanqueObject = new tanque_model_1.Tanque();
	        this.tanqueDestinoObject = new tanque_model_1.Tanque();
	        this.funcionarioObject = new funcionario_model_1.Funcionario();
	        this.areaObject = new area_model_1.Area();
	        this.tipoAjusteObject = new tipo_ajuste_model_1.TipoAjuste();
	        this.bombaObject = new bomba_model_1.Bomba();
	        this.lancamentoObject = {};
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showAreasMessage = false;
	        this.module = data_service_5.abastecimentosModuleName;
	        this.loadingSpinnerTanques = false;
	        this.tanquesList = [];
	        this.tanquesDestinoList = [];
	        this.tipoLancamentosList = [];
	        this.funcionarioSelectId = 'funcionarioSelect';
	        this.funcionarioQuery = {};
	        this.areaSelectId = 'areaSelect';
	        this.areaQuery = {};
	        this.loadingSpinnerTipoAjustes = false;
	        this.tipoAjustesList = [];
	        this.areasList = [];
	        this.loadingSpinnerBombas = false;
	        this.bombasList = [];
	        this.ativo = new forms_1.FormControl('');
	        this.data = new forms_1.FormControl('', forms_1.Validators.required);
	        this.quantidade = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, number_validation_1.NumberValidator.numberFormat]));
	        // odometroHorimetro = new FormControl('', Validators.required);
	        this.tipoLancamento = new forms_1.FormControl('', forms_1.Validators.required);
	        this.notaFiscal = new forms_1.FormControl('', forms_1.Validators.required);
	        this.af = new forms_1.FormControl('', forms_1.Validators.required);
	        // documento = new FormControl('', Validators.required);
	        this.observacao = new forms_1.FormControl('');
	        this.motivo = new forms_1.FormControl('', forms_1.Validators.required);
	        // bem = new FormControl('', Validators.required);
	        this.bomba = new forms_1.FormControl('', forms_1.Validators.required);
	        this.combustivel = new forms_1.FormControl('');
	        this.area = new forms_1.FormControl('', forms_1.Validators.required);
	        this.funcionario = new forms_1.FormControl('', forms_1.Validators.required);
	        this.local = new forms_1.FormControl('');
	        this.tanque = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tiposAjuste = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tanqueDestino = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tanquesListClone = [];
	        this.objectSend = new tanque_model_1.MovimentacaoTanque();
	        this.funcionarioTemplateResult = (function (state) {
	            return this._funcionarioService.templateResult(state, false);
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this.objectSend.id = Response.id;
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toGetOutOfHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            data: this.data,
	            quantidade: this.quantidade,
	            // odometroHorimetro: this.odometroHorimetro,
	            tipoLancamento: this.tipoLancamento,
	            notaFiscal: this.notaFiscal,
	            af: this.af,
	            // documento: this.documento,
	            observacao: this.observacao,
	            motivo: this.motivo,
	            // bem: this.bem,
	            bomba: this.bomba,
	            combustivel: this.combustivel,
	            area: this.area,
	            funcionario: this.funcionario,
	            local: this.local,
	            tanque: this.tanque,
	            tiposAjuste: this.tiposAjuste,
	            tanqueDestino: this.tanqueDestino
	        });
	    }
	    TanqueMovimentacaoFormComponent.prototype.ngOnInit = function () {
	        this.areaQuery = this._utilService.cloneObject(data_service_4.areasQuery);
	        this.funcionarioQuery = this._utilService.cloneObject(data_service_3.funcionariosQueryComPessoa);
	        this.tipoLancamentosList = this._utilService.cloneObject(data_service_1.TiposMovimentacoesTanques);
	        var tipo = this._tanqueService.getTipoMovimentacaoEntrada();
	        this.tipoEntrada = tipo.Key;
	        tipo = this._tanqueService.getTipoMovimentacaoSaida();
	        this.tipoSaida = tipo.Key;
	        tipo = this._tanqueService.getTipoMovimentacaoEstorno();
	        this.tipoEstorno = tipo.Key;
	        tipo = this._tanqueService.getTipoMovimentacaoAjuste();
	        this.tipoAjuste = tipo.Key;
	        tipo = this._tanqueService.getTipoMovimentacaoTransferencia();
	        this.tipoTransferencia = tipo.Key;
	        this._utilService.disabledFutureDates('data');
	        this.getTanques();
	        this.testNew();
	    };
	    TanqueMovimentacaoFormComponent.prototype.ngAfterViewChecked = function () {
	        this._cdRef.detectChanges();
	    };
	    TanqueMovimentacaoFormComponent.prototype.clickGoToEstoque = function () {
	        this.toGetOutOfHere();
	    };
	    TanqueMovimentacaoFormComponent.prototype.clickCancel = function () {
	        this.toGetOutOfHere();
	    };
	    TanqueMovimentacaoFormComponent.prototype.changeTipoLancamento = function () {
	        this.checkTipoLancamento();
	    };
	    TanqueMovimentacaoFormComponent.prototype.changeTanque = function () {
	        this.checkTipoLancamento();
	    };
	    TanqueMovimentacaoFormComponent.prototype.getAreaObject = function (object) {
	        this.areaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'area', object);
	    };
	    TanqueMovimentacaoFormComponent.prototype.getFuncionarioObject = function (object) {
	        this.funcionarioObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'funcionario', object);
	    };
	    TanqueMovimentacaoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (this.lancamentoObject.Key === this.tipoEntrada) {
	            this._utilService.setSelectOnFormControl(this.form, 'tiposAjuste', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'motivo', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'tanqueDestino', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'area', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'bomba', { id: -1 });
	        }
	        else if (this.lancamentoObject.Key === this.tipoSaida) {
	            this._utilService.setSelectOnFormControl(this.form, 'tiposAjuste', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'af', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'tanqueDestino', { id: -1 });
	        }
	        else if (this.lancamentoObject.Key === this.tipoEstorno) {
	            this._utilService.setSelectOnFormControl(this.form, 'tiposAjuste', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'tanqueDestino', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'motivo', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'area', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'bomba', { id: -1 });
	        }
	        else if (this.lancamentoObject.Key === this.tipoAjuste) {
	            this._utilService.setSelectOnFormControl(this.form, 'tanqueDestino', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'motivo', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'af', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'bomba', { id: -1 });
	        }
	        else if (this.lancamentoObject.Key === this.tipoTransferencia) {
	            this._utilService.setSelectOnFormControl(this.form, 'motivo', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'af', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'notaFiscal', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'tiposAjuste', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'bomba', { id: -1 });
	        }
	        if (this.lancamentoObject.Key === this.tipoEstorno ||
	            this.lancamentoObject.Key === this.tipoEntrada) {
	            var litros = this.quantidadeLitrosAreas();
	            if (!litros) {
	                return;
	            }
	        }
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.lancamentoObject && this.lancamentoObject.Key) {
	                object.tipoLancamento = this.lancamentoObject.Key;
	            }
	            if (this.funcionarioObject && this.funcionarioObject.id) {
	                object.funcionarioId = this.funcionarioObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.tanqueObject && this.tanqueObject.id) {
	                object.tanqueId = this.tanqueObject.id;
	                object.combustivelId = this.tanqueObject.combustivelId;
	                object.localId = this.tanqueObject.localId;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (object.quantidade == 0) {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            var date = document.getElementById('data');
	            if (date.value) {
	                object.data = this._utilService.convertStringToDate(date.value);
	            }
	            if (this.lancamentoObject.Key === this.tipoEntrada) {
	                if (!this.areasList.length) {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                if (object.quantidade < 0) {
	                    object.quantidade = object.quantidade * (-1);
	                }
	                delete object['motivo'];
	            }
	            else if (this.lancamentoObject.Key === this.tipoSaida) {
	                if (this.bombaObject && this.bombaObject.id) {
	                    object.bombaId = this.bombaObject.id;
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                if (object.quantidade < 0) {
	                    object.quantidade = object.quantidade * (-1);
	                }
	                delete object['notaFiscal'];
	                delete object['af'];
	            }
	            else if (this.lancamentoObject.Key === this.tipoEstorno) {
	                if (!this.areasList.length) {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                delete object['motivo'];
	            }
	            else if (this.lancamentoObject.Key === this.tipoAjuste) {
	                if (this.tipoAjusteObject && this.tipoAjusteObject.id) {
	                    object.tipoAjusteId = this.tipoAjusteObject.id;
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                delete object['notaFiscal'];
	                delete object['af'];
	                delete object['motivo'];
	            }
	            else if (this.lancamentoObject.Key === this.tipoTransferencia) {
	                if (this.tanqueDestinoObject && this.tanqueDestinoObject.id) {
	                    object.tanqueDestinoId = this.tanqueDestinoObject.id;
	                }
	                else {
	                    this.btnSaveDisabled = false;
	                    return false;
	                }
	                if (object.quantidade < 0) {
	                    object.quantidade = object.quantidade * (-1);
	                }
	                delete object['motivo'];
	                delete object['notaFiscal'];
	                delete object['af'];
	            }
	            if (this.lancamentoObject.Key === this.tipoEntrada || this.lancamentoObject.Key === this.tipoEstorno) {
	                object.Areas = this.sendAreas();
	            }
	            else {
	                object.Areas = [{
	                        quantidade: this.formObject.quantidade,
	                        areaId: this.areaObject.id
	                    }];
	            }
	            this.objectSend = object;
	            if (this.formObject.id) {
	                this.onEdit(object);
	            }
	            else {
	                this.onAdd(object);
	            }
	        }
	    };
	    TanqueMovimentacaoFormComponent.prototype.onAdd = function (object) {
	        this._tanqueApiService.onPostMovimentacao(object, this.onDone);
	    };
	    TanqueMovimentacaoFormComponent.prototype.onEdit = function (object) {
	        this._tanqueApiService.onPutMovimentacao(object, this.onDone);
	    };
	    TanqueMovimentacaoFormComponent.prototype.sendAreas = function () {
	        var obj, list = [], x, lenX;
	        for (x = 0, lenX = this.areasList.length; x < lenX; x++) {
	            obj = this.areasList[x];
	            if (obj.quantidade && obj.quantidade != 0 && obj.area) {
	                obj.areaId = obj.area.id;
	                delete obj['area'];
	                list.push(obj);
	            }
	        }
	        return list;
	    };
	    TanqueMovimentacaoFormComponent.prototype.testNew = function () {
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.setEditNormal(id);
	        }
	        else {
	            this.setNewNormal();
	        }
	        this.setActionTitle(id);
	    };
	    TanqueMovimentacaoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    TanqueMovimentacaoFormComponent.prototype.setNewNormal = function () {
	        this.setFirstLancamento();
	        this.formObject.data = this._utilService.convertDateToString(new Date());
	    };
	    TanqueMovimentacaoFormComponent.prototype.setEditNormal = function (id) {
	        this.getMovimentacao(id);
	    };
	    TanqueMovimentacaoFormComponent.prototype.getMovimentacao = function (movimentacaoId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	        }.bind(this));
	        this._tanqueApiService.onGetByMovimentacaoId(movimentacaoId, onDone);
	    };
	    TanqueMovimentacaoFormComponent.prototype.getTanques = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.tanquesList = list;
	                this.tanquesListClone = this._utilService.cloneObject(list);
	                this.loadingSpinnerTanques = false;
	                this.setFirstTanque();
	            }
	        }.bind(this));
	        this.loadingSpinnerTanques = true;
	        this._tanqueApiService.onGetAll(onDone);
	    };
	    TanqueMovimentacaoFormComponent.prototype.getTiposAjustes = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.tipoAjustesList = list;
	                this.loadingSpinnerTipoAjustes = false;
	                this.setFirstTipoAjuste();
	            }
	        }.bind(this));
	        this.loadingSpinnerTipoAjustes = true;
	        this._tipoAjusteApiService.onGetAll(onDone);
	    };
	    TanqueMovimentacaoFormComponent.prototype.getBombas = function (tanqueId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.bombasList = list;
	                this.loadingSpinnerBombas = false;
	                this.enabledBomba();
	                this.setFirstBomba();
	            }
	        }.bind(this));
	        this.loadingSpinnerBombas = true;
	        this._bombaApiService.onGetByTanque(tanqueId, onDone);
	    };
	    TanqueMovimentacaoFormComponent.prototype.getAreasMovimentacao = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.areasList = Response;
	            }
	        }.bind(this));
	        var query = { where: { movimentacaoId: this.formObject.id } };
	        this._tanqueApiService.onGetByMovimentacaoAreaFilter(query, onDone);
	    };
	    TanqueMovimentacaoFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.tipoLancamento) {
	            this.setFirstLancamento();
	            if (this.formObject.tipoLancamento === this.tipoEntrada ||
	                this.formObject.tipoLancamento === this.tipoEstorno) {
	                this.getAreasMovimentacao();
	            }
	        }
	        if (this.formObject.data) {
	            this.formObject.data = this._utilService.convertDateToString(this.formObject.data);
	        }
	        if (this.formObject.tanqueId) {
	            this.setFirstTanque();
	        }
	        if (this.formObject.combustivel) {
	            delete this.formObject['combustivel'];
	        }
	        if (this.formObject.local) {
	            delete this.formObject['local'];
	        }
	        if (this.formObject.funcionario) {
	            this.funcionarioObject = this.formObject.funcionario;
	            delete this.formObject['funcionario'];
	            var text = this._autocompleteService.getTextSelect2(this.funcionarioObject.pessoa, 'nome');
	            var selectObject = { text: text, id: this.funcionarioObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.funcionarioSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.funcionarioSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'funcionario', this.funcionarioObject);
	        }
	        if (this.formObject.area) {
	            this.areaObject = this.formObject.area;
	            delete this.formObject['area'];
	            var text = this._autocompleteService.getTextSelect2(this.areaObject, 'nome');
	            var selectObject_1 = { text: text, id: this.areaObject.id };
	            setTimeout(function () {
	                this._autocompleteService.createOptionOnSelect2(this.areaSelectId, selectObject_1);
	                this._autocompleteService.setValueOnSelect2(selectObject_1.id, this.areaSelectId);
	            }.bind(this));
	            this._utilService.setSelectOnFormControl(this.form, 'area', this.areaObject);
	        }
	    };
	    TanqueMovimentacaoFormComponent.prototype.setFirstTanque = function () {
	        if (this.formObject.id) {
	            var x = void 0, lenX = void 0;
	            for (x = 0, lenX = this.tanquesList.length; x < lenX; x++) {
	                if (this.tanquesList[x].id === this.formObject.tanqueId) {
	                    this.tanqueObject = this.tanquesList[x];
	                    break;
	                }
	            }
	            delete this.formObject['tanque'];
	            return;
	        }
	        this.tanqueObject = this.tanquesList[0];
	    };
	    TanqueMovimentacaoFormComponent.prototype.setFirstLancamento = function () {
	        if (this.formObject.id) {
	            var x = void 0, lenX = void 0;
	            for (x = 0, lenX = this.tipoLancamentosList.length; x < lenX; x++) {
	                if (this.tipoLancamentosList[x].Key === this.formObject.tipoLancamento) {
	                    this.lancamentoObject = this.tipoLancamentosList[x];
	                    break;
	                }
	            }
	            return;
	        }
	        this.lancamentoObject = this.tipoLancamentosList[0];
	    };
	    TanqueMovimentacaoFormComponent.prototype.setFirstTipoAjuste = function () {
	        if (this.formObject.id) {
	            var x = void 0, lenX = void 0;
	            for (x = 0, lenX = this.tipoAjustesList.length; x < lenX; x++) {
	                if (this.tipoAjustesList[x].id === this.formObject.tipoAjusteId) {
	                    this.tipoAjusteObject = this.tipoAjustesList[x];
	                    break;
	                }
	            }
	            delete this.formObject['tipoAjuste'];
	            return;
	        }
	        this.tipoAjusteObject = this.tipoAjustesList[0];
	    };
	    TanqueMovimentacaoFormComponent.prototype.setFirstBomba = function () {
	        if (this.formObject.id) {
	            var x = void 0, lenX = void 0;
	            for (x = 0, lenX = this.bombasList.length; x < lenX; x++) {
	                if (this.bombasList[x].id === this.formObject.bombaId) {
	                    this.bombaObject = this.bombasList[x];
	                    break;
	                }
	            }
	            delete this.formObject['bomba'];
	            return;
	        }
	        this.bombaObject = this.bombasList[0];
	    };
	    TanqueMovimentacaoFormComponent.prototype.checkTipoLancamento = function () {
	        if (this.lancamentoObject.Key === this.tipoEntrada) {
	        }
	        else if (this.lancamentoObject.Key === this.tipoSaida) {
	            this.disabledBomba();
	            this.getBombas(this.tanqueObject.id);
	        }
	        else if (this.lancamentoObject.Key === this.tipoEstorno) {
	        }
	        else if (this.lancamentoObject.Key === this.tipoAjuste) {
	            this.getTiposAjustes();
	        }
	        else if (this.lancamentoObject.Key === this.tipoTransferencia) {
	            this.disabledTanque();
	            this.setTanqueDestino();
	        }
	    };
	    TanqueMovimentacaoFormComponent.prototype.setTanqueDestino = function () {
	        var list = [], x, lenX;
	        for (x = 0, lenX = this.tanquesListClone.length; x < lenX; x++) {
	            if (this.tanquesListClone[x].id !== this.tanqueObject.id &&
	                this.tanquesListClone[x].combustivelId === this.tanqueObject.combustivelId) {
	                list.push(this.tanquesListClone[x]);
	            }
	        }
	        this.tanquesDestinoList = this._utilService.cloneObject(list);
	        this.enabledTanque();
	        if (this.formObject.id) {
	            var x_1, lenX_1;
	            for (x_1 = 0, lenX_1 = this.tanquesDestinoList.length; x_1 < lenX_1; x_1++) {
	                if (this.tanquesDestinoList[x_1].id === this.formObject.tanqueDestinoId) {
	                    this.tanqueDestinoObject = this.tanquesDestinoList[x_1];
	                    break;
	                }
	            }
	            delete this.formObject['tanqueDestino'];
	            return;
	        }
	        this.tanqueDestinoObject = this.tanquesDestinoList[0];
	    };
	    TanqueMovimentacaoFormComponent.prototype.enabledTanque = function () {
	        if (this.tanquesDestinoList.length) {
	            var element = this.form.controls['tanqueDestino'];
	            element.enable();
	        }
	    };
	    TanqueMovimentacaoFormComponent.prototype.disabledTanque = function () {
	        var element = this.form.controls['tanqueDestino'];
	        element.disable();
	    };
	    TanqueMovimentacaoFormComponent.prototype.enabledBomba = function () {
	        if (this.bombasList.length) {
	            var element = this.form.controls['bomba'];
	            element.enable();
	        }
	    };
	    TanqueMovimentacaoFormComponent.prototype.disabledBomba = function () {
	        var element = this.form.controls['bomba'];
	        element.disable();
	    };
	    TanqueMovimentacaoFormComponent.prototype.toGetOutOfHere = function () {
	        if (this.formObject.id) {
	            this._tanqueNavigationService.goToMovimentacaoDetail(this.formObject.tanqueId);
	        }
	        else {
	            this._tanqueNavigationService.goToEstoque();
	        }
	    };
	    TanqueMovimentacaoFormComponent.prototype.quantidadeLitrosAreas = function () {
	        var soma = 0, x, lenX;
	        for (x = 0, lenX = this.areasList.length; x < lenX; x++) {
	            if (this.areasList[x].quantidade) {
	                soma += this.areasList[x].quantidade;
	            }
	        }
	        if (soma != this.formObject.quantidade) {
	            this.showAreasMessage = true;
	            return false;
	        }
	        this.showAreasMessage = false;
	        return true;
	    };
	    TanqueMovimentacaoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(607),
	            styles: [__webpack_require__(608)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _a) || Object, (typeof (_b = typeof tanque_navigation_service_1.TanqueNavigationService !== 'undefined' && tanque_navigation_service_1.TanqueNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof tanque_api_service_1.TanqueApiService !== 'undefined' && tanque_api_service_1.TanqueApiService) === 'function' && _c) || Object, (typeof (_d = typeof tanque_service_1.TanqueService !== 'undefined' && tanque_service_1.TanqueService) === 'function' && _d) || Object, (typeof (_e = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _e) || Object, (typeof (_f = typeof funcionario_api_service_1.FuncionarioApiService !== 'undefined' && funcionario_api_service_1.FuncionarioApiService) === 'function' && _f) || Object, (typeof (_g = typeof funcionario_service_1.FuncionarioService !== 'undefined' && funcionario_service_1.FuncionarioService) === 'function' && _g) || Object, (typeof (_h = typeof tipo_ajuste_api_service_1.TipoAjusteApiService !== 'undefined' && tipo_ajuste_api_service_1.TipoAjusteApiService) === 'function' && _h) || Object, (typeof (_j = typeof bomba_api_service_1.BombaApiService !== 'undefined' && bomba_api_service_1.BombaApiService) === 'function' && _j) || Object, (typeof (_k = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _k) || Object, (typeof (_l = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _l) || Object, (typeof (_m = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _m) || Object, (typeof (_o = typeof core_1.ChangeDetectorRef !== 'undefined' && core_1.ChangeDetectorRef) === 'function' && _o) || Object])
	    ], TanqueMovimentacaoFormComponent);
	    return TanqueMovimentacaoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
	}());
	exports.TanqueMovimentacaoFormComponent = TanqueMovimentacaoFormComponent;


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(585);
	var rest_service_1 = __webpack_require__(26);
	var TipoAjusteApiService = (function () {
	    function TipoAjusteApiService(_restService) {
	        this._restService = _restService;
	    }
	    TipoAjusteApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    TipoAjusteApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    TipoAjusteApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    TipoAjusteApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "tipo" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    TipoAjusteApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    TipoAjusteApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    TipoAjusteApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], TipoAjusteApiService);
	    return TipoAjusteApiService;
	    var _a;
	}());
	exports.TipoAjusteApiService = TipoAjusteApiService;


/***/ },
/* 606 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var TipoAjuste = (function () {
	    function TipoAjuste() {
	    }
	    return TipoAjuste;
	}());
	exports.TipoAjuste = TipoAjuste;


/***/ },
/* 607 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToEstoque()\" class=\"cursor-pointer\">{{tanquesEstoqueModuleName.single}} de {{tanquesModuelName.plural | lowercase}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{tanquesMovimentacaoModuleName.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{tanquesMovimentacaoModuleName.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados da movimentação</h2>\n        <div class=\"geo-input--3c geo-input--datepicker\"  [ngClass]=\"{'geo-input--error': !data.value && submitted}\">\n            <label for=\"data\">Data <abbr>*</abbr></label>\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"data\" [(ngModel)]=\"formObject.data\" formControlName=\"data\" appDatepicker autocomplete=\"off\" />\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tanque.valid && submitted}\">\n            <label for=\"tanque\">Tanque <abbr>*</abbr></label>\n            <div class=\"containerSpinner\">\n                <span class=\"error-alert\" *ngIf=\"!tanque.valid && tanque.hasError('required')\">Este campo é obrigatório.</span>\n                <select id=\"tanque\" [(ngModel)]=\"tanqueObject\" formControlName=\"tanque\" (ngModelChange)=\"changeTanque()\">\n                    <option *ngFor=\"let item of tanquesList\" [ngValue]=\"item\">{{item.identificacao}} <span *ngIf=\"item.combustivel\">({{item.combustivel.combustivel}})</span></option>\n                </select>\n                <spinner-component *ngIf=\"loadingSpinnerTanques\"></spinner-component>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipoLancamento.valid && submitted}\">\n            <label for=\"tipoLancamento\">Tipo de lançamento <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!tipoLancamento.valid && tipoLancamento.hasError('required')\">Este campo é obrigatório.</span>\n                <select id=\"tipoLancamento\" [(ngModel)]=\"lancamentoObject\" formControlName=\"tipoLancamento\" (ngModelChange)=\"changeTipoLancamento()\">\n                    <option *ngFor=\"let item of tipoLancamentosList\" [ngValue]=\"item\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"funcionarioSelect\"\n                                (setObejct)=\"getFuncionarioObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"funcionarioSelectId\"\n                                [model]=\"funcionarioObject\"\n                                [_service]=\"_funcionarioApiService\"\n                                [templateResult]=\"funcionarioTemplateResult\"\n                                [apiCustom]=\"'/populado'\"\n                                [query]=\"funcionarioQuery\"\n                                [isCreateNew]=\"false\"\n                                [label]=\"'Responsável'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"areaSelect\" *ngIf=\"lancamentoObject.Key === tipoSaida || lancamentoObject.Key === tipoAjuste || lancamentoObject.Key === tipoTransferencia\"\n                                (setObejct)=\"getAreaObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"areaSelectId\"\n                                [model]=\"areaObject\"\n                                [_service]=\"_areaApiService\"\n                                [fieldToShow]=\"'nome'\"\n                                [query]=\"areaQuery\"\n                                [isCreateNew]=\"false\"\n                                [label]=\"'Área'\"></autocomplete-component>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tiposAjuste.valid && submitted}\" *ngIf=\"lancamentoObject.Key === tipoAjuste\">\n            <label for=\"tiposAjuste\">Tipo de ajuste <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!tiposAjuste.valid && tiposAjuste.hasError('required')\">Este campo é obrigatório.</span>\n                <select id=\"tiposAjuste\" [(ngModel)]=\"tipoAjusteObject\" formControlName=\"tiposAjuste\">\n                    <option *ngFor=\"let item of tipoAjustesList\" [ngValue]=\"item\">{{item.tipo}}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !af.valid && submitted}\" *ngIf=\"lancamentoObject.Key === tipoEntrada || lancamentoObject.Key === tipoEstorno\">\n            <label for=\"af\">AF <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!af.valid && af.hasError('required')\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"af\" [(ngModel)]=\"formObject.af\" formControlName=\"af\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !notaFiscal.valid && submitted}\" *ngIf=\"lancamentoObject.Key === tipoEntrada || lancamentoObject.Key === tipoEstorno\">\n            <label for=\"notaFiscal\">Nota fiscal <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!notaFiscal.valid && notaFiscal.hasError('required')\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"notaFiscal\" [(ngModel)]=\"formObject.notaFiscal\" formControlName=\"notaFiscal\" appNumberInteger>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tanqueDestino.valid && submitted}\" *ngIf=\"lancamentoObject.Key === tipoTransferencia\">\n            <label for=\"tanqueDestino\">Tanque de destino <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!tanqueDestino.valid && tanqueDestino.hasError('required')\">Este campo é obrigatório.</span>\n                <select id=\"tanqueDestino\" [(ngModel)]=\"tanqueDestinoObject\" formControlName=\"tanqueDestino\">\n                    <option *ngFor=\"let item of tanquesDestinoList\" [ngValue]=\"item\">{{item.identificacao}} <span *ngIf=\"item.combustivel\">({{item.combustivel.combustivel}})</span></option>\n                </select>\n            </div>\n            <span *ngIf=\"!tanquesDestinoList.length\" class=\"input-hint\">Nenhum tanque com o mesmo combustível</span>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !quantidade.valid && submitted}\" >\n            <label for=\"quantidade\">Quantidade (litros) <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!quantidade.valid && quantidade.hasError('required')\">Este campo é obrigatório.</span>\n                <span class=\"error-alert\" *ngIf=\"!quantidade.valid && quantidade.hasError('incorrectNumberFormat')\">Formato incorreto.</span>\n                <input type=\"number\" id=\"quantidade\" [(ngModel)]=\"formObject.quantidade\" formControlName=\"quantidade\">\n            </div>\n            <p class=\"hint\" *ngIf=\"lancamentoObject.Key === tipoAjuste || lancamentoObject.Key === tipoEstorno\">Valores negativos subtraem do tanque / Valores positivos adicionam ao tanque</p>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !bomba.valid && submitted}\" *ngIf=\"lancamentoObject.Key === tipoSaida\">\n            <label for=\"bomba\">Bomba <abbr>*</abbr></label>\n            <div class=\"container\">\n                <span class=\"error-alert\" *ngIf=\"!bomba.valid && bomba.hasError('required')\">Este campo é obrigatório.</span>\n                <select id=\"bomba\" [(ngModel)]=\"bombaObject\" formControlName=\"bomba\">\n                    <option *ngFor=\"let item of bombasList\" [ngValue]=\"item\">{{item.nome}} <span *ngIf=\"item.tanque && item.tanque.combustivel\">({{item.tanque.combustivel.combustivel}})</span></option>\n                </select>\n                <spinner-component *ngIf=\"loadingSpinnerBombas\"></spinner-component>\n            </div>\n            <span *ngIf=\"!bombasList.length\" class=\"input-hint\">Nenhuma bomba para o tanque selecionado</span>\n        </div>\n\n        <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !motivo.valid && submitted}\" *ngIf=\"lancamentoObject.Key === tipoSaida\">\n            <label for=\"motivo\">Motivo <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!motivo.valid && motivo.hasError('required')\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"motivo\" [(ngModel)]=\"formObject.motivo\" formControlName=\"motivo\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\">\n            <label for=\"observacao\">Observação</label>\n            <div>\n                <textarea id=\"observacao\" [(ngModel)]=\"formObject.observacao\" formControlName=\"observacao\"></textarea>\n            </div>\n        </div>\n    </div>\n\n    <app-tanque-movimentacao-area-form *ngIf=\"lancamentoObject.Key === tipoEntrada || lancamentoObject.Key === tipoEstorno\"\n                                       [list]=\"areasList\"\n                                       [showMessage]=\"showAreasMessage\"></app-tanque-movimentacao-area-form>\n\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 608 */
/***/ function(module, exports) {

	module.exports = ".containerSpinner {\n    position: relative;\n}\n\nspinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}\n\n.input-hint {\n    font-size: 12px;\n    position: absolute;\n}\n\np.hint {\n    font-size: 12px;\n    margin: 0;\n}"

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var TipoAjustesComponent = (function () {
	    function TipoAjustesComponent() {
	    }
	    TipoAjustesComponent.prototype.ngOnInit = function () {
	    };
	    TipoAjustesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(610)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TipoAjustesComponent);
	    return TipoAjustesComponent;
	}());
	exports.TipoAjustesComponent = TipoAjustesComponent;


/***/ },
/* 610 */
55,
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var tipo_ajuste_list_component_1 = __webpack_require__(612);
	var tipo_ajuste_form_component_1 = __webpack_require__(616);
	var TipoAjustesRoutingModule = (function () {
	    function TipoAjustesRoutingModule() {
	    }
	    TipoAjustesRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TipoAjustesRoutingModule);
	    return TipoAjustesRoutingModule;
	}());
	exports.TipoAjustesRoutingModule = TipoAjustesRoutingModule;
	exports.tipoAjustesRoutes = [
	    {
	        path: '',
	        component: tipo_ajuste_list_component_1.TipoAjusteListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: tipo_ajuste_form_component_1.TipoAjusteFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: tipo_ajuste_form_component_1.TipoAjusteFormComponent
	    }
	];


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(585);
	var util_service_1 = __webpack_require__(88);
	var abastecimento_service_1 = __webpack_require__(546);
	var tipo_ajuste_api_service_1 = __webpack_require__(605);
	var tipo_ajuste_service_1 = __webpack_require__(613);
	var tipo_ajuste_navigation_service_1 = __webpack_require__(586);
	var data_service_2 = __webpack_require__(398);
	var data_service_3 = __webpack_require__(178);
	var TipoAjusteListComponent = (function () {
	    function TipoAjusteListComponent(_tipoAjustesApiService, _tipoAjusteService, _tipoAjusteNavigationService, _utilService, _abastecimentoService) {
	        this._tipoAjustesApiService = _tipoAjustesApiService;
	        this._tipoAjusteService = _tipoAjusteService;
	        this._tipoAjusteNavigationService = _tipoAjusteNavigationService;
	        this._utilService = _utilService;
	        this._abastecimentoService = _abastecimentoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.tipoAjustesModuleName = data_service_1.tipoAjustesModuleName;
	        this.module = data_service_2.abastecimentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	    }
	    TipoAjusteListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    TipoAjusteListComponent.prototype.clickNew = function () {
	        this._tipoAjusteService.clearSessionStorage();
	        this._tipoAjusteNavigationService.goToNew();
	    };
	    TipoAjusteListComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    TipoAjusteListComponent.prototype.clickEdit = function (item) {
	        this._tipoAjusteService.clearSessionStorage();
	        this._tipoAjusteNavigationService.goToEdit(item.id);
	    };
	    TipoAjusteListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    TipoAjusteListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._tipoAjustesApiService.onGetAll(onDone);
	    };
	    TipoAjusteListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._tipoAjustesApiService.onDelete(item.id, onDone);
	    };
	    TipoAjusteListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(614),
	            styles: [__webpack_require__(615)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof tipo_ajuste_api_service_1.TipoAjusteApiService !== 'undefined' && tipo_ajuste_api_service_1.TipoAjusteApiService) === 'function' && _a) || Object, (typeof (_b = typeof tipo_ajuste_service_1.TipoAjusteService !== 'undefined' && tipo_ajuste_service_1.TipoAjusteService) === 'function' && _b) || Object, (typeof (_c = typeof tipo_ajuste_navigation_service_1.TipoAjusteNavigationService !== 'undefined' && tipo_ajuste_navigation_service_1.TipoAjusteNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _e) || Object])
	    ], TipoAjusteListComponent);
	    return TipoAjusteListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.TipoAjusteListComponent = TipoAjusteListComponent;


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(585);
	var TipoAjusteService = (function () {
	    function TipoAjusteService() {
	    }
	    //session
	    TipoAjusteService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.tipoAjustesStorage + '-new', object);
	    };
	    TipoAjusteService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.tipoAjustesStorage + "-new");
	        return JSON.parse(item);
	    };
	    TipoAjusteService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.tipoAjustesStorage + "-new");
	    };
	    TipoAjusteService.prototype.returnToOtherForm = function (otherForm, Response) {
	    };
	    TipoAjusteService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], TipoAjusteService);
	    return TipoAjusteService;
	}());
	exports.TipoAjusteService = TipoAjusteService;


/***/ },
/* 614 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{tipoAjustesModuleName.plural}}</a></li>\n        </ul>\n        <h1>{{tipoAjustesModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{tipoAjustesModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Tipo</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['tipo'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.tipo}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 615 */
166,
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(585);
	var tipo_ajuste_model_1 = __webpack_require__(606);
	var data_service_2 = __webpack_require__(178);
	var tipo_ajuste_navigation_service_1 = __webpack_require__(586);
	var tipo_ajuste_api_service_1 = __webpack_require__(605);
	var util_service_1 = __webpack_require__(88);
	var tipo_ajuste_service_1 = __webpack_require__(613);
	var abastecimento_service_1 = __webpack_require__(546);
	var data_service_3 = __webpack_require__(398);
	var TipoAjusteFormComponent = (function () {
	    function TipoAjusteFormComponent(_route, _TipoAjusteNavigationService, _TipoAjusteApiService, _TipoAjusteService, _utilService, _abastecimentoService, _fb) {
	        this._route = _route;
	        this._TipoAjusteNavigationService = _TipoAjusteNavigationService;
	        this._TipoAjusteApiService = _TipoAjusteApiService;
	        this._TipoAjusteService = _TipoAjusteService;
	        this._utilService = _utilService;
	        this._abastecimentoService = _abastecimentoService;
	        this._fb = _fb;
	        this.tipoAjustesModule = data_service_1.tipoAjustesModuleName;
	        this.formObject = new tipo_ajuste_model_1.TipoAjuste();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.module = data_service_3.abastecimentosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.ativo = new forms_1.FormControl('');
	        this.tipo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            tipo: this.tipo
	        });
	    }
	    TipoAjusteFormComponent.prototype.ngOnInit = function () {
	        this.testSession();
	    };
	    TipoAjusteFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    TipoAjusteFormComponent.prototype.clickGoToSettings = function () {
	        this._abastecimentoService.goToSetting();
	    };
	    TipoAjusteFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    TipoAjusteFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEditTipoAjuste(object);
	            }
	            else {
	                this.onAddTipoAjuste(object);
	            }
	        }
	    };
	    TipoAjusteFormComponent.prototype.onAddTipoAjuste = function (object) {
	        this._TipoAjusteApiService.onPost(object, this.onDone);
	    };
	    TipoAjusteFormComponent.prototype.onEditTipoAjuste = function (object) {
	        this._TipoAjusteApiService.onPut(object, this.onDone);
	    };
	    TipoAjusteFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum tipo de ajuste encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._TipoAjusteApiService.onGetById(id, onDone);
	    };
	    TipoAjusteFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._TipoAjusteService.getSessionStorage();
	        this._TipoAjusteService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    TipoAjusteFormComponent.prototype.setModelToForm = function () {
	    };
	    TipoAjusteFormComponent.prototype.toLeaveHere = function () {
	        this.goToList();
	    };
	    TipoAjusteFormComponent.prototype.goToList = function () {
	        this._TipoAjusteNavigationService.goToList();
	    };
	    TipoAjusteFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    TipoAjusteFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    TipoAjusteFormComponent.prototype.setNewNormal = function () {
	    };
	    TipoAjusteFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    TipoAjusteFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    TipoAjusteFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(617),
	            styles: [__webpack_require__(618)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof tipo_ajuste_navigation_service_1.TipoAjusteNavigationService !== 'undefined' && tipo_ajuste_navigation_service_1.TipoAjusteNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof tipo_ajuste_api_service_1.TipoAjusteApiService !== 'undefined' && tipo_ajuste_api_service_1.TipoAjusteApiService) === 'function' && _c) || Object, (typeof (_d = typeof tipo_ajuste_service_1.TipoAjusteService !== 'undefined' && tipo_ajuste_service_1.TipoAjusteService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof abastecimento_service_1.AbastecimentoService !== 'undefined' && abastecimento_service_1.AbastecimentoService) === 'function' && _f) || Object, (typeof (_g = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _g) || Object])
	    ], TipoAjusteFormComponent);
	    return TipoAjusteFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.TipoAjusteFormComponent = TipoAjusteFormComponent;


/***/ },
/* 617 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToSettings()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{tipoAjustesModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{tipoAjustesModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{tipoAjustesModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipo.valid && submitted}\">\n            <label for=\"tipo\">Tipo <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!tipo.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"tipo\" placeholder=\"\" [(ngModel)]=\"formObject.tipo\" formControlName=\"tipo\">\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 618 */
166,
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AbastecimentoBensComponent = (function () {
	    function AbastecimentoBensComponent() {
	    }
	    AbastecimentoBensComponent.prototype.ngOnInit = function () {
	    };
	    AbastecimentoBensComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(620)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AbastecimentoBensComponent);
	    return AbastecimentoBensComponent;
	}());
	exports.AbastecimentoBensComponent = AbastecimentoBensComponent;


/***/ },
/* 620 */
171,
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var abastecimento_bem_list_component_1 = __webpack_require__(394);
	var data_service_1 = __webpack_require__(178);
	var abastecimento_bem_form_component_1 = __webpack_require__(411);
	var AbastecimentoBensRoutingModule = (function () {
	    function AbastecimentoBensRoutingModule() {
	    }
	    AbastecimentoBensRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AbastecimentoBensRoutingModule);
	    return AbastecimentoBensRoutingModule;
	}());
	exports.AbastecimentoBensRoutingModule = AbastecimentoBensRoutingModule;
	exports.abastecimentoBensRoutes = [
	    {
	        path: '',
	        component: abastecimento_bem_list_component_1.AbastecimentoBemListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: abastecimento_bem_form_component_1.AbastecimentoBemFormComponent
	    }
	];


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(398);
	var AbastecimentoRelatorioComponent = (function () {
	    function AbastecimentoRelatorioComponent() {
	        this.module = data_service_1.abastecimentosModuleName;
	    }
	    AbastecimentoRelatorioComponent.prototype.ngOnInit = function () {
	    };
	    AbastecimentoRelatorioComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(623)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AbastecimentoRelatorioComponent);
	    return AbastecimentoRelatorioComponent;
	}());
	exports.AbastecimentoRelatorioComponent = AbastecimentoRelatorioComponent;


/***/ },
/* 623 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">Relatórios</a></li>\n        </ul>\n    </div>\n\n    <h1>Relatórios de {{module.plural | lowercase}}</h1>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c geo-card\" >\n        <div class=\"geo-card__title\">\n            <a>Relatório 1</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Relatório de abastecimentos\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" >\n        <div class=\"geo-card__title\">\n            <a>Relatório 2</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Relatório de abastecimentos\n        </div>\n    </div>\n</div>";

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(625);
	var auth_guard_service_1 = __webpack_require__(89);
	var pontos_component_1 = __webpack_require__(626);
	var pontos_routing_module_1 = __webpack_require__(628);
	var data_service_2 = __webpack_require__(202);
	var deslocamentos_component_1 = __webpack_require__(640);
	var deslocamentos_routing_module_1 = __webpack_require__(642);
	var viagem_configuracao_component_1 = __webpack_require__(663);
	var data_service_3 = __webpack_require__(178);
	var data_service_4 = __webpack_require__(458);
	var destinos_component_1 = __webpack_require__(668);
	var destinos_routing_module_1 = __webpack_require__(670);
	var data_service_5 = __webpack_require__(651);
	var passageiros_component_1 = __webpack_require__(678);
	var passageiros_routing_module_1 = __webpack_require__(680);
	var ViagensRoutingModule = (function () {
	    function ViagensRoutingModule() {
	    }
	    ViagensRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ViagensRoutingModule);
	    return ViagensRoutingModule;
	}());
	exports.ViagensRoutingModule = ViagensRoutingModule;
	exports.viagensRoutes = [
	    {
	        path: '',
	        redirectTo: '/' + data_service_1.pontosRoute,
	        pathMatch: 'full'
	    }, {
	        path: data_service_3.configuracaoRoute,
	        component: viagem_configuracao_component_1.ViagemConfiguracaoComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService]
	    }, {
	        path: data_service_3.configuracaoRoute + '/' + data_service_1.pontosRoute,
	        component: pontos_component_1.PontosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: pontos_routing_module_1.pontosRoutes
	    }, {
	        path: data_service_3.configuracaoRoute + '/' + data_service_5.passageirosRoute,
	        component: passageiros_component_1.PassageirosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: passageiros_routing_module_1.passageirosRoutes
	    }, {
	        path: data_service_3.configuracaoRoute + '/' + data_service_4.destinosRoute,
	        component: destinos_component_1.DestinosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: destinos_routing_module_1.destinosRoutes
	    }, {
	        path: data_service_2.deslocamentosRoute,
	        component: deslocamentos_component_1.DeslocamentosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: deslocamentos_routing_module_1.deslocamentosRoutes
	    }
	];
	exports.viagensVisitantesRoutes = [
	    {
	        path: data_service_2.deslocamentosRoute,
	        component: deslocamentos_component_1.DeslocamentosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: deslocamentos_routing_module_1.deslocamentosVisitanteRoutes
	    }
	];


/***/ },
/* 625 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'pontos';
	exports.pontosRoute = 'pontos';
	exports.pontosStorage = 'pontos';
	exports.pontosModuleName = { plural: 'Pontos', single: 'Ponto' };
	exports.apiNamePontosDeslocamento = 'pontos-deslocamentos';
	exports.pontosQuery = {
	    "where": {
	        "ativo": true,
	        "nome": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "nome"
	};
	exports.tiposPontos = [
	    { "Key": 1, "Value": "Partida" },
	    { "Key": 2, "Value": "Passagem" },
	    { "Key": 3, "Value": "Final" }
	];


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PontosComponent = (function () {
	    function PontosComponent() {
	    }
	    PontosComponent.prototype.ngOnInit = function () {
	    };
	    PontosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(627)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PontosComponent);
	    return PontosComponent;
	}());
	exports.PontosComponent = PontosComponent;


/***/ },
/* 627 */
171,
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var ponto_list_component_1 = __webpack_require__(629);
	var ponto_form_component_1 = __webpack_require__(636);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(457);
	var data_service_3 = __webpack_require__(625);
	var PontosRoutingModule = (function () {
	    function PontosRoutingModule() {
	    }
	    PontosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PontosRoutingModule);
	    return PontosRoutingModule;
	}());
	exports.PontosRoutingModule = PontosRoutingModule;
	exports.pontosRoutes = [
	    {
	        path: '',
	        component: ponto_list_component_1.PontoListComponent,
	        data: {
	            breadcrumb: data_service_2.viagensRoute + '/' + data_service_1.configuracaoRoute + '/' + data_service_3.pontosRoute
	        }
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: ponto_form_component_1.PontoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: ponto_form_component_1.PontoFormComponent
	    }
	];


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(625);
	var ponto_api_service_1 = __webpack_require__(630);
	var ponto_navigation_service_1 = __webpack_require__(631);
	var endereco_service_1 = __webpack_require__(229);
	var ponto_service_1 = __webpack_require__(632);
	var viagem_service_1 = __webpack_require__(633);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(457);
	var PontoListComponent = (function () {
	    function PontoListComponent(_pontosApiService, _pontoNavigationService, _pontoService, _enderecoService, _viagemService) {
	        this._pontosApiService = _pontosApiService;
	        this._pontoNavigationService = _pontoNavigationService;
	        this._pontoService = _pontoService;
	        this._enderecoService = _enderecoService;
	        this._viagemService = _viagemService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.pontosModuleName = data_service_1.pontosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.viagensModuleName;
	    }
	    PontoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    PontoListComponent.prototype.clickGoToConfig = function () {
	        this._viagemService.goToSetting();
	    };
	    PontoListComponent.prototype.clickNew = function () {
	        this._pontoService.clearSessionStorage();
	        this._pontoNavigationService.goToNew();
	    };
	    PontoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].endereco) {
	                        Response[x].address = this._enderecoService.getAddress(Response[x].endereco);
	                    }
	                }
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._pontosApiService.onGetAll(onDone);
	    };
	    PontoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(634),
	            styles: [__webpack_require__(635)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ponto_api_service_1.PontoApiService !== 'undefined' && ponto_api_service_1.PontoApiService) === 'function' && _a) || Object, (typeof (_b = typeof ponto_navigation_service_1.PontoNavigationService !== 'undefined' && ponto_navigation_service_1.PontoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof ponto_service_1.PontoService !== 'undefined' && ponto_service_1.PontoService) === 'function' && _c) || Object, (typeof (_d = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _d) || Object, (typeof (_e = typeof viagem_service_1.ViagemService !== 'undefined' && viagem_service_1.ViagemService) === 'function' && _e) || Object])
	    ], PontoListComponent);
	    return PontoListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.PontoListComponent = PontoListComponent;


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(625);
	var PontoApiService = (function () {
	    function PontoApiService(_restService) {
	        this._restService = _restService;
	    }
	    PontoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    PontoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    PontoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    PontoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "descricao", "include": [{ "endereco": [{ "cidade": "estado" }, "tipoLogradouro"] }] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    PontoApiService.prototype.onGetAllActive = function (done) {
	        var filter = { "where": { "ativo": true }, "order": "nome" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    PontoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": [{ "endereco": [{ "cidade": "estado" }, "tipoLogradouro"] }] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    PontoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //pontos deslocamentos
	    PontoApiService.prototype.onPostPontoDeslocamento = function (object, done) {
	        this._restService.onPost(data_service_1.apiNamePontosDeslocamento, object, done);
	    };
	    PontoApiService.prototype.onPutPontoDeslocamento = function (object, done) {
	        this._restService.onPut(data_service_1.apiNamePontosDeslocamento, object, done);
	    };
	    PontoApiService.prototype.onDeletePontoDeslocamento = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiNamePontosDeslocamento, objectId, done);
	    };
	    PontoApiService.prototype.onGetPontoDeslocamento = function (filter, done) {
	        filter.include = ["deslocamento", "ponto"];
	        this._restService.onGetPost(data_service_1.apiNamePontosDeslocamento, filter, done);
	    };
	    PontoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], PontoApiService);
	    return PontoApiService;
	    var _a;
	}());
	exports.PontoApiService = PontoApiService;


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(625);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(457);
	var PontoNavigationService = (function () {
	    function PontoNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.pontosRoute;
	        this.fatherRouter = data_service_3.viagensRoute;
	        this.configuracaoRoute = data_service_2.configuracaoRoute;
	    }
	    PontoNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    PontoNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    PontoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    PontoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], PontoNavigationService);
	    return PontoNavigationService;
	    var _a;
	}());
	exports.PontoNavigationService = PontoNavigationService;


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(625);
	var PontoService = (function () {
	    function PontoService() {
	    }
	    //session
	    PontoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.pontosStorage + '-new', object);
	    };
	    PontoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.pontosStorage + "-new");
	        return JSON.parse(item);
	    };
	    PontoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.pontosStorage + "-new");
	    };
	    PontoService.prototype.checkTipo = function (tipo) {
	        var tipos = data_service_1.tiposPontos;
	        var x, lenX;
	        for (x = 0, lenX = tipos.length; x < lenX; x++) {
	            if (tipo === tipos[x].Key) {
	                tipo = tipos[x];
	                break;
	            }
	        }
	        return tipo;
	    };
	    PontoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], PontoService);
	    return PontoService;
	}());
	exports.PontoService = PontoService;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(457);
	var auth_service_1 = __webpack_require__(61);
	var ViagemService = (function () {
	    function ViagemService(_authService) {
	        this._authService = _authService;
	    }
	    ViagemService.prototype.goToSetting = function () {
	        var router = data_service_1.viagensRoute + '/configuracoes';
	        this._authService.navigateTo(router);
	    };
	    ViagemService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ViagemService);
	    return ViagemService;
	    var _a;
	}());
	exports.ViagemService = ViagemService;


/***/ },
/* 634 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{pontosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>{{pontosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n\n<div class=\"geo-content__row\" *ngIf=\"loading\">\n    <spinner-component [showDisplay]=\"true\"></spinner-component>\n</div>\n\n<app-ponto-table [list]=\"list\"\n                 [listFilter]=\"listFilter\"\n                 [loading]=\"loading\"\n                 [showDisabled]=\"showDisabled\"></app-ponto-table>\n\n";

/***/ },
/* 635 */
166,
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(625);
	var ponto_model_1 = __webpack_require__(637);
	var data_service_2 = __webpack_require__(178);
	var ponto_navigation_service_1 = __webpack_require__(631);
	var ponto_api_service_1 = __webpack_require__(630);
	var ponto_service_1 = __webpack_require__(632);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var endereco_model_1 = __webpack_require__(240);
	var endereco_service_1 = __webpack_require__(229);
	var data_service_3 = __webpack_require__(457);
	var viagem_service_1 = __webpack_require__(633);
	var PontoFormComponent = (function () {
	    function PontoFormComponent(_route, _pontoNavigationService, _pontoApiService, _pontoService, _enderecoService, _utilService, _autocompleteService, _viagemService, _fb) {
	        this._route = _route;
	        this._pontoNavigationService = _pontoNavigationService;
	        this._pontoApiService = _pontoApiService;
	        this._pontoService = _pontoService;
	        this._enderecoService = _enderecoService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._viagemService = _viagemService;
	        this._fb = _fb;
	        this.pontosModule = data_service_1.pontosModuleName;
	        this.formObject = new ponto_model_1.Ponto();
	        this.formObjectToSave = new ponto_model_1.Ponto();
	        this.enderecoObject = new endereco_model_1.Endereco();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showAddress = false;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.viagensModuleName;
	        this.ativo = new forms_1.FormControl('');
	        this.nome = new forms_1.FormControl('', forms_1.Validators.required);
	        this.descricao = new forms_1.FormControl('');
	        this.endereco = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDoneEndereco = (function (Response) {
	            if (!Response.error) {
	                this.formObjectToSave.enderecoId = Response.id;
	                if (this.formObject.id) {
	                    this.onEditPonto();
	                }
	                else {
	                    this.onAddPonto();
	                }
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responsePonto = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            nome: this.nome,
	            descricao: this.descricao,
	            endereco: this.endereco
	        });
	    }
	    PontoFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    PontoFormComponent.prototype.clickGoToConfig = function () {
	        this._viagemService.goToSetting();
	    };
	    PontoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    PontoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    PontoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            this.formObjectToSave = this._utilService.cloneObject(this.formObject);
	            this._enderecoService.onSubmit(this.enderecoObject, this.onDoneEndereco);
	        }
	    };
	    PontoFormComponent.prototype.onAddPonto = function () {
	        this._pontoApiService.onPost(this.formObjectToSave, this.onDone);
	    };
	    PontoFormComponent.prototype.onEditPonto = function () {
	        this._pontoApiService.onPut(this.formObjectToSave, this.onDone);
	    };
	    PontoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum ponto encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._pontoApiService.onGetById(id, onDone);
	    };
	    PontoFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._pontoService.getSessionStorage();
	        this._pontoService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    PontoFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.endereco) {
	            this.enderecoObject = this.formObject.endereco;
	            delete this.formObject['endereco'];
	        }
	        this.showAddress = true;
	    };
	    PontoFormComponent.prototype.toLeaveHere = function () {
	        this.goToList();
	    };
	    PontoFormComponent.prototype.goToList = function () {
	        this._pontoNavigationService.goToList();
	    };
	    PontoFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.pontosStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.nome = newAutoComplete.nome;
	            this.setActionTitle(this.formObject.id);
	            this.showAddress = true;
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    PontoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    PontoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    PontoFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	        this.showAddress = true;
	    };
	    PontoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(638),
	            styles: [__webpack_require__(639)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof ponto_navigation_service_1.PontoNavigationService !== 'undefined' && ponto_navigation_service_1.PontoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof ponto_api_service_1.PontoApiService !== 'undefined' && ponto_api_service_1.PontoApiService) === 'function' && _c) || Object, (typeof (_d = typeof ponto_service_1.PontoService !== 'undefined' && ponto_service_1.PontoService) === 'function' && _d) || Object, (typeof (_e = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object, (typeof (_g = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _g) || Object, (typeof (_h = typeof viagem_service_1.ViagemService !== 'undefined' && viagem_service_1.ViagemService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], PontoFormComponent);
	    return PontoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.PontoFormComponent = PontoFormComponent;


/***/ },
/* 637 */
/***/ function(module, exports) {

	"use strict";
	var Ponto = (function () {
	    function Ponto() {
	    }
	    return Ponto;
	}());
	exports.Ponto = Ponto;
	var PontoDeslocamento = (function () {
	    function PontoDeslocamento() {
	    }
	    return PontoDeslocamento;
	}());
	exports.PontoDeslocamento = PontoDeslocamento;


/***/ },
/* 638 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{pontosModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{pontosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{pontosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados do {{pontosModule.single | lowercase}}</h2>\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !nome.valid && submitted}\">\n            <label for=\"nome\">Título / Ref. <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!nome.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"nome\"[(ngModel)]=\"formObject.nome\" formControlName=\"nome\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\">\n            <label for=\"descricao\">Observação </label>\n            <div>\n                <textarea id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\"></textarea>\n            </div>\n        </div>\n    </div>\n\n    <app-endereco-form [formObject]=\"enderecoObject\" *ngIf=\"showAddress\"></app-endereco-form>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 639 */
551,
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var DeslocamentosComponent = (function () {
	    function DeslocamentosComponent() {
	    }
	    DeslocamentosComponent.prototype.ngOnInit = function () {
	    };
	    DeslocamentosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(641)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DeslocamentosComponent);
	    return DeslocamentosComponent;
	}());
	exports.DeslocamentosComponent = DeslocamentosComponent;


/***/ },
/* 641 */
171,
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var deslocamento_list_component_1 = __webpack_require__(643);
	var deslocamento_form_component_1 = __webpack_require__(647);
	var data_service_1 = __webpack_require__(178);
	var delocamento_detail_component_1 = __webpack_require__(657);
	var deslocamento_history_component_1 = __webpack_require__(454);
	var deslocamento_calendar_component_1 = __webpack_require__(660);
	var DeslocamentosRoutingModule = (function () {
	    function DeslocamentosRoutingModule() {
	    }
	    DeslocamentosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DeslocamentosRoutingModule);
	    return DeslocamentosRoutingModule;
	}());
	exports.DeslocamentosRoutingModule = DeslocamentosRoutingModule;
	exports.deslocamentosRoutes = [
	    {
	        path: '',
	        component: deslocamento_list_component_1.DeslocamentoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: deslocamento_form_component_1.DeslocamentoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: deslocamento_form_component_1.DeslocamentoFormComponent
	    }, {
	        path: data_service_1.detailRoute + '/:id',
	        component: delocamento_detail_component_1.DelocamentoDetailComponent
	    }, {
	        path: 'historico',
	        component: deslocamento_history_component_1.DeslocamentoHistoryComponent
	    }, {
	        path: 'agenda',
	        component: deslocamento_calendar_component_1.DeslocamentoCalendarComponent
	    }
	];
	exports.deslocamentosVisitanteRoutes = [
	    {
	        path: '',
	        component: deslocamento_list_component_1.DeslocamentoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: deslocamento_form_component_1.DeslocamentoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: deslocamento_form_component_1.DeslocamentoFormComponent
	    }, {
	        path: data_service_1.detailRoute + '/:id',
	        component: delocamento_detail_component_1.DelocamentoDetailComponent
	    },
	];


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(202);
	var deslocamento_api_service_1 = __webpack_require__(455);
	var deslocamento_navigation_service_1 = __webpack_require__(644);
	var util_service_1 = __webpack_require__(88);
	var deslocamento_service_1 = __webpack_require__(456);
	var funcionario_service_1 = __webpack_require__(214);
	var data_service_2 = __webpack_require__(185);
	var funcionario_api_service_1 = __webpack_require__(184);
	var autocomplete_service_1 = __webpack_require__(101);
	var usuario_service_1 = __webpack_require__(85);
	var data_service_3 = __webpack_require__(457);
	var DeslocamentoListComponent = (function () {
	    function DeslocamentoListComponent(_deslocamentosApiService, _deslocamentoNavigationService, _deslocamentoService, _utilService, _usuarioService, _funcionarioService, _funcionarioApiService, _autocompleteService) {
	        this._deslocamentosApiService = _deslocamentosApiService;
	        this._deslocamentoNavigationService = _deslocamentoNavigationService;
	        this._deslocamentoService = _deslocamentoService;
	        this._utilService = _utilService;
	        this._usuarioService = _usuarioService;
	        this._funcionarioService = _funcionarioService;
	        this._funcionarioApiService = _funcionarioApiService;
	        this._autocompleteService = _autocompleteService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.deslocamentosModuleName = data_service_1.deslocamentosModuleName;
	        this.module = data_service_3.viagensModuleName;
	        this.funcionarioSearch = {};
	        this.funcionarioSelectId = 'funcionario';
	        this.funcionarioQuery = {};
	        this.tipoSearch = {};
	        this.tiposList = [];
	        this.statusSearch = {};
	        this.statusList = [];
	        this.periodoSearch = {};
	        this.periodosList = [];
	        this.isVisitor = false;
	        this.funcionarioTemplateResult = (function (state) {
	            var template = this._funcionarioService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].tipo = this._deslocamentoService.getTipo(Response[x].tipo);
	                    Response[x].status = this._deslocamentoService.getStatus(Response[x].status);
	                }
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	    }
	    DeslocamentoListComponent.prototype.ngOnInit = function () {
	        this.isVisitor = this._usuarioService.checkIsVisitor();
	        this.funcionarioQuery = this._utilService.cloneObject(data_service_2.funcionariosQueryComPessoa);
	        this.getTipos();
	        this.getStatus();
	        this.clickClearSearch();
	        var datePicker = $('.input-datepicker');
	        var t = this;
	        datePicker.datepicker({
	            onSelect: function (e) {
	                t.changeData();
	            }
	        });
	    };
	    DeslocamentoListComponent.prototype.clickNew = function () {
	        this._deslocamentoNavigationService.goToNew();
	    };
	    DeslocamentoListComponent.prototype.changeData = function () {
	        this.list = [];
	        this.queryMovimentacoes();
	    };
	    DeslocamentoListComponent.prototype.changeTipo = function () {
	        this.queryMovimentacoes();
	    };
	    DeslocamentoListComponent.prototype.changeStatus = function () {
	        this.queryMovimentacoes();
	    };
	    DeslocamentoListComponent.prototype.clickClearSearch = function () {
	        this.periodoSearch = this.periodosList[0];
	        this.tipoSearch = this.tiposList[0];
	        this.funcionarioSearch = {};
	        var date = document.getElementById('data_saida');
	        date.value = null;
	        if (this.isVisitor) {
	            this.statusSearch = this.statusList[0];
	        }
	        else {
	            this.statusSearch = this.statusList[1];
	        }
	        this._autocompleteService.setValueOnSelect2(null, "funcionario");
	        this.queryMovimentacoes();
	    };
	    DeslocamentoListComponent.prototype.getFuncionarioObject = function (object) {
	        this.funcionarioSearch = object;
	        this.queryMovimentacoes();
	    };
	    DeslocamentoListComponent.prototype.queryMovimentacoes = function () {
	        var query = { "where": {} };
	        var dateStart = document.getElementById('data_saida');
	        if (dateStart.value) {
	            var currDate = this._utilService.convertStringToDate(dateStart.value);
	            var nextCurrDate = new Date(currDate.getTime());
	            nextCurrDate.setDate(currDate.getDate() + 1);
	            var dateQuery = [{ dataHoraPrevistaSaida: { "gt": currDate } }, { dataHoraPrevistaSaida: { "lt": nextCurrDate } }];
	            query.where.and = dateQuery;
	        }
	        if (this.tipoSearch.Key) {
	            query.where.tipo = this.tipoSearch.Key;
	        }
	        if (this.statusSearch.Key) {
	            if (this.statusSearch.Key === -1) {
	                var statusAprovado = this._deslocamentoService.getStatusAprovado();
	                var statusSolicitado = this._deslocamentoService.getStatusSolicitado();
	                var or = { or: [{ status: statusAprovado }, { status: statusSolicitado }] };
	                if (query.where.and) {
	                    query.where.and.push(or);
	                }
	                else {
	                    query.where.and = [or];
	                }
	            }
	            else {
	                query.where.status = this.statusSearch.Key;
	            }
	        }
	        if (this.funcionarioSearch.id) {
	            query.where.solicitanteId = this.funcionarioSearch.id;
	        }
	        this.getMovimentacoes(query);
	    };
	    DeslocamentoListComponent.prototype.getMovimentacoes = function (query) {
	        if (this.isVisitor) {
	            query.where.usuarioCriacaoId = this.isVisitor;
	        }
	        this.loading = true;
	        this._deslocamentosApiService.onGetByFilter(query, this.onDone);
	    };
	    DeslocamentoListComponent.prototype.getStatus = function () {
	        var list = this._utilService.cloneObject(data_service_1.statusDeslocamentos);
	        var statusAprovado = this._deslocamentoService.getStatusAprovado();
	        var statusSolicitado = this._deslocamentoService.getStatusSolicitado();
	        statusAprovado = this._deslocamentoService.getStatus(statusAprovado);
	        statusSolicitado = this._deslocamentoService.getStatus(statusSolicitado);
	        list.unshift({ Key: -1, Value: 'Ativos (' + statusAprovado.Value + ' e ' + statusSolicitado.Value + ')' });
	        list.unshift({ Key: null, Value: '— Status —' });
	        this.statusList = list;
	    };
	    DeslocamentoListComponent.prototype.getTipos = function () {
	        var list = this._utilService.cloneObject(data_service_1.tiposDeslocamentos);
	        list.unshift({ Key: null, Value: '— Tipo —' });
	        this.tiposList = list;
	        this.tipoSearch = this.tiposList[0];
	    };
	    DeslocamentoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(645),
	            styles: [__webpack_require__(646)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof deslocamento_api_service_1.DeslocamentoApiService !== 'undefined' && deslocamento_api_service_1.DeslocamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof deslocamento_navigation_service_1.DeslocamentoNavigationService !== 'undefined' && deslocamento_navigation_service_1.DeslocamentoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof deslocamento_service_1.DeslocamentoService !== 'undefined' && deslocamento_service_1.DeslocamentoService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof usuario_service_1.UsuarioService !== 'undefined' && usuario_service_1.UsuarioService) === 'function' && _e) || Object, (typeof (_f = typeof funcionario_service_1.FuncionarioService !== 'undefined' && funcionario_service_1.FuncionarioService) === 'function' && _f) || Object, (typeof (_g = typeof funcionario_api_service_1.FuncionarioApiService !== 'undefined' && funcionario_api_service_1.FuncionarioApiService) === 'function' && _g) || Object, (typeof (_h = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _h) || Object])
	    ], DeslocamentoListComponent);
	    return DeslocamentoListComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.DeslocamentoListComponent = DeslocamentoListComponent;


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(202);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(457);
	var DeslocamentoNavigationService = (function () {
	    function DeslocamentoNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    DeslocamentoNavigationService.prototype.goToList = function () {
	        var router = data_service_3.viagensRoute + '/' + data_service_1.deslocamentosRoute;
	        this._authService.navigateTo(router);
	    };
	    DeslocamentoNavigationService.prototype.goToNew = function () {
	        var router = data_service_3.viagensRoute + '/' + data_service_1.deslocamentosRoute + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    DeslocamentoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_3.viagensRoute + '/' + data_service_1.deslocamentosRoute + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    DeslocamentoNavigationService.prototype.goToDetail = function (objectId) {
	        var router = data_service_3.viagensRoute + '/' + data_service_1.deslocamentosRoute + '/' + data_service_2.detailRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    DeslocamentoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], DeslocamentoNavigationService);
	    return DeslocamentoNavigationService;
	    var _a;
	}());
	exports.DeslocamentoNavigationService = DeslocamentoNavigationService;


/***/ },
/* 645 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">{{deslocamentosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>{{deslocamentosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c geo-input--datepicker\">\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"data_saida\" placeholder=\"Data de saída\" [(ngModel)]=\"dataSaida\" appDatepicker autocomplete=\"off\" (ngModelChange)=\"changeData()\"/>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"funcionario\"\n                                (setObejct)=\"getFuncionarioObject($event)\"\n                                (clearObject)=\"getFuncionarioObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"funcionarioSelectId\"\n                                [model]=\"funcionarioSearch\"\n                                [_service]=\"_funcionarioApiService\"\n                                [templateResult]=\"funcionarioTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'— Solicitante —'\"\n                                [apiCustom]=\"'/populado'\"\n                                [query]=\"funcionarioQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"tipo\" [(ngModel)]=\"tipoSearch\" (ngModelChange)=\"changeTipo()\" class=\"option_{{tipoSearch.Key}}\">\n                    <option *ngFor=\"let item of tiposList\" id=\"tipo_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"status\" [(ngModel)]=\"statusSearch\" (ngModelChange)=\"changeStatus()\" class=\"option_{{statusSearch.Key}}\">\n                    <option *ngFor=\"let item of statusList\" id=\"status_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c geo-columns--right\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickClearSearch()\" class=\"cursor-pointer clear-search\">Limpar busca</a>\n            <!--<a (click)=\"clickToggleAdvancedSearch()\" *ngIf=\"!showAdvancedSearch\" class=\"cursor-pointer\">Busca avançada</a>-->\n            <!--<a (click)=\"clickToggleAdvancedSearch()\" *ngIf=\"showAdvancedSearch\" class=\"cursor-pointer\">Esconder busca avançada</a>-->\n        </p>\n    </div>\n</div>\n\n<app-deslocamento-table [list]=\"list\"\n                        [loading]=\"loading\"\n                        [showDisabled]=\"showDisabled\"></app-deslocamento-table>";

/***/ },
/* 646 */
/***/ function(module, exports) {

	module.exports = ".cursor-pointer {\n    cursor: pointer;\n}\n.advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}"

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(202);
	var deslocamento_model_1 = __webpack_require__(648);
	var data_service_2 = __webpack_require__(178);
	var deslocamento_navigation_service_1 = __webpack_require__(644);
	var deslocamento_api_service_1 = __webpack_require__(455);
	var deslocamento_service_1 = __webpack_require__(456);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_3 = __webpack_require__(457);
	var funcionario_model_1 = __webpack_require__(183);
	var funcionario_api_service_1 = __webpack_require__(184);
	var funcionario_service_1 = __webpack_require__(214);
	var data_service_4 = __webpack_require__(185);
	var destino_model_1 = __webpack_require__(649);
	var destino_api_service_1 = __webpack_require__(459);
	var data_service_5 = __webpack_require__(458);
	var passageiro_api_service_1 = __webpack_require__(650);
	var tipo_viagem_model_1 = __webpack_require__(652);
	var tipo_viagem_api_service_1 = __webpack_require__(653);
	var DeslocamentoFormComponent = (function () {
	    function DeslocamentoFormComponent(_route, _deslocamentoNavigationService, _deslocamentoApiService, _deslocamentoService, _utilService, _autocompleteService, _funcionarioApiService, _funcionarioService, _destinoApiService, _passageiroApiService, _tipoViagemApiService, _fb, _cdRef) {
	        this._route = _route;
	        this._deslocamentoNavigationService = _deslocamentoNavigationService;
	        this._deslocamentoApiService = _deslocamentoApiService;
	        this._deslocamentoService = _deslocamentoService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._funcionarioApiService = _funcionarioApiService;
	        this._funcionarioService = _funcionarioService;
	        this._destinoApiService = _destinoApiService;
	        this._passageiroApiService = _passageiroApiService;
	        this._tipoViagemApiService = _tipoViagemApiService;
	        this._fb = _fb;
	        this._cdRef = _cdRef;
	        this.deslocamentosModule = data_service_1.deslocamentosModuleName;
	        this.module = data_service_3.viagensModuleName;
	        this.formObject = new deslocamento_model_1.Deslocamento();
	        this.funcionarioObject = new funcionario_model_1.Funcionario();
	        this.destinoObject = new destino_model_1.Destino();
	        this.tipoViagemObject = new tipo_viagem_model_1.TipoViagem();
	        this.tipoObject = {};
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.isDriver = false;
	        this.funcionarioSelectId = 'funcionario';
	        this.destinoSelectId = 'destino';
	        this.tiposList = [];
	        this.passageirosList = [];
	        this.tiposViagemList = [];
	        this.loadingSpinnerTiposViagem = true;
	        this.ativo = new forms_1.FormControl('');
	        this.dataRetorno = new forms_1.FormControl('', forms_1.Validators.required);
	        this.dataSaida = new forms_1.FormControl('', forms_1.Validators.required);
	        this.horaSaida = new forms_1.FormControl('', forms_1.Validators.required);
	        this.horaRetorno = new forms_1.FormControl('', forms_1.Validators.required);
	        this.observacao = new forms_1.FormControl('');
	        this.funcionario = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipoViagem = new forms_1.FormControl('');
	        this.comMotorista = new forms_1.FormControl('');
	        this.enderecoPartidaSolicitante = new forms_1.FormControl('', forms_1.Validators.required);
	        this.destino = new forms_1.FormControl('', forms_1.Validators.required);
	        this.descricao = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.isEdition = false;
	        this.funcionarioTemplateResult = (function (state) {
	            var template = this._funcionarioService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseDeslocamento = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                if (this.passageirosList.length && (Response.tipo === this.tipoDeslocViagem)) {
	                    this.sendPassageiros(Response.id);
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            comMotorista: this.comMotorista,
	            dataRetorno: this.dataRetorno,
	            dataSaida: this.dataSaida,
	            observacao: this.observacao,
	            horaSaida: this.horaSaida,
	            horaRetorno: this.horaRetorno,
	            enderecoPartidaSolicitante: this.enderecoPartidaSolicitante,
	            funcionario: this.funcionario,
	            tipo: this.tipo,
	            tipoViagem: this.tipoViagem,
	            destino: this.destino,
	            descricao: this.descricao
	        });
	    }
	    DeslocamentoFormComponent.prototype.ngOnInit = function () {
	        this.funcionarioQuery = this._utilService.cloneObject(data_service_4.funcionariosQueryComPessoa);
	        this.destinoQuery = this._utilService.cloneObject(data_service_5.destinosQuery);
	        this.tiposList = this._utilService.cloneObject(data_service_1.tiposDeslocamentos);
	        this.tipoDeslocSaida = this._deslocamentoService.getTipoSaida();
	        this.tipoDeslocViagem = this._deslocamentoService.getTipoViagem();
	        this.getTiposViagem();
	        this.testSession();
	    };
	    DeslocamentoFormComponent.prototype.ngAfterViewChecked = function () {
	        this._cdRef.detectChanges();
	    };
	    DeslocamentoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    DeslocamentoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    DeslocamentoFormComponent.prototype.clickGoToDetail = function () {
	        this.goToDetail();
	    };
	    DeslocamentoFormComponent.prototype.changeTipo = function () {
	    };
	    DeslocamentoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (!this.isDriver) {
	            this._utilService.setSelectOnFormControl(this.form, 'enderecoPartidaSolicitante', 'x');
	        }
	        if (this.tipoObject.Key === this.tipoDeslocSaida) {
	            this._utilService.setSelectOnFormControl(this.form, 'destino', { id: -1 });
	        }
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject), date = void 0, time = void 0;
	            if (!this.isDriver) {
	                object.enderecoPartidaSolicitante = '';
	            }
	            if (this.funcionarioObject.id) {
	                object.solicitanteId = this.funcionarioObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.tipoObject.Key) {
	                object.tipo = this.tipoObject.Key;
	                if (this.tipoObject.Key === this.tipoDeslocViagem) {
	                    if (this.destinoObject.id) {
	                        object.destinoId = this.destinoObject.id;
	                    }
	                    else {
	                        this.btnSaveDisabled = false;
	                        return false;
	                    }
	                }
	            }
	            if (this.tipoViagemObject.id) {
	                object.tipoViagemId = this.tipoViagemObject.id;
	            }
	            date = document.getElementById('data_saida');
	            time = document.getElementById('hora_saida');
	            if (date.value && time.value) {
	                object.dataHoraPrevistaSaida = this._utilService.convertStringToDateTime(date.value, time.value);
	                delete object['dataSaida'];
	                delete object['horaSaida'];
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            date = document.getElementById('data_retorno_previsto');
	            time = document.getElementById('hora_retorno_previsto');
	            if (date.value && time.value) {
	                object.dataHoraPrevistaRetorno = this._utilService.convertStringToDateTime(date.value, time.value);
	                delete object['dataRetorno'];
	                delete object['horaRetorno'];
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.formObject.id) {
	                this.onEditDeslocamento(object);
	            }
	            else {
	                object.status = this._deslocamentoService.getStatusSolicitado();
	                this.onAddDeslocamento(object);
	            }
	        }
	    };
	    DeslocamentoFormComponent.prototype.getDestinoObject = function (object) {
	        this.destinoObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'destino', object);
	    };
	    DeslocamentoFormComponent.prototype.getFuncionariosObject = function (object) {
	        this.funcionarioObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'funcionario', object);
	    };
	    DeslocamentoFormComponent.prototype.onAddDeslocamento = function (object) {
	        this._deslocamentoApiService.onPost(object, this.onDone);
	    };
	    DeslocamentoFormComponent.prototype.onEditDeslocamento = function (object) {
	        this._deslocamentoApiService.onPut(object, this.onDone);
	    };
	    DeslocamentoFormComponent.prototype.sendPassageiros = function (deslocamentoId) {
	        var x, lenX, passObject = {};
	        for (x = 0, lenX = this.passageirosList.length; x < lenX; x++) {
	            if (this.passageirosList[x].passageiro && !this.passageirosList[x].id) {
	                passObject = {
	                    deslocamentoId: deslocamentoId,
	                    passageiroId: this.passageirosList[x].passageiro.id,
	                    acompanhante: this.passageirosList[x].acompanhante
	                };
	                this.onAddPassageiro(passObject);
	            }
	        }
	    };
	    DeslocamentoFormComponent.prototype.onAddPassageiro = function (object) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	            }
	        }.bind(this));
	        this._passageiroApiService.onPostPassageiroDeslocamento(object, onDone);
	    };
	    DeslocamentoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma solicitação encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._deslocamentoApiService.onGetById(id, onDone);
	    };
	    DeslocamentoFormComponent.prototype.getTiposViagem = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.tiposViagemList = Response;
	                this.setTipoViagem();
	                this.loadingSpinnerTiposViagem = false;
	            }
	        }.bind(this));
	        this._tipoViagemApiService.onGetAllActive(onDone);
	    };
	    DeslocamentoFormComponent.prototype.testSession = function () {
	        this._deslocamentoService.clearSessionStorage();
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.setEditNormal(id);
	        }
	        else {
	            this.setNewNormal();
	        }
	        this.setActionTitle(id);
	    };
	    DeslocamentoFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.enderecoPartidaSolicitante) {
	            this.isDriver = true;
	        }
	        if (this.formObject.solicitante) {
	            this.funcionarioObject = this.formObject.solicitante;
	            delete this.formObject['solicitante'];
	            var selectObject = { text: this.funcionarioObject.pessoa.nome, id: this.funcionarioObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.funcionarioSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.funcionarioSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'funcionario', this.funcionarioObject);
	        }
	        if (this.formObject.destino) {
	            this.destinoObject = this.formObject.destino;
	            delete this.formObject['destino'];
	            var selectObject_1 = { text: this.destinoObject.destino, id: this.destinoObject.id };
	            setTimeout(function () {
	                this._autocompleteService.createOptionOnSelect2(this.destinoSelectId, selectObject_1);
	                this._autocompleteService.setValueOnSelect2(selectObject_1.id, this.destinoSelectId);
	                this._utilService.setSelectOnFormControl(this.form, 'destino', this.destinoObject);
	            }.bind(this));
	        }
	        if (this.formObject.tipo) {
	            var x = void 0, lenX = void 0;
	            for (x = 0, lenX = this.tiposList.length; x < lenX; x++) {
	                if (this.tiposList[x].Key === this.formObject.tipo) {
	                    this.tipoObject = this.tiposList[x];
	                    break;
	                }
	            }
	            delete this.formObject['tipo'];
	        }
	        if (this.formObject.tipoViagem) {
	            this.tipoViagemObject = this.formObject.tipoViagem;
	            delete this.formObject['tipoViagem'];
	            this.setTipoViagem();
	        }
	        if (this.formObject.dataHoraPrevistaSaida) {
	            if (this.formObject.dataHoraPrevistaSaida.indexOf("/") === -1) {
	                this.formObject.dataSaida = this._utilService.convertDateToString(this.formObject.dataHoraPrevistaSaida);
	                this.formObject.horaSaida = this._utilService.convertTimeToString(this.formObject.dataHoraPrevistaSaida);
	            }
	        }
	        if (this.formObject.dataHoraPrevistaRetorno) {
	            if (this.formObject.dataHoraPrevistaRetorno.indexOf("/") === -1) {
	                this.formObject.dataRetorno = this._utilService.convertDateToString(this.formObject.dataHoraPrevistaRetorno);
	                this.formObject.horaRetorno = this._utilService.convertTimeToString(this.formObject.dataHoraPrevistaRetorno);
	            }
	        }
	    };
	    DeslocamentoFormComponent.prototype.setTipoViagem = function () {
	        if (this.tipoViagemObject.id) {
	            var x = void 0, lenX = void 0;
	            for (x = 0, lenX = this.tiposViagemList.length; x < lenX; x++) {
	                if (this.tiposViagemList[x].id === this.tipoViagemObject.id) {
	                    this.tipoViagemObject = this.tiposViagemList[x];
	                    break;
	                }
	            }
	        }
	    };
	    DeslocamentoFormComponent.prototype.toLeaveHere = function () {
	        if (this.formObject.id) {
	            this.goToDetail();
	        }
	        else {
	            this.goToList();
	        }
	    };
	    DeslocamentoFormComponent.prototype.goToList = function () {
	        this._deslocamentoNavigationService.goToList();
	    };
	    DeslocamentoFormComponent.prototype.goToDetail = function () {
	        this._deslocamentoNavigationService.goToDetail(this.formObject.id);
	    };
	    DeslocamentoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    DeslocamentoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    DeslocamentoFormComponent.prototype.setNewNormal = function () {
	        this.setFirstTipo();
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    DeslocamentoFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    DeslocamentoFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    DeslocamentoFormComponent.prototype.setFirstTipo = function () {
	        if (this.isEdition) {
	        }
	        else {
	            this.tipoObject = this.tiposList[0];
	        }
	    };
	    DeslocamentoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(655),
	            styles: [__webpack_require__(656)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof deslocamento_navigation_service_1.DeslocamentoNavigationService !== 'undefined' && deslocamento_navigation_service_1.DeslocamentoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof deslocamento_api_service_1.DeslocamentoApiService !== 'undefined' && deslocamento_api_service_1.DeslocamentoApiService) === 'function' && _c) || Object, (typeof (_d = typeof deslocamento_service_1.DeslocamentoService !== 'undefined' && deslocamento_service_1.DeslocamentoService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof funcionario_api_service_1.FuncionarioApiService !== 'undefined' && funcionario_api_service_1.FuncionarioApiService) === 'function' && _g) || Object, (typeof (_h = typeof funcionario_service_1.FuncionarioService !== 'undefined' && funcionario_service_1.FuncionarioService) === 'function' && _h) || Object, (typeof (_j = typeof destino_api_service_1.DestinoApiService !== 'undefined' && destino_api_service_1.DestinoApiService) === 'function' && _j) || Object, (typeof (_k = typeof passageiro_api_service_1.PassageiroApiService !== 'undefined' && passageiro_api_service_1.PassageiroApiService) === 'function' && _k) || Object, (typeof (_l = typeof tipo_viagem_api_service_1.TipoViagemApiService !== 'undefined' && tipo_viagem_api_service_1.TipoViagemApiService) === 'function' && _l) || Object, (typeof (_m = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _m) || Object, (typeof (_o = typeof core_1.ChangeDetectorRef !== 'undefined' && core_1.ChangeDetectorRef) === 'function' && _o) || Object])
	    ], DeslocamentoFormComponent);
	    return DeslocamentoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
	}());
	exports.DeslocamentoFormComponent = DeslocamentoFormComponent;


/***/ },
/* 648 */
/***/ function(module, exports) {

	"use strict";
	var Deslocamento = (function () {
	    function Deslocamento() {
	    }
	    return Deslocamento;
	}());
	exports.Deslocamento = Deslocamento;
	var CustoDeslocamento = (function () {
	    function CustoDeslocamento() {
	    }
	    return CustoDeslocamento;
	}());
	exports.CustoDeslocamento = CustoDeslocamento;


/***/ },
/* 649 */
/***/ function(module, exports) {

	"use strict";
	var Destino = (function () {
	    function Destino() {
	    }
	    return Destino;
	}());
	exports.Destino = Destino;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(651);
	var PassageiroApiService = (function () {
	    function PassageiroApiService(_restService) {
	        this._restService = _restService;
	    }
	    PassageiroApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    PassageiroApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    PassageiroApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    PassageiroApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "nome", "include": ["endereco"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    PassageiroApiService.prototype.onGetAllActive = function (done) {
	        var filter = { "where": { "ativo": true }, "order": "nome", "include": ["endereco"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    PassageiroApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["endereco"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    PassageiroApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    //passageiro deslocamento
	    PassageiroApiService.prototype.onPostPassageiroDeslocamento = function (object, done) {
	        this._restService.onPost(data_service_1.apiNamePassageirosDeslocamento, object, done);
	    };
	    PassageiroApiService.prototype.onPutPassageiroDeslocamento = function (object, done) {
	        this._restService.onPut(data_service_1.apiNamePassageirosDeslocamento, object, done);
	    };
	    PassageiroApiService.prototype.onDeletePassageiroDeslocamento = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiNamePassageirosDeslocamento, objectId, done);
	    };
	    PassageiroApiService.prototype.onGetPassageiroDeslocamento = function (filter, done) {
	        filter.include = ["deslocamento", "passageiro", "pontoDeslocamentoEmbarque", "pontoDeslocamentoDesembarque"];
	        this._restService.onGetPost(data_service_1.apiNamePassageirosDeslocamento, filter, done);
	    };
	    PassageiroApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], PassageiroApiService);
	    return PassageiroApiService;
	    var _a;
	}());
	exports.PassageiroApiService = PassageiroApiService;


/***/ },
/* 651 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'passageiros';
	exports.passageirosRoute = 'passageiros';
	exports.passageirosStorage = 'passageiros';
	exports.passageirosModuleName = { plural: 'Passageiros', single: 'Passageiro' };
	exports.apiNamePassageirosDeslocamento = 'passageiros-deslocamentos';
	exports.passageirosQuery = {
	    "where": {
	        "ativo": true,
	        "nome": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "nome"
	};


/***/ },
/* 652 */
/***/ function(module, exports) {

	"use strict";
	var TipoViagem = (function () {
	    function TipoViagem() {
	    }
	    return TipoViagem;
	}());
	exports.TipoViagem = TipoViagem;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(654);
	var TipoViagemApiService = (function () {
	    function TipoViagemApiService(_restService) {
	        this._restService = _restService;
	    }
	    TipoViagemApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    TipoViagemApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    TipoViagemApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    TipoViagemApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "tipo" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    TipoViagemApiService.prototype.onGetAllActive = function (done) {
	        var filter = { "where": { "ativo": true }, "order": "tipo" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    TipoViagemApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    TipoViagemApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    TipoViagemApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], TipoViagemApiService);
	    return TipoViagemApiService;
	    var _a;
	}());
	exports.TipoViagemApiService = TipoViagemApiService;


/***/ },
/* 654 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-viagens';


/***/ },
/* 655 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a  class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{deslocamentosModule.plural}}</a></li>\n        <li class=\"item\" *ngIf=\"formObject.id\"><a (click)=\"clickGoToDetail()\" class=\"cursor-pointer\">Detalhes</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{deslocamentosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{deslocamentosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados da {{deslocamentosModule.single}}</h2>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipo.valid && submitted}\">\n                <label for=\"tipo\">Tipo da solicitação <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"(!tipo.valid && submitted)\">Este campo é obrigatório.</span>\n                    <select id=\"tipo\" [(ngModel)]=\"tipoObject\" formControlName=\"tipo\" (ngModelChange)=\"changeTipo()\">\n                        <option *ngFor=\"let item of tiposList\" [ngValue]=\"item\">{{item.Value}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipoViagem.valid && submitted}\">\n                <label for=\"tipoViagem\">Tipo </label>\n                <div  class=\"containerSpinner\">\n                    <span class=\"error-alert\" *ngIf=\"(!tipoViagem.valid && submitted)\">Este campo é obrigatório.</span>\n                    <select id=\"tipoViagem\" [(ngModel)]=\"tipoViagemObject\" formControlName=\"tipoViagem\">\n                        <option *ngFor=\"let item of tiposViagemList\" [ngValue]=\"item\">{{item.tipo}}</option>\n                    </select>\n                    <spinner-component *ngIf=\"loadingSpinnerTiposViagem\"></spinner-component>\n                </div>\n            </div>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"funcionario\"\n                                    (setObejct)=\"getFuncionariosObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"funcionarioSelectId\"\n                                    [model]=\"funcionarioObject\"\n                                    [_service]=\"_funcionarioApiService\"\n                                    [templateResult]=\"funcionarioTemplateResult\"\n                                    [apiCustom]=\"'/populado'\"\n                                    [query]=\"funcionarioQuery\"\n                                    [label]=\"'Solicitante'\"></autocomplete-component>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"destino\" *ngIf=\"tipoObject.Key === tipoDeslocViagem\"\n                                    (setObejct)=\"getDestinoObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"destinoSelectId\"\n                                    [model]=\"destinoObject\"\n                                    [_service]=\"_destinoApiService\"\n                                    [fieldToShow]=\"'destino'\"\n                                    [query]=\"destinoQuery\"\n                                    [isCreateNew]=\"false\"\n                                    [label]=\"'Destino'\"></autocomplete-component>\n\n        </div>\n\n        <div class=\"geo-columns--12c\" *ngIf=\"tipoObject.Key === tipoDeslocSaida\">\n            <div class=\"geo-toggle\">\n                <input type=\"checkbox\" id=\"isDriver\" value=\"\" [(ngModel)]=\"isDriver\" formControlName=\"comMotorista\">\n                <label for=\"isDriver\">Com motorista</label>\n            </div>\n        </div>\n\n        <div class=\"geo-columns--12c\" *ngIf=\"isDriver\">\n            <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !enderecoPartidaSolicitante.valid && submitted}\">\n                <label for=\"enderecoPartidaSolicitante\">Local onde o motorista deverá buscar o solicitante <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!enderecoPartidaSolicitante.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\"  id=\"enderecoPartidaSolicitante\" [(ngModel)]=\"formObject.enderecoPartidaSolicitante\" formControlName=\"enderecoPartidaSolicitante\" />\n                </div>\n            </div>\n        </div>\n\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c geo-input--datepicker\"  [ngClass]=\"{'geo-input--error': !dataSaida.value && submitted}\">\n                <label for=\"data_saida\">Data da saída  <abbr>*</abbr></label>\n                <div>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"data_saida\" [(ngModel)]=\"formObject.dataSaida\" formControlName=\"dataSaida\" appDatepicker autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !horaSaida.value && submitted}\">\n                <label for=\"hora_saida\">Hora da saída  <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!horaSaida.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"hora_saida\" [(ngModel)]=\"formObject.horaSaida\" formControlName=\"horaSaida\" appTimepicker maxlength=\"5\" autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c geo-input--datepicker\"  [ngClass]=\"{'geo-input--error': !dataRetorno.value && submitted}\">\n                <label for=\"data_retorno_previsto\">Data de retorno previsto <abbr>*</abbr></label>\n                <div>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"data_retorno_previsto\" [(ngModel)]=\"formObject.dataRetorno\" formControlName=\"dataRetorno\" appDatepicker autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !horaRetorno.value && submitted}\">\n                <label for=\"hora_retorno_previsto\">Hora de retorno previsto  <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!horaRetorno.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"hora_retorno_previsto\" [(ngModel)]=\"formObject.horaRetorno\" formControlName=\"horaRetorno\" appTimepicker maxlength=\"5\" autocomplete=\"off\" />\n                </div>\n            </div>\n\n            <div class=\"geo-input--12c\" *ngIf=\"tipoObject.Key === tipoDeslocSaida\">\n                <label for=\"observacao\">Observação</label>\n                <div>\n                    <textarea id=\"observacao\" [(ngModel)]=\"formObject.observacao\" formControlName=\"observacao\"></textarea>\n                </div>\n            </div>\n\n            <div class=\"geo-input--12c\" *ngIf=\"tipoObject.Key === tipoDeslocViagem\">\n                <label for=\"descricao\">Descrição</label>\n                <div>\n                    <textarea id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\"></textarea>\n                </div>\n            </div>\n        </div>\n\n        <h2 *ngIf=\"(tipoObject.Key === tipoDeslocViagem) && !formObject.id\">Passageiros</h2>\n    </div>\n\n    <app-passageiro-deslocamento-form-list [list]=\"passageirosList\" *ngIf=\"(tipoObject.Key === tipoDeslocViagem) && !formObject.id\"></app-passageiro-deslocamento-form-list>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 656 */
/***/ function(module, exports) {

	module.exports = "\n.containerSpinner {\n    position: relative;\n}\n\nspinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}"

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var deslocamento_api_service_1 = __webpack_require__(455);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(202);
	var deslocamento_model_1 = __webpack_require__(648);
	var deslocamento_navigation_service_1 = __webpack_require__(644);
	var deslocamento_service_1 = __webpack_require__(456);
	var data_service_2 = __webpack_require__(457);
	var frota_model_1 = __webpack_require__(373);
	var motorista_model_1 = __webpack_require__(213);
	var motorista_api_service_1 = __webpack_require__(209);
	var motorista_service_1 = __webpack_require__(188);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var data_service_3 = __webpack_require__(154);
	var data_service_4 = __webpack_require__(146);
	var autocomplete_service_1 = __webpack_require__(101);
	var forma_controle_service_1 = __webpack_require__(369);
	var passageiro_api_service_1 = __webpack_require__(650);
	var ponto_api_service_1 = __webpack_require__(630);
	var ponto_service_1 = __webpack_require__(632);
	var DelocamentoDetailComponent = (function () {
	    function DelocamentoDetailComponent(_deslocamentoApiService, _deslocamentoNavigationService, _deslocamentoService, _motoristaApiService, _motoristaService, _frotaApiService, _frotaService, _passageiroApiService, _pontoApiService, _pontoService, _formaControleService, _autocompleteService, _route, _utilService, _fb) {
	        this._deslocamentoApiService = _deslocamentoApiService;
	        this._deslocamentoNavigationService = _deslocamentoNavigationService;
	        this._deslocamentoService = _deslocamentoService;
	        this._motoristaApiService = _motoristaApiService;
	        this._motoristaService = _motoristaService;
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._passageiroApiService = _passageiroApiService;
	        this._pontoApiService = _pontoApiService;
	        this._pontoService = _pontoService;
	        this._formaControleService = _formaControleService;
	        this._autocompleteService = _autocompleteService;
	        this._route = _route;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this.deslocamentosModule = data_service_1.deslocamentosModuleName;
	        this.module = data_service_2.viagensModuleName;
	        this.detail = new deslocamento_model_1.Deslocamento();
	        this.tabSelected = 'detalhes';
	        this.isAdm = false;
	        this.formObject = {};
	        this.frotaObject = new frota_model_1.Frota();
	        this.motoristaObject = new motorista_model_1.Motorista();
	        this.statusObject = {};
	        this.statusList = [];
	        this.isDriver = false;
	        this.submitted = false;
	        this.frotaSelectId = 'frota';
	        this.motoristaSelectId = 'motorista';
	        this.passageirosList = [];
	        this.pontosList = [];
	        this.custosList = [];
	        this.status = new forms_1.FormControl('', forms_1.Validators.required);
	        this.justificativa = new forms_1.FormControl('', forms_1.Validators.required);
	        this.motorista = new forms_1.FormControl('', forms_1.Validators.required);
	        this.bem = new forms_1.FormControl('', forms_1.Validators.required);
	        this.enderecoPartidaVeiculo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.dataRetorno = new forms_1.FormControl('', forms_1.Validators.required);
	        this.dataSaida = new forms_1.FormControl('', forms_1.Validators.required);
	        this.horaSaida = new forms_1.FormControl('', forms_1.Validators.required);
	        this.horaRetorno = new forms_1.FormControl('', forms_1.Validators.required);
	        this.observacao = new forms_1.FormControl('');
	        this.horasTrabalhadas = new forms_1.FormControl('');
	        this.titulo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.numeroRequisicao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.motoristaTemplateResult = (function (state) {
	            var template = this._motoristaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this._utilService.swalMessageEditSuccess();
	                this.clickList();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            status: this.status,
	            justificativa: this.justificativa,
	            motorista: this.motorista,
	            bem: this.bem,
	            enderecoPartidaVeiculo: this.enderecoPartidaVeiculo,
	            dataRetorno: this.dataRetorno,
	            dataSaida: this.dataSaida,
	            observacao: this.observacao,
	            horaSaida: this.horaSaida,
	            horaRetorno: this.horaRetorno,
	            titulo: this.titulo,
	            numeroRequisicao: this.numeroRequisicao,
	            horasTrabalhadas: this.horasTrabalhadas
	        });
	    }
	    DelocamentoDetailComponent.prototype.ngOnInit = function () {
	        this.isAdm = this._deslocamentoService.checkVisitor();
	        this.tipoSaida = this._deslocamentoService.getTipoSaida();
	        this.tipoViagem = this._deslocamentoService.getTipoViagem();
	        this.deslocamentoId = +this._route.snapshot.params['id'];
	        this.getObject(this.deslocamentoId);
	        this.getPassageiros(this.deslocamentoId);
	        if (this.isAdm) {
	            this.getPontos(this.deslocamentoId);
	            this.getCustos(this.deslocamentoId);
	        }
	    };
	    DelocamentoDetailComponent.prototype.ngAfterViewInit = function () {
	    };
	    DelocamentoDetailComponent.prototype.clickEdit = function () {
	        this._deslocamentoNavigationService.goToEdit(this.detail.id);
	    };
	    DelocamentoDetailComponent.prototype.clickList = function () {
	        this._deslocamentoNavigationService.goToList();
	    };
	    DelocamentoDetailComponent.prototype.changeStatus = function () {
	        this.statusItem = this._utilService.cloneObject(this.statusObject.Key);
	    };
	    DelocamentoDetailComponent.prototype.setTab = function (tab) {
	        this.tabSelected = tab;
	        if (tab === 'status') {
	            this.setDados();
	        }
	    };
	    DelocamentoDetailComponent.prototype.isTab = function (tab) {
	        var isTab = (tab === this.tabSelected) ? true : false;
	        return isTab;
	    };
	    DelocamentoDetailComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (this.statusItem === this.statusAprovado) {
	            if (this.isDriver) {
	                this._utilService.setSelectOnFormControl(this.form, 'enderecoPartidaVeiculo', 'x');
	            }
	            else {
	                this._utilService.setSelectOnFormControl(this.form, 'motorista', { id: -1 });
	            }
	            this._utilService.setSelectOnFormControl(this.form, 'justificativa', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'dataSaida', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'horaSaida', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'dataRetorno', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'horaRetorno', 'x');
	        }
	        else if (this.statusItem === this.statusCancelado) {
	            this._utilService.setSelectOnFormControl(this.form, 'enderecoPartidaVeiculo', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'motorista', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'bem', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'dataRetorno', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'horaRetorno', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'dataSaida', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'horaSaida', 'x');
	        }
	        else if (this.statusItem === this.statusConcluido) {
	            this._utilService.setSelectOnFormControl(this.form, 'enderecoPartidaVeiculo', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'motorista', { id: -1 });
	            this._utilService.setSelectOnFormControl(this.form, 'justificativa', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'bem', { id: -1 });
	            if (!this.formObject.odometroSaida || !this.formObject.odometroRetorno) {
	                return false;
	            }
	        }
	        if (this.deslocamentoTipoId === this.tipoSaida) {
	            this._utilService.setSelectOnFormControl(this.form, 'titulo', 'x');
	            this._utilService.setSelectOnFormControl(this.form, 'numeroRequisicao', 'x');
	        }
	        if (evt.valid) {
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.motoristaObject.id) {
	                object.motoristaDesignadoId = this.motoristaObject.id;
	            }
	            if (this.frotaObject.id) {
	                object.bemId = this.frotaObject.id;
	            }
	            if (this.statusItem === this.statusConcluido) {
	                var date = document.getElementById('data_saida');
	                var time = document.getElementById('hora_saida');
	                if (date.value && time.value) {
	                    object.dataHoraEfetivaSaida = this._utilService.convertStringToDateTime(date.value, time.value);
	                    delete object['dataSaida'];
	                    delete object['horaSaida'];
	                }
	                date = document.getElementById('data_retorno_efetivo');
	                time = document.getElementById('hora_retorno_efetivo');
	                if (date.value && time.value) {
	                    object.dataHoraEfetivaRetorno = this._utilService.convertStringToDateTime(date.value, time.value);
	                    delete object['dataRetorno'];
	                    delete object['horaRetorno'];
	                }
	                object.kmSaida = this._formaControleService.submitOdometroHorimetro(object.odometroSaida);
	                delete object['odometroSaida'];
	                object.kmRetorno = this._formaControleService.submitOdometroHorimetro(object.odometroRetorno);
	                delete object['odometroRetorno'];
	            }
	            object.status = this.statusItem;
	            object.id = this.detail.id;
	            this.onEditDeslocamento(object);
	        }
	    };
	    DelocamentoDetailComponent.prototype.getMotoristasObject = function (object) {
	        this.motoristaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'motorista', object);
	    };
	    DelocamentoDetailComponent.prototype.getFrotasObject = function (object) {
	        this.frotaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'bem', object);
	    };
	    DelocamentoDetailComponent.prototype.onEditDeslocamento = function (object) {
	        this._deslocamentoApiService.onPut(object, this.onDone);
	    };
	    DelocamentoDetailComponent.prototype.getObject = function (deslocamentoId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.statusItem = this._utilService.cloneObject(Response.status);
	                this.deslocamentoTipoId = Response.tipo;
	                Response.tipo = this._deslocamentoService.getTipo(Response.tipo);
	                Response.statusId = Response.status;
	                Response.status = this._deslocamentoService.getStatus(Response.status);
	                this.detail = Response;
	                if (this.isAdm && this.detail.id) {
	                    this.setAdmSettings();
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma solicitação encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._deslocamentoApiService.onGetById(deslocamentoId, onDone);
	    };
	    DelocamentoDetailComponent.prototype.getPassageiros = function (deslocamentoId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.passageirosList = Response;
	            }
	        }.bind(this));
	        var query = {
	            where: {
	                ativo: true,
	                deslocamentoId: deslocamentoId
	            }
	        };
	        this._passageiroApiService.onGetPassageiroDeslocamento(query, onDone);
	    };
	    DelocamentoDetailComponent.prototype.getPontos = function (deslocamentoId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].tipo = this._pontoService.checkTipo(Response[x].tipo);
	                }
	                this.pontosList = Response;
	            }
	        }.bind(this));
	        var query = {
	            where: {
	                ativo: true,
	                deslocamentoId: deslocamentoId
	            }
	        };
	        this._pontoApiService.onGetPontoDeslocamento(query, onDone);
	    };
	    DelocamentoDetailComponent.prototype.getCustos = function (deslocamentoId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.custosList = Response;
	            }
	        }.bind(this));
	        var query = {
	            where: {
	                ativo: true,
	                deslocamentoId: deslocamentoId
	            }
	        };
	        this._deslocamentoApiService.onGetCustoDeslocamento(query, onDone);
	    };
	    DelocamentoDetailComponent.prototype.setAdmSettings = function () {
	        this.veiculoCategoriaId = this._frotaService.getTipoVeiculo();
	        this.frotaQuery = this._utilService.cloneObject(data_service_3.frotasQuery);
	        this.motoristaQuery = this._utilService.cloneObject(data_service_4.motoristasQuery);
	        if (this.deslocamentoTipoId === this.tipoViagem) {
	            this.isDriver = true;
	        }
	        this.statusList = this._utilService.cloneObject(data_service_1.statusDeslocamentos);
	        if (this.detail.status) {
	            var x = void 0, lenX = void 0;
	            for (x = 0, lenX = this.statusList.length; x < lenX; x++) {
	                if (this.statusList[x].Key === this.statusItem) {
	                    this.statusObject = this.statusList[x];
	                    break;
	                }
	            }
	        }
	        if (this.detail.enderecoPartidaSolicitante) {
	            this.isDriver = true;
	        }
	        this.statusCancelado = this._deslocamentoService.getStatusCancelado();
	        this.statusAprovado = this._deslocamentoService.getStatusAprovado();
	        this.statusConcluido = this._deslocamentoService.getStatusConcluido();
	        this.statusSolicitado = this._deslocamentoService.getStatusSolicitado();
	        if (this.detail.enderecoPartidaVeiculo) {
	            this.formObject.enderecoPartidaVeiculo = this.detail.enderecoPartidaVeiculo;
	        }
	        if (this.detail.justificativa) {
	            this.formObject.justificativa = this.detail.justificativa;
	        }
	        if (this.detail.bem) {
	            this.frotaObject = this.detail.bem;
	        }
	        if (this.detail.motoristaDesignado) {
	            this.motoristaObject = this.detail.motoristaDesignado;
	        }
	        if (this.detail.observacao) {
	            this.formObject.observacao = this.detail.observacao;
	        }
	        if (this.detail.titulo) {
	            this.formObject.titulo = this.detail.titulo;
	        }
	        if (this.detail.numeroRequisicao) {
	            this.formObject.numeroRequisicao = this.detail.numeroRequisicao;
	        }
	        if (this.detail.kmSaida) {
	            this.detail.odometroSaida = this._formaControleService.setOdometroHorimetroToForm(this.detail.kmSaida.odometroHorimetro);
	            this.formObject.odometroSaida = this.detail.odometroSaida;
	        }
	        if (this.detail.kmRetorno) {
	            this.detail.odometroRetorno = this._formaControleService.setOdometroHorimetroToForm(this.detail.kmRetorno.odometroHorimetro);
	            this.formObject.odometroRetorno = this.detail.odometroRetorno;
	        }
	        if (this.detail.dataHoraEfetivaSaida) {
	            if (this.detail.dataHoraEfetivaSaida.indexOf("/") === -1) {
	                this.formObject.dataSaida = this._utilService.convertDateToString(this.detail.dataHoraEfetivaSaida);
	                this.formObject.horaSaida = this._utilService.convertTimeToString(this.detail.dataHoraEfetivaSaida);
	            }
	        }
	        if (this.detail.dataHoraEfetivaRetorno) {
	            if (this.detail.dataHoraEfetivaRetorno.indexOf("/") === -1) {
	                this.formObject.dataRetorno = this._utilService.convertDateToString(this.detail.dataHoraEfetivaRetorno);
	                this.formObject.horaRetorno = this._utilService.convertTimeToString(this.detail.dataHoraEfetivaRetorno);
	            }
	        }
	        this.setDados();
	    };
	    DelocamentoDetailComponent.prototype.setDados = function () {
	        setTimeout(function () {
	            var selectObject = { text: this.frotaObject.identificacao, id: this.frotaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'bem', this.frotaObject);
	            if (this.motoristaObject) {
	                if (this.motoristaObject.funcionario) {
	                    if (this.motoristaObject.funcionario.pessoa) {
	                        selectObject = { text: this.motoristaObject.funcionario.pessoa.nome, id: this.motoristaObject.id };
	                        this._autocompleteService.createOptionOnSelect2(this.motoristaSelectId, selectObject);
	                        this._autocompleteService.setValueOnSelect2(selectObject.id, this.motoristaSelectId);
	                        this._utilService.setSelectOnFormControl(this.form, 'motorista', this.motoristaObject);
	                    }
	                }
	            }
	        }.bind(this));
	    };
	    DelocamentoDetailComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(658),
	            styles: [__webpack_require__(659)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof deslocamento_api_service_1.DeslocamentoApiService !== 'undefined' && deslocamento_api_service_1.DeslocamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof deslocamento_navigation_service_1.DeslocamentoNavigationService !== 'undefined' && deslocamento_navigation_service_1.DeslocamentoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof deslocamento_service_1.DeslocamentoService !== 'undefined' && deslocamento_service_1.DeslocamentoService) === 'function' && _c) || Object, (typeof (_d = typeof motorista_api_service_1.MotoristaApiService !== 'undefined' && motorista_api_service_1.MotoristaApiService) === 'function' && _d) || Object, (typeof (_e = typeof motorista_service_1.MotoristaService !== 'undefined' && motorista_service_1.MotoristaService) === 'function' && _e) || Object, (typeof (_f = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _f) || Object, (typeof (_g = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _g) || Object, (typeof (_h = typeof passageiro_api_service_1.PassageiroApiService !== 'undefined' && passageiro_api_service_1.PassageiroApiService) === 'function' && _h) || Object, (typeof (_j = typeof ponto_api_service_1.PontoApiService !== 'undefined' && ponto_api_service_1.PontoApiService) === 'function' && _j) || Object, (typeof (_k = typeof ponto_service_1.PontoService !== 'undefined' && ponto_service_1.PontoService) === 'function' && _k) || Object, (typeof (_l = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _l) || Object, (typeof (_m = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _m) || Object, (typeof (_o = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _o) || Object, (typeof (_p = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _p) || Object, (typeof (_q = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _q) || Object])
	    ], DelocamentoDetailComponent);
	    return DelocamentoDetailComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
	}());
	exports.DelocamentoDetailComponent = DelocamentoDetailComponent;


/***/ },
/* 658 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--6c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a  class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickList()\" class=\"cursor-pointer\">{{deslocamentosModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">Detalhes</a></li>\n        </ul>\n        <h1 *ngIf=\"detail.tipo\">{{detail.tipo.Value}}</h1>\n        <p><strong>Solicitante: </strong><span *ngIf=\"detail.solicitante && detail.solicitante.pessoa\">{{detail.solicitante.pessoa.nome}}</span></p>\n        <p><strong>Data/hora da saída previsto: </strong>{{detail.dataHoraPrevistaSaida  | date: 'dd/MM/yyyy - HH:mm'}}</p>\n        <p><strong>Data/hora da retorno previsto: </strong>{{detail.dataHoraPrevistaRetorno  | date: 'dd/MM/yyyy - HH:mm'}}</p>\n        <p><strong>Status: </strong><span *ngIf=\"detail.status\">{{detail.status.Value}}</span></p>\n    </div>\n    <div class=\"geo-columns--6c geo-columns--right\" *ngIf=\"isAdm\">\n        <div class=\"geo-columns--12c\">\n            <a (click)=\"clickEdit()\" class=\"geo-button\">Editar</a>\n        </div>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <nav class=\"geo-tabs\">\n        <ul class=\"items\">\n            <li class=\"item\">\n                <a (click)=\"setTab('detalhes')\" [ngClass]=\"{'active': isTab('detalhes')}\" class=\"item-link\">Detalhes</a>\n            </li>\n            <li class=\"item\" *ngIf=\"isAdm\">\n                <a (click)=\"setTab('status')\" [ngClass]=\"{'active': isTab('status')}\" class=\"item-link\">Definir status</a>\n            </li>\n            <li class=\"item\" *ngIf=\"(deslocamentoTipoId === tipoViagem) && isAdm\">\n                <a (click)=\"setTab('pontos')\" [ngClass]=\"{'active': isTab('pontos')}\" class=\"item-link\">Pontos</a>\n            </li>\n            <li class=\"item\" *ngIf=\"deslocamentoTipoId === tipoViagem\">\n                <a (click)=\"setTab('passageiros')\" [ngClass]=\"{'active': isTab('passageiros')}\" class=\"item-link\">Passageiros</a>\n            </li>\n            <li class=\"item\" *ngIf=\"deslocamentoTipoId === tipoViagem\">\n                <a (click)=\"setTab('custos')\" [ngClass]=\"{'active': isTab('custos')}\" class=\"item-link\">Custos</a>\n            </li>\n        </ul>\n    </nav>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('detalhes')\">\n        <div *ngIf=\"detail.id\">\n            <p><strong>Tipo da solicitação: </strong><span *ngIf=\"detail.tipo\">{{detail.tipo.Value}}</span> <i *ngIf=\"!detail.tipo\">não cadastrado</i></p>\n            <p><strong>Tipo: </strong><span *ngIf=\"detail.tipoViagem\">{{detail.tipoViagem.tipo}}</span> <i *ngIf=\"!detail.tipoViagem\">não cadastrado</i></p>\n            <p *ngIf=\"deslocamentoTipoId === tipoViagem\"><strong>Título/Ref.: </strong><span *ngIf=\"detail.titulo\">{{detail.titulo}}</span> <i *ngIf=\"!detail.titulo\">não cadastrado</i></p>\n            <p *ngIf=\"deslocamentoTipoId === tipoViagem\"><strong>Número da requisição: </strong><span *ngIf=\"detail.numeroRequisicao\">{{detail.numeroRequisicao}}</span> <i *ngIf=\"!detail.numeroRequisicao\">não cadastrado</i></p>\n            <p *ngIf=\"deslocamentoTipoId === tipoViagem\"><strong>Destino: </strong><span *ngIf=\"detail.destino\">{{detail.destino.destino}}</span> <i *ngIf=\"!detail.destino\">não cadastrado</i></p>\n            <p><strong>Data/hora de saída previsto: </strong> {{detail.dataHoraPrevistaSaida | date: 'dd/MM/yyyy - HH:mm'}} <i *ngIf=\"!detail.dataHoraPrevistaSaida\">não cadastrado</i></p>\n            <p><strong>Data/hora de retorno previsto: </strong> {{detail.dataHoraPrevistaRetorno  | date: 'dd/MM/yyyy - HH:mm'}} <i *ngIf=\"!detail.dataHoraPrevistaRetorno\">não cadastrado</i></p>\n            <p><strong>Com motorista: </strong><span *ngIf=\"detail.enderecoPartidaSolicitante || (deslocamentoTipoId === tipoViagem)\">Sim</span> <i *ngIf=\"!detail.enderecoPartidaSolicitante && (deslocamentoTipoId !== tipoViagem)\">Não</i></p>\n            <p *ngIf=\"detail.enderecoPartidaSolicitante\"><strong>Local onde o motorista deverá buscar o solicitante: </strong><span >{{detail.enderecoPartidaSolicitante}}</span> <i *ngIf=\"!detail.enderecoPartidaSolicitante\">não cadastrado</i></p>\n             <p *ngIf=\"detail.enderecoPartidaVeiculo\"><strong>Local onde o solicitante deverá buscar o veículo: </strong><span >{{detail.enderecoPartidaVeiculo}}</span> <i *ngIf=\"!detail.enderecoPartidaVeiculo\">não cadastrado</i></p>\n            <p *ngIf=\"detail.bem\"><strong>Veículo: </strong><span *ngIf=\"detail.bem\">{{detail.bem.identificacao}}</span> <i *ngIf=\"!detail.bem\">não cadastrado</i></p>\n            <p><strong>Observação: </strong>{{detail.observacao}} <i *ngIf=\"!detail.observacao\">não cadastrado</i></p>\n            <p *ngIf=\"deslocamentoTipoId === tipoViagem\"><strong>Descrição: </strong>{{detail.descricao}} <i *ngIf=\"!detail.descricao\">não cadastrado</i></p>\n            <p *ngIf=\"detail.statusId === statusCancelado\"><strong>Justificativa do cancelamento: </strong>{{detail.justificativa}} <i *ngIf=\"!detail.justificativa\">não cadastrado</i></p>\n            <br />\n            <p *ngIf=\"detail.statusId === statusConcluido\"><strong>Data/hora efetiva de saída: </strong> {{detail.dataHoraEfetivaSaida | date: 'dd/MM/yyyy - HH:mm'}} <i *ngIf=\"!detail.dataHoraEfetivaSaida\">não cadastrado</i></p>\n            <p *ngIf=\"detail.statusId === statusConcluido\"><strong>Data/hora efetiva de retorno: </strong> {{detail.dataHoraEfetivaRetorno | date: 'dd/MM/yyyy - HH:mm'}} <i *ngIf=\"!detail.dataHoraEfetivaRetorno\">não cadastrado</i></p>\n            <p *ngIf=\"detail.statusId === statusConcluido\">\n                <app-odometro-horimetro-label-component [labelHorimetro]=\"'Horímetro de saída: '\"\n                                                        [labelOdometro]=\"'Odômetro de saída: '\"\n                                                        [odometroHorimetroObject]=\"detail.kmSaida\"\n                                                        [bemObject]=\"detail.bem\"></app-odometro-horimetro-label-component>\n            </p>\n            <p *ngIf=\"detail.statusId === statusConcluido\">\n                <app-odometro-horimetro-label-component [labelHorimetro]=\"'Horímetro de retorno: '\"\n                                                        [labelOdometro]=\"'Odômetro de retorno: '\"\n                                                        [odometroHorimetroObject]=\"detail.kmRetorno\"\n                                                        [bemObject]=\"detail.bem\"></app-odometro-horimetro-label-component>\n            </p>\n            <p *ngIf=\"detail.statusId === statusConcluido\"><strong>Horas trabalhadas: </strong> {{detail.horasTrabalhadas}} <i *ngIf=\"!detail.horasTrabalhadas\">não cadastrado</i></p>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('status')\">\n        <form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n            <div class=\"geo-content__row\">\n                <div class=\"geo-columns--12c\">\n                    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !status.valid && submitted}\">\n                        <label for=\"status\">Status <abbr>*</abbr></label>\n                        <div>\n                            <span class=\"error-alert\" *ngIf=\"(!status.valid && submitted)\">Este campo é obrigatório.</span>\n                            <select id=\"status\" [(ngModel)]=\"statusObject\" formControlName=\"status\" (ngModelChange)=\"changeStatus()\">\n                                <option *ngFor=\"let item of statusList\" [ngValue]=\"item\">{{item.Value}}</option>\n                            </select>\n                        </div>\n                    </div>\n\n                    <br />\n\n                    <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !justificativa.valid && submitted}\" *ngIf=\"(statusItem === statusCancelado)\">\n                        <label for=\"justificativa\">Justificativa</label>\n                        <div>\n                            <span class=\"error-alert\" *ngIf=\"(!justificativa.valid && submitted)\">Este campo é obrigatório.</span>\n                            <textarea id=\"justificativa\" [(ngModel)]=\"formObject.justificativa\" formControlName=\"justificativa\"></textarea>\n                        </div>\n                    </div>\n\n                    <div *ngIf=\"(statusItem === statusAprovado)\">\n                        <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !titulo.valid && submitted}\" *ngIf=\"deslocamentoTipoId === tipoViagem\">\n                            <label for=\"titulo\">Título/Ref. <abbr>*</abbr></label>\n                            <div>\n                                <span class=\"error-alert\" *ngIf=\"!titulo.valid && submitted\">Este campo é obrigatório.</span>\n                                <input type=\"text\" id=\"titulo\" [(ngModel)]=\"formObject.titulo\" formControlName=\"titulo\" />\n                            </div>\n                        </div>\n\n                        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !numeroRequisicao.value && submitted}\" *ngIf=\"deslocamentoTipoId === tipoViagem\">\n                            <label for=\"numeroRequisicao\">Número da requisição <abbr>*</abbr></label>\n                            <div>\n                                <span class=\"error-alert\" *ngIf=\"!numeroRequisicao.valid && submitted\">Este campo é obrigatório.</span>\n                                <input type=\"number\" id=\"numeroRequisicao\" [(ngModel)]=\"formObject.numeroRequisicao\" formControlName=\"numeroRequisicao\" />\n                            </div>\n                        </div>\n\n                        <autocomplete-component class=\"geo-input--3c\" id=\"motorista\" *ngIf=\"isDriver\"\n                                                (setObejct)=\"getMotoristasObject($event)\"\n                                                [submitted]=\"submitted\"\n                                                [isRequired]=\"true\"\n                                                [selectId]=\"motoristaSelectId\"\n                                                [model]=\"motoristaObject\"\n                                                [_service]=\"_motoristaApiService\"\n                                                [templateResult]=\"motoristaTemplateResult\"\n                                                [apiCustom]=\"'/populado'\"\n                                                [query]=\"motoristaQuery\"\n                                                [label]=\"'Motorista'\"></autocomplete-component>\n\n                        <autocomplete-component class=\"geo-input--3c\" id=\"frota\"\n                                                (setObejct)=\"getFrotasObject($event)\"\n                                                [submitted]=\"submitted\"\n                                                [isRequired]=\"true\"\n                                                [selectId]=\"frotaSelectId\"\n                                                [model]=\"frotaObject\"\n                                                [_service]=\"_frotaApiService\"\n                                                [templateResult]=\"frotaTemplateResult\"\n                                                [isCreateNew]=\"false\"\n                                                [apiCustom]=\"'/populado'\"\n                                                [query]=\"frotaQuery\"\n                                                [label]=\"'Veículo'\"></autocomplete-component>\n\n                        <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !enderecoPartidaVeiculo.valid && submitted}\" *ngIf=\"!isDriver\">\n                            <label for=\"enderecoPartidaVeiculo\">Local onde o solicitante deverá buscar o veículo <abbr>*</abbr></label>\n                            <div>\n                                <span class=\"error-alert\" *ngIf=\"!enderecoPartidaVeiculo.valid && submitted\">Este campo é obrigatório.</span>\n                                <input type=\"text\" id=\"enderecoPartidaVeiculo\" [(ngModel)]=\"formObject.enderecoPartidaVeiculo\" formControlName=\"enderecoPartidaVeiculo\" />\n                            </div>\n                        </div>\n                    </div>\n\n                    <div *ngIf=\"(statusItem === statusConcluido)\">\n                        <div class=\"geo-input--3c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': !dataSaida.value && submitted}\">\n                            <label for=\"data_saida\">Data efetiva da saída <abbr>*</abbr></label>\n                            <div>\n                                <input type=\"text\" class=\"input-datepicker\" id=\"data_saida\" [(ngModel)]=\"formObject.dataSaida\" formControlName=\"dataSaida\" appDatepicker autocomplete=\"off\" />\n                            </div>\n                        </div>\n\n                        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !horaSaida.value && submitted}\">\n                            <label for=\"hora_saida\">Hora efetiva da saída <abbr>*</abbr></label>\n                            <div>\n                                <span class=\"error-alert\" *ngIf=\"!horaSaida.valid && submitted\">Este campo é obrigatório.</span>\n                                <input type=\"text\" id=\"hora_saida\" [(ngModel)]=\"formObject.horaSaida\" formControlName=\"horaSaida\" appTimepicker maxlength=\"5\" autocomplete=\"off\" />\n                            </div>\n                        </div>\n\n                        <div class=\"geo-input--3c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': !dataRetorno.value && submitted}\">\n                            <label for=\"data_retorno_efetivo\">Data efetiva de retorno <abbr>*</abbr></label>\n                            <div>\n                                <input type=\"text\" class=\"input-datepicker\" id=\"data_retorno_efetivo\" [(ngModel)]=\"formObject.dataRetorno\" formControlName=\"dataRetorno\" appDatepicker autocomplete=\"off\" />\n                            </div>\n                        </div>\n\n                        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !horaRetorno.value && submitted}\">\n                            <label for=\"hora_retorno_efetivo\">Hora efetiva de retorno <abbr>*</abbr></label>\n                            <div>\n                                <span class=\"error-alert\" *ngIf=\"!horaRetorno.valid && submitted\">Este campo é obrigatório.</span>\n                                <input type=\"text\" id=\"hora_retorno_efetivo\" [(ngModel)]=\"formObject.horaRetorno\" formControlName=\"horaRetorno\" appTimepicker maxlength=\"5\" autocomplete=\"off\" />\n                            </div>\n                        </div>\n\n                        <app-odometro-horimetro-form-component [labelOdometro]=\"'Odômetro de saída '\"\n                                                               [labelHorimetro]=\"'Horímetro de saída'\"\n                                                               [showOdometro]=\"true\"\n                                                               [required]=\"true\"\n                                                               [submitted]=\"submitted\"\n                                                               [model]=\"formObject.odometroSaida\"\n                                                               (returnModel)=\"formObject.odometroSaida = $event\"\n                                                               [bemId]=\"frotaObject.id\"></app-odometro-horimetro-form-component>\n\n                        <app-odometro-horimetro-form-component [labelOdometro]=\"'Odômetro de retorno '\"\n                                                               [labelHorimetro]=\"'Horímetro de retorno'\"\n                                                               [showOdometro]=\"true\"\n                                                               [required]=\"true\"\n                                                               [submitted]=\"submitted\"\n                                                               [model]=\"formObject.odometroRetorno\"\n                                                               (returnModel)=\"formObject.odometroRetorno = $event\"\n                                                               [bemId]=\"frotaObject.id\"></app-odometro-horimetro-form-component>\n\n                        <div class=\"geo-input--3c\">\n                            <label for=\"horasTrabalhadas\">Horas trabalhadas </label>\n                            <div>\n                                <input type=\"number\" class=\"form-control\" id=\"horasTrabalhadas\" [(ngModel)]=\"formObject.horasTrabalhadas\" formControlName=\"horasTrabalhadas\">\n                            </div>\n                        </div>\n\n                        <div class=\"geo-input--12c\">\n                            <label for=\"observacao\">Observação</label>\n                            <div>\n                                <textarea id=\"observacao\" [(ngModel)]=\"formObject.observacao\" formControlName=\"observacao\"></textarea>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"geo-content__row\" *ngIf=\"(statusItem !== statusSolicitado)\">\n                <button type=\"submit\" class=\"geo-button button-remove-margin-left\">Salvar</button>\n            </div>\n        </form>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('passageiros')\">\n        <app-passageiro-deslocamento-form-list [list]=\"passageirosList\"\n                                               [isAdm]=\"isAdm\"\n                                               [deslocamentoId]=\"deslocamentoId\"\n                                               [pontosList]=\"pontosList\"\n                                               [isEdition]=\"true\"></app-passageiro-deslocamento-form-list>\n\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('pontos')\">\n        <app-ponto-deslocamento-form-list [list]=\"pontosList\"\n                                          [deslocamentoId]=\"deslocamentoId\"></app-ponto-deslocamento-form-list>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('custos')\">\n        <app-custo-deslocamento-form-list [list]=\"custosList\"\n                                          [deslocamentoId]=\"deslocamentoId\"></app-custo-deslocamento-form-list>\n    </div>\n</div>\n";

/***/ },
/* 659 */
/***/ function(module, exports) {

	module.exports = "app-ponto-table .geo-content__row {\n  padding: 0;\n}\n"

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(202);
	var deslocamento_api_service_1 = __webpack_require__(455);
	var util_service_1 = __webpack_require__(88);
	var deslocamento_service_1 = __webpack_require__(456);
	var funcionario_service_1 = __webpack_require__(214);
	var funcionario_api_service_1 = __webpack_require__(184);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(457);
	var destino_api_service_1 = __webpack_require__(459);
	var frota_service_1 = __webpack_require__(203);
	var frota_api_service_1 = __webpack_require__(368);
	var motorista_api_service_1 = __webpack_require__(209);
	var motorista_service_1 = __webpack_require__(188);
	var data_service_3 = __webpack_require__(458);
	var data_service_4 = __webpack_require__(146);
	var data_service_5 = __webpack_require__(154);
	var deslocamento_navigation_service_1 = __webpack_require__(644);
	var DeslocamentoCalendarComponent = (function () {
	    function DeslocamentoCalendarComponent(_deslocamentosApiService, _deslocamentoService, _deslocamentoNavigationService, _utilService, _funcionarioService, _funcionarioApiService, _destinoApiService, _frotaService, _frotaApiService, _motoristaApiService, _motoristaService, _autocompleteService) {
	        this._deslocamentosApiService = _deslocamentosApiService;
	        this._deslocamentoService = _deslocamentoService;
	        this._deslocamentoNavigationService = _deslocamentoNavigationService;
	        this._utilService = _utilService;
	        this._funcionarioService = _funcionarioService;
	        this._funcionarioApiService = _funcionarioApiService;
	        this._destinoApiService = _destinoApiService;
	        this._frotaService = _frotaService;
	        this._frotaApiService = _frotaApiService;
	        this._motoristaApiService = _motoristaApiService;
	        this._motoristaService = _motoristaService;
	        this._autocompleteService = _autocompleteService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.deslocamentosModuleName = data_service_1.deslocamentosModuleName;
	        this.module = data_service_2.viagensModuleName;
	        this.statusSearch = {};
	        this.statusList = [];
	        this.destinoSearch = {};
	        this.destinoSelectId = 'destino';
	        this.destinoQuery = {};
	        this.frotaSearch = {};
	        this.frotaSelectId = 'frota';
	        this.frotaQuery = {};
	        this.motoristaSearch = {};
	        this.motoristaSelectId = 'motorista';
	        this.motoristaQuery = {};
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.motoristaTemplateResult = (function (state) {
	            var template = this._motoristaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, eItem = void 0, events = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].tipo = this._deslocamentoService.getTipo(Response[x].tipo);
	                    Response[x].status = this._deslocamentoService.getStatus(Response[x].status);
	                    eItem = this.calendarEvents(Response[x]);
	                    events.push(eItem);
	                }
	                this.list = events;
	                this.setCalendarEvents(events);
	            }
	            this.loading = false;
	        }.bind(this));
	    }
	    DeslocamentoCalendarComponent.prototype.ngOnInit = function () {
	        this.destinoQuery = this._utilService.cloneObject(data_service_3.destinosQuery);
	        this.motoristaQuery = this._utilService.cloneObject(data_service_4.motoristasQuery);
	        this.frotaQuery = this._utilService.cloneObject(data_service_5.frotasQuery);
	        this.getStatus();
	        this.clickClearSearch();
	        this.createCalendar();
	    };
	    DeslocamentoCalendarComponent.prototype.changeStatus = function () {
	        this.queryMovimentacoes();
	    };
	    DeslocamentoCalendarComponent.prototype.clickClearSearch = function () {
	        this.statusSearch = this.statusList[1];
	        this.frotaSearch = {};
	        this.destinoSearch = {};
	        this.motoristaSearch = {};
	        this._autocompleteService.setValueOnSelect2(null, "frota");
	        this._autocompleteService.setValueOnSelect2(null, "motorista");
	        this._autocompleteService.setValueOnSelect2(null, "destino");
	        this.queryMovimentacoes();
	    };
	    DeslocamentoCalendarComponent.prototype.getDestinoObject = function (object) {
	        this.destinoSearch = object;
	        this.queryMovimentacoes();
	    };
	    DeslocamentoCalendarComponent.prototype.getFrotaObject = function (object) {
	        this.frotaSearch = object;
	        this.queryMovimentacoes();
	    };
	    DeslocamentoCalendarComponent.prototype.getMotoristaObject = function (object) {
	        this.motoristaSearch = object;
	        this.queryMovimentacoes();
	    };
	    DeslocamentoCalendarComponent.prototype.queryMovimentacoes = function () {
	        var query = { "where": {} };
	        if (this.statusSearch.Key) {
	            if (this.statusSearch.Key === -1) {
	                var statusAprovado = this._deslocamentoService.getStatusAprovado();
	                var statusSolicitado = this._deslocamentoService.getStatusSolicitado();
	                var or = { or: [{ status: statusAprovado }, { status: statusSolicitado }] };
	                if (query.where.and) {
	                    query.where.and.push(or);
	                }
	                else {
	                    query.where.and = [or];
	                }
	            }
	            else {
	                query.where.status = this.statusSearch.Key;
	            }
	        }
	        if (this.destinoSearch.id) {
	            query.where.destinoId = this.destinoSearch.id;
	        }
	        if (this.motoristaSearch.id) {
	            query.where.motoristaDesignadoId = this.motoristaSearch.id;
	        }
	        if (this.frotaSearch.id) {
	            query.where.bemId = this.frotaSearch.id;
	        }
	        this.getMovimentacoes(query);
	    };
	    DeslocamentoCalendarComponent.prototype.getMovimentacoes = function (query) {
	        this.loading = true;
	        this._deslocamentosApiService.onGetByFilter(query, this.onDone);
	    };
	    DeslocamentoCalendarComponent.prototype.getStatus = function () {
	        var list = this._utilService.cloneObject(data_service_1.statusDeslocamentos);
	        var statusAprovado = this._deslocamentoService.getStatusAprovado();
	        var statusSolicitado = this._deslocamentoService.getStatusSolicitado();
	        statusAprovado = this._deslocamentoService.getStatus(statusAprovado);
	        statusSolicitado = this._deslocamentoService.getStatus(statusSolicitado);
	        list.unshift({ Key: -1, Value: 'Ativos (' + statusAprovado.Value + ' e ' + statusSolicitado.Value + ')' });
	        list.unshift({ Key: null, Value: '— Status —' });
	        this.statusList = list;
	        this.statusSearch = this.statusList[1];
	    };
	    DeslocamentoCalendarComponent.prototype.createCalendar = function () {
	        var c = this._deslocamentoNavigationService;
	        $('#calendar').fullCalendar({
	            header: {
	                left: 'prev,next today',
	                center: 'title',
	                right: 'month,basicWeek,basicDay'
	            },
	            locale: 'pt-br',
	            height: 'auto',
	            events: [],
	            timeFormat: 'H:mm',
	            eventRender: function (event, element) {
	                var t = element.find('.fc-title');
	                t.html(t.text());
	            },
	            eventClick: function (calEvent, jsEvent, view) {
	                c.goToDetail(calEvent.id);
	            }
	        });
	    };
	    DeslocamentoCalendarComponent.prototype.setCalendarEvents = function (events) {
	        $('#calendar').fullCalendar('removeEventSources');
	        $('#calendar').fullCalendar('addEventSource', events);
	    };
	    DeslocamentoCalendarComponent.prototype.calendarEvents = function (item) {
	        var tipo = '', motorista = '', destino = '', status = '', title;
	        if (item.tipo) {
	            tipo = item.tipo.Value;
	        }
	        if (item.status) {
	            status = " - " + item.status.Value + "<br />";
	        }
	        if (item.destino) {
	            destino = "Destino: " + item.destino.destino + "<br />";
	        }
	        if (item.motoristaDesignado) {
	            if (item.motoristaDesignado.funcionario) {
	                if (item.motoristaDesignado.funcionario.pessoa) {
	                    motorista = "Motorista: " + item.motoristaDesignado.funcionario.pessoa.nome;
	                }
	            }
	        }
	        title = tipo + "" + status + "" + destino + "" + motorista;
	        var event = {
	            id: item.id,
	            title: title,
	            start: item.dataHoraPrevistaSaida,
	            end: item.dataHoraPrevistaRetorno,
	            color: '#4C87FF',
	            textColor: '#FFFFFF'
	        };
	        return event;
	    };
	    DeslocamentoCalendarComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(661),
	            styles: [__webpack_require__(662)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof deslocamento_api_service_1.DeslocamentoApiService !== 'undefined' && deslocamento_api_service_1.DeslocamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof deslocamento_service_1.DeslocamentoService !== 'undefined' && deslocamento_service_1.DeslocamentoService) === 'function' && _b) || Object, (typeof (_c = typeof deslocamento_navigation_service_1.DeslocamentoNavigationService !== 'undefined' && deslocamento_navigation_service_1.DeslocamentoNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof funcionario_service_1.FuncionarioService !== 'undefined' && funcionario_service_1.FuncionarioService) === 'function' && _e) || Object, (typeof (_f = typeof funcionario_api_service_1.FuncionarioApiService !== 'undefined' && funcionario_api_service_1.FuncionarioApiService) === 'function' && _f) || Object, (typeof (_g = typeof destino_api_service_1.DestinoApiService !== 'undefined' && destino_api_service_1.DestinoApiService) === 'function' && _g) || Object, (typeof (_h = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _h) || Object, (typeof (_j = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _j) || Object, (typeof (_k = typeof motorista_api_service_1.MotoristaApiService !== 'undefined' && motorista_api_service_1.MotoristaApiService) === 'function' && _k) || Object, (typeof (_l = typeof motorista_service_1.MotoristaService !== 'undefined' && motorista_service_1.MotoristaService) === 'function' && _l) || Object, (typeof (_m = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _m) || Object])
	    ], DeslocamentoCalendarComponent);
	    return DeslocamentoCalendarComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
	}());
	exports.DeslocamentoCalendarComponent = DeslocamentoCalendarComponent;


/***/ },
/* 661 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">Agenda</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>Agenda</h1>\n\n        <!--<label class=\"geo-switch\">-->\n            <!--<span class=\"geo-switch&#45;&#45;label\">Exibir inativos:</span>-->\n            <!--<input type=\"checkbox\" [(ngModel)]=\"showDisabled\">-->\n            <!--<div class=\"geo-switch&#45;&#45;checkbox\">-->\n                <!--<span class=\"geo-switch&#45;&#45;status\"></span>-->\n            <!--</div>-->\n        <!--</label>-->\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"motorista\"\n                                (setObejct)=\"getMotoristaObject($event)\"\n                                (clearObject)=\"getMotoristaObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"motoristaSelectId\"\n                                [model]=\"motoristaSearch\"\n                                [_service]=\"_motoristaApiService\"\n                                [query]=\"motoristaQuery\"\n                                [templateResult]=\"motoristaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'— Motorista —'\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"frota\"\n                                (setObejct)=\"getFrotaObject($event)\"\n                                (clearObject)=\"getFrotaObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"frotaSearch\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'— Veículo —'\"\n                                [query]=\"frotaQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"destino\"\n                                (setObejct)=\"getDestinoObject($event)\"\n                                (clearObject)=\"getDestinoObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"destinoSelectId\"\n                                [model]=\"destinoSearch\"\n                                [_service]=\"_destinoApiService\"\n                                [fieldToShow]=\"'destino'\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'— Destino —'\"\n                                [query]=\"destinoQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"status\" [(ngModel)]=\"statusSearch\" (ngModelChange)=\"changeStatus()\" class=\"option_{{statusSearch.Key}}\">\n                    <option *ngFor=\"let item of statusList\" id=\"status_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c geo-columns--right\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickClearSearch()\" class=\"cursor-pointer clear-search\">Limpar busca</a>\n        </p>\n    </div>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{deslocamentosModuleName.single | lowercase}} encontrada</p>\n\n</div>\n\n<div class=\"geo-content__row\">\n    <div id='calendar'></div>\n</div>";

/***/ },
/* 662 */
/***/ function(module, exports) {

	module.exports = ".cursor-pointer {\n    cursor: pointer;\n}\n.advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}\n"

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(625);
	var data_service_2 = __webpack_require__(457);
	var ponto_navigation_service_1 = __webpack_require__(631);
	var data_service_3 = __webpack_require__(178);
	var data_service_4 = __webpack_require__(458);
	var destino_navigation_service_1 = __webpack_require__(664);
	var data_service_5 = __webpack_require__(651);
	var passageiro_navigation_service_1 = __webpack_require__(665);
	var ViagemConfiguracaoComponent = (function () {
	    function ViagemConfiguracaoComponent(_pontoService, _destinoService, _passageiroService) {
	        this._pontoService = _pontoService;
	        this._destinoService = _destinoService;
	        this._passageiroService = _passageiroService;
	        this.module = data_service_2.viagensModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	        this.pontoModule = data_service_1.pontosModuleName;
	        this.destinoModule = data_service_4.destinosModuleName;
	        this.passageiroModule = data_service_5.passageirosModuleName;
	    }
	    ViagemConfiguracaoComponent.prototype.ngOnInit = function () {
	    };
	    ViagemConfiguracaoComponent.prototype.clickItem = function (module) {
	        if (module.plural === this.pontoModule.plural) {
	            this._pontoService.goToList();
	        }
	        else if (module.plural === this.destinoModule.plural) {
	            this._destinoService.goToList();
	        }
	        else if (module.plural === this.passageiroModule.plural) {
	            this._passageiroService.goToList();
	        }
	    };
	    ViagemConfiguracaoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(666),
	            styles: [__webpack_require__(667)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ponto_navigation_service_1.PontoNavigationService !== 'undefined' && ponto_navigation_service_1.PontoNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof destino_navigation_service_1.DestinoNavigationService !== 'undefined' && destino_navigation_service_1.DestinoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof passageiro_navigation_service_1.PassageiroNavigationService !== 'undefined' && passageiro_navigation_service_1.PassageiroNavigationService) === 'function' && _c) || Object])
	    ], ViagemConfiguracaoComponent);
	    return ViagemConfiguracaoComponent;
	    var _a, _b, _c;
	}());
	exports.ViagemConfiguracaoComponent = ViagemConfiguracaoComponent;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(458);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(457);
	var DestinoNavigationService = (function () {
	    function DestinoNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.destinosRoute;
	        this.fatherRouter = data_service_3.viagensRoute;
	        this.configuracaoRoute = data_service_2.configuracaoRoute;
	    }
	    DestinoNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    DestinoNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    DestinoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    DestinoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], DestinoNavigationService);
	    return DestinoNavigationService;
	    var _a;
	}());
	exports.DestinoNavigationService = DestinoNavigationService;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(651);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(457);
	var PassageiroNavigationService = (function () {
	    function PassageiroNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.passageirosRoute;
	        this.fatherRouter = data_service_3.viagensRoute;
	        this.configuracaoRouter = data_service_2.configuracaoRoute;
	    }
	    PassageiroNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRouter + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    PassageiroNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRouter + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    PassageiroNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.configuracaoRouter + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    PassageiroNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], PassageiroNavigationService);
	    return PassageiroNavigationService;
	    var _a;
	}());
	exports.PassageiroNavigationService = PassageiroNavigationService;


/***/ },
/* 666 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a class=\"active\">{{configuracaoModule.plural}}</a></li>\n    </ul>\n\n    <h1>{{configuracaoModule.plural}} de {{module.plural | lowercase}}</h1>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(destinoModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{destinoModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{destinoModule.plural | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(passageiroModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{passageiroModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{passageiroModule.plural | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(pontoModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{pontoModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{pontoModule.plural | lowercase}}\n        </div>\n    </div>\n</div>";

/***/ },
/* 667 */
166,
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var DestinosComponent = (function () {
	    function DestinosComponent() {
	    }
	    DestinosComponent.prototype.ngOnInit = function () {
	    };
	    DestinosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(669)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DestinosComponent);
	    return DestinosComponent;
	}());
	exports.DestinosComponent = DestinosComponent;


/***/ },
/* 669 */
171,
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var destino_list_component_1 = __webpack_require__(671);
	var destino_form_component_1 = __webpack_require__(675);
	var data_service_1 = __webpack_require__(178);
	var DestinosRoutingModule = (function () {
	    function DestinosRoutingModule() {
	    }
	    DestinosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DestinosRoutingModule);
	    return DestinosRoutingModule;
	}());
	exports.DestinosRoutingModule = DestinosRoutingModule;
	exports.destinosRoutes = [
	    {
	        path: '',
	        component: destino_list_component_1.DestinoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: destino_form_component_1.DestinoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: destino_form_component_1.DestinoFormComponent
	    }
	];


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(458);
	var destino_api_service_1 = __webpack_require__(459);
	var destino_navigation_service_1 = __webpack_require__(664);
	var destino_service_1 = __webpack_require__(672);
	var viagem_service_1 = __webpack_require__(633);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(457);
	var util_service_1 = __webpack_require__(88);
	var DestinoListComponent = (function () {
	    function DestinoListComponent(_destinosApiService, _destinoNavigationService, _destinoService, _viagemService, _utilService) {
	        this._destinosApiService = _destinosApiService;
	        this._destinoNavigationService = _destinoNavigationService;
	        this._destinoService = _destinoService;
	        this._viagemService = _viagemService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.destinosModuleName = data_service_1.destinosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.viagensModuleName;
	    }
	    DestinoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    DestinoListComponent.prototype.clickGoToConfig = function () {
	        this._viagemService.goToSetting();
	    };
	    DestinoListComponent.prototype.clickNew = function () {
	        this._destinoService.clearSessionStorage();
	        this._destinoNavigationService.goToNew();
	    };
	    DestinoListComponent.prototype.clickEdit = function (item) {
	        this._destinoService.clearSessionStorage();
	        this._destinoNavigationService.goToEdit(item.id);
	    };
	    DestinoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    DestinoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._destinosApiService.onGetAll(onDone);
	    };
	    DestinoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._destinosApiService.onDelete(item.id, onDone);
	    };
	    DestinoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(673),
	            styles: [__webpack_require__(674)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof destino_api_service_1.DestinoApiService !== 'undefined' && destino_api_service_1.DestinoApiService) === 'function' && _a) || Object, (typeof (_b = typeof destino_navigation_service_1.DestinoNavigationService !== 'undefined' && destino_navigation_service_1.DestinoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof destino_service_1.DestinoService !== 'undefined' && destino_service_1.DestinoService) === 'function' && _c) || Object, (typeof (_d = typeof viagem_service_1.ViagemService !== 'undefined' && viagem_service_1.ViagemService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], DestinoListComponent);
	    return DestinoListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.DestinoListComponent = DestinoListComponent;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(458);
	var autocomplete_service_1 = __webpack_require__(101);
	var DestinoService = (function () {
	    function DestinoService(_autocompleteService) {
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    DestinoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.destinosStorage + '-new', object);
	    };
	    DestinoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.destinosStorage + "-new");
	        return JSON.parse(item);
	    };
	    DestinoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.destinosStorage + "-new");
	    };
	    DestinoService.prototype.returnToOtherForm = function (otherForm, Response) {
	        //     let otherFormObject: any;
	        // if(Response) {
	        //     if (otherForm === destinosTrajetosStorage) {
	        //         otherFormObject = this._destinoTrajetoService.getSessionStorage();
	        //         otherFormObject.destino = Response;
	        //         this._destinoTrajetoService.setSessionStorage(otherFormObject);
	        //     }
	        // }
	        //
	        // this._autocompleteService.clearSessionStorage(destinosTrajetosStorage);
	        //
	        // if (otherForm === destinosTrajetosStorage) {
	        //     otherFormObject = this._destinoTrajetoService.getSessionStorage();
	        //     if (otherFormObject.id) {
	        //         this._destinoTrajetoNavigationService.goToEdit(otherFormObject.id);
	        //     } else {
	        //         this._destinoTrajetoNavigationService.goToNew();
	        //     }
	        // }
	    };
	    DestinoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object])
	    ], DestinoService);
	    return DestinoService;
	    var _a;
	}());
	exports.DestinoService = DestinoService;


/***/ },
/* 673 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{destinosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>{{destinosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n\n<div class=\"geo-content__row\" >\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{destinosModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Destino</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['destino'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.destino}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div>\n                    <p><strong>Observação:</strong> {{item.observacao}} <i *ngIf=\"!item.observacao\">não cadastrado</i></p>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 674 */
166,
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(458);
	var destino_model_1 = __webpack_require__(649);
	var data_service_2 = __webpack_require__(178);
	var destino_navigation_service_1 = __webpack_require__(664);
	var destino_api_service_1 = __webpack_require__(459);
	var destino_service_1 = __webpack_require__(672);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_3 = __webpack_require__(457);
	var viagem_service_1 = __webpack_require__(633);
	var DestinoFormComponent = (function () {
	    function DestinoFormComponent(_route, _destinoNavigationService, _destinoApiService, _destinoService, _utilService, _autocompleteService, _viagemService, _fb) {
	        this._route = _route;
	        this._destinoNavigationService = _destinoNavigationService;
	        this._destinoApiService = _destinoApiService;
	        this._destinoService = _destinoService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._viagemService = _viagemService;
	        this._fb = _fb;
	        this.destinosModule = data_service_1.destinosModuleName;
	        this.formObject = new destino_model_1.Destino();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.viagensModuleName;
	        this.ativo = new forms_1.FormControl('');
	        this.destino = new forms_1.FormControl('', forms_1.Validators.required);
	        this.observacao = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseDestino = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            destino: this.destino,
	            observacao: this.observacao
	        });
	    }
	    DestinoFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    DestinoFormComponent.prototype.clickGoToConfig = function () {
	        this._viagemService.goToSetting();
	    };
	    DestinoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    DestinoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    DestinoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEditDestino(object);
	            }
	            else {
	                this.onAddDestino(object);
	            }
	        }
	    };
	    DestinoFormComponent.prototype.onAddDestino = function (object) {
	        this._destinoApiService.onPost(object, this.onDone);
	    };
	    DestinoFormComponent.prototype.onEditDestino = function (object) {
	        this._destinoApiService.onPut(object, this.onDone);
	    };
	    DestinoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum destino encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._destinoApiService.onGetById(id, onDone);
	    };
	    DestinoFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._destinoService.getSessionStorage();
	        this._destinoService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    DestinoFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._destinoService.returnToOtherForm(this.otherForm, this.responseDestino);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    DestinoFormComponent.prototype.goToList = function () {
	        this._destinoNavigationService.goToList();
	    };
	    DestinoFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.destinosStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.destino = newAutoComplete.destino;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    DestinoFormComponent.prototype.setModelToForm = function () {
	    };
	    DestinoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    DestinoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    DestinoFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    DestinoFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    DestinoFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    DestinoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(676),
	            styles: [__webpack_require__(677)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof destino_navigation_service_1.DestinoNavigationService !== 'undefined' && destino_navigation_service_1.DestinoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof destino_api_service_1.DestinoApiService !== 'undefined' && destino_api_service_1.DestinoApiService) === 'function' && _c) || Object, (typeof (_d = typeof destino_service_1.DestinoService !== 'undefined' && destino_service_1.DestinoService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof viagem_service_1.ViagemService !== 'undefined' && viagem_service_1.ViagemService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object])
	    ], DestinoFormComponent);
	    return DestinoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.DestinoFormComponent = DestinoFormComponent;


/***/ },
/* 676 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{destinosModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{destinosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{destinosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !destino.valid && submitted}\">\n            <label for=\"destino\">Destino <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!destino.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"destino\"[(ngModel)]=\"formObject.destino\" formControlName=\"destino\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\">\n            <label for=\"descricao\">Observação </label>\n            <div>\n                <textarea id=\"descricao\" [(ngModel)]=\"formObject.observacao\" formControlName=\"observacao\"></textarea>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 677 */
551,
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PassageirosComponent = (function () {
	    function PassageirosComponent() {
	    }
	    PassageirosComponent.prototype.ngOnInit = function () {
	    };
	    PassageirosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(679)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PassageirosComponent);
	    return PassageirosComponent;
	}());
	exports.PassageirosComponent = PassageirosComponent;


/***/ },
/* 679 */
171,
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var passageiro_list_component_1 = __webpack_require__(681);
	var passageiro_form_component_1 = __webpack_require__(684);
	var data_service_1 = __webpack_require__(178);
	var PassageirosRoutingModule = (function () {
	    function PassageirosRoutingModule() {
	    }
	    PassageirosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PassageirosRoutingModule);
	    return PassageirosRoutingModule;
	}());
	exports.PassageirosRoutingModule = PassageirosRoutingModule;
	exports.passageirosRoutes = [
	    {
	        path: '',
	        component: passageiro_list_component_1.PassageiroListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: passageiro_form_component_1.PassageiroFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: passageiro_form_component_1.PassageiroFormComponent
	    }
	];


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(651);
	var passageiro_api_service_1 = __webpack_require__(650);
	var passageiro_navigation_service_1 = __webpack_require__(665);
	var util_service_1 = __webpack_require__(88);
	var endereco_service_1 = __webpack_require__(229);
	var data_service_2 = __webpack_require__(457);
	var data_service_3 = __webpack_require__(178);
	var viagem_service_1 = __webpack_require__(633);
	var PassageiroListComponent = (function () {
	    function PassageiroListComponent(_passageirosApiService, _passageiroNavigationService, _enderecoService, _viagemService, _utilService) {
	        this._passageirosApiService = _passageirosApiService;
	        this._passageiroNavigationService = _passageiroNavigationService;
	        this._enderecoService = _enderecoService;
	        this._viagemService = _viagemService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.passageirosModuleName = data_service_1.passageirosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	        this.module = data_service_2.viagensModuleName;
	    }
	    PassageiroListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    PassageiroListComponent.prototype.clickNew = function () {
	        this._passageiroNavigationService.goToNew();
	    };
	    PassageiroListComponent.prototype.clickEdit = function (item) {
	        this._passageiroNavigationService.goToEdit(item.id);
	    };
	    PassageiroListComponent.prototype.clickGoToConfig = function () {
	        this._viagemService.goToSetting();
	    };
	    PassageiroListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    PassageiroListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.forEach(function (item) {
	                    if (item.endereco) {
	                        item.address = this._enderecoService.getAddress(item.endereco);
	                    }
	                }.bind(this));
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._passageirosApiService.onGetAll(onDone);
	    };
	    PassageiroListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._passageirosApiService.onDelete(item.id, onDone);
	    };
	    PassageiroListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(682),
	            styles: [__webpack_require__(683)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof passageiro_api_service_1.PassageiroApiService !== 'undefined' && passageiro_api_service_1.PassageiroApiService) === 'function' && _a) || Object, (typeof (_b = typeof passageiro_navigation_service_1.PassageiroNavigationService !== 'undefined' && passageiro_navigation_service_1.PassageiroNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _c) || Object, (typeof (_d = typeof viagem_service_1.ViagemService !== 'undefined' && viagem_service_1.ViagemService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], PassageiroListComponent);
	    return PassageiroListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.PassageiroListComponent = PassageiroListComponent;


/***/ },
/* 682 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{passageirosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>{{passageirosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{passageirosModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Nome</th>\n            <th>CPF</th>\n            <th>Telefone</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['nome','cpf','telefone'] | filterActive:showDisabled | sort:['nome'])\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span> {{item.nome}}</td>\n            <td>{{item.cpf | cpfMask}}</td>\n            <td>{{item.telefone | phoneMask}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div>\n                    <p><strong>RG: </strong> {{item.rg}} <i *ngIf=\"!item.rg\">não cadastrado</i></p>\n                    <p><strong>Órgão expedidor: </strong> {{item.rgOrgaoExpedidor}} <i *ngIf=\"!item.rgOrgaoExpedidor\">não cadastrado</i></p>\n                    <p><strong>Email: </strong> {{item.email}} <i *ngIf=\"!item.email\">não cadastrado</i></p>\n                    <p><strong>Data de nascimento: </strong> {{item.dataNascimento | date:'dd/MM/yyyy'}} <i *ngIf=\"!item.dataNascimento\">não cadastrado</i></p>\n                    <p><strong>Endereço: </strong> {{item.address}} <i *ngIf=\"!item.address\">não cadastrado</i></p>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 683 */
166,
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(651);
	var passageiro_model_1 = __webpack_require__(685);
	var data_service_2 = __webpack_require__(178);
	var passageiro_navigation_service_1 = __webpack_require__(665);
	var passageiro_api_service_1 = __webpack_require__(650);
	var phone_validation_1 = __webpack_require__(92);
	var email_validation_1 = __webpack_require__(91);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var passageiro_service_1 = __webpack_require__(686);
	var cpf_validation_1 = __webpack_require__(116);
	var endereco_model_1 = __webpack_require__(240);
	var endereco_service_1 = __webpack_require__(229);
	var data_service_3 = __webpack_require__(457);
	var viagem_service_1 = __webpack_require__(633);
	var PassageiroFormComponent = (function () {
	    function PassageiroFormComponent(_route, _passageiroNavigationService, _passageiroApiService, _enderecoService, _utilService, _autocompleteService, _passageiroService, _viagemService, _fb) {
	        this._route = _route;
	        this._passageiroNavigationService = _passageiroNavigationService;
	        this._passageiroApiService = _passageiroApiService;
	        this._enderecoService = _enderecoService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._passageiroService = _passageiroService;
	        this._viagemService = _viagemService;
	        this._fb = _fb;
	        this.passageirosModule = data_service_1.passageirosModuleName;
	        this.formObject = new passageiro_model_1.Passageiro();
	        this.formObjectToSave = new passageiro_model_1.Passageiro();
	        this.enderecoObject = new endereco_model_1.Endereco();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.viagensModuleName;
	        this.nome = new forms_1.FormControl('', forms_1.Validators.required);
	        this.dataNascimento = new forms_1.FormControl('');
	        this.ativo = new forms_1.FormControl('');
	        this.email = new forms_1.FormControl('', forms_1.Validators.compose([email_validation_1.EmailValidator.emailFormat]));
	        this.rg = new forms_1.FormControl('');
	        this.rgOrgaoExpedidor = new forms_1.FormControl('');
	        this.telefone = new forms_1.FormControl('', forms_1.Validators.compose([phone_validation_1.PhoneValidator.phoneFormat]));
	        this.cpf = new forms_1.FormControl('', forms_1.Validators.compose([cpf_validation_1.CpfValidator.cpfFormat]));
	        this.returnToOtherForm = false;
	        this.onDoneEndereco = (function (Response) {
	            if (!Response.error) {
	                this.formObjectToSave.enderecoId = Response.id;
	                if (this.formObject.id) {
	                    this.onEditPassageiro();
	                }
	                else {
	                    this.onAddPassageiro();
	                }
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responsePassageiro = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            email: this.email,
	            nome: this.nome,
	            dataNascimento: this.dataNascimento,
	            rg: this.rg,
	            rgOrgaoExpedidor: this.rgOrgaoExpedidor,
	            telefone: this.telefone,
	            cpf: this.cpf
	        });
	    }
	    PassageiroFormComponent.prototype.ngOnInit = function () {
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	            this.getObject(id);
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	            this.isNewAutoComplete();
	        }
	    };
	    PassageiroFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    PassageiroFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    PassageiroFormComponent.prototype.clickGoToConfig = function () {
	        this._viagemService.goToSetting();
	    };
	    PassageiroFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (object.telefone) {
	                object.telefone = this._utilService.removeSpecialCharacter(object.telefone);
	            }
	            if (object.cpf) {
	                object.cpf = this._utilService.removeSpecialCharacter(object.cpf);
	            }
	            var date = document.getElementById('dataNascimento');
	            if (date.value) {
	                object.dataNascimento = this._utilService.convertStringToDate(date.value);
	            }
	            this.formObjectToSave = object;
	            this._enderecoService.onSubmit(this.enderecoObject, this.onDoneEndereco);
	        }
	    };
	    PassageiroFormComponent.prototype.onAddPassageiro = function () {
	        this._passageiroApiService.onPost(this.formObjectToSave, this.onDone);
	    };
	    PassageiroFormComponent.prototype.onEditPassageiro = function () {
	        this._passageiroApiService.onPut(this.formObjectToSave, this.onDone);
	    };
	    PassageiroFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (Response.dataNascimento) {
	                    Response.dataNascimento = this._utilService.convertDateToString(Response.dataNascimento);
	                }
	                this.formObject = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum passageiro encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._passageiroApiService.onGetById(id, onDone);
	    };
	    PassageiroFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.passageirosStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.nome = newAutoComplete.nome;
	        }
	    };
	    PassageiroFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._passageiroService.returnToOtherForm(this.otherForm, this.responsePassageiro);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    PassageiroFormComponent.prototype.goToList = function () {
	        this._passageiroNavigationService.goToList();
	    };
	    PassageiroFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(687),
	            styles: [__webpack_require__(688)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof passageiro_navigation_service_1.PassageiroNavigationService !== 'undefined' && passageiro_navigation_service_1.PassageiroNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof passageiro_api_service_1.PassageiroApiService !== 'undefined' && passageiro_api_service_1.PassageiroApiService) === 'function' && _c) || Object, (typeof (_d = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof passageiro_service_1.PassageiroService !== 'undefined' && passageiro_service_1.PassageiroService) === 'function' && _g) || Object, (typeof (_h = typeof viagem_service_1.ViagemService !== 'undefined' && viagem_service_1.ViagemService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], PassageiroFormComponent);
	    return PassageiroFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.PassageiroFormComponent = PassageiroFormComponent;


/***/ },
/* 685 */
/***/ function(module, exports) {

	"use strict";
	var Passageiro = (function () {
	    function Passageiro() {
	    }
	    return Passageiro;
	}());
	exports.Passageiro = Passageiro;
	var PassageiroDeslocamento = (function () {
	    function PassageiroDeslocamento() {
	    }
	    return PassageiroDeslocamento;
	}());
	exports.PassageiroDeslocamento = PassageiroDeslocamento;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(651);
	var autocomplete_service_1 = __webpack_require__(101);
	var PassageiroService = (function () {
	    function PassageiroService(_autocompleteService) {
	        this._autocompleteService = _autocompleteService;
	        this.templateResult = (function (state, isCreateNew) {
	            var stateReturn, text;
	            if (state.loading) {
	                stateReturn = state.text;
	            }
	            else {
	                if (state.id === -1) {
	                    if (isCreateNew) {
	                        stateReturn = this._autocompleteService.setNewTagInList(state);
	                    }
	                    else {
	                        stateReturn = this._autocompleteService.setNoCreateNew(state.text);
	                    }
	                }
	                else {
	                    if (state.text) {
	                        text = state.text;
	                    }
	                    else {
	                        var name = state.nome;
	                        text = name;
	                    }
	                    stateReturn = $('<span>' + text + '</span>');
	                }
	            }
	            return stateReturn;
	        }.bind(this));
	    }
	    //session
	    PassageiroService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.passageirosStorage + '-new', object);
	    };
	    PassageiroService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.passageirosStorage + "-new");
	        return JSON.parse(item);
	    };
	    PassageiroService.prototype.returnToOtherForm = function (otherForm, Response) {
	    };
	    PassageiroService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object])
	    ], PassageiroService);
	    return PassageiroService;
	    var _a;
	}());
	exports.PassageiroService = PassageiroService;


/***/ },
/* 687 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{passageirosModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{passageirosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{passageirosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados do {{passageirosModule.single}}</h2>\n        <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !nome.valid && submitted}\">\n            <label for=\"nome\">Nome <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!nome.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"nome\" [(ngModel)]=\"formObject.nome\" formControlName=\"nome\" autofocus>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c geo-input--datepicker\">\n            <label for=\"dataNascimento\">Data de nascimento</label>\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"dataNascimento\" [(ngModel)]=\"formObject.dataNascimento\" formControlName=\"dataNascimento\" appDatepicker autocomplete=\"off\" />\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !telefone.valid && submitted}\">\n            <label for=\"telefone\">Telefone</label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!telefone.valid && submitted\">Número de telefone inválido.</span>\n                <input type=\"text\" id=\"telefone\" [(ngModel)]=\"formObject.telefone\" formControlName=\"telefone\" appPhoneMask maxlength=\"15\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !email.valid && submitted}\">\n            <label for=\"email\">Email</label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!email.valid && submitted\">Email inválido.</span>\n                <input type=\"text\" id=\"email\" [(ngModel)]=\"formObject.email\" formControlName=\"email\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !cpf.valid && submitted}\">\n            <label for=\"rg\">CPF</label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!cpf.valid && submitted\">CPF inválido.</span>\n                <input type=\"text\" id=\"cpf\" [(ngModel)]=\"formObject.cpf\" formControlName=\"cpf\" appCpfMask maxlength=\"14\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" >\n            <label for=\"rg\">RG</label>\n            <div>\n                <input type=\"text\" id=\"rg\" [(ngModel)]=\"formObject.rg\" formControlName=\"rg\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" >\n            <label for=\"rgOrgaoExpedidor\">Órgão expedidor</label>\n            <div>\n                <input type=\"text\" id=\"rgOrgaoExpedidor\" [(ngModel)]=\"formObject.rgOrgaoExpedidor\" formControlName=\"rgOrgaoExpedidor\">\n            </div>\n        </div>\n    </div>\n\n    <app-endereco-form [formObject]=\"enderecoObject\"></app-endereco-form>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 688 */
206,
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var usuario_change_component_1 = __webpack_require__(690);
	var UsuariosRoutingModule = (function () {
	    function UsuariosRoutingModule() {
	    }
	    UsuariosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], UsuariosRoutingModule);
	    return UsuariosRoutingModule;
	}());
	exports.UsuariosRoutingModule = UsuariosRoutingModule;
	exports.usuariosRoutes = [
	    {
	        path: 'trocar',
	        component: usuario_change_component_1.UsuarioChangeComponent
	    }
	];


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(50);
	var data_service_2 = __webpack_require__(87);
	var UsuarioChangeComponent = (function () {
	    function UsuarioChangeComponent(_dataService, _router) {
	        this._dataService = _dataService;
	        this._router = _router;
	        this.usuariosModuleName = data_service_2.usuariosModuleName;
	        this.userAdm = 'eyJhbGciOiJIUzI1NiJ9.MTgw.0dhL7CSKEEdznJW9AbFAFsBW3kwKBlnWBAXjUkq65is';
	        this.userVisitante = 'eyJhbGciOiJIUzI1NiJ9.MTgx.YlwDOqAiNUqzozngn-VTvhoYJ-9xNJpTQ48AOSZKknc';
	    }
	    UsuarioChangeComponent.prototype.ngOnInit = function () {
	    };
	    UsuarioChangeComponent.prototype.clickVisitor = function () {
	        this._dataService.setToken(this.userVisitante);
	        var tenant = this.getCurrentyTenant();
	        var router = tenant + '/visitante';
	        this._router.navigate([router]);
	    };
	    UsuarioChangeComponent.prototype.clickAdm = function () {
	        this._dataService.setToken(this.userAdm);
	        var tenant = this.getCurrentyTenant();
	        var router = tenant + '/';
	        this._router.navigate([router]);
	    };
	    UsuarioChangeComponent.prototype.getCurrentyTenant = function () {
	        var tenants = this._dataService.getTenants();
	        var url = this._router.url;
	        var x, lenX;
	        for (x = 0, lenX = tenants.length; x < lenX; x++) {
	            if (url.indexOf(tenants[x]) !== -1) {
	                return tenants[x];
	            }
	        }
	    };
	    UsuarioChangeComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(691),
	            styles: [__webpack_require__(692)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof data_service_1.DataService !== 'undefined' && data_service_1.DataService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], UsuarioChangeComponent);
	    return UsuarioChangeComponent;
	    var _a, _b;
	}());
	exports.UsuarioChangeComponent = UsuarioChangeComponent;


/***/ },
/* 691 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <h1>{{usuariosModuleName.plural}}</h1>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button\" (click)=\"clickAdm()\">Administrador</button>\n    <button type=\"submit\" class=\"geo-button\" (click)=\"clickVisitor()\">Visitante</button>\n</div>\n";

/***/ },
/* 692 */
166,
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var UsuariosComponent = (function () {
	    function UsuariosComponent() {
	    }
	    UsuariosComponent.prototype.ngOnInit = function () {
	    };
	    UsuariosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(694)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], UsuariosComponent);
	    return UsuariosComponent;
	}());
	exports.UsuariosComponent = UsuariosComponent;


/***/ },
/* 694 */
171,
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(429);
	var data_service_2 = __webpack_require__(178);
	var manutencao_configuracao_component_1 = __webpack_require__(696);
	var auth_guard_service_1 = __webpack_require__(89);
	var servicos_component_1 = __webpack_require__(700);
	var servicos_routing_module_1 = __webpack_require__(702);
	var data_service_3 = __webpack_require__(201);
	var planos_component_1 = __webpack_require__(711);
	var planos_routing_module_1 = __webpack_require__(713);
	var data_service_4 = __webpack_require__(200);
	var ordens_servico_component_1 = __webpack_require__(721);
	var ordens_servico_routing_module_1 = __webpack_require__(723);
	var data_service_5 = __webpack_require__(423);
	var manutencao_programada_component_1 = __webpack_require__(730);
	var manutencao_programada_routing_module_1 = __webpack_require__(732);
	var ManutencoesRoutingModule = (function () {
	    function ManutencoesRoutingModule() {
	    }
	    ManutencoesRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ManutencoesRoutingModule);
	    return ManutencoesRoutingModule;
	}());
	exports.ManutencoesRoutingModule = ManutencoesRoutingModule;
	exports.manutencoesRoutes = [
	    {
	        path: '',
	        redirectTo: '/' + data_service_1.servicosRoute,
	        pathMatch: 'full'
	    }, {
	        path: data_service_2.configuracaoRoute,
	        component: manutencao_configuracao_component_1.ManutencaoConfiguracaoComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService]
	    }, {
	        path: data_service_2.configuracaoRoute + '/' + data_service_1.servicosRoute,
	        component: servicos_component_1.ServicosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: servicos_routing_module_1.servicosRoutes
	    }, {
	        path: data_service_2.configuracaoRoute + '/' + data_service_3.planosRoute,
	        component: planos_component_1.PlanosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: planos_routing_module_1.planosRoutes
	    }, {
	        path: data_service_1.servicosRoute,
	        component: servicos_component_1.ServicosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: servicos_routing_module_1.servicosRoutes
	    }, {
	        path: data_service_3.planosRoute,
	        component: planos_component_1.PlanosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: planos_routing_module_1.planosRoutes
	    }, {
	        path: data_service_4.ordensServicoRoute,
	        component: ordens_servico_component_1.OrdensServicoComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: ordens_servico_routing_module_1.ordensServicoRoutes
	    }, {
	        path: data_service_5.manutencoesProgramadaRoute,
	        component: manutencao_programada_component_1.ManutencaoProgramadaComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: manutencao_programada_routing_module_1.manutencaoProgramadaRoutes
	    }
	];


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(201);
	var data_service_3 = __webpack_require__(429);
	var plano_navigation_service_1 = __webpack_require__(441);
	var servico_navigation_service_1 = __webpack_require__(697);
	var data_service_4 = __webpack_require__(234);
	var ManutencaoConfiguracaoComponent = (function () {
	    function ManutencaoConfiguracaoComponent(_planoNavigationService, _servicoNavigationService) {
	        this._planoNavigationService = _planoNavigationService;
	        this._servicoNavigationService = _servicoNavigationService;
	        this.module = data_service_4.manutencoesModuleName;
	        this.configuracaoModule = data_service_1.configuracaoModuleName;
	        this.planoManutencaoModule = data_service_2.planosModuleName;
	        this.servicoModule = data_service_3.servicosModuleName;
	    }
	    ManutencaoConfiguracaoComponent.prototype.ngOnInit = function () {
	    };
	    ManutencaoConfiguracaoComponent.prototype.clickItem = function (module) {
	        if (module.plural === this.planoManutencaoModule.plural) {
	            this._planoNavigationService.goToList();
	        }
	        else if (module.plural === this.servicoModule.plural) {
	            this._servicoNavigationService.goToList();
	        }
	    };
	    ManutencaoConfiguracaoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(698),
	            styles: [__webpack_require__(699)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof plano_navigation_service_1.PlanoNavigationService !== 'undefined' && plano_navigation_service_1.PlanoNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof servico_navigation_service_1.ServicoNavigationService !== 'undefined' && servico_navigation_service_1.ServicoNavigationService) === 'function' && _b) || Object])
	    ], ManutencaoConfiguracaoComponent);
	    return ManutencaoConfiguracaoComponent;
	    var _a, _b;
	}());
	exports.ManutencaoConfiguracaoComponent = ManutencaoConfiguracaoComponent;


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(429);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(234);
	var ServicoNavigationService = (function () {
	    function ServicoNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    ServicoNavigationService.prototype.goToList = function () {
	        var router = data_service_3.manutencoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.servicosRoute;
	        this._authService.navigateTo(router);
	    };
	    ServicoNavigationService.prototype.goToNew = function () {
	        var router = data_service_3.manutencoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.servicosRoute + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    ServicoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_3.manutencoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_1.servicosRoute + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    ServicoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ServicoNavigationService);
	    return ServicoNavigationService;
	    var _a;
	}());
	exports.ServicoNavigationService = ServicoNavigationService;


/***/ },
/* 698 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a class=\"active\">{{configuracaoModule.plural}}</a></li>\n    </ul>\n\n    <h1>{{configuracaoModule.plural}} de {{module.plural | lowercase}}</h1>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(planoManutencaoModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{planoManutencaoModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{planoManutencaoModule.plural | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(servicoModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{servicoModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{servicoModule.plural | lowercase}}\n        </div>\n    </div>\n</div>";

/***/ },
/* 699 */
166,
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ServicosComponent = (function () {
	    function ServicosComponent() {
	    }
	    ServicosComponent.prototype.ngOnInit = function () {
	    };
	    ServicosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(701)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ServicosComponent);
	    return ServicosComponent;
	}());
	exports.ServicosComponent = ServicosComponent;


/***/ },
/* 701 */
171,
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var servico_list_component_1 = __webpack_require__(703);
	var servico_form_component_1 = __webpack_require__(707);
	var data_service_1 = __webpack_require__(178);
	var ServicosRoutingModule = (function () {
	    function ServicosRoutingModule() {
	    }
	    ServicosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ServicosRoutingModule);
	    return ServicosRoutingModule;
	}());
	exports.ServicosRoutingModule = ServicosRoutingModule;
	exports.servicosRoutes = [
	    {
	        path: '',
	        component: servico_list_component_1.ServicoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: servico_form_component_1.ServicoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: servico_form_component_1.ServicoFormComponent
	    }
	];


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(429);
	var servico_api_service_1 = __webpack_require__(430);
	var servico_navigation_service_1 = __webpack_require__(697);
	var util_service_1 = __webpack_require__(88);
	var manutencao_service_1 = __webpack_require__(704);
	var data_service_2 = __webpack_require__(234);
	var data_service_3 = __webpack_require__(178);
	var ServicoListComponent = (function () {
	    function ServicoListComponent(_servicosApiService, _servicoNavigationService, _utilService, _manutencaoService) {
	        this._servicosApiService = _servicosApiService;
	        this._servicoNavigationService = _servicoNavigationService;
	        this._utilService = _utilService;
	        this._manutencaoService = _manutencaoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.servicosModuleName = data_service_1.servicosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	        this.module = data_service_2.manutencoesModuleName;
	    }
	    ServicoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    ServicoListComponent.prototype.clickNew = function () {
	        this._servicoNavigationService.goToNew();
	    };
	    ServicoListComponent.prototype.clickEdit = function (item) {
	        this._servicoNavigationService.goToEdit(item.id);
	    };
	    ServicoListComponent.prototype.clickGoToConfig = function () {
	        this._manutencaoService.goToSetting();
	    };
	    ServicoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    ServicoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.forEach(function (item) {
	                    if (!item.Materiais) {
	                        item.Materiais = [];
	                    }
	                });
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._servicosApiService.onGetWithMateriais(onDone);
	    };
	    ServicoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._servicosApiService.onDelete(item.id, onDone);
	    };
	    ServicoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(705),
	            styles: [__webpack_require__(706)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _a) || Object, (typeof (_b = typeof servico_navigation_service_1.ServicoNavigationService !== 'undefined' && servico_navigation_service_1.ServicoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof manutencao_service_1.ManutencaoService !== 'undefined' && manutencao_service_1.ManutencaoService) === 'function' && _d) || Object])
	    ], ServicoListComponent);
	    return ServicoListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.ServicoListComponent = ServicoListComponent;


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(234);
	var ManutencaoService = (function () {
	    function ManutencaoService(_authService) {
	        this._authService = _authService;
	    }
	    ManutencaoService.prototype.goToSetting = function () {
	        var router = data_service_1.manutencoesRoute + '/configuracoes';
	        this._authService.navigateTo(router);
	    };
	    ManutencaoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ManutencaoService);
	    return ManutencaoService;
	    var _a;
	}());
	exports.ManutencaoService = ManutencaoService;


/***/ },
/* 705 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{servicosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{servicosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{servicosModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Descrição</th>\n            <th>Valor</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['descricao'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span> {{item.descricao}}</td>\n            <td>{{item.valor| currencyMask}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <app-material-servico-table [list]=\"item.Materiais\"\n                                            [showDelete]=\"false\"\n                                            ></app-material-servico-table>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 706 */
166,
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(429);
	var servico_model_1 = __webpack_require__(708);
	var data_service_2 = __webpack_require__(178);
	var servico_navigation_service_1 = __webpack_require__(697);
	var servico_api_service_1 = __webpack_require__(430);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var servico_service_1 = __webpack_require__(440);
	var manutencao_service_1 = __webpack_require__(704);
	var data_service_3 = __webpack_require__(234);
	var material_servico_api_service_1 = __webpack_require__(431);
	var ServicoFormComponent = (function () {
	    function ServicoFormComponent(_route, _servicoNavigationService, _servicoApiService, _utilService, _autocompleteService, _servicoService, _manutencaoService, _materialServicoApiService, _fb) {
	        this._route = _route;
	        this._servicoNavigationService = _servicoNavigationService;
	        this._servicoApiService = _servicoApiService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._servicoService = _servicoService;
	        this._manutencaoService = _manutencaoService;
	        this._materialServicoApiService = _materialServicoApiService;
	        this._fb = _fb;
	        this.servicosModule = data_service_1.servicosModuleName;
	        this.module = data_service_3.manutencoesModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.formObject = new servico_model_1.Servico();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.materiais = [];
	        this.valor = new forms_1.FormControl('', forms_1.Validators.required);
	        this.ativo = new forms_1.FormControl('');
	        this.descricao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseServico = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            descricao: this.descricao,
	            valor: this.valor
	        });
	    }
	    ServicoFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    ServicoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    ServicoFormComponent.prototype.clickGoToConfig = function () {
	        this._manutencaoService.goToSetting();
	    };
	    ServicoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    ServicoFormComponent.prototype.keyupCurrency = function (start) {
	        var valor = this._utilService.currencyFormat(this.formObject.valor, start);
	        if (valor) {
	            this.formObject.valor = valor;
	        }
	    };
	    ServicoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (object.valor) {
	                object.valor = this._utilService.getCurrency(object.valor);
	            }
	            object.Materiais = [];
	            this.materiais.forEach(function (item) {
	                item.materialId = item.material.id;
	                delete item['material'];
	                object.Materiais.push(item);
	            });
	            if (this.formObject.id) {
	                this.onEditServico(object);
	            }
	            else {
	                this.onAddServico(object);
	            }
	        }
	    };
	    ServicoFormComponent.prototype.onAddServico = function (object) {
	        this._servicoApiService.onPost(object, this.onDone);
	    };
	    ServicoFormComponent.prototype.onEditServico = function (object) {
	        this._servicoApiService.onPut(object, this.onDone);
	    };
	    ServicoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum serviço encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._servicoApiService.onGetById(id, onDone);
	    };
	    ServicoFormComponent.prototype.getMateriais = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.materiais = Response;
	            }
	        }.bind(this));
	        this._materialServicoApiService.onGetByServico(id, onDone);
	    };
	    ServicoFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._servicoService.getSessionStorage();
	        this._servicoService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    ServicoFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.id) {
	            this.keyupCurrency(true);
	        }
	    };
	    ServicoFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._servicoService.returnToOtherForm(this.otherForm, this.responseServico);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    ServicoFormComponent.prototype.goToList = function () {
	        this._servicoNavigationService.goToList();
	    };
	    ServicoFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.servicosStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.descricao = newAutoComplete.descricao;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    ServicoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    ServicoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	        this.getMateriais(id);
	    };
	    ServicoFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    ServicoFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    ServicoFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    ServicoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(709),
	            styles: [__webpack_require__(710)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof servico_navigation_service_1.ServicoNavigationService !== 'undefined' && servico_navigation_service_1.ServicoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object, (typeof (_f = typeof servico_service_1.ServicoService !== 'undefined' && servico_service_1.ServicoService) === 'function' && _f) || Object, (typeof (_g = typeof manutencao_service_1.ManutencaoService !== 'undefined' && manutencao_service_1.ManutencaoService) === 'function' && _g) || Object, (typeof (_h = typeof material_servico_api_service_1.MaterialServicoApiService !== 'undefined' && material_servico_api_service_1.MaterialServicoApiService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], ServicoFormComponent);
	    return ServicoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.ServicoFormComponent = ServicoFormComponent;


/***/ },
/* 708 */
/***/ function(module, exports) {

	"use strict";
	var Servico = (function () {
	    function Servico() {
	    }
	    return Servico;
	}());
	exports.Servico = Servico;
	var ServicoPlano = (function () {
	    function ServicoPlano() {
	    }
	    return ServicoPlano;
	}());
	exports.ServicoPlano = ServicoPlano;
	var ServicoOrdemServico = (function () {
	    function ServicoOrdemServico() {
	    }
	    return ServicoOrdemServico;
	}());
	exports.ServicoOrdemServico = ServicoOrdemServico;
	var ServicoBem = (function () {
	    function ServicoBem() {
	    }
	    return ServicoBem;
	}());
	exports.ServicoBem = ServicoBem;


/***/ },
/* 709 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{servicosModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{servicosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{servicosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <h2>Dados do {{servicosModule.single | lowercase}}</h2>\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !descricao.valid && submitted}\">\n            <label for=\"descricao\">Descrição <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!descricao.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\" autofocus>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !valor.valid && submitted}\">\n            <label for=\"valor\">Valor (R$) <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!valor.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"valor\" [(ngModel)]=\"formObject.valor\" (keyup)=\"keyupCurrency()\" formControlName=\"valor\">\n            </div>\n        </div>\n\n        <h2>Materiais relacionados</h2>\n    </div>\n\n    <app-material-servico-form-list [list]=\"materiais\"></app-material-servico-form-list>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 710 */
206,
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PlanosComponent = (function () {
	    function PlanosComponent() {
	    }
	    PlanosComponent.prototype.ngOnInit = function () {
	    };
	    PlanosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(712)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PlanosComponent);
	    return PlanosComponent;
	}());
	exports.PlanosComponent = PlanosComponent;


/***/ },
/* 712 */
171,
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var plano_form_component_1 = __webpack_require__(714);
	var plano_list_component_1 = __webpack_require__(718);
	var PlanosRoutingModule = (function () {
	    function PlanosRoutingModule() {
	    }
	    PlanosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PlanosRoutingModule);
	    return PlanosRoutingModule;
	}());
	exports.PlanosRoutingModule = PlanosRoutingModule;
	exports.planosRoutes = [
	    {
	        path: '',
	        component: plano_list_component_1.PlanoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: plano_form_component_1.PlanosFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: plano_form_component_1.PlanosFormComponent
	    }
	];


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(201);
	var plano_model_1 = __webpack_require__(715);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var plano_api_service_1 = __webpack_require__(443);
	var plano_service_1 = __webpack_require__(442);
	var plano_navigation_service_1 = __webpack_require__(441);
	var servico_api_service_1 = __webpack_require__(430);
	var data_service_3 = __webpack_require__(234);
	var manutencao_service_1 = __webpack_require__(704);
	var marca_api_service_1 = __webpack_require__(308);
	var data_service_4 = __webpack_require__(152);
	var categoria_api_service_1 = __webpack_require__(324);
	var autocomplete_service_1 = __webpack_require__(101);
	var PlanosFormComponent = (function () {
	    function PlanosFormComponent(_route, _planosApiService, _planosService, _planosNavigationService, _servicoApiService, _utilService, _manutencaoService, _marcaApiService, _categoriaApiService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._planosApiService = _planosApiService;
	        this._planosService = _planosService;
	        this._planosNavigationService = _planosNavigationService;
	        this._servicoApiService = _servicoApiService;
	        this._utilService = _utilService;
	        this._manutencaoService = _manutencaoService;
	        this._marcaApiService = _marcaApiService;
	        this._categoriaApiService = _categoriaApiService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.planosModule = data_service_1.planosModuleName;
	        this.formObject = new plano_model_1.Plano();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.showServicesMsg = false;
	        this.module = data_service_3.manutencoesModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.loadingSpinnerCategorias = true;
	        this.categoriaObject = {};
	        this.categoriaList = [];
	        this.marcaObject = {};
	        this.marcaSelectId = 'marca';
	        this.servicosList = [];
	        this.servicoObject = {};
	        this.ativo = new forms_1.FormControl('');
	        this.titulo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.descricao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.marca = new forms_1.FormControl('');
	        this.categoria = new forms_1.FormControl('');
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.goToList();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            titulo: this.titulo,
	            descricao: this.descricao,
	            categoria: this.categoria,
	            marca: this.marca
	        });
	    }
	    PlanosFormComponent.prototype.ngOnInit = function () {
	        this.marcaQuery = this._utilService.cloneObject(data_service_4.marcasQuery);
	        this.getCategorias();
	        this.testSession();
	    };
	    PlanosFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    PlanosFormComponent.prototype.clickGoToConfig = function () {
	        this._manutencaoService.goToSetting();
	    };
	    PlanosFormComponent.prototype.clickCancel = function () {
	        this.goToList();
	    };
	    PlanosFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject), list = this._utilService.cloneObject(this.servicosList);
	            if (list.length) {
	                var servicos = [], x, lenX;
	                for (x = 0, lenX = list.length; x < lenX; x++) {
	                    if (list[x].servico && list[x].servico.id) {
	                        list[x].servicoId = list[x].servico.id;
	                        if (list[x].referenciaTempo) {
	                            list[x].referenciaTempo = list[x].referenciaTempo.Key;
	                        }
	                        if (this.formObject.id) {
	                            list[x].planoId = this.formObject.id;
	                        }
	                        delete list[x]['servico'];
	                        servicos.push(list[x]);
	                    }
	                }
	                object.Servicos = servicos;
	            }
	            if (this.marcaObject.id) {
	                object.marcaId = this.marcaObject.id;
	            }
	            else {
	                object.marcaId = null;
	            }
	            if (this.categoriaObject.id) {
	                object.categoriaId = this.categoriaObject.id;
	            }
	            else {
	                object.categoriaId = null;
	            }
	            if (!object.Servicos) {
	                this.btnSaveDisabled = false;
	                this.showServicesMsg = true;
	            }
	            else {
	                if (this.formObject.id) {
	                    this.onEditPlanos(object);
	                }
	                else {
	                    this.onAddPlanos(object);
	                }
	            }
	        }
	    };
	    PlanosFormComponent.prototype.getMarcaObject = function (object) {
	        this.marcaObject = object;
	        if (object.id) {
	            this._utilService.setSelectOnFormControl(this.form, 'marca', object);
	        }
	        else {
	            this._utilService.setSelectOnFormControl(this.form, 'marca', { id: -1 });
	        }
	    };
	    PlanosFormComponent.prototype.onAddPlanos = function (object) {
	        this._planosApiService.onPost(object, this.onDone);
	    };
	    PlanosFormComponent.prototype.onEditPlanos = function (object) {
	        this._planosApiService.onPut(object, this.onDone);
	    };
	    PlanosFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum plano encontrado com este id.');
	                this.clickGoToList();
	            }
	        }.bind(this));
	        this._planosApiService.onGetById(id, onDone);
	    };
	    PlanosFormComponent.prototype.getServicos = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].referenciaTempo = this._planosService.getReferenciaTempo(Response[x].referenciaTempo);
	                }
	                this.servicosList = Response;
	            }
	        }.bind(this));
	        this._servicoApiService.onGetByPlanoServicoPlano(id, onDone);
	    };
	    PlanosFormComponent.prototype.getCategorias = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.categoriaList = Response;
	                this.categoriaList.unshift({ id: null, categoria: '— Selecione —' });
	                this.loadingSpinnerCategorias = false;
	                if (this.formObject.categoria) {
	                    this.setCategoria(this.formObject.categoria.id);
	                }
	                else {
	                    this.setCategoria(null);
	                }
	            }
	        }.bind(this));
	        this._categoriaApiService.onGetAll(onDone);
	    };
	    PlanosFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._planosService.getSessionStorage();
	        this._planosService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    PlanosFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.marca) {
	            this.marcaObject = this._utilService.cloneObject(this.formObject.marca);
	            delete this.formObject['marca'];
	            var text = this._autocompleteService.getTextSelect2(this.marcaObject, 'marca');
	            var selectObject = { text: text, id: this.marcaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.marcaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.marcaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'marca', this.marcaObject);
	        }
	        if (this.formObject.categoria) {
	            this.categoriaObject = this.formObject.categoria;
	            this.setCategoria(this.formObject.categoria.id);
	            delete this.formObject['categoria'];
	        }
	        if (this.formObject.servicoObject) {
	            this.servicoObject = this.formObject.servicoObject;
	            delete this.formObject['servicoObject'];
	        }
	        if (this.formObject.servicos) {
	            this.servicosList = this.formObject.servicos;
	            delete this.formObject['servicos'];
	        }
	    };
	    PlanosFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    PlanosFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	        this.getServicos(id);
	    };
	    PlanosFormComponent.prototype.setNewNormal = function () {
	    };
	    PlanosFormComponent.prototype.goToList = function () {
	        this._planosNavigationService.goToList();
	    };
	    PlanosFormComponent.prototype.setCategoria = function (categoriaId) {
	        var x, lenX;
	        if (this.categoriaList.length) {
	            this.categoriaObject = this.categoriaList[0];
	        }
	        for (x = 0, lenX = this.categoriaList.length; x < lenX; x++) {
	            if (this.categoriaList[x].id === categoriaId) {
	                this.categoriaObject = this.categoriaList[x];
	                break;
	            }
	        }
	    };
	    PlanosFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(716),
	            styles: [__webpack_require__(717)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof plano_api_service_1.PlanoApiService !== 'undefined' && plano_api_service_1.PlanoApiService) === 'function' && _b) || Object, (typeof (_c = typeof plano_service_1.PlanoService !== 'undefined' && plano_service_1.PlanoService) === 'function' && _c) || Object, (typeof (_d = typeof plano_navigation_service_1.PlanoNavigationService !== 'undefined' && plano_navigation_service_1.PlanoNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object, (typeof (_g = typeof manutencao_service_1.ManutencaoService !== 'undefined' && manutencao_service_1.ManutencaoService) === 'function' && _g) || Object, (typeof (_h = typeof marca_api_service_1.MarcaApiService !== 'undefined' && marca_api_service_1.MarcaApiService) === 'function' && _h) || Object, (typeof (_j = typeof categoria_api_service_1.CategoriaApiService !== 'undefined' && categoria_api_service_1.CategoriaApiService) === 'function' && _j) || Object, (typeof (_k = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _k) || Object, (typeof (_l = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _l) || Object])
	    ], PlanosFormComponent);
	    return PlanosFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.PlanosFormComponent = PlanosFormComponent;


/***/ },
/* 715 */
/***/ function(module, exports) {

	"use strict";
	var Plano = (function () {
	    function Plano() {
	    }
	    return Plano;
	}());
	exports.Plano = Plano;


/***/ },
/* 716 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{planosModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{planosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{planosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados do plano</h2>\n        <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !titulo.valid && submitted}\">\n            <label for=\"titulo\">Nome <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!titulo.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"titulo\" [(ngModel)]=\"formObject.titulo\" formControlName=\"titulo\" autofocus>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\">\n            <label for=\"categoria\">Categoria</label>\n            <div  class=\"containerSpinner\">\n                <select id=\"categoria\" [(ngModel)]=\"categoriaObject\" formControlName=\"categoria\" class=\"option_{{categoriaObject.id}}\">\n                    <option *ngFor=\"let item of categoriaList\" [ngValue]=\"item\" class=\"option_{{item.id}}\">{{item.categoria}}</option>\n                </select>\n                <spinner-component *ngIf=\"loadingSpinnerCategorias\"></spinner-component>\n            </div>\n        </div>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"marca\"\n                                (setObejct)=\"getMarcaObject($event)\"\n                                (clearObject)=\"getMarcaObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"marcaSelectId\"\n                                [model]=\"marcaObject\"\n                                [_service]=\"_marcaApiService\"\n                                [fieldToShow]=\"'marca'\"\n                                [isCreateNew]=\"false\"\n                                [query]=\"marcaQuery\"\n                                [clear]=\"true\"\n                                [label]=\"'Marca'\"></autocomplete-component>\n\n        <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !descricao.valid && submitted}\">\n            <label for=\"descricao\">Descrição <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!descricao.valid && submitted\">Este campo é obrigatório.</span>\n                <textarea id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\"></textarea>\n            </div>\n        </div>\n\n        <h2>Serviços\n        <span class=\"error-alert\" *ngIf=\"showServicesMsg\"> - Adicione ao menos um serviço no plano de manutenção</span>\n        </h2>\n    </div>\n\n    <app-servico-plano-form-list [list]=\"servicosList\"\n                                 [planoObject]=\"formObject\"\n                                 [categoriaObject]=\"categoriaObject\"\n                                 [marcaObject]=\"marcaObject\"\n                                 [servicoObject]=\"servicoObject\"\n                                 ></app-servico-plano-form-list>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>";

/***/ },
/* 717 */
/***/ function(module, exports) {

	module.exports = ".containerSpinner {\n    position: relative;\n}\n\nspinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}\n\n.error-alert {\n    color: #fd0000;\n}"

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(201);
	var plano_api_service_1 = __webpack_require__(443);
	var plano_navigation_service_1 = __webpack_require__(441);
	var util_service_1 = __webpack_require__(88);
	var plano_service_1 = __webpack_require__(442);
	var group_by_service_1 = __webpack_require__(111);
	var servico_api_service_1 = __webpack_require__(430);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(234);
	var manutencao_service_1 = __webpack_require__(704);
	var PlanoListComponent = (function () {
	    function PlanoListComponent(_servicoApiService, _planosApiService, _planoService, _planoNavigationService, _utilService, _groupBy, _manutencaoService) {
	        this._servicoApiService = _servicoApiService;
	        this._planosApiService = _planosApiService;
	        this._planoService = _planoService;
	        this._planoNavigationService = _planoNavigationService;
	        this._utilService = _utilService;
	        this._groupBy = _groupBy;
	        this._manutencaoService = _manutencaoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.planosModuleName = data_service_1.planosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.manutencoesModuleName;
	    }
	    PlanoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    PlanoListComponent.prototype.clickNew = function () {
	        this._planoService.clearSessionStorage();
	        this._planoNavigationService.goToNew();
	    };
	    PlanoListComponent.prototype.clickEdit = function (item) {
	        this._planoService.clearSessionStorage();
	        this._planoNavigationService.goToEdit(item.id);
	    };
	    PlanoListComponent.prototype.clickGoToConfig = function () {
	        this._manutencaoService.goToSetting();
	    };
	    PlanoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    PlanoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX, y, lenY;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].Servicos) {
	                        for (y = 0, lenY = Response[x].Servicos.length; y < lenY; y++) {
	                            Response[x].Servicos[y].referenciaTempo = this._planoService.getReferenciaTempo(Response[x].Servicos[y].referenciaTempo);
	                        }
	                    }
	                    else {
	                        Response[x].Servicos = [];
	                    }
	                }
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._planosApiService.onGetAllPopulate(onDone);
	    };
	    PlanoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._planosApiService.onDelete(item.id, onDone);
	    };
	    PlanoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(719),
	            styles: [__webpack_require__(720)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _a) || Object, (typeof (_b = typeof plano_api_service_1.PlanoApiService !== 'undefined' && plano_api_service_1.PlanoApiService) === 'function' && _b) || Object, (typeof (_c = typeof plano_service_1.PlanoService !== 'undefined' && plano_service_1.PlanoService) === 'function' && _c) || Object, (typeof (_d = typeof plano_navigation_service_1.PlanoNavigationService !== 'undefined' && plano_navigation_service_1.PlanoNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof group_by_service_1.GroupByService !== 'undefined' && group_by_service_1.GroupByService) === 'function' && _f) || Object, (typeof (_g = typeof manutencao_service_1.ManutencaoService !== 'undefined' && manutencao_service_1.ManutencaoService) === 'function' && _g) || Object])
	    ], PlanoListComponent);
	    return PlanoListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.PlanoListComponent = PlanoListComponent;


/***/ },
/* 719 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{planosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{planosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{planosModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Nome</th>\n            <th>Categoria</th>\n            <th>Marca</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['titulo','categoria.categoria','marca.marca'] | filterActive:showDisabled | sort:['titulo'])\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.titulo}}</td>\n            <td><span *ngIf=\"item.categoria\">{{item.categoria.categoria}}</span></td>\n            <td><span *ngIf=\"item.marca\">{{item.marca.marca}}</span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div>\n                    <p><strong>Descrição: </strong> {{item.descricao}} <i *ngIf=\"!item.descricao\">não cadastrado</i></p>\n                </div>\n\n                <app-servico-plano-table [list]=\"item.Servicos\"\n                                         [showRemove]=\"false\"></app-servico-plano-table>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 720 */
166,
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var OrdensServicoComponent = (function () {
	    function OrdensServicoComponent() {
	    }
	    OrdensServicoComponent.prototype.ngOnInit = function () {
	    };
	    OrdensServicoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(722)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OrdensServicoComponent);
	    return OrdensServicoComponent;
	}());
	exports.OrdensServicoComponent = OrdensServicoComponent;


/***/ },
/* 722 */
171,
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var ordem_servico_list_component_1 = __webpack_require__(420);
	var ordem_servico_form_component_1 = __webpack_require__(426);
	var ordem_servico_detail_component_1 = __webpack_require__(436);
	var ordem_servico_item_form_component_1 = __webpack_require__(724);
	var data_service_2 = __webpack_require__(200);
	var ordem_servico_calendar_component_1 = __webpack_require__(727);
	var OrdensServicoRoutingModule = (function () {
	    function OrdensServicoRoutingModule() {
	    }
	    OrdensServicoRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OrdensServicoRoutingModule);
	    return OrdensServicoRoutingModule;
	}());
	exports.OrdensServicoRoutingModule = OrdensServicoRoutingModule;
	exports.ordensServicoRoutes = [
	    {
	        path: '',
	        component: ordem_servico_list_component_1.OrdemServicoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_1.detailRoute + '/:id',
	        component: ordem_servico_detail_component_1.OrdemServicoDetailComponent
	    }, {
	        path: data_service_2.ordensServicoItemsServicoRoute + '/' + data_service_1.editRoute + '/:osId/:tipo/:id',
	        component: ordem_servico_item_form_component_1.OrdemServicoItemFormComponent
	    }, {
	        path: data_service_2.ordensServicoItemsServicoRoute + '/' + data_service_1.newRoute + '/:osId/:tipo',
	        component: ordem_servico_item_form_component_1.OrdemServicoItemFormComponent
	    }, {
	        path: data_service_2.ordensServicoItemsMaterialRoute + '/' + data_service_1.editRoute + '/:osId/:tipo/:id',
	        component: ordem_servico_item_form_component_1.OrdemServicoItemFormComponent
	    }, {
	        path: data_service_2.ordensServicoItemsMaterialRoute + '/' + data_service_1.newRoute + '/:osId/:tipo',
	        component: ordem_servico_item_form_component_1.OrdemServicoItemFormComponent
	    }, {
	        path: 'agenda',
	        component: ordem_servico_calendar_component_1.OrdemServicoCalendarComponent
	    }
	];


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(200);
	var medida_api_service_1 = __webpack_require__(472);
	var ordem_servico_api_service_1 = __webpack_require__(421);
	var isNumeric_1 = __webpack_require__(413);
	var ordem_servico_service_1 = __webpack_require__(235);
	var servico_api_service_1 = __webpack_require__(430);
	var ordem_servico_model_1 = __webpack_require__(427);
	var material_ordem_servico_api_service_1 = __webpack_require__(432);
	var data_service_3 = __webpack_require__(429);
	var data_service_4 = __webpack_require__(161);
	var material_service_1 = __webpack_require__(475);
	var autocomplete_service_1 = __webpack_require__(101);
	var servico_navigation_service_1 = __webpack_require__(697);
	var material_servico_api_service_1 = __webpack_require__(431);
	var OrdemServicoItemFormComponent = (function () {
	    function OrdemServicoItemFormComponent(_route, _ordemServicoNavigationService, _ordemServicoApiService, _medidaApiService, _ordemServicoService, _servicoApiService, _materialOrdemServicoApiService, _autocompleteService, _servicoNavigationService, _materialService, _utilService, _materialServicoApiService, _fb) {
	        this._route = _route;
	        this._ordemServicoNavigationService = _ordemServicoNavigationService;
	        this._ordemServicoApiService = _ordemServicoApiService;
	        this._medidaApiService = _medidaApiService;
	        this._ordemServicoService = _ordemServicoService;
	        this._servicoApiService = _servicoApiService;
	        this._materialOrdemServicoApiService = _materialOrdemServicoApiService;
	        this._autocompleteService = _autocompleteService;
	        this._servicoNavigationService = _servicoNavigationService;
	        this._materialService = _materialService;
	        this._utilService = _utilService;
	        this._materialServicoApiService = _materialServicoApiService;
	        this._fb = _fb;
	        this.ordemServicoModuleName = data_service_2.ordensServicoModuleName;
	        this.itemComponentName = 'item';
	        this.formObject = {};
	        this.ordemServicoObject = new ordem_servico_model_1.OrdemServico();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.isService = false;
	        this.servicomaterialObject = {};
	        this.unidadeObject = {};
	        this.materiaisServicesList = [];
	        this.medidasList = [];
	        this.total = '';
	        this.materialLimitQnt = 0;
	        this.servicomaterial = new forms_1.FormControl('', forms_1.Validators.required);
	        this.ativo = new forms_1.FormControl('');
	        this.data = new forms_1.FormControl('', forms_1.Validators.required);
	        this.quantidade = new forms_1.FormControl('', forms_1.Validators.required);
	        this.medida = new forms_1.FormControl('', forms_1.Validators.required);
	        this.valor = new forms_1.FormControl('', forms_1.Validators.required);
	        this.valorTotal = new forms_1.FormControl({ value: '', disabled: true }, forms_1.Validators.required);
	        this.isSubMaterial = false;
	        this.materiaisServicosTemplateResult = (function (state) {
	            return this._ordemServicoService.templateResult(state, true);
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseServico = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                if (this.isService) {
	                    this.getMateriaisServico();
	                }
	                else {
	                    this.toLeaveHere();
	                }
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            servicomaterial: this.servicomaterial,
	            data: this.data,
	            quantidade: this.quantidade,
	            medida: this.medida,
	            valor: this.valor,
	            valorTotal: this.valorTotal
	        });
	    }
	    OrdemServicoItemFormComponent.prototype.ngOnInit = function () {
	        this.getOrdemServico();
	        var tipo = +this._route.snapshot.params['tipo'];
	        var tipoServico = this._ordemServicoService.getItemTipoServico();
	        if (tipo === tipoServico.Key) {
	            this.materiaisServicosQuery = data_service_3.servicosQuery;
	            this.isService = true;
	            this.materiaisServicosSelectId = 'servicos';
	        }
	        else {
	            this.getMedidas();
	            this.materiaisServicosQuery = data_service_4.materiaisQuery;
	            this.materiaisServicosSelectId = 'materiais';
	        }
	        this.testSession();
	    };
	    OrdemServicoItemFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    OrdemServicoItemFormComponent.prototype.clickGoToDetail = function () {
	        this.goToDetail();
	    };
	    OrdemServicoItemFormComponent.prototype.clickCancel = function () {
	        this.goToDetail();
	    };
	    OrdemServicoItemFormComponent.prototype.keyupCurrency = function (start) {
	        var valor = this._utilService.currencyFormat(this.formObject.valor, start);
	        if (valor) {
	            this.formObject.valor = valor;
	        }
	        this.calculateTotal();
	    };
	    OrdemServicoItemFormComponent.prototype.keyupQuantidade = function () {
	        if (this.materialLimitQnt && (this.formObject.quantidade > this.materialLimitQnt)) {
	            this.formObject.quantidade = 1;
	        }
	        this.calculateTotal();
	    };
	    OrdemServicoItemFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (this.isService) {
	            this._utilService.setSelectOnFormControl(this.form, 'medida', { id: -1 });
	        }
	        else {
	            this._utilService.setSelectOnFormControl(this.form, 'data', { id: -1 });
	        }
	        if (this.formObject.valor == 0 || this.formObject.valor === '0,00') {
	            return false;
	        }
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.total) {
	                object.valor = this._utilService.getCurrency(this.total);
	            }
	            object.descricao = this.servicomaterialObject.descricao;
	            if (this.isService) {
	                //servico
	                var date = document.getElementById('data');
	                if (date.value) {
	                    object.data = this._utilService.convertStringToDate(date.value);
	                }
	                else {
	                    object.data = null;
	                }
	                delete object['unidade'];
	                object.servicoId = this.servicomaterialObject.id;
	            }
	            else {
	                //material
	                if (this.unidadeObject.id) {
	                    object.medidaId = this.unidadeObject.id;
	                }
	                delete object['data'];
	                object.materialId = this.servicomaterialObject.id;
	            }
	            object.ordemServicoId = this.ordemServicoObject.id;
	            if (this.formObject.id) {
	                this.onEditServico(object);
	            }
	            else {
	                this.onAddServico(object);
	            }
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.getMateriaisServicosObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._ordemServicoService.setItemsSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                descricao: object.text,
	                form: data_service_2.ordensServicoItemsStorage
	            };
	            if (this.isService) {
	                this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_3.servicosStorage);
	                this._servicoNavigationService.goToNew();
	            }
	            else {
	                this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.materialStorageName);
	                this._materialService.goToAdd();
	            }
	        }
	        else {
	            this.servicomaterialObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'servicomaterial', object);
	            if (!this.isService) {
	                this.setMedidaOnMaterial(this.servicomaterialObject.medidaId);
	            }
	            if (this.servicomaterialObject.valor) {
	                this.formObject.valor = this.servicomaterialObject.valor;
	                this.keyupCurrency(true);
	            }
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.tipo = +this._route.snapshot.params['tipo'];
	        object.osId = +this._route.snapshot.params['osId'];
	        object.valor = this.total;
	        if (this.isService) {
	            object.servico = this.servicomaterialObject;
	        }
	        else {
	            object.material = this.servicomaterialObject;
	            object.medidaId = this.unidadeObject.id;
	        }
	        return object;
	    };
	    OrdemServicoItemFormComponent.prototype.onAddServico = function (object) {
	        if (this.isService) {
	            this._servicoApiService.onPostServicoOrdemServico(object, this.onDone);
	        }
	        else {
	            this._materialOrdemServicoApiService.onPostMaterialOrdemServico(object, this.onDone);
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.onEditServico = function (object) {
	        if (this.isService) {
	            this._servicoApiService.onPutServicoOrdemServico(object, this.onDone);
	        }
	        else {
	            this._materialOrdemServicoApiService.onPutMaterialOrdemServico(object, this.onDone);
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum material/serviço encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        var tipo = +this._route.snapshot.params['tipo'];
	        var serviceType = this._ordemServicoService.getItemTipoServico();
	        if (tipo === serviceType.Key) {
	            this._servicoApiService.onGetByIdServicoOrdemServico(id, onDone);
	        }
	        else {
	            this._materialOrdemServicoApiService.onGetByIdMaterialOrdemServico(id, onDone);
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.getMateriaisServico = function () {
	        var onDone2 = (function (Response) {
	            this.toLeaveHere();
	        }.bind(this));
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (Response.length === 0) {
	                    this.toLeaveHere();
	                }
	                else {
	                    this.isSubMaterial = true;
	                    var list = [];
	                    Response.forEach(function (item) {
	                        if (item.material) {
	                            list.push({
	                                descricao: item.material.descricao,
	                                quantidade: item.quantidade,
	                                medidaId: item.material.medidaId,
	                                materialId: item.material.id,
	                                ordemServicoId: this.ordemServicoObject.id,
	                                ativo: true
	                            });
	                        }
	                    }.bind(this));
	                    this._materialOrdemServicoApiService.onPostMateriaisOrdemServico(list, onDone2);
	                }
	            }
	        }.bind(this));
	        this._materialServicoApiService.onGetByServico(this.servicomaterialObject.id, onDone);
	    };
	    OrdemServicoItemFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._ordemServicoService.getItemsSessionStorage();
	        this._ordemServicoService.clearItemsSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            setTimeout(function () {
	                this.setModelToForm();
	            }.bind(this));
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    OrdemServicoItemFormComponent.prototype.setModelToForm = function () {
	        var valor = 0, qnt = 0;
	        if (this.formObject.data && (this.formObject.data.indexOf("/") === -1)) {
	            this.formObject.data = this._utilService.convertDateToString(this.formObject.data);
	        }
	        if (this.formObject.quantidade && (this.formObject.quantidade !== undefined)) {
	            qnt = this.formObject.quantidade;
	        }
	        if (this.formObject.valor && (this.formObject.valor !== '0,00')) {
	            valor = this._utilService.getCurrency(this.formObject.valor);
	        }
	        else {
	            if (this.formObject.servico) {
	                valor = this.formObject.servico.valor;
	            }
	        }
	        this.formObject.valor = (valor / qnt || 0).toFixed(2);
	        this.calculateTotal();
	        this.keyupCurrency(true);
	        if (this.formObject.servico) {
	            this.isService = true;
	            this.servicomaterialObject = this._utilService.cloneObject(this.formObject.servico);
	            delete this.formObject['servico'];
	        }
	        if (this.formObject.material) {
	            this.isService = false;
	            this.servicomaterialObject = this._utilService.cloneObject(this.formObject.material);
	            delete this.formObject['material'];
	            if (this.formObject.medidaId) {
	                this.unidadeObject = { id: this.formObject.medidaId };
	                this.setMedidaOnMaterial(this.formObject.medidaId);
	                delete this.formObject['medida'];
	            }
	        }
	        if (this.servicomaterialObject) {
	            var selectObject = { text: this.servicomaterialObject.descricao, id: this.servicomaterialObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.materiaisServicosSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.materiaisServicosSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'servicomaterial', this.servicomaterialObject);
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.toLeaveHere = function () {
	        this.goToDetail();
	    };
	    OrdemServicoItemFormComponent.prototype.goToList = function () {
	        this._ordemServicoNavigationService.goToList();
	    };
	    OrdemServicoItemFormComponent.prototype.goToDetail = function () {
	        this._ordemServicoNavigationService.goToDetail(this.ordemServicoObject.id);
	    };
	    OrdemServicoItemFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_1.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_1.newRoute;
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    OrdemServicoItemFormComponent.prototype.setNewNormal = function () {
	        if (this.isService) {
	            this.formObject.data = this._utilService.convertDateToString(new Date());
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.getOrdemServico = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.ordemServicoObject = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma manutenção encontrada com este id.');
	                this.clickGoToDetail();
	            }
	        }.bind(this));
	        var osId = +this._route.snapshot.params['osId'];
	        this._ordemServicoApiService.onGetById(osId, onDone);
	    };
	    OrdemServicoItemFormComponent.prototype.getMedidas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = void 0, lenX = void 0;
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.medidasList = list;
	                if (this.unidadeObject.id) {
	                    this.setMedidaOnMaterial(this.unidadeObject.id);
	                }
	            }
	        }.bind(this));
	        this._medidaApiService.onGetAll(onDone);
	    };
	    OrdemServicoItemFormComponent.prototype.setMedidaOnMaterial = function (medidaId) {
	        var x, lenX;
	        for (x = 0, lenX = this.medidasList.length; x < lenX; x++) {
	            if (medidaId === this.medidasList[x].id) {
	                this.unidadeObject = this.medidasList[x];
	                break;
	            }
	        }
	    };
	    OrdemServicoItemFormComponent.prototype.calculateTotal = function () {
	        if (!this.formObject.quantidade) {
	            this.formObject.quantidade = 1;
	        }
	        if (!this.formObject.valor) {
	            this.formObject.valor = 0;
	        }
	        var valor = this.formObject.valor;
	        if (valor) {
	            if (isNumeric_1.isNumeric(valor)) {
	                valor = valor.toString();
	            }
	            else {
	                valor = valor.replace(/\./g, "");
	                valor = valor.replace(",", ".");
	            }
	        }
	        valor = parseFloat(valor);
	        if (!valor)
	            valor = 0;
	        valor = this.formObject.quantidade * valor;
	        valor = valor.toFixed(2);
	        this.total = this._utilService.currencyFormat(valor, true);
	    };
	    OrdemServicoItemFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(725),
	            styles: [__webpack_require__(726)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_api_service_1.OrdemServicoApiService !== 'undefined' && ordem_servico_api_service_1.OrdemServicoApiService) === 'function' && _c) || Object, (typeof (_d = typeof medida_api_service_1.MedidaApiService !== 'undefined' && medida_api_service_1.MedidaApiService) === 'function' && _d) || Object, (typeof (_e = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _e) || Object, (typeof (_f = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _f) || Object, (typeof (_g = typeof material_ordem_servico_api_service_1.MaterialOrdemServicoApiService !== 'undefined' && material_ordem_servico_api_service_1.MaterialOrdemServicoApiService) === 'function' && _g) || Object, (typeof (_h = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _h) || Object, (typeof (_j = typeof servico_navigation_service_1.ServicoNavigationService !== 'undefined' && servico_navigation_service_1.ServicoNavigationService) === 'function' && _j) || Object, (typeof (_k = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _k) || Object, (typeof (_l = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _l) || Object, (typeof (_m = typeof material_servico_api_service_1.MaterialServicoApiService !== 'undefined' && material_servico_api_service_1.MaterialServicoApiService) === 'function' && _m) || Object, (typeof (_o = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _o) || Object])
	    ], OrdemServicoItemFormComponent);
	    return OrdemServicoItemFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
	}());
	exports.OrdemServicoItemFormComponent = OrdemServicoItemFormComponent;


/***/ },
/* 725 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{ordemServicoModuleName.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToDetail()\" class=\"cursor-pointer\">{{ordemServicoObject.numero}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{itemComponentName}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{itemComponentName}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c\">\n            <autocomplete-component class=\"geo-input--3c\" id=\"servicos\" *ngIf=\"isService\"\n                                    (setObejct)=\"getMateriaisServicosObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"materiaisServicosSelectId\"\n                                    [model]=\"servicomaterialObject\"\n                                    [_service]=\"_servicoApiService\"\n                                    [isCreateNew]=\"true\"\n                                    [query]=\"materiaisServicosQuery\"\n                                    [templateResult]=\"materiaisServicosTemplateResult\"\n                                    [label]=\"'Serviço'\"></autocomplete-component>\n\n            <autocomplete-component class=\"geo-input--3c\" id=\"materiais\" *ngIf=\"!isService\"\n                                    (setObejct)=\"getMateriaisServicosObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"materiaisServicosSelectId\"\n                                    [model]=\"servicomaterialObject\"\n                                    [_service]=\"_materialService\"\n                                    [isCreateNew]=\"true\"\n                                    [query]=\"materiaisServicosQuery\"\n                                    [templateResult]=\"materiaisServicosTemplateResult\"\n                                    [label]=\"'Material'\"></autocomplete-component>\n\n\n            <div class=\"geo-input--3c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': (!data || !data.value) && submitted}\" *ngIf=\"isService\">\n                <label>Data <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!data && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" class=\"input-datepicker\" id=\"data\" [(ngModel)]=\"formObject.data\" formControlName=\"data\" appDatepicker autocomplete=\"off\" />\n                </div>\n            </div>\n        </div>\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !quantidade.valid && submitted}\">\n                <label for=\"quantidade\">Quantidade <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!quantidade.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" class=\"form-control\" id=\"quantidade\" placeholder=\"\" [(ngModel)]=\"formObject.quantidade\" appNumberInteger formControlName=\"quantidade\" (keyup)=\"keyupQuantidade()\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !medida.valid && submitted}\" *ngIf=\"!isService\">\n                <label>Medida <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!medida.valid && submitted\">Este campo é obrigatório.</span>\n                    <select [(ngModel)]=\"unidadeObject\" formControlName=\"medida\">\n                        <option *ngFor=\"let item of medidasList\" id=\"medida_{{item.id}}\" [ngValue]=\"item\">{{item.medida}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!valor.valid || formObject.valor == 0 || formObject.valor === '0,00') && submitted}\">\n                <label for=\"valor_unitario\">Valor unitário (R$) <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"(!valor.valid || formObject.valor == 0 || formObject.valor === '0,00') && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"valor_unitario\" [(ngModel)]=\"formObject.valor\" formControlName=\"valor\" (keyup)=\"keyupCurrency()\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label>Total (R$) <abbr>*</abbr></label>\n                <div>\n                    <input type=\"text\" id=\"valor\" [(ngModel)]=\"total\" formControlName=\"valorTotal\">\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 726 */
206,
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(200);
	var util_service_1 = __webpack_require__(88);
	var autocomplete_service_1 = __webpack_require__(101);
	var frota_service_1 = __webpack_require__(203);
	var frota_api_service_1 = __webpack_require__(368);
	var data_service_2 = __webpack_require__(154);
	var data_service_3 = __webpack_require__(234);
	var localidade_api_service_1 = __webpack_require__(227);
	var data_service_4 = __webpack_require__(148);
	var ordem_servico_api_service_1 = __webpack_require__(421);
	var ordem_servico_service_1 = __webpack_require__(235);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var OrdemServicoCalendarComponent = (function () {
	    function OrdemServicoCalendarComponent(_ordemServicoApiService, _ordemServicoService, _ordemServicoNavigationService, _utilService, _localidadeApiService, _frotaService, _frotaApiService, _autocompleteService) {
	        this._ordemServicoApiService = _ordemServicoApiService;
	        this._ordemServicoService = _ordemServicoService;
	        this._ordemServicoNavigationService = _ordemServicoNavigationService;
	        this._utilService = _utilService;
	        this._localidadeApiService = _localidadeApiService;
	        this._frotaService = _frotaService;
	        this._frotaApiService = _frotaApiService;
	        this._autocompleteService = _autocompleteService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.ordemServicosModuleName = data_service_1.ordensServicoModuleName;
	        this.module = data_service_3.manutencoesModuleName;
	        this.statusSearch = {};
	        this.statusList = [];
	        this.tipoSearch = {};
	        this.tiposList = [];
	        this.localidadeSearch = {};
	        this.localidadeSelectId = 'localidade';
	        this.localidadeQuery = {};
	        this.frotaSearch = {};
	        this.frotaSelectId = 'frota';
	        this.frotaQuery = {};
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, eItem = void 0, events = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    Response[x].tipo = this._ordemServicoService.getTipoOrdemServico(Response[x].tipo);
	                    Response[x].status = this._ordemServicoService.getStatusOrdemServico(Response[x].status);
	                    eItem = this.calendarEvents(Response[x]);
	                    events.push(eItem);
	                }
	                this.list = events;
	                this.setCalendarEvents(events);
	            }
	            this.loading = false;
	        }.bind(this));
	    }
	    OrdemServicoCalendarComponent.prototype.ngOnInit = function () {
	        this.localidadeQuery = this._utilService.cloneObject(data_service_4.localidadesQuery);
	        this.frotaQuery = this._utilService.cloneObject(data_service_2.frotasQuery);
	        this.getStatus();
	        this.getTipos();
	        this.clickClearSearch();
	        this.createCalendar();
	    };
	    OrdemServicoCalendarComponent.prototype.changeStatus = function () {
	        this.queryMovimentacoes();
	    };
	    OrdemServicoCalendarComponent.prototype.changeTipo = function () {
	        this.queryMovimentacoes();
	    };
	    OrdemServicoCalendarComponent.prototype.clickClearSearch = function () {
	        this.statusSearch = this.statusList[0];
	        this.statusSearch = this.statusList[0];
	        this.frotaSearch = {};
	        this.localidadeSearch = {};
	        this._autocompleteService.setValueOnSelect2(null, "frota");
	        this._autocompleteService.setValueOnSelect2(null, "localidade");
	        this.queryMovimentacoes();
	    };
	    OrdemServicoCalendarComponent.prototype.getLocalidadeObject = function (object) {
	        this.localidadeSearch = object;
	        this.queryMovimentacoes();
	    };
	    OrdemServicoCalendarComponent.prototype.getFrotaObject = function (object) {
	        this.frotaSearch = object;
	        this.queryMovimentacoes();
	    };
	    OrdemServicoCalendarComponent.prototype.queryMovimentacoes = function () {
	        var query = { "where": {} };
	        if (this.statusSearch.Key) {
	            query.where.status = this.statusSearch.Key;
	        }
	        if (this.tipoSearch.Key) {
	            query.where.tipo = this.tipoSearch.Key;
	        }
	        if (this.localidadeSearch.id) {
	            query.where.localidadeId = this.localidadeSearch.id;
	        }
	        if (this.frotaSearch.id) {
	            query.where.bemId = this.frotaSearch.id;
	        }
	        query.where.ativo = true;
	        this.getMovimentacoes(query);
	    };
	    OrdemServicoCalendarComponent.prototype.getMovimentacoes = function (query) {
	        this.loading = true;
	        this._ordemServicoApiService.onGetByFilter(query, this.onDone);
	    };
	    OrdemServicoCalendarComponent.prototype.getStatus = function () {
	        var list = this._utilService.cloneObject(data_service_1.OrdemServicoStatus);
	        list.unshift({ Key: null, Value: '— Status —' });
	        this.statusList = list;
	        this.statusSearch = this.statusList[0];
	    };
	    OrdemServicoCalendarComponent.prototype.getTipos = function () {
	        var list = this._utilService.cloneObject(data_service_1.TipoOrdemServico);
	        list.unshift({ Key: null, Value: '— Tipo —' });
	        this.tiposList = list;
	        this.tipoSearch = this.tiposList[0];
	    };
	    OrdemServicoCalendarComponent.prototype.createCalendar = function () {
	        var c = this._ordemServicoNavigationService;
	        $('#calendar').fullCalendar({
	            header: {
	                left: 'prev,next today',
	                center: 'title',
	                right: 'month,basicWeek,basicDay'
	            },
	            locale: 'pt-br',
	            height: 'auto',
	            events: [],
	            displayEventTime: false,
	            eventRender: function (event, element) {
	                var t = element.find('.fc-title');
	                t.html(t.text());
	            },
	            eventClick: function (calEvent, jsEvent, view) {
	                c.goToDetail(calEvent.id);
	            }
	        });
	    };
	    OrdemServicoCalendarComponent.prototype.setCalendarEvents = function (events) {
	        $('#calendar').fullCalendar('removeEventSources');
	        $('#calendar').fullCalendar('addEventSource', events);
	    };
	    OrdemServicoCalendarComponent.prototype.calendarEvents = function (item) {
	        var tipo = '', localidade = '', bem = '', status = '', placa = '', title, cancelado = this._ordemServicoService.getStatusCancelado(), color = '#4C87FF';
	        if (item.tipo) {
	            tipo = item.tipo.Value;
	        }
	        if (item.status) {
	            status = " - " + item.status.Value + "<br />";
	            if (item.status.Key === cancelado.Key) {
	                color = '#8e928e';
	            }
	        }
	        if (item.localidade) {
	            localidade = "Localidade: " + item.localidade.localidade + "<br />";
	        }
	        if (item.bem) {
	            if (item.bem.placa) {
	                placa = item.bem.placa.toUpperCase();
	                placa = placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
	                placa = " / ".concat(placa);
	            }
	            bem = " " + item.bem.identificacao + " " + placa + "<br />";
	        }
	        title = tipo + "" + status + "" + localidade + "" + bem;
	        var event = {
	            id: item.id,
	            title: title,
	            start: item.dataEntrada,
	            end: item.dataSaida,
	            color: color,
	            textColor: '#FFFFFF'
	        };
	        return event;
	    };
	    OrdemServicoCalendarComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(728),
	            styles: [__webpack_require__(729)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ordem_servico_api_service_1.OrdemServicoApiService !== 'undefined' && ordem_servico_api_service_1.OrdemServicoApiService) === 'function' && _a) || Object, (typeof (_b = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof localidade_api_service_1.LocalidadeApiService !== 'undefined' && localidade_api_service_1.LocalidadeApiService) === 'function' && _e) || Object, (typeof (_f = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _f) || Object, (typeof (_g = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _g) || Object, (typeof (_h = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _h) || Object])
	    ], OrdemServicoCalendarComponent);
	    return OrdemServicoCalendarComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.OrdemServicoCalendarComponent = OrdemServicoCalendarComponent;


/***/ },
/* 728 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">Agenda</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>Agenda</h1>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"frota\"\n                                (setObejct)=\"getFrotaObject($event)\"\n                                (clearObject)=\"getFrotaObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"frotaSearch\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'— Frota / equipamento —'\"\n                                [query]=\"frotaQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"localidade\"\n                                (setObejct)=\"getLocalidadeObject($event)\"\n                                (clearObject)=\"getLocalidadeObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"localidadeSelectId\"\n                                [model]=\"localidadeSearch\"\n                                [_service]=\"_localidadeApiService\"\n                                [fieldToShow]=\"'localidade'\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'— Localidade —'\"\n                                [query]=\"localidadeQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"tipo\" [(ngModel)]=\"tipoSearch\" (ngModelChange)=\"changeTipo()\" class=\"option_{{tipoSearch.Key}}\">\n                    <option *ngFor=\"let item of tiposList\" id=\"tipo_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"status\" [(ngModel)]=\"statusSearch\" (ngModelChange)=\"changeStatus()\" class=\"option_{{statusSearch.Key}}\">\n                    <option *ngFor=\"let item of statusList\" id=\"status_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c geo-columns--right\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickClearSearch()\" class=\"cursor-pointer clear-search\">Limpar busca</a>\n        </p>\n    </div>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{ordemServicosModuleName.single | lowercase}} encontrada</p>\n\n</div>\n\n<div class=\"geo-content__row\">\n    <div id='calendar'></div>\n</div>";

/***/ },
/* 729 */
662,
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ManutencaoProgramadaComponent = (function () {
	    function ManutencaoProgramadaComponent() {
	    }
	    ManutencaoProgramadaComponent.prototype.ngOnInit = function () {
	    };
	    ManutencaoProgramadaComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(731)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ManutencaoProgramadaComponent);
	    return ManutencaoProgramadaComponent;
	}());
	exports.ManutencaoProgramadaComponent = ManutencaoProgramadaComponent;


/***/ },
/* 731 */
171,
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var manutencao_programada_list_component_1 = __webpack_require__(733);
	var data_service_1 = __webpack_require__(200);
	var data_service_2 = __webpack_require__(178);
	var ordem_servico_form_component_1 = __webpack_require__(426);
	var data_service_3 = __webpack_require__(429);
	var servico_bem_form_component_1 = __webpack_require__(737);
	var manutencaoPprogramadaRoutingModule = (function () {
	    function manutencaoPprogramadaRoutingModule() {
	    }
	    manutencaoPprogramadaRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], manutencaoPprogramadaRoutingModule);
	    return manutencaoPprogramadaRoutingModule;
	}());
	exports.manutencaoPprogramadaRoutingModule = manutencaoPprogramadaRoutingModule;
	exports.manutencaoProgramadaRoutes = [
	    {
	        path: '',
	        component: manutencao_programada_list_component_1.ManutencaoProgramadaListComponent
	    }, {
	        path: data_service_1.ordensServicoRoute + '/' + data_service_2.newRoute,
	        component: ordem_servico_form_component_1.OrdemServicosFormComponent
	    }, {
	        path: data_service_3.servicosRoute + '/:id',
	        component: servico_bem_form_component_1.ServicoBemFormComponent
	    }
	];


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(234);
	var util_service_1 = __webpack_require__(88);
	var manutencao_programada_api_service_1 = __webpack_require__(734);
	var data_service_2 = __webpack_require__(423);
	var data_service_3 = __webpack_require__(154);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var autocomplete_service_1 = __webpack_require__(101);
	var manutencao_programada_service_1 = __webpack_require__(422);
	var manutencao_programada_navigation_service_1 = __webpack_require__(428);
	var ordem_servico_service_1 = __webpack_require__(235);
	var servico_api_service_1 = __webpack_require__(430);
	var odometro_horimetro_service_1 = __webpack_require__(131);
	var plano_service_1 = __webpack_require__(442);
	var ManutencaoProgramadaListComponent = (function () {
	    function ManutencaoProgramadaListComponent(_manutencaoProgramadaApiService, _manutencaoProgramadaService, _manutencaoProgramadaNavigationService, _frotaApiService, _frotaService, _utilService, _autocompleteService, _ordemServicoService, _servicoApiService, _odometroHorimetroService, _planoService) {
	        this._manutencaoProgramadaApiService = _manutencaoProgramadaApiService;
	        this._manutencaoProgramadaService = _manutencaoProgramadaService;
	        this._manutencaoProgramadaNavigationService = _manutencaoProgramadaNavigationService;
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._ordemServicoService = _ordemServicoService;
	        this._servicoApiService = _servicoApiService;
	        this._odometroHorimetroService = _odometroHorimetroService;
	        this._planoService = _planoService;
	        this.list = [];
	        this.loading = true;
	        this.manutencaoProgramadaModuleName = data_service_2.manutencoesProgramadaModuleName;
	        this.module = data_service_1.manutencoesModuleName;
	        this.bemObject = {};
	        this.frotaSelectId = 'frota';
	        this.tipoObject = {};
	        this.tiposList = [];
	        this.selectedObject = {};
	        this.selectedList = [];
	        this.selectedItem = [];
	        this.cloneList = [];
	        this.checkList = [];
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	    }
	    ManutencaoProgramadaListComponent.prototype.ngOnInit = function () {
	        this.frotaQuery = this._utilService.cloneObject(data_service_3.frotasQuery);
	        this.tiposList = this._utilService.cloneObject(data_service_2.tiposVencimento);
	        this.tiposList.unshift({ Key: null, Value: 'Todos' });
	        this.selectedList = this._utilService.cloneObject(data_service_2.selectedList);
	        this.selectedList.unshift({ Key: null, Value: '— Selecione uma ação —' });
	        this.selectedObject = this.selectedList[0];
	        this.clickClear();
	        this.getAll();
	    };
	    ManutencaoProgramadaListComponent.prototype.clickEdit = function (item) {
	        this._manutencaoProgramadaNavigationService.goToServico(item.id);
	    };
	    ManutencaoProgramadaListComponent.prototype.clickManut = function (item) {
	        this.changeItem(item, false);
	        this.criarManutencao();
	    };
	    ManutencaoProgramadaListComponent.prototype.clickDelete = function (item) {
	        swal({
	            title: "Você deseja realmente desativar este(s) serviço(s)?",
	            text: "Este e todos os serviços futuros serão desativados.",
	            type: "warning",
	            showCancelButton: true,
	            confirmButtonText: "Sim, Desativar",
	            cancelButtonText: "Cancelar",
	            closeOnConfirm: false
	        }, function () {
	            var list = [], x, lenX;
	            if (item) {
	                list.push({ id: item.id });
	            }
	            else {
	                for (x = 0, lenX = this.checkList.length; x < lenX; x++) {
	                    list.push({ id: this.checkList[x].id });
	                }
	            }
	            this.onDelete(list);
	        }.bind(this));
	    };
	    ManutencaoProgramadaListComponent.prototype.clickClear = function () {
	        this.bemObject = {};
	        this.tipoObject = this.tiposList[1];
	        this._autocompleteService.setValueOnSelect2(null, this.frotaSelectId);
	        //this.list = this._utilService.cloneObject(this.cloneList);
	        this.filterList();
	    };
	    ManutencaoProgramadaListComponent.prototype.changeTipo = function () {
	        this.filterList();
	    };
	    ManutencaoProgramadaListComponent.prototype.changeSelected = function () {
	        if (this.checkList.length) {
	            if (this.selectedObject.Key === 1) {
	                //criar manutencao
	                var x = void 0, lenX = void 0, bemId = void 0, different = false;
	                for (x = 0, lenX = this.checkList.length; x < lenX; x++) {
	                    if (!bemId) {
	                        bemId = this.checkList[x].bemId;
	                    }
	                    if (this.checkList[x].bemId !== bemId) {
	                        different = true;
	                        break;
	                    }
	                }
	                if (different) {
	                    this._utilService.swalMessageWarningCustom("A manutenção somente poderá ser criada para serviços de uma mesma Frota/equipamento");
	                }
	                else {
	                    this.criarManutencao();
	                }
	            }
	            else if (this.selectedObject.Key === 2) {
	                //excluir
	                this.clickDelete();
	            }
	        }
	    };
	    ManutencaoProgramadaListComponent.prototype.getFrotaObject = function (object) {
	        this.bemObject = object;
	        this.filterList();
	    };
	    ManutencaoProgramadaListComponent.prototype.changeItem = function (item, splice) {
	        var x, lenX, found = false;
	        for (x = 0, lenX = this.checkList.length; x < lenX; x++) {
	            if (item.id === this.checkList[x].id) {
	                if (splice) {
	                    this.checkList.splice(x, 1);
	                }
	                found = true;
	                break;
	            }
	        }
	        if (!found) {
	            this.checkList.push(item);
	        }
	    };
	    ManutencaoProgramadaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var minutes = 1000 * 60, hours = minutes * 60, days_1 = hours * 24;
	                var c;
	                Response.forEach(function (item) {
	                    if (item.StatusTempo && item.StatusTempo.Key) {
	                        c = Math.round((item.InfoTempo.fim - item.InfoTempo.atual) / days_1);
	                        c = (c < 0) ? (c * (-1)) : c;
	                        item.InfoTempo.aVencer = c;
	                    }
	                    else {
	                        item.StatusTempo = {};
	                        item.InfoTempo = {};
	                    }
	                    item.referenciaTempo = this._planoService.getReferenciaTempo(item.referenciaTempo);
	                    if (item.servico.descricao === 'Serviço B') {
	                    }
	                    if (item.StatusOdometroHorimetro && item.StatusOdometroHorimetro.Key) {
	                        c = item.InfoOdometroHorimetro.fim - item.InfoOdometroHorimetro.atual;
	                        c = (c < 0) ? (c * (-1)) : c;
	                        item.InfoOdometroHorimetro.atual = this._odometroHorimetroService.setMask(item.InfoOdometroHorimetro.atual);
	                        item.InfoOdometroHorimetro.fim = this._odometroHorimetroService.setMask(item.InfoOdometroHorimetro.fim);
	                        item.InfoOdometroHorimetro.aVencer = this._odometroHorimetroService.setMask(c);
	                    }
	                    else {
	                        item.InfoOdometroHorimetro = {};
	                        item.StatusOdometroHorimetro = {};
	                    }
	                }.bind(this));
	                this.list = Response;
	                this.cloneList = this._utilService.cloneObject(Response);
	                this.filterList();
	            }
	            this.loading = false;
	        }.bind(this));
	        this._manutencaoProgramadaApiService.onGetAll(onDone);
	    };
	    ManutencaoProgramadaListComponent.prototype.criarManutencao = function () {
	        this._ordemServicoService.clearSessionStorage();
	        this._manutencaoProgramadaService.setSessionStorage(this.checkList);
	        this._manutencaoProgramadaNavigationService.goToNewOS();
	    };
	    ManutencaoProgramadaListComponent.prototype.onDelete = function (items) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX, y, lenY;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    for (y = 0, lenY = items.length; y < lenY; y++) {
	                        if (this.list[x].id === items[y].id) {
	                            this.list[x].ativo = false;
	                            break;
	                        }
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        var obj = { Servicos: items };
	        this._servicoApiService.onDeleteServicosBem(obj, onDone);
	    };
	    ManutencaoProgramadaListComponent.prototype.filterList = function () {
	        var x, lenX, list = [], f1, f2, f3;
	        for (x = 0, lenX = this.cloneList.length; x < lenX; x++) {
	            f1 = true;
	            f2 = true;
	            f3 = true;
	            if (this.bemObject.id) {
	                if (this.cloneList[x].bem.id !== this.bemObject.id) {
	                    f1 = false;
	                }
	            }
	            if (this.tipoObject && this.tipoObject.Key) {
	                if (this.cloneList[x].StatusTempo) {
	                    if (this.cloneList[x].StatusTempo.Key !== this.tipoObject.Key) {
	                        f2 = false;
	                    }
	                }
	                if (this.cloneList[x].StatusOdometroHorimetro) {
	                    if (this.cloneList[x].StatusOdometroHorimetro.Key !== this.tipoObject.Key) {
	                        f3 = false;
	                    }
	                }
	            }
	            if (f1 && (f2 || f3)) {
	                list.push(this.cloneList[x]);
	            }
	        }
	        this.list = list;
	    };
	    ManutencaoProgramadaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(735),
	            styles: [__webpack_require__(736)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof manutencao_programada_api_service_1.ManutencaoProgramadaApiService !== 'undefined' && manutencao_programada_api_service_1.ManutencaoProgramadaApiService) === 'function' && _a) || Object, (typeof (_b = typeof manutencao_programada_service_1.ManutencaoProgramadaService !== 'undefined' && manutencao_programada_service_1.ManutencaoProgramadaService) === 'function' && _b) || Object, (typeof (_c = typeof manutencao_programada_navigation_service_1.ManutencaoProgramadaNavigationService !== 'undefined' && manutencao_programada_navigation_service_1.ManutencaoProgramadaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _d) || Object, (typeof (_e = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object, (typeof (_g = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _g) || Object, (typeof (_h = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _h) || Object, (typeof (_j = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _j) || Object, (typeof (_k = typeof odometro_horimetro_service_1.OdometroHorimetroService !== 'undefined' && odometro_horimetro_service_1.OdometroHorimetroService) === 'function' && _k) || Object, (typeof (_l = typeof plano_service_1.PlanoService !== 'undefined' && plano_service_1.PlanoService) === 'function' && _l) || Object])
	    ], ManutencaoProgramadaListComponent);
	    return ManutencaoProgramadaListComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.ManutencaoProgramadaListComponent = ManutencaoProgramadaListComponent;


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(423);
	var ManutencaoProgramadaApiService = (function () {
	    function ManutencaoProgramadaApiService(_restService) {
	        this._restService = _restService;
	    }
	    ManutencaoProgramadaApiService.prototype.onGetAll = function (done) {
	        this._restService.onGet(data_service_1.apiName + '/alarmes', done);
	    };
	    ManutencaoProgramadaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ManutencaoProgramadaApiService);
	    return ManutencaoProgramadaApiService;
	    var _a;
	}());
	exports.ManutencaoProgramadaApiService = ManutencaoProgramadaApiService;


/***/ },
/* 735 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">{{manutencaoProgramadaModuleName.plural}}</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>{{manutencaoProgramadaModuleName.plural}}</h1>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"selecionados\" [(ngModel)]=\"selectedObject\" (ngModelChange)=\"changeSelected()\" class=\"option_{{selectedObject.Key}}\">\n                    <option *ngFor=\"let item of selectedList\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\"></div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"tipo\" [(ngModel)]=\"tipoObject\" (ngModelChange)=\"changeTipo()\">\n                    <option *ngFor=\"let item of tiposList\" id=\"tipo_{{item.Key}}\" [ngValue]=\"item\" >{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"frota\"\n                                (setObejct)=\"getFrotaObject($event)\"\n                                (clearObject)=\"getFrotaObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"bemObject\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'Frota / equipamento'\"\n                                [query]=\"frotaQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--12c geo-columns--right\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickClear()\" class=\"cursor-pointer clear-search\">Limpar filtro</a>\n        </p>\n    </div>\n\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{manutencaoProgramadaModuleName.single | lowercase}} cadastrada</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Frota / equipamento</th>\n            <th>Serviço</th>\n            <th>Odômetro / horímetro atual</th>\n            <th>Period. km/hora</th>\n            <th>Venc. km/hora</th>\n            <th>Period. tempo</th>\n            <th>Venc. tempo</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filterActive:true | sort:['bem.identificacao']);let i = index;\">\n        <tr [ngClass]=\"{inative: item.naManutencao}\">\n            <td>\n                <input type=\"checkbox\" id=\"check_{{i}}\" [(ngModel)]=\"selectedItem[i]\" (ngModelChange)=\"changeItem(item, true)\">\n                <label attr.for=\"check_{{i}}\" *ngIf=\"item.bem\">{{item.bem.identificacao}} <span *ngIf=\"item.bem.placa\"> / {{item.bem.placa | licensePlateMask}}</span></label>\n            </td>\n            <td><span *ngIf=\"item.servico\">{{item.servico.descricao}}</span></td>\n            <td><span *ngIf=\"item.InfoOdometroHorimetro\">{{item.InfoOdometroHorimetro.atual}}</span></td>\n            <td><span>{{item.periodicidadeOdometroHorimetro | odometroHorimetroMask}}</span></td>\n            <td>\n                <span *ngIf=\"item.InfoOdometroHorimetro\" [ngClass]=\"item.StatusOdometroHorimetro.Value\">\n                    <span *ngIf=\"item.InfoOdometroHorimetro.aVencer\">em {{item.InfoOdometroHorimetro.aVencer}}</span>\n                </span>\n            </td>\n            <td><span *ngIf=\"item.periodicidadeTempo\">{{item.periodicidadeTempo}} <span *ngIf=\"item.referenciaTempo\">{{item.referenciaTempo.Value}}</span></span></td>\n            <td>\n                <span *ngIf=\"item.InfoTempo\" [ngClass]=\"item.StatusTempo.Value\">\n                    <span *ngIf=\"item.InfoTempo.aVencer\">em {{item.InfoTempo.aVencer}} dia(s)</span>\n                </span>\n            </td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickManut(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-manutencao'/></svg>\n                </a>\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 736 */
/***/ function(module, exports) {

	module.exports = ".Vermelho {\n    color: #f83636;\n    font-weight: bold;\n}\n.Amarelo {\n    color: #ef7d18;\n    font-weight: bold;\n}\n.Verde {\n    color: #3ca63c;\n    font-weight: bold;\n}\n.cursor-pointer {\n    cursor: pointer;\n}\n.advanced-search {\n     border-bottom: 1px solid #edf0f4;\n     margin: -0.5em 1.5em 1em 0;\n     padding-bottom: 1em;\n }\n\ntd span span {\n    color: inherit;\n}"

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(423);
	var data_service_2 = __webpack_require__(234);
	var data_service_3 = __webpack_require__(429);
	var servico_model_1 = __webpack_require__(708);
	var frota_model_1 = __webpack_require__(373);
	var manutencao_programada_navigation_service_1 = __webpack_require__(428);
	var servico_api_service_1 = __webpack_require__(430);
	var manutencao_programada_service_1 = __webpack_require__(422);
	var util_service_1 = __webpack_require__(88);
	var plano_service_1 = __webpack_require__(442);
	var odometro_horimetro_service_1 = __webpack_require__(131);
	var forma_controle_service_1 = __webpack_require__(369);
	var ServicoBemFormComponent = (function () {
	    function ServicoBemFormComponent(_route, _manutencaoProgramadaNavigationService, _servicoApiService, _manutencaoProgramadaService, _planoService, _utilService, _odometroHorimetroService, _formaControleService, _fb) {
	        this._route = _route;
	        this._manutencaoProgramadaNavigationService = _manutencaoProgramadaNavigationService;
	        this._servicoApiService = _servicoApiService;
	        this._manutencaoProgramadaService = _manutencaoProgramadaService;
	        this._planoService = _planoService;
	        this._utilService = _utilService;
	        this._odometroHorimetroService = _odometroHorimetroService;
	        this._formaControleService = _formaControleService;
	        this._fb = _fb;
	        this.module = data_service_2.manutencoesModuleName;
	        this.manutencaoProgramadaModule = data_service_1.manutencoesProgramadaModuleName;
	        this.servicosModule = data_service_3.servicosModuleName;
	        this.formObject = new servico_model_1.ServicoBem();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.frotaObject = new frota_model_1.Frota();
	        this.servicoObject = new servico_model_1.Servico();
	        this.periodicidadeOdometroHorimetro = new forms_1.FormControl({ value: '', disabled: true });
	        this.periodicidadeTempo = new forms_1.FormControl({ value: '', disabled: true });
	        this.servico = new forms_1.FormControl({ value: '', disabled: true });
	        this.bem = new forms_1.FormControl({ value: '', disabled: true });
	        this.proximaExecucaoOdometroHorimetro = new forms_1.FormControl('');
	        this.proximaExecucaoTempo = new forms_1.FormControl('');
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this._utilService.swalMessageEditSuccess();
	                this.clickGoToList();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            periodicidadeOdometroHorimetro: this.periodicidadeOdometroHorimetro,
	            periodicidadeTempo: this.periodicidadeTempo,
	            servico: this.servico,
	            bem: this.bem,
	            proximaExecucaoOdometroHorimetro: this.proximaExecucaoOdometroHorimetro,
	            proximaExecucaoTempo: this.proximaExecucaoTempo
	        });
	    }
	    ServicoBemFormComponent.prototype.ngOnInit = function () {
	        var id = +this._route.snapshot.params['id'];
	        this.getObject(id);
	    };
	    ServicoBemFormComponent.prototype.clickGoToList = function () {
	        this._manutencaoProgramadaNavigationService.goToList();
	    };
	    ServicoBemFormComponent.prototype.clickCancel = function () {
	        this._manutencaoProgramadaNavigationService.goToList();
	    };
	    ServicoBemFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            var date = document.getElementById('data');
	            if (date.value) {
	                date = this._utilService.convertStringToDate(date.value);
	                date = new Date(date);
	                date.setHours(8);
	                date = +(date);
	                object.proximaExecucaoTempo = date;
	            }
	            object.proximaExecucaoOdometroHorimetro = this._odometroHorimetroService.setMask(object.proximaExecucaoOdometroHorimetro);
	            object.proximaExecucaoOdometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.proximaExecucaoOdometroHorimetro);
	            this.onEditServicoBem(object);
	        }
	    };
	    ServicoBemFormComponent.prototype.onEditServicoBem = function (object) {
	        this._servicoApiService.onPutServicoBem(object, this.onDone);
	    };
	    ServicoBemFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma serviço encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._servicoApiService.onGetByIdServicoBem(id, onDone);
	    };
	    ServicoBemFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.bem) {
	            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
	            delete this.formObject['bem'];
	        }
	        if (this.formObject.servico) {
	            this.servicoObject = this._utilService.cloneObject(this.formObject.servico);
	            delete this.formObject['servico'];
	        }
	        if (this.formObject.periodicidadeTempo) {
	            var t = this.formObject.periodicidadeTempo;
	            t = t.toString();
	            if (this.formObject.referenciaTempo) {
	                this.refTempo = this._planoService.getReferenciaTempo(this.formObject.referenciaTempo);
	                t = t.concat(" " + this.refTempo.Value);
	                this.periodicidadeTempoText = t;
	            }
	        }
	        if (this.formObject.proximaExecucaoTempo) {
	            var t = this.formObject.proximaExecucaoTempo;
	            this.formObject.proximaExecucaoTempoData = this._utilService.convertDateToString(t);
	        }
	    };
	    ServicoBemFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(738),
	            styles: [__webpack_require__(739)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof manutencao_programada_navigation_service_1.ManutencaoProgramadaNavigationService !== 'undefined' && manutencao_programada_navigation_service_1.ManutencaoProgramadaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _c) || Object, (typeof (_d = typeof manutencao_programada_service_1.ManutencaoProgramadaService !== 'undefined' && manutencao_programada_service_1.ManutencaoProgramadaService) === 'function' && _d) || Object, (typeof (_e = typeof plano_service_1.PlanoService !== 'undefined' && plano_service_1.PlanoService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object, (typeof (_g = typeof odometro_horimetro_service_1.OdometroHorimetroService !== 'undefined' && odometro_horimetro_service_1.OdometroHorimetroService) === 'function' && _g) || Object, (typeof (_h = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], ServicoBemFormComponent);
	    return ServicoBemFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.ServicoBemFormComponent = ServicoBemFormComponent;


/***/ },
/* 738 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{manutencaoProgramadaModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{servicosModule.single}}</a></li>\n        </ul>\n    </div>\n    <h1>Ajustar {{servicosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--6c\">\n            <label for=\"identificacao\">Frota / equipamento </label>\n            <div>\n                <input type=\"text\" class=\"form-control\" id=\"identificacao\" [(ngModel)]=\"frotaObject.identificacao\" formControlName=\"bem\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--6c\">\n            <label for=\"servico\">Serviço </label>\n            <div>\n                <input type=\"text\" class=\"form-control\" id=\"servico\" [(ngModel)]=\"servicoObject.descricao\" formControlName=\"servico\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" *ngIf=\"formObject.periodicidadeOdometroHorimetro\">\n            <label for=\"periodicidadeOdometroHorimetro\">Periodicidade de km/hora </label>\n            <div>\n                <input type=\"text\" id=\"periodicidadeOdometroHorimetro\" [(ngModel)]=\"formObject.periodicidadeOdometroHorimetro\" appOdometroHorimetroMask formControlName=\"periodicidadeOdometroHorimetro\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" *ngIf=\"formObject.periodicidadeTempo\">\n            <label for=\"periodicidadeTempo\">Periodicidade de tempo</label>\n            <div>\n                <input type=\"text\" id=\"periodicidadeTempo\" [(ngModel)]=\"periodicidadeTempoText\" formControlName=\"periodicidadeTempo\">\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" *ngIf=\"formObject.periodicidadeOdometroHorimetro\">\n            <label for=\"ajustePeriodicidadeOdometroHorimetro\">Ajustar próximo alarme de km/hora</label>\n            <div>\n                <input type=\"text\" id=\"ajustePeriodicidadeOdometroHorimetro\" [(ngModel)]=\"formObject.proximaExecucaoOdometroHorimetro\" appOdometroHorimetroMask formControlName=\"proximaExecucaoOdometroHorimetro\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c geo-input--datepicker\" *ngIf=\"formObject.periodicidadeTempo\">\n            <label for=\"data\">Ajustar próximo alarme de tempo</label>\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"data\" [(ngModel)]=\"formObject.proximaExecucaoTempoData\" formControlName=\"proximaExecucaoTempo\" appDatepicker autocomplete=\"off\" />\n            </div>\n        </div>\n\n        <!--<div class=\"geo-input&#45;&#45;3c\" *ngIf=\"formObject.periodicidadeTempo\">-->\n            <!--<label for=\"ajustePeriodicidadeTempo\">Ajustar próximo alarme de tempo ({{refTempo.Value}})</label>-->\n            <!--<div>-->\n                <!--<input type=\"text\" id=\"ajustePeriodicidadeTempo\" [(ngModel)]=\"formObject.proximaExecucaoTempo\" appNumberInteger formControlName=\"proximaExecucaoTempo\">-->\n            <!--</div>-->\n        <!--</div>-->\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>";

/***/ },
/* 739 */
166,
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(741);
	var auth_guard_service_1 = __webpack_require__(89);
	var data_service_2 = __webpack_require__(742);
	var seguros_component_1 = __webpack_require__(743);
	var seguros_routing_module_1 = __webpack_require__(745);
	var data_service_3 = __webpack_require__(773);
	var obrigacoes_component_1 = __webpack_require__(774);
	var obrigacoes_routing_module_1 = __webpack_require__(776);
	var DespachosRoutingModule = (function () {
	    function DespachosRoutingModule() {
	    }
	    DespachosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DespachosRoutingModule);
	    return DespachosRoutingModule;
	}());
	exports.DespachosRoutingModule = DespachosRoutingModule;
	exports.despachosRoutes = [
	    {
	        path: '',
	        redirectTo: '/' + data_service_1.seguradorasRoute,
	        pathMatch: 'full'
	    }, {
	        path: data_service_2.segurosRoute,
	        component: seguros_component_1.SegurosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: seguros_routing_module_1.segurosRoutes
	    }, {
	        path: data_service_3.obrigacoesRoute,
	        component: obrigacoes_component_1.ObrigacoesComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: obrigacoes_routing_module_1.obrigacoesRoutes,
	    }
	];


/***/ },
/* 741 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'Seguradoras';
	exports.seguradorasRoute = 'seguradoras';
	exports.seguradorasStorage = 'seguradoras';
	exports.seguradorasModuleName = { plural: 'Seguradoras', single: 'Seguradora' };
	exports.seguradorasQuery = {
	    "where": {
	        "ativo": true,
	        "nome": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "nome",
	    "include": ["pessoaJuridica"]
	};


/***/ },
/* 742 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'Seguros';
	exports.segurosRoute = 'seguros';
	exports.segurosStorage = 'seguros';
	exports.segurosModuleName = { plural: 'Seguros', single: 'Seguro' };


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SegurosComponent = (function () {
	    function SegurosComponent() {
	    }
	    SegurosComponent.prototype.ngOnInit = function () {
	    };
	    SegurosComponent = __decorate([
	        core_1.Component({
	            selector: 'app-seguros',
	            template: __webpack_require__(744)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SegurosComponent);
	    return SegurosComponent;
	}());
	exports.SegurosComponent = SegurosComponent;


/***/ },
/* 744 */
171,
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var seguro_form_component_1 = __webpack_require__(746);
	var seguro_list_component_1 = __webpack_require__(757);
	var data_service_2 = __webpack_require__(741);
	var seguradoras_routing_module_1 = __webpack_require__(762);
	var auth_guard_service_1 = __webpack_require__(89);
	var seguradoras_component_1 = __webpack_require__(771);
	var SegurosRoutingModule = (function () {
	    function SegurosRoutingModule() {
	    }
	    SegurosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SegurosRoutingModule);
	    return SegurosRoutingModule;
	}());
	exports.SegurosRoutingModule = SegurosRoutingModule;
	exports.segurosRoutes = [
	    {
	        path: '',
	        component: seguro_list_component_1.SeguroListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: seguro_form_component_1.SeguroFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: seguro_form_component_1.SeguroFormComponent
	    }, {
	        path: data_service_2.seguradorasRoute,
	        component: seguradoras_component_1.SeguradorasComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: seguradoras_routing_module_1.seguradorasRoutes
	    }
	];


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(742);
	var seguro_model_1 = __webpack_require__(747);
	var frota_model_1 = __webpack_require__(373);
	var seguro_navigation_service_1 = __webpack_require__(748);
	var seguro_api_service_1 = __webpack_require__(749);
	var seguro_service_1 = __webpack_require__(750);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var autocomplete_service_1 = __webpack_require__(101);
	var seguradora_model_1 = __webpack_require__(751);
	var seguradora_api_service_1 = __webpack_require__(752);
	var seguradora_service_1 = __webpack_require__(753);
	var seguradora_navigation_service_1 = __webpack_require__(754);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var data_service_3 = __webpack_require__(741);
	var data_service_4 = __webpack_require__(154);
	var SeguroFormComponent = (function () {
	    function SeguroFormComponent(_route, _seguroNavigationService, _seguroApiService, _seguroService, _frotaApiService, _frotaService, _seguradoraNavigationService, _seguradoraService, _seguradoraApiService, _utilService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._seguroNavigationService = _seguroNavigationService;
	        this._seguroApiService = _seguroApiService;
	        this._seguroService = _seguroService;
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._seguradoraNavigationService = _seguradoraNavigationService;
	        this._seguradoraService = _seguradoraService;
	        this._seguradoraApiService = _seguradoraApiService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.module = data_service_1.segurosModuleName;
	        this.formObject = new seguro_model_1.Seguro();
	        this.seguradoraObject = new seguradora_model_1.Seguradora();
	        this.frotaObject = new frota_model_1.Frota();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.frotaSelectId = 'frota';
	        this.frotaQuery = data_service_4.frotasQuery;
	        this.seguradoraSelectId = 'seguradora';
	        this.seguradoraQuery = data_service_3.seguradorasQuery;
	        this.ativo = new forms_1.FormControl('');
	        this.bonus = new forms_1.FormControl('');
	        this.inicioVigor = new forms_1.FormControl('', forms_1.Validators.required);
	        this.numeroApolice = new forms_1.FormControl('', forms_1.Validators.required);
	        this.vencimento = new forms_1.FormControl('', forms_1.Validators.required);
	        this.seguradora = new forms_1.FormControl('', forms_1.Validators.required);
	        this.frota = new forms_1.FormControl('', forms_1.Validators.required);
	        this.valorSeguro = new forms_1.FormControl('', forms_1.Validators.required);
	        this.valorSegurado = new forms_1.FormControl('', forms_1.Validators.required);
	        this.descricao = new forms_1.FormControl('');
	        this.observacao = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseSeguro = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            bonus: this.bonus,
	            inicioVigor: this.inicioVigor,
	            numeroApolice: this.numeroApolice,
	            vencimento: this.vencimento,
	            seguradora: this.seguradora,
	            frota: this.frota,
	            valorSeguro: this.valorSeguro,
	            valorSegurado: this.valorSegurado,
	            descricao: this.descricao,
	            observacao: this.observacao
	        });
	    }
	    SeguroFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    SeguroFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    SeguroFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    SeguroFormComponent.prototype.keyupCurrency = function (start) {
	        var valor = this._utilService.currencyFormat(this.formObject.valorSeguro, start);
	        if (valor) {
	            this.formObject.valorSeguro = valor;
	        }
	    };
	    SeguroFormComponent.prototype.keyupCurrency2 = function (start) {
	        var valor = this._utilService.currencyFormat(this.formObject.valorSegurado, start);
	        if (valor) {
	            this.formObject.valorSegurado = valor;
	        }
	    };
	    SeguroFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.seguradoraObject.id) {
	                object.seguradoraId = this.seguradoraObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.frotaObject.id) {
	                object.bemId = this.frotaObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            var date = document.getElementById('inicioVigor');
	            if (date.value) {
	                object.inicioVigor = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.inicioVigor = null;
	            }
	            date = document.getElementById('vencimento');
	            if (date.value) {
	                object.vencimento = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.vencimento = null;
	            }
	            if (object.valorSeguro) {
	                object.valorSeguro = this._utilService.getCurrency(object.valorSeguro);
	            }
	            if (object.valorSegurado) {
	                object.valorSegurado = this._utilService.getCurrency(object.valorSegurado);
	            }
	            if (object.id) {
	                this.onEditSeguro(object);
	            }
	            else {
	                this.onAddSeguro(object);
	            }
	        }
	    };
	    SeguroFormComponent.prototype.getFrotasObject = function (object) {
	        this.frotaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'frota', object);
	    };
	    SeguroFormComponent.prototype.getSeguradoraObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._seguroService.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                nome: object.text,
	                form: data_service_1.segurosStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_3.seguradorasStorage);
	            this._seguradoraNavigationService.goToNew();
	        }
	        else {
	            this.seguradoraObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'seguradora', object);
	        }
	    };
	    SeguroFormComponent.prototype.onAddSeguro = function (object) {
	        this._seguroApiService.onPost(object, this.onDone);
	    };
	    SeguroFormComponent.prototype.onEditSeguro = function (object) {
	        this._seguroApiService.onPut(object, this.onDone);
	    };
	    SeguroFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma seguro encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._seguroApiService.onGetById(id, onDone);
	    };
	    SeguroFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.bem = this.frotaObject;
	        object.seguradora = this.seguradoraObject;
	        return object;
	    };
	    SeguroFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._seguroService.getSessionStorage();
	        this._seguroService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    SeguroFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    SeguroFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    SeguroFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    SeguroFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    SeguroFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    SeguroFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.segurosStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.nome = newAutoComplete.nome;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    SeguroFormComponent.prototype.setModelToForm = function () {
	        this.keyupCurrency(true);
	        this.keyupCurrency2(true);
	        if (this.formObject.bem) {
	            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
	            delete this.formObject['bem'];
	            var placa = '';
	            if (this.frotaObject.placa) {
	                placa = this.frotaObject.placa + ' / ';
	            }
	            var selectObject = { text: placa.concat(this.frotaObject.identificacao), id: this.frotaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'frota', this.frotaObject);
	        }
	        if (this.formObject.seguradora) {
	            this.seguradoraObject = this._utilService.cloneObject(this.formObject.seguradora);
	            delete this.formObject['seguradora'];
	            var selectObject = { text: placa.concat(this.seguradoraObject.nome), id: this.seguradoraObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.seguradoraSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.seguradoraSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'seguradora', this.seguradoraObject);
	        }
	        if (this.formObject.inicioVigor) {
	            if (this.formObject.inicioVigor.indexOf("/") === -1) {
	                this.formObject.inicioVigor = this._utilService.convertDateToString(this.formObject.inicioVigor);
	            }
	        }
	        if (this.formObject.vencimento) {
	            if (this.formObject.vencimento.indexOf("/") === -1) {
	                this.formObject.vencimento = this._utilService.convertDateToString(this.formObject.vencimento);
	            }
	        }
	    };
	    SeguroFormComponent.prototype.goToList = function () {
	        this._seguroNavigationService.goToList();
	    };
	    SeguroFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._seguroService.returnToOtherForm(this.otherForm, this.responseSeguro);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    SeguroFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-seguro-form',
	            template: __webpack_require__(755),
	            styles: [__webpack_require__(756)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof seguro_navigation_service_1.SeguroNavigationService !== 'undefined' && seguro_navigation_service_1.SeguroNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof seguro_api_service_1.SeguroApiService !== 'undefined' && seguro_api_service_1.SeguroApiService) === 'function' && _c) || Object, (typeof (_d = typeof seguro_service_1.SeguroService !== 'undefined' && seguro_service_1.SeguroService) === 'function' && _d) || Object, (typeof (_e = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _e) || Object, (typeof (_f = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _f) || Object, (typeof (_g = typeof seguradora_navigation_service_1.SeguradoraNavigationService !== 'undefined' && seguradora_navigation_service_1.SeguradoraNavigationService) === 'function' && _g) || Object, (typeof (_h = typeof seguradora_service_1.SeguradoraService !== 'undefined' && seguradora_service_1.SeguradoraService) === 'function' && _h) || Object, (typeof (_j = typeof seguradora_api_service_1.SeguradoraApiService !== 'undefined' && seguradora_api_service_1.SeguradoraApiService) === 'function' && _j) || Object, (typeof (_k = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _k) || Object, (typeof (_l = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _l) || Object, (typeof (_m = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _m) || Object])
	    ], SeguroFormComponent);
	    return SeguroFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
	}());
	exports.SeguroFormComponent = SeguroFormComponent;


/***/ },
/* 747 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 29/11/2016.
	 */
	var Seguro = (function () {
	    function Seguro() {
	    }
	    return Seguro;
	}());
	exports.Seguro = Seguro;


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(537);
	var data_service_3 = __webpack_require__(742);
	var SeguroNavigationService = (function () {
	    function SeguroNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    SeguroNavigationService.prototype.goToList = function () {
	        var router = data_service_2.despachosRoute + '/' + data_service_3.segurosRoute;
	        this._authService.navigateTo(router);
	    };
	    SeguroNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.despachosRoute + '/' + data_service_3.segurosRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    SeguroNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.despachosRoute + '/' + data_service_3.segurosRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    SeguroNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], SeguroNavigationService);
	    return SeguroNavigationService;
	    var _a;
	}());
	exports.SeguroNavigationService = SeguroNavigationService;


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(742);
	var SeguroApiService = (function () {
	    function SeguroApiService(_restService) {
	        this._restService = _restService;
	    }
	    SeguroApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    SeguroApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    SeguroApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    SeguroApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "vencimento", "include": ["seguradora", "bem"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    SeguroApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["seguradora", "bem"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    SeguroApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    SeguroApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], SeguroApiService);
	    return SeguroApiService;
	    var _a;
	}());
	exports.SeguroApiService = SeguroApiService;


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(742);
	var autocomplete_service_1 = __webpack_require__(101);
	var SeguroService = (function () {
	    function SeguroService(_autocompleteService) {
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    SeguroService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.segurosStorage + '-new', object);
	    };
	    SeguroService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.segurosStorage + "-new");
	        return JSON.parse(item);
	    };
	    SeguroService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.segurosStorage + "-new");
	    };
	    SeguroService.prototype.returnToOtherForm = function (otherForm, Response) {
	        // if(Response) {
	        //   var otherFormObject: any;
	        //
	        //   if (otherForm === setoresStorage) {
	        //     otherFormObject = this._setorService.getSessionStorage();
	        //     otherFormObject.seguro = Response;
	        //     this._setorService.setSessionStorage(otherFormObject);
	        //   }
	        // }
	        //
	        // this._autocompleteService.clearSessionStorage(segurosStorage);
	        //
	        // if (otherForm === setoresStorage) {
	        //   otherFormObject = this._setorService.getSessionStorage();
	        //   if (otherFormObject.id) {
	        //     this._setorNavigationService.goToEdit(otherFormObject.id);
	        //   } else {
	        //     this._setorNavigationService.goToNew();
	        //   }
	        // }
	    };
	    SeguroService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object])
	    ], SeguroService);
	    return SeguroService;
	    var _a;
	}());
	exports.SeguroService = SeguroService;


/***/ },
/* 751 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 29/11/2016.
	 */
	var Seguradora = (function () {
	    function Seguradora() {
	    }
	    return Seguradora;
	}());
	exports.Seguradora = Seguradora;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(741);
	var SeguradoraApiService = (function () {
	    function SeguradoraApiService(_restService) {
	        this._restService = _restService;
	    }
	    SeguradoraApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    SeguradoraApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    SeguradoraApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    SeguradoraApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "nome", "include": ["pessoaJuridica"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    SeguradoraApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["pessoaJuridica"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    SeguradoraApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    SeguradoraApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], SeguradoraApiService);
	    return SeguradoraApiService;
	    var _a;
	}());
	exports.SeguradoraApiService = SeguradoraApiService;


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(741);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_2 = __webpack_require__(742);
	var seguro_navigation_service_1 = __webpack_require__(748);
	var seguro_service_1 = __webpack_require__(750);
	var SeguradoraService = (function () {
	    function SeguradoraService(_seguroNavigationService, _seguroService, _autocompleteService) {
	        this._seguroNavigationService = _seguroNavigationService;
	        this._seguroService = _seguroService;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    SeguradoraService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.seguradorasStorage + '-new', object);
	    };
	    SeguradoraService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.seguradorasStorage + "-new");
	        return JSON.parse(item);
	    };
	    SeguradoraService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.seguradorasStorage + "-new");
	    };
	    SeguradoraService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.segurosStorage) {
	                otherFormObject = this._seguroService.getSessionStorage();
	                otherFormObject.seguradora = Response;
	                this._seguroService.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.seguradorasStorage);
	        if (otherForm === data_service_2.segurosStorage) {
	            otherFormObject = this._seguroService.getSessionStorage();
	            if (otherFormObject.id) {
	                this._seguroNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._seguroNavigationService.goToNew();
	            }
	        }
	    };
	    SeguradoraService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof seguro_navigation_service_1.SeguroNavigationService !== 'undefined' && seguro_navigation_service_1.SeguroNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof seguro_service_1.SeguroService !== 'undefined' && seguro_service_1.SeguroService) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object])
	    ], SeguradoraService);
	    return SeguradoraService;
	    var _a, _b, _c;
	}());
	exports.SeguradoraService = SeguradoraService;


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(537);
	var data_service_3 = __webpack_require__(741);
	var data_service_4 = __webpack_require__(742);
	var SeguradoraNavigationService = (function () {
	    function SeguradoraNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    SeguradoraNavigationService.prototype.goToList = function () {
	        var router = data_service_2.despachosRoute + '/' + data_service_4.segurosRoute + '/' + data_service_3.seguradorasRoute;
	        this._authService.navigateTo(router);
	    };
	    SeguradoraNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.despachosRoute + '/' + data_service_4.segurosRoute + '/' + data_service_3.seguradorasRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    SeguradoraNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.despachosRoute + '/' + data_service_4.segurosRoute + '/' + data_service_3.seguradorasRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    SeguradoraNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], SeguradoraNavigationService);
	    return SeguradoraNavigationService;
	    var _a;
	}());
	exports.SeguradoraNavigationService = SeguradoraNavigationService;


/***/ },
/* 755 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{module.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{module.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{module.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <autocomplete-component class=\"geo-input--3c\" id=\"frota\"\n                                (setObejct)=\"getFrotasObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"frotaObject\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [query]=\"frotaQuery\"\n                                [label]=\"'Frota / equipamento'\"></autocomplete-component>\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"seguradora\"\n                                (setObejct)=\"getSeguradoraObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"seguradoraSelectId\"\n                                [model]=\"seguradoraObject\"\n                                [_service]=\"_seguradoraApiService\"\n                                [fieldToShow]=\"'nome'\"\n                                [query]=\"seguradoraQuery\"\n                                [label]=\"'Seguradora'\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <h2>Dados do seguro</h2>\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !numeroApolice.valid && submitted}\">\n            <label for=\"numeroApolice\">Número da apólice <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!numeroApolice.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"numeroApolice\" [(ngModel)]=\"formObject.numeroApolice\" formControlName=\"numeroApolice\" autofocus appNumberInteger>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !valorSegurado.valid && submitted}\">\n            <label for=\"valorSegurado\">Valor segurado (R$) <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!valorSegurado.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"valorSegurado\" [(ngModel)]=\"formObject.valorSegurado\" (keyup)=\"keyupCurrency2()\" formControlName=\"valorSegurado\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': !inicioVigor.value && submitted}\">\n            <label for=\"inicioVigor\">Data de início <abbr>*</abbr></label>\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"inicioVigor\" [(ngModel)]=\"formObject.inicioVigor\" formControlName=\"inicioVigor\" appDatepicker autocomplete=\"off\" />\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': !vencimento.value && submitted}\">\n            <label for=\"vencimento\">Vencimento <abbr>*</abbr></label>\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"vencimento\" [(ngModel)]=\"formObject.vencimento\" formControlName=\"vencimento\" appDatepicker autocomplete=\"off\" />\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !valorSeguro.valid && submitted}\">\n            <label for=\"valorSeguro\">Valor do seguro (R$) <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!valorSeguro.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"valorSeguro\" [(ngModel)]=\"formObject.valorSeguro\" (keyup)=\"keyupCurrency()\" formControlName=\"valorSeguro\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\">\n            <label for=\"bonus\">Bônus</label>\n            <div>\n                <input type=\"text\" id=\"bonus\" [(ngModel)]=\"formObject.bonus\" formControlName=\"bonus\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\">\n            <label for=\"descricao\">Descrição</label>\n            <div>\n                <textarea id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\"></textarea>\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\">\n            <label for=\"observacao\">Observação</label>\n            <div>\n                <textarea id=\"observacao\" [(ngModel)]=\"formObject.observacao\" formControlName=\"observacao\"></textarea>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 756 */
166,
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var seguro_api_service_1 = __webpack_require__(749);
	var seguro_service_1 = __webpack_require__(750);
	var seguro_navigation_service_1 = __webpack_require__(748);
	var data_service_1 = __webpack_require__(742);
	var util_service_1 = __webpack_require__(88);
	var pessoa_juridica_api_service_1 = __webpack_require__(758);
	var SeguroListComponent = (function () {
	    function SeguroListComponent(_segurosApiService, _seguroService, _seguroNavigationService, _pessoaJuridicaApiService, _utilService) {
	        this._segurosApiService = _segurosApiService;
	        this._seguroService = _seguroService;
	        this._seguroNavigationService = _seguroNavigationService;
	        this._pessoaJuridicaApiService = _pessoaJuridicaApiService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.segurosModuleName = data_service_1.segurosModuleName;
	    }
	    SeguroListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    SeguroListComponent.prototype.clickNew = function () {
	        this._seguroService.clearSessionStorage();
	        this._seguroNavigationService.goToNew();
	    };
	    SeguroListComponent.prototype.clickEdit = function (item) {
	        this._seguroService.clearSessionStorage();
	        this._seguroNavigationService.goToEdit(item.id);
	    };
	    SeguroListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    SeguroListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._segurosApiService.onGetAll(onDone);
	    };
	    SeguroListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	                this.deletePessoaJuridica(item.pessoaJuridicaId);
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._segurosApiService.onDelete(item.id, onDone);
	    };
	    SeguroListComponent.prototype.deletePessoaJuridica = function (pessoJuridicaId) {
	        var onDone = (function (Response) {
	        });
	        this._pessoaJuridicaApiService.onDelete(pessoJuridicaId, onDone);
	    };
	    SeguroListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-seguro-list',
	            template: __webpack_require__(760),
	            styles: [__webpack_require__(761)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof seguro_api_service_1.SeguroApiService !== 'undefined' && seguro_api_service_1.SeguroApiService) === 'function' && _a) || Object, (typeof (_b = typeof seguro_service_1.SeguroService !== 'undefined' && seguro_service_1.SeguroService) === 'function' && _b) || Object, (typeof (_c = typeof seguro_navigation_service_1.SeguroNavigationService !== 'undefined' && seguro_navigation_service_1.SeguroNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof pessoa_juridica_api_service_1.PessoaJuridicaApiService !== 'undefined' && pessoa_juridica_api_service_1.PessoaJuridicaApiService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], SeguroListComponent);
	    return SeguroListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.SeguroListComponent = SeguroListComponent;


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(759);
	var PessoaJuridicaApiService = (function () {
	    function PessoaJuridicaApiService(_restService) {
	        this._restService = _restService;
	    }
	    PessoaJuridicaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    PessoaJuridicaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    PessoaJuridicaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    PessoaJuridicaApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "razaoSocial" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    PessoaJuridicaApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    PessoaJuridicaApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    PessoaJuridicaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], PessoaJuridicaApiService);
	    return PessoaJuridicaApiService;
	    var _a;
	}());
	exports.PessoaJuridicaApiService = PessoaJuridicaApiService;


/***/ },
/* 759 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'pessoas-juridicas';


/***/ },
/* 760 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{segurosModuleName.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">{{segurosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{segurosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{segurosModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Vencimento</th>\n            <th>Identificação</th>\n            <th>Valor segurado</th>\n            <th>Nº da apólice</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['vencimento', 'bem.identificacao', 'valorSegurado', 'numeroApolice'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.vencimento | date: 'dd/MM/yyyy'}}</td>\n            <td>\n        <span *ngIf=\"item.bem\">\n          {{item.bem.codigo}} <span *ngIf=\"item.bem.placa\"> / {{item.bem.placa | licensePlateMask}}</span> - {{item.bem.identificacao}}\n        </span>\n            </td>\n            <td><span >{{item.valorSegurado | currencyMask}}</span></td>\n            <td><span >{{item.numeroApolice}}</span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <p><strong>Data de início: </strong> {{item.inicioVigor | date: 'dd/MM/yyyy'}} <i *ngIf=\"!item.inicioVigor\">não cadastrado</i></p>\n                <p><strong>Bônus: </strong> {{item.bonus}}  <i *ngIf=\"!item.bonus\">não cadastrado</i></p>\n                <p><strong>Valor do seguro: </strong> {{item.valorSeguro | currencyMask}}  <i *ngIf=\"!item.valorSeguro\">não cadastrado</i></p>\n                <p><strong>Descrição: </strong>{{item.descricao}} <i *ngIf=\"!item.descricao\">não cadastrado</i></p>\n                <p><strong>Observaçaõ: </strong>{{item.observacao}} <i *ngIf=\"!item.observacao\">não cadastrado</i></p>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 761 */
166,
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var seguradora_form_component_1 = __webpack_require__(763);
	var seguradora_list_component_1 = __webpack_require__(768);
	var SeguradorasRoutingModule = (function () {
	    function SeguradorasRoutingModule() {
	    }
	    SeguradorasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SeguradorasRoutingModule);
	    return SeguradorasRoutingModule;
	}());
	exports.SeguradorasRoutingModule = SeguradorasRoutingModule;
	exports.seguradorasRoutes = [
	    {
	        path: '',
	        component: seguradora_list_component_1.SeguradoraListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: seguradora_form_component_1.SeguradoraFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: seguradora_form_component_1.SeguradoraFormComponent
	    }
	];


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(741);
	var seguradora_model_1 = __webpack_require__(751);
	var pessoa_juridica_model_1 = __webpack_require__(764);
	var seguradora_navigation_service_1 = __webpack_require__(754);
	var seguradora_api_service_1 = __webpack_require__(752);
	var seguradora_service_1 = __webpack_require__(753);
	var pessoa_juridica_api_service_1 = __webpack_require__(758);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var autocomplete_service_1 = __webpack_require__(101);
	var pessoa_juridica_service_1 = __webpack_require__(765);
	var data_service_3 = __webpack_require__(742);
	var SeguradoraFormComponent = (function () {
	    function SeguradoraFormComponent(_route, _seguradoraNavigationService, _seguradoraApiService, _seguradoraService, _pessoaJuridicaApiService, _pessoaJuridicaService, _utilService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._seguradoraNavigationService = _seguradoraNavigationService;
	        this._seguradoraApiService = _seguradoraApiService;
	        this._seguradoraService = _seguradoraService;
	        this._pessoaJuridicaApiService = _pessoaJuridicaApiService;
	        this._pessoaJuridicaService = _pessoaJuridicaService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.module = data_service_3.segurosModuleName;
	        this.moduleSeguradora = data_service_1.seguradorasModuleName;
	        this.formObject = new seguradora_model_1.Seguradora();
	        this.pessoaJuridicaObject = new pessoa_juridica_model_1.PessoaJuridica();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.ativo = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDonePessoaJuridica = (function (Response) {
	            if (!Response.error) {
	                var pessoaJuridicaId = Response.id;
	                this.formObjectToSave.pessoaJuridicaId = pessoaJuridicaId;
	                this.formObjectToSave.nome = Response.razaoSocial;
	                if (this.formObject.id) {
	                    this.onEditSeguradora();
	                }
	                else {
	                    this.onAddSeguradora();
	                }
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseSeguradora = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo
	        });
	    }
	    SeguradoraFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    SeguradoraFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    SeguradoraFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    SeguradoraFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            this.formObjectToSave = object;
	            this.pessoaJuridicaObject.ativo = object.ativo;
	            this._pessoaJuridicaService.onSubmit(this.pessoaJuridicaObject, this.onDonePessoaJuridica);
	        }
	    };
	    SeguradoraFormComponent.prototype.onAddSeguradora = function () {
	        this._seguradoraApiService.onPost(this.formObjectToSave, this.onDone);
	    };
	    SeguradoraFormComponent.prototype.onEditSeguradora = function () {
	        this._seguradoraApiService.onPut(this.formObjectToSave, this.onDone);
	    };
	    SeguradoraFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma seguradora encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._seguradoraApiService.onGetById(id, onDone);
	    };
	    SeguradoraFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._seguradoraService.getSessionStorage();
	        this._seguradoraService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    SeguradoraFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    SeguradoraFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    SeguradoraFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    SeguradoraFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    SeguradoraFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    SeguradoraFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_1.seguradorasStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            //qndo vier de outro formulario, setar o objeto de pessoa juridica
	            this.pessoaJuridicaObject.razaoSocial = newAutoComplete.nome;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    SeguradoraFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.pessoaJuridica) {
	            this.pessoaJuridicaObject = this._utilService.cloneObject(this.formObject.pessoaJuridica);
	            delete this.formObject['pessoaJuridica'];
	        }
	    };
	    SeguradoraFormComponent.prototype.goToList = function () {
	        this._seguradoraNavigationService.goToList();
	    };
	    SeguradoraFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._seguradoraService.returnToOtherForm(this.otherForm, this.responseSeguradora);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    SeguradoraFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-seguradora-form',
	            template: __webpack_require__(766),
	            styles: [__webpack_require__(767)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof seguradora_navigation_service_1.SeguradoraNavigationService !== 'undefined' && seguradora_navigation_service_1.SeguradoraNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof seguradora_api_service_1.SeguradoraApiService !== 'undefined' && seguradora_api_service_1.SeguradoraApiService) === 'function' && _c) || Object, (typeof (_d = typeof seguradora_service_1.SeguradoraService !== 'undefined' && seguradora_service_1.SeguradoraService) === 'function' && _d) || Object, (typeof (_e = typeof pessoa_juridica_api_service_1.PessoaJuridicaApiService !== 'undefined' && pessoa_juridica_api_service_1.PessoaJuridicaApiService) === 'function' && _e) || Object, (typeof (_f = typeof pessoa_juridica_service_1.PessoaJuridicaService !== 'undefined' && pessoa_juridica_service_1.PessoaJuridicaService) === 'function' && _f) || Object, (typeof (_g = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _g) || Object, (typeof (_h = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], SeguradoraFormComponent);
	    return SeguradoraFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.SeguradoraFormComponent = SeguradoraFormComponent;


/***/ },
/* 764 */
/***/ function(module, exports) {

	"use strict";
	var PessoaJuridica = (function () {
	    function PessoaJuridica() {
	    }
	    return PessoaJuridica;
	}());
	exports.PessoaJuridica = PessoaJuridica;


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var util_service_1 = __webpack_require__(88);
	var pessoa_juridica_api_service_1 = __webpack_require__(758);
	var PessoaJuridicaService = (function () {
	    function PessoaJuridicaService(_pessoaJuridicaApiService, _utilService) {
	        this._pessoaJuridicaApiService = _pessoaJuridicaApiService;
	        this._utilService = _utilService;
	    }
	    PessoaJuridicaService.prototype.onSubmit = function (object, onDone) {
	        if (object.cnpj) {
	            object.cnpj = this._utilService.removeSpecialCharacter(object.cnpj);
	        }
	        if (object.telefone) {
	            object.telefone = this._utilService.removeSpecialCharacter(object.telefone);
	        }
	        if (object.id) {
	            this._pessoaJuridicaApiService.onPut(object, onDone);
	        }
	        else {
	            this._pessoaJuridicaApiService.onPost(object, onDone);
	        }
	    };
	    PessoaJuridicaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof pessoa_juridica_api_service_1.PessoaJuridicaApiService !== 'undefined' && pessoa_juridica_api_service_1.PessoaJuridicaApiService) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object])
	    ], PessoaJuridicaService);
	    return PessoaJuridicaService;
	    var _a, _b;
	}());
	exports.PessoaJuridicaService = PessoaJuridicaService;


/***/ },
/* 766 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{moduleSeguradora.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{module.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{module.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <app-pessoa-juridica-form [formObject]=\"pessoaJuridicaObject\"\n                              [submitted]=\"submitted\"></app-pessoa-juridica-form>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 767 */
166,
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var seguradora_api_service_1 = __webpack_require__(752);
	var seguradora_service_1 = __webpack_require__(753);
	var seguradora_navigation_service_1 = __webpack_require__(754);
	var data_service_1 = __webpack_require__(741);
	var util_service_1 = __webpack_require__(88);
	var pessoa_juridica_api_service_1 = __webpack_require__(758);
	var data_service_2 = __webpack_require__(742);
	var SeguradoraListComponent = (function () {
	    function SeguradoraListComponent(_seguradorasApiService, _seguradoraService, _seguradoraNavigationService, _pessoaJuridicaApiService, _utilService) {
	        this._seguradorasApiService = _seguradorasApiService;
	        this._seguradoraService = _seguradoraService;
	        this._seguradoraNavigationService = _seguradoraNavigationService;
	        this._pessoaJuridicaApiService = _pessoaJuridicaApiService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.seguradorasModuleName = data_service_1.seguradorasModuleName;
	        this.module = data_service_2.segurosModuleName;
	    }
	    SeguradoraListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    SeguradoraListComponent.prototype.clickNew = function () {
	        this._seguradoraService.clearSessionStorage();
	        this._seguradoraNavigationService.goToNew();
	    };
	    SeguradoraListComponent.prototype.clickEdit = function (item) {
	        this._seguradoraService.clearSessionStorage();
	        this._seguradoraNavigationService.goToEdit(item.id);
	    };
	    SeguradoraListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    SeguradoraListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._seguradorasApiService.onGetAll(onDone);
	    };
	    SeguradoraListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	                this.deletePessoaJuridica(item.pessoaJuridicaId);
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._seguradorasApiService.onDelete(item.id, onDone);
	    };
	    SeguradoraListComponent.prototype.deletePessoaJuridica = function (pessoJuridicaId) {
	        var onDone = (function (Response) {
	        });
	        this._pessoaJuridicaApiService.onDelete(pessoJuridicaId, onDone);
	    };
	    SeguradoraListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-seguradora-list',
	            template: __webpack_require__(769),
	            styles: [__webpack_require__(770)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof seguradora_api_service_1.SeguradoraApiService !== 'undefined' && seguradora_api_service_1.SeguradoraApiService) === 'function' && _a) || Object, (typeof (_b = typeof seguradora_service_1.SeguradoraService !== 'undefined' && seguradora_service_1.SeguradoraService) === 'function' && _b) || Object, (typeof (_c = typeof seguradora_navigation_service_1.SeguradoraNavigationService !== 'undefined' && seguradora_navigation_service_1.SeguradoraNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof pessoa_juridica_api_service_1.PessoaJuridicaApiService !== 'undefined' && pessoa_juridica_api_service_1.PessoaJuridicaApiService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], SeguradoraListComponent);
	    return SeguradoraListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.SeguradoraListComponent = SeguradoraListComponent;


/***/ },
/* 769 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">{{seguradorasModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{seguradorasModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{seguradorasModuleName.single | lowercase}} cadastrada</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Razão social</th>\n            <th>CNPJ</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['nome', 'pessoaJuridica.cnpj'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.nome}}</td>\n            <td ><span *ngIf=\"item.pessoaJuridica\">{{item.pessoaJuridica.cnpj | cnpjMask}}</span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <p><strong>Nome fantasia: </strong> <span *ngIf=\"item.pessoaJuridica\">{{item.pessoaJuridica.nomeFantasia}}</span> <i *ngIf=\"!item.pessoaJuridica || !item.pessoaJuridica.nomeFantasia\">não cadastrado</i></p>\n                <p><strong>Telefone: </strong> <span *ngIf=\"item.pessoaJuridica\">{{item.pessoaJuridica.telefone | phoneMask}}</span>  <i *ngIf=\"!item.pessoaJuridica || !item.pessoaJuridica.telefone\">não cadastrado</i></p>\n                <p><strong>Email: </strong> <span *ngIf=\"item.pessoaJuridica\">{{item.pessoaJuridica.email}}</span> <i *ngIf=\"!item.pessoaJuridica || !item.pessoaJuridica.email\">não cadastrado</i></p>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 770 */
166,
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SeguradorasComponent = (function () {
	    function SeguradorasComponent() {
	    }
	    SeguradorasComponent.prototype.ngOnInit = function () {
	    };
	    SeguradorasComponent = __decorate([
	        core_1.Component({
	            selector: 'app-seguradoras',
	            template: __webpack_require__(772)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SeguradorasComponent);
	    return SeguradorasComponent;
	}());
	exports.SeguradorasComponent = SeguradorasComponent;


/***/ },
/* 772 */
171,
/* 773 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'obrigacoes';
	exports.obrigacoesRoute = 'obrigacoes';
	exports.obrigacoesStorage = 'obrigacoes';
	exports.obrigacoesModuleName = { plural: 'Obrigações', single: 'Obrigação' };


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ObrigacoesComponent = (function () {
	    function ObrigacoesComponent() {
	    }
	    ObrigacoesComponent.prototype.ngOnInit = function () {
	    };
	    ObrigacoesComponent = __decorate([
	        core_1.Component({
	            selector: 'app-obrigacoes',
	            template: __webpack_require__(775)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ObrigacoesComponent);
	    return ObrigacoesComponent;
	}());
	exports.ObrigacoesComponent = ObrigacoesComponent;


/***/ },
/* 775 */
171,
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var obrigacao_form_component_1 = __webpack_require__(777);
	var obrigacao_list_component_1 = __webpack_require__(788);
	var obrigacao_tipo_form_component_1 = __webpack_require__(791);
	var data_service_2 = __webpack_require__(783);
	var obrigacao_tipo_list_component_1 = __webpack_require__(796);
	var despacho_configuracao_obrigacoes_component_1 = __webpack_require__(799);
	var data_service_3 = __webpack_require__(385);
	var licenciamentos_component_1 = __webpack_require__(802);
	var licenciamentos_routing_module_1 = __webpack_require__(804);
	var auth_guard_service_1 = __webpack_require__(89);
	var ObrigacoesRoutingModule = (function () {
	    function ObrigacoesRoutingModule() {
	    }
	    ObrigacoesRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ObrigacoesRoutingModule);
	    return ObrigacoesRoutingModule;
	}());
	exports.ObrigacoesRoutingModule = ObrigacoesRoutingModule;
	exports.obrigacoesRoutes = [
	    {
	        path: '',
	        component: obrigacao_list_component_1.ObrigacaoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: obrigacao_form_component_1.ObrigacaoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: obrigacao_form_component_1.ObrigacaoFormComponent
	    }, {
	        path: data_service_1.configuracaoRoute,
	        component: despacho_configuracao_obrigacoes_component_1.DespachoConfiguracaoObrigacoesComponent
	    }, {
	        path: data_service_1.configuracaoRoute + '/' + data_service_2.obrigacaoTiposRoute,
	        component: obrigacao_tipo_list_component_1.ObrigacaoTipoListComponent
	    }, {
	        path: data_service_1.configuracaoRoute + '/' + data_service_2.obrigacaoTiposRoute + '/' + data_service_1.newRoute,
	        component: obrigacao_tipo_form_component_1.ObrigacaoTipoFormComponent
	    }, {
	        path: data_service_1.configuracaoRoute + '/' + data_service_2.obrigacaoTiposRoute + '/' + data_service_1.editRoute + '/:id',
	        component: obrigacao_tipo_form_component_1.ObrigacaoTipoFormComponent
	    }, {
	        path: data_service_1.configuracaoRoute + '/' + data_service_3.licenciamentosRoute,
	        component: licenciamentos_component_1.LicenciamentosComponent,
	        canActivateChildren: [auth_guard_service_1.AuthGuardService],
	        children: licenciamentos_routing_module_1.licenciamentosRoutes
	    }
	];


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(773);
	var obrigacao_model_1 = __webpack_require__(778);
	var frota_model_1 = __webpack_require__(373);
	var obrigacao_navigation_service_1 = __webpack_require__(779);
	var obrigacao_api_service_1 = __webpack_require__(780);
	var obrigacao_service_1 = __webpack_require__(781);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var autocomplete_service_1 = __webpack_require__(101);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var data_service_3 = __webpack_require__(154);
	var obrigacao_tipo_model_1 = __webpack_require__(782);
	var data_service_4 = __webpack_require__(783);
	var obrigacao_tipo_navigation_service_1 = __webpack_require__(784);
	var obrigacao_tipo_api_service_1 = __webpack_require__(785);
	var ObrigacaoFormComponent = (function () {
	    function ObrigacaoFormComponent(_route, _obrigacaoNavigationService, _obrigacaoApiService, _obrigacoeservice, _frotaApiService, _frotaService, _obrigacaoTipoNavigationService, _obrigacaoTipoApiService, _utilService, _autocompleteService, _fb) {
	        this._route = _route;
	        this._obrigacaoNavigationService = _obrigacaoNavigationService;
	        this._obrigacaoApiService = _obrigacaoApiService;
	        this._obrigacoeservice = _obrigacoeservice;
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._obrigacaoTipoNavigationService = _obrigacaoTipoNavigationService;
	        this._obrigacaoTipoApiService = _obrigacaoTipoApiService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this._fb = _fb;
	        this.obrigacaoModule = data_service_1.obrigacoesModuleName;
	        this.formObject = new obrigacao_model_1.Obrigacao();
	        this.obrigacaoTipoObject = new obrigacao_tipo_model_1.TipoObrigacao();
	        this.frotaObject = new frota_model_1.Frota();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.frotaSelectId = 'frota';
	        this.frotaQuery = data_service_3.frotasQuery;
	        this.obrigacaoTipoSelectId = 'obrigacaoTipo';
	        this.obrigacaoTipoQuery = data_service_4.obrigacaoTiposQuery;
	        this.ativo = new forms_1.FormControl('');
	        this.dataPagamento = new forms_1.FormControl('');
	        this.dataVencimento = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipoObrigacao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.frota = new forms_1.FormControl('', forms_1.Validators.required);
	        this.observacao = new forms_1.FormControl('');
	        this.valor = new forms_1.FormControl('', forms_1.Validators.required);
	        this.returnToOtherForm = false;
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseObrigacao = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            dataPagamento: this.dataPagamento,
	            dataVencimento: this.dataVencimento,
	            tipoObrigacao: this.tipoObrigacao,
	            frota: this.frota,
	            observacao: this.observacao,
	            valor: this.valor
	        });
	    }
	    ObrigacaoFormComponent.prototype.ngOnInit = function () {
	        this.testSession();
	    };
	    ObrigacaoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    ObrigacaoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    ObrigacaoFormComponent.prototype.keyupCurrency = function (start) {
	        var valor = this._utilService.currencyFormat(this.formObject.valor, start);
	        if (valor) {
	            this.formObject.valor = valor;
	        }
	    };
	    ObrigacaoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.obrigacaoTipoObject.id) {
	                object.tipoObrigacaoId = this.obrigacaoTipoObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.frotaObject.id) {
	                object.bemId = this.frotaObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            var date = document.getElementById('dataVencimento');
	            if (date.value) {
	                object.dataVencimento = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.dataVencimento = null;
	            }
	            date = document.getElementById('dataPagamento');
	            if (date.value) {
	                object.dataPagamento = this._utilService.convertStringToDate(date.value);
	            }
	            else {
	                object.dataPagamento = null;
	            }
	            if (object.valor) {
	                object.valor = this._utilService.getCurrency(object.valor);
	            }
	            if (object.id) {
	                this.onEditObrigacao(object);
	            }
	            else {
	                this.onAddObrigacao(object);
	            }
	        }
	    };
	    ObrigacaoFormComponent.prototype.getFrotasObject = function (object) {
	        this.frotaObject = object;
	        this._utilService.setSelectOnFormControl(this.form, 'frota', object);
	    };
	    ObrigacaoFormComponent.prototype.getObrigacaoTipoObject = function (object) {
	        if (object.novo) {
	            var thisFormObject = this.setObjectBeforeLeave();
	            this._obrigacoeservice.setSessionStorage(thisFormObject);
	            var toOtherFormObject = {
	                titulo: object.text,
	                form: data_service_1.obrigacoesStorage
	            };
	            this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_4.obrigacaoTiposStorage);
	            this._obrigacaoTipoNavigationService.goToNew();
	        }
	        else {
	            this.obrigacaoTipoObject = object;
	            this._utilService.setSelectOnFormControl(this.form, 'tipoObrigacao', object);
	        }
	    };
	    ObrigacaoFormComponent.prototype.onAddObrigacao = function (object) {
	        this._obrigacaoApiService.onPost(object, this.onDone);
	    };
	    ObrigacaoFormComponent.prototype.onEditObrigacao = function (object) {
	        this._obrigacaoApiService.onPut(object, this.onDone);
	    };
	    ObrigacaoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma obrigação encontrada com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._obrigacaoApiService.onGetById(id, onDone);
	    };
	    ObrigacaoFormComponent.prototype.setObjectBeforeLeave = function () {
	        var object = this.formObject;
	        object.bem = this.frotaObject;
	        object.tipoObrigacao = this.obrigacaoTipoObject;
	        if (this.formObject.valor) {
	            object.valor = this._utilService.getCurrency(this.formObject.valor);
	        }
	        return object;
	    };
	    ObrigacaoFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._obrigacoeservice.getSessionStorage();
	        this._obrigacoeservice.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            this.setModelToForm();
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    ObrigacaoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	        }
	    };
	    ObrigacaoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    ObrigacaoFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    ObrigacaoFormComponent.prototype.setEditSession = function () {
	        //qndo retornou para continuar a edição
	    };
	    ObrigacaoFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	    };
	    ObrigacaoFormComponent.prototype.setModelToForm = function () {
	        this.keyupCurrency(true);
	        if (this.formObject.bem) {
	            this.frotaObject = this._utilService.cloneObject(this.formObject.bem);
	            delete this.formObject['bem'];
	            var placa = '';
	            if (this.frotaObject.placa) {
	                placa = this.frotaObject.placa + ' / ';
	            }
	            var selectObject = { text: placa.concat(this.frotaObject.identificacao), id: this.frotaObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.frotaSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.frotaSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'frota', this.frotaObject);
	        }
	        if (this.formObject.tipoObrigacao) {
	            this.obrigacaoTipoObject = this._utilService.cloneObject(this.formObject.tipoObrigacao);
	            delete this.formObject['tipoObrigacao'];
	            var selectObject = { text: this.obrigacaoTipoObject.titulo, id: this.obrigacaoTipoObject.id };
	            this._autocompleteService.createOptionOnSelect2(this.obrigacaoTipoSelectId, selectObject);
	            this._autocompleteService.setValueOnSelect2(selectObject.id, this.obrigacaoTipoSelectId);
	            this._utilService.setSelectOnFormControl(this.form, 'tipoObrigacao', this.obrigacaoTipoObject);
	        }
	        if (this.formObject.dataPagamento) {
	            if (this.formObject.dataPagamento.indexOf("/") === -1) {
	                this.formObject.dataPagamento = this._utilService.convertDateToString(this.formObject.dataPagamento);
	            }
	        }
	        if (this.formObject.dataVencimento) {
	            if (this.formObject.dataVencimento.indexOf("/") === -1) {
	                this.formObject.dataVencimento = this._utilService.convertDateToString(this.formObject.dataVencimento);
	            }
	        }
	    };
	    ObrigacaoFormComponent.prototype.goToList = function () {
	        this._obrigacaoNavigationService.goToList();
	    };
	    ObrigacaoFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._obrigacoeservice.returnToOtherForm(this.otherForm, this.responseObrigacao);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    ObrigacaoFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-obrigacao-form',
	            template: __webpack_require__(786),
	            styles: [__webpack_require__(787)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof obrigacao_navigation_service_1.ObrigacaoNavigationService !== 'undefined' && obrigacao_navigation_service_1.ObrigacaoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof obrigacao_api_service_1.ObrigacaoApiService !== 'undefined' && obrigacao_api_service_1.ObrigacaoApiService) === 'function' && _c) || Object, (typeof (_d = typeof obrigacao_service_1.Obrigacoeservice !== 'undefined' && obrigacao_service_1.Obrigacoeservice) === 'function' && _d) || Object, (typeof (_e = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _e) || Object, (typeof (_f = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _f) || Object, (typeof (_g = typeof obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService !== 'undefined' && obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService) === 'function' && _g) || Object, (typeof (_h = typeof obrigacao_tipo_api_service_1.ObrigacaoTipoApiService !== 'undefined' && obrigacao_tipo_api_service_1.ObrigacaoTipoApiService) === 'function' && _h) || Object, (typeof (_j = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _j) || Object, (typeof (_k = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _k) || Object, (typeof (_l = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _l) || Object])
	    ], ObrigacaoFormComponent);
	    return ObrigacaoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.ObrigacaoFormComponent = ObrigacaoFormComponent;


/***/ },
/* 778 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * Created by Daniela on 29/11/2016.
	 */
	var Obrigacao = (function () {
	    function Obrigacao() {
	    }
	    return Obrigacao;
	}());
	exports.Obrigacao = Obrigacao;


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(537);
	var data_service_3 = __webpack_require__(773);
	var ObrigacaoNavigationService = (function () {
	    function ObrigacaoNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    ObrigacaoNavigationService.prototype.goToList = function () {
	        var router = data_service_2.despachosRoute + '/' + data_service_3.obrigacoesRoute;
	        this._authService.navigateTo(router);
	    };
	    ObrigacaoNavigationService.prototype.goToNew = function () {
	        var router = data_service_2.despachosRoute + '/' + data_service_3.obrigacoesRoute + '/' + data_service_1.newRoute;
	        this._authService.navigateTo(router);
	    };
	    ObrigacaoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_2.despachosRoute + '/' + data_service_3.obrigacoesRoute + '/' + data_service_1.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    ObrigacaoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ObrigacaoNavigationService);
	    return ObrigacaoNavigationService;
	    var _a;
	}());
	exports.ObrigacaoNavigationService = ObrigacaoNavigationService;


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(773);
	var ObrigacaoApiService = (function () {
	    function ObrigacaoApiService(_restService) {
	        this._restService = _restService;
	    }
	    ObrigacaoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    ObrigacaoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    ObrigacaoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    ObrigacaoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "dataVencimento", "include": ["tipoObrigacao", "bem"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ObrigacaoApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["tipoObrigacao", "bem"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    ObrigacaoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    ObrigacaoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ObrigacaoApiService);
	    return ObrigacaoApiService;
	    var _a;
	}());
	exports.ObrigacaoApiService = ObrigacaoApiService;


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(773);
	var Obrigacoeservice = (function () {
	    function Obrigacoeservice() {
	    }
	    //session
	    Obrigacoeservice.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.obrigacoesStorage + '-new', object);
	    };
	    Obrigacoeservice.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.obrigacoesStorage + "-new");
	        return JSON.parse(item);
	    };
	    Obrigacoeservice.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.obrigacoesStorage + "-new");
	    };
	    Obrigacoeservice.prototype.returnToOtherForm = function (otherForm, Response) {
	    };
	    Obrigacoeservice = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], Obrigacoeservice);
	    return Obrigacoeservice;
	}());
	exports.Obrigacoeservice = Obrigacoeservice;


/***/ },
/* 782 */
/***/ function(module, exports) {

	"use strict";
	var TipoObrigacao = (function () {
	    function TipoObrigacao() {
	    }
	    return TipoObrigacao;
	}());
	exports.TipoObrigacao = TipoObrigacao;


/***/ },
/* 783 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-obrigacoes';
	exports.obrigacaoTiposRoute = 'tipo-obrigacao';
	exports.obrigacaoTiposStorage = 'obrigacaotipos';
	exports.obrigacaoTiposModuleName = { plural: 'Tipos de obrigação', single: 'Tipo de obrigação' };
	exports.obrigacaoTiposQuery = {
	    "where": {
	        "and": [
	            { "ativo": true },
	            { "titulo": { "regexp": "/REPLACEHERE/i" } },
	        ]
	    },
	    "order": "titulo"
	};


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(537);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(773);
	var data_service_4 = __webpack_require__(783);
	var ObrigacaoTipoNavigationService = (function () {
	    function ObrigacaoTipoNavigationService(_authService) {
	        this._authService = _authService;
	    }
	    ObrigacaoTipoNavigationService.prototype.goToList = function () {
	        var router = data_service_1.despachosRoute + '/' + data_service_3.obrigacoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_4.obrigacaoTiposRoute;
	        this._authService.navigateTo(router);
	    };
	    ObrigacaoTipoNavigationService.prototype.goToNew = function () {
	        var router = data_service_1.despachosRoute + '/' + data_service_3.obrigacoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_4.obrigacaoTiposRoute + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    ObrigacaoTipoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = data_service_1.despachosRoute + '/' + data_service_3.obrigacoesRoute + '/' + data_service_2.configuracaoRoute + '/' + data_service_4.obrigacaoTiposRoute + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    ObrigacaoTipoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ObrigacaoTipoNavigationService);
	    return ObrigacaoTipoNavigationService;
	    var _a;
	}());
	exports.ObrigacaoTipoNavigationService = ObrigacaoTipoNavigationService;


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(783);
	var ObrigacaoTipoApiService = (function () {
	    function ObrigacaoTipoApiService(_restService) {
	        this._restService = _restService;
	    }
	    ObrigacaoTipoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    ObrigacaoTipoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    ObrigacaoTipoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    ObrigacaoTipoApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": ["titulo"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ObrigacaoTipoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    ObrigacaoTipoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    ObrigacaoTipoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ObrigacaoTipoApiService);
	    return ObrigacaoTipoApiService;
	    var _a;
	}());
	exports.ObrigacaoTipoApiService = ObrigacaoTipoApiService;


/***/ },
/* 786 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{obrigacaoModule.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{obrigacaoModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{obrigacaoModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{obrigacaoModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <autocomplete-component class=\"geo-input--3c\" id=\"obrigacaoTipo\"\n                                (setObejct)=\"getObrigacaoTipoObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"obrigacaoTipoSelectId\"\n                                [model]=\"obrigacaoTipoObject\"\n                                [_service]=\"_obrigacaoTipoApiService\"\n                                [fieldToShow]=\"'titulo'\"\n                                [query]=\"obrigacaoTipoQuery\"\n                                [label]=\"'Tipo'\"></autocomplete-component>\n\n\n        <autocomplete-component class=\"geo-input--3c\" id=\"frota\"\n                                (setObejct)=\"getFrotasObject($event)\"\n                                [submitted]=\"submitted\"\n                                [isRequired]=\"true\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"frotaObject\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [query]=\"frotaQuery\"\n                                [label]=\"'Frota / equipamento'\"></autocomplete-component>\n\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !valor.valid && submitted}\">\n            <label for=\"valor\">Valor (R$) <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!valor.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"valor\" [(ngModel)]=\"formObject.valor\" (keyup)=\"keyupCurrency()\" formControlName=\"valor\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c geo-input--datepicker\" [ngClass]=\"{'geo-input--error': !dataVencimento.value && submitted}\">\n            <label for=\"dataVencimento\">Data de vencimento <abbr>*</abbr></label>\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"dataVencimento\" [(ngModel)]=\"formObject.dataVencimento\" formControlName=\"dataVencimento\" appDatepicker autocomplete=\"off\" />\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c geo-input--datepicker\" >\n            <label for=\"dataPagamento\">Data de pagamento </label>\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"dataPagamento\" [(ngModel)]=\"formObject.dataPagamento\" formControlName=\"dataPagamento\" appDatepicker autocomplete=\"off\" />\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\">\n            <label for=\"observacao\">Observação</label>\n            <div>\n                <textarea id=\"observacao\" [(ngModel)]=\"formObject.observacao\" formControlName=\"observacao\"></textarea>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 787 */
166,
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var obrigacao_api_service_1 = __webpack_require__(780);
	var obrigacao_service_1 = __webpack_require__(781);
	var obrigacao_navigation_service_1 = __webpack_require__(779);
	var data_service_1 = __webpack_require__(773);
	var util_service_1 = __webpack_require__(88);
	var pessoa_juridica_api_service_1 = __webpack_require__(758);
	var ObrigacaoListComponent = (function () {
	    function ObrigacaoListComponent(_obrigacoesApiService, _obrigacoeservice, _obrigacaoNavigationService, _pessoaJuridicaApiService, _utilService) {
	        this._obrigacoesApiService = _obrigacoesApiService;
	        this._obrigacoeservice = _obrigacoeservice;
	        this._obrigacaoNavigationService = _obrigacaoNavigationService;
	        this._pessoaJuridicaApiService = _pessoaJuridicaApiService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.obrigacoesModuleName = data_service_1.obrigacoesModuleName;
	    }
	    ObrigacaoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    ObrigacaoListComponent.prototype.clickNew = function () {
	        this._obrigacoeservice.clearSessionStorage();
	        this._obrigacaoNavigationService.goToNew();
	    };
	    ObrigacaoListComponent.prototype.clickEdit = function (item) {
	        this._obrigacoeservice.clearSessionStorage();
	        this._obrigacaoNavigationService.goToEdit(item.id);
	    };
	    ObrigacaoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    ObrigacaoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._obrigacoesApiService.onGetAll(onDone);
	    };
	    ObrigacaoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	                this.deletePessoaJuridica(item.pessoaJuridicaId);
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._obrigacoesApiService.onDelete(item.id, onDone);
	    };
	    ObrigacaoListComponent.prototype.deletePessoaJuridica = function (pessoJuridicaId) {
	        var onDone = (function (Response) {
	        });
	        this._pessoaJuridicaApiService.onDelete(pessoJuridicaId, onDone);
	    };
	    ObrigacaoListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-obrigacao-list',
	            template: __webpack_require__(789),
	            styles: [__webpack_require__(790)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof obrigacao_api_service_1.ObrigacaoApiService !== 'undefined' && obrigacao_api_service_1.ObrigacaoApiService) === 'function' && _a) || Object, (typeof (_b = typeof obrigacao_service_1.Obrigacoeservice !== 'undefined' && obrigacao_service_1.Obrigacoeservice) === 'function' && _b) || Object, (typeof (_c = typeof obrigacao_navigation_service_1.ObrigacaoNavigationService !== 'undefined' && obrigacao_navigation_service_1.ObrigacaoNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof pessoa_juridica_api_service_1.PessoaJuridicaApiService !== 'undefined' && pessoa_juridica_api_service_1.PessoaJuridicaApiService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], ObrigacaoListComponent);
	    return ObrigacaoListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ObrigacaoListComponent = ObrigacaoListComponent;


/***/ },
/* 789 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{obrigacoesModuleName.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">{{obrigacoesModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{obrigacoesModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{obrigacoesModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Data de vencimento</th>\n            <th>Identificação</th>\n            <th>Tipo</th>\n            <th>Valor</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['dataVencimento', 'bem.identificacao', 'valorSegurado', 'numeroApolice'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.dataVencimento | date: 'dd/MM/yyyy'}}</td>\n            <td>\n                <span *ngIf=\"item.bem\">\n                  {{item.bem.codigo}} <span *ngIf=\"item.bem.placa\"> / {{item.bem.placa | licensePlateMask}}</span> - {{item.bem.identificacao}}\n                </span>\n            </td>\n            <td><span *ngIf=\"item.tipoObrigacao\">{{item.tipoObrigacao.titulo}}</span></td>\n            <td><span >{{item.valor | currencyMask}}</span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit' /></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash' /></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <p><strong>Data de pagamento: </strong> {{item.dataPagamento | date: 'dd/MM/yyyy'}} <i *ngIf=\"!item.dataPagamento\">não cadastrado</i></p>\n                <p><strong>Observação: </strong>{{item.observacao}} <i *ngIf=\"!item.observacao\">não cadastrado</i></p>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 790 */
166,
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(178);
	var obrigacao_tipo_api_service_1 = __webpack_require__(785);
	var obrigacao_tipo_navigation_service_1 = __webpack_require__(784);
	var autocomplete_service_1 = __webpack_require__(101);
	var obrigacao_tipo_model_1 = __webpack_require__(782);
	var obrigacao_tipo_service_1 = __webpack_require__(792);
	var data_service_2 = __webpack_require__(783);
	var data_service_3 = __webpack_require__(773);
	var despacho_service_1 = __webpack_require__(793);
	var ObrigacaoTipoFormComponent = (function () {
	    function ObrigacaoTipoFormComponent(_route, _utilService, _obrigacaoTipoApiService, _obrigacaoTipoNavigationService, _obrigacaoTipoService, _autocompleteService, _despachoService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._obrigacaoTipoApiService = _obrigacaoTipoApiService;
	        this._obrigacaoTipoNavigationService = _obrigacaoTipoNavigationService;
	        this._obrigacaoTipoService = _obrigacaoTipoService;
	        this._autocompleteService = _autocompleteService;
	        this._despachoService = _despachoService;
	        this._fb = _fb;
	        this.obrigacaoTiposModule = data_service_2.obrigacaoTiposModuleName;
	        this.configuracaoModule = data_service_1.configuracaoModuleName;
	        this.module = data_service_3.obrigacoesModuleName;
	        this.formObject = new obrigacao_tipo_model_1.TipoObrigacao();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.ativo = new forms_1.FormControl('');
	        this.titulo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.descricao = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responseTipoObrigacao = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            descricao: this.descricao,
	            titulo: this.titulo
	        });
	    }
	    ObrigacaoTipoFormComponent.prototype.ngOnInit = function () {
	        this.isNewAutoComplete();
	    };
	    ObrigacaoTipoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    ObrigacaoTipoFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    ObrigacaoTipoFormComponent.prototype.clickGoToConfig = function () {
	        this._despachoService.goToSettingObrigacoes();
	    };
	    ObrigacaoTipoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEdit(object);
	            }
	            else {
	                this.onAdd(object);
	            }
	        }
	    };
	    ObrigacaoTipoFormComponent.prototype.onAdd = function (object) {
	        this._obrigacaoTipoApiService.onPost(object, this.onDone);
	    };
	    ObrigacaoTipoFormComponent.prototype.onEdit = function (object) {
	        this._obrigacaoTipoApiService.onPut(object, this.onDone);
	    };
	    ObrigacaoTipoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum tipo de obrigação encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._obrigacaoTipoApiService.onGetById(id, onDone);
	    };
	    ObrigacaoTipoFormComponent.prototype.goToList = function () {
	        this._obrigacaoTipoNavigationService.goToList();
	    };
	    ObrigacaoTipoFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._obrigacaoTipoService.getSessionStorage();
	        this._obrigacaoTipoService.clearSessionStorage();
	        if (!session) {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	        }
	        this.setActionTitle(id);
	    };
	    ObrigacaoTipoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_1.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_1.newRoute;
	        }
	    };
	    ObrigacaoTipoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    ObrigacaoTipoFormComponent.prototype.isNewAutoComplete = function () {
	        var newAutoComplete = this._autocompleteService.getSessionStorage(data_service_2.obrigacaoTiposStorage);
	        if (newAutoComplete) {
	            this.returnToOtherForm = true;
	            this.otherForm = newAutoComplete.form;
	            this.formObject.titulo = newAutoComplete.titulo;
	            this.setActionTitle(this.formObject.id);
	        }
	        else {
	            //retornando de um cadastro
	            this.testSession();
	        }
	    };
	    ObrigacaoTipoFormComponent.prototype.toLeaveHere = function () {
	        if (this.returnToOtherForm) {
	            this._obrigacaoTipoService.returnToOtherForm(this.otherForm, this.responseTipoObrigacao);
	        }
	        else {
	            this.goToList();
	        }
	    };
	    ObrigacaoTipoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(794),
	            styles: [__webpack_require__(795)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof obrigacao_tipo_api_service_1.ObrigacaoTipoApiService !== 'undefined' && obrigacao_tipo_api_service_1.ObrigacaoTipoApiService) === 'function' && _c) || Object, (typeof (_d = typeof obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService !== 'undefined' && obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof obrigacao_tipo_service_1.ObrigacaoTipoService !== 'undefined' && obrigacao_tipo_service_1.ObrigacaoTipoService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof despacho_service_1.DespachoService !== 'undefined' && despacho_service_1.DespachoService) === 'function' && _g) || Object, (typeof (_h = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _h) || Object])
	    ], ObrigacaoTipoFormComponent);
	    return ObrigacaoTipoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.ObrigacaoTipoFormComponent = ObrigacaoTipoFormComponent;


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var obrigacao_navigation_service_1 = __webpack_require__(779);
	var obrigacao_service_1 = __webpack_require__(781);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_1 = __webpack_require__(783);
	var data_service_2 = __webpack_require__(773);
	var ObrigacaoTipoService = (function () {
	    function ObrigacaoTipoService(_obrigacaoNavigationService, _obrigacoeservice, _autocompleteService) {
	        this._obrigacaoNavigationService = _obrigacaoNavigationService;
	        this._obrigacoeservice = _obrigacoeservice;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    ObrigacaoTipoService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.obrigacaoTiposStorage + '-new', object);
	    };
	    ObrigacaoTipoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.obrigacaoTiposStorage + "-new");
	        return JSON.parse(item);
	    };
	    ObrigacaoTipoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.obrigacaoTiposStorage + "-new");
	    };
	    ObrigacaoTipoService.prototype.returnToOtherForm = function (otherForm, Response) {
	        if (Response) {
	            var otherFormObject;
	            if (otherForm === data_service_2.obrigacoesStorage) {
	                otherFormObject = this._obrigacoeservice.getSessionStorage();
	                otherFormObject.tipoObrigacao = Response;
	                this._obrigacoeservice.setSessionStorage(otherFormObject);
	            }
	        }
	        this._autocompleteService.clearSessionStorage(data_service_1.obrigacaoTiposStorage);
	        if (otherForm === data_service_2.obrigacoesStorage) {
	            otherFormObject = this._obrigacoeservice.getSessionStorage();
	            if (otherFormObject.id) {
	                this._obrigacaoNavigationService.goToEdit(otherFormObject.id);
	            }
	            else {
	                this._obrigacaoNavigationService.goToNew();
	            }
	        }
	    };
	    ObrigacaoTipoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof obrigacao_navigation_service_1.ObrigacaoNavigationService !== 'undefined' && obrigacao_navigation_service_1.ObrigacaoNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof obrigacao_service_1.Obrigacoeservice !== 'undefined' && obrigacao_service_1.Obrigacoeservice) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object])
	    ], ObrigacaoTipoService);
	    return ObrigacaoTipoService;
	    var _a, _b, _c;
	}());
	exports.ObrigacaoTipoService = ObrigacaoTipoService;


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(61);
	var data_service_1 = __webpack_require__(537);
	var data_service_2 = __webpack_require__(773);
	var DespachoService = (function () {
	    function DespachoService(_authService) {
	        this._authService = _authService;
	    }
	    DespachoService.prototype.goToSettingObrigacoes = function () {
	        var router = data_service_1.despachosRoute + '/' + data_service_2.obrigacoesRoute + '/configuracoes';
	        this._authService.navigateTo(router);
	    };
	    DespachoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], DespachoService);
	    return DespachoService;
	    var _a;
	}());
	exports.DespachoService = DespachoService;


/***/ },
/* 794 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{obrigacaoTiposModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{obrigacaoTiposModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{obrigacaoTiposModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !titulo.valid && submitted}\">\n            <label for=\"titulo\">Tipo <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!titulo.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"titulo\" [(ngModel)]=\"formObject.titulo\" formControlName=\"titulo\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\">\n            <label for=\"descricao\">Descrição</label>\n            <div>\n                <textarea id=\"descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\"></textarea>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 795 */
166,
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var util_service_1 = __webpack_require__(88);
	var obrigacao_tipo_api_service_1 = __webpack_require__(785);
	var obrigacao_tipo_navigation_service_1 = __webpack_require__(784);
	var obrigacao_service_1 = __webpack_require__(781);
	var data_service_1 = __webpack_require__(783);
	var data_service_2 = __webpack_require__(773);
	var data_service_3 = __webpack_require__(178);
	var despacho_service_1 = __webpack_require__(793);
	var ObrigacaoTipoListComponent = (function () {
	    function ObrigacaoTipoListComponent(_obrigacaoTipoApiService, _obrigacaoTipoNavigationService, _obrigacoeservice, _utilService, _despachoService) {
	        this._obrigacaoTipoApiService = _obrigacaoTipoApiService;
	        this._obrigacaoTipoNavigationService = _obrigacaoTipoNavigationService;
	        this._obrigacoeservice = _obrigacoeservice;
	        this._utilService = _utilService;
	        this._despachoService = _despachoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.obrigacaoTiposModuleName = data_service_1.obrigacaoTiposModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	        this.module = data_service_2.obrigacoesModuleName;
	    }
	    ObrigacaoTipoListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    ObrigacaoTipoListComponent.prototype.clickNew = function () {
	        this._obrigacoeservice.clearSessionStorage();
	        this._obrigacaoTipoNavigationService.goToNew();
	    };
	    ObrigacaoTipoListComponent.prototype.clickEdit = function (item) {
	        this._obrigacoeservice.clearSessionStorage();
	        this._obrigacaoTipoNavigationService.goToEdit(item.id);
	    };
	    ObrigacaoTipoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    ObrigacaoTipoListComponent.prototype.clickGoToConfig = function () {
	        this._despachoService.goToSettingObrigacoes();
	    };
	    ObrigacaoTipoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._obrigacaoTipoApiService.onGetAll(onDone);
	    };
	    ObrigacaoTipoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._obrigacaoTipoApiService.onDelete(item.id, onDone);
	    };
	    ObrigacaoTipoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(797),
	            styles: [__webpack_require__(798)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof obrigacao_tipo_api_service_1.ObrigacaoTipoApiService !== 'undefined' && obrigacao_tipo_api_service_1.ObrigacaoTipoApiService) === 'function' && _a) || Object, (typeof (_b = typeof obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService !== 'undefined' && obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof obrigacao_service_1.Obrigacoeservice !== 'undefined' && obrigacao_service_1.Obrigacoeservice) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof despacho_service_1.DespachoService !== 'undefined' && despacho_service_1.DespachoService) === 'function' && _e) || Object])
	    ], ObrigacaoTipoListComponent);
	    return ObrigacaoTipoListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ObrigacaoTipoListComponent = ObrigacaoTipoListComponent;


/***/ },
/* 797 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{obrigacaoTiposModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{obrigacaoTiposModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{obrigacaoTiposModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Título</th>\n            <th>Descrição</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['titulo', 'descricao'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.titulo}}</td>\n            <td>{{item.descricao}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 798 */
166,
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(178);
	var obrigacao_tipo_navigation_service_1 = __webpack_require__(784);
	var licenciamento_navigation_service_1 = __webpack_require__(800);
	var data_service_2 = __webpack_require__(783);
	var data_service_3 = __webpack_require__(385);
	var data_service_4 = __webpack_require__(773);
	var DespachoConfiguracaoObrigacoesComponent = (function () {
	    function DespachoConfiguracaoObrigacoesComponent(_obrigacaoNavigationService, _licenciamentoNavigationService) {
	        this._obrigacaoNavigationService = _obrigacaoNavigationService;
	        this._licenciamentoNavigationService = _licenciamentoNavigationService;
	        this.module = data_service_4.obrigacoesModuleName;
	        this.configuracaoModule = data_service_1.configuracaoModuleName;
	        this.obrigacaoTiposModule = data_service_2.obrigacaoTiposModuleName;
	        this.licenciamentoModule = data_service_3.licenciamentosModuleName;
	    }
	    DespachoConfiguracaoObrigacoesComponent.prototype.ngOnInit = function () {
	    };
	    DespachoConfiguracaoObrigacoesComponent.prototype.clickItem = function (module) {
	        if (module.plural === this.obrigacaoTiposModule.plural) {
	            this._obrigacaoNavigationService.goToList();
	        }
	        else if (module.plural === this.licenciamentoModule.plural) {
	            this._licenciamentoNavigationService.goToList();
	        }
	    };
	    DespachoConfiguracaoObrigacoesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(801)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService !== 'undefined' && obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof licenciamento_navigation_service_1.LicenciamentoNavigationService !== 'undefined' && licenciamento_navigation_service_1.LicenciamentoNavigationService) === 'function' && _b) || Object])
	    ], DespachoConfiguracaoObrigacoesComponent);
	    return DespachoConfiguracaoObrigacoesComponent;
	    var _a, _b;
	}());
	exports.DespachoConfiguracaoObrigacoesComponent = DespachoConfiguracaoObrigacoesComponent;


/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(537);
	var data_service_2 = __webpack_require__(385);
	var auth_service_1 = __webpack_require__(61);
	var data_service_3 = __webpack_require__(178);
	var data_service_4 = __webpack_require__(773);
	var LicenciamentoNavigationService = (function () {
	    function LicenciamentoNavigationService(_authService) {
	        this._authService = _authService;
	        this.fatherRouter = data_service_1.despachosRoute;
	        this.moduleRouter = data_service_2.licenciamentosRoute;
	    }
	    LicenciamentoNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + data_service_4.obrigacoesRoute + '/' + data_service_3.configuracaoRoute + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    LicenciamentoNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + data_service_4.obrigacoesRoute + '/' + data_service_3.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_3.newRoute;
	        this._authService.navigateTo(router);
	    };
	    LicenciamentoNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + data_service_4.obrigacoesRoute + '/' + data_service_3.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_3.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    LicenciamentoNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], LicenciamentoNavigationService);
	    return LicenciamentoNavigationService;
	    var _a;
	}());
	exports.LicenciamentoNavigationService = LicenciamentoNavigationService;


/***/ },
/* 801 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a class=\"active\">{{configuracaoModule.plural}}</a></li>\n    </ul>\n\n    <h1>{{configuracaoModule.plural}} de {{module.plural | lowercase}}</h1>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(obrigacaoTiposModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{obrigacaoTiposModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{obrigacaoTiposModule.plural | lowercase}}\n        </div>\n    </div>\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(licenciamentoModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{licenciamentoModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro e gerenciamento de {{licenciamentoModule.plural | lowercase}}\n        </div>\n    </div>\n</div>";

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LicenciamentosComponent = (function () {
	    function LicenciamentosComponent() {
	    }
	    LicenciamentosComponent.prototype.ngOnInit = function () {
	    };
	    LicenciamentosComponent = __decorate([
	        core_1.Component({
	            selector: 'app-licenciamentos',
	            template: __webpack_require__(803)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LicenciamentosComponent);
	    return LicenciamentosComponent;
	}());
	exports.LicenciamentosComponent = LicenciamentosComponent;


/***/ },
/* 803 */
171,
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(178);
	var licenciamento_form_component_1 = __webpack_require__(805);
	var licenciamento_list_component_1 = __webpack_require__(810);
	var LicenciamentosRoutingModule = (function () {
	    function LicenciamentosRoutingModule() {
	    }
	    LicenciamentosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LicenciamentosRoutingModule);
	    return LicenciamentosRoutingModule;
	}());
	exports.LicenciamentosRoutingModule = LicenciamentosRoutingModule;
	exports.licenciamentosRoutes = [
	    {
	        path: '',
	        component: licenciamento_list_component_1.LicenciamentoListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: licenciamento_form_component_1.LicenciamentoFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: licenciamento_form_component_1.LicenciamentoFormComponent
	    }
	];


/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(385);
	var licenciamento_model_1 = __webpack_require__(806);
	var licenciamento_navigation_service_1 = __webpack_require__(800);
	var licenciamento_api_service_1 = __webpack_require__(384);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(178);
	var licenciamento_service_1 = __webpack_require__(807);
	var estado_model_1 = __webpack_require__(267);
	var data_service_3 = __webpack_require__(199);
	var estado_api_service_1 = __webpack_require__(265);
	var despacho_service_1 = __webpack_require__(793);
	var data_service_4 = __webpack_require__(773);
	var projeto_service_1 = __webpack_require__(52);
	var LicenciamentoFormComponent = (function () {
	    function LicenciamentoFormComponent(_route, _licenciamentoNavigationService, _licenciamentoApiService, _licenciamentosService, _utilService, _estadoApiService, _despachoService, _projetoService, _fb) {
	        this._route = _route;
	        this._licenciamentoNavigationService = _licenciamentoNavigationService;
	        this._licenciamentoApiService = _licenciamentoApiService;
	        this._licenciamentosService = _licenciamentosService;
	        this._utilService = _utilService;
	        this._estadoApiService = _estadoApiService;
	        this._despachoService = _despachoService;
	        this._projetoService = _projetoService;
	        this._fb = _fb;
	        this.licenciamentosModule = data_service_1.licenciamentosModuleName;
	        this.module = data_service_4.obrigacoesModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.formObject = new licenciamento_model_1.Licenciamento();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.monthsList = [];
	        this.mesObject = {};
	        this.estadosList = [];
	        this.loadingEstados = true;
	        this.estadoObject = new estado_model_1.Estado();
	        this.estado = new forms_1.FormControl('', forms_1.Validators.required);
	        this.mes = new forms_1.FormControl('', forms_1.Validators.required);
	        this.finalPlaca = new forms_1.FormControl('', forms_1.Validators.required);
	        this.ativo = new forms_1.FormControl('');
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.goToList();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            finalPlaca: this.finalPlaca,
	            estado: this.estado,
	            mes: this.mes
	        });
	    }
	    LicenciamentoFormComponent.prototype.ngOnInit = function () {
	        this.project = this._projetoService.getSessionStorage();
	        this.monthsList = this._utilService.cloneObject(data_service_3.months);
	        this.mesObject = this.monthsList[0];
	        this.getEstados();
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.setEditNormal(id);
	        }
	        else {
	            this.setNewNormal();
	        }
	        this.setActionTitle(id);
	    };
	    LicenciamentoFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    LicenciamentoFormComponent.prototype.clickCancel = function () {
	        this.goToList();
	    };
	    LicenciamentoFormComponent.prototype.clickGoToConfig = function () {
	        this._despachoService.goToSettingObrigacoes();
	    };
	    LicenciamentoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.estadoObject.id) {
	                object.estadoId = this.estadoObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.mesObject.Value) {
	                object.mes = this.mesObject.Key;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.formObject.id) {
	                this.onEditLicenciamento(object);
	            }
	            else {
	                this.onAddLicenciamento(object);
	            }
	        }
	    };
	    LicenciamentoFormComponent.prototype.onAddLicenciamento = function (object) {
	        this._licenciamentoApiService.onPost(object, this.onDone);
	    };
	    LicenciamentoFormComponent.prototype.onEditLicenciamento = function (object) {
	        this._licenciamentoApiService.onPut(object, this.onDone);
	    };
	    LicenciamentoFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum licenciamento encontrado com este id.');
	                this.goToList();
	            }
	        }.bind(this));
	        this._licenciamentoApiService.onGetById(id, onDone);
	    };
	    LicenciamentoFormComponent.prototype.getEstados = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.estadosList = Response;
	                this.setEstado();
	            }
	            this.loadingEstados = false;
	        }.bind(this));
	        this._estadoApiService.onGetAll(onDone);
	    };
	    LicenciamentoFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    LicenciamentoFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    LicenciamentoFormComponent.prototype.setNewNormal = function () {
	        //se tiver alguma configuração inicial de um cadastro novo
	    };
	    LicenciamentoFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.estado) {
	            this.estadoObject = this.formObject.estado;
	            delete this.formObject['estado'];
	            this.setEstado();
	        }
	        if (this.formObject.mes) {
	            this.mesObject = this.monthsList[this.formObject.mes];
	        }
	    };
	    LicenciamentoFormComponent.prototype.setEstado = function () {
	        var x, lenX, t = this.estadoObject.id;
	        if (!t && this.estadosList.length) {
	            if (this.project) {
	                t = this.project.estadoId;
	            }
	            else {
	                t = this.estadosList[11].id;
	            }
	        }
	        for (x = 0, lenX = this.estadosList.length; x < lenX; x++) {
	            if (this.estadosList[x].id === t) {
	                this.estadoObject = this.estadosList[x];
	                break;
	            }
	        }
	    };
	    LicenciamentoFormComponent.prototype.goToList = function () {
	        this._licenciamentoNavigationService.goToList();
	    };
	    LicenciamentoFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(808),
	            styles: [__webpack_require__(809)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof licenciamento_navigation_service_1.LicenciamentoNavigationService !== 'undefined' && licenciamento_navigation_service_1.LicenciamentoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof licenciamento_api_service_1.LicenciamentoApiService !== 'undefined' && licenciamento_api_service_1.LicenciamentoApiService) === 'function' && _c) || Object, (typeof (_d = typeof licenciamento_service_1.LicenciamentosService !== 'undefined' && licenciamento_service_1.LicenciamentosService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof estado_api_service_1.EstadoApiService !== 'undefined' && estado_api_service_1.EstadoApiService) === 'function' && _f) || Object, (typeof (_g = typeof despacho_service_1.DespachoService !== 'undefined' && despacho_service_1.DespachoService) === 'function' && _g) || Object, (typeof (_h = typeof projeto_service_1.ProjetoService !== 'undefined' && projeto_service_1.ProjetoService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], LicenciamentoFormComponent);
	    return LicenciamentoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.LicenciamentoFormComponent = LicenciamentoFormComponent;


/***/ },
/* 806 */
/***/ function(module, exports) {

	"use strict";
	var Licenciamento = (function () {
	    function Licenciamento() {
	    }
	    return Licenciamento;
	}());
	exports.Licenciamento = Licenciamento;


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(385);
	var autocomplete_service_1 = __webpack_require__(101);
	var LicenciamentosService = (function () {
	    function LicenciamentosService(_autocompleteService) {
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    LicenciamentosService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.licenciamentosStorage + '-new', object);
	    };
	    LicenciamentosService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.licenciamentosStorage + "-new");
	        return JSON.parse(item);
	    };
	    LicenciamentosService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.licenciamentosStorage + "-new");
	    };
	    LicenciamentosService.prototype.returnToOtherForm = function (otherForm, Response) {
	    };
	    LicenciamentosService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _a) || Object])
	    ], LicenciamentosService);
	    return LicenciamentosService;
	    var _a;
	}());
	exports.LicenciamentosService = LicenciamentosService;


/***/ },
/* 808 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{licenciamentosModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{licenciamentosModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{licenciamentosModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !estado.valid && submitted}\">\n            <label for=\"estado\">Estado <abbr>*</abbr></label>\n            <div  class=\"containerSpinner\">\n                <span class=\"error-alert\" *ngIf=\"!estado.valid && submitted\">Este campo é obrigatório.</span>\n                <select id=\"estado\" [(ngModel)]=\"estadoObject\" formControlName=\"estado\">\n                    <option *ngFor=\"let item of estadosList\" [ngValue]=\"item\">{{item.nome}}</option>\n                </select>\n                <spinner-component *ngIf=\"loadingEstados\"></spinner-component>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !mes.valid && submitted}\">\n            <label for=\"mes\">Mês <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!mes.valid && submitted\">Este campo é obrigatório.</span>\n                <select id=\"mes\" [(ngModel)]=\"mesObject\" formControlName=\"mes\">\n                    <option *ngFor=\"let item of monthsList\" [ngValue]=\"item\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !finalPlaca.valid && submitted}\">\n            <label for=\"finalPlaca\">Final da placa <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!finalPlaca.valid && submitted\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"finalPlaca\" placeholder=\"\" [(ngModel)]=\"formObject.finalPlaca\" appNumberInteger maxlength=\"1\" formControlName=\"finalPlaca\">\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>";

/***/ },
/* 809 */
/***/ function(module, exports) {

	module.exports = ".containerSpinner {\n    position: relative;\n}\nspinner-component {\n    position: absolute;\n    top: -5px;\n    right: 12px;\n}\n"

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(385);
	var licenciamento_api_service_1 = __webpack_require__(384);
	var licenciamento_navigation_service_1 = __webpack_require__(800);
	var licenciamento_service_1 = __webpack_require__(807);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(199);
	var despacho_service_1 = __webpack_require__(793);
	var data_service_3 = __webpack_require__(178);
	var data_service_4 = __webpack_require__(773);
	var LicenciamentoListComponent = (function () {
	    function LicenciamentoListComponent(_licenciamentosApiService, _licenciamentosService, _licenciamentoNavigationService, _utilService, _despachoService) {
	        this._licenciamentosApiService = _licenciamentosApiService;
	        this._licenciamentosService = _licenciamentosService;
	        this._licenciamentoNavigationService = _licenciamentoNavigationService;
	        this._utilService = _utilService;
	        this._despachoService = _despachoService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.licenciamentosModuleName = data_service_1.licenciamentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	        this.module = data_service_4.obrigacoesModuleName;
	        this.mesesList = [];
	    }
	    LicenciamentoListComponent.prototype.ngOnInit = function () {
	        this.mesesList = this._utilService.cloneObject(data_service_2.months);
	        this.getAll();
	    };
	    LicenciamentoListComponent.prototype.clickNew = function () {
	        this._licenciamentosService.clearSessionStorage();
	        this._licenciamentoNavigationService.goToNew();
	    };
	    LicenciamentoListComponent.prototype.clickEdit = function (item) {
	        this._licenciamentosService.clearSessionStorage();
	        this._licenciamentoNavigationService.goToEdit(item.id);
	    };
	    LicenciamentoListComponent.prototype.clickGoToConfig = function () {
	        this._despachoService.goToSettingObrigacoes();
	    };
	    LicenciamentoListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    LicenciamentoListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.forEach(function (item) {
	                    if (item.mes) {
	                        item.mes = this.mesesList[item.mes];
	                    }
	                }.bind(this));
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._licenciamentosApiService.onGetAll(onDone);
	    };
	    LicenciamentoListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._licenciamentosApiService.onDelete(item.id, onDone);
	    };
	    LicenciamentoListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(811),
	            styles: [__webpack_require__(812)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof licenciamento_api_service_1.LicenciamentoApiService !== 'undefined' && licenciamento_api_service_1.LicenciamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof licenciamento_service_1.LicenciamentosService !== 'undefined' && licenciamento_service_1.LicenciamentosService) === 'function' && _b) || Object, (typeof (_c = typeof licenciamento_navigation_service_1.LicenciamentoNavigationService !== 'undefined' && licenciamento_navigation_service_1.LicenciamentoNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof despacho_service_1.DespachoService !== 'undefined' && despacho_service_1.DespachoService) === 'function' && _e) || Object])
	    ], LicenciamentoListComponent);
	    return LicenciamentoListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.LicenciamentoListComponent = LicenciamentoListComponent;


/***/ },
/* 811 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{licenciamentosModuleName.plural}}</a></li>\n        </ul>\n    </div>\n    <div class=\"geo-columns--3c\">\n        <h1>{{licenciamentosModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{licenciamentosModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Estado</th>\n            <th>Mês</th>\n            <th>Final da placa</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['mes.Value','estado.nome','finalPlaca'] | filterActive:showDisabled | sort:['estado.nome'])\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span *ngIf=\"item.estado\">{{item.estado.nome}}</span></td>\n            <td><span *ngIf=\"item.mes\">{{item.mes.Value}}</span></td>\n            <td>{{item.finalPlaca}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 812 */
166,
/* 813 */
/***/ function(module, exports) {

	"use strict";
	exports.rastreamentosRoute = 'rastreamento';
	exports.rastreamentosModuleName = { plural: 'Rastreamentos', single: 'Rastreamento' };
	exports.apiName = 'rastreamentos';
	exports.rastreamentosStorage = 'rastreamento';
	exports.eventosRastreamentoApiName = 'eventos-rastreamentos';
	exports.time = [
	    { Key: 0, Value: '0h' },
	    { Key: 1, Value: '1h' },
	    { Key: 2, Value: '2h' },
	    { Key: 4, Value: '3h' },
	    { Key: 5, Value: '4h' },
	    { Key: 5, Value: '5h' },
	    { Key: 6, Value: '6h' },
	    { Key: 7, Value: '7h' },
	    { Key: 8, Value: '8h' },
	    { Key: 9, Value: '9h' },
	    { Key: 10, Value: '10h' },
	    { Key: 11, Value: '11h' },
	    { Key: 12, Value: '12h' },
	    { Key: 13, Value: '13h' },
	    { Key: 14, Value: '14h' },
	    { Key: 15, Value: '15h' },
	    { Key: 16, Value: '16h' },
	    { Key: 17, Value: '17h' },
	    { Key: 18, Value: '18h' },
	    { Key: 19, Value: '19h' },
	    { Key: 20, Value: '20h' },
	    { Key: 21, Value: '21h' },
	    { Key: 22, Value: '22h' },
	    { Key: 23, Value: '23h' },
	    { Key: 24, Value: '24h' }
	];
	exports.distance = [
	    { Key: 0, Value: '0m' },
	    { Key: 50, Value: '50m' },
	    { Key: 100, Value: '100m' }
	];


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var RastreamentosComponent = (function () {
	    function RastreamentosComponent() {
	    }
	    RastreamentosComponent.prototype.ngOnInit = function () {
	    };
	    RastreamentosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(815)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], RastreamentosComponent);
	    return RastreamentosComponent;
	}());
	exports.RastreamentosComponent = RastreamentosComponent;


/***/ },
/* 815 */
55,
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var auth_guard_service_1 = __webpack_require__(89);
	var rastreamento_configuracao_component_1 = __webpack_require__(817);
	var data_service_1 = __webpack_require__(178);
	var rastreamento_mapa_component_1 = __webpack_require__(825);
	var rastreamento_veiculos_component_1 = __webpack_require__(830);
	var rastreamento_historico_component_1 = __webpack_require__(833);
	var modelos_gps_component_1 = __webpack_require__(836);
	var data_service_2 = __webpack_require__(387);
	var modelos_gps_routing_module_1 = __webpack_require__(838);
	var rastreamento_mapa2_component_1 = __webpack_require__(846);
	var data_service_3 = __webpack_require__(819);
	var cercas_component_1 = __webpack_require__(849);
	var cercas_routing_module_1 = __webpack_require__(851);
	var data_service_4 = __webpack_require__(821);
	var alarmes_component_1 = __webpack_require__(861);
	var alarmes_routing_module_1 = __webpack_require__(863);
	var RastreamentosRoutingModule = (function () {
	    function RastreamentosRoutingModule() {
	    }
	    RastreamentosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], RastreamentosRoutingModule);
	    return RastreamentosRoutingModule;
	}());
	exports.RastreamentosRoutingModule = RastreamentosRoutingModule;
	exports.rastreamentosRoutes = [
	    {
	        path: '',
	        redirectTo: '/mapa',
	        pathMatch: 'full'
	    }, {
	        path: data_service_1.configuracaoRoute,
	        component: rastreamento_configuracao_component_1.RastreamentoConfiguracaoComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService]
	    }, {
	        path: data_service_1.configuracaoRoute + '/' + data_service_2.modeloGpsRoute,
	        component: modelos_gps_component_1.ModelosGpsComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: modelos_gps_routing_module_1.modeloGpsRoutes
	    }, {
	        path: data_service_1.configuracaoRoute + '/' + data_service_3.cercaRoute,
	        component: cercas_component_1.CercasComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: cercas_routing_module_1.cercaRoutes
	    }, {
	        path: data_service_1.configuracaoRoute + '/' + data_service_4.alarmeRoute,
	        component: alarmes_component_1.AlarmesComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	        children: alarmes_routing_module_1.alarmeRoutes
	    }, {
	        path: 'mapa',
	        component: rastreamento_mapa_component_1.RastreamentoMapaComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	    }, {
	        path: 'mapa2',
	        component: rastreamento_mapa2_component_1.RastreamentoMapa2Component,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	    }, {
	        path: 'veiculos',
	        component: rastreamento_veiculos_component_1.RastreamentoVeiculosComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	    }, {
	        path: 'veiculos/:id',
	        component: rastreamento_historico_component_1.RastreamentoHistoricoComponent,
	        canActivate: [auth_guard_service_1.AuthGuardService],
	    }
	];


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(813);
	var data_service_2 = __webpack_require__(178);
	var modelo_gps_navigation_service_1 = __webpack_require__(818);
	var data_service_3 = __webpack_require__(387);
	var data_service_4 = __webpack_require__(819);
	var cerca_navigation_service_1 = __webpack_require__(820);
	var data_service_5 = __webpack_require__(821);
	var alarme_navigation_service_1 = __webpack_require__(822);
	var RastreamentoConfiguracaoComponent = (function () {
	    function RastreamentoConfiguracaoComponent(_modeloGpsNavigationService, _cercaNavigationService, _alarmeNavigationService) {
	        this._modeloGpsNavigationService = _modeloGpsNavigationService;
	        this._cercaNavigationService = _cercaNavigationService;
	        this._alarmeNavigationService = _alarmeNavigationService;
	        this.module = data_service_1.rastreamentosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.modeloGpsModule = data_service_3.modeloGpsModuleName;
	        this.cercaModule = data_service_4.cercaModuleName;
	        this.alarmeModule = data_service_5.alarmeModuleName;
	    }
	    RastreamentoConfiguracaoComponent.prototype.ngOnInit = function () {
	    };
	    RastreamentoConfiguracaoComponent.prototype.clickItem = function (module) {
	        if (module.plural === this.modeloGpsModule.plural) {
	            this._modeloGpsNavigationService.goToList();
	        }
	        else if (module.plural === this.cercaModule.plural) {
	            this._cercaNavigationService.goToList();
	        }
	        else if (module.plural === this.alarmeModule.plural) {
	            this._alarmeNavigationService.goToList();
	        }
	    };
	    RastreamentoConfiguracaoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(823),
	            styles: [__webpack_require__(824)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof modelo_gps_navigation_service_1.ModeloGpsNavigationService !== 'undefined' && modelo_gps_navigation_service_1.ModeloGpsNavigationService) === 'function' && _a) || Object, (typeof (_b = typeof cerca_navigation_service_1.CercaNavigationService !== 'undefined' && cerca_navigation_service_1.CercaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof alarme_navigation_service_1.AlarmeNavigationService !== 'undefined' && alarme_navigation_service_1.AlarmeNavigationService) === 'function' && _c) || Object])
	    ], RastreamentoConfiguracaoComponent);
	    return RastreamentoConfiguracaoComponent;
	    var _a, _b, _c;
	}());
	exports.RastreamentoConfiguracaoComponent = RastreamentoConfiguracaoComponent;


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(387);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(813);
	var ModeloGpsNavigationService = (function () {
	    function ModeloGpsNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.modeloGpsRoute;
	        this.fatherRouter = data_service_3.rastreamentosRoute;
	        this.configuracaoRoute = data_service_2.configuracaoRoute;
	    }
	    ModeloGpsNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    ModeloGpsNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    ModeloGpsNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    ModeloGpsNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], ModeloGpsNavigationService);
	    return ModeloGpsNavigationService;
	    var _a;
	}());
	exports.ModeloGpsNavigationService = ModeloGpsNavigationService;


/***/ },
/* 819 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'cercas-projetos';
	exports.cercaRoute = 'cercas';
	exports.cercaStorage = 'cercas';
	exports.cercaModuleName = { plural: 'Cercas', single: 'Cerca' };
	exports.cercaQuery = {
	    "where": {
	        "ativo": true,
	        "nome": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "nome"
	};
	exports.tiposCercas = [
	    { Key: 1, Value: "circular" },
	    { Key: 2, Value: "poligonal" }
	];


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(819);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(813);
	var CercaNavigationService = (function () {
	    function CercaNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.cercaRoute;
	        this.fatherRouter = data_service_3.rastreamentosRoute;
	        this.configuracaoRoute = data_service_2.configuracaoRoute;
	    }
	    CercaNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    CercaNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    CercaNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    CercaNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], CercaNavigationService);
	    return CercaNavigationService;
	    var _a;
	}());
	exports.CercaNavigationService = CercaNavigationService;


/***/ },
/* 821 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'alarmes';
	exports.alarmeRoute = 'alarmes';
	exports.alarmestorage = 'alarmes';
	exports.alarmeModuleName = { plural: 'Alarmes', single: 'Alarme' };
	exports.apiBemAlarme = 'bens-alarmes';
	exports.apiCercaAlarme = 'cercas-alarmes';
	exports.apiEmailAlarme = 'emails-alarmes';
	exports.apiTemplateAlarme = 'templates';


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(821);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(813);
	var AlarmeNavigationService = (function () {
	    function AlarmeNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.alarmeRoute;
	        this.fatherRouter = data_service_3.rastreamentosRoute;
	        this.configuracaoRoute = data_service_2.configuracaoRoute;
	    }
	    AlarmeNavigationService.prototype.goToList = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter;
	        this._authService.navigateTo(router);
	    };
	    AlarmeNavigationService.prototype.goToNew = function () {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.newRoute;
	        this._authService.navigateTo(router);
	    };
	    AlarmeNavigationService.prototype.goToEdit = function (objectId) {
	        var router = this.fatherRouter + '/' + this.configuracaoRoute + '/' + this.moduleRouter + '/' + data_service_2.editRoute;
	        this._authService.navigateTo(router, objectId);
	    };
	    AlarmeNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], AlarmeNavigationService);
	    return AlarmeNavigationService;
	    var _a;
	}());
	exports.AlarmeNavigationService = AlarmeNavigationService;


/***/ },
/* 823 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a class=\"active\">{{configuracaoModule.plural}}</a></li>\n    </ul>\n\n    <h1>{{configuracaoModule.plural}} de {{module.plural | lowercase}}</h1>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(alarmeModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{alarmeModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro de gerenciamento de {{alarmeModule.plural | lowercase}}\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(cercaModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{cercaModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro de gerenciamento de {{cercaModule.plural | lowercase}}\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c geo-card\" (click)=\"clickItem(modeloGpsModule)\">\n        <div class=\"geo-card__title\">\n            <a>{{modeloGpsModule.plural}}</a>\n            <a class=\"geo-card--icon\"></a>\n        </div>\n        <div class=\"geo-card__content\">\n            Cadastro de gerenciamento de {{modeloGpsModule.plural | lowercase}}\n        </div>\n    </div>\n</div>\n\n\n";

/***/ },
/* 824 */
166,
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(813);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(154);
	var rastreamento_api_service_1 = __webpack_require__(826);
	var sort_service_1 = __webpack_require__(97);
	var data_service_3 = __webpack_require__(50);
	var projeto_service_1 = __webpack_require__(52);
	var rastreamento_service_1 = __webpack_require__(827);
	var RastreamentoMapaComponent = (function () {
	    function RastreamentoMapaComponent(_rastreamentoApiService, _rastreamentoService, _frotaApiService, _frotaService, _utilService, _sortService, _dataService, _projetoService) {
	        this._rastreamentoApiService = _rastreamentoApiService;
	        this._rastreamentoService = _rastreamentoService;
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._utilService = _utilService;
	        this._sortService = _sortService;
	        this._dataService = _dataService;
	        this._projetoService = _projetoService;
	        this.module = data_service_1.rastreamentosModuleName;
	        this.tabSelected = 'atual';
	        this.frotaSelectId = 'frota';
	        this.frotaObject = {};
	        this.loadingFrota = true;
	        this.frotaList = [];
	        this.timeListStart = [];
	        this.timeListEnd = [];
	        this.timeStart = {};
	        this.timeEnd = {};
	        this.distance = {};
	        this.historic = [];
	        this.loadingHistoric = false;
	        this.locationObject = {};
	        this.loadingEvents = false;
	        this.events = [];
	        this.eventSelected = {};
	        this.eventsList = [];
	        this.distanceList = [];
	        this.timeList = [];
	        this.markers = [];
	        this.coordinates = [];
	        this.showTrail = false;
	        this.showChart = false;
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	    }
	    RastreamentoMapaComponent.prototype.ngOnInit = function () {
	        this.timeListStart = this._utilService.cloneObject(data_service_1.time);
	        this.timeListEnd = this._utilService.cloneObject(data_service_1.time);
	        this.timeList = this._utilService.cloneObject(data_service_1.time);
	        this.distanceList = this._utilService.cloneObject(data_service_1.distance);
	        this.distance = this.distanceList[0];
	        this.frotaQuery = this._utilService.cloneObject(data_service_2.frotasQuery);
	        this.frotaQuery.where.and.push({ gpsImei: { neq: null } });
	        this.frotaQuery.where.and.push({ gpsModeloId: { neq: null } });
	        this.veiculoCategoriaId = this._frotaService.getTipoVeiculo();
	        this.frotaApi = '/categoria/' + this.veiculoCategoriaId;
	        this.initialize();
	        this.getAllFrota();
	        this.getAllEvents();
	    };
	    RastreamentoMapaComponent.prototype.ngAfterViewInit = function () {
	        this.velocityChartDiv = document.getElementById('velocity-chart');
	        this.initChart();
	        // se veio da pagina de historico de rastreamento
	        var e = this._rastreamentoService.getSessionStorage();
	        if (e) {
	            setTimeout(function () {
	                $('#' + e.id + ' tr').click();
	            }, 1000);
	            this._rastreamentoService.clearSessionStorage();
	        }
	    };
	    RastreamentoMapaComponent.prototype.getFrotasObject = function (object) {
	        this.frotaObject = object;
	    };
	    RastreamentoMapaComponent.prototype.clickItem = function (item) {
	        $('#tableRatreamento [data-collapse] tr').each(function (i, event) {
	            if (this.className.search(item.id) === -1) {
	                $(this).removeClass('geo-arrow--down active');
	            }
	        });
	        this.removeMarkers();
	        if (item.id !== this.frotaObject.id) {
	            this.locationObject = {};
	            this.frotaObject = item;
	            this.getCurrentLocation();
	        }
	        else {
	            this.frotaObject = {};
	        }
	    };
	    RastreamentoMapaComponent.prototype.changeStartTime = function () {
	        if (this.timeStart.Key === 24) {
	            return this.timeListEnd = [];
	        }
	        this.timeListEnd = this.timeList.slice(this.timeStart.Key + 1, this.timeList.length);
	        this.timeEnd = this.timeListEnd[0];
	        this.changeEndTime();
	        this.timeStart.label = this._utilService.cloneObject("das " + this.timeStart.Value);
	    };
	    RastreamentoMapaComponent.prototype.changeEndTime = function () {
	        this.timeEnd.label = this._utilService.cloneObject("às " + this.timeEnd.Value);
	    };
	    RastreamentoMapaComponent.prototype.clickBuscarHistorico = function () {
	        var date = document.getElementById('date');
	        date = date.value;
	        this.msg = '';
	        if (this.frotaObject.id && date) {
	            var timeStart = this.timeStart;
	            if (timeStart) {
	                timeStart = ((timeStart.Key < 10) ? '0' + timeStart.Key.toString() : timeStart.Key.toString()).concat(":00");
	            }
	            var timeEnd = this.timeEnd;
	            if (timeEnd) {
	                timeEnd = ((timeEnd.Key < 10) ? '0' + timeEnd.Key.toString() : timeEnd.Key.toString()).concat(":00");
	            }
	            var start = this._utilService.convertStringToDateTime(date, timeStart);
	            var end = this._utilService.convertStringToDateTime(date, timeEnd);
	            var query = {
	                bemId: this.frotaObject.id,
	                inicio: start,
	                fim: end,
	                distanciaMinimaPontos: this.distance.Key
	            };
	            this.dateString = date;
	            this.removeMarkers();
	            this.getHistoric(query);
	        }
	        else {
	            this.msg = "Informe o veículo e a data";
	            this.historic = [];
	            this.removeMarkers();
	        }
	    };
	    RastreamentoMapaComponent.prototype.clickBuscarEventos = function () {
	        var query = {};
	        if (this.frotaObject.id) {
	            query.bemId = this.frotaObject.id;
	        }
	        if (this.eventSelected.id) {
	            query.evento = this.eventSelected.id;
	        }
	        var date = document.getElementById('date2');
	        date = date.value;
	        if (date) {
	            date = this._utilService.convertStringToDate(date);
	            var currDate = date;
	            var currDay = currDate.getDate(), currMonth = currDate.getMonth(), currYear = currDate.getFullYear();
	            var currDate2 = new Date(currYear, currMonth, currDay);
	            var tomorrowDate = new Date(currDate.setDate(currDate.getDate() + 1));
	            var tomorrowDay = tomorrowDate.getDate(), tomorrowMonth = tomorrowDate.getMonth(), tomorrowYear = tomorrowDate.getFullYear();
	            var tomorrowDate2 = new Date(tomorrowYear, tomorrowMonth, tomorrowDay);
	            query.and = [
	                {
	                    data: {
	                        gte: currDate2
	                    }
	                }, {
	                    data: {
	                        lte: tomorrowDate2
	                    }
	                }
	            ];
	        }
	        this.getEvents(query);
	    };
	    RastreamentoMapaComponent.prototype.setTab = function (tab) {
	        this.tabSelected = tab;
	        if (tab === 'historico') {
	            setTimeout(function () {
	                this.historic = [];
	                if (this.frotaObject.id) {
	                    this._frotaService.setAutocompleteOption(this.frotaSelectId, this.frotaObject);
	                }
	                this._utilService.disabledFutureDates('date');
	                this.timeStart = this.timeListStart[0];
	                this.changeStartTime();
	            }.bind(this));
	        }
	        if (tab === 'eventos') {
	            setTimeout(function () {
	                this.events = [];
	                this._utilService.disabledFutureDates('date2');
	                var date = document.getElementById('date2');
	                if (date) {
	                    date.value = this._utilService.convertDateToString(new Date());
	                }
	                this.clickBuscarEventos();
	            }.bind(this));
	        }
	        else {
	            this.frotaObject = {};
	        }
	    };
	    RastreamentoMapaComponent.prototype.isTab = function (tab) {
	        var isTab = (tab === this.tabSelected) ? true : false;
	        return isTab;
	    };
	    RastreamentoMapaComponent.prototype.clickShowChart = function () {
	        this.clickHideChart();
	        this.velocityChartDiv.style.display = 'block';
	        this.showChart = true;
	        this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(this.velocityChartDiv);
	        this.initChart();
	    };
	    RastreamentoMapaComponent.prototype.clickHideChart = function () {
	        this.showChart = false;
	        this.velocityChart.destroy();
	        var a = this.map.controls[google.maps.ControlPosition.LEFT_BOTTOM];
	        if (a.length) {
	            a.removeAt(0);
	        }
	    };
	    RastreamentoMapaComponent.prototype.initialize = function () {
	        var project = this._projetoService.getSessionStorage();
	        var coord = this._dataService.getCoordinates();
	        var lat = coord.lat, lng = coord.lng;
	        if (project) {
	            lat = project.latitude;
	            lng = project.longitude;
	        }
	        this.patternCoordinates = { lat: lat, lng: lng };
	        this.initMap(lat, lng);
	    };
	    RastreamentoMapaComponent.prototype.initMap = function (lat, lng) {
	        var map;
	        var latlng = new google.maps.LatLng(lat, lng);
	        var mapOptions = {
	            zoom: 12,
	            mapTypeControl: false,
	            streetViewControlOptions: {
	                position: google.maps.ControlPosition.LEFT_TOP
	            },
	            zoomControlOptions: {
	                position: google.maps.ControlPosition.LEFT_TOP
	            },
	        };
	        map = new google.maps.Map(document.getElementById("map"), mapOptions);
	        var infoContent = document.getElementById('info-content');
	        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(infoContent);
	        var btn = document.getElementById('btnRoadmap');
	        this.addMapTypeButtonEvent(btn, 'ROADMAP', map);
	        btn.click();
	        btn = document.getElementById('btnSatellite');
	        this.addMapTypeButtonEvent(btn, 'SATELLITE', map);
	        btn = document.getElementById('btnHybrid');
	        this.addMapTypeButtonEvent(btn, 'HYBRID', map);
	        var input = document.getElementById('trafficLayer');
	        var trafficLayer = new google.maps.TrafficLayer();
	        this.toogleMapLayerEvent(input, trafficLayer, map);
	        input = document.getElementById('transitLayer');
	        var transitLayer = new google.maps.TransitLayer();
	        this.toogleMapLayerEvent(input, transitLayer, map);
	        input = document.getElementById('trail');
	        input.addEventListener('click', function (e) {
	            this.showTrail = !this.showTrail;
	            if (this.showTrail) {
	                input.classList.add("active");
	            }
	            else {
	                input.classList.remove("active");
	                this.removePolyline();
	            }
	        }.bind(this));
	        input.click();
	        var div = document.getElementById('controls-map');
	        map.controls[google.maps.ControlPosition.TOP_LEFT].push(div);
	        var btnToggle = document.getElementById('btnToggle');
	        btnToggle.addEventListener('click', function (e) {
	            var x, lenX, found = false, controls = map.controls[google.maps.ControlPosition.TOP_RIGHT];
	            for (x = 0, lenX = controls.b.length; x < lenX; x++) {
	                if (controls.b[x].id === 'info-content') {
	                    map.controls[google.maps.ControlPosition.TOP_RIGHT].removeAt(x);
	                    found = true;
	                    break;
	                }
	            }
	            if (!found) {
	                map.controls[google.maps.ControlPosition.TOP_RIGHT].removeAt(0);
	                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(infoContent);
	                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnToggle);
	            }
	        });
	        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnToggle);
	        map.setCenter(latlng);
	        this.map = map;
	    };
	    RastreamentoMapaComponent.prototype.setMarker = function (location) {
	        var frota = this.frotaObject;
	        if (frota.id) {
	            var map_1 = this.map;
	            var latlng_1 = { lat: location.latitude, lng: location.longitude };
	            var rotation = location.angulo;
	            if (!rotation) {
	                rotation = 40;
	            }
	            var marker_1 = new google.maps.Marker({
	                position: latlng_1,
	                title: frota.identificacao,
	                map: map_1,
	                //icon: '../../assets/images/arrow-gps.svg',
	                icon: {
	                    path: "M 50.084,0 50.084,111.908 100.169,150.254, 50.084,0 50.084,111.908 0,150.254",
	                    fillColor: '#BA1B06',
	                    fillOpacity: 1,
	                    strokeWeight: 0,
	                    scale: .20,
	                    rotation: rotation
	                }
	            });
	            var callbackGeoCoder = function (response) {
	                location.address = response;
	                var infowindow = this.setInfowindow(location);
	                infowindow.open(map_1, marker_1);
	            }.bind(this);
	            marker_1.addListener('click', function () {
	                this.geocodeLatLng(latlng_1, callbackGeoCoder);
	            }.bind(this));
	            this.markers.push(marker_1);
	            this.coordinates.push(latlng_1);
	        }
	    };
	    RastreamentoMapaComponent.prototype.removeMarkers = function () {
	        var x, lenX;
	        for (x = 0, lenX = this.markers.length; x < lenX; x++) {
	            this.markers[x].setMap(null);
	        }
	        this.markers = [];
	        this.coordinates = [];
	        this.removeMarkerCluster();
	        this.removePolyline();
	    };
	    RastreamentoMapaComponent.prototype.geocodeLatLng = function (latlng, callback) {
	        var geocoder = new google.maps.Geocoder;
	        geocoder.geocode({ 'location': latlng }, function (results, status) {
	            if (status === 'OK') {
	                if (results[0]) {
	                    callback(results[0].formatted_address);
	                }
	                else {
	                    window.alert('No results found');
	                }
	            }
	            else {
	                window.alert('Geocoder failed due to: ' + status);
	            }
	        });
	    };
	    RastreamentoMapaComponent.prototype.setInfowindow = function (location) {
	        var date = this._utilService.convertDateToString(location.data);
	        var time = this._utilService.convertTimeToString(location.data);
	        if (!location.address) {
	            location.address = ' - ';
	        }
	        var content = '<div>' +
	            '<strong>' + this.frotaObject.identificacao + '</strong>' +
	            '<br> ' +
	            '<p>Local: ' + location.address + '</p>' +
	            '<p>Data/hora: ' + date + ' ' + time + '</p>' +
	            '<p>lat: ' + location.latitude + ' / lng:' + location.longitude + '</p>' +
	            '<p>Velocidade: ' + location.kmPorHora + ' km/h</p>' +
	            '</div>';
	        var infowindow = new google.maps.InfoWindow({
	            content: content
	        });
	        return infowindow;
	    };
	    RastreamentoMapaComponent.prototype.setPolyline = function () {
	        var coordinates = this.coordinates;
	        //draw line
	        var flightPath = new google.maps.Polyline({
	            path: coordinates,
	            geodesic: true,
	            strokeColor: '#8075D6',
	            strokeOpacity: 1.0,
	            strokeWeight: 2
	        });
	        flightPath.setMap(this.map);
	        this.polyline = flightPath;
	    };
	    RastreamentoMapaComponent.prototype.removePolyline = function () {
	        if (this.polyline) {
	            this.polyline.setMap(null);
	        }
	    };
	    RastreamentoMapaComponent.prototype.setMarkerCluster = function () {
	        // Add a marker clusterer to manage the markers.
	        var markerCluster = new MarkerClusterer(this.map, this.markers, { imagePath: 'assets/markerclusterer-1.0/m/m' });
	        this.markerCluster = markerCluster;
	    };
	    RastreamentoMapaComponent.prototype.removeMarkerCluster = function () {
	        if (this.markerCluster) {
	            this.markerCluster.clearMarkers();
	        }
	    };
	    RastreamentoMapaComponent.prototype.getAllFrota = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.frotaList = list;
	            }
	            this.loadingFrota = false;
	        }.bind(this));
	        var query = this._utilService.cloneObject(data_service_2.frotasQueryComGPS);
	        this._frotaApiService.onGetByCategoriaQuery(this.veiculoCategoriaId, query, onDone);
	    };
	    RastreamentoMapaComponent.prototype.getAllEvents = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.eventsList = Response;
	                this.eventsList.unshift({ id: null, titulo: "— Todos os eventos —" });
	                this.eventSelected = this.eventsList[0];
	            }
	            this.loadingFrota = false;
	        }.bind(this));
	        this._rastreamentoApiService.onGetAllEvents(onDone);
	    };
	    RastreamentoMapaComponent.prototype.getCurrentLocation = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.locationObject = Response;
	                Response = this.testObject(Response);
	                if (Response.latlng) {
	                    var found = this.checkCoordinates(Response);
	                    if (!found) {
	                        //set o marker no mapa somente se as coordenadas não existirem no array
	                        var rastro = this._utilService.cloneObject(this.coordinates);
	                        this.removeMarkers();
	                        this.setMarker(Response);
	                        rastro.reverse();
	                        rastro.unshift(this.coordinates[0]);
	                        rastro = (rastro.length > 5) ? rastro.slice(0, 5) : rastro;
	                        this.coordinates = rastro.reverse();
	                        if (this.showTrail) {
	                            this.setPolyline();
	                        }
	                        this.map.setCenter(Response.latlng);
	                        this.map.setZoom(16);
	                    }
	                }
	            }
	            else {
	            }
	            setTimeout(function () {
	                if (this.tabSelected === 'atual') {
	                    this.getCurrentLocation();
	                }
	            }.bind(this), 10000);
	        }.bind(this));
	        if (this.frotaObject.id) {
	            this._rastreamentoApiService.onGetCurrent(this.frotaObject.id, onDone);
	        }
	    };
	    RastreamentoMapaComponent.prototype.getHistoric = function (query) {
	        var onDone = (function (Response) {
	            var _this = this;
	            if (!Response.error) {
	                Response = this._sortService.sortArray(Response, ['data']);
	                var found_1, latlng_2 = this.patternCoordinates;
	                Response.forEach(function (item) {
	                    item = _this.testObject(item);
	                    if (item.latlng) {
	                        latlng_2 = item.latlng;
	                        found_1 = _this.checkCoordinates(item);
	                        if (!found_1) {
	                            _this.setMarker(item);
	                        }
	                    }
	                    if (item.kmPorHora) {
	                        item.kmPorHora = item.kmPorHora.toFixed(2);
	                    }
	                });
	                this.historic = Response;
	                if (this.showChart) {
	                    this.clickShowChart();
	                }
	                if (Response.length) {
	                    this.setMarkerCluster();
	                    this.setPolyline();
	                    this.map.setCenter(latlng_2);
	                    this.map.setZoom(16);
	                }
	                else {
	                    this.msg = "Nenhum dado encontrado";
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom("Não foi possível obter a localidade do veículo");
	            }
	            this.loadingHistoric = false;
	        }.bind(this));
	        this.loadingHistoric = true;
	        this._rastreamentoApiService.onGetPeriod(query, onDone);
	    };
	    RastreamentoMapaComponent.prototype.checkCoordinates = function (newLocation) {
	        var x, lenX, found = false;
	        for (x = 0, lenX = this.coordinates.length; x < lenX; x++) {
	            if (this.coordinates[x].lat === newLocation.latitude && this.coordinates[x].lng === newLocation.longitude) {
	                found = true;
	            }
	        }
	        return found;
	    };
	    RastreamentoMapaComponent.prototype.testObject = function (location) {
	        if (location.longitude && location.latitude) {
	            location.latlng = { lat: location.latitude, lng: location.longitude };
	        }
	        return location;
	    };
	    RastreamentoMapaComponent.prototype.addMapTypeButtonEvent = function (btn, type, map) {
	        btn.addEventListener('click', function (e) {
	            var c = document.getElementsByClassName('btns-controls');
	            var x, lenX;
	            for (x = 0, lenX = c.length; x < lenX; x++) {
	                c[x].classList.remove("active");
	            }
	            e.target.classList.add("active");
	            map.setMapTypeId(google.maps.MapTypeId[type]);
	        });
	    };
	    RastreamentoMapaComponent.prototype.toogleMapLayerEvent = function (input, layer, map) {
	        input.addEventListener('click', function (e) {
	            if (!layer.getMap()) {
	                input.classList.add("active");
	                layer.setMap(map);
	            }
	            else {
	                input.classList.remove("active");
	                layer.setMap(null);
	            }
	        });
	    };
	    RastreamentoMapaComponent.prototype.initChart = function () {
	        var u = this.convertHistoricChart();
	        var ctx = document.getElementById("myChart");
	        this.velocityChart = new Chart(ctx, {
	            type: 'line',
	            data: {
	                datasets: [{
	                        fill: true,
	                        lineTension: 0.1,
	                        pointBorderColor: "rgba(76,135,255,0.4)",
	                        pointRadius: 1,
	                        backgroundColor: "rgba(76,135,255,0.4)",
	                        data: u
	                    }]
	            },
	            options: {
	                legend: {
	                    display: false
	                },
	                responsive: false,
	                tooltips: {
	                    callbacks: {
	                        label: function (tooltipItem, data) {
	                            return tooltipItem.yLabel + 'km/h';
	                        }
	                    }
	                },
	                scales: {
	                    yAxes: [{
	                            ticks: {
	                                max: 150,
	                                min: 0,
	                                stepSize: 30,
	                                callback: function (value, index, values) {
	                                    return value + 'km/h';
	                                }
	                            }
	                        }],
	                    xAxes: [{
	                            type: 'time',
	                            position: 'bottom',
	                            time: {
	                                displayFormats: '',
	                                tooltipFormat: moment().format("HH:mm")
	                            },
	                            ticks: {
	                                callback: function (value, index, values) {
	                                    return moment(value).format("HH:mm");
	                                }
	                            }
	                        }]
	                }
	            }
	        });
	    };
	    RastreamentoMapaComponent.prototype.convertHistoricChart = function () {
	        var c = this.historic;
	        //c = [{"dataCriacao":"2017-04-26T11:20:06.426Z","dataUltimaAlteracao":"2017-04-26T11:20:06.426Z","ativo":true,"ip":"179.138.116.144","porta":"61098","imei":"868683027310956","data":"2017-04-26T11:18:24.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:18:20:000","latitude":-22.943928,"longitude":-45.474693,"altitude":null,"kmPorHora":53.671,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57997,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}},{"dataCriacao":"2017-04-26T11:17:41.032Z","dataUltimaAlteracao":"2017-04-26T11:17:41.032Z","ativo":true,"ip":"179.137.252.246","porta":"64168","imei":"868683027310956","data":"2017-04-26T11:17:54.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:17:50:000","latitude":-22.94151,"longitude":-45.472237,"altitude":null,"kmPorHora":41.355,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57991,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}},{"dataCriacao":"2017-04-26T11:17:27.013Z","dataUltimaAlteracao":"2017-04-26T11:17:27.013Z","ativo":true,"ip":"179.137.252.246","porta":"64168","imei":"868683027310956","data":"2017-04-26T11:17:37.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:17:34:000","latitude":-22.939972,"longitude":-45.47172,"altitude":null,"kmPorHora":23.798,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57989,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}},{"dataCriacao":"2017-04-26T11:16:41.158Z","dataUltimaAlteracao":"2017-04-26T11:16:41.158Z","ativo":true,"ip":"179.137.252.246","porta":"64168","imei":"868683027310956","data":"2017-04-26T11:16:54.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:16:50:000","latitude":-22.936867,"longitude":-45.471387,"altitude":null,"kmPorHora":18.038,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57988,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}},{"dataCriacao":"2017-04-26T11:16:11.551Z","dataUltimaAlteracao":"2017-04-26T11:16:11.551Z","ativo":true,"ip":"179.137.252.246","porta":"64168","imei":"868683027310956","data":"2017-04-26T11:16:24.000Z","dataBusca":20170326,"gpsAtivo":true,"gpsSinalCheio":true,"gpsTempo":"11:16:19:000","latitude":-22.934348,"longitude":-45.470982,"altitude":null,"kmPorHora":39.725,"bemId":21,"gpsModeloId":1,"protocolo":"tk300","evento":"rastrear","protocoloEnvio":"udp","id":57986,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null,"gpsModelo":{"dataCriacao":"2017-03-27T12:35:34.581Z","dataUltimaAlteracao":"2017-04-18T11:43:28.713Z","ativo":true,"modelo":"TK303","senha":"123456","numero":"5512981461976","protocolo":"tk300","id":1,"usuarioCriacaoId":null,"usuarioUltimaAlteracaoId":null}}];
	        var time, list = [];
	        c.forEach(function (item) {
	            time = new Date(item.data);
	            list.push({ x: time, y: item.kmPorHora });
	        });
	        return list;
	    };
	    RastreamentoMapaComponent.prototype.getEvents = function (query) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response = this._sortService.sortArray(Response, ['data']);
	                this.events = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom("Não foi possível obter os eventos");
	            }
	            this.loadingEvents = false;
	        }.bind(this));
	        this.loadingEvents = true;
	        this._rastreamentoApiService.onGetByQuery(query, onDone);
	    };
	    RastreamentoMapaComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(828),
	            styles: [__webpack_require__(829)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rastreamento_api_service_1.RastreamentoApiService !== 'undefined' && rastreamento_api_service_1.RastreamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _b) || Object, (typeof (_c = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _c) || Object, (typeof (_d = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object, (typeof (_f = typeof sort_service_1.SortService !== 'undefined' && sort_service_1.SortService) === 'function' && _f) || Object, (typeof (_g = typeof data_service_3.DataService !== 'undefined' && data_service_3.DataService) === 'function' && _g) || Object, (typeof (_h = typeof projeto_service_1.ProjetoService !== 'undefined' && projeto_service_1.ProjetoService) === 'function' && _h) || Object])
	    ], RastreamentoMapaComponent);
	    return RastreamentoMapaComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.RastreamentoMapaComponent = RastreamentoMapaComponent;


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(813);
	var RastreamentoApiService = (function () {
	    function RastreamentoApiService(_restService) {
	        this._restService = _restService;
	    }
	    RastreamentoApiService.prototype.onGetCurrent = function (bemId, done) {
	        this._restService.onGet(data_service_1.apiName + '/bem/' + bemId, done);
	    };
	    RastreamentoApiService.prototype.onGetPeriod = function (query, done) {
	        this._restService.onGetPostCustom(data_service_1.apiName + '/bem/periodo', query, done);
	    };
	    RastreamentoApiService.prototype.onGetAll = function (query, done) {
	        this._restService.onGetPost(data_service_1.apiName, query, done);
	    };
	    //eventos
	    RastreamentoApiService.prototype.onGetByQuery = function (query, done) {
	        this._restService.onGetPostCustom(data_service_1.eventosRastreamentoApiName + '/populado', query, done);
	    };
	    RastreamentoApiService.prototype.onGetAllEvents = function (done) {
	        this._restService.onGetSemSchema(data_service_1.eventosRastreamentoApiName + '/listar-tipos-eventos', done);
	    };
	    RastreamentoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], RastreamentoApiService);
	    return RastreamentoApiService;
	    var _a;
	}());
	exports.RastreamentoApiService = RastreamentoApiService;


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(813);
	var auth_service_1 = __webpack_require__(61);
	var RastreamentoService = (function () {
	    function RastreamentoService(_authService) {
	        this._authService = _authService;
	    }
	    RastreamentoService.prototype.goToSetting = function () {
	        var router = data_service_1.rastreamentosRoute + '/configuracoes';
	        this._authService.navigateTo(router);
	    };
	    RastreamentoService.prototype.goToMap = function () {
	        var router = data_service_1.rastreamentosRoute + '/mapa';
	        this._authService.navigateTo(router);
	    };
	    RastreamentoService.prototype.goToMap2 = function () {
	        var router = data_service_1.rastreamentosRoute + '/mapa2';
	        this._authService.navigateTo(router);
	    };
	    RastreamentoService.prototype.goToVehicles = function () {
	        var router = data_service_1.rastreamentosRoute + '/veiculos';
	        this._authService.navigateTo(router);
	    };
	    RastreamentoService.prototype.goToHistoric = function (bemId) {
	        var router = data_service_1.rastreamentosRoute + '/veiculos';
	        this._authService.navigateTo(router, bemId);
	    };
	    //storage
	    RastreamentoService.prototype.setSessionStorage = function (veiculoObject) {
	        var object = JSON.stringify(veiculoObject);
	        sessionStorage.setItem(data_service_1.rastreamentosStorage + '-rastrear', object);
	    };
	    RastreamentoService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.rastreamentosStorage + "-rastrear");
	        return JSON.parse(item);
	    };
	    RastreamentoService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.rastreamentosStorage + "-rastrear");
	    };
	    RastreamentoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], RastreamentoService);
	    return RastreamentoService;
	    var _a;
	}());
	exports.RastreamentoService = RastreamentoService;


/***/ },
/* 828 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.single}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">Mapa</a></li>\n        </ul>\n    </div>\n</div>\n\n<div id=\"controls-map\">\n    <div class=\"option-container\">\n        <button id=\"btnRoadmap\" class=\"btns-controls\" title=\"Mostrar mapa de ruas\">Mapa</button>\n        <button id=\"btnSatellite\" class=\"btns-controls\" title=\"Mostrar imagens de satélite\">Satélite</button>\n        <button id=\"btnHybrid\" class=\"btns-controls\" title=\"Mostrar imagens de satélite e mapa de ruas\">Híbrido</button>\n    </div>\n    <div class=\"option-container\">\n        <div class=\"input-option\" id=\"trafficLayer\">\n            <span class=\"checkbox\"><div class=\"arrow\"></div></span>\n            <label>Mostrar tráfego</label>\n        </div>\n        <div class=\"input-option\" id=\"transitLayer\">\n            <span class=\"checkbox\"><div class=\"arrow\"></div></span>\n            <label>Mostrar trânsito</label>\n        </div>\n        <div class=\"input-option\" id=\"trail\">\n            <span class=\"checkbox\"><div class=\"arrow\"></div></span>\n            <label>Mostrar rastro do veículo</label>\n        </div>\n    </div>\n</div>\n\n<button id=\"btnToggle\" class=\"controls\"></button>\n\n<div id=\"info-content\" class=\"controls info-content\">\n    <nav class=\"geo-tabs\">\n        <ul class=\"items\">\n            <li class=\"item\">\n                <a (click)=\"setTab('atual')\" [ngClass]=\"{'active': isTab('atual')}\" class=\"item-link\">Atual</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('historico')\" [ngClass]=\"{'active': isTab('historico')}\" class=\"item-link\">Histórico</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('eventos')\" [ngClass]=\"{'active': isTab('eventos')}\" class=\"item-link\">Eventos</a>\n            </li>\n        </ul>\n    </nav>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('atual')\">\n        <div class=\"geo-input--12c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\" *ngIf=\"loadingFrota\">\n            <spinner-component [showDisplay]=\"true\" ></spinner-component>\n        </div>\n\n        <p class=\"lead padding\" *ngIf=\"!frotaList.length && !loadingFrota\">Nenhum veículo cadastrado com GPS</p>\n\n        <table id=\"tableRatreamento\" *ngIf=\"frotaList.length\">\n            <tbody data-collapse *ngFor=\"let item of(frotaList | filter:listFilter.value:['identificacao', 'placa', 'codigoPatrimonio', 'codigo'] | sort:['identificacao'])\" id=\"{{item.id}}\">\n            <tr (click)=\"clickItem(item)\" class=\"{{item.id}}\">\n                <td>\n                    <span class=\"geo-arrow\"></span>\n                    <!--<div class=\"status\"></div>-->\n                    <span *ngIf=\"item.placa\">{{item.placa | licensePlateMask}} / </span> {{item.identificacao}}\n                    <span class=\"date\" *ngIf=\"locationObject.id && (locationObject.bemId === item.id)\">{{locationObject.data | date:'dd/MM/yyyy H:mm:ss'}}</span>\n                </td>\n            </tr>\n            <tr class=\"description {{item.id}}\">\n                <td colspan=\"100%\">\n                    <div class=\"line\">\n                        <strong>Marca:</strong>\n                        <span *ngIf=\"item.modelo\"><span *ngIf=\"item.modelo.marca\"> {{item.modelo.marca.marca}} </span></span>\n                        <span *ngIf=\"!item.modelo || !item.modelo.marca\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <strong>Modelo:</strong>\n                        <span *ngIf=\"item.modelo\"> {{item.modelo.modelo}} </span>\n                        <span *ngIf=\"!item.modelo\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <strong>Placa:</strong>\n                        <span> {{item.placa | licensePlateMask}} </span>\n                        <span *ngIf=\"!item.placa\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <div class=\"status\" [ngClass]=\"{'red':(locationObject.ligado === false), 'green':locationObject.ligado}\"></div>\n                        <strong>Veículo ligado:</strong>\n                        <span *ngIf=\"locationObject.ligado\"> Sim </span>\n                        <span *ngIf=\"locationObject.ligado === false\"> Não </span>\n                        <span *ngIf=\"locationObject.ligado === null\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <strong>GPS ativo:</strong>\n                        <span *ngIf=\"locationObject.gpsAtivo\"> Sim </span>\n                        <span *ngIf=\"locationObject.gpsAtivo === false\"> Não </span>\n                        <span *ngIf=\"locationObject.gpsAtivo === null\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('historico')\">\n        <autocomplete-component id=\"frota\"\n                                (setObejct)=\"getFrotasObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"frotaObject\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [apiCustom]=\"frotaApi\"\n                                [query]=\"frotaQuery\"\n                                [placeholder]=\"'Veículo'\"\n                                [label]=\"''\"></autocomplete-component>\n\n        <div class=\"date-content\">\n            <input type=\"text\" class=\"input-datepicker\" id=\"date\" autocomplete=\"off\" placeholder=\"Data\" />\n\n            <select id=\"time-end\" [(ngModel)]=\"timeEnd\" (ngModelChange)=\"changeEndTime()\">\n                <option *ngFor=\"let item of timeListEnd\" [ngValue]=\"item\">{{item.Value}}</option>\n            </select>\n\n            <select id=\"time-start\" [(ngModel)]=\"timeStart\" (ngModelChange)=\"changeStartTime()\">\n                <option *ngFor=\"let item of timeListStart\" [ngValue]=\"item\">{{item.Value}}</option>\n            </select>\n\n            <div class=\"distanceContainer\">\n                <label for=\"distance\">Distância entre pontos</label>\n                <select id=\"distance\" [(ngModel)]=\"distance\">\n                    <option *ngFor=\"let item of distanceList\" [ngValue]=\"item\">{{item.Value}}</option>\n                </select>\n            </div>\n\n            <div class=\"clear\"></div>\n            <button type=\"button\" class=\"geo-button button-remove-margin-left\" (click)=\"clickBuscarHistorico()\">Buscar</button>\n            <br/>\n            <a class=\"cursor-pointer link-button\" (click)=\"clickShowChart()\" *ngIf=\"historic.length\">\n                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-chart'/></svg>\n                <span>Velocidade</span>\n            </a>\n\n            <hr>\n            <div *ngIf=\"loadingHistoric\">\n                <spinner-component [showDisplay]=\"true\" ></spinner-component>\n            </div>\n            <div *ngIf=\"msg\">\n                <p >{{msg}}</p>\n            </div>\n            <div class=\"clear\"></div>\n\n            <ul class=\"historic\">\n                <li *ngFor=\"let item of (historic | sort:['data'])\">\n                    <div class=\"flex\">\n                        <div class=\"icon\">\n                            <div class=\"circle\">\n                                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-arrow-down'/></svg>\n                            </div>\n                        </div>\n                        <div class=\"plus\">\n                            {{item.data | date: 'H:mm:ss'}} <span class=\"right\">{{item.data | date: 'dd/MM/yyyy'}}</span>\n                            <p>lat: {{item.latitude}} / lng: {{item.longitude}}</p>\n                            <p>{{item.kmPorHora}} km/h</p>\n                            <p>Evento:\n                                <span *ngIf=\"item.evento === 'rastrear'\">Rastreamento</span>\n                                <span *ngIf=\"item.evento === 'ligar'\" class=\"color-green\"> Veículo ligado</span>\n                                <span *ngIf=\"item.evento === 'desligar'\" class=\"color-red\"> Veículo desligado</span>\n                            </p>\n                            <p>Ângulo:\n                                <span *ngIf=\"item.angulo\">{{item.angulo}}°</span>\n                                <span *ngIf=\"!item.angulo\">-</span>\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"line\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('eventos')\">\n        <autocomplete-component id=\"frota2\"\n                                (setObejct)=\"getFrotasObject($event)\"\n                                (clearObject)=\"getFrotasObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId+'2'\"\n                                [model]=\"frotaObject\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [apiCustom]=\"frotaApi\"\n                                [query]=\"frotaQuery\"\n                                [clear]=\"true\"\n                                [placeholder]=\"'— Todos os veículos —'\"\n                                [label]=\"''\"></autocomplete-component>\n\n        <div class=\"date-content\">\n            <select id=\"select_events\" [(ngModel)]=\"eventSelected\">\n                <option *ngFor=\"let item of eventsList\" [ngValue]=\"item\">{{item.titulo}}</option>\n            </select>\n\n            <input type=\"text\" class=\"input-datepicker\" id=\"date2\" autocomplete=\"off\" placeholder=\"Data\" />\n\n            <div class=\"clear\"></div>\n            <button type=\"button\" class=\"geo-button button-remove-margin-left\" (click)=\"clickBuscarEventos()\">Buscar</button>\n            <hr>\n        </div>\n\n        <div class=\"geo-input--12c\" *ngIf=\"loadingEvents\">\n            <spinner-component [showDisplay]=\"true\" ></spinner-component>\n        </div>\n\n        <p class=\"lead padding\" *ngIf=\"!events.length && !loadingEvents\">Nenhum evento encontrado</p>\n\n        <ul class=\"events\">\n            <li *ngFor=\"let item of (events | sort:['data'])\">\n                <div class=\"flex\">\n                    <div class=\"icon\">\n                        <div class=\"circle\">\n                            <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-arrow-down'/></svg>\n                        </div>\n                    </div>\n                    <div class=\"plus\">\n                        {{item.data | date: 'H:mm:ss'}} <span class=\"right\">{{item.data | date: 'dd/MM/yyyy'}}</span>\n                        <p>\n                            <span *ngIf=\"item.bem\"> <span *ngIf=\"item.bem.placa\">{{item.bem.placa | licensePlateMask}} / </span> {{item.bem.identificacao}}</span>\n                            <span *ngIf=\"!item.bem\">-</span>\n                        </p>\n                        <p>Evento:\n                            <span *ngIf=\"item.evento\">{{item.evento.titulo}}</span>\n                            <span *ngIf=\"!item.evento\">-</span>\n                        </p>\n                        <p *ngIf=\"item.cercaProjeto\">Cerca:\n                            <span *ngIf=\"item.cercaProjeto\">{{item.cercaProjeto.nome}}</span>\n                            <span *ngIf=\"!item.cercaProjeto\">-</span>\n                        </p>\n                    </div>\n                </div>\n                <div class=\"line\"></div>\n            </li>\n        </ul>\n    </div>\n</div>\n\n<div id=\"velocity-chart\" class=\"controls\">\n    <p class=\"title\">\n        <a (click)=\"clickHideChart()\">\n            <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-close'/></svg>\n        </a>\n        <span>Gráfico de velocidade - {{dateString}} das {{timeStart.Value}} às {{timeEnd.Value}}</span>\n    </p>\n    <canvas id=\"myChart\" width=\"2000\" height=\"180\"></canvas>\n</div>\n\n<div id=\"map-container\">\n    <div id=\"map\"></div>\n</div>\n";

/***/ },
/* 829 */
/***/ function(module, exports) {

	module.exports = "#map-container {\n    position: relative;\n    margin: 12px 0;\n    height: calc(100vh - 6.5em - 64px);\n}\n\n#map {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n#controls-map .option-container {\n    margin-top: 10px;\n    margin-left: 10px;\n    background-color: #fff;\n    border-radius: 2px;\n    box-shadow: rgba(0, 0, 0, 0.298039) 0 1px 4px -1px;\n    display: inline-block;\n    overflow: hidden;\n    text-align: center;\n    position: relative;\n    font-family: Roboto, Arial, sans-serif;\n    font-size: 11px;\n    color: rgb(86, 86, 86);\n}\n#controls-map .option-container .btns-controls,\n#controls-map .option-container .input-option {\n    padding: 8px;\n    min-width: 27px;\n    border-right: 1px solid #f3eded;\n}\n#controls-map .option-container .btns-controls {\n    direction: ltr;\n    overflow: hidden;\n    background-color: transparent;\n    outline: none;\n    border: none;\n}\n#controls-map .option-container .btns-controls:last-child {\n    border-right: none;\n}\n#controls-map .option-container .input-option {\n    display: inline-block;\n}\n#controls-map .option-container .input-option span.checkbox {\n    box-sizing: border-box;\n    position: relative;\n    line-height: 0;\n    font-size: 0;\n    margin: -1px 5px 0 0;\n    display: inline-block;\n    background-color: rgb(255, 255, 255);\n    border: 1px solid rgb(198, 198, 198);\n    border-radius: 1px;\n    width: 13px;\n    height: 13px;\n    vertical-align: middle;\n}\n#controls-map .option-container .input-option.active span.checkbox .arrow {\n    display: none;\n}\n#controls-map .option-container .input-option.active span.checkbox .arrow {\n    position: absolute;\n    left: 4px;\n    top: -5px;\n    width: 5px;\n    height: 12px;\n    border: solid rgb(116, 116, 116);\n    border-width: 0 2px 2px 0;\n    transform: rotate(40deg);\n    display: block;\n}\n#controls-map .option-container .btns-controls.active,\n#controls-map .option-container .input-option.active label {\n    font-weight: 500;\n    color: rgb(0, 0, 0);\n}\n\n.controls {\n    border: 1px solid transparent;\n    border-radius: 2px;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    outline: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n    background-color: #fff;\n}\n\n.info-content {\n    margin-top: 10px;\n    margin-right: 10px;\n    width: 300px;\n    max-height: calc(100% - 30px);\n    padding: 8px;\n    overflow: auto;\n    overflow-x: hidden;\n}\n.info-content .status {\n    width: 12px;\n    height: 12px;\n    float: left;\n    background-color: grey;\n    border-radius: 50%;\n    box-shadow: 1px 1px 2px #bbbaba;\n    margin-right: 8px;\n    margin-top: 2px;\n}\n.info-content .status.red {\n    background-color: #f23147;\n}\n.info-content .status.green {\n    background-color: #268d19;\n}\n\n.color-red {\n    color: #f23147;\n}\n.color-green {\n    color: #268d19;\n}\n\n.info-content .geo-arrow {\n    float: right;\n    text-align: right;\n    margin: 0;\n    padding: 0;\n    width: 8px;\n}\n.info-content .geo-input--search {\n    width: 100%;\n    margin-bottom: 0;\n}\n.info-content table {\n    /*margin-top: 0;*/\n    font-size: 14px;\n}\n.info-content .date {\n    display: block;\n    margin-top: 2px;\n    color: #9a9a9a;\n    font-size: 12px;\n}\n.info-content .description td {\n    padding: 4px 8px;\n}\n.info-content .description td div.line {\n    border-bottom: 1px solid #eee;\n    margin: 0;\n    padding: 8px 0;\n}\n.info-content .description td div.line span {\n    float: right;\n}\ndiv.clear {\n    clear: both;\n}\n.info-content tr.geo-arrow--down {\n    border-left: 3px solid #4c87ff;\n}\n\n#btnToggle {\n    margin-top: 10px;\n    margin-right: -3px;\n    height: 44px;\n    width: 40px;\n    box-shadow: -1px 2px 2px rgba(0, 0, 0, 0.3);\n}\n#btnToggle:after {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iXzAxXy1fY2FtcG9fZGVfYnVzY2FfbWVudV9jbG9zZSIgZGF0YS1uYW1lPSIwMSAtIGNhbXBvIGRlIGJ1c2NhIG1lbnUgY2xvc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE0IDE0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6Izc0NzQ3NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24tcGVzcXVpc2EtYmFyPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNTk5LjA2LDg2LjhoLTAuNjNsLTAuMjItLjIyYTUuMiw1LjIsMCwxLDAtLjU2LjU2bDAuMjEsMC4yMlY4OGw0LDQsMS4xOS0xLjE5Wm0tNC44LDBhMy42LDMuNiwwLDEsMSwzLjYtMy42QTMuNiwzLjYsMCwwLDEsMTU5NC4yNiw4Ni44WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1ODkuMDYgLTc4KSIvPjwvc3ZnPg==);\n    margin-top: -8px;\n    top: 50%;\n    right: 10px;\n    width: 16px;\n    height: 16px;\n}\n\n.date-content {\n    margin-top: 10px;\n}\n.date-content input,\n.date-content select {\n    height: 32px;\n    min-width: 60px;\n    outline: none;\n    border: 2px solid #edf0f4;\n}\n\n.date-content select#time-start,\n.date-content select#time-end {\n    margin-right: 0;\n    float: right;\n}\n.date-content select#select_events {\n    width:100%;\n    margin-bottom: 10px;\n}\n.date-content input#date,\n.date-content input#date2 {\n    padding-left: 8px;\n    margin-right: 10px;\n    height: 26px;\n}\n.date-content .geo-button {\n    font-size: 14px;\n    margin-top: 10px;\n}\n\n.date-content .distanceContainer {\n    margin-top: 8px;\n}\n.date-content .distanceContainer label {\n    color: #747474;\n    position: relative;\n    top: 10px;\n    left: 2px;\n}\n.date-content .distanceContainer select {\n    float: right;\n    width: 120px;\n}\n\nhr {\n    border: none;\n    border-bottom: 1px solid #ddd;\n}\n\n.flex {\n    display: flex;\n}\n.flex .plus {\n    flex: 1;\n}\n\nul.historic,\nul.events {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\nul.historic li,\nul.events li {\n    border-bottom: 1px solid #ddd;\n    padding: 8px 0;\n    position: relative;\n}\nul.historic .icon .circle,\nul.events .icon .circle {\n    border-radius: 50%;\n    border: 1px solid #777;\n    background-color: #fff;\n    width: 20px;\n    height: 20px;\n    margin: 0 12px;\n    text-align: center;\n}\nul.historic .icon .circle svg,\nul.events .icon .circle svg {\n    width: 16px;\n    height: 16px;\n    fill: #151617;\n    position: relative;\n    top: 2px;\n}\nul.historic li .line,\nul.events li .line {\n    width: 2px;\n    height: 85px;\n    position: absolute;\n    left: 22px;\n    top: 13px;\n    z-index: -1;\n    border-left: 2px dashed #4c87ff;\n}\nul.historic .plus p,\nul.events .plus p {\n    color: #747474;\n    display: block;\n    margin: 2px 0;\n}\nul.historic .plus span.right,\nul.events .plus span.right {\n    color: #747474;\n    float: right;\n}\n\n#velocity-chart {\n    width: calc(100% - 20px);\n    height: 270px;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 0 0 0 8px;\n    overflow: auto;\n    overflow-x: auto;\n    display: none;\n}\n\n.link-button {\n    display: inline-block;\n    padding: 6px 6px 0;\n    background-color: #FFF;\n    color: #BCC0C7;\n    border: 1px solid #BCC0C7;\n}\n.link-button span {\n    position: relative;\n    top: -6px;\n}\n.link-button svg {\n    width: 16px;\n    height: 16px;\n    fill: #9d9fa2;\n    position: relative;\n    top: -2px;\n}\n.title {\n    margin-bottom: 16px;\n    margin-left: 6px;\n}\n.title span {\n    position: relative;\n    font-size: 1rem;\n    top: -6px;\n    left: 8px;\n}"

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(813);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var rastreamento_service_1 = __webpack_require__(827);
	var data_service_2 = __webpack_require__(154);
	var util_service_1 = __webpack_require__(88);
	var filter_service_1 = __webpack_require__(94);
	var autocomplete_service_1 = __webpack_require__(101);
	var RastreamentoVeiculosComponent = (function () {
	    function RastreamentoVeiculosComponent(_frotaApiService, _frotaService, _rastreamentoService, _utilService, _filterService, _autocompleteService) {
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._rastreamentoService = _rastreamentoService;
	        this._utilService = _utilService;
	        this._filterService = _filterService;
	        this._autocompleteService = _autocompleteService;
	        this.list = [];
	        this.loading = true;
	        this.module = data_service_1.rastreamentosModuleName;
	        this.frotaSelectId = 'frota';
	        this.frotaQuery = {};
	        this.frotaSearch = {};
	        this.statusSearch = {};
	        this.statusList = [];
	        this.cloneList = [];
	        this.frotaTemplateResult = (function (state) {
	            return this._frotaService.templateResult(state, false);
	        }.bind(this));
	    }
	    RastreamentoVeiculosComponent.prototype.ngOnInit = function () {
	        this.frotaQuery = this._utilService.cloneObject(data_service_2.frotasQuery);
	        this.frotaQuery.where.and.push({ gpsImei: { neq: null } });
	        this.frotaQuery.where.and.push({ gpsModeloId: { neq: null } });
	        this.statusList = [
	            { Key: null, Value: '— Status —' },
	            { Key: 1, Value: 'Ligado' },
	            { Key: 2, Value: 'Desligado' },
	            { Key: 3, Value: 'Não informado' }
	        ];
	        this.clickClearSearch();
	        this.getAll();
	    };
	    RastreamentoVeiculosComponent.prototype.clickGoLog = function (item) {
	        this._rastreamentoService.goToHistoric(item.id);
	    };
	    RastreamentoVeiculosComponent.prototype.clickGoRastreamento = function (item) {
	        this._rastreamentoService.setSessionStorage(item);
	        this._rastreamentoService.goToMap();
	    };
	    RastreamentoVeiculosComponent.prototype.clickClearSearch = function () {
	        this.frotaSearch = {};
	        this.statusSearch = this.statusList[0];
	        this._autocompleteService.setValueOnSelect2(null, "frota");
	        this.onFilter();
	    };
	    RastreamentoVeiculosComponent.prototype.getFrotasObject = function (object) {
	        this.frotaSearch = object;
	        this.onFilter();
	    };
	    RastreamentoVeiculosComponent.prototype.changeStatus = function () {
	        this.onFilter();
	    };
	    RastreamentoVeiculosComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.forEach(function (item) {
	                    if (item.Imagens.length) {
	                        item.imageUrl = item.Imagens[0].url;
	                    }
	                });
	                this.list = Response;
	                this.cloneList = this._utilService.cloneObject(Response);
	            }
	            this.loading = false;
	        }.bind(this));
	        var cat = this._frotaService.getTipoVeiculo();
	        var query = this._utilService.cloneObject(data_service_2.frotasQueryComGPS);
	        query.where.ativo = true;
	        this._frotaApiService.onGetAllRastreamento(cat, query, onDone);
	    };
	    RastreamentoVeiculosComponent.prototype.onFilter = function () {
	        var l = this.cloneList;
	        if (this.frotaSearch.id) {
	            l = this._filterService.filterArray(l, this.frotaSearch.id, ["id"]);
	        }
	        if (this.statusSearch.Key) {
	            var x = void 0, lenX = void 0, list = [];
	            for (x = 0, lenX = l.length; x < lenX; x++) {
	                if (this.statusSearch.Key === 1) {
	                    if (l[x].Rastreamento) {
	                        if (l[x].Rastreamento.ligado) {
	                            list.push(l[x]);
	                        }
	                    }
	                }
	                else if (this.statusSearch.Key === 2) {
	                    if (l[x].Rastreamento) {
	                        if (!l[x].Rastreamento.ligado) {
	                            list.push(l[x]);
	                        }
	                    }
	                }
	                else if (this.statusSearch.Key === 3) {
	                    if (!l[x].Rastreamento) {
	                        list.push(l[x]);
	                    }
	                }
	            }
	            l = list;
	        }
	        this.list = l;
	    };
	    RastreamentoVeiculosComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(831),
	            styles: [__webpack_require__(832)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _a) || Object, (typeof (_b = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _b) || Object, (typeof (_c = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof filter_service_1.FilterService !== 'undefined' && filter_service_1.FilterService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object])
	    ], RastreamentoVeiculosComponent);
	    return RastreamentoVeiculosComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.RastreamentoVeiculosComponent = RastreamentoVeiculosComponent;


/***/ },
/* 831 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">Veículos</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>Veículos</h1>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <autocomplete-component class=\"geo-input--12c\" id=\"frota\"\n                                (setObejct)=\"getFrotasObject($event)\"\n                                (clearObject)=\"getFrotasObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"frotaSearch\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [placeholder]=\"'— Veículo —'\"\n                                [query]=\"frotaQuery\"\n                                [clear]=\"true\"\n                                [label]=\"\"></autocomplete-component>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--12c\">\n            <div>\n                <select id=\"status\" [(ngModel)]=\"statusSearch\" (ngModelChange)=\"changeStatus()\" class=\"option_{{statusSearch.Key}}\">\n                    <option *ngFor=\"let item of statusList\" id=\"status_{{item.Key}}\" [ngValue]=\"item\" class=\"option_{{item.Key}}\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--12c geo-columns--right\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickClearSearch()\" class=\"cursor-pointer clear-search\">Limpar filtro</a>\n        </p>\n    </div>\n\n    <div class=\"geo-columns--12c\">\n        <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n        <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum veículo cadastrado com GPS</p>\n    </div>\n\n    <div class=\"geo-columns--3c\" *ngFor=\"let item of (list | sort:['identificacao'])\">\n        <div class=\"geo-card\"> <div class=\"geo-card__title\">\n            <div class=\"flex\">\n                <div class=\"image-container\">\n                    <img [src]=\"item.imageUrl\" *ngIf=\"item.imageUrl\">\n                    <div class=\"img-svg\" *ngIf=\"!item.imageUrl\">\n                        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-car'/></svg>\n                    </div>\n                </div>\n                <div>\n                    <a>{{item.identificacao}}</a>\n                </div>\n            </div>\n            <span class=\"status\" *ngIf=\"item.Rastreamento\" [ngClass]=\"{'red': !item.Rastreamento.ligado, 'green': item.Rastreamento.ligado}\"></span>\n        </div>\n            <div class=\"geo-card__content\">\n                <div>\n                    <button type=\"button\" class=\"geo-button geo-button--error\" (click)=\"clickGoRastreamento(item)\">Rastrear</button>\n                    <button type=\"button\" class=\"geo-button\" (click)=\"clickGoLog(item)\">Log</button>\n                </div>\n\n                <div *ngIf=\"!item.Rastreamento\">\n                    <p>Não foi possível obter a localidade do veículo</p>\n                </div>\n                <div *ngIf=\"item.Rastreamento\">\n                    <p>\n                        <strong>Último registro: </strong>\n                        <span>{{item.Rastreamento.data | date:'dd/MM/yyyy H:mm:ss'}}</span>\n                        <span *ngIf=\"!item.Rastreamento.data\"> - </span>\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 832 */
/***/ function(module, exports) {

	module.exports = ".image-container {\n    background-color: #f8fafb;\n    border: 1px solid #edf0f4;\n    max-width: 100px;\n}\n.image-container .img-svg {\n    padding: 8px;\n}\n.image-container svg {\n    width: 50px;\n    height: 50px;\n}\n.image-container img {\n    width: 100px;\n}\n\n.flex {\n    display: flex;\n}\n.flex div:last-child {\n    flex: 1;\n    padding: 8px;\n}\n\n.geo-card__title .status {\n    width: 16px;\n    height: 16px;\n    float: left;\n    background-color: grey;\n    border-radius: 50%;\n    box-shadow: 1px 1px 2px #bbbaba;\n}\n.red {\n    background-color: #f23147;\n}\n.green {\n    background-color: #268d19;\n}\n\n.geo-button {\n    min-width: 100px;\n    margin-bottom: 12px;\n}\n\n.geo-card {\n    margin-left: 0;\n}\n\n.advanced-search {\n    border-bottom: 1px solid #edf0f4;\n    margin: -0.5em 1.5em 1em 0;\n    padding-bottom: 1em;\n}"

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var data_service_1 = __webpack_require__(813);
	var frota_api_service_1 = __webpack_require__(368);
	var rastreamento_service_1 = __webpack_require__(827);
	var rastreamento_api_service_1 = __webpack_require__(826);
	var util_service_1 = __webpack_require__(88);
	var export_csv_service_1 = __webpack_require__(142);
	var RastreamentoHistoricoComponent = (function () {
	    function RastreamentoHistoricoComponent(_frotaApiService, _rastreamentoService, _rastreamentoApiService, _utilService, _exportService, _route) {
	        this._frotaApiService = _frotaApiService;
	        this._rastreamentoService = _rastreamentoService;
	        this._rastreamentoApiService = _rastreamentoApiService;
	        this._utilService = _utilService;
	        this._exportService = _exportService;
	        this._route = _route;
	        this.list = [];
	        this.loading = true;
	        this.loadingBem = true;
	        this.module = data_service_1.rastreamentosModuleName;
	        this.detail = {};
	        this.timeListStart = [];
	        this.timeListEnd = [];
	        this.page = 0;
	        this.limit = 100;
	    }
	    RastreamentoHistoricoComponent.prototype.ngOnInit = function () {
	        this.timeListStart = this._utilService.cloneObject(data_service_1.time);
	        this.timeListEnd = this._utilService.cloneObject(data_service_1.time);
	        this.bemId = +this._route.snapshot.params['id'];
	        this.getBem();
	    };
	    RastreamentoHistoricoComponent.prototype.ngAfterViewInit = function () {
	        this._utilService.disabledFutureDates('data_final');
	        this._utilService.disabledFutureDates('data_inicial');
	        this.dataInicial = this._utilService.convertDateToString(new Date());
	        this.dataFinal = this._utilService.convertDateToString(new Date());
	        this.timeStart = this.timeListStart[0];
	        this.timeEnd = this.timeListEnd[this.timeListStart.length - 1];
	        setTimeout(function () {
	            this.clickSearch();
	        }.bind(this));
	    };
	    RastreamentoHistoricoComponent.prototype.clickGoToList = function () {
	        this._rastreamentoService.goToVehicles();
	    };
	    RastreamentoHistoricoComponent.prototype.changeStartTime = function () {
	    };
	    RastreamentoHistoricoComponent.prototype.changeEndTime = function () {
	    };
	    RastreamentoHistoricoComponent.prototype.clickNext = function () {
	        this.page += 1;
	        this.clickSearch();
	    };
	    RastreamentoHistoricoComponent.prototype.clickPrevious = function () {
	        this.page -= 1;
	        this.clickSearch();
	    };
	    RastreamentoHistoricoComponent.prototype.clickSearch = function () {
	        var queryWhere = this.getDateTime();
	        this.getLog(queryWhere);
	    };
	    RastreamentoHistoricoComponent.prototype.clickExport = function () {
	        var queryWhere = this.getDateTime();
	        this.getLogExport(queryWhere);
	    };
	    RastreamentoHistoricoComponent.prototype.getBem = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.detail = Response;
	                this.loadingBem = false;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum veículo encontrado com este id.');
	                this.clickGoToList();
	            }
	        }.bind(this));
	        this._frotaApiService.onGetById(this.bemId, onDone);
	    };
	    RastreamentoHistoricoComponent.prototype.getDateTime = function () {
	        if (!this.timeStart || !this.timeEnd || !this.dataFinal || !this.dataInicial) {
	            return false;
	        }
	        var dateStart = document.getElementById('data_inicial');
	        if (dateStart.value) {
	            dateStart = dateStart.value;
	        }
	        var dateEnd = document.getElementById('data_final');
	        if (dateEnd.value) {
	            dateEnd = dateEnd.value;
	        }
	        var timeStart = this.timeStart;
	        if (timeStart) {
	            timeStart = ((timeStart.Key < 10) ? '0' + timeStart.Key.toString() : timeStart.Key.toString()).concat(":00");
	        }
	        var timeEnd = this.timeEnd;
	        if (timeEnd) {
	            timeEnd = ((timeEnd.Key < 10) ? '0' + timeEnd.Key.toString() : timeEnd.Key.toString()).concat(":00");
	        }
	        var start = this._utilService.convertStringToDateTime(dateStart, timeStart);
	        var end = this._utilService.convertStringToDateTime(dateEnd, timeEnd);
	        var queryWhere = [];
	        if (start instanceof Date) {
	            queryWhere.push({ data: { 'gte': start } });
	        }
	        if (end instanceof Date) {
	            queryWhere.push({ data: { 'lte': end } });
	        }
	        return queryWhere;
	    };
	    RastreamentoHistoricoComponent.prototype.getLog = function (queryWhere) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.forEach(function (item) {
	                    if (item.kmPorHora) {
	                        item.kmPorHora = item.kmPorHora.toFixed(2);
	                    }
	                });
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        var query = {
	            order: "data DESC",
	            include: ["gpsModelo"],
	            limit: this.limit,
	            skip: this.page,
	            where: {
	                bemId: this.bemId,
	                ativo: true
	            }
	        };
	        query.where.and = queryWhere;
	        this.loading = true;
	        this._rastreamentoApiService.onGetAll(query, onDone);
	    };
	    RastreamentoHistoricoComponent.prototype.getLogExport = function (queryWhere) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.forEach(function (item) {
	                    if (item.kmPorHora) {
	                        item.kmPorHora = item.kmPorHora.toFixed(2);
	                    }
	                });
	                this._exportService.JsonToCsvConvertor(Response, 'GeosiapFrotas_log_rastreamento', true);
	            }
	            this.loading = false;
	        }.bind(this));
	        var query = {
	            order: "data DESC",
	            where: {
	                bemId: this.bemId,
	                ativo: true
	            }
	        };
	        query.where.and = queryWhere;
	        this.loading = true;
	        this._rastreamentoApiService.onGetAll(query, onDone);
	    };
	    RastreamentoHistoricoComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(834),
	            styles: [__webpack_require__(835)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _a) || Object, (typeof (_b = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _b) || Object, (typeof (_c = typeof rastreamento_api_service_1.RastreamentoApiService !== 'undefined' && rastreamento_api_service_1.RastreamentoApiService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof export_csv_service_1.ExportCsvService !== 'undefined' && export_csv_service_1.ExportCsvService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object])
	    ], RastreamentoHistoricoComponent);
	    return RastreamentoHistoricoComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.RastreamentoHistoricoComponent = RastreamentoHistoricoComponent;


/***/ },
/* 834 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">Veículos</a></li>\n            <li class=\"item\"><a class=\"active\">Log</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--12c\">\n        <h1>Log - {{detail.identificacao}}</h1>\n        <div *ngIf=\"!loadingBem\">\n            <p>\n                <strong>Modelo: </strong>\n                <span *ngIf=\"detail.modelo\">{{detail.modelo.modelo}}\n                <span *ngIf=\"detail.modelo.marca\"> / {{detail.modelo.marca.marca}}</span>\n                <span *ngIf=\"detail.modelo.tipo\"> / {{detail.modelo.tipo.tipo}}</span>\n            </span>\n                <i *ngIf=\"!detail.modelo\">não cadastrado</i>\n            </p>\n            <p *ngIf=\"thisRoute === veiculosRoute\">\n                <strong>Placa: </strong>\n                <span *ngIf=\"detail.placa\">{{detail.placa | licensePlateMask}}</span>\n                <i *ngIf=\"!detail.placa\">não cadastrado</i>\n            </p>\n            <p *ngIf=\"thisRoute === equipamentosRoute\">\n                <strong>Registro: </strong>\n                <span *ngIf=\"detail.codigo\">{{detail.codigo}}</span>\n                <i *ngIf=\"!detail.codigo\">não cadastrado</i>\n            </p>\n            <p *ngIf=\"thisRoute !== veiculosRoute && thisRoute !== equipamentosRoute\">\n                <strong>Cód. do patrimônio: </strong>\n                <span *ngIf=\"detail.codigoPatrimonio\">{{detail.codigoPatrimonio}}</span>\n                <i *ngIf=\"!detail.codigoPatrimonio\">não cadastrado</i>\n            </p>\n        </div>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--6c geo-input--datepicker\">\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"data_inicial\" placeholder=\"Data inicial\" [(ngModel)]=\"dataInicial\" appDatepicker autocomplete=\"off\"  />\n            </div>\n        </div>\n\n        <div class=\"geo-input--6c\">\n            <div>\n                <select id=\"time-start\" [(ngModel)]=\"timeStart\" (ngModelChange)=\"changeStartTime()\">\n                    <option *ngFor=\"let item of timeListStart\" [ngValue]=\"item\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <div class=\"geo-input--6c geo-input--datepicker\">\n            <div>\n                <input type=\"text\" class=\"input-datepicker\" id=\"data_final\" placeholder=\"Data final\" [(ngModel)]=\"dataFinal\" appDatepicker autocomplete=\"off\" />\n            </div>\n        </div>\n\n        <div class=\"geo-input--6c\">\n            <div>\n                <select id=\"time-end\" [(ngModel)]=\"timeEnd\" (ngModelChange)=\"changeEndTime()\">\n                    <option *ngFor=\"let item of timeListEnd\" [ngValue]=\"item\">{{item.Value}}</option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <button type=\"button\" class=\"geo-button\" (click)=\"clickSearch()\">Buscar</button>\n        <button type=\"button\" class=\"geo-button geo-button--action\" (click)=\"clickExport()\">Exportar</button>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <div class=\"geo-columns--12c\">\n        <p class=\"advanced-search\">\n            <a (click)=\"clickPrevious()\" class=\"cursor-pointer geo-button\" *ngIf=\"list.length && page > 0\">Anterior</a>\n            <a (click)=\"clickNext()\" class=\"cursor-pointer geo-button\" *ngIf=\"list.length === limit\">Próximo</a>\n        </p>\n    </div>\n\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum registro encontrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Data</th>\n            <th>Hora</th>\n            <th>Evento</th>\n            <th>Latitude</th>\n            <th>Longitude</th>\n            <th>Velocidade</th>\n        </tr>\n        </thead>\n        <tbody *ngIf=\"!list || list.length === 0\">\n        <tr>\n            <td colspan=\"5\">Nenhum {{modeloModule.single | lowercase}} cadastrado</td>\n        </tr>\n        </tbody>\n        <tbody data-collapse *ngFor=\"let item of(list | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span> {{item.data | date:'dd/MM/yyyy'}}</td>\n            <td>{{item.data | date:'H:mm:ss'}}</td>\n            <td>\n                <span *ngIf=\"item.evento === 'ligar'\" > Veículo ligado</span>\n                <span *ngIf=\"item.evento === 'desligar'\"> Veículo desligado</span>\n                <span *ngIf=\"item.evento === 'rastrear'\"> Rastreamento</span>\n            </td>\n            <td>{{item.latitude}}</td>\n            <td>{{item.longitude}}</td>\n            <td>{{item.kmPorHora}} km/h</td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div class=\"geo-content__row\" >\n                    <div class=\"geo-columns--3c\" >\n                        <p><strong>Data/hora: </strong>\n                            {{item.data | date: 'dd/MM/yyyy HH:mm:ss'}}\n                            <i *ngIf=\"!item.data\"> - </i>\n                        </p>\n                        <p><strong>Latitude/Longitude: </strong>\n                            {{item.latitude}} <i *ngIf=\"!item.latitude\"> - </i> / {{item.longitude}} <i *ngIf=\"!item.longitude\"> - </i>\n                        </p>\n                        <p><strong>Velocidade: </strong>\n                            {{item.kmPorHora}} <i *ngIf=\"!item.kmPorHora && (item.kmPorHora !== 0)\"> - </i> km\n                        </p>\n                    </div>\n                    <div class=\"geo-columns--3c\" >\n                        <p><strong>GPS ativo: </strong>\n                            <span *ngIf=\"item.gpsAtivo\">Sim</span>\n                            <span *ngIf=\"item.gpsAtivo === false\"> Não </span>\n                            <span *ngIf=\"item.gpsAtivo === null\"> - </span>\n                        </p>\n                        <p><strong>GPS sinal cheio: </strong>\n                            <span *ngIf=\"item.gpsSinalCheio\">Sim</span>\n                            <span *ngIf=\"item.gpsSinalCheio === false\">Não</span>\n                            <span *ngIf=\"item.gpsSinalCheio === null\"> - </span>\n                        </p>\n                        <p><strong>Modelo GPS: </strong>\n                            <span *ngIf=\"item.gpsModelo\">{{item.gpsModelo.modelo}}</span>\n                            <span *ngIf=\"!item.gpsModelo\"> - </span>\n                        </p>\n                        <p><strong>IMEI: </strong>\n                            {{item.imei}}\n                            <i *ngIf=\"!item.imei\"> - </i>\n                        </p>\n                    </div>\n                    <div class=\"geo-columns--3c\" >\n                        <p><strong>Altitude: </strong>\n                            {{item.altitude}}\n                            <i *ngIf=\"!item.altitude\"> - </i>\n                        </p>\n                        <p><strong>Ângulo: </strong>\n                            {{item.angulo}}\n                            <i *ngIf=\"!item.angulo\"> - </i>\n                        </p>\n                    </div>\n                    <div class=\"geo-columns--3c\" >\n                        <p><strong>IP: </strong>\n                            {{item.ip}}\n                            <i *ngIf=\"!item.ip\"> - </i>\n                        </p>\n                        <p><strong>Porta: </strong>\n                            {{item.porta}}\n                            <i *ngIf=\"!item.porta\"> - </i>\n                        </p>\n                        <p><strong>Protocolo: </strong>\n                            {{item.protocolo}}\n                            <i *ngIf=\"!item.protocolo\"> - </i>\n                        </p>\n                        <p><strong>Protocolo de envio: </strong>\n                            {{item.protocoloEnvio}}\n                            <i *ngIf=\"!item.protocoloEnvio\"> - </i>\n                        </p>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 835 */
/***/ function(module, exports) {

	module.exports = ".advanced-search {\n    border-top: 1px solid #edf0f4;\n    margin: -1em 1.5em 0.4em 0;\n    padding-top: 1em;\n}"

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ModelosGpsComponent = (function () {
	    function ModelosGpsComponent() {
	    }
	    ModelosGpsComponent.prototype.ngOnInit = function () {
	    };
	    ModelosGpsComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(837)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ModelosGpsComponent);
	    return ModelosGpsComponent;
	}());
	exports.ModelosGpsComponent = ModelosGpsComponent;


/***/ },
/* 837 */
171,
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var modelo_gps_form_component_1 = __webpack_require__(839);
	var data_service_1 = __webpack_require__(178);
	var modelo_gps_list_component_1 = __webpack_require__(843);
	var ModeloGpsRoutingModule = (function () {
	    function ModeloGpsRoutingModule() {
	    }
	    ModeloGpsRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ModeloGpsRoutingModule);
	    return ModeloGpsRoutingModule;
	}());
	exports.ModeloGpsRoutingModule = ModeloGpsRoutingModule;
	exports.modeloGpsRoutes = [
	    {
	        path: '',
	        component: modelo_gps_list_component_1.ModeloGpsListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: modelo_gps_form_component_1.ModeloGpsFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: modelo_gps_form_component_1.ModeloGpsFormComponent
	    }
	];


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/12/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(387);
	var data_service_2 = __webpack_require__(178);
	var modelo_gps_model_1 = __webpack_require__(840);
	var modelo_gps_api_service_1 = __webpack_require__(388);
	var modelo_gps_service_1 = __webpack_require__(386);
	var modelo_gps_navigation_service_1 = __webpack_require__(818);
	var rastreamento_service_1 = __webpack_require__(827);
	var data_service_3 = __webpack_require__(813);
	var ModeloGpsFormComponent = (function () {
	    function ModeloGpsFormComponent(_route, _utilService, _modeloGpsService, _modeloGpsApiService, _modeloGpsNavigationService, _rastreamentoService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._modeloGpsService = _modeloGpsService;
	        this._modeloGpsApiService = _modeloGpsApiService;
	        this._modeloGpsNavigationService = _modeloGpsNavigationService;
	        this._rastreamentoService = _rastreamentoService;
	        this._fb = _fb;
	        this.modeloGpsModule = data_service_1.modeloGpsModuleName;
	        this.formObject = new modelo_gps_model_1.ModeloGps();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.rastreamentosModuleName;
	        this.ativo = new forms_1.FormControl('');
	        this.modelo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.senha = new forms_1.FormControl('');
	        this.numero = new forms_1.FormControl('');
	        this.protocolo = new forms_1.FormControl('');
	        this.returnToOtherForm = false;
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                this.responsModeloGps = Response;
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.toLeaveHere();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            modelo: this.modelo,
	            senha: this.senha,
	            numero: this.numero,
	            protocolo: this.protocolo
	        });
	    }
	    ModeloGpsFormComponent.prototype.ngOnInit = function () {
	        this.testSession();
	    };
	    ModeloGpsFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    ModeloGpsFormComponent.prototype.clickCancel = function () {
	        this.toLeaveHere();
	    };
	    ModeloGpsFormComponent.prototype.clickGoToConfig = function () {
	        this._rastreamentoService.goToSetting();
	    };
	    ModeloGpsFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEditModeloGps(object);
	            }
	            else {
	                this.onAddModeloGps(object);
	            }
	        }
	    };
	    ModeloGpsFormComponent.prototype.onAddModeloGps = function (object) {
	        this._modeloGpsApiService.onPost(object, this.onDone);
	    };
	    ModeloGpsFormComponent.prototype.onEditModeloGps = function (object) {
	        this._modeloGpsApiService.onPut(object, this.onDone);
	    };
	    ModeloGpsFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum modelo de aparelho encontrado com este id.');
	                this.toLeaveHere();
	            }
	        }.bind(this));
	        this._modeloGpsApiService.onGetById(id, onDone);
	    };
	    ModeloGpsFormComponent.prototype.setModelToForm = function () {
	    };
	    ModeloGpsFormComponent.prototype.goToList = function () {
	        this._modeloGpsService.clearSessionStorage();
	        this._modeloGpsNavigationService.goToList();
	    };
	    ModeloGpsFormComponent.prototype.testSession = function () {
	        var id;
	        var session = this._modeloGpsService.getSessionStorage();
	        this._modeloGpsService.clearSessionStorage();
	        if (session) {
	            this.formObject = session;
	            id = session.id;
	            if (id) {
	                this.setEditSession();
	            }
	            else {
	                this.setNewSession();
	            }
	        }
	        else {
	            id = +this._route.snapshot.params['id'];
	            if (id) {
	                this.setEditNormal(id);
	            }
	            else {
	                this.setNewNormal();
	            }
	        }
	        this.setActionTitle(id);
	    };
	    ModeloGpsFormComponent.prototype.setActionTitle = function (id) {
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    ModeloGpsFormComponent.prototype.setEditNormal = function (id) {
	        this.getObject(id);
	    };
	    ModeloGpsFormComponent.prototype.setNewNormal = function () {
	        this.setModelToForm();
	    };
	    ModeloGpsFormComponent.prototype.setEditSession = function () {
	    };
	    ModeloGpsFormComponent.prototype.setNewSession = function () {
	        //qndo retornou para continuar o cadastro
	        this.setModelToForm();
	    };
	    ModeloGpsFormComponent.prototype.toLeaveHere = function () {
	        this.goToList();
	    };
	    ModeloGpsFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(841),
	            styles: [__webpack_require__(842)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof modelo_gps_service_1.ModeloGpsService !== 'undefined' && modelo_gps_service_1.ModeloGpsService) === 'function' && _c) || Object, (typeof (_d = typeof modelo_gps_api_service_1.ModeloGpsApiService !== 'undefined' && modelo_gps_api_service_1.ModeloGpsApiService) === 'function' && _d) || Object, (typeof (_e = typeof modelo_gps_navigation_service_1.ModeloGpsNavigationService !== 'undefined' && modelo_gps_navigation_service_1.ModeloGpsNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _f) || Object, (typeof (_g = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _g) || Object])
	    ], ModeloGpsFormComponent);
	    return ModeloGpsFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.ModeloGpsFormComponent = ModeloGpsFormComponent;


/***/ },
/* 840 */
/***/ function(module, exports) {

	"use strict";
	var ModeloGps = (function () {
	    function ModeloGps() {
	    }
	    return ModeloGps;
	}());
	exports.ModeloGps = ModeloGps;


/***/ },
/* 841 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{modeloGpsModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{modeloGpsModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{modeloGpsModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !modelo.valid && submitted}\">\n                <label for=\"modelo\">Modelo <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!modelo.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"modelo\" formControlName=\"modelo\" [(ngModel)]=\"formObject.modelo\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"numero\">Número </label>\n                <div>\n                    <input type=\"text\" id=\"numero\" formControlName=\"numero\" [(ngModel)]=\"formObject.numero\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"protocolo\">Protocolo </label>\n                <div>\n                    <input type=\"text\" id=\"protocolo\" formControlName=\"protocolo\" [(ngModel)]=\"formObject.protocolo\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <label for=\"senha\">Senha </label>\n                <div>\n                    <input type=\"password\" id=\"senha\" formControlName=\"senha\" [(ngModel)]=\"formObject.senha\">\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 842 */
166,
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(387);
	var modelo_gps_api_service_1 = __webpack_require__(388);
	var modelo_gps_navigation_service_1 = __webpack_require__(818);
	var modelo_gps_service_1 = __webpack_require__(386);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(813);
	var data_service_3 = __webpack_require__(178);
	var rastreamento_service_1 = __webpack_require__(827);
	var ModeloGpsListComponent = (function () {
	    function ModeloGpsListComponent(_modelosGpsApiService, _modelosGpsService, _modeloGpsNavigationService, _rastreamentoService, _utilService) {
	        this._modelosGpsApiService = _modelosGpsApiService;
	        this._modelosGpsService = _modelosGpsService;
	        this._modeloGpsNavigationService = _modeloGpsNavigationService;
	        this._rastreamentoService = _rastreamentoService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.modelosGpsModuleName = data_service_1.modeloGpsModuleName;
	        this.module = data_service_2.rastreamentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	    }
	    ModeloGpsListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    ModeloGpsListComponent.prototype.clickNew = function () {
	        this._modelosGpsService.clearSessionStorage();
	        this._modeloGpsNavigationService.goToNew();
	    };
	    ModeloGpsListComponent.prototype.clickEdit = function (item) {
	        this._modelosGpsService.clearSessionStorage();
	        this._modeloGpsNavigationService.goToEdit(item.id);
	    };
	    ModeloGpsListComponent.prototype.clickGoToConfig = function () {
	        this._rastreamentoService.goToSetting();
	    };
	    ModeloGpsListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    ModeloGpsListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._modelosGpsApiService.onGetAll(onDone);
	    };
	    ModeloGpsListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._modelosGpsApiService.onDelete(item.id, onDone);
	    };
	    ModeloGpsListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(844),
	            styles: [__webpack_require__(845)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof modelo_gps_api_service_1.ModeloGpsApiService !== 'undefined' && modelo_gps_api_service_1.ModeloGpsApiService) === 'function' && _a) || Object, (typeof (_b = typeof modelo_gps_service_1.ModeloGpsService !== 'undefined' && modelo_gps_service_1.ModeloGpsService) === 'function' && _b) || Object, (typeof (_c = typeof modelo_gps_navigation_service_1.ModeloGpsNavigationService !== 'undefined' && modelo_gps_navigation_service_1.ModeloGpsNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], ModeloGpsListComponent);
	    return ModeloGpsListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ModeloGpsListComponent = ModeloGpsListComponent;


/***/ },
/* 844 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{modelosGpsModuleName.plural}}</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>{{modelosGpsModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{modelosGpsModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Modelo</th>\n            <th>Número</th>\n            <th>Protocolo</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['modelo','numero','protocolo'] | filterActive:showDisabled | sort:['modelo'])\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.modelo}}</td>\n            <td>{{item.numero}}</td>\n            <td>{{item.protocolo}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 845 */
166,
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(813);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(154);
	var rastreamento_api_service_1 = __webpack_require__(826);
	var sort_service_1 = __webpack_require__(97);
	var data_service_3 = __webpack_require__(50);
	var projeto_service_1 = __webpack_require__(52);
	var RastreamentoMapa2Component = (function () {
	    function RastreamentoMapa2Component(_rastreamentoApiService, _frotaApiService, _frotaService, _utilService, _sortService, _dataService, _projetoService) {
	        this._rastreamentoApiService = _rastreamentoApiService;
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._utilService = _utilService;
	        this._sortService = _sortService;
	        this._dataService = _dataService;
	        this._projetoService = _projetoService;
	        this.module = data_service_1.rastreamentosModuleName;
	        this.tabSelected = 'atual';
	        this.frotaSelectId = 'frota';
	        this.frotaObject = {};
	        this.loadingFrota = true;
	        this.frotaList = [];
	        this.timeListStart = [];
	        this.timeListEnd = [];
	        this.timeStart = {};
	        this.timeEnd = {};
	        this.historic = [];
	        this.loadingHistoric = false;
	        this.locationObject = {};
	        this.timeList = [];
	        this.markers = [];
	        this.coordinates = [];
	        this.showTrail = false;
	        this.frotaTemplateResult = (function (state) {
	            var template = this._frotaService.templateResult(state, false);
	            return template;
	        }.bind(this));
	    }
	    RastreamentoMapa2Component.prototype.ngOnInit = function () {
	        this.timeListStart = this._utilService.cloneObject(data_service_1.time);
	        this.timeListEnd = this._utilService.cloneObject(data_service_1.time);
	        this.timeList = this._utilService.cloneObject(data_service_1.time);
	        this.frotaQuery = this._utilService.cloneObject(data_service_2.frotasQuery);
	        this.frotaQuery.where.and.push({ gpsImei: { neq: null } });
	        this.frotaQuery.where.and.push({ gpsModeloId: { neq: null } });
	        this.veiculoCategoriaId = this._frotaService.getTipoVeiculo();
	        this.frotaApi = '/categoria/' + this.veiculoCategoriaId;
	        this.initialize();
	        this.getAllFrota();
	    };
	    RastreamentoMapa2Component.prototype.ngAfterViewInit = function () {
	    };
	    RastreamentoMapa2Component.prototype.getFrotasObject = function (object) {
	        this.frotaObject = object;
	    };
	    RastreamentoMapa2Component.prototype.clickItem = function (item) {
	        var location = this.testObject(item.Rastreamento);
	        this.map.setCenter(location.latlng);
	        this.map.setZoom(16);
	    };
	    RastreamentoMapa2Component.prototype.changeStartTime = function () {
	        if (this.timeStart.Key === 24) {
	            return this.timeListEnd = [];
	        }
	        this.timeListEnd = this.timeList.slice(this.timeStart.Key + 1, this.timeList.length);
	        this.timeEnd = this.timeListEnd[0];
	        this.changeEndTime();
	        this.timeStart.label = this._utilService.cloneObject("das " + this.timeStart.Value);
	    };
	    RastreamentoMapa2Component.prototype.changeEndTime = function () {
	        this.timeEnd.label = this._utilService.cloneObject("às " + this.timeEnd.Value);
	    };
	    RastreamentoMapa2Component.prototype.clickBuscarHistorico = function () {
	        var date = document.getElementById('date');
	        date = date.value;
	        this.msg = '';
	        if (this.frotaObject.id && date) {
	            var timeStart = this.timeStart;
	            if (timeStart) {
	                timeStart = ((timeStart.Key < 10) ? '0' + timeStart.Key.toString() : timeStart.Key.toString()).concat(":00");
	            }
	            var timeEnd = this.timeEnd;
	            if (timeEnd) {
	                timeEnd = ((timeEnd.Key < 10) ? '0' + timeEnd.Key.toString() : timeEnd.Key.toString()).concat(":00");
	            }
	            var start = this._utilService.convertStringToDateTime(date, timeStart);
	            var end = this._utilService.convertStringToDateTime(date, timeEnd);
	            var query = {
	                bemId: this.frotaObject.id,
	                inicio: start,
	                fim: end
	            };
	            this.removeMarkers();
	            this.getHistoric(query);
	        }
	        else {
	            this.msg = "Informe o veículo e a data";
	            this.historic = [];
	            this.removeMarkers();
	        }
	    };
	    RastreamentoMapa2Component.prototype.setTab = function (tab) {
	        this.tabSelected = tab;
	        if (tab === 'historico') {
	            setTimeout(function () {
	                this.historic = [];
	                if (this.frotaObject.id) {
	                    this._frotaService.setAutocompleteOption(this.frotaSelectId, this.frotaObject);
	                }
	                this._utilService.disabledFutureDates('date');
	                this.timeStart = this.timeListStart[0];
	                this.changeStartTime();
	            }.bind(this));
	        }
	        else {
	            this.frotaObject = {};
	        }
	    };
	    RastreamentoMapa2Component.prototype.isTab = function (tab) {
	        var isTab = (tab === this.tabSelected) ? true : false;
	        return isTab;
	    };
	    RastreamentoMapa2Component.prototype.initialize = function () {
	        var project = this._projetoService.getSessionStorage();
	        var coord = this._dataService.getCoordinates();
	        var lat = coord.lat, lng = coord.lng;
	        if (project) {
	            lat = project.latitude;
	            lng = project.longitude;
	        }
	        this.patternCoordinates = { lat: lat, lng: lng };
	        this.initMap(lat, lng);
	    };
	    RastreamentoMapa2Component.prototype.initMap = function (lat, lng) {
	        var map;
	        var latlng = new google.maps.LatLng(lat, lng);
	        var mapOptions = {
	            zoom: 12,
	            mapTypeControl: false,
	            streetViewControlOptions: {
	                position: google.maps.ControlPosition.LEFT_TOP
	            },
	            zoomControlOptions: {
	                position: google.maps.ControlPosition.LEFT_TOP
	            },
	        };
	        map = new google.maps.Map(document.getElementById("map"), mapOptions);
	        var infoContent = document.getElementById('info-content');
	        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(infoContent);
	        var btn = document.getElementById('btnRoadmap');
	        this.addMapTypeButtonEvent(btn, 'ROADMAP', map);
	        btn.click();
	        btn = document.getElementById('btnSatellite');
	        this.addMapTypeButtonEvent(btn, 'SATELLITE', map);
	        btn = document.getElementById('btnHybrid');
	        this.addMapTypeButtonEvent(btn, 'HYBRID', map);
	        var input = document.getElementById('trafficLayer');
	        var trafficLayer = new google.maps.TrafficLayer();
	        this.toogleMapLayerEvent(input, trafficLayer, map);
	        input = document.getElementById('transitLayer');
	        var transitLayer = new google.maps.TransitLayer();
	        this.toogleMapLayerEvent(input, transitLayer, map);
	        input = document.getElementById('trail');
	        input.addEventListener('click', function (e) {
	            this.showTrail = !this.showTrail;
	            if (this.showTrail) {
	                input.classList.add("active");
	            }
	            else {
	                input.classList.remove("active");
	                this.removePolyline();
	            }
	        }.bind(this));
	        input.click();
	        var div = document.getElementById('controls-map');
	        map.controls[google.maps.ControlPosition.TOP_LEFT].push(div);
	        var btnToggle = document.getElementById('btnToggle');
	        btnToggle.addEventListener('click', function (e) {
	            var x, lenX, found = false, controls = map.controls[google.maps.ControlPosition.TOP_RIGHT];
	            for (x = 0, lenX = controls.b.length; x < lenX; x++) {
	                if (controls.b[x].id === 'info-content') {
	                    map.controls[google.maps.ControlPosition.TOP_RIGHT].removeAt(x);
	                    found = true;
	                    break;
	                }
	            }
	            if (!found) {
	                map.controls[google.maps.ControlPosition.TOP_RIGHT].removeAt(0);
	                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(infoContent);
	                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnToggle);
	            }
	        });
	        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnToggle);
	        map.setCenter(latlng);
	        this.map = map;
	    };
	    RastreamentoMapa2Component.prototype.setMarker = function (frota, location) {
	        if (frota.id) {
	            var map_1 = this.map;
	            var latlng_1 = { lat: location.latitude, lng: location.longitude };
	            var marker_1 = new google.maps.Marker({
	                position: latlng_1,
	                title: frota.identificacao,
	                map: map_1
	            });
	            var callbackGeoCoder = function (response) {
	                location.address = response;
	                var infowindow = this.setInfowindow(location, frota);
	                infowindow.open(map_1, marker_1);
	            }.bind(this);
	            marker_1.addListener('click', function () {
	                this.geocodeLatLng(latlng_1, callbackGeoCoder);
	            }.bind(this));
	            this.markers.push(marker_1);
	            this.coordinates.push(latlng_1);
	        }
	    };
	    RastreamentoMapa2Component.prototype.removeMarkers = function () {
	        var x, lenX;
	        for (x = 0, lenX = this.markers.length; x < lenX; x++) {
	            this.markers[x].setMap(null);
	        }
	        this.markers = [];
	        this.coordinates = [];
	        this.removeMarkerCluster();
	        this.removePolyline();
	    };
	    RastreamentoMapa2Component.prototype.geocodeLatLng = function (latlng, callback) {
	        var geocoder = new google.maps.Geocoder;
	        geocoder.geocode({ 'location': latlng }, function (results, status) {
	            if (status === 'OK') {
	                if (results[0]) {
	                    callback(results[0].formatted_address);
	                }
	                else {
	                    window.alert('No results found');
	                }
	            }
	            else {
	                window.alert('Geocoder failed due to: ' + status);
	            }
	        });
	    };
	    RastreamentoMapa2Component.prototype.setInfowindow = function (location, frota) {
	        var date = this._utilService.convertDateToString(location.data);
	        var time = this._utilService.convertTimeToString(location.data);
	        if (!location.address) {
	            location.address = ' - ';
	        }
	        var content = '<div>' +
	            '<strong>' + frota.identificacao + '</strong>' +
	            '<br> ' +
	            '<p>Local: ' + location.address + '</p>' +
	            '<p>Data/hora: ' + date + ' ' + time + '</p>' +
	            '<p>lat: ' + location.latitude + ' / lng:' + location.longitude + '</p>' +
	            '<p>Velocidade: ' + location.kmPorHora + ' km/h</p>' +
	            '</div>';
	        var infowindow = new google.maps.InfoWindow({
	            content: content
	        });
	        return infowindow;
	    };
	    RastreamentoMapa2Component.prototype.setPolyline = function () {
	        var coordinates = this.coordinates;
	        //draw line
	        var flightPath = new google.maps.Polyline({
	            path: coordinates,
	            geodesic: true,
	            strokeColor: '#8075D6',
	            strokeOpacity: 1.0,
	            strokeWeight: 2
	        });
	        flightPath.setMap(this.map);
	        this.polyline = flightPath;
	    };
	    RastreamentoMapa2Component.prototype.removePolyline = function () {
	        if (this.polyline) {
	            this.polyline.setMap(null);
	        }
	    };
	    RastreamentoMapa2Component.prototype.setMarkerCluster = function () {
	        // Add a marker clusterer to manage the markers.
	        var markerCluster = new MarkerClusterer(this.map, this.markers, { imagePath: 'assets/markerclusterer-1.0/m/m' });
	        this.markerCluster = markerCluster;
	    };
	    RastreamentoMapa2Component.prototype.removeMarkerCluster = function () {
	        if (this.markerCluster) {
	            this.markerCluster.clearMarkers();
	        }
	    };
	    RastreamentoMapa2Component.prototype.getAllFrota = function () {
	        var onDone = (function (Response) {
	            var _this = this;
	            if (!Response.error) {
	                this.removeMarkers();
	                Response.forEach(function (item) {
	                    if (item.Imagens.length) {
	                        item.imageUrl = item.Imagens[0].url;
	                    }
	                    if (item.Rastreamento) {
	                        if (item.Rastreamento.latitude && item.Rastreamento.longitude) {
	                            _this.setMarker(item, item.Rastreamento);
	                        }
	                    }
	                    else {
	                        item.Rastreamento = {};
	                    }
	                });
	                this.frotaList = Response;
	                this.map.setCenter(this.patternCoordinates);
	                this.map.setZoom(12);
	            }
	            this.loadingFrota = false;
	        }.bind(this));
	        var query = this._utilService.cloneObject(data_service_2.frotasQueryComGPS);
	        query.where.ativo = true;
	        this._frotaApiService.onGetAllRastreamento(this.veiculoCategoriaId, query, onDone);
	    };
	    RastreamentoMapa2Component.prototype.getCurrentLocation = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.locationObject = Response;
	                Response = this.testObject(Response);
	                if (Response.latlng) {
	                    var found = this.checkCoordinates(Response);
	                    if (!found) {
	                        //set o marker no mapa somente se as coordenadas não existirem no array
	                        var rastro = this._utilService.cloneObject(this.coordinates);
	                        this.removeMarkers();
	                        this.setMarker(Response);
	                        rastro.reverse();
	                        rastro.unshift(this.coordinates[0]);
	                        rastro = (rastro.length > 5) ? rastro.slice(0, 5) : rastro;
	                        this.coordinates = rastro.reverse();
	                        if (this.showTrail) {
	                            this.setPolyline();
	                        }
	                        this.map.setCenter(Response.latlng);
	                        this.map.setZoom(16);
	                    }
	                }
	            }
	            else {
	            }
	            setTimeout(function () {
	                if (this.tabSelected === 'atual') {
	                    this.getCurrentLocation();
	                }
	            }.bind(this), 10000);
	        }.bind(this));
	        if (this.frotaObject.id) {
	            this._rastreamentoApiService.onGetCurrent(this.frotaObject.id, onDone);
	        }
	    };
	    RastreamentoMapa2Component.prototype.getHistoric = function (query) {
	        var onDone = (function (Response) {
	            var _this = this;
	            if (!Response.error) {
	                Response = this._sortService.sortArray(Response, ['data']);
	                var found_1, latlng_2 = this.patternCoordinates;
	                Response.forEach(function (item) {
	                    item = _this.testObject(item);
	                    if (item.latlng) {
	                        latlng_2 = item.latlng;
	                        found_1 = _this.checkCoordinates(item);
	                        if (!found_1) {
	                            _this.setMarker(item);
	                        }
	                    }
	                });
	                this.historic = Response;
	                if (Response.length) {
	                    this.setMarkerCluster();
	                    this.setPolyline();
	                    this.map.setCenter(latlng_2);
	                    this.map.setZoom(16);
	                }
	                else {
	                    this.msg = "Nenhum dado encontrado";
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom("Não foi possível obter a localidade do veículo");
	            }
	            this.loadingHistoric = false;
	        }.bind(this));
	        this.loadingHistoric = true;
	        this._rastreamentoApiService.onGetPeriod(query, onDone);
	    };
	    RastreamentoMapa2Component.prototype.checkCoordinates = function (newLocation) {
	        var x, lenX, found = false;
	        for (x = 0, lenX = this.coordinates.length; x < lenX; x++) {
	            if (this.coordinates[x].lat === newLocation.latitude && this.coordinates[x].lng === newLocation.longitude) {
	                found = true;
	            }
	        }
	        return found;
	    };
	    RastreamentoMapa2Component.prototype.testObject = function (location) {
	        if (location.longitude && location.latitude) {
	            location.latlng = { lat: location.latitude, lng: location.longitude };
	        }
	        return location;
	    };
	    RastreamentoMapa2Component.prototype.addMapTypeButtonEvent = function (btn, type, map) {
	        btn.addEventListener('click', function (e) {
	            var c = document.getElementsByClassName('btns-controls');
	            var x, lenX;
	            for (x = 0, lenX = c.length; x < lenX; x++) {
	                c[x].classList.remove("active");
	            }
	            e.target.classList.add("active");
	            map.setMapTypeId(google.maps.MapTypeId[type]);
	        });
	    };
	    RastreamentoMapa2Component.prototype.toogleMapLayerEvent = function (input, layer, map) {
	        input.addEventListener('click', function (e) {
	            if (!layer.getMap()) {
	                input.classList.add("active");
	                layer.setMap(map);
	            }
	            else {
	                input.classList.remove("active");
	                layer.setMap(null);
	            }
	        });
	    };
	    RastreamentoMapa2Component = __decorate([
	        core_1.Component({
	            template: __webpack_require__(847),
	            styles: [__webpack_require__(848)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rastreamento_api_service_1.RastreamentoApiService !== 'undefined' && rastreamento_api_service_1.RastreamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _b) || Object, (typeof (_c = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof sort_service_1.SortService !== 'undefined' && sort_service_1.SortService) === 'function' && _e) || Object, (typeof (_f = typeof data_service_3.DataService !== 'undefined' && data_service_3.DataService) === 'function' && _f) || Object, (typeof (_g = typeof projeto_service_1.ProjetoService !== 'undefined' && projeto_service_1.ProjetoService) === 'function' && _g) || Object])
	    ], RastreamentoMapa2Component);
	    return RastreamentoMapa2Component;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.RastreamentoMapa2Component = RastreamentoMapa2Component;


/***/ },
/* 847 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.single}}</a></li>\n            <li class=\"item pipe\"><a class=\"active\">Mapa</a></li>\n        </ul>\n    </div>\n</div>\n\n<div id=\"controls-map\">\n    <div class=\"option-container\">\n        <button id=\"btnRoadmap\" class=\"btns-controls\" title=\"Mostrar mapa de ruas\">Mapa</button>\n        <button id=\"btnSatellite\" class=\"btns-controls\" title=\"Mostrar imagens de satélite\">Satélite</button>\n        <button id=\"btnHybrid\" class=\"btns-controls\" title=\"Mostrar imagens de satélite e mapa de ruas\">Híbrido</button>\n    </div>\n    <div class=\"option-container\">\n        <div class=\"input-option\" id=\"trafficLayer\">\n            <span class=\"checkbox\"><div class=\"arrow\"></div></span>\n            <label>Mostrar tráfego</label>\n        </div>\n        <div class=\"input-option\" id=\"transitLayer\">\n            <span class=\"checkbox\"><div class=\"arrow\"></div></span>\n            <label>Mostrar trânsito</label>\n        </div>\n        <div class=\"input-option\" id=\"trail\">\n            <span class=\"checkbox\"><div class=\"arrow\"></div></span>\n            <label>Mostrar rastro do veículo</label>\n        </div>\n    </div>\n</div>\n\n<button id=\"btnToggle\" class=\"controls\"></button>\n\n<div id=\"info-content\" class=\"controls info-content\">\n    <nav class=\"geo-tabs\">\n        <ul class=\"items\">\n            <li class=\"item\">\n                <a (click)=\"setTab('atual')\" [ngClass]=\"{'active': isTab('atual')}\" class=\"item-link\">Atual</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('eventos')\" [ngClass]=\"{'active': isTab('eventos')}\" class=\"item-link\">Eventos</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('historico')\" [ngClass]=\"{'active': isTab('historico')}\" class=\"item-link\">Histórico</a>\n            </li>\n        </ul>\n    </nav>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('atual')\">\n        <div class=\"geo-input--12c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\" *ngIf=\"loadingFrota\">\n            <spinner-component [showDisplay]=\"true\" ></spinner-component>\n        </div>\n\n        <p class=\"lead padding\" *ngIf=\"!frotaList.length && !loadingFrota\">Nenhum veículo cadastrado com GPS</p>\n\n        <table *ngIf=\"frotaList.length\">\n            <tbody data-collapse *ngFor=\"let item of(frotaList | filter:listFilter.value:['identificacao', 'placa', 'codigoPatrimonio', 'codigo'] | sort:['identificacao'])\">\n            <tr (click)=\"clickItem(item)\">\n                <td class=\"header-list\">\n                    <span class=\"geo-arrow\"></span>\n                    <div class=\"content-image\">\n                        <img [src]=\"item.imageUrl\" *ngIf=\"item.imageUrl\" class=\"image\">\n                    </div>\n                    <div class=\"content-all\">\n                        <span *ngIf=\"item.placa\">{{item.placa | licensePlateMask}} / </span> {{item.identificacao}}\n                        <span class=\"date\" *ngIf=\"item.Rastreamento\">{{item.Rastreamento.data | date:'dd/MM/yyyy H:mm:ss'}}</span>\n                    </div>\n                    <div class=\"content-icons\">\n                        <div class=\"gpsStatus\" [ngClass]=\"{'gpsAtivo': item.Rastreamento.gpsAtivo}\" title=\"GPS ativo\">\n                            <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-wifi'/></svg>\n                        </div>\n                    </div>\n                </td>\n            </tr>\n            <tr class=\"description\">\n                <td colspan=\"100%\">\n                    <div class=\"line\">\n                        <strong>Posição:</strong>\n                        <span>\n                            lat: {{item.Rastreamento.latitude}} <span *ngIf=\"!item.Rastreamento.latitude\"> - </span>\n                            <br />\n                            lng: {{item.Rastreamento.longitude}} <span *ngIf=\"!item.Rastreamento.longitude\"> - </span>\n                            </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <div class=\"status\" [ngClass]=\"{'red':(item.Rastreamento.ligado === false), 'green':item.Rastreamento.ligado}\"></div>\n                        <strong>Veículo ligado:</strong>\n                        <span *ngIf=\"item.Rastreamento.ligado\"> Sim </span>\n                        <span *ngIf=\"item.Rastreamento.ligado === false\"> Não </span>\n                        <span *ngIf=\"item.Rastreamento.ligado === null\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <strong>Velocidade:</strong>\n                        <span>{{item.Rastreamento.kmPorHora}} km/h</span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <strong>Data/hora:</strong>\n                        <span> {{item.Rastreamento.data | date:'dd/MM/yyyy H:mm:ss'}}</span>\n                        <span *ngIf=\"!item.Rastreamento.data\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <strong>GPS ativo:</strong>\n                        <span *ngIf=\"item.Rastreamento.gpsAtivo\"> Sim </span>\n                        <span *ngIf=\"item.Rastreamento.gpsAtivo === false\"> Não </span>\n                        <span *ngIf=\"item.Rastreamento.gpsAtivo === null\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <strong>Modelo do GPS:</strong>\n                        <span *ngIf=\"item.Rastreamento.gpsModelo\">{{item.Rastreamento.gpsModelo.modelo}}</span>\n                        <span *ngIf=\"!item.Rastreamento.gpsModelo\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                    <div class=\"line\">\n                        <strong>IMEI:</strong>\n                        <span> {{item.Rastreamento.imei}} </span>\n                        <span *ngIf=\"!item.Rastreamento.imei\"> - </span>\n                        <div class=\"clear\"></div>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('historico')\">\n        <autocomplete-component id=\"frota\"\n                                (setObejct)=\"getFrotasObject($event)\"\n                                [isRequired]=\"false\"\n                                [selectId]=\"frotaSelectId\"\n                                [model]=\"frotaObject\"\n                                [_service]=\"_frotaApiService\"\n                                [templateResult]=\"frotaTemplateResult\"\n                                [isCreateNew]=\"false\"\n                                [apiCustom]=\"frotaApi\"\n                                [query]=\"frotaQuery\"\n                                [placeholder]=\"'Veículo'\"\n                                [label]=\"''\"></autocomplete-component>\n\n\n        <div id=\"date-content\">\n            <input type=\"text\" class=\"input-datepicker\" id=\"date\" autocomplete=\"off\" placeholder=\"Data\" />\n\n            <select id=\"time-end\" [(ngModel)]=\"timeEnd\" (ngModelChange)=\"changeEndTime()\">\n                <option *ngFor=\"let item of timeListEnd\" [ngValue]=\"item\">{{item.Value}}</option>\n            </select>\n\n            <select id=\"time-start\" [(ngModel)]=\"timeStart\" (ngModelChange)=\"changeStartTime()\">\n                <option *ngFor=\"let item of timeListStart\" [ngValue]=\"item\">{{item.Value}}</option>\n            </select>\n\n            <div class=\"clear\"></div>\n            <button type=\"button\" class=\"geo-button button-remove-margin-left\" (click)=\"clickBuscarHistorico()\">Buscar</button>\n\n            <hr>\n            <div *ngIf=\"loadingHistoric\">\n                <spinner-component [showDisplay]=\"true\" ></spinner-component>\n            </div>\n            <div *ngIf=\"msg\">\n                <p >{{msg}}</p>\n            </div>\n            <div class=\"clear\"></div>\n\n            <ul class=\"historic\">\n                <li *ngFor=\"let item of (historic | sort:['data'])\">\n                    <div class=\"flex\">\n                        <div class=\"icon\">\n                            <div class=\"circle\">\n                                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-arrow-down'/></svg>\n                            </div>\n                        </div>\n                        <div class=\"plus\">\n                            {{item.data | date: 'H:mm:ss'}} <span class=\"right\">{{item.data | date: 'dd/MM/yyyy'}}</span>\n                            <p>lat: {{item.latitude}} / lng: {{item.longitude}}</p>\n                            <p>{{item.kmPorHora}} km/h</p>\n                            <p>Evento:\n                                <span *ngIf=\"item.evento === 'rastrear'\">Rastreamento</span>\n                                <span *ngIf=\"item.evento === 'ligar'\" class=\"color-green\"> Veículo ligado</span>\n                                <span *ngIf=\"item.evento === 'desligar'\" class=\"color-red\"> Veículo desligado</span>\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"line\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n\n<div id=\"map-container\">\n    <div id=\"map\"></div>\n</div>\n";

/***/ },
/* 848 */
/***/ function(module, exports) {

	module.exports = "#map-container {\n    position: relative;\n    margin: 12px 0;\n    height: calc(100vh - 6.5em - 64px);\n}\n\n#map {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n#controls-map .option-container {\n    margin-top: 10px;\n    margin-left: 10px;\n    background-color: #fff;\n    border-radius: 2px;\n    box-shadow: rgba(0, 0, 0, 0.298039) 0 1px 4px -1px;\n    display: inline-block;\n    overflow: hidden;\n    text-align: center;\n    position: relative;\n    font-family: Roboto, Arial, sans-serif;\n    font-size: 11px;\n    color: rgb(86, 86, 86);\n}\n#controls-map .option-container .btns-controls,\n#controls-map .option-container .input-option {\n    padding: 8px;\n    min-width: 27px;\n    border-right: 1px solid #f3eded;\n}\n#controls-map .option-container .btns-controls {\n    direction: ltr;\n    overflow: hidden;\n    background-color: transparent;\n    outline: none;\n    border: none;\n}\n#controls-map .option-container .btns-controls:last-child {\n    border-right: none;\n}\n#controls-map .option-container .input-option {\n    display: inline-block;\n}\n#controls-map .option-container .input-option span.checkbox {\n    box-sizing: border-box;\n    position: relative;\n    line-height: 0;\n    font-size: 0;\n    margin: -1px 5px 0 0;\n    display: inline-block;\n    background-color: rgb(255, 255, 255);\n    border: 1px solid rgb(198, 198, 198);\n    border-radius: 1px;\n    width: 13px;\n    height: 13px;\n    vertical-align: middle;\n}\n#controls-map .option-container .input-option.active span.checkbox .arrow {\n    display: none;\n}\n#controls-map .option-container .input-option.active span.checkbox .arrow {\n    position: absolute;\n    left: 4px;\n    top: -5px;\n    width: 5px;\n    height: 12px;\n    border: solid rgb(116, 116, 116);\n    border-width: 0 2px 2px 0;\n    transform: rotate(40deg);\n    display: block;\n}\n#controls-map .option-container .btns-controls.active,\n#controls-map .option-container .input-option.active label {\n    font-weight: 500;\n    color: rgb(0, 0, 0);\n}\n\n.controls {\n    border: 1px solid transparent;\n    border-radius: 2px;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    outline: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n    background-color: #fff;\n}\n\n.info-content {\n    margin-top: 10px;\n    margin-right: 10px;\n    width: 400px;\n    max-height: calc(100% - 30px);\n    padding: 8px;\n    overflow: auto;\n    overflow-x: hidden;\n}\n.info-content table tr td.header-list {\n    display: flex;\n    padding: 8px;\n    position: relative;\n}\n.info-content table tr td.header-list .content-all {\n    flex: 1;\n    padding-left: 8px;\n}\n.info-content table tr td.header-list .content-image img {\n    width: 50px;\n}\n.info-content table tr td.header-list .content-icons {\n    padding-right: 10px;\n}\n.info-content .status {\n    width: 12px;\n    height: 12px;\n    float: left;\n    background-color: grey;\n    border-radius: 50%;\n    box-shadow: 1px 1px 2px #bbbaba;\n    margin-right: 8px;\n    margin-top: 2px;\n}\n.info-content .gpsStatus {\n    float: right;\n    margin-right: 8px;\n    margin-top: -3px\n}\n.info-content .gpsStatus svg {\n    width: 20px;\n    height: 20px;\n    fill: grey\n}\n.info-content .gpsAtivo svg {\n    fill: #268d19;\n}\n.info-content .status.red {\n    background-color: #f23147;\n}\n.info-content .status.green {\n    background-color: #268d19;\n}\n\n.color-red {\n    color: #f23147;\n}\n.color-green {\n    color: #268d19;\n}\n\n.info-content .geo-arrow {\n    position: absolute;\n    right: -5px;\n    top: 8px;\n}\n.info-content .geo-input--search {\n    width: 100%;\n    margin-bottom: 0;\n}\n.info-content table {\n    /*margin-top: 0;*/\n    font-size: 14px;\n}\n.info-content .date {\n    display: block;\n    margin-top: 2px;\n    color: #9a9a9a;\n    font-size: 12px;\n}\n.info-content .description td {\n    padding: 4px 8px;\n}\n.info-content .description td div.line {\n    border-bottom: 1px solid #eee;\n    margin: 0;\n    padding: 8px 0;\n}\n.info-content .description td div.line span {\n    float: right;\n}\ndiv.clear {\n    clear: both;\n}\n.info-content tr.geo-arrow--down {\n    border-left: 3px solid #4c87ff;\n}\n\n#btnToggle {\n    margin-top: 10px;\n    margin-right: -3px;\n    height: 44px;\n    width: 40px;\n    box-shadow: -1px 2px 2px rgba(0, 0, 0, 0.3);\n}\n#btnToggle:after {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iXzAxXy1fY2FtcG9fZGVfYnVzY2FfbWVudV9jbG9zZSIgZGF0YS1uYW1lPSIwMSAtIGNhbXBvIGRlIGJ1c2NhIG1lbnUgY2xvc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE0IDE0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6Izc0NzQ3NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24tcGVzcXVpc2EtYmFyPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNTk5LjA2LDg2LjhoLTAuNjNsLTAuMjItLjIyYTUuMiw1LjIsMCwxLDAtLjU2LjU2bDAuMjEsMC4yMlY4OGw0LDQsMS4xOS0xLjE5Wm0tNC44LDBhMy42LDMuNiwwLDEsMSwzLjYtMy42QTMuNiwzLjYsMCwwLDEsMTU5NC4yNiw4Ni44WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1ODkuMDYgLTc4KSIvPjwvc3ZnPg==);\n    margin-top: -8px;\n    top: 50%;\n    right: 10px;\n    width: 16px;\n    height: 16px;\n}\n\n#date-content {\n    margin-top: 10px;\n}\n#date-content input,\n#date-content select {\n    height: 32px;\n    min-width: 60px;\n    outline: none;\n    border: 2px solid #edf0f4;\n}\n\n#date-content select#time-start,\n#date-content select#time-end {\n    margin-right: 0;\n    float: right;\n}\n#date-content input#date {\n    padding-left: 8px;\n    margin-right: 10px;\n    height: 26px;\n}\n#date-content .geo-button {\n    font-size: 14px;\n    margin-top: 10px;\n}\n\nhr {\n    border: none;\n    border-bottom: 1px solid #ddd;\n}\n\n.flex {\n    display: flex;\n}\n.flex .plus {\n    flex: 1;\n}\n\nul.historic {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\nul.historic li {\n    border-bottom: 1px solid #ddd;\n    padding: 12px 0;\n    position: relative;\n}\nul.historic .icon .circle {\n    border-radius: 50%;\n    border: 1px solid #777;\n    background-color: #fff;\n    width: 20px;\n    height: 20px;\n    margin: 0 12px;\n    text-align: center;\n}\nul.historic .icon .circle svg {\n    width: 16px;\n    height: 16px;\n    fill: #151617;\n    position: relative;\n    top: 2px;\n}\nul.historic li .line {\n    width: 2px;\n    height: 70px;\n    position: absolute;\n    left: 22px;\n    top: 13px;\n    z-index: -1;\n    border-left: 2px dashed #4c87ff;\n}\nul.historic .plus p {\n    color: #747474;\n    display: block;\n    margin: 2px 0;\n}\nul.historic .plus span.right {\n    color: #747474;\n    float: right;\n}"

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CercasComponent = (function () {
	    function CercasComponent() {
	    }
	    CercasComponent.prototype.ngOnInit = function () {
	    };
	    CercasComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(850)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CercasComponent);
	    return CercasComponent;
	}());
	exports.CercasComponent = CercasComponent;


/***/ },
/* 850 */
171,
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var cerca_form_component_1 = __webpack_require__(852);
	var data_service_1 = __webpack_require__(178);
	var cerca_list_component_1 = __webpack_require__(858);
	var CercaRoutingModule = (function () {
	    function CercaRoutingModule() {
	    }
	    CercaRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CercaRoutingModule);
	    return CercaRoutingModule;
	}());
	exports.CercaRoutingModule = CercaRoutingModule;
	exports.cercaRoutes = [
	    {
	        path: '',
	        component: cerca_list_component_1.CercaListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: cerca_form_component_1.CercaFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: cerca_form_component_1.CercaFormComponent
	    }
	];


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/12/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(819);
	var data_service_2 = __webpack_require__(178);
	var cerca_model_1 = __webpack_require__(853);
	var cerca_api_service_1 = __webpack_require__(854);
	var cerca_service_1 = __webpack_require__(855);
	var cerca_navigation_service_1 = __webpack_require__(820);
	var rastreamento_service_1 = __webpack_require__(827);
	var data_service_3 = __webpack_require__(813);
	var projeto_service_1 = __webpack_require__(52);
	var data_service_4 = __webpack_require__(50);
	var CercaFormComponent = (function () {
	    function CercaFormComponent(_route, _utilService, _cercaService, _cercaApiService, _cercaNavigationService, _rastreamentoService, _projetoService, _dataService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._cercaService = _cercaService;
	        this._cercaApiService = _cercaApiService;
	        this._cercaNavigationService = _cercaNavigationService;
	        this._rastreamentoService = _rastreamentoService;
	        this._projetoService = _projetoService;
	        this._dataService = _dataService;
	        this._fb = _fb;
	        this.cercaModule = data_service_1.cercaModuleName;
	        this.formObject = new cerca_model_1.Cerca();
	        this.submitted = false;
	        this.btnSaveDisabled = false;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.rastreamentosModuleName;
	        this.ativo = new forms_1.FormControl('');
	        this.nome = new forms_1.FormControl('', forms_1.Validators.required);
	        this.raio = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipo = new forms_1.FormControl({ value: '', disabled: true });
	        this.latitude = new forms_1.FormControl('', forms_1.Validators.required);
	        this.longitude = new forms_1.FormControl('', forms_1.Validators.required);
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.goToList();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            nome: this.nome,
	            raio: this.raio,
	            tipo: this.tipo,
	            latitude: this.latitude,
	            longitude: this.longitude
	        });
	    }
	    CercaFormComponent.prototype.ngOnInit = function () {
	        var project = this._projetoService.getSessionStorage();
	        if (project) {
	            this.projectLatLng = { lat: project.latitude, lng: project.longitude };
	        }
	        else {
	            project = this._dataService.getCoordinates();
	            this.projectLatLng = { lat: project.lat, lng: project.lng };
	        }
	        this.initMap();
	        this.testSession();
	    };
	    CercaFormComponent.prototype.ngAfterViewInit = function () {
	        this.formObject.tipo = this._utilService.cloneObject(data_service_1.tiposCercas[0].Value);
	    };
	    CercaFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    CercaFormComponent.prototype.clickCancel = function () {
	        this.goToList();
	    };
	    CercaFormComponent.prototype.clickGoToConfig = function () {
	        this._rastreamentoService.goToSetting();
	    };
	    CercaFormComponent.prototype.onSubmit = function (evt) {
	        // this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.formObject.id) {
	                this.onEditCerca(object);
	            }
	            else {
	                this.onAddCerca(object);
	            }
	        }
	    };
	    CercaFormComponent.prototype.blurRadius = function () {
	        if (this.formObject.raio) {
	            this.circle.setRadius(Number(this.formObject.raio));
	        }
	    };
	    CercaFormComponent.prototype.blurLatLng = function () {
	        if (this.formObject.latitude && this.formObject.longitude) {
	            var latLng = { lat: Number(this.formObject.latitude), lng: Number(this.formObject.longitude) };
	            this.circle.setCenter(latLng);
	        }
	    };
	    CercaFormComponent.prototype.onAddCerca = function (object) {
	        this._cercaApiService.onPost(object, this.onDone);
	    };
	    CercaFormComponent.prototype.onEditCerca = function (object) {
	        this._cercaApiService.onPut(object, this.onDone);
	    };
	    CercaFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setCircle();
	                this.setDraw();
	                this.map.setCenter({ lat: this.formObject.latitude, lng: this.formObject.longitude });
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma cerca encontrada com este id.');
	                this.goToList();
	            }
	        }.bind(this));
	        this._cercaApiService.onGetById(id, onDone);
	    };
	    CercaFormComponent.prototype.goToList = function () {
	        this._cercaService.clearSessionStorage();
	        this._cercaNavigationService.goToList();
	    };
	    CercaFormComponent.prototype.testSession = function () {
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	            this.getObject(id);
	        }
	        else {
	            this.actionTitle = data_service_2.newRouteFemale;
	            this.setCircle();
	            this.setDraw();
	        }
	    };
	    CercaFormComponent.prototype.initMap = function () {
	        var latLng = this.projectLatLng;
	        var map = new google.maps.Map(document.getElementById('map'), {
	            center: latLng,
	            zoom: 12,
	            streetViewControlOptions: {
	                position: google.maps.ControlPosition.LEFT_TOP
	            },
	            zoomControlOptions: {
	                position: google.maps.ControlPosition.LEFT_TOP
	            }
	        });
	        var formContent = document.getElementById('form_content');
	        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(formContent);
	        this.map = map;
	        this.setSeachBox();
	    };
	    CercaFormComponent.prototype.setCircle = function () {
	        var _this = this;
	        var options = {
	            fillColor: '#4C87FF',
	            fillOpacity: 0.5,
	            strokeColor: '#4C87FF',
	            strokeWeight: 1,
	            clickable: true,
	            editable: true,
	            draggable: true,
	            zIndex: 1
	        };
	        if (this.formObject.id) {
	            if (this.formObject.raio) {
	                options.radius = this.formObject.raio;
	            }
	            else {
	                options.radius = 100;
	            }
	            if (this.formObject.latitude && this.formObject.longitude) {
	                options.center = { lat: this.formObject.latitude, lng: this.formObject.longitude };
	            }
	            else {
	                options.center = this.projectLatLng;
	            }
	            options.map = this.map;
	        }
	        var circle = new google.maps.Circle(options);
	        google.maps.event.addListener(circle, 'radius_changed', function () {
	            _this.setRadius();
	        });
	        google.maps.event.addListener(circle, 'dragend', function () {
	            _this.setLatLng();
	        });
	        this.circle = circle;
	        if (options.radius < 500) {
	            this.map.setZoom(16);
	        }
	    };
	    CercaFormComponent.prototype.setDraw = function () {
	        var _this = this;
	        var map = this.map;
	        var circle = this.circle;
	        var drawingManager = new google.maps.drawing.DrawingManager({
	            drawingMode: google.maps.drawing.OverlayType.CIRCLE,
	            circleOptions: circle,
	            drawingControl: false
	        });
	        var btn1 = document.getElementById('btnHandDraw');
	        var btn2 = document.getElementById('btnDraw');
	        var btn3 = document.getElementById('btnRemoveDraw');
	        btn1.addEventListener('click', function (e) {
	            drawingManager.drawingMode = null;
	            drawingManager.setMap(map);
	        });
	        btn2.addEventListener('click', function (e) {
	            btn3.click();
	            drawingManager.drawingMode = google.maps.drawing.OverlayType.CIRCLE;
	            drawingManager.setMap(map);
	        });
	        btn3.addEventListener('click', function (e) {
	            _this.circle.setMap(null);
	            btn1.click();
	        });
	        google.maps.event.addListener(drawingManager, 'circlecomplete', function (circle) {
	            _this.circle = circle;
	            _this.setRadius();
	            _this.setLatLng();
	            btn1.click();
	        });
	        var btn = document.getElementById('drawOptions');
	        map.controls[google.maps.ControlPosition.TOP_LEFT].push(btn);
	        if (!this.formObject.id) {
	            drawingManager.setMap(map);
	        }
	        this.draw = drawingManager;
	        //btn1.click();
	    };
	    CercaFormComponent.prototype.setSeachBox = function () {
	        var map = this.map;
	        var input = document.getElementById('pac-input');
	        var searchBox = new google.maps.places.SearchBox(input);
	        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(input);
	        map.addListener('bounds_changed', function () {
	            searchBox.setBounds(map.getBounds());
	        });
	        searchBox.addListener('places_changed', function () {
	            var places = searchBox.getPlaces();
	            if (places.length == 0) {
	                return;
	            }
	            var bounds = new google.maps.LatLngBounds();
	            places.forEach(function (place) {
	                if (!place.geometry) {
	                    return;
	                }
	                if (place.geometry.viewport) {
	                    bounds.union(place.geometry.viewport);
	                }
	                else {
	                    bounds.extend(place.geometry.location);
	                }
	            });
	            map.fitBounds(bounds);
	        });
	    };
	    CercaFormComponent.prototype.setRadius = function () {
	        if (this.circle) {
	            var radius = this.circle.getRadius();
	            if (radius) {
	                this._utilService.setSelectOnFormControl(this.form, 'raio', radius.toString());
	                this.formObject.raio = parseInt(radius);
	                var e = document.getElementById('raio');
	                e.value = this.formObject.raio;
	            }
	        }
	    };
	    CercaFormComponent.prototype.setLatLng = function () {
	        if (this.circle) {
	            var circle = this.circle;
	            this._utilService.setSelectOnFormControl(this.form, 'latitude', circle.getCenter().lat());
	            this._utilService.setSelectOnFormControl(this.form, 'longitude', circle.getCenter().lng());
	            this.formObject.latitude = circle.getCenter().lat();
	            this.formObject.longitude = circle.getCenter().lng();
	            var e = document.getElementById('latitude');
	            e.value = this.formObject.latitude;
	            e = document.getElementById('longitude');
	            e.value = this.formObject.longitude;
	        }
	    };
	    CercaFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(856),
	            styles: [__webpack_require__(857)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof cerca_service_1.CercaService !== 'undefined' && cerca_service_1.CercaService) === 'function' && _c) || Object, (typeof (_d = typeof cerca_api_service_1.CercaApiService !== 'undefined' && cerca_api_service_1.CercaApiService) === 'function' && _d) || Object, (typeof (_e = typeof cerca_navigation_service_1.CercaNavigationService !== 'undefined' && cerca_navigation_service_1.CercaNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _f) || Object, (typeof (_g = typeof projeto_service_1.ProjetoService !== 'undefined' && projeto_service_1.ProjetoService) === 'function' && _g) || Object, (typeof (_h = typeof data_service_4.DataService !== 'undefined' && data_service_4.DataService) === 'function' && _h) || Object, (typeof (_j = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _j) || Object])
	    ], CercaFormComponent);
	    return CercaFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.CercaFormComponent = CercaFormComponent;


/***/ },
/* 853 */
/***/ function(module, exports) {

	"use strict";
	var Cerca = (function () {
	    function Cerca() {
	    }
	    return Cerca;
	}());
	exports.Cerca = Cerca;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(819);
	var rest_service_1 = __webpack_require__(26);
	var CercaApiService = (function () {
	    function CercaApiService(_restService) {
	        this._restService = _restService;
	    }
	    CercaApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    CercaApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    CercaApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    CercaApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "nome" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    CercaApiService.prototype.onGetById = function (objectId, done) {
	        var filter = {};
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    CercaApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], CercaApiService);
	    return CercaApiService;
	    var _a;
	}());
	exports.CercaApiService = CercaApiService;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(819);
	var CercaService = (function () {
	    function CercaService() {
	    }
	    //session
	    CercaService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.cercaStorage + '-new', object);
	    };
	    CercaService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.cercaStorage + "-new");
	        return JSON.parse(item);
	    };
	    CercaService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.cercaStorage + "-new");
	    };
	    CercaService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], CercaService);
	    return CercaService;
	}());
	exports.CercaService = CercaService;


/***/ },
/* 856 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{cercaModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{cercaModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{cercaModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div id=\"form_content\">\n        <div class=\"geo-content__row\">\n            <div class=\"geo-columns--12c\">\n                <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !nome.valid && submitted}\">\n                    <label for=\"nome\">Nome <abbr>*</abbr></label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!nome.valid && submitted\">Este campo é obrigatório.</span>\n                        <input type=\"text\" id=\"nome\" formControlName=\"nome\" [(ngModel)]=\"formObject.nome\">\n                    </div>\n                </div>\n                <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !raio.valid && submitted}\">\n                    <label for=\"raio\">Raio (m) <abbr>*</abbr></label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!raio.valid && submitted\">Este campo é obrigatório.</span>\n                        <input type=\"number\" id=\"raio\" formControlName=\"raio\" [(ngModel)]=\"formObject.raio\" (blur)=\"blurRadius()\">\n                    </div>\n                </div>\n                <div class=\"geo-input--6c\">\n                    <label for=\"tipo\">Tipo </label>\n                    <div>\n                        <input type=\"text\" id=\"tipo\" formControlName=\"tipo\" [(ngModel)]=\"formObject.tipo\">\n                    </div>\n                </div>\n                <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !latitude.valid && submitted}\">\n                    <label for=\"latitude\">Latitude <abbr>*</abbr></label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!latitude.valid && submitted\">Este campo é obrigatório.</span>\n                        <input type=\"text\" id=\"latitude\" formControlName=\"latitude\" [(ngModel)]=\"formObject.latitude\" (blur)=\"blurLatLng()\">\n                    </div>\n                </div>\n                <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !longitude.valid && submitted}\">\n                    <label for=\"longitude\">Longitude <abbr>*</abbr></label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!longitude.valid && submitted\">Este campo é obrigatório.</span>\n                        <input type=\"text\" id=\"longitude\" formControlName=\"longitude\" [(ngModel)]=\"formObject.longitude\" (blur)=\"blurLatLng()\">\n                    </div>\n                </div>\n            </div>\n\n            <button type=\"submit\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n\n        </div>\n    </div>\n\n    <div id=\"drawOptions\">\n        <a class=\"cursor-pointer link-button\" id=\"btnHandDraw\" title=\"Mover mapa\">\n            <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-hand'/></svg>\n        </a>\n\n        <a class=\"cursor-pointer link-button\" id=\"btnDraw\" title=\"Adicionar cerca\">\n            <div></div>\n        </a>\n\n        <a class=\"cursor-pointer link-button\" id=\"btnRemoveDraw\" title=\"Remover cerca\">\n            <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n        </a>\n    </div>\n\n    <input id=\"pac-input\" class=\"controls\" type=\"text\" placeholder=\"Pesquisar lugar\">\n\n    <div id=\"map-container\">\n        <div id=\"map\"></div>\n    </div>\n\n</form>\n";

/***/ },
/* 857 */
/***/ function(module, exports) {

	module.exports = "#map-container {\n    position: relative;\n    margin: 12px 0;\n    height: calc(100vh - 14rem);\n}\n\n#map {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n#form_content {\n    margin-top: 10px;\n    margin-right: 10px;\n    background-color: #fff;\n    border-radius: 2px;\n    box-shadow: rgba(0, 0, 0, 0.298039) 0 1px 4px -1px;\n    display: inline-block;\n    overflow: hidden;\n    position: relative;\n    font-family: Roboto, Arial, sans-serif;\n    font-size: 14px;\n    color: rgb(86, 86, 86);\n    width: 300px;\n}\n#form_content .geo-input--12c,\n#form_content .geo-input--6c {\n    margin-bottom: 10px;\n    margin-right: 0;\n}\n#form_content .geo-input--12c {\n    width: 100%;\n}\n#form_content .geo-input--6c {\n    width: 49%;\n}\n#form_content .geo-button {\n    font-size: 14px;\n}\n\n#pac-input {\n    background-color: #fff;\n    font-family: Roboto;\n    font-size: 15px;\n    font-weight: 300;\n    margin-right: 10px;\n    padding: 0 11px 0 13px;\n    text-overflow: ellipsis;\n    width: 350px;\n    margin-top: 10px;\n    border: 1px solid transparent;\n    border-radius: 2px 0 0 2px;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    height: 32px;\n    outline: none;\n    box-shadow: rgba(0, 0, 0, 0.298039) 0 1px 4px -1px;\n}\n.pac-container {\n    font-family: Roboto;\n}\n#type-selector {\n    color: #fff;\n    background-color: #4d90fe;\n    padding: 5px 11px 0px 11px;\n}\n#type-selector label {\n    font-family: Roboto;\n    font-size: 13px;\n    font-weight: 300;\n}\n#target {\n    width: 345px;\n}\n\n.link-button {\n    display: inline-block;\n    padding: 6px 6px 0;\n    background-color: #FFF;\n    color: #BCC0C7;\n    border: 1px solid #BCC0C7;\n}\n.link-button span {\n    position: relative;\n    top: -6px;\n}\n.link-button svg {\n    width: 16px;\n    height: 16px;\n    fill: #9d9fa2;\n    position: relative;\n    top: -2px;\n}\n\n#drawOptions {\n    background-color: #fff;\n    margin-right: 10px;\n    padding: 0 4px;\n    margin-top: 10px;\n    border: 1px solid transparent;\n    border-radius: 2px 0 0 2px;\n    box-shadow: rgba(0, 0, 0, 0.298039) 0 1px 4px -1px;\n}\n#drawOptions a {\n    border: none;\n    background-color: transparent;\n    min-width: 27px;\n    text-align: center;\n    line-height: 16px;\n    display: inline-block;\n}\n#drawOptions a:first-child {\n    border-right: 1px solid #f3eded;\n}\n#drawOptions a:last-child {\n    border-left: 1px solid #f3eded;\n}\n#drawOptions a svg {\n    fill: rgb(86, 86, 86);\n}\n#drawOptions a.active {\n    font-weight: 500;\n    color: rgb(0, 0, 0);\n}\n#drawOptions #btnDraw div {\n    border-radius: 50%;\n    background-color: #b5b5b5;\n    width: 12px;\n    height: 12px;\n    border: 1px solid #888686;\n    position: relative;\n    top: -2px;\n    left: 6px;\n}"

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(819);
	var cerca_api_service_1 = __webpack_require__(854);
	var cerca_navigation_service_1 = __webpack_require__(820);
	var cerca_service_1 = __webpack_require__(855);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(813);
	var data_service_3 = __webpack_require__(178);
	var rastreamento_service_1 = __webpack_require__(827);
	var CercaListComponent = (function () {
	    function CercaListComponent(_cercasApiService, _cercasService, _cercaNavigationService, _rastreamentoService, _utilService) {
	        this._cercasApiService = _cercasApiService;
	        this._cercasService = _cercasService;
	        this._cercaNavigationService = _cercaNavigationService;
	        this._rastreamentoService = _rastreamentoService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.cercasModuleName = data_service_1.cercaModuleName;
	        this.module = data_service_2.rastreamentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	    }
	    CercaListComponent.prototype.ngOnInit = function () {
	        this.getAll();
	    };
	    CercaListComponent.prototype.clickNew = function () {
	        this._cercasService.clearSessionStorage();
	        this._cercaNavigationService.goToNew();
	    };
	    CercaListComponent.prototype.clickEdit = function (item) {
	        this._cercasService.clearSessionStorage();
	        this._cercaNavigationService.goToEdit(item.id);
	    };
	    CercaListComponent.prototype.clickGoToConfig = function () {
	        this._rastreamentoService.goToSetting();
	    };
	    CercaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    CercaListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            this.loading = false;
	        }.bind(this));
	        this._cercasApiService.onGetAll(onDone);
	    };
	    CercaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._cercasApiService.onDelete(item.id, onDone);
	    };
	    CercaListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(859),
	            styles: [__webpack_require__(860)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof cerca_api_service_1.CercaApiService !== 'undefined' && cerca_api_service_1.CercaApiService) === 'function' && _a) || Object, (typeof (_b = typeof cerca_service_1.CercaService !== 'undefined' && cerca_service_1.CercaService) === 'function' && _b) || Object, (typeof (_c = typeof cerca_navigation_service_1.CercaNavigationService !== 'undefined' && cerca_navigation_service_1.CercaNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], CercaListComponent);
	    return CercaListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.CercaListComponent = CercaListComponent;


/***/ },
/* 859 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{cercasModuleName.plural}}</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>{{cercasModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhuma {{cercasModuleName.single | lowercase}} cadastrada</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Nome</th>\n            <th>Tipo</th>\n            <th>Raio</th>\n            <th>Lat/Lng</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filter:listFilter.value:['nome','tipo','raio','latitude','longitude'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td>{{item.nome}}</td>\n            <td>{{item.tipo | capitalize}}</td>\n            <td>{{item.raio}}m</td>\n            <td>{{item.latitude}} / {{item.longitude}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 860 */
166,
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var AlarmesComponent = (function () {
	    function AlarmesComponent() {
	    }
	    AlarmesComponent.prototype.ngOnInit = function () {
	    };
	    AlarmesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(862)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AlarmesComponent);
	    return AlarmesComponent;
	}());
	exports.AlarmesComponent = AlarmesComponent;


/***/ },
/* 862 */
171,
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var alarme_form_component_1 = __webpack_require__(864);
	var data_service_1 = __webpack_require__(178);
	var alarme_list_component_1 = __webpack_require__(873);
	var AlarmeRoutingModule = (function () {
	    function AlarmeRoutingModule() {
	    }
	    AlarmeRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AlarmeRoutingModule);
	    return AlarmeRoutingModule;
	}());
	exports.AlarmeRoutingModule = AlarmeRoutingModule;
	exports.alarmeRoutes = [
	    {
	        path: '',
	        component: alarme_list_component_1.AlarmeListComponent
	    }, {
	        path: data_service_1.editRoute + '/:id',
	        component: alarme_form_component_1.AlarmeFormComponent
	    }, {
	        path: data_service_1.newRoute,
	        component: alarme_form_component_1.AlarmeFormComponent
	    }
	];


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/12/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(821);
	var data_service_2 = __webpack_require__(178);
	var alarme_model_1 = __webpack_require__(865);
	var alarme_api_service_1 = __webpack_require__(866);
	var alarme_service_1 = __webpack_require__(867);
	var alarme_navigation_service_1 = __webpack_require__(822);
	var rastreamento_service_1 = __webpack_require__(827);
	var data_service_3 = __webpack_require__(813);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_service_1 = __webpack_require__(203);
	var data_service_4 = __webpack_require__(154);
	var cerca_api_service_1 = __webpack_require__(854);
	var email_validation_1 = __webpack_require__(91);
	var template_api_service_1 = __webpack_require__(868);
	var template_service_1 = __webpack_require__(870);
	var AlarmeFormComponent = (function () {
	    function AlarmeFormComponent(_route, _utilService, _alarmeservice, _alarmeApiService, _alarmeNavigationService, _rastreamentoService, _frotaApiService, _frotaService, _cercaApiService, _templateApiService, _templateService, _fb) {
	        this._route = _route;
	        this._utilService = _utilService;
	        this._alarmeservice = _alarmeservice;
	        this._alarmeApiService = _alarmeApiService;
	        this._alarmeNavigationService = _alarmeNavigationService;
	        this._rastreamentoService = _rastreamentoService;
	        this._frotaApiService = _frotaApiService;
	        this._frotaService = _frotaService;
	        this._cercaApiService = _cercaApiService;
	        this._templateApiService = _templateApiService;
	        this._templateService = _templateService;
	        this._fb = _fb;
	        this.alarmeModule = data_service_1.alarmeModuleName;
	        this.formObject = new alarme_model_1.Alarme();
	        this.submitted = false;
	        this.submitted2 = false;
	        this.btnSaveDisabled = false;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.module = data_service_3.rastreamentosModuleName;
	        this.loadingEvent = true;
	        this.eventsList = [];
	        this.eventObject = {};
	        this.loadingBens = true;
	        this.bensList = [];
	        this.bensObject = [];
	        this.loadingCercas = true;
	        this.cercasList = [];
	        this.cercasObject = [];
	        this.emailsObject = [];
	        this.templateObject = {};
	        this.ativo = new forms_1.FormControl('');
	        this.titulo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipoEvento = new forms_1.FormControl('', forms_1.Validators.required);
	        this.minimoVelocidade = new forms_1.FormControl('');
	        this.maximoVelocidade = new forms_1.FormControl('');
	        this.bens = new forms_1.FormControl([]);
	        this.cercas = new forms_1.FormControl([]);
	        this.email = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, email_validation_1.EmailValidator.emailFormat]));
	        this.tabSelected = 'bens';
	        this.cloneBensObject = [];
	        this.cloneCercasObject = [];
	        this.cloneEmailsObject = [];
	        this.onDone = (function (Response) {
	            if (!Response.error) {
	                if (this.formObject.id) {
	                    this._utilService.swalMessageEditSuccess();
	                }
	                else {
	                    this._utilService.swalMessageAddSuccess();
	                }
	                this.goToList();
	            }
	            else {
	                this.btnSaveDisabled = false;
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this.form = _fb.group({
	            ativo: this.ativo,
	            titulo: this.titulo,
	            tipoEvento: this.tipoEvento,
	            minimoVelocidade: this.minimoVelocidade,
	            maximoVelocidade: this.maximoVelocidade,
	            bens: this.bens,
	            cercas: this.cercas
	        });
	        this.form2 = _fb.group({
	            email: this.email
	        });
	    }
	    AlarmeFormComponent.prototype.ngOnInit = function () {
	        this.getEvents();
	        this.getFrotas();
	        this.getCercas();
	        this.testSession();
	    };
	    AlarmeFormComponent.prototype.ngAfterViewInit = function () {
	        this.formObject.ativo = true;
	    };
	    AlarmeFormComponent.prototype.clickGoToList = function () {
	        this.goToList();
	    };
	    AlarmeFormComponent.prototype.clickCancel = function () {
	        this.goToList();
	    };
	    AlarmeFormComponent.prototype.clickSubmit = function () {
	        $('#submitForm').click();
	    };
	    AlarmeFormComponent.prototype.clickGoToConfig = function () {
	        this._rastreamentoService.goToSetting();
	    };
	    AlarmeFormComponent.prototype.setTab = function (tab) {
	        this.tabSelected = tab;
	    };
	    AlarmeFormComponent.prototype.isTab = function (tab) {
	        return (tab === this.tabSelected);
	    };
	    AlarmeFormComponent.prototype.clickRemoveEmail = function (index) {
	        this.emailsObject.splice(index, 1);
	    };
	    AlarmeFormComponent.prototype.changeEvent = function () {
	        if (this.eventObject.id) {
	            this.getTemplateByEvent();
	        }
	    };
	    AlarmeFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            this.btnSaveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (this.eventObject.id) {
	                object.tipoEvento = this.eventObject.id;
	            }
	            else {
	                this.btnSaveDisabled = false;
	                return false;
	            }
	            if (this.templateObject.id) {
	                object.templateId = this.templateObject.id;
	            }
	            object.Bens = this.formatOptionsAlarme(this.bensObject, this.cloneBensObject, 'bemId', 'id');
	            object.Cercas = this.formatOptionsAlarme(this.cercasObject, this.cloneCercasObject, 'cercaProjetoId', 'id');
	            object.Emails = this.formatOptionsAlarme(this.emailsObject, this.cloneEmailsObject, 'email', 'email');
	            if (this.formObject.id) {
	                this.onEditAlarme(object);
	            }
	            else {
	                this.onAddAlarme(object);
	            }
	        }
	    };
	    AlarmeFormComponent.prototype.onSubmit2 = function (evt) {
	        this.submitted2 = true;
	        if (evt.valid) {
	            this.emailsObject.push({ ativo: true, email: this.emailString });
	            this.submitted2 = false;
	        }
	    };
	    AlarmeFormComponent.prototype.onAddAlarme = function (object) {
	        this._alarmeApiService.onPost(object, this.onDone);
	    };
	    AlarmeFormComponent.prototype.onEditAlarme = function (object) {
	        this._alarmeApiService.onPut(object, this.onDone);
	    };
	    AlarmeFormComponent.prototype.getTemplateByEvent = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                if (Response.length) {
	                    this.templateObject = Response[0];
	                }
	                else {
	                    this._utilService.swalMessageWarningCustom("Nenhuma template encontrada para o evento selecionado!");
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        var query = {
	            where: {
	                tipoEvento: this.eventObject.id
	            }
	        };
	        this._templateApiService.onGetByQuery(query, onDone);
	    };
	    AlarmeFormComponent.prototype.getObject = function (id) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	                this.setModelToForm();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhum alarme encontrado com este id.');
	                this.goToList();
	            }
	        }.bind(this));
	        this._alarmeApiService.onGetById(id, onDone);
	    };
	    AlarmeFormComponent.prototype.getEvents = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.eventsList = Response;
	                this.setEvent();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	            this.loadingEvent = false;
	        }.bind(this));
	        this._alarmeApiService.onGetEvents(onDone);
	    };
	    AlarmeFormComponent.prototype.getFrotas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.bensList = Response;
	                if (this.bensObject.length) {
	                    this.setOptionsAlarme(this.bensList, this.bensObject, 'bemId');
	                }
	            }
	            this.loadingBens = false;
	        }.bind(this));
	        var query = this._utilService.cloneObject(data_service_4.frotasQueryComGPS);
	        query.where.ativo = true;
	        var veiculoCategoriaId = this._frotaService.getTipoVeiculo();
	        this._frotaApiService.onGetByCategoriaQuery(veiculoCategoriaId, query, onDone);
	    };
	    AlarmeFormComponent.prototype.getCercas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0, list = [];
	                for (x = 0, lenX = Response.length; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.cercasList = list;
	                if (this.cercasObject.length) {
	                    this.setOptionsAlarme(this.cercasList, this.cercasObject, 'cercaProjetoId');
	                }
	            }
	            this.loadingCercas = false;
	        }.bind(this));
	        this._cercaApiService.onGetAll(onDone);
	    };
	    AlarmeFormComponent.prototype.getBensAlarme = function (alarmeId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.bensObject = Response;
	                this.cloneBensObject = this._utilService.cloneObject(Response);
	                this.setOptionsAlarme(this.bensList, this.bensObject, 'bemId');
	            }
	        }.bind(this));
	        var query = {
	            where: {
	                ativo: true,
	                alarmeId: alarmeId
	            }
	        };
	        this._alarmeApiService.onGetByQueryBemAlarme(query, onDone);
	    };
	    AlarmeFormComponent.prototype.getCercasAlarme = function (alarmeId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.cercasObject = Response;
	                this.cloneCercasObject = this._utilService.cloneObject(Response);
	                this.setOptionsAlarme(this.cercasList, this.cercasObject, 'cercaProjetoId');
	            }
	        }.bind(this));
	        var query = {
	            where: {
	                ativo: true,
	                alarmeId: alarmeId
	            }
	        };
	        this._alarmeApiService.onGetByQueryCercaAlarme(query, onDone);
	    };
	    AlarmeFormComponent.prototype.getEmailsAlarme = function (alarmeId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.emailsObject = Response;
	                this.cloneEmailsObject = this._utilService.cloneObject(Response);
	            }
	        }.bind(this));
	        var query = {
	            where: {
	                ativo: true,
	                alarmeId: alarmeId
	            }
	        };
	        this._alarmeApiService.onGetByQueryEmailAlarme(query, onDone);
	    };
	    AlarmeFormComponent.prototype.setEvent = function () {
	        var x, lenX, t = this.eventObject.id;
	        if (!t) {
	            t = this.eventsList[0].id;
	        }
	        for (x = 0, lenX = this.eventsList.length; x < lenX; x++) {
	            if (this.eventsList[x].id === t) {
	                this.eventObject = this.eventsList[x];
	                break;
	            }
	        }
	    };
	    AlarmeFormComponent.prototype.setModelToForm = function () {
	        if (this.formObject.tipoEvento) {
	            this.eventObject = { id: this.formObject.tipoEvento };
	            this.setEvent();
	        }
	        delete this.formObject['template'];
	    };
	    AlarmeFormComponent.prototype.setOptionsAlarme = function (list1, list2, compare) {
	        var x, lenX, y, lenY;
	        for (x = 0, lenX = list1.length; x < lenX; x++) {
	            for (y = 0, lenY = list2.length; y < lenY; y++) {
	                if (list1[x].id === list2[y][compare]) {
	                    list2[y] = list1[x];
	                    break;
	                }
	            }
	        }
	    };
	    AlarmeFormComponent.prototype.formatOptionsAlarme = function (objectList, clone, att1, att2) {
	        var x, lenX, y, lenY, notFound, e, newList = [];
	        if (objectList.length) {
	            //se tiver no clone e object = n faz nada
	            //se tiver somente no object = add
	            //se nao tiver objeto e tiver no clone = remove
	            //add os elementos que permanecem/ou sao novos
	            for (x = 0, lenX = objectList.length; x < lenX; x++) {
	                newList.push((_a = {
	                        ativo: true
	                    },
	                    _a[att1] = objectList[x][att2],
	                    _a
	                ));
	            }
	            for (x = 0, lenX = clone.length; x < lenX; x++) {
	                notFound = true;
	                for (y = 0, lenY = newList.length; y < lenY; y++) {
	                    //add os elementos q ja estao cadastrados
	                    if (clone[x][att1] === newList[y][att1]) {
	                        notFound = false;
	                        newList[y] = clone[x];
	                        break;
	                    }
	                }
	                //add os que serao removidos para serem editados passando ativo=false
	                if (notFound) {
	                    e = clone[x];
	                    e.ativo = false;
	                    newList.push(e);
	                }
	            }
	        }
	        else {
	            //se for para remover todos os itens
	            for (x = 0, lenX = clone.length; x < lenX; x++) {
	                e = clone[x];
	                e.ativo = false;
	                newList.push(e);
	            }
	        }
	        return newList;
	        var _a;
	    };
	    AlarmeFormComponent.prototype.goToList = function () {
	        this._alarmeservice.clearSessionStorage();
	        this._alarmeNavigationService.goToList();
	    };
	    AlarmeFormComponent.prototype.testSession = function () {
	        var id = +this._route.snapshot.params['id'];
	        if (id) {
	            this.actionTitle = data_service_2.editRoute;
	            this.getObject(id);
	            this.getBensAlarme(id);
	            this.getCercasAlarme(id);
	            this.getEmailsAlarme(id);
	        }
	        else {
	            this.actionTitle = data_service_2.newRoute;
	        }
	    };
	    AlarmeFormComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(871),
	            styles: [__webpack_require__(872)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof alarme_service_1.Alarmeservice !== 'undefined' && alarme_service_1.Alarmeservice) === 'function' && _c) || Object, (typeof (_d = typeof alarme_api_service_1.AlarmeApiService !== 'undefined' && alarme_api_service_1.AlarmeApiService) === 'function' && _d) || Object, (typeof (_e = typeof alarme_navigation_service_1.AlarmeNavigationService !== 'undefined' && alarme_navigation_service_1.AlarmeNavigationService) === 'function' && _e) || Object, (typeof (_f = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _f) || Object, (typeof (_g = typeof frota_api_service_1.FrotaApiService !== 'undefined' && frota_api_service_1.FrotaApiService) === 'function' && _g) || Object, (typeof (_h = typeof frota_service_1.FrotasService !== 'undefined' && frota_service_1.FrotasService) === 'function' && _h) || Object, (typeof (_j = typeof cerca_api_service_1.CercaApiService !== 'undefined' && cerca_api_service_1.CercaApiService) === 'function' && _j) || Object, (typeof (_k = typeof template_api_service_1.TemplateApiService !== 'undefined' && template_api_service_1.TemplateApiService) === 'function' && _k) || Object, (typeof (_l = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _l) || Object, (typeof (_m = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _m) || Object])
	    ], AlarmeFormComponent);
	    return AlarmeFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
	}());
	exports.AlarmeFormComponent = AlarmeFormComponent;


/***/ },
/* 865 */
/***/ function(module, exports) {

	"use strict";
	var Alarme = (function () {
	    function Alarme() {
	    }
	    return Alarme;
	}());
	exports.Alarme = Alarme;
	var BemAlarme = (function () {
	    function BemAlarme() {
	    }
	    return BemAlarme;
	}());
	exports.BemAlarme = BemAlarme;
	var CercaAlarme = (function () {
	    function CercaAlarme() {
	    }
	    return CercaAlarme;
	}());
	exports.CercaAlarme = CercaAlarme;
	var EmailAlarme = (function () {
	    function EmailAlarme() {
	    }
	    return EmailAlarme;
	}());
	exports.EmailAlarme = EmailAlarme;
	var TemplateAlarme = (function () {
	    function TemplateAlarme() {
	    }
	    return TemplateAlarme;
	}());
	exports.TemplateAlarme = TemplateAlarme;


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(821);
	var rest_service_1 = __webpack_require__(26);
	var AlarmeApiService = (function () {
	    function AlarmeApiService(_restService) {
	        this._restService = _restService;
	    }
	    AlarmeApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    AlarmeApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    AlarmeApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    AlarmeApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "titulo", "include": ["template"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    AlarmeApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { "include": ["template"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    AlarmeApiService.prototype.onGetEvents = function (done) {
	        this._restService.onGetSemSchema(data_service_1.apiName + '/listar-tipos-eventos', done);
	    };
	    AlarmeApiService.prototype.onGetVariaveisAlarme = function (done) {
	        this._restService.onGetSemSchema(data_service_1.apiName + '/listar-variaveis-templates', done);
	    };
	    AlarmeApiService.prototype.onGetPopulate = function (done) {
	        var filter = { "order": "titulo", "include": ["template"] };
	        this._restService.onGetPostCustom(data_service_1.apiName + '/populado', filter, done);
	    };
	    //bem alarme
	    AlarmeApiService.prototype.onGetByQueryBemAlarme = function (query, done) {
	        this._restService.onGetPost(data_service_1.apiBemAlarme, query, done);
	    };
	    //cerca alarme
	    AlarmeApiService.prototype.onGetByQueryCercaAlarme = function (query, done) {
	        this._restService.onGetPost(data_service_1.apiCercaAlarme, query, done);
	    };
	    //email alarme
	    AlarmeApiService.prototype.onGetByQueryEmailAlarme = function (query, done) {
	        this._restService.onGetPost(data_service_1.apiEmailAlarme, query, done);
	    };
	    AlarmeApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], AlarmeApiService);
	    return AlarmeApiService;
	    var _a;
	}());
	exports.AlarmeApiService = AlarmeApiService;


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(821);
	var Alarmeservice = (function () {
	    function Alarmeservice() {
	    }
	    //session
	    Alarmeservice.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.alarmestorage + '-new', object);
	    };
	    Alarmeservice.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.alarmestorage + "-new");
	        return JSON.parse(item);
	    };
	    Alarmeservice.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.alarmestorage + "-new");
	    };
	    Alarmeservice = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], Alarmeservice);
	    return Alarmeservice;
	}());
	exports.Alarmeservice = Alarmeservice;


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(869);
	var rest_service_1 = __webpack_require__(26);
	var TemplateApiService = (function () {
	    function TemplateApiService(_restService) {
	        this._restService = _restService;
	    }
	    TemplateApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    TemplateApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    TemplateApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    TemplateApiService.prototype.onGetByQuery = function (query, done) {
	        query.order = "titulo";
	        this._restService.onGetPost(data_service_1.apiName, query, done);
	    };
	    TemplateApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    TemplateApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    TemplateApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], TemplateApiService);
	    return TemplateApiService;
	    var _a;
	}());
	exports.TemplateApiService = TemplateApiService;


/***/ },
/* 869 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'templates';
	exports.templateStorage = 'template';
	exports.templateQuery = {
	    "where": {
	        "ativo": true,
	        "nome": { "regexp": "/REPLACEHERE/i" }
	    },
	    "order": "nome"
	};


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var autocomplete_service_1 = __webpack_require__(101);
	var data_service_1 = __webpack_require__(869);
	var TemplateService = (function () {
	    function TemplateService(_router, _autocompleteService) {
	        this._router = _router;
	        this._autocompleteService = _autocompleteService;
	    }
	    //session
	    TemplateService.prototype.setSessionStorage = function (item) {
	        var object = JSON.stringify(item);
	        sessionStorage.setItem(data_service_1.templateStorage + '-new', object);
	    };
	    TemplateService.prototype.getSessionStorage = function () {
	        var item = sessionStorage.getItem(data_service_1.templateStorage + "-new");
	        return JSON.parse(item);
	    };
	    TemplateService.prototype.clearSessionStorage = function () {
	        sessionStorage.removeItem(data_service_1.templateStorage + "-new");
	    };
	    TemplateService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _b) || Object])
	    ], TemplateService);
	    return TemplateService;
	    var _a, _b;
	}());
	exports.TemplateService = TemplateService;


/***/ },
/* 871 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <ul class=\"geo-breadcrumb\">\n        <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n        <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n        <li class=\"item\"><a (click)=\"clickGoToList()\" class=\"cursor-pointer\">{{alarmeModule.plural}}</a></li>\n        <li class=\"item\"><a class=\"active\">{{actionTitle | capitalize}} {{alarmeModule.single | lowercase}}</a></li>\n    </ul>\n    <h1>{{actionTitle | capitalize}} {{alarmeModule.single | lowercase}}</h1>\n</div>\n\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form)\" novalidate>\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-columns--12c noMargin\">\n            <div class=\"geo-input--6c\" [ngClass]=\"{'geo-input--error': !titulo.valid && submitted}\">\n                <label for=\"titulo\">Título <abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!titulo.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"titulo\" formControlName=\"titulo\" [(ngModel)]=\"formObject.titulo\">\n                </div>\n            </div>\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipoEvento.valid && submitted}\">\n                <label for=\"tipoEvento\">Eventos <abbr>*</abbr></label>\n                <div class=\"containerSpinner\">\n                    <span class=\"error-alert\" *ngIf=\"!tipoEvento.valid && submitted\">Este campo é obrigatório.</span>\n                    <spinner-component *ngIf=\"loadingEvent\"></spinner-component>\n                    <select id=\"tipoEvento\" [(ngModel)]=\"eventObject\" formControlName=\"tipoEvento\" class=\"option_{{eventObject.id}}\" (ngModelChange)=\"changeEvent()\">\n                        <option *ngFor=\"let item of eventsList\" [ngValue]=\"item\">{{item.titulo}}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <button type=\"submit\" id=\"submitForm\" class=\"geo-button button-remove-margin-left hidden\" >Salvar</button>\n</form>\n<div class=\"geo-content__row\">\n    <nav class=\"geo-tabs\">\n        <ul class=\"items\">\n            <li class=\"item\">\n                <a (click)=\"setTab('bens')\" [ngClass]=\"{'active': isTab('bens')}\" class=\"item-link\">Veículos</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('cercas')\" [ngClass]=\"{'active': isTab('cercas')}\" class=\"item-link\">Cercas</a>\n            </li>\n            <li class=\"item\">\n                <a (click)=\"setTab('notificacoes')\" [ngClass]=\"{'active': isTab('notificacoes')}\" class=\"item-link\">Notificações</a>\n            </li>\n            <!--<li class=\"item\">-->\n                <!--<a (click)=\"setTab('outros')\" [ngClass]=\"{'active': isTab('outros')}\" class=\"item-link\">Outros</a>-->\n            <!--</li>-->\n        </ul>\n    </nav>\n\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('bens')\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\">\n                <label for=\"bens\">Selecione os veículos</label>\n                <div class=\"containerSpinner\">\n                    <spinner-component *ngIf=\"loadingBens\"></spinner-component>\n                    <select id=\"bens\" multiple [(ngModel)]=\"bensObject\">\n                        <option *ngFor=\"let item of bensList\" [ngValue]=\"item\"><span *ngIf=\"item.placa\">{{item.placa | licensePlateMask}} / </span>{{item.identificacao}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <span>Aperte \"Ctrl\" para selecionar múltiplos veículos</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('cercas')\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\">\n                <label for=\"cercas\">Selecione as cercas </label>\n                <div class=\"containerSpinner\">\n                    <spinner-component *ngIf=\"loadingCercas\"></spinner-component>\n                    <select id=\"cercas\" multiple [(ngModel)]=\"cercasObject\">\n                        <option *ngFor=\"let item of cercasList\" [ngValue]=\"item\">{{item.nome}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <span>Aperte \"Ctrl\" para selecionar múltiplas cercas</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('notificacoes')\">\n        <form [formGroup]=\"form2\" (ngSubmit)=\"onSubmit2(form2)\" novalidate>\n            <div class=\"geo-columns--12c\">\n                <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !email.valid && submitted2}\">\n                    <label for=\"email\">Email </label>\n                    <div>\n                        <span class=\"error-alert\" *ngIf=\"!email.valid && submitted2\">Email inválido.</span>\n                        <input type=\"email\" id=\"email\" [(ngModel)]=\"emailString\" formControlName=\"email\">\n                    </div>\n                </div>\n\n                <div class=\"geo-input--3c\">\n                    <button type=\"submit\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\">Adicionar email</button>\n                </div>\n            </div>\n        </form>\n\n        <table>\n            <thead>\n            <tr>\n                <th>Email</th>\n                <th class=\"small\"></th>\n            </tr>\n            </thead>\n            <tbody *ngIf=\"!emailsObject || emailsObject.length === 0\">\n            <tr>\n                <td colspan=\"2\">Nenhum email informado</td>\n            </tr>\n            </tbody>\n            <tbody *ngFor=\"let item of emailsObject; let i=index\">\n            <tr>\n                <td><span *ngIf=\"item.email\">{{item.email}}</span></td>\n                <td class=\"geo-table--action\">\n                    <a (click)=\"clickRemoveEmail(i)\">\n                        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                    </a>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class=\"geo-columns--12c\" *ngIf=\"isTab('outros')\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--3c\">\n                <label for=\"minimoVelocidade\">Velocidade mínima (km)</label>\n                <div>\n                    <input type=\"text\" id=\"minimoVelocidade\" maxlength=\"3\" appNumberInteger [(ngModel)]=\"formObject.minimoVelocidade\">\n                </div>\n            </div>\n            <div class=\"geo-input--3c\">\n                <label for=\"maximoVelocidade\">Velocidade máxima (km) </label>\n                <div>\n                    <input type=\"text\" id=\"maximoVelocidade\" maxlength=\"3\" appNumberInteger [(ngModel)]=\"formObject.maximoVelocidade\">\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <button type=\"button\" class=\"geo-button button-remove-margin-left\" (click)=\"clickSubmit()\" [disabled]=\"btnSaveDisabled\">Salvar</button>\n    <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"clickCancel()\">Cancelar</button>\n</div>\n";

/***/ },
/* 872 */
/***/ function(module, exports) {

	module.exports = ".containerSpinner {\n    position: relative;\n}\nspinner-component {\n    position: absolute;\n    top: -5px;\n    right: 12px;\n}\n\nselect[multiple] {\n    min-height: 300px;\n    line-height: 12px;\n}\nselect[multiple] option {\n    padding: 2px;\n}\n\nselect[multiple] option.select {\n    background-color: red;\n    color: #fff;\n}\n\n.icon {\n    position: relative;\n    top: 5px;\n}\n\n.hidden {\n    visibility: hidden;\n    margin: 0;\n    padding: 0;\n    height: 1px;\n    position: absolute;\n}\n\n.noMargin .geo-input--6c,\n.noMargin .geo-input--3c {\n    margin-bottom: 0;\n}"

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(821);
	var alarme_api_service_1 = __webpack_require__(866);
	var alarme_navigation_service_1 = __webpack_require__(822);
	var alarme_service_1 = __webpack_require__(867);
	var util_service_1 = __webpack_require__(88);
	var data_service_2 = __webpack_require__(813);
	var data_service_3 = __webpack_require__(178);
	var rastreamento_service_1 = __webpack_require__(827);
	var AlarmeListComponent = (function () {
	    function AlarmeListComponent(_alarmesApiService, _alarmesService, _alarmeNavigationService, _rastreamentoService, _utilService) {
	        this._alarmesApiService = _alarmesApiService;
	        this._alarmesService = _alarmesService;
	        this._alarmeNavigationService = _alarmeNavigationService;
	        this._rastreamentoService = _rastreamentoService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.loading = true;
	        this.showDisabled = false;
	        this.alarmesModuleName = data_service_1.alarmeModuleName;
	        this.module = data_service_2.rastreamentosModuleName;
	        this.configuracaoModule = data_service_3.configuracaoModuleName;
	        this.typesList = [];
	    }
	    AlarmeListComponent.prototype.ngOnInit = function () {
	        this.getTypes();
	        this.getAll();
	    };
	    AlarmeListComponent.prototype.clickNew = function () {
	        this._alarmesService.clearSessionStorage();
	        this._alarmeNavigationService.goToNew();
	    };
	    AlarmeListComponent.prototype.clickEdit = function (item) {
	        this._alarmesService.clearSessionStorage();
	        this._alarmeNavigationService.goToEdit(item.id);
	    };
	    AlarmeListComponent.prototype.clickGoToConfig = function () {
	        this._rastreamentoService.goToSetting();
	    };
	    AlarmeListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    AlarmeListComponent.prototype.getAll = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.list = Response;
	            }
	            if (this.typesList.length) {
	                this.setList();
	            }
	        }.bind(this));
	        this._alarmesApiService.onGetPopulate(onDone);
	    };
	    AlarmeListComponent.prototype.getTypes = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.typesList = Response;
	                if (this.list.length) {
	                    this.setList();
	                }
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	            this.loadingType = false;
	        }.bind(this));
	        this._alarmesApiService.onGetEvents(onDone);
	    };
	    AlarmeListComponent.prototype.setList = function () {
	        var x, lenX, y, lenY;
	        for (x = 0, lenX = this.list.length; x < lenX; x++) {
	            for (y = 0, lenY = this.typesList.length; y < lenY; y++) {
	                if (this.list[x].tipoEvento === this.typesList[y].id) {
	                    this.list[x].tipoEvento = this.typesList[y];
	                    break;
	                }
	            }
	        }
	        this.loading = false;
	    };
	    AlarmeListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._alarmesApiService.onDelete(item.id, onDone);
	    };
	    AlarmeListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(874),
	            styles: [__webpack_require__(875)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof alarme_api_service_1.AlarmeApiService !== 'undefined' && alarme_api_service_1.AlarmeApiService) === 'function' && _a) || Object, (typeof (_b = typeof alarme_service_1.Alarmeservice !== 'undefined' && alarme_service_1.Alarmeservice) === 'function' && _b) || Object, (typeof (_c = typeof alarme_navigation_service_1.AlarmeNavigationService !== 'undefined' && alarme_navigation_service_1.AlarmeNavigationService) === 'function' && _c) || Object, (typeof (_d = typeof rastreamento_service_1.RastreamentoService !== 'undefined' && rastreamento_service_1.RastreamentoService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], AlarmeListComponent);
	    return AlarmeListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AlarmeListComponent = AlarmeListComponent;


/***/ },
/* 874 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--12c\">\n        <ul class=\"geo-breadcrumb\">\n            <li class=\"item\"><a class=\"active\">{{module.plural}}</a></li>\n            <li class=\"item pipe\"><a (click)=\"clickGoToConfig()\" class=\"cursor-pointer\">{{configuracaoModule.plural}}</a></li>\n            <li class=\"item\"><a class=\"active\">{{alarmesModuleName.plural}}</a></li>\n        </ul>\n    </div>\n\n    <div class=\"geo-columns--3c\">\n        <h1>{{alarmesModuleName.plural}}</h1>\n\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Exibir inativos:</span>\n            <input type=\"checkbox\" [(ngModel)]=\"showDisabled\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n    </div>\n    <div class=\"geo-columns--9c geo-columns--right geo-columns--middle\">\n        <div class=\"geo-input--4c geo-input--search\">\n            <div>\n                <input type=\"text\" #listFilter (keyup)=\"0\" placeholder=\"Pesquisar\">\n            </div>\n        </div>\n        <a (click)=\"clickNew()\" class=\"geo-button--action geo-button__icon--add\">Novo</a>\n    </div>\n</div>\n<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{alarmesModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Título</th>\n            <th>Evento</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['titulo','tipoEvento'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.titulo}}</td>\n            <td><span *ngIf=\"item.tipoEvento\">{{item.tipoEvento.titulo}}</span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div class=\"geo-content__row\">\n                    <div class=\"geo-columns--12c\">\n                        <p><strong>Emails para notificação</strong></p>\n                        <p *ngFor=\"let e of item.Emails\">{{e.email}}</p>\n                        <p *ngIf=\"!item.Emails.length\">Nenhum email informado</p>\n                    </div>\n                    <div class=\"geo-columns--6c\">\n                        <p><strong>Veículos</strong></p>\n                        <p *ngFor=\"let v of item.Bens\"><span *ngIf=\"v.bem\"><span *ngIf=\"v.bem.placa\">{{v.bem.placa | licensePlateMask}} / </span> {{v.bem.identificacao}}</span></p>\n                        <p *ngIf=\"!item.Bens.length\">Nenhum veículo informado</p>\n                    </div>\n                    <div class=\"geo-columns--6c\">\n                        <p><strong>Cercas</strong></p>\n                        <p *ngFor=\"let c of item.Cercas\"><span *ngIf=\"c.cercaProjeto\"> {{c.cercaProjeto.nome}}</span></p>\n                        <p *ngIf=\"!item.Cercas.length\">Nenhuma cerca informada</p>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 875 */
166,
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var pessoas_module_1 = __webpack_require__(877);
	var recursos_humanos_component_1 = __webpack_require__(170);
	var motoristas_module_1 = __webpack_require__(879);
	var funcionarios_module_1 = __webpack_require__(878);
	var recursos_humanos_routing_module_1 = __webpack_require__(880);
	var contatos_module_1 = __webpack_require__(881);
	var pessoa_juridica_module_1 = __webpack_require__(887);
	var usuarios_module_1 = __webpack_require__(891);
	var RecursosHumanosModule = (function () {
	    function RecursosHumanosModule() {
	    }
	    RecursosHumanosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                pessoas_module_1.PessoasModule,
	                motoristas_module_1.MotoristasModule,
	                funcionarios_module_1.FuncionariosModule,
	                contatos_module_1.ContatosModule,
	                pessoa_juridica_module_1.PessoaJuridicaModule,
	                usuarios_module_1.UsuariosModule,
	                recursos_humanos_routing_module_1.RecursosHumanosRoutingModule
	            ],
	            declarations: [
	                recursos_humanos_component_1.RecursosHumanosComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], RecursosHumanosModule);
	    return RecursosHumanosModule;
	}());
	exports.RecursosHumanosModule = RecursosHumanosModule;


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var pessoa_api_service_1 = __webpack_require__(176);
	var pessoas_component_1 = __webpack_require__(172);
	var pessoa_list_component_1 = __webpack_require__(175);
	var pessoas_routing_module_1 = __webpack_require__(174);
	var pessoa_form_component_1 = __webpack_require__(181);
	var pessoa_navigation_service_1 = __webpack_require__(177);
	var funcionarios_module_1 = __webpack_require__(878);
	var pessoa_service_1 = __webpack_require__(186);
	var PessoasModule = (function () {
	    function PessoasModule() {
	    }
	    PessoasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                funcionarios_module_1.FuncionariosModule,
	                pessoas_routing_module_1.PessoasRoutingModule
	            ],
	            providers: [
	                pessoa_api_service_1.PessoaApiService,
	                pessoa_navigation_service_1.PessoaNavigationService,
	                pessoa_service_1.PessoaService
	            ],
	            declarations: [
	                pessoas_component_1.PessoasComponent,
	                pessoa_list_component_1.PessoaListComponent,
	                pessoa_form_component_1.PessoaFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PessoasModule);
	    return PessoasModule;
	}());
	exports.PessoasModule = PessoasModule;


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var funcionario_service_1 = __webpack_require__(214);
	var funcionario_api_service_1 = __webpack_require__(184);
	var FuncionariosModule = (function () {
	    function FuncionariosModule() {
	    }
	    FuncionariosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                funcionario_api_service_1.FuncionarioApiService,
	                funcionario_service_1.FuncionarioService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FuncionariosModule);
	    return FuncionariosModule;
	}());
	exports.FuncionariosModule = FuncionariosModule;


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var motoristas_component_1 = __webpack_require__(221);
	var motoristas_routing_module_1 = __webpack_require__(207);
	var motorista_form_component_1 = __webpack_require__(212);
	var motorista_list_component_1 = __webpack_require__(208);
	var motorista_api_service_1 = __webpack_require__(209);
	var motorista_navigation_service_1 = __webpack_require__(187);
	var funcionarios_module_1 = __webpack_require__(878);
	var motorista_service_1 = __webpack_require__(188);
	var MotoristasModule = (function () {
	    function MotoristasModule() {
	    }
	    MotoristasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                funcionarios_module_1.FuncionariosModule,
	                motoristas_routing_module_1.MotoristasRoutingModule
	            ],
	            providers: [
	                motorista_api_service_1.MotoristaApiService,
	                motorista_navigation_service_1.MotoristaNavigationService,
	                motorista_service_1.MotoristaService
	            ],
	            declarations: [
	                motoristas_component_1.MotoristasComponent,
	                motorista_form_component_1.MotoristaFormComponent,
	                motorista_list_component_1.MotoristaListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MotoristasModule);
	    return MotoristasModule;
	}());
	exports.MotoristasModule = MotoristasModule;


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var RecursosHumanosRoutingModule = (function () {
	    function RecursosHumanosRoutingModule() {
	    }
	    RecursosHumanosRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], RecursosHumanosRoutingModule);
	    return RecursosHumanosRoutingModule;
	}());
	exports.RecursosHumanosRoutingModule = RecursosHumanosRoutingModule;


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var contato_tipo_api_service_1 = __webpack_require__(882);
	var contato_service_1 = __webpack_require__(276);
	var contato_form_component_1 = __webpack_require__(884);
	var ContatosModule = (function () {
	    function ContatosModule() {
	    }
	    ContatosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                contato_tipo_api_service_1.ContatoTipoApiService,
	                contato_service_1.ContatoTipoService
	            ],
	            declarations: [
	                contato_form_component_1.ContatoFormComponent
	            ],
	            exports: [
	                contato_form_component_1.ContatoFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContatosModule);
	    return ContatosModule;
	}());
	exports.ContatosModule = ContatosModule;


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rest_service_1 = __webpack_require__(26);
	var data_service_1 = __webpack_require__(883);
	var ContatoTipoApiService = (function () {
	    function ContatoTipoApiService(_restService) {
	        this._restService = _restService;
	    }
	    ContatoTipoApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    ContatoTipoApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    ContatoTipoApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    ContatoTipoApiService.prototype.onGetAll = function (done) {
	        var filter = { "where": { "ativo": true }, "order": "tipo" };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    ContatoTipoApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    ContatoTipoApiService.prototype.onGetApiUrl = function () {
	        return data_service_1.apiName;
	    };
	    ContatoTipoApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], ContatoTipoApiService);
	    return ContatoTipoApiService;
	    var _a;
	}());
	exports.ContatoTipoApiService = ContatoTipoApiService;


/***/ },
/* 883 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-contatos';


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var contato_tipo_api_service_1 = __webpack_require__(882);
	var contato_service_1 = __webpack_require__(276);
	var ContatoFormComponent = (function () {
	    function ContatoFormComponent(_contatoTipoApiService, _contatoTipoService) {
	        this._contatoTipoApiService = _contatoTipoApiService;
	        this._contatoTipoService = _contatoTipoService;
	        this.list = [];
	        this.tiposList = [];
	        this.isPhone = [];
	    }
	    ContatoFormComponent.prototype.ngAfterViewInit = function () {
	        this.getTipos();
	        if (!this.list.length) {
	            this.newContato();
	        }
	    };
	    ContatoFormComponent.prototype.clickAddNew = function () {
	        this.newContato();
	    };
	    ContatoFormComponent.prototype.changeTipo = function (item, i) {
	        this.setIsPhone(item.tipo.id, i);
	    };
	    ContatoFormComponent.prototype.clickRemove = function (index) {
	        this.list.splice(index, 1);
	    };
	    ContatoFormComponent.prototype.getTipos = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.tiposList = Response;
	                this.setTiposContatos();
	            }
	        }.bind(this));
	        this._contatoTipoApiService.onGetAll(onDone);
	    };
	    ContatoFormComponent.prototype.newContato = function () {
	        var object = { ativo: true, tipo: this.tiposList[0] };
	        this.list.push(object);
	        this.isPhone.push(true);
	    };
	    ContatoFormComponent.prototype.setIsPhone = function (tipoId, index) {
	        var tipo = false;
	        tipo = this._contatoTipoService.getTipoTelefoneCelular(tipoId);
	        if (tipo) {
	            this.isPhone[index] = true;
	        }
	        else {
	            this.isPhone[index] = false;
	        }
	    };
	    ContatoFormComponent.prototype.setTiposContatos = function () {
	        var x, lenX, y, lenY;
	        for (x = 0, lenX = this.list.length; x < lenX; x++) {
	            if (!this.list[x].tipoContatoId) {
	                this.list[x].tipoContatoId = this.tiposList[0].id;
	            }
	            for (y = 0, lenY = this.tiposList.length; y < lenY; y++) {
	                if (this.list[x].tipoContatoId === this.tiposList[y].id) {
	                    this.isPhone.push(true);
	                    this.setIsPhone(this.list[x].tipoContatoId, x);
	                    this.list[x].tipo = this.tiposList[y];
	                    break;
	                }
	            }
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], ContatoFormComponent.prototype, "list", void 0);
	    ContatoFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-contato-form',
	            template: __webpack_require__(885),
	            styles: [__webpack_require__(886)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof contato_tipo_api_service_1.ContatoTipoApiService !== 'undefined' && contato_tipo_api_service_1.ContatoTipoApiService) === 'function' && _a) || Object, (typeof (_b = typeof contato_service_1.ContatoTipoService !== 'undefined' && contato_service_1.ContatoTipoService) === 'function' && _b) || Object])
	    ], ContatoFormComponent);
	    return ContatoFormComponent;
	    var _a, _b;
	}());
	exports.ContatoFormComponent = ContatoFormComponent;


/***/ },
/* 885 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n  <h2>Contatos</h2>\n  <div class=\"geo-columns--12c\" *ngFor=\"let item of list; let i = index;\">\n    <div class=\"geo-input--3c\">\n      <label>Tipo </label>\n      <div>\n        <select id=\"tipo_{{i}}\" [(ngModel)]=\"item.tipo\" (ngModelChange)=\"changeTipo(item, i)\">\n          <option *ngFor=\"let item2 of tiposList\" [ngValue]=\"item2\">{{item2.tipo}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n      <label>Valor </label>\n      <div>\n        <input type=\"text\" [(ngModel)]=\"item.contato\" appPhoneMask maxlength=\"15\" *ngIf=\"isPhone[i]\">\n        <input type=\"text\" [(ngModel)]=\"item.contato\" *ngIf=\"!isPhone[i]\">\n      </div>\n    </div>\n    <a (click)=\"clickRemove(i)\" title=\"Remover\" class=\"icon\">\n      <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n    </a>\n  </div>\n\n  <button type=\"button\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickAddNew()\">Adicionar Contato</button>\n\n</div>\n";

/***/ },
/* 886 */
/***/ function(module, exports) {

	module.exports = ".icon {\n  position: relative;\n  top: 5px;\n}\n"

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var pessoa_juridica_form_component_1 = __webpack_require__(888);
	var pessoa_juridica_api_service_1 = __webpack_require__(758);
	var pessoa_juridica_service_1 = __webpack_require__(765);
	var PessoaJuridicaModule = (function () {
	    function PessoaJuridicaModule() {
	    }
	    PessoaJuridicaModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                pessoa_juridica_api_service_1.PessoaJuridicaApiService,
	                pessoa_juridica_service_1.PessoaJuridicaService
	            ],
	            declarations: [
	                pessoa_juridica_form_component_1.PessoaJuridicaFormComponent
	            ],
	            exports: [
	                pessoa_juridica_form_component_1.PessoaJuridicaFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PessoaJuridicaModule);
	    return PessoaJuridicaModule;
	}());
	exports.PessoaJuridicaModule = PessoaJuridicaModule;


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var pessoa_juridica_model_1 = __webpack_require__(764);
	var cnpj_validation_1 = __webpack_require__(106);
	var email_validation_1 = __webpack_require__(91);
	var phone_validation_1 = __webpack_require__(92);
	var PessoaJuridicaFormComponent = (function () {
	    function PessoaJuridicaFormComponent(_fb) {
	        this._fb = _fb;
	        this.formObject = new pessoa_juridica_model_1.PessoaJuridica();
	        this.submitted = false;
	        this.cnpj = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, cnpj_validation_1.CnpjValidator.cnpjFormat]));
	        this.email = new forms_1.FormControl('', forms_1.Validators.compose([email_validation_1.EmailValidator.emailFormat]));
	        this.razaoSocial = new forms_1.FormControl('', forms_1.Validators.required);
	        this.nomeFantasia = new forms_1.FormControl();
	        this.telefone = new forms_1.FormControl('', forms_1.Validators.compose([phone_validation_1.PhoneValidator.phoneFormat]));
	        this.ativo = new forms_1.FormControl('');
	        this.form = _fb.group({
	            ativo: this.ativo,
	            email: this.email,
	            cnpj: this.cnpj,
	            razaoSocial: this.razaoSocial,
	            telefone: this.telefone,
	            nomeFantasia: this.nomeFantasia
	        });
	    }
	    PessoaJuridicaFormComponent.prototype.ngOnInit = function () {
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PessoaJuridicaFormComponent.prototype, "formObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PessoaJuridicaFormComponent.prototype, "submitted", void 0);
	    PessoaJuridicaFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-pessoa-juridica-form',
	            template: __webpack_require__(889),
	            styles: [__webpack_require__(890)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _a) || Object])
	    ], PessoaJuridicaFormComponent);
	    return PessoaJuridicaFormComponent;
	    var _a;
	}());
	exports.PessoaJuridicaFormComponent = PessoaJuridicaFormComponent;


/***/ },
/* 889 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\" [formGroup]=\"form\">\n  <div class=\"geo-columns--12c\">\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!cnpj.valid && submitted) || (cnpj.errors && cnpj.errors.incorrectCnpjFormat)}\">\n      <label for=\"cnpj\">CNPJ <abbr>*</abbr></label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!cnpj.valid && submitted\">Este campo é obrigatório.</span>\n        <span class=\"error-alert\" *ngIf=\"submitted && cnpj.errors && cnpj.errors.incorrectCnpjFormat\">Formato incorreto.</span>\n        <input type=\"text\" id=\"cnpj\" placeholder=\"\" [(ngModel)]=\"formObject.cnpj\" formControlName=\"cnpj\" appCnpjMask maxlength=\"18\">\n      </div>\n    </div>\n\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !razaoSocial.valid && submitted}\">\n      <label for=\"razaoSocial\">Razão social <abbr>*</abbr></label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!razaoSocial.valid && submitted\">Este campo é obrigatório.</span>\n        <input type=\"text\" id=\"razaoSocial\" placeholder=\"\" [(ngModel)]=\"formObject.razaoSocial\" formControlName=\"razaoSocial\">\n      </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n      <label for=\"nomeFantasia \">Nome fantasia</label>\n      <div>\n        <input type=\"text\" id=\"nomeFantasia \" placeholder=\"\" [(ngModel)]=\"formObject.nomeFantasia \" formControlName=\"nomeFantasia\">\n      </div>\n    </div>\n\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !telefone.valid && submitted}\">\n      <label for=\"telefone\">Telefone</label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!telefone.valid && submitted\">Número de telefone inválido.</span>\n        <input type=\"text\" id=\"telefone\" [(ngModel)]=\"formObject.telefone\" maxlength=\"15\" appPhoneMask formControlName=\"telefone\">\n      </div>\n    </div>\n\n    <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !email.valid && submitted}\">\n      <label for=\"email\">Email</label>\n      <div>\n        <span class=\"error-alert\" *ngIf=\"!email.valid && submitted\">Email inválido.</span>\n        <input type=\"text\" id=\"email\" [(ngModel)]=\"formObject.email\" formControlName=\"email\">\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ },
/* 890 */
166,
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var usuarios_component_1 = __webpack_require__(693);
	var usuarios_routing_module_1 = __webpack_require__(689);
	var usuario_navigation_service_1 = __webpack_require__(892);
	var usuario_change_component_1 = __webpack_require__(690);
	var usuario_service_1 = __webpack_require__(85);
	var usuario_api_service_1 = __webpack_require__(86);
	var UsuariosModule = (function () {
	    function UsuariosModule() {
	    }
	    UsuariosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                usuarios_routing_module_1.UsuariosRoutingModule
	            ],
	            providers: [
	                usuario_navigation_service_1.UsuarioNavigationService,
	                usuario_api_service_1.UsuarioApiService,
	                usuario_service_1.UsuarioService
	            ],
	            declarations: [
	                usuarios_component_1.UsuariosComponent,
	                usuario_change_component_1.UsuarioChangeComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], UsuariosModule);
	    return UsuariosModule;
	}());
	exports.UsuariosModule = UsuariosModule;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(87);
	var auth_service_1 = __webpack_require__(61);
	var data_service_2 = __webpack_require__(145);
	var UsuarioNavigationService = (function () {
	    function UsuarioNavigationService(_authService) {
	        this._authService = _authService;
	        this.moduleRouter = data_service_1.usuariosRoute;
	        this.fatherRouter = data_service_2.recursosHumanosRoute;
	    }
	    UsuarioNavigationService.prototype.goToChange = function () {
	        var router = this.fatherRouter + '/' + this.moduleRouter + '/trocar';
	        this._authService.navigateTo(router);
	    };
	    UsuarioNavigationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], UsuarioNavigationService);
	    return UsuarioNavigationService;
	    var _a;
	}());
	exports.UsuarioNavigationService = UsuarioNavigationService;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var estruturas_component_1 = __webpack_require__(223);
	var enderecos_module_1 = __webpack_require__(894);
	var localidades_module_1 = __webpack_require__(902);
	var orgaos_module_1 = __webpack_require__(904);
	var areas_module_1 = __webpack_require__(905);
	var divisoes_module_1 = __webpack_require__(909);
	var setores_module_1 = __webpack_require__(910);
	var estruturas_routing_module_1 = __webpack_require__(914);
	var EstruturasModule = (function () {
	    function EstruturasModule() {
	    }
	    EstruturasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                enderecos_module_1.EnderecosModule,
	                localidades_module_1.LocalidadesModule,
	                orgaos_module_1.OrgaosModule,
	                areas_module_1.AreasModule,
	                divisoes_module_1.DivisoesModule,
	                setores_module_1.SetoresModule,
	                estruturas_routing_module_1.EstruturasRoutingModule
	            ],
	            declarations: [
	                estruturas_component_1.EstruturasComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], EstruturasModule);
	    return EstruturasModule;
	}());
	exports.EstruturasModule = EstruturasModule;


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var endereco_api_service_1 = __webpack_require__(230);
	var endereco_form_component_1 = __webpack_require__(895);
	var endereco_service_1 = __webpack_require__(229);
	var estado_api_service_1 = __webpack_require__(265);
	var cidade_api_service_1 = __webpack_require__(896);
	var tipo_logradouro_api_service_1 = __webpack_require__(898);
	var EnderecosModule = (function () {
	    function EnderecosModule() {
	    }
	    EnderecosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                endereco_api_service_1.EnderecoApiService,
	                endereco_api_service_1.EnderecoApiService,
	                endereco_service_1.EnderecoService,
	                estado_api_service_1.EstadoApiService,
	                cidade_api_service_1.CidadeApiService,
	                tipo_logradouro_api_service_1.TipoLogradouroApiService
	            ],
	            declarations: [
	                endereco_form_component_1.EnderecoFormComponent
	            ],
	            exports: [
	                endereco_form_component_1.EnderecoFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], EnderecosModule);
	    return EnderecosModule;
	}());
	exports.EnderecosModule = EnderecosModule;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var endereco_model_1 = __webpack_require__(240);
	var estado_api_service_1 = __webpack_require__(265);
	var cidade_api_service_1 = __webpack_require__(896);
	var tipo_logradouro_api_service_1 = __webpack_require__(898);
	var endereco_service_1 = __webpack_require__(229);
	var util_service_1 = __webpack_require__(88);
	var projeto_service_1 = __webpack_require__(52);
	var data_service_1 = __webpack_require__(50);
	var EnderecoFormComponent = (function () {
	    function EnderecoFormComponent(_estadoApiService, _cidadeApiService, _enderecoService, _tipoLogradouroApiService, _projetoService, _utilService, _dataService) {
	        this._estadoApiService = _estadoApiService;
	        this._cidadeApiService = _cidadeApiService;
	        this._enderecoService = _enderecoService;
	        this._tipoLogradouroApiService = _tipoLogradouroApiService;
	        this._projetoService = _projetoService;
	        this._utilService = _utilService;
	        this._dataService = _dataService;
	        this.formObject = new endereco_model_1.Endereco();
	        this.tipoLogradourosList = [];
	        this.estadosList = [];
	        this.cidadesList = [];
	        this.loadingCidade = false;
	        this.loadingEstado = true;
	        this.loadingTipoLogradouro = true;
	        this.project = {};
	    }
	    EnderecoFormComponent.prototype.ngOnInit = function () {
	        this.project = this._projetoService.getSessionStorage();
	        this.getEstados();
	        this.getTiposLogradouro();
	        this.initialize();
	    };
	    EnderecoFormComponent.prototype.initialize = function () {
	        var lat, lng;
	        if (this.formObject.coordenadaLatitude && this.formObject.coordenadaLongitude) {
	            lat = this.formObject.coordenadaLatitude;
	            lng = this.formObject.coordenadaLongitude;
	        }
	        else {
	            if (this.project) {
	                lat = this.project.latitude;
	                lng = this.project.longitude;
	            }
	            else {
	                var coord = this._dataService.getCoordinates();
	                lat = coord.lat;
	                lng = coord.lng;
	            }
	        }
	        this._enderecoService.initMap(lat, lng);
	    };
	    EnderecoFormComponent.prototype.changeEstado = function () {
	        this.getCidades();
	    };
	    EnderecoFormComponent.prototype.getGeocoding = function () {
	        var onDone = (function (response) {
	            if (response) {
	                this.formObject.coordenadaLatitude = this._utilService.cloneObject(response.lat);
	                this.formObject.coordenadaLongitude = this._utilService.cloneObject(response.lng);
	                var y = document.getElementById("coordenadaLatitude");
	                if (y) {
	                    y.value = response.lat;
	                }
	                y = document.getElementById("coordenadaLongitude");
	                if (y) {
	                    y.value = response.lng;
	                }
	            }
	        }.bind(this));
	        var f = this._enderecoService.getGeocodingAddress(this.formObject);
	        this._enderecoService.getGeocoding(f, onDone);
	    };
	    EnderecoFormComponent.prototype.getEstados = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.estadosList = Response;
	                if (this.formObject.id) {
	                    if (this.formObject.cidade && this.formObject.cidade.estado) {
	                        this.setEstado(this.formObject.cidade.estado.id);
	                    }
	                }
	                else {
	                    if (this.project) {
	                        this.setEstado(this.project.estadoId);
	                    }
	                    else {
	                        this.setEstado(this.estadosList[11].id);
	                    }
	                }
	                this.loadingEstado = false;
	                this.getCidades();
	            }
	        }.bind(this));
	        this._estadoApiService.onGetAll(onDone);
	    };
	    EnderecoFormComponent.prototype.getCidades = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.cidadesList = Response;
	                if (this.formObject.id) {
	                    if (this.formObject.cidade) {
	                        this.setCidade(this.formObject.cidade.id);
	                    }
	                }
	                else {
	                    if (this.project) {
	                        this.setCidade(this.project.cidadeId);
	                    }
	                    else {
	                        this.setCidade(this.cidadesList[0].id);
	                    }
	                }
	                this.loadingCidade = false;
	            }
	        }.bind(this));
	        var estado = this.formObject.estado;
	        if (estado) {
	            this.loadingCidade = true;
	            this._cidadeApiService.onGetByEstado(estado.id, onDone);
	        }
	    };
	    EnderecoFormComponent.prototype.getTiposLogradouro = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.tipoLogradourosList = Response;
	                if (this.formObject.id) {
	                    var x, lenX;
	                    for (x = 0, lenX = this.tipoLogradourosList.length; x < lenX; x++) {
	                        if (this.tipoLogradourosList[x].id === this.formObject.tipoLogradouroId) {
	                            this.formObject.tipoLogradouro = this.tipoLogradourosList[x];
	                            break;
	                        }
	                    }
	                }
	                else {
	                    this.formObject.tipoLogradouro = this.tipoLogradourosList[0];
	                }
	                this.loadingTipoLogradouro = false;
	            }
	        }.bind(this));
	        this._tipoLogradouroApiService.onGetAll(onDone);
	    };
	    EnderecoFormComponent.prototype.setEstado = function (estadoId) {
	        var x, lenX;
	        for (x = 0, lenX = this.estadosList.length; x < lenX; x++) {
	            if (this.estadosList[x].id === estadoId) {
	                this.formObject.estado = this.estadosList[x];
	                break;
	            }
	        }
	    };
	    EnderecoFormComponent.prototype.setCidade = function (cidadeId) {
	        var x, lenX;
	        for (x = 0, lenX = this.cidadesList.length; x < lenX; x++) {
	            if (this.cidadesList[x].id === cidadeId) {
	                this.formObject.cidade = this.cidadesList[x];
	                break;
	            }
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], EnderecoFormComponent.prototype, "formObject", void 0);
	    EnderecoFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-endereco-form',
	            template: __webpack_require__(900),
	            styles: [__webpack_require__(901)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof estado_api_service_1.EstadoApiService !== 'undefined' && estado_api_service_1.EstadoApiService) === 'function' && _a) || Object, (typeof (_b = typeof cidade_api_service_1.CidadeApiService !== 'undefined' && cidade_api_service_1.CidadeApiService) === 'function' && _b) || Object, (typeof (_c = typeof endereco_service_1.EnderecoService !== 'undefined' && endereco_service_1.EnderecoService) === 'function' && _c) || Object, (typeof (_d = typeof tipo_logradouro_api_service_1.TipoLogradouroApiService !== 'undefined' && tipo_logradouro_api_service_1.TipoLogradouroApiService) === 'function' && _d) || Object, (typeof (_e = typeof projeto_service_1.ProjetoService !== 'undefined' && projeto_service_1.ProjetoService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object, (typeof (_g = typeof data_service_1.DataService !== 'undefined' && data_service_1.DataService) === 'function' && _g) || Object])
	    ], EnderecoFormComponent);
	    return EnderecoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.EnderecoFormComponent = EnderecoFormComponent;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(897);
	var rest_service_1 = __webpack_require__(26);
	var CidadeApiService = (function () {
	    function CidadeApiService(_restService) {
	        this._restService = _restService;
	    }
	    CidadeApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    CidadeApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    CidadeApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    CidadeApiService.prototype.onGetByEstado = function (estadoId, done) {
	        var filter = { where: { estadoId: estadoId }, include: ["estado"] };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    CidadeApiService.prototype.onGetById = function (objectId, done) {
	        var filter = { include: ["estado"] };
	        this._restService.onGetPostId(data_service_1.apiName, objectId, filter, done);
	    };
	    CidadeApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], CidadeApiService);
	    return CidadeApiService;
	    var _a;
	}());
	exports.CidadeApiService = CidadeApiService;


/***/ },
/* 897 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'cidades';


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(899);
	var rest_service_1 = __webpack_require__(26);
	var TipoLogradouroApiService = (function () {
	    function TipoLogradouroApiService(_restService) {
	        this._restService = _restService;
	    }
	    TipoLogradouroApiService.prototype.onPost = function (object, done) {
	        this._restService.onPost(data_service_1.apiName, object, done);
	    };
	    TipoLogradouroApiService.prototype.onPut = function (object, done) {
	        this._restService.onPut(data_service_1.apiName, object, done);
	    };
	    TipoLogradouroApiService.prototype.onDelete = function (objectId, done) {
	        this._restService.onDelete(data_service_1.apiName, objectId, done);
	    };
	    TipoLogradouroApiService.prototype.onGetAll = function (done) {
	        var filter = { "order": "tipo", "where": { "ativo": true } };
	        this._restService.onGetPost(data_service_1.apiName, filter, done);
	    };
	    TipoLogradouroApiService.prototype.onGetById = function (objectId, done) {
	        this._restService.onGetPostId(data_service_1.apiName, objectId, {}, done);
	    };
	    TipoLogradouroApiService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rest_service_1.RestService !== 'undefined' && rest_service_1.RestService) === 'function' && _a) || Object])
	    ], TipoLogradouroApiService);
	    return TipoLogradouroApiService;
	    var _a;
	}());
	exports.TipoLogradouroApiService = TipoLogradouroApiService;


/***/ },
/* 899 */
/***/ function(module, exports) {

	"use strict";
	exports.apiName = 'tipos-logradouros';


/***/ },
/* 900 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n    <h2>Endereço</h2>\n    <div class=\"geo-input--3c\">\n        <label for=\"cep\">CEP </label>\n        <div>\n            <input type=\"text\" class=\"zipcode\" id=\"cep\" placeholder=\"\" appCepMask [(ngModel)]=\"formObject.cep\" maxlength=\"9\">\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"tipo_logradouro\">Tipo do logradouro </label>\n        <div class=\"containerSpinner\">\n            <spinner-component *ngIf=\"loadingTipoLogradouro\"></spinner-component>\n            <select id=\"tipo_logradouro\" [(ngModel)]=\"formObject.tipoLogradouro\" >\n                <option *ngFor=\"let item of tipoLogradourosList\" [ngValue]=\"item\">{{item.tipo}}</option>\n            </select>\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"logradouro\">Logradouro </label>\n        <div>\n            <input type=\"text\" id=\"logradouro\" placeholder=\"\" [(ngModel)]=\"formObject.logradouro\" >\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"numero\">Número </label>\n        <div>\n            <input type=\"text\" id=\"numero\" placeholder=\"\" [(ngModel)]=\"formObject.numero\" max=\"9999\" maxlength=\"4\" appNumberInteger>\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"complemento\">Complemento </label>\n        <div>\n            <input type=\"text\"  id=\"complemento\" placeholder=\"\" [(ngModel)]=\"formObject.complemento\">\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"bairro\">Bairro </label>\n        <div>\n            <input type=\"text\" id=\"bairro\" placeholder=\"\" [(ngModel)]=\"formObject.bairro\" >\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"estado\">Estado </label>\n        <div class=\"containerSpinner\">\n            <spinner-component *ngIf=\"loadingEstado\"></spinner-component>\n            <select id=\"estado\" [(ngModel)]=\"formObject.estado\" (ngModelChange)=\"changeEstado()\">\n                <option *ngFor=\"let item of estadosList\" [ngValue]=\"item\">{{item.nome}}</option>\n            </select>\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"cidade\">Cidade </label>\n        <div class=\"containerSpinner\">\n            <spinner-component *ngIf=\"loadingCidade\"></spinner-component>\n            <select id=\"cidade\" [(ngModel)]=\"formObject.cidade\">\n                <option *ngFor=\"let item of cidadesList\" [ngValue]=\"item\">{{item.nome}}</option>\n            </select>\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"coordenadaLatitude\">Latitude </label>\n        <div>\n            <input type=\"text\" id=\"coordenadaLatitude\" disabled placeholder=\"\" [(ngModel)]=\"formObject.coordenadaLatitude\" >\n        </div>\n    </div>\n\n    <div class=\"geo-input--3c\">\n        <label for=\"coordenadaLongitude\">Longitude </label>\n        <div>\n            <input type=\"text\" id=\"coordenadaLongitude\" disabled placeholder=\"\" [(ngModel)]=\"formObject.coordenadaLongitude\" >\n        </div>\n    </div>\n\n    <button type=\"button\" class=\"geo-button geo-button--secundary btnCoord\" (click)=\"getGeocoding()\">Gerar coordenada</button>\n\n</div>\n\n<div class=\"geo-content__row\">\n    <div id=\"map\"></div>\n</div>\n";

/***/ },
/* 901 */
/***/ function(module, exports) {

	module.exports = ".containerSpinner {\n    position: relative;\n}\nspinner-component {\n    position: absolute;\n    top: -5px;\n    right: 12px;\n}\n\n#map {\n    height: 300px;\n    width: 100%;\n}\n\n.btnCoord {\n    margin-top: 20px;\n}"

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var localidades_component_1 = __webpack_require__(246);
	var localidades_routing_module_1 = __webpack_require__(225);
	var localidade_list_component_1 = __webpack_require__(226);
	var localidade_api_service_1 = __webpack_require__(227);
	var localidade_navigation_service_1 = __webpack_require__(228);
	var localidade_service_1 = __webpack_require__(232);
	var localidade_form_component_1 = __webpack_require__(238);
	var enderecos_module_1 = __webpack_require__(894);
	var localidade_tipos_module_1 = __webpack_require__(903);
	var LocalidadesModule = (function () {
	    function LocalidadesModule() {
	    }
	    LocalidadesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                enderecos_module_1.EnderecosModule,
	                localidade_tipos_module_1.LocalidadeTiposModule,
	                localidades_routing_module_1.LocalidadesRoutingModule
	            ],
	            providers: [
	                localidade_api_service_1.LocalidadeApiService,
	                localidade_navigation_service_1.LocalidadeNavigationService,
	                localidade_service_1.LocalidadeService
	            ],
	            declarations: [
	                localidades_component_1.LocalidadesComponent,
	                localidade_list_component_1.LocalidadeListComponent,
	                localidade_form_component_1.LocalidadeFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocalidadesModule);
	    return LocalidadesModule;
	}());
	exports.LocalidadesModule = LocalidadesModule;


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var localidade_tipos_api_service_1 = __webpack_require__(242);
	var LocalidadeTiposModule = (function () {
	    function LocalidadeTiposModule() {
	    }
	    LocalidadeTiposModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                localidade_tipos_api_service_1.LocalidadeTiposApiService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocalidadeTiposModule);
	    return LocalidadeTiposModule;
	}());
	exports.LocalidadeTiposModule = LocalidadeTiposModule;


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var orgaos_component_1 = __webpack_require__(270);
	var orgao_list_component_1 = __webpack_require__(249);
	var orgao_form_component_1 = __webpack_require__(253);
	var orgao_navigation_service_1 = __webpack_require__(204);
	var orgao_api_service_1 = __webpack_require__(250);
	var orgao_service_1 = __webpack_require__(189);
	var enderecos_module_1 = __webpack_require__(894);
	var areas_module_1 = __webpack_require__(905);
	var orgaos_routing_module_1 = __webpack_require__(248);
	var orgao_tipo_list_component_1 = __webpack_require__(261);
	var orgao_tipo_form_component_1 = __webpack_require__(264);
	var orgao_tipo_api_service_1 = __webpack_require__(256);
	var orgao_tipo_navigation_service_1 = __webpack_require__(257);
	var orgao_service_2 = __webpack_require__(258);
	var OrgaosModule = (function () {
	    function OrgaosModule() {
	    }
	    OrgaosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                enderecos_module_1.EnderecosModule,
	                areas_module_1.AreasModule,
	                orgaos_routing_module_1.OrgaosRoutingModule
	            ],
	            providers: [
	                orgao_navigation_service_1.OrgaoNavigationService,
	                orgao_api_service_1.OrgaoApiService,
	                orgao_service_1.OrgaoService,
	                orgao_tipo_api_service_1.OrgaoTipoApiService,
	                orgao_tipo_navigation_service_1.OrgaoTipoNavigationService,
	                orgao_service_2.OrgaoTipoService
	            ],
	            declarations: [
	                orgaos_component_1.OrgaosComponent,
	                orgao_list_component_1.OrgaoListComponent,
	                orgao_form_component_1.OrgaoFormComponent,
	                orgao_tipo_list_component_1.OrgaoTipoListComponent,
	                orgao_tipo_form_component_1.OrgaoTipoFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OrgaosModule);
	    return OrgaosModule;
	}());
	exports.OrgaosModule = OrgaosModule;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var areas_component_1 = __webpack_require__(281);
	var area_list_component_1 = __webpack_require__(906);
	var area_form_component_1 = __webpack_require__(273);
	var area_service_1 = __webpack_require__(192);
	var area_api_service_1 = __webpack_require__(275);
	var area_navigation_service_1 = __webpack_require__(191);
	var areas_routing_module_1 = __webpack_require__(272);
	var area_contato_api_service_1 = __webpack_require__(277);
	var contatos_module_1 = __webpack_require__(881);
	var AreasModule = (function () {
	    function AreasModule() {
	    }
	    AreasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                contatos_module_1.ContatosModule,
	                areas_routing_module_1.AreasRoutingModule
	            ],
	            providers: [
	                area_service_1.AreaService,
	                area_api_service_1.AreaApiService,
	                area_navigation_service_1.AreaNavigationService,
	                area_contato_api_service_1.AreaContatoApiService
	            ],
	            declarations: [
	                areas_component_1.AreasComponent,
	                area_list_component_1.AreaListComponent,
	                area_form_component_1.AreaFormComponent
	            ],
	            exports: [
	                area_list_component_1.AreaListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AreasModule);
	    return AreasModule;
	}());
	exports.AreasModule = AreasModule;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var orgao_model_1 = __webpack_require__(254);
	var area_navigation_service_1 = __webpack_require__(191);
	var util_service_1 = __webpack_require__(88);
	var area_api_service_1 = __webpack_require__(275);
	var data_service_1 = __webpack_require__(190);
	var area_service_1 = __webpack_require__(192);
	var AreaListComponent = (function () {
	    function AreaListComponent(_areaNavigationService, _areasApiService, _areaService, _utilService) {
	        this._areaNavigationService = _areaNavigationService;
	        this._areasApiService = _areasApiService;
	        this._areaService = _areaService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.orgaoObject = new orgao_model_1.Orgao();
	        this.showDisabled = true;
	        this.areaModule = data_service_1.areasModuleName;
	    }
	    AreaListComponent.prototype.ngOnInit = function () {
	    };
	    AreaListComponent.prototype.clickNew = function () {
	        this._areaService.setSessionStorageFatherModule(this.orgaoObject);
	        this._areaNavigationService.goToNew();
	    };
	    AreaListComponent.prototype.clickEdit = function (item) {
	        this._areaService.clearSessionStorage();
	        this._areaNavigationService.goToEdit(item.id);
	    };
	    AreaListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    AreaListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._areasApiService.onDelete(item.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], AreaListComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof orgao_model_1.Orgao !== 'undefined' && orgao_model_1.Orgao) === 'function' && _a) || Object)
	    ], AreaListComponent.prototype, "orgaoObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], AreaListComponent.prototype, "showDisabled", void 0);
	    AreaListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-area-list',
	            template: __webpack_require__(907),
	            styles: [__webpack_require__(908)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof area_navigation_service_1.AreaNavigationService !== 'undefined' && area_navigation_service_1.AreaNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _c) || Object, (typeof (_d = typeof area_service_1.AreaService !== 'undefined' && area_service_1.AreaService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], AreaListComponent);
	    return AreaListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AreaListComponent = AreaListComponent;


/***/ },
/* 907 */
/***/ function(module, exports) {

	module.exports = "<a class=\"geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickNew(item)\">Nova área</a>\n\n<table>\n  <thead>\n  <tr>\n    <th>Área</th>\n    <th>Unidade orçamentária</th>\n    <th>Responsável</th>\n    <th class=\"small\"></th>\n  </tr>\n  </thead>\n  <tbody *ngIf=\"!list || list.length === 0\">\n  <tr>\n    <td colspan=\"4\">Nenhuma {{areaModule.single | lowercase}} cadastrada</td>\n  </tr>\n  </tbody>\n  <tbody *ngFor=\"let item of(list | filterActive:showDisabled | sort:['nome'])\">\n  <tr [ngClass]=\"{inative: !item.ativo}\">\n    <td>{{item.nome}}</td>\n    <td >{{item.codigoUnidadeOrcamentaria}}</td>\n    <td>{{item.nomeResponsavel}}</td>\n    <td class=\"geo-table--action\">\n      <a (click)=\"clickEdit(item)\">\n        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n      </a>\n      <a (click)=\"clickDelete(item)\">\n        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n      </a>\n    </td>\n  </tr>\n  </tbody>\n</table>\n";

/***/ },
/* 908 */
166,
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var divisoes_component_1 = __webpack_require__(292);
	var divisao_list_component_1 = __webpack_require__(284);
	var divisao_form_component_1 = __webpack_require__(288);
	var divisao_api_service_1 = __webpack_require__(285);
	var divisao_navigation_service_1 = __webpack_require__(193);
	var divisao_service_1 = __webpack_require__(194);
	var setores_module_1 = __webpack_require__(910);
	var divisoes_routing_module_1 = __webpack_require__(283);
	var DivisoesModule = (function () {
	    function DivisoesModule() {
	    }
	    DivisoesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                setores_module_1.SetoresModule,
	                divisoes_routing_module_1.DivisoesRoutingModule
	            ],
	            providers: [
	                divisao_api_service_1.DivisaoApiService,
	                divisao_navigation_service_1.DivisaoNavigationService,
	                divisao_service_1.DivisoesService
	            ],
	            declarations: [
	                divisoes_component_1.DivisoesComponent,
	                divisao_list_component_1.DivisaoListComponent,
	                divisao_form_component_1.DivisaoFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DivisoesModule);
	    return DivisoesModule;
	}());
	exports.DivisoesModule = DivisoesModule;


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var setores_component_1 = __webpack_require__(300);
	var setor_list_component_1 = __webpack_require__(911);
	var setor_form_component_1 = __webpack_require__(295);
	var setor_api_service_1 = __webpack_require__(297);
	var setor_navigation_service_1 = __webpack_require__(195);
	var setor_service_1 = __webpack_require__(197);
	var setores_routing_module_1 = __webpack_require__(294);
	var SetoresModule = (function () {
	    function SetoresModule() {
	    }
	    SetoresModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                setores_routing_module_1.SetoresRoutingModule
	            ],
	            providers: [
	                setor_api_service_1.SetorApiService,
	                setor_navigation_service_1.SetorNavigationService,
	                setor_service_1.SetorService
	            ],
	            declarations: [
	                setores_component_1.SetoresComponent,
	                setor_list_component_1.SetorListComponent,
	                setor_form_component_1.SetorFormComponent
	            ],
	            exports: [
	                setor_list_component_1.SetorListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SetoresModule);
	    return SetoresModule;
	}());
	exports.SetoresModule = SetoresModule;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var setor_navigation_service_1 = __webpack_require__(195);
	var util_service_1 = __webpack_require__(88);
	var setor_api_service_1 = __webpack_require__(297);
	var data_service_1 = __webpack_require__(196);
	var setor_service_1 = __webpack_require__(197);
	var divisao_model_1 = __webpack_require__(289);
	var SetorListComponent = (function () {
	    function SetorListComponent(_setorNavigationService, _setoresApiService, _setoreservice, _utilService) {
	        this._setorNavigationService = _setorNavigationService;
	        this._setoresApiService = _setoresApiService;
	        this._setoreservice = _setoreservice;
	        this._utilService = _utilService;
	        this.list = [];
	        this.divisaoObject = new divisao_model_1.Divisao();
	        this.showDisabled = true;
	        this.setorModule = data_service_1.setoresModuleName;
	    }
	    SetorListComponent.prototype.ngOnInit = function () {
	    };
	    SetorListComponent.prototype.clickNew = function () {
	        this._setoreservice.setSessionStorageFatherModule(this.divisaoObject);
	        this._setorNavigationService.goToNew();
	    };
	    SetorListComponent.prototype.clickEdit = function (item) {
	        this._setoreservice.clearSessionStorage();
	        this._setorNavigationService.goToEdit(item.id);
	    };
	    SetorListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    SetorListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._setoresApiService.onDelete(item.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], SetorListComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof divisao_model_1.Divisao !== 'undefined' && divisao_model_1.Divisao) === 'function' && _a) || Object)
	    ], SetorListComponent.prototype, "divisaoObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], SetorListComponent.prototype, "showDisabled", void 0);
	    SetorListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-setor-list',
	            template: __webpack_require__(912),
	            styles: [__webpack_require__(913)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof setor_navigation_service_1.SetorNavigationService !== 'undefined' && setor_navigation_service_1.SetorNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof setor_api_service_1.SetorApiService !== 'undefined' && setor_api_service_1.SetorApiService) === 'function' && _c) || Object, (typeof (_d = typeof setor_service_1.SetorService !== 'undefined' && setor_service_1.SetorService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], SetorListComponent);
	    return SetorListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.SetorListComponent = SetorListComponent;


/***/ },
/* 912 */
/***/ function(module, exports) {

	module.exports = "<a class=\"geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickNew(item)\">Novo setor</a>\n\n<table>\n  <thead>\n  <tr>\n    <th>Setor</th>\n    <th class=\"small\"></th>\n  </tr>\n  </thead>\n  <tbody *ngIf=\"!list || list.length === 0\">\n  <tr>\n    <td colspan=\"5\">Nenhum {{setorModule.single | lowercase}} cadastrado</td>\n  </tr>\n  </tbody>\n  <tbody *ngFor=\"let item of(list | filterActive:showDisabled | sort:['setor'])\">\n  <tr [ngClass]=\"{inative: !item.ativo}\">\n    <td>{{item.setor}}</td>\n    <td class=\"geo-table--action\">\n      <a (click)=\"clickEdit(item)\">\n        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n      </a>\n      <a (click)=\"clickDelete(item)\">\n        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n      </a>\n    </td>\n  </tr>\n  </tbody>\n</table>\n";

/***/ },
/* 913 */
166,
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var EstruturasRoutingModule = (function () {
	    function EstruturasRoutingModule() {
	    }
	    EstruturasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], EstruturasRoutingModule);
	    return EstruturasRoutingModule;
	}());
	exports.EstruturasRoutingModule = EstruturasRoutingModule;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var bens_component_1 = __webpack_require__(302);
	var shared_module_1 = __webpack_require__(57);
	var bens_routing_module_1 = __webpack_require__(916);
	var marcas_module_1 = __webpack_require__(917);
	var categorias_module_1 = __webpack_require__(922);
	var bem_tipos_module_1 = __webpack_require__(923);
	var modelos_module_1 = __webpack_require__(918);
	var situacoes_module_1 = __webpack_require__(931);
	var cores_module_1 = __webpack_require__(932);
	var cnh_module_1 = __webpack_require__(933);
	var formas_controle_module_1 = __webpack_require__(934);
	var BensModule = (function () {
	    function BensModule() {
	    }
	    BensModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                bem_tipos_module_1.BemTiposModule,
	                categorias_module_1.CategoriasModule,
	                marcas_module_1.MarcasModule,
	                modelos_module_1.ModelosModule,
	                cores_module_1.CoresModule,
	                situacoes_module_1.SituacoesModule,
	                bens_routing_module_1.BensRoutingModule,
	                cnh_module_1.CnhModule,
	                formas_controle_module_1.FormasControleModule
	            ],
	            declarations: [
	                bens_component_1.BensComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BensModule);
	    return BensModule;
	}());
	exports.BensModule = BensModule;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var BensRoutingModule = (function () {
	    function BensRoutingModule() {
	    }
	    BensRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BensRoutingModule);
	    return BensRoutingModule;
	}());
	exports.BensRoutingModule = BensRoutingModule;


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var marcas_component_1 = __webpack_require__(304);
	var shared_module_1 = __webpack_require__(57);
	var marcas_routing_module_1 = __webpack_require__(306);
	var marca_form_component_1 = __webpack_require__(316);
	var marca_list_component_1 = __webpack_require__(307);
	var marca_api_service_1 = __webpack_require__(308);
	var marca_navigation_service_1 = __webpack_require__(309);
	var marca_service_1 = __webpack_require__(310);
	var modelos_module_1 = __webpack_require__(918);
	var MarcasModule = (function () {
	    function MarcasModule() {
	    }
	    MarcasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                modelos_module_1.ModelosModule,
	                marcas_routing_module_1.MarcasRoutingModule
	            ],
	            providers: [
	                marca_api_service_1.MarcaApiService,
	                marca_navigation_service_1.MarcaNavigationService,
	                marca_service_1.MarcasService
	            ],
	            declarations: [
	                marcas_component_1.MarcasComponent,
	                marca_form_component_1.MarcaFormComponent,
	                marca_list_component_1.MarcaListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MarcasModule);
	    return MarcasModule;
	}());
	exports.MarcasModule = MarcasModule;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var modelos_component_1 = __webpack_require__(346);
	var shared_module_1 = __webpack_require__(57);
	var modelo_api_service_1 = __webpack_require__(351);
	var modelo_navigation_service_1 = __webpack_require__(311);
	var modelo_service_1 = __webpack_require__(313);
	var modelo_form_component_1 = __webpack_require__(349);
	var modelo_list_component_1 = __webpack_require__(919);
	var modelos_routing_module_1 = __webpack_require__(348);
	var ModelosModule = (function () {
	    function ModelosModule() {
	    }
	    ModelosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                modelos_routing_module_1.ModelosRoutingModule
	            ],
	            providers: [
	                modelo_api_service_1.ModeloApiService,
	                modelo_navigation_service_1.ModeloNavigationService,
	                modelo_service_1.ModeloService
	            ],
	            declarations: [
	                modelos_component_1.ModelosComponent,
	                modelo_form_component_1.ModeloFormComponent,
	                modelo_list_component_1.ModeloListComponent
	            ],
	            exports: [
	                modelo_list_component_1.ModeloListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ModelosModule);
	    return ModelosModule;
	}());
	exports.ModelosModule = ModelosModule;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var modelo_navigation_service_1 = __webpack_require__(311);
	var util_service_1 = __webpack_require__(88);
	var modelo_api_service_1 = __webpack_require__(351);
	var data_service_1 = __webpack_require__(312);
	var modelo_service_1 = __webpack_require__(313);
	var marca_model_1 = __webpack_require__(317);
	var ModeloListComponent = (function () {
	    function ModeloListComponent(_modeloNavigationService, _modelosApiService, _modeloservice, _utilService) {
	        this._modeloNavigationService = _modeloNavigationService;
	        this._modelosApiService = _modelosApiService;
	        this._modeloservice = _modeloservice;
	        this._utilService = _utilService;
	        this.list = [];
	        this.marcaObject = new marca_model_1.Marca();
	        this.showDisabled = true;
	        this.modeloModule = data_service_1.modelosModuleName;
	    }
	    ModeloListComponent.prototype.ngOnInit = function () {
	    };
	    ModeloListComponent.prototype.clickNew = function () {
	        this._modeloservice.setSessionStorageFatherModule(this.marcaObject);
	        this._modeloNavigationService.goToNew();
	    };
	    ModeloListComponent.prototype.clickEdit = function (item) {
	        this._modeloservice.clearSessionStorageFatherModule();
	        this._modeloservice.clearSessionStorage();
	        this._modeloNavigationService.goToEdit(item.id);
	    };
	    ModeloListComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    ModeloListComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._modelosApiService.onDelete(item.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], ModeloListComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof marca_model_1.Marca !== 'undefined' && marca_model_1.Marca) === 'function' && _a) || Object)
	    ], ModeloListComponent.prototype, "marcaObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ModeloListComponent.prototype, "showDisabled", void 0);
	    ModeloListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-modelo-list',
	            template: __webpack_require__(920),
	            styles: [__webpack_require__(921)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof modelo_navigation_service_1.ModeloNavigationService !== 'undefined' && modelo_navigation_service_1.ModeloNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof modelo_api_service_1.ModeloApiService !== 'undefined' && modelo_api_service_1.ModeloApiService) === 'function' && _c) || Object, (typeof (_d = typeof modelo_service_1.ModeloService !== 'undefined' && modelo_service_1.ModeloService) === 'function' && _d) || Object, (typeof (_e = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _e) || Object])
	    ], ModeloListComponent);
	    return ModeloListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ModeloListComponent = ModeloListComponent;


/***/ },
/* 920 */
/***/ function(module, exports) {

	module.exports = "<a class=\"geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickNew(item)\">Novo modelo</a>\n\n<table>\n  <thead>\n  <tr>\n    <th>Modelo</th>\n    <th>Tipo</th>\n    <th>Subtipo</th>\n    <th class=\"small\"></th>\n  </tr>\n  </thead>\n  <tbody *ngIf=\"!list || list.length === 0\">\n  <tr>\n    <td colspan=\"5\">Nenhum {{modeloModule.single | lowercase}} cadastrado</td>\n  </tr>\n  </tbody>\n  <tbody data-collapse *ngFor=\"let item of(list | filterActive:showDisabled)\">\n  <tr [ngClass]=\"{inative: !item.ativo}\">\n    <td><span class=\"geo-arrow\"></span> {{item.modelo}}</td>\n    <td><span *ngIf=\"item.tipoBem\">{{item.tipoBem.tipo}}</span></td>\n    <td><span *ngIf=\"item.subTipoBem\">{{item.subTipoBem.subTipo}}</span></td>\n    <td class=\"geo-table--action\">\n      <a (click)=\"clickEdit(item)\">\n        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n      </a>\n      <a (click)=\"clickDelete(item)\">\n        <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n      </a>\n    </td>\n  </tr>\n  <tr class=\"description\">\n    <td colspan=\"100%\">\n      <div class=\"geo-content__row\">\n        <div class=\"geo-columns--6c\">\n          <p><strong>Categoria CNH: </strong>\n            <span *ngIf=\"item.categoriaExigida\">&nbsp;{{item.categoriaExigida.categoria}} </span>\n            <i *ngIf=\"!item.categoriaExigida\">não cadastrado</i>\n          </p>\n          <p><strong>Motorizado: </strong> <span *ngIf=\"item.motorizado\">Sim</span> <span *ngIf=\"!item.motorizado\">Não</span></p>\n          <p><strong>Potência: </strong> <span *ngIf=\"item.potencia\">{{item.potencia}}</span> <i *ngIf=\"!item.potencia\">não cadastrado</i></p>\n          <p><strong>Cilindrada: </strong> <span *ngIf=\"item.cilindradas\">{{item.cilindradas}}</span> <i *ngIf=\"!item.cilindradas\">não cadastrado</i></p>\n          <p><strong>Forma de controle: </strong> <span *ngIf=\"item.formaControle\">{{item.formaControle.formaControle}}</span> <i *ngIf=\"!item.formaControle\">não cadastrado</i></p>\n          <p><strong>Medida de deslocamento: </strong> <span *ngIf=\"item.tipoDeslocamento\">{{item.tipoDeslocamento.nome}}</span> <i *ngIf=\"!item.tipoDeslocamento\">não cadastrado</i></p>\n        </div>\n        <div class=\"geo-columns--6c\">\n          <p><strong>Consumo médio: </strong> {{item.consumoMedio }} <i *ngIf=\"!item.consumoMedio\">não cadastrado</i></p>\n          <p><strong>Consumo mínimo: </strong> {{item.consumoEsperadoMinimo }} <i *ngIf=\"!item.consumoEsperadoMinimo\">não cadastrado</i></p>\n          <p><strong>Consumo máximo: </strong> {{item.consumoEsperadoMaximo }} <i *ngIf=\"!item.consumoEsperadoMaximo\">não cadastrado</i></p>\n          <p><strong>Tanque: </strong> {{item.capacidadeTanque  }} <i *ngIf=\"!item.capacidadeTanque \">não cadastrado</i></p>\n          <p><strong>Número de eixos: </strong> <span *ngIf=\"item.numeroEixos\">{{item.numeroEixos}}</span> <i *ngIf=\"!item.numeroEixos\">não cadastrado</i></p>\n          <p><strong>Tipo de eixo: </strong> {{item.tipoEixo }} <i *ngIf=\"!item.tipoEixo\">não cadastrado</i></p>\n          <p><strong>Quantidade / nº de passageiros: </strong> <span *ngIf=\"item.numeroPassageiros\">{{item.numeroPassageiros }}</span> <i *ngIf=\"!item.numeroPassageiros\">não cadastrado</i></p>\n          <p><strong>Capacidade de carga: </strong> {{item.capacidadeCarga }} <i *ngIf=\"!item.capacidadeCarga\">não cadastrado</i></p>\n        </div>\n      </div>\n    </td>\n  </tr>\n  </tbody>\n</table>\n";

/***/ },
/* 921 */
166,
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var categoria_api_service_1 = __webpack_require__(324);
	var categoria_list_component_1 = __webpack_require__(323);
	var categorias_component_1 = __webpack_require__(320);
	var categorias_routing_module_1 = __webpack_require__(322);
	var categoria_navigation_service_1 = __webpack_require__(325);
	var bem_tipos_module_1 = __webpack_require__(923);
	var bem_subtipos_module_1 = __webpack_require__(924);
	var categoria_form_component_1 = __webpack_require__(328);
	var CategoriasModule = (function () {
	    function CategoriasModule() {
	    }
	    CategoriasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                bem_tipos_module_1.BemTiposModule,
	                bem_subtipos_module_1.BemSubtiposModule,
	                categorias_routing_module_1.CategoriasRoutingModule
	            ],
	            providers: [
	                categoria_api_service_1.CategoriaApiService,
	                categoria_navigation_service_1.CategoriaNavigationService
	            ],
	            declarations: [
	                categorias_component_1.CategoriasComponent,
	                categoria_list_component_1.CategoriaListComponent,
	                categoria_form_component_1.CategoriaFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CategoriasModule);
	    return CategoriasModule;
	}());
	exports.CategoriasModule = CategoriasModule;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var bem_tipos_component_1 = __webpack_require__(333);
	var bem_tipos_list_component_1 = __webpack_require__(336);
	var bem_tipos_form_component_1 = __webpack_require__(343);
	var bem_tipos_routing_module_1 = __webpack_require__(335);
	var bem_tipos_api_service_1 = __webpack_require__(339);
	var bem_tipos_navigation_service_1 = __webpack_require__(338);
	var bem_tipos_service_1 = __webpack_require__(340);
	var bem_subtipos_module_1 = __webpack_require__(924);
	var BemTiposModule = (function () {
	    function BemTiposModule() {
	    }
	    BemTiposModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                bem_subtipos_module_1.BemSubtiposModule,
	                bem_tipos_routing_module_1.BemTiposRoutingModule
	            ],
	            providers: [
	                bem_tipos_api_service_1.BemTiposApiService,
	                bem_tipos_navigation_service_1.BemTiposNavigationService,
	                bem_tipos_service_1.BemTiposService
	            ],
	            declarations: [
	                bem_tipos_component_1.BemTiposComponent,
	                bem_tipos_list_component_1.BemTiposListComponent,
	                bem_tipos_form_component_1.BemTiposFormComponent
	            ],
	            exports: [
	                bem_tipos_list_component_1.BemTiposListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BemTiposModule);
	    return BemTiposModule;
	}());
	exports.BemTiposModule = BemTiposModule;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var bem_subtipos_form_component_1 = __webpack_require__(925);
	var bem_subtipo_api_service_1 = __webpack_require__(356);
	var bem_subtipos_list_component_1 = __webpack_require__(928);
	var BemSubtiposModule = (function () {
	    function BemSubtiposModule() {
	    }
	    BemSubtiposModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                bem_subtipo_api_service_1.BemSubtipoApiService
	            ],
	            declarations: [
	                bem_subtipos_list_component_1.BemSubtiposListComponent,
	                bem_subtipos_form_component_1.BemSubtiposFormComponent
	            ],
	            exports: [
	                bem_subtipos_form_component_1.BemSubtiposFormComponent,
	                bem_subtipos_list_component_1.BemSubtiposListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BemSubtiposModule);
	    return BemSubtiposModule;
	}());
	exports.BemSubtiposModule = BemSubtiposModule;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var bem_subtipo_model_1 = __webpack_require__(352);
	var bem_subtipo_api_service_1 = __webpack_require__(356);
	var BemSubtiposFormComponent = (function () {
	    function BemSubtiposFormComponent(_bemSubtipoApiService) {
	        this._bemSubtipoApiService = _bemSubtipoApiService;
	        this.list = [];
	    }
	    BemSubtiposFormComponent.prototype.ngAfterViewInit = function () {
	        if (!this.list.length) {
	            this.newSubtipo();
	        }
	    };
	    BemSubtiposFormComponent.prototype.changeEnable = function (item, changedByUser) {
	        if (changedByUser) {
	            if (item.ativo) {
	                this.onEnable(item);
	            }
	            else {
	                this.onDelete(item);
	            }
	        }
	    };
	    BemSubtiposFormComponent.prototype.clickAddNew = function () {
	        this.newSubtipo();
	    };
	    BemSubtiposFormComponent.prototype.newSubtipo = function () {
	        var object = new bem_subtipo_model_1.BemSubtipo();
	        object.ativo = true;
	        this.list.push(object);
	    };
	    BemSubtiposFormComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	        }.bind(this));
	        this._bemSubtipoApiService.onDelete(item.id, onDone);
	    };
	    BemSubtiposFormComponent.prototype.onEnable = function (item) {
	        var onDone = (function (Response) {
	        }.bind(this));
	        var obj = { id: item.id, ativo: true };
	        this._bemSubtipoApiService.onPut(obj, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BemSubtiposFormComponent.prototype, "list", void 0);
	    BemSubtiposFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-bem-subtipos-form',
	            template: __webpack_require__(926),
	            styles: [__webpack_require__(927)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof bem_subtipo_api_service_1.BemSubtipoApiService !== 'undefined' && bem_subtipo_api_service_1.BemSubtipoApiService) === 'function' && _a) || Object])
	    ], BemSubtiposFormComponent);
	    return BemSubtiposFormComponent;
	    var _a;
	}());
	exports.BemSubtiposFormComponent = BemSubtiposFormComponent;


/***/ },
/* 926 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n    <h2>Subtipos</h2>\n    <div class=\"geo-columns--12c\" *ngFor=\"let item of list; let i = index;\">\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Ativo</span>\n            <input type=\"checkbox\" [(ngModel)]=\"item.ativo\" (ngModelChange)=\"changeEnable(item, true)\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n        <div class=\"geo-input--3c\">\n            <label>Subtipo </label>\n            <div>\n                <input type=\"text\" id=\"subtipo_{{i}}\" [(ngModel)]=\"item.subTipo\">\n            </div>\n        </div>\n        <!--<a (click)=\"clickRemove(i)\" title=\"Remover\" class=\"icon\">-->\n        <!--<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>-->\n        <!--</a>-->\n    </div>\n\n    <button type=\"button\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickAddNew()\">Adicionar Subtipo</button>\n</div>\n";

/***/ },
/* 927 */
886,
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(357);
	var BemSubtiposListComponent = (function () {
	    function BemSubtiposListComponent() {
	        this.showDisabled = true;
	        this.list = [];
	        this.bemSubtiposModule = data_service_1.bemSubtiposModuleName;
	    }
	    BemSubtiposListComponent.prototype.ngOnInit = function () {
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], BemSubtiposListComponent.prototype, "showDisabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], BemSubtiposListComponent.prototype, "list", void 0);
	    BemSubtiposListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-bem-subtipos-list',
	            template: __webpack_require__(929),
	            styles: [__webpack_require__(930)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BemSubtiposListComponent);
	    return BemSubtiposListComponent;
	}());
	exports.BemSubtiposListComponent = BemSubtiposListComponent;


/***/ },
/* 929 */
/***/ function(module, exports) {

	module.exports = "<table>\n    <thead>\n    <tr>\n        <th>Subtipo</th>\n    </tr>\n    </thead>\n    <tbody *ngIf=\"!list || list.length === 0\">\n    <tr>\n        <td colspan=\"1\">Nenhum {{bemSubtiposModule.single | lowercase}} cadastrado</td>\n    </tr>\n    </tbody>\n    <tbody *ngFor=\"let item of(list | filterActive:showDisabled | sort:['subTipo'])\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n        <td>{{item.subTipo}}</td>\n    </tr>\n    </tbody>\n</table>";

/***/ },
/* 930 */
166,
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var situacao_api_service_1 = __webpack_require__(382);
	var SituacoesModule = (function () {
	    function SituacoesModule() {
	    }
	    SituacoesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                situacao_api_service_1.SituacaoApiService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SituacoesModule);
	    return SituacoesModule;
	}());
	exports.SituacoesModule = SituacoesModule;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var cor_api_service_1 = __webpack_require__(374);
	var CoresModule = (function () {
	    function CoresModule() {
	    }
	    CoresModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                cor_api_service_1.CorApiService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CoresModule);
	    return CoresModule;
	}());
	exports.CoresModule = CoresModule;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var categoria_cnh_api_service_1 = __webpack_require__(216);
	var CnhModule = (function () {
	    function CnhModule() {
	    }
	    CnhModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                categoria_cnh_api_service_1.CategoriaCnhApiService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CnhModule);
	    return CnhModule;
	}());
	exports.CnhModule = CnhModule;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var forma_controle_api_service_1 = __webpack_require__(359);
	var forma_controle_service_1 = __webpack_require__(369);
	var FormasControleModule = (function () {
	    function FormasControleModule() {
	    }
	    FormasControleModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                forma_controle_api_service_1.FormaControleApiService,
	                forma_controle_service_1.FormaControleService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FormasControleModule);
	    return FormasControleModule;
	}());
	exports.FormasControleModule = FormasControleModule;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var viagens_component_1 = __webpack_require__(462);
	var shared_module_1 = __webpack_require__(57);
	var viagens_routing_module_1 = __webpack_require__(624);
	var deslocamento_tipos_module_1 = __webpack_require__(936);
	var pontos_module_1 = __webpack_require__(937);
	var deslocamentos_module_1 = __webpack_require__(944);
	var viagem_menu_component_1 = __webpack_require__(962);
	var viagem_service_1 = __webpack_require__(633);
	var viagem_configuracao_component_1 = __webpack_require__(663);
	var destinos_module_1 = __webpack_require__(964);
	var passageiros_module_1 = __webpack_require__(945);
	var visitante_viagem_menu_component_1 = __webpack_require__(965);
	var tipos_viagem_module_1 = __webpack_require__(967);
	var ViagensModule = (function () {
	    function ViagensModule() {
	    }
	    ViagensModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                deslocamento_tipos_module_1.DeslocamentoTiposModule,
	                pontos_module_1.PontosModule,
	                deslocamentos_module_1.DeslocamentosModule,
	                destinos_module_1.DestinosModule,
	                passageiros_module_1.PassageirosModule,
	                tipos_viagem_module_1.TiposViagemModule,
	                viagens_routing_module_1.ViagensRoutingModule
	            ],
	            providers: [
	                viagem_service_1.ViagemService
	            ],
	            declarations: [
	                viagens_component_1.ViagensComponent,
	                viagem_menu_component_1.ViagemMenuComponent,
	                visitante_viagem_menu_component_1.VisitanteViagemMenuComponent,
	                viagem_configuracao_component_1.ViagemConfiguracaoComponent
	            ],
	            exports: [
	                viagem_menu_component_1.ViagemMenuComponent,
	                visitante_viagem_menu_component_1.VisitanteViagemMenuComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ViagensModule);
	    return ViagensModule;
	}());
	exports.ViagensModule = ViagensModule;


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var deslocamento_tipos_api_service_1 = __webpack_require__(354);
	var deslocamento_tipos_service_1 = __webpack_require__(358);
	var DeslocamentoTiposModule = (function () {
	    function DeslocamentoTiposModule() {
	    }
	    DeslocamentoTiposModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                deslocamento_tipos_api_service_1.DeslocamentoTiposApiService,
	                deslocamento_tipos_service_1.DeslocamentoTiposService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DeslocamentoTiposModule);
	    return DeslocamentoTiposModule;
	}());
	exports.DeslocamentoTiposModule = DeslocamentoTiposModule;


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var pontos_component_1 = __webpack_require__(626);
	var shared_module_1 = __webpack_require__(57);
	var pontos_routing_module_1 = __webpack_require__(628);
	var ponto_api_service_1 = __webpack_require__(630);
	var ponto_navigation_service_1 = __webpack_require__(631);
	var ponto_service_1 = __webpack_require__(632);
	var ponto_form_component_1 = __webpack_require__(636);
	var ponto_list_component_1 = __webpack_require__(629);
	var enderecos_module_1 = __webpack_require__(894);
	var ponto_table_component_1 = __webpack_require__(938);
	var ponto_deslocamento_form_list_component_1 = __webpack_require__(941);
	var PontosModule = (function () {
	    function PontosModule() {
	    }
	    PontosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                enderecos_module_1.EnderecosModule,
	                pontos_routing_module_1.PontosRoutingModule
	            ],
	            providers: [
	                ponto_api_service_1.PontoApiService,
	                ponto_navigation_service_1.PontoNavigationService,
	                ponto_service_1.PontoService
	            ],
	            declarations: [
	                pontos_component_1.PontosComponent,
	                ponto_form_component_1.PontoFormComponent,
	                ponto_list_component_1.PontoListComponent,
	                ponto_table_component_1.PontoTableComponent,
	                ponto_deslocamento_form_list_component_1.PontoDeslocamentoFormListComponent
	            ],
	            exports: [
	                ponto_table_component_1.PontoTableComponent,
	                ponto_deslocamento_form_list_component_1.PontoDeslocamentoFormListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PontosModule);
	    return PontosModule;
	}());
	exports.PontosModule = PontosModule;


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ponto_api_service_1 = __webpack_require__(630);
	var ponto_navigation_service_1 = __webpack_require__(631);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(625);
	var ponto_service_1 = __webpack_require__(632);
	var PontoTableComponent = (function () {
	    function PontoTableComponent(_pontosApiService, _pontoNavigationService, _pontoService, _utilService) {
	        this._pontosApiService = _pontosApiService;
	        this._pontoNavigationService = _pontoNavigationService;
	        this._pontoService = _pontoService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.listFilter = {};
	        this.showActions = true;
	        this.showDisabled = false;
	        this.loading = false;
	        this.pontosModuleName = data_service_1.pontosModuleName;
	    }
	    PontoTableComponent.prototype.ngOnInit = function () {
	    };
	    PontoTableComponent.prototype.clickEdit = function (item) {
	        this._pontoService.clearSessionStorage();
	        this._pontoNavigationService.goToEdit(item.id);
	    };
	    PontoTableComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    PontoTableComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._pontosApiService.onDelete(item.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], PontoTableComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], PontoTableComponent.prototype, "listFilter", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PontoTableComponent.prototype, "showActions", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PontoTableComponent.prototype, "showDisabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PontoTableComponent.prototype, "loading", void 0);
	    PontoTableComponent = __decorate([
	        core_1.Component({
	            selector: 'app-ponto-table',
	            template: __webpack_require__(939),
	            styles: [__webpack_require__(940)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ponto_api_service_1.PontoApiService !== 'undefined' && ponto_api_service_1.PontoApiService) === 'function' && _a) || Object, (typeof (_b = typeof ponto_navigation_service_1.PontoNavigationService !== 'undefined' && ponto_navigation_service_1.PontoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof ponto_service_1.PontoService !== 'undefined' && ponto_service_1.PontoService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object])
	    ], PontoTableComponent);
	    return PontoTableComponent;
	    var _a, _b, _c, _d;
	}());
	exports.PontoTableComponent = PontoTableComponent;


/***/ },
/* 939 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading\">Nenhum {{pontosModuleName.single | lowercase}} cadastrado</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Ponto</th>\n            <th class=\"small\" *ngIf=\"showActions\"></th>\n        </tr>\n        </thead>\n        <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['nome'] | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td><span class=\"geo-arrow\"></span>{{item.nome}}</td>\n            <td class=\"geo-table--action\" *ngIf=\"showActions\">\n                <a (click)=\"clickEdit(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n                </a>\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <div>\n                    <p><strong>Observação:</strong> {{item.descricao}} <i *ngIf=\"!item.descricao\">não cadastrado</i></p>\n                    <p><strong>Endereço:</strong> {{item.address}} <i *ngIf=\"!item.address\">não cadastrado</i></p>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 940 */
166,
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var autocomplete_service_1 = __webpack_require__(101);
	var ponto_api_service_1 = __webpack_require__(630);
	var data_service_1 = __webpack_require__(625);
	var util_service_1 = __webpack_require__(88);
	var PontoDeslocamentoFormListComponent = (function () {
	    function PontoDeslocamentoFormListComponent(_pontoApiService, _autocompleteService, _utilService, _fb) {
	        this._pontoApiService = _pontoApiService;
	        this._autocompleteService = _autocompleteService;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this.list = [];
	        this.moduleName = data_service_1.pontosModuleName;
	        this.pontoObject = {};
	        this.newObject = {};
	        this.submitted = false;
	        this.pontoId = 'pontoSelect';
	        this.tiposList = [];
	        this.ponto = new forms_1.FormControl('', forms_1.Validators.required);
	        this.tipo = new forms_1.FormControl('', forms_1.Validators.required);
	        this.form2 = _fb.group({
	            ponto: this.ponto,
	            tipo: this.tipo
	        });
	    }
	    PontoDeslocamentoFormListComponent.prototype.ngOnInit = function () {
	        this.pontoQuery = this._utilService.cloneObject(data_service_1.pontosQuery);
	        this.tiposList = this._utilService.cloneObject(data_service_1.tiposPontos);
	        this.newItem();
	    };
	    PontoDeslocamentoFormListComponent.prototype.clickRemove = function (item) {
	        var onDelete = (function () {
	            this.onRemovePonto(item.id);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    PontoDeslocamentoFormListComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            var object = this._utilService.cloneObject(this.newObject);
	            object.pontoId = this.pontoObject.id;
	            object.tipo = this.newObject.tipo.Key;
	            object.deslocamentoId = this.deslocamentoId;
	            this.onAddPonto(object);
	        }
	    };
	    PontoDeslocamentoFormListComponent.prototype.getPontoObject = function (object) {
	        this.pontoObject = object;
	        this._utilService.setSelectOnFormControl(this.form2, 'ponto', object);
	    };
	    PontoDeslocamentoFormListComponent.prototype.newItem = function () {
	        this.newObject = {
	            tipo: this.tiposList[0],
	            ativo: true
	        };
	    };
	    PontoDeslocamentoFormListComponent.prototype.onAddPonto = function (object) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.ponto = { id: this.pontoObject.id, nome: this.pontoObject.text };
	                Response.tipo = this.newObject.tipo;
	                this.list.push(Response);
	                this.newItem();
	                this.pontoObject = {};
	                this._autocompleteService.setValueOnSelect2(null, this.pontoId);
	                this._utilService.setSelectOnFormControl(this.form2, 'ponto', {});
	                this.submitted = false;
	                this._utilService.swalMessageAddSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._pontoApiService.onPostPontoDeslocamento(object, onDone);
	    };
	    PontoDeslocamentoFormListComponent.prototype.onRemovePonto = function (objectId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === objectId) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._pontoApiService.onDeletePontoDeslocamento(objectId, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], PontoDeslocamentoFormListComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], PontoDeslocamentoFormListComponent.prototype, "deslocamentoId", void 0);
	    PontoDeslocamentoFormListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-ponto-deslocamento-form-list',
	            template: __webpack_require__(942),
	            styles: [__webpack_require__(943)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof ponto_api_service_1.PontoApiService !== 'undefined' && ponto_api_service_1.PontoApiService) === 'function' && _a) || Object, (typeof (_b = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _d) || Object])
	    ], PontoDeslocamentoFormListComponent);
	    return PontoDeslocamentoFormListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.PontoDeslocamentoFormListComponent = PontoDeslocamentoFormListComponent;


/***/ },
/* 942 */
/***/ function(module, exports) {

	module.exports = "<form [formGroup]=\"form2\" (ngSubmit)=\"onSubmit(form2)\">\n    <div class=\"geo-content__row pt0\">\n        <div class=\"geo-columns--12c\">\n            <autocomplete-component class=\"geo-input--3c\" id=\"pontoSelect\"\n                                    (setObejct)=\"getPontoObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"pontoId\"\n                                    [model]=\"pontoObject\"\n                                    [_service]=\"_pontoApiService\"\n                                    [fieldToShow]=\"'nome'\"\n                                    [query]=\"pontoQuery\"\n                                    [isCreateNew]=\"false\"\n                                    [label]=\"'Ponto'\"></autocomplete-component>\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !tipo.valid && submitted}\">\n                <label for=\"tipo\">Tipo de ponto <abbr>*</abbr></label>\n                <div>\n                    <select id=\"tipo\" [(ngModel)]=\"newObject.tipo\" formControlName=\"tipo\">\n                        <option *ngFor=\"let item of tiposList\" [ngValue]=\"item\">{{item.Value}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <button type=\"submit\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\">Adicionar ponto</button>\n            </div>\n        </div>\n    </div>\n</form>\n\n<div class=\"geo-content__row\">\n    <table>\n        <thead>\n        <tr>\n            <th>Ponto</th>\n            <th>Tipo</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngIf=\"!list || list.length === 0\">\n        <tr>\n            <td colspan=\"3\">Nenhum {{moduleName.single | lowercase}} cadastrado</td>\n        </tr>\n        </tbody>\n        <tbody *ngFor=\"let item of (list | filterActive:false); let i=index\">\n        <tr>\n            <td><span *ngIf=\"item.ponto\">{{item.ponto.nome}}</span></td>\n            <td><span *ngIf=\"item.tipo\">{{item.tipo.Value}}</span></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickRemove(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 943 */
/***/ function(module, exports) {

	module.exports = "@media only screen and (min-width: 821px) {\n  .toggleAcompanhante {\n    margin-top: 36px;\n  }\n}\n\n.pt0 {\n  padding-top: 0;\n}\n"

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var deslocamentos_component_1 = __webpack_require__(640);
	var shared_module_1 = __webpack_require__(57);
	var deslocamentos_routing_module_1 = __webpack_require__(642);
	var deslocamento_api_service_1 = __webpack_require__(455);
	var deslocamento_navigation_service_1 = __webpack_require__(644);
	var deslocamento_service_1 = __webpack_require__(456);
	var deslocamento_form_component_1 = __webpack_require__(647);
	var deslocamento_list_component_1 = __webpack_require__(643);
	var delocamento_detail_component_1 = __webpack_require__(657);
	var pontos_module_1 = __webpack_require__(937);
	var passageiros_module_1 = __webpack_require__(945);
	var deslocamento_history_component_1 = __webpack_require__(454);
	var deslocamento_table_component_1 = __webpack_require__(949);
	var custo_deslocamento_form_list_component_1 = __webpack_require__(952);
	var deslocamento_calendar_component_1 = __webpack_require__(660);
	var odometros_horimetros_module_1 = __webpack_require__(955);
	var DeslocamentosModule = (function () {
	    function DeslocamentosModule() {
	    }
	    DeslocamentosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                pontos_module_1.PontosModule,
	                passageiros_module_1.PassageirosModule,
	                odometros_horimetros_module_1.OdometrosHorimetrosModule,
	                deslocamentos_routing_module_1.DeslocamentosRoutingModule
	            ],
	            providers: [
	                deslocamento_api_service_1.DeslocamentoApiService,
	                deslocamento_navigation_service_1.DeslocamentoNavigationService,
	                deslocamento_service_1.DeslocamentoService
	            ],
	            declarations: [
	                deslocamentos_component_1.DeslocamentosComponent,
	                deslocamento_form_component_1.DeslocamentoFormComponent,
	                deslocamento_list_component_1.DeslocamentoListComponent,
	                delocamento_detail_component_1.DelocamentoDetailComponent,
	                deslocamento_history_component_1.DeslocamentoHistoryComponent,
	                deslocamento_calendar_component_1.DeslocamentoCalendarComponent,
	                deslocamento_table_component_1.DeslocamentoTableComponent,
	                custo_deslocamento_form_list_component_1.CustoDeslocamentoFormListComponent
	            ],
	            exports: [
	                deslocamento_table_component_1.DeslocamentoTableComponent,
	                custo_deslocamento_form_list_component_1.CustoDeslocamentoFormListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DeslocamentosModule);
	    return DeslocamentosModule;
	}());
	exports.DeslocamentosModule = DeslocamentosModule;


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var passageiro_api_service_1 = __webpack_require__(650);
	var passageiro_list_component_1 = __webpack_require__(681);
	var passageiros_routing_module_1 = __webpack_require__(680);
	var passageiro_form_component_1 = __webpack_require__(684);
	var passageiro_navigation_service_1 = __webpack_require__(665);
	var passageiro_service_1 = __webpack_require__(686);
	var passageiros_component_1 = __webpack_require__(678);
	var enderecos_module_1 = __webpack_require__(894);
	var passageiro_deslocamento_form_list_component_1 = __webpack_require__(946);
	var PassageirosModule = (function () {
	    function PassageirosModule() {
	    }
	    PassageirosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                enderecos_module_1.EnderecosModule,
	                passageiros_routing_module_1.PassageirosRoutingModule
	            ],
	            providers: [
	                passageiro_api_service_1.PassageiroApiService,
	                passageiro_navigation_service_1.PassageiroNavigationService,
	                passageiro_service_1.PassageiroService
	            ],
	            declarations: [
	                passageiros_component_1.PassageirosComponent,
	                passageiro_list_component_1.PassageiroListComponent,
	                passageiro_form_component_1.PassageiroFormComponent,
	                passageiro_deslocamento_form_list_component_1.PassageiroDeslocamentoFormListComponent
	            ],
	            exports: [
	                passageiro_deslocamento_form_list_component_1.PassageiroDeslocamentoFormListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PassageirosModule);
	    return PassageirosModule;
	}());
	exports.PassageirosModule = PassageirosModule;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var autocomplete_service_1 = __webpack_require__(101);
	var passageiro_api_service_1 = __webpack_require__(650);
	var data_service_1 = __webpack_require__(651);
	var passageiro_service_1 = __webpack_require__(686);
	var util_service_1 = __webpack_require__(88);
	var PassageiroDeslocamentoFormListComponent = (function () {
	    function PassageiroDeslocamentoFormListComponent(_passageiroApiService, _passageiroService, _autocompleteService, _utilService, _fb) {
	        this._passageiroApiService = _passageiroApiService;
	        this._passageiroService = _passageiroService;
	        this._autocompleteService = _autocompleteService;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this.list = [];
	        this.pontosList = [];
	        this.isAdm = false;
	        this.isEdition = false;
	        this.moduleName = data_service_1.passageirosModuleName;
	        this.passageiroObject = {};
	        this.newObject = {};
	        this.submitted = false;
	        this.passageiroId = 'passageiroSelect';
	        this.passageiro = new forms_1.FormControl('', forms_1.Validators.required);
	        this.observacao = new forms_1.FormControl('');
	        this.acompanhante = new forms_1.FormControl('');
	        this.passageiroTemplateResult = (function (state) {
	            return this._passageiroService.templateResult(state, false);
	        }.bind(this));
	        this.form2 = _fb.group({
	            passageiro: this.passageiro,
	            observacao: this.observacao,
	            acompanhante: this.acompanhante
	        });
	    }
	    PassageiroDeslocamentoFormListComponent.prototype.ngOnInit = function () {
	        this.passageiroQuery = this._utilService.cloneObject(data_service_1.passageirosQuery);
	        this.newItem();
	        this.formatPassageiros();
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.clickRemove = function (item, index) {
	        var onDelete = (function () {
	            if (this.list[index].id) {
	                this.onRemovePassageiro(item.id);
	            }
	            else {
	                this.list.splice(index, 1);
	            }
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.changePassageiroPonto = function (passageiro) {
	        if (passageiro.id) {
	            var pontoId = void 0;
	            if (passageiro.pontoEmbarque) {
	                pontoId = passageiro.pontoEmbarque.id;
	            }
	            var object = { pontoDeslocamentoEmbarqueId: pontoId, id: passageiro.id };
	            this.onEditPassageiro(object);
	        }
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            var object = this._utilService.cloneObject(this.newObject);
	            if (this.isAdm || this.isEdition) {
	                object.passageiroId = this.passageiroObject.id;
	                object.deslocamentoId = this.deslocamentoId;
	                this.onAddPassageiro(object);
	            }
	            else {
	                object.passageiro = this.passageiroObject;
	                this.setNewList(object);
	            }
	        }
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.getPassageiroObject = function (object) {
	        this.passageiroObject = object;
	        this._utilService.setSelectOnFormControl(this.form2, 'passageiro', object);
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.newItem = function () {
	        this.newObject = {
	            acompanhante: false,
	            observacao: '',
	            ativo: true
	        };
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.setNewList = function (object) {
	        this.list.push(object);
	        this.newItem();
	        this.passageiroObject = {};
	        this._autocompleteService.setValueOnSelect2(null, this.passageiroId);
	        this._utilService.setSelectOnFormControl(this.form2, 'passageiro', {});
	        this.submitted = false;
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.formatPassageiros = function () {
	        var x, lenX, y, lenY, ponto;
	        for (x = 0, lenX = this.list.length; x < lenX; x++) {
	            for (y = 0, lenY = this.pontosList.length; y < lenY; y++) {
	                ponto = this.pontosList[y];
	                if (this.list[x].pontoDeslocamentoEmbarqueId === this.pontosList[y].id) {
	                    this.list[x].pontoEmbarque = this.pontosList[y];
	                    break;
	                }
	            }
	        }
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.onAddPassageiro = function (object) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                Response.passageiro = this.passageiroObject;
	                this.setNewList(Response);
	                this._utilService.swalMessageAddSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._passageiroApiService.onPostPassageiroDeslocamento(object, onDone);
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.onEditPassageiro = function (object) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === object.id) {
	                        this.list[x].pontoDeslocamentoEmbarqueId = object.pontoDeslocamentoEmbarqueId;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageAddSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._passageiroApiService.onPutPassageiroDeslocamento(object, onDone);
	    };
	    PassageiroDeslocamentoFormListComponent.prototype.onRemovePassageiro = function (objectId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === objectId) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._passageiroApiService.onDeletePassageiroDeslocamento(objectId, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], PassageiroDeslocamentoFormListComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], PassageiroDeslocamentoFormListComponent.prototype, "pontosList", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], PassageiroDeslocamentoFormListComponent.prototype, "deslocamentoId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PassageiroDeslocamentoFormListComponent.prototype, "isAdm", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], PassageiroDeslocamentoFormListComponent.prototype, "isEdition", void 0);
	    PassageiroDeslocamentoFormListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-passageiro-deslocamento-form-list',
	            template: __webpack_require__(947),
	            styles: [__webpack_require__(948)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof passageiro_api_service_1.PassageiroApiService !== 'undefined' && passageiro_api_service_1.PassageiroApiService) === 'function' && _a) || Object, (typeof (_b = typeof passageiro_service_1.PassageiroService !== 'undefined' && passageiro_service_1.PassageiroService) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _e) || Object])
	    ], PassageiroDeslocamentoFormListComponent);
	    return PassageiroDeslocamentoFormListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.PassageiroDeslocamentoFormListComponent = PassageiroDeslocamentoFormListComponent;


/***/ },
/* 947 */
/***/ function(module, exports) {

	module.exports = "<form [formGroup]=\"form2\" (ngSubmit)=\"onSubmit(form2)\">\n    <div class=\"geo-content__row pt0\">\n        <div class=\"geo-columns--12c\">\n            <autocomplete-component class=\"geo-input--3c\" id=\"passageiroSelect\"\n                                    (setObejct)=\"getPassageiroObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"passageiroId\"\n                                    [model]=\"passageiroObject\"\n                                    [_service]=\"_passageiroApiService\"\n                                    [templateResult]=\"passageiroTemplateResult\"\n                                    [query]=\"passageiroQuery\"\n                                    [isCreateNew]=\"false\"\n                                    [label]=\"'Passageiro'\"></autocomplete-component>\n\n            <div class=\"geo-toggle toggleAcompanhante\">\n                <input type=\"checkbox\" id=\"acompanhante\" value=\"\" [(ngModel)]=\"newObject.acompanhante\" formControlName=\"acompanhante\">\n                <label for=\"acompanhante\">É acompanhante</label>\n            </div>\n\n            <div class=\"geo-input--9c\" >\n                <label for=\"observacao\">Observação</label>\n                <div>\n                    <input type=\"text\" id=\"observacao\" [(ngModel)]=\"newObject.observacao\" formControlName=\"observacao\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <button type=\"submit\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\">Adicionar passageiro</button>\n            </div>\n        </div>\n    </div>\n</form>\n\n<div class=\"geo-content__row\">\n    <table>\n        <thead>\n        <tr>\n            <th>Passageiro</th>\n            <th>Telefone</th>\n            <th>Acompanhante</th>\n            <th>Observação</th>\n            <th *ngIf=\"isAdm\">Ponto de embarque</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngIf=\"!list || list.length === 0\">\n        <tr>\n            <td colspan=\"6\">Nenhum {{moduleName.single | lowercase}} cadastrado</td>\n        </tr>\n        </tbody>\n        <tbody *ngFor=\"let item of (list | filterActive:false); let i=index\">\n        <tr>\n            <td><span *ngIf=\"item.passageiro\">{{item.passageiro.nome}}</span></td>\n            <td><span *ngIf=\"item.passageiro\">{{item.passageiro.telefone | phoneMask}}</span></td>\n            <td><span *ngIf=\"item.acompanhante\">Sim</span> <span *ngIf=\"!item.acompanhante\">Não</span></td>\n            <td><span>{{item.observacao}}</span></td>\n            <td class=\"geo-table--action\" *ngIf=\"isAdm\">\n                <select id=\"ponto\" [(ngModel)]=\"item.pontoEmbarque\" *ngIf=\"pontosList.length\" (ngModelChange)=\"changePassageiroPonto(item)\">\n                    <option *ngFor=\"let item of (pontosList | filterActive:false)\" [ngValue]=\"item\">{{item.ponto.nome}}</option>\n                </select>\n\n                <span *ngIf=\"!pontosList.length\">Nenhum ponto adicionado à viagem</span>\n            </td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickRemove(item, i)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        <tr class=\"description\">\n            <td colspan=\"100%\">\n                <p><strong>Observação: </strong> {{item.observacao}}<i *ngIf=\"!item.observacao\">não cadastrado</i></p>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n";

/***/ },
/* 948 */
943,
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(202);
	var deslocamento_api_service_1 = __webpack_require__(455);
	var deslocamento_navigation_service_1 = __webpack_require__(644);
	var util_service_1 = __webpack_require__(88);
	var DeslocamentoTableComponent = (function () {
	    function DeslocamentoTableComponent(_deslocamentosApiService, _deslocamentoNavigationService, _utilService) {
	        this._deslocamentosApiService = _deslocamentosApiService;
	        this._deslocamentoNavigationService = _deslocamentoNavigationService;
	        this._utilService = _utilService;
	        this.list = [];
	        this.showDisabled = false;
	        this.loading = true;
	        this.researched = true;
	        this.deslocamentosModuleName = data_service_1.deslocamentosModuleName;
	    }
	    DeslocamentoTableComponent.prototype.ngOnInit = function () {
	    };
	    DeslocamentoTableComponent.prototype.clickDetail = function (item) {
	        this._deslocamentoNavigationService.goToDetail(item.id);
	    };
	    DeslocamentoTableComponent.prototype.clickDelete = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    DeslocamentoTableComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list[x].ativo = false;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        this._deslocamentosApiService.onDelete(item.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], DeslocamentoTableComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DeslocamentoTableComponent.prototype, "showDisabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DeslocamentoTableComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], DeslocamentoTableComponent.prototype, "researched", void 0);
	    DeslocamentoTableComponent = __decorate([
	        core_1.Component({
	            selector: 'app-deslocamento-table',
	            template: __webpack_require__(950),
	            styles: [__webpack_require__(951)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof deslocamento_api_service_1.DeslocamentoApiService !== 'undefined' && deslocamento_api_service_1.DeslocamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof deslocamento_navigation_service_1.DeslocamentoNavigationService !== 'undefined' && deslocamento_navigation_service_1.DeslocamentoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object])
	    ], DeslocamentoTableComponent);
	    return DeslocamentoTableComponent;
	    var _a, _b, _c;
	}());
	exports.DeslocamentoTableComponent = DeslocamentoTableComponent;


/***/ },
/* 950 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n    <spinner-component [showDisplay]=\"true\" *ngIf=\"loading\"></spinner-component>\n\n    <p class=\"lead padding\" *ngIf=\"!list.length && !loading && researched\">Nenhuma {{deslocamentosModuleName.single | lowercase}} encontrada</p>\n\n    <table *ngIf=\"list.length\">\n        <thead>\n        <tr>\n            <th>Data/Hora da saída</th>\n            <th>Solicitante</th>\n            <th>Tipo</th>\n            <th>Status</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngFor=\"let item of(list | filterActive:showDisabled)\">\n        <tr [ngClass]=\"{inative: !item.ativo}\">\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\">{{item.dataHoraPrevistaSaida | date:'dd/MM/yyyy - HH:mm'}}</a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.solicitante && item.solicitante.pessoa\">{{item.solicitante.pessoa.nome}}</span></a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.tipo\">{{item.tipo.Value}}</span></a></td>\n            <td class=\"has-link cursor-pointer\"><a (click)=\"clickDetail(item)\"><span *ngIf=\"item.status\">{{item.status.Value}}</span></a></td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickDelete(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>";

/***/ },
/* 951 */
166,
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var util_service_1 = __webpack_require__(88);
	var deslocamento_api_service_1 = __webpack_require__(455);
	var CustoDeslocamentoFormListComponent = (function () {
	    function CustoDeslocamentoFormListComponent(_deslocamentoApiService, _utilService, _fb) {
	        this._deslocamentoApiService = _deslocamentoApiService;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this.list = [];
	        this.newObject = {};
	        this.submitted = false;
	        this.descricao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.valor = new forms_1.FormControl('', forms_1.Validators.required);
	        this.observacao = new forms_1.FormControl('');
	        this.comprovante = new forms_1.FormControl('');
	        this.form2 = _fb.group({
	            descricao: this.descricao,
	            valor: this.valor,
	            observacao: this.observacao,
	            comprovante: this.comprovante
	        });
	    }
	    CustoDeslocamentoFormListComponent.prototype.ngOnInit = function () {
	        var t = 0.0;
	        this.list.forEach(function (item) {
	            if (item.valor) {
	                t += item.valor;
	            }
	        });
	        this.total = t;
	        this.newItem();
	    };
	    CustoDeslocamentoFormListComponent.prototype.clickRemove = function (item) {
	        var onDelete = (function () {
	            this.onRemoveCusto(item.id);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    CustoDeslocamentoFormListComponent.prototype.keyupCurrency = function (start) {
	        var valor = this._utilService.currencyFormat(this.newObject.valor, start);
	        if (valor) {
	            this.newObject.valor = valor;
	        }
	    };
	    CustoDeslocamentoFormListComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            var object = this._utilService.cloneObject(this.newObject);
	            object.deslocamentoId = this.deslocamentoId;
	            if (object.valor) {
	                object.valor = this._utilService.getCurrency(object.valor);
	            }
	            this.onAddCusto(object);
	        }
	    };
	    CustoDeslocamentoFormListComponent.prototype.newItem = function () {
	        var object = {
	            ativo: true
	        };
	        this.newObject = object;
	    };
	    CustoDeslocamentoFormListComponent.prototype.onAddCusto = function (object) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.total += Response.valor;
	                this.list.push(Response);
	                this.newItem();
	                this.submitted = false;
	                this._utilService.swalMessageAddSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._deslocamentoApiService.onPostCustoDeslocamento(object, onDone);
	    };
	    CustoDeslocamentoFormListComponent.prototype.onRemoveCusto = function (objectId) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x = void 0, lenX = void 0;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === objectId) {
	                        this.list[x].ativo = false;
	                        this.total -= this.list[x].valor;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	            }
	        }.bind(this));
	        this._deslocamentoApiService.onDeleteCustoDeslocamento(objectId, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], CustoDeslocamentoFormListComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], CustoDeslocamentoFormListComponent.prototype, "deslocamentoId", void 0);
	    CustoDeslocamentoFormListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-custo-deslocamento-form-list',
	            template: __webpack_require__(953),
	            styles: [__webpack_require__(954)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof deslocamento_api_service_1.DeslocamentoApiService !== 'undefined' && deslocamento_api_service_1.DeslocamentoApiService) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _c) || Object])
	    ], CustoDeslocamentoFormListComponent);
	    return CustoDeslocamentoFormListComponent;
	    var _a, _b, _c;
	}());
	exports.CustoDeslocamentoFormListComponent = CustoDeslocamentoFormListComponent;


/***/ },
/* 953 */
/***/ function(module, exports) {

	module.exports = "<form [formGroup]=\"form2\" (ngSubmit)=\"onSubmit(form2)\">\n    <div class=\"geo-content__row pt0\">\n        <div class=\"geo-columns--12c\">\n            <div class=\"geo-input--9c\" [ngClass]=\"{'geo-input--error': !descricao.valid && submitted}\">\n                <label for=\"descricao\">Descritivo <abbr>*</abbr></label>\n                <div>\n                    <input type=\"text\" id=\"descricao\" [(ngModel)]=\"newObject.descricao\" formControlName=\"descricao\">\n                </div>\n            </div>\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !valor.valid && submitted}\">\n                <label for=\"valor\">Valor (R$) <abbr>*</abbr></label>\n                <div>\n                    <input type=\"text\" id=\"valor\" [(ngModel)]=\"newObject.valor\" formControlName=\"valor\" (keyup)=\"keyupCurrency()\">\n                </div>\n            </div>\n            <div class=\"geo-input--9c\" >\n                <label for=\"observacao\">Observação </label>\n                <div>\n                    <input type=\"text\" id=\"observacao\" [(ngModel)]=\"newObject.observacao\" formControlName=\"observacao\">\n                </div>\n            </div>\n            <div class=\"geo-input--3c\" >\n                <label for=\"comprovante\">Comprovante </label>\n                <div>\n                    <input type=\"text\" id=\"comprovante\" [(ngModel)]=\"newObject.comprovante\" formControlName=\"comprovante\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <button type=\"submit\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\">Adicionar custo</button>\n            </div>\n        </div>\n    </div>\n</form>\n\n<div class=\"geo-content__row\">\n    <table>\n        <thead>\n        <tr>\n            <th>Descritivo</th>\n            <th>Valor</th>\n            <th>Comprovante</th>\n            <th>Observação</th>\n            <th class=\"small\"></th>\n        </tr>\n        </thead>\n        <tbody *ngIf=\"!list || list.length === 0\">\n        <tr>\n            <td colspan=\"5\">Nenhum custo cadastrado</td>\n        </tr>\n        </tbody>\n        <tbody *ngFor=\"let item of (list | filterActive:false); let i=index\">\n        <tr>\n            <td>{{item.descricao}}</td>\n            <td>{{item.valor | currencyMask}}</td>\n            <td>{{item.comprovante}}</td>\n            <td>{{item.observacao}}</td>\n            <td class=\"geo-table--action\">\n                <a (click)=\"clickRemove(item)\">\n                    <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n                </a>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n\n    <div class=\"geo-columns--12c\" >\n        <div class=\"geo-input--12c\">\n            <label>Valor Total: </label>\n            <span>{{total | currencyMask}}</span>\n        </div>\n    </div>\n</div>\n";

/***/ },
/* 954 */
943,
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var odometro_horimetro_api_service_1 = __webpack_require__(450);
	var odometro_horimetro_service_1 = __webpack_require__(131);
	var odometro_horimetro_form_component_1 = __webpack_require__(956);
	var odometro_horimetro_label_component_1 = __webpack_require__(959);
	var OdometrosHorimetrosModule = (function () {
	    function OdometrosHorimetrosModule() {
	    }
	    OdometrosHorimetrosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                odometro_horimetro_service_1.OdometroHorimetroService,
	                odometro_horimetro_api_service_1.OdometroHorimetroApiService
	            ],
	            declarations: [
	                odometro_horimetro_form_component_1.OdometroHorimetroFormComponent,
	                odometro_horimetro_label_component_1.OdometroHorimetroLabelComponent
	            ],
	            exports: [
	                odometro_horimetro_form_component_1.OdometroHorimetroFormComponent,
	                odometro_horimetro_label_component_1.OdometroHorimetroLabelComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OdometrosHorimetrosModule);
	    return OdometrosHorimetrosModule;
	}());
	exports.OdometrosHorimetrosModule = OdometrosHorimetrosModule;


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var odometro_horimetro_api_service_1 = __webpack_require__(450);
	var odometro_horimetro_service_1 = __webpack_require__(131);
	var OdometroHorimetroFormComponent = (function () {
	    function OdometroHorimetroFormComponent(_odometroHorimetroApiService, _odometroHorimetroService) {
	        this._odometroHorimetroApiService = _odometroHorimetroApiService;
	        this._odometroHorimetroService = _odometroHorimetroService;
	        this.labelOdometro = '';
	        this.labelHorimetro = '';
	        this.showOdometro = true;
	        this.submitted = false;
	        this.required = false;
	        this.returnModel = new core_1.EventEmitter();
	        this.lasBemId = 0;
	    }
	    OdometroHorimetroFormComponent.prototype.ngOnInit = function () { };
	    OdometroHorimetroFormComponent.prototype.ngDoCheck = function () {
	        if (this.bemId && (this.bemId !== this.lasBemId)) {
	            this.lasBemId = this.bemId;
	            this.getLastOdometroHorimetro();
	        }
	    };
	    OdometroHorimetroFormComponent.prototype.changeModel = function () {
	        var t = this._odometroHorimetroService.setMask(this.model);
	        this.returnModel.emit(t);
	    };
	    OdometroHorimetroFormComponent.prototype.getLastOdometroHorimetro = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var y = this._odometroHorimetroService.setMask(Response.odometroHorimetro);
	                this.lastOdometroHorimetro = y;
	            }
	            else {
	                this.lastOdometroHorimetro = '';
	            }
	        }.bind(this));
	        this._odometroHorimetroApiService.onGetLast(this.bemId, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OdometroHorimetroFormComponent.prototype, "labelOdometro", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OdometroHorimetroFormComponent.prototype, "labelHorimetro", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], OdometroHorimetroFormComponent.prototype, "showOdometro", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], OdometroHorimetroFormComponent.prototype, "submitted", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], OdometroHorimetroFormComponent.prototype, "required", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OdometroHorimetroFormComponent.prototype, "model", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], OdometroHorimetroFormComponent.prototype, "bemId", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], OdometroHorimetroFormComponent.prototype, "returnModel", void 0);
	    OdometroHorimetroFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-odometro-horimetro-form-component',
	            template: __webpack_require__(957),
	            styles: [__webpack_require__(958)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof odometro_horimetro_api_service_1.OdometroHorimetroApiService !== 'undefined' && odometro_horimetro_api_service_1.OdometroHorimetroApiService) === 'function' && _b) || Object, (typeof (_c = typeof odometro_horimetro_service_1.OdometroHorimetroService !== 'undefined' && odometro_horimetro_service_1.OdometroHorimetroService) === 'function' && _c) || Object])
	    ], OdometroHorimetroFormComponent);
	    return OdometroHorimetroFormComponent;
	    var _a, _b, _c;
	}());
	exports.OdometroHorimetroFormComponent = OdometroHorimetroFormComponent;


/***/ },
/* 957 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': required && submitted && !model}\">\n    <label *ngIf=\"showOdometro\">{{labelOdometro}} <abbr *ngIf=\"required\">*</abbr></label>\n    <label *ngIf=\"!showOdometro\">{{labelHorimetro}} <abbr *ngIf=\"required\">*</abbr></label>\n    <div>\n        <span class=\"error-alert\" *ngIf=\"required && submitted && !model\">Este campo é obrigatório / Formato incorreto.</span>\n        <input type=\"text\" class=\"form-control\" placeholder=\"{{lastOdometroHorimetro}}\" id=\"odometroHorimetroValor\" [(ngModel)]=\"model\" (ngModelChange)=\"changeModel()\" appOdometroHorimetroMask>\n    </div>\n</div>";

/***/ },
/* 958 */
124,
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forma_controle_service_1 = __webpack_require__(369);
	var OdometroHorimetroLabelComponent = (function () {
	    function OdometroHorimetroLabelComponent(_formaControleService) {
	        this._formaControleService = _formaControleService;
	        this.labelOdometro = '';
	        this.labelHorimetro = '';
	        this.bemObject = {};
	        this.odometroHorimetroObject = {};
	        this.showOdometro = false;
	    }
	    OdometroHorimetroLabelComponent.prototype.ngOnInit = function () {
	        this.horimetro = this._formaControleService.getFormaControleHorimetro();
	        this.odometro = this._formaControleService.getFormaControleOdometro();
	    };
	    OdometroHorimetroLabelComponent.prototype.ngDoCheck = function () {
	        if (this.bemObject) {
	            if (this.bemObject.formaControleId === this.odometro) {
	                this.showOdometro = true;
	            }
	            else {
	                this.showOdometro = false;
	            }
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OdometroHorimetroLabelComponent.prototype, "labelOdometro", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OdometroHorimetroLabelComponent.prototype, "labelHorimetro", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OdometroHorimetroLabelComponent.prototype, "bemObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OdometroHorimetroLabelComponent.prototype, "odometroHorimetroObject", void 0);
	    OdometroHorimetroLabelComponent = __decorate([
	        core_1.Component({
	            selector: 'app-odometro-horimetro-label-component',
	            template: __webpack_require__(960),
	            styles: [__webpack_require__(961)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _a) || Object])
	    ], OdometroHorimetroLabelComponent);
	    return OdometroHorimetroLabelComponent;
	    var _a;
	}());
	exports.OdometroHorimetroLabelComponent = OdometroHorimetroLabelComponent;


/***/ },
/* 960 */
/***/ function(module, exports) {

	module.exports = "<span *ngIf=\"bemObject\">\n    <strong *ngIf=\"showOdometro\">{{labelOdometro}} </strong>\n    <strong *ngIf=\"!showOdometro\">{{labelHorimetro}} </strong>\n    <span *ngIf=\"odometroHorimetroObject\">{{odometroHorimetroObject.odometroHorimetro | odometroHorimetroMask}}</span>\n    <i *ngIf=\"!odometroHorimetroObject && (odometroHorimetroObject != 0)\">não cadastrado</i>\n</span>";

/***/ },
/* 961 */
124,
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(457);
	var data_service_2 = __webpack_require__(202);
	var data_service_3 = __webpack_require__(625);
	var data_service_4 = __webpack_require__(178);
	var ViagemMenuComponent = (function () {
	    function ViagemMenuComponent() {
	        this.viagensRoute = data_service_1.viagensRoute;
	        this.deslocamentosRoute = data_service_2.deslocamentosRoute;
	        this.pontosRoute = data_service_3.pontosRoute;
	        this.configuracaoRoute = data_service_4.configuracaoRoute;
	        this.deslocamentosModule = data_service_2.deslocamentosModuleName;
	        this.pontosModule = data_service_3.pontosModuleName;
	        this.configuracaoModule = data_service_4.configuracaoModuleName;
	    }
	    ViagemMenuComponent.prototype.ngOnInit = function () {
	    };
	    ViagemMenuComponent = __decorate([
	        core_1.Component({
	            selector: 'app-viagem-menu',
	            template: __webpack_require__(963)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ViagemMenuComponent);
	    return ViagemMenuComponent;
	}());
	exports.ViagemMenuComponent = ViagemMenuComponent;


/***/ },
/* 963 */
/***/ function(module, exports) {

	module.exports = "<span class=\"geo-arrow\"></span>\n<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-viagem'/></svg>\n<span>Deslocamentos</span>\n<div class=\"geo-submenu\">\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + viagensRoute + '/' + deslocamentosRoute]\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">{{deslocamentosModule.plural}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + viagensRoute + '/' + deslocamentosRoute + '/historico']\" routerLinkActive=\"active\">Histórico</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + viagensRoute + '/' + deslocamentosRoute + '/agenda']\" routerLinkActive=\"active\">Agenda</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + viagensRoute + '/' + configuracaoRoute]\" routerLinkActive=\"active\">{{configuracaoModule.plural}}</a>\n</div>\n";

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var destinos_component_1 = __webpack_require__(668);
	var shared_module_1 = __webpack_require__(57);
	var destinos_routing_module_1 = __webpack_require__(670);
	var destino_api_service_1 = __webpack_require__(459);
	var destino_navigation_service_1 = __webpack_require__(664);
	var destino_service_1 = __webpack_require__(672);
	var destino_form_component_1 = __webpack_require__(675);
	var destino_list_component_1 = __webpack_require__(671);
	var DestinosModule = (function () {
	    function DestinosModule() {
	    }
	    DestinosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                destinos_routing_module_1.DestinosRoutingModule
	            ],
	            providers: [
	                destino_api_service_1.DestinoApiService,
	                destino_navigation_service_1.DestinoNavigationService,
	                destino_service_1.DestinoService
	            ],
	            declarations: [
	                destinos_component_1.DestinosComponent,
	                destino_form_component_1.DestinoFormComponent,
	                destino_list_component_1.DestinoListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DestinosModule);
	    return DestinosModule;
	}());
	exports.DestinosModule = DestinosModule;


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(457);
	var data_service_2 = __webpack_require__(202);
	var VisitanteViagemMenuComponent = (function () {
	    function VisitanteViagemMenuComponent() {
	        this.viagensRoute = data_service_1.viagensRoute;
	        this.deslocamentosRoute = data_service_2.deslocamentosRoute;
	        this.deslocamentosModule = data_service_2.deslocamentosModuleName;
	    }
	    VisitanteViagemMenuComponent.prototype.ngOnInit = function () {
	    };
	    VisitanteViagemMenuComponent = __decorate([
	        core_1.Component({
	            selector: 'app-visitante-viagem-menu',
	            template: __webpack_require__(966)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], VisitanteViagemMenuComponent);
	    return VisitanteViagemMenuComponent;
	}());
	exports.VisitanteViagemMenuComponent = VisitanteViagemMenuComponent;


/***/ },
/* 966 */
/***/ function(module, exports) {

	module.exports = "<a class=\"geo-menu__button\" style=\"display: block;\" [routerLink]=\"['./' + viagensRoute + '/' + deslocamentosRoute]\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">\n    <svg>\n        <use xlink:href='../../assets/images/icons/icons.svg#icon-viagem' />\n    </svg>\n    <span>{{deslocamentosModule.plural}}</span>\n</a>";

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var tipo_viagem_api_service_1 = __webpack_require__(653);
	var TiposViagemModule = (function () {
	    function TiposViagemModule() {
	    }
	    TiposViagemModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	            ],
	            providers: [
	                tipo_viagem_api_service_1.TipoViagemApiService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TiposViagemModule);
	    return TiposViagemModule;
	}());
	exports.TiposViagemModule = TiposViagemModule;


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var frotas_component_1 = __webpack_require__(364);
	var frotas_routing_module_1 = __webpack_require__(366);
	var frota_api_service_1 = __webpack_require__(368);
	var frota_navigation_service_1 = __webpack_require__(198);
	var frota_service_1 = __webpack_require__(203);
	var frota_form_component_1 = __webpack_require__(372);
	var frota_list_component_1 = __webpack_require__(367);
	var bem_combustiveis_module_1 = __webpack_require__(969);
	var frota_detail_component_1 = __webpack_require__(391);
	var frota_imagem_component_1 = __webpack_require__(446);
	var frota_odometro_horimetro_component_1 = __webpack_require__(449);
	var odometros_horimetros_module_1 = __webpack_require__(955);
	var FrotasModule = (function () {
	    function FrotasModule() {
	    }
	    FrotasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                bem_combustiveis_module_1.BemCombustiveisModule,
	                odometros_horimetros_module_1.OdometrosHorimetrosModule,
	                frotas_routing_module_1.FrotasRoutingModule
	            ],
	            providers: [
	                frota_api_service_1.FrotaApiService,
	                frota_navigation_service_1.FrotaNavigationService,
	                frota_service_1.FrotasService
	            ],
	            declarations: [
	                frotas_component_1.FrotasComponent,
	                frota_form_component_1.FrotaFormComponent,
	                frota_list_component_1.FrotaListComponent,
	                frota_detail_component_1.FrotaDetailComponent,
	                frota_imagem_component_1.FrotaImagemComponent,
	                frota_odometro_horimetro_component_1.FrotaOdometroHorimetroComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FrotasModule);
	    return FrotasModule;
	}());
	exports.FrotasModule = FrotasModule;


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var bem_combustivel_api_service_1 = __webpack_require__(379);
	var BemCombustiveisModule = (function () {
	    function BemCombustiveisModule() {
	    }
	    BemCombustiveisModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                bem_combustivel_api_service_1.BemCombustivelApiService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BemCombustiveisModule);
	    return BemCombustiveisModule;
	}());
	exports.BemCombustiveisModule = BemCombustiveisModule;


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var combustiveis_module_1 = __webpack_require__(971);
	var locais_module_1 = __webpack_require__(972);
	var bombas_module_1 = __webpack_require__(973);
	var abastecimento_bens_module_1 = __webpack_require__(978);
	var abastecimento_configuracao_component_1 = __webpack_require__(584);
	var abastecimentos_routing_module_1 = __webpack_require__(542);
	var abastecimentos_component_1 = __webpack_require__(540);
	var abastecimento_menu_component_1 = __webpack_require__(979);
	var abastecimento_service_1 = __webpack_require__(546);
	var tanques_module_1 = __webpack_require__(981);
	var tipo_ajustes_module_1 = __webpack_require__(985);
	var abastecimento_relatorio_component_1 = __webpack_require__(622);
	var AbastecimentosModule = (function () {
	    function AbastecimentosModule() {
	    }
	    AbastecimentosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                combustiveis_module_1.CombustiveisModule,
	                locais_module_1.LocaisModule,
	                bombas_module_1.BombasModule,
	                abastecimento_bens_module_1.AbastecimentoBensModule,
	                tanques_module_1.TanquesModule,
	                tipo_ajustes_module_1.TipoAjustesModule,
	                abastecimentos_routing_module_1.AbastecimentosRoutingModule
	            ],
	            providers: [
	                abastecimento_service_1.AbastecimentoService,
	            ],
	            declarations: [
	                abastecimentos_component_1.AbastecimentosComponent,
	                abastecimento_configuracao_component_1.AbastecimentoConfiguracaoComponent,
	                abastecimento_menu_component_1.AbastecimentoMenuComponent,
	                abastecimento_relatorio_component_1.AbastecimentoRelatorioComponent
	            ],
	            exports: [
	                abastecimento_menu_component_1.AbastecimentoMenuComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AbastecimentosModule);
	    return AbastecimentosModule;
	}());
	exports.AbastecimentosModule = AbastecimentosModule;


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var combustivel_api_service_1 = __webpack_require__(376);
	var combustivel_navigation_service_1 = __webpack_require__(575);
	var combustivel_list_component_1 = __webpack_require__(574);
	var combustivel_service_1 = __webpack_require__(576);
	var combustiveis_routing_module_1 = __webpack_require__(573);
	var combustivel_form_component_1 = __webpack_require__(579);
	var combustiveis_component_1 = __webpack_require__(571);
	var CombustiveisModule = (function () {
	    function CombustiveisModule() {
	    }
	    CombustiveisModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                combustiveis_routing_module_1.CombustiveisRoutingModule
	            ],
	            providers: [
	                combustivel_api_service_1.CombustivelApiService,
	                combustivel_navigation_service_1.CombustivelNavigationService,
	                combustivel_service_1.CombustivelService
	            ],
	            declarations: [
	                combustiveis_component_1.CombustiveisComponent,
	                combustivel_list_component_1.CombustivelListComponent,
	                combustivel_form_component_1.CombustivelFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CombustiveisModule);
	    return CombustiveisModule;
	}());
	exports.CombustiveisModule = CombustiveisModule;


/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var locais_component_1 = __webpack_require__(582);
	var shared_module_1 = __webpack_require__(57);
	var locais_routing_module_1 = __webpack_require__(543);
	var local_api_service_1 = __webpack_require__(407);
	var local_navigation_service_1 = __webpack_require__(545);
	var local_service_1 = __webpack_require__(399);
	var local_form_component_1 = __webpack_require__(549);
	var local_list_component_1 = __webpack_require__(544);
	var bombas_module_1 = __webpack_require__(973);
	var local_combustivel_form_component_1 = __webpack_require__(974);
	var local_combustivel_list_component_1 = __webpack_require__(976);
	var LocaisModule = (function () {
	    function LocaisModule() {
	    }
	    LocaisModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                bombas_module_1.BombasModule,
	                locais_routing_module_1.LocaisRoutingModule
	            ],
	            providers: [
	                local_api_service_1.LocalApiService,
	                local_navigation_service_1.LocalNavigationService,
	                local_service_1.LocalService
	            ],
	            declarations: [
	                locais_component_1.LocaisComponent,
	                local_form_component_1.LocalFormComponent,
	                local_list_component_1.LocalListComponent,
	                local_combustivel_form_component_1.LocalCombustivelFormComponent,
	                local_combustivel_list_component_1.LocalCombustivelListComponent
	            ],
	            exports: [
	                local_combustivel_form_component_1.LocalCombustivelFormComponent,
	                local_combustivel_list_component_1.LocalCombustivelListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocaisModule);
	    return LocaisModule;
	}());
	exports.LocaisModule = LocaisModule;


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var bombas_component_1 = __webpack_require__(552);
	var bomba_list_component_1 = __webpack_require__(559);
	var bomba_form_component_1 = __webpack_require__(555);
	var bomba_api_service_1 = __webpack_require__(408);
	var bomba_navigation_service_1 = __webpack_require__(403);
	var bomba_service_1 = __webpack_require__(402);
	var bombas_routing_module_1 = __webpack_require__(554);
	var bomba_auditoria_list_component_1 = __webpack_require__(562);
	var bomba_auditoria_detail_component_1 = __webpack_require__(565);
	var bomba_auditoria_component_1 = __webpack_require__(568);
	var BombasModule = (function () {
	    function BombasModule() {
	    }
	    BombasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                bombas_routing_module_1.BombasRoutingModule
	            ],
	            providers: [
	                bomba_api_service_1.BombaApiService,
	                bomba_navigation_service_1.BombaNavigationService,
	                bomba_service_1.BombaService
	            ],
	            declarations: [
	                bombas_component_1.BombasComponent,
	                bomba_list_component_1.BombaListComponent,
	                bomba_form_component_1.BombaFormComponent,
	                bomba_auditoria_list_component_1.BombaAuditoriaListComponent,
	                bomba_auditoria_detail_component_1.BombaAuditoriaDetailComponent,
	                bomba_auditoria_component_1.BombaAuditoriaComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], BombasModule);
	    return BombasModule;
	}());
	exports.BombasModule = BombasModule;


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var util_service_1 = __webpack_require__(88);
	var combustivel_api_service_1 = __webpack_require__(376);
	var LocalCombustivelFormComponent = (function () {
	    function LocalCombustivelFormComponent(_combustivelApiService, _utilService, _route) {
	        this._combustivelApiService = _combustivelApiService;
	        this._utilService = _utilService;
	        this._route = _route;
	        this.list = [];
	        this.combustiveisList = [];
	    }
	    LocalCombustivelFormComponent.prototype.ngOnInit = function () {
	        this.getCombustiveis();
	    };
	    LocalCombustivelFormComponent.prototype.clickAddNew = function () {
	        var newItem = {
	            ativo: true,
	            combustivel: this.combustiveisList[0]
	        };
	        this.list.push(newItem);
	    };
	    LocalCombustivelFormComponent.prototype.keyupCurrency = function (item, i) {
	        var valor = this._utilService.currencyFormat(item.preco, false);
	        if (valor) {
	            this.list[i].preco = valor;
	        }
	    };
	    LocalCombustivelFormComponent.prototype.getCombustiveis = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.combustiveisList = list;
	                if (!this.list.length) {
	                    this.clickAddNew();
	                }
	                this.setListBind();
	            }
	        }.bind(this));
	        this._combustivelApiService.onGetAll(onDone);
	    };
	    LocalCombustivelFormComponent.prototype.setListBind = function () {
	        var x = 0, lenX = this.list.length, y = 0, lenY = this.combustiveisList.length;
	        for (x, lenX; x < lenX; x++) {
	            var valor = this._utilService.currencyFormat(this.list[x].preco, true);
	            if (valor) {
	                this.list[x].preco = valor;
	            }
	            for (y = 0, lenY = this.combustiveisList.length; y < lenY; y++) {
	                if (this.list[x].combustivelId === this.combustiveisList[y].id) {
	                    this.list[x].combustivel = this.combustiveisList[y];
	                    break;
	                }
	            }
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], LocalCombustivelFormComponent.prototype, "list", void 0);
	    LocalCombustivelFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-local-combustivel-form',
	            template: __webpack_require__(975)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof combustivel_api_service_1.CombustivelApiService !== 'undefined' && combustivel_api_service_1.CombustivelApiService) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object])
	    ], LocalCombustivelFormComponent);
	    return LocalCombustivelFormComponent;
	    var _a, _b, _c;
	}());
	exports.LocalCombustivelFormComponent = LocalCombustivelFormComponent;


/***/ },
/* 975 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n    <h2>Combustíveis</h2>\n    <div class=\"geo-columns--12c\" *ngFor=\"let item of list; let i = index;\">\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Ativo</span>\n            <input type=\"checkbox\" [(ngModel)]=\"item.ativo\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n        <div class=\"geo-input--3c\">\n            <label>Combustível <abbr>*</abbr></label>\n            <div>\n                <select id=\"combustivel_{{i}}\" [(ngModel)]=\"item.combustivel\">\n                    <option *ngFor=\"let fuel of combustiveisList\" [ngValue]=\"fuel\">{{fuel.combustivel}}</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"geo-input--3c\">\n            <label>Preço (R$) <abbr>*</abbr></label>\n            <div>\n                <input type=\"text\" id=\"subtipo_{{i}}\" [(ngModel)]=\"item.preco\" (keyup)=\"keyupCurrency(item, i)\" >\n            </div>\n        </div>\n    </div>\n\n    <button type=\"button\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickAddNew()\">Adicionar combustível</button>\n</div>\n";

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LocalCombustivelListComponent = (function () {
	    function LocalCombustivelListComponent() {
	        this.list = [];
	        this.showDisabled = false;
	    }
	    LocalCombustivelListComponent.prototype.ngOnInit = function () {
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], LocalCombustivelListComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], LocalCombustivelListComponent.prototype, "showDisabled", void 0);
	    LocalCombustivelListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-local-combustivel-list',
	            template: __webpack_require__(977)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LocalCombustivelListComponent);
	    return LocalCombustivelListComponent;
	}());
	exports.LocalCombustivelListComponent = LocalCombustivelListComponent;


/***/ },
/* 977 */
/***/ function(module, exports) {

	module.exports = "<table>\n    <thead>\n    <tr>\n        <th>Combustível</th>\n        <th>Preço (R$)</th>\n    </tr>\n    </thead>\n    <tbody *ngIf=\"!list || list.length === 0\">\n    <tr>\n        <td colspan=\"2\">Nenhum combustível adicionado</td>\n    </tr>\n    </tbody>\n    <tbody *ngFor=\"let item of (list | filterActive:showDisabled | sort:['combustivel.combustivel'])\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n        <td><span *ngIf=\"item.combustivel\">{{item.combustivel.combustivel}}</span></td>\n        <td>{{item.preco | currencyMask}}</td>\n    </tr>\n    </tbody>\n</table>\n\n<!--| filterActive:showDisabled | sort:['subTipo']-->";

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var abastecimento_bens_component_1 = __webpack_require__(619);
	var abastecimento_bem_form_component_1 = __webpack_require__(411);
	var abastecimento_bem_list_component_1 = __webpack_require__(394);
	var shared_module_1 = __webpack_require__(57);
	var abastecimento_bens_routing_module_1 = __webpack_require__(621);
	var abastecimento_bem_api_service_1 = __webpack_require__(395);
	var abastecimento_bem_navigation_service_1 = __webpack_require__(397);
	var abastecimento_bem_service_1 = __webpack_require__(396);
	var odometros_horimetros_module_1 = __webpack_require__(955);
	var AbastecimentoBensModule = (function () {
	    function AbastecimentoBensModule() {
	    }
	    AbastecimentoBensModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                odometros_horimetros_module_1.OdometrosHorimetrosModule,
	                abastecimento_bens_routing_module_1.AbastecimentoBensRoutingModule
	            ],
	            providers: [
	                abastecimento_bem_api_service_1.AbastecimentoBemApiService,
	                abastecimento_bem_navigation_service_1.AbastecimentoBemNavigationService,
	                abastecimento_bem_service_1.AbastecimentoBemService
	            ],
	            declarations: [
	                abastecimento_bens_component_1.AbastecimentoBensComponent,
	                abastecimento_bem_form_component_1.AbastecimentoBemFormComponent,
	                abastecimento_bem_list_component_1.AbastecimentoBemListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AbastecimentoBensModule);
	    return AbastecimentoBensModule;
	}());
	exports.AbastecimentoBensModule = AbastecimentoBensModule;


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(199);
	var data_service_2 = __webpack_require__(401);
	var data_service_3 = __webpack_require__(398);
	var data_service_4 = __webpack_require__(404);
	var AbastecimentoMenuComponent = (function () {
	    function AbastecimentoMenuComponent() {
	        this.abastecimentosRoute = data_service_3.abastecimentosRoute;
	        this.abastecimentoBensRoute = data_service_1.abastecimentoBensRoute;
	        this.abastecimentoBensModule = data_service_1.abastecimentoBensModuleName;
	        this.bombasRoute = data_service_2.bombasRoute;
	        this.tanquesRoute = data_service_4.tanquesRoute;
	        this.tanquesEstoqueRoute = data_service_4.tanquesEstoqueRoute;
	        this.tanquesEstoqueModuleName = data_service_4.tanquesEstoqueModuleName;
	        this.bombasAuditoriaRoute = data_service_2.bombasAuditoriaRoute;
	        this.bombasAuditoriaModuleName = data_service_2.bombasAuditoriaModuleName;
	    }
	    AbastecimentoMenuComponent.prototype.ngOnInit = function () {
	    };
	    AbastecimentoMenuComponent = __decorate([
	        core_1.Component({
	            selector: 'app-abastecimento-menu',
	            template: __webpack_require__(980)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AbastecimentoMenuComponent);
	    return AbastecimentoMenuComponent;
	}());
	exports.AbastecimentoMenuComponent = AbastecimentoMenuComponent;


/***/ },
/* 980 */
/***/ function(module, exports) {

	module.exports = "<span class=\"geo-arrow\"></span>\n<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-abastecimento'/></svg>\n<span>Abastecimentos</span>\n<div class=\"geo-submenu\">\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + abastecimentosRoute + '/' + abastecimentoBensRoute]\" routerLinkActive=\"active\">{{abastecimentoBensModule.plural}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + abastecimentosRoute + '/' + tanquesRoute + '/' + tanquesEstoqueRoute]\" routerLinkActive=\"active\">{{tanquesEstoqueModuleName.single}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + abastecimentosRoute + '/' + bombasAuditoriaRoute]\" routerLinkActive=\"active\">{{bombasAuditoriaModuleName.single}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + abastecimentosRoute + '/relatorios']\" routerLinkActive=\"active\">Relatórios</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + abastecimentosRoute + '/configuracoes']\" routerLinkActive=\"active\">Configurações</a>\n</div>\n";

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var tanques_component_1 = __webpack_require__(589);
	var shared_module_1 = __webpack_require__(57);
	var tanque_api_service_1 = __webpack_require__(416);
	var tanque_navigation_service_1 = __webpack_require__(406);
	var tanque_service_1 = __webpack_require__(405);
	var tanques_routing_module_1 = __webpack_require__(591);
	var tanque_form_component_1 = __webpack_require__(595);
	var tanque_list_component_1 = __webpack_require__(592);
	var tanque_estoque_list_component_1 = __webpack_require__(598);
	var tanque_movimentacao_detail_component_1 = __webpack_require__(601);
	var tanque_movimentacao_form_component_1 = __webpack_require__(604);
	var tanque_movimentacao_area_form_component_1 = __webpack_require__(982);
	var TanquesModule = (function () {
	    function TanquesModule() {
	    }
	    TanquesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                tanques_routing_module_1.TanquesRoutingModule
	            ],
	            providers: [
	                tanque_api_service_1.TanqueApiService,
	                tanque_navigation_service_1.TanqueNavigationService,
	                tanque_service_1.TanqueService
	            ],
	            declarations: [
	                tanques_component_1.TanquesComponent,
	                tanque_form_component_1.TanqueFormComponent,
	                tanque_list_component_1.TanqueListComponent,
	                tanque_estoque_list_component_1.TanqueEstoqueListComponent,
	                tanque_movimentacao_detail_component_1.TanqueMovimentacaoDetailComponent,
	                tanque_movimentacao_form_component_1.TanqueMovimentacaoFormComponent,
	                tanque_movimentacao_area_form_component_1.TanqueMovimentacaoAreaFormComponent
	            ],
	            exports: [
	                tanque_movimentacao_area_form_component_1.TanqueMovimentacaoAreaFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TanquesModule);
	    return TanquesModule;
	}());
	exports.TanquesModule = TanquesModule;


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var area_api_service_1 = __webpack_require__(275);
	var TanqueMovimentacaoAreaFormComponent = (function () {
	    function TanqueMovimentacaoAreaFormComponent(_areaApiService) {
	        this._areaApiService = _areaApiService;
	        this.list = [];
	        this.showMessage = false;
	        this.areasList = [];
	    }
	    TanqueMovimentacaoAreaFormComponent.prototype.ngOnInit = function () {
	        this.getAreas();
	    };
	    TanqueMovimentacaoAreaFormComponent.prototype.clickAddNew = function () {
	        var newItem = {
	            ativo: true,
	            area: this.areasList[0]
	        };
	        this.list.push(newItem);
	    };
	    TanqueMovimentacaoAreaFormComponent.prototype.getAreas = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var list = [], x = 0, lenX = Response.length;
	                for (x, lenX; x < lenX; x++) {
	                    if (Response[x].ativo) {
	                        list.push(Response[x]);
	                    }
	                }
	                this.areasList = list;
	                if (!this.list.length)
	                    this.clickAddNew();
	                this.setListBind();
	            }
	        }.bind(this));
	        this._areaApiService.onGetAll(onDone);
	    };
	    TanqueMovimentacaoAreaFormComponent.prototype.setListBind = function () {
	        var x, lenX, y, lenY;
	        for (x = 0, lenX = this.list.length; x < lenX; x++) {
	            for (y = 0, lenY = this.areasList.length; y < lenY; y++) {
	                if (this.list[x].areaId === this.areasList[y].id) {
	                    this.list[x].area = this.areasList[y];
	                    break;
	                }
	            }
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], TanqueMovimentacaoAreaFormComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], TanqueMovimentacaoAreaFormComponent.prototype, "showMessage", void 0);
	    TanqueMovimentacaoAreaFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-tanque-movimentacao-area-form',
	            template: __webpack_require__(983),
	            styles: [__webpack_require__(984)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof area_api_service_1.AreaApiService !== 'undefined' && area_api_service_1.AreaApiService) === 'function' && _a) || Object])
	    ], TanqueMovimentacaoAreaFormComponent);
	    return TanqueMovimentacaoAreaFormComponent;
	    var _a;
	}());
	exports.TanqueMovimentacaoAreaFormComponent = TanqueMovimentacaoAreaFormComponent;


/***/ },
/* 983 */
/***/ function(module, exports) {

	module.exports = "<div class=\"geo-content__row\">\n    <h2>Áreas\n        <span *ngIf=\"showMessage\"> - A quantidade de litros das áreas deve ser igual ao da movimentação</span>\n    </h2>\n    <div class=\"geo-columns--12c\" *ngFor=\"let item of list; let i = index;\">\n        <label class=\"geo-switch\">\n            <span class=\"geo-switch--label\">Ativo</span>\n            <input type=\"checkbox\" [(ngModel)]=\"item.ativo\">\n            <div class=\"geo-switch--checkbox\">\n                <span class=\"geo-switch--status\"></span>\n            </div>\n        </label>\n        <div class=\"geo-input--3c\">\n            <label>Área <abbr>*</abbr></label>\n            <div>\n                <select id=\"area_{{i}}\" [(ngModel)]=\"item.area\">\n                    <option *ngFor=\"let ar of areasList\" [ngValue]=\"ar\">{{ar.nome}}</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"geo-input--3c\" >\n            <label>Quantidade (litros) <abbr>*</abbr></label>\n            <div>\n                <input type=\"number\" id=\"quant_{{i}}\" [(ngModel)]=\"item.quantidade\">\n            </div>\n        </div>\n    </div>\n\n    <button type=\"button\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickAddNew()\">Adicionar área</button>\n</div>";

/***/ },
/* 984 */
/***/ function(module, exports) {

	module.exports = "h2 span {\n    color: #e74c3c\n}"

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var tipo_ajustes_component_1 = __webpack_require__(609);
	var shared_module_1 = __webpack_require__(57);
	var tipo_ajuste_api_service_1 = __webpack_require__(605);
	var tipo_ajuste_navigation_service_1 = __webpack_require__(586);
	var tipo_ajuste_service_1 = __webpack_require__(613);
	var tipo_ajustes_routing_module_1 = __webpack_require__(611);
	var tipo_ajuste_form_component_1 = __webpack_require__(616);
	var tipo_ajuste_list_component_1 = __webpack_require__(612);
	var TipoAjustesModule = (function () {
	    function TipoAjustesModule() {
	    }
	    TipoAjustesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                tipo_ajustes_routing_module_1.TipoAjustesRoutingModule
	            ],
	            providers: [
	                tipo_ajuste_api_service_1.TipoAjusteApiService,
	                tipo_ajuste_navigation_service_1.TipoAjusteNavigationService,
	                tipo_ajuste_service_1.TipoAjusteService
	            ],
	            declarations: [
	                tipo_ajustes_component_1.TipoAjustesComponent,
	                tipo_ajuste_form_component_1.TipoAjusteFormComponent,
	                tipo_ajuste_list_component_1.TipoAjusteListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TipoAjustesModule);
	    return TipoAjustesModule;
	}());
	exports.TipoAjustesModule = TipoAjustesModule;


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var manutencoes_component_1 = __webpack_require__(464);
	var shared_module_1 = __webpack_require__(57);
	var manutencoes_routing_module_1 = __webpack_require__(695);
	var servicos_module_1 = __webpack_require__(987);
	var planos_module_1 = __webpack_require__(1010);
	var odometros_horimetros_module_1 = __webpack_require__(955);
	var ordens_servico_module_1 = __webpack_require__(1011);
	var manutencao_configuracao_component_1 = __webpack_require__(696);
	var manutencao_menu_component_1 = __webpack_require__(1015);
	var manutencao_service_1 = __webpack_require__(704);
	var manutencao_programada_module_1 = __webpack_require__(1017);
	var ManutencoesModule = (function () {
	    function ManutencoesModule() {
	    }
	    ManutencoesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                servicos_module_1.ServicosModule,
	                planos_module_1.PlanosModule,
	                odometros_horimetros_module_1.OdometrosHorimetrosModule,
	                ordens_servico_module_1.OrdensServicoModule,
	                manutencao_programada_module_1.ManutencaoProgramadaModule,
	                manutencoes_routing_module_1.ManutencoesRoutingModule
	            ],
	            providers: [
	                manutencao_service_1.ManutencaoService
	            ],
	            declarations: [
	                manutencoes_component_1.ManutencoesComponent,
	                manutencao_configuracao_component_1.ManutencaoConfiguracaoComponent,
	                manutencao_menu_component_1.ManutencaoMenuComponent
	            ],
	            exports: [
	                manutencao_menu_component_1.ManutencaoMenuComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ManutencoesModule);
	    return ManutencoesModule;
	}());
	exports.ManutencoesModule = ManutencoesModule;


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var servicos_component_1 = __webpack_require__(700);
	var shared_module_1 = __webpack_require__(57);
	var servicos_routing_module_1 = __webpack_require__(702);
	var servico_form_component_1 = __webpack_require__(707);
	var servico_list_component_1 = __webpack_require__(703);
	var servico_api_service_1 = __webpack_require__(430);
	var servico_navigation_service_1 = __webpack_require__(697);
	var servico_service_1 = __webpack_require__(440);
	var servico_plano_table_component_1 = __webpack_require__(988);
	var servico_plano_form_list_component_1 = __webpack_require__(991);
	var servico_bem_list_component_1 = __webpack_require__(439);
	var materiais_module_1 = __webpack_require__(994);
	var servico_plano_form_component_1 = __webpack_require__(1007);
	var servico_bem_form_component_1 = __webpack_require__(737);
	var ServicosModule = (function () {
	    function ServicosModule() {
	    }
	    ServicosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                materiais_module_1.MateriaisModule,
	                servicos_routing_module_1.ServicosRoutingModule
	            ],
	            providers: [
	                servico_api_service_1.ServicoApiService,
	                servico_navigation_service_1.ServicoNavigationService,
	                servico_service_1.ServicoService
	            ],
	            declarations: [
	                servicos_component_1.ServicosComponent,
	                servico_form_component_1.ServicoFormComponent,
	                servico_list_component_1.ServicoListComponent,
	                servico_plano_table_component_1.ServicoPlanoTableComponent,
	                servico_plano_form_list_component_1.ServicoPlanoFormListComponent,
	                servico_plano_form_component_1.ServicoPlanoFormComponent,
	                servico_bem_list_component_1.ServicoBemListComponent,
	                servico_bem_form_component_1.ServicoBemFormComponent
	            ],
	            exports: [
	                servico_plano_table_component_1.ServicoPlanoTableComponent,
	                servico_plano_form_list_component_1.ServicoPlanoFormListComponent,
	                servico_plano_form_component_1.ServicoPlanoFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ServicosModule);
	    return ServicosModule;
	}());
	exports.ServicosModule = ServicosModule;


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(429);
	var ServicoPlanoTableComponent = (function () {
	    function ServicoPlanoTableComponent() {
	        this.list = [];
	        this.showRemove = false;
	        this.removeEvent = new core_1.EventEmitter();
	        this.servicoPlanosName = data_service_1.servicoPlanosComponentName;
	    }
	    ServicoPlanoTableComponent.prototype.ngOnInit = function () {
	    };
	    ServicoPlanoTableComponent.prototype.clickRemove = function (item, index) {
	        this.removeEvent.next([item, index]);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], ServicoPlanoTableComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ServicoPlanoTableComponent.prototype, "showRemove", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], ServicoPlanoTableComponent.prototype, "removeEvent", void 0);
	    ServicoPlanoTableComponent = __decorate([
	        core_1.Component({
	            selector: 'app-servico-plano-table',
	            template: __webpack_require__(989),
	            styles: [__webpack_require__(990)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ServicoPlanoTableComponent);
	    return ServicoPlanoTableComponent;
	    var _a;
	}());
	exports.ServicoPlanoTableComponent = ServicoPlanoTableComponent;


/***/ },
/* 989 */
/***/ function(module, exports) {

	module.exports = "<table>\n    <thead>\n    <tr>\n        <th>Serviço</th>\n        <th>Periodicidade de km/hora</th>\n        <th>Alerta início de km/hora</th>\n        <th>Periodicidade de tempo</th>\n        <th>Alerta início de tempo</th>\n        <th class=\"small\" *ngIf=\"showRemove\"></th>\n    </tr>\n    </thead>\n    <tbody *ngIf=\"!list || list.length === 0\">\n    <tr>\n        <td colspan=\"6\">Nenhum {{servicoPlanosName.single | lowercase}} cadastrado</td>\n    </tr>\n    </tbody>\n    <tbody *ngFor=\"let item of (list); let i=index\">\n    <tr [ngClass]=\"{inative: item.paraRemover}\">\n        <td><span *ngIf=\"item.servico\">{{item.servico.descricao}}</span></td>\n        <td><span *ngIf=\"item.periodicidadeOdometroHorimetro\">{{item.periodicidadeOdometroHorimetro | odometroHorimetroMask}} km</span></td>\n        <td><span *ngIf=\"item.alertaInicioOdometroHorimetro\">{{item.alertaInicioOdometroHorimetro}}% antes</span></td>\n        <td><span *ngIf=\"item.periodicidadeTempo\">{{item.periodicidadeTempo}} <span *ngIf=\"item.referenciaTempo\">{{item.referenciaTempo.Value}}</span></span> </td>\n        <td><span *ngIf=\"item.alertaInicioTempo\">{{item.alertaInicioTempo}} dia(s) antes</span></td>\n        <td class=\"geo-table--action\" *ngIf=\"showRemove\">\n            <a (click)=\"clickRemove(item, i)\">\n                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n            </a>\n        </td>\n    </tr>\n    </tbody>\n</table>";

/***/ },
/* 990 */
166,
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var plano_service_1 = __webpack_require__(442);
	var util_service_1 = __webpack_require__(88);
	var data_service_1 = __webpack_require__(429);
	var data_service_2 = __webpack_require__(201);
	var autocomplete_service_1 = __webpack_require__(101);
	var ServicoPlanoFormListComponent = (function () {
	    function ServicoPlanoFormListComponent(_planoService, _utilService, _autocompleteService) {
	        this._planoService = _planoService;
	        this._utilService = _utilService;
	        this._autocompleteService = _autocompleteService;
	        this.planoObject = {};
	        this.categoriaObject = {};
	        this.marcaObject = {};
	        this.servicoObject = {};
	        this.list = [];
	    }
	    ServicoPlanoFormListComponent.prototype.ngOnInit = function () {
	    };
	    ServicoPlanoFormListComponent.prototype.clickRemove = function (item) {
	        //item[0] = objeto de servico / item[1] = index na lista
	        var onDelete = (function () {
	            this.list.splice(item[1], 1);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete, true);
	    };
	    ServicoPlanoFormListComponent.prototype.onSubmit = function (evt) {
	        this.setNewList(evt);
	    };
	    ServicoPlanoFormListComponent.prototype.getServicoObject = function (object) {
	        var thisFormObject = this.planoObject;
	        thisFormObject.categoria = this.categoriaObject;
	        thisFormObject.marca = this.marcaObject;
	        thisFormObject.servicos = this.list;
	        this._planoService.setSessionStorage(thisFormObject);
	        var toOtherFormObject = {
	            descricao: object.text,
	            form: data_service_2.planosStorage
	        };
	        this._autocompleteService.setSessionStorage(toOtherFormObject, data_service_1.servicosStorage);
	    };
	    ServicoPlanoFormListComponent.prototype.setNewList = function (object) {
	        this.list.push(object);
	        this.servicoObject = {};
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ServicoPlanoFormListComponent.prototype, "planoObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ServicoPlanoFormListComponent.prototype, "categoriaObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ServicoPlanoFormListComponent.prototype, "marcaObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ServicoPlanoFormListComponent.prototype, "servicoObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], ServicoPlanoFormListComponent.prototype, "list", void 0);
	    ServicoPlanoFormListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-servico-plano-form-list',
	            template: __webpack_require__(992),
	            styles: [__webpack_require__(993)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof plano_service_1.PlanoService !== 'undefined' && plano_service_1.PlanoService) === 'function' && _a) || Object, (typeof (_b = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _b) || Object, (typeof (_c = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _c) || Object])
	    ], ServicoPlanoFormListComponent);
	    return ServicoPlanoFormListComponent;
	    var _a, _b, _c;
	}());
	exports.ServicoPlanoFormListComponent = ServicoPlanoFormListComponent;


/***/ },
/* 992 */
/***/ function(module, exports) {

	module.exports = "<app-servico-plano-form [servicoObject]=\"servicoObject\"\n                        (serviceNewEvent)=\"getServicoObject($event)\"\n                        (submitEvent)=\"onSubmit($event)\"></app-servico-plano-form>\n\n<div class=\"geo-content__row\">\n    <app-servico-plano-table [list]=\"list\"\n                             [showRemove]=\"true\"\n                             (removeEvent)=\"clickRemove($event)\"></app-servico-plano-table>\n</div>";

/***/ },
/* 993 */
/***/ function(module, exports) {

	module.exports = "app-servico-plano-table {\n    width: 100%;\n}"

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var material_ordem_servico_api_service_1 = __webpack_require__(432);
	var material_service_1 = __webpack_require__(475);
	var material_codigo_barra_service_1 = __webpack_require__(531);
	var material_especificacao_service_1 = __webpack_require__(524);
	var material_codigo_barra_list_component_1 = __webpack_require__(530);
	var material_especificacao_register_component_1 = __webpack_require__(527);
	var material_especificacao_form_component_1 = __webpack_require__(995);
	var material_especificacao_list_component_1 = __webpack_require__(523);
	var material_codigo_barra_register_component_1 = __webpack_require__(533);
	var material_component_1 = __webpack_require__(535);
	var material_form_component_1 = __webpack_require__(515);
	var material_list_component_1 = __webpack_require__(510);
	var material_detail_component_1 = __webpack_require__(512);
	var material_especificacao_component_1 = __webpack_require__(521);
	var material_codigo_barra_component_1 = __webpack_require__(997);
	var material_codigo_barra_form_component_1 = __webpack_require__(999);
	var materiais_routing_1 = __webpack_require__(509);
	var materiais_component_1 = __webpack_require__(507);
	var material_tipo_api_service_1 = __webpack_require__(518);
	var material_servico_form_list_component_1 = __webpack_require__(1002);
	var material_servico_table_component_1 = __webpack_require__(1005);
	var material_servico_api_service_1 = __webpack_require__(431);
	var MateriaisModule = (function () {
	    function MateriaisModule() {
	    }
	    MateriaisModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                materiais_routing_1.MateriaisRoutingModule
	            ],
	            providers: [
	                material_ordem_servico_api_service_1.MaterialOrdemServicoApiService,
	                material_service_1.MaterialService,
	                material_codigo_barra_service_1.MaterialCodigoBarraService,
	                material_especificacao_service_1.MaterialEspecificacaoService,
	                material_tipo_api_service_1.MaterialTipoApiService,
	                material_servico_api_service_1.MaterialServicoApiService
	            ],
	            declarations: [
	                materiais_component_1.MateriaisComponent,
	                material_component_1.MaterialComponent,
	                material_form_component_1.MaterialFormComponent,
	                material_list_component_1.MaterialListComponent,
	                material_detail_component_1.MaterialDetailComponent,
	                material_especificacao_component_1.MaterialEspecificacaoComponent,
	                material_especificacao_register_component_1.MaterialEspecificacaoRegisterComponent,
	                material_especificacao_form_component_1.MaterialEspecificacaoFormComponent,
	                material_especificacao_list_component_1.MaterialEspecificacaoListComponent,
	                material_codigo_barra_component_1.MaterialCodigoBarraComponent,
	                material_codigo_barra_register_component_1.MaterialCodigoBarraRegisterComponent,
	                material_codigo_barra_form_component_1.MaterialCodigoBarraFormComponent,
	                material_codigo_barra_list_component_1.MaterialCodigoBarraListComponent,
	                material_servico_form_list_component_1.MaterialServicoFormListComponent,
	                material_servico_table_component_1.MaterialServicoTableComponent
	            ],
	            exports: [
	                material_servico_form_list_component_1.MaterialServicoFormListComponent,
	                material_servico_table_component_1.MaterialServicoTableComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MateriaisModule);
	    return MateriaisModule;
	}());
	exports.MateriaisModule = MateriaisModule;


/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var material_especificacao_model_1 = __webpack_require__(528);
	var util_service_1 = __webpack_require__(88);
	var material_service_1 = __webpack_require__(475);
	var material_especificacao_service_1 = __webpack_require__(524);
	var data_service_1 = __webpack_require__(161);
	var autocomplete_service_1 = __webpack_require__(101);
	var MaterialEspecificacaoFormComponent = (function () {
	    function MaterialEspecificacaoFormComponent(_materialEspecificacaoService, _materialService, _autocompleteService, _utilService, builder) {
	        this._materialEspecificacaoService = _materialEspecificacaoService;
	        this._materialService = _materialService;
	        this._autocompleteService = _autocompleteService;
	        this._utilService = _utilService;
	        this.builder = builder;
	        this.formObject = new material_especificacao_model_1.MaterialEspecificacao();
	        this.submitEvent = new core_1.EventEmitter();
	        this.cancelEvent = new core_1.EventEmitter();
	        this.btnSalveDisabled = false;
	        this.submitAttempt = false;
	        this.materialRequired = true;
	        this.materialFieldToFind = 'descricao';
	        this.materialFieldToSort = 'descricao';
	        this.materialFieldToShow = 'descricao';
	        this.materialLabel = 'Material';
	        this.materialSelectId = 'materialEspecificacao_material';
	        this.materialEspecificacaoModule = data_service_1.materialEspecificacaoStorageName;
	        this.materialModule = data_service_1.materialStorageName;
	        this.hasSession = false;
	        this.onDone = (function (Response) {
	            this.submitEvent.next(Response);
	            this.btnSalveDisabled = false;
	        }.bind(this));
	        this.material = new forms_1.FormControl('', forms_1.Validators.required);
	        this.especificacao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.descricao = new forms_1.FormControl('', forms_1.Validators.required);
	        this.ativo = new forms_1.FormControl();
	        this.formMaterialEspecificacao = builder.group({
	            ativo: this.ativo,
	            material: this.material,
	            especificacao: this.especificacao,
	            descricao: this.descricao
	        });
	    }
	    MaterialEspecificacaoFormComponent.prototype.ngOnInit = function () {
	        this.testSession();
	        document.getElementById("materialEspecificacao_descricao").focus();
	        if (this.formObject.id) {
	            //edicao
	            this.getObject();
	        }
	    };
	    MaterialEspecificacaoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitAttempt = true;
	        if (evt.valid) {
	            this.btnSalveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (object.material) {
	                object.materialId = object.material.id;
	            }
	            delete object['material'];
	            if (object.id) {
	                this.onEditMaterialEspecificacao(object);
	            }
	            else {
	                this.onSaveMaterialEspecificacao(object);
	            }
	        }
	    };
	    MaterialEspecificacaoFormComponent.prototype.onclickCancel = function () {
	        this.cancelEvent.next("");
	    };
	    //material
	    MaterialEspecificacaoFormComponent.prototype.onGetMaterialObject = function (object) {
	        if (object.novo) {
	            this._materialEspecificacaoService.setSessionStorage(this.formObject);
	            var objectModel = { descricao: object.text, novo: true, form: this.materialEspecificacaoModule };
	            this._autocompleteService.setSessionStorage(objectModel, this.materialModule);
	            this._materialService.goToAdd();
	        }
	        else {
	            this.formObject.material = object;
	            this.setSelectOnFormControl('materialId', object);
	        }
	    };
	    MaterialEspecificacaoFormComponent.prototype.onSaveMaterialEspecificacao = function (objeto) {
	        this._materialEspecificacaoService.onPost(objeto, this.onDone);
	    };
	    MaterialEspecificacaoFormComponent.prototype.onEditMaterialEspecificacao = function (objeto) {
	        this._materialEspecificacaoService.onPut(objeto, this.onDone);
	    };
	    MaterialEspecificacaoFormComponent.prototype.testSession = function () {
	        var session = this._materialEspecificacaoService.getSessionStorage();
	        if (session) {
	            this.formObject = session;
	            this.hasSession = true;
	        }
	    };
	    MaterialEspecificacaoFormComponent.prototype.setSelectOnFormControl = function (item, object) {
	        var tt = this.formMaterialEspecificacao.controls[item];
	        tt.patchValue(object.id);
	    };
	    //se edicao
	    MaterialEspecificacaoFormComponent.prototype.getObject = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom('Nenhuma especificação encontrada com este id.');
	                this.onclickCancel();
	            }
	        }.bind(this));
	        this._materialEspecificacaoService.onGetById(this.formObject.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MaterialEspecificacaoFormComponent.prototype, "formObject", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], MaterialEspecificacaoFormComponent.prototype, "submitEvent", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_b = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _b) || Object)
	    ], MaterialEspecificacaoFormComponent.prototype, "cancelEvent", void 0);
	    MaterialEspecificacaoFormComponent = __decorate([
	        core_1.Component({
	            selector: 'material-especificacao-formulario',
	            template: __webpack_require__(996)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof material_especificacao_service_1.MaterialEspecificacaoService !== 'undefined' && material_especificacao_service_1.MaterialEspecificacaoService) === 'function' && _c) || Object, (typeof (_d = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _d) || Object, (typeof (_e = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object, (typeof (_g = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _g) || Object])
	    ], MaterialEspecificacaoFormComponent);
	    return MaterialEspecificacaoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.MaterialEspecificacaoFormComponent = MaterialEspecificacaoFormComponent;


/***/ },
/* 996 */
/***/ function(module, exports) {

	module.exports = "<form [formGroup]=\"formMaterialEspecificacao\" (ngSubmit)=\"onSubmit(formMaterialEspecificacao)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" >\n            <label for=\"materialEspecificacao_material\">Material <abbr>*</abbr></label>\n            <div>\n                <input type=\"text\" id=\"materialEspecificacao_material\" [(ngModel)]=\"formObject.material.descricao\" formControlName=\"material\" disabled>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !especificacao.valid && submitAttempt}\">\n            <label for=\"materialEspecificacao_especificacao\">Título da especificação <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!especificacao.valid && submitAttempt\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"materialEspecificacao_especificacao\" [(ngModel)]=\"formObject.especificacao\" formControlName=\"especificacao\" maxlength=\"10\" numberInteger>\n            </div>\n        </div>\n\n        <div class=\"geo-input--12c\" [ngClass]=\"{'geo-input--error': !descricao.valid && submitAttempt}\">\n            <label for=\"materialEspecificacao_descricao\">Especificação <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!descricao.valid && submitAttempt\">Este campo é obrigatório.</span>\n                <textarea id=\"materialEspecificacao_descricao\" [(ngModel)]=\"formObject.descricao\" formControlName=\"descricao\"></textarea>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" id=\"btnSaveMaterialEspecificacao\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSalveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"onclickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 27/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var MaterialCodigoBarraComponent = (function () {
	    function MaterialCodigoBarraComponent() {
	    }
	    MaterialCodigoBarraComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(998)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MaterialCodigoBarraComponent);
	    return MaterialCodigoBarraComponent;
	}());
	exports.MaterialCodigoBarraComponent = MaterialCodigoBarraComponent;


/***/ },
/* 998 */
55,
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var material_codigo_barra_model_1 = __webpack_require__(525);
	var material_codigo_barra_service_1 = __webpack_require__(531);
	var util_service_1 = __webpack_require__(88);
	var gtin13_validatior_1 = __webpack_require__(1000);
	var MaterialCodigoBarraFormComponent = (function () {
	    function MaterialCodigoBarraFormComponent(_materialCodigoBarraService, _utilService, builder) {
	        this._materialCodigoBarraService = _materialCodigoBarraService;
	        this._utilService = _utilService;
	        this.builder = builder;
	        this.formObject = new material_codigo_barra_model_1.MaterialCodigoBarra();
	        this.submitEvent = new core_1.EventEmitter();
	        this.cancelEvent = new core_1.EventEmitter();
	        this.btnSalveDisabled = false;
	        this.submitAttempt = false;
	        this.hasSession = false;
	        this.onDone = (function (Response) {
	            this.submitEvent.next(Response);
	            this.btnSalveDisabled = false;
	        }.bind(this));
	        this.material = new forms_1.FormControl('', forms_1.Validators.required);
	        this.codigoBarra = new forms_1.FormControl('', forms_1.Validators.compose([forms_1.Validators.required, gtin13_validatior_1.Gtin13Validator.gtin13Format]));
	        this.ativo = new forms_1.FormControl();
	        this.formMaterialCodigoBarra = builder.group({
	            ativo: this.ativo,
	            material: this.material,
	            codigoBarra: this.codigoBarra
	        });
	    }
	    MaterialCodigoBarraFormComponent.prototype.ngOnInit = function () {
	        this.testSession();
	        document.getElementById("codigoBarra_codigoBarra").focus();
	        if (this.formObject.id) {
	            //edicao
	            this.getObject();
	        }
	    };
	    MaterialCodigoBarraFormComponent.prototype.onSubmit = function (evt) {
	        this.submitAttempt = true;
	        if (evt.valid) {
	            this.btnSalveDisabled = true;
	            var object = this._utilService.cloneObject(this.formObject);
	            if (object.material) {
	                object.materialId = object.material.id;
	            }
	            if (object.codigoBarra) {
	                object.codigoBarra = object.codigoBarra.replace(/\D/g, '');
	            }
	            delete object['material'];
	            if (object.id) {
	                this.onEditMaterialCodigoBarra(object);
	            }
	            else {
	                this.onSaveMaterialCodigoBarra(object);
	            }
	        }
	    };
	    MaterialCodigoBarraFormComponent.prototype.onSaveMaterialCodigoBarra = function (objeto) {
	        this._materialCodigoBarraService.onPost(objeto, this.onDone);
	    };
	    MaterialCodigoBarraFormComponent.prototype.onEditMaterialCodigoBarra = function (objeto) {
	        this._materialCodigoBarraService.onPut(objeto, this.onDone);
	    };
	    MaterialCodigoBarraFormComponent.prototype.onclickCancel = function () {
	        this.cancelEvent.next('');
	    };
	    MaterialCodigoBarraFormComponent.prototype.testSession = function () {
	        var session = this._materialCodigoBarraService.getSessionStorage();
	        if (session) {
	            this.formObject = session;
	            this.hasSession = true;
	        }
	    };
	    //se edicao
	    MaterialCodigoBarraFormComponent.prototype.getObject = function () {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                this.formObject = Response;
	            }
	            else {
	                this._utilService.swalMessageWarningCustom(Response.error);
	                this.onclickCancel();
	            }
	        }.bind(this));
	        this._materialCodigoBarraService.onGetById(this.formObject.id, onDone);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MaterialCodigoBarraFormComponent.prototype, "formObject", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], MaterialCodigoBarraFormComponent.prototype, "submitEvent", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_b = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _b) || Object)
	    ], MaterialCodigoBarraFormComponent.prototype, "cancelEvent", void 0);
	    MaterialCodigoBarraFormComponent = __decorate([
	        core_1.Component({
	            selector: 'material-codigo-barra-formulario',
	            template: __webpack_require__(1001)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof material_codigo_barra_service_1.MaterialCodigoBarraService !== 'undefined' && material_codigo_barra_service_1.MaterialCodigoBarraService) === 'function' && _c) || Object, (typeof (_d = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _d) || Object, (typeof (_e = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _e) || Object])
	    ], MaterialCodigoBarraFormComponent);
	    return MaterialCodigoBarraFormComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.MaterialCodigoBarraFormComponent = MaterialCodigoBarraFormComponent;


/***/ },
/* 1000 */
/***/ function(module, exports) {

	"use strict";
	var Gtin13Validator = (function () {
	    function Gtin13Validator() {
	    }
	    Gtin13Validator.gtin13Format = function (item) {
	        var gtin = item.value;
	        if (gtin) {
	            gtin = gtin.replace(/\D/g, '');
	            // Check length of barcode for validity
	            if (!CheckBasics(gtin)) {
	                return { "incorrectGtin13Format": true };
	            }
	            // Define fixed variables
	            var CheckDigitArray = [];
	            var gtinMaths = [3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3];
	            var modifier = 17 - (gtin.length - 1); // Gets the position to place first digit in array
	            var BarcodeArray = gtin.split(""); // Split barcode at each digit into array
	            var gtinLength = gtin.length;
	            var tmpCheckSum = 0;
	            var i = void 0;
	            // Run through and put digits into multiplication table
	            for (i = 0; i < (gtinLength - 1); i++) {
	                CheckDigitArray[modifier + i] = BarcodeArray[i]; // Add barcode digits to Multiplication Table
	            }
	            // Calculate "Sum" of barcode digits
	            for (i = modifier; i < 17; i++) {
	                tmpCheckSum += (CheckDigitArray[i] * gtinMaths[i]);
	            }
	            // Difference from Rounded-Up-To-Nearest-10 - Fianl Check Digit Calculation
	            var tmpCheckDigit = (Math.ceil(tmpCheckSum / 10) * 10) - parseInt(tmpCheckSum);
	            // Check if last digit is same as calculated check digit
	            if (gtin.slice(-1) != tmpCheckDigit) {
	                return { "incorrectGtin13Format": true };
	            }
	            return null;
	        }
	        function CheckBasics(gtin) {
	            // Check length is ok
	            if (gtin.length != 8 && gtin.length != 12 && gtin.length != 13 && gtin.length != 14) {
	                return false;
	            }
	            // Check whether is a number
	            var m = gtin.match(/\d+/);
	            if (isNaN(m[0])) {
	                return false;
	            }
	            // Is valid, return true
	            return true;
	        }
	    };
	    return Gtin13Validator;
	}());
	exports.Gtin13Validator = Gtin13Validator;


/***/ },
/* 1001 */
/***/ function(module, exports) {

	module.exports = "<form [formGroup]=\"formMaterialCodigoBarra\" (ngSubmit)=\"onSubmit(formMaterialCodigoBarra)\">\n    <div class=\"geo-content__row\" *ngIf=\"formObject.id\">\n        <div class=\"geo-columns--12c\">\n            <label class=\"geo-switch\">\n                <span class=\"geo-switch--label\">Ativo</span>\n                <input type=\"checkbox\" [(ngModel)]=\"formObject.ativo\" formControlName=\"ativo\">\n                <div class=\"geo-switch--checkbox\">\n                    <span class=\"geo-switch--status\"></span>\n                </div>\n            </label>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <div class=\"geo-input--3c\" >\n            <label for=\"codigoBarra_material\">Material <abbr>*</abbr></label>\n            <div>\n                <input type=\"text\" id=\"codigoBarra_material\" [(ngModel)]=\"formObject.material.descricao\" formControlName=\"material\" disabled>\n            </div>\n        </div>\n\n        <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': (!codigoBarra.valid && submitAttempt) || (codigoBarra.errors && codigoBarra.errors.incorrectGtin13Format)}\">\n            <label for=\"codigoBarra_codigoBarra\">Código de barra <abbr>*</abbr></label>\n            <div>\n                <span class=\"error-alert\" *ngIf=\"!codigoBarra.valid && submitAttempt\">Este campo é obrigatório.</span>\n                <input type=\"text\" id=\"codigoBarra_codigoBarra\" [(ngModel)]=\"formObject.codigoBarra\" formControlName=\"codigoBarra\" ngControl=\"codigoBarra\" gtin13 maxlength=\"15\">\n            </div>\n        </div>\n    </div>\n\n    <div class=\"geo-content__row\">\n        <button type=\"submit\" id=\"btnSaveMaterialCodigoBarra\" class=\"geo-button button-remove-margin-left\" [disabled]=\"btnSalveDisabled\">Salvar</button>\n        <button type=\"button\" class=\"geo-button geo-button--secundary\" (click)=\"onclickCancel()\">Cancelar</button>\n    </div>\n</form>\n";

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var data_service_1 = __webpack_require__(161);
	var material_service_1 = __webpack_require__(475);
	var autocomplete_service_1 = __webpack_require__(101);
	var util_service_1 = __webpack_require__(88);
	var MaterialServicoFormListComponent = (function () {
	    function MaterialServicoFormListComponent(_materialService, _autocompleteService, _utilService, _fb) {
	        this._materialService = _materialService;
	        this._autocompleteService = _autocompleteService;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this.list = [];
	        this.moduleName = data_service_1.materialTitle;
	        this.materialObject = {};
	        this.newObject = {};
	        this.submitted = false;
	        this.materialId = 'materialSelect';
	        this.material = new forms_1.FormControl('', forms_1.Validators.required);
	        this.quantidade = new forms_1.FormControl('', forms_1.Validators.required);
	        this.materialTemplateResult = (function (state) {
	            var template = this._materialService.templateResult(state, false);
	            return template;
	        }.bind(this));
	        this.form2 = _fb.group({
	            material: this.material,
	            quantidade: this.quantidade
	        });
	    }
	    MaterialServicoFormListComponent.prototype.ngOnInit = function () {
	        this.materialQuery = this._utilService.cloneObject(data_service_1.materiaisQuery);
	        this.newItem();
	    };
	    MaterialServicoFormListComponent.prototype.clickRemove = function (item) {
	        //item[0] = objeto de material / item[1] = index na lista
	        var onDelete = (function () {
	            this.list.splice(item[1], 1);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete, true);
	    };
	    MaterialServicoFormListComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            var object = this._utilService.cloneObject(this.newObject);
	            if (this.materialObject.id) {
	                object.material = this.materialObject;
	                this.setNewList(object);
	            }
	        }
	    };
	    MaterialServicoFormListComponent.prototype.getMaterialObject = function (object) {
	        this.materialObject = object;
	        this._utilService.setSelectOnFormControl(this.form2, 'material', object);
	    };
	    MaterialServicoFormListComponent.prototype.newItem = function () {
	        var object = {
	            quantidade: null,
	            ativo: true
	        };
	        this.newObject = object;
	    };
	    MaterialServicoFormListComponent.prototype.setNewList = function (object) {
	        this.list.push(object);
	        this.newItem();
	        this.materialObject = {};
	        this._autocompleteService.setValueOnSelect2(null, this.materialId);
	        this._utilService.setSelectOnFormControl(this.form2, 'material', {});
	        this.submitted = false;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], MaterialServicoFormListComponent.prototype, "list", void 0);
	    MaterialServicoFormListComponent = __decorate([
	        core_1.Component({
	            selector: 'app-material-servico-form-list',
	            template: __webpack_require__(1003),
	            styles: [__webpack_require__(1004)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof material_service_1.MaterialService !== 'undefined' && material_service_1.MaterialService) === 'function' && _a) || Object, (typeof (_b = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _b) || Object, (typeof (_c = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _c) || Object, (typeof (_d = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _d) || Object])
	    ], MaterialServicoFormListComponent);
	    return MaterialServicoFormListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MaterialServicoFormListComponent = MaterialServicoFormListComponent;


/***/ },
/* 1003 */
/***/ function(module, exports) {

	module.exports = "<form [formGroup]=\"form2\" (ngSubmit)=\"onSubmit(form2)\">\n    <div class=\"geo-content__row pt0\">\n        <div class=\"geo-columns--12c\">\n            <autocomplete-component class=\"geo-input--3c\" id=\"materialSelect\"\n                                    (setObejct)=\"getMaterialObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"materialId\"\n                                    [model]=\"materialObject\"\n                                    [_service]=\"_materialService\"\n                                    [templateResult]=\"materialTemplateResult\"\n                                    [query]=\"materialQuery\"\n                                    [isCreateNew]=\"false\"\n                                    [label]=\"'Material'\"></autocomplete-component>\n\n\n            <div class=\"geo-input--3c\" [ngClass]=\"{'geo-input--error': !quantidade.valid && submitted}\">\n                <label for=\"quantidade\">Quantidade <span *ngIf=\"materialObject.medida\">({{materialObject.medida.medida | lowercase}})</span><abbr>*</abbr></label>\n                <div>\n                    <span class=\"error-alert\" *ngIf=\"!quantidade.valid && submitted\">Este campo é obrigatório.</span>\n                    <input type=\"text\" id=\"quantidade\" [(ngModel)]=\"newObject.quantidade\" appNumberInteger formControlName=\"quantidade\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <button type=\"submit\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\">Adicionar material</button>\n            </div>\n        </div>\n    </div>\n</form>\n\n<div class=\"geo-content__row\">\n    <app-material-servico-table [list]=\"list\"\n                                [showDelete]=\"true\"\n                                (deleteEvent)=\"clickRemove($event)\"></app-material-servico-table>\n</div>\n";

/***/ },
/* 1004 */
/***/ function(module, exports) {

	module.exports = "app-material-servico-table {\n    width: 100%;\n}"

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(161);
	var MaterialServicoTableComponent = (function () {
	    function MaterialServicoTableComponent() {
	        this.showDelete = false;
	        this.deleteEvent = new core_1.EventEmitter();
	        this.materialTitle = data_service_1.materialTitle;
	    }
	    MaterialServicoTableComponent.prototype.ngOnInit = function () {
	    };
	    MaterialServicoTableComponent.prototype.clickRemove = function (item, index) {
	        this.deleteEvent.next([item, index]);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], MaterialServicoTableComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], MaterialServicoTableComponent.prototype, "showDelete", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], MaterialServicoTableComponent.prototype, "deleteEvent", void 0);
	    MaterialServicoTableComponent = __decorate([
	        core_1.Component({
	            selector: 'app-material-servico-table',
	            template: __webpack_require__(1006)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MaterialServicoTableComponent);
	    return MaterialServicoTableComponent;
	    var _a;
	}());
	exports.MaterialServicoTableComponent = MaterialServicoTableComponent;


/***/ },
/* 1006 */
/***/ function(module, exports) {

	module.exports = "<table>\n    <thead>\n    <tr>\n        <th>Descrição</th>\n        <th>Quantidade</th>\n        <th class=\"small\" *ngIf=\"showDelete\"></th>\n    </tr>\n    </thead>\n    <tbody *ngIf=\"!list || list.length === 0\">\n    <tr>\n        <td colspan=\"3\">Nenhum {{materialTitle.single | lowercase}} cadastrado</td>\n    </tr>\n    </tbody>\n    <tbody *ngFor=\"let item of (list | filterActive:false); let i=index\">\n    <tr>\n        <td><span *ngIf=\"item.material\">{{item.material.descricao}}</span></td>\n        <td><span>{{item.quantidade}}</span> <span *ngIf=\"item.material && item.material.medida\">{{item.material.medida.medida | lowercase}}</span></td>\n        <td class=\"geo-table--action\" *ngIf=\"showDelete\">\n            <a (click)=\"clickRemove(item, i)\">\n                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n            </a>\n        </td>\n    </tr>\n    </tbody>\n</table>";

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var servico_api_service_1 = __webpack_require__(430);
	var plano_service_1 = __webpack_require__(442);
	var servico_navigation_service_1 = __webpack_require__(697);
	var data_service_1 = __webpack_require__(201);
	var data_service_2 = __webpack_require__(429);
	var autocomplete_service_1 = __webpack_require__(101);
	var util_service_1 = __webpack_require__(88);
	var forma_controle_service_1 = __webpack_require__(369);
	var odometro_horimetro_service_1 = __webpack_require__(131);
	var ServicoPlanoFormComponent = (function () {
	    function ServicoPlanoFormComponent(_servicoApiService, _servicoNavigationService, _planoService, _autocompleteService, _formaControleService, _odometroHorimetroService, _utilService, _fb) {
	        this._servicoApiService = _servicoApiService;
	        this._servicoNavigationService = _servicoNavigationService;
	        this._planoService = _planoService;
	        this._autocompleteService = _autocompleteService;
	        this._formaControleService = _formaControleService;
	        this._odometroHorimetroService = _odometroHorimetroService;
	        this._utilService = _utilService;
	        this._fb = _fb;
	        this.servicoObject = {};
	        this.submitEvent = new core_1.EventEmitter();
	        this.serviceNewEvent = new core_1.EventEmitter();
	        this.newObject = {};
	        this.submitted = false;
	        this.servicoSelectId = 'servico';
	        this.referenciaTempoList = [];
	        this.servico = new forms_1.FormControl('', forms_1.Validators.required);
	        this.periodicidadeOdometroHorimetro = new forms_1.FormControl('');
	        this.alertaInicioOdometroHorimetro = new forms_1.FormControl('');
	        this.periodicidadeTempo = new forms_1.FormControl('');
	        this.alertaInicioTempo = new forms_1.FormControl('');
	        this.referenciaTempo = new forms_1.FormControl('');
	        this.form2 = _fb.group({
	            servico: this.servico,
	            periodicidadeOdometroHorimetro: this.periodicidadeOdometroHorimetro,
	            alertaInicioOdometroHorimetro: this.alertaInicioOdometroHorimetro,
	            periodicidadeTempo: this.periodicidadeTempo,
	            alertaInicioTempo: this.alertaInicioTempo,
	            referenciaTempo: this.referenciaTempo
	        });
	    }
	    ServicoPlanoFormComponent.prototype.ngOnInit = function () {
	        this.servicoQuery = this._utilService.cloneObject(data_service_2.servicosQuery);
	        this.referenciaTempoList = this._utilService.cloneObject(data_service_1.referenciaTempo);
	        this.newItem();
	        if (this.servicoObject) {
	            if (this.servicoObject.id) {
	                var text = this._autocompleteService.getTextSelect2(this.servicoObject, 'descricao');
	                var selectObject = { text: text, id: this.servicoObject.id };
	                this._autocompleteService.createOptionOnSelect2(this.servicoSelectId, selectObject);
	                this._autocompleteService.setValueOnSelect2(selectObject.id, this.servicoSelectId);
	                this._utilService.setSelectOnFormControl(this.form2, 'servico', this.servicoObject);
	            }
	        }
	    };
	    ServicoPlanoFormComponent.prototype.onSubmit = function (evt) {
	        this.submitted = true;
	        if (evt.valid) {
	            var object = this._utilService.cloneObject(this.newObject);
	            if (this.servicoObject.id) {
	                var text = this._autocompleteService.getTextSelect2(this.servicoObject, 'descricao');
	                object.servico = { id: this.servicoObject.id, descricao: text };
	                this._autocompleteService.setValueOnSelect2(null, this.servicoSelectId);
	                this._utilService.setSelectOnFormControl(this.form2, 'servico', {});
	                this.submitted = false;
	                this.newItem();
	                object.periodicidadeOdometroHorimetro = this._odometroHorimetroService.setMask(object.periodicidadeOdometroHorimetro);
	                object.periodicidadeOdometroHorimetro = this._formaControleService.submitOdometroHorimetro(object.periodicidadeOdometroHorimetro);
	                this.submitEvent.next(object);
	            }
	        }
	    };
	    ServicoPlanoFormComponent.prototype.getServicoObject = function (object) {
	        if (object.novo) {
	            this.serviceNewEvent.next(object);
	            this._servicoNavigationService.goToNew();
	        }
	        else {
	            this.servicoObject = object;
	            this._utilService.setSelectOnFormControl(this.form2, 'servico', object);
	        }
	    };
	    ServicoPlanoFormComponent.prototype.newItem = function () {
	        var object = {
	            periodicidadeOdometroHorimetro: null,
	            alertaInicioOdometroHorimetro: null,
	            periodicidadeTempo: null,
	            alertaInicioTempo: null,
	            referenciaTempo: this.referenciaTempoList[0],
	            servico: {}
	        };
	        this.newObject = object;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ServicoPlanoFormComponent.prototype, "servicoObject", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], ServicoPlanoFormComponent.prototype, "submitEvent", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_b = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _b) || Object)
	    ], ServicoPlanoFormComponent.prototype, "serviceNewEvent", void 0);
	    ServicoPlanoFormComponent = __decorate([
	        core_1.Component({
	            selector: 'app-servico-plano-form',
	            template: __webpack_require__(1008),
	            styles: [__webpack_require__(1009)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _c) || Object, (typeof (_d = typeof servico_navigation_service_1.ServicoNavigationService !== 'undefined' && servico_navigation_service_1.ServicoNavigationService) === 'function' && _d) || Object, (typeof (_e = typeof plano_service_1.PlanoService !== 'undefined' && plano_service_1.PlanoService) === 'function' && _e) || Object, (typeof (_f = typeof autocomplete_service_1.AutoCompleteService !== 'undefined' && autocomplete_service_1.AutoCompleteService) === 'function' && _f) || Object, (typeof (_g = typeof forma_controle_service_1.FormaControleService !== 'undefined' && forma_controle_service_1.FormaControleService) === 'function' && _g) || Object, (typeof (_h = typeof odometro_horimetro_service_1.OdometroHorimetroService !== 'undefined' && odometro_horimetro_service_1.OdometroHorimetroService) === 'function' && _h) || Object, (typeof (_j = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _j) || Object, (typeof (_k = typeof forms_1.FormBuilder !== 'undefined' && forms_1.FormBuilder) === 'function' && _k) || Object])
	    ], ServicoPlanoFormComponent);
	    return ServicoPlanoFormComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	}());
	exports.ServicoPlanoFormComponent = ServicoPlanoFormComponent;


/***/ },
/* 1008 */
/***/ function(module, exports) {

	module.exports = "<form [formGroup]=\"form2\" (ngSubmit)=\"onSubmit(form2)\">\n    <div class=\"geo-content__row pt0\">\n        <div class=\"geo-columns--12c\">\n            <autocomplete-component class=\"geo-input--3c\" id=\"servico\"\n                                    (setObejct)=\"getServicoObject($event)\"\n                                    [submitted]=\"submitted\"\n                                    [isRequired]=\"true\"\n                                    [selectId]=\"servicoSelectId\"\n                                    [model]=\"servicoObject\"\n                                    [_service]=\"_servicoApiService\"\n                                    [fieldToShow]=\"'descricao'\"\n                                    [query]=\"servicoQuery\"\n                                    [label]=\"'Serviço'\"></autocomplete-component>\n\n            <div class=\"geo-input--1c\">\n                <label for=\"periodicidadeOdometroHorimetro\">Periodicidade de km/hora </label>\n                <div>\n                    <input type=\"text\" id=\"periodicidadeOdometroHorimetro\" [(ngModel)]=\"newObject.periodicidadeOdometroHorimetro\" appOdometroHorimetroMask formControlName=\"periodicidadeOdometroHorimetro\">\n                </div>\n            </div>\n            <div class=\"geo-input--1c\">\n                <label for=\"alertaInicioOdometroHorimetro\">Alerta início de km/hora (%)</label>\n                <div>\n                    <input type=\"text\" id=\"alertaInicioOdometroHorimetro\" [(ngModel)]=\"newObject.alertaInicioOdometroHorimetro\" appNumberInteger maxlength=\"2\" formControlName=\"alertaInicioOdometroHorimetro\">\n                </div>\n            </div>\n            <div class=\"geo-input--1c\">\n                <label for=\"periodicidadeTempo\">Periodicidade de tempo</label>\n                <div>\n                    <input type=\"text\" id=\"periodicidadeTempo\" [(ngModel)]=\"newObject.periodicidadeTempo\" appNumberInteger formControlName=\"periodicidadeTempo\">\n                </div>\n            </div>\n            <div class=\"geo-input--1c\">\n                <label for=\"referenciaTempo\">Ref. de tempo</label>\n                <div>\n                    <select id=\"referenciaTempo\" [(ngModel)]=\"newObject.referenciaTempo\" formControlName=\"referenciaTempo\">\n                        <option *ngFor=\"let item of referenciaTempoList\" [ngValue]=\"item\">{{item.Value}}</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"geo-input--1c\">\n                <label for=\"alertaInicioTempo\">Alerta início de tempo (dias) </label>\n                <div>\n                    <input type=\"text\" id=\"alertaInicioTempo\" [(ngModel)]=\"newObject.alertaInicioTempo\" appNumberInteger maxlength=\"2\" formControlName=\"alertaInicioTempo\">\n                </div>\n            </div>\n\n            <div class=\"geo-input--3c\">\n                <button type=\"submit\" class=\"geo-button geo-button--action geo-button__icon--add button-remove-margin-left\">Adicionar serviço</button>\n            </div>\n        </div>\n    </div>\n</form>";

/***/ },
/* 1009 */
166,
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var planos_component_1 = __webpack_require__(711);
	var planos_routing_module_1 = __webpack_require__(713);
	var plano_api_service_1 = __webpack_require__(443);
	var plano_navigation_service_1 = __webpack_require__(441);
	var plano_service_1 = __webpack_require__(442);
	var plano_list_component_1 = __webpack_require__(718);
	var plano_form_component_1 = __webpack_require__(714);
	var servicos_module_1 = __webpack_require__(987);
	var PlanosModule = (function () {
	    function PlanosModule() {
	    }
	    PlanosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                servicos_module_1.ServicosModule,
	                planos_routing_module_1.PlanosRoutingModule
	            ],
	            providers: [
	                plano_api_service_1.PlanoApiService,
	                plano_navigation_service_1.PlanoNavigationService,
	                plano_service_1.PlanoService
	            ],
	            declarations: [
	                planos_component_1.PlanosComponent,
	                plano_list_component_1.PlanoListComponent,
	                plano_form_component_1.PlanosFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PlanosModule);
	    return PlanosModule;
	}());
	exports.PlanosModule = PlanosModule;


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ordens_servico_component_1 = __webpack_require__(721);
	var shared_module_1 = __webpack_require__(57);
	var ordens_servico_routing_module_1 = __webpack_require__(723);
	var ordem_servico_list_component_1 = __webpack_require__(420);
	var ordem_servico_form_component_1 = __webpack_require__(426);
	var ordem_servico_api_service_1 = __webpack_require__(421);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var ordem_servico_service_1 = __webpack_require__(235);
	var ordem_servico_detail_component_1 = __webpack_require__(436);
	var ordem_servico_item_form_component_1 = __webpack_require__(724);
	var ordem_servico_item_table_component_1 = __webpack_require__(1012);
	var ordem_servico_calendar_component_1 = __webpack_require__(727);
	var odometros_horimetros_module_1 = __webpack_require__(955);
	var OrdensServicoModule = (function () {
	    function OrdensServicoModule() {
	    }
	    OrdensServicoModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                odometros_horimetros_module_1.OdometrosHorimetrosModule,
	                ordens_servico_routing_module_1.OrdensServicoRoutingModule
	            ],
	            providers: [
	                ordem_servico_api_service_1.OrdemServicoApiService,
	                ordem_servico_navigation_service_1.OrdemServicoNavigationService,
	                ordem_servico_service_1.OrdemServicoService
	            ],
	            declarations: [
	                ordens_servico_component_1.OrdensServicoComponent,
	                ordem_servico_list_component_1.OrdemServicoListComponent,
	                ordem_servico_form_component_1.OrdemServicosFormComponent,
	                ordem_servico_detail_component_1.OrdemServicoDetailComponent,
	                ordem_servico_item_form_component_1.OrdemServicoItemFormComponent,
	                ordem_servico_item_table_component_1.OrdemServicoItemTableComponent,
	                ordem_servico_calendar_component_1.OrdemServicoCalendarComponent
	            ],
	            exports: [
	                ordem_servico_item_table_component_1.OrdemServicoItemTableComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], OrdensServicoModule);
	    return OrdensServicoModule;
	}());
	exports.OrdensServicoModule = OrdensServicoModule;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ordem_servico_navigation_service_1 = __webpack_require__(233);
	var ordem_servico_model_1 = __webpack_require__(427);
	var util_service_1 = __webpack_require__(88);
	var ordem_servico_service_1 = __webpack_require__(235);
	var servico_api_service_1 = __webpack_require__(430);
	var material_ordem_servico_api_service_1 = __webpack_require__(432);
	var OrdemServicoItemTableComponent = (function () {
	    function OrdemServicoItemTableComponent(_ordemServicoNavigationService, _ordemServicoService, _servicoApiService, _materialOrdemServicoApiService, _utilService) {
	        this._ordemServicoNavigationService = _ordemServicoNavigationService;
	        this._ordemServicoService = _ordemServicoService;
	        this._servicoApiService = _servicoApiService;
	        this._materialOrdemServicoApiService = _materialOrdemServicoApiService;
	        this._utilService = _utilService;
	        this.osObject = new ordem_servico_model_1.OrdemServico();
	        this.statusObject = {};
	        this.total = 0;
	        this.totalOs = 0;
	        this.list = [];
	        this.tipo = '';
	    }
	    OrdemServicoItemTableComponent.prototype.ngOnInit = function () {
	    };
	    OrdemServicoItemTableComponent.prototype.clickAddItem = function () {
	        var tipoServico = this._ordemServicoService.getItemTipoServico();
	        var tipoMaterial = this._ordemServicoService.getItemTipoMaterial();
	        if (this.tipo === 'servico') {
	            this._ordemServicoNavigationService.goToNewServico(this.osObject.id, tipoServico.Key);
	        }
	        else {
	            this._ordemServicoNavigationService.goToNewMaterial(this.osObject.id, tipoMaterial.Key);
	        }
	    };
	    OrdemServicoItemTableComponent.prototype.clickEditMateriaisServicos = function (item) {
	        if (this.tipo === 'servico') {
	            this._ordemServicoNavigationService.goToEditServico(this.osObject.id, item.Tipo.Key, item.id);
	        }
	        else {
	            this._ordemServicoNavigationService.goToEditMaterial(this.osObject.id, item.Tipo.Key, item.id);
	        }
	    };
	    OrdemServicoItemTableComponent.prototype.clickDeleteMateriaisServicos = function (item) {
	        var onDelete = (function () {
	            this.onDelete(item);
	        }.bind(this));
	        this._utilService.swalMessageDelete(onDelete);
	    };
	    OrdemServicoItemTableComponent.prototype.onDelete = function (item) {
	        var onDone = (function (Response) {
	            if (!Response.error) {
	                var x, lenX;
	                for (x = 0, lenX = this.list.length; x < lenX; x++) {
	                    if (this.list[x].id === item.id) {
	                        this.list.splice(x, 1);
	                        this.total -= item.valor;
	                        this.totalOs -= item.valor;
	                        break;
	                    }
	                }
	                this._utilService.swalMessageDeleteSuccess();
	            }
	            else {
	                this._utilService.swalMessageDeleteError();
	            }
	        }.bind(this));
	        var serviceType = this._ordemServicoService.getItemTipoServico();
	        if (item.Tipo.Key === serviceType.Key) {
	            this._servicoApiService.onDeleteServicoOrdemServico(item.id, onDone);
	        }
	        else {
	            this._materialOrdemServicoApiService.onDeleteMaterialOrdemServico(item.id, onDone);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof ordem_servico_model_1.OrdemServico !== 'undefined' && ordem_servico_model_1.OrdemServico) === 'function' && _a) || Object)
	    ], OrdemServicoItemTableComponent.prototype, "osObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OrdemServicoItemTableComponent.prototype, "statusObject", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], OrdemServicoItemTableComponent.prototype, "total", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], OrdemServicoItemTableComponent.prototype, "totalOs", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array)
	    ], OrdemServicoItemTableComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OrdemServicoItemTableComponent.prototype, "tipo", void 0);
	    OrdemServicoItemTableComponent = __decorate([
	        core_1.Component({
	            selector: 'app-ordem-servico-item-table',
	            template: __webpack_require__(1013),
	            styles: [__webpack_require__(1014)]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof ordem_servico_navigation_service_1.OrdemServicoNavigationService !== 'undefined' && ordem_servico_navigation_service_1.OrdemServicoNavigationService) === 'function' && _b) || Object, (typeof (_c = typeof ordem_servico_service_1.OrdemServicoService !== 'undefined' && ordem_servico_service_1.OrdemServicoService) === 'function' && _c) || Object, (typeof (_d = typeof servico_api_service_1.ServicoApiService !== 'undefined' && servico_api_service_1.ServicoApiService) === 'function' && _d) || Object, (typeof (_e = typeof material_ordem_servico_api_service_1.MaterialOrdemServicoApiService !== 'undefined' && material_ordem_servico_api_service_1.MaterialOrdemServicoApiService) === 'function' && _e) || Object, (typeof (_f = typeof util_service_1.UtilService !== 'undefined' && util_service_1.UtilService) === 'function' && _f) || Object])
	    ], OrdemServicoItemTableComponent);
	    return OrdemServicoItemTableComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.OrdemServicoItemTableComponent = OrdemServicoItemTableComponent;


/***/ },
/* 1013 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <a class=\"geo-button--action geo-button__icon--add button-remove-margin-left\" (click)=\"clickAddItem()\" *ngIf=\"statusObject.Key === 1\">Novo Item</a>\n    <p class=\"p-materiaisServicos\">\n        <strong>Total: </strong> {{total | currencyMask}} <span *ngIf=\"!total\">R$ 0,00</span>\n    </p>\n</div>\n\n<p class=\"lead padding\" *ngIf=\"!list.length\">Nenhum material ou serviço cadastrado</p>\n\n<table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n        <th>Item</th>\n        <th>Tipo</th>\n        <th>Valor</th>\n        <th *ngIf=\"statusObject.Key === 1\"></th>\n    </tr>\n    </thead>\n    <tbody data-collapse *ngFor=\"let item of(list | sort:['descricao'])\">\n    <tr>\n        <td><span class=\"geo-arrow\"></span> <span>{{item.descricao}}</span></td>\n        <td class=\"small\"><span *ngIf=\"item.Tipo\">{{item.Tipo.Value}}</span></td>\n        <td class=\"small\"><span>{{item.valor | currencyMask}}</span></td>\n        <td class=\"geo-table--action\" *ngIf=\"statusObject.Key === 1\">\n            <a (click)=\"clickEditMateriaisServicos(item)\">\n                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n            </a>\n            <a (click)=\"clickDeleteMateriaisServicos(item)\">\n                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n            </a>\n        </td>\n    </tr>\n    <tr class=\"description\">\n        <td colspan=\"100%\">\n            <p *ngIf=\"item.Tipo && (item.Tipo.Key === 1)\"><strong>Data: </strong> <span >{{item.data | date:'dd/MM/yyyy'}}</span> <i *ngIf=\"!item.data\">não cadastrado</i></p>\n            <p ><strong>Quantidade: </strong> <span >{{item.quantidade}}</span> <i *ngIf=\"!item.quantidade\">não cadastrado</i></p>\n            <p *ngIf=\"item.Tipo && (item.Tipo.Key === 2)\"><strong>Medida: </strong> <span *ngIf=\"item.medida\">{{item.medida.medida}}</span> <i *ngIf=\"!item.medida\">não cadastrado</i></p>\n            <p ><strong>Valor unitário: </strong> <span>{{item.valorUnitario | currencyMask}}</span> <i *ngIf=\"!item.valorUnitario\">não cadastrado</i></p>\n        </td>\n    </tr>\n    </tbody>\n</table>\n";

/***/ },
/* 1014 */
166,
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(234);
	var data_service_2 = __webpack_require__(178);
	var data_service_3 = __webpack_require__(200);
	var data_service_4 = __webpack_require__(423);
	var ManutencaoMenuComponent = (function () {
	    function ManutencaoMenuComponent() {
	        this.manutencoesRoute = data_service_1.manutencoesRoute;
	        this.ordensServicoRoute = data_service_3.ordensServicoRoute;
	        this.configuracaoRoute = data_service_2.configuracaoRoute;
	        this.manutencaoProgramadaRoute = data_service_4.manutencoesProgramadaRoute;
	        this.ordensServicoModule = data_service_3.ordensServicoModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	        this.manutencaoProgramadaModule = data_service_4.manutencoesProgramadaModuleName;
	    }
	    ManutencaoMenuComponent.prototype.ngOnInit = function () {
	    };
	    ManutencaoMenuComponent = __decorate([
	        core_1.Component({
	            selector: 'app-manutencao-menu',
	            template: __webpack_require__(1016)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ManutencaoMenuComponent);
	    return ManutencaoMenuComponent;
	}());
	exports.ManutencaoMenuComponent = ManutencaoMenuComponent;


/***/ },
/* 1016 */
/***/ function(module, exports) {

	module.exports = "<span class=\"geo-arrow\"></span>\n<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-manutencao'/></svg>\n<span>Manutenção</span>\n<div class=\"geo-submenu\">\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + manutencoesRoute + '/' + ordensServicoRoute]\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">{{ordensServicoModule.plural}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + manutencoesRoute + '/' + manutencaoProgramadaRoute]\" routerLinkActive=\"active\">{{manutencaoProgramadaModule.plural}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + manutencoesRoute + '/' + ordensServicoRoute + '/agenda']\" routerLinkActive=\"active\">Agenda</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + manutencoesRoute + '/' + configuracaoRoute]\" routerLinkActive=\"active\">{{configuracaoModule.plural}}</a>\n</div>\n";

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var manutencao_programada_list_component_1 = __webpack_require__(733);
	var manutencoes_routing_module_1 = __webpack_require__(695);
	var manutencao_programada_api_service_1 = __webpack_require__(734);
	var manutencao_programada_navigation_service_1 = __webpack_require__(428);
	var manutencao_programada_service_1 = __webpack_require__(422);
	var manutencao_programada_component_1 = __webpack_require__(730);
	var ManutencaoProgramadaModule = (function () {
	    function ManutencaoProgramadaModule() {
	    }
	    ManutencaoProgramadaModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                manutencoes_routing_module_1.ManutencoesRoutingModule
	            ],
	            providers: [
	                manutencao_programada_api_service_1.ManutencaoProgramadaApiService,
	                manutencao_programada_navigation_service_1.ManutencaoProgramadaNavigationService,
	                manutencao_programada_service_1.ManutencaoProgramadaService
	            ],
	            declarations: [
	                manutencao_programada_component_1.ManutencaoProgramadaComponent,
	                manutencao_programada_list_component_1.ManutencaoProgramadaListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ManutencaoProgramadaModule);
	    return ManutencaoProgramadaModule;
	}());
	exports.ManutencaoProgramadaModule = ManutencaoProgramadaModule;


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var medidas_module_1 = __webpack_require__(1019);
	var materiais_module_1 = __webpack_require__(994);
	var almoxarifado_component_1 = __webpack_require__(466);
	var almoxarifado_routing_module_1 = __webpack_require__(1020);
	var grupos_materiais_module_1 = __webpack_require__(1021);
	var AlmoxarifadoModule = (function () {
	    function AlmoxarifadoModule() {
	    }
	    AlmoxarifadoModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                medidas_module_1.MedidasModule,
	                materiais_module_1.MateriaisModule,
	                grupos_materiais_module_1.GruposMateriaisModule,
	                almoxarifado_routing_module_1.AlmoxarifadoRoutingModule
	            ],
	            declarations: [
	                almoxarifado_component_1.AlmoxarifadoComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AlmoxarifadoModule);
	    return AlmoxarifadoModule;
	}());
	exports.AlmoxarifadoModule = AlmoxarifadoModule;


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var medidas_routing_1 = __webpack_require__(470);
	var medida_service_1 = __webpack_require__(474);
	var medida_api_service_1 = __webpack_require__(472);
	var medida_navigation_service_1 = __webpack_require__(473);
	var medidas_component_1 = __webpack_require__(468);
	var medida_list_component_1 = __webpack_require__(471);
	var medida_form_component_1 = __webpack_require__(477);
	var MedidasModule = (function () {
	    function MedidasModule() {
	    }
	    MedidasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                medidas_routing_1.MedidasRoutingModule
	            ],
	            providers: [
	                medida_service_1.MedidaService,
	                medida_api_service_1.MedidaApiService,
	                medida_navigation_service_1.MedidaNavigationService
	            ],
	            declarations: [
	                medidas_component_1.MedidasComponent,
	                medida_form_component_1.MedidaFormComponent,
	                medida_list_component_1.MedidaListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], MedidasModule);
	    return MedidasModule;
	}());
	exports.MedidasModule = MedidasModule;


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var AlmoxarifadoRoutingModule = (function () {
	    function AlmoxarifadoRoutingModule() {
	    }
	    AlmoxarifadoRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AlmoxarifadoRoutingModule);
	    return AlmoxarifadoRoutingModule;
	}());
	exports.AlmoxarifadoRoutingModule = AlmoxarifadoRoutingModule;


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var grupos_materiais_routing_1 = __webpack_require__(500);
	var grupo_material_service_1 = __webpack_require__(489);
	var grupo_material_api_service_1 = __webpack_require__(502);
	var grupo_material_navigation_service_1 = __webpack_require__(490);
	var grupos_materiais_component_1 = __webpack_require__(498);
	var grupo_material_form_component_1 = __webpack_require__(504);
	var grupo_material_list_component_1 = __webpack_require__(501);
	var GruposMateriaisModule = (function () {
	    function GruposMateriaisModule() {
	    }
	    GruposMateriaisModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                grupos_materiais_routing_1.GruposMateriaisRoutingModule
	            ],
	            providers: [
	                grupo_material_service_1.GrupoMaterialService,
	                grupo_material_api_service_1.GrupoMaterialApiService,
	                grupo_material_navigation_service_1.GrupoMaterialNavigationService
	            ],
	            declarations: [
	                grupos_materiais_component_1.GruposMateriaisComponent,
	                grupo_material_form_component_1.GrupoMaterialFormComponent,
	                grupo_material_list_component_1.GrupoMaterialListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], GruposMateriaisModule);
	    return GruposMateriaisModule;
	}());
	exports.GruposMateriaisModule = GruposMateriaisModule;


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var contas_component_1 = __webpack_require__(480);
	var contas_routing_module_1 = __webpack_require__(1023);
	var conta_contabil_module_1 = __webpack_require__(1024);
	var ContasModule = (function () {
	    function ContasModule() {
	    }
	    ContasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                conta_contabil_module_1.ContaContabilModule,
	                contas_routing_module_1.ContasRoutingModule
	            ],
	            declarations: [contas_component_1.ContasComponent]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContasModule);
	    return ContasModule;
	}());
	exports.ContasModule = ContasModule;


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var ContasRoutingModule = (function () {
	    function ContasRoutingModule() {
	    }
	    ContasRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContasRoutingModule);
	    return ContasRoutingModule;
	}());
	exports.ContasRoutingModule = ContasRoutingModule;


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 26/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var conta_contabil_routing_1 = __webpack_require__(484);
	var conta_contabil_service_1 = __webpack_require__(488);
	var conta_contabil_component_1 = __webpack_require__(482);
	var conta_contabil_form_component_1 = __webpack_require__(492);
	var conta_contabil_table_component_1 = __webpack_require__(1025);
	var conta_contabil_list_component_1 = __webpack_require__(485);
	var conta_contabil_codigo_pipe_1 = __webpack_require__(1028);
	var conta_contabil_codigo_mask_directive_1 = __webpack_require__(1029);
	var conta_contabil_tipo_api_service_1 = __webpack_require__(495);
	var conta_contabil_navigation_service_1 = __webpack_require__(487);
	var contaContabilCodigo_validator_1 = __webpack_require__(494);
	var conta_contabil_api_service_1 = __webpack_require__(486);
	var ContaContabilModule = (function () {
	    function ContaContabilModule() {
	    }
	    ContaContabilModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                conta_contabil_routing_1.ContaContabilRoutingModule
	            ],
	            providers: [
	                conta_contabil_service_1.ContaContabilService,
	                conta_contabil_navigation_service_1.ContaContabilNavigationService,
	                conta_contabil_service_1.ContaContabilService,
	                conta_contabil_api_service_1.ContaContabilApiService,
	                contaContabilCodigo_validator_1.ContaContabilCodigoValidator,
	                conta_contabil_tipo_api_service_1.ContaContabilTipoApiService
	            ],
	            declarations: [
	                conta_contabil_component_1.ContaContabilComponent,
	                conta_contabil_form_component_1.ContaContabilFormComponent,
	                conta_contabil_table_component_1.ContaContabilTableComponent,
	                conta_contabil_list_component_1.ContaContabilListComponent,
	                conta_contabil_codigo_pipe_1.ContaContabilCodigoPipe,
	                conta_contabil_codigo_mask_directive_1.ContaContabilCodigoMaskDirective
	            ],
	            exports: [
	                conta_contabil_table_component_1.ContaContabilTableComponent,
	                conta_contabil_codigo_mask_directive_1.ContaContabilCodigoMaskDirective,
	                conta_contabil_codigo_pipe_1.ContaContabilCodigoPipe
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContaContabilModule);
	    return ContaContabilModule;
	}());
	exports.ContaContabilModule = ContaContabilModule;


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(159);
	var ContaContabilTableComponent = (function () {
	    function ContaContabilTableComponent() {
	        this.editEvent = new core_1.EventEmitter();
	        this.deleteEvent = new core_1.EventEmitter();
	        this.list = [];
	        this.types = data_service_1.modelosContaContabil;
	        this.contasContabeisModuleName = data_service_1.contasContabeisModuleName;
	    }
	    ContaContabilTableComponent.prototype.ngOnInit = function () {
	        this.count += 1;
	    };
	    ContaContabilTableComponent.prototype.clickEdit = function (item) {
	        this.editEvent.next(item);
	    };
	    ContaContabilTableComponent.prototype.clickDelete = function (item) {
	        this.deleteEvent.next(item);
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], ContaContabilTableComponent.prototype, "editEvent", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_b = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _b) || Object)
	    ], ContaContabilTableComponent.prototype, "deleteEvent", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ContaContabilTableComponent.prototype, "list", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], ContaContabilTableComponent.prototype, "listFilter", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], ContaContabilTableComponent.prototype, "showDisabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Number)
	    ], ContaContabilTableComponent.prototype, "count", void 0);
	    ContaContabilTableComponent = __decorate([
	        core_1.Component({
	            selector: 'conta-contabil-table',
	            template: __webpack_require__(1026),
	            styles: [__webpack_require__(1027)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContaContabilTableComponent);
	    return ContaContabilTableComponent;
	    var _a, _b;
	}());
	exports.ContaContabilTableComponent = ContaContabilTableComponent;


/***/ },
/* 1026 */
/***/ function(module, exports) {

	module.exports = "<table *ngIf=\"list.length\">\n    <thead>\n    <tr>\n        <th>-</th>\n        <th class=\"small\"></th>\n        <th class=\"small\"></th>\n    </tr>\n    </thead>\n    <tbody data-collapse *ngFor=\"let item of(list | filter:listFilter.value:['codigo', 'descricao','labels'] | filterActive:showDisabled); let i = index;\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n        <td>\n            <span class=\"geo-arrow\" [ngStyle]=\"{'padding-left.em': count}\" *ngIf=\"!item.tipoId\"></span>\n            <span [ngStyle]=\"{'padding-left.em': count}\" *ngIf=\"item.tipoId\"></span>\n            {{item.codigo}} -  {{item.descricao}}\n        </td>\n        <td class=\"small\">\n            <span *ngIf=\"item.tipoId\">\n                {{types[1].Value}}\n                 <!--<svg><use xlink:href='images/icons.svg#icon-analitico'/></svg>-->\n            </span>\n        </td>\n        <td class=\"geo-table--action\">\n            <a (click)=\"clickEdit(item)\">\n                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-edit'/></svg>\n            </a>\n            <a (click)=\"clickDelete(item)\">\n                <svg><use xlink:href='../../assets/images/icons/icons.svg#icon-trash'/></svg>\n            </a>\n        </td>\n    </tr>\n    <tr class=\"description\" *ngIf=\"!item.tipoId\">\n        <td colspan=\"100%\" class=\"colspan100\">\n            <p class=\"lead padding\" [ngStyle]=\"{'padding-left.em': count}\" *ngIf=\"!item.contas.length\">Nenhuma {{contasContabeisModuleName.single | lowercase}} cadastrada</p>\n\n            <conta-contabil-table [list]=\"item.contas\"\n                                  [listFilter]=\"listFilter\"\n                                  [showDisabled]=\"showDisabled\"\n                                  [count]=\"count\"\n                                  (editEvent)=\"clickEdit($event)\"\n                                  (deleteEvent)=\"clickDelete($event)\"></conta-contabil-table>\n        </td>\n    </tr>\n    </tbody>\n</table>\n";

/***/ },
/* 1027 */
/***/ function(module, exports) {

	module.exports = "table {\n    font-size: 15px;\n}\n\ntable thead {\n    display: none;\n}\n\ntable .description td.colspan100{\n    padding: 0;\n}\ntable .description table{\n    margin: 0;\n    border: none;\n}\n\ntable .description table tbody tr {\n    border: none;\n}\n\ntable .description table tbody tr:not(last-child) {\n    border-bottom: 1px solid #edf0f4;\n}\n"

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 29/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var ContaContabilCodigoPipe = (function () {
	    function ContaContabilCodigoPipe() {
	    }
	    ContaContabilCodigoPipe.prototype.transform = function (value, args) {
	        if (value) {
	            if (typeof value !== 'string') {
	                value = value.toString();
	            }
	            var valueLength = value.length, x, lenX;
	            for (x = valueLength, lenX = args; x < lenX; x++) {
	                value = "0" + value;
	            }
	            return value;
	        }
	    };
	    ContaContabilCodigoPipe = __decorate([
	        core_1.Pipe({
	            name: 'contaContabilCodigoMask'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContaContabilCodigoPipe);
	    return ContaContabilCodigoPipe;
	}());
	exports.ContaContabilCodigoPipe = ContaContabilCodigoPipe;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 29/09/2016.
	 */
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(58);
	var ContaContabilCodigoMaskDirective = (function () {
	    function ContaContabilCodigoMaskDirective(model) {
	        this.model = model;
	    }
	    ContaContabilCodigoMaskDirective.prototype.ngModelChange = function () {
	        this.modelValue();
	    };
	    ContaContabilCodigoMaskDirective.prototype.onKeyDownBackspace = function () {
	        this.modelValue(true);
	    };
	    ContaContabilCodigoMaskDirective.prototype.modelValue = function (backspace) {
	        if (this.model) {
	            var model = this.model;
	            if (model.viewModel) {
	                if (typeof model.viewModel === 'number') {
	                    model.viewModel = model.viewModel.toString();
	                }
	                this.inputChange(model.viewModel, backspace);
	            }
	        }
	    };
	    ContaContabilCodigoMaskDirective.prototype.inputChange = function (model, backspace) {
	        if (model) {
	            var newVal = model.replace(/\D/g, '');
	            if (backspace) {
	                if (newVal.length === 1) {
	                    newVal = newVal.substring(0, newVal.length - 1);
	                }
	            }
	            if (newVal.length == 0) {
	                newVal = '';
	            }
	            else if (newVal.length === 1) {
	                newVal = newVal.replace(/(\d{1})/, "$1.");
	            }
	            else if (newVal.length <= 2) {
	                newVal = newVal.replace(/(\d{1})(\d{1})/, "$1.$2");
	            }
	            else if (newVal.length <= 3) {
	                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})/, "$1.$2.$3");
	            }
	            else if (newVal.length <= 4) {
	                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})/, "$1.$2.$3.$4");
	            }
	            else if (newVal.length <= 5) {
	                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})/, "$1.$2.$3.$4.$5");
	            }
	            else if (newVal.length <= 7) {
	                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{0,2})/, "$1.$2.$3.$4.$5.$6");
	            }
	            else if (newVal.length <= 9) {
	                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{0,2})(\d{0,2})/, "$1.$2.$3.$4.$5.$6.$7");
	            }
	            this.model.valueAccessor.writeValue(newVal);
	        }
	    };
	    __decorate([
	        core_1.HostListener('ngModelChange'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], ContaContabilCodigoMaskDirective.prototype, "ngModelChange", null);
	    __decorate([
	        core_1.HostListener('keydown.backspace'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', void 0)
	    ], ContaContabilCodigoMaskDirective.prototype, "onKeyDownBackspace", null);
	    ContaContabilCodigoMaskDirective = __decorate([
	        core_1.Directive({
	            selector: '[contaContabilCodigoMask]'
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forms_1.NgControl !== 'undefined' && forms_1.NgControl) === 'function' && _a) || Object])
	    ], ContaContabilCodigoMaskDirective);
	    return ContaContabilCodigoMaskDirective;
	    var _a;
	}());
	exports.ContaContabilCodigoMaskDirective = ContaContabilCodigoMaskDirective;


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var despachos_component_1 = __webpack_require__(538);
	var seguradoras_module_1 = __webpack_require__(1031);
	var despachos_routing_module_1 = __webpack_require__(740);
	var seguros_module_1 = __webpack_require__(1032);
	var obrigacoes_module_1 = __webpack_require__(1033);
	var licenciamentos_module_1 = __webpack_require__(1034);
	var despacho_obrigacoes_menu_component_1 = __webpack_require__(1035);
	var despacho_configuracao_obrigacoes_component_1 = __webpack_require__(799);
	var despacho_service_1 = __webpack_require__(793);
	var despacho_seguros_menu_component_1 = __webpack_require__(1037);
	var DespachosModule = (function () {
	    function DespachosModule() {
	    }
	    DespachosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                seguradoras_module_1.SeguradorasModule,
	                seguros_module_1.SegurosModule,
	                obrigacoes_module_1.ObrigacoesModule,
	                licenciamentos_module_1.LicenciamentosModule,
	                despachos_routing_module_1.DespachosRoutingModule
	            ],
	            providers: [
	                despacho_service_1.DespachoService
	            ],
	            declarations: [
	                despachos_component_1.DespachosComponent,
	                despacho_obrigacoes_menu_component_1.DespachoObrigacoesMenuComponent,
	                despacho_seguros_menu_component_1.DespachoSegurosMenuComponent,
	                despacho_configuracao_obrigacoes_component_1.DespachoConfiguracaoObrigacoesComponent,
	            ],
	            exports: [
	                despacho_obrigacoes_menu_component_1.DespachoObrigacoesMenuComponent,
	                despacho_seguros_menu_component_1.DespachoSegurosMenuComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DespachosModule);
	    return DespachosModule;
	}());
	exports.DespachosModule = DespachosModule;


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var seguradoras_component_1 = __webpack_require__(771);
	var shared_module_1 = __webpack_require__(57);
	var seguradora_list_component_1 = __webpack_require__(768);
	var seguradora_form_component_1 = __webpack_require__(763);
	var seguradoras_routing_module_1 = __webpack_require__(762);
	var pessoa_juridica_module_1 = __webpack_require__(887);
	var seguradora_api_service_1 = __webpack_require__(752);
	var seguradora_navigation_service_1 = __webpack_require__(754);
	var seguradora_service_1 = __webpack_require__(753);
	var SeguradorasModule = (function () {
	    function SeguradorasModule() {
	    }
	    SeguradorasModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                pessoa_juridica_module_1.PessoaJuridicaModule,
	                seguradoras_routing_module_1.SeguradorasRoutingModule
	            ],
	            providers: [
	                seguradora_api_service_1.SeguradoraApiService,
	                seguradora_navigation_service_1.SeguradoraNavigationService,
	                seguradora_service_1.SeguradoraService
	            ],
	            declarations: [
	                seguradoras_component_1.SeguradorasComponent,
	                seguradora_list_component_1.SeguradoraListComponent,
	                seguradora_form_component_1.SeguradoraFormComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SeguradorasModule);
	    return SeguradorasModule;
	}());
	exports.SeguradorasModule = SeguradorasModule;


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var seguros_component_1 = __webpack_require__(743);
	var shared_module_1 = __webpack_require__(57);
	var seguro_api_service_1 = __webpack_require__(749);
	var seguro_navigation_service_1 = __webpack_require__(748);
	var seguro_service_1 = __webpack_require__(750);
	var seguro_form_component_1 = __webpack_require__(746);
	var seguro_list_component_1 = __webpack_require__(757);
	var seguros_routing_module_1 = __webpack_require__(745);
	var SegurosModule = (function () {
	    function SegurosModule() {
	    }
	    SegurosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                seguros_routing_module_1.SegurosRoutingModule
	            ],
	            providers: [
	                seguro_api_service_1.SeguroApiService,
	                seguro_navigation_service_1.SeguroNavigationService,
	                seguro_service_1.SeguroService
	            ],
	            declarations: [
	                seguros_component_1.SegurosComponent,
	                seguro_form_component_1.SeguroFormComponent,
	                seguro_list_component_1.SeguroListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SegurosModule);
	    return SegurosModule;
	}());
	exports.SegurosModule = SegurosModule;


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var obrigacoes_component_1 = __webpack_require__(774);
	var shared_module_1 = __webpack_require__(57);
	var obrigacao_api_service_1 = __webpack_require__(780);
	var obrigacao_navigation_service_1 = __webpack_require__(779);
	var obrigacao_service_1 = __webpack_require__(781);
	var obrigacao_form_component_1 = __webpack_require__(777);
	var obrigacao_list_component_1 = __webpack_require__(788);
	var obrigacoes_routing_module_1 = __webpack_require__(776);
	var obrigacao_tipo_form_component_1 = __webpack_require__(791);
	var obrigacao_tipo_list_component_1 = __webpack_require__(796);
	var obrigacao_tipo_api_service_1 = __webpack_require__(785);
	var obrigacao_tipo_navigation_service_1 = __webpack_require__(784);
	var obrigacao_tipo_service_1 = __webpack_require__(792);
	var ObrigacoesModule = (function () {
	    function ObrigacoesModule() {
	    }
	    ObrigacoesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                obrigacoes_routing_module_1.ObrigacoesRoutingModule
	            ],
	            providers: [
	                obrigacao_api_service_1.ObrigacaoApiService,
	                obrigacao_navigation_service_1.ObrigacaoNavigationService,
	                obrigacao_service_1.Obrigacoeservice,
	                obrigacao_tipo_api_service_1.ObrigacaoTipoApiService,
	                obrigacao_tipo_navigation_service_1.ObrigacaoTipoNavigationService,
	                obrigacao_tipo_service_1.ObrigacaoTipoService
	            ],
	            declarations: [
	                obrigacoes_component_1.ObrigacoesComponent,
	                obrigacao_form_component_1.ObrigacaoFormComponent,
	                obrigacao_list_component_1.ObrigacaoListComponent,
	                obrigacao_tipo_form_component_1.ObrigacaoTipoFormComponent,
	                obrigacao_tipo_list_component_1.ObrigacaoTipoListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ObrigacoesModule);
	    return ObrigacoesModule;
	}());
	exports.ObrigacoesModule = ObrigacoesModule;


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var licenciamentos_component_1 = __webpack_require__(802);
	var shared_module_1 = __webpack_require__(57);
	var licenciamento_api_service_1 = __webpack_require__(384);
	var licenciamento_navigation_service_1 = __webpack_require__(800);
	var licenciamento_service_1 = __webpack_require__(807);
	var licenciamentos_routing_module_1 = __webpack_require__(804);
	var licenciamento_form_component_1 = __webpack_require__(805);
	var licenciamento_list_component_1 = __webpack_require__(810);
	var LicenciamentosModule = (function () {
	    function LicenciamentosModule() {
	    }
	    LicenciamentosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                licenciamentos_routing_module_1.LicenciamentosRoutingModule
	            ],
	            providers: [
	                licenciamento_api_service_1.LicenciamentoApiService,
	                licenciamento_navigation_service_1.LicenciamentoNavigationService,
	                licenciamento_service_1.LicenciamentosService,
	            ],
	            declarations: [
	                licenciamentos_component_1.LicenciamentosComponent,
	                licenciamento_form_component_1.LicenciamentoFormComponent,
	                licenciamento_list_component_1.LicenciamentoListComponent,
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LicenciamentosModule);
	    return LicenciamentosModule;
	}());
	exports.LicenciamentosModule = LicenciamentosModule;


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(178);
	var data_service_2 = __webpack_require__(773);
	var data_service_3 = __webpack_require__(537);
	var DespachoObrigacoesMenuComponent = (function () {
	    function DespachoObrigacoesMenuComponent() {
	        this.despachosRoute = data_service_3.despachosRoute;
	        this.obrigacoesRoute = data_service_2.obrigacoesRoute;
	        this.configuracaoRoute = data_service_1.configuracaoRoute;
	        this.obrigacoesModule = data_service_2.obrigacoesModuleName;
	        this.configuracaoModule = data_service_1.configuracaoModuleName;
	    }
	    DespachoObrigacoesMenuComponent.prototype.ngOnInit = function () {
	    };
	    DespachoObrigacoesMenuComponent = __decorate([
	        core_1.Component({
	            selector: 'app-despacho-obrigacoes-menu',
	            template: __webpack_require__(1036)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DespachoObrigacoesMenuComponent);
	    return DespachoObrigacoesMenuComponent;
	}());
	exports.DespachoObrigacoesMenuComponent = DespachoObrigacoesMenuComponent;


/***/ },
/* 1036 */
/***/ function(module, exports) {

	module.exports = "<span class=\"geo-arrow\"></span>\n<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-obrigacoes'/></svg>\n<span>Obrigações</span>\n<div class=\"geo-submenu\">\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + despachosRoute + '/' + obrigacoesRoute]\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">{{obrigacoesModule.plural}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + despachosRoute + '/' + obrigacoesRoute + '/' + configuracaoRoute]\" routerLinkActive=\"active\">{{configuracaoModule.plural}}</a>\n</div>";

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(537);
	var data_service_2 = __webpack_require__(742);
	var data_service_3 = __webpack_require__(741);
	var DespachoSegurosMenuComponent = (function () {
	    function DespachoSegurosMenuComponent() {
	        this.despachosRoute = data_service_1.despachosRoute;
	        this.seguradorasRoute = data_service_3.seguradorasRoute;
	        this.segurosRoute = data_service_2.segurosRoute;
	        this.seguradorasModule = data_service_3.seguradorasModuleName;
	        this.segurosModule = data_service_2.segurosModuleName;
	    }
	    DespachoSegurosMenuComponent.prototype.ngOnInit = function () {
	    };
	    DespachoSegurosMenuComponent = __decorate([
	        core_1.Component({
	            selector: 'app-despacho-seguros-menu',
	            template: __webpack_require__(1038)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DespachoSegurosMenuComponent);
	    return DespachoSegurosMenuComponent;
	}());
	exports.DespachoSegurosMenuComponent = DespachoSegurosMenuComponent;


/***/ },
/* 1038 */
/***/ function(module, exports) {

	module.exports = "<span class=\"geo-arrow\"></span>\n<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-despachos'/></svg>\n<span>Seguros</span>\n<div class=\"geo-submenu\">\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + despachosRoute + '/' + segurosRoute + '/' + seguradorasRoute]\" routerLinkActive=\"active\">{{seguradorasModule.plural}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + despachosRoute + '/' + segurosRoute]\" [routerLinkActiveOptions]=\"{ exact: true }\" routerLinkActive=\"active\">{{segurosModule.plural}}</a>\n</div>";

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rastreamentos_component_1 = __webpack_require__(814);
	var shared_module_1 = __webpack_require__(57);
	var rastreamento_menu_component_1 = __webpack_require__(1040);
	var rastreamento_configuracao_component_1 = __webpack_require__(817);
	var rastreamento_mapa_component_1 = __webpack_require__(825);
	var rastreamento_mapa2_component_1 = __webpack_require__(846);
	var rastreamento_veiculos_component_1 = __webpack_require__(830);
	var rastreamento_service_1 = __webpack_require__(827);
	var rastreamentos_routing_module_1 = __webpack_require__(816);
	var rastreamento_api_service_1 = __webpack_require__(826);
	var rastreamento_historico_component_1 = __webpack_require__(833);
	var modelos_gps_module_1 = __webpack_require__(1042);
	var cercas_module_1 = __webpack_require__(1043);
	var alarmes_module_1 = __webpack_require__(1044);
	var templates_module_1 = __webpack_require__(1045);
	var RastreamentosModule = (function () {
	    function RastreamentosModule() {
	    }
	    RastreamentosModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                modelos_gps_module_1.ModeloGpsModule,
	                cercas_module_1.CercaModule,
	                alarmes_module_1.AlarmeModule,
	                templates_module_1.TemplatesModule,
	                rastreamentos_routing_module_1.RastreamentosRoutingModule
	            ],
	            providers: [
	                rastreamento_service_1.RastreamentoService,
	                rastreamento_api_service_1.RastreamentoApiService
	            ],
	            declarations: [
	                rastreamentos_component_1.RastreamentosComponent,
	                rastreamento_menu_component_1.RastreamentoMenuComponent,
	                rastreamento_configuracao_component_1.RastreamentoConfiguracaoComponent,
	                rastreamento_mapa_component_1.RastreamentoMapaComponent,
	                rastreamento_mapa2_component_1.RastreamentoMapa2Component,
	                rastreamento_veiculos_component_1.RastreamentoVeiculosComponent,
	                rastreamento_historico_component_1.RastreamentoHistoricoComponent
	            ],
	            exports: [
	                rastreamento_menu_component_1.RastreamentoMenuComponent,
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], RastreamentosModule);
	    return RastreamentosModule;
	}());
	exports.RastreamentosModule = RastreamentosModule;


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 23/01/2017.
	 */
	var core_1 = __webpack_require__(3);
	var data_service_1 = __webpack_require__(813);
	var data_service_2 = __webpack_require__(178);
	var RastreamentoMenuComponent = (function () {
	    function RastreamentoMenuComponent() {
	        this.rastreamentosRoute = data_service_1.rastreamentosRoute;
	        this.configuracaoRoute = data_service_2.configuracaoRoute;
	        this.module = data_service_1.rastreamentosModuleName;
	        this.configuracaoModule = data_service_2.configuracaoModuleName;
	    }
	    RastreamentoMenuComponent.prototype.ngOnInit = function () {
	    };
	    RastreamentoMenuComponent = __decorate([
	        core_1.Component({
	            selector: 'app-rastreamento-menu',
	            template: __webpack_require__(1041)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], RastreamentoMenuComponent);
	    return RastreamentoMenuComponent;
	}());
	exports.RastreamentoMenuComponent = RastreamentoMenuComponent;


/***/ },
/* 1041 */
/***/ function(module, exports) {

	module.exports = "<span class=\"geo-arrow\"></span>\n<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-rastreamentos'/></svg>\n<span>{{module.single}}</span>\n<div class=\"geo-submenu\">\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + rastreamentosRoute + '/mapa']\" routerLinkActive=\"active\">Mapa</a>\n    <!--<a class=\"geo-submenu__item\" [routerLink]=\"['./' + rastreamentosRoute + '/mapa2']\" routerLinkActive=\"active\">Mapa2</a>-->\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + rastreamentosRoute + '/veiculos']\" routerLinkActive=\"active\">Veículos</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + rastreamentosRoute + '/' + configuracaoRoute]\" routerLinkActive=\"active\">{{configuracaoModule.plural}}</a>\n</div>\n";

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var modelos_gps_component_1 = __webpack_require__(836);
	var shared_module_1 = __webpack_require__(57);
	var modelo_gps_api_service_1 = __webpack_require__(388);
	var modelo_gps_navigation_service_1 = __webpack_require__(818);
	var modelo_gps_service_1 = __webpack_require__(386);
	var modelo_gps_form_component_1 = __webpack_require__(839);
	var modelo_gps_list_component_1 = __webpack_require__(843);
	var modelos_gps_routing_module_1 = __webpack_require__(838);
	var ModeloGpsModule = (function () {
	    function ModeloGpsModule() {
	    }
	    ModeloGpsModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                modelos_gps_routing_module_1.ModeloGpsRoutingModule
	            ],
	            providers: [
	                modelo_gps_api_service_1.ModeloGpsApiService,
	                modelo_gps_navigation_service_1.ModeloGpsNavigationService,
	                modelo_gps_service_1.ModeloGpsService
	            ],
	            declarations: [
	                modelos_gps_component_1.ModelosGpsComponent,
	                modelo_gps_form_component_1.ModeloGpsFormComponent,
	                modelo_gps_list_component_1.ModeloGpsListComponent
	            ],
	            exports: [
	                modelo_gps_list_component_1.ModeloGpsListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ModeloGpsModule);
	    return ModeloGpsModule;
	}());
	exports.ModeloGpsModule = ModeloGpsModule;


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var cerca_api_service_1 = __webpack_require__(854);
	var cerca_navigation_service_1 = __webpack_require__(820);
	var cerca_service_1 = __webpack_require__(855);
	var cerca_form_component_1 = __webpack_require__(852);
	var cerca_list_component_1 = __webpack_require__(858);
	var cercas_routing_module_1 = __webpack_require__(851);
	var cercas_component_1 = __webpack_require__(849);
	var CercaModule = (function () {
	    function CercaModule() {
	    }
	    CercaModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                cercas_routing_module_1.CercaRoutingModule
	            ],
	            providers: [
	                cerca_api_service_1.CercaApiService,
	                cerca_navigation_service_1.CercaNavigationService,
	                cerca_service_1.CercaService
	            ],
	            declarations: [
	                cercas_component_1.CercasComponent,
	                cerca_form_component_1.CercaFormComponent,
	                cerca_list_component_1.CercaListComponent
	            ],
	            exports: [
	                cerca_list_component_1.CercaListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], CercaModule);
	    return CercaModule;
	}());
	exports.CercaModule = CercaModule;


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var alarme_api_service_1 = __webpack_require__(866);
	var alarme_navigation_service_1 = __webpack_require__(822);
	var alarme_service_1 = __webpack_require__(867);
	var alarme_form_component_1 = __webpack_require__(864);
	var alarme_list_component_1 = __webpack_require__(873);
	var alarmes_routing_module_1 = __webpack_require__(863);
	var alarmes_component_1 = __webpack_require__(861);
	var AlarmeModule = (function () {
	    function AlarmeModule() {
	    }
	    AlarmeModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                alarmes_routing_module_1.AlarmeRoutingModule
	            ],
	            providers: [
	                alarme_api_service_1.AlarmeApiService,
	                alarme_navigation_service_1.AlarmeNavigationService,
	                alarme_service_1.Alarmeservice
	            ],
	            declarations: [
	                alarmes_component_1.AlarmesComponent,
	                alarme_form_component_1.AlarmeFormComponent,
	                alarme_list_component_1.AlarmeListComponent
	            ],
	            exports: [
	                alarme_list_component_1.AlarmeListComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AlarmeModule);
	    return AlarmeModule;
	}());
	exports.AlarmeModule = AlarmeModule;


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var template_api_service_1 = __webpack_require__(868);
	var template_service_1 = __webpack_require__(870);
	var TemplatesModule = (function () {
	    function TemplatesModule() {
	    }
	    TemplatesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule
	            ],
	            providers: [
	                template_api_service_1.TemplateApiService,
	                template_service_1.TemplateService
	            ],
	            declarations: []
	        }), 
	        __metadata('design:paramtypes', [])
	    ], TemplatesModule);
	    return TemplatesModule;
	}());
	exports.TemplatesModule = TemplatesModule;


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 01/09/2016.
	 */
	var router_1 = __webpack_require__(62);
	var core_1 = __webpack_require__(3);
	var auth_guard_service_1 = __webpack_require__(89);
	var visitantes_routing_module_1 = __webpack_require__(1047);
	var gestao_component_1 = __webpack_require__(143);
	var gestao_routing_module_1 = __webpack_require__(167);
	var visitantes_component_1 = __webpack_require__(1048);
	var error_page_component_1 = __webpack_require__(1050);
	var not_tenant_page_component_1 = __webpack_require__(1054);
	exports.routes = createRoutes();
	function createRoutes() {
	    var tenants = [];
	    if (true) {
	        tenants = ["grupoembras", "demo", "teste"];
	    }
	    else if (process.env.ENV === 'staging') {
	        tenants = ["t1", "t2", "t3", "pinda", "teste"];
	    }
	    else {
	        tenants = ["t1", "t2", "t3", "pinda", "teste"];
	    }
	    var routes = [];
	    tenants.forEach(function (item) {
	        routes.push({
	            path: item + '/visitante',
	            component: visitantes_component_1.VisitantesComponent,
	            canActivate: [auth_guard_service_1.AuthGuardService],
	            children: visitantes_routing_module_1.visitantesRoutes
	        });
	        routes.push({
	            path: item,
	            component: gestao_component_1.GestaoComponent,
	            canActivate: [auth_guard_service_1.AuthGuardService],
	            children: gestao_routing_module_1.gestaoRoutes
	        });
	    });
	    routes.push({
	        path: '',
	        component: not_tenant_page_component_1.NotTenantPageComponent
	    });
	    routes.push({
	        path: '**',
	        component: error_page_component_1.ErrorPageComponent
	    });
	    return routes;
	}
	exports.createRoutes = createRoutes;
	var AppRoutingModule = (function () {
	    function AppRoutingModule() {
	    }
	    AppRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forRoot(exports.routes)
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppRoutingModule);
	    return AppRoutingModule;
	}());
	exports.AppRoutingModule = AppRoutingModule;


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/**
	 * Created by Daniela on 19/10/2016.
	 */
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(62);
	var auth_guard_service_1 = __webpack_require__(89);
	var home_component_1 = __webpack_require__(168);
	var data_service_1 = __webpack_require__(457);
	var viagens_routing_module_1 = __webpack_require__(624);
	var viagens_component_1 = __webpack_require__(462);
	var data_service_2 = __webpack_require__(145);
	var recursos_humanos_component_1 = __webpack_require__(170);
	var data_service_3 = __webpack_require__(87);
	var usuarios_component_1 = __webpack_require__(693);
	var usuarios_routing_module_1 = __webpack_require__(689);
	var VisitantesRoutingModule = (function () {
	    function VisitantesRoutingModule() {
	    }
	    VisitantesRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                router_1.RouterModule.forChild([])
	            ],
	            exports: [
	                router_1.RouterModule
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], VisitantesRoutingModule);
	    return VisitantesRoutingModule;
	}());
	exports.VisitantesRoutingModule = VisitantesRoutingModule;
	exports.visitantesRoutes = [
	    {
	        path: '',
	        component: home_component_1.HomeComponent
	    }, {
	        path: data_service_1.viagensRoute,
	        component: viagens_component_1.ViagensComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: viagens_routing_module_1.viagensVisitantesRoutes
	    }, {
	        path: data_service_2.recursosHumanosRoute,
	        component: recursos_humanos_component_1.RecursosHumanosComponent,
	        canActivateChild: [auth_guard_service_1.AuthGuardService],
	        children: [
	            {
	                path: data_service_3.usuariosRoute,
	                component: usuarios_component_1.UsuariosComponent,
	                canActivate: [auth_guard_service_1.AuthGuardService],
	                children: usuarios_routing_module_1.usuariosRoutes
	            }
	        ]
	    },
	];


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var VisitantesComponent = (function () {
	    function VisitantesComponent() {
	    }
	    VisitantesComponent.prototype.ngOnInit = function () {
	    };
	    VisitantesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(1049)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], VisitantesComponent);
	    return VisitantesComponent;
	}());
	exports.VisitantesComponent = VisitantesComponent;


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"geo-framework\">\n    <div class=\"geo-nav__header--mobile\">\n    <span class=\"geo-mobile__toggle\">\n        <img alt=\"Abrir menu\" src=\"" + __webpack_require__(163) + "\" />\n    </span>\n    </div>\n    <div class=\"geo-nav__overlay\"></div>\n\n    <nav class=\"geo-nav\">\n        <div class=\"geo-nav__header\">\n            <a [routerLink]=\"['./']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">\n                <span data-logo=\"expand\"><svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-assets'/></svg></span>\n                <img alt=\"Logo GeoSiap\" data-logo=\"reduced\" src=\"" + __webpack_require__(164) + "\" />\n            </a>\n        </div>\n        <div class=\"geo-nav__menu\">\n            <a class=\"geo-menu__button\" [routerLink]=\"['./']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">\n                <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-home' /></svg>\n                <span>Home</span>\n            </a>\n\n            <app-visitante-viagem-menu style=\"width: 100%\"></app-visitante-viagem-menu>\n        </div>\n\n        <div class=\"geo-nav__footer\"></div>\n    </nav>\n\n    <main class=\"geo-framework__content\">\n        <header class=\"geo-header\">\n      <span class=\"geo-header__title\">\n        <a [routerLink]=\"['./']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">Embras - Empresa Brasileira de Sistemas</a>\n      </span>\n\n            <div class=\"geo-header__info\">\n                <a class=\"geo-menu__button\" id=\"menu-user\" data-menu>\n                    <svg><use xlink:href='../../../assets/images/icons/icons.svg#icon-usuario_info'/></svg>\n                </a>\n            </div>\n        </header>\n\n        <div class=\"geo-content\">\n            <router-outlet></router-outlet>\n        </div>\n    </main>\n</div>\n\n<div class=\"geo-menu geo-menu--bottom-left\" data-geo-for=\"menu-user\">\n    <div class=\"geo-menu--full\">\n        <div class=\"menu-full__header\">\n            <img src=\"" + __webpack_require__(165) + "\" class=\"profile-picture\">\n            <div class=\"menu-full__infos\">\n                <p><strong>Nome do usuário</strong></p>\n                <p>email@email.com</p>\n            </div>\n        </div>\n        <div class=\"menu-full__actions\">\n            <a [routerLink]=\"['./rh/usuarios/trocar']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">Alterar perfil</a>\n            <a [routerLink]=\"['./']\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">Sair</a>\n        </div>\n    </div>\n</div>\n";

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ErrorPageComponent = (function () {
	    function ErrorPageComponent() {
	    }
	    ErrorPageComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(1051),
	            styles: [__webpack_require__(1053)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ErrorPageComponent);
	    return ErrorPageComponent;
	}());
	exports.ErrorPageComponent = ErrorPageComponent;


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"container\">\n  <div class=\"box\">\n    <div class=\"logo\">\n      <img src=\"" + __webpack_require__(1052) + "\" width=\"185\" height=\"49\" alt=\"Logo GeoSiap\">\n    </div>\n\n    <h1>Página não encontrada.</h1>\n    <p>A página que você está procurando não foi encontrada.\n      Você pode ter digitado o endereço errado ou a página foi alterada.</p>\n  </div>\n</div>\n";

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo_geosiap.dff8c4d839b216766331e0bad6173dac.png";

/***/ },
/* 1053 */
/***/ function(module, exports) {

	module.exports = ".container {\n  background-color: #00A6F0;\n  background: url('../../../../assets/images/bg.jpg') no-repeat center center fixed;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  aling-content: center;\n  text-align: center;\n  height: 100%;\n  padding: 100px 0;\n  box-sizing: border-box;\n}\n.box {\n  max-width: 500px;\n}\nh1 {\n  font-size: 1.5em;\n  font-weight: bold;\n  margin-bottom: 30px;\n  color: #FFFFFF;\n}\np {\n  color: #FFFFFF;\n  font-size: 1.2em;\n}\n"

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var NotTenantPageComponent = (function () {
	    function NotTenantPageComponent() {
	    }
	    NotTenantPageComponent.prototype.ngOnInit = function () {
	        this.domain = window.location.href;
	    };
	    NotTenantPageComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(1055),
	            styles: [__webpack_require__(1056)]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], NotTenantPageComponent);
	    return NotTenantPageComponent;
	}());
	exports.NotTenantPageComponent = NotTenantPageComponent;


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"container\">\n    <div class=\"box\">\n        <div class=\"logo\">\n            <img src=\"" + __webpack_require__(1052) + "\" width=\"185\" height=\"49\" alt=\"Logo GeoSiap\">\n        </div>\n\n        <h1>Projeto não informado.</h1>\n        <p>Informe o projeto que você deseja acessar. <br />\n            Por exemplo <i>{{domain}}</i><strong>nome-do-projeto</strong>\n        </p>\n    </div>\n</div>\n";

/***/ },
/* 1056 */
1053,
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var shared_module_1 = __webpack_require__(57);
	var visitantes_component_1 = __webpack_require__(1048);
	var visitantes_routing_module_1 = __webpack_require__(1047);
	var viagens_module_1 = __webpack_require__(935);
	var VisitantesModule = (function () {
	    function VisitantesModule() {
	    }
	    VisitantesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                shared_module_1.SharedModule,
	                viagens_module_1.ViagensModule,
	                visitantes_routing_module_1.VisitantesRoutingModule
	            ],
	            declarations: [
	                visitantes_component_1.VisitantesComponent
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], VisitantesModule);
	    return VisitantesModule;
	}());
	exports.VisitantesModule = VisitantesModule;


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var projeto_api_service_1 = __webpack_require__(54);
	var projeto_service_1 = __webpack_require__(52);
	var ProjetoModule = (function () {
	    function ProjetoModule() {
	    }
	    ProjetoModule = __decorate([
	        core_1.NgModule({
	            imports: [],
	            providers: [
	                projeto_api_service_1.ProjetoApiService,
	                projeto_service_1.ProjetoService
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ProjetoModule);
	    return ProjetoModule;
	}());
	exports.ProjetoModule = ProjetoModule;


/***/ }
]);


/** WEBPACK FOOTER **
 ** app.e5f821bdb5141dd96a52.js
 **/